// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import 'rxjs/add/operator/finally';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export class AbpProjectServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 生成ABP项目的ZIP文件
     * @param dirPath (optional) 
     * @param filePath (optional) 
     * @return Success
     */
    generateAbpProjectZip(dirPath: string | null | undefined, filePath: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AbpProject/GenerateAbpProjectZip?";
        if (dirPath !== undefined && dirPath !== null)
            url_ += "dirPath=" + encodeURIComponent("" + dirPath) + "&";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateAbpProjectZip(_response);
        });
    }

    protected processGenerateAbpProjectZip(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AccountServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateEmail(_response);
        });
    }

    protected processActivateEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator( cancelToken?: CancelToken | undefined): Promise<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBackToImpersonator(_response);
        });
    }

    protected processBackToImpersonator(response: AxiosResponse): Promise<ImpersonateOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpersonateOutput.fromJS(resultData200);
            return Promise.resolve<ImpersonateOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpersonateOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkEmailVerificationCode(body: GetEmailAddressCodeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/CheckEmailVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailVerificationCode(_response);
        });
    }

    protected processCheckEmailVerificationCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据名称获取租户
     * @param name (optional) 
     * @return Success
     */
    getTenantByName(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<Tenant> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetTenantByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantByName(_response);
        });
    }

    protected processGetTenantByName(response: AxiosResponse): Promise<Tenant> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Tenant.fromJS(resultData200);
            return Promise.resolve<Tenant>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Tenant>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined, cancelToken?: CancelToken | undefined): Promise<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonate(_response);
        });
    }

    protected processImpersonate(response: AxiosResponse): Promise<ImpersonateOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpersonateOutput.fromJS(resultData200);
            return Promise.resolve<ImpersonateOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpersonateOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined, cancelToken?: CancelToken | undefined): Promise<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsTenantAvailable(_response);
        });
    }

    protected processIsTenantAvailable(response: AxiosResponse): Promise<IsTenantAvailableOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return Promise.resolve<IsTenantAvailableOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined, cancelToken?: CancelToken | undefined): Promise<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterOutput.fromJS(resultData200);
            return Promise.resolve<RegisterOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterOutput>(null as any);
    }

    /**
     * 重置密码
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined, cancelToken?: CancelToken | undefined): Promise<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return Promise.resolve<ResetPasswordOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveTenantId(_response);
        });
    }

    protected processResolveTenantId(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailActivationLink(_response);
        });
    }

    protected processSendEmailActivationLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailAddressConfirmCode(body: SendPasswordResetCodeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailAddressConfirmCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailAddressConfirmCode(_response);
        });
    }

    protected processSendEmailAddressConfirmCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送密码重置Code
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendPasswordResetCode(_response);
        });
    }

    protected processSendPasswordResetCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined, cancelToken?: CancelToken | undefined): Promise<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchToLinkedAccount(_response);
        });
    }

    protected processSwitchToLinkedAccount(response: AxiosResponse): Promise<SwitchToLinkedAccountOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return Promise.resolve<SwitchToLinkedAccountOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwitchToLinkedAccountOutput>(null as any);
    }
}

export class AccountsApiServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 判断重置密码链接是否有效
     * @param key (optional) 
     * @return Success
     */
    getLinkIsActivate(key: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsApi/GetLinkIsActivate?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkIsActivate(_response);
        });
    }

    protected processGetLinkIsActivate(response: AxiosResponse): Promise<ResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResultDto.fromJS(resultData200);
            return Promise.resolve<ResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResultDto>(null as any);
    }

    /**
     * 租户名称找回租户编码
     * @param name (optional) 
     * @return Success
     */
    getTenantNameByName(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsApi/GetTenantNameByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantNameByName(_response);
        });
    }

    protected processGetTenantNameByName(response: AxiosResponse): Promise<GetTenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantDto.fromJS(resultData200);
            return Promise.resolve<GetTenantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantDto>(null as any);
    }

    /**
     * 根据邮箱重置密码
     * @param body (optional) 
     * @return Success
     */
    retrievePwdByEmail(body: UpdatePwdByEmailParam | undefined, cancelToken?: CancelToken | undefined): Promise<ResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsApi/RetrievePwdByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetrievePwdByEmail(_response);
        });
    }

    protected processRetrievePwdByEmail(response: AxiosResponse): Promise<ResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResultDto.fromJS(resultData200);
            return Promise.resolve<ResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResultDto>(null as any);
    }

    /**
     * 根据手机号修改密码
     * @param body (optional) 
     * @return Success
     */
    retrievePwdByPhone(body: UpdatePwdByPhoneEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<ResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsApi/RetrievePwdByPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetrievePwdByPhone(_response);
        });
    }

    protected processRetrievePwdByPhone(response: AxiosResponse): Promise<ResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResultDto.fromJS(resultData200);
            return Promise.resolve<ResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResultDto>(null as any);
    }

    /**
     * 发送重置密码邮件
     * @param body (optional) 
     * @return Success
     */
    sendEmailPasswordResetLink(body: UpdatePwdByEmailEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<ResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsApi/SendEmailPasswordResetLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailPasswordResetLink(_response);
        });
    }

    protected processSendEmailPasswordResetLink(response: AxiosResponse): Promise<ResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResultDto.fromJS(resultData200);
            return Promise.resolve<ResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResultDto>(null as any);
    }

    /**
     * 发送手机验证码
     * @param phoneNumbers (optional) 
     * @return Success
     */
    sendVerificationCode(phoneNumbers: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<VerificationCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsApi/SendVerificationCode?";
        if (phoneNumbers !== undefined && phoneNumbers !== null)
            url_ += "phoneNumbers=" + encodeURIComponent("" + phoneNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendVerificationCode(_response);
        });
    }

    protected processSendVerificationCode(response: AxiosResponse): Promise<VerificationCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerificationCodeDto.fromJS(resultData200);
            return Promise.resolve<VerificationCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerificationCodeDto>(null as any);
    }
}

export class AddressLinkageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取所有数据
     * @return Success
     */
    getAll( cancelToken?: CancelToken | undefined): Promise<AllAddressLinkage> {
        let url_ = this.baseUrl + "/api/services/app/AddressLinkage/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AllAddressLinkage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllAddressLinkage.fromJS(resultData200);
            return Promise.resolve<AllAddressLinkage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllAddressLinkage>(null as any);
    }

    /**
     * 获取所有县数据
     * @return Success
     */
    getAllArea( cancelToken?: CancelToken | undefined): Promise<AddressAreaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressLinkage/GetAllArea";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllArea(_response);
        });
    }

    protected processGetAllArea(response: AxiosResponse): Promise<AddressAreaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressAreaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressAreaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressAreaDto[]>(null as any);
    }

    /**
     * 获取所有市数据
     * @return Success
     */
    getAllCity( cancelToken?: CancelToken | undefined): Promise<AddressCityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressLinkage/GetAllCity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCity(_response);
        });
    }

    protected processGetAllCity(response: AxiosResponse): Promise<AddressCityDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressCityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressCityDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressCityDto[]>(null as any);
    }

    /**
     * 获取所有镇数据
     * @return Success
     */
    getAllStreet( cancelToken?: CancelToken | undefined): Promise<AddressStreetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressLinkage/GetAllStreet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllStreet(_response);
        });
    }

    protected processGetAllStreet(response: AxiosResponse): Promise<AddressStreetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressStreetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressStreetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressStreetDto[]>(null as any);
    }

    /**
     * 通过code获取省市区县镇名称（没有code传空）
     * @param provinceCode (optional) 
     * @param cityCode (optional) 
     * @param areaCode (optional) 
     * @param streetCode (optional) 
     * @return Success
     */
    getByCode(provinceCode: string | null | undefined, cityCode: string | null | undefined, areaCode: string | null | undefined, streetCode: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetByCodeOutput> {
        let url_ = this.baseUrl + "/api/services/app/AddressLinkage/GetByCode?";
        if (provinceCode !== undefined && provinceCode !== null)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (cityCode !== undefined && cityCode !== null)
            url_ += "cityCode=" + encodeURIComponent("" + cityCode) + "&";
        if (areaCode !== undefined && areaCode !== null)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (streetCode !== undefined && streetCode !== null)
            url_ += "streetCode=" + encodeURIComponent("" + streetCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByCode(_response);
        });
    }

    protected processGetByCode(response: AxiosResponse): Promise<GetByCodeOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetByCodeOutput.fromJS(resultData200);
            return Promise.resolve<GetByCodeOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetByCodeOutput>(null as any);
    }

    /**
     * 通过父级code获取省市区县镇数据
     * @param parentCode (optional) 父级code
     * @return Success
     */
    getByParentCode(addressEnum: AddressEnum, parentCode: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AddressProvincetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressLinkage/GetByParentCode?";
        if (addressEnum === undefined || addressEnum === null)
            throw new Error("The parameter 'addressEnum' must be defined and cannot be null.");
        else
            url_ += "addressEnum=" + encodeURIComponent("" + addressEnum) + "&";
        if (parentCode !== undefined && parentCode !== null)
            url_ += "parentCode=" + encodeURIComponent("" + parentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByParentCode(_response);
        });
    }

    protected processGetByParentCode(response: AxiosResponse): Promise<AddressProvincetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressProvincetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AddressProvincetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressProvincetDto[]>(null as any);
    }
}

export class AliyunVodCategoryServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVodCategory(body: VodCategoryEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<VodCategoryEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AliyunVodCategory/CreateVodCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVodCategory(_response);
        });
    }

    protected processCreateVodCategory(response: AxiosResponse): Promise<VodCategoryEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VodCategoryEditDto.fromJS(resultData200);
            return Promise.resolve<VodCategoryEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VodCategoryEditDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteVodCategory(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AliyunVodCategory/DeleteVodCategory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVodCategory(_response);
        });
    }

    protected processDeleteVodCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取vod分类的信息
     * @return Success
     */
    getAllVodCategories( cancelToken?: CancelToken | undefined): Promise<VodCategoryEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AliyunVodCategory/GetAllVodCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllVodCategories(_response);
        });
    }

    protected processGetAllVodCategories(response: AxiosResponse): Promise<VodCategoryEditDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VodCategoryEditDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VodCategoryEditDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VodCategoryEditDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVodCategory(body: VodCategoryEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AliyunVodCategory/UpdateVodCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVodCategory(_response);
        });
    }

    protected processUpdateVodCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AliyunVodUploadServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUploadVideoRequest(body: VodUploadDto | undefined, cancelToken?: CancelToken | undefined): Promise<VideoAutherOutput> {
        let url_ = this.baseUrl + "/api/services/app/AliyunVodUpload/CreateUploadVideoRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUploadVideoRequest(_response);
        });
    }

    protected processCreateUploadVideoRequest(response: AxiosResponse): Promise<VideoAutherOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoAutherOutput.fromJS(resultData200);
            return Promise.resolve<VideoAutherOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoAutherOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshUploadVideoRequest(body: RefreshUploadInputDto | undefined, cancelToken?: CancelToken | undefined): Promise<VideoAutherOutput> {
        let url_ = this.baseUrl + "/api/services/app/AliyunVodUpload/RefreshUploadVideoRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshUploadVideoRequest(_response);
        });
    }

    protected processRefreshUploadVideoRequest(response: AxiosResponse): Promise<VideoAutherOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoAutherOutput.fromJS(resultData200);
            return Promise.resolve<VideoAutherOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoAutherOutput>(null as any);
    }
}

export class AnnexesFileServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除AnnexesFile的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改附件表的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAnnexesFileInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除附件表信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取AnnexesFileListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AnnexesFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AnnexesFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnnexesFileListDto.fromJS(resultData200);
            return Promise.resolve<AnnexesFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnnexesFileListDto>(null as any);
    }

    /**
     * 获取编辑 附件表
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAnnexesFileForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAnnexesFileForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAnnexesFileForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAnnexesFileForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAnnexesFileForEditOutput>(null as any);
    }

    /**
     * 获取附件表的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAnnexesFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAnnexesFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAnnexesFileListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAnnexesFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAnnexesFileListDto>(null as any);
    }

    /**
     * 导出附件表为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnexesFile/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class APPApiServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 审核记录转办
     * @param id (optional) 审核记录Id
     * @param userId (optional) 用户Id
     * @return Success
     */
    auditTaskDetailTransfer(id: number | undefined, userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/AuditTaskDetailTransfer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuditTaskDetailTransfer(_response);
        });
    }

    protected processAuditTaskDetailTransfer(response: AxiosResponse): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return Promise.resolve<moment.Moment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * 点位打卡
     * @param str (optional) 
     * @return Success
     */
    check(str: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/Check?";
        if (str !== undefined && str !== null)
            url_ += "str=" + encodeURIComponent("" + str) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 关闭问题
     * @param issueId (optional) 
     * @param remark (optional) 
     * @return Success
     */
    closeIssue(issueId: number | undefined, remark: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/CloseIssue?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (remark !== undefined && remark !== null)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseIssue(_response);
        });
    }

    protected processCloseIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * APP创建审核点任务
     * @param body (optional) 
     * @return Success
     */
    createAuditTask(body: APPCreateAuditTaskDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/CreateAuditTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAuditTask(_response);
        });
    }

    protected processCreateAuditTask(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * APP创建审核项任务
     * @param body (optional) 
     * @return Success
     */
    createAuditTaskItem(body: APPCreateAuditTaskItemDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/CreateAuditTaskItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAuditTaskItem(_response);
        });
    }

    protected processCreateAuditTaskItem(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 创建即时问题（即时问题）（问题反馈）（添加问题）
     * @param body (optional) 
     * @return Success
     */
    createIssue(body: CreatOrUpdataIssue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/CreateIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIssue(_response);
        });
    }

    protected processCreateIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取审核点树数据
     * @return Success
     */
    getAllData( cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * 根据审核模板下的审核点id获取审核项
     * @param auditTemplateId (optional) 
     * @param auditPointId (optional) 
     * @return Success
     */
    getAuditItemByPointId(auditTemplateId: number | null | undefined, auditPointId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditItemByPointId?";
        if (auditTemplateId !== undefined && auditTemplateId !== null)
            url_ += "auditTemplateId=" + encodeURIComponent("" + auditTemplateId) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditItemByPointId(_response);
        });
    }

    protected processGetAuditItemByPointId(response: AxiosResponse): Promise<AuditItemListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemListDto[]>(null as any);
    }

    /**
     * 获取审核计划下的审核点下的所有审核项（扫码也是调用这个）
     * @param auditTaskId (optional) 任务Id
     * @param auditPointId (optional) 审核点Id
     * @param isTransferTask (optional) 是否为审核记录转办任务
     * @return Success
     */
    getAuditItemByTaskPoint(auditTaskId: number | undefined, auditPointId: number | undefined, isTransferTask: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<GetByAuditTaskIdInAllAuditItemListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditItemByTaskPoint?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (auditPointId === null)
            throw new Error("The parameter 'auditPointId' cannot be null.");
        else if (auditPointId !== undefined)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (isTransferTask === null)
            throw new Error("The parameter 'isTransferTask' cannot be null.");
        else if (isTransferTask !== undefined)
            url_ += "isTransferTask=" + encodeURIComponent("" + isTransferTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditItemByTaskPoint(_response);
        });
    }

    protected processGetAuditItemByTaskPoint(response: AxiosResponse): Promise<GetByAuditTaskIdInAllAuditItemListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetByAuditTaskIdInAllAuditItemListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetByAuditTaskIdInAllAuditItemListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetByAuditTaskIdInAllAuditItemListDto[]>(null as any);
    }

    /**
     * 选择审核点下的审核项
     * @param auditPointId (optional) 
     * @return Success
     */
    getAuditItemList(auditPointId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditItemList?";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditItemList(_response);
        });
    }

    protected processGetAuditItemList(response: AxiosResponse): Promise<AuditItemListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemListDto[]>(null as any);
    }

    /**
     * 获取审核计划下所有审核点
     * @param auditTaskId (optional) 审核任务Id
     * @param isTransferTask (optional) 是否为审核记录转办任务
     * @return Success
     */
    getAuditPointByTask(auditTaskId: number | undefined, isTransferTask: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<GetByAuditTaskIdInAllPointTreeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditPointByTask?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (isTransferTask === null)
            throw new Error("The parameter 'isTransferTask' cannot be null.");
        else if (isTransferTask !== undefined)
            url_ += "isTransferTask=" + encodeURIComponent("" + isTransferTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditPointByTask(_response);
        });
    }

    protected processGetAuditPointByTask(response: AxiosResponse): Promise<GetByAuditTaskIdInAllPointTreeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetByAuditTaskIdInAllPointTreeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetByAuditTaskIdInAllPointTreeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetByAuditTaskIdInAllPointTreeListDto[]>(null as any);
    }

    /**
     * 审核点树数据（带审核项数据）
     * @param auditTemplateId (optional) 
     * @return Success
     */
    getAuditPointByTemplateId(auditTemplateId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditPointByTemplateId?";
        if (auditTemplateId !== undefined && auditTemplateId !== null)
            url_ += "auditTemplateId=" + encodeURIComponent("" + auditTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditPointByTemplateId(_response);
        });
    }

    protected processGetAuditPointByTemplateId(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * 选择审核点
     * @return Success
     */
    getAuditPointList( cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditPointList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditPointList(_response);
        });
    }

    protected processGetAuditPointList(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * 获取当前用户审核任务的气泡
     * @return Success
     */
    getAuditTaskBubble( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditTaskBubble";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskBubble(_response);
        });
    }

    protected processGetAuditTaskBubble(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取当前用户的当天的所有审核计划
     * @param auditPointId (optional) 
     * @return Success
     */
    getAuditTaskToday(auditPointId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditTaskToday?";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskToday(_response);
        });
    }

    protected processGetAuditTaskToday(response: AxiosResponse): Promise<AuditTaskListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTaskListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTaskListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskListDto[]>(null as any);
    }

    /**
     * 获取当前用户当天以后的审核计划
     * @param allAndNoFinish (optional) 完成还是未完成(默认全部) 1.全部 2.完成 3.未完成
     * @param auditPointId (optional) 审核点
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditTaskTodayAfter(allAndNoFinish: string | null | undefined, auditPointId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditTaskTodayAfter?";
        if (allAndNoFinish !== undefined && allAndNoFinish !== null)
            url_ += "allAndNoFinish=" + encodeURIComponent("" + allAndNoFinish) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskTodayAfter(_response);
        });
    }

    protected processGetAuditTaskTodayAfter(response: AxiosResponse): Promise<AuditTaskListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTaskListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTaskListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskListDto[]>(null as any);
    }

    /**
     * 获取当前用户当天以前的审核计划
     * @param allAndNoFinish (optional) 完成还是未完成(默认全部) 1.全部 2.完成 3.未完成
     * @param auditPointId (optional) 审核点
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditTaskTodayBefore(allAndNoFinish: string | null | undefined, auditPointId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetAuditTaskTodayBefore?";
        if (allAndNoFinish !== undefined && allAndNoFinish !== null)
            url_ += "allAndNoFinish=" + encodeURIComponent("" + allAndNoFinish) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskTodayBefore(_response);
        });
    }

    protected processGetAuditTaskTodayBefore(response: AxiosResponse): Promise<AuditTaskListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTaskListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTaskListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskListDto[]>(null as any);
    }

    /**
     * 获取服务器当前时间
     * @return Success
     */
    getCurrentTime( cancelToken?: CancelToken | undefined): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetCurrentTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentTime(_response);
        });
    }

    protected processGetCurrentTime(response: AxiosResponse): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return Promise.resolve<moment.Moment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<moment.Moment>(null as any);
    }

    /**
     * 获取当前用户问题的气泡
     * @return Success
     */
    getIssueBubble( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetIssueBubble";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueBubble(_response);
        });
    }

    protected processGetIssueBubble(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取审核计划下的审核点下的所有问题
     * @param auditTaskId (optional) 审核任务
     * @param auditPointId (optional) 审核点
     * @param auditItemId (optional) 审核项
     * @param isTransferTask (optional) 
     * @return Success
     */
    getIssueByTaskPoint(auditTaskId: number | undefined, auditPointId: number | undefined, auditItemId: number | null | undefined, isTransferTask: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<APPIssueListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetIssueByTaskPoint?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (auditPointId === null)
            throw new Error("The parameter 'auditPointId' cannot be null.");
        else if (auditPointId !== undefined)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (auditItemId !== undefined && auditItemId !== null)
            url_ += "auditItemId=" + encodeURIComponent("" + auditItemId) + "&";
        if (isTransferTask === null)
            throw new Error("The parameter 'isTransferTask' cannot be null.");
        else if (isTransferTask !== undefined)
            url_ += "isTransferTask=" + encodeURIComponent("" + isTransferTask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueByTaskPoint(_response);
        });
    }

    protected processGetIssueByTaskPoint(response: AxiosResponse): Promise<APPIssueListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(APPIssueListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<APPIssueListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<APPIssueListDto[]>(null as any);
    }

    /**
     * 获取问题进度
     * @return Success
     * @deprecated
     */
    getIssueProcess( cancelToken?: CancelToken | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetIssueProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueProcess(_response);
        });
    }

    protected processGetIssueProcess(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * 获取问题分类显示配置
     * @return Success
     */
    getIssueTypeDisplayConfig( cancelToken?: CancelToken | undefined): Promise<IssueTypeDisplayConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetIssueTypeDisplayConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeDisplayConfig(_response);
        });
    }

    protected processGetIssueTypeDisplayConfig(response: AxiosResponse): Promise<IssueTypeDisplayConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueTypeDisplayConfigDto.fromJS(resultData200);
            return Promise.resolve<IssueTypeDisplayConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeDisplayConfigDto>(null as any);
    }

    /**
     * 获取问题分类（树节点）
     * @return Success
     */
    getIssueTypeList( cancelToken?: CancelToken | undefined): Promise<IssueTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetIssueTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeList(_response);
        });
    }

    protected processGetIssueTypeList(response: AxiosResponse): Promise<IssueTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueTypeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeListDto[]>(null as any);
    }

    /**
     * 获取lpa用户（LPAUserType==0||LPAUserType==null时查询所有用户，1.审核人，2.责任人）
     * @param lPAUserType (optional) 
     * @return Success
     */
    getLayoutUser(lPAUserType: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<LayoutUserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetLayoutUser?";
        if (lPAUserType !== undefined && lPAUserType !== null)
            url_ += "lPAUserType=" + encodeURIComponent("" + lPAUserType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLayoutUser(_response);
        });
    }

    protected processGetLayoutUser(response: AxiosResponse): Promise<LayoutUserListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LayoutUserListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LayoutUserListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutUserListDto[]>(null as any);
    }

    /**
     * 获取所有组织架构数据
     * @param lPAUserType (optional) 状态（什么不传默认全部）1:审核人,2:责任人
     * @return Success
     */
    getLayoutUserTree(lPAUserType: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetLayoutUserTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetLayoutUserTree?";
        if (lPAUserType !== undefined && lPAUserType !== null)
            url_ += "lPAUserType=" + encodeURIComponent("" + lPAUserType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLayoutUserTree(_response);
        });
    }

    protected processGetLayoutUserTree(response: AxiosResponse): Promise<GetLayoutUserTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetLayoutUserTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetLayoutUserTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLayoutUserTreeDto[]>(null as any);
    }

    /**
     * 获取问题（我负责的和我发现的封装到一个对象里，三个属性分别是我负责的和我发现的、我关注的）
     * @return Success
     */
    getMineIssueList( cancelToken?: CancelToken | undefined): Promise<GetIssueListDto> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetMineIssueList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMineIssueList(_response);
        });
    }

    protected processGetMineIssueList(response: AxiosResponse): Promise<GetIssueListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueListDto.fromJS(resultData200);
            return Promise.resolve<GetIssueListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueListDto>(null as any);
    }

    /**
     * 获取问题（我负责的和我发现的封装到一个对象里，三个属性分别是我负责的和我发现的、我关注的）
     * @param issueTypeId (optional) 问题类型(多选)
     * @param auditPointId (optional) 审核点
     * @param issueProgress (optional) 问题进度
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param discoveryStartTime (optional) 发现开始时间
     * @param discoveryEndTime (optional) 发现结束时间
     * @param isScanAuditPoint (optional) 是否扫描审核点
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getMineIssueListV2(issueTypeId: string | null | undefined, auditPointId: number | null | undefined, issueProgress: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, discoveryStartTime: moment.Moment | null | undefined, discoveryEndTime: moment.Moment | null | undefined, isScanAuditPoint: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueListDtoV2> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetMineIssueListV2?";
        if (issueTypeId !== undefined && issueTypeId !== null)
            url_ += "issueTypeId=" + encodeURIComponent("" + issueTypeId) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (issueProgress !== undefined && issueProgress !== null)
            url_ += "issueProgress=" + encodeURIComponent("" + issueProgress) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (discoveryStartTime !== undefined && discoveryStartTime !== null)
            url_ += "discoveryStartTime=" + encodeURIComponent(discoveryStartTime ? "" + discoveryStartTime.toISOString() : "") + "&";
        if (discoveryEndTime !== undefined && discoveryEndTime !== null)
            url_ += "discoveryEndTime=" + encodeURIComponent(discoveryEndTime ? "" + discoveryEndTime.toISOString() : "") + "&";
        if (isScanAuditPoint === null)
            throw new Error("The parameter 'isScanAuditPoint' cannot be null.");
        else if (isScanAuditPoint !== undefined)
            url_ += "isScanAuditPoint=" + encodeURIComponent("" + isScanAuditPoint) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMineIssueListV2(_response);
        });
    }

    protected processGetMineIssueListV2(response: AxiosResponse): Promise<GetIssueListDtoV2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueListDtoV2.fromJS(resultData200);
            return Promise.resolve<GetIssueListDtoV2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueListDtoV2>(null as any);
    }

    /**
     * 获取点位打卡记录
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPointCheck(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfPointCheckListDto> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetPointCheck?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPointCheck(_response);
        });
    }

    protected processGetPointCheck(response: AxiosResponse): Promise<PagedResultDtoOfPointCheckListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfPointCheckListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfPointCheckListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfPointCheckListDto>(null as any);
    }

    /**
     * 获取条码
     * @param code (optional) 
     * @return Success
     */
    getTemplateBarCodeList(code: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetTemplateBarCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetTemplateBarCodeList?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateBarCodeList(_response);
        });
    }

    protected processGetTemplateBarCodeList(response: AxiosResponse): Promise<GetTemplateBarCodeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetTemplateBarCodeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetTemplateBarCodeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTemplateBarCodeListDto[]>(null as any);
    }

    /**
     * 获取审核项模板走动检查模板
     * @param templateName (optional) 
     * @return Success
     */
    getWalkAuditItemTemplate(templateName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTemplateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetWalkAuditItemTemplate?";
        if (templateName !== undefined && templateName !== null)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWalkAuditItemTemplate(_response);
        });
    }

    protected processGetWalkAuditItemTemplate(response: AxiosResponse): Promise<AuditItemTemplateListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemTemplateListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemTemplateListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTemplateListDto[]>(null as any);
    }

    /**
     * 获取审核项树数据
     * @param templateName (optional) 
     * @return Success
     */
    getWalkAuditItemTemplateTree(templateName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTemplateTreeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetWalkAuditItemTemplateTree?";
        if (templateName !== undefined && templateName !== null)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWalkAuditItemTemplateTree(_response);
        });
    }

    protected processGetWalkAuditItemTemplateTree(response: AxiosResponse): Promise<AuditItemTemplateTreeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemTemplateTreeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemTemplateTreeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTemplateTreeListDto[]>(null as any);
    }

    /**
     * 获取审核点模板走动检查模板
     * @param templateName (optional) 
     * @param auditPointId (optional) 
     * @return Success
     * @deprecated
     */
    getWalkAuditTemplate(templateName: string | null | undefined, auditPointId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetWalkAuditTemplate?";
        if (templateName !== undefined && templateName !== null)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWalkAuditTemplate(_response);
        });
    }

    protected processGetWalkAuditTemplate(response: AxiosResponse): Promise<AuditTemplateListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTemplateListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTemplateListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateListDto[]>(null as any);
    }

    /**
     * 获取审核点模板走动检查模板
     * @param templateBarCodeId (optional) 
     * @return Success
     */
    getWalkAuditTemplateByTemplateBarCode(templateBarCodeId: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetWalkAuditTemplateByTemplateBarCode?";
        if (templateBarCodeId === null)
            throw new Error("The parameter 'templateBarCodeId' cannot be null.");
        else if (templateBarCodeId !== undefined)
            url_ += "templateBarCodeId=" + encodeURIComponent("" + templateBarCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWalkAuditTemplateByTemplateBarCode(_response);
        });
    }

    protected processGetWalkAuditTemplateByTemplateBarCode(response: AxiosResponse): Promise<AuditTemplateListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTemplateListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTemplateListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateListDto[]>(null as any);
    }

    /**
     * 获取审核点树数据
     * @param templateName (optional) 
     * @param auditPointId (optional) 
     * @return Success
     */
    getWalkAuditTemplateTree(templateName: string | null | undefined, auditPointId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateTreeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/GetWalkAuditTemplateTree?";
        if (templateName !== undefined && templateName !== null)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWalkAuditTemplateTree(_response);
        });
    }

    protected processGetWalkAuditTemplateTree(response: AxiosResponse): Promise<AuditTemplateTreeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTemplateTreeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTemplateTreeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateTreeListDto[]>(null as any);
    }

    /**
     * 更新问题
     * @param body (optional) 
     * @return Success
     */
    handleIssue(body: APPIssueEditInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/HandleIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleIssue(_response);
        });
    }

    protected processHandleIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题转办(问题ID，被转办的人Id)
     * @param issueId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    issueTransfer(issueId: number | undefined, userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/IssueTransfer?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTransfer(_response);
        });
    }

    protected processIssueTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题分类显示配置(隐藏的问题分类)
     * @param body (optional) 
     * @return Success
     */
    issueTypeDisplayConfig(body: IssueTypeDisplayConfigDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/IssueTypeDisplayConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTypeDisplayConfig(_response);
        });
    }

    protected processIssueTypeDisplayConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 请假
     * @param body (optional) 
     * @return Success
     */
    leave(body: LeaveDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/Leave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLeave(_response);
        });
    }

    protected processLeave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 保存审核记录
     * @param body (optional) 
     * @return Success
     */
    saveAuditTaskDetail(body: SaveAuditTaskDetailDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/SaveAuditTaskDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAuditTaskDetail(_response);
        });
    }

    protected processSaveAuditTaskDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param auditTaskId (optional) 
     * @param filedExt1 (optional) 
     * @param filedExt2 (optional) 
     * @param filedExt3 (optional) 
     * @return Success
     */
    saveFiledExt(auditTaskId: number | undefined, filedExt1: string | null | undefined, filedExt2: string | null | undefined, filedExt3: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/SaveFiledExt?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (filedExt1 !== undefined && filedExt1 !== null)
            url_ += "filedExt1=" + encodeURIComponent("" + filedExt1) + "&";
        if (filedExt2 !== undefined && filedExt2 !== null)
            url_ += "filedExt2=" + encodeURIComponent("" + filedExt2) + "&";
        if (filedExt3 !== undefined && filedExt3 !== null)
            url_ += "filedExt3=" + encodeURIComponent("" + filedExt3) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveFiledExt(_response);
        });
    }

    protected processSaveFiledExt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 扫描审核点
     * @param type (optional) 类型 1.二维码 2.rfid
     * @param str (optional) 
     * @return Success
     */
    scanAuditPoint(type: string | null | undefined, str: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditpointListDto> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/ScanAuditPoint?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (str !== undefined && str !== null)
            url_ += "str=" + encodeURIComponent("" + str) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScanAuditPoint(_response);
        });
    }

    protected processScanAuditPoint(response: AxiosResponse): Promise<AuditpointListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditpointListDto.fromJS(resultData200);
            return Promise.resolve<AuditpointListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto>(null as any);
    }

    /**
     * 设置是否跳过审核项
     * @param auditTaskId (optional) 审核任务id
     * @param auditPointId (optional) 
     * @param auditItemId (optional) 审核项id
     * @param isSkip (optional) 是否跳过
     * @param skipReason (optional) 
     * @return Success
     */
    setIsSkipAuditItem(auditTaskId: number | undefined, auditPointId: number | undefined, auditItemId: number | undefined, isSkip: boolean | undefined, skipReason: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/SetIsSkipAuditItem?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (auditPointId === null)
            throw new Error("The parameter 'auditPointId' cannot be null.");
        else if (auditPointId !== undefined)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (auditItemId === null)
            throw new Error("The parameter 'auditItemId' cannot be null.");
        else if (auditItemId !== undefined)
            url_ += "auditItemId=" + encodeURIComponent("" + auditItemId) + "&";
        if (isSkip === null)
            throw new Error("The parameter 'isSkip' cannot be null.");
        else if (isSkip !== undefined)
            url_ += "isSkip=" + encodeURIComponent("" + isSkip) + "&";
        if (skipReason !== undefined && skipReason !== null)
            url_ += "skipReason=" + encodeURIComponent("" + skipReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsSkipAuditItem(_response);
        });
    }

    protected processSetIsSkipAuditItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置是否跳过审核点
     * @param auditTaskId (optional) 审核任务id
     * @param auditPointId (optional) 审核点id
     * @param isSkip (optional) 是否跳过
     * @param skipReason (optional) 
     * @return Success
     */
    setIsSkipAuditPoint(auditTaskId: number | undefined, auditPointId: number | undefined, isSkip: boolean | undefined, skipReason: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/SetIsSkipAuditPoint?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (auditPointId === null)
            throw new Error("The parameter 'auditPointId' cannot be null.");
        else if (auditPointId !== undefined)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (isSkip === null)
            throw new Error("The parameter 'isSkip' cannot be null.");
        else if (isSkip !== undefined)
            url_ += "isSkip=" + encodeURIComponent("" + isSkip) + "&";
        if (skipReason !== undefined && skipReason !== null)
            url_ += "skipReason=" + encodeURIComponent("" + skipReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsSkipAuditPoint(_response);
        });
    }

    protected processSetIsSkipAuditPoint(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 转办(计划ID，被转办的人Id)
     * @param auditTaskId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    transfer(auditTaskId: number | undefined, userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/APPApi/Transfer?";
        if (auditTaskId === null)
            throw new Error("The parameter 'auditTaskId' cannot be null.");
        else if (auditTaskId !== undefined)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AppBaseServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除AppBase的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBase/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAppBaseInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBase/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBase/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取AppBaseListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AppBaseListDto> {
        let url_ = this.baseUrl + "/api/services/app/AppBase/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AppBaseListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppBaseListDto.fromJS(resultData200);
            return Promise.resolve<AppBaseListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppBaseListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAppBaseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AppBase/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAppBaseForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppBaseForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAppBaseForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppBaseForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAppBaseListDto> {
        let url_ = this.baseUrl + "/api/services/app/AppBase/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAppBaseListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAppBaseListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAppBaseListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAppBaseListDto>(null as any);
    }
}

export class AppDTImgServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除AppDTImg的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改APP图片的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAppDTImgInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除APP图片信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取AppDTImgListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AppDTImgListDto> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AppDTImgListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppDTImgListDto.fromJS(resultData200);
            return Promise.resolve<AppDTImgListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppDTImgListDto>(null as any);
    }

    /**
     * 获取编辑 APP图片
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAppDTImgForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAppDTImgForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppDTImgForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAppDTImgForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppDTImgForEditOutput>(null as any);
    }

    /**
     * 获取列表数据(有效)
     * @return Success
     */
    getList( cancelToken?: CancelToken | undefined): Promise<AppDTImgListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AppDTImgListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AppDTImgListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppDTImgListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppDTImgListDto[]>(null as any);
    }

    /**
     * 获取APP图片的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAppDTImgListDto> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAppDTImgListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAppDTImgListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAppDTImgListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAppDTImgListDto>(null as any);
    }

    /**
     * 导出APP图片为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 禁用
     * @param id (optional) 
     * @return Success
     */
    updateEnabledMarkToFalse(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AppDTImgEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/UpdateEnabledMarkToFalse?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnabledMarkToFalse(_response);
        });
    }

    protected processUpdateEnabledMarkToFalse(response: AxiosResponse): Promise<AppDTImgEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppDTImgEditDto.fromJS(resultData200);
            return Promise.resolve<AppDTImgEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppDTImgEditDto>(null as any);
    }

    /**
     * 启用
     * @param id (optional) 
     * @return Success
     */
    updateEnabledMarkToTrue(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AppDTImgEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AppDTImg/UpdateEnabledMarkToTrue?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnabledMarkToTrue(_response);
        });
    }

    protected processUpdateEnabledMarkToTrue(response: AxiosResponse): Promise<AppDTImgEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppDTImgEditDto.fromJS(resultData200);
            return Promise.resolve<AppDTImgEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppDTImgEditDto>(null as any);
    }
}

export class AppVersionDetailServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除AppVersionDetail的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * app版本更新
     * @param version (optional) 
     * @param code (optional) 
     * @return Success
     */
    checkUpdate(version: string | null | undefined, code: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AppDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/CheckUpdate?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUpdate(_response);
        });
    }

    protected processCheckUpdate(response: AxiosResponse): Promise<AppDownloadDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppDownloadDto.fromJS(resultData200);
            return Promise.resolve<AppDownloadDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppDownloadDto>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAppVersionDetailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取AppVersionDetailListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AppVersionDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AppVersionDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppVersionDetailListDto.fromJS(resultData200);
            return Promise.resolve<AppVersionDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionDetailListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAppVersionDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAppVersionDetailForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppVersionDetailForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAppVersionDetailForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppVersionDetailForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param appBaseId (optional) AppBaseId
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(appBaseId: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAppVersionDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/GetPaged?";
        if (appBaseId === null)
            throw new Error("The parameter 'appBaseId' cannot be null.");
        else if (appBaseId !== undefined)
            url_ += "appBaseId=" + encodeURIComponent("" + appBaseId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAppVersionDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAppVersionDetailListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAppVersionDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAppVersionDetailListDto>(null as any);
    }

    /**
     * 获取最新版本序号
     * @param appBaseId (optional) 
     * @return Success
     */
    getVersionSort(appBaseId: number | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/AppVersionDetail/GetVersionSort?";
        if (appBaseId === null)
            throw new Error("The parameter 'appBaseId' cannot be null.");
        else if (appBaseId !== undefined)
            url_ += "appBaseId=" + encodeURIComponent("" + appBaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersionSort(_response);
        });
    }

    protected processGetVersionSort(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AttendanceApiServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取员工请假记录
     * @param year (optional) 
     * @param month (optional) 
     * @param attLeaceType (optional) 请假类型
     * @param maxResultCount (optional) 条数
     * @param skipCount (optional) 跳过条数
     * @return Success
     */
    getAttLeaceRecordList(year: number | null | undefined, month: number | null | undefined, empId: number, attLeaceType: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAttLeaceRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceApi/GetAttLeaceRecordList?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (attLeaceType !== undefined && attLeaceType !== null)
            url_ += "attLeaceType=" + encodeURIComponent("" + attLeaceType) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttLeaceRecordList(_response);
        });
    }

    protected processGetAttLeaceRecordList(response: AxiosResponse): Promise<PagedResultDtoOfAttLeaceRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAttLeaceRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAttLeaceRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAttLeaceRecordListDto>(null as any);
    }

    /**
     * 获取员工加班记录
     * @param year (optional) 
     * @param month (optional) 
     * @param maxResultCount (optional) 条数
     * @param skipCount (optional) 跳过条数
     * @return Success
     */
    getAttOverTimeRecordList(year: number | null | undefined, month: number | null | undefined, empId: number, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAttOverTimeRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceApi/GetAttOverTimeRecordList?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttOverTimeRecordList(_response);
        });
    }

    protected processGetAttOverTimeRecordList(response: AxiosResponse): Promise<PagedResultDtoOfAttOverTimeRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAttOverTimeRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAttOverTimeRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAttOverTimeRecordListDto>(null as any);
    }

    /**
     * 获取员工补卡记录
     * @param year (optional) 
     * @param month (optional) 
     * @param maxResultCount (optional) 条数
     * @param skipCount (optional) 跳过条数
     * @return Success
     */
    getAttSignCardRecordList(year: number | null | undefined, month: number | null | undefined, empId: number, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAttSignCardRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceApi/GetAttSignCardRecordList?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttSignCardRecordList(_response);
        });
    }

    protected processGetAttSignCardRecordList(response: AxiosResponse): Promise<PagedResultDtoOfAttSignCardRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAttSignCardRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAttSignCardRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAttSignCardRecordListDto>(null as any);
    }
}

export class AttendanceGroupServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除AttendanceGroup的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改考勤组的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAttendanceGroupInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加员工排班明细
     * @param shiftinfoCode (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param body (optional) 考勤的人员
     * @return Success
     */
    createUserShiftPlanDetails(shiftinfoCode: string | null | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, body: AttendancePeopleEditDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/CreateUserShiftPlanDetails?";
        if (shiftinfoCode !== undefined && shiftinfoCode !== null)
            url_ += "shiftinfoCode=" + encodeURIComponent("" + shiftinfoCode) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserShiftPlanDetails(_response);
        });
    }

    protected processCreateUserShiftPlanDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除考勤组信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取排班明细
     * @param attGroupId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getAttGroupDetailedEdit(attGroupId: number | undefined, date: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<GetAttGroupDetailedDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetAttGroupDetailedEdit?";
        if (attGroupId === null)
            throw new Error("The parameter 'attGroupId' cannot be null.");
        else if (attGroupId !== undefined)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttGroupDetailedEdit(_response);
        });
    }

    protected processGetAttGroupDetailedEdit(response: AxiosResponse): Promise<GetAttGroupDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAttGroupDetailedDto.fromJS(resultData200);
            return Promise.resolve<GetAttGroupDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttGroupDetailedDto>(null as any);
    }

    /**
     * 获取考勤组集合
     * @return Success
     */
    getAttGroupList( cancelToken?: CancelToken | undefined): Promise<AttendanceGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetAttGroupList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttGroupList(_response);
        });
    }

    protected processGetAttGroupList(response: AxiosResponse): Promise<AttendanceGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AttendanceGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AttendanceGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttendanceGroupListDto[]>(null as any);
    }

    /**
     * 通过指定id获取AttendanceGroupListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AttendanceGroupListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AttendanceGroupListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttendanceGroupListDto.fromJS(resultData200);
            return Promise.resolve<AttendanceGroupListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttendanceGroupListDto>(null as any);
    }

    /**
     * 根据考勤组Id、年、月获取日历数据初始化
     * @param attGroupId (optional) 
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    getCalendarList(attGroupId: number | undefined, year: number | undefined, month: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetCalendarListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetCalendarList?";
        if (attGroupId === null)
            throw new Error("The parameter 'attGroupId' cannot be null.");
        else if (attGroupId !== undefined)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCalendarList(_response);
        });
    }

    protected processGetCalendarList(response: AxiosResponse): Promise<GetCalendarListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetCalendarListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetCalendarListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCalendarListDto[]>(null as any);
    }

    /**
     * 获取编辑 考勤组
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAttendanceGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAttendanceGroupForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAttendanceGroupForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAttendanceGroupForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttendanceGroupForEditOutput>(null as any);
    }

    /**
     * 获取考勤组的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAttendanceGroupListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAttendanceGroupListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAttendanceGroupListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAttendanceGroupListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAttendanceGroupListDto>(null as any);
    }

    /**
     * 获取当前考勤组周期排列的周期班次
     * @param attGroupId (optional) 
     * @return Success
     */
    getShiftinfoByAttGroupId(attGroupId: number | undefined, cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetShiftinfoByAttGroupId?";
        if (attGroupId === null)
            throw new Error("The parameter 'attGroupId' cannot be null.");
        else if (attGroupId !== undefined)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftinfoByAttGroupId(_response);
        });
    }

    protected processGetShiftinfoByAttGroupId(response: AxiosResponse): Promise<ShiftInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShiftInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto[]>(null as any);
    }

    /**
     * 获取当前考勤组的考勤班次
     * @param attGroupId (optional) 
     * @return Success
     */
    getShiftInfoCodeByAttGroupId(attGroupId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetShiftInfoCodeByAttGroupId?";
        if (attGroupId !== undefined && attGroupId !== null)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftInfoCodeByAttGroupId(_response);
        });
    }

    protected processGetShiftInfoCodeByAttGroupId(response: AxiosResponse): Promise<ShiftInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShiftInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto[]>(null as any);
    }

    /**
     * 根据员工获取相对应的考勤班次
     * @param empId (optional) 
     * @return Success
     */
    getShiftInfoCodeByEmpId(empId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetShiftInfoCodeByEmpId?";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftInfoCodeByEmpId(_response);
        });
    }

    protected processGetShiftInfoCodeByEmpId(response: AxiosResponse): Promise<ShiftInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShiftInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto[]>(null as any);
    }

    /**
     * 导出考勤组为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 轮班
     * @param body (optional) 
     * @return Success
     */
    shift(body: ShiftEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShift(_response);
        });
    }

    protected processShift(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改考勤组内指定日期的考勤班次
     * @param attGroupId (optional) 
     * @param attendDate (optional) 
     * @param attendShiftCode (optional) 
     * @param isCover (optional) 是否覆盖所有考勤组人员班次
     * @return Success
     */
    updateAttGroupPlanByDateTime(attGroupId: number | undefined, attendDate: moment.Moment | undefined, attendShiftCode: string | null | undefined, isCover: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceGroup/UpdateAttGroupPlanByDateTime?";
        if (attGroupId === null)
            throw new Error("The parameter 'attGroupId' cannot be null.");
        else if (attGroupId !== undefined)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        if (attendDate === null)
            throw new Error("The parameter 'attendDate' cannot be null.");
        else if (attendDate !== undefined)
            url_ += "attendDate=" + encodeURIComponent(attendDate ? "" + attendDate.toISOString() : "") + "&";
        if (attendShiftCode !== undefined && attendShiftCode !== null)
            url_ += "attendShiftCode=" + encodeURIComponent("" + attendShiftCode) + "&";
        if (isCover === null)
            throw new Error("The parameter 'isCover' cannot be null.");
        else if (isCover !== undefined)
            url_ += "isCover=" + encodeURIComponent("" + isCover) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAttGroupPlanByDateTime(_response);
        });
    }

    protected processUpdateAttGroupPlanByDateTime(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AttMachineDeployServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除AttMachineDeploy的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAttMachineDeployInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取AttMachineDeployListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AttMachineDeployListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AttMachineDeployListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttMachineDeployListDto.fromJS(resultData200);
            return Promise.resolve<AttMachineDeployListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttMachineDeployListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAttMachineDeployForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAttMachineDeployForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAttMachineDeployForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAttMachineDeployForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttMachineDeployForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAttMachineDeployListDto> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAttMachineDeployListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAttMachineDeployListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAttMachineDeployListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAttMachineDeployListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttMachineDeploy/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class AudititemServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdataAuditItemInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditItemEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditItemEditDto.fromJS(resultData200);
            return Promise.resolve<AuditItemEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param auditItemTypeId (optional) 审核项类型id
     * @param auditItemGroupId (optional) 审核项分组id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(auditItemTypeId: number | null | undefined, auditItemGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetPaged?";
        if (auditItemTypeId !== undefined && auditItemTypeId !== null)
            url_ += "auditItemTypeId=" + encodeURIComponent("" + auditItemTypeId) + "&";
        if (auditItemGroupId !== undefined && auditItemGroupId !== null)
            url_ += "auditItemGroupId=" + encodeURIComponent("" + auditItemGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditItemListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditItemListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditItemListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditItemListDto>(null as any);
    }

    /**
     * 获取分页数据（仅包含启用数据）
     * @param auditItemTypeId (optional) 审核项类型id
     * @param auditItemGroupId (optional) 审核项分组id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedEnable(auditItemTypeId: number | null | undefined, auditItemGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetPagedEnable?";
        if (auditItemTypeId !== undefined && auditItemTypeId !== null)
            url_ += "auditItemTypeId=" + encodeURIComponent("" + auditItemTypeId) + "&";
        if (auditItemGroupId !== undefined && auditItemGroupId !== null)
            url_ += "auditItemGroupId=" + encodeURIComponent("" + auditItemGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedEnable(_response);
        });
    }

    protected processGetPagedEnable(response: AxiosResponse): Promise<PagedResultDtoOfAuditItemListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditItemListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditItemListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditItemListDto>(null as any);
    }

    /**
     * 导出
     * @param auditItemTypeId (optional) 审核项类型id
     * @param auditItemGroupId (optional) 审核项分组id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param ids (optional) 
     * @return Success
     */
    getToExcelFile(auditItemTypeId: number | null | undefined, auditItemGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, ids: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetToExcelFile?";
        if (auditItemTypeId !== undefined && auditItemTypeId !== null)
            url_ += "auditItemTypeId=" + encodeURIComponent("" + auditItemTypeId) + "&";
        if (auditItemGroupId !== undefined && auditItemGroupId !== null)
            url_ += "auditItemGroupId=" + encodeURIComponent("" + auditItemGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 下载导入模板
     * @return Success
     */
    getToImportTempFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetToImportTempFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToImportTempFile(_response);
        });
    }

    protected processGetToImportTempFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param query (optional) 
     * @param groupchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: AuditItemGroupListDto[] | null | undefined, groupchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (groupchildrenList !== undefined && groupchildrenList !== null)
            groupchildrenList && groupchildrenList.forEach(item => { url_ += "groupchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param query (optional) 
     * @param typechildrenList (optional) 
     * @return Success
     */
    getTypeTreeChildren(query: AuditItemTypeListDto[] | null | undefined, typechildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetTypeTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (typechildrenList !== undefined && typechildrenList !== null)
            typechildrenList && typechildrenList.forEach(item => { url_ += "typechildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTypeTreeChildren(_response);
        });
    }

    protected processGetTypeTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查看审核项
     * @param id (optional) 
     * @return Success
     */
    getViewInfo(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/GetViewInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewInfo(_response);
        });
    }

    protected processGetViewInfo(response: AxiosResponse): Promise<AuditItemListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditItemListDto.fromJS(resultData200);
            return Promise.resolve<AuditItemListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemListDto>(null as any);
    }

    /**
     * 导入数据
     * @param fileName (optional) 
     * @return Success
     */
    importExcel(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * 是否启用功能接口
     * @param enable (optional) 
     * @param body (optional) 
     * @return Success
     */
    isDetelt(enable: boolean | undefined, body: NullableIdDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/IsDetelt?";
        if (enable === null)
            throw new Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsDetelt(_response);
        });
    }

    protected processIsDetelt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 移动富文本图片
     * @param fileName (optional) 
     * @return Success
     */
    moveFile(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Audititem/MoveFile?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveFile(_response);
        });
    }

    protected processMoveFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditItemExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 导入模板下载
     * @param body (optional) 
     * @return Success
     */
    importToExcelTemplate(body: DataItemDetail[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemExporter/ImportToExcelTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportToExcelTemplate(_response);
        });
    }

    protected processImportToExcelTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class AuditItemGroupServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemGroup/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdateAuditItemGroupInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemGroup/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取树Id
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemGroup/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<AuditItemGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemGroupListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemGroupEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemGroup/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditItemGroupEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditItemGroupEditDto.fromJS(resultData200);
            return Promise.resolve<AuditItemGroupEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemGroupEditDto>(null as any);
    }

    /**
     * 获取审核项树数据
     * @param filterText (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemGroup/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<AuditItemGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemGroupListDto[]>(null as any);
    }
}

export class AuditItemTemplateServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制
     * @param id (optional) 
     * @param newName (optional) 
     * @return Success
     */
    copy(id: number | undefined, newName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/Copy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdataAuditItemTemplateDetailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param auditItemTemplateId (optional) 审核模板Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditItem(auditItemTemplateId: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/GetAuditItem?";
        if (auditItemTemplateId === null)
            throw new Error("The parameter 'auditItemTemplateId' cannot be null.");
        else if (auditItemTemplateId !== undefined)
            url_ += "auditItemTemplateId=" + encodeURIComponent("" + auditItemTemplateId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditItem(_response);
        });
    }

    protected processGetAuditItem(response: AxiosResponse): Promise<AuditItemListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditItemTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditItemTemplateListDto.fromJS(resultData200);
            return Promise.resolve<AuditItemTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTemplateListDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param auditItemTemplateGroupId (optional) 审核项模板分组Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(auditItemTemplateGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditItemTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplate/GetPaged?";
        if (auditItemTemplateGroupId !== undefined && auditItemTemplateGroupId !== null)
            url_ += "auditItemTemplateGroupId=" + encodeURIComponent("" + auditItemTemplateGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditItemTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditItemTemplateListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditItemTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditItemTemplateListDto>(null as any);
    }
}

export class AuditItemTemplateGroupServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplateGroup/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAuditItemTemplateGroupInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplateGroup/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplateGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取树Id
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTemplateGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplateGroup/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<AuditItemTemplateGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemTemplateGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemTemplateGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTemplateGroupListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTemplateGroupEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplateGroup/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditItemTemplateGroupEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditItemTemplateGroupEditDto.fromJS(resultData200);
            return Promise.resolve<AuditItemTemplateGroupEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTemplateGroupEditDto>(null as any);
    }

    /**
     * 获取审核项树数据
     * @param filterText (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTemplateGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemTemplateGroup/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<AuditItemTemplateGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemTemplateGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemTemplateGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTemplateGroupListDto[]>(null as any);
    }
}

export class AuditItemtypeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdateAuditItemTypeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有数据（不分页）
     * @return Success
     */
    getAllDate( cancelToken?: CancelToken | undefined): Promise<AuditItemTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/GetAllDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDate(_response);
        });
    }

    protected processGetAllDate(response: AxiosResponse): Promise<AuditItemTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemTypeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTypeListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<AuditItemTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemTypeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTypeListDto[]>(null as any);
    }

    /**
     * 获取编辑数据
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemTypeEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditItemTypeEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditItemTypeEditDto.fromJS(resultData200);
            return Promise.resolve<AuditItemTypeEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemTypeEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditItemTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditItemTypeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditItemTypeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditItemTypeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditItemTypeListDto>(null as any);
    }

    /**
     * 循环获取树Id数据
     * @param auditItemTypeId (optional) 
     * @return Success
     */
    getTreeAuditItemTypeId(auditItemTypeId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditItemtype/GetTreeAuditItemTypeId?";
        if (auditItemTypeId !== undefined && auditItemTypeId !== null)
            url_ += "auditItemTypeId=" + encodeURIComponent("" + auditItemTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeAuditItemTypeId(_response);
        });
    }

    protected processGetTreeAuditItemTypeId(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class AuditLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param userName (optional) 用户名
     * @param serviceName (optional) 服务名称
     * @param methodName (optional) 方法名称
     * @param browserInfo (optional) 浏览器信息
     * @param hasException (optional) 是否包含异常
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "methodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "browserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "hasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "minExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "maxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogsToExcel(_response);
        });
    }

    protected processGetAuditLogsToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "entityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityChanges(_response);
        });
    }

    protected processGetEntityChanges(response: AxiosResponse): Promise<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEntityChangeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEntityChangeListDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "entityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityChangesToExcel(_response);
        });
    }

    protected processGetEntityChangesToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes( cancelToken?: CancelToken | undefined): Promise<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityHistoryObjectTypes(_response);
        });
    }

    protected processGetEntityHistoryObjectTypes(response: AxiosResponse): Promise<NameValueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NameValueDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NameValueDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param userName (optional) 用户名
     * @param serviceName (optional) 服务名称
     * @param methodName (optional) 方法名称
     * @param browserInfo (optional) 浏览器信息
     * @param hasException (optional) 是否包含异常
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedAuditLogs(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetPagedAuditLogs?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "methodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "browserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "hasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "minExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "maxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedAuditLogs(_response);
        });
    }

    protected processGetPagedAuditLogs(response: AxiosResponse): Promise<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditLogListDto>(null as any);
    }
}

export class AuditPointServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAuditPointInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取手机号码
     * @param id (optional) 
     * @return Success
     */
    generateWXMPQrCodePic(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GenerateWXMPQrCodePic?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateWXMPQrCodePic(_response);
        });
    }

    protected processGenerateWXMPQrCodePic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取小程序AccessToken
     * @return Success
     */
    getAccessToken( cancelToken?: CancelToken | undefined): Promise<WXAccessToken> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessToken(_response);
        });
    }

    protected processGetAccessToken(response: AxiosResponse): Promise<WXAccessToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WXAccessToken.fromJS(resultData200);
            return Promise.resolve<WXAccessToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WXAccessToken>(null as any);
    }

    /**
     * @return Success
     */
    getAllData( cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * 获取编辑DTO
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditPointEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditPointEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditPointEditDto.fromJS(resultData200);
            return Promise.resolve<AuditPointEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditPointEditDto>(null as any);
    }

    /**
     * 获取分页信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditpointListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditpointListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditpointListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditpointListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditpointListDto>(null as any);
    }

    /**
     * 导出
     * @param filterText (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param ids (optional)
     * @return Success
     */
    getToExcelFile(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, ids: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetToExcelFile?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param query (optional)
     * @param orgchildrenList (optional)
     * @return Success
     */
    getTreeByIdChildren(query: AuditpointListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/GetTreeByIdChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeByIdChildren(_response);
        });
    }

    protected processGetTreeByIdChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 移动富文本图片
     * @param fileName (optional) 
     * @return Success
     */
    moveFile(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditPoint/MoveFile?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveFile(_response);
        });
    }

    protected processMoveFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditTaskServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 审核团队月视图
     * @param body (optional) 
     * @return Success
     */
    auditTeamMonthView(body: AuditTeamMonthViewInput | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTeamMonthViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/AuditTeamMonthView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuditTeamMonthView(_response);
        });
    }

    protected processAuditTeamMonthView(response: AxiosResponse): Promise<AuditTeamMonthViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTeamMonthViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTeamMonthViewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamMonthViewDto[]>(null as any);
    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量完成任务
     * @param body (optional) 
     * @return Success
     */
    batchFinishTask(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/BatchFinishTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchFinishTask(_response);
        });
    }

    protected processBatchFinishTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量修改审核人
     * @param inspectorid (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchUpdateInspector(inspectorid: number | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/BatchUpdateInspector?";
        if (inspectorid === null)
            throw new Error("The parameter 'inspectorid' cannot be null.");
        else if (inspectorid !== undefined)
            url_ += "inspectorid=" + encodeURIComponent("" + inspectorid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateInspector(_response);
        });
    }

    protected processBatchUpdateInspector(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建审核计划
     * @param body (optional) 
     * @return Success
     */
    createAuditTask(body: CreateAuditTaskDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/CreateAuditTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAuditTask(_response);
        });
    }

    protected processCreateAuditTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取分页数据
     * @param auditItemTemplateGroupId (optional) 审核项模板分组Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllAuditItemTemplate(auditItemTemplateGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditItemTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAllAuditItemTemplate?";
        if (auditItemTemplateGroupId !== undefined && auditItemTemplateGroupId !== null)
            url_ += "auditItemTemplateGroupId=" + encodeURIComponent("" + auditItemTemplateGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAuditItemTemplate(_response);
        });
    }

    protected processGetAllAuditItemTemplate(response: AxiosResponse): Promise<PagedResultDtoOfAuditItemTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditItemTemplateListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditItemTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditItemTemplateListDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param auditTemplateGroupId (optional) 审核点模板分组Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllAuditTemplate(auditTemplateGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAllAuditTemplate?";
        if (auditTemplateGroupId !== undefined && auditTemplateGroupId !== null)
            url_ += "auditTemplateGroupId=" + encodeURIComponent("" + auditTemplateGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAuditTemplate(_response);
        });
    }

    protected processGetAllAuditTemplate(response: AxiosResponse): Promise<PagedResultDtoOfAuditTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditTemplateListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditTemplateListDto>(null as any);
    }

    /**
     * 获取所有任务数据
     * @return Success
     */
    getAllData( cancelToken?: CancelToken | undefined): Promise<AuditTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<AuditTaskListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTaskListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTaskListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskListDto[]>(null as any);
    }

    /**
     * 获取所有LPA用户
     * @return Success
     */
    getAllLPAUsers( cancelToken?: CancelToken | undefined): Promise<User[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAllLPAUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllLPAUsers(_response);
        });
    }

    protected processGetAllLPAUsers(response: AxiosResponse): Promise<User[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<User[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User[]>(null as any);
    }

    /**
     * 报表
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param auditPoint (optional) 审核点
     * @param auditTaskLabel (optional) 审核标签
     * @return Success
     */
    getAuditResultSummary_Report(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, auditPoint: number | null | undefined, auditTaskLabel: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditResultSummary_ReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAuditResultSummary_Report?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (auditPoint !== undefined && auditPoint !== null)
            url_ += "auditPoint=" + encodeURIComponent("" + auditPoint) + "&";
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditResultSummary_Report(_response);
        });
    }

    protected processGetAuditResultSummary_Report(response: AxiosResponse): Promise<AuditResultSummary_ReportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditResultSummary_ReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditResultSummary_ReportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditResultSummary_ReportDto[]>(null as any);
    }

    /**
     * 获取审核记录
     * @param auditPointId (optional) 审核点Id
     * @param auditItemId (optional) 审核项Id
     * @param startDate (optional) 审核开始时间
     * @param endDate (optional) 审核结束时间
     * @param planStartDate (optional) 计划开始时间
     * @param planEndDate (optional) 计划结束时间
     * @param userId (optional) 审核点Id
     * @param isSkip (optional) 是否跳过
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditTaskDetail(auditPointId: number | null | undefined, auditItemId: number | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, planStartDate: moment.Moment | null | undefined, planEndDate: moment.Moment | null | undefined, userId: number | null | undefined, isSkip: boolean | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetAuditTaskDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAuditTaskDetail?";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (auditItemId !== undefined && auditItemId !== null)
            url_ += "auditItemId=" + encodeURIComponent("" + auditItemId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (planStartDate !== undefined && planStartDate !== null)
            url_ += "planStartDate=" + encodeURIComponent(planStartDate ? "" + planStartDate.toISOString() : "") + "&";
        if (planEndDate !== undefined && planEndDate !== null)
            url_ += "planEndDate=" + encodeURIComponent(planEndDate ? "" + planEndDate.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isSkip !== undefined && isSkip !== null)
            url_ += "isSkip=" + encodeURIComponent("" + isSkip) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskDetail(_response);
        });
    }

    protected processGetAuditTaskDetail(response: AxiosResponse): Promise<PagedResultDtoOfGetAuditTaskDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetAuditTaskDetailListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetAuditTaskDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetAuditTaskDetailListDto>(null as any);
    }

    /**
     * 获取单个审核任务
     * @param taskId (optional) 审核任务Id
     * @return Success
     */
    getById(taskId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTaskListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetById?";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AuditTaskListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditTaskListDto.fromJS(resultData200);
            return Promise.resolve<AuditTaskListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskListDto>(null as any);
    }

    /**
     * 获取审核任务下的审核记录
     * @param auditTaskId (optional) 审核任务Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getDetailByAuditTaskId(auditTaskId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetDetailByAuditTaskIdListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetDetailByAuditTaskId?";
        if (auditTaskId !== undefined && auditTaskId !== null)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailByAuditTaskId(_response);
        });
    }

    protected processGetDetailByAuditTaskId(response: AxiosResponse): Promise<PagedResultDtoOfGetDetailByAuditTaskIdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetDetailByAuditTaskIdListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetDetailByAuditTaskIdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetDetailByAuditTaskIdListDto>(null as any);
    }

    /**
     * @return Success
     */
    getAuditTaskPointIds(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<number[] | null> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetAuditTaskPointIds?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskPointIds(_response);
        });
    }

    protected processGetAuditTaskPointIds(response: AxiosResponse): Promise<number[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return Promise.resolve<number[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[] | null>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional)
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTaskListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditTaskListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditTaskListDto.fromJS(resultData200);
            return Promise.resolve<AuditTaskListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskListDto>(null as any);
    }

    /**
     * 获取是否启用任务转办
     * @return Success
     */
    getIsEnabledAuditTaskTransfer( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetIsEnabledAuditTaskTransfer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnabledAuditTaskTransfer(_response);
        });
    }

    protected processGetIsEnabledAuditTaskTransfer(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取审核任务下的问题记录
     * @param auditTaskId (optional) 审核任务Id
     * @param auditPointId (optional) 审核点Id
     * @param auditItemId (optional) 审核项Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getIssueByAuditTaskId(auditTaskId: number | null | undefined, auditPointId: number | null | undefined, auditItemId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetIssueByAuditTaskIdListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetIssueByAuditTaskId?";
        if (auditTaskId !== undefined && auditTaskId !== null)
            url_ += "auditTaskId=" + encodeURIComponent("" + auditTaskId) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (auditItemId !== undefined && auditItemId !== null)
            url_ += "auditItemId=" + encodeURIComponent("" + auditItemId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueByAuditTaskId(_response);
        });
    }

    protected processGetIssueByAuditTaskId(response: AxiosResponse): Promise<PagedResultDtoOfGetIssueByAuditTaskIdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetIssueByAuditTaskIdListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetIssueByAuditTaskIdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetIssueByAuditTaskIdListDto>(null as any);
    }

    /**
     * 获取审核任务下的问题记录
     * @param issueList (optional) 问题Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getIssueByIssueId(issueList: number[] | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetIssueByAuditTaskIdListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetIssueByIssueId?";
        if (issueList !== undefined && issueList !== null)
            issueList && issueList.forEach(item => { url_ += "issueList=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueByIssueId(_response);
        });
    }

    protected processGetIssueByIssueId(response: AxiosResponse): Promise<PagedResultDtoOfGetIssueByAuditTaskIdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetIssueByAuditTaskIdListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetIssueByAuditTaskIdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetIssueByAuditTaskIdListDto>(null as any);
    }

    /**
     * 月视图
     * @param datetime (optional) 
     * @return Success
     */
    getMonthView(datetime: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<MonthviewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetMonthView?";
        if (datetime !== undefined && datetime !== null)
            url_ += "datetime=" + encodeURIComponent("" + datetime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthView(_response);
        });
    }

    protected processGetMonthView(response: AxiosResponse): Promise<MonthviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthviewDto[]>(null as any);
    }

    /**
     * 获取分页数据
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param status (optional) 状态
     * @param userId (optional) 用户
     * @param auditTaskType (optional) 审核类型
     * @param ids (optional) Ids
     * @param auditTaskLabel (optional) 审核任务标签
     * @param barcode (optional) 条码
     * @param assitField (optional) 辅助字段
     * @param levelId (optional) 层级
     * @param orgId (optional) 部门
     * @param auditTeamId (optional) 审核团队
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, status: string[] | null | undefined, userId: number | null | undefined, auditTaskType: string | null | undefined, ids: number[] | null | undefined, auditTaskLabel: string | null | undefined, barcode: string | null | undefined, assitField: string | null | undefined, levelId: number | null | undefined, orgId: number | null | undefined, auditTeamId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditTaskListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetPaged?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "status=" + encodeURIComponent("" + item) + "&"; });
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (auditTaskType !== undefined && auditTaskType !== null)
            url_ += "auditTaskType=" + encodeURIComponent("" + auditTaskType) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (assitField !== undefined && assitField !== null)
            url_ += "assitField=" + encodeURIComponent("" + assitField) + "&";
        if (levelId !== undefined && levelId !== null)
            url_ += "levelId=" + encodeURIComponent("" + levelId) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (auditTeamId !== undefined && auditTeamId !== null)
            url_ += "auditTeamId=" + encodeURIComponent("" + auditTeamId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditTaskListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditTaskListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditTaskListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditTaskListDto>(null as any);
    }

    /**
     * 点位审核次数统计折线图
     * @param isPointDetail (optional) 是否点位明细
     * @param auditPointList (optional) 选择的审核点
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getPointAuditStatisticsCount(isPointDetail: boolean | undefined, auditPointList: number[] | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<PointAuditStatisticsCountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetPointAuditStatisticsCount?";
        if (isPointDetail === null)
            throw new Error("The parameter 'isPointDetail' cannot be null.");
        else if (isPointDetail !== undefined)
            url_ += "isPointDetail=" + encodeURIComponent("" + isPointDetail) + "&";
        if (auditPointList !== undefined && auditPointList !== null)
            auditPointList && auditPointList.forEach(item => { url_ += "auditPointList=" + encodeURIComponent("" + item) + "&"; });
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPointAuditStatisticsCount(_response);
        });
    }

    protected processGetPointAuditStatisticsCount(response: AxiosResponse): Promise<PointAuditStatisticsCountListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PointAuditStatisticsCountListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PointAuditStatisticsCountListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PointAuditStatisticsCountListDto[]>(null as any);
    }

    /**
     * 审核任务导出
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param status (optional) 状态
     * @param userId (optional) 用户
     * @param auditTaskType (optional) 审核类型
     * @param ids (optional) Ids
     * @param auditTaskLabel (optional) 审核任务标签
     * @param barcode (optional) 条码
     * @param assitField (optional) 辅助字段
     * @param levelId (optional) 层级
     * @param orgId (optional) 部门
     * @param auditTeamId (optional) 审核团队
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcel(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, status: string[] | null | undefined, userId: number | null | undefined, auditTaskType: string | null | undefined, ids: number[] | null | undefined, auditTaskLabel: string | null | undefined, barcode: string | null | undefined, assitField: string | null | undefined, levelId: number | null | undefined, orgId: number | null | undefined, auditTeamId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetToExcel?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "status=" + encodeURIComponent("" + item) + "&"; });
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (auditTaskType !== undefined && auditTaskType !== null)
            url_ += "auditTaskType=" + encodeURIComponent("" + auditTaskType) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (assitField !== undefined && assitField !== null)
            url_ += "assitField=" + encodeURIComponent("" + assitField) + "&";
        if (levelId !== undefined && levelId !== null)
            url_ += "levelId=" + encodeURIComponent("" + levelId) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (auditTeamId !== undefined && auditTeamId !== null)
            url_ += "auditTeamId=" + encodeURIComponent("" + auditTeamId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcel(_response);
        });
    }

    protected processGetToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导出
     * @param auditPointId (optional) 审核点Id
     * @param auditItemId (optional) 审核项Id
     * @param startDate (optional) 审核开始时间
     * @param endDate (optional) 审核结束时间
     * @param planStartDate (optional) 计划开始时间
     * @param planEndDate (optional) 计划结束时间
     * @param userId (optional) 审核点Id
     * @param isSkip (optional) 是否跳过
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param ids (optional) 
     * @return Success
     */
    getToExcelAuditTaskDetail(auditPointId: number | null | undefined, auditItemId: number | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, planStartDate: moment.Moment | null | undefined, planEndDate: moment.Moment | null | undefined, userId: number | null | undefined, isSkip: boolean | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, ids: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetToExcelAuditTaskDetail?";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (auditItemId !== undefined && auditItemId !== null)
            url_ += "auditItemId=" + encodeURIComponent("" + auditItemId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (planStartDate !== undefined && planStartDate !== null)
            url_ += "planStartDate=" + encodeURIComponent(planStartDate ? "" + planStartDate.toISOString() : "") + "&";
        if (planEndDate !== undefined && planEndDate !== null)
            url_ += "planEndDate=" + encodeURIComponent(planEndDate ? "" + planEndDate.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isSkip !== undefined && isSkip !== null)
            url_ += "isSkip=" + encodeURIComponent("" + isSkip) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelAuditTaskDetail(_response);
        });
    }

    protected processGetToExcelAuditTaskDetail(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导出带文件的
     * @param auditPointId (optional) 审核点Id
     * @param auditItemId (optional) 审核项Id
     * @param startDate (optional) 审核开始时间
     * @param endDate (optional) 审核结束时间
     * @param planStartDate (optional) 计划开始时间
     * @param planEndDate (optional) 计划结束时间
     * @param userId (optional) 审核点Id
     * @param isSkip (optional) 是否跳过
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param ids (optional) 
     * @return Success
     */
    getToExcelAuditTaskDetailHasFile(auditPointId: number | null | undefined, auditItemId: number | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, planStartDate: moment.Moment | null | undefined, planEndDate: moment.Moment | null | undefined, userId: number | null | undefined, isSkip: boolean | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, ids: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetToExcelAuditTaskDetailHasFile?";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (auditItemId !== undefined && auditItemId !== null)
            url_ += "auditItemId=" + encodeURIComponent("" + auditItemId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (planStartDate !== undefined && planStartDate !== null)
            url_ += "planStartDate=" + encodeURIComponent(planStartDate ? "" + planStartDate.toISOString() : "") + "&";
        if (planEndDate !== undefined && planEndDate !== null)
            url_ += "planEndDate=" + encodeURIComponent(planEndDate ? "" + planEndDate.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isSkip !== undefined && isSkip !== null)
            url_ += "isSkip=" + encodeURIComponent("" + isSkip) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelAuditTaskDetailHasFile(_response);
        });
    }

    protected processGetToExcelAuditTaskDetailHasFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导出报告
     * @param id (optional) 
     * @return Success
     */
    getToExcelByExportReport(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetToExcelByExportReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelByExportReport(_response);
        });
    }

    protected processGetToExcelByExportReport(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 审核任务详情导出
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param status (optional) 状态
     * @param userId (optional) 用户
     * @param auditTaskType (optional) 审核类型
     * @param ids (optional) Ids
     * @param auditTaskLabel (optional) 审核任务标签
     * @param barcode (optional) 条码
     * @param assitField (optional) 辅助字段
     * @param levelId (optional) 层级
     * @param orgId (optional) 部门
     * @param auditTeamId (optional) 审核团队
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelDetail(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, status: string[] | null | undefined, userId: number | null | undefined, auditTaskType: string | null | undefined, ids: number[] | null | undefined, auditTaskLabel: string | null | undefined, barcode: string | null | undefined, assitField: string | null | undefined, levelId: number | null | undefined, orgId: number | null | undefined, auditTeamId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetToExcelDetail?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "status=" + encodeURIComponent("" + item) + "&"; });
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (auditTaskType !== undefined && auditTaskType !== null)
            url_ += "auditTaskType=" + encodeURIComponent("" + auditTaskType) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (assitField !== undefined && assitField !== null)
            url_ += "assitField=" + encodeURIComponent("" + assitField) + "&";
        if (levelId !== undefined && levelId !== null)
            url_ += "levelId=" + encodeURIComponent("" + levelId) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (auditTeamId !== undefined && auditTeamId !== null)
            url_ += "auditTeamId=" + encodeURIComponent("" + auditTeamId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelDetail(_response);
        });
    }

    protected processGetToExcelDetail(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 下载导入模板
     * @return Success
     */
    getToImportTempFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetToImportTempFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToImportTempFile(_response);
        });
    }

    protected processGetToImportTempFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: LayoutOrgListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param query (optional) 
     * @param id (optional) 
     * @param ids (optional) 
     * @return Success
     */
    getTreeChildrenId(query: AuditpointListDto[] | null | undefined, id: number | undefined, ids: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/GetTreeChildrenId?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildrenId(_response);
        });
    }

    protected processGetTreeChildrenId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入数据
     * @param fileName (optional) 
     * @param isNoExist (optional) 是否可以创建重复任务
     * @return Success
     */
    importExcel(fileName: string | null | undefined, isNoExist: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (isNoExist === null)
            throw new Error("The parameter 'isNoExist' cannot be null.");
        else if (isNoExist !== undefined)
            url_ += "isNoExist=" + encodeURIComponent("" + isNoExist) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * 是否启用任务转办
     * @param body (optional) 
     * @return Success
     */
    isEnabledAuditTaskTransfer(body: IsEnabledAuditTaskTransferDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/IsEnabledAuditTaskTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnabledAuditTaskTransfer(_response);
        });
    }

    protected processIsEnabledAuditTaskTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 请假
     * @param body (optional) 
     * @return Success
     */
    leave(body: LeaveDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/Leave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLeave(_response);
        });
    }

    protected processLeave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 月视图
     * @param body (optional) 
     * @return Success
     */
    month_View(body: Month_ViewInput | undefined, cancelToken?: CancelToken | undefined): Promise<Month_ViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/Month_View";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMonth_View(_response);
        });
    }

    protected processMonth_View(response: AxiosResponse): Promise<Month_ViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Month_ViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Month_ViewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Month_ViewDto[]>(null as any);
    }

    /**
     * 报表
     * @param taskId (optional) 
     * @return Success
     */
    task_Report(taskId: number | undefined, cancelToken?: CancelToken | undefined): Promise<Task_ReportAndTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/Task_Report?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTask_Report(_response);
        });
    }

    protected processTask_Report(response: AxiosResponse): Promise<Task_ReportAndTitleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Task_ReportAndTitleDto.fromJS(resultData200);
            return Promise.resolve<Task_ReportAndTitleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Task_ReportAndTitleDto>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param body (optional) 
     * @return Success
     */
    update(body: AuditTaskEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTask/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditTaskExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 检验任务导出为Excel文件
     * @param title (optional) 
     * @param weekdate (optional) 
     * @param companyCode (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportToExcelFile(title: string | null | undefined, weekdate: string | null | undefined, companyCode: string | null | undefined, body: AuditTaskExportDetailDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTaskExporter/ExportToExcelFile?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (weekdate !== undefined && weekdate !== null)
            url_ += "weekdate=" + encodeURIComponent("" + weekdate) + "&";
        if (companyCode !== undefined && companyCode !== null)
            url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToExcelFile(_response);
        });
    }

    protected processExportToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导入模板下载
     * @return Success
     */
    importToExcelTemplate( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTaskExporter/ImportToExcelTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportToExcelTemplate(_response);
        });
    }

    protected processImportToExcelTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class AuditTeamServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加团队成员
     * @param teamId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addMembers(teamId: number | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/AddMembers?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMembers(_response);
        });
    }

    protected processAddMembers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除团队
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建团队
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAuditTeamDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 删除团队
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取详情
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTeamDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AuditTeamDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditTeamDetailDto.fromJS(resultData200);
            return Promise.resolve<AuditTeamDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamDetailDto>(null as any);
    }

    /**
     * 获取团队列表（不包含分页）
     * @return Success
     */
    getAll( cancelToken?: CancelToken | undefined): Promise<AuditTeamListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AuditTeamListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTeamListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTeamListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamListDto[]>(null as any);
    }

    /**
     * 获取审核团队选择列表
     * @return Success
     */
    getAllForSelect( cancelToken?: CancelToken | undefined): Promise<AuditTeamForSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/GetAllForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllForSelect(_response);
        });
    }

    protected processGetAllForSelect(response: AxiosResponse): Promise<AuditTeamForSelectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTeamForSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTeamForSelectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamForSelectDto[]>(null as any);
    }

    /**
     * 获取编辑数据
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTeamEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditTeamEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditTeamEditDto.fromJS(resultData200);
            return Promise.resolve<AuditTeamEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param name (optional) 团队名称（模糊查询）
     * @param status (optional) 团队状态筛选
     * @param leaderId (optional) 团队负责人ID
     * @param scenesId (optional) 场景ID
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPaged(name: string | null | undefined, status: number | null | undefined, leaderId: number | null | undefined, scenesId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditTeamListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/GetPaged?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (leaderId !== undefined && leaderId !== null)
            url_ += "leaderId=" + encodeURIComponent("" + leaderId) + "&";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditTeamListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditTeamListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditTeamListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditTeamListDto>(null as any);
    }

    /**
     * 获取团队成员
     * @param teamId (optional) 
     * @return Success
     */
    getTeamMembers(teamId: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTeamMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/GetTeamMembers?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamMembers(_response);
        });
    }

    protected processGetTeamMembers(response: AxiosResponse): Promise<AuditTeamMemberDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTeamMemberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTeamMemberDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamMemberDto[]>(null as any);
    }

    /**
     * 获取用户可加入的团队列表
     * @param userId (optional) 
     * @return Success
     */
    getUserAvailableTeams(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTeamListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/GetUserAvailableTeams?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAvailableTeams(_response);
        });
    }

    protected processGetUserAvailableTeams(response: AxiosResponse): Promise<AuditTeamListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTeamListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTeamListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTeamListDto[]>(null as any);
    }

    /**
     * 移除团队成员
     * @param teamId (optional) 
     * @param userIds (optional) 
     * @return Success
     */
    removeMembers(teamId: number | undefined, userIds: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/RemoveMembers?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMembers(_response);
        });
    }

    protected processRemoveMembers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新团队
     * @param body (optional) 
     * @return Success
     */
    update(body: AuditTeamEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新成员角色
     * @param teamId (optional) 
     * @param userId (optional) 
     * @param role (optional) 
     * @return Success
     */
    updateMemberRole(teamId: number | undefined, userId: number | undefined, role: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/UpdateMemberRole?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberRole(_response);
        });
    }

    protected processUpdateMemberRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新团队状态
     * @param status (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateStatus(status: number | undefined, body: EntityDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTeam/UpdateStatus?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditTemplateServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除审核模板详情
     * @param body (optional) 
     * @return Success
     */
    batchDeleteDetail(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/BatchDeleteDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDeleteDetail(_response);
        });
    }

    protected processBatchDeleteDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制
     * @param id (optional) 
     * @param newName (optional) 
     * @return Success
     */
    copy(id: number | undefined, newName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/Copy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdataAuditTemplateDetailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除审核模板详情
     * @param id (optional) 
     * @return Success
     */
    deleteDetail(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/DeleteDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDetail(_response);
        });
    }

    protected processDeleteDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 审核点树数据（带审核项数据）
     * @param auditTemplateId (optional) 
     * @return Success
     */
    getAllData(auditTemplateId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/GetAllData?";
        if (auditTemplateId !== undefined && auditTemplateId !== null)
            url_ += "auditTemplateId=" + encodeURIComponent("" + auditTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditTemplateListDto.fromJS(resultData200);
            return Promise.resolve<AuditTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateListDto>(null as any);
    }

    /**
     * 根据审核点id获取审核项
     * @param auditTemplateId (optional) 
     * @param auditPointId (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getitem(auditTemplateId: number | null | undefined, auditPointId: number | null | undefined, filterText: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditItemListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/Getitem?";
        if (auditTemplateId !== undefined && auditTemplateId !== null)
            url_ += "auditTemplateId=" + encodeURIComponent("" + auditTemplateId) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetitem(_response);
        });
    }

    protected processGetitem(response: AxiosResponse): Promise<AuditItemListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditItemListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditItemListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditItemListDto[]>(null as any);
    }

    /**
     * 获取分页数据
     * @param auditTemplateGroupId (optional) 审核点模板分组Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(auditTemplateGroupId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplate/GetPaged?";
        if (auditTemplateGroupId !== undefined && auditTemplateGroupId !== null)
            url_ += "auditTemplateGroupId=" + encodeURIComponent("" + auditTemplateGroupId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuditTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditTemplateListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditTemplateListDto>(null as any);
    }
}

export class AuditTemplateGroupServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplateGroup/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAuditTemplateGroupInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplateGroup/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplateGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取树Id
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplateGroup/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<AuditTemplateGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTemplateGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTemplateGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateGroupListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateGroupEditDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplateGroup/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<AuditTemplateGroupEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditTemplateGroupEditDto.fromJS(resultData200);
            return Promise.resolve<AuditTemplateGroupEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateGroupEditDto>(null as any);
    }

    /**
     * 获取审核项树数据
     * @param filterText (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTemplateGroupListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditTemplateGroup/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<AuditTemplateGroupListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTemplateGroupListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTemplateGroupListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTemplateGroupListDto[]>(null as any);
    }
}

export class AuthorizeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Authorize的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAuthorizeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取AuthorizeListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuthorizeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AuthorizeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthorizeListDto.fromJS(resultData200);
            return Promise.resolve<AuthorizeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthorizeListDto>(null as any);
    }

    /**
     * 获取客户端类型
     * @return Success
     */
    getClientType( cancelToken?: CancelToken | undefined): Promise<ValueTupleOfInt64String[]> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/GetClientType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientType(_response);
        });
    }

    protected processGetClientType(response: AxiosResponse): Promise<ValueTupleOfInt64String[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ValueTupleOfInt64String.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ValueTupleOfInt64String[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueTupleOfInt64String[]>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAuthorizeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetAuthorizeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAuthorizeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAuthorizeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuthorizeForEditOutput>(null as any);
    }

    /**
     * 获取对象限制客户端权限
     * @param objectID (optional) 对象ID
     * @param objectType (optional) 1角色，2用户，3部门
     * @return Success
     */
    getObjRestrictClientAuthorize(objectID: number | undefined, objectType: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetObjRestrictClientAuthorizeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/GetObjRestrictClientAuthorize?";
        if (objectID === null)
            throw new Error("The parameter 'objectID' cannot be null.");
        else if (objectID !== undefined)
            url_ += "objectID=" + encodeURIComponent("" + objectID) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetObjRestrictClientAuthorize(_response);
        });
    }

    protected processGetObjRestrictClientAuthorize(response: AxiosResponse): Promise<GetObjRestrictClientAuthorizeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetObjRestrictClientAuthorizeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetObjRestrictClientAuthorizeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetObjRestrictClientAuthorizeDto[]>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuthorizeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAuthorizeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuthorizeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuthorizeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuthorizeListDto>(null as any);
    }

    /**
     * 获取用户权限
     * @param objectID (optional) 对象ID
     * @param objectType (optional) 1角色，2用户，3部门
     * @param isApp (optional) 
     * @return Success
     */
    getUserAuthorize(objectID: number | undefined, objectType: number | undefined, isApp: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserAuthorizeDto> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/GetUserAuthorize?";
        if (objectID === null)
            throw new Error("The parameter 'objectID' cannot be null.");
        else if (objectID !== undefined)
            url_ += "objectID=" + encodeURIComponent("" + objectID) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (isApp === null)
            throw new Error("The parameter 'isApp' cannot be null.");
        else if (isApp !== undefined)
            url_ += "isApp=" + encodeURIComponent("" + isApp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAuthorize(_response);
        });
    }

    protected processGetUserAuthorize(response: AxiosResponse): Promise<GetUserAuthorizeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserAuthorizeDto.fromJS(resultData200);
            return Promise.resolve<GetUserAuthorizeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserAuthorizeDto>(null as any);
    }

    /**
     * 设置对象限制登录类型
     * @param objType (optional) 对象类型1角色，2用户，3部门
     * @param objId (optional) 对象ID
     * @param body (optional) 客户端类型
     * @return Success
     */
    setObjectRestrictClientType(objType: number | undefined, objId: number | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Authorize/SetObjectRestrictClientType?";
        if (objType === null)
            throw new Error("The parameter 'objType' cannot be null.");
        else if (objType !== undefined)
            url_ += "objType=" + encodeURIComponent("" + objType) + "&";
        if (objId === null)
            throw new Error("The parameter 'objId' cannot be null.");
        else if (objId !== undefined)
            url_ += "objId=" + encodeURIComponent("" + objId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetObjectRestrictClientType(_response);
        });
    }

    protected processSetObjectRestrictClientType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BannerImgServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除BannerAd的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改轮播图广告的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateBannerAdInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除轮播图广告信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取BannerAdListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<BannerAdListDto> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<BannerAdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BannerAdListDto.fromJS(resultData200);
            return Promise.resolve<BannerAdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BannerAdListDto>(null as any);
    }

    /**
     * 获取编辑 轮播图广告
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetBannerAdForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetBannerAdForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBannerAdForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetBannerAdForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBannerAdForEditOutput>(null as any);
    }

    /**
     * 获取前端门户使用的banner图
     * @return Success
     */
    getForReadBannerAds( cancelToken?: CancelToken | undefined): Promise<BannerAdListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/GetForReadBannerAds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForReadBannerAds(_response);
        });
    }

    protected processGetForReadBannerAds(response: AxiosResponse): Promise<BannerAdListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BannerAdListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BannerAdListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BannerAdListDto[]>(null as any);
    }

    /**
     * 获取轮播图广告的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfBannerAdListDto> {
        let url_ = this.baseUrl + "/api/services/app/BannerImg/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfBannerAdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfBannerAdListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfBannerAdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfBannerAdListDto>(null as any);
    }
}

export class BirthdayWishServiceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加或修改
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBirthdayWish(body: BirthdayWishEditInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BirthdayWishService/CreateOrUpdateBirthdayWish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateBirthdayWish(_response);
        });
    }

    protected processCreateOrUpdateBirthdayWish(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑实体
     * @param type (optional) 1:生日祝福 2:周年庆
     * @return Success
     */
    getForEdit(type: number | undefined, cancelToken?: CancelToken | undefined): Promise<BirthdayWishEditInput> {
        let url_ = this.baseUrl + "/api/services/app/BirthdayWishService/GetForEdit?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<BirthdayWishEditInput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BirthdayWishEditInput.fromJS(resultData200);
            return Promise.resolve<BirthdayWishEditInput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BirthdayWishEditInput>(null as any);
    }
}

export class BlogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Blog的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Blog/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改博客的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateBlogInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Blog/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除博客信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Blog/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取博客列表
     * @return Success
     */
    getBlogs( cancelToken?: CancelToken | undefined): Promise<BlogListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetBlogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBlogs(_response);
        });
    }

    protected processGetBlogs(response: AxiosResponse): Promise<BlogListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BlogListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BlogListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlogListDto[]>(null as any);
    }

    /**
     * 通过指定id获取BlogListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<BlogListDto> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<BlogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlogListDto.fromJS(resultData200);
            return Promise.resolve<BlogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlogListDto>(null as any);
    }

    /**
     * 根据短名称获取博客信息
     * @param shortName (optional) 
     * @return Success
     */
    getByShortName(shortName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<BlogListDto> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetByShortName?";
        if (shortName !== undefined && shortName !== null)
            url_ += "shortName=" + encodeURIComponent("" + shortName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByShortName(_response);
        });
    }

    protected processGetByShortName(response: AxiosResponse): Promise<BlogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlogListDto.fromJS(resultData200);
            return Promise.resolve<BlogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlogListDto>(null as any);
    }

    /**
     * 获取编辑 博客
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetBlogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetBlogForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBlogForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetBlogForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBlogForEditOutput>(null as any);
    }

    /**
     * 获取博客的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfBlogListDto> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfBlogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfBlogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfBlogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfBlogListDto>(null as any);
    }

    /**
     * 获取博客下的标签列表
     * @param id (optional) 
     * @return Success
     */
    getTagsOfBlog(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<TagListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetTagsOfBlog?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagsOfBlog(_response);
        });
    }

    protected processGetTagsOfBlog(response: AxiosResponse): Promise<TagListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TagListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagListDto[]>(null as any);
    }

    /**
     * 导出博客为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getUserList(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<UserListOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Blog/GetUserList?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserList(_response);
        });
    }

    protected processGetUserList(response: AxiosResponse): Promise<UserListOutput[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserListOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserListOutput[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListOutput[]>(null as any);
    }
}

export class BlogrollServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Blogroll的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Blogroll/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改友情链接的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateBlogrollInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Blogroll/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除友情链接信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Blogroll/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取BlogrollListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<BlogrollListDto> {
        let url_ = this.baseUrl + "/api/services/app/Blogroll/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<BlogrollListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlogrollListDto.fromJS(resultData200);
            return Promise.resolve<BlogrollListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlogrollListDto>(null as any);
    }

    /**
     * 获取编辑 友情链接
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetBlogrollForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Blogroll/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetBlogrollForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBlogrollForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetBlogrollForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBlogrollForEditOutput>(null as any);
    }

    /**
     * 获取友情链接的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfBlogrollListDto> {
        let url_ = this.baseUrl + "/api/services/app/Blogroll/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfBlogrollListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfBlogrollListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfBlogrollListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfBlogrollListDto>(null as any);
    }
}

export class BlogrollTypeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除BlogrollType的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BlogrollType/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改友情链接分类的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateBlogrollTypeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BlogrollType/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除友情链接分类信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/BlogrollType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取BlogrollTypeListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<BlogrollTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/BlogrollType/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<BlogrollTypeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlogrollTypeListDto.fromJS(resultData200);
            return Promise.resolve<BlogrollTypeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlogrollTypeListDto>(null as any);
    }

    /**
     * 获取编辑 友情链接分类
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetBlogrollTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BlogrollType/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetBlogrollTypeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBlogrollTypeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetBlogrollTypeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBlogrollTypeForEditOutput>(null as any);
    }

    /**
     * 获取友情链接分类的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfBlogrollTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/BlogrollType/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfBlogrollTypeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfBlogrollTypeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfBlogrollTypeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfBlogrollTypeListDto>(null as any);
    }
}

export class ChatServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取好友列表
     * @return Success
     */
    getUserChatFriendsWithSettings( cancelToken?: CancelToken | undefined): Promise<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserChatFriendsWithSettings(_response);
        });
    }

    protected processGetUserChatFriendsWithSettings(response: AxiosResponse): Promise<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return Promise.resolve<GetUserChatFriendsWithSettingsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserChatFriendsWithSettingsOutput>(null as any);
    }

    /**
     * 获取聊天记录
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | null | undefined, userId: number | undefined, minMessageId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined && minMessageId !== null)
            url_ += "minMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserChatMessages(_response);
        });
    }

    protected processGetUserChatMessages(response: AxiosResponse): Promise<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfChatMessageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfChatMessageDto>(null as any);
    }

    /**
     * 讲所有未读变成已读
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(_response);
        });
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CheckInRecordServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除CheckInRecord的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateCheckInRecordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 下载导入模板
     * @return Success
     */
    exportTemplate( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/ExportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 通过指定id获取CheckInRecordListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CheckInRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CheckInRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckInRecordListDto.fromJS(resultData200);
            return Promise.resolve<CheckInRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckInRecordListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCheckInRecordForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetCheckInRecordForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCheckInRecordForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetCheckInRecordForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCheckInRecordForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司
     * @param deparmentId (optional) 部门
     * @param isEmpState (optional) 是否离职
     * @param empType (optional) 员工类型
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, companyId: string | null | undefined, deparmentId: string | null | undefined, isEmpState: boolean | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfCheckInRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/GetPaged?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (isEmpState === null)
            throw new Error("The parameter 'isEmpState' cannot be null.");
        else if (isEmpState !== undefined)
            url_ += "isEmpState=" + encodeURIComponent("" + isEmpState) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfCheckInRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfCheckInRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfCheckInRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfCheckInRecordListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司
     * @param deparmentId (optional) 部门
     * @param isEmpState (optional) 是否离职
     * @param empType (optional) 员工类型
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, companyId: string | null | undefined, deparmentId: string | null | undefined, isEmpState: boolean | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/GetToExcelFile?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (isEmpState === null)
            throw new Error("The parameter 'isEmpState' cannot be null.");
        else if (isEmpState !== undefined)
            url_ += "isEmpState=" + encodeURIComponent("" + isEmpState) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导入原始打卡记录
     * @param fileName (optional) 
     * @return Success
     */
    importExecl(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckInRecord/ImportExecl?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExecl(_response);
        });
    }

    protected processImportExecl(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }
}

export class CommentServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Comment的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Comment/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改评论的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateCommentInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Comment/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除评论信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Comment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取CommentListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<CommentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Comment/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CommentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommentListDto.fromJS(resultData200);
            return Promise.resolve<CommentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommentListDto>(null as any);
    }

    /**
     * 获取编辑 评论
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCommentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Comment/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetCommentForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCommentForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetCommentForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCommentForEditOutput>(null as any);
    }

    /**
     * 获取评论的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfCommentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Comment/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfCommentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfCommentListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfCommentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfCommentListDto>(null as any);
    }

    /**
     * 导出评论为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Comment/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class CommonLookupServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: CommonLookupFindUsersInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindUsers(_response);
        });
    }

    protected processFindUsers(response: AxiosResponse): Promise<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNameValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsersSetUserNameToValue(body: CommonLookupFindUsersInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsersSetUserNameToValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindUsersSetUserNameToValue(_response);
        });
    }

    protected processFindUsersSetUserNameToValue(response: AxiosResponse): Promise<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNameValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName( cancelToken?: CancelToken | undefined): Promise<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultEditionName(_response);
        });
    }

    protected processGetDefaultEditionName(response: AxiosResponse): Promise<GetDefaultEditionNameOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return Promise.resolve<GetDefaultEditionNameOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDefaultEditionNameOutput>(null as any);
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditionsForCombobox(_response);
        });
    }

    protected processGetEditionsForCombobox(response: AxiosResponse): Promise<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfSubscribableEditionComboboxItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfSubscribableEditionComboboxItemDto>(null as any);
    }

    /**
     * 获取枚举，字符串类型combox数据
     * @param input (optional) 枚举类型,字符串,区分大小写
     * @return Success
     */
    getEnumForCombobox(input: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfComboboxItemDtoTOfString> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEnumForCombobox?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnumForCombobox(_response);
        });
    }

    protected processGetEnumForCombobox(response: AxiosResponse): Promise<ListResultDtoOfComboboxItemDtoTOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfComboboxItemDtoTOfString.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfComboboxItemDtoTOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfComboboxItemDtoTOfString>(null as any);
    }

    /**
     * @return Success
     */
    getValidateCodeTypesForCombobox( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfComboboxItemDtoTOfInt32> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetValidateCodeTypesForCombobox";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetValidateCodeTypesForCombobox(_response);
        });
    }

    protected processGetValidateCodeTypesForCombobox(response: AxiosResponse): Promise<ListResultDtoOfComboboxItemDtoTOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfComboboxItemDtoTOfInt32.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfComboboxItemDtoTOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfComboboxItemDtoTOfInt32>(null as any);
    }
}

export class CompanyServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Company的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改公司的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateCompanyInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除公司信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取CompanyListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CompanyListDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CompanyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyListDto.fromJS(resultData200);
            return Promise.resolve<CompanyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyListDto>(null as any);
    }

    /**
     * 获取编辑 公司
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCompanyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetCompanyForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompanyForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetCompanyForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompanyForEditOutput>(null as any);
    }

    /**
     * 获取公司的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfCompanyListDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfCompanyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfCompanyListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfCompanyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfCompanyListDto>(null as any);
    }

    /**
     * @param roleId (optional) 
     * @return Success
     */
    getPagedByRole(roleId: number | undefined, cancelToken?: CancelToken | undefined): Promise<CompanyListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetPagedByRole?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedByRole(_response);
        });
    }

    protected processGetPagedByRole(response: AxiosResponse): Promise<CompanyListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompanyListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyListDto[]>(null as any);
    }

    /**
     * 导出公司为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取公司树
     * @return Success
     */
    getTreeList( cancelToken?: CancelToken | undefined): Promise<CompanyTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetTreeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeList(_response);
        });
    }

    protected processGetTreeList(response: AxiosResponse): Promise<CompanyTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CompanyTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyTreeDto[]>(null as any);
    }
}

export class CompanyImagesServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除CompanyImages的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改公司图片---用户设置的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateCompanyImagesInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除公司图片---用户设置信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取CompanyImagesListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CompanyImagesListDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CompanyImagesListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyImagesListDto.fromJS(resultData200);
            return Promise.resolve<CompanyImagesListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyImagesListDto>(null as any);
    }

    /**
     * 获取公司图片
     * @return Success
     */
    getCompanyImagesListByTenantId( cancelToken?: CancelToken | undefined): Promise<CompanyImagesEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/GetCompanyImagesListByTenantId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyImagesListByTenantId(_response);
        });
    }

    protected processGetCompanyImagesListByTenantId(response: AxiosResponse): Promise<CompanyImagesEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyImagesEditDto.fromJS(resultData200);
            return Promise.resolve<CompanyImagesEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyImagesEditDto>(null as any);
    }

    /**
     * 获取编辑 公司图片---用户设置
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCompanyImagesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetCompanyImagesForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompanyImagesForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetCompanyImagesForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompanyImagesForEditOutput>(null as any);
    }

    /**
     * 获取公司图片---用户设置的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfCompanyImagesListDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfCompanyImagesListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfCompanyImagesListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfCompanyImagesListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfCompanyImagesListDto>(null as any);
    }

    /**
     * 更新公司图片
     * @param body (optional) 
     * @return Success
     */
    updateCompanyImage(body: CompanyImagesEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyImages/UpdateCompanyImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyImage(_response);
        });
    }

    protected processUpdateCompanyImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContactsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 根据其他ID删除联系
     * @param otherId (optional) 
     * @return Success
     */
    deleteMyContactsByOtherId(otherId: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/DeleteMyContactsByOtherId?";
        if (otherId !== undefined && otherId !== null)
            otherId && otherId.forEach(item => { url_ += "otherId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMyContactsByOtherId(_response);
        });
    }

    protected processDeleteMyContactsByOtherId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取自己最近联系人
     * @return Success
     */
    getMyContacts( cancelToken?: CancelToken | undefined): Promise<MyContactsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetMyContacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyContacts(_response);
        });
    }

    protected processGetMyContacts(response: AxiosResponse): Promise<MyContactsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MyContactsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MyContactsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyContactsDto[]>(null as any);
    }
}

export class ContractsManageServiceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取合同管理清单
     * @param companyId (optional) 公司---------------------新增
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getContractsManageList(companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetContractsManageListDto> {
        let url_ = this.baseUrl + "/api/services/app/ContractsManageService/GetContractsManageList?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractsManageList(_response);
        });
    }

    protected processGetContractsManageList(response: AxiosResponse): Promise<PagedResultDtoOfGetContractsManageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetContractsManageListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetContractsManageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetContractsManageListDto>(null as any);
    }

    /**
     * 更新合同为已完成
     * @param id (optional) 
     * @return Success
     */
    updateContractsToComplete(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ContractsManageService/UpdateContractsToComplete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContractsToComplete(_response);
        });
    }

    protected processUpdateContractsToComplete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CourseServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Course/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateCourseDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Course/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Course/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CourseListDto> {
        let url_ = this.baseUrl + "/api/services/app/Course/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CourseListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseListDto.fromJS(resultData200);
            return Promise.resolve<CourseListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseListDto>(null as any);
    }

    /**
     * @return Success
     */
    getCourseStatistics( cancelToken?: CancelToken | undefined): Promise<CourseStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Course/GetCourseStatistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseStatistics(_response);
        });
    }

    protected processGetCourseStatistics(response: AxiosResponse): Promise<CourseStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseStatisticsDto.fromJS(resultData200);
            return Promise.resolve<CourseStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseStatisticsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<CreateOrUpdateCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/Course/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<CreateOrUpdateCourseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateCourseDto.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateCourseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateCourseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaged(body: CourseQueryInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfCourseListDto> {
        let url_ = this.baseUrl + "/api/services/app/Course/GetPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfCourseListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfCourseListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfCourseListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfCourseListDto>(null as any);
    }

    /**
     * @param catetoryId (optional) 分类Id
     * @param courseVideoType (optional) 课程视频类型-直播、录播
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedCourseStatistics(catetoryId: number | null | undefined, courseVideoType: CourseVideoTypeEnum | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfQueryCourseStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Course/GetPagedCourseStatistics?";
        if (catetoryId !== undefined && catetoryId !== null)
            url_ += "catetoryId=" + encodeURIComponent("" + catetoryId) + "&";
        if (courseVideoType === null)
            throw new Error("The parameter 'courseVideoType' cannot be null.");
        else if (courseVideoType !== undefined)
            url_ += "courseVideoType=" + encodeURIComponent("" + courseVideoType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedCourseStatistics(_response);
        });
    }

    protected processGetPagedCourseStatistics(response: AxiosResponse): Promise<PagedResultDtoOfQueryCourseStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfQueryCourseStatisticsDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfQueryCourseStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfQueryCourseStatisticsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSectionAndClassHourStatistics(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CourseSectionAndClassHourStatisticalDto> {
        let url_ = this.baseUrl + "/api/services/app/Course/GetSectionAndClassHourStatistics?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSectionAndClassHourStatistics(_response);
        });
    }

    protected processGetSectionAndClassHourStatistics(response: AxiosResponse): Promise<CourseSectionAndClassHourStatisticalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseSectionAndClassHourStatisticalDto.fromJS(resultData200);
            return Promise.resolve<CourseSectionAndClassHourStatisticalDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSectionAndClassHourStatisticalDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publishCourse(body: EntityDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Course/PublishCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishCourse(_response);
        });
    }

    protected processPublishCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CourseCategoryServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 将课程添加到分类
     * @param body (optional) 
     * @return Success
     */
    addCourse(body: AddCourseToCategoryInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/AddCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCourse(_response);
        });
    }

    protected processAddCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除CourseCategory的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改课程分类的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateCourseCategoryInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除课程分类信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 查询可以添加到分类中的课程列表信息
     * @param body (optional) 
     * @return Success
     */
    findCourses(body: FindCoursesInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/FindCourses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindCourses(_response);
        });
    }

    protected processFindCourses(response: AxiosResponse): Promise<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNameValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * 获取所有的课程分类列表
     * @return Success
     */
    getAllCourseCategoriesList( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfCourseCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/GetAllCourseCategoriesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCourseCategoriesList(_response);
        });
    }

    protected processGetAllCourseCategoriesList(response: AxiosResponse): Promise<ListResultDtoOfCourseCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfCourseCategoryListDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfCourseCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfCourseCategoryListDto>(null as any);
    }

    /**
     * 通过指定id获取CourseCategoryListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CourseCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CourseCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseCategoryListDto.fromJS(resultData200);
            return Promise.resolve<CourseCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseCategoryListDto>(null as any);
    }

    /**
     * 获取编辑 课程分类
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCourseCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetCourseCategoryForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCourseCategoryForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetCourseCategoryForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCourseCategoryForEditOutput>(null as any);
    }

    /**
     * 获取课程分类的分页列表信息
     * @param id (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedCategory(id: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfCourseCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/GetPagedCategory?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedCategory(_response);
        });
    }

    protected processGetPagedCategory(response: AxiosResponse): Promise<PagedResultDtoOfCourseCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfCourseCategoryListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfCourseCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfCourseCategoryListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedCourseListInCategory(id: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTreeMemberListDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/GetPagedCourseListInCategory?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedCourseListInCategory(_response);
        });
    }

    protected processGetPagedCourseListInCategory(response: AxiosResponse): Promise<PagedResultDtoOfTreeMemberListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTreeMemberListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTreeMemberListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTreeMemberListDto>(null as any);
    }

    /**
     * 移动分类
     * @param body (optional) 
     * @return Success
     */
    move(body: MoveCourseCategoryInput | undefined, cancelToken?: CancelToken | undefined): Promise<CourseCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/Move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<CourseCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseCategoryListDto.fromJS(resultData200);
            return Promise.resolve<CourseCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseCategoryListDto>(null as any);
    }

    /**
     * 从分类中移除课程
     * @param courseIds (optional) 
     * @param courseCategoryId (optional) 
     * @return Success
     */
    removeCourse(courseIds: number[] | null | undefined, courseCategoryId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseCategory/RemoveCourse?";
        if (courseIds !== undefined && courseIds !== null)
            courseIds && courseIds.forEach(item => { url_ += "courseIds=" + encodeURIComponent("" + item) + "&"; });
        if (courseCategoryId === null)
            throw new Error("The parameter 'courseCategoryId' cannot be null.");
        else if (courseCategoryId !== undefined)
            url_ += "courseCategoryId=" + encodeURIComponent("" + courseCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCourse(_response);
        });
    }

    protected processRemoveCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CourseClassHourServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 创建
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CourseClassHourDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/CourseClassHour/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseClassHour/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据课时id获取课时信息
     * @param courseClassHourId (optional) 课时id
     * @return Success
     */
    getById(courseClassHourId: number | undefined, cancelToken?: CancelToken | undefined): Promise<CourseClassHourDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseClassHour/GetById?";
        if (courseClassHourId === null)
            throw new Error("The parameter 'courseClassHourId' cannot be null.");
        else if (courseClassHourId !== undefined)
            url_ += "courseClassHourId=" + encodeURIComponent("" + courseClassHourId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CourseClassHourDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseClassHourDto.fromJS(resultData200);
            return Promise.resolve<CourseClassHourDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseClassHourDto>(null as any);
    }

    /**
     * 根据章节获取课时集合
     * @param courseSectionId (optional) 课时章节id
     * @return Success
     */
    getBySectionId(courseSectionId: number | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfCourseClassHourDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseClassHour/GetBySectionId?";
        if (courseSectionId === null)
            throw new Error("The parameter 'courseSectionId' cannot be null.");
        else if (courseSectionId !== undefined)
            url_ += "courseSectionId=" + encodeURIComponent("" + courseSectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySectionId(_response);
        });
    }

    protected processGetBySectionId(response: AxiosResponse): Promise<ListResultDtoOfCourseClassHourDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfCourseClassHourDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfCourseClassHourDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfCourseClassHourDto>(null as any);
    }

    /**
     * 根据章节获取课时集合
     * @param body (optional) 课时章节id集合
     * @return Success
     */
    getBySectionIdList(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfCourseClassHourDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseClassHour/GetBySectionIdList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySectionIdList(_response);
        });
    }

    protected processGetBySectionIdList(response: AxiosResponse): Promise<ListResultDtoOfCourseClassHourDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfCourseClassHourDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfCourseClassHourDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfCourseClassHourDto>(null as any);
    }
}

export class CourseSectionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 创建
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CourseSectionDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/CourseSection/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 删除章节
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CourseSection/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据章节id获取章节
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<CourseSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseSection/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CourseSectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseSectionDto.fromJS(resultData200);
            return Promise.resolve<CourseSectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseSectionDto>(null as any);
    }

    /**
     * 根据课程id获取章节
     * @param courseId (optional) 课程id
     * @return Success
     */
    getSectionsByCourseId(courseId: number | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfCourseSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/CourseSection/GetSectionsByCourseId?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSectionsByCourseId(_response);
        });
    }

    protected processGetSectionsByCourseId(response: AxiosResponse): Promise<ListResultDtoOfCourseSectionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfCourseSectionDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfCourseSectionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfCourseSectionDto>(null as any);
    }
}

export class DashboardServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 问题区域TOP10
     * @param body (optional) 
     * @return Success
     */
    auditPointIssueTOPTen(body: DashboardInput | undefined, cancelToken?: CancelToken | undefined): Promise<AuditPointIssueTOPTenDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/AuditPointIssueTOPTen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuditPointIssueTOPTen(_response);
        });
    }

    protected processAuditPointIssueTOPTen(response: AxiosResponse): Promise<AuditPointIssueTOPTenDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditPointIssueTOPTenDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditPointIssueTOPTenDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditPointIssueTOPTenDto[]>(null as any);
    }

    /**
     * 按照问题分类汇总问题
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param orgId (optional) 组织架构ID
     * @return Success
     */
    getIssueForIssueType(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, orgId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueForIssueTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetIssueForIssueType?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueForIssueType(_response);
        });
    }

    protected processGetIssueForIssueType(response: AxiosResponse): Promise<GetIssueForIssueTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueForIssueTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueForIssueTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueForIssueTypeDto[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: LayoutOrgListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题数量和计划数量相关
     * @param body (optional) 
     * @return Success
     */
    issueAndAuditTaskRelevant(body: DashboardInput | undefined, cancelToken?: CancelToken | undefined): Promise<IssueAndAuditTaskRelevantDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/IssueAndAuditTaskRelevant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueAndAuditTaskRelevant(_response);
        });
    }

    protected processIssueAndAuditTaskRelevant(response: AxiosResponse): Promise<IssueAndAuditTaskRelevantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueAndAuditTaskRelevantDto.fromJS(resultData200);
            return Promise.resolve<IssueAndAuditTaskRelevantDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueAndAuditTaskRelevantDto>(null as any);
    }
}

export class DataConditionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除DataCondition的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改权限条件表的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateDataConditionInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除权限条件表信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取DataConditionListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<DataConditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DataConditionListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataConditionListDto.fromJS(resultData200);
            return Promise.resolve<DataConditionListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataConditionListDto>(null as any);
    }

    /**
     * 获取获取条件相关字典静态数据
     * @param type (optional) 1.比较符 2、字段值类型
     * @return Success
     */
    getConditionDataDic(type: number | undefined, cancelToken?: CancelToken | undefined): Promise<DataConditionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/GetConditionDataDic?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConditionDataDic(_response);
        });
    }

    protected processGetConditionDataDic(response: AxiosResponse): Promise<DataConditionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataConditionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataConditionDto[]>(null as any);
    }

    /**
     * 获取编辑 权限条件表
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDataConditionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetDataConditionForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataConditionForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetDataConditionForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataConditionForEditOutput>(null as any);
    }

    /**
     * 获取权限条件表的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfDataConditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataCondition/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfDataConditionListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfDataConditionListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfDataConditionListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfDataConditionListDto>(null as any);
    }
}

export class DataItemServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除DataItem的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改字典的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateDataItemInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除字典信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取DataItemListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<DataItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DataItemListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataItemListDto.fromJS(resultData200);
            return Promise.resolve<DataItemListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemListDto>(null as any);
    }

    /**
     * 获取字典树
     * @return Success
     */
    getDataItemTree( cancelToken?: CancelToken | undefined): Promise<DataItemTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/GetDataItemTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataItemTree(_response);
        });
    }

    protected processGetDataItemTree(response: AxiosResponse): Promise<DataItemTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataItemTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataItemTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemTreeDto[]>(null as any);
    }

    /**
     * 获取编辑 字典
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDataItemForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetDataItemForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataItemForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetDataItemForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataItemForEditOutput>(null as any);
    }

    /**
     * 获取字典的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfDataItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfDataItemListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfDataItemListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfDataItemListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfDataItemListDto>(null as any);
    }

    /**
     * 导出字典为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 包装成字典的树结构
     * @return Success
     */
    getTreeList( cancelToken?: CancelToken | undefined): Promise<DataItemTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DataItem/GetTreeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeList(_response);
        });
    }

    protected processGetTreeList(response: AxiosResponse): Promise<DataItemTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataItemTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataItemTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemTreeDto[]>(null as any);
    }
}

export class DataItemDetailServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除DataItemDetail的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改字典明细的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateDataItemDetailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除字典明细信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据编号获取区县
     * @param administrationCode (optional) 
     * @return Success
     */
    getAdministrationByCode(administrationCode: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AdministrativeRegion[]> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetAdministrationByCode?";
        if (administrationCode !== undefined && administrationCode !== null)
            url_ += "administrationCode=" + encodeURIComponent("" + administrationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdministrationByCode(_response);
        });
    }

    protected processGetAdministrationByCode(response: AxiosResponse): Promise<AdministrativeRegion[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AdministrativeRegion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdministrativeRegion[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdministrativeRegion[]>(null as any);
    }

    /**
     * 通过指定id获取DataItemDetailListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<DataItemDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DataItemDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataItemDetailListDto.fromJS(resultData200);
            return Promise.resolve<DataItemDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemDetailListDto>(null as any);
    }

    /**
     * 获取编辑 字典明细
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDataItemDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetDataItemDetailForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataItemDetailForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetDataItemDetailForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataItemDetailForEditOutput>(null as any);
    }

    /**
     * 根据字典ID去获取字典明细
     * @param dataItemId (optional) 字典ID
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getListByByDataItmeCode(dataItemId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<DataItemDetailListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetListByByDataItmeCode?";
        if (dataItemId !== undefined && dataItemId !== null)
            url_ += "dataItemId=" + encodeURIComponent("" + dataItemId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByByDataItmeCode(_response);
        });
    }

    protected processGetListByByDataItmeCode(response: AxiosResponse): Promise<DataItemDetailListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataItemDetailListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataItemDetailListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemDetailListDto[]>(null as any);
    }

    /**
     * 根据字典代码获取字典明细列表
     * @param dataItemCode (optional) 
     * @return Success
     */
    getListByDataItmeCode(dataItemCode: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDataItemDetailListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetListByDataItmeCode?";
        if (dataItemCode !== undefined && dataItemCode !== null)
            url_ += "dataItemCode=" + encodeURIComponent("" + dataItemCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByDataItmeCode(_response);
        });
    }

    protected processGetListByDataItmeCode(response: AxiosResponse): Promise<GetDataItemDetailListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetDataItemDetailListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetDataItemDetailListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataItemDetailListDto[]>(null as any);
    }

    /**
     * 获取字典明细的分页列表信息
     * @param dataItemId (optional) 字典ID
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(dataItemId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfDataItemDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetPaged?";
        if (dataItemId !== undefined && dataItemId !== null)
            url_ += "dataItemId=" + encodeURIComponent("" + dataItemId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfDataItemDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfDataItemDetailListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfDataItemDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfDataItemDetailListDto>(null as any);
    }

    /**
     * 导出字典明细为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DataItemDetail/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class DataRelationServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除DataRelation的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改接口权限的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateDataRelationInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除接口权限信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取DataRelationListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<DataRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DataRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataRelationListDto.fromJS(resultData200);
            return Promise.resolve<DataRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataRelationListDto>(null as any);
    }

    /**
     * 获取编辑 接口权限
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDataRelationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetDataRelationForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataRelationForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetDataRelationForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataRelationForEditOutput>(null as any);
    }

    /**
     * 获取接口权限清单接口
     * @param interfaceId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getInterfaceAuthorizeDetailPage(interfaceId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfInterfaceAuthorizeDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/GetInterfaceAuthorizeDetailPage?";
        if (interfaceId !== undefined && interfaceId !== null)
            url_ += "interfaceId=" + encodeURIComponent("" + interfaceId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInterfaceAuthorizeDetailPage(_response);
        });
    }

    protected processGetInterfaceAuthorizeDetailPage(response: AxiosResponse): Promise<PagedResultDtoOfInterfaceAuthorizeDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfInterfaceAuthorizeDetailListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfInterfaceAuthorizeDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfInterfaceAuthorizeDetailListDto>(null as any);
    }

    /**
     * 获取接口权限的分页列表信息
     * @param interfaceId (optional) 接口Id
     * @param objectType (optional) 1、角色 2、用户
     * @param objectId (optional) 对象Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(interfaceId: number | null | undefined, objectType: number | null | undefined, objectId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfDataRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataRelation/GetPaged?";
        if (interfaceId !== undefined && interfaceId !== null)
            url_ += "interfaceId=" + encodeURIComponent("" + interfaceId) + "&";
        if (objectType !== undefined && objectType !== null)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (objectId !== undefined && objectId !== null)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfDataRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfDataRelationListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfDataRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfDataRelationListDto>(null as any);
    }
}

export class DepartmentServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Department的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Department/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改部门的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateDepartmentInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Department/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除部门信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Department/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取DepartmentListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<DepartmentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DepartmentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DepartmentListDto.fromJS(resultData200);
            return Promise.resolve<DepartmentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DepartmentListDto>(null as any);
    }

    /**
     * 根据公司获取部门信息
     * @param companyId (optional) 
     * @return Success
     */
    getDepListByCompanyId(companyId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AbpOrganizationunitsExtendListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepListByCompanyId?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDepListByCompanyId(_response);
        });
    }

    protected processGetDepListByCompanyId(response: AxiosResponse): Promise<AbpOrganizationunitsExtendListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AbpOrganizationunitsExtendListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbpOrganizationunitsExtendListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbpOrganizationunitsExtendListDto[]>(null as any);
    }

    /**
     * 获取部门树
     * @param companyId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getDepTreeData(companyId: string | null | undefined, type: number | undefined, cancelToken?: CancelToken | undefined): Promise<DepartmentTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepTreeData?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDepTreeData(_response);
        });
    }

    protected processGetDepTreeData(response: AxiosResponse): Promise<DepartmentTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DepartmentTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DepartmentTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DepartmentTreeDto[]>(null as any);
    }

    /**
     * 获取编辑 部门
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDepartmentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetDepartmentForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDepartmentForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetDepartmentForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDepartmentForEditOutput>(null as any);
    }

    /**
     * 根据公司获取一级部门
     * @param companyId (optional) 
     * @return Success
     */
    getOneDepData(companyId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<DepartmentTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetOneDepData?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOneDepData(_response);
        });
    }

    protected processGetOneDepData(response: AxiosResponse): Promise<DepartmentTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DepartmentTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DepartmentTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DepartmentTreeDto[]>(null as any);
    }

    /**
     * 获取部门的分页列表信息
     * @param companyId (optional) 公司Id
     * @param isVirtual (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(companyId: number | null | undefined, isVirtual: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAbpOrganizationunitsExtendListDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetPaged?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (isVirtual === null)
            throw new Error("The parameter 'isVirtual' cannot be null.");
        else if (isVirtual !== undefined)
            url_ += "isVirtual=" + encodeURIComponent("" + isVirtual) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfAbpOrganizationunitsExtendListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAbpOrganizationunitsExtendListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAbpOrganizationunitsExtendListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAbpOrganizationunitsExtendListDto>(null as any);
    }

    /**
     * 导出部门为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class DocumentServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param projectId (optional) 项目ID
     * @param version (optional) 
     * @param name 文档名称
     * @return Success
     */
    getDocDetails(projectId: string | undefined, version: string | null | undefined, name: string, cancelToken?: CancelToken | undefined): Promise<DocumentWithDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetDocDetails?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocDetails(_response);
        });
    }

    protected processGetDocDetails(response: AxiosResponse): Promise<DocumentWithDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentWithDetailsDto.fromJS(resultData200);
            return Promise.resolve<DocumentWithDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentWithDetailsDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param version (optional) 
     * @return Success
     */
    getNavigationDocument(projectId: string | undefined, version: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<DocumentWithDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetNavigationDocument?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNavigationDocument(_response);
        });
    }

    protected processGetNavigationDocument(response: AxiosResponse): Promise<DocumentWithDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentWithDetailsDto.fromJS(resultData200);
            return Promise.resolve<DocumentWithDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentWithDetailsDto>(null as any);
    }
}

export class DownloadLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 通过指定id获取DownloadLogListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<DownloadLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/DownloadLog/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DownloadLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadLogListDto.fromJS(resultData200);
            return Promise.resolve<DownloadLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadLogListDto>(null as any);
    }

    /**
     * 获取DownloadLog的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfDownloadLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/DownloadLog/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfDownloadLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfDownloadLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfDownloadLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfDownloadLogListDto>(null as any);
    }
}

export class DynamicPageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 根据名称获取对应的筛选条件配置
     * @param name (optional) 筛选条件名称
     * @return Success
     */
    getColumns(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfColumnItemDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPage/GetColumns?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetColumns(_response);
        });
    }

    protected processGetColumns(response: AxiosResponse): Promise<ListResultDtoOfColumnItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfColumnItemDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfColumnItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfColumnItemDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getDynamicPageInfo(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<DynamicPageDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPage/GetDynamicPageInfo?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDynamicPageInfo(_response);
        });
    }

    protected processGetDynamicPageInfo(response: AxiosResponse): Promise<DynamicPageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DynamicPageDto.fromJS(resultData200);
            return Promise.resolve<DynamicPageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicPageDto>(null as any);
    }

    /**
     * 根据名称获取对应的筛选条件配置
     * @param name (optional) 筛选条件名称
     * @return Success
     */
    getPageFilters(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfPageFilterItemDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPage/GetPageFilters?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageFilters(_response);
        });
    }

    protected processGetPageFilters(response: AxiosResponse): Promise<ListResultDtoOfPageFilterItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfPageFilterItemDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfPageFilterItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfPageFilterItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    test(body: QueryInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPage/Test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EditionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEdition(body: CreateOrUpdateEditionDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateEdition(_response);
        });
    }

    protected processCreateOrUpdateEdition(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEdition(_response);
        });
    }

    protected processDeleteEdition(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | null | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined && selectedEditionId !== null)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditionComboboxItems(_response);
        });
    }

    protected processGetEditionComboboxItems(response: AxiosResponse): Promise<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscribableEditionComboboxItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscribableEditionComboboxItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditionForEdit(_response);
        });
    }

    protected processGetEditionForEdit(response: AxiosResponse): Promise<GetEditionEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return Promise.resolve<GetEditionEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEditionEditOutput>(null as any);
    }

    /**
     * @return Success
     */
    getEditions( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditions(_response);
        });
    }

    protected processGetEditions(response: AxiosResponse): Promise<ListResultDtoOfEditionListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfEditionListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfEditionListDto>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantCount(_response);
        });
    }

    protected processGetTenantCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveTenantsToAnotherEdition(_response);
        });
    }

    protected processMoveTenantsToAnotherEdition(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EducationBackgroundServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除EducationBackground的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改教育背景的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateEducationBackgroundInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除教育背景信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取EducationBackgroundListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<EducationBackgroundListDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<EducationBackgroundListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EducationBackgroundListDto.fromJS(resultData200);
            return Promise.resolve<EducationBackgroundListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EducationBackgroundListDto>(null as any);
    }

    /**
     * 获取编辑 教育背景
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetEducationBackgroundForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetEducationBackgroundForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEducationBackgroundForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetEducationBackgroundForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEducationBackgroundForEditOutput>(null as any);
    }

    /**
     * 根据用户Id获取教育背景列表
     * @param userId (optional) 
     * @return Success
     */
    getListByUserId(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<EducationBackgroundListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/GetListByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByUserId(_response);
        });
    }

    protected processGetListByUserId(response: AxiosResponse): Promise<EducationBackgroundListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EducationBackgroundListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EducationBackgroundListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EducationBackgroundListDto[]>(null as any);
    }

    /**
     * 获取教育背景的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEducationBackgroundListDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfEducationBackgroundListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEducationBackgroundListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEducationBackgroundListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEducationBackgroundListDto>(null as any);
    }

    /**
     * 导出教育背景为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationBackground/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class EHSServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 创建修改
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: EHSUserEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EHS/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateUser(_response);
        });
    }

    protected processCreateOrUpdateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增
     * @param body (optional) 
     * @return Success
     */
    createUser(body: EHSUserEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EHS/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建问题
     * @param body (optional) 
     * @return Success
     */
    eHSCreateIssue(body: EHSCreateIssueDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EHS/EHSCreateIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEHSCreateIssue(_response);
        });
    }

    protected processEHSCreateIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置EHS私钥
     * @param body (optional) 
     * @return Success
     */
    eHSPrivatekey(body: EHSPrivatekeyDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EHS/EHSPrivatekey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEHSPrivatekey(_response);
        });
    }

    protected processEHSPrivatekey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 生成EHS私钥
     * @return Success
     */
    generatePrivatekey( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/EHS/GeneratePrivatekey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeneratePrivatekey(_response);
        });
    }

    protected processGeneratePrivatekey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取EHS私钥
     * @return Success
     */
    getEHSPrivatekey( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/EHS/GetEHSPrivatekey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEHSPrivatekey(_response);
        });
    }

    protected processGetEHSPrivatekey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取EHS私钥用于msf
     * @param tenantId (optional) 
     * @return Success
     */
    getEHSPrivatekeyForMSF(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/EHS/GetEHSPrivatekeyForMSF?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEHSPrivatekeyForMSF(_response);
        });
    }

    protected processGetEHSPrivatekeyForMSF(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EmpattdailyServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 分析
     * @param body (optional) 
     * @return Success
     */
    analysis(body: AnalysisDtos | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/Analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalysis(_response);
        });
    }

    protected processAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<EmpattdailyEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<EmpattdailyEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmpattdailyEditDto.fromJS(resultData200);
            return Promise.resolve<EmpattdailyEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmpattdailyEditDto>(null as any);
    }

    /**
     * 获取当前用户的管理的考勤组
     * @return Success
     */
    getGroupListByManage( cancelToken?: CancelToken | undefined): Promise<AttGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetGroupListByManage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupListByManage(_response);
        });
    }

    protected processGetGroupListByManage(response: AxiosResponse): Promise<AttGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AttGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AttGroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttGroupDto[]>(null as any);
    }

    /**
     * 获取我的当月考勤异常
     * @param abnormalType (optional) 
     * @return Success
     */
    getMyAttErrorByNowMon(abnormalType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<EmpattdailyErrorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetMyAttErrorByNowMon?";
        if (abnormalType !== undefined && abnormalType !== null)
            url_ += "abnormalType=" + encodeURIComponent("" + abnormalType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAttErrorByNowMon(_response);
        });
    }

    protected processGetMyAttErrorByNowMon(response: AxiosResponse): Promise<EmpattdailyErrorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpattdailyErrorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmpattdailyErrorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmpattdailyErrorDto[]>(null as any);
    }

    /**
     * 获取我的下属当月考勤异常
     * @param abnormalType (optional) 
     * @return Success
     */
    getMySubordinateAttErrorByNowMon(abnormalType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<EmpattdailyErrorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetMySubordinateAttErrorByNowMon?";
        if (abnormalType !== undefined && abnormalType !== null)
            url_ += "abnormalType=" + encodeURIComponent("" + abnormalType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMySubordinateAttErrorByNowMon(_response);
        });
    }

    protected processGetMySubordinateAttErrorByNowMon(response: AxiosResponse): Promise<EmpattdailyErrorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpattdailyErrorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmpattdailyErrorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmpattdailyErrorDto[]>(null as any);
    }

    /**
     * 获取我的下属当月考勤异常
     * @param abnormalType (optional) 
     * @return Success
     */
    getMySubordinateAttErrorByNowMon1(abnormalType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<EmpattdailyErrorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetMySubordinateAttErrorByNowMon1?";
        if (abnormalType !== undefined && abnormalType !== null)
            url_ += "abnormalType=" + encodeURIComponent("" + abnormalType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMySubordinateAttErrorByNowMon1(_response);
        });
    }

    protected processGetMySubordinateAttErrorByNowMon1(response: AxiosResponse): Promise<EmpattdailyErrorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmpattdailyErrorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmpattdailyErrorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmpattdailyErrorDto[]>(null as any);
    }

    /**
     * 获取考勤日汇总分页清单
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param abnormalTypes (optional) 异常类型(1：迟到 2：早退 3：旷工)---字典代码
     * @param state (optional) (1:待审核 2：已审核 3：员工已确认 4:已结账)----字典代码
     * @param isAbnormalType (optional) 只查询异常
     * @param empType (optional) 员工状态
     * @param isOverTime (optional) 只查询有效加班人员
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPgeds(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, abnormalTypes: string | null | undefined, state: string | null | undefined, isAbnormalType: boolean | null | undefined, empType: string | null | undefined, isOverTime: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmpattdailyListDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetPgeds?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (abnormalTypes !== undefined && abnormalTypes !== null)
            url_ += "abnormalTypes=" + encodeURIComponent("" + abnormalTypes) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (isAbnormalType !== undefined && isAbnormalType !== null)
            url_ += "isAbnormalType=" + encodeURIComponent("" + isAbnormalType) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (isOverTime === null)
            throw new Error("The parameter 'isOverTime' cannot be null.");
        else if (isOverTime !== undefined)
            url_ += "isOverTime=" + encodeURIComponent("" + isOverTime) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPgeds(_response);
        });
    }

    protected processGetPgeds(response: AxiosResponse): Promise<PagedResultDtoOfEmpattdailyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmpattdailyListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmpattdailyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmpattdailyListDto>(null as any);
    }

    /**
     * 表格导出
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param abnormalTypes (optional) 异常类型(1：迟到 2：早退 3：旷工)---字典代码
     * @param state (optional) (1:待审核 2：已审核 3：员工已确认 4:已结账)----字典代码
     * @param isAbnormalType (optional) 只查询异常
     * @param empType (optional) 员工状态
     * @param isOverTime (optional) 只查询有效加班人员
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, abnormalTypes: string | null | undefined, state: string | null | undefined, isAbnormalType: boolean | null | undefined, empType: string | null | undefined, isOverTime: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/GetToExcelFile?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (abnormalTypes !== undefined && abnormalTypes !== null)
            url_ += "abnormalTypes=" + encodeURIComponent("" + abnormalTypes) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (isAbnormalType !== undefined && isAbnormalType !== null)
            url_ += "isAbnormalType=" + encodeURIComponent("" + isAbnormalType) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (isOverTime === null)
            throw new Error("The parameter 'isOverTime' cannot be null.");
        else if (isOverTime !== undefined)
            url_ += "isOverTime=" + encodeURIComponent("" + isOverTime) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 编辑日汇总
     * @param body (optional) 
     * @return Success
     */
    update(body: EmpattdailyEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更改状态
     * @param body (optional) 
     * @return Success
     */
    updateState(body: UpdateStateDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattdaily/UpdateState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateState(_response);
        });
    }

    protected processUpdateState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmpattdailyExcelExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToExcelFile(body: EmpattdailyListDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmpattdailyExcelExporter/ExportToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToExcelFile(_response);
        });
    }

    protected processExportToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class EmpattmonthlyServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 分析
     * @param body (optional) 
     * @return Success
     */
    analysis(body: EmpattmonthlyAnalysisDtos | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/Analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalysis(_response);
        });
    }

    protected processAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 员工确认月汇总考勤
     * @param id (optional) 
     * @return Success
     */
    empConfirmMonthAtt(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/EmpConfirmMonthAtt?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmpConfirmMonthAtt(_response);
        });
    }

    protected processEmpConfirmMonthAtt(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取周汇总
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param empType (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEmpAttWeekList(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmpAttWeekListDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetEmpAttWeekList?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpAttWeekList(_response);
        });
    }

    protected processGetEmpAttWeekList(response: AxiosResponse): Promise<PagedResultDtoOfEmpAttWeekListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmpAttWeekListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmpAttWeekListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmpAttWeekListDto>(null as any);
    }

    /**
     * 导出考勤周汇总
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param empType (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEmpAttWeekListToExcel(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetEmpAttWeekListToExcel?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpAttWeekListToExcel(_response);
        });
    }

    protected processGetEmpAttWeekListToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取月汇总编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<EmpAttMonthlyEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<EmpAttMonthlyEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmpAttMonthlyEditDto.fromJS(resultData200);
            return Promise.resolve<EmpAttMonthlyEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmpAttMonthlyEditDto>(null as any);
    }

    /**
     * 获取月度考勤汇总
     * @param isNowMonth (optional) 
     * @return Success
     */
    getMonthAttAllPage(isNowMonth: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<MonthAttAll[]> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetMonthAttAllPage?";
        if (isNowMonth === null)
            throw new Error("The parameter 'isNowMonth' cannot be null.");
        else if (isNowMonth !== undefined)
            url_ += "isNowMonth=" + encodeURIComponent("" + isNowMonth) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthAttAllPage(_response);
        });
    }

    protected processGetMonthAttAllPage(response: AxiosResponse): Promise<MonthAttAll[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthAttAll.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthAttAll[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthAttAll[]>(null as any);
    }

    /**
     * 获取月度考勤明细
     * @param id (optional) 
     * @return Success
     */
    getMonthAttDetail(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<MonthAttDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetMonthAttDetail?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthAttDetail(_response);
        });
    }

    protected processGetMonthAttDetail(response: AxiosResponse): Promise<MonthAttDetail[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthAttDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthAttDetail[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthAttDetail[]>(null as any);
    }

    /**
     * 获取当月打卡点位
     * @param empId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getMonthPoint(empId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<GetMonthPointDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetMonthPoint?";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthPoint(_response);
        });
    }

    protected processGetMonthPoint(response: AxiosResponse): Promise<GetMonthPointDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMonthPointDto.fromJS(resultData200);
            return Promise.resolve<GetMonthPointDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMonthPointDto>(null as any);
    }

    /**
     * 获取考勤月汇总分页清单
     * @param attYear (optional) 考勤年
     * @param attMonth (optional) 考勤月
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param state (optional) (1:待审核 2：已审核 3：员工已确认 4:已结账)----字典代码
     * @param empType (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPgeds(attYear: number | null | undefined, attMonth: number | null | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, state: string | null | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmpattmonthlyListDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetPgeds?";
        if (attYear !== undefined && attYear !== null)
            url_ += "attYear=" + encodeURIComponent("" + attYear) + "&";
        if (attMonth !== undefined && attMonth !== null)
            url_ += "attMonth=" + encodeURIComponent("" + attMonth) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPgeds(_response);
        });
    }

    protected processGetPgeds(response: AxiosResponse): Promise<PagedResultDtoOfEmpattmonthlyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmpattmonthlyListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmpattmonthlyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmpattmonthlyListDto>(null as any);
    }

    /**
     * 导出考勤月汇总
     * @param attYear (optional) 考勤年
     * @param attMonth (optional) 考勤月
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param state (optional) (1:待审核 2：已审核 3：员工已确认 4:已结账)----字典代码
     * @param empType (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(attYear: number | null | undefined, attMonth: number | null | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, state: string | null | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/GetToExcelFile?";
        if (attYear !== undefined && attYear !== null)
            url_ += "attYear=" + encodeURIComponent("" + attYear) + "&";
        if (attMonth !== undefined && attMonth !== null)
            url_ += "attMonth=" + encodeURIComponent("" + attMonth) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 一键审核
     * @param attYear (optional) 考勤年
     * @param attMonth (optional) 考勤月
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param state (optional) (1:待审核 2：已审核 3：员工已确认 4:已结账)----字典代码
     * @param empType (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    oneClickAudit(attYear: number | null | undefined, attMonth: number | null | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, state: string | null | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/OneClickAudit?";
        if (attYear !== undefined && attYear !== null)
            url_ += "attYear=" + encodeURIComponent("" + attYear) + "&";
        if (attMonth !== undefined && attMonth !== null)
            url_ += "attMonth=" + encodeURIComponent("" + attMonth) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOneClickAudit(_response);
        });
    }

    protected processOneClickAudit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 以审核人员消息推送
     * @param attYear (optional) 考勤年
     * @param attMonth (optional) 考勤月
     * @param companyId (optional) 公司Id
     * @param departmentIds (optional) 部门Id
     * @param attGroupIds (optional) 考勤组Code
     * @param state (optional) (1:待审核 2：已审核 3：员工已确认 4:已结账)----字典代码
     * @param empType (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    sendExamineNotice(attYear: number | null | undefined, attMonth: number | null | undefined, companyId: string | null | undefined, departmentIds: string | null | undefined, attGroupIds: string | null | undefined, state: string | null | undefined, empType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/SendExamineNotice?";
        if (attYear !== undefined && attYear !== null)
            url_ += "attYear=" + encodeURIComponent("" + attYear) + "&";
        if (attMonth !== undefined && attMonth !== null)
            url_ += "attMonth=" + encodeURIComponent("" + attMonth) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (attGroupIds !== undefined && attGroupIds !== null)
            url_ += "attGroupIds=" + encodeURIComponent("" + attGroupIds) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendExamineNotice(_response);
        });
    }

    protected processSendExamineNotice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 同步员工自助超时状态
     * @return Success
     */
    syncStaffSelfConfirmation( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/SyncStaffSelfConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncStaffSelfConfirmation(_response);
        });
    }

    protected processSyncStaffSelfConfirmation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 月汇总编辑
     * @param body (optional) 
     * @return Success
     */
    update(body: EmpAttMonthlyEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更改状态
     * @param body (optional) 
     * @return Success
     */
    updateState(body: EmpattmonthlyUpdateStateDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/UpdateState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateState(_response);
        });
    }

    protected processUpdateState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 周汇总分析
     * @param body (optional) 
     * @return Success
     */
    weekAnalysis(body: WeekAnalysisDtoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Empattmonthly/WeekAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWeekAnalysis(_response);
        });
    }

    protected processWeekAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmployeeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加民族
     * @param nationName (optional) 
     * @return Success
     */
    addNation(nationName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<DataItemDetail> {
        let url_ = this.baseUrl + "/api/services/app/Employee/AddNation?";
        if (nationName !== undefined && nationName !== null)
            url_ += "nationName=" + encodeURIComponent("" + nationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNation(_response);
        });
    }

    protected processAddNation(response: AxiosResponse): Promise<DataItemDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataItemDetail.fromJS(resultData200);
            return Promise.resolve<DataItemDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemDetail>(null as any);
    }

    /**
     * 批量删除Employee的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送生日祝福
     * @param body (optional) 
     * @return Success
     */
    brithdayWishMessage(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/BrithdayWishMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBrithdayWishMessage(_response);
        });
    }

    protected processBrithdayWishMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateEmployeeInput | undefined, cancelToken?: CancelToken | undefined): Promise<EmployeeEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<EmployeeEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeEditDto.fromJS(resultData200);
            return Promise.resolve<EmployeeEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeEditDto>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 下载导入模板
     * @return Success
     */
    downloadTemplateFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/DownloadTemplateFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadTemplateFile(_response);
        });
    }

    protected processDownloadTemplateFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导出花名册
     * @param companyIds (optional) 
     * @param departmentIds (optional) 部门
     * @param empTypeCodes (optional) 员工类型-------------------新增
     * @param empStateCodes (optional) 员工状态-------------------新增
     * @param maritalStatusCode (optional) 婚姻状态-------------------新增
     * @param idCardOverTime (optional) 证件即将到期(近两个月)
     * @param isChildrenOrg (optional) 是否只看部门(不包含子部门)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    exportRoster(companyIds: string | null | undefined, departmentIds: string | null | undefined, empTypeCodes: string | null | undefined, empStateCodes: string | null | undefined, maritalStatusCode: string | null | undefined, idCardOverTime: boolean | null | undefined, isChildrenOrg: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/ExportRoster?";
        if (companyIds !== undefined && companyIds !== null)
            url_ += "companyIds=" + encodeURIComponent("" + companyIds) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (empTypeCodes !== undefined && empTypeCodes !== null)
            url_ += "empTypeCodes=" + encodeURIComponent("" + empTypeCodes) + "&";
        if (empStateCodes !== undefined && empStateCodes !== null)
            url_ += "empStateCodes=" + encodeURIComponent("" + empStateCodes) + "&";
        if (maritalStatusCode !== undefined && maritalStatusCode !== null)
            url_ += "maritalStatusCode=" + encodeURIComponent("" + maritalStatusCode) + "&";
        if (idCardOverTime !== undefined && idCardOverTime !== null)
            url_ += "idCardOverTime=" + encodeURIComponent("" + idCardOverTime) + "&";
        if (isChildrenOrg === null)
            throw new Error("The parameter 'isChildrenOrg' cannot be null.");
        else if (isChildrenOrg !== undefined)
            url_ += "isChildrenOrg=" + encodeURIComponent("" + isChildrenOrg) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRoster(_response);
        });
    }

    protected processExportRoster(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取所有员工信息
     * @return Success
     */
    getAllEmp( cancelToken?: CancelToken | undefined): Promise<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetAllEmp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEmp(_response);
        });
    }

    protected processGetAllEmp(response: AxiosResponse): Promise<UserListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListDto[]>(null as any);
    }

    /**
     * 获取所有员工列表
     * @param companyId (optional) 公司Id
     * @param depId (optional) 部门Id
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllEmployeeList(companyId: number | null | undefined, depId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetAllEmployeeList?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (depId !== undefined && depId !== null)
            url_ += "depId=" + encodeURIComponent("" + depId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEmployeeList(_response);
        });
    }

    protected processGetAllEmployeeList(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * 通过指定id获取EmployeeListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<EmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<EmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeListDto.fromJS(resultData200);
            return Promise.resolve<EmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeListDto>(null as any);
    }

    /**
     * 获取员工当月生日列表测试
     * @return Success
     */
    getEmpBirthdayList( cancelToken?: CancelToken | undefined): Promise<BirthdayComGroup[]> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmpBirthdayList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpBirthdayList(_response);
        });
    }

    protected processGetEmpBirthdayList(response: AxiosResponse): Promise<BirthdayComGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BirthdayComGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BirthdayComGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BirthdayComGroup[]>(null as any);
    }

    /**
     * 下月合同到期人员清单
     * @return Success
     */
    getEmpContractList( cancelToken?: CancelToken | undefined): Promise<ContractEmpInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmpContractList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpContractList(_response);
        });
    }

    protected processGetEmpContractList(response: AxiosResponse): Promise<ContractEmpInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ContractEmpInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractEmpInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractEmpInfo[]>(null as any);
    }

    /**
     * 获取员工统计数据信息
     * @return Success
     */
    getEmpCountInfo( cancelToken?: CancelToken | undefined): Promise<EmpCountInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmpCountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpCountInfo(_response);
        });
    }

    protected processGetEmpCountInfo(response: AxiosResponse): Promise<EmpCountInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmpCountInfoDto.fromJS(resultData200);
            return Promise.resolve<EmpCountInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmpCountInfoDto>(null as any);
    }

    /**
     * 判断当前员工部门异动时是否为部门负责人
     * @param empId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getEmpDepManager(empId: number | undefined, departmentId: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetEmpDepManagerDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmpDepManager?";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpDepManager(_response);
        });
    }

    protected processGetEmpDepManager(response: AxiosResponse): Promise<GetEmpDepManagerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmpDepManagerDto.fromJS(resultData200);
            return Promise.resolve<GetEmpDepManagerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmpDepManagerDto>(null as any);
    }

    /**
     * 导出Excel
     * @param companyId (optional) 公司---------------------新增
     * @param departmentId (optional) 部门Id
     * @param hireDateStart (optional) 入职日期 开始-------------------新增
     * @param hireDateEnd (optional) 入职日期 结束-------------------新增
     * @param termDateStart (optional) 离职日期 开始-------------------新增
     * @param termDateEnd (optional) 离职日期 结束-------------------新增
     * @param departmentIds (optional) 部门Id集(多选)-------------------新增
     * @param empTypeId (optional) 员工类型-------------------新增
     * @param isWillQuit (optional) 只看预离职
     * @param maritalStatusId (optional) 婚姻状态-------------------新增
     * @param isChildrenOrg (optional) 是否只看当前部门(不包含子部门)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEmployeeToExcel(companyId: number | null | undefined, departmentId: number | null | undefined, hireDateStart: moment.Moment | null | undefined, hireDateEnd: moment.Moment | null | undefined, termDateStart: moment.Moment | null | undefined, termDateEnd: moment.Moment | null | undefined, departmentIds: string | null | undefined, empTypeId: string | null | undefined, isWillQuit: boolean | undefined, maritalStatusId: string | null | undefined, isChildrenOrg: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmployeeToExcel?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (hireDateStart !== undefined && hireDateStart !== null)
            url_ += "hireDateStart=" + encodeURIComponent(hireDateStart ? "" + hireDateStart.toISOString() : "") + "&";
        if (hireDateEnd !== undefined && hireDateEnd !== null)
            url_ += "hireDateEnd=" + encodeURIComponent(hireDateEnd ? "" + hireDateEnd.toISOString() : "") + "&";
        if (termDateStart !== undefined && termDateStart !== null)
            url_ += "termDateStart=" + encodeURIComponent(termDateStart ? "" + termDateStart.toISOString() : "") + "&";
        if (termDateEnd !== undefined && termDateEnd !== null)
            url_ += "termDateEnd=" + encodeURIComponent(termDateEnd ? "" + termDateEnd.toISOString() : "") + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (empTypeId !== undefined && empTypeId !== null)
            url_ += "empTypeId=" + encodeURIComponent("" + empTypeId) + "&";
        if (isWillQuit === null)
            throw new Error("The parameter 'isWillQuit' cannot be null.");
        else if (isWillQuit !== undefined)
            url_ += "isWillQuit=" + encodeURIComponent("" + isWillQuit) + "&";
        if (maritalStatusId !== undefined && maritalStatusId !== null)
            url_ += "maritalStatusId=" + encodeURIComponent("" + maritalStatusId) + "&";
        if (isChildrenOrg === null)
            throw new Error("The parameter 'isChildrenOrg' cannot be null.");
        else if (isChildrenOrg !== undefined)
            url_ += "isChildrenOrg=" + encodeURIComponent("" + isChildrenOrg) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeToExcel(_response);
        });
    }

    protected processGetEmployeeToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetEmployeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetEmployeeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetEmployeeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeForEditOutput>(null as any);
    }

    /**
     * 获取用户工号
     * @param companyId (optional) 
     * @return Success
     */
    getNewEmpJobNumber(companyId: number | undefined, cancelToken?: CancelToken | undefined): Promise<NewUserJobNumberDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetNewEmpJobNumber?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewEmpJobNumber(_response);
        });
    }

    protected processGetNewEmpJobNumber(response: AxiosResponse): Promise<NewUserJobNumberDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewUserJobNumberDto.fromJS(resultData200);
            return Promise.resolve<NewUserJobNumberDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewUserJobNumberDto>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param companyId (optional) 公司---------------------新增
     * @param departmentId (optional) 部门Id
     * @param hireDateStart (optional) 入职日期 开始-------------------新增
     * @param hireDateEnd (optional) 入职日期 结束-------------------新增
     * @param termDateStart (optional) 离职日期 开始-------------------新增
     * @param termDateEnd (optional) 离职日期 结束-------------------新增
     * @param departmentIds (optional) 部门Id集(多选)-------------------新增
     * @param empTypeId (optional) 员工类型-------------------新增
     * @param isWillQuit (optional) 只看预离职
     * @param maritalStatusId (optional) 婚姻状态-------------------新增
     * @param isChildrenOrg (optional) 是否只看当前部门(不包含子部门)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(companyId: number | null | undefined, departmentId: number | null | undefined, hireDateStart: moment.Moment | null | undefined, hireDateEnd: moment.Moment | null | undefined, termDateStart: moment.Moment | null | undefined, termDateEnd: moment.Moment | null | undefined, departmentIds: string | null | undefined, empTypeId: string | null | undefined, isWillQuit: boolean | undefined, maritalStatusId: string | null | undefined, isChildrenOrg: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetPaged?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (hireDateStart !== undefined && hireDateStart !== null)
            url_ += "hireDateStart=" + encodeURIComponent(hireDateStart ? "" + hireDateStart.toISOString() : "") + "&";
        if (hireDateEnd !== undefined && hireDateEnd !== null)
            url_ += "hireDateEnd=" + encodeURIComponent(hireDateEnd ? "" + hireDateEnd.toISOString() : "") + "&";
        if (termDateStart !== undefined && termDateStart !== null)
            url_ += "termDateStart=" + encodeURIComponent(termDateStart ? "" + termDateStart.toISOString() : "") + "&";
        if (termDateEnd !== undefined && termDateEnd !== null)
            url_ += "termDateEnd=" + encodeURIComponent(termDateEnd ? "" + termDateEnd.toISOString() : "") + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (empTypeId !== undefined && empTypeId !== null)
            url_ += "empTypeId=" + encodeURIComponent("" + empTypeId) + "&";
        if (isWillQuit === null)
            throw new Error("The parameter 'isWillQuit' cannot be null.");
        else if (isWillQuit !== undefined)
            url_ += "isWillQuit=" + encodeURIComponent("" + isWillQuit) + "&";
        if (maritalStatusId !== undefined && maritalStatusId !== null)
            url_ += "maritalStatusId=" + encodeURIComponent("" + maritalStatusId) + "&";
        if (isChildrenOrg === null)
            throw new Error("The parameter 'isChildrenOrg' cannot be null.");
        else if (isChildrenOrg !== undefined)
            url_ += "isChildrenOrg=" + encodeURIComponent("" + isChildrenOrg) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * 获取员工花名册
     * @param companyIds (optional) 
     * @param departmentIds (optional) 部门
     * @param empTypeCodes (optional) 员工类型-------------------新增
     * @param empStateCodes (optional) 员工状态-------------------新增
     * @param maritalStatusCode (optional) 婚姻状态-------------------新增
     * @param idCardOverTime (optional) 证件即将到期(近两个月)
     * @param isChildrenOrg (optional) 是否只看部门(不包含子部门)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getRoster(companyIds: string | null | undefined, departmentIds: string | null | undefined, empTypeCodes: string | null | undefined, empStateCodes: string | null | undefined, maritalStatusCode: string | null | undefined, idCardOverTime: boolean | null | undefined, isChildrenOrg: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfRosterListDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetRoster?";
        if (companyIds !== undefined && companyIds !== null)
            url_ += "companyIds=" + encodeURIComponent("" + companyIds) + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (empTypeCodes !== undefined && empTypeCodes !== null)
            url_ += "empTypeCodes=" + encodeURIComponent("" + empTypeCodes) + "&";
        if (empStateCodes !== undefined && empStateCodes !== null)
            url_ += "empStateCodes=" + encodeURIComponent("" + empStateCodes) + "&";
        if (maritalStatusCode !== undefined && maritalStatusCode !== null)
            url_ += "maritalStatusCode=" + encodeURIComponent("" + maritalStatusCode) + "&";
        if (idCardOverTime !== undefined && idCardOverTime !== null)
            url_ += "idCardOverTime=" + encodeURIComponent("" + idCardOverTime) + "&";
        if (isChildrenOrg === null)
            throw new Error("The parameter 'isChildrenOrg' cannot be null.");
        else if (isChildrenOrg !== undefined)
            url_ += "isChildrenOrg=" + encodeURIComponent("" + isChildrenOrg) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoster(_response);
        });
    }

    protected processGetRoster(response: AxiosResponse): Promise<PagedResultDtoOfRosterListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfRosterListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfRosterListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfRosterListDto>(null as any);
    }

    /**
     * 导入
     * @param fileName (optional) 
     * @return Success
     */
    importExcel(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * 入职提醒
     * @param identityCard (optional) 
     * @param empId (optional) 
     * @return Success
     */
    inductionReminder(identityCard: string | null | undefined, empId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Employee/InductionReminder?";
        if (identityCard !== undefined && identityCard !== null)
            url_ += "identityCard=" + encodeURIComponent("" + identityCard) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInductionReminder(_response);
        });
    }

    protected processInductionReminder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 漏卡逻辑
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param nowTime (optional) 当前时间
     * @param shiftTime (optional) 班次时间
     * @param isUp (optional) 是否上班
     * @param body (optional) 
     * @return Success
     */
    omitCheckInProcess(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, nowTime: moment.Moment | undefined, shiftTime: moment.Moment | undefined, isUp: boolean | undefined, body: User | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/OmitCheckInProcess?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (nowTime === null)
            throw new Error("The parameter 'nowTime' cannot be null.");
        else if (nowTime !== undefined)
            url_ += "nowTime=" + encodeURIComponent(nowTime ? "" + nowTime.toISOString() : "") + "&";
        if (shiftTime === null)
            throw new Error("The parameter 'shiftTime' cannot be null.");
        else if (shiftTime !== undefined)
            url_ += "shiftTime=" + encodeURIComponent(shiftTime ? "" + shiftTime.toISOString() : "") + "&";
        if (isUp === null)
            throw new Error("The parameter 'isUp' cannot be null.");
        else if (isUp !== undefined)
            url_ += "isUp=" + encodeURIComponent("" + isUp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOmitCheckInProcess(_response);
        });
    }

    protected processOmitCheckInProcess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试漏卡提醒
     * @return Success
     */
    omitCheckInRemindTest( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/OmitCheckInRemindTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOmitCheckInRemindTest(_response);
        });
    }

    protected processOmitCheckInRemindTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试员工考勤提醒任务
     * @return Success
     */
    testAttendanceRemind( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/TestAttendanceRemind";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestAttendanceRemind(_response);
        });
    }

    protected processTestAttendanceRemind(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    testCheck(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Employee/TestCheck?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestCheck(_response);
        });
    }

    protected processTestCheck(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 离职恢复
     * @param id (optional) 
     * @return Success
     */
    withdrawQuit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/WithdrawQuit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWithdrawQuit(_response);
        });
    }

    protected processWithdrawQuit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmployeeAttendanceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 创建打卡记录
     * @param body (optional) 
     * @return Success
     */
    createAttendanceRecord(body: AttendanceRecordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendance/CreateAttendanceRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAttendanceRecord(_response);
        });
    }

    protected processCreateAttendanceRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取打卡信息
     * @return Success
     */
    getAttendanceRecord( cancelToken?: CancelToken | undefined): Promise<AttendanceRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendance/GetAttendanceRecord";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttendanceRecord(_response);
        });
    }

    protected processGetAttendanceRecord(response: AxiosResponse): Promise<AttendanceRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttendanceRecordDto.fromJS(resultData200);
            return Promise.resolve<AttendanceRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttendanceRecordDto>(null as any);
    }

    /**
     * 根据年月获取月打卡记录
     * @param dateTime (optional) 
     * @return Success
     */
    getMonthAttendanceRecord(dateTime: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<MonthAttendanceRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendance/GetMonthAttendanceRecord?";
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthAttendanceRecord(_response);
        });
    }

    protected processGetMonthAttendanceRecord(response: AxiosResponse): Promise<MonthAttendanceRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MonthAttendanceRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MonthAttendanceRecordDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthAttendanceRecordDto[]>(null as any);
    }
}

export class EmployeeExcelExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param fileName (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportToExcel(fileName: string | null | undefined, body: EmployeeListDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExcelExporter/ExportToExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToExcel(_response);
        });
    }

    protected processExportToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param employeeListDto (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getRosterToExcel(employeeListDto: RosterListDto[] | null | undefined, fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExcelExporter/GetRosterToExcel?";
        if (employeeListDto !== undefined && employeeListDto !== null)
            employeeListDto && employeeListDto.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "employeeListDto[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRosterToExcel(_response);
        });
    }

    protected processGetRosterToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class EmployeeQuitServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取分页清单
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param companyId (optional) 公司Id
     * @param departmentId (optional) 部门Id
     * @param empStateCode (optional) 员工状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPage(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, companyId: number | null | undefined, departmentId: number | null | undefined, empStateCode: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeQuitListDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeQuit/GetPage?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empStateCode !== undefined && empStateCode !== null)
            url_ += "empStateCode=" + encodeURIComponent("" + empStateCode) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeQuitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeQuitListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeQuitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeQuitListDto>(null as any);
    }

    /**
     * 办理离职
     * @param body (optional) 
     * @return Success
     */
    handleEmployeeQuit(body: HandleEmployeeQuitDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeQuit/HandleEmployeeQuit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleEmployeeQuit(_response);
        });
    }

    protected processHandleEmployeeQuit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnterpriseAttendCycleServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除EnterpriseAttendCycle的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改企业考勤周期的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateEnterpriseAttendCycleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除企业考勤周期信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取指定年月的周期
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    getByTenant(year: number | undefined, month: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetCycleDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetByTenant?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByTenant(_response);
        });
    }

    protected processGetByTenant(response: AxiosResponse): Promise<GetCycleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCycleDto.fromJS(resultData200);
            return Promise.resolve<GetCycleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCycleDto>(null as any);
    }

    /**
     * 获取当前日期所属周期
     * @return Success
     */
    getCycleByNow( cancelToken?: CancelToken | undefined): Promise<GetCycleDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetCycleByNow";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCycleByNow(_response);
        });
    }

    protected processGetCycleByNow(response: AxiosResponse): Promise<GetCycleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCycleDto.fromJS(resultData200);
            return Promise.resolve<GetCycleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCycleDto>(null as any);
    }

    /**
     * 获取指定日期所属周期
     * @param date (optional) 
     * @return Success
     */
    getCycleByNowByDate(date: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<GetCycleDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetCycleByNowByDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCycleByNowByDate(_response);
        });
    }

    protected processGetCycleByNowByDate(response: AxiosResponse): Promise<GetCycleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCycleDto.fromJS(resultData200);
            return Promise.resolve<GetCycleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCycleDto>(null as any);
    }

    /**
     * 获取编辑 企业考勤周期
     * @return Success
     */
    getForEdit( cancelToken?: CancelToken | undefined): Promise<GetEnterpriseAttendCycleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetEnterpriseAttendCycleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEnterpriseAttendCycleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetEnterpriseAttendCycleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEnterpriseAttendCycleForEditOutput>(null as any);
    }

    /**
     * 获取企业考勤周期的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEnterpriseAttendCycleListDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfEnterpriseAttendCycleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEnterpriseAttendCycleListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEnterpriseAttendCycleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEnterpriseAttendCycleListDto>(null as any);
    }

    /**
     * 获取薪资周期
     * @return Success
     */
    getSalaryCycle( cancelToken?: CancelToken | undefined): Promise<GetCycleDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetSalaryCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalaryCycle(_response);
        });
    }

    protected processGetSalaryCycle(response: AxiosResponse): Promise<GetCycleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCycleDto.fromJS(resultData200);
            return Promise.resolve<GetCycleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCycleDto>(null as any);
    }

    /**
     * 导出企业考勤周期为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseAttendCycle/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class EnterpriseCalendarServiceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加日历
     * @param body (optional) 
     * @return Success
     */
    create(body: EnterpriseCalendarDtoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseCalendarService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 清空
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    empty(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseCalendarService/Empty?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmpty(_response);
        });
    }

    protected processEmpty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取当前年份的日历
     * @param year (optional) 
     * @return Success
     */
    getEnterpriseCalendarList(year: number | undefined, cancelToken?: CancelToken | undefined): Promise<EnterpriseCalendarListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseCalendarService/GetEnterpriseCalendarList?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnterpriseCalendarList(_response);
        });
    }

    protected processGetEnterpriseCalendarList(response: AxiosResponse): Promise<EnterpriseCalendarListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnterpriseCalendarListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EnterpriseCalendarListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnterpriseCalendarListDto[]>(null as any);
    }

    /**
     * 获取编辑实体
     * @param date (optional) 
     * @return Success
     */
    getForEdit(date: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<EnterpriseCalendarEditDto> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseCalendarService/GetForEdit?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<EnterpriseCalendarEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnterpriseCalendarEditDto.fromJS(resultData200);
            return Promise.resolve<EnterpriseCalendarEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnterpriseCalendarEditDto>(null as any);
    }

    /**
     * 编辑
     * @param body (optional) 
     * @return Success
     */
    update(body: EnterpriseCalendarDtoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/EnterpriseCalendarService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExportingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 数据模板导出
     * @param exportName (optional) 文件名称
     * @param body (optional) 表格列头
     * @return Success
     */
    exportToExcel(exportName: string | null | undefined, body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Exporting/ExportToExcel?";
        if (exportName !== undefined && exportName !== null)
            url_ += "exportName=" + encodeURIComponent("" + exportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToExcel(_response);
        });
    }

    protected processExportToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 审核记录快速导出
     * @param exportName (optional) 文件名称
     * @param body (optional) 数据集合
     * @return Success
     */
    lPAExportAuditTaskDetailToExcel(exportName: string | null | undefined, body: GetAuditTaskDetailExportDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Exporting/LPAExportAuditTaskDetailToExcel?";
        if (exportName !== undefined && exportName !== null)
            url_ += "exportName=" + encodeURIComponent("" + exportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLPAExportAuditTaskDetailToExcel(_response);
        });
    }

    protected processLPAExportAuditTaskDetailToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 数据模板导出
     * @param exportName (optional) 文件名称
     * @param body (optional) 表格列头
     * @return Success
     */
    lPAExportToExcel(exportName: string | null | undefined, body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Exporting/LPAExportToExcel?";
        if (exportName !== undefined && exportName !== null)
            url_ += "exportName=" + encodeURIComponent("" + exportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLPAExportToExcel(_response);
        });
    }

    protected processLPAExportToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class FeedbackServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加反馈
     * @param body (optional) 
     * @return Success
     */
    add(body: FeedbackEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 关闭反馈
     * @param id (optional) 
     * @return Success
     */
    closeFeedback(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/CloseFeedback?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseFeedback(_response);
        });
    }

    protected processCloseFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取意见反馈明细
     * @param id (optional) 
     * @return Success
     */
    getFeedbackDetail(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<FeedbackListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetFeedbackDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedbackDetail(_response);
        });
    }

    protected processGetFeedbackDetail(response: AxiosResponse): Promise<FeedbackListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FeedbackListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FeedbackListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeedbackListDto[]>(null as any);
    }

    /**
     * 获取意见反馈列表
     * @param feedbackType (optional) 问题类型
     * @param feedbackState (optional) 问题状态
     * @param isAll (optional) 是否查看全部
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getFeedbackList(feedbackType: string | null | undefined, feedbackState: string | null | undefined, isAll: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfFeedbackListDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetFeedbackList?";
        if (feedbackType !== undefined && feedbackType !== null)
            url_ += "feedbackType=" + encodeURIComponent("" + feedbackType) + "&";
        if (feedbackState !== undefined && feedbackState !== null)
            url_ += "feedbackState=" + encodeURIComponent("" + feedbackState) + "&";
        if (isAll === null)
            throw new Error("The parameter 'isAll' cannot be null.");
        else if (isAll !== undefined)
            url_ += "isAll=" + encodeURIComponent("" + isAll) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedbackList(_response);
        });
    }

    protected processGetFeedbackList(response: AxiosResponse): Promise<PagedResultDtoOfFeedbackListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfFeedbackListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfFeedbackListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfFeedbackListDto>(null as any);
    }

    /**
     * 年度问题分类占比
     * @param year (optional) 
     * @param companyId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFeedbackTypeGroupReport(year: number | undefined, companyId: number | null | undefined, tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<PieChart[]> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetFeedbackTypeGroupReport?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedbackTypeGroupReport(_response);
        });
    }

    protected processGetFeedbackTypeGroupReport(response: AxiosResponse): Promise<PieChart[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PieChart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PieChart[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PieChart[]>(null as any);
    }

    /**
     * 月度提交与关闭量
     * @param year (optional) 
     * @param companyId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getMonthSubmitOffReport(year: number | undefined, companyId: number | null | undefined, tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<Histogram> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetMonthSubmitOffReport?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthSubmitOffReport(_response);
        });
    }

    protected processGetMonthSubmitOffReport(response: AxiosResponse): Promise<Histogram> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Histogram.fromJS(resultData200);
            return Promise.resolve<Histogram>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Histogram>(null as any);
    }

    /**
     * 获取意见反馈列表(app)
     * @param state (optional) 状态(1、未关闭2、已关闭)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getNewFeedbackList(state: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfFeedbackListDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetNewFeedbackList?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewFeedbackList(_response);
        });
    }

    protected processGetNewFeedbackList(response: AxiosResponse): Promise<PagedResultDtoOfFeedbackListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfFeedbackListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfFeedbackListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfFeedbackListDto>(null as any);
    }

    /**
     * 获取反馈清单
     * @param feedbackType (optional) 问题类型
     * @param feedbackState (optional) 问题状态
     * @param isAll (optional) 是否查看全部
     * @param isMe (optional) 只看我提交的
     * @param problemType (optional) 意见分类
     * @param tenantId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPage(feedbackType: string | null | undefined, feedbackState: string | null | undefined, isAll: boolean | undefined, isMe: boolean | undefined, problemType: string | null | undefined, tenantId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfFeedbackListDto> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetPage?";
        if (feedbackType !== undefined && feedbackType !== null)
            url_ += "feedbackType=" + encodeURIComponent("" + feedbackType) + "&";
        if (feedbackState !== undefined && feedbackState !== null)
            url_ += "feedbackState=" + encodeURIComponent("" + feedbackState) + "&";
        if (isAll === null)
            throw new Error("The parameter 'isAll' cannot be null.");
        else if (isAll !== undefined)
            url_ += "isAll=" + encodeURIComponent("" + isAll) + "&";
        if (isMe === null)
            throw new Error("The parameter 'isMe' cannot be null.");
        else if (isMe !== undefined)
            url_ += "isMe=" + encodeURIComponent("" + isMe) + "&";
        if (problemType !== undefined && problemType !== null)
            url_ += "problemType=" + encodeURIComponent("" + problemType) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPage(_response);
        });
    }

    protected processGetPage(response: AxiosResponse): Promise<PagedResultDtoOfFeedbackListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfFeedbackListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfFeedbackListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfFeedbackListDto>(null as any);
    }

    /**
     * 年度关闭量
     * @param year (optional) 
     * @param companyId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getYearOffReport(year: number | undefined, companyId: number | null | undefined, tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<PieChart[]> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/GetYearOffReport?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYearOffReport(_response);
        });
    }

    protected processGetYearOffReport(response: AxiosResponse): Promise<PieChart[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PieChart.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PieChart[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PieChart[]>(null as any);
    }

    /**
     * 意见反馈评价
     * @param id (optional) 
     * @param evaluationGrade (optional) 
     * @param problemEvaluation (optional) 
     * @return Success
     */
    scoreFeedback(id: number | undefined, evaluationGrade: string | null | undefined, problemEvaluation: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Feedback/ScoreFeedback?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (evaluationGrade !== undefined && evaluationGrade !== null)
            url_ += "evaluationGrade=" + encodeURIComponent("" + evaluationGrade) + "&";
        if (problemEvaluation !== undefined && problemEvaluation !== null)
            url_ += "problemEvaluation=" + encodeURIComponent("" + problemEvaluation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScoreFeedback(_response);
        });
    }

    protected processScoreFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FileManagementServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 上传文件到数据库中
     * @param file (optional) 
     * @return Success
     */
    uploadFileToData(file: FileParameter | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileUploadOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/FileManagement/UploadFileToData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFileToData(_response);
        });
    }

    protected processUploadFileToData(response: AxiosResponse): Promise<FileUploadOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadOutputDto.fromJS(resultData200);
            return Promise.resolve<FileUploadOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadOutputDto>(null as any);
    }

    /**
     * 上传文件到文件夹
     * @param file (optional) 
     * @return Success
     */
    uploadFileToSysFiles(file: FileParameter | null | undefined, cancelToken?: CancelToken | undefined): Promise<SysFileListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileManagement/UploadFileToSysFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFileToSysFiles(_response);
        });
    }

    protected processUploadFileToSysFiles(response: AxiosResponse): Promise<SysFileListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SysFileListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SysFileListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysFileListDto[]>(null as any);
    }

    /**
     * 上传文件到缓存中
     * @param file (optional) 
     * @return Success
     */
    uploadTempFile(file: FileParameter | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileUploadOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/FileManagement/UploadTempFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTempFile(_response);
        });
    }

    protected processUploadTempFile(response: AxiosResponse): Promise<FileUploadOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileUploadOutputDto.fromJS(resultData200);
            return Promise.resolve<FileUploadOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadOutputDto>(null as any);
    }
}

export class FriendshipServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptFriendshipRequest(_response);
        });
    }

    protected processAcceptFriendshipRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 屏蔽用户消息
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBlockUser(_response);
        });
    }

    protected processBlockUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加好友关系
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined, cancelToken?: CancelToken | undefined): Promise<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFriendshipRequest(_response);
        });
    }

    protected processCreateFriendshipRequest(response: AxiosResponse): Promise<FriendDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FriendDto.fromJS(resultData200);
            return Promise.resolve<FriendDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FriendDto>(null as any);
    }

    /**
     * 根据用户名查找用户
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined, cancelToken?: CancelToken | undefined): Promise<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFriendshipRequestByUserName(_response);
        });
    }

    protected processCreateFriendshipRequestByUserName(response: AxiosResponse): Promise<FriendDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FriendDto.fromJS(resultData200);
            return Promise.resolve<FriendDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FriendDto>(null as any);
    }

    /**
     * 接收用户消息
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnblockUser(_response);
        });
    }

    protected processUnblockUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GitlabClientServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getClientInfo( cancelToken?: CancelToken | undefined): Promise<GitLabClient> {
        let url_ = this.baseUrl + "/api/services/app/GitlabClient/GetClientInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientInfo(_response);
        });
    }

    protected processGetClientInfo(response: AxiosResponse): Promise<GitLabClient> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GitLabClient.fromJS(resultData200);
            return Promise.resolve<GitLabClient>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GitLabClient>(null as any);
    }

    /**
     * @return Success
     */
    getDocument( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/GitlabClient/GetDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pathWithNamespace (optional) 
     * @param filePath (optional) 
     * @param fileName (optional) 
     * @param fullPath (optional) 
     * @param sercertCode (optional) 
     * @param gitlabApiUrl (optional) 
     * @param gitlabAccessToken (optional) 
     * @return Success
     */
    getGitlabFileInfo(pathWithNamespace: string | null | undefined, filePath: string | null | undefined, fileName: string | null | undefined, fullPath: string | null | undefined, sercertCode: string | null | undefined, gitlabApiUrl: string | null | undefined, gitlabAccessToken: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<File> {
        let url_ = this.baseUrl + "/api/services/app/GitlabClient/GetGitlabFileInfo?";
        if (pathWithNamespace !== undefined && pathWithNamespace !== null)
            url_ += "pathWithNamespace=" + encodeURIComponent("" + pathWithNamespace) + "&";
        if (filePath !== undefined && filePath !== null)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fullPath !== undefined && fullPath !== null)
            url_ += "fullPath=" + encodeURIComponent("" + fullPath) + "&";
        if (sercertCode !== undefined && sercertCode !== null)
            url_ += "sercertCode=" + encodeURIComponent("" + sercertCode) + "&";
        if (gitlabApiUrl !== undefined && gitlabApiUrl !== null)
            url_ += "gitlabApiUrl=" + encodeURIComponent("" + gitlabApiUrl) + "&";
        if (gitlabAccessToken !== undefined && gitlabAccessToken !== null)
            url_ += "gitlabAccessToken=" + encodeURIComponent("" + gitlabAccessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGitlabFileInfo(_response);
        });
    }

    protected processGetGitlabFileInfo(response: AxiosResponse): Promise<File> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = File.fromJS(resultData200);
            return Promise.resolve<File>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File>(null as any);
    }

    /**
     * @return Success
     */
    getProjects( cancelToken?: CancelToken | undefined): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/services/app/GitlabClient/GetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Project.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadPictureToImgBed(body: UploadPictureToBed | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/GitlabClient/UploadPictureToImgBed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPictureToImgBed(_response);
        });
    }

    protected processUploadPictureToImgBed(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class HandLeentryServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加或者修改班次的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrEditHandLenntryInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HandLeentry/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<CreateOrEditHandLenntryInput> {
        let url_ = this.baseUrl + "/api/services/app/HandLeentry/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<CreateOrEditHandLenntryInput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrEditHandLenntryInput.fromJS(resultData200);
            return Promise.resolve<CreateOrEditHandLenntryInput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrEditHandLenntryInput>(null as any);
    }

    /**
     * 办理入职人员查询
     * @param companyId (optional) 公司Id
     * @param departmentId (optional) 部门Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(companyId: number | null | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/HandLeentry/GetPaged?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param username (optional) 
     * @param jobnumber (optional) 
     * @return Success
     */
    getRepeat(id: number | null | undefined, username: string | null | undefined, jobnumber: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<UserEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HandLeentry/GetRepeat?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (jobnumber !== undefined && jobnumber !== null)
            url_ += "jobnumber=" + encodeURIComponent("" + jobnumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRepeat(_response);
        });
    }

    protected processGetRepeat(response: AxiosResponse): Promise<UserEditDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserEditDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserEditDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEditDto[]>(null as any);
    }

    /**
     * 获取小程序扫码入职二维码图片
     * @return Success
     */
    getWXAppImg( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/HandLeentry/GetWXAppImg";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWXAppImg(_response);
        });
    }

    protected processGetWXAppImg(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class HitTimeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param deparmentId (optional) 部门id
     * @param companyId (optional) 公司id
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param isEmpState (optional) 是否含离职人员
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEmpattdailyToExcel(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, isEmpState: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HitTime/GetEmpattdailyToExcel?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (isEmpState === null)
            throw new Error("The parameter 'isEmpState' cannot be null.");
        else if (isEmpState !== undefined)
            url_ += "isEmpState=" + encodeURIComponent("" + isEmpState) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpattdailyToExcel(_response);
        });
    }

    protected processGetEmpattdailyToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param deparmentId (optional) 部门id
     * @param companyId (optional) 公司id
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param isEmpState (optional) 是否含离职人员
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, isEmpState: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmpattdailyListsDto> {
        let url_ = this.baseUrl + "/api/services/app/HitTime/GetPaged?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (isEmpState === null)
            throw new Error("The parameter 'isEmpState' cannot be null.");
        else if (isEmpState !== undefined)
            url_ += "isEmpState=" + encodeURIComponent("" + isEmpState) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfEmpattdailyListsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmpattdailyListsDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmpattdailyListsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmpattdailyListsDto>(null as any);
    }
}

export class HitTimeListExcelExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToExcel(body: EmpattdailyListsDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HitTimeListExcelExporter/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToExcel(_response);
        });
    }

    protected processExportToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class HolidayRuleServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除HolidayRule的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateHolidayRuleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取HolidayRuleListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<HolidayRuleListDto> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<HolidayRuleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HolidayRuleListDto.fromJS(resultData200);
            return Promise.resolve<HolidayRuleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayRuleListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetHolidayRuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetHolidayRuleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetHolidayRuleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetHolidayRuleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHolidayRuleForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfHolidayRuleListDto> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfHolidayRuleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfHolidayRuleListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfHolidayRuleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfHolidayRuleListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HolidayRule/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class HostCachingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    clearAllCaches( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HostCaching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearAllCaches(_response);
        });
    }

    protected processClearAllCaches(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HostCaching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllCaches( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfHostCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/HostCaching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCaches(_response);
        });
    }

    protected processGetAllCaches(response: AxiosResponse): Promise<ListResultDtoOfHostCacheDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfHostCacheDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfHostCacheDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfHostCacheDto>(null as any);
    }
}

export class HostSettingsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getAllSettings( cancelToken?: CancelToken | undefined): Promise<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSettings(_response);
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<HostSettingsEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return Promise.resolve<HostSettingsEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HostSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAllSettings(_response);
        });
    }

    protected processUpdateAllSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InterfaceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Interface的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Interface/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateInterfaceInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Interface/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Interface/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取InterfaceListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<InterfaceListDto> {
        let url_ = this.baseUrl + "/api/services/app/Interface/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<InterfaceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InterfaceListDto.fromJS(resultData200);
            return Promise.resolve<InterfaceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InterfaceListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetInterfaceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Interface/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetInterfaceForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInterfaceForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetInterfaceForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInterfaceForEditOutput>(null as any);
    }

    /**
     * 获取接口集合
     * @return Success
     */
    getInterfaceList( cancelToken?: CancelToken | undefined): Promise<InterfaceListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interface/GetInterfaceList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInterfaceList(_response);
        });
    }

    protected processGetInterfaceList(response: AxiosResponse): Promise<InterfaceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InterfaceListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InterfaceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InterfaceListDto[]>(null as any);
    }

    /**
     * 获取接口树
     * @return Success
     */
    getInterfaceTree( cancelToken?: CancelToken | undefined): Promise<InterfaceTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interface/GetInterfaceTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInterfaceTree(_response);
        });
    }

    protected processGetInterfaceTree(response: AxiosResponse): Promise<InterfaceTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InterfaceTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InterfaceTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InterfaceTreeDto[]>(null as any);
    }

    /**
     * 获取接口类型
     * @return Success
     */
    getInterfaceTypeItem( cancelToken?: CancelToken | undefined): Promise<DataItemDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/Interface/GetInterfaceTypeItem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInterfaceTypeItem(_response);
        });
    }

    protected processGetInterfaceTypeItem(response: AxiosResponse): Promise<DataItemDetail[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataItemDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataItemDetail[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemDetail[]>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfInterfaceListDto> {
        let url_ = this.baseUrl + "/api/services/app/Interface/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfInterfaceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfInterfaceListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfInterfaceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfInterfaceListDto>(null as any);
    }
}

export class InterfaceFieIdServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateInterfaceFieIdInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取InterfaceFieIdListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<InterfaceFieIdListDto> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<InterfaceFieIdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InterfaceFieIdListDto.fromJS(resultData200);
            return Promise.resolve<InterfaceFieIdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InterfaceFieIdListDto>(null as any);
    }

    /**
     * 获取字段类型
     * @return Success
     */
    getFiledType( cancelToken?: CancelToken | undefined): Promise<DataConditionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/GetFiledType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiledType(_response);
        });
    }

    protected processGetFiledType(response: AxiosResponse): Promise<DataConditionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataConditionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataConditionDto[]>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetInterfaceFieIdForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetInterfaceFieIdForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInterfaceFieIdForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetInterfaceFieIdForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInterfaceFieIdForEditOutput>(null as any);
    }

    /**
     * 根据接口Id获取对应的字段数据
     * @param intefaceId (optional) 
     * @return Success
     */
    getInterfaceFieldListByInterfaceId(intefaceId: number | undefined, cancelToken?: CancelToken | undefined): Promise<InterfaceFieIdListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/GetInterfaceFieldListByInterfaceId?";
        if (intefaceId === null)
            throw new Error("The parameter 'intefaceId' cannot be null.");
        else if (intefaceId !== undefined)
            url_ += "intefaceId=" + encodeURIComponent("" + intefaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInterfaceFieldListByInterfaceId(_response);
        });
    }

    protected processGetInterfaceFieldListByInterfaceId(response: AxiosResponse): Promise<InterfaceFieIdListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InterfaceFieIdListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InterfaceFieIdListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InterfaceFieIdListDto[]>(null as any);
    }

    /**
     * @param interfaceId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(interfaceId: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfInterfaceFieIdListDto> {
        let url_ = this.baseUrl + "/api/services/app/InterfaceFieId/GetPaged?";
        if (interfaceId === null)
            throw new Error("The parameter 'interfaceId' cannot be null.");
        else if (interfaceId !== undefined)
            url_ += "interfaceId=" + encodeURIComponent("" + interfaceId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfInterfaceFieIdListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfInterfaceFieIdListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfInterfaceFieIdListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfInterfaceFieIdListDto>(null as any);
    }
}

export class InternshipServiceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param empId (optional) 
     * @return Success
     */
    getForEdit(empId: number | undefined, cancelToken?: CancelToken | undefined): Promise<HandleFormalEditDto> {
        let url_ = this.baseUrl + "/api/services/app/InternshipService/GetForEdit?";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<HandleFormalEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HandleFormalEditDto.fromJS(resultData200);
            return Promise.resolve<HandleFormalEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HandleFormalEditDto>(null as any);
    }

    /**
     * 获取转正管理清单
     * @param deparmentId (optional) 
     * @param companyId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getInternshipList(deparmentId: number | null | undefined, companyId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetInternshipListDto> {
        let url_ = this.baseUrl + "/api/services/app/InternshipService/GetInternshipList?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInternshipList(_response);
        });
    }

    protected processGetInternshipList(response: AxiosResponse): Promise<PagedResultDtoOfGetInternshipListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetInternshipListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetInternshipListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetInternshipListDto>(null as any);
    }

    /**
     * 办理转正
     * @param body (optional) 
     * @return Success
     */
    handleFormal(body: HandleFormalEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/InternshipService/HandleFormal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleFormal(_response);
        });
    }

    protected processHandleFormal(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InvalidUserExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToFile(body: ImportUserDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/InvalidUserExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToFile(_response);
        });
    }

    protected processExportToFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class IssueServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 关注问题
     * @param body (optional) 
     * @return Success
     */
    addStar(body: StarDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/AddStar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddStar(_response);
        });
    }

    protected processAddStar(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 审核时排除问题分类配置
     * @param body (optional) 
     * @return Success
     */
    auditExcludeIssueCategoriesConfig(body: AuditExcludeIssueCategoriesConfigDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/AuditExcludeIssueCategoriesConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuditExcludeIssueCategoriesConfig(_response);
        });
    }

    protected processAuditExcludeIssueCategoriesConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 审核时必须发现若干个问题项配置
     * @param body (optional) 
     * @return Success
     */
    auditMustFindIssuesConfig(body: AuditMustFindIssuesConfigDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/AuditMustFindIssuesConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuditMustFindIssuesConfig(_response);
        });
    }

    protected processAuditMustFindIssuesConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量处理
     * @param body (optional) 
     * @return Success
     */
    batchHandle(body: BatchHandleDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/BatchHandle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchHandle(_response);
        });
    }

    protected processBatchHandle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 关闭问题
     * @param issueId (optional) 
     * @param closeTime (optional) 
     * @param remark (optional) 
     * @return Success
     */
    closeIssue(issueId: number | undefined, closeTime: moment.Moment | null | undefined, remark: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/CloseIssue?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (closeTime !== undefined && closeTime !== null)
            url_ += "closeTime=" + encodeURIComponent(closeTime ? "" + closeTime.toISOString() : "") + "&";
        if (remark !== undefined && remark !== null)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseIssue(_response);
        });
    }

    protected processCloseIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建问题
     * @param body (optional) 
     * @return Success
     */
    createIssue(body: CreateIssueDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/CreateIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIssue(_response);
        });
    }

    protected processCreateIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建问题用于安全隐患
     * @param body (optional) 
     * @return Success
     */
    createIssueForSafetyHazards(body: CreateIssueBySafetyHazardsDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/CreateIssueForSafetyHazards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateIssueForSafetyHazards(_response);
        });
    }

    protected processCreateIssueForSafetyHazards(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建泛微工作流
     * @param body (optional) 请求参数
     * @return Success
     */
    createWorkflowRequest(body: CreateWorkflowRequestInput | undefined, cancelToken?: CancelToken | undefined): Promise<WorkflowResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/CreateWorkflowRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWorkflowRequest(_response);
        });
    }

    protected processCreateWorkflowRequest(response: AxiosResponse): Promise<WorkflowResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkflowResponseDto.fromJS(resultData200);
            return Promise.resolve<WorkflowResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkflowResponseDto>(null as any);
    }

    /**
     * 填写改善措施必须修改进度
     * @param body (optional) 
     * @return Success
     */
    fillInCorrectiveNoteMustUpdateProgress(body: FillInCorrectiveNoteMustUpdateProgressDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/FillInCorrectiveNoteMustUpdateProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFillInCorrectiveNoteMustUpdateProgress(_response);
        });
    }

    protected processFillInCorrectiveNoteMustUpdateProgress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有数据（不分页）
     * @param sourceType (optional) 问题来源类型（字典）1.审核时发现 2.即时问题
     * @param auditPointId (optional) 审核点
     * @param issueTypeId (optional) 问题类型
     * @param issueProgress (optional) 问题进度（存问题进度的值，不是id）
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param userId (optional) 用户
     * @param filterText (optional) 
     * @param skip (optional) 
     * @param isStar (optional) 是否只显示关注的
     * @param orgId (optional) 组织架构ID
     * @return Success
     */
    getAllData(sourceType: string | null | undefined, auditPointId: number | null | undefined, issueTypeId: number | null | undefined, issueProgress: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, userId: number | null | undefined, filterText: string | null | undefined, skip: number | null | undefined, isStar: boolean | undefined, orgId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetAllData?";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (issueTypeId !== undefined && issueTypeId !== null)
            url_ += "issueTypeId=" + encodeURIComponent("" + issueTypeId) + "&";
        if (issueProgress !== undefined && issueProgress !== null)
            url_ += "issueProgress=" + encodeURIComponent("" + issueProgress) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (isStar === null)
            throw new Error("The parameter 'isStar' cannot be null.");
        else if (isStar !== undefined)
            url_ += "isStar=" + encodeURIComponent("" + isStar) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<IssueListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueListDto[]>(null as any);
    }

    /**
     * 获取除了责任人自己以外所有的用户信息
     * @param userId (optional) 
     * @return Success
     */
    getAllEmp(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetAllEmp?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEmp(_response);
        });
    }

    protected processGetAllEmp(response: AxiosResponse): Promise<UserListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListDto[]>(null as any);
    }

    /**
     * 获取全部审核点
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @return Success
     */
    getAllPointForSafetyHazards(tenantId: number | undefined, scenesId: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditpointListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetAllPointForSafetyHazards?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId === null)
            throw new Error("The parameter 'scenesId' cannot be null.");
        else if (scenesId !== undefined)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPointForSafetyHazards(_response);
        });
    }

    protected processGetAllPointForSafetyHazards(response: AxiosResponse): Promise<AuditpointListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditpointListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditpointListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditpointListDto[]>(null as any);
    }

    /**
     * 实现APP端获取所有必填字段
     * @return Success
     */
    getAppIssueAllScenesRequiredFields( cancelToken?: CancelToken | undefined): Promise<AppIssueRequiredAllScenesDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetAppIssueAllScenesRequiredFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppIssueAllScenesRequiredFields(_response);
        });
    }

    protected processGetAppIssueAllScenesRequiredFields(response: AxiosResponse): Promise<AppIssueRequiredAllScenesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppIssueRequiredAllScenesDto.fromJS(resultData200);
            return Promise.resolve<AppIssueRequiredAllScenesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppIssueRequiredAllScenesDto>(null as any);
    }

    /**
     * 获取审核时排除问题分类配置
     * @return Success
     */
    getAuditExcludeIssueCategoriesConfig( cancelToken?: CancelToken | undefined): Promise<AuditExcludeIssueCategoriesConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetAuditExcludeIssueCategoriesConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditExcludeIssueCategoriesConfig(_response);
        });
    }

    protected processGetAuditExcludeIssueCategoriesConfig(response: AxiosResponse): Promise<AuditExcludeIssueCategoriesConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditExcludeIssueCategoriesConfigDto.fromJS(resultData200);
            return Promise.resolve<AuditExcludeIssueCategoriesConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditExcludeIssueCategoriesConfigDto>(null as any);
    }

    /**
     * 获取审核时必须发现若干个问题项配置
     * @return Success
     */
    getAuditMustFindIssuesConfig( cancelToken?: CancelToken | undefined): Promise<AuditMustFindIssuesConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetAuditMustFindIssuesConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditMustFindIssuesConfig(_response);
        });
    }

    protected processGetAuditMustFindIssuesConfig(response: AxiosResponse): Promise<AuditMustFindIssuesConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditMustFindIssuesConfigDto.fromJS(resultData200);
            return Promise.resolve<AuditMustFindIssuesConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditMustFindIssuesConfigDto>(null as any);
    }

    /**
     * 获取填写改善措施必须修改进度
     * @return Success
     */
    getFillInCorrectiveNoteMustUpdateProgress( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetFillInCorrectiveNoteMustUpdateProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFillInCorrectiveNoteMustUpdateProgress(_response);
        });
    }

    protected processGetFillInCorrectiveNoteMustUpdateProgress(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueListDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<IssueListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueListDto.fromJS(resultData200);
            return Promise.resolve<IssueListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueListDto>(null as any);
    }

    /**
     * 获取关闭问题时是否需要必须填写备注
     * @return Success
     */
    getIsCloseIssueFillInRemarks( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIsCloseIssueFillInRemarks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsCloseIssueFillInRemarks(_response);
        });
    }

    protected processGetIsCloseIssueFillInRemarks(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否启用专员确认流程
     * @return Success
     */
    getIsEnabledAssistantConfirmationProcess( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIsEnabledAssistantConfirmationProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnabledAssistantConfirmationProcess(_response);
        });
    }

    protected processGetIsEnabledAssistantConfirmationProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否需要上传改善后照片
     * @return Success
     */
    getIsMustUploadImprovedPicture( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIsMustUploadImprovedPicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsMustUploadImprovedPicture(_response);
        });
    }

    protected processGetIsMustUploadImprovedPicture(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取问题责任人是否必填
     * @return Success
     */
    getIsRequiredIssueResp( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIsRequiredIssueResp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsRequiredIssueResp(_response);
        });
    }

    protected processGetIsRequiredIssueResp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取设置问题发现时拍照是否必填
     * @return Success
     */
    getIsRequiredPhotoIssueResp( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIsRequiredPhotoIssueResp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsRequiredPhotoIssueResp(_response);
        });
    }

    protected processGetIsRequiredPhotoIssueResp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取问题确认专员
     * @return Success
     */
    getIssueConfirmAssistant( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssueConfirmAssistant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueConfirmAssistant(_response);
        });
    }

    protected processGetIssueConfirmAssistant(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取问题发现人是否可以关闭问题
     * @return Success
     */
    getIssueDiscovererIsCanCloseIssue( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssueDiscovererIsCanCloseIssue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueDiscovererIsCanCloseIssue(_response);
        });
    }

    protected processGetIssueDiscovererIsCanCloseIssue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取滚动分页数据
     * @param sourceType (optional) 问题来源类型（字典）1.审核时发现 2.即时问题
     * @param auditPointId (optional) 审核点
     * @param issueTypeId (optional) 问题类型
     * @param issueProgress (optional) 问题进度（存问题进度的值，不是id）
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param userId (optional) 用户
     * @param filterText (optional) 
     * @param skip (optional) 
     * @param isStar (optional) 是否只显示关注的
     * @param orgId (optional) 组织架构ID
     * @return Success
     */
    getIssuepage(sourceType: string | null | undefined, auditPointId: number | null | undefined, issueTypeId: number | null | undefined, issueProgress: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, userId: number | null | undefined, filterText: string | null | undefined, skip: number | null | undefined, isStar: boolean | undefined, orgId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetPageIssueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssuepage?";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (issueTypeId !== undefined && issueTypeId !== null)
            url_ += "issueTypeId=" + encodeURIComponent("" + issueTypeId) + "&";
        if (issueProgress !== undefined && issueProgress !== null)
            url_ += "issueProgress=" + encodeURIComponent("" + issueProgress) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (isStar === null)
            throw new Error("The parameter 'isStar' cannot be null.");
        else if (isStar !== undefined)
            url_ += "isStar=" + encodeURIComponent("" + isStar) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssuepage(_response);
        });
    }

    protected processGetIssuepage(response: AxiosResponse): Promise<GetPageIssueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetPageIssueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetPageIssueDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageIssueDto[]>(null as any);
    }

    /**
     * 获取计划完成时间未填写时长
     * @return Success
     */
    getIssuePlanTimeNotFilledInHour( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssuePlanTimeNotFilledInHour";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssuePlanTimeNotFilledInHour(_response);
        });
    }

    protected processGetIssuePlanTimeNotFilledInHour(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 问题报表
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param monthOrWeek (optional) 月或周
    1.月
    2.周
     * @param type (optional) 筛选条件
    1.问题关闭率
    2.问题分类
    3.问题区域
    4.问题负责人
    5.问题发现人
    6.审核点模板
    7.审核项模板
     * @return Success
     */
    getIssueReport(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, monthOrWeek: number | undefined, type: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssueReport?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (monthOrWeek === null)
            throw new Error("The parameter 'monthOrWeek' cannot be null.");
        else if (monthOrWeek !== undefined)
            url_ += "monthOrWeek=" + encodeURIComponent("" + monthOrWeek) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueReport(_response);
        });
    }

    protected processGetIssueReport(response: AxiosResponse): Promise<GetIssueReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueReportDto.fromJS(resultData200);
            return Promise.resolve<GetIssueReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueReportDto>(null as any);
    }

    /**
     * 获取问题限制字段
     * @return Success
     */
    getIssueRestrictedFields( cancelToken?: CancelToken | undefined): Promise<IssueRestrictedFieldsDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssueRestrictedFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueRestrictedFields(_response);
        });
    }

    protected processGetIssueRestrictedFields(response: AxiosResponse): Promise<IssueRestrictedFieldsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueRestrictedFieldsDto.fromJS(resultData200);
            return Promise.resolve<IssueRestrictedFieldsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueRestrictedFieldsDto>(null as any);
    }

    /**
     * 获取多少人关注了这个问题
     * @param issueId (optional) 
     * @return Success
     */
    getIssueSubscribeByUsers(issueId: number | undefined, cancelToken?: CancelToken | undefined): Promise<IssueSubscribeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssueSubscribeByUsers?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueSubscribeByUsers(_response);
        });
    }

    protected processGetIssueSubscribeByUsers(response: AxiosResponse): Promise<IssueSubscribeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueSubscribeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueSubscribeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueSubscribeListDto[]>(null as any);
    }

    /**
     * 获取问题分类树状
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getIssueTypeForSafetyHazards(tenantId: number | undefined, scenesId: number | undefined, filterText: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetIssueTypeForSafetyHazards?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId === null)
            throw new Error("The parameter 'scenesId' cannot be null.");
        else if (scenesId !== undefined)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeForSafetyHazards(_response);
        });
    }

    protected processGetIssueTypeForSafetyHazards(response: AxiosResponse): Promise<IssueTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueTypeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeListDto[]>(null as any);
    }

    /**
     * 获取组织架构
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @return Success
     */
    getLayoutOrgForSafetyHazards(tenantId: number | undefined, scenesId: number | undefined, cancelToken?: CancelToken | undefined): Promise<LayoutOrgListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetLayoutOrgForSafetyHazards?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId === null)
            throw new Error("The parameter 'scenesId' cannot be null.");
        else if (scenesId !== undefined)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLayoutOrgForSafetyHazards(_response);
        });
    }

    protected processGetLayoutOrgForSafetyHazards(response: AxiosResponse): Promise<LayoutOrgListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LayoutOrgListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LayoutOrgListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutOrgListDto[]>(null as any);
    }

    /**
     * 获取人员
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param lPAUserType (optional) 状态（什么不传默认全部）1:审核人,2:责任人
     * @return Success
     */
    getLayoutUserTreeForSafetyHazards(tenantId: number | undefined, scenesId: number | undefined, lPAUserType: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetLayoutUserTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetLayoutUserTreeForSafetyHazards?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId === null)
            throw new Error("The parameter 'scenesId' cannot be null.");
        else if (scenesId !== undefined)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        if (lPAUserType !== undefined && lPAUserType !== null)
            url_ += "lPAUserType=" + encodeURIComponent("" + lPAUserType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLayoutUserTreeForSafetyHazards(_response);
        });
    }

    protected processGetLayoutUserTreeForSafetyHazards(response: AxiosResponse): Promise<GetLayoutUserTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetLayoutUserTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetLayoutUserTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLayoutUserTreeDto[]>(null as any);
    }

    /**
     * 问题的 月关闭率
     * @param year (optional) 
     * @return Success
     */
    getMonthClosePercent(year: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetMonthClosePercent?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthClosePercent(_response);
        });
    }

    protected processGetMonthClosePercent(response: AxiosResponse): Promise<GetIssueReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueReportDto.fromJS(resultData200);
            return Promise.resolve<GetIssueReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueReportDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param sourceType (optional) 问题来源类型（字典）1.审核时发现 2.即时问题
     * @param auditPointId (optional) 审核点
     * @param issueTypeId (optional) 问题类型
     * @param issueProgress (optional) 问题进度（存问题进度的值，不是id）
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param isStar (optional) 是否只显示关注的
     * @param discoveryStartTime (optional) 发现开始时间
     * @param discoveryEndTime (optional) 发现结束时间
     * @param orgId (optional) 部门
     * @param respId (optional) 责任人
     * @param issueStatus (optional) 问题状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(sourceType: string | null | undefined, auditPointId: number | null | undefined, issueTypeId: number | null | undefined, issueProgress: number[] | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, isStar: boolean | undefined, discoveryStartTime: moment.Moment | null | undefined, discoveryEndTime: moment.Moment | null | undefined, orgId: number | null | undefined, respId: number | null | undefined, issueStatus: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfIssueListDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetPaged?";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (issueTypeId !== undefined && issueTypeId !== null)
            url_ += "issueTypeId=" + encodeURIComponent("" + issueTypeId) + "&";
        if (issueProgress !== undefined && issueProgress !== null)
            issueProgress && issueProgress.forEach(item => { url_ += "issueProgress=" + encodeURIComponent("" + item) + "&"; });
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (isStar === null)
            throw new Error("The parameter 'isStar' cannot be null.");
        else if (isStar !== undefined)
            url_ += "isStar=" + encodeURIComponent("" + isStar) + "&";
        if (discoveryStartTime !== undefined && discoveryStartTime !== null)
            url_ += "discoveryStartTime=" + encodeURIComponent(discoveryStartTime ? "" + discoveryStartTime.toISOString() : "") + "&";
        if (discoveryEndTime !== undefined && discoveryEndTime !== null)
            url_ += "discoveryEndTime=" + encodeURIComponent(discoveryEndTime ? "" + discoveryEndTime.toISOString() : "") + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (respId !== undefined && respId !== null)
            url_ += "respId=" + encodeURIComponent("" + respId) + "&";
        if (issueStatus !== undefined && issueStatus !== null)
            url_ += "issueStatus=" + encodeURIComponent("" + issueStatus) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfIssueListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfIssueListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfIssueListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfIssueListDto>(null as any);
    }

    /**
     * 获取审核点信息
     * @param tenantId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getPointInfoById(tenantId: number | undefined, id: number | undefined, cancelToken?: CancelToken | undefined): Promise<AuditPointEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetPointInfoById?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPointInfoById(_response);
        });
    }

    protected processGetPointInfoById(response: AxiosResponse): Promise<AuditPointEditDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditPointEditDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditPointEditDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditPointEditDto[]>(null as any);
    }

    /**
     * 获取安全问题
     * @param tenantId (optional) 租户Id
     * @param issueId (optional) 上次同步时间
     * @return Success
     */
    getSecurityIssue(tenantId: number | undefined, issueId: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<IssueListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetSecurityIssue?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent(issueId ? "" + issueId.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecurityIssue(_response);
        });
    }

    protected processGetSecurityIssue(response: AxiosResponse): Promise<IssueListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueListDto[]>(null as any);
    }

    /**
     * 导出
     * @param sourceType (optional) 问题来源类型（字典）1.审核时发现 2.即时问题
     * @param auditPointId (optional) 审核点
     * @param issueTypeId (optional) 问题类型
     * @param issueProgress (optional) 问题进度（存问题进度的值，不是id）
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param isStar (optional) 是否只显示关注的
     * @param discoveryStartTime (optional) 发现开始时间
     * @param discoveryEndTime (optional) 发现结束时间
     * @param orgId (optional) 部门
     * @param respId (optional) 责任人
     * @param issueStatus (optional) 问题状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param ids (optional) 
     * @return Success
     */
    getToExcelIssue(sourceType: string | null | undefined, auditPointId: number | null | undefined, issueTypeId: number | null | undefined, issueProgress: number[] | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, isStar: boolean | undefined, discoveryStartTime: moment.Moment | null | undefined, discoveryEndTime: moment.Moment | null | undefined, orgId: number | null | undefined, respId: number | null | undefined, issueStatus: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, ids: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetToExcelIssue?";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (issueTypeId !== undefined && issueTypeId !== null)
            url_ += "issueTypeId=" + encodeURIComponent("" + issueTypeId) + "&";
        if (issueProgress !== undefined && issueProgress !== null)
            issueProgress && issueProgress.forEach(item => { url_ += "issueProgress=" + encodeURIComponent("" + item) + "&"; });
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (isStar === null)
            throw new Error("The parameter 'isStar' cannot be null.");
        else if (isStar !== undefined)
            url_ += "isStar=" + encodeURIComponent("" + isStar) + "&";
        if (discoveryStartTime !== undefined && discoveryStartTime !== null)
            url_ += "discoveryStartTime=" + encodeURIComponent(discoveryStartTime ? "" + discoveryStartTime.toISOString() : "") + "&";
        if (discoveryEndTime !== undefined && discoveryEndTime !== null)
            url_ += "discoveryEndTime=" + encodeURIComponent(discoveryEndTime ? "" + discoveryEndTime.toISOString() : "") + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (respId !== undefined && respId !== null)
            url_ += "respId=" + encodeURIComponent("" + respId) + "&";
        if (issueStatus !== undefined && issueStatus !== null)
            url_ += "issueStatus=" + encodeURIComponent("" + issueStatus) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelIssue(_response);
        });
    }

    protected processGetToExcelIssue(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: LayoutOrgListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取用户信息
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param userid (optional) 
     * @return Success
     */
    getUserInfoForSafetyHazards(tenantId: number | undefined, scenesId: number | undefined, userid: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserInfoForSafetyHazardsDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetUserInfoForSafetyHazards?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId === null)
            throw new Error("The parameter 'scenesId' cannot be null.");
        else if (scenesId !== undefined)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        if (userid === null)
            throw new Error("The parameter 'userid' cannot be null.");
        else if (userid !== undefined)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfoForSafetyHazards(_response);
        });
    }

    protected processGetUserInfoForSafetyHazards(response: AxiosResponse): Promise<GetUserInfoForSafetyHazardsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserInfoForSafetyHazardsDto.fromJS(resultData200);
            return Promise.resolve<GetUserInfoForSafetyHazardsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserInfoForSafetyHazardsDto>(null as any);
    }

    /**
     * 查看数据
     * @param issueId (optional) 
     * @param issueStatus (optional) 
     * @return Success
     */
    getView(issueId: number | undefined, issueStatus: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueListDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetView?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (issueStatus !== undefined && issueStatus !== null)
            url_ += "issueStatus=" + encodeURIComponent("" + issueStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetView(_response);
        });
    }

    protected processGetView(response: AxiosResponse): Promise<IssueListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueListDto.fromJS(resultData200);
            return Promise.resolve<IssueListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueListDto>(null as any);
    }

    /**
     * 获取每周问题的关闭率
     * @param year (optional) 
     * @return Success
     */
    getWeekClosePercent(year: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Issue/GetWeekClosePercent?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeekClosePercent(_response);
        });
    }

    protected processGetWeekClosePercent(response: AxiosResponse): Promise<GetIssueReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueReportDto.fromJS(resultData200);
            return Promise.resolve<GetIssueReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueReportDto>(null as any);
    }

    /**
     * 编辑问题
     * @param body (optional) 
     * @return Success
     */
    handleIssue(body: UpdataIssueDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/HandleIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHandleIssue(_response);
        });
    }

    protected processHandleIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置关闭问题时是否需要必须填写备注
     * @param body (optional) 
     * @return Success
     */
    isCloseIssueFillInRemarks(body: IsCloseIssueFillInRemarksDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IsCloseIssueFillInRemarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsCloseIssueFillInRemarks(_response);
        });
    }

    protected processIsCloseIssueFillInRemarks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置是否启用专员确认流程
     * @param body (optional) 
     * @return Success
     */
    isEnabledAssistantConfirmationProcess(body: IsEnabledAssistantConfirmationProcessDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IsEnabledAssistantConfirmationProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnabledAssistantConfirmationProcess(_response);
        });
    }

    protected processIsEnabledAssistantConfirmationProcess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置是否需要上传改善后照片
     * @param body (optional) 
     * @return Success
     */
    isMustUploadImprovedPicture(body: IsMustUploadImprovedPictureDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IsMustUploadImprovedPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsMustUploadImprovedPicture(_response);
        });
    }

    protected processIsMustUploadImprovedPicture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置问题责任人是否必填
     * @param body (optional) 
     * @return Success
     */
    isRequiredIssueResp(body: IsRequiredIssueRespDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IsRequiredIssueResp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsRequiredIssueResp(_response);
        });
    }

    protected processIsRequiredIssueResp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置问题发现时拍照是否必填
     * @param body (optional) 
     * @return Success
     */
    isRequiredPhotoIssueResp(body: IsRequiredPhotoIssueRespDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IsRequiredPhotoIssueResp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsRequiredPhotoIssueResp(_response);
        });
    }

    protected processIsRequiredPhotoIssueResp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过
     * @param issueId (optional) 问题Id
     * @return Success
     */
    issueApprove(issueId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IssueApprove?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueApprove(_response);
        });
    }

    protected processIssueApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题确认专员
     * @param body (optional) 
     * @return Success
     */
    issueConfirmAssistant(body: IssueConfirmAssistantDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IssueConfirmAssistant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueConfirmAssistant(_response);
        });
    }

    protected processIssueConfirmAssistant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题发现人是否可以关闭问题
     * @param body (optional) 
     * @return Success
     */
    issueDiscovererIsCanCloseIssue(body: IssueDiscovererIsCanCloseIssueDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IssueDiscovererIsCanCloseIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueDiscovererIsCanCloseIssue(_response);
        });
    }

    protected processIssueDiscovererIsCanCloseIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 作废
     * @param issueId (optional) 问题Id
     * @param remark (optional) 作废备注
     * @return Success
     */
    issueNullify(issueId: number | undefined, remark: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IssueNullify?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (remark !== undefined && remark !== null)
            url_ += "remark=" + encodeURIComponent("" + remark) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueNullify(_response);
        });
    }

    protected processIssueNullify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 计划完成时间未填写时长
     * @param body (optional) 
     * @return Success
     */
    issuePlanTimeNotFilledInHour(body: IssuePlanTimeNotFilledInHourDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IssuePlanTimeNotFilledInHour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssuePlanTimeNotFilledInHour(_response);
        });
    }

    protected processIssuePlanTimeNotFilledInHour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置问题限制字段
     * @param body (optional) 
     * @return Success
     */
    issueRestrictedFields(body: IssueRestrictedFieldsDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/IssueRestrictedFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueRestrictedFields(_response);
        });
    }

    protected processIssueRestrictedFields(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 取消关注问题
     * @param issueId (optional) 
     * @return Success
     */
    removeStar(issueId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/RemoveStar?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveStar(_response);
        });
    }

    protected processRemoveStar(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 转办
     * @param issueId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    transfer(issueId: number | undefined, userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Issue/Transfer?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IssueProgressServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除eqm_am_IssueStatus的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateIssueProgressInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定阈值获取eqm_am_IssueStatusListDto信息
     * @param input (optional) 
     * @return Success
     */
    getByData(input: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueProgressListDto> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/GetByData?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByData(_response);
        });
    }

    protected processGetByData(response: AxiosResponse): Promise<IssueProgressListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueProgressListDto.fromJS(resultData200);
            return Promise.resolve<IssueProgressListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueProgressListDto>(null as any);
    }

    /**
     * 通过指定id获取eqm_am_IssueStatusListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<IssueProgressListDto> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IssueProgressListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueProgressListDto.fromJS(resultData200);
            return Promise.resolve<IssueProgressListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueProgressListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueProgressForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetIssueProgressForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueProgressForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetIssueProgressForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueProgressForEditOutput>(null as any);
    }

    /**
     * 获取所有问题进度
     * @param isKanBan (optional) 
     * @return Success
     */
    getIssueStatusList(isKanBan: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<IssueProgressListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/GetIssueStatusList?";
        if (isKanBan === null)
            throw new Error("The parameter 'isKanBan' cannot be null.");
        else if (isKanBan !== undefined)
            url_ += "isKanBan=" + encodeURIComponent("" + isKanBan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueStatusList(_response);
        });
    }

    protected processGetIssueStatusList(response: AxiosResponse): Promise<IssueProgressListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueProgressListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueProgressListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueProgressListDto[]>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfIssueProgressListDto> {
        let url_ = this.baseUrl + "/api/services/app/IssueProgress/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfIssueProgressListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfIssueProgressListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfIssueProgressListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfIssueProgressListDto>(null as any);
    }
}

export class IssueTypeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或修改
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateIssueTypeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 单个删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据Id获取数据
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<IssueTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IssueTypeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueTypeListDto.fromJS(resultData200);
            return Promise.resolve<IssueTypeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<IssueTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueTypeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeListDto[]>(null as any);
    }

    /**
     * 获取编码是否重复
     * @param id (optional) 
     * @param code (optional) 
     * @return Success
     */
    getCodeCount(id: number | null | undefined, code: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetCodeCount?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodeCount(_response);
        });
    }

    protected processGetCodeCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取修改的实体
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetIssueTypeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueTypeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetIssueTypeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueTypeForEditOutput>(null as any);
    }

    /**
     * 获取树Tree选择控件的Dto
     * @return Success
     */
    getIssueTypeTree( cancelToken?: CancelToken | undefined): Promise<IssueTypeTreeSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetIssueTypeTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeTree(_response);
        });
    }

    protected processGetIssueTypeTree(response: AxiosResponse): Promise<IssueTypeTreeSelectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueTypeTreeSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueTypeTreeSelectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeTreeSelectDto[]>(null as any);
    }

    /**
     * 问题分类树状
     * @param filterText (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<IssueTypeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IssueTypeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IssueTypeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueTypeListDto[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeByIdChildren(query: IssueTypeListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetTreeByIdChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeByIdChildren(_response);
        });
    }

    protected processGetTreeByIdChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 循环获取树Id数据
     * @param issueTypeId (optional) 
     * @return Success
     */
    getTreeIssueTypeId(issueTypeId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/services/app/IssueType/GetTreeIssueTypeId?";
        if (issueTypeId !== undefined && issueTypeId !== null)
            url_ += "issueTypeId=" + encodeURIComponent("" + issueTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeIssueTypeId(_response);
        });
    }

    protected processGetTreeIssueTypeId(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class JumpProtocolServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除JumpProtocol的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/JumpProtocol/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateJumpProtocolInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/JumpProtocol/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/JumpProtocol/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取JumpProtocolListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<JumpProtocolListDto> {
        let url_ = this.baseUrl + "/api/services/app/JumpProtocol/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JumpProtocolListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JumpProtocolListDto.fromJS(resultData200);
            return Promise.resolve<JumpProtocolListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JumpProtocolListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetJumpProtocolForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JumpProtocol/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetJumpProtocolForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJumpProtocolForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetJumpProtocolForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJumpProtocolForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfJumpProtocolListDto> {
        let url_ = this.baseUrl + "/api/services/app/JumpProtocol/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfJumpProtocolListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfJumpProtocolListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfJumpProtocolListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfJumpProtocolListDto>(null as any);
    }
}

export class JumpValidPathServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除JumpValidPath的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/JumpValidPath/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateJumpValidPathInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/JumpValidPath/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/JumpValidPath/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取JumpValidPathListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<JumpValidPathListDto> {
        let url_ = this.baseUrl + "/api/services/app/JumpValidPath/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JumpValidPathListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JumpValidPathListDto.fromJS(resultData200);
            return Promise.resolve<JumpValidPathListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JumpValidPathListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetJumpValidPathForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JumpValidPath/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetJumpValidPathForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJumpValidPathForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetJumpValidPathForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJumpValidPathForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param jvpId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(jvpId: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfJumpValidPathListDto> {
        let url_ = this.baseUrl + "/api/services/app/JumpValidPath/GetPaged?";
        if (jvpId === null)
            throw new Error("The parameter 'jvpId' cannot be null.");
        else if (jvpId !== undefined)
            url_ += "jvpId=" + encodeURIComponent("" + jvpId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfJumpValidPathListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfJumpValidPathListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfJumpValidPathListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfJumpValidPathListDto>(null as any);
    }
}

export class KanBanServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: KanbanAnalogDataEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取数据
     * @param code (optional) 
     * @return Success
     */
    getAll(code: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<KanbanAnalogDataListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetAll?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<KanbanAnalogDataListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KanbanAnalogDataListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KanbanAnalogDataListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KanbanAnalogDataListDto[]>(null as any);
    }

    /**
     * 获取审核点符合率数据
     * @param date (optional) 
     * @return Success
     */
    getAuditPointComplianceRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAuditPointComplianceRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetAuditPointComplianceRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditPointComplianceRate(_response);
        });
    }

    protected processGetAuditPointComplianceRate(response: AxiosResponse): Promise<GetAuditPointComplianceRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAuditPointComplianceRateDto.fromJS(resultData200);
            return Promise.resolve<GetAuditPointComplianceRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditPointComplianceRateDto>(null as any);
    }

    /**
     * 获取审核任务数据
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param userId (optional) 用户
     * @param status (optional) 状态
     * @param date (optional) 日期，在主页面需要传，打开之后不需要
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditTaskList(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userId: number | null | undefined, status: string | null | undefined, date: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetAuditTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetAuditTaskList?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskList(_response);
        });
    }

    protected processGetAuditTaskList(response: AxiosResponse): Promise<GetAuditTaskListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAuditTaskListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAuditTaskListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditTaskListDto[]>(null as any);
    }

    /**
     * 获取部门完成率数据
     * @param date (optional) 
     * @return Success
     */
    getDeptCompletionRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCompletionRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetDeptCompletionRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptCompletionRate(_response);
        });
    }

    protected processGetDeptCompletionRate(response: AxiosResponse): Promise<GetCompletionRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompletionRateDto.fromJS(resultData200);
            return Promise.resolve<GetCompletionRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompletionRateDto>(null as any);
    }

    /**
     * 获取部门符合率数据
     * @param date (optional) 
     * @return Success
     */
    getDeptComplianceRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetComplianceRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetDeptComplianceRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptComplianceRate(_response);
        });
    }

    protected processGetDeptComplianceRate(response: AxiosResponse): Promise<GetComplianceRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetComplianceRateDto.fromJS(resultData200);
            return Promise.resolve<GetComplianceRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetComplianceRateDto>(null as any);
    }

    /**
     * 获取部门问题关闭率数据
     * @param date (optional) 
     * @return Success
     */
    getDeptIssueCloseRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueCloseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetDeptIssueCloseRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptIssueCloseRate(_response);
        });
    }

    protected processGetDeptIssueCloseRate(response: AxiosResponse): Promise<GetIssueCloseRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueCloseRateDto.fromJS(resultData200);
            return Promise.resolve<GetIssueCloseRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueCloseRateDto>(null as any);
    }

    /**
     * 隐患问题部门关闭率数据
     * @param date (optional) 
     * @return Success
     */
    getDeptIssueCloseRateForSafetyHazards(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueCloseRateForSafetyHazardsDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetDeptIssueCloseRateForSafetyHazards?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptIssueCloseRateForSafetyHazards(_response);
        });
    }

    protected processGetDeptIssueCloseRateForSafetyHazards(response: AxiosResponse): Promise<GetIssueCloseRateForSafetyHazardsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueCloseRateForSafetyHazardsDto.fromJS(resultData200);
            return Promise.resolve<GetIssueCloseRateForSafetyHazardsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueCloseRateForSafetyHazardsDto>(null as any);
    }

    /**
     * 部门隐患月度发现数量
     * @param date (optional) 
     * @return Success
     */
    getDeptIssueMonthQtyForSafetyHazards(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDeptIssueMonthQtyForSafetyHazardsDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetDeptIssueMonthQtyForSafetyHazards?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptIssueMonthQtyForSafetyHazards(_response);
        });
    }

    protected processGetDeptIssueMonthQtyForSafetyHazards(response: AxiosResponse): Promise<GetDeptIssueMonthQtyForSafetyHazardsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeptIssueMonthQtyForSafetyHazardsDto.fromJS(resultData200);
            return Promise.resolve<GetDeptIssueMonthQtyForSafetyHazardsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeptIssueMonthQtyForSafetyHazardsDto>(null as any);
    }

    /**
     * 获取部门问题数量数据
     * @param date (optional) 
     * @return Success
     */
    getDeptIssueQty(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDeptIssueQtyDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetDeptIssueQty?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptIssueQty(_response);
        });
    }

    protected processGetDeptIssueQty(response: AxiosResponse): Promise<GetDeptIssueQtyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeptIssueQtyDto.fromJS(resultData200);
            return Promise.resolve<GetDeptIssueQtyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeptIssueQtyDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<KanbanAnalogDataEditDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<KanbanAnalogDataEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KanbanAnalogDataEditDto.fromJS(resultData200);
            return Promise.resolve<KanbanAnalogDataEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KanbanAnalogDataEditDto>(null as any);
    }

    /**
     * 关键岗位人员月度隐患排查数量
     * @param date (optional) 
     * @return Success
     */
    getIsKeyPositionsUserMonthIssueQtyForSafetyHazards(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetIsKeyPositionsUserMonthIssueQtyForSafetyHazards?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsKeyPositionsUserMonthIssueQtyForSafetyHazards(_response);
        });
    }

    protected processGetIsKeyPositionsUserMonthIssueQtyForSafetyHazards(response: AxiosResponse): Promise<GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto.fromJS(resultData200);
            return Promise.resolve<GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto>(null as any);
    }

    /**
     * 获取问题清单数据
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param auditPointId (optional) 审核点
     * @param issueProgress (optional) 问题进度（存问题进度的值，不是id）
     * @param filterText (optional) 模糊搜索
     * @param date (optional) 日期，在主页面需要传，打开之后不需要
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getIssueList(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, auditPointId: number | null | undefined, issueProgress: number[] | null | undefined, filterText: string | null | undefined, date: moment.Moment | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetKanBanIssueListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetIssueList?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (issueProgress !== undefined && issueProgress !== null)
            issueProgress && issueProgress.forEach(item => { url_ += "issueProgress=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueList(_response);
        });
    }

    protected processGetIssueList(response: AxiosResponse): Promise<GetKanBanIssueListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetKanBanIssueListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetKanBanIssueListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKanBanIssueListDto[]>(null as any);
    }

    /**
     * 获取问题按时关闭率数据
     * @param date (optional) 
     * @return Success
     */
    getIssueOnTimeCloseRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueOnTimeCloseRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetIssueOnTimeCloseRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueOnTimeCloseRate(_response);
        });
    }

    protected processGetIssueOnTimeCloseRate(response: AxiosResponse): Promise<GetIssueOnTimeCloseRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueOnTimeCloseRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueOnTimeCloseRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueOnTimeCloseRateDto[]>(null as any);
    }

    /**
     * 获取问题区域TOP3数据
     * @param date (optional) 
     * @return Success
     */
    getIssuePointTopThree(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueTopThree[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetIssuePointTopThree?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssuePointTopThree(_response);
        });
    }

    protected processGetIssuePointTopThree(response: AxiosResponse): Promise<GetIssueTopThree[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueTopThree.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueTopThree[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueTopThree[]>(null as any);
    }

    /**
     * 获取问题分类TOP10数据
     * @param date (optional) 
     * @return Success
     */
    getIssueTypeTopTen(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueTypeTopTenDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetIssueTypeTopTen?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeTopTen(_response);
        });
    }

    protected processGetIssueTypeTopTen(response: AxiosResponse): Promise<GetIssueTypeTopTenDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueTypeTopTenDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueTypeTopTenDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueTypeTopTenDto[]>(null as any);
    }

    /**
     * 获取问题分类TOP3数据
     * @param date (optional) 
     * @return Success
     */
    getIssueTypeTopThree(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueTopThree[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetIssueTypeTopThree?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeTopThree(_response);
        });
    }

    protected processGetIssueTypeTopThree(response: AxiosResponse): Promise<GetIssueTopThree[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueTopThree.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueTopThree[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueTopThree[]>(null as any);
    }

    /**
     * 获取看板审核计划分页数据。
     * @param date (optional) 日期
     * @param auditPlanSkipCount (optional) 审核计划分页跳过数量
     * @param auditPlanMaxResultCount (optional) 审核计划分页条数
     * @return Success
     */
    getKanBanAuditPlanBoardList(date: moment.Moment | null | undefined, auditPlanSkipCount: number | null | undefined, auditPlanMaxResultCount: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<KanBanAuditPlanBoardItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetKanBanAuditPlanBoardList?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (auditPlanSkipCount !== undefined && auditPlanSkipCount !== null)
            url_ += "auditPlanSkipCount=" + encodeURIComponent("" + auditPlanSkipCount) + "&";
        if (auditPlanMaxResultCount !== undefined && auditPlanMaxResultCount !== null)
            url_ += "auditPlanMaxResultCount=" + encodeURIComponent("" + auditPlanMaxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKanBanAuditPlanBoardList(_response);
        });
    }

    protected processGetKanBanAuditPlanBoardList(response: AxiosResponse): Promise<KanBanAuditPlanBoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KanBanAuditPlanBoardItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KanBanAuditPlanBoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KanBanAuditPlanBoardItemDto[]>(null as any);
    }

    /**
     * 获取看板聚合数据
     * @param date (optional) 日期
     * @param auditPlanSkipCount (optional) 审核计划分页跳过数量
     * @param auditPlanMaxResultCount (optional) 审核计划分页条数
     * @return Success
     */
    getKanBanDashboardBundle(date: moment.Moment | null | undefined, auditPlanSkipCount: number | null | undefined, auditPlanMaxResultCount: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetKanBanDashboardBundleDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetKanBanDashboardBundle?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (auditPlanSkipCount !== undefined && auditPlanSkipCount !== null)
            url_ += "auditPlanSkipCount=" + encodeURIComponent("" + auditPlanSkipCount) + "&";
        if (auditPlanMaxResultCount !== undefined && auditPlanMaxResultCount !== null)
            url_ += "auditPlanMaxResultCount=" + encodeURIComponent("" + auditPlanMaxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKanBanDashboardBundle(_response);
        });
    }

    protected processGetKanBanDashboardBundle(response: AxiosResponse): Promise<GetKanBanDashboardBundleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKanBanDashboardBundleDto.fromJS(resultData200);
            return Promise.resolve<GetKanBanDashboardBundleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKanBanDashboardBundleDto>(null as any);
    }

    /**
     * 获取看板问题清单数据。
     * @param date (optional) 
     * @return Success
     */
    getKanBanIssueBoardList(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<KanBanIssueBoardItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetKanBanIssueBoardList?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKanBanIssueBoardList(_response);
        });
    }

    protected processGetKanBanIssueBoardList(response: AxiosResponse): Promise<KanBanIssueBoardItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KanBanIssueBoardItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KanBanIssueBoardItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KanBanIssueBoardItemDto[]>(null as any);
    }

    /**
     * 获取看板总览快照
     * @param date (optional) 
     * @return Success
     */
    getKanBanSummarySnapshot(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetKanBanSummarySnapshotDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetKanBanSummarySnapshot?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetKanBanSummarySnapshot(_response);
        });
    }

    protected processGetKanBanSummarySnapshot(response: AxiosResponse): Promise<GetKanBanSummarySnapshotDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKanBanSummarySnapshotDto.fromJS(resultData200);
            return Promise.resolve<GetKanBanSummarySnapshotDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKanBanSummarySnapshotDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfKanbanAnalogDataListDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfKanbanAnalogDataListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfKanbanAnalogDataListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfKanbanAnalogDataListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfKanbanAnalogDataListDto>(null as any);
    }

    /**
     * 获取六个月内重复问题
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getSixMonthRepeatIssueForEcharts(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSixMonthRepeatIssueForEchartsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetSixMonthRepeatIssueForEcharts?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSixMonthRepeatIssueForEcharts(_response);
        });
    }

    protected processGetSixMonthRepeatIssueForEcharts(response: AxiosResponse): Promise<GetSixMonthRepeatIssueForEchartsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetSixMonthRepeatIssueForEchartsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSixMonthRepeatIssueForEchartsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSixMonthRepeatIssueForEchartsDto[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: LayoutOrgListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取用户层级数据
     * @param date (optional) 
     * @return Success
     */
    getUserLevel(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserLevelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetUserLevel?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserLevel(_response);
        });
    }

    protected processGetUserLevel(response: AxiosResponse): Promise<GetUserLevelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetUserLevelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserLevelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserLevelDto[]>(null as any);
    }

    /**
     * 获取年度完成率数据
     * @param date (optional) 
     * @return Success
     */
    getYearCompletionRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetCompletionRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetYearCompletionRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYearCompletionRate(_response);
        });
    }

    protected processGetYearCompletionRate(response: AxiosResponse): Promise<GetCompletionRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCompletionRateDto.fromJS(resultData200);
            return Promise.resolve<GetCompletionRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCompletionRateDto>(null as any);
    }

    /**
     * 获取年度符合率数据
     * @param date (optional) 
     * @return Success
     */
    getYearComplianceRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetComplianceRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetYearComplianceRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYearComplianceRate(_response);
        });
    }

    protected processGetYearComplianceRate(response: AxiosResponse): Promise<GetComplianceRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetComplianceRateDto.fromJS(resultData200);
            return Promise.resolve<GetComplianceRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetComplianceRateDto>(null as any);
    }

    /**
     * 获取年度问题关闭率数据
     * @param date (optional) 
     * @return Success
     */
    getYearIssueCloseRate(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueCloseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetYearIssueCloseRate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYearIssueCloseRate(_response);
        });
    }

    protected processGetYearIssueCloseRate(response: AxiosResponse): Promise<GetIssueCloseRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueCloseRateDto.fromJS(resultData200);
            return Promise.resolve<GetIssueCloseRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueCloseRateDto>(null as any);
    }

    /**
     * 获取年度隐患问题关闭率数据
     * @param date (optional) 
     * @return Success
     */
    getYearIssueCloseRateForSafetyHazards(date: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueCloseRateForSafetyHazardsDto> {
        let url_ = this.baseUrl + "/api/services/app/KanBan/GetYearIssueCloseRateForSafetyHazards?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYearIssueCloseRateForSafetyHazards(_response);
        });
    }

    protected processGetYearIssueCloseRateForSafetyHazards(response: AxiosResponse): Promise<GetIssueCloseRateForSafetyHazardsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetIssueCloseRateForSafetyHazardsDto.fromJS(resultData200);
            return Promise.resolve<GetIssueCloseRateForSafetyHazardsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueCloseRateForSafetyHazardsDto>(null as any);
    }
}

export class LaborcostYearPlanServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除LaborcostYearPlan的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateLaborcostYearPlanInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 下载导入模板
     * @param body (optional) 
     * @return Success
     */
    exportTemplate(body: LCExportTemplateInput | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/ExportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 通过指定id获取LaborcostYearPlanListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<LaborcostYearPlanListDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<LaborcostYearPlanListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LaborcostYearPlanListDto.fromJS(resultData200);
            return Promise.resolve<LaborcostYearPlanListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LaborcostYearPlanListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetLaborcostYearPlanForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetLaborcostYearPlanForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLaborcostYearPlanForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetLaborcostYearPlanForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLaborcostYearPlanForEditOutput>(null as any);
    }

    /**
     * 月度人力成本计划差异率
     * @param year (optional) 年
     * @param companyId (optional) 公司
     * @param departmentId (optional) 部门
     * @param item (optional) 对比项,1 人数差异率，2出勤差异率，3加班差异率，4成本差异率
     * @return Success
     */
    getMonthLCRate(year: number | undefined, companyId: number | undefined, departmentId: number | null | undefined, item: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetMonthLCRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetMonthLCRate?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (item !== undefined && item !== null)
            url_ += "item=" + encodeURIComponent("" + item) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthLCRate(_response);
        });
    }

    protected processGetMonthLCRate(response: AxiosResponse): Promise<GetMonthLCRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetMonthLCRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetMonthLCRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMonthLCRateDto[]>(null as any);
    }

    /**
     * 月度人力成本计划差异率导出
     * @param year (optional) 年
     * @param companyId (optional) 公司
     * @param departmentId (optional) 部门
     * @param item (optional) 对比项,1 人数差异率，2出勤差异率，3加班差异率，4成本差异率
     * @return Success
     */
    getMonthLCRateToExcelFile(year: number | undefined, companyId: number | undefined, departmentId: number | null | undefined, item: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetMonthLCRateToExcelFile?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (item !== undefined && item !== null)
            url_ += "item=" + encodeURIComponent("" + item) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthLCRateToExcelFile(_response);
        });
    }

    protected processGetMonthLCRateToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param year (optional) 年
     * @param companyId (optional) 公司---------------------新增
     * @param departmentId (optional) 部门Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(year: number | undefined, companyId: number | null | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetPagedResult> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetPaged?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<GetPagedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPagedResult.fromJS(resultData200);
            return Promise.resolve<GetPagedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPagedResult>(null as any);
    }

    /**
     * 导出为excel文件
     * @param year (optional) 年
     * @param companyId (optional) 公司---------------------新增
     * @param departmentId (optional) 部门Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(year: number | undefined, companyId: number | null | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetToExcelFile?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 全年计划对比导出
     * @param year (optional) 年
     * @param companyId (optional) 公司
     * @param departmentId (optional) 部门
     * @param item (optional) 对比项,1 人数差异率，2出勤差异率，3加班差异率，4成本差异率
     * @return Success
     */
    getYearPlanContrastToExcelFile(year: number | undefined, companyId: number | undefined, departmentId: number | null | undefined, item: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/GetYearPlanContrastToExcelFile?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (item !== undefined && item !== null)
            url_ += "item=" + encodeURIComponent("" + item) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYearPlanContrastToExcelFile(_response);
        });
    }

    protected processGetYearPlanContrastToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导入
     * @param body (optional) 
     * @return Success
     */
    importLoborcost(body: LCExportTemplateInput | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LaborcostYearPlan/ImportLoborcost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportLoborcost(_response);
        });
    }

    protected processImportLoborcost(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }
}

export class LanguageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateLanguage(_response);
        });
    }

    protected processCreateOrUpdateLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLanguage(_response);
        });
    }

    protected processDeleteLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguageForEdit(_response);
        });
    }

    protected processGetLanguageForEdit(response: AxiosResponse): Promise<GetLanguageForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetLanguageForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLanguageForEditOutput>(null as any);
    }

    /**
     * @return Success
     */
    getLanguages( cancelToken?: CancelToken | undefined): Promise<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: AxiosResponse): Promise<GetLanguagesOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return Promise.resolve<GetLanguagesOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLanguagesOutput>(null as any);
    }

    /**
     * @param sourceName 语言名称
     * @param baseLanguageName (optional) 原语言名称
     * @param targetLanguageName 目标语言名称
     * @param targetValueFilter (optional) 目标值过滤
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getLanguageTexts(sourceName: string, baseLanguageName: string | null | undefined, targetLanguageName: string, targetValueFilter: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined && baseLanguageName !== null)
            url_ += "baseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "targetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined && targetValueFilter !== null)
            url_ += "targetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguageTexts(_response);
        });
    }

    protected processGetLanguageTexts(response: AxiosResponse): Promise<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLanguageTextListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLanguageTextListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDefaultLanguage(_response);
        });
    }

    protected processSetDefaultLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改语言的文本内容
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLanguageText(_response);
        });
    }

    protected processUpdateLanguageText(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LayoutLevelServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutLevel/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdataLayoutLevelInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutLevel/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutLevel/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有数据（不分页）
     * @return Success
     */
    getAllData( cancelToken?: CancelToken | undefined): Promise<LayoutLevel[]> {
        let url_ = this.baseUrl + "/api/services/app/LayoutLevel/GetAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<LayoutLevel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LayoutLevel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LayoutLevel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutLevel[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<LayoutLevelEditDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutLevel/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<LayoutLevelEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LayoutLevelEditDto.fromJS(resultData200);
            return Promise.resolve<LayoutLevelEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutLevelEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLayoutLevel> {
        let url_ = this.baseUrl + "/api/services/app/LayoutLevel/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfLayoutLevel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLayoutLevel.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLayoutLevel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLayoutLevel>(null as any);
    }
}

export class LayoutOrgServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdataLayoutOrgInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有数据（不分页）
     * @return Success
     */
    getAllData( cancelToken?: CancelToken | undefined): Promise<LayoutOrgListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/GetAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: AxiosResponse): Promise<LayoutOrgListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LayoutOrgListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LayoutOrgListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutOrgListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getbyTreeId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<LayoutOrgListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/GetbyTreeId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyTreeId(_response);
        });
    }

    protected processGetbyTreeId(response: AxiosResponse): Promise<LayoutOrgListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LayoutOrgListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LayoutOrgListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutOrgListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<LayoutOrgEditDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<LayoutOrgEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LayoutOrgEditDto.fromJS(resultData200);
            return Promise.resolve<LayoutOrgEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutOrgEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLayoutOrgListDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutOrg/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfLayoutOrgListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLayoutOrgListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLayoutOrgListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLayoutOrgListDto>(null as any);
    }
}

export class LayoutUserServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreatOrUpdataLayoutUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<LayoutUserEditDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<LayoutUserEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LayoutUserEditDto.fromJS(resultData200);
            return Promise.resolve<LayoutUserEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutUserEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param orgId (optional) lap组织架构id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(orgId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLayoutUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/GetPaged?";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfLayoutUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLayoutUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLayoutUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLayoutUserListDto>(null as any);
    }

    /**
     * 获取分页数据应用于组件
     * @param orgId (optional) lap组织架构id
     * @param userType (optional) 是责任人还是审核人 0.全部 1.责任人 2.审核人
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedForAssembly(orgId: number | null | undefined, userType: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLayoutUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/GetPagedForAssembly?";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (userType === null)
            throw new Error("The parameter 'userType' cannot be null.");
        else if (userType !== undefined)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedForAssembly(_response);
        });
    }

    protected processGetPagedForAssembly(response: AxiosResponse): Promise<PagedResultDtoOfLayoutUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLayoutUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLayoutUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLayoutUserListDto>(null as any);
    }

    /**
     * 下载导入模板
     * @return Success
     */
    getToImportTempFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/GetToImportTempFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToImportTempFile(_response);
        });
    }

    protected processGetToImportTempFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: LayoutOrgListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导入数据
     * @param fileName (optional) 
     * @return Success
     */
    importExcel(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUser/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }
}

export class LayoutUserExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 导入模板下载
     * @return Success
     */
    importToExcelTemplate( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LayoutUserExporter/ImportToExcelTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportToExcelTemplate(_response);
        });
    }

    protected processImportToExcelTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class LdapServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getldaptest( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Ldap/getldaptest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetldaptest(_response);
        });
    }

    protected processGetldaptest(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class LeaveRecordServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除LeaveRecord的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateLeaveRecordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取LeaveRecordListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<LeaveRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<LeaveRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LeaveRecordListDto.fromJS(resultData200);
            return Promise.resolve<LeaveRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LeaveRecordListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetLeaveRecordForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetLeaveRecordForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLeaveRecordForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetLeaveRecordForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLeaveRecordForEditOutput>(null as any);
    }

    /**
     * 获取假期余额
     * @return Success
     */
    getHolidayLimit( cancelToken?: CancelToken | undefined): Promise<GetHolidayLimit[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetHolidayLimit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayLimit(_response);
        });
    }

    protected processGetHolidayLimit(response: AxiosResponse): Promise<GetHolidayLimit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetHolidayLimit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetHolidayLimit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetHolidayLimit[]>(null as any);
    }

    /**
     * 获取用户的假期可用额度
     * @param userId (optional) 
     * @param holidayType (optional) 
     * @return Success
     */
    getHolidayLimitByUserId(userId: number | undefined, holidayType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<HolidayLimitDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetHolidayLimitByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (holidayType !== undefined && holidayType !== null)
            url_ += "holidayType=" + encodeURIComponent("" + holidayType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayLimitByUserId(_response);
        });
    }

    protected processGetHolidayLimitByUserId(response: AxiosResponse): Promise<HolidayLimitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HolidayLimitDto.fromJS(resultData200);
            return Promise.resolve<HolidayLimitDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayLimitDto>(null as any);
    }

    /**
     * 获取假期余额明细
     * @param holidayRuleCode (optional) 
     * @return Success
     */
    getHolidayLimitDetail(holidayRuleCode: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<HolidayLimit[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetHolidayLimitDetail?";
        if (holidayRuleCode !== undefined && holidayRuleCode !== null)
            url_ += "holidayRuleCode=" + encodeURIComponent("" + holidayRuleCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayLimitDetail(_response);
        });
    }

    protected processGetHolidayLimitDetail(response: AxiosResponse): Promise<HolidayLimit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HolidayLimit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HolidayLimit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayLimit[]>(null as any);
    }

    /**
     * 根据类型s获取假期额度集合
     * @param userId (optional) 
     * @param holidayTypes (optional) 
     * @return Success
     */
    getHolidayLimitListByTypes(userId: number | undefined, holidayTypes: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<HolidayLimitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetHolidayLimitListByTypes?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (holidayTypes !== undefined && holidayTypes !== null)
            url_ += "holidayTypes=" + encodeURIComponent("" + holidayTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayLimitListByTypes(_response);
        });
    }

    protected processGetHolidayLimitListByTypes(response: AxiosResponse): Promise<HolidayLimitDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HolidayLimitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HolidayLimitDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayLimitDto[]>(null as any);
    }

    /**
     * 获取假期规则集合
     * @return Success
     */
    getHolidayRuleList( cancelToken?: CancelToken | undefined): Promise<HolidayRuleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetHolidayRuleList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayRuleList(_response);
        });
    }

    protected processGetHolidayRuleList(response: AxiosResponse): Promise<HolidayRuleListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HolidayRuleListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HolidayRuleListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayRuleListDto[]>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param userId (optional) 
     * @param companyId (optional) 公司
     * @param deparmentIds (optional) 部门
     * @param leaveTypeCode (optional) 请假类型
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(userId: number | null | undefined, companyId: string | null | undefined, deparmentIds: string | null | undefined, leaveTypeCode: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLeaveRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetPaged?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentIds !== undefined && deparmentIds !== null)
            url_ += "deparmentIds=" + encodeURIComponent("" + deparmentIds) + "&";
        if (leaveTypeCode !== undefined && leaveTypeCode !== null)
            url_ += "leaveTypeCode=" + encodeURIComponent("" + leaveTypeCode) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfLeaveRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLeaveRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLeaveRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLeaveRecordListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @param userId (optional) 
     * @param companyId (optional) 公司
     * @param deparmentIds (optional) 部门
     * @param leaveTypeCode (optional) 请假类型
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(userId: number | null | undefined, companyId: string | null | undefined, deparmentIds: string | null | undefined, leaveTypeCode: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRecord/GetToExcelFile?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentIds !== undefined && deparmentIds !== null)
            url_ += "deparmentIds=" + encodeURIComponent("" + deparmentIds) + "&";
        if (leaveTypeCode !== undefined && leaveTypeCode !== null)
            url_ += "leaveTypeCode=" + encodeURIComponent("" + leaveTypeCode) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class MailKitSendServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param subject (optional) 
     * @param bodyQuery (optional) 
     * @param bodyBody (optional) 
     * @return Success
     */
    send(subject: string | null | undefined, bodyQuery: string | null | undefined, bodyBody: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailKitSend/Send?";
        if (subject !== undefined && subject !== null)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (bodyQuery !== undefined && bodyQuery !== null)
            url_ += "body=" + encodeURIComponent("" + bodyQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bodyBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MailTemplateServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 专员新问题发送邮箱
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assistantNewProbSendMessage(tenantId: number | undefined, scenesId: string | null | undefined, body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/AssistantNewProbSendMessage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssistantNewProbSendMessage(_response);
        });
    }

    protected processAssistantNewProbSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateMailTemplateInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    dailyMessageSendMessagedata(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/DailyMessageSendMessagedata?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageSendMessagedata(_response);
        });
    }

    protected processDailyMessageSendMessagedata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 禁用
     * @param id (optional) 
     * @param enable (optional) 
     * @return Success
     */
    enable(id: number | undefined, enable: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/Enable?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (enable === null)
            throw new Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<MailTemplateEditDto> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<MailTemplateEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailTemplateEditDto.fromJS(resultData200);
            return Promise.resolve<MailTemplateEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailTemplateEditDto>(null as any);
    }

    /**
     * 获取全局配置的邮箱
     * @return Success
     */
    getGlobalConfiguration( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/GetGlobalConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGlobalConfiguration(_response);
        });
    }

    protected processGetGlobalConfiguration(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfMailTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfMailTemplateListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfMailTemplateListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfMailTemplateListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfMailTemplateListDto>(null as any);
    }

    /**
     * 设置全局配置的邮箱
     * @param body (optional) 
     * @return Success
     */
    globalConfiguration(body: GlobalConfigurationDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/GlobalConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGlobalConfiguration(_response);
        });
    }

    protected processGlobalConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题通过发送邮箱
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueApproveSendMessage(tenantId: number | undefined, scenesId: string | null | undefined, body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/IssueApproveSendMessage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueApproveSendMessage(_response);
        });
    }

    protected processIssueApproveSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 帮助类
     * @param body (optional) 
     * @return Success
     */
    issueEditHelper(body: any[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/IssueEditHelper";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditHelper(_response);
        });
    }

    protected processIssueEditHelper(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 问题修改通知APP端
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueEditSendMessageAPP(scenesId: string | null | undefined, body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/IssueEditSendMessageAPP?";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditSendMessageAPP(_response);
        });
    }

    protected processIssueEditSendMessageAPP(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题修改通知WEB端
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueEditSendMessageWeb(scenesId: string | null | undefined, body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/IssueEditSendMessageWeb?";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditSendMessageWeb(_response);
        });
    }

    protected processIssueEditSendMessageWeb(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题作废发送邮箱
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueNullifySendMessage(tenantId: number | undefined, scenesId: string | null | undefined, body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/IssueNullifySendMessage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueNullifySendMessage(_response);
        });
    }

    protected processIssueNullifySendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题转办通知
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueTurnSendMessage(scenesId: string | null | undefined, body: IssueTurnToListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/IssueTurnSendMessage?";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTurnSendMessage(_response);
        });
    }

    protected processIssueTurnSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新任务发送邮箱
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    newPlanSendMessage(tenantId: number | undefined, scenesId: string | null | undefined, body: AuditTaskListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/NewPlanSendMessage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewPlanSendMessage(_response);
        });
    }

    protected processNewPlanSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新问题发送邮箱
     * @param tenantId (optional) 
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    newProbSendMessage(tenantId: number | undefined, scenesId: string | null | undefined, body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/NewProbSendMessage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewProbSendMessage(_response);
        });
    }

    protected processNewProbSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 审核记录转办
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    taskDetailTurnSendMessage(scenesId: string | null | undefined, body: TaskDetailTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/TaskDetailTurnSendMessage?";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskDetailTurnSendMessage(_response);
        });
    }

    protected processTaskDetailTurnSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 计划转办通知
     * @param scenesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    taskTurnSendMessage(scenesId: string | null | undefined, body: TaskTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/TaskTurnSendMessage?";
        if (scenesId !== undefined && scenesId !== null)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskTurnSendMessage(_response);
        });
    }

    protected processTaskTurnSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试发送邮箱
     * @param emailAddress (optional) 
     * @return Success
     */
    testSendEmail(emailAddress: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/TestSendEmail?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendEmail(_response);
        });
    }

    protected processTestSendEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改json文件
     * @return Success
     */
    update( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/MailTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MemberServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Member的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改Member的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateMemberInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Member信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取MemberListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<MemberListDto> {
        let url_ = this.baseUrl + "/api/services/app/Member/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<MemberListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MemberListDto.fromJS(resultData200);
            return Promise.resolve<MemberListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MemberListDto>(null as any);
    }

    /**
     * 获取编辑 Member
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetMemberForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Member/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetMemberForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMemberForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetMemberForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMemberForEditOutput>(null as any);
    }

    /**
     * 获取Member的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfMemberListDto> {
        let url_ = this.baseUrl + "/api/services/app/Member/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfMemberListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfMemberListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfMemberListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfMemberListDto>(null as any);
    }
}

export class MessageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加消息
     * @param body (optional) 
     * @return Success
     */
    addSystemMessage(body: AddSystemMessageInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Message/AddSystemMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSystemMessage(_response);
        });
    }

    protected processAddSystemMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据对方ID和系统类型获取历史消息
     * @param otherUserId (optional) 其他ID
     * @param systemType (optional) 系统类型
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getHistoryByOtherUserId(otherUserId: number | undefined, systemType: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfHistoryByOtherUserIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Message/GetHistoryByOtherUserId?";
        if (otherUserId === null)
            throw new Error("The parameter 'otherUserId' cannot be null.");
        else if (otherUserId !== undefined)
            url_ += "otherUserId=" + encodeURIComponent("" + otherUserId) + "&";
        if (systemType !== undefined && systemType !== null)
            url_ += "systemType=" + encodeURIComponent("" + systemType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoryByOtherUserId(_response);
        });
    }

    protected processGetHistoryByOtherUserId(response: AxiosResponse): Promise<PagedResultDtoOfHistoryByOtherUserIdDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfHistoryByOtherUserIdDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfHistoryByOtherUserIdDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfHistoryByOtherUserIdDto>(null as any);
    }
}

export class MessagePushServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: MessagePushEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 每日邮件提醒
     * @param body (optional) 
     * @return Success
     */
    dailyMessageMessagePush(body: DailyMessageDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/DailyMessageMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageMessagePush(_response);
        });
    }

    protected processDailyMessageMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 每日邮件提醒数据处理
     * @return Success
     */
    dailyMessageMessagePushdata( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/DailyMessageMessagePushdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageMessagePushdata(_response);
        });
    }

    protected processDailyMessageMessagePushdata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 禁用
     * @param id (optional) 
     * @param enable (optional) 
     * @return Success
     */
    enable(id: number | undefined, enable: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/Enable?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (enable === null)
            throw new Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<MessagePushEditDto> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<MessagePushEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessagePushEditDto.fromJS(resultData200);
            return Promise.resolve<MessagePushEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessagePushEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfMessagePushListDto> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfMessagePushListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfMessagePushListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfMessagePushListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfMessagePushListDto>(null as any);
    }

    /**
     * 问题修改通知APP端
     * @param body (optional) 
     * @return Success
     */
    issueEditMessagePushAPP(body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/IssueEditMessagePushAPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditMessagePushAPP(_response);
        });
    }

    protected processIssueEditMessagePushAPP(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题修改通知WEB端
     * @param body (optional) 
     * @return Success
     */
    issueEditMessagePushWeb(body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/IssueEditMessagePushWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditMessagePushWeb(_response);
        });
    }

    protected processIssueEditMessagePushWeb(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题转办通知
     * @param body (optional) 
     * @return Success
     */
    issueTurnMessagePush(body: IssueTurnToListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/IssueTurnMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTurnMessagePush(_response);
        });
    }

    protected processIssueTurnMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新任务推送
     * @param body (optional) 
     * @return Success
     */
    newPlanMessagePush(body: AuditTaskListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/NewPlanMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewPlanMessagePush(_response);
        });
    }

    protected processNewPlanMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新问题推送
     * @param body (optional) 
     * @return Success
     */
    newProbMessagePush(body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/NewProbMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewProbMessagePush(_response);
        });
    }

    protected processNewProbMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 计划转办通知
     * @param body (optional) 
     * @return Success
     */
    taskDetailTurnMessagePush(body: TaskDetailTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/TaskDetailTurnMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskDetailTurnMessagePush(_response);
        });
    }

    protected processTaskDetailTurnMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 计划转办通知
     * @param body (optional) 
     * @return Success
     */
    taskTurnMessagePush(body: TaskTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MessagePush/TaskTurnMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskTurnMessagePush(_response);
        });
    }

    protected processTaskTurnMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ModuleServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Module的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Module/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchDeleteWithTenantId(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Module/BatchDeleteWithTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDeleteWithTenantId(_response);
        });
    }

    protected processBatchDeleteWithTenantId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法  宿主用
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateModuleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Module/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 租户用的 修改或李建
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateWithTenantId(body: CreateOrUpdateModuleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Module/CreateOrUpdateWithTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateWithTenantId(_response);
        });
    }

    protected processCreateOrUpdateWithTenantId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Module/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取ModuleListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<ModuleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ModuleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModuleListDto.fromJS(resultData200);
            return Promise.resolve<ModuleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleListDto>(null as any);
    }

    /**
     * 通过指定id获取ModuleListDto信息
     * @param id (optional) 
     * @return Success
     */
    getChildById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<ModuleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetChildById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChildById(_response);
        });
    }

    protected processGetChildById(response: AxiosResponse): Promise<ModuleListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModuleListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModuleListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleListDto[]>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetModuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetModuleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModuleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetModuleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModuleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEditWithTenantId(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetModuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetForEditWithTenantId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEditWithTenantId(_response);
        });
    }

    protected processGetForEditWithTenantId(response: AxiosResponse): Promise<GetModuleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModuleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetModuleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModuleForEditOutput>(null as any);
    }

    /**
     * 获取功能列表的树形数据
     * @param isApp (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getModuleTree(isApp: string | null | undefined, tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<ModuleTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetModuleTree?";
        if (isApp !== undefined && isApp !== null)
            url_ += "isApp=" + encodeURIComponent("" + isApp) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleTree(_response);
        });
    }

    protected processGetModuleTree(response: AxiosResponse): Promise<ModuleTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModuleTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModuleTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleTreeDto[]>(null as any);
    }

    /**
     * 获取功能列表的树形数据 租户使用
     * @param isApp (optional) 
     * @return Success
     */
    getModuleTreeWithTenantId(isApp: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ModuleTreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetModuleTreeWithTenantId?";
        if (isApp !== undefined && isApp !== null)
            url_ += "isApp=" + encodeURIComponent("" + isApp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleTreeWithTenantId(_response);
        });
    }

    protected processGetModuleTreeWithTenantId(response: AxiosResponse): Promise<ModuleTreeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModuleTreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModuleTreeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleTreeDto[]>(null as any);
    }

    /**
     * 获取的分页列表信息   宿主模式取 0
     * @param moduleID (optional) 功能ID
     * @param languageId (optional) 
     * @param targetLanguageId (optional) 目标语言
     * @param isApp (optional) 是否App菜单
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(moduleID: number | undefined, languageId: number | null | undefined, targetLanguageId: number | null | undefined, isApp: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfModuleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetPaged?";
        if (moduleID === null)
            throw new Error("The parameter 'moduleID' cannot be null.");
        else if (moduleID !== undefined)
            url_ += "moduleID=" + encodeURIComponent("" + moduleID) + "&";
        if (languageId !== undefined && languageId !== null)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (targetLanguageId !== undefined && targetLanguageId !== null)
            url_ += "targetLanguageId=" + encodeURIComponent("" + targetLanguageId) + "&";
        if (isApp !== undefined && isApp !== null)
            url_ += "isApp=" + encodeURIComponent("" + isApp) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfModuleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfModuleListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfModuleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfModuleListDto>(null as any);
    }

    /**
     * 租户用的 根据租户ID去取
     * @param moduleID (optional) 功能ID
     * @param languageId (optional) 
     * @param targetLanguageId (optional) 目标语言
     * @param isApp (optional) 是否App菜单
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedWithTenantId(moduleID: number | undefined, languageId: number | null | undefined, targetLanguageId: number | null | undefined, isApp: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfModuleLanguageListDto> {
        let url_ = this.baseUrl + "/api/services/app/Module/GetPagedWithTenantId?";
        if (moduleID === null)
            throw new Error("The parameter 'moduleID' cannot be null.");
        else if (moduleID !== undefined)
            url_ += "moduleID=" + encodeURIComponent("" + moduleID) + "&";
        if (languageId !== undefined && languageId !== null)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (targetLanguageId !== undefined && targetLanguageId !== null)
            url_ += "targetLanguageId=" + encodeURIComponent("" + targetLanguageId) + "&";
        if (isApp !== undefined && isApp !== null)
            url_ += "isApp=" + encodeURIComponent("" + isApp) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedWithTenantId(_response);
        });
    }

    protected processGetPagedWithTenantId(response: AxiosResponse): Promise<PagedResultDtoOfModuleLanguageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfModuleLanguageListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfModuleLanguageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfModuleLanguageListDto>(null as any);
    }
}

export class MonthAttendancePlanServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 将考勤数据同步到月计划内(根据日汇总同步)
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    asynData(year: number | undefined, month: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/AsynData?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsynData(_response);
        });
    }

    protected processAsynData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 将排班同步到月度考勤计划(只同步排班)
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    asynDataByEmpShift(year: number | undefined, month: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/AsynDataByEmpShift?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsynDataByEmpShift(_response);
        });
    }

    protected processAsynDataByEmpShift(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除MonthAttendancePlan的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateMonthAttendancePlanInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 编辑月度考勤计划
     * @param body (optional) 
     * @return Success
     */
    editMonthAttPlan(body: MonthAttPlanEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/EditMonthAttPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditMonthAttPlan(_response);
        });
    }

    protected processEditMonthAttPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 下载导入模板
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    exportTemplate(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/ExportTemplate?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 通过指定id获取MonthAttendancePlanListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<MonthAttendancePlanListDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<MonthAttendancePlanListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthAttendancePlanListDto.fromJS(resultData200);
            return Promise.resolve<MonthAttendancePlanListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthAttendancePlanListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetMonthAttendancePlanForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetMonthAttendancePlanForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMonthAttendancePlanForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetMonthAttendancePlanForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMonthAttendancePlanForEditOutput>(null as any);
    }

    /**
     * 获取请假类型
     * @return Success
     */
    getHolidayRuleList( cancelToken?: CancelToken | undefined): Promise<HolidayRuleList[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/GetHolidayRuleList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayRuleList(_response);
        });
    }

    protected processGetHolidayRuleList(response: AxiosResponse): Promise<HolidayRuleList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HolidayRuleList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HolidayRuleList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayRuleList[]>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司
     * @param deparmentId (optional) 部门
     * @param empType (optional) 员工类型
     * @return Success
     */
    getPaged(filterText: string | null | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, companyId: string | null | undefined, deparmentId: string | null | undefined, empType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<MonthAttendancePlanListDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<MonthAttendancePlanListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthAttendancePlanListDto.fromJS(resultData200);
            return Promise.resolve<MonthAttendancePlanListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthAttendancePlanListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @param filterText (optional) 
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司
     * @param deparmentId (optional) 部门
     * @param empType (optional) 员工类型
     * @return Success
     */
    getToExcelFile(filterText: string | null | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, companyId: string | null | undefined, deparmentId: string | null | undefined, empType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/GetToExcelFile?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (empType !== undefined && empType !== null)
            url_ += "empType=" + encodeURIComponent("" + empType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导入月度考勤计划
     * @param body (optional) 
     * @return Success
     */
    importMonthAttPlan(body: MonthAttendancePlanImportInput | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/ImportMonthAttPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportMonthAttPlan(_response);
        });
    }

    protected processImportMonthAttPlan(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * 同步排班
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    syncEmpShiftPlan(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlan/SyncEmpShiftPlan?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncEmpShiftPlan(_response);
        });
    }

    protected processSyncEmpShiftPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MonthAttendancePlanImportServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param fileName (optional) 
     * @return Success
     */
    importExcel(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<MonthAttendancePlanImportDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthAttendancePlanImport/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<MonthAttendancePlanImportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MonthAttendancePlanImportDto.fromJS(resultData200);
            return Promise.resolve<MonthAttendancePlanImportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonthAttendancePlanImportDto>(null as any);
    }
}

export class NeteaseOrderInfoServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param isChecked (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchUpdateChecked(isChecked: boolean | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/BatchUpdateChecked?";
        if (isChecked === null)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else if (isChecked !== undefined)
            url_ += "isChecked=" + encodeURIComponent("" + isChecked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateChecked(_response);
        });
    }

    protected processBatchUpdateChecked(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isChecked (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchUpdateGiteeChecked(isChecked: boolean | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/BatchUpdateGiteeChecked?";
        if (isChecked === null)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else if (isChecked !== undefined)
            url_ += "isChecked=" + encodeURIComponent("" + isChecked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateGiteeChecked(_response);
        });
    }

    protected processBatchUpdateGiteeChecked(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取 OrderInfo 详情
     * @param id (optional) 
     * @return Success
     */
    getDetailsById(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<NeteaseOrderInfoEditDto> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/GetDetailsById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailsById(_response);
        });
    }

    protected processGetDetailsById(response: AxiosResponse): Promise<NeteaseOrderInfoEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NeteaseOrderInfoEditDto.fromJS(resultData200);
            return Promise.resolve<NeteaseOrderInfoEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NeteaseOrderInfoEditDto>(null as any);
    }

    /**
     * 获取OrderInfo的分页列表信息
     * @param transactionStatus (optional) 交易状态
     * @param isChecked (optional) 已审核
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(transactionStatus: string | null | undefined, isChecked: boolean | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNeteaseOrderInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/GetPaged?";
        if (transactionStatus !== undefined && transactionStatus !== null)
            url_ += "transactionStatus=" + encodeURIComponent("" + transactionStatus) + "&";
        if (isChecked !== undefined && isChecked !== null)
            url_ += "isChecked=" + encodeURIComponent("" + isChecked) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfNeteaseOrderInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNeteaseOrderInfoListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNeteaseOrderInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNeteaseOrderInfoListDto>(null as any);
    }

    /**
     * @return Success
     */
    getStatistics( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfNeteaseOrderInfoStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/GetStatistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatistics(_response);
        });
    }

    protected processGetStatistics(response: AxiosResponse): Promise<ListResultDtoOfNeteaseOrderInfoStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfNeteaseOrderInfoStatisticsDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfNeteaseOrderInfoStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfNeteaseOrderInfoStatisticsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshOrderInfo(body: NullableIdDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/RefreshOrderInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshOrderInfo(_response);
        });
    }

    protected processRefreshOrderInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    synchronize( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/Synchronize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronize(_response);
        });
    }

    protected processSynchronize(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isChecked (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateChecked(isChecked: boolean | undefined, body: NullableIdDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/UpdateChecked?";
        if (isChecked === null)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else if (isChecked !== undefined)
            url_ += "isChecked=" + encodeURIComponent("" + isChecked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateChecked(_response);
        });
    }

    protected processUpdateChecked(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param isChecked (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateGiteeChecked(isChecked: boolean | undefined, body: NullableIdDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NeteaseOrderInfo/UpdateGiteeChecked?";
        if (isChecked === null)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else if (isChecked !== undefined)
            url_ += "isChecked=" + encodeURIComponent("" + isChecked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGiteeChecked(_response);
        });
    }

    protected processUpdateGiteeChecked(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NewsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/News/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改实体的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateNews(body: CreateOrUpdateNewsInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/News/CreateOrUpdateNews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateNews(_response);
        });
    }

    protected processCreateOrUpdateNews(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改实体的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateNotic(body: CreateOrUpdateNewsInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/News/CreateOrUpdateNotic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateNotic(_response);
        });
    }

    protected processCreateOrUpdateNotic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/News/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取实体信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<NewsListDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<NewsListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsListDto.fromJS(resultData200);
            return Promise.resolve<NewsListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsListDto>(null as any);
    }

    /**
     * 获取编辑 实体
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetNewsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/News/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetNewsForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNewsForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetNewsForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNewsForEditOutput>(null as any);
    }

    /**
     * 获取消息公告编辑实体
     * @param id (optional) 
     * @param type (optional) 
     * @return Success
     */
    getForEditByNotice(id: number | null | undefined, type: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetNewsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/News/GetForEditByNotice?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEditByNotice(_response);
        });
    }

    protected processGetForEditByNotice(response: AxiosResponse): Promise<GetNewsForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNewsForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetNewsForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNewsForEditOutput>(null as any);
    }

    /**
     * @return Success
     */
    getNewList( cancelToken?: CancelToken | undefined): Promise<GetNewListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/News/GetNewList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewList(_response);
        });
    }

    protected processGetNewList(response: AxiosResponse): Promise<GetNewListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetNewListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetNewListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNewListDto[]>(null as any);
    }

    /**
     * 获取通知消息(分页)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getNewPage(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetNewListDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetNewPage?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewPage(_response);
        });
    }

    protected processGetNewPage(response: AxiosResponse): Promise<PagedResultDtoOfGetNewListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetNewListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetNewListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetNewListDto>(null as any);
    }

    /**
     * 获取新闻中心的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedByNews(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNewsListDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetPagedByNews?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedByNews(_response);
        });
    }

    protected processGetPagedByNews(response: AxiosResponse): Promise<PagedResultDtoOfNewsListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNewsListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNewsListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNewsListDto>(null as any);
    }

    /**
     * 获取公告的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedByNotice(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNewsListDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetPagedByNotice?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedByNotice(_response);
        });
    }

    protected processGetPagedByNotice(response: AxiosResponse): Promise<PagedResultDtoOfNewsListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNewsListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNewsListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNewsListDto>(null as any);
    }

    /**
     * 更新记录并获取阅读清单
     * @param id (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getRecordList(id: number | undefined, userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<NoticInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetRecordList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecordList(_response);
        });
    }

    protected processGetRecordList(response: AxiosResponse): Promise<NoticInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NoticInfoDto.fromJS(resultData200);
            return Promise.resolve<NoticInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoticInfoDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class NoticSendRecordServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除NoticSendRecord的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改消息通知记录的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateNoticSendRecordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除消息通知记录信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取NoticSendRecordListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<NoticSendRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<NoticSendRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NoticSendRecordListDto.fromJS(resultData200);
            return Promise.resolve<NoticSendRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoticSendRecordListDto>(null as any);
    }

    /**
     * 获取编辑 消息通知记录
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetNoticSendRecordForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetNoticSendRecordForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNoticSendRecordForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetNoticSendRecordForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNoticSendRecordForEditOutput>(null as any);
    }

    /**
     * 获取消息通知记录的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNoticSendRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfNoticSendRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNoticSendRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNoticSendRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNoticSendRecordListDto>(null as any);
    }

    /**
     * 导出消息通知记录为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/NoticSendRecord/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class NotificationServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 删除通知
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNotification(_response);
        });
    }

    protected processDeleteNotification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings( cancelToken?: CancelToken | undefined): Promise<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationSettings(_response);
        });
    }

    protected processGetNotificationSettings(response: AxiosResponse): Promise<GetNotificationSettingsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return Promise.resolve<GetNotificationSettingsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNotificationSettingsOutput>(null as any);
    }

    /**
     * @param state (optional) 是否阅读枚举 0是未读 1是已经阅读
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedUserNotifications(state: UserNotificationState | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetPagedUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedUserNotifications(_response);
        });
    }

    protected processGetPagedUserNotifications(response: AxiosResponse): Promise<GetNotificationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return Promise.resolve<GetNotificationsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNotificationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    makeAllUserNotificationsAsRead( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/MakeAllUserNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMakeAllUserNotificationsAsRead(_response);
        });
    }

    protected processMakeAllUserNotificationsAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    makeNotificationAsRead(body: EntityDtoOfGuid | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/MakeNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMakeNotificationAsRead(_response);
        });
    }

    protected processMakeNotificationAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param msg (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    sendNoticeToUser(msg: string | null | undefined, tenantId: number | null | undefined, userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SendNoticeToUser?";
        if (msg !== undefined && msg !== null)
            url_ += "msg=" + encodeURIComponent("" + msg) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendNoticeToUser(_response);
        });
    }

    protected processSendNoticeToUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新消息设置
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNotificationSettings(_response);
        });
    }

    protected processUpdateNotificationSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationDispatchServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param tenantId (optional) 
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @return Success
     */
    dailyMessageAll(tenantId: number | undefined, sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/DailyMessageAll?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageAll(_response);
        });
    }

    protected processDailyMessageAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueEditApp(sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/IssueEditApp?";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditApp(_response);
        });
    }

    protected processIssueEditApp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueEditWeb(sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/IssueEditWeb?";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditWeb(_response);
        });
    }

    protected processIssueEditWeb(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param body (optional) 
     * @return Success
     */
    issueTurn(sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, body: IssueTurnToListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/IssueTurn?";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTurn(_response);
        });
    }

    protected processIssueTurn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param body (optional) 
     * @return Success
     */
    newPlan(sendApp: boolean | undefined, sendSms: boolean | undefined, body: AuditTaskListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/NewPlan?";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewPlan(_response);
        });
    }

    protected processNewPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param sendWeCom (optional) 
     * @param body (optional) 
     * @return Success
     */
    newProblem(sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, sendWeCom: boolean | undefined, body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/NewProblem?";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        if (sendWeCom === null)
            throw new Error("The parameter 'sendWeCom' cannot be null.");
        else if (sendWeCom !== undefined)
            url_ += "sendWeCom=" + encodeURIComponent("" + sendWeCom) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewProblem(_response);
        });
    }

    protected processNewProblem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param body (optional) 
     * @return Success
     */
    taskDetailTurn(sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, body: TaskDetailTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/TaskDetailTurn?";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskDetailTurn(_response);
        });
    }

    protected processTaskDetailTurn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sendMail (optional) 
     * @param sendApp (optional) 
     * @param sendSms (optional) 
     * @param body (optional) 
     * @return Success
     */
    taskTurn(sendMail: boolean | undefined, sendApp: boolean | undefined, sendSms: boolean | undefined, body: TaskTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationDispatch/TaskTurn?";
        if (sendMail === null)
            throw new Error("The parameter 'sendMail' cannot be null.");
        else if (sendMail !== undefined)
            url_ += "sendMail=" + encodeURIComponent("" + sendMail) + "&";
        if (sendApp === null)
            throw new Error("The parameter 'sendApp' cannot be null.");
        else if (sendApp !== undefined)
            url_ += "sendApp=" + encodeURIComponent("" + sendApp) + "&";
        if (sendSms === null)
            throw new Error("The parameter 'sendSms' cannot be null.");
        else if (sendSms !== undefined)
            url_ += "sendSms=" + encodeURIComponent("" + sendSms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskTurn(_response);
        });
    }

    protected processTaskTurn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OptionListServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete_Detail(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/BatchDelete_Detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete_Detail(_response);
        });
    }

    protected processBatchDelete_Detail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: OptionListEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate_Detail(body: OptionListDetailEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/CreateOrUpdate_Detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate_Detail(_response);
        });
    }

    protected processCreateOrUpdate_Detail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取全部数据
     * @return Success
     */
    getAllOptionList( cancelToken?: CancelToken | undefined): Promise<OptionListListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/GetAllOptionList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOptionList(_response);
        });
    }

    protected processGetAllOptionList(response: AxiosResponse): Promise<OptionListListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OptionListListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OptionListListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OptionListListDto[]>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<OptionListEditDto> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<OptionListEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OptionListEditDto.fromJS(resultData200);
            return Promise.resolve<OptionListEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OptionListEditDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit_Detail(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<OptionListDetailEditDto> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/GetForEdit_Detail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit_Detail(_response);
        });
    }

    protected processGetForEdit_Detail(response: AxiosResponse): Promise<OptionListDetailEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OptionListDetailEditDto.fromJS(resultData200);
            return Promise.resolve<OptionListDetailEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OptionListDetailEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOptionListListDto> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfOptionListListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOptionListListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOptionListListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOptionListListDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param optionListId (optional) 选项列表Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged_Detail(optionListId: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOptionListDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/OptionList/GetPaged_Detail?";
        if (optionListId === null)
            throw new Error("The parameter 'optionListId' cannot be null.");
        else if (optionListId !== undefined)
            url_ += "optionListId=" + encodeURIComponent("" + optionListId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged_Detail(_response);
        });
    }

    protected processGetPaged_Detail(response: AxiosResponse): Promise<PagedResultDtoOfOptionListDetailListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOptionListDetailListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOptionListDetailListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOptionListDetailListDto>(null as any);
    }
}

export class OrderServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Order的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Order信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取OrderListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<OrderListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrderListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderListDto.fromJS(resultData200);
            return Promise.resolve<OrderListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderListDto>(null as any);
    }

    /**
     * 获取Order的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOrderListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfOrderListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOrderListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOrderListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOrderListDto>(null as any);
    }

    /**
     * 获取产品分类的收益统计表
     * @return Success
     */
    getProductOrderStatistics( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfOrderStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetProductOrderStatistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductOrderStatistics(_response);
        });
    }

    protected processGetProductOrderStatistics(response: AxiosResponse): Promise<ListResultDtoOfOrderStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfOrderStatisticsDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfOrderStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfOrderStatisticsDto>(null as any);
    }

    /**
     * 获取Order的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserCenterPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserCenterOrderListDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetUserCenterPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCenterPaged(_response);
        });
    }

    protected processGetUserCenterPaged(response: AxiosResponse): Promise<PagedResultDtoOfUserCenterOrderListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserCenterOrderListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserCenterOrderListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserCenterOrderListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    present(body: EntityDtoOfGuid | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/Present";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPresent(_response);
        });
    }

    protected processPresent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOraderPrice(body: OrderEditPriceDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOraderPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOraderPrice(_response);
        });
    }

    protected processUpdateOraderPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrder(body: OrderEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrder(_response);
        });
    }

    protected processUpdateOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganizationChartServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getOrgChart( cancelToken?: CancelToken | undefined): Promise<OrgChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationChart/GetOrgChart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrgChart(_response);
        });
    }

    protected processGetOrgChart(response: AxiosResponse): Promise<OrgChartDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrgChartDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgChartDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgChartDto[]>(null as any);
    }
}

export class OrganizationReportExcelExporterServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 导出离职明细报表
     * @param body (optional) 
     * @return Success
     */
    employeeQuitReportToExcel(body: EmployeeQuitReportDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationReportExcelExporter/EmployeeQuitReportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployeeQuitReportToExcel(_response);
        });
    }

    protected processEmployeeQuitReportToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导出新进人员报表
     * @param body (optional) 
     * @return Success
     */
    newEmployeeReportToExcel(body: NewEmployeeReportDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationReportExcelExporter/NewEmployeeReportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewEmployeeReportToExcel(_response);
        });
    }

    protected processNewEmployeeReportToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class OrganizationUnitServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加角色 组织关联
     * @param body (optional) 
     * @return Success
     */
    addRoles(body: RolesToOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRoles(_response);
        });
    }

    protected processAddRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsers(body: UsersToOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUsers(_response);
        });
    }

    protected processAddUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量从组织中移除角色
     * @param organizationUnitId (optional) 
     * @param body (optional) 
     * @return Success
     */
    batchRemoveRoleFromOrganizationUnit(organizationUnitId: number | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/BatchRemoveRoleFromOrganizationUnit?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchRemoveRoleFromOrganizationUnit(_response);
        });
    }

    protected processBatchRemoveRoleFromOrganizationUnit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量从组织中移除用户
     * @param organizationUnitId (optional) 组织机构Id
     * @param body (optional) 用户Id列表
     * @return Success
     */
    batchRemoveUserFromOrganizationUnit(organizationUnitId: number | undefined, body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/BatchRemoveUserFromOrganizationUnit?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchRemoveUserFromOrganizationUnit(_response);
        });
    }

    protected processBatchRemoveUserFromOrganizationUnit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<OrganizationUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrganizationUnitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitListDto.fromJS(resultData200);
            return Promise.resolve<OrganizationUnitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindUsersInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindRoles(_response);
        });
    }

    protected processFindRoles(response: AxiosResponse): Promise<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNameValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindUsers(_response);
        });
    }

    protected processFindUsers(response: AxiosResponse): Promise<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfNameValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param isVirtual (optional) 
     * @param type (optional) 
     * @return Success
     */
    getAllOrganizationUnitList(companyId: number | null | undefined, isVirtual: boolean | undefined, type: number | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfOrganizationUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAllOrganizationUnitList?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (isVirtual === null)
            throw new Error("The parameter 'isVirtual' cannot be null.");
        else if (isVirtual !== undefined)
            url_ += "isVirtual=" + encodeURIComponent("" + isVirtual) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOrganizationUnitList(_response);
        });
    }

    protected processGetAllOrganizationUnitList(response: AxiosResponse): Promise<ListResultDtoOfOrganizationUnitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfOrganizationUnitListDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfOrganizationUnitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfOrganizationUnitListDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param roleId (optional) 
     * @return Success
     */
    getAllOrganizationUnitListByRoles(companyId: number | null | undefined, roleId: number | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfOrganizationUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAllOrganizationUnitListByRoles?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOrganizationUnitListByRoles(_response);
        });
    }

    protected processGetAllOrganizationUnitListByRoles(response: AxiosResponse): Promise<ListResultDtoOfOrganizationUnitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfOrganizationUnitListDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfOrganizationUnitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfOrganizationUnitListDto>(null as any);
    }

    /**
     * 获取当前用户所属一级部门
     * @return Success
     */
    getMyOneDep( cancelToken?: CancelToken | undefined): Promise<OrganizationUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetMyOneDep";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyOneDep(_response);
        });
    }

    protected processGetMyOneDep(response: AxiosResponse): Promise<OrganizationUnitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitListDto.fromJS(resultData200);
            return Promise.resolve<OrganizationUnitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitListDto>(null as any);
    }

    /**
     * 获取角色列表
     * @param id (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedOrganizationUnitRoles(id: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetPagedOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedOrganizationUnitRoles(_response);
        });
    }

    protected processGetPagedOrganizationUnitRoles(response: AxiosResponse): Promise<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOrganizationUnitRoleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOrganizationUnitRoleListDto>(null as any);
    }

    /**
     * @param depantmentId (optional) 部门
     * @param companyId (optional) 公司Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedOrganizationUnitUsers(depantmentId: number | null | undefined, companyId: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetPagedOrganizationUnitUsers?";
        if (depantmentId !== undefined && depantmentId !== null)
            url_ += "depantmentId=" + encodeURIComponent("" + depantmentId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedOrganizationUnitUsers(_response);
        });
    }

    protected processGetPagedOrganizationUnitUsers(response: AxiosResponse): Promise<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOrganizationUnitUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOrganizationUnitUserListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isInOrganizationUnit(body: UserToOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/IsInOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsInOrganizationUnit(_response);
        });
    }

    protected processIsInOrganizationUnit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    move(body: MoveOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<OrganizationUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<OrganizationUnitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitListDto.fromJS(resultData200);
            return Promise.resolve<OrganizationUnitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitListDto>(null as any);
    }

    /**
     * 删除 角色 组织关联
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeRole(roleId: number | undefined, organizationUnitId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRole?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRole(_response);
        });
    }

    protected processRemoveRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUser(userId: number | undefined, organizationUnitId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUser(_response);
        });
    }

    protected processRemoveUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 判断角色是否在当前组织
     * @param body (optional) 
     * @return Success
     */
    rolesIsInOrganizationUnit(body: RoleToOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RolesIsInOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesIsInOrganizationUnit(_response);
        });
    }

    protected processRolesIsInOrganizationUnit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOrganizationUnitInput | undefined, cancelToken?: CancelToken | undefined): Promise<OrganizationUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrganizationUnitListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitListDto.fromJS(resultData200);
            return Promise.resolve<OrganizationUnitListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitListDto>(null as any);
    }
}

export class OrgPostServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除OrgPost的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改岗位的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateOrgPostInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除岗位信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取OrgPostListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<OrgPostListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrgPostListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrgPostListDto.fromJS(resultData200);
            return Promise.resolve<OrgPostListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgPostListDto>(null as any);
    }

    /**
     * 岗位员工
     * @param companyId (optional) 
     * @param postId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEmpPageByPost(companyId: number | null | undefined, postId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetEmpPageByPost?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (postId !== undefined && postId !== null)
            url_ += "postId=" + encodeURIComponent("" + postId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmpPageByPost(_response);
        });
    }

    protected processGetEmpPageByPost(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * 获取编辑 岗位
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetOrgPostForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetOrgPostForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrgPostForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetOrgPostForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrgPostForEditOutput>(null as any);
    }

    /**
     * 根据公司Id获取岗位列表
     * @param companyId (optional) 
     * @return Success
     */
    getListByCompanyId(companyId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<OrgPostListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetListByCompanyId?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByCompanyId(_response);
        });
    }

    protected processGetListByCompanyId(response: AxiosResponse): Promise<OrgPostListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrgPostListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgPostListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgPostListDto[]>(null as any);
    }

    /**
     * 获取岗位的分页列表信息
     * @param companyId (optional) 公司主键
     * @param departmentId (optional) 部门主键
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(companyId: number | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOrgPostListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetPaged?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfOrgPostListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOrgPostListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOrgPostListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOrgPostListDto>(null as any);
    }

    /**
     * @param companyId (optional) 公司主键
     * @param departmentId (optional) 部门主键
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedDepPosts(companyId: number | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOrgPostListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetPagedDepPosts?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedDepPosts(_response);
        });
    }

    protected processGetPagedDepPosts(response: AxiosResponse): Promise<PagedResultDtoOfOrgPostListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOrgPostListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOrgPostListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOrgPostListDto>(null as any);
    }

    /**
     * 导出岗位为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPost/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class OrgPostGradeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除OrgPostGrade的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateOrgPostGradeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取OrgPostGradeListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<OrgPostGradeListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrgPostGradeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrgPostGradeListDto.fromJS(resultData200);
            return Promise.resolve<OrgPostGradeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgPostGradeListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetOrgPostGradeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetOrgPostGradeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrgPostGradeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetOrgPostGradeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrgPostGradeForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOrgPostGradeListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfOrgPostGradeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOrgPostGradeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOrgPostGradeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOrgPostGradeListDto>(null as any);
    }

    /**
     * 获取岗位等级列表
     * @param postId (optional) 
     * @return Success
     */
    getPostGradeListByPostId(postId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<OrgPostGradeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/GetPostGradeListByPostId?";
        if (postId !== undefined && postId !== null)
            url_ += "postId=" + encodeURIComponent("" + postId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPostGradeListByPostId(_response);
        });
    }

    protected processGetPostGradeListByPostId(response: AxiosResponse): Promise<OrgPostGradeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrgPostGradeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgPostGradeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgPostGradeListDto[]>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgPostGrade/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class OrgWebApiServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 验证安全策略
     * @return Success
     */
    checkSecuritySettings( cancelToken?: CancelToken | undefined): Promise<CheckSecuritySettingDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/CheckSecuritySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSecuritySettings(_response);
        });
    }

    protected processCheckSecuritySettings(response: AxiosResponse): Promise<CheckSecuritySettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckSecuritySettingDto.fromJS(resultData200);
            return Promise.resolve<CheckSecuritySettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckSecuritySettingDto>(null as any);
    }

    /**
     * 获取所有字典(key:value)
     * @param tenantId (optional) 
     * @return Success
     */
    geAlltDicList(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: { [key: string]: DicItemDto; }; }> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GeAlltDicList?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeAlltDicList(_response);
        });
    }

    protected processGeAlltDicList(response: AxiosResponse): Promise<{ [key: string]: { [key: string]: DicItemDto; }; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: { [key: string]: DicItemDto; }; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: { [key: string]: DicItemDto; }; }>(null as any);
    }

    /**
     * 获取所有公司
     * @param tenantId (optional) 
     * @return Success
     */
    getAllCompanyList(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: GetCompanyListDto; }> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllCompanyList?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCompanyList(_response);
        });
    }

    protected processGetAllCompanyList(response: AxiosResponse): Promise<{ [key: string]: GetCompanyListDto; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] ? GetCompanyListDto.fromJS(resultData200[key]) : new GetCompanyListDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: GetCompanyListDto; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: GetCompanyListDto; }>(null as any);
    }

    /**
     * 获取所有部门(老接口)
     * @param tenantId (optional) 
     * @return Success
     */
    getAllDepartmentList(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: GetDepartmentListDto; }> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllDepartmentList?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDepartmentList(_response);
        });
    }

    protected processGetAllDepartmentList(response: AxiosResponse): Promise<{ [key: string]: GetDepartmentListDto; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] ? GetDepartmentListDto.fromJS(resultData200[key]) : new GetDepartmentListDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: GetDepartmentListDto; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: GetDepartmentListDto; }>(null as any);
    }

    /**
     * 获取所有部门(新接口)
     * @param tenantId (optional) 
     * @return Success
     */
    getAllDepartmentListToNew(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<DicDtoOfGetDepartmentListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllDepartmentListToNew?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDepartmentListToNew(_response);
        });
    }

    protected processGetAllDepartmentListToNew(response: AxiosResponse): Promise<DicDtoOfGetDepartmentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DicDtoOfGetDepartmentListDto.fromJS(resultData200);
            return Promise.resolve<DicDtoOfGetDepartmentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DicDtoOfGetDepartmentListDto>(null as any);
    }

    /**
     * 获取所有员工接口(老接口)
     * @param tenantId (optional) 
     * @return Success
     */
    getAllEmpList(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: GetUserListDto; }> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllEmpList?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEmpList(_response);
        });
    }

    protected processGetAllEmpList(response: AxiosResponse): Promise<{ [key: string]: GetUserListDto; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] ? GetUserListDto.fromJS(resultData200[key]) : new GetUserListDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: GetUserListDto; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: GetUserListDto; }>(null as any);
    }

    /**
     * 获取所有员工接口(APP组织架构)(新接口)
     * @param tenantId (optional) 
     * @return Success
     */
    getAllEmpListToNew(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<DicDtoOfGetUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllEmpListToNew?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEmpListToNew(_response);
        });
    }

    protected processGetAllEmpListToNew(response: AxiosResponse): Promise<DicDtoOfGetUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DicDtoOfGetUserListDto.fromJS(resultData200);
            return Promise.resolve<DicDtoOfGetUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DicDtoOfGetUserListDto>(null as any);
    }

    /**
     * 获取所有岗位集合
     * @param tenantId (optional) 
     * @return Success
     */
    getAllPostList(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: GetPostListDto; }> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllPostList?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPostList(_response);
        });
    }

    protected processGetAllPostList(response: AxiosResponse): Promise<{ [key: string]: GetPostListDto; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] ? GetPostListDto.fromJS(resultData200[key]) : new GetPostListDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: GetPostListDto; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: GetPostListDto; }>(null as any);
    }

    /**
     * 获取所有用户
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUserList(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: GetUserListDto; }> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetAllUserList?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserList(_response);
        });
    }

    protected processGetAllUserList(response: AxiosResponse): Promise<{ [key: string]: GetUserListDto; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] ? GetUserListDto.fromJS(resultData200[key]) : new GetUserListDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: GetUserListDto; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: GetUserListDto; }>(null as any);
    }

    /**
     * 获取当前公司图片
     * @param tenantId (optional) 
     * @return Success
     */
    getCompanyImagesListByTenantId(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<CompanyImagesEditDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetCompanyImagesListByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyImagesListByTenantId(_response);
        });
    }

    protected processGetCompanyImagesListByTenantId(response: AxiosResponse): Promise<CompanyImagesEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyImagesEditDto.fromJS(resultData200);
            return Promise.resolve<CompanyImagesEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyImagesEditDto>(null as any);
    }

    /**
     * 根据字典代码获取字典明细
     * @param dataItemCode (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getListByDataItmeCodeAndTenantId(dataItemCode: string | null | undefined, tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<DataItemDetailListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetListByDataItmeCodeAndTenantId?";
        if (dataItemCode !== undefined && dataItemCode !== null)
            url_ += "dataItemCode=" + encodeURIComponent("" + dataItemCode) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByDataItmeCodeAndTenantId(_response);
        });
    }

    protected processGetListByDataItmeCodeAndTenantId(response: AxiosResponse): Promise<DataItemDetailListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DataItemDetailListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataItemDetailListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataItemDetailListDto[]>(null as any);
    }

    /**
     * 获取所有组织架构数据
     * @param state (optional) 状态1:User,2:Emp
     * @return Success
     */
    getOrganizationalAll(state: number | undefined, cancelToken?: CancelToken | undefined): Promise<OrgAllDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrgWebApi/GetOrganizationalAll?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationalAll(_response);
        });
    }

    protected processGetOrganizationalAll(response: AxiosResponse): Promise<OrgAllDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrgAllDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgAllDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgAllDto[]>(null as any);
    }
}

export class OverTimeRecordServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除OverTimeRecord的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateOverTimeRecordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取OverTimeRecordListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<OverTimeRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OverTimeRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OverTimeRecordListDto.fromJS(resultData200);
            return Promise.resolve<OverTimeRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OverTimeRecordListDto>(null as any);
    }

    /**
     * 获取加班超额人员
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getExcessdMaxOverTimeNumber(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<ExceedMaxOverTimeNumberListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetExcessdMaxOverTimeNumber?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExcessdMaxOverTimeNumber(_response);
        });
    }

    protected processGetExcessdMaxOverTimeNumber(response: AxiosResponse): Promise<ExceedMaxOverTimeNumberListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExceedMaxOverTimeNumberListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExceedMaxOverTimeNumberListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExceedMaxOverTimeNumberListDto[]>(null as any);
    }

    /**
     * 获取加班超额人员(分页)
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getExcessdMaxOverTimeNumberList(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfExceedMaxOverTimeNumberListDto> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetExcessdMaxOverTimeNumberList?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExcessdMaxOverTimeNumberList(_response);
        });
    }

    protected processGetExcessdMaxOverTimeNumberList(response: AxiosResponse): Promise<PagedResultDtoOfExceedMaxOverTimeNumberListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfExceedMaxOverTimeNumberListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfExceedMaxOverTimeNumberListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfExceedMaxOverTimeNumberListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetOverTimeRecordForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetOverTimeRecordForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOverTimeRecordForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetOverTimeRecordForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOverTimeRecordForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param userId (optional) 
     * @param companyId (optional) 公司
     * @param deparmentIds (optional) 部门
     * @param overTimeTypeCode (optional) 加班类型
     * @param declareWayCode (optional) 申报方式
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(userId: number | null | undefined, companyId: string | null | undefined, deparmentIds: string | null | undefined, overTimeTypeCode: string | null | undefined, declareWayCode: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfOverTimeRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetPaged?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentIds !== undefined && deparmentIds !== null)
            url_ += "deparmentIds=" + encodeURIComponent("" + deparmentIds) + "&";
        if (overTimeTypeCode !== undefined && overTimeTypeCode !== null)
            url_ += "overTimeTypeCode=" + encodeURIComponent("" + overTimeTypeCode) + "&";
        if (declareWayCode !== undefined && declareWayCode !== null)
            url_ += "declareWayCode=" + encodeURIComponent("" + declareWayCode) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfOverTimeRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfOverTimeRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfOverTimeRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfOverTimeRecordListDto>(null as any);
    }

    /**
     * 获取班次集合
     * @return Success
     */
    getShiftInfoList( cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetShiftInfoList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftInfoList(_response);
        });
    }

    protected processGetShiftInfoList(response: AxiosResponse): Promise<ShiftInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShiftInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto[]>(null as any);
    }

    /**
     * 导出为excel文件
     * @param userId (optional) 
     * @param companyId (optional) 公司
     * @param deparmentIds (optional) 部门
     * @param overTimeTypeCode (optional) 加班类型
     * @param declareWayCode (optional) 申报方式
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(userId: number | null | undefined, companyId: string | null | undefined, deparmentIds: string | null | undefined, overTimeTypeCode: string | null | undefined, declareWayCode: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OverTimeRecord/GetToExcelFile?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentIds !== undefined && deparmentIds !== null)
            url_ += "deparmentIds=" + encodeURIComponent("" + deparmentIds) + "&";
        if (overTimeTypeCode !== undefined && overTimeTypeCode !== null)
            url_ += "overTimeTypeCode=" + encodeURIComponent("" + overTimeTypeCode) + "&";
        if (declareWayCode !== undefined && declareWayCode !== null)
            url_ += "declareWayCode=" + encodeURIComponent("" + declareWayCode) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class PermissionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getAllPermissions( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfFlatPermissionWithLevelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfFlatPermissionWithLevelDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissionsTree( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfTreePermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissionsTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissionsTree(_response);
        });
    }

    protected processGetAllPermissionsTree(response: AxiosResponse): Promise<ListResultDtoOfTreePermissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfTreePermissionDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfTreePermissionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfTreePermissionDto>(null as any);
    }
}

export class PersonnelContractsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除PersonnelContracts的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改合同信息的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdatePersonnelContractsInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除合同信息信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取PersonnelContractsListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<PersonnelContractsListDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<PersonnelContractsListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PersonnelContractsListDto.fromJS(resultData200);
            return Promise.resolve<PersonnelContractsListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelContractsListDto>(null as any);
    }

    /**
     * 获取编辑 合同信息
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetPersonnelContractsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetPersonnelContractsForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPersonnelContractsForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetPersonnelContractsForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPersonnelContractsForEditOutput>(null as any);
    }

    /**
     * 根据用户Id获取合同列表
     * @param userId (optional) 
     * @return Success
     */
    getListByUserId(userId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<PersonnelContractsListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/GetListByUserId?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByUserId(_response);
        });
    }

    protected processGetListByUserId(response: AxiosResponse): Promise<PersonnelContractsListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonnelContractsListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PersonnelContractsListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PersonnelContractsListDto[]>(null as any);
    }

    /**
     * 获取合同信息的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfPersonnelContractsListDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfPersonnelContractsListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfPersonnelContractsListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfPersonnelContractsListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfPersonnelContractsListDto>(null as any);
    }

    /**
     * 导出合同信息为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonnelContracts/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class PointCheckServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取分页数据
     * @param auditPointId (optional) 审核点
     * @param userId (optional) 打卡人
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(auditPointId: number | null | undefined, userId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfPointCheckListDto> {
        let url_ = this.baseUrl + "/api/services/app/PointCheck/GetPaged?";
        if (auditPointId !== undefined && auditPointId !== null)
            url_ += "auditPointId=" + encodeURIComponent("" + auditPointId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfPointCheckListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfPointCheckListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfPointCheckListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfPointCheckListDto>(null as any);
    }

    /**
     * 月视图详情接口
     * @param body (optional) 
     * @return Success
     */
    monthViewDetails(body: GetMonthViewDetailsInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfPointCheckListDto> {
        let url_ = this.baseUrl + "/api/services/app/PointCheck/MonthViewDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMonthViewDetails(_response);
        });
    }

    protected processMonthViewDetails(response: AxiosResponse): Promise<PagedResultDtoOfPointCheckListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfPointCheckListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfPointCheckListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfPointCheckListDto>(null as any);
    }

    /**
     * 月视图接口
     * @param body (optional) 
     * @return Success
     */
    pointCheckMonthView(body: GetPointCheckMonthViewInput | undefined, cancelToken?: CancelToken | undefined): Promise<ParPointCheckMonthViewListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PointCheck/PointCheckMonthView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPointCheckMonthView(_response);
        });
    }

    protected processPointCheckMonthView(response: AxiosResponse): Promise<ParPointCheckMonthViewListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ParPointCheckMonthViewListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ParPointCheckMonthViewListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ParPointCheckMonthViewListDto[]>(null as any);
    }
}

export class PortalBlogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    autoMaticallyPublishMarkdownPosts(body: GitlabPostsNavInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PortalBlog/AutoMaticallyPublishMarkdownPosts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutoMaticallyPublishMarkdownPosts(_response);
        });
    }

    protected processAutoMaticallyPublishMarkdownPosts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param dt (optional) 
     * @return Success
     */
    convertDatetimeToTimeAgo(dt: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/PortalBlog/ConvertDatetimeToTimeAgo?";
        if (dt === null)
            throw new Error("The parameter 'dt' cannot be null.");
        else if (dt !== undefined)
            url_ += "dt=" + encodeURIComponent(dt ? "" + dt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConvertDatetimeToTimeAgo(_response);
        });
    }

    protected processConvertDatetimeToTimeAgo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param content (optional) 
     * @return Success
     */
    getShortContentByHtml(content: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/PortalBlog/GetShortContentByHtml?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortContentByHtml(_response);
        });
    }

    protected processGetShortContentByHtml(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param content (optional) 
     * @return Success
     */
    getShortContentByMarkDown(content: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/PortalBlog/GetShortContentByMarkDown?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortContentByMarkDown(_response);
        });
    }

    protected processGetShortContentByMarkDown(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param content (optional) 
     * @return Success
     */
    renderMarkdownToHtml(content: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<IHtmlContent> {
        let url_ = this.baseUrl + "/api/services/app/PortalBlog/RenderMarkdownToHtml?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderMarkdownToHtml(_response);
        });
    }

    protected processRenderMarkdownToHtml(response: AxiosResponse): Promise<IHtmlContent> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IHtmlContent.fromJS(resultData200);
            return Promise.resolve<IHtmlContent>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IHtmlContent>(null as any);
    }

    /**
     * @param content (optional) 
     * @return Success
     */
    renderMarkdownToString(content: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/PortalBlog/RenderMarkdownToString?";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderMarkdownToString(_response);
        });
    }

    protected processRenderMarkdownToString(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PortalMarketServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getPublishedCourseListforHome( cancelToken?: CancelToken | undefined): Promise<CourseListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PortalMarket/GetPublishedCourseListforHome";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublishedCourseListforHome(_response);
        });
    }

    protected processGetPublishedCourseListforHome(response: AxiosResponse): Promise<CourseListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CourseListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CourseListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseListDto[]>(null as any);
    }

    /**
     * 服务于发布后的产品列表，服务门户
     * @return Success
     */
    getPublishedProductforHomePrice( cancelToken?: CancelToken | undefined): Promise<ProductListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PortalMarket/GetPublishedProductforHomePrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublishedProductforHomePrice(_response);
        });
    }

    protected processGetPublishedProductforHomePrice(response: AxiosResponse): Promise<ProductListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductListDto[]>(null as any);
    }
}

export class PostServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Post的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Post/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改文章的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdatePostInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Post/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPostByMakrdown(body: CreatePostDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Post/CreatePostByMakrdown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePostByMakrdown(_response);
        });
    }

    protected processCreatePostByMakrdown(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除文章信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Post/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取PostListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<PostListDto> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<PostListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostListDto.fromJS(resultData200);
            return Promise.resolve<PostListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostListDto>(null as any);
    }

    /**
     * 获取编辑 文章
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetPostForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetPostForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPostForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetPostForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPostForEditOutput>(null as any);
    }

    /**
     * 获取阅读文章的地址
     * @param url (optional) 
     * @param blogId (optional) 
     * @return Success
     */
    getForReading(url: string | null | undefined, blogId: string | undefined, cancelToken?: CancelToken | undefined): Promise<PostDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetForReading?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (blogId === null)
            throw new Error("The parameter 'blogId' cannot be null.");
        else if (blogId !== undefined)
            url_ += "blogId=" + encodeURIComponent("" + blogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForReading(_response);
        });
    }

    protected processGetForReading(response: AxiosResponse): Promise<PostDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostDetailsDto.fromJS(resultData200);
            return Promise.resolve<PostDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDetailsDto>(null as any);
    }

    /**
     * 根据博客id或者标签查询文章列表
     * @param blogId (optional) 
     * @param tagName (optional) 
     * @return Success
     */
    getListByBlogIdAndTagName(blogId: string | undefined, tagName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfPostDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetListByBlogIdAndTagName?";
        if (blogId === null)
            throw new Error("The parameter 'blogId' cannot be null.");
        else if (blogId !== undefined)
            url_ += "blogId=" + encodeURIComponent("" + blogId) + "&";
        if (tagName !== undefined && tagName !== null)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByBlogIdAndTagName(_response);
        });
    }

    protected processGetListByBlogIdAndTagName(response: AxiosResponse): Promise<ListResultDtoOfPostDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfPostDetailsDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfPostDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfPostDetailsDto>(null as any);
    }

    /**
     * 根据博客id获取阅读量最多的10条文章
     * @param blogId (optional) 
     * @return Success
     */
    getMostViewsListByBlogId(blogId: string | undefined, cancelToken?: CancelToken | undefined): Promise<PostDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetMostViewsListByBlogId?";
        if (blogId === null)
            throw new Error("The parameter 'blogId' cannot be null.");
        else if (blogId !== undefined)
            url_ += "blogId=" + encodeURIComponent("" + blogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMostViewsListByBlogId(_response);
        });
    }

    protected processGetMostViewsListByBlogId(response: AxiosResponse): Promise<PostDetailsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PostDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PostDetailsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostDetailsDto[]>(null as any);
    }

    /**
     * 获取文章的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfPostListDto> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfPostListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfPostListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfPostListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfPostListDto>(null as any);
    }

    /**
     * 获取文章列表
     * @return Success
     */
    getPosts( cancelToken?: CancelToken | undefined): Promise<PostListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetPosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPosts(_response);
        });
    }

    protected processGetPosts(response: AxiosResponse): Promise<PostListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PostListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PostListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostListDto[]>(null as any);
    }

    /**
     * 获取为文章下的标签列表
     * @param id (optional) 
     * @return Success
     */
    getTagsOfPostId(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<TagListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetTagsOfPostId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTagsOfPostId(_response);
        });
    }

    protected processGetTagsOfPostId(response: AxiosResponse): Promise<TagListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TagListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagListDto[]>(null as any);
    }

    /**
     * 导出文章为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Post/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class ProductServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Product的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 买产品送课程
     * @param body (optional) 
     * @return Success
     */
    buyProductAndSendCourses(body: PurchasePayInput | undefined, cancelToken?: CancelToken | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/api/services/app/Product/BuyProductAndSendCourses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuyProductAndSendCourses(_response);
        });
    }

    protected processBuyProductAndSendCourses(response: AxiosResponse): Promise<Order> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Order.fromJS(resultData200);
            return Promise.resolve<Order>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * 添加或者修改Product的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateProductInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建产品框架订单
     * @param body (optional) 
     * @return Success
     */
    createProductOrder(body: PurchasePayInput | undefined, cancelToken?: CancelToken | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProductOrder(_response);
        });
    }

    protected processCreateProductOrder(response: AxiosResponse): Promise<Order> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Order.fromJS(resultData200);
            return Promise.resolve<Order>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * 删除Product信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取ProductListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<ProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ProductListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductListDto.fromJS(resultData200);
            return Promise.resolve<ProductListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductListDto>(null as any);
    }

    /**
     * 获取编辑 Product
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetProductForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProductForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetProductForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductForEditOutput>(null as any);
    }

    /**
     * 获取Product的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfProductListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfProductListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfProductListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfProductListDto>(null as any);
    }

    /**
     * @return Success
     */
    getProducts( cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<KeyValuePairOfStringString[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringString[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringString[]>(null as any);
    }

    /**
     * @return Success
     */
    getTypes( cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTypes(_response);
        });
    }

    protected processGetTypes(response: AxiosResponse): Promise<KeyValuePairOfStringString[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringString[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringString[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publishProduct(body: NullableIdDtoOfGuid | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/PublishProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublishProduct(_response);
        });
    }

    protected processPublishProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unshelveProduct(body: NullableIdDtoOfGuid | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/UnshelveProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnshelveProduct(_response);
        });
    }

    protected processUnshelveProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProductSecretKeyServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchCreate(body: BatchCreateProductSecretKeyInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductSecretKey/BatchCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchCreate(_response);
        });
    }

    protected processBatchCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除ProductSecretKey的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductSecretKey/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bindToUser(body: ProductSecretKeyBindToUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductSecretKey/BindToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBindToUser(_response);
        });
    }

    protected processBindToUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除ProductSecretKey信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductSecretKey/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取ProductSecretKeyListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<ProductSecretKeyListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductSecretKey/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ProductSecretKeyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductSecretKeyListDto.fromJS(resultData200);
            return Promise.resolve<ProductSecretKeyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSecretKeyListDto>(null as any);
    }

    /**
     * 获取ProductSecretKey的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfProductSecretKeyListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductSecretKey/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfProductSecretKeyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfProductSecretKeyListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfProductSecretKeyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfProductSecretKeyListDto>(null as any);
    }
}

export class ProfileServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLanguage(_response);
        });
    }

    protected processChangeLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改密码
     * @param body (optional) 
     * @return Success
     */
    changePasswordByTenant(body: ChangePasswordByTenantInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePasswordByTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePasswordByTenant(_response);
        });
    }

    protected processChangePasswordByTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除用户头像
     * @param profilePictureId (optional) 头像ID
     * @return Success
     */
    deleteProfilePictureById(profilePictureId: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DeleteProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProfilePictureById(_response);
        });
    }

    protected processDeleteProfilePictureById(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取当前的个人信息
     * @return Success
     */
    getCurrentUserProfileForEdit( cancelToken?: CancelToken | undefined): Promise<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserProfileForEdit(_response);
        });
    }

    protected processGetCurrentUserProfileForEdit(response: AxiosResponse): Promise<CurrentUserProfileEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return Promise.resolve<CurrentUserProfileEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserProfileEditDto>(null as any);
    }

    /**
     * @param profilePictureId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string | null | undefined, userId: number | undefined, tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined && profilePictureId !== null)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFriendProfilePictureById(_response);
        });
    }

    protected processGetFriendProfilePictureById(response: AxiosResponse): Promise<GetProfilePictureOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return Promise.resolve<GetProfilePictureOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetProfilePictureOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfilePictureById(_response);
        });
    }

    protected processGetProfilePictureById(response: AxiosResponse): Promise<GetProfilePictureOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProfilePictureOutputDto.fromJS(resultData200);
            return Promise.resolve<GetProfilePictureOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProfilePictureOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCurrentUserProfile(_response);
        });
    }

    protected processUpdateCurrentUserProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfilePicture(_response);
        });
    }

    protected processUpdateProfilePicture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProjectServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Project的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改Project的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateProjectInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除Project信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param shortName (optional) 
     * @return Success
     */
    findByShortName(shortName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/FindByShortName?";
        if (shortName !== undefined && shortName !== null)
            url_ += "shortName=" + encodeURIComponent("" + shortName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindByShortName(_response);
        });
    }

    protected processFindByShortName(response: AxiosResponse): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectDto.fromJS(resultData200);
            return Promise.resolve<ProjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    /**
     * 通过指定id获取ProjectListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<ProjectListDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ProjectListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectListDto.fromJS(resultData200);
            return Promise.resolve<ProjectListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectListDto>(null as any);
    }

    /**
     * 获取编辑 Project
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetProjectForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetProjectForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetProjectForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectForEditOutput>(null as any);
    }

    /**
     * 获取所有的项目列表
     * @return Success
     */
    getList( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ListResultDtoOfProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfProjectDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfProjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfProjectDto>(null as any);
    }

    /**
     * 获取Project的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfProjectListDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfProjectListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfProjectListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfProjectListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfProjectListDto>(null as any);
    }

    /**
     * 获取项目的版本信息，带缓存
     * @param shortName (optional) 
     * @return Success
     */
    getVersions(shortName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfVersionInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetVersions?";
        if (shortName !== undefined && shortName !== null)
            url_ += "shortName=" + encodeURIComponent("" + shortName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVersions(_response);
        });
    }

    protected processGetVersions(response: AxiosResponse): Promise<ListResultDtoOfVersionInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfVersionInfoDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfVersionInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfVersionInfoDto>(null as any);
    }
}

export class PurchaseServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPay(body: PurchasePayInput | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Purchase/CreatePay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePay(_response);
        });
    }

    protected processCreatePay(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PushApiServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param title (optional) 
     * @param description (optional) 
     * @param systemName (optional) 
     * @param regIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendAppMessageByGeTui(title: string | null | undefined, description: string | null | undefined, systemName: string | null | undefined, regIds: string | null | undefined, body: MessagePayloadOfDefaultData | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PushApi/SendAppMessageByGeTui?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (systemName !== undefined && systemName !== null)
            url_ += "systemName=" + encodeURIComponent("" + systemName) + "&";
        if (regIds !== undefined && regIds !== null)
            url_ += "regIds=" + encodeURIComponent("" + regIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAppMessageByGeTui(_response);
        });
    }

    protected processSendAppMessageByGeTui(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class QuotaUpdateRecordServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 修改额度
     * @param body (optional) 
     * @return Success
     */
    edit(body: QuotaUpdateRecordEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QuotaUpdateRecord/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有假期规则
     * @return Success
     */
    getHolidayRuleList( cancelToken?: CancelToken | undefined): Promise<HolidayRuleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QuotaUpdateRecord/GetHolidayRuleList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayRuleList(_response);
        });
    }

    protected processGetHolidayRuleList(response: AxiosResponse): Promise<HolidayRuleListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HolidayRuleListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HolidayRuleListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayRuleListDto[]>(null as any);
    }

    /**
     * 获取当前用户的额度修改记录
     * @param limitId (optional) 假期主键
     * @param userId (optional) 用户Id
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(limitId: number | undefined, userId: number | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfQuotaUpdateRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotaUpdateRecord/GetPaged?";
        if (limitId === null)
            throw new Error("The parameter 'limitId' cannot be null.");
        else if (limitId !== undefined)
            url_ += "limitId=" + encodeURIComponent("" + limitId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfQuotaUpdateRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfQuotaUpdateRecordDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfQuotaUpdateRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfQuotaUpdateRecordDto>(null as any);
    }

    /**
     * 查询用户的请假数据
     * @param userId (optional) 用户Id
     * @param holidayType (optional) 假期类型
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedByUserId(userId: number | undefined, holidayType: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfQuotaRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotaUpdateRecord/GetPagedByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (holidayType !== undefined && holidayType !== null)
            url_ += "holidayType=" + encodeURIComponent("" + holidayType) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedByUserId(_response);
        });
    }

    protected processGetPagedByUserId(response: AxiosResponse): Promise<PagedResultDtoOfQuotaRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfQuotaRecordDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfQuotaRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfQuotaRecordDto>(null as any);
    }

    /**
     * 获取用户的选项卡数据
     * @param userId (optional) 
     * @return Success
     */
    getTabsDataList(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<TabsDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QuotaUpdateRecord/GetTabsDataList?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTabsDataList(_response);
        });
    }

    protected processGetTabsDataList(response: AxiosResponse): Promise<TabsDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TabsDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TabsDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TabsDataDto[]>(null as any);
    }
}

export class QYBLanguageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrUpdateLanguage(body: QYBLanguages | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/AddOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateLanguage(_response);
        });
    }

    protected processAddOrUpdateLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguageDisplayName(body: EditLanguage | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/ChangeLanguageDisplayName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLanguageDisplayName(_response);
        });
    }

    protected processChangeLanguageDisplayName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 创建语言
     * @param body (optional) 
     * @return Success
     */
    /**
     * 刷新多语言缓存(全量重建语言缓存并清除本地化字典缓存)
     */
    refreshAllLanguageCache(cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/RefreshAllLanguageCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_: any = undefined;

        const options_ = <any>{
            method: "POST",
            url: url_,
            headers: {
            },
            data: content_,
            cancelToken: cancelToken
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return Promise.resolve<void>(<any>(_response.data));
        });
    }

    createLanguage(body: CreateLanguageReq | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/CreateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLanguage(_response);
        });
    }

    protected processCreateLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 添加业务字典会and菜单 默认创建当前语言的Key
     * @param body (optional) 
     * @return Success
     */
    createLanguageText(body: CreatOrUpdateLangualeText | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/CreateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLanguageText(_response);
        });
    }

    protected processCreateLanguageText(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置默认语言
     * @param body (optional) 
     * @return Success
     */
    defaultLanguage(body: QueryLanguageReq | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/DefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDefaultLanguage(_response);
        });
    }

    protected processDefaultLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 删除语言
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLanguage(_response);
        });
    }

    protected processDeleteLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 修改语言状态
     * @param body (optional) 
     * @return Success
     */
    enableLanguage(body: ChangeLanguageStatusReq | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/EnableLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnableLanguage(_response);
        });
    }

    protected processEnableLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 导出语言对照
     * @return Success
     */
    exportLanguage(sourceLanguageId: number, targetLanguageId: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/ExportLanguage?";
        if (sourceLanguageId === undefined || sourceLanguageId === null)
            throw new Error("The parameter 'sourceLanguageId' must be defined and cannot be null.");
        else
            url_ += "sourceLanguageId=" + encodeURIComponent("" + sourceLanguageId) + "&";
        if (targetLanguageId === undefined || targetLanguageId === null)
            throw new Error("The parameter 'targetLanguageId' must be defined and cannot be null.");
        else
            url_ += "targetLanguageId=" + encodeURIComponent("" + targetLanguageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportLanguage(_response);
        });
    }

    protected processExportLanguage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * 获取可以使用的语言（排除用户已经在系统中定义的）
     * @return Success
     */
    getAvaliableLanguages( cancelToken?: CancelToken | undefined): Promise<CultureInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/GetAvaliableLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvaliableLanguages(_response);
        });
    }

    protected processGetAvaliableLanguages(response: AxiosResponse): Promise<CultureInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CultureInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CultureInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CultureInfoDto[]>(null as any);
    }

    /**
     * 只用于查询字典多语言
     * @param itemId (optional) 
     * @param languageId (optional) 
     * @return Success
     */
    getItemDetailKeyValue(itemId: number | undefined, languageId: number | undefined, cancelToken?: CancelToken | undefined): Promise<KeyValue[]> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/GetItemDetailKeyValue?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemDetailKeyValue(_response);
        });
    }

    protected processGetItemDetailKeyValue(response: AxiosResponse): Promise<KeyValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(KeyValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValue[]>(null as any);
    }

    /**
     * 获取已经存在的全部语言
     * @return Success
     */
    getLanguages( cancelToken?: CancelToken | undefined): Promise<LanguageResp[]> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: AxiosResponse): Promise<LanguageResp[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LanguageResp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LanguageResp[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LanguageResp[]>(null as any);
    }

    /**
     * 多语言子项导入
     * @param targetLanguageId (optional) 
     * @param file (optional) Excel文件
     * @return Success
     */
    importLanguage(targetLanguageId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/ImportLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (targetLanguageId === null || targetLanguageId === undefined)
            throw new Error("The parameter 'targetLanguageId' cannot be null.");
        else
            content_.append("targetLanguageId", targetLanguageId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportLanguage(_response);
        });
    }

    protected processImportLanguage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 查询是否已经存在相同的展示名称
     * @param displayName (optional) 
     * @return Success
     */
    queryLanguageNameExist(displayName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/QueryLanguageNameExist?";
        if (displayName !== undefined && displayName !== null)
            url_ += "displayName=" + encodeURIComponent("" + displayName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryLanguageNameExist(_response);
        });
    }

    protected processQueryLanguageNameExist(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取对照的翻译文本
     * @param body (optional) 语言ID
     * @return Success
     */
    queryLanguageTranslate(body: EditTranslateLanguageReq | undefined, cancelToken?: CancelToken | undefined): Promise<TranslateTextDto> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/QueryLanguageTranslate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryLanguageTranslate(_response);
        });
    }

    protected processQueryLanguageTranslate(response: AxiosResponse): Promise<TranslateTextDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslateTextDto.fromJS(resultData200);
            return Promise.resolve<TranslateTextDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslateTextDto>(null as any);
    }

    /**
     * 保存翻译好的文本(差异更新、或修改，支持单条操作)
     * @param body (optional) 
     * @return Success
     */
    saveLanguageOneText(body: SaveLanguageTextReq | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/SaveLanguageOneText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveLanguageOneText(_response);
        });
    }

    protected processSaveLanguageOneText(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 保存翻译好的文本(替换原来存在的全部)
     * @param body (optional) 
     * @return Success
     */
    saveLanguageTexts(body: SaveLanguageTextReq | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/SaveLanguageTexts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveLanguageTexts(_response);
        });
    }

    protected processSaveLanguageTexts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param languageId (optional) 
     * @param id (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateKeyValue(languageId: number | undefined, id: number | undefined, value: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/QYBLanguage/UpdateKeyValue?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateKeyValue(_response);
        });
    }

    protected processUpdateKeyValue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取按审核项类型分组的符合率数据
     * @param auditItemTypeId (optional) 审核项类型Id（可多选）
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getAnditItemTypeGroupComplianceRate(auditItemTypeId: number[] | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAnditItemTypeGroupComplianceRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAnditItemTypeGroupComplianceRate?";
        if (auditItemTypeId !== undefined && auditItemTypeId !== null)
            auditItemTypeId && auditItemTypeId.forEach(item => { url_ += "auditItemTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnditItemTypeGroupComplianceRate(_response);
        });
    }

    protected processGetAnditItemTypeGroupComplianceRate(response: AxiosResponse): Promise<GetAnditItemTypeGroupComplianceRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAnditItemTypeGroupComplianceRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAnditItemTypeGroupComplianceRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAnditItemTypeGroupComplianceRateDto[]>(null as any);
    }

    /**
     * 获取审核员符合率数据
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getAuditInspComplianceRate(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAuditInspComplianceRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAuditInspComplianceRate?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditInspComplianceRate(_response);
        });
    }

    protected processGetAuditInspComplianceRate(response: AxiosResponse): Promise<GetAuditInspComplianceRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAuditInspComplianceRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAuditInspComplianceRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditInspComplianceRateDto[]>(null as any);
    }

    /**
     * 获取审核项问题统计
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param itemGroupId (optional) 审核项分组
     * @param itemTypeId (optional) 审核项类型
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditItemIssueStatistics(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, itemGroupId: number | null | undefined, itemTypeId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetAuditItemIssueStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAuditItemIssueStatistics?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (itemGroupId !== undefined && itemGroupId !== null)
            url_ += "itemGroupId=" + encodeURIComponent("" + itemGroupId) + "&";
        if (itemTypeId !== undefined && itemTypeId !== null)
            url_ += "itemTypeId=" + encodeURIComponent("" + itemTypeId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditItemIssueStatistics(_response);
        });
    }

    protected processGetAuditItemIssueStatistics(response: AxiosResponse): Promise<PagedResultDtoOfGetAuditItemIssueStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetAuditItemIssueStatisticsDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetAuditItemIssueStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetAuditItemIssueStatisticsDto>(null as any);
    }

    /**
     * 获取审核项问题统计Echarts
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param itemGroupId (optional) 审核项分组
     * @param itemTypeId (optional) 审核项类型
     * @param pointId (optional) 审核点
     * @return Success
     */
    getAuditItemIssueStatisticsForEcharts(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, itemGroupId: number | null | undefined, itemTypeId: number | null | undefined, pointId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAuditItemIssueStatisticsForEchartsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAuditItemIssueStatisticsForEcharts?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (itemGroupId !== undefined && itemGroupId !== null)
            url_ += "itemGroupId=" + encodeURIComponent("" + itemGroupId) + "&";
        if (itemTypeId !== undefined && itemTypeId !== null)
            url_ += "itemTypeId=" + encodeURIComponent("" + itemTypeId) + "&";
        if (pointId !== undefined && pointId !== null)
            url_ += "pointId=" + encodeURIComponent("" + pointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditItemIssueStatisticsForEcharts(_response);
        });
    }

    protected processGetAuditItemIssueStatisticsForEcharts(response: AxiosResponse): Promise<GetAuditItemIssueStatisticsForEchartsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAuditItemIssueStatisticsForEchartsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAuditItemIssueStatisticsForEchartsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditItemIssueStatisticsForEchartsDto[]>(null as any);
    }

    /**
     * 审核点记录统计
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param pointIds (optional) 审核点，可多选
     * @param auditTaskLabel (optional) 审核任务标签
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditPointRecord(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, pointIds: number[] | null | undefined, auditTaskLabel: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfAuditPointRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAuditPointRecord?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pointIds !== undefined && pointIds !== null)
            pointIds && pointIds.forEach(item => { url_ += "pointIds=" + encodeURIComponent("" + item) + "&"; });
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditPointRecord(_response);
        });
    }

    protected processGetAuditPointRecord(response: AxiosResponse): Promise<PagedResultDtoOfAuditPointRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfAuditPointRecordDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfAuditPointRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfAuditPointRecordDto>(null as any);
    }

    /**
     * 审核任务柱状图
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param orgId (optional) lap组织架构id
     * @return Success
     */
    getAuditTaskHistogram(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, orgId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<AuditTaskHistogramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAuditTaskHistogram?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskHistogram(_response);
        });
    }

    protected processGetAuditTaskHistogram(response: AxiosResponse): Promise<AuditTaskHistogramDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuditTaskHistogramDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuditTaskHistogramDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditTaskHistogramDto[]>(null as any);
    }

    /**
     * 获取层级报表
     * @param year (optional) 
     * @return Success
     */
    getAuditTaskLevelReport(year: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetAuditTaskLevelReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAuditTaskLevelReport?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditTaskLevelReport(_response);
        });
    }

    protected processGetAuditTaskLevelReport(response: AxiosResponse): Promise<GetAuditTaskLevelReportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetAuditTaskLevelReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAuditTaskLevelReportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditTaskLevelReportDto[]>(null as any);
    }

    /**
     * 获取部门审核任务完成率
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getDeptAuditTaskCompletionRate(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetDeptAuditTaskCompletionRateDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetDeptAuditTaskCompletionRate?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeptAuditTaskCompletionRate(_response);
        });
    }

    protected processGetDeptAuditTaskCompletionRate(response: AxiosResponse): Promise<GetDeptAuditTaskCompletionRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeptAuditTaskCompletionRateDto.fromJS(resultData200);
            return Promise.resolve<GetDeptAuditTaskCompletionRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeptAuditTaskCompletionRateDto>(null as any);
    }

    /**
     * 获取部门每个月的问题数量
     * @param year (optional) 
     * @return Success
     */
    getEveryMonthIssueCountForDept(year: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetEveryMonthIssueCountForDeptDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetEveryMonthIssueCountForDept?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEveryMonthIssueCountForDept(_response);
        });
    }

    protected processGetEveryMonthIssueCountForDept(response: AxiosResponse): Promise<GetEveryMonthIssueCountForDeptDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetEveryMonthIssueCountForDeptDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetEveryMonthIssueCountForDeptDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEveryMonthIssueCountForDeptDto[]>(null as any);
    }

    /**
     * 获取未完成的审核员TOP10
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getInCompleteAuditInspTopTen(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetInCompleteAuditInspTopTenDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetInCompleteAuditInspTopTen?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInCompleteAuditInspTopTen(_response);
        });
    }

    protected processGetInCompleteAuditInspTopTen(response: AxiosResponse): Promise<GetInCompleteAuditInspTopTenDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetInCompleteAuditInspTopTenDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetInCompleteAuditInspTopTenDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInCompleteAuditInspTopTenDto[]>(null as any);
    }

    /**
     * 获取责任部门问题关闭率数据
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getInspDeptIssueCloseRate(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetInspDeptIssueCloseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetInspDeptIssueCloseRate?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInspDeptIssueCloseRate(_response);
        });
    }

    protected processGetInspDeptIssueCloseRate(response: AxiosResponse): Promise<GetInspDeptIssueCloseRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInspDeptIssueCloseRateDto.fromJS(resultData200);
            return Promise.resolve<GetInspDeptIssueCloseRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInspDeptIssueCloseRateDto>(null as any);
    }

    /**
     * 获取责任部门问题关闭率数据
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getIssueThirtyDayNoCloseForDept(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueThirtyDayNoCloseForDeptDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetIssueThirtyDayNoCloseForDept?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueThirtyDayNoCloseForDept(_response);
        });
    }

    protected processGetIssueThirtyDayNoCloseForDept(response: AxiosResponse): Promise<GetIssueThirtyDayNoCloseForDeptDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueThirtyDayNoCloseForDeptDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueThirtyDayNoCloseForDeptDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueThirtyDayNoCloseForDeptDto[]>(null as any);
    }

    /**
     * 获取未完成的审核员TOP10
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getIssueThirtyDayNoCloseForInsp(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueThirtyDayNoCloseForInspDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetIssueThirtyDayNoCloseForInsp?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueThirtyDayNoCloseForInsp(_response);
        });
    }

    protected processGetIssueThirtyDayNoCloseForInsp(response: AxiosResponse): Promise<GetIssueThirtyDayNoCloseForInspDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueThirtyDayNoCloseForInspDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueThirtyDayNoCloseForInspDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueThirtyDayNoCloseForInspDto[]>(null as any);
    }

    /**
     * 获取问题30天未关闭的列表
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getIssueThirtyDayNoCloseForList(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetIssueThirtyDayNoCloseForList?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueThirtyDayNoCloseForList(_response);
        });
    }

    protected processGetIssueThirtyDayNoCloseForList(response: AxiosResponse): Promise<PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto>(null as any);
    }

    /**
     * 获取按问题分类分组的关闭率数据
     * @param issueTypeId (optional) 审核项类型Id（可多选）
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getIssueTypeGroupCloseRate(issueTypeId: number[] | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetIssueTypeGroupCloseRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetIssueTypeGroupCloseRate?";
        if (issueTypeId !== undefined && issueTypeId !== null)
            issueTypeId && issueTypeId.forEach(item => { url_ += "issueTypeId=" + encodeURIComponent("" + item) + "&"; });
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIssueTypeGroupCloseRate(_response);
        });
    }

    protected processGetIssueTypeGroupCloseRate(response: AxiosResponse): Promise<GetIssueTypeGroupCloseRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetIssueTypeGroupCloseRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetIssueTypeGroupCloseRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIssueTypeGroupCloseRateDto[]>(null as any);
    }

    /**
     * 获取全部问题关闭率
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param orgId (optional) 组织架构ID
     * @return Success
     */
    getMonthClosePercent(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, orgId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetMonthClosePercentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetMonthClosePercent?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonthClosePercent(_response);
        });
    }

    protected processGetMonthClosePercent(response: AxiosResponse): Promise<GetMonthClosePercentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetMonthClosePercentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetMonthClosePercentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMonthClosePercentDto[]>(null as any);
    }

    /**
     * 获取总体符合率数据
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getOverAllComplianceRate(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetOverAllComplianceRateDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetOverAllComplianceRate?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOverAllComplianceRate(_response);
        });
    }

    protected processGetOverAllComplianceRate(response: AxiosResponse): Promise<GetOverAllComplianceRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOverAllComplianceRateDto.fromJS(resultData200);
            return Promise.resolve<GetOverAllComplianceRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOverAllComplianceRateDto>(null as any);
    }

    /**
     * 人员问题统计
     * @param starttime (optional) 
     * @param endtime (optional) 
     * @param progressList (optional) 
     * @param orgid (optional) 
     * @param layoutlevel (optional) 
     * @return Success
     */
    getRespIssueStatistics(starttime: moment.Moment | null | undefined, endtime: moment.Moment | null | undefined, progressList: number[] | null | undefined, orgid: number | null | undefined, layoutlevel: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetRespIssueStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetRespIssueStatistics?";
        if (starttime !== undefined && starttime !== null)
            url_ += "starttime=" + encodeURIComponent(starttime ? "" + starttime.toISOString() : "") + "&";
        if (endtime !== undefined && endtime !== null)
            url_ += "endtime=" + encodeURIComponent(endtime ? "" + endtime.toISOString() : "") + "&";
        if (progressList !== undefined && progressList !== null)
            progressList && progressList.forEach(item => { url_ += "progressList=" + encodeURIComponent("" + item) + "&"; });
        if (orgid !== undefined && orgid !== null)
            url_ += "orgid=" + encodeURIComponent("" + orgid) + "&";
        if (layoutlevel !== undefined && layoutlevel !== null)
            url_ += "layoutlevel=" + encodeURIComponent("" + layoutlevel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRespIssueStatistics(_response);
        });
    }

    protected processGetRespIssueStatistics(response: AxiosResponse): Promise<GetRespIssueStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRespIssueStatisticsDto.fromJS(resultData200);
            return Promise.resolve<GetRespIssueStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRespIssueStatisticsDto>(null as any);
    }

    /**
     * 获取六个月内重复问题
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getSixMonthRepeatIssue(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSixMonthRepeatIssueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetSixMonthRepeatIssue?";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSixMonthRepeatIssue(_response);
        });
    }

    protected processGetSixMonthRepeatIssue(response: AxiosResponse): Promise<GetSixMonthRepeatIssueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetSixMonthRepeatIssueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSixMonthRepeatIssueDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSixMonthRepeatIssueDto[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @param groupchildrenList (optional) 
     * @return Success
     */
    getTreeChildren(query: AuditItemGroupListDto[] | null | undefined, groupchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (groupchildrenList !== undefined && groupchildrenList !== null)
            groupchildrenList && groupchildrenList.forEach(item => { url_ += "groupchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildren(_response);
        });
    }

    protected processGetTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param query (optional) 
     * @param orgchildrenList (optional) 
     * @return Success
     */
    getTreeChildrenByGetUserAuditRecord(query: LayoutOrgListDto[] | null | undefined, orgchildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTreeChildrenByGetUserAuditRecord?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (orgchildrenList !== undefined && orgchildrenList !== null)
            orgchildrenList && orgchildrenList.forEach(item => { url_ += "orgchildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTreeChildrenByGetUserAuditRecord(_response);
        });
    }

    protected processGetTreeChildrenByGetUserAuditRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取24小时内问题关闭率
     * @param isHighRisk (optional) 是否高风险
     * @param type (optional) 类型 1.24小时内 2.24小时外 3.大于30天
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @return Success
     */
    getTwentyFourInnerIssueCloseRate(isHighRisk: boolean | undefined, type: number | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetTwentyFourInnerIssueCloseRateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTwentyFourInnerIssueCloseRate?";
        if (isHighRisk === null)
            throw new Error("The parameter 'isHighRisk' cannot be null.");
        else if (isHighRisk !== undefined)
            url_ += "isHighRisk=" + encodeURIComponent("" + isHighRisk) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTwentyFourInnerIssueCloseRate(_response);
        });
    }

    protected processGetTwentyFourInnerIssueCloseRate(response: AxiosResponse): Promise<GetTwentyFourInnerIssueCloseRateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetTwentyFourInnerIssueCloseRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetTwentyFourInnerIssueCloseRateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTwentyFourInnerIssueCloseRateDto[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @param typechildrenList (optional) 
     * @return Success
     */
    getTypeTreeChildren(query: AuditItemTypeListDto[] | null | undefined, typechildrenList: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTypeTreeChildren?";
        if (query !== undefined && query !== null)
            query && query.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "query[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (typechildrenList !== undefined && typechildrenList !== null)
            typechildrenList && typechildrenList.forEach(item => { url_ += "typechildrenList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTypeTreeChildren(_response);
        });
    }

    protected processGetTypeTreeChildren(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 人员审核记录统计
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param pointIds (optional) 审核点，可多选
     * @param auditTaskLabel (optional) 审核任务标签
     * @param orgId (optional) lap组织架构id
     * @param startNum (optional) 开始数字
     * @param endNum (optional) 结束数字
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserAuditRecord(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, pointIds: number[] | null | undefined, auditTaskLabel: string | null | undefined, orgId: number | null | undefined, startNum: number | undefined, endNum: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserAuditRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetUserAuditRecord?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pointIds !== undefined && pointIds !== null)
            pointIds && pointIds.forEach(item => { url_ += "pointIds=" + encodeURIComponent("" + item) + "&"; });
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (startNum === null)
            throw new Error("The parameter 'startNum' cannot be null.");
        else if (startNum !== undefined)
            url_ += "startNum=" + encodeURIComponent("" + startNum) + "&";
        if (endNum === null)
            throw new Error("The parameter 'endNum' cannot be null.");
        else if (endNum !== undefined)
            url_ += "endNum=" + encodeURIComponent("" + endNum) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAuditRecord(_response);
        });
    }

    protected processGetUserAuditRecord(response: AxiosResponse): Promise<PagedResultDtoOfUserAuditRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserAuditRecordDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserAuditRecordDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserAuditRecordDto>(null as any);
    }

    /**
     * 人员审核记录统计导出
     * @param startDate (optional) 开始时间
     * @param endDate (optional) 结束时间
     * @param pointIds (optional) 审核点，可多选
     * @param auditTaskLabel (optional) 审核任务标签
     * @param orgId (optional) lap组织架构id
     * @param startNum (optional) 开始数字
     * @param endNum (optional) 结束数字
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserAuditRecordToExcel(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, pointIds: number[] | null | undefined, auditTaskLabel: string | null | undefined, orgId: number | null | undefined, startNum: number | undefined, endNum: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetUserAuditRecordToExcel?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pointIds !== undefined && pointIds !== null)
            pointIds && pointIds.forEach(item => { url_ += "pointIds=" + encodeURIComponent("" + item) + "&"; });
        if (auditTaskLabel !== undefined && auditTaskLabel !== null)
            url_ += "auditTaskLabel=" + encodeURIComponent("" + auditTaskLabel) + "&";
        if (orgId !== undefined && orgId !== null)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (startNum === null)
            throw new Error("The parameter 'startNum' cannot be null.");
        else if (startNum !== undefined)
            url_ += "startNum=" + encodeURIComponent("" + startNum) + "&";
        if (endNum === null)
            throw new Error("The parameter 'endNum' cannot be null.");
        else if (endNum !== undefined)
            url_ += "endNum=" + encodeURIComponent("" + endNum) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAuditRecordToExcel(_response);
        });
    }

    protected processGetUserAuditRecordToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class RoleServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加用户
     * @param body (optional) 
     * @return Success
     */
    batchAddUser(body: UserRoleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/BatchAddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchAddUser(_response);
        });
    }

    protected processBatchAddUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量添加用户
     * @param body (optional) 
     * @return Success
     */
    batchCreateUser(body: UserRoleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/BatchCreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchCreateUser(_response);
        });
    }

    protected processBatchCreateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除角色
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除用户
     * @param body (optional) 
     * @return Success
     */
    batchDeleteUser(body: UserRoleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/BatchDeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDeleteUser(_response);
        });
    }

    protected processBatchDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRoleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 服务于前端RoleComboxComponent 组件信息，
     * @param permission (optional) 权限名称
     * @return Success
     */
    getAll(permission: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ListResultDtoOfRoleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfRoleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfRoleListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetRoleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetRoleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param permissionNames (optional) 权限名称
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(permissionNames: string[] | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetPaged?";
        if (permissionNames !== undefined && permissionNames !== null)
            permissionNames && permissionNames.forEach(item => { url_ += "permissionNames=" + encodeURIComponent("" + item) + "&"; });
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfRoleListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfRoleListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfRoleListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfRoleListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleForEdit(_response);
        });
    }

    protected processGetRoleForEdit(response: AxiosResponse): Promise<GetRoleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetRoleForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleForEditOutput>(null as any);
    }

    /**
     * 根据角色获取用户
     * @param roleId (optional) 
     * @param filterText (optional) 
     * @param companyId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getUserByRole(roleId: number | null | undefined, filterText: string | null | undefined, companyId: number | null | undefined, departmentId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<RoleUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetUserByRole?";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByRole(_response);
        });
    }

    protected processGetUserByRole(response: AxiosResponse): Promise<RoleUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RoleUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleUserDto[]>(null as any);
    }

    /**
     * 根据部门和公司获取账号信息
     * @param companyId (optional) 
     * @param departmentId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserPageList(companyId: number | null | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfRoleUserDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetUserPageList?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPageList(_response);
        });
    }

    protected processGetUserPageList(response: AxiosResponse): Promise<PagedResultDtoOfRoleUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfRoleUserDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfRoleUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfRoleUserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePermissions(body: UpdateRolePermissionsInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/UpdatePermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePermissions(_response);
        });
    }

    protected processUpdatePermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SceneServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Scene/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制场景
     * @param moudleId (optional) 
     * @param scenesId (optional) 
     * @param scenesName (optional) 
     * @return Success
     */
    copyScene(moudleId: number | undefined, scenesId: number | undefined, scenesName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Scene/CopyScene?";
        if (moudleId === null)
            throw new Error("The parameter 'moudleId' cannot be null.");
        else if (moudleId !== undefined)
            url_ += "moudleId=" + encodeURIComponent("" + moudleId) + "&";
        if (scenesId === null)
            throw new Error("The parameter 'scenesId' cannot be null.");
        else if (scenesId !== undefined)
            url_ += "scenesId=" + encodeURIComponent("" + scenesId) + "&";
        if (scenesName !== undefined && scenesName !== null)
            url_ += "scenesName=" + encodeURIComponent("" + scenesName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyScene(_response);
        });
    }

    protected processCopyScene(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: SceneEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Scene/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据场景名字获取场景Id
     * @param name (optional) 场景名字
     * @return Success
     */
    getByName(name: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/Scene/GetByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<SceneEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Scene/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<SceneEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SceneEditDto.fromJS(resultData200);
            return Promise.resolve<SceneEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SceneEditDto>(null as any);
    }

    /**
     * 获取APP最顶级的一级菜单
     * @return Success
     */
    getMenuListForAPP( cancelToken?: CancelToken | undefined): Promise<ModuleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Scene/GetMenuListForAPP";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuListForAPP(_response);
        });
    }

    protected processGetMenuListForAPP(response: AxiosResponse): Promise<ModuleListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModuleListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModuleListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleListDto[]>(null as any);
    }

    /**
     * 获取web最顶级的一级菜单
     * @return Success
     */
    getMenuListForWeb( cancelToken?: CancelToken | undefined): Promise<ModuleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Scene/GetMenuListForWeb";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuListForWeb(_response);
        });
    }

    protected processGetMenuListForWeb(response: AxiosResponse): Promise<ModuleListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModuleListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ModuleListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleListDto[]>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfSceneListDto> {
        let url_ = this.baseUrl + "/api/services/app/Scene/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfSceneListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfSceneListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfSceneListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfSceneListDto>(null as any);
    }
}

export class SessionServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getAppSystemUserConfigurations( cancelToken?: CancelToken | undefined): Promise<AppSystemUserConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetAppSystemUserConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppSystemUserConfigurations(_response);
        });
    }

    protected processGetAppSystemUserConfigurations(response: AxiosResponse): Promise<AppSystemUserConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppSystemUserConfigurationDto.fromJS(resultData200);
            return Promise.resolve<AppSystemUserConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppSystemUserConfigurationDto>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations( cancelToken?: CancelToken | undefined): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLoginInformations(_response);
        });
    }

    protected processGetCurrentLoginInformations(response: AxiosResponse): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return Promise.resolve<GetCurrentLoginInformationsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    getSystemUserConfigurations( cancelToken?: CancelToken | undefined): Promise<SystemUserConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetSystemUserConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSystemUserConfigurations(_response);
        });
    }

    protected processGetSystemUserConfigurations(response: AxiosResponse): Promise<SystemUserConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemUserConfigurationDto.fromJS(resultData200);
            return Promise.resolve<SystemUserConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemUserConfigurationDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserConfigurations( cancelToken?: CancelToken | undefined): Promise<AbpUserConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetUserConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserConfigurations(_response);
        });
    }

    protected processGetUserConfigurations(response: AxiosResponse): Promise<AbpUserConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbpUserConfigurationDto.fromJS(resultData200);
            return Promise.resolve<AbpUserConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbpUserConfigurationDto>(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken( cancelToken?: CancelToken | undefined): Promise<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserSignInToken(_response);
        });
    }

    protected processUpdateUserSignInToken(response: AxiosResponse): Promise<UpdateUserSignInTokenOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return Promise.resolve<UpdateUserSignInTokenOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserSignInTokenOutput>(null as any);
    }
}

export class SettingsAppServiceBaseServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingsAppServiceBase/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ShiftInfoServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除ShiftInfo的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改班次的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateShiftInfoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除班次信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取ShiftInfoListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ShiftInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShiftInfoListDto.fromJS(resultData200);
            return Promise.resolve<ShiftInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto>(null as any);
    }

    /**
     * 获取编辑 班次
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetShiftInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetShiftInfoForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetShiftInfoForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetShiftInfoForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetShiftInfoForEditOutput>(null as any);
    }

    /**
     * 获取班次的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfShiftInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfShiftInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfShiftInfoListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfShiftInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfShiftInfoListDto>(null as any);
    }

    /**
     * 检查code信息是否重复
     * @param id (optional) 
     * @param code (optional) 
     * @return Success
     */
    getRepeat(id: number | null | undefined, code: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/GetRepeat?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRepeat(_response);
        });
    }

    protected processGetRepeat(response: AxiosResponse): Promise<ShiftInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShiftInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto[]>(null as any);
    }

    /**
     * 导出班次为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftInfo/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class SignCardRecordServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除SignCardRecord的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateSignCardRecordInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取SignCardRecordListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<SignCardRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SignCardRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignCardRecordListDto.fromJS(resultData200);
            return Promise.resolve<SignCardRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignCardRecordListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSignCardRecordForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetSignCardRecordForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignCardRecordForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetSignCardRecordForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignCardRecordForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param userId (optional) 
     * @param companyId (optional) 公司
     * @param deparmentIds (optional) 部门
     * @param signCardTypeCode (optional) 补卡类型
     * @param reasonTypeCode (optional) 补卡原因
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束日期
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(userId: number | null | undefined, companyId: string | null | undefined, deparmentIds: string | null | undefined, signCardTypeCode: string | null | undefined, reasonTypeCode: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfSignCardRecordListDto> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/GetPaged?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentIds !== undefined && deparmentIds !== null)
            url_ += "deparmentIds=" + encodeURIComponent("" + deparmentIds) + "&";
        if (signCardTypeCode !== undefined && signCardTypeCode !== null)
            url_ += "signCardTypeCode=" + encodeURIComponent("" + signCardTypeCode) + "&";
        if (reasonTypeCode !== undefined && reasonTypeCode !== null)
            url_ += "reasonTypeCode=" + encodeURIComponent("" + reasonTypeCode) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfSignCardRecordListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfSignCardRecordListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfSignCardRecordListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfSignCardRecordListDto>(null as any);
    }

    /**
     * 获取用户信息
     * @param companyId (optional) 
     * @param departmentId (optional) 
     * @param empStateCode (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPageUserList(companyId: number | null | undefined, departmentId: number | null | undefined, empStateCode: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/GetPageUserList?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empStateCode !== undefined && empStateCode !== null)
            url_ += "empStateCode=" + encodeURIComponent("" + empStateCode) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageUserList(_response);
        });
    }

    protected processGetPageUserList(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @param userId (optional) 
     * @param companyId (optional) 公司
     * @param deparmentIds (optional) 部门
     * @param signCardTypeCode (optional) 补卡类型
     * @param reasonTypeCode (optional) 补卡原因
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束日期
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(userId: number | null | undefined, companyId: string | null | undefined, deparmentIds: string | null | undefined, signCardTypeCode: string | null | undefined, reasonTypeCode: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SignCardRecord/GetToExcelFile?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentIds !== undefined && deparmentIds !== null)
            url_ += "deparmentIds=" + encodeURIComponent("" + deparmentIds) + "&";
        if (signCardTypeCode !== undefined && signCardTypeCode !== null)
            url_ += "signCardTypeCode=" + encodeURIComponent("" + signCardTypeCode) + "&";
        if (reasonTypeCode !== undefined && reasonTypeCode !== null)
            url_ += "reasonTypeCode=" + encodeURIComponent("" + reasonTypeCode) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class SkillInfoServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除SkillInfo的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改证书表的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateSkillInfoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除证书表信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取SkillInfoListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<SkillInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SkillInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SkillInfoListDto.fromJS(resultData200);
            return Promise.resolve<SkillInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillInfoListDto>(null as any);
    }

    /**
     * 获取编辑 证书表
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSkillInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetSkillInfoForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSkillInfoForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetSkillInfoForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSkillInfoForEditOutput>(null as any);
    }

    /**
     * 根据用户Id获取证书列表
     * @param userId (optional) 
     * @return Success
     */
    getListByUserId(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<SkillInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/GetListByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByUserId(_response);
        });
    }

    protected processGetListByUserId(response: AxiosResponse): Promise<SkillInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SkillInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SkillInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SkillInfoListDto[]>(null as any);
    }

    /**
     * 获取证书表的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfSkillInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfSkillInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfSkillInfoListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfSkillInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfSkillInfoListDto>(null as any);
    }

    /**
     * 导出证书表为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SkillInfo/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class SocialRelationServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除SocialRelation的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改社会关系表的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateSocialRelationInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除社会关系表信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取SocialRelationListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<SocialRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SocialRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SocialRelationListDto.fromJS(resultData200);
            return Promise.resolve<SocialRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialRelationListDto>(null as any);
    }

    /**
     * 获取编辑 社会关系表
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSocialRelationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetSocialRelationForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSocialRelationForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetSocialRelationForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSocialRelationForEditOutput>(null as any);
    }

    /**
     * 根据用户Id获取社会关系列表
     * @param userId (optional) 
     * @return Success
     */
    getListByUserId(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<SocialRelationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/GetListByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByUserId(_response);
        });
    }

    protected processGetListByUserId(response: AxiosResponse): Promise<SocialRelationListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SocialRelationListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SocialRelationListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialRelationListDto[]>(null as any);
    }

    /**
     * 获取社会关系表的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfSocialRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfSocialRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfSocialRelationListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfSocialRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfSocialRelationListDto>(null as any);
    }

    /**
     * 导出社会关系表为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialRelation/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class SysClassifyServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除SysClassify的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysClassify/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateSysClassifyInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysClassify/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysClassify/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取SysClassifyListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<SysClassifyListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysClassify/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SysClassifyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SysClassifyListDto.fromJS(resultData200);
            return Promise.resolve<SysClassifyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysClassifyListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSysClassifyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SysClassify/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetSysClassifyForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSysClassifyForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetSysClassifyForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSysClassifyForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfSysClassifyListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysClassify/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfSysClassifyListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfSysClassifyListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfSysClassifyListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfSysClassifyListDto>(null as any);
    }
}

export class SysFileServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除SysFile的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 复制文件
     * @param body (optional) 
     * @return Success
     */
    copyFile(body: SysFileEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<SysFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/CopyFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyFile(_response);
        });
    }

    protected processCopyFile(response: AxiosResponse): Promise<SysFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SysFileListDto.fromJS(resultData200);
            return Promise.resolve<SysFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysFileListDto>(null as any);
    }

    /**
     * 新增文件
     * @param parentId (optional) 
     * @return Success
     */
    create(parentId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/Create?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建文件夹
     * @param body (optional) 
     * @return Success
     */
    createDirectory(body: SysFileEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<SysFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/CreateDirectory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDirectory(_response);
        });
    }

    protected processCreateDirectory(response: AxiosResponse): Promise<SysFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SysFileListDto.fromJS(resultData200);
            return Promise.resolve<SysFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysFileListDto>(null as any);
    }

    /**
     * 删除文件信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取SysFileListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<SysFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SysFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SysFileListDto.fromJS(resultData200);
            return Promise.resolve<SysFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysFileListDto>(null as any);
    }

    /**
     * 获取文件夹列表
     * @return Success
     */
    getDirectories( cancelToken?: CancelToken | undefined): Promise<SysFileListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/GetDirectories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDirectories(_response);
        });
    }

    protected processGetDirectories(response: AxiosResponse): Promise<SysFileListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SysFileListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SysFileListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysFileListDto[]>(null as any);
    }

    /**
     * 获取编辑 文件
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetSysFileForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetSysFileForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSysFileForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetSysFileForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSysFileForEditOutput>(null as any);
    }

    /**
     * 获取文件的分页列表信息
     * @param parentId (optional) 父级Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(parentId: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfSysFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/GetPaged?";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfSysFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfSysFileListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfSysFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfSysFileListDto>(null as any);
    }

    /**
     * 移动文件夹和文件
     * @param body (optional) 
     * @return Success
     */
    move(body: MoveSysFilesInput | undefined, cancelToken?: CancelToken | undefined): Promise<SysFileListDto> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/Move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<SysFileListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SysFileListDto.fromJS(resultData200);
            return Promise.resolve<SysFileListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SysFileListDto>(null as any);
    }

    /**
     * 重命名文件
     * @param body (optional) 
     * @return Success
     */
    reFileName(body: SysFileEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/ReFileName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReFileName(_response);
        });
    }

    protected processReFileName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 编辑文件
     * @param body (optional) 
     * @return Success
     */
    update(body: SysFileEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SysFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SystemConfigServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 获取扩展字段配置
     * @return Success
     */
    getFiledExtSettings( cancelToken?: CancelToken | undefined): Promise<FiledExtSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetFiledExtSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiledExtSettings(_response);
        });
    }

    protected processGetFiledExtSettings(response: AxiosResponse): Promise<FiledExtSettingsEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FiledExtSettingsEditDto.fromJS(resultData200);
            return Promise.resolve<FiledExtSettingsEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FiledExtSettingsEditDto>(null as any);
    }

    /**
     * 获取是否启用审核点问题反馈
     * @return Success
     */
    getIsEnableAuditPointFeedback( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableAuditPointFeedback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableAuditPointFeedback(_response);
        });
    }

    protected processGetIsEnableAuditPointFeedback(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否启用审核记录不符合项分类
     * @return Success
     */
    getIsEnableAuditTaskDetailDeviationType( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableAuditTaskDetailDeviationType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableAuditTaskDetailDeviationType(_response);
        });
    }

    protected processGetIsEnableAuditTaskDetailDeviationType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否启用打开手机相册
     * @return Success
     */
    getIsEnableOpenPhoneAlbum( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableOpenPhoneAlbum";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableOpenPhoneAlbum(_response);
        });
    }

    protected processGetIsEnableOpenPhoneAlbum(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否启用部门归属
     * @return Success
     */
    getIsEnableStatisticsOrg( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableStatisticsOrg";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableStatisticsOrg(_response);
        });
    }

    protected processGetIsEnableStatisticsOrg(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否启用上传图片
     * @return Success
     */
    getIsEnableUploadPicture( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableUploadPicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableUploadPicture(_response);
        });
    }

    protected processGetIsEnableUploadPicture(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否禁用从相册上传图片
     * @return Success
     */
    getIsEnableUploadPictureForPhone( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableUploadPictureForPhone";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableUploadPictureForPhone(_response);
        });
    }

    protected processGetIsEnableUploadPictureForPhone(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取是否启用上传视频
     * @return Success
     */
    getIsEnableUploadVideo( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetIsEnableUploadVideo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsEnableUploadVideo(_response);
        });
    }

    protected processGetIsEnableUploadVideo(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取Ldap配置
     * @param tenantId (optional) 
     * @return Success
     */
    getLdapSetting(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<LdapSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetLdapSetting?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLdapSetting(_response);
        });
    }

    protected processGetLdapSetting(response: AxiosResponse): Promise<LdapSettingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LdapSettingDto.fromJS(resultData200);
            return Promise.resolve<LdapSettingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LdapSettingDto>(null as any);
    }

    /**
     * 获取图片质量
     * @return Success
     */
    getPictureQuality( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetPictureQuality";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPictureQuality(_response);
        });
    }

    protected processGetPictureQuality(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取责任人是否可以关闭问题
     * @return Success
     */
    getRespIsCloseIssue( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetRespIsCloseIssue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRespIsCloseIssue(_response);
        });
    }

    protected processGetRespIsCloseIssue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 获取部门归属配置
     * @return Success
     */
    getStatisticsOrgConfig( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetStatisticsOrgConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsOrgConfig(_response);
        });
    }

    protected processGetStatisticsOrgConfig(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 获取待关闭问题提醒进度
     * @return Success
     */
    getToBeClosedIssueNoticeProgress( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetToBeClosedIssueNoticeProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToBeClosedIssueNoticeProgress(_response);
        });
    }

    protected processGetToBeClosedIssueNoticeProgress(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取登录验证
     * @param tenantId (optional) 
     * @return Success
     */
    getValidateLogonSetting(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<ValidateLogonDto> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetValidateLogonSetting?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetValidateLogonSetting(_response);
        });
    }

    protected processGetValidateLogonSetting(response: AxiosResponse): Promise<ValidateLogonDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateLogonDto.fromJS(resultData200);
            return Promise.resolve<ValidateLogonDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateLogonDto>(null as any);
    }

    /**
     * 获取视频时长
     * @return Success
     */
    getVideoDuration( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetVideoDuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideoDuration(_response);
        });
    }

    protected processGetVideoDuration(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取视频分辨率
     * @return Success
     */
    getVideoResolution( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/GetVideoResolution";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideoResolution(_response);
        });
    }

    protected processGetVideoResolution(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * 是否启用审核点问题反馈
     * @param body (optional) 
     * @return Success
     */
    isEnableAuditPointFeedback(body: IsEnableAuditPointFeedbackDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableAuditPointFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableAuditPointFeedback(_response);
        });
    }

    protected processIsEnableAuditPointFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是否启用审核记录不符合项分类
     * @param body (optional) 
     * @return Success
     */
    isEnableAuditTaskDetailDeviationType(body: IsEnableAuditTaskDetailDeviationTypeDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableAuditTaskDetailDeviationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableAuditTaskDetailDeviationType(_response);
        });
    }

    protected processIsEnableAuditTaskDetailDeviationType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是否启用打开手机相册
     * @param body (optional) 
     * @return Success
     */
    isEnableOpenPhoneAlbum(body: IsEnableOpenPhoneAlbumDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableOpenPhoneAlbum";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableOpenPhoneAlbum(_response);
        });
    }

    protected processIsEnableOpenPhoneAlbum(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是否启用部门归属
     * @param body (optional) 
     * @return Success
     */
    isEnableStatisticsOrg(body: IsEnableStatisticsOrgDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableStatisticsOrg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableStatisticsOrg(_response);
        });
    }

    protected processIsEnableStatisticsOrg(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是否禁用上传图片
     * @param body (optional) 
     * @return Success
     */
    isEnableUploadPicture(body: IsEnableUploadPictureDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableUploadPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableUploadPicture(_response);
        });
    }

    protected processIsEnableUploadPicture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 禁用从相册上传图片
     * @param body (optional) 
     * @return Success
     */
    isEnableUploadPictureForPhone(body: IsEnableUploadPictureForPhoneDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableUploadPictureForPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableUploadPictureForPhone(_response);
        });
    }

    protected processIsEnableUploadPictureForPhone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 是否启用上传视频
     * @param body (optional) 
     * @return Success
     */
    isEnableUploadVideo(body: IsEnableUploadVideoDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/IsEnableUploadVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsEnableUploadVideo(_response);
        });
    }

    protected processIsEnableUploadVideo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Ldap配置
     * @param body (optional) 
     * @return Success
     */
    ldapSetting(body: LdapSettingDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/LdapSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLdapSetting(_response);
        });
    }

    protected processLdapSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 图片质量
     * @param body (optional) 
     * @return Success
     */
    pictureQuality(body: PictureQualityDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/PictureQuality";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPictureQuality(_response);
        });
    }

    protected processPictureQuality(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 责任人是否可以关闭问题
     * @param body (optional) 
     * @return Success
     */
    respIsCloseIssue(body: RespIsCloseIssueDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/RespIsCloseIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRespIsCloseIssue(_response);
        });
    }

    protected processRespIsCloseIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 部门归属配置
     * @param body (optional) 
     * @return Success
     */
    statisticsOrgConfig(body: StatisticsOrgConfigDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/StatisticsOrgConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatisticsOrgConfig(_response);
        });
    }

    protected processStatisticsOrgConfig(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试Ldap连接
     * @param tenantId (optional) 
     * @return Success
     */
    testLdapSetting(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/TestLdapSetting?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestLdapSetting(_response);
        });
    }

    protected processTestLdapSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 待关闭问题提醒进度
     * @param body (optional) 
     * @return Success
     */
    toBeClosedIssueNoticeProgress(body: ToBeClosedIssueNoticeProgressDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/ToBeClosedIssueNoticeProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToBeClosedIssueNoticeProgress(_response);
        });
    }

    protected processToBeClosedIssueNoticeProgress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 设置扩展配置
     * @param body (optional) 
     * @return Success
     */
    updateFiledExtSettings(body: FiledExtSettingsEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/UpdateFiledExtSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFiledExtSettings(_response);
        });
    }

    protected processUpdateFiledExtSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 视频时长
     * @param body (optional) 
     * @return Success
     */
    videoDuration(body: VideoDurationDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/VideoDuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideoDuration(_response);
        });
    }

    protected processVideoDuration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 视频分辨率
     * @param body (optional) 
     * @return Success
     */
    videoResolution(body: VideoResolutionDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemConfig/VideoResolution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideoResolution(_response);
        });
    }

    protected processVideoResolution(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TagServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除Tag的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改标签的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateTagInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除标签信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有标签
     * @return Success
     */
    getAll( cancelToken?: CancelToken | undefined): Promise<TagListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<TagListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TagListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagListDto[]>(null as any);
    }

    /**
     * 通过指定id获取TagListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<TagListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<TagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagListDto.fromJS(resultData200);
            return Promise.resolve<TagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagListDto>(null as any);
    }

    /**
     * 获取编辑 标签
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetTagForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetTagForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTagForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetTagForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTagForEditOutput>(null as any);
    }

    /**
     * 获取标签的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTagListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTagListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTagListDto>(null as any);
    }

    /**
     * 获取流行的标签
     * @param blogId (optional) 
     * @param resultCount (optional) 
     * @param minimumPostCount (optional) 
     * @return Success
     */
    getPopularTags(blogId: string | undefined, resultCount: number | undefined, minimumPostCount: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<TagListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetPopularTags?";
        if (blogId === null)
            throw new Error("The parameter 'blogId' cannot be null.");
        else if (blogId !== undefined)
            url_ += "blogId=" + encodeURIComponent("" + blogId) + "&";
        if (resultCount === null)
            throw new Error("The parameter 'resultCount' cannot be null.");
        else if (resultCount !== undefined)
            url_ += "resultCount=" + encodeURIComponent("" + resultCount) + "&";
        if (minimumPostCount !== undefined && minimumPostCount !== null)
            url_ += "minimumPostCount=" + encodeURIComponent("" + minimumPostCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPopularTags(_response);
        });
    }

    protected processGetPopularTags(response: AxiosResponse): Promise<TagListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TagListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagListDto[]>(null as any);
    }

    /**
     * 导出标签为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class TaskBaseInfoServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除TaskBaseInfo的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateTaskBaseInfoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 导出任务完成率
     * @param company (optional) 公司
     * @param department (optional) 部门
     * @param year (optional) 年
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    exportTaskCompletionRate(company: string | null | undefined, department: string | null | undefined, year: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/ExportTaskCompletionRate?";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTaskCompletionRate(_response);
        });
    }

    protected processExportTaskCompletionRate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导出任务拒绝率
     * @param company (optional) 公司
     * @param department (optional) 部门
     * @param year (optional) 年
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    exportTaskRefuseRate(company: string | null | undefined, department: string | null | undefined, year: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/ExportTaskRefuseRate?";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTaskRefuseRate(_response);
        });
    }

    protected processExportTaskRefuseRate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取APP统计分析
     * @param year (optional) 
     * @param companyId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getAppTaskAnalysis(year: number | null | undefined, companyId: number | null | undefined, departmentId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetAppTaskAnalysisDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetAppTaskAnalysis?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppTaskAnalysis(_response);
        });
    }

    protected processGetAppTaskAnalysis(response: AxiosResponse): Promise<GetAppTaskAnalysisDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppTaskAnalysisDto.fromJS(resultData200);
            return Promise.resolve<GetAppTaskAnalysisDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppTaskAnalysisDto>(null as any);
    }

    /**
     * 获取APP任务清单
     * @param state (optional) (1发出 2待办 3已完成)
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAppTaskList(state: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetAppTaskListDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetAppTaskList?";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppTaskList(_response);
        });
    }

    protected processGetAppTaskList(response: AxiosResponse): Promise<PagedResultDtoOfGetAppTaskListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetAppTaskListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetAppTaskListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetAppTaskListDto>(null as any);
    }

    /**
     * 通过指定id获取TaskBaseInfoListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<TaskBaseInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<TaskBaseInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskBaseInfoListDto.fromJS(resultData200);
            return Promise.resolve<TaskBaseInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskBaseInfoListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @param systemType (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, systemType: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetTaskBaseInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (systemType !== undefined && systemType !== null)
            url_ += "systemType=" + encodeURIComponent("" + systemType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetTaskBaseInfoForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTaskBaseInfoForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetTaskBaseInfoForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTaskBaseInfoForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param state (optional) 状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(state: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTaskBaseInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetPaged?";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTaskBaseInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTaskBaseInfoListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTaskBaseInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTaskBaseInfoListDto>(null as any);
    }

    /**
     * 查看分析
     * @param year (optional) 
     * @param companyId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getTaskAnalysis(year: number | null | undefined, companyId: number | null | undefined, departmentId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<TaskAnalysisDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetTaskAnalysis?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskAnalysis(_response);
        });
    }

    protected processGetTaskAnalysis(response: AxiosResponse): Promise<TaskAnalysisDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskAnalysisDto.fromJS(resultData200);
            return Promise.resolve<TaskAnalysisDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskAnalysisDto>(null as any);
    }

    /**
     * 获取任务完成率报表
     * @param company (optional) 公司
     * @param department (optional) 部门
     * @param year (optional) 年
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTaskCompletionRate(company: string | null | undefined, department: string | null | undefined, year: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetTaskCompletionRateDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetTaskCompletionRate?";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskCompletionRate(_response);
        });
    }

    protected processGetTaskCompletionRate(response: AxiosResponse): Promise<PagedResultDtoOfGetTaskCompletionRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetTaskCompletionRateDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetTaskCompletionRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetTaskCompletionRateDto>(null as any);
    }

    /**
     * 获取任务拒绝率
     * @param company (optional) 公司
     * @param department (optional) 部门
     * @param year (optional) 年
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTaskRefuseRate(company: string | null | undefined, department: string | null | undefined, year: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfGetTaskRefuseRateDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetTaskRefuseRate?";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskRefuseRate(_response);
        });
    }

    protected processGetTaskRefuseRate(response: AxiosResponse): Promise<PagedResultDtoOfGetTaskRefuseRateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfGetTaskRefuseRateDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfGetTaskRefuseRateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfGetTaskRefuseRateDto>(null as any);
    }

    /**
     * 获取任务类型字典
     * @return Success
     */
    getTaskTypeDataItemList( cancelToken?: CancelToken | undefined): Promise<TaskTypeDataItemList[]> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetTaskTypeDataItemList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaskTypeDataItemList(_response);
        });
    }

    protected processGetTaskTypeDataItemList(response: AxiosResponse): Promise<TaskTypeDataItemList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TaskTypeDataItemList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TaskTypeDataItemList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskTypeDataItemList[]>(null as any);
    }

    /**
     * 导出为excel文件
     * @param state (optional) 状态
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getToExcelFile(state: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/GetToExcelFile?";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 第三方创建任务
     * @param body (optional) 
     * @return Success
     */
    otherCreateTask(body: OtherCreateTaskDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/OtherCreateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtherCreateTask(_response);
        });
    }

    protected processOtherCreateTask(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 第三方根据来源删除任务
     * @param body (optional) 
     * @return Success
     */
    otherDeleteTaskBySoure(body: OtherDeleteTaskBySoureInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/OtherDeleteTaskBySoure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtherDeleteTaskBySoure(_response);
        });
    }

    protected processOtherDeleteTaskBySoure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 第三方修改任务
     * @param body (optional) 
     * @return Success
     */
    otherUpdateTask(body: OtherUpdateTaskDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/OtherUpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtherUpdateTask(_response);
        });
    }

    protected processOtherUpdateTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 第三方根据ID修改任务状态
     * @param body (optional) 
     * @return Success
     */
    otherUpdateTaskStateById(body: OtherUpdateTaskStateByIdInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/OtherUpdateTaskStateById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtherUpdateTaskStateById(_response);
        });
    }

    protected processOtherUpdateTaskStateById(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 第三方根据来源修改任务状态
     * @param body (optional) 
     * @return Success
     */
    otherUpdateTaskStateBySoure(body: OtherUpdateTaskStateBySoureInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/OtherUpdateTaskStateBySoure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtherUpdateTaskStateBySoure(_response);
        });
    }

    protected processOtherUpdateTaskStateBySoure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 第三方根据来源匹配修改任务状态
     * @param body (optional) 
     * @return Success
     */
    otherUpdateTaskStateMatchingBySoure(body: OtherUpdateTaskStateBySoureInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/OtherUpdateTaskStateMatchingBySoure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtherUpdateTaskStateMatchingBySoure(_response);
        });
    }

    protected processOtherUpdateTaskStateMatchingBySoure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改任务状态 3作废 4拒绝 5完成 6关闭
     * @param id (optional) 
     * @param state (optional) 
     * @return Success
     */
    updateTaskState(id: number | undefined, state: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskBaseInfo/UpdateTaskState?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTaskState(_response);
        });
    }

    protected processUpdateTaskState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TemplateBarCodeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TemplateBarCode/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新增或编辑
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateTemplateBarCodeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TemplateBarCode/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TemplateBarCode/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取分页数据
     * @return Success
     */
    getAll( cancelToken?: CancelToken | undefined): Promise<TemplateBarCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TemplateBarCode/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<TemplateBarCodeListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TemplateBarCodeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateBarCodeListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateBarCodeListDto[]>(null as any);
    }

    /**
     * 获取编辑Dto
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<TemplateBarCodeEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateBarCode/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<TemplateBarCodeEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateBarCodeEditDto.fromJS(resultData200);
            return Promise.resolve<TemplateBarCodeEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateBarCodeEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTemplateBarCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateBarCode/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTemplateBarCodeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTemplateBarCodeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTemplateBarCodeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTemplateBarCodeListDto>(null as any);
    }
}

export class TenantServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: EntityDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyMenuToTenantUser(body: SynsTenantMenuDto | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CopyMenuToTenantUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyMenuToTenantUser(_response);
        });
    }

    protected processCopyMenuToTenantUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 创建租户
     * @param body (optional) 
     * @return Success
     */
    createWithCopyMenu(body: CreateTenantInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateWithCopyMenu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWithCopyMenu(_response);
        });
    }

    protected processCreateWithCopyMenu(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取默认租户代码
     * @return Success
     */
    getDefatultTenantCode( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetDefatultTenantCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefatultTenantCode(_response);
        });
    }

    protected processGetDefatultTenantCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<TenantEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantEditDto.fromJS(resultData200);
            return Promise.resolve<TenantEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantEditDto>(null as any);
    }

    /**
     * @param subscriptionStart (optional) 
     * @param subscriptionEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(subscriptionStart: moment.Moment | null | undefined, subscriptionEnd: moment.Moment | null | undefined, creationDateStart: moment.Moment | null | undefined, creationDateEnd: moment.Moment | null | undefined, editionId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetPaged?";
        if (subscriptionStart !== undefined && subscriptionStart !== null)
            url_ += "subscriptionStart=" + encodeURIComponent(subscriptionStart ? "" + subscriptionStart.toISOString() : "") + "&";
        if (subscriptionEnd !== undefined && subscriptionEnd !== null)
            url_ += "subscriptionEnd=" + encodeURIComponent(subscriptionEnd ? "" + subscriptionEnd.toISOString() : "") + "&";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "creationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toISOString() : "") + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "creationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toISOString() : "") + "&";
        if (editionId !== undefined && editionId !== null)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTenantListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTenantListDto>(null as any);
    }

    /**
     * @param modules (optional) 
     * @param currentId (optional) 
     * @param outPut (optional) 
     * @param index (optional) 
     * @return Success
     */
    getSubModules(modules: Module[] | null | undefined, currentId: number | undefined, outPut: ValueTupleOfInt32Module[] | null | undefined, index: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetSubModules?";
        if (modules !== undefined && modules !== null)
            modules && modules.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "modules[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (currentId === null)
            throw new Error("The parameter 'currentId' cannot be null.");
        else if (currentId !== undefined)
            url_ += "currentId=" + encodeURIComponent("" + currentId) + "&";
        if (outPut !== undefined && outPut !== null)
            outPut && outPut.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "outPut[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubModules(_response);
        });
    }

    protected processGetSubModules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTenant( cancelToken?: CancelToken | undefined): Promise<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: AxiosResponse): Promise<TenantListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantListDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantFeaturesForEdit(_response);
        });
    }

    protected processGetTenantFeaturesForEdit(response: AxiosResponse): Promise<GetTenantFeaturesEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return Promise.resolve<GetTenantFeaturesEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantFeaturesEditOutput>(null as any);
    }

    /**
     * 获取租户列表
     * @return Success
     */
    getTenantList( cancelToken?: CancelToken | undefined): Promise<TenantListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantList(_response);
        });
    }

    protected processGetTenantList(response: AxiosResponse): Promise<TenantListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TenantListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantListDto[]>(null as any);
    }

    /**
     * 获取租户服务配置
     * @param tenantCode (optional) 
     * @return Success
     */
    getTenantServiceByCode(tenantCode: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<TenantServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantServiceByCode?";
        if (tenantCode !== undefined && tenantCode !== null)
            url_ += "tenantCode=" + encodeURIComponent("" + tenantCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantServiceByCode(_response);
        });
    }

    protected processGetTenantServiceByCode(response: AxiosResponse): Promise<TenantServiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantServiceDto.fromJS(resultData200);
            return Promise.resolve<TenantServiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantServiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetTenantSpecificFeatures(_response);
        });
    }

    protected processResetTenantSpecificFeatures(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockTenantAdmin(_response);
        });
    }

    protected processUnlockTenantAdmin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTenantFeatures(_response);
        });
    }

    protected processUpdateTenantFeatures(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TenantRegistrationServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 注册租户信息
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: CreateTenantDto | undefined, cancelToken?: CancelToken | undefined): Promise<RegisterTenantResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterTenant(_response);
        });
    }

    protected processRegisterTenant(response: AxiosResponse): Promise<RegisterTenantResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterTenantResultDto.fromJS(resultData200);
            return Promise.resolve<RegisterTenantResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterTenantResultDto>(null as any);
    }
}

export class TenantSettingsServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    clearCustomCss( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearCustomCss(_response);
        });
    }

    protected processClearCustomCss(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    clearLogo( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearLogo(_response);
        });
    }

    protected processClearLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取所有设置
     * @return Success
     */
    getAllSettings( cancelToken?: CancelToken | undefined): Promise<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSettings(_response);
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<TenantSettingsEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return Promise.resolve<TenantSettingsEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantSettingsEditDto>(null as any);
    }

    /**
     * 获取同步年度计划配置
     * @return Success
     */
    getAsycMonthAttendancePlanSetting( cancelToken?: CancelToken | undefined): Promise<AsycMonthAttendancePlanEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAsycMonthAttendancePlanSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAsycMonthAttendancePlanSetting(_response);
        });
    }

    protected processGetAsycMonthAttendancePlanSetting(response: AxiosResponse): Promise<AsycMonthAttendancePlanEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AsycMonthAttendancePlanEditDto.fromJS(resultData200);
            return Promise.resolve<AsycMonthAttendancePlanEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsycMonthAttendancePlanEditDto>(null as any);
    }

    /**
     * 获取保底工资配置
     * @return Success
     */
    getBaseSaralySettings( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetBaseSaralySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBaseSaralySettings(_response);
        });
    }

    protected processGetBaseSaralySettings(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取最大加班时数
     * @return Success
     */
    getMaxOverTimeNumber( cancelToken?: CancelToken | undefined): Promise<MaxOverTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetMaxOverTimeNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaxOverTimeNumber(_response);
        });
    }

    protected processGetMaxOverTimeNumber(response: AxiosResponse): Promise<MaxOverTimeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaxOverTimeDto.fromJS(resultData200);
            return Promise.resolve<MaxOverTimeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaxOverTimeDto>(null as any);
    }

    /**
     * 获取夜班津贴配置
     * @return Success
     */
    getNightShiftSettings( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetNightShiftSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNightShiftSettings(_response);
        });
    }

    protected processGetNightShiftSettings(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取薪资周期设置
     * @return Success
     */
    getSalaryCycleSetting( cancelToken?: CancelToken | undefined): Promise<SalaryCycleSettingEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetSalaryCycleSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalaryCycleSetting(_response);
        });
    }

    protected processGetSalaryCycleSetting(response: AxiosResponse): Promise<SalaryCycleSettingEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SalaryCycleSettingEditDto.fromJS(resultData200);
            return Promise.resolve<SalaryCycleSettingEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalaryCycleSettingEditDto>(null as any);
    }

    /**
     * 获取薪资设置
     * @return Success
     */
    getSalarySettings( cancelToken?: CancelToken | undefined): Promise<SalarySettingEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetSalarySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalarySettings(_response);
        });
    }

    protected processGetSalarySettings(response: AxiosResponse): Promise<SalarySettingEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SalarySettingEditDto.fromJS(resultData200);
            return Promise.resolve<SalarySettingEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalarySettingEditDto>(null as any);
    }

    /**
     * 获取安全策略白名单
     * @return Success
     */
    getSettingWhiteUserList( cancelToken?: CancelToken | undefined): Promise<SettingWhiteUserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetSettingWhiteUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingWhiteUserList(_response);
        });
    }

    protected processGetSettingWhiteUserList(response: AxiosResponse): Promise<SettingWhiteUserListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SettingWhiteUserListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SettingWhiteUserListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingWhiteUserListDto[]>(null as any);
    }

    /**
     * 获取安全策略白名单
     * @param tenantId (optional) 
     * @return Success
     */
    getSettingWhiteUserListByTenantId(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetSettingWhiteUserListByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingWhiteUserListByTenantId(_response);
        });
    }

    protected processGetSettingWhiteUserListByTenantId(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * 获取员工自助确认内容
     * @return Success
     */
    getStaffSelfConfirmation( cancelToken?: CancelToken | undefined): Promise<StaffSelfConfirmationDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetStaffSelfConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStaffSelfConfirmation(_response);
        });
    }

    protected processGetStaffSelfConfirmation(response: AxiosResponse): Promise<StaffSelfConfirmationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StaffSelfConfirmationDto.fromJS(resultData200);
            return Promise.resolve<StaffSelfConfirmationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffSelfConfirmationDto>(null as any);
    }

    /**
     * 获取程序缓存配置
     * @return Success
     */
    getTokenExpiration( cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetTokenExpiration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTokenExpiration(_response);
        });
    }

    protected processGetTokenExpiration(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * 获取用户安全设置
     * @return Success
     */
    getUserSecuritySettingsDto( cancelToken?: CancelToken | undefined): Promise<SecuritySettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetUserSecuritySettingsDto";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSecuritySettingsDto(_response);
        });
    }

    protected processGetUserSecuritySettingsDto(response: AxiosResponse): Promise<SecuritySettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SecuritySettingsDto.fromJS(resultData200);
            return Promise.resolve<SecuritySettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SecuritySettingsDto>(null as any);
    }

    /**
     * 获取用户安全设置
     * @param tenantId (optional) 
     * @return Success
     */
    getUserSecuritySettingsDtoByTenantId(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<SecuritySettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetUserSecuritySettingsDtoByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSecuritySettingsDtoByTenantId(_response);
        });
    }

    protected processGetUserSecuritySettingsDtoByTenantId(response: AxiosResponse): Promise<SecuritySettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SecuritySettingsDto.fromJS(resultData200);
            return Promise.resolve<SecuritySettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SecuritySettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reRegisterHangfireJobs(body: ReRegisterHangfireJobsInput | undefined, cancelToken?: CancelToken | undefined): Promise<ReRegisterHangfireJobResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ReRegisterHangfireJobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReRegisterHangfireJobs(_response);
        });
    }

    protected processReRegisterHangfireJobs(response: AxiosResponse): Promise<ReRegisterHangfireJobResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReRegisterHangfireJobResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReRegisterHangfireJobResultDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReRegisterHangfireJobResultDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新所有设置
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAllSettings(_response);
        });
    }

    protected processUpdateAllSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新入职周年消息推送配置
     * @param body (optional) 
     * @return Success
     */
    updateAnniversarySettings(body: AnniversaryManagementSettingsEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAnniversarySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAnniversarySettings(_response);
        });
    }

    protected processUpdateAnniversarySettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新保底工资配置
     * @param salary (optional) 
     * @return Success
     */
    updateBaseSalarySetting(salary: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateBaseSalarySetting?";
        if (salary === null)
            throw new Error("The parameter 'salary' cannot be null.");
        else if (salary !== undefined)
            url_ += "salary=" + encodeURIComponent("" + salary) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBaseSalarySetting(_response);
        });
    }

    protected processUpdateBaseSalarySetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新生日祝福消息推送配置
     * @param body (optional) 
     * @return Success
     */
    updateBirthdayWishSettings(body: BirthdayWishManagementSettingEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateBirthdayWishSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBirthdayWishSettings(_response);
        });
    }

    protected processUpdateBirthdayWishSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新最大加班时数
     * @param number (optional) 
     * @param startNum (optional) 
     * @return Success
     */
    updateMaxOverTimeNumber(number: number | undefined, startNum: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateMaxOverTimeNumber?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (startNum === null)
            throw new Error("The parameter 'startNum' cannot be null.");
        else if (startNum !== undefined)
            url_ += "startNum=" + encodeURIComponent("" + startNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMaxOverTimeNumber(_response);
        });
    }

    protected processUpdateMaxOverTimeNumber(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新夜班津贴配置
     * @param subsidy (optional) 
     * @return Success
     */
    updateNightShiftSettings(subsidy: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateNightShiftSettings?";
        if (subsidy === null)
            throw new Error("The parameter 'subsidy' cannot be null.");
        else if (subsidy !== undefined)
            url_ += "subsidy=" + encodeURIComponent("" + subsidy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNightShiftSettings(_response);
        });
    }

    protected processUpdateNightShiftSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新薪资设置
     * @param body (optional) 
     * @return Success
     */
    updateSalarySetting(body: SalarySettingEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateSalarySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSalarySetting(_response);
        });
    }

    protected processUpdateSalarySetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 更新员工自助确认内容
     * @param isEnable (optional) 
     * @param overTimePromptCopy (optional) 
     * @param sureOverTimeDays (optional) 
     * @return Success
     */
    updateStaffSelfConfirmation(isEnable: string | null | undefined, overTimePromptCopy: string | null | undefined, sureOverTimeDays: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateStaffSelfConfirmation?";
        if (isEnable !== undefined && isEnable !== null)
            url_ += "isEnable=" + encodeURIComponent("" + isEnable) + "&";
        if (overTimePromptCopy !== undefined && overTimePromptCopy !== null)
            url_ += "overTimePromptCopy=" + encodeURIComponent("" + overTimePromptCopy) + "&";
        if (sureOverTimeDays === null)
            throw new Error("The parameter 'sureOverTimeDays' cannot be null.");
        else if (sureOverTimeDays !== undefined)
            url_ += "sureOverTimeDays=" + encodeURIComponent("" + sureOverTimeDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStaffSelfConfirmation(_response);
        });
    }

    protected processUpdateStaffSelfConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param days (optional) 
     * @return Success
     */
    updateTokenExpiration(days: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateTokenExpiration?";
        if (days === null)
            throw new Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTokenExpiration(_response);
        });
    }

    protected processUpdateTokenExpiration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TencentOrderInfoServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除TencentOrderInfo的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改TencentOrderInfo的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateTencentOrderInfoInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除TencentOrderInfo信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteSyncBackgroundJobs( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/DeleteSyncBackgroundJobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSyncBackgroundJobs(_response);
        });
    }

    protected processDeleteSyncBackgroundJobs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取TencentOrderInfoListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<TencentOrderInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<TencentOrderInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TencentOrderInfoListDto.fromJS(resultData200);
            return Promise.resolve<TencentOrderInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TencentOrderInfoListDto>(null as any);
    }

    /**
     * 获取编辑 TencentOrderInfo
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetTencentOrderInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetTencentOrderInfoForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTencentOrderInfoForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetTencentOrderInfoForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTencentOrderInfoForEditOutput>(null as any);
    }

    /**
     * 获取TencentOrderInfo的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTencentOrderInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTencentOrderInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTencentOrderInfoListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTencentOrderInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTencentOrderInfoListDto>(null as any);
    }

    /**
     * 通过腾讯课程的order订单编码激活52abp的课程
     * @param body (optional) 
     * @return Success
     */
    syncTencentOrderToL52ABPCourseOrder(body: EntityDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TencentOrderInfo/SyncTencentOrderToL52ABPCourseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncTencentOrderToL52ABPCourseOrder(_response);
        });
    }

    protected processSyncTencentOrderToL52ABPCourseOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TestServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 上下班打卡
     * @return Success
     */
    checkIn( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/CheckIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIn(_response);
        });
    }

    protected processCheckIn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 打卡通知
     * @return Success
     */
    checkInRemind( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/CheckInRemind";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckInRemind(_response);
        });
    }

    protected processCheckInRemind(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试连通
     * @param tid (optional) 
     * @return Success
     */
    dailyMessageSendMessageGet(tid: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/DailyMessageSendMessage?";
        if (tid === null)
            throw new Error("The parameter 'tid' cannot be null.");
        else if (tid !== undefined)
            url_ += "tid=" + encodeURIComponent("" + tid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageSendMessageGet(_response);
        });
    }

    protected processDailyMessageSendMessageGet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * App个推测试
     * @param tenantId (optional) 
     * @return Success
     */
    dailyMessageSendMessagePost(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/DailyMessageSendMessage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageSendMessagePost(_response);
        });
    }

    protected processDailyMessageSendMessagePost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * App个推测试
     * @param tenantId (optional) 
     * @return Success
     */
    dailyMessageSendMessageSendEmail(tenantId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/DailyMessageSendMessageSendEmail?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageSendMessageSendEmail(_response);
        });
    }

    protected processDailyMessageSendMessageSendEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 试用期到期提醒
     * @return Success
     */
    empInternshipExpire( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/EmpInternshipExpire";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmpInternshipExpire(_response);
        });
    }

    protected processEmpInternshipExpire(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 根据姓名查找工号
     * @param fileName (optional) 
     * @return Success
     */
    findJobNumberExcelByRealName(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Test/FindJobNumberExcelByRealName?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindJobNumberExcelByRealName(_response);
        });
    }

    protected processFindJobNumberExcelByRealName(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * App个推测试
     * @param cid (optional) 
     * @return Success
     */
    getuiTest(cid: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/GetuiTest?";
        if (cid !== undefined && cid !== null)
            url_ += "cid=" + encodeURIComponent("" + cid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetuiTest(_response);
        });
    }

    protected processGetuiTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 身份证到期
     * @return Success
     */
    identityCardExpire( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/IdentityCardExpire";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIdentityCardExpire(_response);
        });
    }

    protected processIdentityCardExpire(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 漏打卡提醒
     * @return Success
     */
    omitCheckIn( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/OmitCheckIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOmitCheckIn(_response);
        });
    }

    protected processOmitCheckIn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 漏卡逻辑
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param nowTime (optional) 当前时间
     * @param shiftTime (optional) 班次时间
     * @param isUp (optional) 是否上班
     * @param body (optional) 员工信息
     * @return Success
     */
    omitCheckInProcess(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, nowTime: moment.Moment | undefined, shiftTime: moment.Moment | undefined, isUp: boolean | undefined, body: User | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/OmitCheckInProcess?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (nowTime === null)
            throw new Error("The parameter 'nowTime' cannot be null.");
        else if (nowTime !== undefined)
            url_ += "nowTime=" + encodeURIComponent(nowTime ? "" + nowTime.toISOString() : "") + "&";
        if (shiftTime === null)
            throw new Error("The parameter 'shiftTime' cannot be null.");
        else if (shiftTime !== undefined)
            url_ += "shiftTime=" + encodeURIComponent(shiftTime ? "" + shiftTime.toISOString() : "") + "&";
        if (isUp === null)
            throw new Error("The parameter 'isUp' cannot be null.");
        else if (isUp !== undefined)
            url_ += "isUp=" + encodeURIComponent("" + isUp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOmitCheckInProcess(_response);
        });
    }

    protected processOmitCheckInProcess(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送考勤异常
     * @param startTime1 (optional) 
     * @param endTime1 (optional) 
     * @param jobNumber (optional) 
     * @return Success
     */
    sendAttErrorReport(startTime1: moment.Moment | undefined, endTime1: moment.Moment | undefined, jobNumber: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/SendAttErrorReport?";
        if (startTime1 === null)
            throw new Error("The parameter 'startTime1' cannot be null.");
        else if (startTime1 !== undefined)
            url_ += "startTime1=" + encodeURIComponent(startTime1 ? "" + startTime1.toISOString() : "") + "&";
        if (endTime1 === null)
            throw new Error("The parameter 'endTime1' cannot be null.");
        else if (endTime1 !== undefined)
            url_ += "endTime1=" + encodeURIComponent(endTime1 ? "" + endTime1.toISOString() : "") + "&";
        if (jobNumber !== undefined && jobNumber !== null)
            url_ += "jobNumber=" + encodeURIComponent("" + jobNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAttErrorReport(_response);
        });
    }

    protected processSendAttErrorReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 考勤异常推送
     * @param jobNumber (optional) 
     * @param content (optional) 
     * @return Success
     */
    sendAttErrorReportPush(jobNumber: string | null | undefined, content: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/SendAttErrorReportPush?";
        if (jobNumber !== undefined && jobNumber !== null)
            url_ += "jobNumber=" + encodeURIComponent("" + jobNumber) + "&";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAttErrorReportPush(_response);
        });
    }

    protected processSendAttErrorReportPush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送邮件
     * @return Success
     */
    sendEmail( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 发送消息
     * @param jobNumber (optional) 
     * @return Success
     */
    sendMessage(jobNumber: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/SendMessage?";
        if (jobNumber !== undefined && jobNumber !== null)
            url_ += "jobNumber=" + encodeURIComponent("" + jobNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 消息推送测试
     * @return Success
     */
    sendSAppMessage( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/SendSAppMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSAppMessage(_response);
        });
    }

    protected processSendSAppMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 短信发送
     * @param phoneNumbers (optional) 
     * @return Success
     */
    sendSMS(phoneNumbers: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/SendSMS?";
        if (phoneNumbers !== undefined && phoneNumbers !== null)
            url_ += "phoneNumbers=" + encodeURIComponent("" + phoneNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSMS(_response);
        });
    }

    protected processSendSMS(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试权限
     * @return Success
     */
    testAuthority( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/TestAuthority";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestAuthority(_response);
        });
    }

    protected processTestAuthority(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 测试连通
     * @return Success
     */
    testConnect( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Test/TestConnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestConnect(_response);
        });
    }

    protected processTestConnect(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 测试Mysql存储过程
     * @param num (optional) 
     * @return Success
     */
    testMysqlStored(num: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/TestMysqlStored?";
        if (num === null)
            throw new Error("The parameter 'num' cannot be null.");
        else if (num !== undefined)
            url_ += "num=" + encodeURIComponent("" + num) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestMysqlStored(_response);
        });
    }

    protected processTestMysqlStored(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通知公告
     * @param newsId (optional) 
     * @return Success
     */
    testSendNewsMessage(newsId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/TestSendNewsMessage?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendNewsMessage(_response);
        });
    }

    protected processTestSendNewsMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 审核超时提醒
     * @return Success
     */
    testVerifyOverTime( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/TestVerifyOverTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestVerifyOverTime(_response);
        });
    }

    protected processTestVerifyOverTime(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 工作流推送
     * @param isOld (optional) 
     * @param body (optional) 
     * @return Success
     */
    wFPush(isOld: boolean | undefined, body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/WFPush?";
        if (isOld === null)
            throw new Error("The parameter 'isOld' cannot be null.");
        else if (isOld !== undefined)
            url_ += "isOld=" + encodeURIComponent("" + isOld) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWFPush(_response);
        });
    }

    protected processWFPush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * /工作流超时
     * @return Success
     */
    workflowOverTimeDep( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Test/WorkflowOverTimeDep";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWorkflowOverTimeDep(_response);
        });
    }

    protected processWorkflowOverTimeDep(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TextMessageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: TextMessageEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 每日邮件提醒
     * @param body (optional) 
     * @return Success
     */
    dailyMessageMessagePush(body: DailyMessageDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/DailyMessageMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageMessagePush(_response);
        });
    }

    protected processDailyMessageMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 每日邮件提醒数据处理
     * @return Success
     */
    dailyMessageMessagePushdata( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/DailyMessageMessagePushdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyMessageMessagePushdata(_response);
        });
    }

    protected processDailyMessageMessagePushdata(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 禁用
     * @param id (optional) 
     * @param enable (optional) 
     * @return Success
     */
    enable(id: number | undefined, enable: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/Enable?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (enable === null)
            throw new Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<TextMessageEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<TextMessageEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TextMessageEditDto.fromJS(resultData200);
            return Promise.resolve<TextMessageEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextMessageEditDto>(null as any);
    }

    /**
     * 获取分页数据
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTextMessageListDto> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTextMessageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTextMessageListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTextMessageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTextMessageListDto>(null as any);
    }

    /**
     * 问题修改通知APP端
     * @param body (optional) 
     * @return Success
     */
    issueEditMessagePushAPP(body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/IssueEditMessagePushAPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditMessagePushAPP(_response);
        });
    }

    protected processIssueEditMessagePushAPP(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题修改通知WEB端
     * @param body (optional) 
     * @return Success
     */
    issueEditMessagePushWeb(body: Issue | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/IssueEditMessagePushWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueEditMessagePushWeb(_response);
        });
    }

    protected processIssueEditMessagePushWeb(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题转办通知
     * @param body (optional) 
     * @return Success
     */
    issueTurnMessagePush(body: IssueTurnToListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/IssueTurnMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssueTurnMessagePush(_response);
        });
    }

    protected processIssueTurnMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新任务推送
     * @param body (optional) 
     * @return Success
     */
    newPlanMessagePush(body: AuditTaskListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/NewPlanMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewPlanMessagePush(_response);
        });
    }

    protected processNewPlanMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新问题推送
     * @param body (optional) 
     * @return Success
     */
    newProbMessagePush(body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/NewProbMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewProbMessagePush(_response);
        });
    }

    protected processNewProbMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新问题短信推送
     * @param body (optional) 
     * @return Success
     */
    newProbSmsMessagePush(body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/NewProbSmsMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewProbSmsMessagePush(_response);
        });
    }

    protected processNewProbSmsMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 新问题企业微信推送
     * @param body (optional) 
     * @return Success
     */
    newProbWeComMessagePush(body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/NewProbWeComMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewProbWeComMessagePush(_response);
        });
    }

    protected processNewProbWeComMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题进度更新通知
     * @param body (optional) 
     * @return Success
     */
    progressChangeMessagePushToAPPIssue(body: APPIssueListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/ProgressChangeMessagePushToAPPIssue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProgressChangeMessagePushToAPPIssue(_response);
        });
    }

    protected processProgressChangeMessagePushToAPPIssue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 问题进度更新通知
     * @param body (optional) 
     * @return Success
     */
    progressChangeMessagePushToIssueTurnTo(body: IssueTurnToListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/ProgressChangeMessagePushToIssueTurnTo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProgressChangeMessagePushToIssueTurnTo(_response);
        });
    }

    protected processProgressChangeMessagePushToIssueTurnTo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 计划转办通知
     * @param body (optional) 
     * @return Success
     */
    taskDetailTurnMessagePush(body: TaskDetailTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/TaskDetailTurnMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskDetailTurnMessagePush(_response);
        });
    }

    protected processTaskDetailTurnMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 计划转办通知
     * @param body (optional) 
     * @return Success
     */
    taskTurnMessagePush(body: TaskTurnListDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/TextMessage/TaskTurnMessagePush";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskTurnMessagePush(_response);
        });
    }

    protected processTaskTurnMessagePush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TimingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
            url_ += "selectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimezoneComboboxItems(_response);
        });
    }

    protected processGetTimezoneComboboxItems(response: AxiosResponse): Promise<ComboboxItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ComboboxItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ComboboxItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "defaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimezones(_response);
        });
    }

    protected processGetTimezones(response: AxiosResponse): Promise<ListResultDtoOfNameValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfNameValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfNameValueDto>(null as any);
    }
}

export class UploadServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 删除指定的文件
     * @param fileName (optional) 文件名
     * @param filedate (optional) 文件的日期
     * @param fileUrl (optional) 文件路径
     * @return Success
     */
    delete(fileName: string | null | undefined, filedate: moment.Moment | undefined, fileUrl: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Upload/Delete?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (filedate === null)
            throw new Error("The parameter 'filedate' cannot be null.");
        else if (filedate !== undefined)
            url_ += "filedate=" + encodeURIComponent(filedate ? "" + filedate.toISOString() : "") + "&";
        if (fileUrl !== undefined && fileUrl !== null)
            url_ += "fileUrl=" + encodeURIComponent("" + fileUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 上传
     * @param upLoadFileDto (optional) Dto
     * @return Success
     */
    getUpload(upLoadFileDto: UpLoadFileDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ReturnListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Upload/GetUpload?";
        if (upLoadFileDto !== undefined && upLoadFileDto !== null)
            upLoadFileDto && upLoadFileDto.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "upLoadFileDto[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpload(_response);
        });
    }

    protected processGetUpload(response: AxiosResponse): Promise<ReturnListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReturnListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReturnListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReturnListDto[]>(null as any);
    }
}

export class UserServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除用户
     * @param body (optional) 用户Id列表
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: CreateOrUpdateUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<User> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = User.fromJS(resultData200);
            return Promise.resolve<User>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 清空租户所有人的缓存
     * @return Success
     */
    emptyAllToken( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/EmptyAllToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmptyAllToken(_response);
        });
    }

    protected processEmptyAllToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 清空指定用户token
     * @param body (optional) 
     * @return Success
     */
    emptyUserToken(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/EmptyUserToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmptyUserToken(_response);
        });
    }

    protected processEmptyUserToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 获取入职周年清单
     * @param compantId (optional) 公司
     * @param denpartmentId (optional) 部门
     * @param year (optional) 年
     * @param month (optional) 月
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAnniversaryList(compantId: number | null | undefined, denpartmentId: number | null | undefined, year: string | null | undefined, month: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfBirthdayWishToUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAnniversaryList?";
        if (compantId !== undefined && compantId !== null)
            url_ += "compantId=" + encodeURIComponent("" + compantId) + "&";
        if (denpartmentId !== undefined && denpartmentId !== null)
            url_ += "denpartmentId=" + encodeURIComponent("" + denpartmentId) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnniversaryList(_response);
        });
    }

    protected processGetAnniversaryList(response: AxiosResponse): Promise<PagedResultDtoOfBirthdayWishToUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfBirthdayWishToUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfBirthdayWishToUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfBirthdayWishToUserListDto>(null as any);
    }

    /**
     * 获取生日祝福 清单
     * @param compantId (optional) 公司
     * @param denpartmentId (optional) 部门
     * @param year (optional) 年
     * @param month (optional) 月
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getBirthdayWishList(compantId: number | null | undefined, denpartmentId: number | null | undefined, year: string | null | undefined, month: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfBirthdayWishToUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetBirthdayWishList?";
        if (compantId !== undefined && compantId !== null)
            url_ += "compantId=" + encodeURIComponent("" + compantId) + "&";
        if (denpartmentId !== undefined && denpartmentId !== null)
            url_ += "denpartmentId=" + encodeURIComponent("" + denpartmentId) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBirthdayWishList(_response);
        });
    }

    protected processGetBirthdayWishList(response: AxiosResponse): Promise<PagedResultDtoOfBirthdayWishToUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfBirthdayWishToUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfBirthdayWishToUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfBirthdayWishToUserListDto>(null as any);
    }

    /**
     * 获取用户编辑信息
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<UserEditDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<UserEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserEditDto.fromJS(resultData200);
            return Promise.resolve<UserEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEditDto>(null as any);
    }

    /**
     * 修改用户信息
     * @param id (optional) 
     * @return Success
     */
    getForEditTree(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserForEditTreeOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetForEditTree?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEditTree(_response);
        });
    }

    protected processGetForEditTree(response: AxiosResponse): Promise<GetUserForEditTreeOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserForEditTreeOutput.fromJS(resultData200);
            return Promise.resolve<GetUserForEditTreeOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserForEditTreeOutput>(null as any);
    }

    /**
     * 获取登录账号分页接口
     * @param islock (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getLoginUserPage(islock: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetLoginUserPage?";
        if (islock === null)
            throw new Error("The parameter 'islock' cannot be null.");
        else if (islock !== undefined)
            url_ += "islock=" + encodeURIComponent("" + islock) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoginUserPage(_response);
        });
    }

    protected processGetLoginUserPage(response: AxiosResponse): Promise<PagedResultDtoOfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserListDto>(null as any);
    }

    /**
     * 分页获取所有用户
     * @param companyId (optional) 公司---------------------新增
     * @param departmentId (optional) 部门Id
     * @param hireDateStart (optional) 入职日期 开始-------------------新增
     * @param hireDateEnd (optional) 入职日期 结束-------------------新增
     * @param termDateStart (optional) 离职日期 开始-------------------新增
     * @param termDateEnd (optional) 离职日期 结束-------------------新增
     * @param departmentIds (optional) 部门Id集(多选)-------------------新增
     * @param empTypeId (optional) 员工类型-------------------新增
     * @param empStateId (optional) 员工状态-------------------新增
     * @param maritalStatusId (optional) 婚姻状态-------------------新增
     * @param permission (optional) 权限
     * @param role (optional) 检索角色Id列表
     * @param isEmailConfirmed (optional) 是否已验证邮箱
     * @param isActive (optional) 是否已激活
     * @param onlyLockedUsers (optional) 仅被锁定的用户
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(companyId: number | null | undefined, departmentId: number | null | undefined, hireDateStart: moment.Moment | null | undefined, hireDateEnd: moment.Moment | null | undefined, termDateStart: moment.Moment | null | undefined, termDateEnd: moment.Moment | null | undefined, departmentIds: string | null | undefined, empTypeId: string | null | undefined, empStateId: string | null | undefined, maritalStatusId: string | null | undefined, permission: string[] | null | undefined, role: number[] | null | undefined, isEmailConfirmed: boolean | null | undefined, isActive: boolean | null | undefined, onlyLockedUsers: boolean | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetPaged?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (hireDateStart !== undefined && hireDateStart !== null)
            url_ += "hireDateStart=" + encodeURIComponent(hireDateStart ? "" + hireDateStart.toISOString() : "") + "&";
        if (hireDateEnd !== undefined && hireDateEnd !== null)
            url_ += "hireDateEnd=" + encodeURIComponent(hireDateEnd ? "" + hireDateEnd.toISOString() : "") + "&";
        if (termDateStart !== undefined && termDateStart !== null)
            url_ += "termDateStart=" + encodeURIComponent(termDateStart ? "" + termDateStart.toISOString() : "") + "&";
        if (termDateEnd !== undefined && termDateEnd !== null)
            url_ += "termDateEnd=" + encodeURIComponent(termDateEnd ? "" + termDateEnd.toISOString() : "") + "&";
        if (departmentIds !== undefined && departmentIds !== null)
            url_ += "departmentIds=" + encodeURIComponent("" + departmentIds) + "&";
        if (empTypeId !== undefined && empTypeId !== null)
            url_ += "empTypeId=" + encodeURIComponent("" + empTypeId) + "&";
        if (empStateId !== undefined && empStateId !== null)
            url_ += "empStateId=" + encodeURIComponent("" + empStateId) + "&";
        if (maritalStatusId !== undefined && maritalStatusId !== null)
            url_ += "maritalStatusId=" + encodeURIComponent("" + maritalStatusId) + "&";
        if (permission !== undefined && permission !== null)
            permission && permission.forEach(item => { url_ += "permission=" + encodeURIComponent("" + item) + "&"; });
        if (role !== undefined && role !== null)
            role && role.forEach(item => { url_ += "role=" + encodeURIComponent("" + item) + "&"; });
        if (isEmailConfirmed !== undefined && isEmailConfirmed !== null)
            url_ += "isEmailConfirmed=" + encodeURIComponent("" + isEmailConfirmed) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "onlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserListDto>(null as any);
    }

    /**
     * 正常参数分页接口
     * @param companyId (optional) 公司Id
     * @param departmentId (optional) 部门Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPageList(companyId: number | null | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetPageList?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageList(_response);
        });
    }

    protected processGetPageList(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * 根据部门获取用户分页列表
     * @param companyId (optional) 公司Id
     * @param depId (optional) 部门Id
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPageListByDepId(companyId: number | null | undefined, depId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetPageListByDepId?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (depId !== undefined && depId !== null)
            url_ += "depId=" + encodeURIComponent("" + depId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPageListByDepId(_response);
        });
    }

    protected processGetPageListByDepId(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * 用户的权限编辑
     * @param id (optional) 
     * @return Success
     */
    getPermissionsTreeForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserPermissionsTreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetPermissionsTreeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPermissionsTreeForEdit(_response);
        });
    }

    protected processGetPermissionsTreeForEdit(response: AxiosResponse): Promise<GetUserPermissionsTreeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserPermissionsTreeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserPermissionsTreeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserPermissionsTreeForEditOutput>(null as any);
    }

    /**
     * 下载导入模板
     * @return Success
     */
    getToImportTempFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetToImportTempFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToImportTempFile(_response);
        });
    }

    protected processGetToImportTempFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 根据用户Id获取用户档案
     * @param userId (optional) 
     * @return Success
     */
    getUserArchiverByUserId(userId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<UserArchiverDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserArchiverByUserId?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserArchiverByUserId(_response);
        });
    }

    protected processGetUserArchiverByUserId(response: AxiosResponse): Promise<UserArchiverDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserArchiverDto.fromJS(resultData200);
            return Promise.resolve<UserArchiverDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserArchiverDto>(null as any);
    }

    /**
     * 根据用户Id获取用户
     * @param userId (optional) 
     * @return Success
     */
    getUserById(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<EmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserById?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<EmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeListDto.fromJS(resultData200);
            return Promise.resolve<EmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserForEdit(_response);
        });
    }

    protected processGetUserForEdit(response: AxiosResponse): Promise<GetUserForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserForEditOutput>(null as any);
    }

    /**
     * 获取用户列表
     * @return Success
     */
    getUserList( cancelToken?: CancelToken | undefined): Promise<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserList(_response);
        });
    }

    protected processGetUserList(response: AxiosResponse): Promise<UserListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListDto[]>(null as any);
    }

    /**
     * 获取公司员工排除指定部门的人员(添加兼职人员)
     * @param companyId (optional) 公司Id
     * @param departmentId (optional) 部门Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserPageListByDep(companyId: number | null | undefined, departmentId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPageListByDep?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPageListByDep(_response);
        });
    }

    protected processGetUserPageListByDep(response: AxiosResponse): Promise<PagedResultDtoOfEmployeeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfEmployeeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfEmployeeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfEmployeeListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissionsForEdit(_response);
        });
    }

    protected processGetUserPermissionsForEdit(response: AxiosResponse): Promise<GetUserPermissionsForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserPermissionsForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserPermissionsForEditOutput>(null as any);
    }

    /**
     * 获取用户导出信息
     * @return Success
     */
    getUsersToExcel( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersToExcel(_response);
        });
    }

    protected processGetUsersToExcel(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 导入数据
     * @param fileName (optional) 
     * @return Success
     */
    importExcel(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: NullableIdDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetSpecificPermissions(body: EntityDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetSpecificPermissions(_response);
        });
    }

    protected processResetSpecificPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过企业微信发送通知消息给指定用户
     * @param body (optional) 
     * @return Success
     */
    sendWeComNotification(body: SendWeComNotificationInput | undefined, cancelToken?: CancelToken | undefined): Promise<SendWeComNotificationOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/SendWeComNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendWeComNotification(_response);
        });
    }

    protected processSendWeComNotification(response: AxiosResponse): Promise<SendWeComNotificationOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendWeComNotificationOutput.fromJS(resultData200);
            return Promise.resolve<SendWeComNotificationOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendWeComNotificationOutput>(null as any);
    }

    /**
     * 同步企业微信员工到系统用户（回写 WeComUserId）
     * @return Success
     */
    syncWeComUsers( cancelToken?: CancelToken | undefined): Promise<SyncWeComUsersOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/SyncWeComUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncWeComUsers(_response);
        });
    }

    protected processSyncWeComUsers(response: AxiosResponse): Promise<SyncWeComUsersOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyncWeComUsersOutput.fromJS(resultData200);
            return Promise.resolve<SyncWeComUsersOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyncWeComUsersOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlock(body: EntityDtoOfInt64 | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Unlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlock(_response);
        });
    }

    protected processUnlock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePermissions(body: UpdateUserPermissionsInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdatePermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePermissions(_response);
        });
    }

    protected processUpdatePermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除用户
     * @param body (optional) 
     * @return Success
     */
    userDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UserDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserDelete(_response);
        });
    }

    protected processUserDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 修改用户信息
     * @param body (optional) 
     * @return Success
     */
    userInfoUpdate(body: UserEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UserInfoUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserInfoUpdate(_response);
        });
    }

    protected processUserInfoUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserChangeLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除UserChangeLog的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateUserChangeLogInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取UserChangeLogListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<UserChangeLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserChangeLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserChangeLogListDto.fromJS(resultData200);
            return Promise.resolve<UserChangeLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserChangeLogListDto>(null as any);
    }

    /**
     * 获取转正记录列表
     * @param deparmentId (optional) 
     * @param companyId (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getCorrectionlogList(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserChangeLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetCorrectionlogList?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCorrectionlogList(_response);
        });
    }

    protected processGetCorrectionlogList(response: AxiosResponse): Promise<PagedResultDtoOfUserChangeLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserChangeLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(null as any);
    }

    /**
     * 获取入职记录列表
     * @param deparmentId (optional) 
     * @param companyId (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntryLogList(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserChangeLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetEntryLogList?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntryLogList(_response);
        });
    }

    protected processGetEntryLogList(response: AxiosResponse): Promise<PagedResultDtoOfUserChangeLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserChangeLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserChangeLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetUserChangeLogForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserChangeLogForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserChangeLogForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserChangeLogForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param deparmentId (optional) 
     * @param companyId (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserChangeLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetPaged?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfUserChangeLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserChangeLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(null as any);
    }

    /**
     * 获取离职记录列表
     * @param deparmentId (optional) 
     * @param companyId (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getResignlogList(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserChangeLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetResignlogList?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResignlogList(_response);
        });
    }

    protected processGetResignlogList(response: AxiosResponse): Promise<PagedResultDtoOfUserChangeLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserChangeLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取调岗记录列表
     * @param deparmentId (optional) 
     * @param companyId (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTransferlogList(deparmentId: number | null | undefined, companyId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserChangeLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserChangeLog/GetTransferlogList?";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransferlogList(_response);
        });
    }

    protected processGetTransferlogList(response: AxiosResponse): Promise<PagedResultDtoOfUserChangeLogListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserChangeLogListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserChangeLogListDto>(null as any);
    }
}

export class UserDepPluralismServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量增加部门兼职人员数据
     * @param body (optional) 
     * @return Success
     */
    addDepUsers(body: AddUserDepInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/AddDepUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDepUsers(_response);
        });
    }

    protected processAddDepUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量添加部门兼职人员
     * @param body (optional) 
     * @return Success
     */
    batchCreateDepUsers(body: AddDepUsersDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/BatchCreateDepUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchCreateDepUsers(_response);
        });
    }

    protected processBatchCreateDepUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除UserDepPluralism的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateUserDepPluralismInput[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取UserDepPluralismListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<UserDepPluralismListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserDepPluralismListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDepPluralismListDto.fromJS(resultData200);
            return Promise.resolve<UserDepPluralismListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDepPluralismListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserDepPluralismForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetUserDepPluralismForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDepPluralismForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserDepPluralismForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDepPluralismForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param departmentId (optional) 部门Id
     * @param companyId (optional) 公司Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(departmentId: number | null | undefined, companyId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserDepPluralismListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/GetPaged?";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfUserDepPluralismListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserDepPluralismListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserDepPluralismListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserDepPluralismListDto>(null as any);
    }

    /**
     * 根据公司或者部门获取部门兼职人员
     * @param departmentId (optional) 部门Id
     * @param companyId (optional) 公司Id
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedDepUsers(departmentId: number | null | undefined, companyId: number | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserDepListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/GetPagedDepUsers?";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedDepUsers(_response);
        });
    }

    protected processGetPagedDepUsers(response: AxiosResponse): Promise<PagedResultDtoOfUserDepListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserDepListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserDepListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserDepListDto>(null as any);
    }

    /**
     * 根据公司或者部门获取部门所有人员，包含兼职(给角色用的)
     * @param departmentId (optional) 部门Id
     * @param companyId (optional) 公司Id
     * @param source (optional) 引用弹窗的来源 vue 发起流程的页面 或者 角色选择人员的页面
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getRolePagedAllUsers(departmentId: number | null | undefined, companyId: number | null | undefined, source: string | null | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfRoleUserDepListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/GetRolePagedAllUsers?";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolePagedAllUsers(_response);
        });
    }

    protected processGetRolePagedAllUsers(response: AxiosResponse): Promise<PagedResultDtoOfRoleUserDepListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfRoleUserDepListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfRoleUserDepListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfRoleUserDepListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDepPluralism/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class UserDownloadConfigServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除UserDownloadConfig的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDownloadConfig/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改UserDownloadConfig的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateUserDownloadConfigInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDownloadConfig/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除UserDownloadConfig信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDownloadConfig/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取UserDownloadConfigListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<UserDownloadConfigListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDownloadConfig/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserDownloadConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDownloadConfigListDto.fromJS(resultData200);
            return Promise.resolve<UserDownloadConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDownloadConfigListDto>(null as any);
    }

    /**
     * 获取编辑 UserDownloadConfig
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserDownloadConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserDownloadConfig/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetUserDownloadConfigForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDownloadConfigForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserDownloadConfigForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDownloadConfigForEditOutput>(null as any);
    }

    /**
     * 获取UserDownloadConfig的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserDownloadConfigListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDownloadConfig/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfUserDownloadConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserDownloadConfigListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserDownloadConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserDownloadConfigListDto>(null as any);
    }
}

export class UserEmailerServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 发送加班超额邮件
     * @param emailAddress (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendEamilExceedOverTime(emailAddress: string | null | undefined, body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/SendEamilExceedOverTime?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEamilExceedOverTime(_response);
        });
    }

    protected processSendEamilExceedOverTime(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send email activation link to user's email address.
     * @param link (optional) Email activation link
     * @param plainPassword (optional) Can be set to user's plain password to include it in the email.
     * @param body (optional) User
     * @return Success
     */
    sendEmailActivationLink(link: string | null | undefined, plainPassword: string | null | undefined, body: User | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/SendEmailActivationLink?";
        if (link !== undefined && link !== null)
            url_ += "link=" + encodeURIComponent("" + link) + "&";
        if (plainPassword !== undefined && plainPassword !== null)
            url_ += "plainPassword=" + encodeURIComponent("" + plainPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailActivationLink(_response);
        });
    }

    protected processSendEmailActivationLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param code (optional) 
     * @return Success
     */
    sendEmailAddressConfirmCode(emailAddress: string | null | undefined, code: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/SendEmailAddressConfirmCode?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailAddressConfirmCode(_response);
        });
    }

    protected processSendEmailAddressConfirmCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sends a password reset link to user's email.
     * @param link (optional) Reset link
     * @param body (optional) User
     * @return Success
     */
    sendPasswordResetLink(link: string | null | undefined, body: SendPasswordResetLinkDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/SendPasswordResetLink?";
        if (link !== undefined && link !== null)
            url_ += "link=" + encodeURIComponent("" + link) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendPasswordResetLink(_response);
        });
    }

    protected processSendPasswordResetLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param utcNow (optional) 
     * @param body (optional) 
     * @return Success
     */
    tryToSendFailedSubscriptionTerminationsEmail(utcNow: moment.Moment | undefined, body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/TryToSendFailedSubscriptionTerminationsEmail?";
        if (utcNow === null)
            throw new Error("The parameter 'utcNow' cannot be null.");
        else if (utcNow !== undefined)
            url_ += "utcNow=" + encodeURIComponent(utcNow ? "" + utcNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTryToSendFailedSubscriptionTerminationsEmail(_response);
        });
    }

    protected processTryToSendFailedSubscriptionTerminationsEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param utcNow (optional) 
     * @param expiringEditionId (optional) 
     * @return Success
     */
    tryToSendSubscriptionAssignedToAnotherEmail(tenantId: number | undefined, utcNow: moment.Moment | undefined, expiringEditionId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/TryToSendSubscriptionAssignedToAnotherEmail?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (utcNow === null)
            throw new Error("The parameter 'utcNow' cannot be null.");
        else if (utcNow !== undefined)
            url_ += "utcNow=" + encodeURIComponent(utcNow ? "" + utcNow.toISOString() : "") + "&";
        if (expiringEditionId === null)
            throw new Error("The parameter 'expiringEditionId' cannot be null.");
        else if (expiringEditionId !== undefined)
            url_ += "expiringEditionId=" + encodeURIComponent("" + expiringEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTryToSendSubscriptionAssignedToAnotherEmail(_response);
        });
    }

    protected processTryToSendSubscriptionAssignedToAnotherEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param utcNow (optional) 
     * @return Success
     */
    tryToSendSubscriptionExpireEmail(tenantId: number | undefined, utcNow: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/TryToSendSubscriptionExpireEmail?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (utcNow === null)
            throw new Error("The parameter 'utcNow' cannot be null.");
        else if (utcNow !== undefined)
            url_ += "utcNow=" + encodeURIComponent(utcNow ? "" + utcNow.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTryToSendSubscriptionExpireEmail(_response);
        });
    }

    protected processTryToSendSubscriptionExpireEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param dateToCheckRemainingDayCount (optional) 
     * @return Success
     */
    tryToSendSubscriptionExpiringSoonEmail(tenantId: number | undefined, dateToCheckRemainingDayCount: moment.Moment | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEmailer/TryToSendSubscriptionExpiringSoonEmail?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (dateToCheckRemainingDayCount === null)
            throw new Error("The parameter 'dateToCheckRemainingDayCount' cannot be null.");
        else if (dateToCheckRemainingDayCount !== undefined)
            url_ += "dateToCheckRemainingDayCount=" + encodeURIComponent(dateToCheckRemainingDayCount ? "" + dateToCheckRemainingDayCount.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTryToSendSubscriptionExpiringSoonEmail(_response);
        });
    }

    protected processTryToSendSubscriptionExpiringSoonEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserEntryApiServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 身份证检验并返回籍贯、生日、性别
     * @param identityCard (optional) 
     * @return Success
     */
    identityCardValidated(identityCard: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<IdentityCardValidatedDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntryApi/IdentityCardValidated?";
        if (identityCard !== undefined && identityCard !== null)
            url_ += "identityCard=" + encodeURIComponent("" + identityCard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIdentityCardValidated(_response);
        });
    }

    protected processIdentityCardValidated(response: AxiosResponse): Promise<IdentityCardValidatedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityCardValidatedDto.fromJS(resultData200);
            return Promise.resolve<IdentityCardValidatedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityCardValidatedDto>(null as any);
    }

    /**
     * 扫码入职接口
     * @param body (optional) 
     * @return Success
     */
    newUserEntry(body: UserEntryEditModel | undefined, cancelToken?: CancelToken | undefined): Promise<ResultInfo> {
        let url_ = this.baseUrl + "/api/services/app/UserEntryApi/NewUserEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewUserEntry(_response);
        });
    }

    protected processNewUserEntry(response: AxiosResponse): Promise<ResultInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResultInfo.fromJS(resultData200);
            return Promise.resolve<ResultInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResultInfo>(null as any);
    }
}

export class UserLinkServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedUsers(_response);
        });
    }

    protected processGetLinkedUsers(response: AxiosResponse): Promise<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfLinkedUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfLinkedUserDto>(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecentlyUsedLinkedUsers(_response);
        });
    }

    protected processGetRecentlyUsedLinkedUsers(response: AxiosResponse): Promise<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfLinkedUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfLinkedUserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkToUser(_response);
        });
    }

    protected processLinkToUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlinkUser(_response);
        });
    }

    protected processUnlinkUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserLoginServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts( cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecentUserLoginAttempts(_response);
        });
    }

    protected processGetRecentUserLoginAttempts(response: AxiosResponse): Promise<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfUserLoginAttemptDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfUserLoginAttemptDto>(null as any);
    }
}

export class UserPlanExportingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 导出错误数据
     * @param body (optional) 
     * @return Success
     */
    errorToExcelFile(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserPlanExporting/ErrorToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processErrorToExcelFile(_response);
        });
    }

    protected processErrorToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToExcelFile(body: UserPlanExportingDto | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserPlanExporting/ExportToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToExcelFile(_response);
        });
    }

    protected processExportToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class UserPlanImportServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param fileName (optional) 
     * @return Success
     */
    importExcel(fileName: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<UserShiftPlanImportDto> {
        let url_ = this.baseUrl + "/api/services/app/UserPlanImport/ImportExcel?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<UserShiftPlanImportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserShiftPlanImportDto.fromJS(resultData200);
            return Promise.resolve<UserShiftPlanImportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserShiftPlanImportDto>(null as any);
    }
}

export class UserRelationServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量添加岗位人员信息
     * @param body (optional) 
     * @return Success
     */
    addPostUsers(body: AddPostUsersDot | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/AddPostUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPostUsers(_response);
        });
    }

    protected processAddPostUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除UserRelation的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 批量删除UserDepPluralism的方法
     * @param body (optional) 
     * @return Success
     */
    batchDeleteUsers(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/BatchDeleteUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDeleteUsers(_response);
        });
    }

    protected processBatchDeleteUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateUserRelationInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取UserRelationListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<UserRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserRelationListDto.fromJS(resultData200);
            return Promise.resolve<UserRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRelationListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserRelationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetUserRelationForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserRelationForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetUserRelationForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserRelationForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param id (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(id: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/GetPaged?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfUserRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserRelationListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserRelationListDto>(null as any);
    }

    /**
     * 岗位兼职人员
     * @param id (optional) 
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPagedOrganizationUnitUsers(id: number | undefined, filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfUserRelationListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/GetPagedOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedOrganizationUnitUsers(_response);
        });
    }

    protected processGetPagedOrganizationUnitUsers(response: AxiosResponse): Promise<PagedResultDtoOfUserRelationListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfUserRelationListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfUserRelationListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfUserRelationListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRelation/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class UserShiftPlanServiceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量调班
     * @param body (optional) 
     * @return Success
     */
    batchUserShiftPlanChange(body: UserShiftPlanChangeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/BatchUserShiftPlanChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUserShiftPlanChange(_response);
        });
    }

    protected processBatchUserShiftPlanChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 清空
     * @param body (optional) 
     * @return Success
     */
    emptyPlan(body: UserShiftPlanByCodeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/EmptyPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmptyPlan(_response);
        });
    }

    protected processEmptyPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 下载导入模板
     * @param body (optional) 
     * @return Success
     */
    exportTemplate(body: ExportTemplateInput | undefined, cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/ExportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取班次集合
     * @param attGroupId (optional) 
     * @return Success
     */
    getShiftInfoListByAttGroupId(attGroupId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<ShiftInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/GetShiftInfoListByAttGroupId?";
        if (attGroupId !== undefined && attGroupId !== null)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShiftInfoListByAttGroupId(_response);
        });
    }

    protected processGetShiftInfoListByAttGroupId(response: AxiosResponse): Promise<ShiftInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShiftInfoListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShiftInfoListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShiftInfoListDto[]>(null as any);
    }

    /**
     * 获取员工排班计划
     * @param filterText (optional) 
     * @param startTime (optional) 开始日期
     * @param endTime (optional) 结束日期
     * @param companyId (optional) 公司
     * @param deparmentId (optional) 部门
     * @param unshift (optional) 是否查询未排班
     * @param attGroupId (optional) 考勤组Id
     * @param unCheckEmp (optional) 未分组查询
     * @return Success
     */
    getUsreShiftPlanList(filterText: string | null | undefined, startTime: string | null | undefined, endTime: string | null | undefined, companyId: number | undefined, deparmentId: string | null | undefined, unshift: boolean | undefined, attGroupId: string | null | undefined, unCheckEmp: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<GetUserShiftPlanDto> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/GetUsreShiftPlanList?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent("" + startTime) + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent("" + endTime) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (deparmentId !== undefined && deparmentId !== null)
            url_ += "deparmentId=" + encodeURIComponent("" + deparmentId) + "&";
        if (unshift === null)
            throw new Error("The parameter 'unshift' cannot be null.");
        else if (unshift !== undefined)
            url_ += "unshift=" + encodeURIComponent("" + unshift) + "&";
        if (attGroupId !== undefined && attGroupId !== null)
            url_ += "attGroupId=" + encodeURIComponent("" + attGroupId) + "&";
        if (unCheckEmp === null)
            throw new Error("The parameter 'unCheckEmp' cannot be null.");
        else if (unCheckEmp !== undefined)
            url_ += "unCheckEmp=" + encodeURIComponent("" + unCheckEmp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsreShiftPlanList(_response);
        });
    }

    protected processGetUsreShiftPlanList(response: AxiosResponse): Promise<GetUserShiftPlanDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserShiftPlanDto.fromJS(resultData200);
            return Promise.resolve<GetUserShiftPlanDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserShiftPlanDto>(null as any);
    }

    /**
     * 导入员工排班
     * @param body (optional) 
     * @return Success
     */
    importEmpShiftPlan(body: UserPlanImportInput | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/ImportEmpShiftPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportEmpShiftPlan(_response);
        });
    }

    protected processImportEmpShiftPlan(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * 导入员工排班(已废弃)
     * @param body (optional) 
     * @return Success
     */
    importExcel(body: UserPlanImportInput | undefined, cancelToken?: CancelToken | undefined): Promise<ImportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/ImportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ImportResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportResultDto.fromJS(resultData200);
            return Promise.resolve<ImportResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportResultDto>(null as any);
    }

    /**
     * 顺延,节假日班次代码顺延到下一天
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param userId (optional) 
     * @param codeIndex (optional) 
     * @param body (optional) 
     * @return Success
     */
    postponement(startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, userId: number | undefined, codeIndex: number | undefined, body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/Postponement?";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (codeIndex === null)
            throw new Error("The parameter 'codeIndex' cannot be null.");
        else if (codeIndex !== undefined)
            url_ += "codeIndex=" + encodeURIComponent("" + codeIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostponement(_response);
        });
    }

    protected processPostponement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 按天排班
     * @param body (optional) 
     * @return Success
     */
    updateUserShiftCode(body: UserShiftPlanByCodeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/UpdateUserShiftCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserShiftCode(_response);
        });
    }

    protected processUpdateUserShiftCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 周期排班
     * @param body (optional) 
     * @return Success
     */
    updateUserShiftPlanByCycle(body: UserShiftPlanByCycleInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/UserShiftPlanService/UpdateUserShiftPlanByCycle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserShiftPlanByCycle(_response);
        });
    }

    protected processUpdateUserShiftPlanByCycle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VideoResourceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除VideoResource的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改VideoResource的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateVideoResourceInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除VideoResource信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取VideoResourceListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<VideoResourceListDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VideoResourceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoResourceListDto.fromJS(resultData200);
            return Promise.resolve<VideoResourceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoResourceListDto>(null as any);
    }

    /**
     * 获取编辑 VideoResource
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetVideoResourceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetVideoResourceForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVideoResourceForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetVideoResourceForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVideoResourceForEditOutput>(null as any);
    }

    /**
     * 获取VideoResource的分页列表信息
     * @param body (optional) 
     * @return Success
     */
    getPaged(body: QueryInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfVideoResourceListDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/GetPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfVideoResourceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfVideoResourceListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfVideoResourceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfVideoResourceListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVideoResourcePlayAuth(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<VideoPlayAuthDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/GetVideoResourcePlayAuth?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideoResourcePlayAuth(_response);
        });
    }

    protected processGetVideoResourcePlayAuth(response: AxiosResponse): Promise<VideoPlayAuthDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoPlayAuthDto.fromJS(resultData200);
            return Promise.resolve<VideoPlayAuthDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoPlayAuthDto>(null as any);
    }

    /**
     * @return Success
     */
    getVodTest( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/GetVodTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVodTest(_response);
        });
    }

    protected processGetVodTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchVideoResources(body: SearchVideoResourceInput | undefined, cancelToken?: CancelToken | undefined): Promise<ListResultDtoOfVideoResourceListDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/SearchVideoResources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchVideoResources(_response);
        });
    }

    protected processSearchVideoResources(response: AxiosResponse): Promise<ListResultDtoOfVideoResourceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultDtoOfVideoResourceListDto.fromJS(resultData200);
            return Promise.resolve<ListResultDtoOfVideoResourceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultDtoOfVideoResourceListDto>(null as any);
    }

    /**
     * 同步阿里云视频
     * @return Success
     */
    synchronizeAliyunVod( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VideoResource/SynchronizeAliyunVod";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynchronizeAliyunVod(_response);
        });
    }

    protected processSynchronizeAliyunVod(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WebSiteLogServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 下载日志文件压缩包
     * @return Success
     */
    downloadWebLogs( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadWebLogs(_response);
        });
    }

    protected processDownloadWebLogs(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }

    /**
     * 获取最新的网站日志信息
     * @return Success
     */
    getLatestWebLogs( cancelToken?: CancelToken | undefined): Promise<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestWebLogs(_response);
        });
    }

    protected processGetLatestWebLogs(response: AxiosResponse): Promise<GetLatestWebLogsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return Promise.resolve<GetLatestWebLogsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLatestWebLogsOutput>(null as any);
    }
}

export class WebSiteNoticeServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除WebSiteNotice的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteNotice/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改网站公告的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateWebSiteNoticeInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteNotice/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除网站公告信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteNotice/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取WebSiteNoticeListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<WebSiteNoticeListDto> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteNotice/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<WebSiteNoticeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebSiteNoticeListDto.fromJS(resultData200);
            return Promise.resolve<WebSiteNoticeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebSiteNoticeListDto>(null as any);
    }

    /**
     * 获取编辑 网站公告
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetWebSiteNoticeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteNotice/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetWebSiteNoticeForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWebSiteNoticeForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetWebSiteNoticeForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWebSiteNoticeForEditOutput>(null as any);
    }

    /**
     * 获取网站公告的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfWebSiteNoticeListDto> {
        let url_ = this.baseUrl + "/api/services/app/WebSiteNotice/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfWebSiteNoticeListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfWebSiteNoticeListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfWebSiteNoticeListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfWebSiteNoticeListDto>(null as any);
    }
}

export class WechatAppConfigServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除WechatAppConfig的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改WechatAppConfig的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateWechatAppConfigInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除WechatAppConfig信息的方法
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取WechatAppConfigListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<WechatAppConfigListDto> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<WechatAppConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WechatAppConfigListDto.fromJS(resultData200);
            return Promise.resolve<WechatAppConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WechatAppConfigListDto>(null as any);
    }

    /**
     * 获取编辑 WechatAppConfig
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetWechatAppConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetWechatAppConfigForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWechatAppConfigForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetWechatAppConfigForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWechatAppConfigForEditOutput>(null as any);
    }

    /**
     * 获取WechatAppConfig的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfWechatAppConfigListDto> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfWechatAppConfigListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfWechatAppConfigListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfWechatAppConfigListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfWechatAppConfigListDto>(null as any);
    }

    /**
     * 将wechat app注入到容器,如果已注入则刷新注入
     * @param appId (optional) 
     * @return Success
     */
    registerWechatApp(appId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatAppConfig/RegisterWechatApp?";
        if (appId !== undefined && appId !== null)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterWechatApp(_response);
        });
    }

    protected processRegisterWechatApp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WechatMediaServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    createOtherrMaterial( cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/WechatMedia/CreateOtherrMaterial";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOtherrMaterial(_response);
        });
    }

    protected processCreateOtherrMaterial(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param appId (optional) 
     * @param mediaId (optional) 
     * @return Success
     */
    delete(appId: string | null | undefined, mediaId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatMedia/Delete?";
        if (appId !== undefined && appId !== null)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        if (mediaId !== undefined && mediaId !== null)
            url_ += "mediaId=" + encodeURIComponent("" + mediaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImageTextMaterialPaged(body: GetImageTextMaterialsInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfMediaList_News_Item> {
        let url_ = this.baseUrl + "/api/services/app/WechatMedia/GetImageTextMaterialPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImageTextMaterialPaged(_response);
        });
    }

    protected processGetImageTextMaterialPaged(response: AxiosResponse): Promise<PagedResultDtoOfMediaList_News_Item> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfMediaList_News_Item.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfMediaList_News_Item>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfMediaList_News_Item>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOtherMaterialPaged(body: GetOtherMaterialsInput | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfMediaList_Others_Item> {
        let url_ = this.baseUrl + "/api/services/app/WechatMedia/GetOtherMaterialPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOtherMaterialPaged(_response);
        });
    }

    protected processGetOtherMaterialPaged(response: AxiosResponse): Promise<PagedResultDtoOfMediaList_Others_Item> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfMediaList_Others_Item.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfMediaList_Others_Item>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfMediaList_Others_Item>(null as any);
    }
}

export class WechatMenuAppSeviceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrWechatEditMenu(body: CreateOrEditWechatMenuInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatMenuAppSevice/CreateOrWechatEditMenu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrWechatEditMenu(_response);
        });
    }

    protected processCreateOrWechatEditMenu(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param appId (optional) 
     * @param menuConditionalId (optional) 
     * @return Success
     */
    deleteMenuConditional(appId: string | null | undefined, menuConditionalId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WechatMenuAppSevice/DeleteMenuConditional?";
        if (appId !== undefined && appId !== null)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        if (menuConditionalId !== undefined && menuConditionalId !== null)
            url_ += "menuConditionalId=" + encodeURIComponent("" + menuConditionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMenuConditional(_response);
        });
    }

    protected processDeleteMenuConditional(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param appId (optional) 
     * @return Success
     */
    getMenuForEdit(appId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetWechatMenuForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WechatMenuAppSevice/GetMenuForEdit?";
        if (appId !== undefined && appId !== null)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMenuForEdit(_response);
        });
    }

    protected processGetMenuForEdit(response: AxiosResponse): Promise<GetWechatMenuForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWechatMenuForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetWechatMenuForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWechatMenuForEditOutput>(null as any);
    }
}

export class WeComMessageServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: TextMessageEditDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WeComMessage/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param enable (optional) 
     * @return Success
     */
    enable(id: number | undefined, enable: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WeComMessage/Enable?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (enable === null)
            throw new Error("The parameter 'enable' cannot be null.");
        else if (enable !== undefined)
            url_ += "enable=" + encodeURIComponent("" + enable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<TextMessageEditDto> {
        let url_ = this.baseUrl + "/api/services/app/WeComMessage/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<TextMessageEditDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TextMessageEditDto.fromJS(resultData200);
            return Promise.resolve<TextMessageEditDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TextMessageEditDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfTextMessageListDto> {
        let url_ = this.baseUrl + "/api/services/app/WeComMessage/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfTextMessageListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfTextMessageListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfTextMessageListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfTextMessageListDto>(null as any);
    }
}

export class WorkExperienceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除WorkExperience的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改工作经验的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateWorkExperienceInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除工作经验信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取WorkExperienceListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<WorkExperienceListDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<WorkExperienceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkExperienceListDto.fromJS(resultData200);
            return Promise.resolve<WorkExperienceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkExperienceListDto>(null as any);
    }

    /**
     * 获取编辑 工作经验
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetWorkExperienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetWorkExperienceForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWorkExperienceForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetWorkExperienceForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWorkExperienceForEditOutput>(null as any);
    }

    /**
     * 根据用户Id获取工作经验列表
     * @param userId (optional) 
     * @return Success
     */
    getListByUserId(userId: number | undefined, cancelToken?: CancelToken | undefined): Promise<WorkExperienceListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/GetListByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByUserId(_response);
        });
    }

    protected processGetListByUserId(response: AxiosResponse): Promise<WorkExperienceListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WorkExperienceListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WorkExperienceListDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkExperienceListDto[]>(null as any);
    }

    /**
     * 获取工作经验的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfWorkExperienceListDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfWorkExperienceListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfWorkExperienceListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfWorkExperienceListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfWorkExperienceListDto>(null as any);
    }

    /**
     * 导出工作经验为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkExperience/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class WorkflowTriggerServiceServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 触发工作流创建
     * @param issueId (optional) 问题ID
     * @return Success
     */
    triggerWorkflow(issueId: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkflowTriggerService/TriggerWorkflow?";
        if (issueId === null)
            throw new Error("The parameter 'issueId' cannot be null.");
        else if (issueId !== undefined)
            url_ += "issueId=" + encodeURIComponent("" + issueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerWorkflow(_response);
        });
    }

    protected processTriggerWorkflow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkYearsQuotaServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量删除WorkYearsQuota的方法
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 添加或者修改的公共方法
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateWorkYearsQuotaInput | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdate(_response);
        });
    }

    protected processCreateOrUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 删除信息
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * 通过指定id获取WorkYearsQuotaListDto信息
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<WorkYearsQuotaListDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<WorkYearsQuotaListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorkYearsQuotaListDto.fromJS(resultData200);
            return Promise.resolve<WorkYearsQuotaListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkYearsQuotaListDto>(null as any);
    }

    /**
     * 获取编辑
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<GetWorkYearsQuotaForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForEdit(_response);
        });
    }

    protected processGetForEdit(response: AxiosResponse): Promise<GetWorkYearsQuotaForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWorkYearsQuotaForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetWorkYearsQuotaForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWorkYearsQuotaForEditOutput>(null as any);
    }

    /**
     * 获取的分页列表信息
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaged(filterText: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined, cancelToken?: CancelToken | undefined): Promise<PagedResultDtoOfWorkYearsQuotaListDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/GetPaged?";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PagedResultDtoOfWorkYearsQuotaListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoOfWorkYearsQuotaListDto.fromJS(resultData200);
            return Promise.resolve<PagedResultDtoOfWorkYearsQuotaListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoOfWorkYearsQuotaListDto>(null as any);
    }

    /**
     * 导出为excel文件
     * @return Success
     */
    getToExcelFile( cancelToken?: CancelToken | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkYearsQuota/GetToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetToExcelFile(_response);
        });
    }

    protected processGetToExcelFile(response: AxiosResponse): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileDto.fromJS(resultData200);
            return Promise.resolve<FileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class ZkDataDockingServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * 批量同步部门数据
     * @return Success
     */
    zkBatchDepartment( cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkBatchDepartment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkBatchDepartment(_response);
        });
    }

    protected processZkBatchDepartment(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 批量同步人员数据
     * @param id (optional) 
     * @return Success
     */
    zkBatchEmployee(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkBatchEmployee?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkBatchEmployee(_response);
        });
    }

    protected processZkBatchEmployee(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 删除部门
     * @param deptnumber (optional) 
     * @return Success
     */
    zkDeleteDepartment(deptnumber: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkDeleteDepartment?";
        if (deptnumber !== undefined && deptnumber !== null)
            url_ += "deptnumber=" + encodeURIComponent("" + deptnumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkDeleteDepartment(_response);
        });
    }

    protected processZkDeleteDepartment(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 删除人员-慎用
    删除后无法撤销删除，可通过更新人员接口重新添加该人员编号人员
    删除人员信息，同时关闭考勤、门禁，若人员存在卡余额则无法删除
     * @param pin (optional) 人员编号（工号）
     * @return Success
     */
    zkDeleteEmployee(pin: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkDeleteEmployee?";
        if (pin !== undefined && pin !== null)
            url_ += "pin=" + encodeURIComponent("" + pin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkDeleteEmployee(_response);
        });
    }

    protected processZkDeleteEmployee(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 人员离职
     * @param body (optional) 
     * @return Success
     */
    zkLeaveEmployee(body: ZkEmpLeave | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkLeaveEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkLeaveEmployee(_response);
        });
    }

    protected processZkLeaveEmployee(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 离职恢复
     * @param body (optional) 
     * @return Success
     */
    zkLeaveEmployeeRestore(body: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkLeaveEmployeeRestore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkLeaveEmployeeRestore(_response);
        });
    }

    protected processZkLeaveEmployeeRestore(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 人员离职
     * @param body (optional) 
     * @return Success
     */
    zkLeaveEmployeeSync(body: ZkEmpLeave | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkLeaveEmployeeSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkLeaveEmployeeSync(_response);
        });
    }

    protected processZkLeaveEmployeeSync(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 同步中控考勤机打卡数据
     * @param tenantId (optional) 
     * @return Success
     */
    zkSyncCheckTime(tenantId: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkSyncCheckTime?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkSyncCheckTime(_response);
        });
    }

    protected processZkSyncCheckTime(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * 更新部门
     * @param body (optional) 
     * @return Success
     */
    zkUpdateDepartment(body: ZkDepartment[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkUpdateDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkUpdateDepartment(_response);
        });
    }

    protected processZkUpdateDepartment(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }

    /**
     * 更新人员
     * @param body (optional) 
     * @return Success
     */
    zkUpdateEmployee(body: ZkEmployee[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<SrvResult> {
        let url_ = this.baseUrl + "/api/services/app/ZkDataDocking/ZkUpdateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZkUpdateEmployee(_response);
        });
    }

    protected processZkUpdateEmployee(response: AxiosResponse): Promise<SrvResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SrvResult.fromJS(resultData200);
            return Promise.resolve<SrvResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SrvResult>(null as any);
    }
}

export class TokenAuthServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateAccount(body: ActivateAccountModel | undefined, cancelToken?: CancelToken | undefined): Promise<ActivateAccountResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ActivateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateAccount(_response);
        });
    }

    protected processActivateAccount(response: AxiosResponse): Promise<ActivateAccountResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivateAccountResultModel.fromJS(resultData200);
            return Promise.resolve<ActivateAccountResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivateAccountResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateToAccountAndNFC(body: AuthenticateToAccountAndNFCModel | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateToAccountAndNFC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateToAccountAndNFC(_response);
        });
    }

    protected processAuthenticateToAccountAndNFC(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateToLdap(body: AuthenticateModel | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateToLdap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateToLdap(_response);
        });
    }

    protected processAuthenticateToLdap(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateToNew(body: AuthenticateModel | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateToNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateToNew(_response);
        });
    }

    protected processAuthenticateToNew(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateToNFC(body: AuthenticateNfcModel | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateToNFC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticateToNFC(_response);
        });
    }

    protected processAuthenticateToNFC(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    autoLogin(body: AutoLoginRequest | undefined, cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AutoLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutoLogin(_response);
        });
    }

    protected processAutoLogin(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined, cancelToken?: CancelToken | undefined): Promise<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalAuthenticate(_response);
        });
    }

    protected processExternalAuthenticate(response: AxiosResponse): Promise<ExternalAuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<ExternalAuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalAuthenticateResultModel>(null as any);
    }

    /**
     * @param name (optional) 
     * @param t (optional) 
     * @param l (optional) 
     * @param tid (optional) 
     * @return Success
     */
    generateVerification(name: string | null | undefined, t: ValidateCodeType | undefined, l: number | null | undefined, tid: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/GenerateVerification?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (t === null)
            throw new Error("The parameter 't' cannot be null.");
        else if (t !== undefined)
            url_ += "t=" + encodeURIComponent("" + t) + "&";
        if (l !== undefined && l !== null)
            url_ += "l=" + encodeURIComponent("" + l) + "&";
        if (tid !== undefined && tid !== null)
            url_ += "tid=" + encodeURIComponent("" + tid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateVerification(_response);
        });
    }

    protected processGenerateVerification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders( cancelToken?: CancelToken | undefined): Promise<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalAuthenticationProviders(_response);
        });
    }

    protected processGetExternalAuthenticationProviders(response: AxiosResponse): Promise<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ExternalLoginProviderInfoModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getIconFont( cancelToken?: CancelToken | undefined): Promise<IconFontDto> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetIconFont";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIconFont(_response);
        });
    }

    protected processGetIconFont(response: AxiosResponse): Promise<IconFontDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IconFontDto.fromJS(resultData200);
            return Promise.resolve<IconFontDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IconFontDto>(null as any);
    }

    /**
     * @return Success
     */
    getIsForcedUpdate( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetIsForcedUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsForcedUpdate(_response);
        });
    }

    protected processGetIsForcedUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getSSOToken( cancelToken?: CancelToken | undefined): Promise<SSODto> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetSSOToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSSOToken(_response);
        });
    }

    protected processGetSSOToken(response: AxiosResponse): Promise<SSODto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SSODto.fromJS(resultData200);
            return Promise.resolve<SSODto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SSODto>(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonatedAuthenticate(_response);
        });
    }

    protected processImpersonatedAuthenticate(response: AxiosResponse): Promise<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<ImpersonatedAuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpersonatedAuthenticateResultModel>(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined && switchAccountToken !== null)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkedAccountAuthenticate(_response);
        });
    }

    protected processLinkedAccountAuthenticate(response: AxiosResponse): Promise<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<SwitchedAccountAuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwitchedAccountAuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    logOut(userId: number, key: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogOut(_response);
        });
    }

    protected processLogOut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WhoAmIServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    whoami( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/WhoAmI/whoami";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWhoami(_response);
        });
    }

    protected processWhoami(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    /** Encrypted values for {TenantId}, {UserId} and {ConfirmationCode} */
    c: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }

    clone(): ActivateEmailInput {
        const json = this.toJSON();
        let result = new ActivateEmailInput();
        result.init(json);
        return result;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    /** Encrypted values for {TenantId}, {UserId} and {ConfirmationCode} */
    c: string | undefined;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): ImpersonateOutput {
        const json = this.toJSON();
        let result = new ImpersonateOutput();
        result.init(json);
        return result;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

/** 获取邮箱验证码 */
export class GetEmailAddressCodeInput implements IGetEmailAddressCodeInput {
    emailAddress: string | undefined;
    confirmationCode: string | undefined;

    constructor(data?: IGetEmailAddressCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): GetEmailAddressCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailAddressCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }

    clone(): GetEmailAddressCodeInput {
        const json = this.toJSON();
        let result = new GetEmailAddressCodeInput();
        result.init(json);
        return result;
    }
}

/** 获取邮箱验证码 */
export interface IGetEmailAddressCodeInput {
    emailAddress: string | undefined;
    confirmationCode: string | undefined;
}

export class Edition implements IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Edition {
        const json = this.toJSON();
        let result = new Edition();
        result.init(json);
        return result;
    }
}

export interface IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    empId: number | undefined;
    signInToken: string | undefined;
    realName: string | undefined;
    userPictureType: string | undefined;
    needToChangeThePassword: boolean;
    lastUpdatePassDate: moment.Moment | undefined;
    clientId: string | undefined;
    systemName: string | undefined;
    isTenantAdmin: number | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    remarks: string | undefined;
    weaverUserId: number | undefined;
    enableEmail: boolean;
    enableAPPPush: boolean;
    enableTextMessage: boolean;
    enableWeComMessage: boolean;
    isOnlyLdapLogin: boolean;
    domainAccount: string | undefined;
    weComUserId: string | undefined;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    name: string;
    profilePictureId: string | undefined;
    surname: string;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.signInToken = _data["signInToken"];
            this.realName = _data["realName"];
            this.userPictureType = _data["userPictureType"];
            this.needToChangeThePassword = _data["needToChangeThePassword"];
            this.lastUpdatePassDate = _data["lastUpdatePassDate"] ? moment(_data["lastUpdatePassDate"].toString()) : <any>undefined;
            this.clientId = _data["clientId"];
            this.systemName = _data["systemName"];
            this.isTenantAdmin = _data["isTenantAdmin"];
            this.appVersion = _data["appVersion"];
            this.phoneBrand = _data["phoneBrand"];
            this.remarks = _data["remarks"];
            this.weaverUserId = _data["weaverUserId"];
            this.enableEmail = _data["enableEmail"];
            this.enableAPPPush = _data["enableAPPPush"];
            this.enableTextMessage = _data["enableTextMessage"];
            this.enableWeComMessage = _data["enableWeComMessage"];
            this.isOnlyLdapLogin = _data["isOnlyLdapLogin"];
            this.domainAccount = _data["domainAccount"];
            this.weComUserId = _data["weComUserId"];
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"] ? moment(_data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.profilePictureId = _data["profilePictureId"];
            this.surname = _data["surname"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["signInToken"] = this.signInToken;
        data["realName"] = this.realName;
        data["userPictureType"] = this.userPictureType;
        data["needToChangeThePassword"] = this.needToChangeThePassword;
        data["lastUpdatePassDate"] = this.lastUpdatePassDate ? this.lastUpdatePassDate.toISOString() : <any>undefined;
        data["clientId"] = this.clientId;
        data["systemName"] = this.systemName;
        data["isTenantAdmin"] = this.isTenantAdmin;
        data["appVersion"] = this.appVersion;
        data["phoneBrand"] = this.phoneBrand;
        data["remarks"] = this.remarks;
        data["weaverUserId"] = this.weaverUserId;
        data["enableEmail"] = this.enableEmail;
        data["enableAPPPush"] = this.enableAPPPush;
        data["enableTextMessage"] = this.enableTextMessage;
        data["enableWeComMessage"] = this.enableWeComMessage;
        data["isOnlyLdapLogin"] = this.isOnlyLdapLogin;
        data["domainAccount"] = this.domainAccount;
        data["weComUserId"] = this.weComUserId;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["profilePictureId"] = this.profilePictureId;
        data["surname"] = this.surname;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    empId: number | undefined;
    signInToken: string | undefined;
    realName: string | undefined;
    userPictureType: string | undefined;
    needToChangeThePassword: boolean;
    lastUpdatePassDate: moment.Moment | undefined;
    clientId: string | undefined;
    systemName: string | undefined;
    isTenantAdmin: number | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    remarks: string | undefined;
    weaverUserId: number | undefined;
    enableEmail: boolean;
    enableAPPPush: boolean;
    enableTextMessage: boolean;
    enableWeComMessage: boolean;
    isOnlyLdapLogin: boolean;
    domainAccount: string | undefined;
    weComUserId: string | undefined;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    name: string;
    profilePictureId: string | undefined;
    surname: string;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Tenant implements ITenant {
    subscriptionEndUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    isDefault: boolean;
    lpaServicePath: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionEndUtc = _data["subscriptionEndUtc"] ? moment(_data["subscriptionEndUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.customCssId = _data["customCssId"];
            this.isDefault = _data["isDefault"];
            this.lpaServicePath = _data["lpaServicePath"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionEndUtc"] = this.subscriptionEndUtc ? this.subscriptionEndUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customCssId"] = this.customCssId;
        data["isDefault"] = this.isDefault;
        data["lpaServicePath"] = this.lpaServicePath;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    subscriptionEndUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    isDefault: boolean;
    lpaServicePath: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): ImpersonateInput {
        const json = this.toJSON();
        let result = new ImpersonateInput();
        result.init(json);
        return result;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

/** 验证租户名称是否可用 */
export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

/** 验证租户名称是否可用 */
export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    Available = <any>"Available",
    InActive = <any>"InActive",
    NotFound = <any>"NotFound",
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    desc: string | undefined;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.desc = _data["desc"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["desc"] = this.desc;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    desc: string | undefined;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    userName: string;
    emailAddress: string;
    password: string;
    /** 验证码 */
    verificationCode: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["verificationCode"] = this.verificationCode;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    userName: string;
    emailAddress: string;
    password: string;
    /** 验证码 */
    verificationCode: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

/** 重置密码的Dto */
export class ResetPasswordInput implements IResetPasswordInput {
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    /** 新密码 */
    newPassword: string;
    /** 确认密码 */
    confirmPassword: string;
    /** 验证码 */
    code: string | undefined;
    /** 重置密码的code */
    resetCode: string;
    error: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
            this.code = _data["code"];
            this.resetCode = _data["resetCode"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["code"] = this.code;
        data["resetCode"] = this.resetCode;
        data["error"] = this.error;
        return data;
    }

    clone(): ResetPasswordInput {
        const json = this.toJSON();
        let result = new ResetPasswordInput();
        result.init(json);
        return result;
    }
}

/** 重置密码的Dto */
export interface IResetPasswordInput {
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    /** 新密码 */
    newPassword: string;
    /** 确认密码 */
    confirmPassword: string;
    /** 验证码 */
    code: string | undefined;
    /** 重置密码的code */
    resetCode: string;
    error: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin: boolean;
    emailAddress: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ResetPasswordOutput {
        const json = this.toJSON();
        let result = new ResetPasswordOutput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    emailAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }

    clone(): ResolveTenantIdInput {
        const json = this.toJSON();
        let result = new ResolveTenantIdInput();
        result.init(json);
        return result;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): SendEmailActivationLinkInput {
        const json = this.toJSON();
        let result = new SendEmailActivationLinkInput();
        result.init(json);
        return result;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress: string;
    link: string | undefined;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["link"] = this.link;
        return data;
    }

    clone(): SendPasswordResetCodeInput {
        const json = this.toJSON();
        let result = new SendPasswordResetCodeInput();
        result.init(json);
        return result;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
    link: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }

    clone(): SwitchToLinkedAccountInput {
        const json = this.toJSON();
        let result = new SwitchToLinkedAccountInput();
        result.init(json);
        return result;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): SwitchToLinkedAccountOutput {
        const json = this.toJSON();
        let result = new SwitchToLinkedAccountOutput();
        result.init(json);
        return result;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class ResultDto implements IResultDto {
    /** 成功 */
    success: boolean | undefined;
    /** 错误描述 */
    errorMes: string | undefined;

    constructor(data?: IResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMes = _data["errorMes"];
        }
    }

    static fromJS(data: any): ResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMes"] = this.errorMes;
        return data;
    }

    clone(): ResultDto {
        const json = this.toJSON();
        let result = new ResultDto();
        result.init(json);
        return result;
    }
}

export interface IResultDto {
    /** 成功 */
    success: boolean | undefined;
    /** 错误描述 */
    errorMes: string | undefined;
}

export class GetTenantDto implements IGetTenantDto {
    /** 租户编码 */
    tenantCode: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;

    constructor(data?: IGetTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantCode = _data["tenantCode"];
            this.tenantName = _data["tenantName"];
        }
    }

    static fromJS(data: any): GetTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantCode"] = this.tenantCode;
        data["tenantName"] = this.tenantName;
        return data;
    }

    clone(): GetTenantDto {
        const json = this.toJSON();
        let result = new GetTenantDto();
        result.init(json);
        return result;
    }
}

export interface IGetTenantDto {
    /** 租户编码 */
    tenantCode: string | undefined;
    /** 租户名称 */
    tenantName: string | undefined;
}

export class UpdatePwdByEmailParam implements IUpdatePwdByEmailParam {
    /** key参数 */
    key: string | undefined;
    /** 密码 */
    pwd: string | undefined;

    constructor(data?: IUpdatePwdByEmailParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.pwd = _data["pwd"];
        }
    }

    static fromJS(data: any): UpdatePwdByEmailParam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePwdByEmailParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["pwd"] = this.pwd;
        return data;
    }

    clone(): UpdatePwdByEmailParam {
        const json = this.toJSON();
        let result = new UpdatePwdByEmailParam();
        result.init(json);
        return result;
    }
}

export interface IUpdatePwdByEmailParam {
    /** key参数 */
    key: string | undefined;
    /** 密码 */
    pwd: string | undefined;
}

export class UpdatePwdByPhoneEditDto implements IUpdatePwdByPhoneEditDto {
    tenantId: number | undefined;
    /** 手机号 */
    phoneNumbers: string | undefined;
    /** 密码 */
    pwd: string | undefined;
    /** 验证码 */
    smsCode: string | undefined;

    constructor(data?: IUpdatePwdByPhoneEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.phoneNumbers = _data["phoneNumbers"];
            this.pwd = _data["pwd"];
            this.smsCode = _data["smsCode"];
        }
    }

    static fromJS(data: any): UpdatePwdByPhoneEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePwdByPhoneEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["phoneNumbers"] = this.phoneNumbers;
        data["pwd"] = this.pwd;
        data["smsCode"] = this.smsCode;
        return data;
    }

    clone(): UpdatePwdByPhoneEditDto {
        const json = this.toJSON();
        let result = new UpdatePwdByPhoneEditDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePwdByPhoneEditDto {
    tenantId: number | undefined;
    /** 手机号 */
    phoneNumbers: string | undefined;
    /** 密码 */
    pwd: string | undefined;
    /** 验证码 */
    smsCode: string | undefined;
}

export class UpdatePwdByEmailEditDto implements IUpdatePwdByEmailEditDto {
    /** 账号 */
    account: string | undefined;
    tenantId: number | undefined;
    email: string | undefined;

    constructor(data?: IUpdatePwdByEmailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.account = _data["account"];
            this.tenantId = _data["tenantId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdatePwdByEmailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePwdByEmailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["tenantId"] = this.tenantId;
        data["email"] = this.email;
        return data;
    }

    clone(): UpdatePwdByEmailEditDto {
        const json = this.toJSON();
        let result = new UpdatePwdByEmailEditDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePwdByEmailEditDto {
    /** 账号 */
    account: string | undefined;
    tenantId: number | undefined;
    email: string | undefined;
}

export class VerificationCodeDto implements IVerificationCodeDto {
    /** 是否成功 */
    success: boolean;
    /** 验证码 */
    smsCode: string | undefined;
    /** 错误编码 */
    errorCode: string | undefined;
    /** 错误 */
    error: string | undefined;

    constructor(data?: IVerificationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.smsCode = _data["smsCode"];
            this.errorCode = _data["errorCode"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): VerificationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["smsCode"] = this.smsCode;
        data["errorCode"] = this.errorCode;
        data["error"] = this.error;
        return data;
    }

    clone(): VerificationCodeDto {
        const json = this.toJSON();
        let result = new VerificationCodeDto();
        result.init(json);
        return result;
    }
}

export interface IVerificationCodeDto {
    /** 是否成功 */
    success: boolean;
    /** 验证码 */
    smsCode: string | undefined;
    /** 错误编码 */
    errorCode: string | undefined;
    /** 错误 */
    error: string | undefined;
}

export class AddressProvincetDto implements IAddressProvincetDto {
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IAddressProvincetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddressProvincetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressProvincetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): AddressProvincetDto {
        const json = this.toJSON();
        let result = new AddressProvincetDto();
        result.init(json);
        return result;
    }
}

export interface IAddressProvincetDto {
    code: string | undefined;
    name: string | undefined;
}

export class AddressCityDto implements IAddressCityDto {
    provinceCode: string | undefined;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IAddressCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provinceCode = _data["provinceCode"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddressCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceCode"] = this.provinceCode;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): AddressCityDto {
        const json = this.toJSON();
        let result = new AddressCityDto();
        result.init(json);
        return result;
    }
}

export interface IAddressCityDto {
    provinceCode: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class AddressAreaDto implements IAddressAreaDto {
    cityCode: string | undefined;
    provinceCode: string | undefined;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IAddressAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityCode = _data["cityCode"];
            this.provinceCode = _data["provinceCode"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddressAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["provinceCode"] = this.provinceCode;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): AddressAreaDto {
        const json = this.toJSON();
        let result = new AddressAreaDto();
        result.init(json);
        return result;
    }
}

export interface IAddressAreaDto {
    cityCode: string | undefined;
    provinceCode: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class AddressStreetDto implements IAddressStreetDto {
    areaCode: string | undefined;
    cityCode: string | undefined;
    provinceCode: string | undefined;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IAddressStreetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaCode = _data["areaCode"];
            this.cityCode = _data["cityCode"];
            this.provinceCode = _data["provinceCode"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddressStreetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressStreetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaCode"] = this.areaCode;
        data["cityCode"] = this.cityCode;
        data["provinceCode"] = this.provinceCode;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): AddressStreetDto {
        const json = this.toJSON();
        let result = new AddressStreetDto();
        result.init(json);
        return result;
    }
}

export interface IAddressStreetDto {
    areaCode: string | undefined;
    cityCode: string | undefined;
    provinceCode: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

/** 所有联动数据 */
export class AllAddressLinkage implements IAllAddressLinkage {
    /** 省 */
    provinces: AddressProvincetDto[] | undefined;
    /** 市 */
    citys: AddressCityDto[] | undefined;
    /** 县 */
    areas: AddressAreaDto[] | undefined;
    /** 镇 */
    streets: AddressStreetDto[] | undefined;

    constructor(data?: IAllAddressLinkage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["provinces"])) {
                this.provinces = [] as any;
                for (let item of _data["provinces"])
                    this.provinces.push(AddressProvincetDto.fromJS(item));
            }
            if (Array.isArray(_data["citys"])) {
                this.citys = [] as any;
                for (let item of _data["citys"])
                    this.citys.push(AddressCityDto.fromJS(item));
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas.push(AddressAreaDto.fromJS(item));
            }
            if (Array.isArray(_data["streets"])) {
                this.streets = [] as any;
                for (let item of _data["streets"])
                    this.streets.push(AddressStreetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllAddressLinkage {
        data = typeof data === 'object' ? data : {};
        let result = new AllAddressLinkage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.provinces)) {
            data["provinces"] = [];
            for (let item of this.provinces)
                data["provinces"].push(item.toJSON());
        }
        if (Array.isArray(this.citys)) {
            data["citys"] = [];
            for (let item of this.citys)
                data["citys"].push(item.toJSON());
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.streets)) {
            data["streets"] = [];
            for (let item of this.streets)
                data["streets"].push(item.toJSON());
        }
        return data;
    }

    clone(): AllAddressLinkage {
        const json = this.toJSON();
        let result = new AllAddressLinkage();
        result.init(json);
        return result;
    }
}

/** 所有联动数据 */
export interface IAllAddressLinkage {
    /** 省 */
    provinces: AddressProvincetDto[] | undefined;
    /** 市 */
    citys: AddressCityDto[] | undefined;
    /** 县 */
    areas: AddressAreaDto[] | undefined;
    /** 镇 */
    streets: AddressStreetDto[] | undefined;
}

export class GetByCodeOutput implements IGetByCodeOutput {
    provinceName: string | undefined;
    cityName: string | undefined;
    areaName: string | undefined;
    streetName: string | undefined;

    constructor(data?: IGetByCodeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provinceName = _data["provinceName"];
            this.cityName = _data["cityName"];
            this.areaName = _data["areaName"];
            this.streetName = _data["streetName"];
        }
    }

    static fromJS(data: any): GetByCodeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetByCodeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceName"] = this.provinceName;
        data["cityName"] = this.cityName;
        data["areaName"] = this.areaName;
        data["streetName"] = this.streetName;
        return data;
    }

    clone(): GetByCodeOutput {
        const json = this.toJSON();
        let result = new GetByCodeOutput();
        result.init(json);
        return result;
    }
}

export interface IGetByCodeOutput {
    provinceName: string | undefined;
    cityName: string | undefined;
    areaName: string | undefined;
    streetName: string | undefined;
}

export enum AddressEnum {
    Provinces = <any>"Provinces",
    Cities = <any>"Cities",
    Areas = <any>"Areas",
    Streets = <any>"Streets",
}

export class VodCategoryEditDto implements IVodCategoryEditDto {
    /** 真实分类ID */
    cateId: number | undefined;
    /** 分类名称 */
    cateName: string | undefined;
    requestId: string | undefined;
    parentId: number | undefined;
    level: number | undefined;
    type: string | undefined;
    children: VodCategoryEditDto[] | undefined;

    constructor(data?: IVodCategoryEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cateId = _data["cateId"];
            this.cateName = _data["cateName"];
            this.requestId = _data["requestId"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.type = _data["type"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(VodCategoryEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VodCategoryEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VodCategoryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cateId"] = this.cateId;
        data["cateName"] = this.cateName;
        data["requestId"] = this.requestId;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["type"] = this.type;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): VodCategoryEditDto {
        const json = this.toJSON();
        let result = new VodCategoryEditDto();
        result.init(json);
        return result;
    }
}

export interface IVodCategoryEditDto {
    /** 真实分类ID */
    cateId: number | undefined;
    /** 分类名称 */
    cateName: string | undefined;
    requestId: string | undefined;
    parentId: number | undefined;
    level: number | undefined;
    type: string | undefined;
    children: VodCategoryEditDto[] | undefined;
}

export class VodUploadDto implements IVodUploadDto {
    /** 标题 */
    title: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 分类Id */
    cateId: number | undefined;

    constructor(data?: IVodUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.fileName = _data["fileName"];
            this.cateId = _data["cateId"];
        }
    }

    static fromJS(data: any): VodUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new VodUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["fileName"] = this.fileName;
        data["cateId"] = this.cateId;
        return data;
    }

    clone(): VodUploadDto {
        const json = this.toJSON();
        let result = new VodUploadDto();
        result.init(json);
        return result;
    }
}

export interface IVodUploadDto {
    /** 标题 */
    title: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 分类Id */
    cateId: number | undefined;
}

export class VideoAutherOutput implements IVideoAutherOutput {
    uploadAuth: string | undefined;
    uploadAddress: string | undefined;
    videoId: string | undefined;

    constructor(data?: IVideoAutherOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadAuth = _data["uploadAuth"];
            this.uploadAddress = _data["uploadAddress"];
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): VideoAutherOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VideoAutherOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadAuth"] = this.uploadAuth;
        data["uploadAddress"] = this.uploadAddress;
        data["videoId"] = this.videoId;
        return data;
    }

    clone(): VideoAutherOutput {
        const json = this.toJSON();
        let result = new VideoAutherOutput();
        result.init(json);
        return result;
    }
}

export interface IVideoAutherOutput {
    uploadAuth: string | undefined;
    uploadAddress: string | undefined;
    videoId: string | undefined;
}

export class RefreshUploadInputDto implements IRefreshUploadInputDto {
    videoId: string | undefined;

    constructor(data?: IRefreshUploadInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): RefreshUploadInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshUploadInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId;
        return data;
    }

    clone(): RefreshUploadInputDto {
        const json = this.toJSON();
        let result = new RefreshUploadInputDto();
        result.init(json);
        return result;
    }
}

export interface IRefreshUploadInputDto {
    videoId: string | undefined;
}

/** 附件表的列表DTO QYB.QYBProduct.Organization.AnnexesFile.AnnexesFile */
export class AnnexesFileEditDto implements IAnnexesFileEditDto {
    /** Id */
    id: number | undefined;
    /** 附件夹Guid */
    folderId: string | undefined;
    /** 保存本地的名称 */
    locName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** FileType */
    fileType: string | undefined;

    constructor(data?: IAnnexesFileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folderId = _data["folderId"];
            this.locName = _data["locName"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): AnnexesFileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexesFileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["folderId"] = this.folderId;
        data["locName"] = this.locName;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        return data;
    }

    clone(): AnnexesFileEditDto {
        const json = this.toJSON();
        let result = new AnnexesFileEditDto();
        result.init(json);
        return result;
    }
}

/** 附件表的列表DTO QYB.QYBProduct.Organization.AnnexesFile.AnnexesFile */
export interface IAnnexesFileEditDto {
    /** Id */
    id: number | undefined;
    /** 附件夹Guid */
    folderId: string | undefined;
    /** 保存本地的名称 */
    locName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** FileType */
    fileType: string | undefined;
}

export class CreateOrUpdateAnnexesFileInput implements ICreateOrUpdateAnnexesFileInput {
    annexesFile: AnnexesFileEditDto;

    constructor(data?: ICreateOrUpdateAnnexesFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.annexesFile = new AnnexesFileEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.annexesFile = _data["annexesFile"] ? AnnexesFileEditDto.fromJS(_data["annexesFile"]) : new AnnexesFileEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAnnexesFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAnnexesFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annexesFile"] = this.annexesFile ? this.annexesFile.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAnnexesFileInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAnnexesFileInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAnnexesFileInput {
    annexesFile: AnnexesFileEditDto;
}

/** 附件表的列表DTO QYB.QYBProduct.Organization.AnnexesFile.AnnexesFile */
export class AnnexesFileListDto implements IAnnexesFileListDto {
    /** 附件夹Guid */
    folderId: string | undefined;
    /** 保存本地的名称 */
    locName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** FileType */
    fileType: string | undefined;
    id: number;

    constructor(data?: IAnnexesFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderId = _data["folderId"];
            this.locName = _data["locName"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AnnexesFileListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexesFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderId"] = this.folderId;
        data["locName"] = this.locName;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        return data;
    }

    clone(): AnnexesFileListDto {
        const json = this.toJSON();
        let result = new AnnexesFileListDto();
        result.init(json);
        return result;
    }
}

/** 附件表的列表DTO QYB.QYBProduct.Organization.AnnexesFile.AnnexesFile */
export interface IAnnexesFileListDto {
    /** 附件夹Guid */
    folderId: string | undefined;
    /** 保存本地的名称 */
    locName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** FileType */
    fileType: string | undefined;
    id: number;
}

/** 读取可编辑附件表的Dto */
export class GetAnnexesFileForEditOutput implements IGetAnnexesFileForEditOutput {
    annexesFile: AnnexesFileEditDto;

    constructor(data?: IGetAnnexesFileForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.annexesFile = _data["annexesFile"] ? AnnexesFileEditDto.fromJS(_data["annexesFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAnnexesFileForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnexesFileForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annexesFile"] = this.annexesFile ? this.annexesFile.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAnnexesFileForEditOutput {
        const json = this.toJSON();
        let result = new GetAnnexesFileForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑附件表的Dto */
export interface IGetAnnexesFileForEditOutput {
    annexesFile: AnnexesFileEditDto;
}

export class PagedResultDtoOfAnnexesFileListDto implements IPagedResultDtoOfAnnexesFileListDto {
    totalCount: number;
    items: AnnexesFileListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAnnexesFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AnnexesFileListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAnnexesFileListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAnnexesFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAnnexesFileListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAnnexesFileListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAnnexesFileListDto {
    totalCount: number;
    items: AnnexesFileListDto[] | undefined;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

/** APP创建审核任务 */
export class APPCreateAuditTaskDto implements IAPPCreateAuditTaskDto {
    /** 选择的开始日期 */
    startDateTime: moment.Moment;
    /** 选择的开始日期 */
    endDateTime: moment.Moment;
    /** 选择的审核模板 */
    auditTemplate: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    /** 备注 */
    remark: string | undefined;

    constructor(data?: IAPPCreateAuditTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : <any>undefined;
            this.auditTemplate = _data["auditTemplate"];
            this.auditTaskLabel = _data["auditTaskLabel"];
            this.templateBarCode = _data["templateBarCode"];
            this.assitField = _data["assitField"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): APPCreateAuditTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new APPCreateAuditTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["auditTemplate"] = this.auditTemplate;
        data["auditTaskLabel"] = this.auditTaskLabel;
        data["templateBarCode"] = this.templateBarCode;
        data["assitField"] = this.assitField;
        data["remark"] = this.remark;
        return data;
    }

    clone(): APPCreateAuditTaskDto {
        const json = this.toJSON();
        let result = new APPCreateAuditTaskDto();
        result.init(json);
        return result;
    }
}

/** APP创建审核任务 */
export interface IAPPCreateAuditTaskDto {
    /** 选择的开始日期 */
    startDateTime: moment.Moment;
    /** 选择的开始日期 */
    endDateTime: moment.Moment;
    /** 选择的审核模板 */
    auditTemplate: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 创建审核项模板 */
export class APPCreateAuditTaskItemDto implements IAPPCreateAuditTaskItemDto {
    /** 选择的开始日期 */
    startDateTime: moment.Moment;
    /** 选择的开始日期 */
    endDateTime: moment.Moment;
    /** 选择的审核项模板 */
    auditTemplate: number;
    /** 选择的审核点 */
    auditPointList: number[] | undefined;
    /** 备注 */
    remark: string | undefined;

    constructor(data?: IAPPCreateAuditTaskItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : <any>undefined;
            this.auditTemplate = _data["auditTemplate"];
            if (Array.isArray(_data["auditPointList"])) {
                this.auditPointList = [] as any;
                for (let item of _data["auditPointList"])
                    this.auditPointList.push(item);
            }
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): APPCreateAuditTaskItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new APPCreateAuditTaskItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["auditTemplate"] = this.auditTemplate;
        if (Array.isArray(this.auditPointList)) {
            data["auditPointList"] = [];
            for (let item of this.auditPointList)
                data["auditPointList"].push(item);
        }
        data["remark"] = this.remark;
        return data;
    }

    clone(): APPCreateAuditTaskItemDto {
        const json = this.toJSON();
        let result = new APPCreateAuditTaskItemDto();
        result.init(json);
        return result;
    }
}

/** 创建审核项模板 */
export interface IAPPCreateAuditTaskItemDto {
    /** 选择的开始日期 */
    startDateTime: moment.Moment;
    /** 选择的开始日期 */
    endDateTime: moment.Moment;
    /** 选择的审核项模板 */
    auditTemplate: number;
    /** 选择的审核点 */
    auditPointList: number[] | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class IssueEditDtos implements IIssueEditDtos {
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    video: string | undefined;

    constructor(data?: IIssueEditDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.description = _data["description"];
            this.respId = _data["respId"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improveNote = _data["improveNote"];
            this.issueReason = _data["issueReason"];
            this.video = _data["video"];
        }
    }

    static fromJS(data: any): IssueEditDtos {
        data = typeof data === 'object' ? data : {};
        let result = new IssueEditDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["description"] = this.description;
        data["respId"] = this.respId;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improveNote"] = this.improveNote;
        data["issueReason"] = this.issueReason;
        data["video"] = this.video;
        return data;
    }

    clone(): IssueEditDtos {
        const json = this.toJSON();
        let result = new IssueEditDtos();
        result.init(json);
        return result;
    }
}

export interface IIssueEditDtos {
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    video: string | undefined;
}

export class CreatOrUpdataIssue implements ICreatOrUpdataIssue {
    issueEditDtos: IssueEditDtos;

    constructor(data?: ICreatOrUpdataIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.issueEditDtos = new IssueEditDtos();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueEditDtos = _data["issueEditDtos"] ? IssueEditDtos.fromJS(_data["issueEditDtos"]) : new IssueEditDtos();
        }
    }

    static fromJS(data: any): CreatOrUpdataIssue {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataIssue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueEditDtos"] = this.issueEditDtos ? this.issueEditDtos.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdataIssue {
        const json = this.toJSON();
        let result = new CreatOrUpdataIssue();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdataIssue {
    issueEditDtos: IssueEditDtos;
}

/** 审核点Dto */
export class AuditpointListDto implements IAuditpointListDto {
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 责任人 */
    respId: number;
    /** 责任人名称 */
    respName: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 上级名称 */
    pName: string | undefined;
    /** 排序 */
    sn: number;
    /** 子集 */
    children: AuditpointListDto[] | undefined;
    /** 审核项数量 */
    auditItemCount: number | undefined;
    /** title */
    title: string | undefined;
    /** key */
    key: number;
    /** 图片 */
    picture: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 小程序码 */
    wxmpQrCodePic: string | undefined;
    id: number;

    constructor(data?: IAuditpointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.mustQRCode = _data["mustQRCode"];
            this.mustNFC = _data["mustNFC"];
            this.qrCode = _data["qrCode"];
            this.nfcNo = _data["nfcNo"];
            this.nfcid = _data["nfcid"];
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.enable = _data["enable"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            this.pName = _data["pName"];
            this.sn = _data["sn"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditpointListDto.fromJS(item));
            }
            this.auditItemCount = _data["auditItemCount"];
            this.title = _data["title"];
            this.key = _data["key"];
            this.picture = _data["picture"];
            this.description = _data["description"];
            this.wxmpQrCodePic = _data["wxmpQrCodePic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditpointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditpointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["mustQRCode"] = this.mustQRCode;
        data["mustNFC"] = this.mustNFC;
        data["qrCode"] = this.qrCode;
        data["nfcNo"] = this.nfcNo;
        data["nfcid"] = this.nfcid;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["enable"] = this.enable;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        data["pName"] = this.pName;
        data["sn"] = this.sn;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["auditItemCount"] = this.auditItemCount;
        data["title"] = this.title;
        data["key"] = this.key;
        data["picture"] = this.picture;
        data["description"] = this.description;
        data["wxmpQrCodePic"] = this.wxmpQrCodePic;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditpointListDto {
        const json = this.toJSON();
        let result = new AuditpointListDto();
        result.init(json);
        return result;
    }
}

/** 审核点Dto */
export interface IAuditpointListDto {
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 责任人 */
    respId: number;
    /** 责任人名称 */
    respName: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 上级名称 */
    pName: string | undefined;
    /** 排序 */
    sn: number;
    /** 子集 */
    children: AuditpointListDto[] | undefined;
    /** 审核项数量 */
    auditItemCount: number | undefined;
    /** title */
    title: string | undefined;
    /** key */
    key: number;
    /** 图片 */
    picture: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 小程序码 */
    wxmpQrCodePic: string | undefined;
    id: number;
}

export class AuditItemListDto implements IAuditItemListDto {
    /** 审核点分组 */
    auditItemGroupId: number;
    auditItemGroupPId: number | undefined;
    /** 审核点分组名称 */
    auditItemGroupName: string | undefined;
    /** 审核项类型 */
    auditItemTypeId: number;
    auditItemTypePId: number | undefined;
    auditItemId: number | undefined;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 概述 */
    name: string | undefined;
    /** 详细描述 */
    description: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 不合格时必须提交问题 */
    unQualifiedMustSubmitIssue: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 问题分类 */
    issueTypeId: number | undefined;
    /** 问题分类名称 */
    issueTypeName: string | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdList: string | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdListName: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 排序 */
    sn: number;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 单位 */
    valueUnit: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 编号 */
    code: string | undefined;
    id: number;

    constructor(data?: IAuditItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemGroupId = _data["auditItemGroupId"];
            this.auditItemGroupPId = _data["auditItemGroupPId"];
            this.auditItemGroupName = _data["auditItemGroupName"];
            this.auditItemTypeId = _data["auditItemTypeId"];
            this.auditItemTypePId = _data["auditItemTypePId"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.auditNeedInput = _data["auditNeedInput"];
            this.auditNeedPic = _data["auditNeedPic"];
            this.auditNeedDesc = _data["auditNeedDesc"];
            this.unQualifiedMustSubmitIssue = _data["unQualifiedMustSubmitIssue"];
            this.issueNeedPic = _data["issueNeedPic"];
            this.issueTypeId = _data["issueTypeId"];
            this.issueTypeName = _data["issueTypeName"];
            this.issueTypeIdList = _data["issueTypeIdList"];
            this.issueTypeIdListName = _data["issueTypeIdListName"];
            this.enable = _data["enable"];
            this.sn = _data["sn"];
            this.optionType = _data["optionType"];
            this.valueStandard = _data["valueStandard"];
            this.valueUpperLimit = _data["valueUpperLimit"];
            this.valueLowerLimit = _data["valueLowerLimit"];
            this.valueUnit = _data["valueUnit"];
            this.isAllowTransfer = _data["isAllowTransfer"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemGroupId"] = this.auditItemGroupId;
        data["auditItemGroupPId"] = this.auditItemGroupPId;
        data["auditItemGroupName"] = this.auditItemGroupName;
        data["auditItemTypeId"] = this.auditItemTypeId;
        data["auditItemTypePId"] = this.auditItemTypePId;
        data["auditItemId"] = this.auditItemId;
        data["auditItemTypeName"] = this.auditItemTypeName;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["auditNeedInput"] = this.auditNeedInput;
        data["auditNeedPic"] = this.auditNeedPic;
        data["auditNeedDesc"] = this.auditNeedDesc;
        data["unQualifiedMustSubmitIssue"] = this.unQualifiedMustSubmitIssue;
        data["issueNeedPic"] = this.issueNeedPic;
        data["issueTypeId"] = this.issueTypeId;
        data["issueTypeName"] = this.issueTypeName;
        data["issueTypeIdList"] = this.issueTypeIdList;
        data["issueTypeIdListName"] = this.issueTypeIdListName;
        data["enable"] = this.enable;
        data["sn"] = this.sn;
        data["optionType"] = this.optionType;
        data["valueStandard"] = this.valueStandard;
        data["valueUpperLimit"] = this.valueUpperLimit;
        data["valueLowerLimit"] = this.valueLowerLimit;
        data["valueUnit"] = this.valueUnit;
        data["isAllowTransfer"] = this.isAllowTransfer;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditItemListDto {
        const json = this.toJSON();
        let result = new AuditItemListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditItemListDto {
    /** 审核点分组 */
    auditItemGroupId: number;
    auditItemGroupPId: number | undefined;
    /** 审核点分组名称 */
    auditItemGroupName: string | undefined;
    /** 审核项类型 */
    auditItemTypeId: number;
    auditItemTypePId: number | undefined;
    auditItemId: number | undefined;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 概述 */
    name: string | undefined;
    /** 详细描述 */
    description: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 不合格时必须提交问题 */
    unQualifiedMustSubmitIssue: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 问题分类 */
    issueTypeId: number | undefined;
    /** 问题分类名称 */
    issueTypeName: string | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdList: string | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdListName: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 排序 */
    sn: number;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 单位 */
    valueUnit: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 编号 */
    code: string | undefined;
    id: number;
}

/** 选项类型详情列表实体 */
export class OptionListDetailListDto implements IOptionListDetailListDto {
    /** Id */
    id: number;
    /** 列表Id */
    optionListId: number;
    /** 名称 */
    name: string | undefined;
    /** 是否合格 */
    isQualified: boolean;
    /** 分值 */
    score: number;
    /** 背景色 Rgb配色 */
    backColor: string | undefined;
    /** 前景色 Rgb配色 */
    foreColor: string | undefined;

    constructor(data?: IOptionListDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.optionListId = _data["optionListId"];
            this.name = _data["name"];
            this.isQualified = _data["isQualified"];
            this.score = _data["score"];
            this.backColor = _data["backColor"];
            this.foreColor = _data["foreColor"];
        }
    }

    static fromJS(data: any): OptionListDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionListDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["optionListId"] = this.optionListId;
        data["name"] = this.name;
        data["isQualified"] = this.isQualified;
        data["score"] = this.score;
        data["backColor"] = this.backColor;
        data["foreColor"] = this.foreColor;
        return data;
    }

    clone(): OptionListDetailListDto {
        const json = this.toJSON();
        let result = new OptionListDetailListDto();
        result.init(json);
        return result;
    }
}

/** 选项类型详情列表实体 */
export interface IOptionListDetailListDto {
    /** Id */
    id: number;
    /** 列表Id */
    optionListId: number;
    /** 名称 */
    name: string | undefined;
    /** 是否合格 */
    isQualified: boolean;
    /** 分值 */
    score: number;
    /** 背景色 Rgb配色 */
    backColor: string | undefined;
    /** 前景色 Rgb配色 */
    foreColor: string | undefined;
}

/** 审核记录 */
export class GetByAuditTaskIdInAllAuditItemListDto implements IGetByAuditTaskIdInAllAuditItemListDto {
    /** Id */
    id: number;
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 概述 */
    itemName: string | undefined;
    /** 详细描述 */
    itemDescription: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 不合格时必须提交问题 */
    unQualifiedMustSubmitIssue: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 问题分类 */
    issueTypeId: number | undefined;
    /** 问题分类名称 */
    issueTypeName: string | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdList: string | undefined;
    /** 问题分类名称（多选） */
    issueTypeListName: string | undefined;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 展示形式 1.下拉 2.平铺 */
    displayForm: string | undefined;
    /** 是否快速点检 */
    isQuickCheck: boolean;
    /** 选项类型 */
    optionListDetail: OptionListDetailListDto[] | undefined;
    /** 文件夹 */
    dicPath: string | undefined;
    /** 文件真实名字 */
    realPath: string | undefined;
    /** 文件guid路径 */
    guidPath: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
    isAddIssue: boolean;
    /** 是否跳过审核点 */
    isSkipAuditPoint: boolean;
    /** 视频 */
    video: string | undefined;

    constructor(data?: IGetByAuditTaskIdInAllAuditItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemTypeId = _data["auditItemTypeId"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.itemName = _data["itemName"];
            this.itemDescription = _data["itemDescription"];
            this.auditNeedInput = _data["auditNeedInput"];
            this.auditNeedPic = _data["auditNeedPic"];
            this.auditNeedDesc = _data["auditNeedDesc"];
            this.unQualifiedMustSubmitIssue = _data["unQualifiedMustSubmitIssue"];
            this.issueNeedPic = _data["issueNeedPic"];
            this.issueTypeId = _data["issueTypeId"];
            this.issueTypeName = _data["issueTypeName"];
            this.issueTypeIdList = _data["issueTypeIdList"];
            this.issueTypeListName = _data["issueTypeListName"];
            this.auditItemSN = _data["auditItemSN"];
            this.result = _data["result"];
            this.deviationType = _data["deviationType"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.note = _data["note"];
            this.data = _data["data"];
            this.picture = _data["picture"];
            this.remark = _data["remark"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.valueActual = _data["valueActual"];
            this.optionType = _data["optionType"];
            this.valueStandard = _data["valueStandard"];
            this.valueUpperLimit = _data["valueUpperLimit"];
            this.valueLowerLimit = _data["valueLowerLimit"];
            this.score = _data["score"];
            this.displayForm = _data["displayForm"];
            this.isQuickCheck = _data["isQuickCheck"];
            if (Array.isArray(_data["optionListDetail"])) {
                this.optionListDetail = [] as any;
                for (let item of _data["optionListDetail"])
                    this.optionListDetail.push(OptionListDetailListDto.fromJS(item));
            }
            this.dicPath = _data["dicPath"];
            this.realPath = _data["realPath"];
            this.guidPath = _data["guidPath"];
            this.isAllowTransfer = _data["isAllowTransfer"];
            this.inspectorId = _data["inspectorId"];
            this.transferRecipient = _data["transferRecipient"];
            this.transferTime = _data["transferTime"] ? moment(_data["transferTime"].toString()) : <any>undefined;
            this.isAddIssue = _data["isAddIssue"];
            this.isSkipAuditPoint = _data["isSkipAuditPoint"];
            this.video = _data["video"];
        }
    }

    static fromJS(data: any): GetByAuditTaskIdInAllAuditItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetByAuditTaskIdInAllAuditItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["auditItemTypeId"] = this.auditItemTypeId;
        data["auditItemTypeName"] = this.auditItemTypeName;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["itemName"] = this.itemName;
        data["itemDescription"] = this.itemDescription;
        data["auditNeedInput"] = this.auditNeedInput;
        data["auditNeedPic"] = this.auditNeedPic;
        data["auditNeedDesc"] = this.auditNeedDesc;
        data["unQualifiedMustSubmitIssue"] = this.unQualifiedMustSubmitIssue;
        data["issueNeedPic"] = this.issueNeedPic;
        data["issueTypeId"] = this.issueTypeId;
        data["issueTypeName"] = this.issueTypeName;
        data["issueTypeIdList"] = this.issueTypeIdList;
        data["issueTypeListName"] = this.issueTypeListName;
        data["auditItemSN"] = this.auditItemSN;
        data["result"] = this.result;
        data["deviationType"] = this.deviationType;
        data["deviationTypeName"] = this.deviationTypeName;
        data["note"] = this.note;
        data["data"] = this.data;
        data["picture"] = this.picture;
        data["remark"] = this.remark;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["valueActual"] = this.valueActual;
        data["optionType"] = this.optionType;
        data["valueStandard"] = this.valueStandard;
        data["valueUpperLimit"] = this.valueUpperLimit;
        data["valueLowerLimit"] = this.valueLowerLimit;
        data["score"] = this.score;
        data["displayForm"] = this.displayForm;
        data["isQuickCheck"] = this.isQuickCheck;
        if (Array.isArray(this.optionListDetail)) {
            data["optionListDetail"] = [];
            for (let item of this.optionListDetail)
                data["optionListDetail"].push(item.toJSON());
        }
        data["dicPath"] = this.dicPath;
        data["realPath"] = this.realPath;
        data["guidPath"] = this.guidPath;
        data["isAllowTransfer"] = this.isAllowTransfer;
        data["inspectorId"] = this.inspectorId;
        data["transferRecipient"] = this.transferRecipient;
        data["transferTime"] = this.transferTime ? this.transferTime.toISOString() : <any>undefined;
        data["isAddIssue"] = this.isAddIssue;
        data["isSkipAuditPoint"] = this.isSkipAuditPoint;
        data["video"] = this.video;
        return data;
    }

    clone(): GetByAuditTaskIdInAllAuditItemListDto {
        const json = this.toJSON();
        let result = new GetByAuditTaskIdInAllAuditItemListDto();
        result.init(json);
        return result;
    }
}

/** 审核记录 */
export interface IGetByAuditTaskIdInAllAuditItemListDto {
    /** Id */
    id: number;
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 概述 */
    itemName: string | undefined;
    /** 详细描述 */
    itemDescription: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 不合格时必须提交问题 */
    unQualifiedMustSubmitIssue: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 问题分类 */
    issueTypeId: number | undefined;
    /** 问题分类名称 */
    issueTypeName: string | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdList: string | undefined;
    /** 问题分类名称（多选） */
    issueTypeListName: string | undefined;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 展示形式 1.下拉 2.平铺 */
    displayForm: string | undefined;
    /** 是否快速点检 */
    isQuickCheck: boolean;
    /** 选项类型 */
    optionListDetail: OptionListDetailListDto[] | undefined;
    /** 文件夹 */
    dicPath: string | undefined;
    /** 文件真实名字 */
    realPath: string | undefined;
    /** 文件guid路径 */
    guidPath: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
    isAddIssue: boolean;
    /** 是否跳过审核点 */
    isSkipAuditPoint: boolean;
    /** 视频 */
    video: string | undefined;
}

/** 树节点 */
export class GetByAuditTaskIdInAllPointTreeListDto implements IGetByAuditTaskIdInAllPointTreeListDto {
    /** Id */
    id: number;
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 上级Id */
    pId: number;
    /** 已完成数量 */
    completedCount: number;
    /** 未完成数量 */
    notCompleteCount: number;
    /** 全部数量 */
    allCount: number;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;
    /** 是否跳过审核点 */
    isSkipAuditPoint: boolean;
    /** 子集 */
    children: GetByAuditTaskIdInAllPointTreeListDto[] | undefined;

    constructor(data?: IGetByAuditTaskIdInAllPointTreeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.mustQRCode = _data["mustQRCode"];
            this.mustNFC = _data["mustNFC"];
            this.nfcNo = _data["nfcNo"];
            this.qrCode = _data["qrCode"];
            this.nfcid = _data["nfcid"];
            this.pId = _data["pId"];
            this.completedCount = _data["completedCount"];
            this.notCompleteCount = _data["notCompleteCount"];
            this.allCount = _data["allCount"];
            this.show = _data["show"];
            this.checked = _data["checked"];
            this.isSkipAuditPoint = _data["isSkipAuditPoint"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GetByAuditTaskIdInAllPointTreeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetByAuditTaskIdInAllPointTreeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetByAuditTaskIdInAllPointTreeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["mustQRCode"] = this.mustQRCode;
        data["mustNFC"] = this.mustNFC;
        data["nfcNo"] = this.nfcNo;
        data["qrCode"] = this.qrCode;
        data["nfcid"] = this.nfcid;
        data["pId"] = this.pId;
        data["completedCount"] = this.completedCount;
        data["notCompleteCount"] = this.notCompleteCount;
        data["allCount"] = this.allCount;
        data["show"] = this.show;
        data["checked"] = this.checked;
        data["isSkipAuditPoint"] = this.isSkipAuditPoint;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetByAuditTaskIdInAllPointTreeListDto {
        const json = this.toJSON();
        let result = new GetByAuditTaskIdInAllPointTreeListDto();
        result.init(json);
        return result;
    }
}

/** 树节点 */
export interface IGetByAuditTaskIdInAllPointTreeListDto {
    /** Id */
    id: number;
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 上级Id */
    pId: number;
    /** 已完成数量 */
    completedCount: number;
    /** 未完成数量 */
    notCompleteCount: number;
    /** 全部数量 */
    allCount: number;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;
    /** 是否跳过审核点 */
    isSkipAuditPoint: boolean;
    /** 子集 */
    children: GetByAuditTaskIdInAllPointTreeListDto[] | undefined;
}

/** 审核任务Dto */
export class AuditTaskListDto implements IAuditTaskListDto {
    /** Id */
    id: number;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核模板名 */
    auditTemplateName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 审核团队 */
    auditTeamId: number | undefined;
    /** 审核团队 */
    auditTeamName: string | undefined;
    /** 审核人 */
    createUserName: string | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 实际开始日期 */
    startTime: moment.Moment | undefined;
    /** 实际结束日期 */
    endTime: moment.Moment | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateSN: number;
    /** 备注 */
    remark: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 请假原因 */
    leaveReason: string | undefined;
    /** 请假详细描述 */
    leaveRemark: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
    /** 提前开始 */
    earlyStartTime: string | undefined;
    /** 延后完成 */
    delayedFinishTime: string | undefined;
    /** 是否为审核记录转办任务 */
    isTransfer: boolean;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    /** 模板类型1.审核点模板2.审核项模板 */
    templateType: number;
    /** 扩展字段1 */
    filedExt1: string | undefined;
    /** 扩展字段2 */
    filedExt2: string | undefined;
    /** 扩展字段3 */
    filedExt3: string | undefined;
    /** 是否团队任务 */
    isTeamTask: boolean;

    constructor(data?: IAuditTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTaskType = _data["auditTaskType"];
            this.auditTaskTypeName = _data["auditTaskTypeName"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.auditTemplateName = _data["auditTemplateName"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.auditTeamId = _data["auditTeamId"];
            this.auditTeamName = _data["auditTeamName"];
            this.createUserName = _data["createUserName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"];
            this.auditTaskStateName = _data["auditTaskStateName"];
            this.auditTaskStateSN = _data["auditTaskStateSN"];
            this.remark = _data["remark"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.leaveReason = _data["leaveReason"];
            this.leaveRemark = _data["leaveRemark"];
            this.auditTaskCreateId = _data["auditTaskCreateId"];
            this.auditTaskLabel = _data["auditTaskLabel"];
            this.auditTaskLabelName = _data["auditTaskLabelName"];
            this.earlyStart = _data["earlyStart"];
            this.delayedFinish = _data["delayedFinish"];
            this.earlyStartTime = _data["earlyStartTime"];
            this.delayedFinishTime = _data["delayedFinishTime"];
            this.isTransfer = _data["isTransfer"];
            this.templateBarCode = _data["templateBarCode"];
            this.assitField = _data["assitField"];
            this.templateType = _data["templateType"];
            this.filedExt1 = _data["filedExt1"];
            this.filedExt2 = _data["filedExt2"];
            this.filedExt3 = _data["filedExt3"];
            this.isTeamTask = _data["isTeamTask"];
        }
    }

    static fromJS(data: any): AuditTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTaskType"] = this.auditTaskType;
        data["auditTaskTypeName"] = this.auditTaskTypeName;
        data["auditTemplateId"] = this.auditTemplateId;
        data["auditTemplateName"] = this.auditTemplateName;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["auditTeamId"] = this.auditTeamId;
        data["auditTeamName"] = this.auditTeamName;
        data["createUserName"] = this.createUserName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState;
        data["auditTaskStateName"] = this.auditTaskStateName;
        data["auditTaskStateSN"] = this.auditTaskStateSN;
        data["remark"] = this.remark;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["leaveReason"] = this.leaveReason;
        data["leaveRemark"] = this.leaveRemark;
        data["auditTaskCreateId"] = this.auditTaskCreateId;
        data["auditTaskLabel"] = this.auditTaskLabel;
        data["auditTaskLabelName"] = this.auditTaskLabelName;
        data["earlyStart"] = this.earlyStart;
        data["delayedFinish"] = this.delayedFinish;
        data["earlyStartTime"] = this.earlyStartTime;
        data["delayedFinishTime"] = this.delayedFinishTime;
        data["isTransfer"] = this.isTransfer;
        data["templateBarCode"] = this.templateBarCode;
        data["assitField"] = this.assitField;
        data["templateType"] = this.templateType;
        data["filedExt1"] = this.filedExt1;
        data["filedExt2"] = this.filedExt2;
        data["filedExt3"] = this.filedExt3;
        data["isTeamTask"] = this.isTeamTask;
        return data;
    }

    clone(): AuditTaskListDto {
        const json = this.toJSON();
        let result = new AuditTaskListDto();
        result.init(json);
        return result;
    }
}

/** 审核任务Dto */
export interface IAuditTaskListDto {
    /** Id */
    id: number;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核模板名 */
    auditTemplateName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 审核团队 */
    auditTeamId: number | undefined;
    /** 审核团队 */
    auditTeamName: string | undefined;
    /** 审核人 */
    createUserName: string | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 实际开始日期 */
    startTime: moment.Moment | undefined;
    /** 实际结束日期 */
    endTime: moment.Moment | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateSN: number;
    /** 备注 */
    remark: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 请假原因 */
    leaveReason: string | undefined;
    /** 请假详细描述 */
    leaveRemark: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
    /** 提前开始 */
    earlyStartTime: string | undefined;
    /** 延后完成 */
    delayedFinishTime: string | undefined;
    /** 是否为审核记录转办任务 */
    isTransfer: boolean;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    /** 模板类型1.审核点模板2.审核项模板 */
    templateType: number;
    /** 扩展字段1 */
    filedExt1: string | undefined;
    /** 扩展字段2 */
    filedExt2: string | undefined;
    /** 扩展字段3 */
    filedExt3: string | undefined;
    /** 是否团队任务 */
    isTeamTask: boolean;
}

export class IssueHistory implements IIssueHistory {
    issueId: number;
    operaterRealName: string | undefined;
    operateTime: moment.Moment;
    changeKey: string | undefined;
    changeKeyCode: string | undefined;
    beforeValue: string | undefined;
    afterValue: string | undefined;
    isCreate: boolean;
    creationTime: moment.Moment;
    tenantId: number;
    id: number;

    constructor(data?: IIssueHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
            this.operaterRealName = _data["operaterRealName"];
            this.operateTime = _data["operateTime"] ? moment(_data["operateTime"].toString()) : <any>undefined;
            this.changeKey = _data["changeKey"];
            this.changeKeyCode = _data["changeKeyCode"];
            this.beforeValue = _data["beforeValue"];
            this.afterValue = _data["afterValue"];
            this.isCreate = _data["isCreate"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IssueHistory {
        data = typeof data === 'object' ? data : {};
        let result = new IssueHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        data["operaterRealName"] = this.operaterRealName;
        data["operateTime"] = this.operateTime ? this.operateTime.toISOString() : <any>undefined;
        data["changeKey"] = this.changeKey;
        data["changeKeyCode"] = this.changeKeyCode;
        data["beforeValue"] = this.beforeValue;
        data["afterValue"] = this.afterValue;
        data["isCreate"] = this.isCreate;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }

    clone(): IssueHistory {
        const json = this.toJSON();
        let result = new IssueHistory();
        result.init(json);
        return result;
    }
}

export interface IIssueHistory {
    issueId: number;
    operaterRealName: string | undefined;
    operateTime: moment.Moment;
    changeKey: string | undefined;
    changeKeyCode: string | undefined;
    beforeValue: string | undefined;
    afterValue: string | undefined;
    isCreate: boolean;
    creationTime: moment.Moment;
    tenantId: number;
    id: number;
}

/** 问题列表listdto */
export class APPIssueListDto implements IAPPIssueListDto {
    /** Id */
    id: number;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceTypeName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称 */
    issueTypeName: string | undefined;
    /** 问题类型名称(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人名称 */
    respName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项概述 */
    auditItemName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
    /** 计划开始处理日期 */
    planStartStr: string | undefined;
    /** 计划完成日期 */
    planEndStr: string | undefined;
    /** 发现时间 */
    discoveryTimeStr: string | undefined;
    /** 实际开始时间 */
    startTimeStr: string | undefined;
    /** 实际完成时间 */
    closeTimeStr: string | undefined;
    /** 问题修改记录 */
    history: IssueHistory[] | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    /** 转办时间 */
    turnToTime: moment.Moment | undefined;
    /** 转办人 */
    turnToUser: string | undefined;
    /** 视频 */
    video: string | undefined;
    /** 问题状态
0、待确认
1、已确认
2、作废 */
    issueStatus: string | undefined;
    /** 作废原因 */
    statusReason: string | undefined;
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门Id */
    submitterDeptId: number | undefined;
    /** 部门 */
    submitterDept: string | undefined;

    constructor(data?: IAPPIssueListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueTypeName = _data["issueTypeName"];
            this.issueTypeListName = _data["issueTypeListName"];
            this.issueProgress = _data["issueProgress"];
            this.issueProgressName = _data["issueProgressName"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discovererName = _data["discovererName"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.issueReason = _data["issueReason"];
            this.remark = _data["remark"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.planStartStr = _data["planStartStr"];
            this.planEndStr = _data["planEndStr"];
            this.discoveryTimeStr = _data["discoveryTimeStr"];
            this.startTimeStr = _data["startTimeStr"];
            this.closeTimeStr = _data["closeTimeStr"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history.push(IssueHistory.fromJS(item));
            }
            this.foreColor = _data["foreColor"];
            this.backColor = _data["backColor"];
            this.turnToTime = _data["turnToTime"] ? moment(_data["turnToTime"].toString()) : <any>undefined;
            this.turnToUser = _data["turnToUser"];
            this.video = _data["video"];
            this.issueStatus = _data["issueStatus"];
            this.statusReason = _data["statusReason"];
            this.submitterJobID = _data["submitterJobID"];
            this.submitterName = _data["submitterName"];
            this.submitterDeptId = _data["submitterDeptId"];
            this.submitterDept = _data["submitterDept"];
        }
    }

    static fromJS(data: any): APPIssueListDto {
        data = typeof data === 'object' ? data : {};
        let result = new APPIssueListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceType"] = this.sourceType;
        data["sourceTypeName"] = this.sourceTypeName;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueTypeName"] = this.issueTypeName;
        data["issueTypeListName"] = this.issueTypeListName;
        data["issueProgress"] = this.issueProgress;
        data["issueProgressName"] = this.issueProgressName;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discovererName"] = this.discovererName;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["issueReason"] = this.issueReason;
        data["remark"] = this.remark;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["planStartStr"] = this.planStartStr;
        data["planEndStr"] = this.planEndStr;
        data["discoveryTimeStr"] = this.discoveryTimeStr;
        data["startTimeStr"] = this.startTimeStr;
        data["closeTimeStr"] = this.closeTimeStr;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["foreColor"] = this.foreColor;
        data["backColor"] = this.backColor;
        data["turnToTime"] = this.turnToTime ? this.turnToTime.toISOString() : <any>undefined;
        data["turnToUser"] = this.turnToUser;
        data["video"] = this.video;
        data["issueStatus"] = this.issueStatus;
        data["statusReason"] = this.statusReason;
        data["submitterJobID"] = this.submitterJobID;
        data["submitterName"] = this.submitterName;
        data["submitterDeptId"] = this.submitterDeptId;
        data["submitterDept"] = this.submitterDept;
        return data;
    }

    clone(): APPIssueListDto {
        const json = this.toJSON();
        let result = new APPIssueListDto();
        result.init(json);
        return result;
    }
}

/** 问题列表listdto */
export interface IAPPIssueListDto {
    /** Id */
    id: number;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceTypeName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称 */
    issueTypeName: string | undefined;
    /** 问题类型名称(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人名称 */
    respName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项概述 */
    auditItemName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
    /** 计划开始处理日期 */
    planStartStr: string | undefined;
    /** 计划完成日期 */
    planEndStr: string | undefined;
    /** 发现时间 */
    discoveryTimeStr: string | undefined;
    /** 实际开始时间 */
    startTimeStr: string | undefined;
    /** 实际完成时间 */
    closeTimeStr: string | undefined;
    /** 问题修改记录 */
    history: IssueHistory[] | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    /** 转办时间 */
    turnToTime: moment.Moment | undefined;
    /** 转办人 */
    turnToUser: string | undefined;
    /** 视频 */
    video: string | undefined;
    /** 问题状态
0、待确认
1、已确认
2、作废 */
    issueStatus: string | undefined;
    /** 作废原因 */
    statusReason: string | undefined;
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门Id */
    submitterDeptId: number | undefined;
    /** 部门 */
    submitterDept: string | undefined;
}

/** 问题分类显示配置 */
export class IssueTypeDisplayConfigDto implements IIssueTypeDisplayConfigDto {
    /** 隐藏的问题分类ID列表,用逗号分隔 */
    hiddenIssueTypeIds: string | undefined;

    constructor(data?: IIssueTypeDisplayConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hiddenIssueTypeIds = _data["hiddenIssueTypeIds"];
        }
    }

    static fromJS(data: any): IssueTypeDisplayConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTypeDisplayConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hiddenIssueTypeIds"] = this.hiddenIssueTypeIds;
        return data;
    }

    clone(): IssueTypeDisplayConfigDto {
        const json = this.toJSON();
        let result = new IssueTypeDisplayConfigDto();
        result.init(json);
        return result;
    }
}

/** 问题分类显示配置 */
export interface IIssueTypeDisplayConfigDto {
    /** 隐藏的问题分类ID列表,用逗号分隔 */
    hiddenIssueTypeIds: string | undefined;
}

export class IssueTypeListDto implements IIssueTypeListDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    planFinishTime: number;
    /** 是否可以修改时间 */
    canModifyTime: boolean;
    /** 上级Id */
    pId: number;
    /** 上级编码 */
    pCode: number;
    /** 子编码 */
    children: IssueTypeListDto[] | undefined;

    constructor(data?: IIssueTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.planFinishTime = _data["planFinishTime"];
            this.canModifyTime = _data["canModifyTime"];
            this.pId = _data["pId"];
            this.pCode = _data["pCode"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(IssueTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssueTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["planFinishTime"] = this.planFinishTime;
        data["canModifyTime"] = this.canModifyTime;
        data["pId"] = this.pId;
        data["pCode"] = this.pCode;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): IssueTypeListDto {
        const json = this.toJSON();
        let result = new IssueTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IIssueTypeListDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    planFinishTime: number;
    /** 是否可以修改时间 */
    canModifyTime: boolean;
    /** 上级Id */
    pId: number;
    /** 上级编码 */
    pCode: number;
    /** 子编码 */
    children: IssueTypeListDto[] | undefined;
}

export class LayoutUserListDto implements ILayoutUserListDto {
    /** 系统用户 */
    userId: number;
    /** 可为责任人 */
    isResponsible: boolean;
    /** 可为审核人 */
    isAuditor: boolean;
    /** LPA组织架构 */
    orgId: number;
    orgPId: number;
    /** 默认审核方案 */
    auditTemplateId: number | undefined;
    /** 用户姓名 */
    realName: string | undefined;
    /** 组织架构名 */
    orgName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 关键岗位 */
    isKeyPositions: boolean;
    /** 月度隐患数量指标 */
    monthlyIssueIndicators: number;
    id: number;

    constructor(data?: ILayoutUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isResponsible = _data["isResponsible"];
            this.isAuditor = _data["isAuditor"];
            this.orgId = _data["orgId"];
            this.orgPId = _data["orgPId"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.realName = _data["realName"];
            this.orgName = _data["orgName"];
            this.remark = _data["remark"];
            this.isKeyPositions = _data["isKeyPositions"];
            this.monthlyIssueIndicators = _data["monthlyIssueIndicators"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LayoutUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isResponsible"] = this.isResponsible;
        data["isAuditor"] = this.isAuditor;
        data["orgId"] = this.orgId;
        data["orgPId"] = this.orgPId;
        data["auditTemplateId"] = this.auditTemplateId;
        data["realName"] = this.realName;
        data["orgName"] = this.orgName;
        data["remark"] = this.remark;
        data["isKeyPositions"] = this.isKeyPositions;
        data["monthlyIssueIndicators"] = this.monthlyIssueIndicators;
        data["id"] = this.id;
        return data;
    }

    clone(): LayoutUserListDto {
        const json = this.toJSON();
        let result = new LayoutUserListDto();
        result.init(json);
        return result;
    }
}

export interface ILayoutUserListDto {
    /** 系统用户 */
    userId: number;
    /** 可为责任人 */
    isResponsible: boolean;
    /** 可为审核人 */
    isAuditor: boolean;
    /** LPA组织架构 */
    orgId: number;
    orgPId: number;
    /** 默认审核方案 */
    auditTemplateId: number | undefined;
    /** 用户姓名 */
    realName: string | undefined;
    /** 组织架构名 */
    orgName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 关键岗位 */
    isKeyPositions: boolean;
    /** 月度隐患数量指标 */
    monthlyIssueIndicators: number;
    id: number;
}

/** 获取组织架构 */
export class GetLayoutUserTreeDto implements IGetLayoutUserTreeDto {
    /** 是否展开，默认展开 */
    show: boolean;
    /** 是否打开，默认不打开 */
    open: boolean;
    /** 是否虚拟 */
    isVirtual: boolean;
    /** ID */
    id: string | undefined;
    /** 父级Id */
    pId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 名称 */
    levelName: string | undefined;
    /** 类型 */
    type: string | undefined;
    /** 排序 */
    sort: number;
    /** 真实Id */
    realId: string[] | undefined;
    /** 子 */
    children: GetLayoutUserTreeDto[] | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 账号ID */
    userId: string | undefined;
    /** 账号 */
    userName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 性别 字典 Gender */
    genderCode: string | undefined;
    /** 部门Id */
    departmentId: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
    /** 头像 */
    img: string | undefined;
    /** 关键字 */
    key: number;

    constructor(data?: IGetLayoutUserTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.show = _data["show"];
            this.open = _data["open"];
            this.isVirtual = _data["isVirtual"];
            this.id = _data["id"];
            this.pId = _data["pId"];
            this.name = _data["name"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
            this.sort = _data["sort"];
            if (Array.isArray(_data["realId"])) {
                this.realId = [] as any;
                for (let item of _data["realId"])
                    this.realId.push(item);
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GetLayoutUserTreeDto.fromJS(item));
            }
            this.postName = _data["postName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.jobNumber = _data["jobNumber"];
            this.mobile = _data["mobile"];
            this.realName = _data["realName"];
            this.genderCode = _data["genderCode"];
            this.departmentId = _data["departmentId"];
            this.postId = _data["postId"];
            this.img = _data["img"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): GetLayoutUserTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLayoutUserTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["show"] = this.show;
        data["open"] = this.open;
        data["isVirtual"] = this.isVirtual;
        data["id"] = this.id;
        data["pId"] = this.pId;
        data["name"] = this.name;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        data["sort"] = this.sort;
        if (Array.isArray(this.realId)) {
            data["realId"] = [];
            for (let item of this.realId)
                data["realId"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["postName"] = this.postName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["jobNumber"] = this.jobNumber;
        data["mobile"] = this.mobile;
        data["realName"] = this.realName;
        data["genderCode"] = this.genderCode;
        data["departmentId"] = this.departmentId;
        data["postId"] = this.postId;
        data["img"] = this.img;
        data["key"] = this.key;
        return data;
    }

    clone(): GetLayoutUserTreeDto {
        const json = this.toJSON();
        let result = new GetLayoutUserTreeDto();
        result.init(json);
        return result;
    }
}

/** 获取组织架构 */
export interface IGetLayoutUserTreeDto {
    /** 是否展开，默认展开 */
    show: boolean;
    /** 是否打开，默认不打开 */
    open: boolean;
    /** 是否虚拟 */
    isVirtual: boolean;
    /** ID */
    id: string | undefined;
    /** 父级Id */
    pId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 名称 */
    levelName: string | undefined;
    /** 类型 */
    type: string | undefined;
    /** 排序 */
    sort: number;
    /** 真实Id */
    realId: string[] | undefined;
    /** 子 */
    children: GetLayoutUserTreeDto[] | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 账号ID */
    userId: string | undefined;
    /** 账号 */
    userName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 性别 字典 Gender */
    genderCode: string | undefined;
    /** 部门Id */
    departmentId: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
    /** 头像 */
    img: string | undefined;
    /** 关键字 */
    key: number;
}

/** 问题 */
export class GetIssueListDto implements IGetIssueListDto {
    /** 我负责的 */
    myCharge: APPIssueListDto[] | undefined;
    /** 我发现的 */
    myfound: APPIssueListDto[] | undefined;
    /** 我关注的 */
    mySubscribe: APPIssueListDto[] | undefined;

    constructor(data?: IGetIssueListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["myCharge"])) {
                this.myCharge = [] as any;
                for (let item of _data["myCharge"])
                    this.myCharge.push(APPIssueListDto.fromJS(item));
            }
            if (Array.isArray(_data["myfound"])) {
                this.myfound = [] as any;
                for (let item of _data["myfound"])
                    this.myfound.push(APPIssueListDto.fromJS(item));
            }
            if (Array.isArray(_data["mySubscribe"])) {
                this.mySubscribe = [] as any;
                for (let item of _data["mySubscribe"])
                    this.mySubscribe.push(APPIssueListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIssueListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.myCharge)) {
            data["myCharge"] = [];
            for (let item of this.myCharge)
                data["myCharge"].push(item.toJSON());
        }
        if (Array.isArray(this.myfound)) {
            data["myfound"] = [];
            for (let item of this.myfound)
                data["myfound"].push(item.toJSON());
        }
        if (Array.isArray(this.mySubscribe)) {
            data["mySubscribe"] = [];
            for (let item of this.mySubscribe)
                data["mySubscribe"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIssueListDto {
        const json = this.toJSON();
        let result = new GetIssueListDto();
        result.init(json);
        return result;
    }
}

/** 问题 */
export interface IGetIssueListDto {
    /** 我负责的 */
    myCharge: APPIssueListDto[] | undefined;
    /** 我发现的 */
    myfound: APPIssueListDto[] | undefined;
    /** 我关注的 */
    mySubscribe: APPIssueListDto[] | undefined;
}

export class PagedResultDtoOfAPPIssueListDto implements IPagedResultDtoOfAPPIssueListDto {
    totalCount: number;
    items: APPIssueListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAPPIssueListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(APPIssueListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAPPIssueListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAPPIssueListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAPPIssueListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAPPIssueListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAPPIssueListDto {
    totalCount: number;
    items: APPIssueListDto[] | undefined;
}

/** 问题 */
export class GetIssueListDtoV2 implements IGetIssueListDtoV2 {
    myCharge: PagedResultDtoOfAPPIssueListDto;
    myfound: PagedResultDtoOfAPPIssueListDto;
    mySubscribe: PagedResultDtoOfAPPIssueListDto;

    constructor(data?: IGetIssueListDtoV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myCharge = _data["myCharge"] ? PagedResultDtoOfAPPIssueListDto.fromJS(_data["myCharge"]) : <any>undefined;
            this.myfound = _data["myfound"] ? PagedResultDtoOfAPPIssueListDto.fromJS(_data["myfound"]) : <any>undefined;
            this.mySubscribe = _data["mySubscribe"] ? PagedResultDtoOfAPPIssueListDto.fromJS(_data["mySubscribe"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIssueListDtoV2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueListDtoV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myCharge"] = this.myCharge ? this.myCharge.toJSON() : <any>undefined;
        data["myfound"] = this.myfound ? this.myfound.toJSON() : <any>undefined;
        data["mySubscribe"] = this.mySubscribe ? this.mySubscribe.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetIssueListDtoV2 {
        const json = this.toJSON();
        let result = new GetIssueListDtoV2();
        result.init(json);
        return result;
    }
}

/** 问题 */
export interface IGetIssueListDtoV2 {
    myCharge: PagedResultDtoOfAPPIssueListDto;
    myfound: PagedResultDtoOfAPPIssueListDto;
    mySubscribe: PagedResultDtoOfAPPIssueListDto;
}

/** listdto */
export class PointCheckListDto implements IPointCheckListDto {
    /** id */
    id: number;
    /** 点位 */
    auditPointId: number;
    /** 点位名称 */
    auditPointName: string | undefined;
    /** 打卡时间 */
    creationTime: moment.Moment;
    /** 打卡人 */
    creatorUserId: number | undefined;
    /** 打卡人 */
    creatorUserName: string | undefined;

    constructor(data?: IPointCheckListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
        }
    }

    static fromJS(data: any): PointCheckListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointCheckListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        return data;
    }

    clone(): PointCheckListDto {
        const json = this.toJSON();
        let result = new PointCheckListDto();
        result.init(json);
        return result;
    }
}

/** listdto */
export interface IPointCheckListDto {
    /** id */
    id: number;
    /** 点位 */
    auditPointId: number;
    /** 点位名称 */
    auditPointName: string | undefined;
    /** 打卡时间 */
    creationTime: moment.Moment;
    /** 打卡人 */
    creatorUserId: number | undefined;
    /** 打卡人 */
    creatorUserName: string | undefined;
}

export class PagedResultDtoOfPointCheckListDto implements IPagedResultDtoOfPointCheckListDto {
    totalCount: number;
    items: PointCheckListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPointCheckListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PointCheckListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPointCheckListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPointCheckListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfPointCheckListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPointCheckListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPointCheckListDto {
    totalCount: number;
    items: PointCheckListDto[] | undefined;
}

export class GetTemplateBarCodeListDto implements IGetTemplateBarCodeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 条码 */
    code: string | undefined;
    /** 辅助信息 */
    assitField: string | undefined;

    constructor(data?: IGetTemplateBarCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.assitField = _data["assitField"];
        }
    }

    static fromJS(data: any): GetTemplateBarCodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateBarCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["assitField"] = this.assitField;
        return data;
    }

    clone(): GetTemplateBarCodeListDto {
        const json = this.toJSON();
        let result = new GetTemplateBarCodeListDto();
        result.init(json);
        return result;
    }
}

export interface IGetTemplateBarCodeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 条码 */
    code: string | undefined;
    /** 辅助信息 */
    assitField: string | undefined;
}

/** Dto */
export class AuditItemTemplateListDto implements IAuditItemTemplateListDto {
    /** Id */
    id: number;
    /** 审核项模板分组Id */
    auditItemTemplateGroupId: number;
    /** 审核项模板分组名称 */
    auditItemTemplateGroupName: string | undefined;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 是否启用 */
    remark: string | undefined;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;

    constructor(data?: IAuditItemTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditItemTemplateGroupId = _data["auditItemTemplateGroupId"];
            this.auditItemTemplateGroupName = _data["auditItemTemplateGroupName"];
            this.name = _data["name"];
            this.isWalkAudit = _data["isWalkAudit"];
            this.enable = _data["enable"];
            this.remark = _data["remark"];
            this.show = _data["show"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): AuditItemTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditItemTemplateGroupId"] = this.auditItemTemplateGroupId;
        data["auditItemTemplateGroupName"] = this.auditItemTemplateGroupName;
        data["name"] = this.name;
        data["isWalkAudit"] = this.isWalkAudit;
        data["enable"] = this.enable;
        data["remark"] = this.remark;
        data["show"] = this.show;
        data["checked"] = this.checked;
        return data;
    }

    clone(): AuditItemTemplateListDto {
        const json = this.toJSON();
        let result = new AuditItemTemplateListDto();
        result.init(json);
        return result;
    }
}

/** Dto */
export interface IAuditItemTemplateListDto {
    /** Id */
    id: number;
    /** 审核项模板分组Id */
    auditItemTemplateGroupId: number;
    /** 审核项模板分组名称 */
    auditItemTemplateGroupName: string | undefined;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 是否启用 */
    remark: string | undefined;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;
}

/** 审核项模板树形结构（APP） */
export class AuditItemTemplateTreeListDto implements IAuditItemTemplateTreeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 审核项模板 */
    auditTemplate: AuditItemTemplateListDto[] | undefined;
    /** 子集（实现递归） */
    children: AuditItemTemplateTreeListDto[] | undefined;

    constructor(data?: IAuditItemTemplateTreeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["auditTemplate"])) {
                this.auditTemplate = [] as any;
                for (let item of _data["auditTemplate"])
                    this.auditTemplate.push(AuditItemTemplateListDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditItemTemplateTreeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditItemTemplateTreeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTemplateTreeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.auditTemplate)) {
            data["auditTemplate"] = [];
            for (let item of this.auditTemplate)
                data["auditTemplate"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditItemTemplateTreeListDto {
        const json = this.toJSON();
        let result = new AuditItemTemplateTreeListDto();
        result.init(json);
        return result;
    }
}

/** 审核项模板树形结构（APP） */
export interface IAuditItemTemplateTreeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 审核项模板 */
    auditTemplate: AuditItemTemplateListDto[] | undefined;
    /** 子集（实现递归） */
    children: AuditItemTemplateTreeListDto[] | undefined;
}

/** dto */
export class AuditTemplateListDto implements IAuditTemplateListDto {
    /** 审核点模板分组Id */
    auditTemplateGroupId: number;
    /** 审核点模板分组名称 */
    auditTemplateGroupName: number;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 条码 */
    barCodeList: number[] | undefined;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;
    /** 是否启用时间限制 */
    enableTimeLimit: boolean;
    /** 时间范围显示文本 */
    timeRangeDisplay: string | undefined;
    /** 时间范围开始 */
    timeRangeStart: string | undefined;
    /** 时间范围结束 */
    timeRangeEnd: string | undefined;
    id: number;

    constructor(data?: IAuditTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditTemplateGroupId = _data["auditTemplateGroupId"];
            this.auditTemplateGroupName = _data["auditTemplateGroupName"];
            this.name = _data["name"];
            this.isWalkAudit = _data["isWalkAudit"];
            this.enable = _data["enable"];
            if (Array.isArray(_data["barCodeList"])) {
                this.barCodeList = [] as any;
                for (let item of _data["barCodeList"])
                    this.barCodeList.push(item);
            }
            this.show = _data["show"];
            this.checked = _data["checked"];
            this.enableTimeLimit = _data["enableTimeLimit"];
            this.timeRangeDisplay = _data["timeRangeDisplay"];
            this.timeRangeStart = _data["timeRangeStart"];
            this.timeRangeEnd = _data["timeRangeEnd"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditTemplateGroupId"] = this.auditTemplateGroupId;
        data["auditTemplateGroupName"] = this.auditTemplateGroupName;
        data["name"] = this.name;
        data["isWalkAudit"] = this.isWalkAudit;
        data["enable"] = this.enable;
        if (Array.isArray(this.barCodeList)) {
            data["barCodeList"] = [];
            for (let item of this.barCodeList)
                data["barCodeList"].push(item);
        }
        data["show"] = this.show;
        data["checked"] = this.checked;
        data["enableTimeLimit"] = this.enableTimeLimit;
        data["timeRangeDisplay"] = this.timeRangeDisplay;
        data["timeRangeStart"] = this.timeRangeStart;
        data["timeRangeEnd"] = this.timeRangeEnd;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditTemplateListDto {
        const json = this.toJSON();
        let result = new AuditTemplateListDto();
        result.init(json);
        return result;
    }
}

/** dto */
export interface IAuditTemplateListDto {
    /** 审核点模板分组Id */
    auditTemplateGroupId: number;
    /** 审核点模板分组名称 */
    auditTemplateGroupName: number;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 条码 */
    barCodeList: number[] | undefined;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;
    /** 是否启用时间限制 */
    enableTimeLimit: boolean;
    /** 时间范围显示文本 */
    timeRangeDisplay: string | undefined;
    /** 时间范围开始 */
    timeRangeStart: string | undefined;
    /** 时间范围结束 */
    timeRangeEnd: string | undefined;
    id: number;
}

/** 审核点模板树形结构（APP） */
export class AuditTemplateTreeListDto implements IAuditTemplateTreeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 审核项模板 */
    auditTemplate: AuditTemplateListDto[] | undefined;
    /** 子集（实现递归） */
    children: AuditTemplateTreeListDto[] | undefined;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;

    constructor(data?: IAuditTemplateTreeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["auditTemplate"])) {
                this.auditTemplate = [] as any;
                for (let item of _data["auditTemplate"])
                    this.auditTemplate.push(AuditTemplateListDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditTemplateTreeListDto.fromJS(item));
            }
            this.show = _data["show"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): AuditTemplateTreeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateTreeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.auditTemplate)) {
            data["auditTemplate"] = [];
            for (let item of this.auditTemplate)
                data["auditTemplate"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["show"] = this.show;
        data["checked"] = this.checked;
        return data;
    }

    clone(): AuditTemplateTreeListDto {
        const json = this.toJSON();
        let result = new AuditTemplateTreeListDto();
        result.init(json);
        return result;
    }
}

/** 审核点模板树形结构（APP） */
export interface IAuditTemplateTreeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 审核项模板 */
    auditTemplate: AuditTemplateListDto[] | undefined;
    /** 子集（实现递归） */
    children: AuditTemplateTreeListDto[] | undefined;
    /** 是否显示 */
    show: boolean;
    /** 是否显示 */
    checked: boolean;
}

/** 问题修改实体 */
export class APPIssueEditDto implements IAPPIssueEditDto {
    /** Id */
    id: number | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 视频 */
    video: string | undefined;

    constructor(data?: IAPPIssueEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueProgress = _data["issueProgress"];
            this.description = _data["description"];
            this.respId = _data["respId"];
            this.auditPointId = _data["auditPointId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.issueReason = _data["issueReason"];
            this.video = _data["video"];
        }
    }

    static fromJS(data: any): APPIssueEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new APPIssueEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueProgress"] = this.issueProgress;
        data["description"] = this.description;
        data["respId"] = this.respId;
        data["auditPointId"] = this.auditPointId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["issueReason"] = this.issueReason;
        data["video"] = this.video;
        return data;
    }

    clone(): APPIssueEditDto {
        const json = this.toJSON();
        let result = new APPIssueEditDto();
        result.init(json);
        return result;
    }
}

/** 问题修改实体 */
export interface IAPPIssueEditDto {
    /** Id */
    id: number | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 视频 */
    video: string | undefined;
}

/** Dot */
export class APPIssueEditInput implements IAPPIssueEditInput {
    appIssueEditDto: APPIssueEditDto;

    constructor(data?: IAPPIssueEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appIssueEditDto = new APPIssueEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appIssueEditDto = _data["appIssueEditDto"] ? APPIssueEditDto.fromJS(_data["appIssueEditDto"]) : new APPIssueEditDto();
        }
    }

    static fromJS(data: any): APPIssueEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new APPIssueEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appIssueEditDto"] = this.appIssueEditDto ? this.appIssueEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): APPIssueEditInput {
        const json = this.toJSON();
        let result = new APPIssueEditInput();
        result.init(json);
        return result;
    }
}

/** Dot */
export interface IAPPIssueEditInput {
    appIssueEditDto: APPIssueEditDto;
}

export class LeaveDto implements ILeaveDto {
    id: number;
    leaveReason: string | undefined;
    leaveRemark: string | undefined;

    constructor(data?: ILeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leaveReason = _data["leaveReason"];
            this.leaveRemark = _data["leaveRemark"];
        }
    }

    static fromJS(data: any): LeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leaveReason"] = this.leaveReason;
        data["leaveRemark"] = this.leaveRemark;
        return data;
    }

    clone(): LeaveDto {
        const json = this.toJSON();
        let result = new LeaveDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveDto {
    id: number;
    leaveReason: string | undefined;
    leaveRemark: string | undefined;
}

/** 审核记录保存 */
export class SaveAuditTaskDetailDto implements ISaveAuditTaskDetailDto {
    /** 审核项 */
    auditTaskDetails: GetByAuditTaskIdInAllAuditItemListDto[] | undefined;

    constructor(data?: ISaveAuditTaskDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["auditTaskDetails"])) {
                this.auditTaskDetails = [] as any;
                for (let item of _data["auditTaskDetails"])
                    this.auditTaskDetails.push(GetByAuditTaskIdInAllAuditItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAuditTaskDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAuditTaskDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.auditTaskDetails)) {
            data["auditTaskDetails"] = [];
            for (let item of this.auditTaskDetails)
                data["auditTaskDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): SaveAuditTaskDetailDto {
        const json = this.toJSON();
        let result = new SaveAuditTaskDetailDto();
        result.init(json);
        return result;
    }
}

/** 审核记录保存 */
export interface ISaveAuditTaskDetailDto {
    /** 审核项 */
    auditTaskDetails: GetByAuditTaskIdInAllAuditItemListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppBase.AppBase */
export class AppBaseEditDto implements IAppBaseEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 描述 */
    describe: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 是否显示更新弹窗 */
    isIsShowUpdateDioLog: boolean;
    /** 是否强制更新到此版本 (版本向上兼容) */
    isForceUpdate: boolean;

    constructor(data?: IAppBaseEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.describe = _data["describe"];
            this.remarks = _data["remarks"];
            this.isIsShowUpdateDioLog = _data["isIsShowUpdateDioLog"];
            this.isForceUpdate = _data["isForceUpdate"];
        }
    }

    static fromJS(data: any): AppBaseEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppBaseEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["describe"] = this.describe;
        data["remarks"] = this.remarks;
        data["isIsShowUpdateDioLog"] = this.isIsShowUpdateDioLog;
        data["isForceUpdate"] = this.isForceUpdate;
        return data;
    }

    clone(): AppBaseEditDto {
        const json = this.toJSON();
        let result = new AppBaseEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppBase.AppBase */
export interface IAppBaseEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 描述 */
    describe: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 是否显示更新弹窗 */
    isIsShowUpdateDioLog: boolean;
    /** 是否强制更新到此版本 (版本向上兼容) */
    isForceUpdate: boolean;
}

export class CreateOrUpdateAppBaseInput implements ICreateOrUpdateAppBaseInput {
    appBase: AppBaseEditDto;

    constructor(data?: ICreateOrUpdateAppBaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appBase = new AppBaseEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appBase = _data["appBase"] ? AppBaseEditDto.fromJS(_data["appBase"]) : new AppBaseEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAppBaseInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAppBaseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appBase"] = this.appBase ? this.appBase.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAppBaseInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAppBaseInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAppBaseInput {
    appBase: AppBaseEditDto;
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppBase.AppBase */
export class AppBaseListDto implements IAppBaseListDto {
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 描述 */
    describe: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 最后更新时间 */
    createTime: moment.Moment | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 是否显示更新弹窗 */
    isIsShowUpdateDioLog: boolean;
    /** 是否强制更新到此版本 (版本向上兼容) */
    isForceUpdate: boolean;
    id: number;

    constructor(data?: IAppBaseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.describe = _data["describe"];
            this.remarks = _data["remarks"];
            this.version = _data["version"];
            this.fileNameOSS = _data["fileNameOSS"];
            this.createTime = _data["createTime"] ? moment(_data["createTime"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.isIsShowUpdateDioLog = _data["isIsShowUpdateDioLog"];
            this.isForceUpdate = _data["isForceUpdate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppBaseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppBaseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["describe"] = this.describe;
        data["remarks"] = this.remarks;
        data["version"] = this.version;
        data["fileNameOSS"] = this.fileNameOSS;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["isIsShowUpdateDioLog"] = this.isIsShowUpdateDioLog;
        data["isForceUpdate"] = this.isForceUpdate;
        data["id"] = this.id;
        return data;
    }

    clone(): AppBaseListDto {
        const json = this.toJSON();
        let result = new AppBaseListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppBase.AppBase */
export interface IAppBaseListDto {
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 描述 */
    describe: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 最后更新时间 */
    createTime: moment.Moment | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 是否显示更新弹窗 */
    isIsShowUpdateDioLog: boolean;
    /** 是否强制更新到此版本 (版本向上兼容) */
    isForceUpdate: boolean;
    id: number;
}

/** 读取可编辑的Dto */
export class GetAppBaseForEditOutput implements IGetAppBaseForEditOutput {
    appBase: AppBaseEditDto;

    constructor(data?: IGetAppBaseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appBase = _data["appBase"] ? AppBaseEditDto.fromJS(_data["appBase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppBaseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppBaseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appBase"] = this.appBase ? this.appBase.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAppBaseForEditOutput {
        const json = this.toJSON();
        let result = new GetAppBaseForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetAppBaseForEditOutput {
    appBase: AppBaseEditDto;
}

export class PagedResultDtoOfAppBaseListDto implements IPagedResultDtoOfAppBaseListDto {
    totalCount: number;
    items: AppBaseListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAppBaseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppBaseListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAppBaseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAppBaseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAppBaseListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAppBaseListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAppBaseListDto {
    totalCount: number;
    items: AppBaseListDto[] | undefined;
}

/** APP图片的列表DTO QYB.QYBProduct.AppManage.AppDTImg.AppDTImg */
export class AppDTImgEditDto implements IAppDTImgEditDto {
    /** Id */
    id: number | undefined;
    /** ImgName */
    imgName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** 关联模块 */
    relatedModule: string | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** SortCode */
    sortCode: number | undefined;

    constructor(data?: IAppDTImgEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imgName = _data["imgName"];
            this.fileName = _data["fileName"];
            this.relatedModule = _data["relatedModule"];
            this.enabledMark = _data["enabledMark"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): AppDTImgEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDTImgEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imgName"] = this.imgName;
        data["fileName"] = this.fileName;
        data["relatedModule"] = this.relatedModule;
        data["enabledMark"] = this.enabledMark;
        data["sortCode"] = this.sortCode;
        return data;
    }

    clone(): AppDTImgEditDto {
        const json = this.toJSON();
        let result = new AppDTImgEditDto();
        result.init(json);
        return result;
    }
}

/** APP图片的列表DTO QYB.QYBProduct.AppManage.AppDTImg.AppDTImg */
export interface IAppDTImgEditDto {
    /** Id */
    id: number | undefined;
    /** ImgName */
    imgName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** 关联模块 */
    relatedModule: string | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
}

export class CreateOrUpdateAppDTImgInput implements ICreateOrUpdateAppDTImgInput {
    appDTImg: AppDTImgEditDto;

    constructor(data?: ICreateOrUpdateAppDTImgInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appDTImg = new AppDTImgEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appDTImg = _data["appDTImg"] ? AppDTImgEditDto.fromJS(_data["appDTImg"]) : new AppDTImgEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAppDTImgInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAppDTImgInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appDTImg"] = this.appDTImg ? this.appDTImg.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAppDTImgInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAppDTImgInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAppDTImgInput {
    appDTImg: AppDTImgEditDto;
}

/** APP图片的列表DTO QYB.QYBProduct.AppManage.AppDTImg.AppDTImg */
export class AppDTImgListDto implements IAppDTImgListDto {
    /** ImgName */
    imgName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** 关联模块 */
    relatedModule: string | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;

    constructor(data?: IAppDTImgListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgName = _data["imgName"];
            this.fileName = _data["fileName"];
            this.relatedModule = _data["relatedModule"];
            this.enabledMark = _data["enabledMark"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppDTImgListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDTImgListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imgName"] = this.imgName;
        data["fileName"] = this.fileName;
        data["relatedModule"] = this.relatedModule;
        data["enabledMark"] = this.enabledMark;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): AppDTImgListDto {
        const json = this.toJSON();
        let result = new AppDTImgListDto();
        result.init(json);
        return result;
    }
}

/** APP图片的列表DTO QYB.QYBProduct.AppManage.AppDTImg.AppDTImg */
export interface IAppDTImgListDto {
    /** ImgName */
    imgName: string | undefined;
    /** FileName */
    fileName: string | undefined;
    /** 关联模块 */
    relatedModule: string | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;
}

/** 读取可编辑APP图片的Dto */
export class GetAppDTImgForEditOutput implements IGetAppDTImgForEditOutput {
    appDTImg: AppDTImgEditDto;

    constructor(data?: IGetAppDTImgForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appDTImg = _data["appDTImg"] ? AppDTImgEditDto.fromJS(_data["appDTImg"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppDTImgForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppDTImgForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appDTImg"] = this.appDTImg ? this.appDTImg.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAppDTImgForEditOutput {
        const json = this.toJSON();
        let result = new GetAppDTImgForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑APP图片的Dto */
export interface IGetAppDTImgForEditOutput {
    appDTImg: AppDTImgEditDto;
}

export class PagedResultDtoOfAppDTImgListDto implements IPagedResultDtoOfAppDTImgListDto {
    totalCount: number;
    items: AppDTImgListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAppDTImgListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppDTImgListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAppDTImgListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAppDTImgListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAppDTImgListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAppDTImgListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAppDTImgListDto {
    totalCount: number;
    items: AppDTImgListDto[] | undefined;
}

export class AppDownloadDto implements IAppDownloadDto {
    /** 文件名称 */
    fileName: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** 版本序号 */
    versionSort: number;
    /** 文件大小 */
    fileSize: number;
    /** 更新内容 */
    content: string | undefined;
    /** 更新描述 */
    describe: string | undefined;
    /** 是否强制更新到此版本 (版本向上兼容) */
    isForceUpdate: boolean;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 是否是最新版本 */
    isLastVersion: boolean;
    /** 是否显示更新弹窗 */
    isIsShowUpdateDioLog: boolean;

    constructor(data?: IAppDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileNameOSS = _data["fileNameOSS"];
            this.version = _data["version"];
            this.versionSort = _data["versionSort"];
            this.fileSize = _data["fileSize"];
            this.content = _data["content"];
            this.describe = _data["describe"];
            this.isForceUpdate = _data["isForceUpdate"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isLastVersion = _data["isLastVersion"];
            this.isIsShowUpdateDioLog = _data["isIsShowUpdateDioLog"];
        }
    }

    static fromJS(data: any): AppDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileNameOSS"] = this.fileNameOSS;
        data["version"] = this.version;
        data["versionSort"] = this.versionSort;
        data["fileSize"] = this.fileSize;
        data["content"] = this.content;
        data["describe"] = this.describe;
        data["isForceUpdate"] = this.isForceUpdate;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isLastVersion"] = this.isLastVersion;
        data["isIsShowUpdateDioLog"] = this.isIsShowUpdateDioLog;
        return data;
    }

    clone(): AppDownloadDto {
        const json = this.toJSON();
        let result = new AppDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IAppDownloadDto {
    /** 文件名称 */
    fileName: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** 版本序号 */
    versionSort: number;
    /** 文件大小 */
    fileSize: number;
    /** 更新内容 */
    content: string | undefined;
    /** 更新描述 */
    describe: string | undefined;
    /** 是否强制更新到此版本 (版本向上兼容) */
    isForceUpdate: boolean;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 是否是最新版本 */
    isLastVersion: boolean;
    /** 是否显示更新弹窗 */
    isIsShowUpdateDioLog: boolean;
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppVersionDetail.AppVersionDetail */
export class AppVersionDetailEditDto implements IAppVersionDetailEditDto {
    /** Id */
    id: number | undefined;
    /** AppBaseId */
    appBaseId: number;
    /** 文件名称 */
    fileName: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** 版本序号 */
    versionSort: number;
    /** 文件大小 */
    fileSize: number;
    /** 更新内容 */
    content: string | undefined;
    /** 更新描述 */
    describe: string | undefined;
    /** 上传时的APK文件名称 */
    uploadFlieName: string | undefined;
    /** AppCode */
    appCode: string | undefined;

    constructor(data?: IAppVersionDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appBaseId = _data["appBaseId"];
            this.fileName = _data["fileName"];
            this.fileNameOSS = _data["fileNameOSS"];
            this.version = _data["version"];
            this.versionSort = _data["versionSort"];
            this.fileSize = _data["fileSize"];
            this.content = _data["content"];
            this.describe = _data["describe"];
            this.uploadFlieName = _data["uploadFlieName"];
            this.appCode = _data["appCode"];
        }
    }

    static fromJS(data: any): AppVersionDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppVersionDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appBaseId"] = this.appBaseId;
        data["fileName"] = this.fileName;
        data["fileNameOSS"] = this.fileNameOSS;
        data["version"] = this.version;
        data["versionSort"] = this.versionSort;
        data["fileSize"] = this.fileSize;
        data["content"] = this.content;
        data["describe"] = this.describe;
        data["uploadFlieName"] = this.uploadFlieName;
        data["appCode"] = this.appCode;
        return data;
    }

    clone(): AppVersionDetailEditDto {
        const json = this.toJSON();
        let result = new AppVersionDetailEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppVersionDetail.AppVersionDetail */
export interface IAppVersionDetailEditDto {
    /** Id */
    id: number | undefined;
    /** AppBaseId */
    appBaseId: number;
    /** 文件名称 */
    fileName: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** 版本序号 */
    versionSort: number;
    /** 文件大小 */
    fileSize: number;
    /** 更新内容 */
    content: string | undefined;
    /** 更新描述 */
    describe: string | undefined;
    /** 上传时的APK文件名称 */
    uploadFlieName: string | undefined;
    /** AppCode */
    appCode: string | undefined;
}

export class CreateOrUpdateAppVersionDetailInput implements ICreateOrUpdateAppVersionDetailInput {
    appVersionDetail: AppVersionDetailEditDto;

    constructor(data?: ICreateOrUpdateAppVersionDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appVersionDetail = new AppVersionDetailEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appVersionDetail = _data["appVersionDetail"] ? AppVersionDetailEditDto.fromJS(_data["appVersionDetail"]) : new AppVersionDetailEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAppVersionDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAppVersionDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appVersionDetail"] = this.appVersionDetail ? this.appVersionDetail.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAppVersionDetailInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAppVersionDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAppVersionDetailInput {
    appVersionDetail: AppVersionDetailEditDto;
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppVersionDetail.AppVersionDetail */
export class AppVersionDetailListDto implements IAppVersionDetailListDto {
    /** AppBaseId */
    appBaseId: number;
    /** 文件名称 */
    fileName: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** 版本序号 */
    versionSort: number;
    /** 文件大小 */
    fileSize: number;
    /** 更新内容 */
    content: string | undefined;
    /** 更新描述 */
    describe: string | undefined;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IAppVersionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appBaseId = _data["appBaseId"];
            this.fileName = _data["fileName"];
            this.fileNameOSS = _data["fileNameOSS"];
            this.version = _data["version"];
            this.versionSort = _data["versionSort"];
            this.fileSize = _data["fileSize"];
            this.content = _data["content"];
            this.describe = _data["describe"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AppVersionDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppVersionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appBaseId"] = this.appBaseId;
        data["fileName"] = this.fileName;
        data["fileNameOSS"] = this.fileNameOSS;
        data["version"] = this.version;
        data["versionSort"] = this.versionSort;
        data["fileSize"] = this.fileSize;
        data["content"] = this.content;
        data["describe"] = this.describe;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): AppVersionDetailListDto {
        const json = this.toJSON();
        let result = new AppVersionDetailListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.AppUpdateManage.AppVersionDetail.AppVersionDetail */
export interface IAppVersionDetailListDto {
    /** AppBaseId */
    appBaseId: number;
    /** 文件名称 */
    fileName: string | undefined;
    /** OSS地址 */
    fileNameOSS: string | undefined;
    /** 版本号 */
    version: string | undefined;
    /** 版本序号 */
    versionSort: number;
    /** 文件大小 */
    fileSize: number;
    /** 更新内容 */
    content: string | undefined;
    /** 更新描述 */
    describe: string | undefined;
    creationTime: moment.Moment;
    id: number;
}

/** 读取可编辑的Dto */
export class GetAppVersionDetailForEditOutput implements IGetAppVersionDetailForEditOutput {
    appVersionDetail: AppVersionDetailEditDto;

    constructor(data?: IGetAppVersionDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appVersionDetail = _data["appVersionDetail"] ? AppVersionDetailEditDto.fromJS(_data["appVersionDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppVersionDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppVersionDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appVersionDetail"] = this.appVersionDetail ? this.appVersionDetail.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAppVersionDetailForEditOutput {
        const json = this.toJSON();
        let result = new GetAppVersionDetailForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetAppVersionDetailForEditOutput {
    appVersionDetail: AppVersionDetailEditDto;
}

export class PagedResultDtoOfAppVersionDetailListDto implements IPagedResultDtoOfAppVersionDetailListDto {
    totalCount: number;
    items: AppVersionDetailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAppVersionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppVersionDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAppVersionDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAppVersionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAppVersionDetailListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAppVersionDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAppVersionDetailListDto {
    totalCount: number;
    items: AppVersionDetailListDto[] | undefined;
}

export class AttLeaceRecordListDto implements IAttLeaceRecordListDto {
    id: number;
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** 请假类型 */
    leaveType: string | undefined;
    /** 休假日期 */
    holidayDate: moment.Moment;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 请假时数 */
    leaveNums: number;
    /** 请假单位 */
    leaveUnit: string | undefined;
    /** 提交日期 */
    submitDate: moment.Moment;
    /** 请假原因 */
    reason: string | undefined;
    unitType: string | undefined;

    constructor(data?: IAttLeaceRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.fromGuid = _data["fromGuid"];
            this.leaveType = _data["leaveType"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.leaveNums = _data["leaveNums"];
            this.leaveUnit = _data["leaveUnit"];
            this.submitDate = _data["submitDate"] ? moment(_data["submitDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.unitType = _data["unitType"];
        }
    }

    static fromJS(data: any): AttLeaceRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttLeaceRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["fromGuid"] = this.fromGuid;
        data["leaveType"] = this.leaveType;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["leaveNums"] = this.leaveNums;
        data["leaveUnit"] = this.leaveUnit;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["unitType"] = this.unitType;
        return data;
    }

    clone(): AttLeaceRecordListDto {
        const json = this.toJSON();
        let result = new AttLeaceRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IAttLeaceRecordListDto {
    id: number;
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** 请假类型 */
    leaveType: string | undefined;
    /** 休假日期 */
    holidayDate: moment.Moment;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 请假时数 */
    leaveNums: number;
    /** 请假单位 */
    leaveUnit: string | undefined;
    /** 提交日期 */
    submitDate: moment.Moment;
    /** 请假原因 */
    reason: string | undefined;
    unitType: string | undefined;
}

export class PagedResultDtoOfAttLeaceRecordListDto implements IPagedResultDtoOfAttLeaceRecordListDto {
    totalCount: number;
    items: AttLeaceRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttLeaceRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttLeaceRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttLeaceRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttLeaceRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAttLeaceRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAttLeaceRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAttLeaceRecordListDto {
    totalCount: number;
    items: AttLeaceRecordListDto[] | undefined;
}

export class AttOverTimeRecordListDto implements IAttOverTimeRecordListDto {
    id: number;
    /** 员工 */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** 加班类型 */
    overTimeType: string | undefined;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 请假时数 */
    overTimeHours: number | undefined;
    /** 申报方式 */
    declareWay: string | undefined;
    /** 加班班次 */
    shiftCode: string | undefined;
    /** 加班班次日期 */
    shiftDate: moment.Moment | undefined;
    /** 说明 */
    reason: string | undefined;

    constructor(data?: IAttOverTimeRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.fromGuid = _data["fromGuid"];
            this.overTimeType = _data["overTimeType"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.overTimeHours = _data["overTimeHours"];
            this.declareWay = _data["declareWay"];
            this.shiftCode = _data["shiftCode"];
            this.shiftDate = _data["shiftDate"] ? moment(_data["shiftDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AttOverTimeRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttOverTimeRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["fromGuid"] = this.fromGuid;
        data["overTimeType"] = this.overTimeType;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["overTimeHours"] = this.overTimeHours;
        data["declareWay"] = this.declareWay;
        data["shiftCode"] = this.shiftCode;
        data["shiftDate"] = this.shiftDate ? this.shiftDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }

    clone(): AttOverTimeRecordListDto {
        const json = this.toJSON();
        let result = new AttOverTimeRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IAttOverTimeRecordListDto {
    id: number;
    /** 员工 */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** 加班类型 */
    overTimeType: string | undefined;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 请假时数 */
    overTimeHours: number | undefined;
    /** 申报方式 */
    declareWay: string | undefined;
    /** 加班班次 */
    shiftCode: string | undefined;
    /** 加班班次日期 */
    shiftDate: moment.Moment | undefined;
    /** 说明 */
    reason: string | undefined;
}

export class PagedResultDtoOfAttOverTimeRecordListDto implements IPagedResultDtoOfAttOverTimeRecordListDto {
    totalCount: number;
    items: AttOverTimeRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttOverTimeRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttOverTimeRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttOverTimeRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttOverTimeRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAttOverTimeRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAttOverTimeRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAttOverTimeRecordListDto {
    totalCount: number;
    items: AttOverTimeRecordListDto[] | undefined;
}

export class AttSignCardRecordListDto implements IAttSignCardRecordListDto {
    id: number;
    /** 员工Id */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** 出勤日期 */
    attDate: moment.Moment;
    /** 打卡时间 */
    checkTime: moment.Moment;
    /** 补卡类型 */
    signCardType: string | undefined;
    /** 补卡原因 */
    reasonType: string | undefined;
    /** 补卡说明 */
    reason: string | undefined;

    constructor(data?: IAttSignCardRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.fromGuid = _data["fromGuid"];
            this.attDate = _data["attDate"] ? moment(_data["attDate"].toString()) : <any>undefined;
            this.checkTime = _data["checkTime"] ? moment(_data["checkTime"].toString()) : <any>undefined;
            this.signCardType = _data["signCardType"];
            this.reasonType = _data["reasonType"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AttSignCardRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttSignCardRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["fromGuid"] = this.fromGuid;
        data["attDate"] = this.attDate ? this.attDate.toISOString() : <any>undefined;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["signCardType"] = this.signCardType;
        data["reasonType"] = this.reasonType;
        data["reason"] = this.reason;
        return data;
    }

    clone(): AttSignCardRecordListDto {
        const json = this.toJSON();
        let result = new AttSignCardRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IAttSignCardRecordListDto {
    id: number;
    /** 员工Id */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** 出勤日期 */
    attDate: moment.Moment;
    /** 打卡时间 */
    checkTime: moment.Moment;
    /** 补卡类型 */
    signCardType: string | undefined;
    /** 补卡原因 */
    reasonType: string | undefined;
    /** 补卡说明 */
    reason: string | undefined;
}

export class PagedResultDtoOfAttSignCardRecordListDto implements IPagedResultDtoOfAttSignCardRecordListDto {
    totalCount: number;
    items: AttSignCardRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttSignCardRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttSignCardRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttSignCardRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttSignCardRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAttSignCardRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAttSignCardRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAttSignCardRecordListDto {
    totalCount: number;
    items: AttSignCardRecordListDto[] | undefined;
}

/** 考勤组的列表DTO QYB.QYBProduct.Attendance.AttendanceGroup.AttendanceGroup */
export class AttendanceGroupEditDto implements IAttendanceGroupEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** AttendanceType */
    attendanceType: string | undefined;
    /** CheckInType */
    checkInType: string | undefined;
    /** ShiftCodes */
    shiftCodes: string | undefined;
    /** CycleDays */
    cycleDays: number | undefined;
    /** 周期名称 */
    cycleName: string | undefined;
    /** RuleShiftCodes */
    ruleShiftCodes: string | undefined;
    /** Description */
    description: string | undefined;

    constructor(data?: IAttendanceGroupEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.attendanceType = _data["attendanceType"];
            this.checkInType = _data["checkInType"];
            this.shiftCodes = _data["shiftCodes"];
            this.cycleDays = _data["cycleDays"];
            this.cycleName = _data["cycleName"];
            this.ruleShiftCodes = _data["ruleShiftCodes"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AttendanceGroupEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceGroupEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["attendanceType"] = this.attendanceType;
        data["checkInType"] = this.checkInType;
        data["shiftCodes"] = this.shiftCodes;
        data["cycleDays"] = this.cycleDays;
        data["cycleName"] = this.cycleName;
        data["ruleShiftCodes"] = this.ruleShiftCodes;
        data["description"] = this.description;
        return data;
    }

    clone(): AttendanceGroupEditDto {
        const json = this.toJSON();
        let result = new AttendanceGroupEditDto();
        result.init(json);
        return result;
    }
}

/** 考勤组的列表DTO QYB.QYBProduct.Attendance.AttendanceGroup.AttendanceGroup */
export interface IAttendanceGroupEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** AttendanceType */
    attendanceType: string | undefined;
    /** CheckInType */
    checkInType: string | undefined;
    /** ShiftCodes */
    shiftCodes: string | undefined;
    /** CycleDays */
    cycleDays: number | undefined;
    /** 周期名称 */
    cycleName: string | undefined;
    /** RuleShiftCodes */
    ruleShiftCodes: string | undefined;
    /** Description */
    description: string | undefined;
}

/** 考勤人员 */
export class AttendancePeopleEditDto implements IAttendancePeopleEditDto {
    id: number | undefined;
    /** 考勤组主键 */
    attendanceGroupId: number;
    /** 用户Id */
    empId: number;
    /** 是否考勤 */
    isCheckIn: boolean | undefined;
    /** 用户名 */
    realName: string | undefined;
    /** 是否显示 */
    isShow: boolean;

    constructor(data?: IAttendancePeopleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attendanceGroupId = _data["attendanceGroupId"];
            this.empId = _data["empId"];
            this.isCheckIn = _data["isCheckIn"];
            this.realName = _data["realName"];
            this.isShow = _data["isShow"];
        }
    }

    static fromJS(data: any): AttendancePeopleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendancePeopleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attendanceGroupId"] = this.attendanceGroupId;
        data["empId"] = this.empId;
        data["isCheckIn"] = this.isCheckIn;
        data["realName"] = this.realName;
        data["isShow"] = this.isShow;
        return data;
    }

    clone(): AttendancePeopleEditDto {
        const json = this.toJSON();
        let result = new AttendancePeopleEditDto();
        result.init(json);
        return result;
    }
}

/** 考勤人员 */
export interface IAttendancePeopleEditDto {
    id: number | undefined;
    /** 考勤组主键 */
    attendanceGroupId: number;
    /** 用户Id */
    empId: number;
    /** 是否考勤 */
    isCheckIn: boolean | undefined;
    /** 用户名 */
    realName: string | undefined;
    /** 是否显示 */
    isShow: boolean;
}

/** 考勤组负责人 */
export class AttgroupManagerEditDto implements IAttgroupManagerEditDto {
    id: number | undefined;
    /** 考勤组主键 */
    attendanceGroupId: number;
    /** 用户Id */
    empId: number;
    /** 用户名 */
    realName: string | undefined;

    constructor(data?: IAttgroupManagerEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attendanceGroupId = _data["attendanceGroupId"];
            this.empId = _data["empId"];
            this.realName = _data["realName"];
        }
    }

    static fromJS(data: any): AttgroupManagerEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttgroupManagerEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attendanceGroupId"] = this.attendanceGroupId;
        data["empId"] = this.empId;
        data["realName"] = this.realName;
        return data;
    }

    clone(): AttgroupManagerEditDto {
        const json = this.toJSON();
        let result = new AttgroupManagerEditDto();
        result.init(json);
        return result;
    }
}

/** 考勤组负责人 */
export interface IAttgroupManagerEditDto {
    id: number | undefined;
    /** 考勤组主键 */
    attendanceGroupId: number;
    /** 用户Id */
    empId: number;
    /** 用户名 */
    realName: string | undefined;
}

export class CheckInAddressEditDto implements ICheckInAddressEditDto {
    /** 考勤组主键 */
    attendanceGroupId: number;
    /** 名称 */
    name: string | undefined;
    /** 详细地址 */
    detailedAddress: string | undefined;
    /** 维度 */
    lat: string | undefined;
    /** 经度 */
    lng: string | undefined;
    /** 有效范围 */
    validLimit: number;

    constructor(data?: ICheckInAddressEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceGroupId = _data["attendanceGroupId"];
            this.name = _data["name"];
            this.detailedAddress = _data["detailedAddress"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.validLimit = _data["validLimit"];
        }
    }

    static fromJS(data: any): CheckInAddressEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInAddressEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceGroupId"] = this.attendanceGroupId;
        data["name"] = this.name;
        data["detailedAddress"] = this.detailedAddress;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["validLimit"] = this.validLimit;
        return data;
    }

    clone(): CheckInAddressEditDto {
        const json = this.toJSON();
        let result = new CheckInAddressEditDto();
        result.init(json);
        return result;
    }
}

export interface ICheckInAddressEditDto {
    /** 考勤组主键 */
    attendanceGroupId: number;
    /** 名称 */
    name: string | undefined;
    /** 详细地址 */
    detailedAddress: string | undefined;
    /** 维度 */
    lat: string | undefined;
    /** 经度 */
    lng: string | undefined;
    /** 有效范围 */
    validLimit: number;
}

export class CreateOrUpdateAttendanceGroupInput implements ICreateOrUpdateAttendanceGroupInput {
    attendanceGroup: AttendanceGroupEditDto;
    /** 考勤人员 */
    attendancePeopleList: AttendancePeopleEditDto[] | undefined;
    /** 考情组负责人 */
    attgroupManagerList: AttgroupManagerEditDto[] | undefined;
    /** 打卡定位表 */
    checkInAddressList: CheckInAddressEditDto[] | undefined;

    constructor(data?: ICreateOrUpdateAttendanceGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attendanceGroup = new AttendanceGroupEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceGroup = _data["attendanceGroup"] ? AttendanceGroupEditDto.fromJS(_data["attendanceGroup"]) : new AttendanceGroupEditDto();
            if (Array.isArray(_data["attendancePeopleList"])) {
                this.attendancePeopleList = [] as any;
                for (let item of _data["attendancePeopleList"])
                    this.attendancePeopleList.push(AttendancePeopleEditDto.fromJS(item));
            }
            if (Array.isArray(_data["attgroupManagerList"])) {
                this.attgroupManagerList = [] as any;
                for (let item of _data["attgroupManagerList"])
                    this.attgroupManagerList.push(AttgroupManagerEditDto.fromJS(item));
            }
            if (Array.isArray(_data["checkInAddressList"])) {
                this.checkInAddressList = [] as any;
                for (let item of _data["checkInAddressList"])
                    this.checkInAddressList.push(CheckInAddressEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAttendanceGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAttendanceGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceGroup"] = this.attendanceGroup ? this.attendanceGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.attendancePeopleList)) {
            data["attendancePeopleList"] = [];
            for (let item of this.attendancePeopleList)
                data["attendancePeopleList"].push(item.toJSON());
        }
        if (Array.isArray(this.attgroupManagerList)) {
            data["attgroupManagerList"] = [];
            for (let item of this.attgroupManagerList)
                data["attgroupManagerList"].push(item.toJSON());
        }
        if (Array.isArray(this.checkInAddressList)) {
            data["checkInAddressList"] = [];
            for (let item of this.checkInAddressList)
                data["checkInAddressList"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateAttendanceGroupInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAttendanceGroupInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAttendanceGroupInput {
    attendanceGroup: AttendanceGroupEditDto;
    /** 考勤人员 */
    attendancePeopleList: AttendancePeopleEditDto[] | undefined;
    /** 考情组负责人 */
    attgroupManagerList: AttgroupManagerEditDto[] | undefined;
    /** 打卡定位表 */
    checkInAddressList: CheckInAddressEditDto[] | undefined;
}

/** 班次的列表DTO QYB.QYBProduct.Attendance.ShiftInfo.ShiftInfo */
export class ShiftInfoListDto implements IShiftInfoListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** WorkTypeId */
    workTypeCode: string | undefined;
    /** StartTime */
    startTime: string | undefined;
    /** EndTime */
    endTime: string | undefined;
    /** UpCardStartTime */
    upCardStartTime: string | undefined;
    /** UpCardEndTime */
    upCardEndTime: string | undefined;
    /** DownCardStartTime */
    downCardStartTime: string | undefined;
    /** DownCardEndTime */
    downCardEndTime: string | undefined;
    /** RestStartTime */
    restStartTime: string | undefined;
    /** RestEndTime */
    restEndTime: string | undefined;
    /** RestMinutes */
    restMinutes: number | undefined;
    /** WorkHours */
    workHours: number | undefined;
    /** WorkDays */
    workDays: number | undefined;
    /** IsNightShift */
    isNightShift: boolean | undefined;
    /** Allowance */
    allowance: number | undefined;
    /** LateMinutes */
    lateMinutes: number | undefined;
    /** LeaveEarlyMinutes */
    leaveEarlyMinutes: number | undefined;
    /** AbsenteeismMinutes */
    absenteeismMinutes: number | undefined;
    /** AfterWorkOTStart */
    afterWorkOTStart: string | undefined;
    id: number;

    constructor(data?: IShiftInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.workTypeCode = _data["workTypeCode"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.upCardStartTime = _data["upCardStartTime"];
            this.upCardEndTime = _data["upCardEndTime"];
            this.downCardStartTime = _data["downCardStartTime"];
            this.downCardEndTime = _data["downCardEndTime"];
            this.restStartTime = _data["restStartTime"];
            this.restEndTime = _data["restEndTime"];
            this.restMinutes = _data["restMinutes"];
            this.workHours = _data["workHours"];
            this.workDays = _data["workDays"];
            this.isNightShift = _data["isNightShift"];
            this.allowance = _data["allowance"];
            this.lateMinutes = _data["lateMinutes"];
            this.leaveEarlyMinutes = _data["leaveEarlyMinutes"];
            this.absenteeismMinutes = _data["absenteeismMinutes"];
            this.afterWorkOTStart = _data["afterWorkOTStart"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShiftInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["workTypeCode"] = this.workTypeCode;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["upCardStartTime"] = this.upCardStartTime;
        data["upCardEndTime"] = this.upCardEndTime;
        data["downCardStartTime"] = this.downCardStartTime;
        data["downCardEndTime"] = this.downCardEndTime;
        data["restStartTime"] = this.restStartTime;
        data["restEndTime"] = this.restEndTime;
        data["restMinutes"] = this.restMinutes;
        data["workHours"] = this.workHours;
        data["workDays"] = this.workDays;
        data["isNightShift"] = this.isNightShift;
        data["allowance"] = this.allowance;
        data["lateMinutes"] = this.lateMinutes;
        data["leaveEarlyMinutes"] = this.leaveEarlyMinutes;
        data["absenteeismMinutes"] = this.absenteeismMinutes;
        data["afterWorkOTStart"] = this.afterWorkOTStart;
        data["id"] = this.id;
        return data;
    }

    clone(): ShiftInfoListDto {
        const json = this.toJSON();
        let result = new ShiftInfoListDto();
        result.init(json);
        return result;
    }
}

/** 班次的列表DTO QYB.QYBProduct.Attendance.ShiftInfo.ShiftInfo */
export interface IShiftInfoListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** WorkTypeId */
    workTypeCode: string | undefined;
    /** StartTime */
    startTime: string | undefined;
    /** EndTime */
    endTime: string | undefined;
    /** UpCardStartTime */
    upCardStartTime: string | undefined;
    /** UpCardEndTime */
    upCardEndTime: string | undefined;
    /** DownCardStartTime */
    downCardStartTime: string | undefined;
    /** DownCardEndTime */
    downCardEndTime: string | undefined;
    /** RestStartTime */
    restStartTime: string | undefined;
    /** RestEndTime */
    restEndTime: string | undefined;
    /** RestMinutes */
    restMinutes: number | undefined;
    /** WorkHours */
    workHours: number | undefined;
    /** WorkDays */
    workDays: number | undefined;
    /** IsNightShift */
    isNightShift: boolean | undefined;
    /** Allowance */
    allowance: number | undefined;
    /** LateMinutes */
    lateMinutes: number | undefined;
    /** LeaveEarlyMinutes */
    leaveEarlyMinutes: number | undefined;
    /** AbsenteeismMinutes */
    absenteeismMinutes: number | undefined;
    /** AfterWorkOTStart */
    afterWorkOTStart: string | undefined;
    id: number;
}

export class GetAttGroupDetailedDto implements IGetAttGroupDetailedDto {
    shiftInfoList: ShiftInfoListDto[] | undefined;
    /** 原生班别 */
    shiftInfoName: string | undefined;

    constructor(data?: IGetAttGroupDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftInfoList"])) {
                this.shiftInfoList = [] as any;
                for (let item of _data["shiftInfoList"])
                    this.shiftInfoList.push(ShiftInfoListDto.fromJS(item));
            }
            this.shiftInfoName = _data["shiftInfoName"];
        }
    }

    static fromJS(data: any): GetAttGroupDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttGroupDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftInfoList)) {
            data["shiftInfoList"] = [];
            for (let item of this.shiftInfoList)
                data["shiftInfoList"].push(item.toJSON());
        }
        data["shiftInfoName"] = this.shiftInfoName;
        return data;
    }

    clone(): GetAttGroupDetailedDto {
        const json = this.toJSON();
        let result = new GetAttGroupDetailedDto();
        result.init(json);
        return result;
    }
}

export interface IGetAttGroupDetailedDto {
    shiftInfoList: ShiftInfoListDto[] | undefined;
    /** 原生班别 */
    shiftInfoName: string | undefined;
}

/** 考勤组的列表DTO QYB.QYBProduct.Attendance.AttendanceGroup.AttendanceGroup */
export class AttendanceGroupListDto implements IAttendanceGroupListDto {
    /** Name */
    name: string | undefined;
    /** AttendanceType */
    attendanceType: string | undefined;
    /** CheckInType */
    checkInType: string | undefined;
    /** ShiftCodes */
    shiftCodes: string | undefined;
    /** CycleDays */
    cycleDays: number | undefined;
    /** 周期名称 */
    cycleName: string | undefined;
    /** RuleShiftCodes */
    ruleShiftCodes: string | undefined;
    /** Description */
    description: string | undefined;
    /** 人数 */
    userCount: number;
    id: number;

    constructor(data?: IAttendanceGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attendanceType = _data["attendanceType"];
            this.checkInType = _data["checkInType"];
            this.shiftCodes = _data["shiftCodes"];
            this.cycleDays = _data["cycleDays"];
            this.cycleName = _data["cycleName"];
            this.ruleShiftCodes = _data["ruleShiftCodes"];
            this.description = _data["description"];
            this.userCount = _data["userCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attendanceType"] = this.attendanceType;
        data["checkInType"] = this.checkInType;
        data["shiftCodes"] = this.shiftCodes;
        data["cycleDays"] = this.cycleDays;
        data["cycleName"] = this.cycleName;
        data["ruleShiftCodes"] = this.ruleShiftCodes;
        data["description"] = this.description;
        data["userCount"] = this.userCount;
        data["id"] = this.id;
        return data;
    }

    clone(): AttendanceGroupListDto {
        const json = this.toJSON();
        let result = new AttendanceGroupListDto();
        result.init(json);
        return result;
    }
}

/** 考勤组的列表DTO QYB.QYBProduct.Attendance.AttendanceGroup.AttendanceGroup */
export interface IAttendanceGroupListDto {
    /** Name */
    name: string | undefined;
    /** AttendanceType */
    attendanceType: string | undefined;
    /** CheckInType */
    checkInType: string | undefined;
    /** ShiftCodes */
    shiftCodes: string | undefined;
    /** CycleDays */
    cycleDays: number | undefined;
    /** 周期名称 */
    cycleName: string | undefined;
    /** RuleShiftCodes */
    ruleShiftCodes: string | undefined;
    /** Description */
    description: string | undefined;
    /** 人数 */
    userCount: number;
    id: number;
}

export class GetCalendarListDto implements IGetCalendarListDto {
    /** 日期 */
    dateTime: string | undefined;
    /** 类型 ,排班，休息 */
    type: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 班次时间，上班时间 */
    shiftInfoTime: string | undefined;
    /** 开始时间 */
    startTime: string | undefined;
    /** 结束时间 */
    endTime: string | undefined;
    /** 班次名称 */
    shiftInfoName: string | undefined;

    constructor(data?: IGetCalendarListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"];
            this.type = _data["type"];
            this.content = _data["content"];
            this.shiftInfoTime = _data["shiftInfoTime"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.shiftInfoName = _data["shiftInfoName"];
        }
    }

    static fromJS(data: any): GetCalendarListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime;
        data["type"] = this.type;
        data["content"] = this.content;
        data["shiftInfoTime"] = this.shiftInfoTime;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["shiftInfoName"] = this.shiftInfoName;
        return data;
    }

    clone(): GetCalendarListDto {
        const json = this.toJSON();
        let result = new GetCalendarListDto();
        result.init(json);
        return result;
    }
}

export interface IGetCalendarListDto {
    /** 日期 */
    dateTime: string | undefined;
    /** 类型 ,排班，休息 */
    type: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 班次时间，上班时间 */
    shiftInfoTime: string | undefined;
    /** 开始时间 */
    startTime: string | undefined;
    /** 结束时间 */
    endTime: string | undefined;
    /** 班次名称 */
    shiftInfoName: string | undefined;
}

/** 读取可编辑考勤组的Dto */
export class GetAttendanceGroupForEditOutput implements IGetAttendanceGroupForEditOutput {
    attendanceGroup: AttendanceGroupEditDto;
    /** 参与考勤人员 */
    attendancePeopleList: AttendancePeopleEditDto[] | undefined;
    /** 不参与考勤人员 */
    unAttendancePeopleList: AttendancePeopleEditDto[] | undefined;
    /** 考情组负责人 */
    attgroupManagerList: AttgroupManagerEditDto[] | undefined;
    /** 打卡定位表 */
    checkInAddressList: CheckInAddressEditDto[] | undefined;
    /** 班次集合 */
    shiftInfoList: ShiftInfoListDto[] | undefined;
    /** 班次周期集合 */
    shiftInfoCycleList: ShiftInfoListDto[] | undefined;

    constructor(data?: IGetAttendanceGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceGroup = _data["attendanceGroup"] ? AttendanceGroupEditDto.fromJS(_data["attendanceGroup"]) : <any>undefined;
            if (Array.isArray(_data["attendancePeopleList"])) {
                this.attendancePeopleList = [] as any;
                for (let item of _data["attendancePeopleList"])
                    this.attendancePeopleList.push(AttendancePeopleEditDto.fromJS(item));
            }
            if (Array.isArray(_data["unAttendancePeopleList"])) {
                this.unAttendancePeopleList = [] as any;
                for (let item of _data["unAttendancePeopleList"])
                    this.unAttendancePeopleList.push(AttendancePeopleEditDto.fromJS(item));
            }
            if (Array.isArray(_data["attgroupManagerList"])) {
                this.attgroupManagerList = [] as any;
                for (let item of _data["attgroupManagerList"])
                    this.attgroupManagerList.push(AttgroupManagerEditDto.fromJS(item));
            }
            if (Array.isArray(_data["checkInAddressList"])) {
                this.checkInAddressList = [] as any;
                for (let item of _data["checkInAddressList"])
                    this.checkInAddressList.push(CheckInAddressEditDto.fromJS(item));
            }
            if (Array.isArray(_data["shiftInfoList"])) {
                this.shiftInfoList = [] as any;
                for (let item of _data["shiftInfoList"])
                    this.shiftInfoList.push(ShiftInfoListDto.fromJS(item));
            }
            if (Array.isArray(_data["shiftInfoCycleList"])) {
                this.shiftInfoCycleList = [] as any;
                for (let item of _data["shiftInfoCycleList"])
                    this.shiftInfoCycleList.push(ShiftInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAttendanceGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceGroup"] = this.attendanceGroup ? this.attendanceGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.attendancePeopleList)) {
            data["attendancePeopleList"] = [];
            for (let item of this.attendancePeopleList)
                data["attendancePeopleList"].push(item.toJSON());
        }
        if (Array.isArray(this.unAttendancePeopleList)) {
            data["unAttendancePeopleList"] = [];
            for (let item of this.unAttendancePeopleList)
                data["unAttendancePeopleList"].push(item.toJSON());
        }
        if (Array.isArray(this.attgroupManagerList)) {
            data["attgroupManagerList"] = [];
            for (let item of this.attgroupManagerList)
                data["attgroupManagerList"].push(item.toJSON());
        }
        if (Array.isArray(this.checkInAddressList)) {
            data["checkInAddressList"] = [];
            for (let item of this.checkInAddressList)
                data["checkInAddressList"].push(item.toJSON());
        }
        if (Array.isArray(this.shiftInfoList)) {
            data["shiftInfoList"] = [];
            for (let item of this.shiftInfoList)
                data["shiftInfoList"].push(item.toJSON());
        }
        if (Array.isArray(this.shiftInfoCycleList)) {
            data["shiftInfoCycleList"] = [];
            for (let item of this.shiftInfoCycleList)
                data["shiftInfoCycleList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAttendanceGroupForEditOutput {
        const json = this.toJSON();
        let result = new GetAttendanceGroupForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑考勤组的Dto */
export interface IGetAttendanceGroupForEditOutput {
    attendanceGroup: AttendanceGroupEditDto;
    /** 参与考勤人员 */
    attendancePeopleList: AttendancePeopleEditDto[] | undefined;
    /** 不参与考勤人员 */
    unAttendancePeopleList: AttendancePeopleEditDto[] | undefined;
    /** 考情组负责人 */
    attgroupManagerList: AttgroupManagerEditDto[] | undefined;
    /** 打卡定位表 */
    checkInAddressList: CheckInAddressEditDto[] | undefined;
    /** 班次集合 */
    shiftInfoList: ShiftInfoListDto[] | undefined;
    /** 班次周期集合 */
    shiftInfoCycleList: ShiftInfoListDto[] | undefined;
}

export class PagedResultDtoOfAttendanceGroupListDto implements IPagedResultDtoOfAttendanceGroupListDto {
    totalCount: number;
    items: AttendanceGroupListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttendanceGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttendanceGroupListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttendanceGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttendanceGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAttendanceGroupListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAttendanceGroupListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAttendanceGroupListDto {
    totalCount: number;
    items: AttendanceGroupListDto[] | undefined;
}

export class ShiftEditDto implements IShiftEditDto {
    /** 考勤组Id */
    attGroupId: number;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 班次 */
    attendShiftCode: string | undefined;
    /** 班次索引 */
    shiftCodeIndex: number;
    /** 规则，1：跳过，2：顺延，3：覆盖 */
    ruleCode: number;
    /** 是否覆盖原有排班 */
    isCoverEmpPlan: boolean;

    constructor(data?: IShiftEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attGroupId = _data["attGroupId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.attendShiftCode = _data["attendShiftCode"];
            this.shiftCodeIndex = _data["shiftCodeIndex"];
            this.ruleCode = _data["ruleCode"];
            this.isCoverEmpPlan = _data["isCoverEmpPlan"];
        }
    }

    static fromJS(data: any): ShiftEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attGroupId"] = this.attGroupId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["attendShiftCode"] = this.attendShiftCode;
        data["shiftCodeIndex"] = this.shiftCodeIndex;
        data["ruleCode"] = this.ruleCode;
        data["isCoverEmpPlan"] = this.isCoverEmpPlan;
        return data;
    }

    clone(): ShiftEditDto {
        const json = this.toJSON();
        let result = new ShiftEditDto();
        result.init(json);
        return result;
    }
}

export interface IShiftEditDto {
    /** 考勤组Id */
    attGroupId: number;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 班次 */
    attendShiftCode: string | undefined;
    /** 班次索引 */
    shiftCodeIndex: number;
    /** 规则，1：跳过，2：顺延，3：覆盖 */
    ruleCode: number;
    /** 是否覆盖原有排班 */
    isCoverEmpPlan: boolean;
}

/** 的列表DTO QYB.QYBProduct.Attendance.AttMachineDeploy.AttMachineDeploy */
export class AttMachineDeployEditDto implements IAttMachineDeployEditDto {
    /** Id */
    id: number | undefined;
    /** Enable */
    enable: boolean | undefined;
    /** DockingUrl */
    dockingUrl: string | undefined;
    /** DockingKey */
    dockingKey: string | undefined;

    constructor(data?: IAttMachineDeployEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enable = _data["enable"];
            this.dockingUrl = _data["dockingUrl"];
            this.dockingKey = _data["dockingKey"];
        }
    }

    static fromJS(data: any): AttMachineDeployEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttMachineDeployEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enable"] = this.enable;
        data["dockingUrl"] = this.dockingUrl;
        data["dockingKey"] = this.dockingKey;
        return data;
    }

    clone(): AttMachineDeployEditDto {
        const json = this.toJSON();
        let result = new AttMachineDeployEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.AttMachineDeploy.AttMachineDeploy */
export interface IAttMachineDeployEditDto {
    /** Id */
    id: number | undefined;
    /** Enable */
    enable: boolean | undefined;
    /** DockingUrl */
    dockingUrl: string | undefined;
    /** DockingKey */
    dockingKey: string | undefined;
}

export class CreateOrUpdateAttMachineDeployInput implements ICreateOrUpdateAttMachineDeployInput {
    attMachineDeploy: AttMachineDeployEditDto;

    constructor(data?: ICreateOrUpdateAttMachineDeployInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attMachineDeploy = new AttMachineDeployEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attMachineDeploy = _data["attMachineDeploy"] ? AttMachineDeployEditDto.fromJS(_data["attMachineDeploy"]) : new AttMachineDeployEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAttMachineDeployInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAttMachineDeployInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attMachineDeploy"] = this.attMachineDeploy ? this.attMachineDeploy.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAttMachineDeployInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAttMachineDeployInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAttMachineDeployInput {
    attMachineDeploy: AttMachineDeployEditDto;
}

/** 的列表DTO QYB.QYBProduct.Attendance.AttMachineDeploy.AttMachineDeploy */
export class AttMachineDeployListDto implements IAttMachineDeployListDto {
    /** Enable */
    enable: boolean | undefined;
    /** DockingUrl */
    dockingUrl: string | undefined;
    /** DockingKey */
    dockingKey: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;

    constructor(data?: IAttMachineDeployListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
            this.dockingUrl = _data["dockingUrl"];
            this.dockingKey = _data["dockingKey"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttMachineDeployListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttMachineDeployListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        data["dockingUrl"] = this.dockingUrl;
        data["dockingKey"] = this.dockingKey;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): AttMachineDeployListDto {
        const json = this.toJSON();
        let result = new AttMachineDeployListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.AttMachineDeploy.AttMachineDeploy */
export interface IAttMachineDeployListDto {
    /** Enable */
    enable: boolean | undefined;
    /** DockingUrl */
    dockingUrl: string | undefined;
    /** DockingKey */
    dockingKey: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;
}

/** 读取可编辑的Dto */
export class GetAttMachineDeployForEditOutput implements IGetAttMachineDeployForEditOutput {
    attMachineDeploy: AttMachineDeployEditDto;

    constructor(data?: IGetAttMachineDeployForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attMachineDeploy = _data["attMachineDeploy"] ? AttMachineDeployEditDto.fromJS(_data["attMachineDeploy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttMachineDeployForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttMachineDeployForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attMachineDeploy"] = this.attMachineDeploy ? this.attMachineDeploy.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAttMachineDeployForEditOutput {
        const json = this.toJSON();
        let result = new GetAttMachineDeployForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetAttMachineDeployForEditOutput {
    attMachineDeploy: AttMachineDeployEditDto;
}

export class PagedResultDtoOfAttMachineDeployListDto implements IPagedResultDtoOfAttMachineDeployListDto {
    totalCount: number;
    items: AttMachineDeployListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttMachineDeployListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttMachineDeployListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttMachineDeployListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttMachineDeployListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAttMachineDeployListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAttMachineDeployListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAttMachineDeployListDto {
    totalCount: number;
    items: AttMachineDeployListDto[] | undefined;
}

/** 审核项修改实体 */
export class AuditItemEditDto implements IAuditItemEditDto {
    /** Id */
    id: number | undefined;
    /** 审核点分组 */
    auditItemGroupId: number;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 概述 */
    name: string | undefined;
    /** 详细描述 */
    description: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 不合格时必须提交问题 */
    unQualifiedMustSubmitIssue: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 问题分类 */
    issueTypeId: number | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdList: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 排序 */
    sn: number;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 单位 */
    valueUnit: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 编号 */
    code: string | undefined;

    constructor(data?: IAuditItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditItemGroupId = _data["auditItemGroupId"];
            this.auditItemTypeId = _data["auditItemTypeId"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.auditNeedInput = _data["auditNeedInput"];
            this.auditNeedPic = _data["auditNeedPic"];
            this.auditNeedDesc = _data["auditNeedDesc"];
            this.unQualifiedMustSubmitIssue = _data["unQualifiedMustSubmitIssue"];
            this.issueNeedPic = _data["issueNeedPic"];
            this.issueTypeId = _data["issueTypeId"];
            this.issueTypeIdList = _data["issueTypeIdList"];
            this.enable = _data["enable"];
            this.sn = _data["sn"];
            this.optionType = _data["optionType"];
            this.valueStandard = _data["valueStandard"];
            this.valueUpperLimit = _data["valueUpperLimit"];
            this.valueLowerLimit = _data["valueLowerLimit"];
            this.valueUnit = _data["valueUnit"];
            this.isAllowTransfer = _data["isAllowTransfer"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AuditItemEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditItemGroupId"] = this.auditItemGroupId;
        data["auditItemTypeId"] = this.auditItemTypeId;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["auditNeedInput"] = this.auditNeedInput;
        data["auditNeedPic"] = this.auditNeedPic;
        data["auditNeedDesc"] = this.auditNeedDesc;
        data["unQualifiedMustSubmitIssue"] = this.unQualifiedMustSubmitIssue;
        data["issueNeedPic"] = this.issueNeedPic;
        data["issueTypeId"] = this.issueTypeId;
        data["issueTypeIdList"] = this.issueTypeIdList;
        data["enable"] = this.enable;
        data["sn"] = this.sn;
        data["optionType"] = this.optionType;
        data["valueStandard"] = this.valueStandard;
        data["valueUpperLimit"] = this.valueUpperLimit;
        data["valueLowerLimit"] = this.valueLowerLimit;
        data["valueUnit"] = this.valueUnit;
        data["isAllowTransfer"] = this.isAllowTransfer;
        data["code"] = this.code;
        return data;
    }

    clone(): AuditItemEditDto {
        const json = this.toJSON();
        let result = new AuditItemEditDto();
        result.init(json);
        return result;
    }
}

/** 审核项修改实体 */
export interface IAuditItemEditDto {
    /** Id */
    id: number | undefined;
    /** 审核点分组 */
    auditItemGroupId: number;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 概述 */
    name: string | undefined;
    /** 详细描述 */
    description: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 不合格时必须提交问题 */
    unQualifiedMustSubmitIssue: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 问题分类 */
    issueTypeId: number | undefined;
    /** 问题分类（多选，防止以前功能崩溃，所以多加了一个字段，后续会删除上面字段） */
    issueTypeIdList: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 排序 */
    sn: number;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 单位 */
    valueUnit: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 编号 */
    code: string | undefined;
}

export class CreatOrUpdataAuditItemInput implements ICreatOrUpdataAuditItemInput {
    auditItemEditDto: AuditItemEditDto;

    constructor(data?: ICreatOrUpdataAuditItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditItemEditDto = new AuditItemEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemEditDto = _data["auditItemEditDto"] ? AuditItemEditDto.fromJS(_data["auditItemEditDto"]) : new AuditItemEditDto();
        }
    }

    static fromJS(data: any): CreatOrUpdataAuditItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataAuditItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemEditDto"] = this.auditItemEditDto ? this.auditItemEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdataAuditItemInput {
        const json = this.toJSON();
        let result = new CreatOrUpdataAuditItemInput();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdataAuditItemInput {
    auditItemEditDto: AuditItemEditDto;
}

export class PagedResultDtoOfAuditItemListDto implements IPagedResultDtoOfAuditItemListDto {
    totalCount: number;
    items: AuditItemListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditItemListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditItemListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditItemListDto {
    totalCount: number;
    items: AuditItemListDto[] | undefined;
}

export class AuditItemGroupListDto implements IAuditItemGroupListDto {
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集（实现递归） */
    children: AuditItemGroupListDto[] | undefined;
    id: number;

    constructor(data?: IAuditItemGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditItemGroupListDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditItemGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AuditItemGroupListDto {
        const json = this.toJSON();
        let result = new AuditItemGroupListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditItemGroupListDto {
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集（实现递归） */
    children: AuditItemGroupListDto[] | undefined;
    id: number;
}

export class AuditItemTypeListDto implements IAuditItemTypeListDto {
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集 */
    children: AuditItemTypeListDto[] | undefined;
    id: number;

    constructor(data?: IAuditItemTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditItemTypeListDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditItemTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AuditItemTypeListDto {
        const json = this.toJSON();
        let result = new AuditItemTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditItemTypeListDto {
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集 */
    children: AuditItemTypeListDto[] | undefined;
    id: number;
}

/** 导入返回结果 */
export class ImportResultDto implements IImportResultDto {
    /** 是否全部导入完成 */
    isSuccess: boolean;
    file: FileDto;
    /** 总条数 */
    totalCount: number;
    /** 失败条数 */
    failedCount: number;

    constructor(data?: IImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
            this.failedCount = _data["failedCount"];
        }
    }

    static fromJS(data: any): ImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        data["failedCount"] = this.failedCount;
        return data;
    }

    clone(): ImportResultDto {
        const json = this.toJSON();
        let result = new ImportResultDto();
        result.init(json);
        return result;
    }
}

/** 导入返回结果 */
export interface IImportResultDto {
    /** 是否全部导入完成 */
    isSuccess: boolean;
    file: FileDto;
    /** 总条数 */
    totalCount: number;
    /** 失败条数 */
    failedCount: number;
}

export class NullableIdDtoOfInt64 implements INullableIdDtoOfInt64 {
    id: number | undefined;

    constructor(data?: INullableIdDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NullableIdDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new NullableIdDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): NullableIdDtoOfInt64 {
        const json = this.toJSON();
        let result = new NullableIdDtoOfInt64();
        result.init(json);
        return result;
    }
}

export interface INullableIdDtoOfInt64 {
    id: number | undefined;
}

export class DataItem implements IDataItem {
    parentId: number;
    itemCode: string | undefined;
    itemName: string | undefined;
    sortCode: number;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    isSyetem: boolean | undefined;
    id: number;

    constructor(data?: IDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.itemCode = _data["itemCode"];
            this.itemName = _data["itemName"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isSyetem = _data["isSyetem"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DataItem {
        data = typeof data === 'object' ? data : {};
        let result = new DataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isSyetem"] = this.isSyetem;
        data["id"] = this.id;
        return data;
    }

    clone(): DataItem {
        const json = this.toJSON();
        let result = new DataItem();
        result.init(json);
        return result;
    }
}

export interface IDataItem {
    parentId: number;
    itemCode: string | undefined;
    itemName: string | undefined;
    sortCode: number;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    isSyetem: boolean | undefined;
    id: number;
}

export class DataItemDetail implements IDataItemDetail {
    dataItemId: number;
    dataItem: DataItem;
    itemCode: string | undefined;
    itemDetailCode: string | undefined;
    itemDetailName: string | undefined;
    sortCode: number | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    isSyetem: boolean | undefined;
    id: number;

    constructor(data?: IDataItemDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataItemId = _data["dataItemId"];
            this.dataItem = _data["dataItem"] ? DataItem.fromJS(_data["dataItem"]) : <any>undefined;
            this.itemCode = _data["itemCode"];
            this.itemDetailCode = _data["itemDetailCode"];
            this.itemDetailName = _data["itemDetailName"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isSyetem = _data["isSyetem"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DataItemDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataItemId"] = this.dataItemId;
        data["dataItem"] = this.dataItem ? this.dataItem.toJSON() : <any>undefined;
        data["itemCode"] = this.itemCode;
        data["itemDetailCode"] = this.itemDetailCode;
        data["itemDetailName"] = this.itemDetailName;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isSyetem"] = this.isSyetem;
        data["id"] = this.id;
        return data;
    }

    clone(): DataItemDetail {
        const json = this.toJSON();
        let result = new DataItemDetail();
        result.init(json);
        return result;
    }
}

export interface IDataItemDetail {
    dataItemId: number;
    dataItem: DataItem;
    itemCode: string | undefined;
    itemDetailCode: string | undefined;
    itemDetailName: string | undefined;
    sortCode: number | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    isSyetem: boolean | undefined;
    id: number;
}

export class AuditItemGroupEditDto implements IAuditItemGroupEditDto {
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;

    constructor(data?: IAuditItemGroupEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
        }
    }

    static fromJS(data: any): AuditItemGroupEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemGroupEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        return data;
    }

    clone(): AuditItemGroupEditDto {
        const json = this.toJSON();
        let result = new AuditItemGroupEditDto();
        result.init(json);
        return result;
    }
}

export interface IAuditItemGroupEditDto {
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
}

/** 创建审核项实体 */
export class CreatOrUpdateAuditItemGroupInput implements ICreatOrUpdateAuditItemGroupInput {
    auditItemGroupEdit: AuditItemGroupEditDto;

    constructor(data?: ICreatOrUpdateAuditItemGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditItemGroupEdit = new AuditItemGroupEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemGroupEdit = _data["auditItemGroupEdit"] ? AuditItemGroupEditDto.fromJS(_data["auditItemGroupEdit"]) : new AuditItemGroupEditDto();
        }
    }

    static fromJS(data: any): CreatOrUpdateAuditItemGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdateAuditItemGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemGroupEdit"] = this.auditItemGroupEdit ? this.auditItemGroupEdit.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdateAuditItemGroupInput {
        const json = this.toJSON();
        let result = new CreatOrUpdateAuditItemGroupInput();
        result.init(json);
        return result;
    }
}

/** 创建审核项实体 */
export interface ICreatOrUpdateAuditItemGroupInput {
    auditItemGroupEdit: AuditItemGroupEditDto;
}

/** dto */
export class AuditItemTemplateEditDto implements IAuditItemTemplateEditDto {
    /** Id */
    id: number | undefined;
    /** 审核项模板分组Id */
    auditItemTemplateGroupId: number;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 是否启用 */
    remark: string | undefined;

    constructor(data?: IAuditItemTemplateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditItemTemplateGroupId = _data["auditItemTemplateGroupId"];
            this.name = _data["name"];
            this.isWalkAudit = _data["isWalkAudit"];
            this.enable = _data["enable"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): AuditItemTemplateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTemplateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditItemTemplateGroupId"] = this.auditItemTemplateGroupId;
        data["name"] = this.name;
        data["isWalkAudit"] = this.isWalkAudit;
        data["enable"] = this.enable;
        data["remark"] = this.remark;
        return data;
    }

    clone(): AuditItemTemplateEditDto {
        const json = this.toJSON();
        let result = new AuditItemTemplateEditDto();
        result.init(json);
        return result;
    }
}

/** dto */
export interface IAuditItemTemplateEditDto {
    /** Id */
    id: number | undefined;
    /** 审核项模板分组Id */
    auditItemTemplateGroupId: number;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 是否启用 */
    remark: string | undefined;
}

/** 新增修改 */
export class CreatOrUpdataAuditItemTemplateDetailInput implements ICreatOrUpdataAuditItemTemplateDetailInput {
    auditItemTemplate: AuditItemTemplateEditDto;
    /** dto */
    auditItemTemplateDetailIdList: number[];

    constructor(data?: ICreatOrUpdataAuditItemTemplateDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditItemTemplate = new AuditItemTemplateEditDto();
            this.auditItemTemplateDetailIdList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemTemplate = _data["auditItemTemplate"] ? AuditItemTemplateEditDto.fromJS(_data["auditItemTemplate"]) : new AuditItemTemplateEditDto();
            if (Array.isArray(_data["auditItemTemplateDetailIdList"])) {
                this.auditItemTemplateDetailIdList = [] as any;
                for (let item of _data["auditItemTemplateDetailIdList"])
                    this.auditItemTemplateDetailIdList.push(item);
            }
        }
    }

    static fromJS(data: any): CreatOrUpdataAuditItemTemplateDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataAuditItemTemplateDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemTemplate"] = this.auditItemTemplate ? this.auditItemTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.auditItemTemplateDetailIdList)) {
            data["auditItemTemplateDetailIdList"] = [];
            for (let item of this.auditItemTemplateDetailIdList)
                data["auditItemTemplateDetailIdList"].push(item);
        }
        return data;
    }

    clone(): CreatOrUpdataAuditItemTemplateDetailInput {
        const json = this.toJSON();
        let result = new CreatOrUpdataAuditItemTemplateDetailInput();
        result.init(json);
        return result;
    }
}

/** 新增修改 */
export interface ICreatOrUpdataAuditItemTemplateDetailInput {
    auditItemTemplate: AuditItemTemplateEditDto;
    /** dto */
    auditItemTemplateDetailIdList: number[];
}

export class PagedResultDtoOfAuditItemTemplateListDto implements IPagedResultDtoOfAuditItemTemplateListDto {
    totalCount: number;
    items: AuditItemTemplateListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditItemTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditItemTemplateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditItemTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditItemTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditItemTemplateListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditItemTemplateListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditItemTemplateListDto {
    totalCount: number;
    items: AuditItemTemplateListDto[] | undefined;
}

/** EditDto */
export class AuditItemTemplateGroupEditDto implements IAuditItemTemplateGroupEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;

    constructor(data?: IAuditItemTemplateGroupEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
        }
    }

    static fromJS(data: any): AuditItemTemplateGroupEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTemplateGroupEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        return data;
    }

    clone(): AuditItemTemplateGroupEditDto {
        const json = this.toJSON();
        let result = new AuditItemTemplateGroupEditDto();
        result.init(json);
        return result;
    }
}

/** EditDto */
export interface IAuditItemTemplateGroupEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
}

/** 修改删除Dto */
export class CreateOrUpdateAuditItemTemplateGroupInput implements ICreateOrUpdateAuditItemTemplateGroupInput {
    auditItemTemplateGroup: AuditItemTemplateGroupEditDto;

    constructor(data?: ICreateOrUpdateAuditItemTemplateGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditItemTemplateGroup = new AuditItemTemplateGroupEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemTemplateGroup = _data["auditItemTemplateGroup"] ? AuditItemTemplateGroupEditDto.fromJS(_data["auditItemTemplateGroup"]) : new AuditItemTemplateGroupEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAuditItemTemplateGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAuditItemTemplateGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemTemplateGroup"] = this.auditItemTemplateGroup ? this.auditItemTemplateGroup.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAuditItemTemplateGroupInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAuditItemTemplateGroupInput();
        result.init(json);
        return result;
    }
}

/** 修改删除Dto */
export interface ICreateOrUpdateAuditItemTemplateGroupInput {
    auditItemTemplateGroup: AuditItemTemplateGroupEditDto;
}

/** ListDto */
export class AuditItemTemplateGroupListDto implements IAuditItemTemplateGroupListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集（实现递归） */
    children: AuditItemTemplateGroupListDto[] | undefined;

    constructor(data?: IAuditItemTemplateGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditItemTemplateGroupListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditItemTemplateGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTemplateGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditItemTemplateGroupListDto {
        const json = this.toJSON();
        let result = new AuditItemTemplateGroupListDto();
        result.init(json);
        return result;
    }
}

/** ListDto */
export interface IAuditItemTemplateGroupListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集（实现递归） */
    children: AuditItemTemplateGroupListDto[] | undefined;
}

export class AuditItemTypeEditDto implements IAuditItemTypeEditDto {
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;

    constructor(data?: IAuditItemTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
        }
    }

    static fromJS(data: any): AuditItemTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItemTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        return data;
    }

    clone(): AuditItemTypeEditDto {
        const json = this.toJSON();
        let result = new AuditItemTypeEditDto();
        result.init(json);
        return result;
    }
}

export interface IAuditItemTypeEditDto {
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
}

export class CreatOrUpdateAuditItemTypeInput implements ICreatOrUpdateAuditItemTypeInput {
    auditItemTypeEditDto: AuditItemTypeEditDto;

    constructor(data?: ICreatOrUpdateAuditItemTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditItemTypeEditDto = new AuditItemTypeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemTypeEditDto = _data["auditItemTypeEditDto"] ? AuditItemTypeEditDto.fromJS(_data["auditItemTypeEditDto"]) : new AuditItemTypeEditDto();
        }
    }

    static fromJS(data: any): CreatOrUpdateAuditItemTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdateAuditItemTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemTypeEditDto"] = this.auditItemTypeEditDto ? this.auditItemTypeEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdateAuditItemTypeInput {
        const json = this.toJSON();
        let result = new CreatOrUpdateAuditItemTypeInput();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdateAuditItemTypeInput {
    auditItemTypeEditDto: AuditItemTypeEditDto;
}

export class PagedResultDtoOfAuditItemTypeListDto implements IPagedResultDtoOfAuditItemTypeListDto {
    totalCount: number;
    items: AuditItemTypeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditItemTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditItemTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditItemTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditItemTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditItemTypeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditItemTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditItemTypeListDto {
    totalCount: number;
    items: AuditItemTypeListDto[] | undefined;
}

export enum EntityChangeType {
    Created = <any>"Created",
    Updated = <any>"Updated",
    Deleted = <any>"Deleted",
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    readonly changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }

    clone(): EntityChangeListDto {
        const json = this.toJSON();
        let result = new EntityChangeListDto();
        result.init(json);
        return result;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEntityChangeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): NameValueDto {
        const json = this.toJSON();
        let result = new NameValueDto();
        result.init(json);
        return result;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    /** 用户Id */
    userId: number | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 模拟租户Id */
    impersonatorTenantId: number | undefined;
    /** 模拟用户Id */
    impersonatorUserId: number | undefined;
    /** 服务名称 */
    serviceName: string | undefined;
    /** 方法名称 */
    methodName: string | undefined;
    /** 参数 */
    parameters: string | undefined;
    /** 执行时间 */
    executionTime: moment.Moment;
    /** 持续时间 */
    executionDuration: number;
    /** 客户端ip地址 */
    clientIpAddress: string | undefined;
    /** 客户端 */
    clientName: string | undefined;
    /** 浏览器信息 */
    browserInfo: string | undefined;
    /** 异常 */
    exception: string | undefined;
    customData: string | undefined;
    id: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditLogListDto {
        const json = this.toJSON();
        let result = new AuditLogListDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogListDto {
    /** 用户Id */
    userId: number | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 模拟租户Id */
    impersonatorTenantId: number | undefined;
    /** 模拟用户Id */
    impersonatorUserId: number | undefined;
    /** 服务名称 */
    serviceName: string | undefined;
    /** 方法名称 */
    methodName: string | undefined;
    /** 参数 */
    parameters: string | undefined;
    /** 执行时间 */
    executionTime: moment.Moment;
    /** 持续时间 */
    executionDuration: number;
    /** 客户端ip地址 */
    clientIpAddress: string | undefined;
    /** 客户端 */
    clientName: string | undefined;
    /** 浏览器信息 */
    browserInfo: string | undefined;
    /** 异常 */
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditLogListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class AuditPointEditDto implements IAuditPointEditDto {
    id: number | undefined;
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 责任人 */
    respId: number;
    /** 是否启用 */
    enable: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 排序 */
    sn: number;
    /** 图片 */
    picture: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 小程序码 */
    wxmpQrCodePic: string | undefined;
    /** 场景Id */
    scenesId: number | undefined;
    /** 场景名称 */
    scenesName: string | undefined;

    constructor(data?: IAuditPointEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.qrCode = _data["qrCode"];
            this.mustQRCode = _data["mustQRCode"];
            this.mustNFC = _data["mustNFC"];
            this.nfcNo = _data["nfcNo"];
            this.nfcid = _data["nfcid"];
            this.respId = _data["respId"];
            this.enable = _data["enable"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            this.sn = _data["sn"];
            this.picture = _data["picture"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.description = _data["description"];
            this.wxmpQrCodePic = _data["wxmpQrCodePic"];
            this.scenesId = _data["scenesId"];
            this.scenesName = _data["scenesName"];
        }
    }

    static fromJS(data: any): AuditPointEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditPointEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["qrCode"] = this.qrCode;
        data["mustQRCode"] = this.mustQRCode;
        data["mustNFC"] = this.mustNFC;
        data["nfcNo"] = this.nfcNo;
        data["nfcid"] = this.nfcid;
        data["respId"] = this.respId;
        data["enable"] = this.enable;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        data["sn"] = this.sn;
        data["picture"] = this.picture;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["description"] = this.description;
        data["wxmpQrCodePic"] = this.wxmpQrCodePic;
        data["scenesId"] = this.scenesId;
        data["scenesName"] = this.scenesName;
        return data;
    }

    clone(): AuditPointEditDto {
        const json = this.toJSON();
        let result = new AuditPointEditDto();
        result.init(json);
        return result;
    }
}

export interface IAuditPointEditDto {
    id: number | undefined;
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 责任人 */
    respId: number;
    /** 是否启用 */
    enable: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 排序 */
    sn: number;
    /** 图片 */
    picture: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 小程序码 */
    wxmpQrCodePic: string | undefined;
    /** 场景Id */
    scenesId: number | undefined;
    /** 场景名称 */
    scenesName: string | undefined;
}

export class CreateOrUpdateAuditPointInput implements ICreateOrUpdateAuditPointInput {
    auditPointEdit: AuditPointEditDto;

    constructor(data?: ICreateOrUpdateAuditPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditPointEdit = new AuditPointEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditPointEdit = _data["auditPointEdit"] ? AuditPointEditDto.fromJS(_data["auditPointEdit"]) : new AuditPointEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAuditPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAuditPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditPointEdit"] = this.auditPointEdit ? this.auditPointEdit.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAuditPointInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAuditPointInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAuditPointInput {
    auditPointEdit: AuditPointEditDto;
}

/** WXAccessToken */
export class WXAccessToken implements IWXAccessToken {
    /** 获取到的凭证 */
    access_token: string | undefined;
    /** 凭证有效时间，单位：秒 */
    expires_in: number;

    constructor(data?: IWXAccessToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.expires_in = _data["expires_in"];
        }
    }

    static fromJS(data: any): WXAccessToken {
        data = typeof data === 'object' ? data : {};
        let result = new WXAccessToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["expires_in"] = this.expires_in;
        return data;
    }

    clone(): WXAccessToken {
        const json = this.toJSON();
        let result = new WXAccessToken();
        result.init(json);
        return result;
    }
}

/** WXAccessToken */
export interface IWXAccessToken {
    /** 获取到的凭证 */
    access_token: string | undefined;
    /** 凭证有效时间，单位：秒 */
    expires_in: number;
}

export class PagedResultDtoOfAuditpointListDto implements IPagedResultDtoOfAuditpointListDto {
    totalCount: number;
    items: AuditpointListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditpointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditpointListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditpointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditpointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditpointListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditpointListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditpointListDto {
    totalCount: number;
    items: AuditpointListDto[] | undefined;
}

export class AuditTeamMonthViewInput implements IAuditTeamMonthViewInput {
    /** 日期 */
    monthAndYear: moment.Moment;
    /** 状态 */
    auditTaskStatus: string[] | undefined;
    /** 是否显示模版 */
    isShowAuditTemplate: boolean;
    /** 搜索内容 */
    filterText: string | undefined;

    constructor(data?: IAuditTeamMonthViewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthAndYear = _data["monthAndYear"] ? moment(_data["monthAndYear"].toString()) : <any>undefined;
            if (Array.isArray(_data["auditTaskStatus"])) {
                this.auditTaskStatus = [] as any;
                for (let item of _data["auditTaskStatus"])
                    this.auditTaskStatus.push(item);
            }
            this.isShowAuditTemplate = _data["isShowAuditTemplate"];
            this.filterText = _data["filterText"];
        }
    }

    static fromJS(data: any): AuditTeamMonthViewInput {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamMonthViewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthAndYear"] = this.monthAndYear ? this.monthAndYear.toISOString() : <any>undefined;
        if (Array.isArray(this.auditTaskStatus)) {
            data["auditTaskStatus"] = [];
            for (let item of this.auditTaskStatus)
                data["auditTaskStatus"].push(item);
        }
        data["isShowAuditTemplate"] = this.isShowAuditTemplate;
        data["filterText"] = this.filterText;
        return data;
    }

    clone(): AuditTeamMonthViewInput {
        const json = this.toJSON();
        let result = new AuditTeamMonthViewInput();
        result.init(json);
        return result;
    }
}

export interface IAuditTeamMonthViewInput {
    /** 日期 */
    monthAndYear: moment.Moment;
    /** 状态 */
    auditTaskStatus: string[] | undefined;
    /** 是否显示模版 */
    isShowAuditTemplate: boolean;
    /** 搜索内容 */
    filterText: string | undefined;
}

/** 每一天可能有多个 */
export class AuditTasksDto implements IAuditTasksDto {
    /** 任务 */
    id: number;
    /** 状态 */
    status: string | undefined;
    /** 问题个数 */
    issueCount: number;
    /** 计划开始日期(yyyy-MM-dd)，用于前端跨日期合并展示 */
    planStartDate: string | undefined;
    /** 计划结束日期(yyyy-MM-dd)，用于前端跨日期合并展示 */
    planEndDate: string | undefined;

    constructor(data?: IAuditTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.issueCount = _data["issueCount"];
            this.planStartDate = _data["planStartDate"];
            this.planEndDate = _data["planEndDate"];
        }
    }

    static fromJS(data: any): AuditTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["issueCount"] = this.issueCount;
        data["planStartDate"] = this.planStartDate;
        data["planEndDate"] = this.planEndDate;
        return data;
    }

    clone(): AuditTasksDto {
        const json = this.toJSON();
        let result = new AuditTasksDto();
        result.init(json);
        return result;
    }
}

/** 每一天可能有多个 */
export interface IAuditTasksDto {
    /** 任务 */
    id: number;
    /** 状态 */
    status: string | undefined;
    /** 问题个数 */
    issueCount: number;
    /** 计划开始日期(yyyy-MM-dd)，用于前端跨日期合并展示 */
    planStartDate: string | undefined;
    /** 计划结束日期(yyyy-MM-dd)，用于前端跨日期合并展示 */
    planEndDate: string | undefined;
}

/** 每一天 */
export class AuditTaskDto implements IAuditTaskDto {
    /** 任务 */
    id: number;
    /** 状态 */
    status: string | undefined;
    /** 问题个数 */
    issueCount: number;
    /** 一天可能有多个任务 */
    tasks: AuditTasksDto[] | undefined;

    constructor(data?: IAuditTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.issueCount = _data["issueCount"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks.push(AuditTasksDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["issueCount"] = this.issueCount;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditTaskDto {
        const json = this.toJSON();
        let result = new AuditTaskDto();
        result.init(json);
        return result;
    }
}

/** 每一天 */
export interface IAuditTaskDto {
    /** 任务 */
    id: number;
    /** 状态 */
    status: string | undefined;
    /** 问题个数 */
    issueCount: number;
    /** 一天可能有多个任务 */
    tasks: AuditTasksDto[] | undefined;
}

/** 任务实体 */
export class Template implements ITemplate {
    /** 模板名称 */
    templateName: string | undefined;
    /** 模板下每一天信息 */
    auditTaskList: AuditTaskDto[] | undefined;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["templateName"];
            if (Array.isArray(_data["auditTaskList"])) {
                this.auditTaskList = [] as any;
                for (let item of _data["auditTaskList"])
                    this.auditTaskList.push(AuditTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        if (Array.isArray(this.auditTaskList)) {
            data["auditTaskList"] = [];
            for (let item of this.auditTaskList)
                data["auditTaskList"].push(item.toJSON());
        }
        return data;
    }

    clone(): Template {
        const json = this.toJSON();
        let result = new Template();
        result.init(json);
        return result;
    }
}

/** 任务实体 */
export interface ITemplate {
    /** 模板名称 */
    templateName: string | undefined;
    /** 模板下每一天信息 */
    auditTaskList: AuditTaskDto[] | undefined;
}

/** 审核团队月视图Dto */
export class AuditTeamMonthViewDto implements IAuditTeamMonthViewDto {
    /** 审核团队 */
    teamName: string | undefined;
    /** 每个人的审核模板 */
    templates: Template[] | undefined;
    /** 模板下每一天信息 */
    auditTaskList: AuditTaskDto[] | undefined;

    constructor(data?: IAuditTeamMonthViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamName = _data["teamName"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates.push(Template.fromJS(item));
            }
            if (Array.isArray(_data["auditTaskList"])) {
                this.auditTaskList = [] as any;
                for (let item of _data["auditTaskList"])
                    this.auditTaskList.push(AuditTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditTeamMonthViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamMonthViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamName"] = this.teamName;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        if (Array.isArray(this.auditTaskList)) {
            data["auditTaskList"] = [];
            for (let item of this.auditTaskList)
                data["auditTaskList"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditTeamMonthViewDto {
        const json = this.toJSON();
        let result = new AuditTeamMonthViewDto();
        result.init(json);
        return result;
    }
}

/** 审核团队月视图Dto */
export interface IAuditTeamMonthViewDto {
    /** 审核团队 */
    teamName: string | undefined;
    /** 每个人的审核模板 */
    templates: Template[] | undefined;
    /** 模板下每一天信息 */
    auditTaskList: AuditTaskDto[] | undefined;
}

/** 创建审核任务参数Dto */
export class CreateAuditTaskDto implements ICreateAuditTaskDto {
    /** 选择的用户 */
    userIds: number[] | undefined;
    /** 负责人类型（1.个人 2.团队） */
    responsibleType: number;
    /** 选择的审核团队ID */
    auditTeamId: number | undefined;
    /** 选择的开始日期 */
    startDateTime: moment.Moment;
    /** 选择的开始日期 */
    endDateTime: moment.Moment;
    /** 选择的审核模板 */
    auditTemplate: number[] | undefined;
    /** 选择的审核项 */
    auditItem: number[] | undefined;
    /** 选择的审核点 */
    auditPoint: number[] | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核周期 */
    auditCycle: number;
    /** 审核周期单位 */
    auditCycleUnit: string | undefined;
    /** 小时开始范围 */
    timeRangeStart: moment.Moment | undefined;
    /** 小时结束范围 */
    timeRangeEnd: moment.Moment | undefined;
    /** 星期范围 */
    weekRange: string | undefined;
    /** 是否重复 */
    isNoExist: boolean;
    /** 创建模式（1.审核点模板  2.审核项模板  3.自由点检） */
    createMode: string | undefined;
    /** 审核点，逗号隔开 */
    auditPointIdList: number[] | undefined;
    /** 名称 */
    name: string | undefined;
    /** 轮询还是重复 1.轮询  2.重复 */
    pollOrRepeat: number;
    /** 审核任务标签 */
    auditTaskLabel: string[] | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;

    constructor(data?: ICreateAuditTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            this.responsibleType = _data["responsibleType"];
            this.auditTeamId = _data["auditTeamId"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["auditTemplate"])) {
                this.auditTemplate = [] as any;
                for (let item of _data["auditTemplate"])
                    this.auditTemplate.push(item);
            }
            if (Array.isArray(_data["auditItem"])) {
                this.auditItem = [] as any;
                for (let item of _data["auditItem"])
                    this.auditItem.push(item);
            }
            if (Array.isArray(_data["auditPoint"])) {
                this.auditPoint = [] as any;
                for (let item of _data["auditPoint"])
                    this.auditPoint.push(item);
            }
            this.remark = _data["remark"];
            this.auditCycle = _data["auditCycle"];
            this.auditCycleUnit = _data["auditCycleUnit"];
            this.timeRangeStart = _data["timeRangeStart"] ? moment(_data["timeRangeStart"].toString()) : <any>undefined;
            this.timeRangeEnd = _data["timeRangeEnd"] ? moment(_data["timeRangeEnd"].toString()) : <any>undefined;
            this.weekRange = _data["weekRange"];
            this.isNoExist = _data["isNoExist"];
            this.createMode = _data["createMode"];
            if (Array.isArray(_data["auditPointIdList"])) {
                this.auditPointIdList = [] as any;
                for (let item of _data["auditPointIdList"])
                    this.auditPointIdList.push(item);
            }
            this.name = _data["name"];
            this.pollOrRepeat = _data["pollOrRepeat"];
            if (Array.isArray(_data["auditTaskLabel"])) {
                this.auditTaskLabel = [] as any;
                for (let item of _data["auditTaskLabel"])
                    this.auditTaskLabel.push(item);
            }
            this.earlyStart = _data["earlyStart"];
            this.delayedFinish = _data["delayedFinish"];
        }
    }

    static fromJS(data: any): CreateAuditTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuditTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["responsibleType"] = this.responsibleType;
        data["auditTeamId"] = this.auditTeamId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.auditTemplate)) {
            data["auditTemplate"] = [];
            for (let item of this.auditTemplate)
                data["auditTemplate"].push(item);
        }
        if (Array.isArray(this.auditItem)) {
            data["auditItem"] = [];
            for (let item of this.auditItem)
                data["auditItem"].push(item);
        }
        if (Array.isArray(this.auditPoint)) {
            data["auditPoint"] = [];
            for (let item of this.auditPoint)
                data["auditPoint"].push(item);
        }
        data["remark"] = this.remark;
        data["auditCycle"] = this.auditCycle;
        data["auditCycleUnit"] = this.auditCycleUnit;
        data["timeRangeStart"] = this.timeRangeStart ? this.timeRangeStart.toISOString() : <any>undefined;
        data["timeRangeEnd"] = this.timeRangeEnd ? this.timeRangeEnd.toISOString() : <any>undefined;
        data["weekRange"] = this.weekRange;
        data["isNoExist"] = this.isNoExist;
        data["createMode"] = this.createMode;
        if (Array.isArray(this.auditPointIdList)) {
            data["auditPointIdList"] = [];
            for (let item of this.auditPointIdList)
                data["auditPointIdList"].push(item);
        }
        data["name"] = this.name;
        data["pollOrRepeat"] = this.pollOrRepeat;
        if (Array.isArray(this.auditTaskLabel)) {
            data["auditTaskLabel"] = [];
            for (let item of this.auditTaskLabel)
                data["auditTaskLabel"].push(item);
        }
        data["earlyStart"] = this.earlyStart;
        data["delayedFinish"] = this.delayedFinish;
        return data;
    }

    clone(): CreateAuditTaskDto {
        const json = this.toJSON();
        let result = new CreateAuditTaskDto();
        result.init(json);
        return result;
    }
}

/** 创建审核任务参数Dto */
export interface ICreateAuditTaskDto {
    /** 选择的用户 */
    userIds: number[] | undefined;
    /** 负责人类型（1.个人 2.团队） */
    responsibleType: number;
    /** 选择的审核团队ID */
    auditTeamId: number | undefined;
    /** 选择的开始日期 */
    startDateTime: moment.Moment;
    /** 选择的开始日期 */
    endDateTime: moment.Moment;
    /** 选择的审核模板 */
    auditTemplate: number[] | undefined;
    /** 选择的审核项 */
    auditItem: number[] | undefined;
    /** 选择的审核点 */
    auditPoint: number[] | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核周期 */
    auditCycle: number;
    /** 审核周期单位 */
    auditCycleUnit: string | undefined;
    /** 小时开始范围 */
    timeRangeStart: moment.Moment | undefined;
    /** 小时结束范围 */
    timeRangeEnd: moment.Moment | undefined;
    /** 星期范围 */
    weekRange: string | undefined;
    /** 是否重复 */
    isNoExist: boolean;
    /** 创建模式（1.审核点模板  2.审核项模板  3.自由点检） */
    createMode: string | undefined;
    /** 审核点，逗号隔开 */
    auditPointIdList: number[] | undefined;
    /** 名称 */
    name: string | undefined;
    /** 轮询还是重复 1.轮询  2.重复 */
    pollOrRepeat: number;
    /** 审核任务标签 */
    auditTaskLabel: string[] | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
}

export class PagedResultDtoOfAuditTemplateListDto implements IPagedResultDtoOfAuditTemplateListDto {
    totalCount: number;
    items: AuditTemplateListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditTemplateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditTemplateListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditTemplateListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditTemplateListDto {
    totalCount: number;
    items: AuditTemplateListDto[] | undefined;
}

export class IssueDescriptionArrDto implements IIssueDescriptionArrDto {
    /** 问题描述，多条给他拼接起来 */
    issueDescription: string | undefined;
    /** 图片 */
    discoveryPicture: string[] | undefined;

    constructor(data?: IIssueDescriptionArrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueDescription = _data["issueDescription"];
            if (Array.isArray(_data["discoveryPicture"])) {
                this.discoveryPicture = [] as any;
                for (let item of _data["discoveryPicture"])
                    this.discoveryPicture.push(item);
            }
        }
    }

    static fromJS(data: any): IssueDescriptionArrDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDescriptionArrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDescription"] = this.issueDescription;
        if (Array.isArray(this.discoveryPicture)) {
            data["discoveryPicture"] = [];
            for (let item of this.discoveryPicture)
                data["discoveryPicture"].push(item);
        }
        return data;
    }

    clone(): IssueDescriptionArrDto {
        const json = this.toJSON();
        let result = new IssueDescriptionArrDto();
        result.init(json);
        return result;
    }
}

export interface IIssueDescriptionArrDto {
    /** 问题描述，多条给他拼接起来 */
    issueDescription: string | undefined;
    /** 图片 */
    discoveryPicture: string[] | undefined;
}

export class AuditTask implements IAuditTask {
    name: string | undefined;
    auditTaskType: string | undefined;
    auditTemplateId: number | undefined;
    inspectorId: number | undefined;
    auditTeamId: number | undefined;
    responsibleType: number;
    planStart: moment.Moment;
    planEnd: moment.Moment;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    auditTaskState: string | undefined;
    remark: string | undefined;
    leaveReason: string | undefined;
    leaveRemark: string | undefined;
    auditTaskCreateId: number;
    templateType: number;
    auditTaskLabel: string | undefined;
    earlyStart: number;
    delayedFinish: number;
    templateBarCode: string | undefined;
    assitField: string | undefined;
    isNoticeSuperior: boolean;
    filedExt1: string | undefined;
    filedExt2: string | undefined;
    filedExt3: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    scenesId: number | undefined;
    id: number;

    constructor(data?: IAuditTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.auditTaskType = _data["auditTaskType"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.inspectorId = _data["inspectorId"];
            this.auditTeamId = _data["auditTeamId"];
            this.responsibleType = _data["responsibleType"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"];
            this.remark = _data["remark"];
            this.leaveReason = _data["leaveReason"];
            this.leaveRemark = _data["leaveRemark"];
            this.auditTaskCreateId = _data["auditTaskCreateId"];
            this.templateType = _data["templateType"];
            this.auditTaskLabel = _data["auditTaskLabel"];
            this.earlyStart = _data["earlyStart"];
            this.delayedFinish = _data["delayedFinish"];
            this.templateBarCode = _data["templateBarCode"];
            this.assitField = _data["assitField"];
            this.isNoticeSuperior = _data["isNoticeSuperior"];
            this.filedExt1 = _data["filedExt1"];
            this.filedExt2 = _data["filedExt2"];
            this.filedExt3 = _data["filedExt3"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.scenesId = _data["scenesId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditTask {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["auditTaskType"] = this.auditTaskType;
        data["auditTemplateId"] = this.auditTemplateId;
        data["inspectorId"] = this.inspectorId;
        data["auditTeamId"] = this.auditTeamId;
        data["responsibleType"] = this.responsibleType;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState;
        data["remark"] = this.remark;
        data["leaveReason"] = this.leaveReason;
        data["leaveRemark"] = this.leaveRemark;
        data["auditTaskCreateId"] = this.auditTaskCreateId;
        data["templateType"] = this.templateType;
        data["auditTaskLabel"] = this.auditTaskLabel;
        data["earlyStart"] = this.earlyStart;
        data["delayedFinish"] = this.delayedFinish;
        data["templateBarCode"] = this.templateBarCode;
        data["assitField"] = this.assitField;
        data["isNoticeSuperior"] = this.isNoticeSuperior;
        data["filedExt1"] = this.filedExt1;
        data["filedExt2"] = this.filedExt2;
        data["filedExt3"] = this.filedExt3;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["scenesId"] = this.scenesId;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditTask {
        const json = this.toJSON();
        let result = new AuditTask();
        result.init(json);
        return result;
    }
}

export interface IAuditTask {
    name: string | undefined;
    auditTaskType: string | undefined;
    auditTemplateId: number | undefined;
    inspectorId: number | undefined;
    auditTeamId: number | undefined;
    responsibleType: number;
    planStart: moment.Moment;
    planEnd: moment.Moment;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    auditTaskState: string | undefined;
    remark: string | undefined;
    leaveReason: string | undefined;
    leaveRemark: string | undefined;
    auditTaskCreateId: number;
    templateType: number;
    auditTaskLabel: string | undefined;
    earlyStart: number;
    delayedFinish: number;
    templateBarCode: string | undefined;
    assitField: string | undefined;
    isNoticeSuperior: boolean;
    filedExt1: string | undefined;
    filedExt2: string | undefined;
    filedExt3: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    scenesId: number | undefined;
    id: number;
}

export class Task_Report_TypeDto implements ITask_Report_TypeDto {
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 发现的问题个数 */
    issueCount: number;
    /** 问题描述 */
    issueDescriptionArr: IssueDescriptionArrDto[] | undefined;
    /** 任务 */
    auditTaskList: AuditTask[] | undefined;

    constructor(data?: ITask_Report_TypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemTypeName = _data["auditItemTypeName"];
            this.auditItemName = _data["auditItemName"];
            this.issueCount = _data["issueCount"];
            if (Array.isArray(_data["issueDescriptionArr"])) {
                this.issueDescriptionArr = [] as any;
                for (let item of _data["issueDescriptionArr"])
                    this.issueDescriptionArr.push(IssueDescriptionArrDto.fromJS(item));
            }
            if (Array.isArray(_data["auditTaskList"])) {
                this.auditTaskList = [] as any;
                for (let item of _data["auditTaskList"])
                    this.auditTaskList.push(AuditTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Task_Report_TypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new Task_Report_TypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemTypeName"] = this.auditItemTypeName;
        data["auditItemName"] = this.auditItemName;
        data["issueCount"] = this.issueCount;
        if (Array.isArray(this.issueDescriptionArr)) {
            data["issueDescriptionArr"] = [];
            for (let item of this.issueDescriptionArr)
                data["issueDescriptionArr"].push(item.toJSON());
        }
        if (Array.isArray(this.auditTaskList)) {
            data["auditTaskList"] = [];
            for (let item of this.auditTaskList)
                data["auditTaskList"].push(item.toJSON());
        }
        return data;
    }

    clone(): Task_Report_TypeDto {
        const json = this.toJSON();
        let result = new Task_Report_TypeDto();
        result.init(json);
        return result;
    }
}

export interface ITask_Report_TypeDto {
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 发现的问题个数 */
    issueCount: number;
    /** 问题描述 */
    issueDescriptionArr: IssueDescriptionArrDto[] | undefined;
    /** 任务 */
    auditTaskList: AuditTask[] | undefined;
}

export class Task_ReportDto implements ITask_ReportDto {
    /** 审核项分组一级 */
    auditItemGroupFirstName: string | undefined;
    /** 审核项分组二级 */
    auditItemGroupSecondName: string | undefined;
    /** 审核项类型和审核项 */
    task_Report_Type: Task_Report_TypeDto[] | undefined;

    constructor(data?: ITask_ReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemGroupFirstName = _data["auditItemGroupFirstName"];
            this.auditItemGroupSecondName = _data["auditItemGroupSecondName"];
            if (Array.isArray(_data["task_Report_Type"])) {
                this.task_Report_Type = [] as any;
                for (let item of _data["task_Report_Type"])
                    this.task_Report_Type.push(Task_Report_TypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Task_ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new Task_ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemGroupFirstName"] = this.auditItemGroupFirstName;
        data["auditItemGroupSecondName"] = this.auditItemGroupSecondName;
        if (Array.isArray(this.task_Report_Type)) {
            data["task_Report_Type"] = [];
            for (let item of this.task_Report_Type)
                data["task_Report_Type"].push(item.toJSON());
        }
        return data;
    }

    clone(): Task_ReportDto {
        const json = this.toJSON();
        let result = new Task_ReportDto();
        result.init(json);
        return result;
    }
}

export interface ITask_ReportDto {
    /** 审核项分组一级 */
    auditItemGroupFirstName: string | undefined;
    /** 审核项分组二级 */
    auditItemGroupSecondName: string | undefined;
    /** 审核项类型和审核项 */
    task_Report_Type: Task_Report_TypeDto[] | undefined;
}

export class AuditResultSummary_ReportDto implements IAuditResultSummary_ReportDto {
    /** 每个月 */
    date: string | undefined;
    /** 报表源数据 */
    task_ReportList: Task_ReportDto[] | undefined;

    constructor(data?: IAuditResultSummary_ReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            if (Array.isArray(_data["task_ReportList"])) {
                this.task_ReportList = [] as any;
                for (let item of _data["task_ReportList"])
                    this.task_ReportList.push(Task_ReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditResultSummary_ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditResultSummary_ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        if (Array.isArray(this.task_ReportList)) {
            data["task_ReportList"] = [];
            for (let item of this.task_ReportList)
                data["task_ReportList"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditResultSummary_ReportDto {
        const json = this.toJSON();
        let result = new AuditResultSummary_ReportDto();
        result.init(json);
        return result;
    }
}

export interface IAuditResultSummary_ReportDto {
    /** 每个月 */
    date: string | undefined;
    /** 报表源数据 */
    task_ReportList: Task_ReportDto[] | undefined;
}

/** 审核记录ListDto */
export class GetAuditTaskDetailListDto implements IGetAuditTaskDetailListDto {
    /** 审核记录Id */
    id: number;
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核任务Id */
    auditTaskCreateId: number;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核模板名 */
    auditTemplateName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 实际开始日期 */
    startTime: moment.Moment;
    /** 实际结束日期 */
    endTime: moment.Moment;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 审核项描述 */
    auditItemDesc: string | undefined;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionTypeName: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办接收人 */
    transferRecipientName: string | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
    /** 实际审核人 */
    actualInspectorName: string | undefined;
    /** 是否跳过 */
    isSkipAuditPoint: boolean;
    /** 视频 */
    video: string | undefined;

    constructor(data?: IGetAuditTaskDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditTaskCreateId = _data["auditTaskCreateId"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.auditTemplateName = _data["auditTemplateName"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"];
            this.auditTaskStateName = _data["auditTaskStateName"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.auditItemDesc = _data["auditItemDesc"];
            this.auditItemTypeId = _data["auditItemTypeId"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.auditItemSN = _data["auditItemSN"];
            this.result = _data["result"];
            this.deviationType = _data["deviationType"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.note = _data["note"];
            this.data = _data["data"];
            this.picture = _data["picture"];
            this.remark = _data["remark"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.valueActual = _data["valueActual"];
            this.optionType = _data["optionType"];
            this.optionTypeName = _data["optionTypeName"];
            this.valueStandard = _data["valueStandard"];
            this.valueUpperLimit = _data["valueUpperLimit"];
            this.valueLowerLimit = _data["valueLowerLimit"];
            this.score = _data["score"];
            this.transferRecipient = _data["transferRecipient"];
            this.transferRecipientName = _data["transferRecipientName"];
            this.transferTime = _data["transferTime"] ? moment(_data["transferTime"].toString()) : <any>undefined;
            this.actualInspectorName = _data["actualInspectorName"];
            this.isSkipAuditPoint = _data["isSkipAuditPoint"];
            this.video = _data["video"];
        }
    }

    static fromJS(data: any): GetAuditTaskDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditTaskDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTaskId"] = this.auditTaskId;
        data["auditTaskCreateId"] = this.auditTaskCreateId;
        data["auditTemplateId"] = this.auditTemplateId;
        data["auditTemplateName"] = this.auditTemplateName;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState;
        data["auditTaskStateName"] = this.auditTaskStateName;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["auditItemDesc"] = this.auditItemDesc;
        data["auditItemTypeId"] = this.auditItemTypeId;
        data["auditItemTypeName"] = this.auditItemTypeName;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["auditItemSN"] = this.auditItemSN;
        data["result"] = this.result;
        data["deviationType"] = this.deviationType;
        data["deviationTypeName"] = this.deviationTypeName;
        data["note"] = this.note;
        data["data"] = this.data;
        data["picture"] = this.picture;
        data["remark"] = this.remark;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["valueActual"] = this.valueActual;
        data["optionType"] = this.optionType;
        data["optionTypeName"] = this.optionTypeName;
        data["valueStandard"] = this.valueStandard;
        data["valueUpperLimit"] = this.valueUpperLimit;
        data["valueLowerLimit"] = this.valueLowerLimit;
        data["score"] = this.score;
        data["transferRecipient"] = this.transferRecipient;
        data["transferRecipientName"] = this.transferRecipientName;
        data["transferTime"] = this.transferTime ? this.transferTime.toISOString() : <any>undefined;
        data["actualInspectorName"] = this.actualInspectorName;
        data["isSkipAuditPoint"] = this.isSkipAuditPoint;
        data["video"] = this.video;
        return data;
    }

    clone(): GetAuditTaskDetailListDto {
        const json = this.toJSON();
        let result = new GetAuditTaskDetailListDto();
        result.init(json);
        return result;
    }
}

/** 审核记录ListDto */
export interface IGetAuditTaskDetailListDto {
    /** 审核记录Id */
    id: number;
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核任务Id */
    auditTaskCreateId: number;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核模板名 */
    auditTemplateName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 实际开始日期 */
    startTime: moment.Moment;
    /** 实际结束日期 */
    endTime: moment.Moment;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 审核项描述 */
    auditItemDesc: string | undefined;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionTypeName: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办接收人 */
    transferRecipientName: string | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
    /** 实际审核人 */
    actualInspectorName: string | undefined;
    /** 是否跳过 */
    isSkipAuditPoint: boolean;
    /** 视频 */
    video: string | undefined;
}

export class PagedResultDtoOfGetAuditTaskDetailListDto implements IPagedResultDtoOfGetAuditTaskDetailListDto {
    totalCount: number;
    items: GetAuditTaskDetailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAuditTaskDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetAuditTaskDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAuditTaskDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAuditTaskDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetAuditTaskDetailListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAuditTaskDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAuditTaskDetailListDto {
    totalCount: number;
    items: GetAuditTaskDetailListDto[] | undefined;
}

/** 审核任务下所有审核记录 */
export class GetDetailByAuditTaskIdListDto implements IGetDetailByAuditTaskIdListDto {
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 审核项描述 */
    auditItemDesc: string | undefined;
    /** 审核项类型Id */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionTypeName: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办接收人 */
    transferRecipientName: string | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
    /** 是否跳过 */
    isSkipAuditPoint: boolean;
    /** 视频 */
    video: string | undefined;

    constructor(data?: IGetDetailByAuditTaskIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.auditItemDesc = _data["auditItemDesc"];
            this.auditItemTypeId = _data["auditItemTypeId"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.auditItemSN = _data["auditItemSN"];
            this.result = _data["result"];
            this.deviationType = _data["deviationType"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.note = _data["note"];
            this.data = _data["data"];
            this.picture = _data["picture"];
            this.remark = _data["remark"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.valueActual = _data["valueActual"];
            this.optionType = _data["optionType"];
            this.optionTypeName = _data["optionTypeName"];
            this.valueStandard = _data["valueStandard"];
            this.valueUpperLimit = _data["valueUpperLimit"];
            this.valueLowerLimit = _data["valueLowerLimit"];
            this.score = _data["score"];
            this.transferRecipient = _data["transferRecipient"];
            this.transferRecipientName = _data["transferRecipientName"];
            this.transferTime = _data["transferTime"] ? moment(_data["transferTime"].toString()) : <any>undefined;
            this.isSkipAuditPoint = _data["isSkipAuditPoint"];
            this.video = _data["video"];
        }
    }

    static fromJS(data: any): GetDetailByAuditTaskIdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailByAuditTaskIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["auditItemDesc"] = this.auditItemDesc;
        data["auditItemTypeId"] = this.auditItemTypeId;
        data["auditItemTypeName"] = this.auditItemTypeName;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["auditItemSN"] = this.auditItemSN;
        data["result"] = this.result;
        data["deviationType"] = this.deviationType;
        data["deviationTypeName"] = this.deviationTypeName;
        data["note"] = this.note;
        data["data"] = this.data;
        data["picture"] = this.picture;
        data["remark"] = this.remark;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["valueActual"] = this.valueActual;
        data["optionType"] = this.optionType;
        data["optionTypeName"] = this.optionTypeName;
        data["valueStandard"] = this.valueStandard;
        data["valueUpperLimit"] = this.valueUpperLimit;
        data["valueLowerLimit"] = this.valueLowerLimit;
        data["score"] = this.score;
        data["transferRecipient"] = this.transferRecipient;
        data["transferRecipientName"] = this.transferRecipientName;
        data["transferTime"] = this.transferTime ? this.transferTime.toISOString() : <any>undefined;
        data["isSkipAuditPoint"] = this.isSkipAuditPoint;
        data["video"] = this.video;
        return data;
    }

    clone(): GetDetailByAuditTaskIdListDto {
        const json = this.toJSON();
        let result = new GetDetailByAuditTaskIdListDto();
        result.init(json);
        return result;
    }
}

/** 审核任务下所有审核记录 */
export interface IGetDetailByAuditTaskIdListDto {
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 审核项描述 */
    auditItemDesc: string | undefined;
    /** 审核项类型Id */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionTypeName: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办接收人 */
    transferRecipientName: string | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
    /** 是否跳过 */
    isSkipAuditPoint: boolean;
    /** 视频 */
    video: string | undefined;
}

export class PagedResultDtoOfGetDetailByAuditTaskIdListDto implements IPagedResultDtoOfGetDetailByAuditTaskIdListDto {
    totalCount: number;
    items: GetDetailByAuditTaskIdListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDetailByAuditTaskIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetDetailByAuditTaskIdListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDetailByAuditTaskIdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDetailByAuditTaskIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetDetailByAuditTaskIdListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetDetailByAuditTaskIdListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetDetailByAuditTaskIdListDto {
    totalCount: number;
    items: GetDetailByAuditTaskIdListDto[] | undefined;
}

/** 审核任务下问题 */
export class GetIssueByAuditTaskIdListDto implements IGetIssueByAuditTaskIdListDto {
    /** Id */
    id: number;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceTypeName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称 */
    issueTypeName: string | undefined;
    /** 问题类型名称(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人名称 */
    respName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项概述 */
    auditItemName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善措施 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;

    constructor(data?: IGetIssueByAuditTaskIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueTypeName = _data["issueTypeName"];
            this.issueTypeListName = _data["issueTypeListName"];
            this.issueProgress = _data["issueProgress"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discovererName = _data["discovererName"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.deviationType = _data["deviationType"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.remark = _data["remark"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
        }
    }

    static fromJS(data: any): GetIssueByAuditTaskIdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueByAuditTaskIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceType"] = this.sourceType;
        data["sourceTypeName"] = this.sourceTypeName;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueTypeName"] = this.issueTypeName;
        data["issueTypeListName"] = this.issueTypeListName;
        data["issueProgress"] = this.issueProgress;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discovererName"] = this.discovererName;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["deviationType"] = this.deviationType;
        data["deviationTypeName"] = this.deviationTypeName;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["remark"] = this.remark;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        return data;
    }

    clone(): GetIssueByAuditTaskIdListDto {
        const json = this.toJSON();
        let result = new GetIssueByAuditTaskIdListDto();
        result.init(json);
        return result;
    }
}

/** 审核任务下问题 */
export interface IGetIssueByAuditTaskIdListDto {
    /** Id */
    id: number;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceTypeName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称 */
    issueTypeName: string | undefined;
    /** 问题类型名称(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人名称 */
    respName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项概述 */
    auditItemName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善措施 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
}

export class PagedResultDtoOfGetIssueByAuditTaskIdListDto implements IPagedResultDtoOfGetIssueByAuditTaskIdListDto {
    totalCount: number;
    items: GetIssueByAuditTaskIdListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIssueByAuditTaskIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetIssueByAuditTaskIdListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIssueByAuditTaskIdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIssueByAuditTaskIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetIssueByAuditTaskIdListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetIssueByAuditTaskIdListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetIssueByAuditTaskIdListDto {
    totalCount: number;
    items: GetIssueByAuditTaskIdListDto[] | undefined;
}

export class AuditTaskEditDto implements IAuditTaskEditDto {
    /** Id */
    id: number | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 实际开始日期 */
    startTime: moment.Moment | undefined;
    /** 实际结束日期 */
    endTime: moment.Moment | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 请假原因 */
    leaveReason: string | undefined;
    /** 请假详细描述 */
    leaveRemark: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    /** 扩展字段1 */
    filedExt1: string | undefined;
    /** 扩展字段2 */
    filedExt2: string | undefined;
    /** 扩展字段3 */
    filedExt3: string | undefined;

    constructor(data?: IAuditTaskEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTaskType = _data["auditTaskType"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.inspectorId = _data["inspectorId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"];
            this.remark = _data["remark"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.leaveReason = _data["leaveReason"];
            this.leaveRemark = _data["leaveRemark"];
            this.auditTaskCreateId = _data["auditTaskCreateId"];
            this.auditTaskLabel = _data["auditTaskLabel"];
            this.auditTaskLabelName = _data["auditTaskLabelName"];
            this.earlyStart = _data["earlyStart"];
            this.delayedFinish = _data["delayedFinish"];
            this.templateBarCode = _data["templateBarCode"];
            this.assitField = _data["assitField"];
            this.filedExt1 = _data["filedExt1"];
            this.filedExt2 = _data["filedExt2"];
            this.filedExt3 = _data["filedExt3"];
        }
    }

    static fromJS(data: any): AuditTaskEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTaskType"] = this.auditTaskType;
        data["auditTemplateId"] = this.auditTemplateId;
        data["inspectorId"] = this.inspectorId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState;
        data["remark"] = this.remark;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["leaveReason"] = this.leaveReason;
        data["leaveRemark"] = this.leaveRemark;
        data["auditTaskCreateId"] = this.auditTaskCreateId;
        data["auditTaskLabel"] = this.auditTaskLabel;
        data["auditTaskLabelName"] = this.auditTaskLabelName;
        data["earlyStart"] = this.earlyStart;
        data["delayedFinish"] = this.delayedFinish;
        data["templateBarCode"] = this.templateBarCode;
        data["assitField"] = this.assitField;
        data["filedExt1"] = this.filedExt1;
        data["filedExt2"] = this.filedExt2;
        data["filedExt3"] = this.filedExt3;
        return data;
    }

    clone(): AuditTaskEditDto {
        const json = this.toJSON();
        let result = new AuditTaskEditDto();
        result.init(json);
        return result;
    }
}

export interface IAuditTaskEditDto {
    /** Id */
    id: number | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 实际开始日期 */
    startTime: moment.Moment | undefined;
    /** 实际结束日期 */
    endTime: moment.Moment | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 请假原因 */
    leaveReason: string | undefined;
    /** 请假详细描述 */
    leaveRemark: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    /** 扩展字段1 */
    filedExt1: string | undefined;
    /** 扩展字段2 */
    filedExt2: string | undefined;
    /** 扩展字段3 */
    filedExt3: string | undefined;
}

export class AuditTaskResult implements IAuditTaskResult {
    day: number;
    auditTask: AuditTaskEditDto[] | undefined;

    constructor(data?: IAuditTaskResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            if (Array.isArray(_data["auditTask"])) {
                this.auditTask = [] as any;
                for (let item of _data["auditTask"])
                    this.auditTask.push(AuditTaskEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditTaskResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        if (Array.isArray(this.auditTask)) {
            data["auditTask"] = [];
            for (let item of this.auditTask)
                data["auditTask"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditTaskResult {
        const json = this.toJSON();
        let result = new AuditTaskResult();
        result.init(json);
        return result;
    }
}

export interface IAuditTaskResult {
    day: number;
    auditTask: AuditTaskEditDto[] | undefined;
}

export class AuditTemplateDto implements IAuditTemplateDto {
    auditTemplateId: number | undefined;
    auditTemplate: string | undefined;
    auditTaskResult: AuditTaskResult[] | undefined;

    constructor(data?: IAuditTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditTemplateId = _data["auditTemplateId"];
            this.auditTemplate = _data["auditTemplate"];
            if (Array.isArray(_data["auditTaskResult"])) {
                this.auditTaskResult = [] as any;
                for (let item of _data["auditTaskResult"])
                    this.auditTaskResult.push(AuditTaskResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditTemplateId"] = this.auditTemplateId;
        data["auditTemplate"] = this.auditTemplate;
        if (Array.isArray(this.auditTaskResult)) {
            data["auditTaskResult"] = [];
            for (let item of this.auditTaskResult)
                data["auditTaskResult"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditTemplateDto {
        const json = this.toJSON();
        let result = new AuditTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IAuditTemplateDto {
    auditTemplateId: number | undefined;
    auditTemplate: string | undefined;
    auditTaskResult: AuditTaskResult[] | undefined;
}

export class MonthviewDto implements IMonthviewDto {
    userId: number | undefined;
    realName: string | undefined;
    auditTemplateDto: AuditTemplateDto[] | undefined;

    constructor(data?: IMonthviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.realName = _data["realName"];
            if (Array.isArray(_data["auditTemplateDto"])) {
                this.auditTemplateDto = [] as any;
                for (let item of _data["auditTemplateDto"])
                    this.auditTemplateDto.push(AuditTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["realName"] = this.realName;
        if (Array.isArray(this.auditTemplateDto)) {
            data["auditTemplateDto"] = [];
            for (let item of this.auditTemplateDto)
                data["auditTemplateDto"].push(item.toJSON());
        }
        return data;
    }

    clone(): MonthviewDto {
        const json = this.toJSON();
        let result = new MonthviewDto();
        result.init(json);
        return result;
    }
}

export interface IMonthviewDto {
    userId: number | undefined;
    realName: string | undefined;
    auditTemplateDto: AuditTemplateDto[] | undefined;
}

export class PagedResultDtoOfAuditTaskListDto implements IPagedResultDtoOfAuditTaskListDto {
    totalCount: number;
    items: AuditTaskListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditTaskListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditTaskListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditTaskListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditTaskListDto {
    totalCount: number;
    items: AuditTaskListDto[] | undefined;
}

/** 点位审核次数统计折线图Dto */
export class PointAuditStatisticsCountListDto implements IPointAuditStatisticsCountListDto {
    /** 审核点名称 */
    pointName: string | undefined;
    /** 日期 */
    date: string[] | undefined;
    /** 次数 */
    count: number[] | undefined;

    constructor(data?: IPointAuditStatisticsCountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pointName = _data["pointName"];
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date.push(item);
            }
            if (Array.isArray(_data["count"])) {
                this.count = [] as any;
                for (let item of _data["count"])
                    this.count.push(item);
            }
        }
    }

    static fromJS(data: any): PointAuditStatisticsCountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointAuditStatisticsCountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointName"] = this.pointName;
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item);
        }
        if (Array.isArray(this.count)) {
            data["count"] = [];
            for (let item of this.count)
                data["count"].push(item);
        }
        return data;
    }

    clone(): PointAuditStatisticsCountListDto {
        const json = this.toJSON();
        let result = new PointAuditStatisticsCountListDto();
        result.init(json);
        return result;
    }
}

/** 点位审核次数统计折线图Dto */
export interface IPointAuditStatisticsCountListDto {
    /** 审核点名称 */
    pointName: string | undefined;
    /** 日期 */
    date: string[] | undefined;
    /** 次数 */
    count: number[] | undefined;
}

export class LayoutOrgListDto implements ILayoutOrgListDto {
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 层级名称 */
    levelName: string | undefined;
    levelNameAndName: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 匿名可见 */
    anonymousVisible: boolean;
    /** 子集 */
    children: LayoutOrgListDto[] | undefined;
    id: number;

    constructor(data?: ILayoutOrgListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.pId = _data["pId"];
            this.leveIndex = _data["leveIndex"];
            this.remark = _data["remark"];
            this.levelName = _data["levelName"];
            this.levelNameAndName = _data["levelNameAndName"];
            this.statisticsOrg = _data["statisticsOrg"];
            this.anonymousVisible = _data["anonymousVisible"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(LayoutOrgListDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LayoutOrgListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutOrgListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["pId"] = this.pId;
        data["leveIndex"] = this.leveIndex;
        data["remark"] = this.remark;
        data["levelName"] = this.levelName;
        data["levelNameAndName"] = this.levelNameAndName;
        data["statisticsOrg"] = this.statisticsOrg;
        data["anonymousVisible"] = this.anonymousVisible;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): LayoutOrgListDto {
        const json = this.toJSON();
        let result = new LayoutOrgListDto();
        result.init(json);
        return result;
    }
}

export interface ILayoutOrgListDto {
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 层级名称 */
    levelName: string | undefined;
    levelNameAndName: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 匿名可见 */
    anonymousVisible: boolean;
    /** 子集 */
    children: LayoutOrgListDto[] | undefined;
    id: number;
}

export class IsEnabledAuditTaskTransferDto implements IIsEnabledAuditTaskTransferDto {
    enable: boolean;

    constructor(data?: IIsEnabledAuditTaskTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnabledAuditTaskTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnabledAuditTaskTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnabledAuditTaskTransferDto {
        const json = this.toJSON();
        let result = new IsEnabledAuditTaskTransferDto();
        result.init(json);
        return result;
    }
}

export interface IIsEnabledAuditTaskTransferDto {
    enable: boolean;
}

/** 月视图筛选参数 */
export class Month_ViewInput implements IMonth_ViewInput {
    /** 日期 */
    monthAndYear: moment.Moment;
    /** 部门 */
    orgId: number | undefined;
    /** 状态 */
    auditTaskStatus: string[] | undefined;
    /** 是否显示模版 */
    isShowAuditTemplate: boolean;
    /** 搜索内容 */
    filterText: string | undefined;

    constructor(data?: IMonth_ViewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthAndYear = _data["monthAndYear"] ? moment(_data["monthAndYear"].toString()) : <any>undefined;
            this.orgId = _data["orgId"];
            if (Array.isArray(_data["auditTaskStatus"])) {
                this.auditTaskStatus = [] as any;
                for (let item of _data["auditTaskStatus"])
                    this.auditTaskStatus.push(item);
            }
            this.isShowAuditTemplate = _data["isShowAuditTemplate"];
            this.filterText = _data["filterText"];
        }
    }

    static fromJS(data: any): Month_ViewInput {
        data = typeof data === 'object' ? data : {};
        let result = new Month_ViewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthAndYear"] = this.monthAndYear ? this.monthAndYear.toISOString() : <any>undefined;
        data["orgId"] = this.orgId;
        if (Array.isArray(this.auditTaskStatus)) {
            data["auditTaskStatus"] = [];
            for (let item of this.auditTaskStatus)
                data["auditTaskStatus"].push(item);
        }
        data["isShowAuditTemplate"] = this.isShowAuditTemplate;
        data["filterText"] = this.filterText;
        return data;
    }

    clone(): Month_ViewInput {
        const json = this.toJSON();
        let result = new Month_ViewInput();
        result.init(json);
        return result;
    }
}

/** 月视图筛选参数 */
export interface IMonth_ViewInput {
    /** 日期 */
    monthAndYear: moment.Moment;
    /** 部门 */
    orgId: number | undefined;
    /** 状态 */
    auditTaskStatus: string[] | undefined;
    /** 是否显示模版 */
    isShowAuditTemplate: boolean;
    /** 搜索内容 */
    filterText: string | undefined;
}

/** 月视图 */
export class Month_ViewDto implements IMonth_ViewDto {
    /** 审核人 */
    inspectorName: string | undefined;
    /** 每个人的审核模板 */
    templates: Template[] | undefined;
    /** 模板下每一天信息 */
    auditTaskList: AuditTaskDto[] | undefined;

    constructor(data?: IMonth_ViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectorName = _data["inspectorName"];
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates.push(Template.fromJS(item));
            }
            if (Array.isArray(_data["auditTaskList"])) {
                this.auditTaskList = [] as any;
                for (let item of _data["auditTaskList"])
                    this.auditTaskList.push(AuditTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Month_ViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new Month_ViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectorName"] = this.inspectorName;
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        if (Array.isArray(this.auditTaskList)) {
            data["auditTaskList"] = [];
            for (let item of this.auditTaskList)
                data["auditTaskList"].push(item.toJSON());
        }
        return data;
    }

    clone(): Month_ViewDto {
        const json = this.toJSON();
        let result = new Month_ViewDto();
        result.init(json);
        return result;
    }
}

/** 月视图 */
export interface IMonth_ViewDto {
    /** 审核人 */
    inspectorName: string | undefined;
    /** 每个人的审核模板 */
    templates: Template[] | undefined;
    /** 模板下每一天信息 */
    auditTaskList: AuditTaskDto[] | undefined;
}

/** 报表和头部信息 */
export class Task_ReportAndTitleDto implements ITask_ReportAndTitleDto {
    /** 部门 */
    businessunit: string | undefined;
    /** 部门负责人 */
    bUmanager: string | undefined;
    /** 审核员 */
    auditor: string | undefined;
    /** 区域 */
    auditarea: string | undefined;
    /** 区域负责人 */
    arearesponsible: string | undefined;
    /** 审核日期 */
    date: string | undefined;
    /** 报表源数据 */
    task_ReportList: Task_ReportDto[] | undefined;

    constructor(data?: ITask_ReportAndTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessunit = _data["businessunit"];
            this.bUmanager = _data["bUmanager"];
            this.auditor = _data["auditor"];
            this.auditarea = _data["auditarea"];
            this.arearesponsible = _data["arearesponsible"];
            this.date = _data["date"];
            if (Array.isArray(_data["task_ReportList"])) {
                this.task_ReportList = [] as any;
                for (let item of _data["task_ReportList"])
                    this.task_ReportList.push(Task_ReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Task_ReportAndTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new Task_ReportAndTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessunit"] = this.businessunit;
        data["bUmanager"] = this.bUmanager;
        data["auditor"] = this.auditor;
        data["auditarea"] = this.auditarea;
        data["arearesponsible"] = this.arearesponsible;
        data["date"] = this.date;
        if (Array.isArray(this.task_ReportList)) {
            data["task_ReportList"] = [];
            for (let item of this.task_ReportList)
                data["task_ReportList"].push(item.toJSON());
        }
        return data;
    }

    clone(): Task_ReportAndTitleDto {
        const json = this.toJSON();
        let result = new Task_ReportAndTitleDto();
        result.init(json);
        return result;
    }
}

/** 报表和头部信息 */
export interface ITask_ReportAndTitleDto {
    /** 部门 */
    businessunit: string | undefined;
    /** 部门负责人 */
    bUmanager: string | undefined;
    /** 审核员 */
    auditor: string | undefined;
    /** 区域 */
    auditarea: string | undefined;
    /** 区域负责人 */
    arearesponsible: string | undefined;
    /** 审核日期 */
    date: string | undefined;
    /** 报表源数据 */
    task_ReportList: Task_ReportDto[] | undefined;
}

export class AuditTaskExportDetailDto implements IAuditTaskExportDetailDto {
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 计划审核人 */
    inspectorName: string | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 数据 */
    inputData: string | undefined;
    /** 审核时间 */
    auditTime: string | undefined;
    /** 录入数值 */
    valueActual: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 实际审核人 */
    actualInspectorName: string | undefined;

    constructor(data?: IAuditTaskExportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fomartDateTime = _data["fomartDateTime"];
            this.auditTaskTypeName = _data["auditTaskTypeName"];
            this.name = _data["name"];
            this.auditTaskLabelName = _data["auditTaskLabelName"];
            this.inspectorName = _data["inspectorName"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            this.auditItemName = _data["auditItemName"];
            this.result = _data["result"];
            this.inputData = _data["inputData"];
            this.auditTime = _data["auditTime"];
            this.valueActual = _data["valueActual"];
            this.valueStandard = _data["valueStandard"];
            this.actualInspectorName = _data["actualInspectorName"];
        }
    }

    static fromJS(data: any): AuditTaskExportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskExportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fomartDateTime"] = this.fomartDateTime;
        data["auditTaskTypeName"] = this.auditTaskTypeName;
        data["name"] = this.name;
        data["auditTaskLabelName"] = this.auditTaskLabelName;
        data["inspectorName"] = this.inspectorName;
        data["auditPointName"] = this.auditPointName;
        data["auditItemTypeName"] = this.auditItemTypeName;
        data["auditItemName"] = this.auditItemName;
        data["result"] = this.result;
        data["inputData"] = this.inputData;
        data["auditTime"] = this.auditTime;
        data["valueActual"] = this.valueActual;
        data["valueStandard"] = this.valueStandard;
        data["actualInspectorName"] = this.actualInspectorName;
        return data;
    }

    clone(): AuditTaskExportDetailDto {
        const json = this.toJSON();
        let result = new AuditTaskExportDetailDto();
        result.init(json);
        return result;
    }
}

export interface IAuditTaskExportDetailDto {
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 计划审核人 */
    inspectorName: string | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 数据 */
    inputData: string | undefined;
    /** 审核时间 */
    auditTime: string | undefined;
    /** 录入数值 */
    valueActual: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 实际审核人 */
    actualInspectorName: string | undefined;
}

/** 创建审核团队Dto */
export class CreateAuditTeamDto implements ICreateAuditTeamDto {
    /** 团队名称 */
    name: string;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 排序号 */
    sortCode: number;
    /** 团队成员用户ID列表 */
    memberUserIds: number[] | undefined;

    constructor(data?: ICreateAuditTeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.leaderId = _data["leaderId"];
            this.status = _data["status"];
            this.sortCode = _data["sortCode"];
            if (Array.isArray(_data["memberUserIds"])) {
                this.memberUserIds = [] as any;
                for (let item of _data["memberUserIds"])
                    this.memberUserIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAuditTeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuditTeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["leaderId"] = this.leaderId;
        data["status"] = this.status;
        data["sortCode"] = this.sortCode;
        if (Array.isArray(this.memberUserIds)) {
            data["memberUserIds"] = [];
            for (let item of this.memberUserIds)
                data["memberUserIds"].push(item);
        }
        return data;
    }

    clone(): CreateAuditTeamDto {
        const json = this.toJSON();
        let result = new CreateAuditTeamDto();
        result.init(json);
        return result;
    }
}

/** 创建审核团队Dto */
export interface ICreateAuditTeamDto {
    /** 团队名称 */
    name: string;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 排序号 */
    sortCode: number;
    /** 团队成员用户ID列表 */
    memberUserIds: number[] | undefined;
}

/** 审核团队成员Dto */
export class AuditTeamMemberDto implements IAuditTeamMemberDto {
    /** ID（编辑时使用） */
    id: number | undefined;
    /** 用户ID */
    userId: number;
    /** 用户姓名 */
    userName: string | undefined;
    /** 用户真实姓名 */
    realName: string | undefined;
    /** 用户工号 */
    jobNumber: string | undefined;
    /** 用户在团队中的角色（0.成员 1.管理员） */
    role: number;
    /** 角色名称 */
    roleName: string | undefined;
    /** 是否可以审核 */
    canAudit: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 加入时间 */
    joinTime: moment.Moment;

    constructor(data?: IAuditTeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.realName = _data["realName"];
            this.jobNumber = _data["jobNumber"];
            this.role = _data["role"];
            this.roleName = _data["roleName"];
            this.canAudit = _data["canAudit"];
            this.remark = _data["remark"];
            this.joinTime = _data["joinTime"] ? moment(_data["joinTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditTeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["realName"] = this.realName;
        data["jobNumber"] = this.jobNumber;
        data["role"] = this.role;
        data["roleName"] = this.roleName;
        data["canAudit"] = this.canAudit;
        data["remark"] = this.remark;
        data["joinTime"] = this.joinTime ? this.joinTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AuditTeamMemberDto {
        const json = this.toJSON();
        let result = new AuditTeamMemberDto();
        result.init(json);
        return result;
    }
}

/** 审核团队成员Dto */
export interface IAuditTeamMemberDto {
    /** ID（编辑时使用） */
    id: number | undefined;
    /** 用户ID */
    userId: number;
    /** 用户姓名 */
    userName: string | undefined;
    /** 用户真实姓名 */
    realName: string | undefined;
    /** 用户工号 */
    jobNumber: string | undefined;
    /** 用户在团队中的角色（0.成员 1.管理员） */
    role: number;
    /** 角色名称 */
    roleName: string | undefined;
    /** 是否可以审核 */
    canAudit: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 加入时间 */
    joinTime: moment.Moment;
}

/** 审核团队详情Dto */
export class AuditTeamDetailDto implements IAuditTeamDetailDto {
    /** 团队名称 */
    name: string | undefined;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队负责人姓名 */
    leaderName: string | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 团队状态名称 */
    statusName: string | undefined;
    /** 排序号 */
    sortCode: number;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 团队成员列表 */
    members: AuditTeamMemberDto[] | undefined;
    id: number;

    constructor(data?: IAuditTeamDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.leaderId = _data["leaderId"];
            this.leaderName = _data["leaderName"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.sortCode = _data["sortCode"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(AuditTeamMemberDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditTeamDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["leaderId"] = this.leaderId;
        data["leaderName"] = this.leaderName;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["sortCode"] = this.sortCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AuditTeamDetailDto {
        const json = this.toJSON();
        let result = new AuditTeamDetailDto();
        result.init(json);
        return result;
    }
}

/** 审核团队详情Dto */
export interface IAuditTeamDetailDto {
    /** 团队名称 */
    name: string | undefined;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队负责人姓名 */
    leaderName: string | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 团队状态名称 */
    statusName: string | undefined;
    /** 排序号 */
    sortCode: number;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 团队成员列表 */
    members: AuditTeamMemberDto[] | undefined;
    id: number;
}

/** 审核团队列表Dto */
export class AuditTeamListDto implements IAuditTeamListDto {
    /** 团队名称 */
    name: string | undefined;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队负责人姓名 */
    leaderName: string | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 团队状态名称 */
    statusName: string | undefined;
    /** 排序号 */
    sortCode: number;
    /** 团队成员数量 */
    memberCount: number;
    /** 创建时间 */
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IAuditTeamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.leaderId = _data["leaderId"];
            this.leaderName = _data["leaderName"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.sortCode = _data["sortCode"];
            this.memberCount = _data["memberCount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditTeamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["leaderId"] = this.leaderId;
        data["leaderName"] = this.leaderName;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["sortCode"] = this.sortCode;
        data["memberCount"] = this.memberCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditTeamListDto {
        const json = this.toJSON();
        let result = new AuditTeamListDto();
        result.init(json);
        return result;
    }
}

/** 审核团队列表Dto */
export interface IAuditTeamListDto {
    /** 团队名称 */
    name: string | undefined;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队负责人姓名 */
    leaderName: string | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 团队状态名称 */
    statusName: string | undefined;
    /** 排序号 */
    sortCode: number;
    /** 团队成员数量 */
    memberCount: number;
    /** 创建时间 */
    creationTime: moment.Moment;
    id: number;
}

/** 审核团队选择Dto */
export class AuditTeamForSelectDto implements IAuditTeamForSelectDto {
    /** 团队名称 */
    name: string | undefined;
    /** 团队描述 */
    description: string | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    id: number;

    constructor(data?: IAuditTeamForSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditTeamForSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamForSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }

    clone(): AuditTeamForSelectDto {
        const json = this.toJSON();
        let result = new AuditTeamForSelectDto();
        result.init(json);
        return result;
    }
}

/** 审核团队选择Dto */
export interface IAuditTeamForSelectDto {
    /** 团队名称 */
    name: string | undefined;
    /** 团队描述 */
    description: string | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    id: number;
}

/** 编辑审核团队Dto */
export class AuditTeamEditDto implements IAuditTeamEditDto {
    /** 团队名称 */
    name: string;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 排序号 */
    sortCode: number;
    /** 团队成员用户ID列表 */
    memberUserIds: number[] | undefined;
    id: number;

    constructor(data?: IAuditTeamEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.leaderId = _data["leaderId"];
            this.status = _data["status"];
            this.sortCode = _data["sortCode"];
            if (Array.isArray(_data["memberUserIds"])) {
                this.memberUserIds = [] as any;
                for (let item of _data["memberUserIds"])
                    this.memberUserIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditTeamEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTeamEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["leaderId"] = this.leaderId;
        data["status"] = this.status;
        data["sortCode"] = this.sortCode;
        if (Array.isArray(this.memberUserIds)) {
            data["memberUserIds"] = [];
            for (let item of this.memberUserIds)
                data["memberUserIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AuditTeamEditDto {
        const json = this.toJSON();
        let result = new AuditTeamEditDto();
        result.init(json);
        return result;
    }
}

/** 编辑审核团队Dto */
export interface IAuditTeamEditDto {
    /** 团队名称 */
    name: string;
    /** 团队描述 */
    description: string | undefined;
    /** 团队负责人ID */
    leaderId: number | undefined;
    /** 团队状态（0.禁用 1.启用） */
    status: number;
    /** 排序号 */
    sortCode: number;
    /** 团队成员用户ID列表 */
    memberUserIds: number[] | undefined;
    id: number;
}

export class PagedResultDtoOfAuditTeamListDto implements IPagedResultDtoOfAuditTeamListDto {
    totalCount: number;
    items: AuditTeamListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditTeamListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditTeamListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditTeamListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditTeamListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditTeamListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditTeamListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditTeamListDto {
    totalCount: number;
    items: AuditTeamListDto[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDtoOfInt64 {
        const json = this.toJSON();
        let result = new EntityDtoOfInt64();
        result.init(json);
        return result;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class AuditTemplateEditoDto implements IAuditTemplateEditoDto {
    id: number | undefined;
    /** 审核点模板分组Id */
    auditTemplateGroupId: number;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 条码 */
    barCodeList: number[] | undefined;
    /** 是否启用时间限制 */
    enableTimeLimit: boolean;
    /** 时间范围开始 */
    timeRangeStart: string | undefined;
    /** 时间范围结束 */
    timeRangeEnd: string | undefined;

    constructor(data?: IAuditTemplateEditoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTemplateGroupId = _data["auditTemplateGroupId"];
            this.name = _data["name"];
            this.isWalkAudit = _data["isWalkAudit"];
            this.enable = _data["enable"];
            if (Array.isArray(_data["barCodeList"])) {
                this.barCodeList = [] as any;
                for (let item of _data["barCodeList"])
                    this.barCodeList.push(item);
            }
            this.enableTimeLimit = _data["enableTimeLimit"];
            this.timeRangeStart = _data["timeRangeStart"];
            this.timeRangeEnd = _data["timeRangeEnd"];
        }
    }

    static fromJS(data: any): AuditTemplateEditoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateEditoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTemplateGroupId"] = this.auditTemplateGroupId;
        data["name"] = this.name;
        data["isWalkAudit"] = this.isWalkAudit;
        data["enable"] = this.enable;
        if (Array.isArray(this.barCodeList)) {
            data["barCodeList"] = [];
            for (let item of this.barCodeList)
                data["barCodeList"].push(item);
        }
        data["enableTimeLimit"] = this.enableTimeLimit;
        data["timeRangeStart"] = this.timeRangeStart;
        data["timeRangeEnd"] = this.timeRangeEnd;
        return data;
    }

    clone(): AuditTemplateEditoDto {
        const json = this.toJSON();
        let result = new AuditTemplateEditoDto();
        result.init(json);
        return result;
    }
}

export interface IAuditTemplateEditoDto {
    id: number | undefined;
    /** 审核点模板分组Id */
    auditTemplateGroupId: number;
    /** 方案名称 */
    name: string | undefined;
    /** 是否走动检查 */
    isWalkAudit: boolean;
    /** 是否启用 */
    enable: boolean;
    /** 条码 */
    barCodeList: number[] | undefined;
    /** 是否启用时间限制 */
    enableTimeLimit: boolean;
    /** 时间范围开始 */
    timeRangeStart: string | undefined;
    /** 时间范围结束 */
    timeRangeEnd: string | undefined;
}

export class AuditTemplateDetailEditDto implements IAuditTemplateDetailEditDto {
    id: number | undefined;
    /** 审核模板Id */
    auditTemplateId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核项Id */
    auditItemId: number;
    /** 排序 */
    sn: number;

    constructor(data?: IAuditTemplateDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.sn = _data["sn"];
        }
    }

    static fromJS(data: any): AuditTemplateDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTemplateId"] = this.auditTemplateId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["sn"] = this.sn;
        return data;
    }

    clone(): AuditTemplateDetailEditDto {
        const json = this.toJSON();
        let result = new AuditTemplateDetailEditDto();
        result.init(json);
        return result;
    }
}

export interface IAuditTemplateDetailEditDto {
    id: number | undefined;
    /** 审核模板Id */
    auditTemplateId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核项Id */
    auditItemId: number;
    /** 排序 */
    sn: number;
}

export class CreatOrUpdataAuditTemplateDetailInput implements ICreatOrUpdataAuditTemplateDetailInput {
    auditTemplateEditoDto: AuditTemplateEditoDto;
    auditTemplateDetailEditDto: AuditTemplateDetailEditDto[];
    /** 是否启用时间限制 */
    enableTimeLimit: boolean;
    /** 时间范围开始 */
    timeRangeStart: string | undefined;
    /** 时间范围结束 */
    timeRangeEnd: string | undefined;

    constructor(data?: ICreatOrUpdataAuditTemplateDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditTemplateEditoDto = new AuditTemplateEditoDto();
            this.auditTemplateDetailEditDto = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditTemplateEditoDto = _data["auditTemplateEditoDto"] ? AuditTemplateEditoDto.fromJS(_data["auditTemplateEditoDto"]) : new AuditTemplateEditoDto();
            if (Array.isArray(_data["auditTemplateDetailEditDto"])) {
                this.auditTemplateDetailEditDto = [] as any;
                for (let item of _data["auditTemplateDetailEditDto"])
                    this.auditTemplateDetailEditDto.push(AuditTemplateDetailEditDto.fromJS(item));
            }
            this.enableTimeLimit = _data["enableTimeLimit"];
            this.timeRangeStart = _data["timeRangeStart"];
            this.timeRangeEnd = _data["timeRangeEnd"];
        }
    }

    static fromJS(data: any): CreatOrUpdataAuditTemplateDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataAuditTemplateDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditTemplateEditoDto"] = this.auditTemplateEditoDto ? this.auditTemplateEditoDto.toJSON() : <any>undefined;
        if (Array.isArray(this.auditTemplateDetailEditDto)) {
            data["auditTemplateDetailEditDto"] = [];
            for (let item of this.auditTemplateDetailEditDto)
                data["auditTemplateDetailEditDto"].push(item.toJSON());
        }
        data["enableTimeLimit"] = this.enableTimeLimit;
        data["timeRangeStart"] = this.timeRangeStart;
        data["timeRangeEnd"] = this.timeRangeEnd;
        return data;
    }

    clone(): CreatOrUpdataAuditTemplateDetailInput {
        const json = this.toJSON();
        let result = new CreatOrUpdataAuditTemplateDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdataAuditTemplateDetailInput {
    auditTemplateEditoDto: AuditTemplateEditoDto;
    auditTemplateDetailEditDto: AuditTemplateDetailEditDto[];
    /** 是否启用时间限制 */
    enableTimeLimit: boolean;
    /** 时间范围开始 */
    timeRangeStart: string | undefined;
    /** 时间范围结束 */
    timeRangeEnd: string | undefined;
}

/** EditDto */
export class AuditTemplateGroupEditDto implements IAuditTemplateGroupEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;

    constructor(data?: IAuditTemplateGroupEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
        }
    }

    static fromJS(data: any): AuditTemplateGroupEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateGroupEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        return data;
    }

    clone(): AuditTemplateGroupEditDto {
        const json = this.toJSON();
        let result = new AuditTemplateGroupEditDto();
        result.init(json);
        return result;
    }
}

/** EditDto */
export interface IAuditTemplateGroupEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
}

/** 修改删除Dto */
export class CreateOrUpdateAuditTemplateGroupInput implements ICreateOrUpdateAuditTemplateGroupInput {
    auditTemplateGroup: AuditTemplateGroupEditDto;

    constructor(data?: ICreateOrUpdateAuditTemplateGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.auditTemplateGroup = new AuditTemplateGroupEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditTemplateGroup = _data["auditTemplateGroup"] ? AuditTemplateGroupEditDto.fromJS(_data["auditTemplateGroup"]) : new AuditTemplateGroupEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAuditTemplateGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAuditTemplateGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditTemplateGroup"] = this.auditTemplateGroup ? this.auditTemplateGroup.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateAuditTemplateGroupInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAuditTemplateGroupInput();
        result.init(json);
        return result;
    }
}

/** 修改删除Dto */
export interface ICreateOrUpdateAuditTemplateGroupInput {
    auditTemplateGroup: AuditTemplateGroupEditDto;
}

/** ListDto */
export class AuditTemplateGroupListDto implements IAuditTemplateGroupListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集（实现递归） */
    children: AuditTemplateGroupListDto[] | undefined;

    constructor(data?: IAuditTemplateGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditTemplateGroupListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditTemplateGroupListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTemplateGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuditTemplateGroupListDto {
        const json = this.toJSON();
        let result = new AuditTemplateGroupListDto();
        result.init(json);
        return result;
    }
}

/** ListDto */
export interface IAuditTemplateGroupListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集（实现递归） */
    children: AuditTemplateGroupListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Authorize.Authorize */
export class AuthorizeEditDto implements IAuthorizeEditDto {
    /** Id */
    id: number | undefined;
    /** ObjectType */
    objectType: number;
    /** ObjectId */
    objectId: number;
    /** ItemType */
    itemType: number;
    /** ItemId */
    itemId: number;

    constructor(data?: IAuthorizeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.itemType = _data["itemType"];
            this.itemId = _data["itemId"];
        }
    }

    static fromJS(data: any): AuthorizeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["itemType"] = this.itemType;
        data["itemId"] = this.itemId;
        return data;
    }

    clone(): AuthorizeEditDto {
        const json = this.toJSON();
        let result = new AuthorizeEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Authorize.Authorize */
export interface IAuthorizeEditDto {
    /** Id */
    id: number | undefined;
    /** ObjectType */
    objectType: number;
    /** ObjectId */
    objectId: number;
    /** ItemType */
    itemType: number;
    /** ItemId */
    itemId: number;
}

export class CreateOrUpdateAuthorizeInput implements ICreateOrUpdateAuthorizeInput {
    authorizeList: AuthorizeEditDto[] | undefined;
    /** 对象ID */
    objectId: number;
    /** 是否是APP */
    isApp: boolean;

    constructor(data?: ICreateOrUpdateAuthorizeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["authorizeList"])) {
                this.authorizeList = [] as any;
                for (let item of _data["authorizeList"])
                    this.authorizeList.push(AuthorizeEditDto.fromJS(item));
            }
            this.objectId = _data["objectId"];
            this.isApp = _data["isApp"];
        }
    }

    static fromJS(data: any): CreateOrUpdateAuthorizeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAuthorizeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.authorizeList)) {
            data["authorizeList"] = [];
            for (let item of this.authorizeList)
                data["authorizeList"].push(item.toJSON());
        }
        data["objectId"] = this.objectId;
        data["isApp"] = this.isApp;
        return data;
    }

    clone(): CreateOrUpdateAuthorizeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateAuthorizeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateAuthorizeInput {
    authorizeList: AuthorizeEditDto[] | undefined;
    /** 对象ID */
    objectId: number;
    /** 是否是APP */
    isApp: boolean;
}

/** 的列表DTO QYB.QYBProduct.Authorize.Authorize */
export class AuthorizeListDto implements IAuthorizeListDto {
    /** ObjectType */
    objectType: number;
    /** ObjectId */
    objectId: number;
    /** ItemType */
    itemType: number;
    /** ItemId */
    itemId: number;
    id: number;

    constructor(data?: IAuthorizeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.itemType = _data["itemType"];
            this.itemId = _data["itemId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuthorizeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["itemType"] = this.itemType;
        data["itemId"] = this.itemId;
        data["id"] = this.id;
        return data;
    }

    clone(): AuthorizeListDto {
        const json = this.toJSON();
        let result = new AuthorizeListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Authorize.Authorize */
export interface IAuthorizeListDto {
    /** ObjectType */
    objectType: number;
    /** ObjectId */
    objectId: number;
    /** ItemType */
    itemType: number;
    /** ItemId */
    itemId: number;
    id: number;
}

export class ValueTupleOfInt64String implements IValueTupleOfInt64String {
    item1: number;
    item2: string | undefined;

    constructor(data?: IValueTupleOfInt64String) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfInt64String {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfInt64String();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }

    clone(): ValueTupleOfInt64String {
        const json = this.toJSON();
        let result = new ValueTupleOfInt64String();
        result.init(json);
        return result;
    }
}

export interface IValueTupleOfInt64String {
    item1: number;
    item2: string | undefined;
}

/** 读取可编辑的Dto */
export class GetAuthorizeForEditOutput implements IGetAuthorizeForEditOutput {
    authorize: AuthorizeEditDto;

    constructor(data?: IGetAuthorizeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorize = _data["authorize"] ? AuthorizeEditDto.fromJS(_data["authorize"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAuthorizeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorizeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorize"] = this.authorize ? this.authorize.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAuthorizeForEditOutput {
        const json = this.toJSON();
        let result = new GetAuthorizeForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetAuthorizeForEditOutput {
    authorize: AuthorizeEditDto;
}

/** 对象限制客户端权限实体 */
export class GetObjRestrictClientAuthorizeDto implements IGetObjRestrictClientAuthorizeDto {
    /** 客户端ID */
    clientId: number;
    /** 客户端名称 */
    clientName: string | undefined;
    /** 是否选中 */
    isCheck: boolean;

    constructor(data?: IGetObjRestrictClientAuthorizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.isCheck = _data["isCheck"];
        }
    }

    static fromJS(data: any): GetObjRestrictClientAuthorizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetObjRestrictClientAuthorizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["isCheck"] = this.isCheck;
        return data;
    }

    clone(): GetObjRestrictClientAuthorizeDto {
        const json = this.toJSON();
        let result = new GetObjRestrictClientAuthorizeDto();
        result.init(json);
        return result;
    }
}

/** 对象限制客户端权限实体 */
export interface IGetObjRestrictClientAuthorizeDto {
    /** 客户端ID */
    clientId: number;
    /** 客户端名称 */
    clientName: string | undefined;
    /** 是否选中 */
    isCheck: boolean;
}

export class PagedResultDtoOfAuthorizeListDto implements IPagedResultDtoOfAuthorizeListDto {
    totalCount: number;
    items: AuthorizeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuthorizeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuthorizeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuthorizeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuthorizeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuthorizeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuthorizeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuthorizeListDto {
    totalCount: number;
    items: AuthorizeListDto[] | undefined;
}

export class ModuleTreeDto implements IModuleTreeDto {
    disabled: boolean;
    acl: boolean;
    title: string | undefined;
    name: string | undefined;
    i18n: string | undefined;
    value: string | undefined;
    key: string | undefined;
    link: string | undefined;
    parentId: string | undefined;
    isExpand: boolean;
    moduleId: string | undefined;
    icon: string | undefined;
    target: string | undefined;
    scenesId: number;
    children: ModuleTreeDto[] | undefined;

    constructor(data?: IModuleTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.acl = _data["acl"];
            this.title = _data["title"];
            this.name = _data["name"];
            this.i18n = _data["i18n"];
            this.value = _data["value"];
            this.key = _data["key"];
            this.link = _data["link"];
            this.parentId = _data["parentId"];
            this.isExpand = _data["isExpand"];
            this.moduleId = _data["moduleId"];
            this.icon = _data["icon"];
            this.target = _data["target"];
            this.scenesId = _data["scenesId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(ModuleTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["acl"] = this.acl;
        data["title"] = this.title;
        data["name"] = this.name;
        data["i18n"] = this.i18n;
        data["value"] = this.value;
        data["key"] = this.key;
        data["link"] = this.link;
        data["parentId"] = this.parentId;
        data["isExpand"] = this.isExpand;
        data["moduleId"] = this.moduleId;
        data["icon"] = this.icon;
        data["target"] = this.target;
        data["scenesId"] = this.scenesId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): ModuleTreeDto {
        const json = this.toJSON();
        let result = new ModuleTreeDto();
        result.init(json);
        return result;
    }
}

export interface IModuleTreeDto {
    disabled: boolean;
    acl: boolean;
    title: string | undefined;
    name: string | undefined;
    i18n: string | undefined;
    value: string | undefined;
    key: string | undefined;
    link: string | undefined;
    parentId: string | undefined;
    isExpand: boolean;
    moduleId: string | undefined;
    icon: string | undefined;
    target: string | undefined;
    scenesId: number;
    children: ModuleTreeDto[] | undefined;
}

export class GetUserAuthorizeDto implements IGetUserAuthorizeDto {
    moduleTree: ModuleTreeDto[] | undefined;
    moduleButtonTree: ModuleTreeDto[] | undefined;
    moduleColumnTree: ModuleTreeDto[] | undefined;
    selectKeyList: string[] | undefined;
    moduleKeyDic: { [key: string]: number; } | undefined;
    buttonKeyDic: { [key: string]: number; } | undefined;
    columnKeyDic: { [key: string]: number; } | undefined;
    allDic: { [key: string]: ModuleTreeDto; } | undefined;

    constructor(data?: IGetUserAuthorizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["moduleTree"])) {
                this.moduleTree = [] as any;
                for (let item of _data["moduleTree"])
                    this.moduleTree.push(ModuleTreeDto.fromJS(item));
            }
            if (Array.isArray(_data["moduleButtonTree"])) {
                this.moduleButtonTree = [] as any;
                for (let item of _data["moduleButtonTree"])
                    this.moduleButtonTree.push(ModuleTreeDto.fromJS(item));
            }
            if (Array.isArray(_data["moduleColumnTree"])) {
                this.moduleColumnTree = [] as any;
                for (let item of _data["moduleColumnTree"])
                    this.moduleColumnTree.push(ModuleTreeDto.fromJS(item));
            }
            if (Array.isArray(_data["selectKeyList"])) {
                this.selectKeyList = [] as any;
                for (let item of _data["selectKeyList"])
                    this.selectKeyList.push(item);
            }
            if (_data["moduleKeyDic"]) {
                this.moduleKeyDic = {} as any;
                for (let key in _data["moduleKeyDic"]) {
                    if (_data["moduleKeyDic"].hasOwnProperty(key))
                        (<any>this.moduleKeyDic)[key] = _data["moduleKeyDic"][key];
                }
            }
            if (_data["buttonKeyDic"]) {
                this.buttonKeyDic = {} as any;
                for (let key in _data["buttonKeyDic"]) {
                    if (_data["buttonKeyDic"].hasOwnProperty(key))
                        (<any>this.buttonKeyDic)[key] = _data["buttonKeyDic"][key];
                }
            }
            if (_data["columnKeyDic"]) {
                this.columnKeyDic = {} as any;
                for (let key in _data["columnKeyDic"]) {
                    if (_data["columnKeyDic"].hasOwnProperty(key))
                        (<any>this.columnKeyDic)[key] = _data["columnKeyDic"][key];
                }
            }
            if (_data["allDic"]) {
                this.allDic = {} as any;
                for (let key in _data["allDic"]) {
                    if (_data["allDic"].hasOwnProperty(key))
                        (<any>this.allDic)[key] = _data["allDic"][key] ? ModuleTreeDto.fromJS(_data["allDic"][key]) : new ModuleTreeDto();
                }
            }
        }
    }

    static fromJS(data: any): GetUserAuthorizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAuthorizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleTree)) {
            data["moduleTree"] = [];
            for (let item of this.moduleTree)
                data["moduleTree"].push(item.toJSON());
        }
        if (Array.isArray(this.moduleButtonTree)) {
            data["moduleButtonTree"] = [];
            for (let item of this.moduleButtonTree)
                data["moduleButtonTree"].push(item.toJSON());
        }
        if (Array.isArray(this.moduleColumnTree)) {
            data["moduleColumnTree"] = [];
            for (let item of this.moduleColumnTree)
                data["moduleColumnTree"].push(item.toJSON());
        }
        if (Array.isArray(this.selectKeyList)) {
            data["selectKeyList"] = [];
            for (let item of this.selectKeyList)
                data["selectKeyList"].push(item);
        }
        if (this.moduleKeyDic) {
            data["moduleKeyDic"] = {};
            for (let key in this.moduleKeyDic) {
                if (this.moduleKeyDic.hasOwnProperty(key))
                    (<any>data["moduleKeyDic"])[key] = (<any>this.moduleKeyDic)[key];
            }
        }
        if (this.buttonKeyDic) {
            data["buttonKeyDic"] = {};
            for (let key in this.buttonKeyDic) {
                if (this.buttonKeyDic.hasOwnProperty(key))
                    (<any>data["buttonKeyDic"])[key] = (<any>this.buttonKeyDic)[key];
            }
        }
        if (this.columnKeyDic) {
            data["columnKeyDic"] = {};
            for (let key in this.columnKeyDic) {
                if (this.columnKeyDic.hasOwnProperty(key))
                    (<any>data["columnKeyDic"])[key] = (<any>this.columnKeyDic)[key];
            }
        }
        if (this.allDic) {
            data["allDic"] = {};
            for (let key in this.allDic) {
                if (this.allDic.hasOwnProperty(key))
                    (<any>data["allDic"])[key] = this.allDic[key] ? this.allDic[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): GetUserAuthorizeDto {
        const json = this.toJSON();
        let result = new GetUserAuthorizeDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserAuthorizeDto {
    moduleTree: ModuleTreeDto[] | undefined;
    moduleButtonTree: ModuleTreeDto[] | undefined;
    moduleColumnTree: ModuleTreeDto[] | undefined;
    selectKeyList: string[] | undefined;
    moduleKeyDic: { [key: string]: number; } | undefined;
    buttonKeyDic: { [key: string]: number; } | undefined;
    columnKeyDic: { [key: string]: number; } | undefined;
    allDic: { [key: string]: ModuleTreeDto; } | undefined;
}

/** 轮播图广告的列表DTO QYB.Modules.WebSiteSetting.BannerAds.BannerAd */
export class BannerAdEditDto implements IBannerAdEditDto {
    /** Id */
    id: number | undefined;
    /** 标题 */
    title: string;
    /** 图片地址 */
    imageUrl: string | undefined;
    /** 缩略图地址 */
    thumbImgUrl: string | undefined;
    /** 描述 */
    description: string;
    /** Url */
    url: string | undefined;
    /** 权重 */
    weight: number;
    /** Price */
    price: number;
    /** Types */
    types: string;
    /** ViewCount */
    viewCount: number;

    constructor(data?: IBannerAdEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.imageUrl = _data["imageUrl"];
            this.thumbImgUrl = _data["thumbImgUrl"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.weight = _data["weight"];
            this.price = _data["price"];
            this.types = _data["types"];
            this.viewCount = _data["viewCount"];
        }
    }

    static fromJS(data: any): BannerAdEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerAdEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["imageUrl"] = this.imageUrl;
        data["thumbImgUrl"] = this.thumbImgUrl;
        data["description"] = this.description;
        data["url"] = this.url;
        data["weight"] = this.weight;
        data["price"] = this.price;
        data["types"] = this.types;
        data["viewCount"] = this.viewCount;
        return data;
    }

    clone(): BannerAdEditDto {
        const json = this.toJSON();
        let result = new BannerAdEditDto();
        result.init(json);
        return result;
    }
}

/** 轮播图广告的列表DTO QYB.Modules.WebSiteSetting.BannerAds.BannerAd */
export interface IBannerAdEditDto {
    /** Id */
    id: number | undefined;
    /** 标题 */
    title: string;
    /** 图片地址 */
    imageUrl: string | undefined;
    /** 缩略图地址 */
    thumbImgUrl: string | undefined;
    /** 描述 */
    description: string;
    /** Url */
    url: string | undefined;
    /** 权重 */
    weight: number;
    /** Price */
    price: number;
    /** Types */
    types: string;
    /** ViewCount */
    viewCount: number;
}

export class CreateOrUpdateBannerAdInput implements ICreateOrUpdateBannerAdInput {
    bannerAd: BannerAdEditDto;

    constructor(data?: ICreateOrUpdateBannerAdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bannerAd = new BannerAdEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bannerAd = _data["bannerAd"] ? BannerAdEditDto.fromJS(_data["bannerAd"]) : new BannerAdEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateBannerAdInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBannerAdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bannerAd"] = this.bannerAd ? this.bannerAd.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateBannerAdInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateBannerAdInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateBannerAdInput {
    bannerAd: BannerAdEditDto;
}

/** 轮播图广告的编辑DTO QYB.Modules.WebSiteSetting.BannerAds.BannerAd */
export class BannerAdListDto implements IBannerAdListDto {
    /** 标题 */
    title: string;
    /** 图片地址 */
    imageUrl: string | undefined;
    /** 缩略图地址 */
    thumbImgUrl: string | undefined;
    /** 描述 */
    description: string;
    /** Url */
    url: string | undefined;
    /** 权重 */
    weight: number;
    /** Price */
    price: number;
    /** Types */
    types: string;
    /** ViewCount */
    viewCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBannerAdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.imageUrl = _data["imageUrl"];
            this.thumbImgUrl = _data["thumbImgUrl"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.weight = _data["weight"];
            this.price = _data["price"];
            this.types = _data["types"];
            this.viewCount = _data["viewCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BannerAdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerAdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["imageUrl"] = this.imageUrl;
        data["thumbImgUrl"] = this.thumbImgUrl;
        data["description"] = this.description;
        data["url"] = this.url;
        data["weight"] = this.weight;
        data["price"] = this.price;
        data["types"] = this.types;
        data["viewCount"] = this.viewCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BannerAdListDto {
        const json = this.toJSON();
        let result = new BannerAdListDto();
        result.init(json);
        return result;
    }
}

/** 轮播图广告的编辑DTO QYB.Modules.WebSiteSetting.BannerAds.BannerAd */
export interface IBannerAdListDto {
    /** 标题 */
    title: string;
    /** 图片地址 */
    imageUrl: string | undefined;
    /** 缩略图地址 */
    thumbImgUrl: string | undefined;
    /** 描述 */
    description: string;
    /** Url */
    url: string | undefined;
    /** 权重 */
    weight: number;
    /** Price */
    price: number;
    /** Types */
    types: string;
    /** ViewCount */
    viewCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** 读取可编辑轮播图广告的Dto */
export class GetBannerAdForEditOutput implements IGetBannerAdForEditOutput {
    bannerAd: BannerAdEditDto;

    constructor(data?: IGetBannerAdForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bannerAd = _data["bannerAd"] ? BannerAdEditDto.fromJS(_data["bannerAd"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBannerAdForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBannerAdForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bannerAd"] = this.bannerAd ? this.bannerAd.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBannerAdForEditOutput {
        const json = this.toJSON();
        let result = new GetBannerAdForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑轮播图广告的Dto */
export interface IGetBannerAdForEditOutput {
    bannerAd: BannerAdEditDto;
}

export class PagedResultDtoOfBannerAdListDto implements IPagedResultDtoOfBannerAdListDto {
    totalCount: number;
    items: BannerAdListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBannerAdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BannerAdListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBannerAdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBannerAdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfBannerAdListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBannerAdListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBannerAdListDto {
    totalCount: number;
    items: BannerAdListDto[] | undefined;
}

export class BirthdayWishEditDto implements IBirthdayWishEditDto {
    /** Id */
    id: number | undefined;
    /** 祝福类型 0:生日祝福 1:入职周年 */
    wishType: number;
    /** 祝福内容 */
    wishConten: string | undefined;

    constructor(data?: IBirthdayWishEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wishType = _data["wishType"];
            this.wishConten = _data["wishConten"];
        }
    }

    static fromJS(data: any): BirthdayWishEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayWishEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wishType"] = this.wishType;
        data["wishConten"] = this.wishConten;
        return data;
    }

    clone(): BirthdayWishEditDto {
        const json = this.toJSON();
        let result = new BirthdayWishEditDto();
        result.init(json);
        return result;
    }
}

export interface IBirthdayWishEditDto {
    /** Id */
    id: number | undefined;
    /** 祝福类型 0:生日祝福 1:入职周年 */
    wishType: number;
    /** 祝福内容 */
    wishConten: string | undefined;
}

export class AnniversaryManagementSettingsEditDto implements IAnniversaryManagementSettingsEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IAnniversaryManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): AnniversaryManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnniversaryManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): AnniversaryManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new AnniversaryManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IAnniversaryManagementSettingsEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class BirthdayWishManagementSettingEditDto implements IBirthdayWishManagementSettingEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IBirthdayWishManagementSettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): BirthdayWishManagementSettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayWishManagementSettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): BirthdayWishManagementSettingEditDto {
        const json = this.toJSON();
        let result = new BirthdayWishManagementSettingEditDto();
        result.init(json);
        return result;
    }
}

export interface IBirthdayWishManagementSettingEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class BirthdayWishEditInput implements IBirthdayWishEditInput {
    birthdayWishEdit: BirthdayWishEditDto;
    anniversarySettings: AnniversaryManagementSettingsEditDto;
    birthdayWishSettings: BirthdayWishManagementSettingEditDto;

    constructor(data?: IBirthdayWishEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthdayWishEdit = _data["birthdayWishEdit"] ? BirthdayWishEditDto.fromJS(_data["birthdayWishEdit"]) : <any>undefined;
            this.anniversarySettings = _data["anniversarySettings"] ? AnniversaryManagementSettingsEditDto.fromJS(_data["anniversarySettings"]) : <any>undefined;
            this.birthdayWishSettings = _data["birthdayWishSettings"] ? BirthdayWishManagementSettingEditDto.fromJS(_data["birthdayWishSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BirthdayWishEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayWishEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthdayWishEdit"] = this.birthdayWishEdit ? this.birthdayWishEdit.toJSON() : <any>undefined;
        data["anniversarySettings"] = this.anniversarySettings ? this.anniversarySettings.toJSON() : <any>undefined;
        data["birthdayWishSettings"] = this.birthdayWishSettings ? this.birthdayWishSettings.toJSON() : <any>undefined;
        return data;
    }

    clone(): BirthdayWishEditInput {
        const json = this.toJSON();
        let result = new BirthdayWishEditInput();
        result.init(json);
        return result;
    }
}

export interface IBirthdayWishEditInput {
    birthdayWishEdit: BirthdayWishEditDto;
    anniversarySettings: AnniversaryManagementSettingsEditDto;
    birthdayWishSettings: BirthdayWishManagementSettingEditDto;
}

/** 博客的列表DTO QYB.Modules.Blogging.Blogs.Blog */
export class BlogEditDto implements IBlogEditDto {
    /** Id */
    id: string | undefined;
    /** 博客名称 */
    name: string;
    /** 博客短名称 */
    shortName: string;
    /** 博客描述 */
    description: string | undefined;
    /** 博客的所属用户 */
    blogUserId: number;
    /** 标签 */
    tagIds: string[] | undefined;

    constructor(data?: IBlogEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.blogUserId = _data["blogUserId"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds.push(item);
            }
        }
    }

    static fromJS(data: any): BlogEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlogEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["blogUserId"] = this.blogUserId;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }

    clone(): BlogEditDto {
        const json = this.toJSON();
        let result = new BlogEditDto();
        result.init(json);
        return result;
    }
}

/** 博客的列表DTO QYB.Modules.Blogging.Blogs.Blog */
export interface IBlogEditDto {
    /** Id */
    id: string | undefined;
    /** 博客名称 */
    name: string;
    /** 博客短名称 */
    shortName: string;
    /** 博客描述 */
    description: string | undefined;
    /** 博客的所属用户 */
    blogUserId: number;
    /** 标签 */
    tagIds: string[] | undefined;
}

export class CreateOrUpdateBlogInput implements ICreateOrUpdateBlogInput {
    blog: BlogEditDto;

    constructor(data?: ICreateOrUpdateBlogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.blog = new BlogEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blog = _data["blog"] ? BlogEditDto.fromJS(_data["blog"]) : new BlogEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateBlogInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBlogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blog"] = this.blog ? this.blog.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateBlogInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateBlogInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateBlogInput {
    blog: BlogEditDto;
}

/** 博客的编辑DTO QYB.Modules.Blogging.Blogs.Blog */
export class BlogListDto implements IBlogListDto {
    /** 博客名称 */
    name: string;
    /** 博客短名称 */
    shortName: string;
    /** 博客描述 */
    description: string | undefined;
    blogUserName: string | undefined;
    /** 标签 */
    tags: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IBlogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.blogUserName = _data["blogUserName"];
            this.tags = _data["tags"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BlogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["blogUserName"] = this.blogUserName;
        data["tags"] = this.tags;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BlogListDto {
        const json = this.toJSON();
        let result = new BlogListDto();
        result.init(json);
        return result;
    }
}

/** 博客的编辑DTO QYB.Modules.Blogging.Blogs.Blog */
export interface IBlogListDto {
    /** 博客名称 */
    name: string;
    /** 博客短名称 */
    shortName: string;
    /** 博客描述 */
    description: string | undefined;
    blogUserName: string | undefined;
    /** 标签 */
    tags: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

/** 读取可编辑博客的Dto */
export class GetBlogForEditOutput implements IGetBlogForEditOutput {
    blog: BlogEditDto;

    constructor(data?: IGetBlogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blog = _data["blog"] ? BlogEditDto.fromJS(_data["blog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBlogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blog"] = this.blog ? this.blog.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBlogForEditOutput {
        const json = this.toJSON();
        let result = new GetBlogForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑博客的Dto */
export interface IGetBlogForEditOutput {
    blog: BlogEditDto;
}

export class PagedResultDtoOfBlogListDto implements IPagedResultDtoOfBlogListDto {
    totalCount: number;
    items: BlogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBlogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BlogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBlogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBlogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfBlogListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBlogListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBlogListDto {
    totalCount: number;
    items: BlogListDto[] | undefined;
}

/** 标签的编辑DTO QYB.Modules.Blogging.Tagging.Tag */
export class TagListDto implements ITagListDto {
    /** 标签名称 */
    name: string | undefined;
    /** 标签描述 */
    description: string | undefined;
    /** 使用计数器 */
    usageCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ITagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.usageCount = _data["usageCount"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["usageCount"] = this.usageCount;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TagListDto {
        const json = this.toJSON();
        let result = new TagListDto();
        result.init(json);
        return result;
    }
}

/** 标签的编辑DTO QYB.Modules.Blogging.Tagging.Tag */
export interface ITagListDto {
    /** 标签名称 */
    name: string | undefined;
    /** 标签描述 */
    description: string | undefined;
    /** 使用计数器 */
    usageCount: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class UserListOutput implements IUserListOutput {
    id: number;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IUserListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): UserListOutput {
        const json = this.toJSON();
        let result = new UserListOutput();
        result.init(json);
        return result;
    }
}

export interface IUserListOutput {
    id: number;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
}

/** 友情链接的列表DTO QYB.Modules.WebSiteSetting.Blogrolls.Blogroll */
export class BlogrollEditDto implements IBlogrollEditDto {
    /** Id */
    id: number | undefined;
    /** 友情链接分类id */
    blogrollTypeId: number;
    /** 名称 */
    name: string;
    /** Url */
    url: string;
    /** 白名单 */
    except: boolean;
    /** 推荐 */
    recommend: boolean;
    /** 权重 */
    weight: number;
    /** Logo */
    logo: string | undefined;
    /** 图标 */
    iconName: string | undefined;

    constructor(data?: IBlogrollEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blogrollTypeId = _data["blogrollTypeId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.except = _data["except"];
            this.recommend = _data["recommend"];
            this.weight = _data["weight"];
            this.logo = _data["logo"];
            this.iconName = _data["iconName"];
        }
    }

    static fromJS(data: any): BlogrollEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlogrollEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blogrollTypeId"] = this.blogrollTypeId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["except"] = this.except;
        data["recommend"] = this.recommend;
        data["weight"] = this.weight;
        data["logo"] = this.logo;
        data["iconName"] = this.iconName;
        return data;
    }

    clone(): BlogrollEditDto {
        const json = this.toJSON();
        let result = new BlogrollEditDto();
        result.init(json);
        return result;
    }
}

/** 友情链接的列表DTO QYB.Modules.WebSiteSetting.Blogrolls.Blogroll */
export interface IBlogrollEditDto {
    /** Id */
    id: number | undefined;
    /** 友情链接分类id */
    blogrollTypeId: number;
    /** 名称 */
    name: string;
    /** Url */
    url: string;
    /** 白名单 */
    except: boolean;
    /** 推荐 */
    recommend: boolean;
    /** 权重 */
    weight: number;
    /** Logo */
    logo: string | undefined;
    /** 图标 */
    iconName: string | undefined;
}

export class CreateOrUpdateBlogrollInput implements ICreateOrUpdateBlogrollInput {
    blogroll: BlogrollEditDto;

    constructor(data?: ICreateOrUpdateBlogrollInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.blogroll = new BlogrollEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogroll = _data["blogroll"] ? BlogrollEditDto.fromJS(_data["blogroll"]) : new BlogrollEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateBlogrollInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBlogrollInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogroll"] = this.blogroll ? this.blogroll.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateBlogrollInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateBlogrollInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateBlogrollInput {
    blogroll: BlogrollEditDto;
}

/** 友情链接的编辑DTO QYB.Modules.WebSiteSetting.Blogrolls.Blogroll */
export class BlogrollListDto implements IBlogrollListDto {
    /** 友情链接分类id */
    blogrollTypeId: number;
    /** 名称 */
    name: string;
    /** Url */
    url: string;
    /** 白名单 */
    except: boolean;
    /** 推荐 */
    recommend: boolean;
    /** 权重 */
    weight: number;
    /** Logo */
    logo: string | undefined;
    /** 图标 */
    iconName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBlogrollListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogrollTypeId = _data["blogrollTypeId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.except = _data["except"];
            this.recommend = _data["recommend"];
            this.weight = _data["weight"];
            this.logo = _data["logo"];
            this.iconName = _data["iconName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BlogrollListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlogrollListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogrollTypeId"] = this.blogrollTypeId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["except"] = this.except;
        data["recommend"] = this.recommend;
        data["weight"] = this.weight;
        data["logo"] = this.logo;
        data["iconName"] = this.iconName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BlogrollListDto {
        const json = this.toJSON();
        let result = new BlogrollListDto();
        result.init(json);
        return result;
    }
}

/** 友情链接的编辑DTO QYB.Modules.WebSiteSetting.Blogrolls.Blogroll */
export interface IBlogrollListDto {
    /** 友情链接分类id */
    blogrollTypeId: number;
    /** 名称 */
    name: string;
    /** Url */
    url: string;
    /** 白名单 */
    except: boolean;
    /** 推荐 */
    recommend: boolean;
    /** 权重 */
    weight: number;
    /** Logo */
    logo: string | undefined;
    /** 图标 */
    iconName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** 读取可编辑友情链接的Dto */
export class GetBlogrollForEditOutput implements IGetBlogrollForEditOutput {
    blogroll: BlogrollEditDto;

    constructor(data?: IGetBlogrollForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogroll = _data["blogroll"] ? BlogrollEditDto.fromJS(_data["blogroll"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBlogrollForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlogrollForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogroll"] = this.blogroll ? this.blogroll.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBlogrollForEditOutput {
        const json = this.toJSON();
        let result = new GetBlogrollForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑友情链接的Dto */
export interface IGetBlogrollForEditOutput {
    blogroll: BlogrollEditDto;
}

export class PagedResultDtoOfBlogrollListDto implements IPagedResultDtoOfBlogrollListDto {
    totalCount: number;
    items: BlogrollListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBlogrollListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BlogrollListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBlogrollListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBlogrollListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfBlogrollListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBlogrollListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBlogrollListDto {
    totalCount: number;
    items: BlogrollListDto[] | undefined;
}

/** 友情链接分类的列表DTO QYB.Modules.WebSiteSetting.Blogrolls.BlogrollType */
export class BlogrollTypeEditDto implements IBlogrollTypeEditDto {
    /** Id */
    id: number | undefined;
    /** 分类名称 */
    name: string;

    constructor(data?: IBlogrollTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BlogrollTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlogrollTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): BlogrollTypeEditDto {
        const json = this.toJSON();
        let result = new BlogrollTypeEditDto();
        result.init(json);
        return result;
    }
}

/** 友情链接分类的列表DTO QYB.Modules.WebSiteSetting.Blogrolls.BlogrollType */
export interface IBlogrollTypeEditDto {
    /** Id */
    id: number | undefined;
    /** 分类名称 */
    name: string;
}

export class CreateOrUpdateBlogrollTypeInput implements ICreateOrUpdateBlogrollTypeInput {
    blogrollType: BlogrollTypeEditDto;

    constructor(data?: ICreateOrUpdateBlogrollTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.blogrollType = new BlogrollTypeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogrollType = _data["blogrollType"] ? BlogrollTypeEditDto.fromJS(_data["blogrollType"]) : new BlogrollTypeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateBlogrollTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBlogrollTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogrollType"] = this.blogrollType ? this.blogrollType.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateBlogrollTypeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateBlogrollTypeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateBlogrollTypeInput {
    blogrollType: BlogrollTypeEditDto;
}

/** 友情链接分类的编辑DTO QYB.Modules.WebSiteSetting.Blogrolls.BlogrollType */
export class BlogrollTypeListDto implements IBlogrollTypeListDto {
    /** 分类名称 */
    name: string;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBlogrollTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BlogrollTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlogrollTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BlogrollTypeListDto {
        const json = this.toJSON();
        let result = new BlogrollTypeListDto();
        result.init(json);
        return result;
    }
}

/** 友情链接分类的编辑DTO QYB.Modules.WebSiteSetting.Blogrolls.BlogrollType */
export interface IBlogrollTypeListDto {
    /** 分类名称 */
    name: string;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** 读取可编辑友情链接分类的Dto */
export class GetBlogrollTypeForEditOutput implements IGetBlogrollTypeForEditOutput {
    blogrollType: BlogrollTypeEditDto;

    constructor(data?: IGetBlogrollTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogrollType = _data["blogrollType"] ? BlogrollTypeEditDto.fromJS(_data["blogrollType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBlogrollTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlogrollTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogrollType"] = this.blogrollType ? this.blogrollType.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetBlogrollTypeForEditOutput {
        const json = this.toJSON();
        let result = new GetBlogrollTypeForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑友情链接分类的Dto */
export interface IGetBlogrollTypeForEditOutput {
    blogrollType: BlogrollTypeEditDto;
}

export class PagedResultDtoOfBlogrollTypeListDto implements IPagedResultDtoOfBlogrollTypeListDto {
    totalCount: number;
    items: BlogrollTypeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBlogrollTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BlogrollTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBlogrollTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBlogrollTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfBlogrollTypeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBlogrollTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBlogrollTypeListDto {
    totalCount: number;
    items: BlogrollTypeListDto[] | undefined;
}

export enum FriendshipState {
    Accepted = <any>"Accepted",
    Blocked = <any>"Blocked",
}

export class FriendDto implements IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }

    clone(): FriendDto {
        const json = this.toJSON();
        let result = new FriendDto();
        result.init(json);
        return result;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export class EnumOutputDto implements IEnumOutputDto {
    name: string | undefined;
    value: string | undefined;
    description: string | undefined;

    constructor(data?: IEnumOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EnumOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }

    clone(): EnumOutputDto {
        const json = this.toJSON();
        let result = new EnumOutputDto();
        result.init(json);
        return result;
    }
}

export interface IEnumOutputDto {
    name: string | undefined;
    value: string | undefined;
    description: string | undefined;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;
    friendState: EnumOutputDto;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? moment(_data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends.push(FriendDto.fromJS(item));
            }
            this.friendState = _data["friendState"] ? EnumOutputDto.fromJS(_data["friendState"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        data["friendState"] = this.friendState ? this.friendState.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUserChatFriendsWithSettingsOutput {
        const json = this.toJSON();
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;
    friendState: EnumOutputDto;
}

export enum ChatMessageReadState {
    Unread = <any>"Unread",
    Read = <any>"Read",
}

export class ChatMessageDto implements IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: number;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;
    id: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }

    clone(): ChatMessageDto {
        const json = this.toJSON();
        let result = new ChatMessageDto();
        result.init(json);
        return result;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: number;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;
    id: number;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfChatMessageDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfChatMessageDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): MarkAllUnreadMessagesOfUserAsReadInput {
        const json = this.toJSON();
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(json);
        return result;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

/** 的列表DTO QYB.QYBProduct.Attendance.CheckInRecord.CheckInRecord */
export class CheckInRecordEditDto implements ICheckInRecordEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    userId: number;
    /** CheckTime */
    checkTime: moment.Moment;
    /** CheckType */
    checkType: string | undefined;
    /** CheckPoint */
    checkPoint: string | undefined;
    /** CardNumber */
    cardNumber: string | undefined;
    /** CheckAddress */
    checkAddress: string | undefined;
    /** Lat */
    lat: string | undefined;
    /** Lng */
    lng: string | undefined;
    /** Distance */
    distance: number | undefined;
    /** WifiMac */
    wifiMac: string | undefined;
    /** SignalStrength */
    signalStrength: string | undefined;

    constructor(data?: ICheckInRecordEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.checkTime = _data["checkTime"] ? moment(_data["checkTime"].toString()) : <any>undefined;
            this.checkType = _data["checkType"];
            this.checkPoint = _data["checkPoint"];
            this.cardNumber = _data["cardNumber"];
            this.checkAddress = _data["checkAddress"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.distance = _data["distance"];
            this.wifiMac = _data["wifiMac"];
            this.signalStrength = _data["signalStrength"];
        }
    }

    static fromJS(data: any): CheckInRecordEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInRecordEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["checkType"] = this.checkType;
        data["checkPoint"] = this.checkPoint;
        data["cardNumber"] = this.cardNumber;
        data["checkAddress"] = this.checkAddress;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["distance"] = this.distance;
        data["wifiMac"] = this.wifiMac;
        data["signalStrength"] = this.signalStrength;
        return data;
    }

    clone(): CheckInRecordEditDto {
        const json = this.toJSON();
        let result = new CheckInRecordEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.CheckInRecord.CheckInRecord */
export interface ICheckInRecordEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    userId: number;
    /** CheckTime */
    checkTime: moment.Moment;
    /** CheckType */
    checkType: string | undefined;
    /** CheckPoint */
    checkPoint: string | undefined;
    /** CardNumber */
    cardNumber: string | undefined;
    /** CheckAddress */
    checkAddress: string | undefined;
    /** Lat */
    lat: string | undefined;
    /** Lng */
    lng: string | undefined;
    /** Distance */
    distance: number | undefined;
    /** WifiMac */
    wifiMac: string | undefined;
    /** SignalStrength */
    signalStrength: string | undefined;
}

export class CreateOrUpdateCheckInRecordInput implements ICreateOrUpdateCheckInRecordInput {
    checkInRecord: CheckInRecordEditDto;

    constructor(data?: ICreateOrUpdateCheckInRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checkInRecord = new CheckInRecordEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkInRecord = _data["checkInRecord"] ? CheckInRecordEditDto.fromJS(_data["checkInRecord"]) : new CheckInRecordEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCheckInRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCheckInRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkInRecord"] = this.checkInRecord ? this.checkInRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCheckInRecordInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCheckInRecordInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCheckInRecordInput {
    checkInRecord: CheckInRecordEditDto;
}

/** 的列表DTO QYB.QYBProduct.Attendance.CheckInRecord.CheckInRecord */
export class CheckInRecordListDto implements ICheckInRecordListDto {
    id: number;
    /** UserId */
    empId: number;
    /** 员工 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    departmentName: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** CheckTime */
    checkTime: moment.Moment;
    /** CheckType */
    checkType: string | undefined;
    /** CheckPoint */
    checkPoint: string | undefined;
    /** CardNumber */
    cardNumber: string | undefined;
    /** CheckAddress */
    checkAddress: string | undefined;
    /** Lat */
    lat: string | undefined;
    /** Lng */
    lng: string | undefined;
    /** Distance */
    distance: number | undefined;
    /** WifiMac */
    wifiMac: string | undefined;
    /** SignalStrength */
    signalStrength: string | undefined;

    constructor(data?: ICheckInRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.company = _data["company"];
            this.departmentName = _data["departmentName"];
            this.empType = _data["empType"];
            this.checkTime = _data["checkTime"] ? moment(_data["checkTime"].toString()) : <any>undefined;
            this.checkType = _data["checkType"];
            this.checkPoint = _data["checkPoint"];
            this.cardNumber = _data["cardNumber"];
            this.checkAddress = _data["checkAddress"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.distance = _data["distance"];
            this.wifiMac = _data["wifiMac"];
            this.signalStrength = _data["signalStrength"];
        }
    }

    static fromJS(data: any): CheckInRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["company"] = this.company;
        data["departmentName"] = this.departmentName;
        data["empType"] = this.empType;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["checkType"] = this.checkType;
        data["checkPoint"] = this.checkPoint;
        data["cardNumber"] = this.cardNumber;
        data["checkAddress"] = this.checkAddress;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["distance"] = this.distance;
        data["wifiMac"] = this.wifiMac;
        data["signalStrength"] = this.signalStrength;
        return data;
    }

    clone(): CheckInRecordListDto {
        const json = this.toJSON();
        let result = new CheckInRecordListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.CheckInRecord.CheckInRecord */
export interface ICheckInRecordListDto {
    id: number;
    /** UserId */
    empId: number;
    /** 员工 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    departmentName: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** CheckTime */
    checkTime: moment.Moment;
    /** CheckType */
    checkType: string | undefined;
    /** CheckPoint */
    checkPoint: string | undefined;
    /** CardNumber */
    cardNumber: string | undefined;
    /** CheckAddress */
    checkAddress: string | undefined;
    /** Lat */
    lat: string | undefined;
    /** Lng */
    lng: string | undefined;
    /** Distance */
    distance: number | undefined;
    /** WifiMac */
    wifiMac: string | undefined;
    /** SignalStrength */
    signalStrength: string | undefined;
}

/** 读取可编辑的Dto */
export class GetCheckInRecordForEditOutput implements IGetCheckInRecordForEditOutput {
    checkInRecord: CheckInRecordEditDto;

    constructor(data?: IGetCheckInRecordForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkInRecord = _data["checkInRecord"] ? CheckInRecordEditDto.fromJS(_data["checkInRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCheckInRecordForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckInRecordForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkInRecord"] = this.checkInRecord ? this.checkInRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCheckInRecordForEditOutput {
        const json = this.toJSON();
        let result = new GetCheckInRecordForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetCheckInRecordForEditOutput {
    checkInRecord: CheckInRecordEditDto;
}

export class PagedResultDtoOfCheckInRecordListDto implements IPagedResultDtoOfCheckInRecordListDto {
    totalCount: number;
    items: CheckInRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCheckInRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CheckInRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCheckInRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCheckInRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCheckInRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCheckInRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCheckInRecordListDto {
    totalCount: number;
    items: CheckInRecordListDto[] | undefined;
}

/** 评论的列表DTO QYB.Modules.Blogging.Comments.Comment */
export class CommentEditDto implements ICommentEditDto {
    /** Id */
    id: string | undefined;
    postId: string;
    /** 回复评论Id */
    repliedCommentId: string | undefined;
    /** 评论内容 */
    text: string;

    constructor(data?: ICommentEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.postId = _data["postId"];
            this.repliedCommentId = _data["repliedCommentId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CommentEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postId"] = this.postId;
        data["repliedCommentId"] = this.repliedCommentId;
        data["text"] = this.text;
        return data;
    }

    clone(): CommentEditDto {
        const json = this.toJSON();
        let result = new CommentEditDto();
        result.init(json);
        return result;
    }
}

/** 评论的列表DTO QYB.Modules.Blogging.Comments.Comment */
export interface ICommentEditDto {
    /** Id */
    id: string | undefined;
    postId: string;
    /** 回复评论Id */
    repliedCommentId: string | undefined;
    /** 评论内容 */
    text: string;
}

export class CreateOrUpdateCommentInput implements ICreateOrUpdateCommentInput {
    comment: CommentEditDto;

    constructor(data?: ICreateOrUpdateCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.comment = new CommentEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] ? CommentEditDto.fromJS(_data["comment"]) : new CommentEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCommentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCommentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCommentInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCommentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCommentInput {
    comment: CommentEditDto;
}

/** 评论的编辑DTO QYB.Modules.Blogging.Comments.Comment */
export class CommentListDto implements ICommentListDto {
    /** 文章Id */
    postId: string;
    /** 回复评论Id */
    repliedCommentId: string | undefined;
    /** 回复评论 */
    repliedCommentTest: string | undefined;
    /** 评论内容 */
    text: string;
    /** 文章Title */
    title: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ICommentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postId = _data["postId"];
            this.repliedCommentId = _data["repliedCommentId"];
            this.repliedCommentTest = _data["repliedCommentTest"];
            this.text = _data["text"];
            this.title = _data["title"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postId"] = this.postId;
        data["repliedCommentId"] = this.repliedCommentId;
        data["repliedCommentTest"] = this.repliedCommentTest;
        data["text"] = this.text;
        data["title"] = this.title;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CommentListDto {
        const json = this.toJSON();
        let result = new CommentListDto();
        result.init(json);
        return result;
    }
}

/** 评论的编辑DTO QYB.Modules.Blogging.Comments.Comment */
export interface ICommentListDto {
    /** 文章Id */
    postId: string;
    /** 回复评论Id */
    repliedCommentId: string | undefined;
    /** 回复评论 */
    repliedCommentTest: string | undefined;
    /** 评论内容 */
    text: string;
    /** 文章Title */
    title: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

/** 读取可编辑评论的Dto */
export class GetCommentForEditOutput implements IGetCommentForEditOutput {
    comment: CommentEditDto;

    constructor(data?: IGetCommentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] ? CommentEditDto.fromJS(_data["comment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCommentForEditOutput {
        const json = this.toJSON();
        let result = new GetCommentForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑评论的Dto */
export interface IGetCommentForEditOutput {
    comment: CommentEditDto;
}

export class PagedResultDtoOfCommentListDto implements IPagedResultDtoOfCommentListDto {
    totalCount: number;
    items: CommentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CommentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCommentListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCommentListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCommentListDto {
    totalCount: number;
    items: CommentListDto[] | undefined;
}

export class CommonLookupFindUsersInput implements ICommonLookupFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number;
    skipCount: number;
    filterText: string | undefined;

    constructor(data?: ICommonLookupFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filterText = _data["filterText"];
        }
    }

    static fromJS(data: any): CommonLookupFindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new CommonLookupFindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filterText"] = this.filterText;
        return data;
    }

    clone(): CommonLookupFindUsersInput {
        const json = this.toJSON();
        let result = new CommonLookupFindUsersInput();
        result.init(json);
        return result;
    }
}

export interface ICommonLookupFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number;
    skipCount: number;
    filterText: string | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfNameValueDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNameValueDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): GetDefaultEditionNameOutput {
        const json = this.toJSON();
        let result = new GetDefaultEditionNameOutput();
        result.init(json);
        return result;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): SubscribableEditionComboboxItemDto {
        const json = this.toJSON();
        let result = new SubscribableEditionComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfSubscribableEditionComboboxItemDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class ComboboxItemDtoTOfString implements IComboboxItemDtoTOfString {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;

    constructor(data?: IComboboxItemDtoTOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoTOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoTOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): ComboboxItemDtoTOfString {
        const json = this.toJSON();
        let result = new ComboboxItemDtoTOfString();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDtoTOfString {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfComboboxItemDtoTOfString implements IListResultDtoOfComboboxItemDtoTOfString {
    items: ComboboxItemDtoTOfString[] | undefined;

    constructor(data?: IListResultDtoOfComboboxItemDtoTOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ComboboxItemDtoTOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfComboboxItemDtoTOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfComboboxItemDtoTOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfComboboxItemDtoTOfString {
        const json = this.toJSON();
        let result = new ListResultDtoOfComboboxItemDtoTOfString();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfComboboxItemDtoTOfString {
    items: ComboboxItemDtoTOfString[] | undefined;
}

export class ComboboxItemDtoTOfInt32 implements IComboboxItemDtoTOfInt32 {
    value: number;
    displayText: string | undefined;
    isSelected: boolean;

    constructor(data?: IComboboxItemDtoTOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDtoTOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDtoTOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): ComboboxItemDtoTOfInt32 {
        const json = this.toJSON();
        let result = new ComboboxItemDtoTOfInt32();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDtoTOfInt32 {
    value: number;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfComboboxItemDtoTOfInt32 implements IListResultDtoOfComboboxItemDtoTOfInt32 {
    items: ComboboxItemDtoTOfInt32[] | undefined;

    constructor(data?: IListResultDtoOfComboboxItemDtoTOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ComboboxItemDtoTOfInt32.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfComboboxItemDtoTOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfComboboxItemDtoTOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfComboboxItemDtoTOfInt32 {
        const json = this.toJSON();
        let result = new ListResultDtoOfComboboxItemDtoTOfInt32();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfComboboxItemDtoTOfInt32 {
    items: ComboboxItemDtoTOfInt32[] | undefined;
}

/** 公司的列表DTO QYB.Organization.Company.Company */
export class CompanyEditDto implements ICompanyEditDto {
    /** Id */
    id: number | undefined;
    /** Category */
    category: number | undefined;
    /** ParentId */
    parentId: number | undefined;
    /** EnCode */
    enCode: string | undefined;
    /** ShortName */
    shortName: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Nature */
    nature: string | undefined;
    /** OuterPhone */
    outerPhone: string | undefined;
    /** InnerPhone */
    innerPhone: string | undefined;
    /** Fax */
    fax: string | undefined;
    /** Postalcode */
    postalcode: string | undefined;
    /** Email */
    email: string | undefined;
    /** 负责人ID */
    managerUserId: number | undefined;
    /** ProvinceId */
    provinceId: string | undefined;
    /** CityId */
    cityId: string | undefined;
    /** CountyId */
    countyId: string | undefined;
    /** Address */
    address: string | undefined;
    /** WebAddress */
    webAddress: string | undefined;
    /** FoundedTime */
    foundedTime: moment.Moment | undefined;
    /** BusinessScope */
    businessScope: string | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** Description */
    description: string | undefined;

    constructor(data?: ICompanyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.shortName = _data["shortName"];
            this.fullName = _data["fullName"];
            this.nature = _data["nature"];
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.fax = _data["fax"];
            this.postalcode = _data["postalcode"];
            this.email = _data["email"];
            this.managerUserId = _data["managerUserId"];
            this.provinceId = _data["provinceId"];
            this.cityId = _data["cityId"];
            this.countyId = _data["countyId"];
            this.address = _data["address"];
            this.webAddress = _data["webAddress"];
            this.foundedTime = _data["foundedTime"] ? moment(_data["foundedTime"].toString()) : <any>undefined;
            this.businessScope = _data["businessScope"];
            this.sortCode = _data["sortCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CompanyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["shortName"] = this.shortName;
        data["fullName"] = this.fullName;
        data["nature"] = this.nature;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["fax"] = this.fax;
        data["postalcode"] = this.postalcode;
        data["email"] = this.email;
        data["managerUserId"] = this.managerUserId;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["countyId"] = this.countyId;
        data["address"] = this.address;
        data["webAddress"] = this.webAddress;
        data["foundedTime"] = this.foundedTime ? this.foundedTime.toISOString() : <any>undefined;
        data["businessScope"] = this.businessScope;
        data["sortCode"] = this.sortCode;
        data["description"] = this.description;
        return data;
    }

    clone(): CompanyEditDto {
        const json = this.toJSON();
        let result = new CompanyEditDto();
        result.init(json);
        return result;
    }
}

/** 公司的列表DTO QYB.Organization.Company.Company */
export interface ICompanyEditDto {
    /** Id */
    id: number | undefined;
    /** Category */
    category: number | undefined;
    /** ParentId */
    parentId: number | undefined;
    /** EnCode */
    enCode: string | undefined;
    /** ShortName */
    shortName: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Nature */
    nature: string | undefined;
    /** OuterPhone */
    outerPhone: string | undefined;
    /** InnerPhone */
    innerPhone: string | undefined;
    /** Fax */
    fax: string | undefined;
    /** Postalcode */
    postalcode: string | undefined;
    /** Email */
    email: string | undefined;
    /** 负责人ID */
    managerUserId: number | undefined;
    /** ProvinceId */
    provinceId: string | undefined;
    /** CityId */
    cityId: string | undefined;
    /** CountyId */
    countyId: string | undefined;
    /** Address */
    address: string | undefined;
    /** WebAddress */
    webAddress: string | undefined;
    /** FoundedTime */
    foundedTime: moment.Moment | undefined;
    /** BusinessScope */
    businessScope: string | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** Description */
    description: string | undefined;
}

export class CreateOrUpdateCompanyInput implements ICreateOrUpdateCompanyInput {
    company: CompanyEditDto;

    constructor(data?: ICreateOrUpdateCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyEditDto.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateCompanyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCompanyInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCompanyInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCompanyInput {
    company: CompanyEditDto;
}

/** 公司的列表DTO QYB.Organization.Company.Company */
export class CompanyListDto implements ICompanyListDto {
    /** Category */
    category: number | undefined;
    /** ParentId */
    parentId: number | undefined;
    /** EnCode */
    enCode: string | undefined;
    /** ShortName */
    shortName: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Nature */
    nature: string | undefined;
    /** OuterPhone */
    outerPhone: string | undefined;
    /** InnerPhone */
    innerPhone: string | undefined;
    /** Fax */
    fax: string | undefined;
    /** Postalcode */
    postalcode: string | undefined;
    /** Email */
    email: string | undefined;
    /** ProvinceId */
    provinceId: string | undefined;
    /** CityId */
    cityId: string | undefined;
    /** CountyId */
    countyId: string | undefined;
    /** Address */
    address: string | undefined;
    /** WebAddress */
    webAddress: string | undefined;
    /** FoundedTime */
    foundedTime: moment.Moment | undefined;
    /** BusinessScope */
    businessScope: string | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** Description */
    description: string | undefined;
    /** ManagerUserId */
    managerUserId: number | undefined;
    /** 负责人 */
    managerName: string | undefined;
    rolesNumber: number;
    id: number;

    constructor(data?: ICompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.shortName = _data["shortName"];
            this.fullName = _data["fullName"];
            this.nature = _data["nature"];
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.fax = _data["fax"];
            this.postalcode = _data["postalcode"];
            this.email = _data["email"];
            this.provinceId = _data["provinceId"];
            this.cityId = _data["cityId"];
            this.countyId = _data["countyId"];
            this.address = _data["address"];
            this.webAddress = _data["webAddress"];
            this.foundedTime = _data["foundedTime"] ? moment(_data["foundedTime"].toString()) : <any>undefined;
            this.businessScope = _data["businessScope"];
            this.sortCode = _data["sortCode"];
            this.description = _data["description"];
            this.managerUserId = _data["managerUserId"];
            this.managerName = _data["managerName"];
            this.rolesNumber = _data["rolesNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["shortName"] = this.shortName;
        data["fullName"] = this.fullName;
        data["nature"] = this.nature;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["fax"] = this.fax;
        data["postalcode"] = this.postalcode;
        data["email"] = this.email;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["countyId"] = this.countyId;
        data["address"] = this.address;
        data["webAddress"] = this.webAddress;
        data["foundedTime"] = this.foundedTime ? this.foundedTime.toISOString() : <any>undefined;
        data["businessScope"] = this.businessScope;
        data["sortCode"] = this.sortCode;
        data["description"] = this.description;
        data["managerUserId"] = this.managerUserId;
        data["managerName"] = this.managerName;
        data["rolesNumber"] = this.rolesNumber;
        data["id"] = this.id;
        return data;
    }

    clone(): CompanyListDto {
        const json = this.toJSON();
        let result = new CompanyListDto();
        result.init(json);
        return result;
    }
}

/** 公司的列表DTO QYB.Organization.Company.Company */
export interface ICompanyListDto {
    /** Category */
    category: number | undefined;
    /** ParentId */
    parentId: number | undefined;
    /** EnCode */
    enCode: string | undefined;
    /** ShortName */
    shortName: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Nature */
    nature: string | undefined;
    /** OuterPhone */
    outerPhone: string | undefined;
    /** InnerPhone */
    innerPhone: string | undefined;
    /** Fax */
    fax: string | undefined;
    /** Postalcode */
    postalcode: string | undefined;
    /** Email */
    email: string | undefined;
    /** ProvinceId */
    provinceId: string | undefined;
    /** CityId */
    cityId: string | undefined;
    /** CountyId */
    countyId: string | undefined;
    /** Address */
    address: string | undefined;
    /** WebAddress */
    webAddress: string | undefined;
    /** FoundedTime */
    foundedTime: moment.Moment | undefined;
    /** BusinessScope */
    businessScope: string | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** Description */
    description: string | undefined;
    /** ManagerUserId */
    managerUserId: number | undefined;
    /** 负责人 */
    managerName: string | undefined;
    rolesNumber: number;
    id: number;
}

/** 读取可编辑公司的Dto */
export class GetCompanyForEditOutput implements IGetCompanyForEditOutput {
    company: CompanyEditDto;

    constructor(data?: IGetCompanyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyEditDto.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCompanyForEditOutput {
        const json = this.toJSON();
        let result = new GetCompanyForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑公司的Dto */
export interface IGetCompanyForEditOutput {
    company: CompanyEditDto;
}

export class PagedResultDtoOfCompanyListDto implements IPagedResultDtoOfCompanyListDto {
    totalCount: number;
    items: CompanyListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCompanyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCompanyListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCompanyListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCompanyListDto {
    totalCount: number;
    items: CompanyListDto[] | undefined;
}

export class CompanyTreeDto implements ICompanyTreeDto {
    /** 标题 */
    title: string | undefined;
    /** id */
    key: number;
    /** 父节点 */
    parentId: number;
    /** 子节点 */
    children: CompanyTreeDto[] | undefined;

    constructor(data?: ICompanyTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.key = _data["key"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(CompanyTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): CompanyTreeDto {
        const json = this.toJSON();
        let result = new CompanyTreeDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyTreeDto {
    /** 标题 */
    title: string | undefined;
    /** id */
    key: number;
    /** 父节点 */
    parentId: number;
    /** 子节点 */
    children: CompanyTreeDto[] | undefined;
}

/** 公司图片---用户设置的列表DTO QYB.QYBProduct.Organization.CompanyImages.CompanyImages */
export class CompanyImagesEditDto implements ICompanyImagesEditDto {
    /** Id */
    id: number | undefined;
    /** LoginLeft */
    loginLeft: string | undefined;
    /** SquareLogo */
    squareLogo: string | undefined;
    /** OblongLogo */
    oblongLogo: string | undefined;
    kanbanLogo: string | undefined;
    /** WebBackground */
    webBackground: string | undefined;
    /** AppBackground */
    appBackground: string | undefined;

    constructor(data?: ICompanyImagesEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.loginLeft = _data["loginLeft"];
            this.squareLogo = _data["squareLogo"];
            this.oblongLogo = _data["oblongLogo"];
            this.kanbanLogo = _data["kanbanLogo"];
            this.webBackground = _data["webBackground"];
            this.appBackground = _data["appBackground"];
        }
    }

    static fromJS(data: any): CompanyImagesEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyImagesEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["loginLeft"] = this.loginLeft;
        data["squareLogo"] = this.squareLogo;
        data["oblongLogo"] = this.oblongLogo;
        data["kanbanLogo"] = this.kanbanLogo;
        data["webBackground"] = this.webBackground;
        data["appBackground"] = this.appBackground;
        return data;
    }

    clone(): CompanyImagesEditDto {
        const json = this.toJSON();
        let result = new CompanyImagesEditDto();
        result.init(json);
        return result;
    }
}

/** 公司图片---用户设置的列表DTO QYB.QYBProduct.Organization.CompanyImages.CompanyImages */
export interface ICompanyImagesEditDto {
    /** Id */
    id: number | undefined;
    /** LoginLeft */
    loginLeft: string | undefined;
    /** SquareLogo */
    squareLogo: string | undefined;
    /** OblongLogo */
    oblongLogo: string | undefined;
    kanbanLogo: string | undefined;
    /** WebBackground */
    webBackground: string | undefined;
    /** AppBackground */
    appBackground: string | undefined;
}

export class CreateOrUpdateCompanyImagesInput implements ICreateOrUpdateCompanyImagesInput {
    companyImages: CompanyImagesEditDto;

    constructor(data?: ICreateOrUpdateCompanyImagesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.companyImages = new CompanyImagesEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyImages = _data["companyImages"] ? CompanyImagesEditDto.fromJS(_data["companyImages"]) : new CompanyImagesEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCompanyImagesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCompanyImagesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyImages"] = this.companyImages ? this.companyImages.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCompanyImagesInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCompanyImagesInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCompanyImagesInput {
    companyImages: CompanyImagesEditDto;
}

/** 公司图片---用户设置的列表DTO QYB.QYBProduct.Organization.CompanyImages.CompanyImages */
export class CompanyImagesListDto implements ICompanyImagesListDto {
    /** LoginLeft */
    loginLeft: string | undefined;
    /** SquareLogo */
    squareLogo: string | undefined;
    /** OblongLogo */
    oblongLogo: string | undefined;
    /** WebBackground */
    webBackground: string | undefined;
    /** AppBackground */
    appBackground: string | undefined;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** TenantId */
    tenantId: number;
    id: number;

    constructor(data?: ICompanyImagesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginLeft = _data["loginLeft"];
            this.squareLogo = _data["squareLogo"];
            this.oblongLogo = _data["oblongLogo"];
            this.webBackground = _data["webBackground"];
            this.appBackground = _data["appBackground"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompanyImagesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyImagesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginLeft"] = this.loginLeft;
        data["squareLogo"] = this.squareLogo;
        data["oblongLogo"] = this.oblongLogo;
        data["webBackground"] = this.webBackground;
        data["appBackground"] = this.appBackground;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }

    clone(): CompanyImagesListDto {
        const json = this.toJSON();
        let result = new CompanyImagesListDto();
        result.init(json);
        return result;
    }
}

/** 公司图片---用户设置的列表DTO QYB.QYBProduct.Organization.CompanyImages.CompanyImages */
export interface ICompanyImagesListDto {
    /** LoginLeft */
    loginLeft: string | undefined;
    /** SquareLogo */
    squareLogo: string | undefined;
    /** OblongLogo */
    oblongLogo: string | undefined;
    /** WebBackground */
    webBackground: string | undefined;
    /** AppBackground */
    appBackground: string | undefined;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** TenantId */
    tenantId: number;
    id: number;
}

/** 读取可编辑公司图片---用户设置的Dto */
export class GetCompanyImagesForEditOutput implements IGetCompanyImagesForEditOutput {
    companyImages: CompanyImagesEditDto;

    constructor(data?: IGetCompanyImagesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyImages = _data["companyImages"] ? CompanyImagesEditDto.fromJS(_data["companyImages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyImagesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyImagesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyImages"] = this.companyImages ? this.companyImages.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCompanyImagesForEditOutput {
        const json = this.toJSON();
        let result = new GetCompanyImagesForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑公司图片---用户设置的Dto */
export interface IGetCompanyImagesForEditOutput {
    companyImages: CompanyImagesEditDto;
}

export class PagedResultDtoOfCompanyImagesListDto implements IPagedResultDtoOfCompanyImagesListDto {
    totalCount: number;
    items: CompanyImagesListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCompanyImagesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyImagesListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCompanyImagesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCompanyImagesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCompanyImagesListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCompanyImagesListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCompanyImagesListDto {
    totalCount: number;
    items: CompanyImagesListDto[] | undefined;
}

/** 最近联系人 */
export class MyContactsDto implements IMyContactsDto {
    /** 对方Id */
    otherId: number;
    /** 对方名称 */
    otherName: string | undefined;
    /** 对方编号 */
    otherCode: string | undefined;
    /** 对方图片 */
    otherIcon: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** 最近一次联系时间 */
    lastContactTime: moment.Moment;
    /** 最后一次消息内容 */
    lastContent: string | undefined;
    /** 是否已读 */
    isRead: boolean;
    /** 未读数量 */
    unReadNum: number;
    /** 是否是系统消息0：不是，1：是 */
    isSystemMes: boolean;

    constructor(data?: IMyContactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otherId = _data["otherId"];
            this.otherName = _data["otherName"];
            this.otherCode = _data["otherCode"];
            this.otherIcon = _data["otherIcon"];
            this.size = _data["size"];
            this.lastContactTime = _data["lastContactTime"] ? moment(_data["lastContactTime"].toString()) : <any>undefined;
            this.lastContent = _data["lastContent"];
            this.isRead = _data["isRead"];
            this.unReadNum = _data["unReadNum"];
            this.isSystemMes = _data["isSystemMes"];
        }
    }

    static fromJS(data: any): MyContactsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyContactsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otherId"] = this.otherId;
        data["otherName"] = this.otherName;
        data["otherCode"] = this.otherCode;
        data["otherIcon"] = this.otherIcon;
        data["size"] = this.size;
        data["lastContactTime"] = this.lastContactTime ? this.lastContactTime.toISOString() : <any>undefined;
        data["lastContent"] = this.lastContent;
        data["isRead"] = this.isRead;
        data["unReadNum"] = this.unReadNum;
        data["isSystemMes"] = this.isSystemMes;
        return data;
    }

    clone(): MyContactsDto {
        const json = this.toJSON();
        let result = new MyContactsDto();
        result.init(json);
        return result;
    }
}

/** 最近联系人 */
export interface IMyContactsDto {
    /** 对方Id */
    otherId: number;
    /** 对方名称 */
    otherName: string | undefined;
    /** 对方编号 */
    otherCode: string | undefined;
    /** 对方图片 */
    otherIcon: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** 最近一次联系时间 */
    lastContactTime: moment.Moment;
    /** 最后一次消息内容 */
    lastContent: string | undefined;
    /** 是否已读 */
    isRead: boolean;
    /** 未读数量 */
    unReadNum: number;
    /** 是否是系统消息0：不是，1：是 */
    isSystemMes: boolean;
}

export class GetContractsManageListDto implements IGetContractsManageListDto {
    id: number;
    /** 姓名 */
    realName: string | undefined;
    /** 部门 */
    derpanment: string | undefined;
    /** 开始时间 */
    startTime: moment.Moment | undefined;
    /** 到期时间 */
    endTime: moment.Moment | undefined;
    /** 合同公司 */
    company: string | undefined;
    /** 合同类型Code */
    contractsTypeCode: string | undefined;
    /** 合同类型 */
    contractsType: string | undefined;
    isCompleted: number | undefined;
    /** 用户Id */
    userId: number;

    constructor(data?: IGetContractsManageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.realName = _data["realName"];
            this.derpanment = _data["derpanment"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.company = _data["company"];
            this.contractsTypeCode = _data["contractsTypeCode"];
            this.contractsType = _data["contractsType"];
            this.isCompleted = _data["isCompleted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetContractsManageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractsManageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["realName"] = this.realName;
        data["derpanment"] = this.derpanment;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["company"] = this.company;
        data["contractsTypeCode"] = this.contractsTypeCode;
        data["contractsType"] = this.contractsType;
        data["isCompleted"] = this.isCompleted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): GetContractsManageListDto {
        const json = this.toJSON();
        let result = new GetContractsManageListDto();
        result.init(json);
        return result;
    }
}

export interface IGetContractsManageListDto {
    id: number;
    /** 姓名 */
    realName: string | undefined;
    /** 部门 */
    derpanment: string | undefined;
    /** 开始时间 */
    startTime: moment.Moment | undefined;
    /** 到期时间 */
    endTime: moment.Moment | undefined;
    /** 合同公司 */
    company: string | undefined;
    /** 合同类型Code */
    contractsTypeCode: string | undefined;
    /** 合同类型 */
    contractsType: string | undefined;
    isCompleted: number | undefined;
    /** 用户Id */
    userId: number;
}

export class PagedResultDtoOfGetContractsManageListDto implements IPagedResultDtoOfGetContractsManageListDto {
    totalCount: number;
    items: GetContractsManageListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetContractsManageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetContractsManageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetContractsManageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetContractsManageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetContractsManageListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetContractsManageListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetContractsManageListDto {
    totalCount: number;
    items: GetContractsManageListDto[] | undefined;
}

export enum CourseTypeEnum {
    Ordinary = <any>"Ordinary",
    Updateing = <any>"Updateing",
    Finish = <any>"Finish",
}

export enum CourseVideoTypeEnum {
    RecordBroadcasting = <any>"RecordBroadcasting",
    LiveBroadcasting = <any>"LiveBroadcasting",
}

export enum CourseStateEnum {
    WaitPublish = <any>"WaitPublish",
    Closed = <any>"Closed",
    Publish = <any>"Publish",
}

/** 课程dto */
export class CourseDto implements ICourseDto {
    /** 课程标题 */
    title: string;
    /** 课程简介 */
    intro: string | undefined;
    /** 价格 */
    price: number;
    type: CourseTypeEnum;
    courseVideoType: CourseVideoTypeEnum;
    /** 课程图片 */
    imgUrl: string | undefined;
    /** 课程详情 */
    description: string | undefined;
    /** 课程编码 */
    courseCode: string | undefined;
    /** 购买后的qq群 */
    buyerQqGroup: string | undefined;
    /** 售前的qq群 */
    notBuyerQqGroup: string | undefined;
    /** 是否为推荐课程 */
    recommendCourse: boolean;
    /** 难度等级,0-5级 */
    gradeOfDifficulty: number;
    /** 出售数量 */
    orderCount: number;
    courseState: CourseStateEnum;
    /** 有效天数,0为永久有效 */
    validDays: number;
    /** 直播开始时间 */
    startTime: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.intro = _data["intro"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.courseVideoType = _data["courseVideoType"];
            this.imgUrl = _data["imgUrl"];
            this.description = _data["description"];
            this.courseCode = _data["courseCode"];
            this.buyerQqGroup = _data["buyerQqGroup"];
            this.notBuyerQqGroup = _data["notBuyerQqGroup"];
            this.recommendCourse = _data["recommendCourse"];
            this.gradeOfDifficulty = _data["gradeOfDifficulty"];
            this.orderCount = _data["orderCount"];
            this.courseState = _data["courseState"];
            this.validDays = _data["validDays"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["intro"] = this.intro;
        data["price"] = this.price;
        data["type"] = this.type;
        data["courseVideoType"] = this.courseVideoType;
        data["imgUrl"] = this.imgUrl;
        data["description"] = this.description;
        data["courseCode"] = this.courseCode;
        data["buyerQqGroup"] = this.buyerQqGroup;
        data["notBuyerQqGroup"] = this.notBuyerQqGroup;
        data["recommendCourse"] = this.recommendCourse;
        data["gradeOfDifficulty"] = this.gradeOfDifficulty;
        data["orderCount"] = this.orderCount;
        data["courseState"] = this.courseState;
        data["validDays"] = this.validDays;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CourseDto {
        const json = this.toJSON();
        let result = new CourseDto();
        result.init(json);
        return result;
    }
}

/** 课程dto */
export interface ICourseDto {
    /** 课程标题 */
    title: string;
    /** 课程简介 */
    intro: string | undefined;
    /** 价格 */
    price: number;
    type: CourseTypeEnum;
    courseVideoType: CourseVideoTypeEnum;
    /** 课程图片 */
    imgUrl: string | undefined;
    /** 课程详情 */
    description: string | undefined;
    /** 课程编码 */
    courseCode: string | undefined;
    /** 购买后的qq群 */
    buyerQqGroup: string | undefined;
    /** 售前的qq群 */
    notBuyerQqGroup: string | undefined;
    /** 是否为推荐课程 */
    recommendCourse: boolean;
    /** 难度等级,0-5级 */
    gradeOfDifficulty: number;
    /** 出售数量 */
    orderCount: number;
    courseState: CourseStateEnum;
    /** 有效天数,0为永久有效 */
    validDays: number;
    /** 直播开始时间 */
    startTime: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class KeyValuePairOfStringString implements IKeyValuePairOfStringString {
    key: string | undefined;
    value: string | undefined;

    constructor(data?: IKeyValuePairOfStringString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): KeyValuePairOfStringString {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringString();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringString {
    key: string | undefined;
    value: string | undefined;
}

/** 创建或更新课程的dto */
export class CreateOrUpdateCourseDto implements ICreateOrUpdateCourseDto {
    entity: CourseDto;
    /** 分类id集合 */
    categoryIds: number[] | undefined;
    /** 课程显示状态 */
    courseDisplayTypeEnum: KeyValuePairOfStringString[] | undefined;
    /** 课程类型 */
    courseVideoTypeEnum: KeyValuePairOfStringString[] | undefined;
    /** 课程状态 */
    courseStateEnum: KeyValuePairOfStringString[] | undefined;

    constructor(data?: ICreateOrUpdateCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new CourseDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? CourseDto.fromJS(_data["entity"]) : new CourseDto();
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds.push(item);
            }
            if (Array.isArray(_data["courseDisplayTypeEnum"])) {
                this.courseDisplayTypeEnum = [] as any;
                for (let item of _data["courseDisplayTypeEnum"])
                    this.courseDisplayTypeEnum.push(KeyValuePairOfStringString.fromJS(item));
            }
            if (Array.isArray(_data["courseVideoTypeEnum"])) {
                this.courseVideoTypeEnum = [] as any;
                for (let item of _data["courseVideoTypeEnum"])
                    this.courseVideoTypeEnum.push(KeyValuePairOfStringString.fromJS(item));
            }
            if (Array.isArray(_data["courseStateEnum"])) {
                this.courseStateEnum = [] as any;
                for (let item of _data["courseStateEnum"])
                    this.courseStateEnum.push(KeyValuePairOfStringString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.courseDisplayTypeEnum)) {
            data["courseDisplayTypeEnum"] = [];
            for (let item of this.courseDisplayTypeEnum)
                data["courseDisplayTypeEnum"].push(item.toJSON());
        }
        if (Array.isArray(this.courseVideoTypeEnum)) {
            data["courseVideoTypeEnum"] = [];
            for (let item of this.courseVideoTypeEnum)
                data["courseVideoTypeEnum"].push(item.toJSON());
        }
        if (Array.isArray(this.courseStateEnum)) {
            data["courseStateEnum"] = [];
            for (let item of this.courseStateEnum)
                data["courseStateEnum"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateCourseDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateCourseDto();
        result.init(json);
        return result;
    }
}

/** 创建或更新课程的dto */
export interface ICreateOrUpdateCourseDto {
    entity: CourseDto;
    /** 分类id集合 */
    categoryIds: number[] | undefined;
    /** 课程显示状态 */
    courseDisplayTypeEnum: KeyValuePairOfStringString[] | undefined;
    /** 课程类型 */
    courseVideoTypeEnum: KeyValuePairOfStringString[] | undefined;
    /** 课程状态 */
    courseStateEnum: KeyValuePairOfStringString[] | undefined;
}

/** 课程列表Dto */
export class CourseListDto implements ICourseListDto {
    /** 课程显示状态 字符串 */
    readonly typeString: string | undefined;
    /** 课程视频类型 字符串 */
    readonly courseVideoTypeString: string | undefined;
    /** 课程状态 字符串 */
    readonly courseStateString: string | undefined;
    /** 课程标题 */
    title: string;
    /** 课程简介 */
    intro: string | undefined;
    /** 价格 */
    price: number;
    type: CourseTypeEnum;
    courseVideoType: CourseVideoTypeEnum;
    /** 课程图片 */
    imgUrl: string | undefined;
    /** 课程详情 */
    description: string | undefined;
    /** 课程编码 */
    courseCode: string | undefined;
    /** 购买后的qq群 */
    buyerQqGroup: string | undefined;
    /** 售前的qq群 */
    notBuyerQqGroup: string | undefined;
    /** 是否为推荐课程 */
    recommendCourse: boolean;
    /** 难度等级,0-5级 */
    gradeOfDifficulty: number;
    /** 出售数量 */
    orderCount: number;
    courseState: CourseStateEnum;
    /** 有效天数,0为永久有效 */
    validDays: number;
    /** 直播开始时间 */
    startTime: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICourseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeString = _data["typeString"];
            (<any>this).courseVideoTypeString = _data["courseVideoTypeString"];
            (<any>this).courseStateString = _data["courseStateString"];
            this.title = _data["title"];
            this.intro = _data["intro"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.courseVideoType = _data["courseVideoType"];
            this.imgUrl = _data["imgUrl"];
            this.description = _data["description"];
            this.courseCode = _data["courseCode"];
            this.buyerQqGroup = _data["buyerQqGroup"];
            this.notBuyerQqGroup = _data["notBuyerQqGroup"];
            this.recommendCourse = _data["recommendCourse"];
            this.gradeOfDifficulty = _data["gradeOfDifficulty"];
            this.orderCount = _data["orderCount"];
            this.courseState = _data["courseState"];
            this.validDays = _data["validDays"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeString"] = this.typeString;
        data["courseVideoTypeString"] = this.courseVideoTypeString;
        data["courseStateString"] = this.courseStateString;
        data["title"] = this.title;
        data["intro"] = this.intro;
        data["price"] = this.price;
        data["type"] = this.type;
        data["courseVideoType"] = this.courseVideoType;
        data["imgUrl"] = this.imgUrl;
        data["description"] = this.description;
        data["courseCode"] = this.courseCode;
        data["buyerQqGroup"] = this.buyerQqGroup;
        data["notBuyerQqGroup"] = this.notBuyerQqGroup;
        data["recommendCourse"] = this.recommendCourse;
        data["gradeOfDifficulty"] = this.gradeOfDifficulty;
        data["orderCount"] = this.orderCount;
        data["courseState"] = this.courseState;
        data["validDays"] = this.validDays;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CourseListDto {
        const json = this.toJSON();
        let result = new CourseListDto();
        result.init(json);
        return result;
    }
}

/** 课程列表Dto */
export interface ICourseListDto {
    /** 课程显示状态 字符串 */
    typeString: string | undefined;
    /** 课程视频类型 字符串 */
    courseVideoTypeString: string | undefined;
    /** 课程状态 字符串 */
    courseStateString: string | undefined;
    /** 课程标题 */
    title: string;
    /** 课程简介 */
    intro: string | undefined;
    /** 价格 */
    price: number;
    type: CourseTypeEnum;
    courseVideoType: CourseVideoTypeEnum;
    /** 课程图片 */
    imgUrl: string | undefined;
    /** 课程详情 */
    description: string | undefined;
    /** 课程编码 */
    courseCode: string | undefined;
    /** 购买后的qq群 */
    buyerQqGroup: string | undefined;
    /** 售前的qq群 */
    notBuyerQqGroup: string | undefined;
    /** 是否为推荐课程 */
    recommendCourse: boolean;
    /** 难度等级,0-5级 */
    gradeOfDifficulty: number;
    /** 出售数量 */
    orderCount: number;
    courseState: CourseStateEnum;
    /** 有效天数,0为永久有效 */
    validDays: number;
    /** 直播开始时间 */
    startTime: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

/** 课程数量统计 */
export class CourseStatisticsDto implements ICourseStatisticsDto {
    /** 课程总数 */
    totalCount: number;
    /** 未发布课程数 */
    waitPublishCount: number;
    /** 已发布课程数 */
    publishCount: number;
    /** 已官币课程数 */
    closedCount: number;

    constructor(data?: ICourseStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.waitPublishCount = _data["waitPublishCount"];
            this.publishCount = _data["publishCount"];
            this.closedCount = _data["closedCount"];
        }
    }

    static fromJS(data: any): CourseStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["waitPublishCount"] = this.waitPublishCount;
        data["publishCount"] = this.publishCount;
        data["closedCount"] = this.closedCount;
        return data;
    }

    clone(): CourseStatisticsDto {
        const json = this.toJSON();
        let result = new CourseStatisticsDto();
        result.init(json);
        return result;
    }
}

/** 课程数量统计 */
export interface ICourseStatisticsDto {
    /** 课程总数 */
    totalCount: number;
    /** 未发布课程数 */
    waitPublishCount: number;
    /** 已发布课程数 */
    publishCount: number;
    /** 已官币课程数 */
    closedCount: number;
}

export enum QueryOperator {
    Equal = <any>"Equal",
    NotEqual = <any>"NotEqual",
    Greater = <any>"Greater",
    GreaterEqual = <any>"GreaterEqual",
    Less = <any>"Less",
    LessEqual = <any>"LessEqual",
    StartsWith = <any>"StartsWith",
    EndsWith = <any>"EndsWith",
    In = <any>"In",
    NotIn = <any>"NotIn",
    Contains = <any>"Contains",
    Between = <any>"Between",
    BetweenEqualStart = <any>"BetweenEqualStart",
    BetweenEqualEnd = <any>"BetweenEqualEnd",
    BetweenEqualStartAndEnd = <any>"BetweenEqualStartAndEnd",
}

export class QueryCondition implements IQueryCondition {
    field: string | undefined;
    value: string | undefined;
    operator: QueryOperator;
    skipValueIsNull: boolean;

    constructor(data?: IQueryCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.value = _data["value"];
            this.operator = _data["operator"];
            this.skipValueIsNull = _data["skipValueIsNull"];
        }
    }

    static fromJS(data: any): QueryCondition {
        data = typeof data === 'object' ? data : {};
        let result = new QueryCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["value"] = this.value;
        data["operator"] = this.operator;
        data["skipValueIsNull"] = this.skipValueIsNull;
        return data;
    }

    clone(): QueryCondition {
        const json = this.toJSON();
        let result = new QueryCondition();
        result.init(json);
        return result;
    }
}

export interface IQueryCondition {
    field: string | undefined;
    value: string | undefined;
    operator: QueryOperator;
    skipValueIsNull: boolean;
}

export enum SortType {
    None = <any>"None",
    Asc = <any>"Asc",
    Desc = <any>"Desc",
}

export class SortCondition implements ISortCondition {
    field: string | undefined;
    order: number;
    type: SortType;

    constructor(data?: ISortCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.order = _data["order"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SortCondition {
        data = typeof data === 'object' ? data : {};
        let result = new SortCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["order"] = this.order;
        data["type"] = this.type;
        return data;
    }

    clone(): SortCondition {
        const json = this.toJSON();
        let result = new SortCondition();
        result.init(json);
        return result;
    }
}

export interface ISortCondition {
    field: string | undefined;
    order: number;
    type: SortType;
}

export class CourseQueryInput implements ICourseQueryInput {
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
    queryConditions: QueryCondition[] | undefined;
    sortConditions: SortCondition[] | undefined;

    constructor(data?: ICourseQueryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["queryConditions"])) {
                this.queryConditions = [] as any;
                for (let item of _data["queryConditions"])
                    this.queryConditions.push(QueryCondition.fromJS(item));
            }
            if (Array.isArray(_data["sortConditions"])) {
                this.sortConditions = [] as any;
                for (let item of _data["sortConditions"])
                    this.sortConditions.push(SortCondition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CourseQueryInput {
        data = typeof data === 'object' ? data : {};
        let result = new CourseQueryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.queryConditions)) {
            data["queryConditions"] = [];
            for (let item of this.queryConditions)
                data["queryConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.sortConditions)) {
            data["sortConditions"] = [];
            for (let item of this.sortConditions)
                data["sortConditions"].push(item.toJSON());
        }
        return data;
    }

    clone(): CourseQueryInput {
        const json = this.toJSON();
        let result = new CourseQueryInput();
        result.init(json);
        return result;
    }
}

export interface ICourseQueryInput {
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
    queryConditions: QueryCondition[] | undefined;
    sortConditions: SortCondition[] | undefined;
}

export class PagedResultDtoOfCourseListDto implements IPagedResultDtoOfCourseListDto {
    totalCount: number;
    items: CourseListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCourseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CourseListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCourseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCourseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCourseListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCourseListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCourseListDto {
    totalCount: number;
    items: CourseListDto[] | undefined;
}

export class QueryCourseStatisticsDto implements IQueryCourseStatisticsDto {
    /** 课程标题 */
    title: string | undefined;
    courseVideoType: CourseVideoTypeEnum;
    /** 课程视频类型-直播、录播 */
    readonly courseVideoTypeName: string | undefined;
    courseState: CourseStateEnum;
    /** 课程状态 */
    readonly courseStateName: string | undefined;
    /** 课程时长 */
    totalTime: number;
    /** 学员数 */
    studentCount: number;
    /** 收入 */
    totalMoney: number;
    id: number;

    constructor(data?: IQueryCourseStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.courseVideoType = _data["courseVideoType"];
            (<any>this).courseVideoTypeName = _data["courseVideoTypeName"];
            this.courseState = _data["courseState"];
            (<any>this).courseStateName = _data["courseStateName"];
            this.totalTime = _data["totalTime"];
            this.studentCount = _data["studentCount"];
            this.totalMoney = _data["totalMoney"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QueryCourseStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryCourseStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["courseVideoType"] = this.courseVideoType;
        data["courseVideoTypeName"] = this.courseVideoTypeName;
        data["courseState"] = this.courseState;
        data["courseStateName"] = this.courseStateName;
        data["totalTime"] = this.totalTime;
        data["studentCount"] = this.studentCount;
        data["totalMoney"] = this.totalMoney;
        data["id"] = this.id;
        return data;
    }

    clone(): QueryCourseStatisticsDto {
        const json = this.toJSON();
        let result = new QueryCourseStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQueryCourseStatisticsDto {
    /** 课程标题 */
    title: string | undefined;
    courseVideoType: CourseVideoTypeEnum;
    /** 课程视频类型-直播、录播 */
    courseVideoTypeName: string | undefined;
    courseState: CourseStateEnum;
    /** 课程状态 */
    courseStateName: string | undefined;
    /** 课程时长 */
    totalTime: number;
    /** 学员数 */
    studentCount: number;
    /** 收入 */
    totalMoney: number;
    id: number;
}

export class PagedResultDtoOfQueryCourseStatisticsDto implements IPagedResultDtoOfQueryCourseStatisticsDto {
    totalCount: number;
    items: QueryCourseStatisticsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQueryCourseStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QueryCourseStatisticsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQueryCourseStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfQueryCourseStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfQueryCourseStatisticsDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfQueryCourseStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfQueryCourseStatisticsDto {
    totalCount: number;
    items: QueryCourseStatisticsDto[] | undefined;
}

/** 章节数量和课时数量统计dto */
export class CourseSectionAndClassHourStatisticalDto implements ICourseSectionAndClassHourStatisticalDto {
    /** 章节总数 */
    courseSectionCount: number;
    /** 课程总数 */
    courseClassHourCount: number;

    constructor(data?: ICourseSectionAndClassHourStatisticalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseSectionCount = _data["courseSectionCount"];
            this.courseClassHourCount = _data["courseClassHourCount"];
        }
    }

    static fromJS(data: any): CourseSectionAndClassHourStatisticalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSectionAndClassHourStatisticalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseSectionCount"] = this.courseSectionCount;
        data["courseClassHourCount"] = this.courseClassHourCount;
        return data;
    }

    clone(): CourseSectionAndClassHourStatisticalDto {
        const json = this.toJSON();
        let result = new CourseSectionAndClassHourStatisticalDto();
        result.init(json);
        return result;
    }
}

/** 章节数量和课时数量统计dto */
export interface ICourseSectionAndClassHourStatisticalDto {
    /** 章节总数 */
    courseSectionCount: number;
    /** 课程总数 */
    courseClassHourCount: number;
}

export class AddCourseToCategoryInput implements IAddCourseToCategoryInput {
    courseIds: number[] | undefined;
    courseCategoryId: number;

    constructor(data?: IAddCourseToCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds.push(item);
            }
            this.courseCategoryId = _data["courseCategoryId"];
        }
    }

    static fromJS(data: any): AddCourseToCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddCourseToCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        data["courseCategoryId"] = this.courseCategoryId;
        return data;
    }

    clone(): AddCourseToCategoryInput {
        const json = this.toJSON();
        let result = new AddCourseToCategoryInput();
        result.init(json);
        return result;
    }
}

export interface IAddCourseToCategoryInput {
    courseIds: number[] | undefined;
    courseCategoryId: number;
}

/** 课程分类的列表DTO QYB.Modules.Mooc.CourseCategoryInfo.CourseCategory */
export class CourseCategoryEditDto implements ICourseCategoryEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 图片路径 */
    imgUrl: string | undefined;
    /** 父类Id */
    parentId: number | undefined;

    constructor(data?: ICourseCategoryEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imgUrl = _data["imgUrl"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): CourseCategoryEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCategoryEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imgUrl"] = this.imgUrl;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): CourseCategoryEditDto {
        const json = this.toJSON();
        let result = new CourseCategoryEditDto();
        result.init(json);
        return result;
    }
}

/** 课程分类的列表DTO QYB.Modules.Mooc.CourseCategoryInfo.CourseCategory */
export interface ICourseCategoryEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 图片路径 */
    imgUrl: string | undefined;
    /** 父类Id */
    parentId: number | undefined;
}

export class CreateOrUpdateCourseCategoryInput implements ICreateOrUpdateCourseCategoryInput {
    courseCategory: CourseCategoryEditDto;

    constructor(data?: ICreateOrUpdateCourseCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.courseCategory = new CourseCategoryEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseCategory = _data["courseCategory"] ? CourseCategoryEditDto.fromJS(_data["courseCategory"]) : new CourseCategoryEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateCourseCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCourseCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseCategory"] = this.courseCategory ? this.courseCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCourseCategoryInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCourseCategoryInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCourseCategoryInput {
    courseCategory: CourseCategoryEditDto;
}

export class FindCoursesInput implements IFindCoursesInput {
    /** 课程分类的Id */
    categoryId: number;
    filterText: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IFindCoursesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.filterText = _data["filterText"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): FindCoursesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindCoursesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["filterText"] = this.filterText;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }

    clone(): FindCoursesInput {
        const json = this.toJSON();
        let result = new FindCoursesInput();
        result.init(json);
        return result;
    }
}

export interface IFindCoursesInput {
    /** 课程分类的Id */
    categoryId: number;
    filterText: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

/** 课程分类的列表DTO QYB.Modules.Mooc.CourseCategoryInfo.CourseCategory */
export class CourseCategoryListDto implements ICourseCategoryListDto {
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 图片路径 */
    imgUrl: string | undefined;
    /** 父类Id */
    parentId: number | undefined;
    /** 课程总数量 */
    courseCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICourseCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.imgUrl = _data["imgUrl"];
            this.parentId = _data["parentId"];
            this.courseCount = _data["courseCount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["imgUrl"] = this.imgUrl;
        data["parentId"] = this.parentId;
        data["courseCount"] = this.courseCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CourseCategoryListDto {
        const json = this.toJSON();
        let result = new CourseCategoryListDto();
        result.init(json);
        return result;
    }
}

/** 课程分类的列表DTO QYB.Modules.Mooc.CourseCategoryInfo.CourseCategory */
export interface ICourseCategoryListDto {
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 图片路径 */
    imgUrl: string | undefined;
    /** 父类Id */
    parentId: number | undefined;
    /** 课程总数量 */
    courseCount: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ListResultDtoOfCourseCategoryListDto implements IListResultDtoOfCourseCategoryListDto {
    items: CourseCategoryListDto[] | undefined;

    constructor(data?: IListResultDtoOfCourseCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CourseCategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCourseCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCourseCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfCourseCategoryListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCourseCategoryListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCourseCategoryListDto {
    items: CourseCategoryListDto[] | undefined;
}

/** 读取可编辑课程分类的Dto */
export class GetCourseCategoryForEditOutput implements IGetCourseCategoryForEditOutput {
    courseCategory: CourseCategoryEditDto;

    constructor(data?: IGetCourseCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseCategory = _data["courseCategory"] ? CourseCategoryEditDto.fromJS(_data["courseCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCourseCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourseCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseCategory"] = this.courseCategory ? this.courseCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCourseCategoryForEditOutput {
        const json = this.toJSON();
        let result = new GetCourseCategoryForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑课程分类的Dto */
export interface IGetCourseCategoryForEditOutput {
    courseCategory: CourseCategoryEditDto;
}

export class PagedResultDtoOfCourseCategoryListDto implements IPagedResultDtoOfCourseCategoryListDto {
    totalCount: number;
    items: CourseCategoryListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCourseCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CourseCategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCourseCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCourseCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfCourseCategoryListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCourseCategoryListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCourseCategoryListDto {
    totalCount: number;
    items: CourseCategoryListDto[] | undefined;
}

/** 服务树形列表的公共Dto */
export class TreeMemberListDto implements ITreeMemberListDto {
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;

    constructor(data?: ITreeMemberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? moment(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TreeMemberListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeMemberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): TreeMemberListDto {
        const json = this.toJSON();
        let result = new TreeMemberListDto();
        result.init(json);
        return result;
    }
}

/** 服务树形列表的公共Dto */
export interface ITreeMemberListDto {
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfTreeMemberListDto implements IPagedResultDtoOfTreeMemberListDto {
    totalCount: number;
    items: TreeMemberListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTreeMemberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TreeMemberListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTreeMemberListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTreeMemberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTreeMemberListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTreeMemberListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTreeMemberListDto {
    totalCount: number;
    items: TreeMemberListDto[] | undefined;
}

/** 移动课程分类的dto */
export class MoveCourseCategoryInput implements IMoveCourseCategoryInput {
    id: number;
    newParentId: number | undefined;

    constructor(data?: IMoveCourseCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveCourseCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveCourseCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }

    clone(): MoveCourseCategoryInput {
        const json = this.toJSON();
        let result = new MoveCourseCategoryInput();
        result.init(json);
        return result;
    }
}

/** 移动课程分类的dto */
export interface IMoveCourseCategoryInput {
    id: number;
    newParentId: number | undefined;
}

export enum CourseClassHourResourcTypeEnum {
    Video = <any>"Video",
}

/** 课时Dto */
export class CourseClassHourDto implements ICourseClassHourDto {
    /** 课时名称 */
    name: string | undefined;
    /** 课时简介 */
    intro: string | undefined;
    /** 序号 */
    sortNumber: number;
    /** 所属课程id */
    courseId: number;
    /** 所属章节id */
    courseSectionId: number;
    /** 资源分类id */
    resourceCategoryId: number;
    /** 资源id */
    resourceId: number;
    /** 资源显示名称 */
    resourceDisplayName: string | undefined;
    resourceType: CourseClassHourResourcTypeEnum;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICourseClassHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.intro = _data["intro"];
            this.sortNumber = _data["sortNumber"];
            this.courseId = _data["courseId"];
            this.courseSectionId = _data["courseSectionId"];
            this.resourceCategoryId = _data["resourceCategoryId"];
            this.resourceId = _data["resourceId"];
            this.resourceDisplayName = _data["resourceDisplayName"];
            this.resourceType = _data["resourceType"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseClassHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseClassHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["intro"] = this.intro;
        data["sortNumber"] = this.sortNumber;
        data["courseId"] = this.courseId;
        data["courseSectionId"] = this.courseSectionId;
        data["resourceCategoryId"] = this.resourceCategoryId;
        data["resourceId"] = this.resourceId;
        data["resourceDisplayName"] = this.resourceDisplayName;
        data["resourceType"] = this.resourceType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CourseClassHourDto {
        const json = this.toJSON();
        let result = new CourseClassHourDto();
        result.init(json);
        return result;
    }
}

/** 课时Dto */
export interface ICourseClassHourDto {
    /** 课时名称 */
    name: string | undefined;
    /** 课时简介 */
    intro: string | undefined;
    /** 序号 */
    sortNumber: number;
    /** 所属课程id */
    courseId: number;
    /** 所属章节id */
    courseSectionId: number;
    /** 资源分类id */
    resourceCategoryId: number;
    /** 资源id */
    resourceId: number;
    /** 资源显示名称 */
    resourceDisplayName: string | undefined;
    resourceType: CourseClassHourResourcTypeEnum;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCourseClassHourDto implements IListResultDtoOfCourseClassHourDto {
    items: CourseClassHourDto[] | undefined;

    constructor(data?: IListResultDtoOfCourseClassHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CourseClassHourDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCourseClassHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCourseClassHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfCourseClassHourDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCourseClassHourDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCourseClassHourDto {
    items: CourseClassHourDto[] | undefined;
}

/** 章节dto */
export class CourseSectionDto implements ICourseSectionDto {
    /** 章节名称 */
    name: string | undefined;
    /** 章节介绍 */
    intro: string | undefined;
    /** 章节索引 */
    index: number;
    /** 课程id */
    coursesId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ICourseSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.intro = _data["intro"];
            this.index = _data["index"];
            this.coursesId = _data["coursesId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["intro"] = this.intro;
        data["index"] = this.index;
        data["coursesId"] = this.coursesId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CourseSectionDto {
        const json = this.toJSON();
        let result = new CourseSectionDto();
        result.init(json);
        return result;
    }
}

/** 章节dto */
export interface ICourseSectionDto {
    /** 章节名称 */
    name: string | undefined;
    /** 章节介绍 */
    intro: string | undefined;
    /** 章节索引 */
    index: number;
    /** 课程id */
    coursesId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCourseSectionDto implements IListResultDtoOfCourseSectionDto {
    items: CourseSectionDto[] | undefined;

    constructor(data?: IListResultDtoOfCourseSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CourseSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCourseSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCourseSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfCourseSectionDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCourseSectionDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCourseSectionDto {
    items: CourseSectionDto[] | undefined;
}

/** 仪表盘入参 */
export class DashboardInput implements IDashboardInput {
    /** 开始日期 */
    startTime: moment.Moment;
    /** 结束日期 */
    endTime: moment.Moment;
    /** 组织架构ID */
    orgId: number | undefined;

    constructor(data?: IDashboardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): DashboardInput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["orgId"] = this.orgId;
        return data;
    }

    clone(): DashboardInput {
        const json = this.toJSON();
        let result = new DashboardInput();
        result.init(json);
        return result;
    }
}

/** 仪表盘入参 */
export interface IDashboardInput {
    /** 开始日期 */
    startTime: moment.Moment;
    /** 结束日期 */
    endTime: moment.Moment;
    /** 组织架构ID */
    orgId: number | undefined;
}

/** 审核区域问题TOP10 */
export class AuditPointIssueTOPTenDto implements IAuditPointIssueTOPTenDto {
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核点问题数量 */
    auditPointIssueCount: number;

    constructor(data?: IAuditPointIssueTOPTenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditPointIssueCount = _data["auditPointIssueCount"];
        }
    }

    static fromJS(data: any): AuditPointIssueTOPTenDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditPointIssueTOPTenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditPointIssueCount"] = this.auditPointIssueCount;
        return data;
    }

    clone(): AuditPointIssueTOPTenDto {
        const json = this.toJSON();
        let result = new AuditPointIssueTOPTenDto();
        result.init(json);
        return result;
    }
}

/** 审核区域问题TOP10 */
export interface IAuditPointIssueTOPTenDto {
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核点问题数量 */
    auditPointIssueCount: number;
}

/** 按照问题分类汇总问题Dto */
export class GetIssueForIssueTypeDto implements IGetIssueForIssueTypeDto {
    /** 问题分类Id */
    issueTypeId: number;
    /** 问题分类名称 */
    name: string | undefined;
    /** 未关闭问题数 */
    notCloseIssueCount: number;
    /** 总问题数 */
    issueTotalCount: number;

    constructor(data?: IGetIssueForIssueTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueTypeId = _data["issueTypeId"];
            this.name = _data["name"];
            this.notCloseIssueCount = _data["notCloseIssueCount"];
            this.issueTotalCount = _data["issueTotalCount"];
        }
    }

    static fromJS(data: any): GetIssueForIssueTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueForIssueTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueTypeId"] = this.issueTypeId;
        data["name"] = this.name;
        data["notCloseIssueCount"] = this.notCloseIssueCount;
        data["issueTotalCount"] = this.issueTotalCount;
        return data;
    }

    clone(): GetIssueForIssueTypeDto {
        const json = this.toJSON();
        let result = new GetIssueForIssueTypeDto();
        result.init(json);
        return result;
    }
}

/** 按照问题分类汇总问题Dto */
export interface IGetIssueForIssueTypeDto {
    /** 问题分类Id */
    issueTypeId: number;
    /** 问题分类名称 */
    name: string | undefined;
    /** 未关闭问题数 */
    notCloseIssueCount: number;
    /** 总问题数 */
    issueTotalCount: number;
}

/** 问题数量和计划数量相关 */
export class IssueAndAuditTaskRelevantDto implements IIssueAndAuditTaskRelevantDto {
    /** 未关闭问题数 */
    notCloseIssueCount: number;
    /** 总问题数 */
    issueTotalCount: number;
    /** 超时问题数 */
    overtimeIssueCount: number;
    /** 最多问题区域数量 */
    mostAuditPointIssueCount: number;
    /** 最多问题区域名称 */
    mostAuditPointIssueName: string | undefined;
    /** 最多问题区域Id */
    mostAuditPointIssueId: number;
    /** 审核计划完成率 */
    auditTaskCompletionRate: number;
    /** 计划总数 */
    auditTaskTotalCount: number;

    constructor(data?: IIssueAndAuditTaskRelevantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notCloseIssueCount = _data["notCloseIssueCount"];
            this.issueTotalCount = _data["issueTotalCount"];
            this.overtimeIssueCount = _data["overtimeIssueCount"];
            this.mostAuditPointIssueCount = _data["mostAuditPointIssueCount"];
            this.mostAuditPointIssueName = _data["mostAuditPointIssueName"];
            this.mostAuditPointIssueId = _data["mostAuditPointIssueId"];
            this.auditTaskCompletionRate = _data["auditTaskCompletionRate"];
            this.auditTaskTotalCount = _data["auditTaskTotalCount"];
        }
    }

    static fromJS(data: any): IssueAndAuditTaskRelevantDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueAndAuditTaskRelevantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notCloseIssueCount"] = this.notCloseIssueCount;
        data["issueTotalCount"] = this.issueTotalCount;
        data["overtimeIssueCount"] = this.overtimeIssueCount;
        data["mostAuditPointIssueCount"] = this.mostAuditPointIssueCount;
        data["mostAuditPointIssueName"] = this.mostAuditPointIssueName;
        data["mostAuditPointIssueId"] = this.mostAuditPointIssueId;
        data["auditTaskCompletionRate"] = this.auditTaskCompletionRate;
        data["auditTaskTotalCount"] = this.auditTaskTotalCount;
        return data;
    }

    clone(): IssueAndAuditTaskRelevantDto {
        const json = this.toJSON();
        let result = new IssueAndAuditTaskRelevantDto();
        result.init(json);
        return result;
    }
}

/** 问题数量和计划数量相关 */
export interface IIssueAndAuditTaskRelevantDto {
    /** 未关闭问题数 */
    notCloseIssueCount: number;
    /** 总问题数 */
    issueTotalCount: number;
    /** 超时问题数 */
    overtimeIssueCount: number;
    /** 最多问题区域数量 */
    mostAuditPointIssueCount: number;
    /** 最多问题区域名称 */
    mostAuditPointIssueName: string | undefined;
    /** 最多问题区域Id */
    mostAuditPointIssueId: number;
    /** 审核计划完成率 */
    auditTaskCompletionRate: number;
    /** 计划总数 */
    auditTaskTotalCount: number;
}

/** 权限条件表的列表DTO QYB.QYBProduct.SystemModule.DataCondition.DataCondition */
export class DataConditionEditDto implements IDataConditionEditDto {
    /** Id */
    id: number | undefined;
    /** 接口权限Id */
    dataRelationId: number;
    /** 接口字段Id */
    interfaceFieId: number;
    /** 比较符1.等于2.包含3.包含于4.不等于5.不包含6.不包含于 */
    symbol: number;
    /** 字段值类型1.文本2.登录者ID3.登录者账号4.登录者公司5.登录者部门6.登录者岗位 */
    filedValueType: number;
    /** 字段值 */
    filedValue: string | undefined;
    /** 排序码 */
    sort: number;

    constructor(data?: IDataConditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataRelationId = _data["dataRelationId"];
            this.interfaceFieId = _data["interfaceFieId"];
            this.symbol = _data["symbol"];
            this.filedValueType = _data["filedValueType"];
            this.filedValue = _data["filedValue"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): DataConditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataConditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataRelationId"] = this.dataRelationId;
        data["interfaceFieId"] = this.interfaceFieId;
        data["symbol"] = this.symbol;
        data["filedValueType"] = this.filedValueType;
        data["filedValue"] = this.filedValue;
        data["sort"] = this.sort;
        return data;
    }

    clone(): DataConditionEditDto {
        const json = this.toJSON();
        let result = new DataConditionEditDto();
        result.init(json);
        return result;
    }
}

/** 权限条件表的列表DTO QYB.QYBProduct.SystemModule.DataCondition.DataCondition */
export interface IDataConditionEditDto {
    /** Id */
    id: number | undefined;
    /** 接口权限Id */
    dataRelationId: number;
    /** 接口字段Id */
    interfaceFieId: number;
    /** 比较符1.等于2.包含3.包含于4.不等于5.不包含6.不包含于 */
    symbol: number;
    /** 字段值类型1.文本2.登录者ID3.登录者账号4.登录者公司5.登录者部门6.登录者岗位 */
    filedValueType: number;
    /** 字段值 */
    filedValue: string | undefined;
    /** 排序码 */
    sort: number;
}

export class CreateOrUpdateDataConditionInput implements ICreateOrUpdateDataConditionInput {
    dataCondition: DataConditionEditDto;

    constructor(data?: ICreateOrUpdateDataConditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataCondition = new DataConditionEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataCondition = _data["dataCondition"] ? DataConditionEditDto.fromJS(_data["dataCondition"]) : new DataConditionEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateDataConditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDataConditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataCondition"] = this.dataCondition ? this.dataCondition.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateDataConditionInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDataConditionInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDataConditionInput {
    dataCondition: DataConditionEditDto;
}

/** 权限条件表的列表DTO QYB.QYBProduct.SystemModule.DataCondition.DataCondition */
export class DataConditionListDto implements IDataConditionListDto {
    /** 接口权限Id */
    dataRelationId: number;
    /** 接口字段Id */
    interfaceFieId: number;
    /** 比较符1.等于2.包含3.包含于4.不等于5.不包含6.不包含于 */
    symbol: number;
    /** 字段值类型1.文本2.登录者ID3.登录者账号4.登录者公司5.登录者部门6.登录者岗位 */
    filedValueType: number;
    /** 字段值 */
    filedValue: string | undefined;
    /** 排序码 */
    sort: number;
    id: number;

    constructor(data?: IDataConditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataRelationId = _data["dataRelationId"];
            this.interfaceFieId = _data["interfaceFieId"];
            this.symbol = _data["symbol"];
            this.filedValueType = _data["filedValueType"];
            this.filedValue = _data["filedValue"];
            this.sort = _data["sort"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DataConditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataConditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataRelationId"] = this.dataRelationId;
        data["interfaceFieId"] = this.interfaceFieId;
        data["symbol"] = this.symbol;
        data["filedValueType"] = this.filedValueType;
        data["filedValue"] = this.filedValue;
        data["sort"] = this.sort;
        data["id"] = this.id;
        return data;
    }

    clone(): DataConditionListDto {
        const json = this.toJSON();
        let result = new DataConditionListDto();
        result.init(json);
        return result;
    }
}

/** 权限条件表的列表DTO QYB.QYBProduct.SystemModule.DataCondition.DataCondition */
export interface IDataConditionListDto {
    /** 接口权限Id */
    dataRelationId: number;
    /** 接口字段Id */
    interfaceFieId: number;
    /** 比较符1.等于2.包含3.包含于4.不等于5.不包含6.不包含于 */
    symbol: number;
    /** 字段值类型1.文本2.登录者ID3.登录者账号4.登录者公司5.登录者部门6.登录者岗位 */
    filedValueType: number;
    /** 字段值 */
    filedValue: string | undefined;
    /** 排序码 */
    sort: number;
    id: number;
}

export class DataConditionDto implements IDataConditionDto {
    key: number;
    value: string | undefined;

    constructor(data?: IDataConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): DataConditionDto {
        const json = this.toJSON();
        let result = new DataConditionDto();
        result.init(json);
        return result;
    }
}

export interface IDataConditionDto {
    key: number;
    value: string | undefined;
}

/** 读取可编辑权限条件表的Dto */
export class GetDataConditionForEditOutput implements IGetDataConditionForEditOutput {
    dataCondition: DataConditionEditDto;

    constructor(data?: IGetDataConditionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataCondition = _data["dataCondition"] ? DataConditionEditDto.fromJS(_data["dataCondition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataConditionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataConditionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataCondition"] = this.dataCondition ? this.dataCondition.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetDataConditionForEditOutput {
        const json = this.toJSON();
        let result = new GetDataConditionForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑权限条件表的Dto */
export interface IGetDataConditionForEditOutput {
    dataCondition: DataConditionEditDto;
}

export class PagedResultDtoOfDataConditionListDto implements IPagedResultDtoOfDataConditionListDto {
    totalCount: number;
    items: DataConditionListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDataConditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DataConditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDataConditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDataConditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfDataConditionListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDataConditionListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDataConditionListDto {
    totalCount: number;
    items: DataConditionListDto[] | undefined;
}

/** 字典的列表DTO QYB.CommonBll.DataItem.DataItem */
export class DataItemEditDto implements IDataItemEditDto {
    /** Id */
    id: number | undefined;
    /** 父级ID */
    parentId: number;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典名称 */
    itemName: string | undefined;
    /** 排序 */
    sortCode: number;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;

    constructor(data?: IDataItemEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.itemCode = _data["itemCode"];
            this.itemName = _data["itemName"];
            this.sortCode = _data["sortCode"];
            this.isSyetem = _data["isSyetem"];
        }
    }

    static fromJS(data: any): DataItemEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["sortCode"] = this.sortCode;
        data["isSyetem"] = this.isSyetem;
        return data;
    }

    clone(): DataItemEditDto {
        const json = this.toJSON();
        let result = new DataItemEditDto();
        result.init(json);
        return result;
    }
}

/** 字典的列表DTO QYB.CommonBll.DataItem.DataItem */
export interface IDataItemEditDto {
    /** Id */
    id: number | undefined;
    /** 父级ID */
    parentId: number;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典名称 */
    itemName: string | undefined;
    /** 排序 */
    sortCode: number;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;
}

export class CreateOrUpdateDataItemInput implements ICreateOrUpdateDataItemInput {
    dataItem: DataItemEditDto;

    constructor(data?: ICreateOrUpdateDataItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataItem = new DataItemEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataItem = _data["dataItem"] ? DataItemEditDto.fromJS(_data["dataItem"]) : new DataItemEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateDataItemInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDataItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataItem"] = this.dataItem ? this.dataItem.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateDataItemInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDataItemInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDataItemInput {
    dataItem: DataItemEditDto;
}

/** 字典的列表DTO QYB.CommonBll.DataItem.DataItem */
export class DataItemListDto implements IDataItemListDto {
    /** 父级ID */
    parentId: number;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典名称 */
    itemName: string | undefined;
    /** 排序 */
    sortCode: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;

    constructor(data?: IDataItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.itemCode = _data["itemCode"];
            this.itemName = _data["itemName"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isSyetem = _data["isSyetem"];
        }
    }

    static fromJS(data: any): DataItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isSyetem"] = this.isSyetem;
        return data;
    }

    clone(): DataItemListDto {
        const json = this.toJSON();
        let result = new DataItemListDto();
        result.init(json);
        return result;
    }
}

/** 字典的列表DTO QYB.CommonBll.DataItem.DataItem */
export interface IDataItemListDto {
    /** 父级ID */
    parentId: number;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典名称 */
    itemName: string | undefined;
    /** 排序 */
    sortCode: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;
}

export class DataItemTreeDto implements IDataItemTreeDto {
    /** 标题 */
    title: string | undefined;
    /** id */
    key: number;
    /** 父节点 */
    parentId: number;
    /** 子节点 */
    children: DataItemTreeDto[] | undefined;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;

    constructor(data?: IDataItemTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.key = _data["key"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(DataItemTreeDto.fromJS(item));
            }
            this.isSyetem = _data["isSyetem"];
        }
    }

    static fromJS(data: any): DataItemTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["isSyetem"] = this.isSyetem;
        return data;
    }

    clone(): DataItemTreeDto {
        const json = this.toJSON();
        let result = new DataItemTreeDto();
        result.init(json);
        return result;
    }
}

export interface IDataItemTreeDto {
    /** 标题 */
    title: string | undefined;
    /** id */
    key: number;
    /** 父节点 */
    parentId: number;
    /** 子节点 */
    children: DataItemTreeDto[] | undefined;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;
}

/** 读取可编辑字典的Dto */
export class GetDataItemForEditOutput implements IGetDataItemForEditOutput {
    dataItem: DataItemEditDto;

    constructor(data?: IGetDataItemForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataItem = _data["dataItem"] ? DataItemEditDto.fromJS(_data["dataItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataItemForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataItemForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataItem"] = this.dataItem ? this.dataItem.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetDataItemForEditOutput {
        const json = this.toJSON();
        let result = new GetDataItemForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑字典的Dto */
export interface IGetDataItemForEditOutput {
    dataItem: DataItemEditDto;
}

export class PagedResultDtoOfDataItemListDto implements IPagedResultDtoOfDataItemListDto {
    totalCount: number;
    items: DataItemListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDataItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DataItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDataItemListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDataItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfDataItemListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDataItemListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDataItemListDto {
    totalCount: number;
    items: DataItemListDto[] | undefined;
}

/** 字典明细的列表DTO QYB.CommonBll.DataItemDetail.DataItemDetail */
export class DataItemDetailEditDto implements IDataItemDetailEditDto {
    /** Id */
    id: number | undefined;
    /** 字典外键 */
    dataItemId: number;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典明细编码 */
    itemDetailCode: string | undefined;
    /** 字典明细名称 */
    itemDetailName: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;

    constructor(data?: IDataItemDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataItemId = _data["dataItemId"];
            this.itemCode = _data["itemCode"];
            this.itemDetailCode = _data["itemDetailCode"];
            this.itemDetailName = _data["itemDetailName"];
            this.sortCode = _data["sortCode"];
            this.isSyetem = _data["isSyetem"];
        }
    }

    static fromJS(data: any): DataItemDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataItemId"] = this.dataItemId;
        data["itemCode"] = this.itemCode;
        data["itemDetailCode"] = this.itemDetailCode;
        data["itemDetailName"] = this.itemDetailName;
        data["sortCode"] = this.sortCode;
        data["isSyetem"] = this.isSyetem;
        return data;
    }

    clone(): DataItemDetailEditDto {
        const json = this.toJSON();
        let result = new DataItemDetailEditDto();
        result.init(json);
        return result;
    }
}

/** 字典明细的列表DTO QYB.CommonBll.DataItemDetail.DataItemDetail */
export interface IDataItemDetailEditDto {
    /** Id */
    id: number | undefined;
    /** 字典外键 */
    dataItemId: number;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典明细编码 */
    itemDetailCode: string | undefined;
    /** 字典明细名称 */
    itemDetailName: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;
}

export class CreateOrUpdateDataItemDetailInput implements ICreateOrUpdateDataItemDetailInput {
    dataItemDetail: DataItemDetailEditDto;

    constructor(data?: ICreateOrUpdateDataItemDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataItemDetail = new DataItemDetailEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataItemDetail = _data["dataItemDetail"] ? DataItemDetailEditDto.fromJS(_data["dataItemDetail"]) : new DataItemDetailEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateDataItemDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDataItemDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataItemDetail"] = this.dataItemDetail ? this.dataItemDetail.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateDataItemDetailInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDataItemDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDataItemDetailInput {
    dataItemDetail: DataItemDetailEditDto;
}

export class AdministrativeRegion implements IAdministrativeRegion {
    code: number;
    name: string | undefined;
    id: number;

    constructor(data?: IAdministrativeRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdministrativeRegion {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrativeRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): AdministrativeRegion {
        const json = this.toJSON();
        let result = new AdministrativeRegion();
        result.init(json);
        return result;
    }
}

export interface IAdministrativeRegion {
    code: number;
    name: string | undefined;
    id: number;
}

/** 字典明细的列表DTO QYB.CommonBll.DataItemDetail.DataItemDetail */
export class DataItemDetailListDto implements IDataItemDetailListDto {
    id: number | undefined;
    /** 字典外键 */
    dataItemId: number;
    dataItem: DataItem;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典明细编码 */
    itemDetailCode: string | undefined;
    /** 字典明细名称 */
    itemDetailName: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;

    constructor(data?: IDataItemDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataItemId = _data["dataItemId"];
            this.dataItem = _data["dataItem"] ? DataItem.fromJS(_data["dataItem"]) : <any>undefined;
            this.itemCode = _data["itemCode"];
            this.itemDetailCode = _data["itemDetailCode"];
            this.itemDetailName = _data["itemDetailName"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isSyetem = _data["isSyetem"];
        }
    }

    static fromJS(data: any): DataItemDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataItemId"] = this.dataItemId;
        data["dataItem"] = this.dataItem ? this.dataItem.toJSON() : <any>undefined;
        data["itemCode"] = this.itemCode;
        data["itemDetailCode"] = this.itemDetailCode;
        data["itemDetailName"] = this.itemDetailName;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isSyetem"] = this.isSyetem;
        return data;
    }

    clone(): DataItemDetailListDto {
        const json = this.toJSON();
        let result = new DataItemDetailListDto();
        result.init(json);
        return result;
    }
}

/** 字典明细的列表DTO QYB.CommonBll.DataItemDetail.DataItemDetail */
export interface IDataItemDetailListDto {
    id: number | undefined;
    /** 字典外键 */
    dataItemId: number;
    dataItem: DataItem;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典明细编码 */
    itemDetailCode: string | undefined;
    /** 字典明细名称 */
    itemDetailName: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** 是否系统默认 */
    isSyetem: boolean | undefined;
}

/** 读取可编辑字典明细的Dto */
export class GetDataItemDetailForEditOutput implements IGetDataItemDetailForEditOutput {
    dataItemDetail: DataItemDetailEditDto;

    constructor(data?: IGetDataItemDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataItemDetail = _data["dataItemDetail"] ? DataItemDetailEditDto.fromJS(_data["dataItemDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataItemDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataItemDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataItemDetail"] = this.dataItemDetail ? this.dataItemDetail.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetDataItemDetailForEditOutput {
        const json = this.toJSON();
        let result = new GetDataItemDetailForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑字典明细的Dto */
export interface IGetDataItemDetailForEditOutput {
    dataItemDetail: DataItemDetailEditDto;
}

export class GetDataItemDetailListDto implements IGetDataItemDetailListDto {
    id: string | undefined;
    /** 字典外键 */
    dataItemId: number;
    dataItem: DataItem;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典明细编码 */
    itemDetailCode: string | undefined;
    /** 字典明细名称 */
    itemDetailName: string | undefined;
    /** 排序 */
    sortCode: number | undefined;

    constructor(data?: IGetDataItemDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataItemId = _data["dataItemId"];
            this.dataItem = _data["dataItem"] ? DataItem.fromJS(_data["dataItem"]) : <any>undefined;
            this.itemCode = _data["itemCode"];
            this.itemDetailCode = _data["itemDetailCode"];
            this.itemDetailName = _data["itemDetailName"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): GetDataItemDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataItemDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataItemId"] = this.dataItemId;
        data["dataItem"] = this.dataItem ? this.dataItem.toJSON() : <any>undefined;
        data["itemCode"] = this.itemCode;
        data["itemDetailCode"] = this.itemDetailCode;
        data["itemDetailName"] = this.itemDetailName;
        data["sortCode"] = this.sortCode;
        return data;
    }

    clone(): GetDataItemDetailListDto {
        const json = this.toJSON();
        let result = new GetDataItemDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IGetDataItemDetailListDto {
    id: string | undefined;
    /** 字典外键 */
    dataItemId: number;
    dataItem: DataItem;
    /** 字典编码 */
    itemCode: string | undefined;
    /** 字典明细编码 */
    itemDetailCode: string | undefined;
    /** 字典明细名称 */
    itemDetailName: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
}

export class PagedResultDtoOfDataItemDetailListDto implements IPagedResultDtoOfDataItemDetailListDto {
    totalCount: number;
    items: DataItemDetailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDataItemDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DataItemDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDataItemDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDataItemDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfDataItemDetailListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDataItemDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDataItemDetailListDto {
    totalCount: number;
    items: DataItemDetailListDto[] | undefined;
}

/** 接口权限的列表DTO QYB.QYBProduct.SystemModule.DataRelation.DataRelation */
export class DataRelationEditDto implements IDataRelationEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 接口Id */
    interfaceId: number;
    /** 对象主键 */
    objectId: number;
    /** 类型，1、角色2、用户 */
    objectType: number;
    /** 条件公式 */
    formula: string | undefined;

    constructor(data?: IDataRelationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.interfaceId = _data["interfaceId"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.formula = _data["formula"];
        }
    }

    static fromJS(data: any): DataRelationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataRelationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["interfaceId"] = this.interfaceId;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["formula"] = this.formula;
        return data;
    }

    clone(): DataRelationEditDto {
        const json = this.toJSON();
        let result = new DataRelationEditDto();
        result.init(json);
        return result;
    }
}

/** 接口权限的列表DTO QYB.QYBProduct.SystemModule.DataRelation.DataRelation */
export interface IDataRelationEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 接口Id */
    interfaceId: number;
    /** 对象主键 */
    objectId: number;
    /** 类型，1、角色2、用户 */
    objectType: number;
    /** 条件公式 */
    formula: string | undefined;
}

export class CreateOrUpdateDataRelationInput implements ICreateOrUpdateDataRelationInput {
    dataRelation: DataRelationEditDto;
    /** 权限条件表 */
    dataConditionList: DataConditionEditDto[] | undefined;

    constructor(data?: ICreateOrUpdateDataRelationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataRelation = new DataRelationEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataRelation = _data["dataRelation"] ? DataRelationEditDto.fromJS(_data["dataRelation"]) : new DataRelationEditDto();
            if (Array.isArray(_data["dataConditionList"])) {
                this.dataConditionList = [] as any;
                for (let item of _data["dataConditionList"])
                    this.dataConditionList.push(DataConditionEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateDataRelationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDataRelationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataRelation"] = this.dataRelation ? this.dataRelation.toJSON() : <any>undefined;
        if (Array.isArray(this.dataConditionList)) {
            data["dataConditionList"] = [];
            for (let item of this.dataConditionList)
                data["dataConditionList"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateDataRelationInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDataRelationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDataRelationInput {
    dataRelation: DataRelationEditDto;
    /** 权限条件表 */
    dataConditionList: DataConditionEditDto[] | undefined;
}

/** 接口权限的列表DTO QYB.QYBProduct.SystemModule.DataRelation.DataRelation */
export class DataRelationListDto implements IDataRelationListDto {
    /** 名称 */
    name: string | undefined;
    /** 接口Id */
    interfaceId: number;
    /** 对象主键 */
    objectId: number;
    /** 类型，1、角色2、用户 */
    objectType: number;
    /** 条件公式 */
    formula: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 创建用户 */
    creatorUserName: string | undefined;
    id: number;

    constructor(data?: IDataRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.interfaceId = _data["interfaceId"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.formula = _data["formula"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DataRelationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["interfaceId"] = this.interfaceId;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["formula"] = this.formula;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["id"] = this.id;
        return data;
    }

    clone(): DataRelationListDto {
        const json = this.toJSON();
        let result = new DataRelationListDto();
        result.init(json);
        return result;
    }
}

/** 接口权限的列表DTO QYB.QYBProduct.SystemModule.DataRelation.DataRelation */
export interface IDataRelationListDto {
    /** 名称 */
    name: string | undefined;
    /** 接口Id */
    interfaceId: number;
    /** 对象主键 */
    objectId: number;
    /** 类型，1、角色2、用户 */
    objectType: number;
    /** 条件公式 */
    formula: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 创建用户 */
    creatorUserName: string | undefined;
    id: number;
}

/** 读取可编辑接口权限的Dto */
export class GetDataRelationForEditOutput implements IGetDataRelationForEditOutput {
    dataRelation: DataRelationEditDto;
    /** 权限条件表 */
    dataConditionList: DataConditionEditDto[] | undefined;

    constructor(data?: IGetDataRelationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataRelation = _data["dataRelation"] ? DataRelationEditDto.fromJS(_data["dataRelation"]) : <any>undefined;
            if (Array.isArray(_data["dataConditionList"])) {
                this.dataConditionList = [] as any;
                for (let item of _data["dataConditionList"])
                    this.dataConditionList.push(DataConditionEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataRelationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataRelationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataRelation"] = this.dataRelation ? this.dataRelation.toJSON() : <any>undefined;
        if (Array.isArray(this.dataConditionList)) {
            data["dataConditionList"] = [];
            for (let item of this.dataConditionList)
                data["dataConditionList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDataRelationForEditOutput {
        const json = this.toJSON();
        let result = new GetDataRelationForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑接口权限的Dto */
export interface IGetDataRelationForEditOutput {
    dataRelation: DataRelationEditDto;
    /** 权限条件表 */
    dataConditionList: DataConditionEditDto[] | undefined;
}

export class InterfaceAuthorizeDetailListDto implements IInterfaceAuthorizeDetailListDto {
    id: number;
    /** 接口Id */
    interfaceId: number | undefined;
    /** 接口名字 */
    interfaceName: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 对象主键 */
    objectId: number;
    /** 类型，1、角色2、用户 */
    objectType: number;
    objectName: string | undefined;
    /** 条件公式 */
    formula: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 创建用户 */
    creatorUserName: string | undefined;

    constructor(data?: IInterfaceAuthorizeDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interfaceId = _data["interfaceId"];
            this.interfaceName = _data["interfaceName"];
            this.name = _data["name"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.objectName = _data["objectName"];
            this.formula = _data["formula"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
        }
    }

    static fromJS(data: any): InterfaceAuthorizeDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceAuthorizeDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interfaceId"] = this.interfaceId;
        data["interfaceName"] = this.interfaceName;
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["objectName"] = this.objectName;
        data["formula"] = this.formula;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        return data;
    }

    clone(): InterfaceAuthorizeDetailListDto {
        const json = this.toJSON();
        let result = new InterfaceAuthorizeDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IInterfaceAuthorizeDetailListDto {
    id: number;
    /** 接口Id */
    interfaceId: number | undefined;
    /** 接口名字 */
    interfaceName: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 对象主键 */
    objectId: number;
    /** 类型，1、角色2、用户 */
    objectType: number;
    objectName: string | undefined;
    /** 条件公式 */
    formula: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 创建用户 */
    creatorUserName: string | undefined;
}

export class PagedResultDtoOfInterfaceAuthorizeDetailListDto implements IPagedResultDtoOfInterfaceAuthorizeDetailListDto {
    totalCount: number;
    items: InterfaceAuthorizeDetailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInterfaceAuthorizeDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InterfaceAuthorizeDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInterfaceAuthorizeDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInterfaceAuthorizeDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfInterfaceAuthorizeDetailListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfInterfaceAuthorizeDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfInterfaceAuthorizeDetailListDto {
    totalCount: number;
    items: InterfaceAuthorizeDetailListDto[] | undefined;
}

export class PagedResultDtoOfDataRelationListDto implements IPagedResultDtoOfDataRelationListDto {
    totalCount: number;
    items: DataRelationListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDataRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DataRelationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDataRelationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDataRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfDataRelationListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDataRelationListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDataRelationListDto {
    totalCount: number;
    items: DataRelationListDto[] | undefined;
}

export class AbpOrganizationunitsExtendEditDto implements IAbpOrganizationunitsExtendEditDto {
    /** Id */
    id: number | undefined;
    /** 公司ID */
    companyId: number;
    /** 父级 */
    parentId: number | undefined;
    /** 部门代码 */
    code: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 部门简称 */
    shortName: string | undefined;
    /** 部门类型ID */
    natureCode: string | undefined;
    /** 负责人ID */
    managerId: number | undefined;
    managerName: string | undefined;
    /** 外线电话 */
    outerPhone: string | undefined;
    /** 内线电话 */
    innerPhone: string | undefined;
    /** 电子邮箱 */
    email: string | undefined;
    /** 部门传真 */
    fax: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 备注 */
    description: string | undefined;

    constructor(data?: IAbpOrganizationunitsExtendEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.shortName = _data["shortName"];
            this.natureCode = _data["natureCode"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.sortCode = _data["sortCode"];
            this.isVirtual = _data["isVirtual"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AbpOrganizationunitsExtendEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpOrganizationunitsExtendEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["shortName"] = this.shortName;
        data["natureCode"] = this.natureCode;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["sortCode"] = this.sortCode;
        data["isVirtual"] = this.isVirtual;
        data["description"] = this.description;
        return data;
    }

    clone(): AbpOrganizationunitsExtendEditDto {
        const json = this.toJSON();
        let result = new AbpOrganizationunitsExtendEditDto();
        result.init(json);
        return result;
    }
}

export interface IAbpOrganizationunitsExtendEditDto {
    /** Id */
    id: number | undefined;
    /** 公司ID */
    companyId: number;
    /** 父级 */
    parentId: number | undefined;
    /** 部门代码 */
    code: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 部门简称 */
    shortName: string | undefined;
    /** 部门类型ID */
    natureCode: string | undefined;
    /** 负责人ID */
    managerId: number | undefined;
    managerName: string | undefined;
    /** 外线电话 */
    outerPhone: string | undefined;
    /** 内线电话 */
    innerPhone: string | undefined;
    /** 电子邮箱 */
    email: string | undefined;
    /** 部门传真 */
    fax: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 备注 */
    description: string | undefined;
}

export class CreateOrUpdateDepartmentInput implements ICreateOrUpdateDepartmentInput {
    department: AbpOrganizationunitsExtendEditDto;

    constructor(data?: ICreateOrUpdateDepartmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.department = new AbpOrganizationunitsExtendEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"] ? AbpOrganizationunitsExtendEditDto.fromJS(_data["department"]) : new AbpOrganizationunitsExtendEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateDepartmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateDepartmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateDepartmentInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateDepartmentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateDepartmentInput {
    department: AbpOrganizationunitsExtendEditDto;
}

export class Company implements ICompany {
    category: number | undefined;
    parentId: number;
    enCode: string | undefined;
    shortName: string | undefined;
    fullName: string | undefined;
    nature: string | undefined;
    outerPhone: string | undefined;
    innerPhone: string | undefined;
    fax: string | undefined;
    postalcode: string | undefined;
    email: string | undefined;
    managerUserId: number | undefined;
    provinceId: string | undefined;
    cityId: string | undefined;
    countyId: string | undefined;
    address: string | undefined;
    webAddress: string | undefined;
    foundedTime: moment.Moment | undefined;
    businessScope: string | undefined;
    sortCode: number | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.shortName = _data["shortName"];
            this.fullName = _data["fullName"];
            this.nature = _data["nature"];
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.fax = _data["fax"];
            this.postalcode = _data["postalcode"];
            this.email = _data["email"];
            this.managerUserId = _data["managerUserId"];
            this.provinceId = _data["provinceId"];
            this.cityId = _data["cityId"];
            this.countyId = _data["countyId"];
            this.address = _data["address"];
            this.webAddress = _data["webAddress"];
            this.foundedTime = _data["foundedTime"] ? moment(_data["foundedTime"].toString()) : <any>undefined;
            this.businessScope = _data["businessScope"];
            this.sortCode = _data["sortCode"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["shortName"] = this.shortName;
        data["fullName"] = this.fullName;
        data["nature"] = this.nature;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["fax"] = this.fax;
        data["postalcode"] = this.postalcode;
        data["email"] = this.email;
        data["managerUserId"] = this.managerUserId;
        data["provinceId"] = this.provinceId;
        data["cityId"] = this.cityId;
        data["countyId"] = this.countyId;
        data["address"] = this.address;
        data["webAddress"] = this.webAddress;
        data["foundedTime"] = this.foundedTime ? this.foundedTime.toISOString() : <any>undefined;
        data["businessScope"] = this.businessScope;
        data["sortCode"] = this.sortCode;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    category: number | undefined;
    parentId: number;
    enCode: string | undefined;
    shortName: string | undefined;
    fullName: string | undefined;
    nature: string | undefined;
    outerPhone: string | undefined;
    innerPhone: string | undefined;
    fax: string | undefined;
    postalcode: string | undefined;
    email: string | undefined;
    managerUserId: number | undefined;
    provinceId: string | undefined;
    cityId: string | undefined;
    countyId: string | undefined;
    address: string | undefined;
    webAddress: string | undefined;
    foundedTime: moment.Moment | undefined;
    businessScope: string | undefined;
    sortCode: number | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

/** 部门的列表DTO QYB.QYBProduct.Department.Department */
export class DepartmentListDto implements IDepartmentListDto {
    id: number | undefined;
    /** 公司ID */
    companyId: number;
    company: Company;
    /** 父级 */
    parentId: number;
    /** 部门代码 */
    enCode: string | undefined;
    /** 部门名称 */
    fullName: string | undefined;
    /** 部门简称 */
    shortName: string | undefined;
    /** 部门类型ID */
    natureID: string | undefined;
    natureName: string | undefined;
    /** 负责人ID */
    managerId: number | undefined;
    manager: User;
    /** 外线电话 */
    outerPhone: string | undefined;
    /** 内线电话 */
    innerPhone: string | undefined;
    /** 电子邮箱 */
    email: string | undefined;
    /** 部门传真 */
    fax: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 备注 */
    description: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;

    constructor(data?: IDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.shortName = _data["shortName"];
            this.natureID = _data["natureID"];
            this.natureName = _data["natureName"];
            this.managerId = _data["managerId"];
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>undefined;
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.sortCode = _data["sortCode"];
            this.isVirtual = _data["isVirtual"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): DepartmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["shortName"] = this.shortName;
        data["natureID"] = this.natureID;
        data["natureName"] = this.natureName;
        data["managerId"] = this.managerId;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["sortCode"] = this.sortCode;
        data["isVirtual"] = this.isVirtual;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): DepartmentListDto {
        const json = this.toJSON();
        let result = new DepartmentListDto();
        result.init(json);
        return result;
    }
}

/** 部门的列表DTO QYB.QYBProduct.Department.Department */
export interface IDepartmentListDto {
    id: number | undefined;
    /** 公司ID */
    companyId: number;
    company: Company;
    /** 父级 */
    parentId: number;
    /** 部门代码 */
    enCode: string | undefined;
    /** 部门名称 */
    fullName: string | undefined;
    /** 部门简称 */
    shortName: string | undefined;
    /** 部门类型ID */
    natureID: string | undefined;
    natureName: string | undefined;
    /** 负责人ID */
    managerId: number | undefined;
    manager: User;
    /** 外线电话 */
    outerPhone: string | undefined;
    /** 内线电话 */
    innerPhone: string | undefined;
    /** 电子邮箱 */
    email: string | undefined;
    /** 部门传真 */
    fax: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 备注 */
    description: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
}

export class AbpOrganizationunitsExtendListDto implements IAbpOrganizationunitsExtendListDto {
    id: number | undefined;
    /** 公司ID */
    companyId: number;
    /** 部门 */
    departmentId: number | undefined;
    /** 父级 */
    parentId: number | undefined;
    /** 部门代码 */
    code: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 部门简称 */
    shortName: string | undefined;
    /** 部门类型ID */
    natureCode: string | undefined;
    natureName: string | undefined;
    /** 负责人ID */
    managerId: number | undefined;
    manangerName: string | undefined;
    /** 外线电话 */
    outerPhone: string | undefined;
    /** 内线电话 */
    innerPhone: string | undefined;
    /** 电子邮箱 */
    email: string | undefined;
    /** 部门传真 */
    fax: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 备注 */
    description: string | undefined;
    userCount: number;

    constructor(data?: IAbpOrganizationunitsExtendListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.shortName = _data["shortName"];
            this.natureCode = _data["natureCode"];
            this.natureName = _data["natureName"];
            this.managerId = _data["managerId"];
            this.manangerName = _data["manangerName"];
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.sortCode = _data["sortCode"];
            this.isVirtual = _data["isVirtual"];
            this.description = _data["description"];
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): AbpOrganizationunitsExtendListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpOrganizationunitsExtendListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["shortName"] = this.shortName;
        data["natureCode"] = this.natureCode;
        data["natureName"] = this.natureName;
        data["managerId"] = this.managerId;
        data["manangerName"] = this.manangerName;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["sortCode"] = this.sortCode;
        data["isVirtual"] = this.isVirtual;
        data["description"] = this.description;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): AbpOrganizationunitsExtendListDto {
        const json = this.toJSON();
        let result = new AbpOrganizationunitsExtendListDto();
        result.init(json);
        return result;
    }
}

export interface IAbpOrganizationunitsExtendListDto {
    id: number | undefined;
    /** 公司ID */
    companyId: number;
    /** 部门 */
    departmentId: number | undefined;
    /** 父级 */
    parentId: number | undefined;
    /** 部门代码 */
    code: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 部门简称 */
    shortName: string | undefined;
    /** 部门类型ID */
    natureCode: string | undefined;
    natureName: string | undefined;
    /** 负责人ID */
    managerId: number | undefined;
    manangerName: string | undefined;
    /** 外线电话 */
    outerPhone: string | undefined;
    /** 内线电话 */
    innerPhone: string | undefined;
    /** 电子邮箱 */
    email: string | undefined;
    /** 部门传真 */
    fax: string | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 备注 */
    description: string | undefined;
    userCount: number;
}

export class DepartmentTreeDto implements IDepartmentTreeDto {
    /** 标题 */
    title: string | undefined;
    /** 父节点 */
    parentId: number | undefined;
    /** Id */
    key: number;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    sortCode: number;
    /** 子节点 */
    children: DepartmentTreeDto[] | undefined;

    constructor(data?: IDepartmentTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.parentId = _data["parentId"];
            this.key = _data["key"];
            this.isVirtual = _data["isVirtual"];
            this.sortCode = _data["sortCode"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(DepartmentTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["key"] = this.key;
        data["isVirtual"] = this.isVirtual;
        data["sortCode"] = this.sortCode;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): DepartmentTreeDto {
        const json = this.toJSON();
        let result = new DepartmentTreeDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentTreeDto {
    /** 标题 */
    title: string | undefined;
    /** 父节点 */
    parentId: number | undefined;
    /** Id */
    key: number;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    sortCode: number;
    /** 子节点 */
    children: DepartmentTreeDto[] | undefined;
}

/** 读取可编辑部门的Dto */
export class GetDepartmentForEditOutput implements IGetDepartmentForEditOutput {
    department: AbpOrganizationunitsExtendEditDto;

    constructor(data?: IGetDepartmentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"] ? AbpOrganizationunitsExtendEditDto.fromJS(_data["department"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDepartmentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetDepartmentForEditOutput {
        const json = this.toJSON();
        let result = new GetDepartmentForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑部门的Dto */
export interface IGetDepartmentForEditOutput {
    department: AbpOrganizationunitsExtendEditDto;
}

export class PagedResultDtoOfAbpOrganizationunitsExtendListDto implements IPagedResultDtoOfAbpOrganizationunitsExtendListDto {
    totalCount: number;
    items: AbpOrganizationunitsExtendListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAbpOrganizationunitsExtendListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AbpOrganizationunitsExtendListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAbpOrganizationunitsExtendListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAbpOrganizationunitsExtendListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAbpOrganizationunitsExtendListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAbpOrganizationunitsExtendListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAbpOrganizationunitsExtendListDto {
    totalCount: number;
    items: AbpOrganizationunitsExtendListDto[] | undefined;
}

export class DocumentContributorDto implements IDocumentContributorDto {
    username: string | undefined;
    userProfileUrl: string | undefined;
    avatarUrl: string | undefined;

    constructor(data?: IDocumentContributorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.userProfileUrl = _data["userProfileUrl"];
            this.avatarUrl = _data["avatarUrl"];
        }
    }

    static fromJS(data: any): DocumentContributorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentContributorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["userProfileUrl"] = this.userProfileUrl;
        data["avatarUrl"] = this.avatarUrl;
        return data;
    }

    clone(): DocumentContributorDto {
        const json = this.toJSON();
        let result = new DocumentContributorDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentContributorDto {
    username: string | undefined;
    userProfileUrl: string | undefined;
    avatarUrl: string | undefined;
}

export class DocumentWithDetailsDto implements IDocumentWithDetailsDto {
    title: string | undefined;
    content: string | undefined;
    format: string | undefined;
    editLink: string | undefined;
    rootUrl: string | undefined;
    rawRootUrl: string | undefined;
    version: string | undefined;
    localDirectory: string | undefined;
    fileName: string | undefined;
    contributors: DocumentContributorDto[] | undefined;
    successfullyRetrieved: boolean;

    constructor(data?: IDocumentWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.format = _data["format"];
            this.editLink = _data["editLink"];
            this.rootUrl = _data["rootUrl"];
            this.rawRootUrl = _data["rawRootUrl"];
            this.version = _data["version"];
            this.localDirectory = _data["localDirectory"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors.push(DocumentContributorDto.fromJS(item));
            }
            this.successfullyRetrieved = _data["successfullyRetrieved"];
        }
    }

    static fromJS(data: any): DocumentWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["format"] = this.format;
        data["editLink"] = this.editLink;
        data["rootUrl"] = this.rootUrl;
        data["rawRootUrl"] = this.rawRootUrl;
        data["version"] = this.version;
        data["localDirectory"] = this.localDirectory;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item.toJSON());
        }
        data["successfullyRetrieved"] = this.successfullyRetrieved;
        return data;
    }

    clone(): DocumentWithDetailsDto {
        const json = this.toJSON();
        let result = new DocumentWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentWithDetailsDto {
    title: string | undefined;
    content: string | undefined;
    format: string | undefined;
    editLink: string | undefined;
    rootUrl: string | undefined;
    rawRootUrl: string | undefined;
    version: string | undefined;
    localDirectory: string | undefined;
    fileName: string | undefined;
    contributors: DocumentContributorDto[] | undefined;
    successfullyRetrieved: boolean;
}

export class DownloadLogListDto implements IDownloadLogListDto {
    /** 版本号 */
    version: string | undefined;
    /** 类型 */
    type: string | undefined;
    /** 用户Id */
    userId: number;
    /** 项目名称 */
    projectName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 用户名 */
    userName: string | undefined;
    id: number;

    constructor(data?: IDownloadLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.projectName = _data["projectName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.userName = _data["userName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DownloadLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["projectName"] = this.projectName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data;
    }

    clone(): DownloadLogListDto {
        const json = this.toJSON();
        let result = new DownloadLogListDto();
        result.init(json);
        return result;
    }
}

export interface IDownloadLogListDto {
    /** 版本号 */
    version: string | undefined;
    /** 类型 */
    type: string | undefined;
    /** 用户Id */
    userId: number;
    /** 项目名称 */
    projectName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 用户名 */
    userName: string | undefined;
    id: number;
}

export class PagedResultDtoOfDownloadLogListDto implements IPagedResultDtoOfDownloadLogListDto {
    totalCount: number;
    items: DownloadLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDownloadLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DownloadLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDownloadLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDownloadLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfDownloadLogListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDownloadLogListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDownloadLogListDto {
    totalCount: number;
    items: DownloadLogListDto[] | undefined;
}

/** 列分析配置 */
export enum ColumnItemStatistical {
    None = <any>"None",
    Count = <any>"Count",
    DistinctCount = <any>"DistinctCount",
    Sum = <any>"Sum",
    Average = <any>"Average",
    Max = <any>"Max",
    Min = <any>"Min",
}

/** 列固定枚举 */
export enum ColumnItemFixed {
    None = <any>"None",
    Left = <any>"Left",
    Right = <any>"Right",
}

/** 列表控件 */
export enum ColumnControl {
    Button = <any>"Button",
    Select = <any>"Select",
}

/** 操作项 */
export class ColumnActionItemDto implements IColumnActionItemDto {
    /** 操作名称 */
    name: string | undefined;
    /** 显示名称 */
    label: string | undefined;
    /** 图标 */
    icon: string | undefined;
    type: ColumnControl;
    /** 权限 */
    acl: string | undefined;
    /** 子级操作按钮 当 QYB.DynamicPage.Dtos.ColumnActionItemDto.Type 值为 QYB.DynamicPage.Dtos.ColumnControl.Select 时使用 */
    buttons: ColumnActionItemDto[] | undefined;

    constructor(data?: IColumnActionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.icon = _data["icon"];
            this.type = _data["type"];
            this.acl = _data["acl"];
            if (Array.isArray(_data["buttons"])) {
                this.buttons = [] as any;
                for (let item of _data["buttons"])
                    this.buttons.push(ColumnActionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ColumnActionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnActionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["icon"] = this.icon;
        data["type"] = this.type;
        data["acl"] = this.acl;
        if (Array.isArray(this.buttons)) {
            data["buttons"] = [];
            for (let item of this.buttons)
                data["buttons"].push(item.toJSON());
        }
        return data;
    }

    clone(): ColumnActionItemDto {
        const json = this.toJSON();
        let result = new ColumnActionItemDto();
        result.init(json);
        return result;
    }
}

/** 操作项 */
export interface IColumnActionItemDto {
    /** 操作名称 */
    name: string | undefined;
    /** 显示名称 */
    label: string | undefined;
    /** 图标 */
    icon: string | undefined;
    type: ColumnControl;
    /** 权限 */
    acl: string | undefined;
    /** 子级操作按钮 当 QYB.DynamicPage.Dtos.ColumnActionItemDto.Type 值为 QYB.DynamicPage.Dtos.ColumnControl.Select 时使用 */
    buttons: ColumnActionItemDto[] | undefined;
}

export class ColumnItemDto implements IColumnItemDto {
    /** 字段名,支持嵌套,aa.bb */
    field: string | undefined;
    /** 字段类型,datetime,number */
    type: string | undefined;
    /** 列名 */
    title: string | undefined;
    /** 自定义渲染器名称 */
    render: string | undefined;
    /** 排序号,越小越靠前 */
    order: number | undefined;
    /** 列表宽度 */
    width: number | undefined;
    /** 列类型为number时保留小数位 */
    numberDigits: number;
    /** 列类型为datetime类型格式化规则 */
    dateFormat: string | undefined;
    statistical: ColumnItemStatistical;
    fixed: ColumnItemFixed;
    /** 操作,当 QYB.DynamicPage.Dtos.ColumnItemDto.Type 值为 action 时 */
    actions: ColumnActionItemDto[] | undefined;

    constructor(data?: IColumnItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.render = _data["render"];
            this.order = _data["order"];
            this.width = _data["width"];
            this.numberDigits = _data["numberDigits"];
            this.dateFormat = _data["dateFormat"];
            this.statistical = _data["statistical"];
            this.fixed = _data["fixed"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions.push(ColumnActionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ColumnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["type"] = this.type;
        data["title"] = this.title;
        data["render"] = this.render;
        data["order"] = this.order;
        data["width"] = this.width;
        data["numberDigits"] = this.numberDigits;
        data["dateFormat"] = this.dateFormat;
        data["statistical"] = this.statistical;
        data["fixed"] = this.fixed;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ColumnItemDto {
        const json = this.toJSON();
        let result = new ColumnItemDto();
        result.init(json);
        return result;
    }
}

export interface IColumnItemDto {
    /** 字段名,支持嵌套,aa.bb */
    field: string | undefined;
    /** 字段类型,datetime,number */
    type: string | undefined;
    /** 列名 */
    title: string | undefined;
    /** 自定义渲染器名称 */
    render: string | undefined;
    /** 排序号,越小越靠前 */
    order: number | undefined;
    /** 列表宽度 */
    width: number | undefined;
    /** 列类型为number时保留小数位 */
    numberDigits: number;
    /** 列类型为datetime类型格式化规则 */
    dateFormat: string | undefined;
    statistical: ColumnItemStatistical;
    fixed: ColumnItemFixed;
    /** 操作,当 QYB.DynamicPage.Dtos.ColumnItemDto.Type 值为 action 时 */
    actions: ColumnActionItemDto[] | undefined;
}

export class ListResultDtoOfColumnItemDto implements IListResultDtoOfColumnItemDto {
    items: ColumnItemDto[] | undefined;

    constructor(data?: IListResultDtoOfColumnItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ColumnItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfColumnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfColumnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfColumnItemDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfColumnItemDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfColumnItemDto {
    items: ColumnItemDto[] | undefined;
}

/** 筛选条件项 */
export class PageFilterItemDto implements IPageFilterItemDto {
    /** 顺序号 */
    order: number;
    /** 显示名称 */
    label: string | undefined;
    /** 组件名称 */
    componentName: string | undefined;
    /** 组件参数 */
    args: { [key: string]: any; } | undefined;
    /** 值发生改变通知的page-filter组件名称集合 */
    valueChange: string[] | undefined;
    /** 是否启用,不启用将隐藏 */
    enabled: boolean;
    /** 默认宽度 */
    width: number;
    xsWidth: number | undefined;
    /** 宽度 当屏幕宽度: ≥576px, 一行24 */
    smWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥768px, 一行24 */
    mdWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥992px, 一行24 */
    lgWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥1200px, 一行24 */
    xlWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥1600px, 一行24 */
    xxlWidth: number | undefined;
    field: string | undefined;
    value: string | undefined;
    operator: QueryOperator;
    skipValueIsNull: boolean;

    constructor(data?: IPageFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.label = _data["label"];
            this.componentName = _data["componentName"];
            if (_data["args"]) {
                this.args = {} as any;
                for (let key in _data["args"]) {
                    if (_data["args"].hasOwnProperty(key))
                        (<any>this.args)[key] = _data["args"][key];
                }
            }
            if (Array.isArray(_data["valueChange"])) {
                this.valueChange = [] as any;
                for (let item of _data["valueChange"])
                    this.valueChange.push(item);
            }
            this.enabled = _data["enabled"];
            this.width = _data["width"];
            this.xsWidth = _data["xsWidth"];
            this.smWidth = _data["smWidth"];
            this.mdWidth = _data["mdWidth"];
            this.lgWidth = _data["lgWidth"];
            this.xlWidth = _data["xlWidth"];
            this.xxlWidth = _data["xxlWidth"];
            this.field = _data["field"];
            this.value = _data["value"];
            this.operator = _data["operator"];
            this.skipValueIsNull = _data["skipValueIsNull"];
        }
    }

    static fromJS(data: any): PageFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["label"] = this.label;
        data["componentName"] = this.componentName;
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    (<any>data["args"])[key] = (<any>this.args)[key];
            }
        }
        if (Array.isArray(this.valueChange)) {
            data["valueChange"] = [];
            for (let item of this.valueChange)
                data["valueChange"].push(item);
        }
        data["enabled"] = this.enabled;
        data["width"] = this.width;
        data["xsWidth"] = this.xsWidth;
        data["smWidth"] = this.smWidth;
        data["mdWidth"] = this.mdWidth;
        data["lgWidth"] = this.lgWidth;
        data["xlWidth"] = this.xlWidth;
        data["xxlWidth"] = this.xxlWidth;
        data["field"] = this.field;
        data["value"] = this.value;
        data["operator"] = this.operator;
        data["skipValueIsNull"] = this.skipValueIsNull;
        return data;
    }

    clone(): PageFilterItemDto {
        const json = this.toJSON();
        let result = new PageFilterItemDto();
        result.init(json);
        return result;
    }
}

/** 筛选条件项 */
export interface IPageFilterItemDto {
    /** 顺序号 */
    order: number;
    /** 显示名称 */
    label: string | undefined;
    /** 组件名称 */
    componentName: string | undefined;
    /** 组件参数 */
    args: { [key: string]: any; } | undefined;
    /** 值发生改变通知的page-filter组件名称集合 */
    valueChange: string[] | undefined;
    /** 是否启用,不启用将隐藏 */
    enabled: boolean;
    /** 默认宽度 */
    width: number;
    xsWidth: number | undefined;
    /** 宽度 当屏幕宽度: ≥576px, 一行24 */
    smWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥768px, 一行24 */
    mdWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥992px, 一行24 */
    lgWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥1200px, 一行24 */
    xlWidth: number | undefined;
    /** 宽度, 当屏幕宽度: ≥1600px, 一行24 */
    xxlWidth: number | undefined;
    field: string | undefined;
    value: string | undefined;
    operator: QueryOperator;
    skipValueIsNull: boolean;
}

export class DynamicPageDto implements IDynamicPageDto {
    pageFilters: PageFilterItemDto[] | undefined;
    columns: ColumnItemDto[] | undefined;

    constructor(data?: IDynamicPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageFilters"])) {
                this.pageFilters = [] as any;
                for (let item of _data["pageFilters"])
                    this.pageFilters.push(PageFilterItemDto.fromJS(item));
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ColumnItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageFilters)) {
            data["pageFilters"] = [];
            for (let item of this.pageFilters)
                data["pageFilters"].push(item.toJSON());
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }

    clone(): DynamicPageDto {
        const json = this.toJSON();
        let result = new DynamicPageDto();
        result.init(json);
        return result;
    }
}

export interface IDynamicPageDto {
    pageFilters: PageFilterItemDto[] | undefined;
    columns: ColumnItemDto[] | undefined;
}

export class ListResultDtoOfPageFilterItemDto implements IListResultDtoOfPageFilterItemDto {
    items: PageFilterItemDto[] | undefined;

    constructor(data?: IListResultDtoOfPageFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PageFilterItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPageFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPageFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfPageFilterItemDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPageFilterItemDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPageFilterItemDto {
    items: PageFilterItemDto[] | undefined;
}

export class QueryInput implements IQueryInput {
    maxResultCount: number;
    skipCount: number;
    queryConditions: QueryCondition[] | undefined;
    sortConditions: SortCondition[] | undefined;

    constructor(data?: IQueryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            if (Array.isArray(_data["queryConditions"])) {
                this.queryConditions = [] as any;
                for (let item of _data["queryConditions"])
                    this.queryConditions.push(QueryCondition.fromJS(item));
            }
            if (Array.isArray(_data["sortConditions"])) {
                this.sortConditions = [] as any;
                for (let item of _data["sortConditions"])
                    this.sortConditions.push(SortCondition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryInput {
        data = typeof data === 'object' ? data : {};
        let result = new QueryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        if (Array.isArray(this.queryConditions)) {
            data["queryConditions"] = [];
            for (let item of this.queryConditions)
                data["queryConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.sortConditions)) {
            data["sortConditions"] = [];
            for (let item of this.sortConditions)
                data["sortConditions"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryInput {
        const json = this.toJSON();
        let result = new QueryInput();
        result.init(json);
        return result;
    }
}

export interface IQueryInput {
    maxResultCount: number;
    skipCount: number;
    queryConditions: QueryCondition[] | undefined;
    sortConditions: SortCondition[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }

    clone(): EditionEditDto {
        const json = this.toJSON();
        let result = new EditionEditDto();
        result.init(json);
        return result;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateEditionDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateEditionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class IValueValidator implements IIValueValidator {
    readonly name: string | undefined;
    readonly attributes: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)[key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }

    clone(): IValueValidator {
        const json = this.toJSON();
        let result = new IValueValidator();
        result.init(json);
        return result;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }

    clone(): LocalizableComboboxItemDto {
        const json = this.toJSON();
        let result = new LocalizableComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): LocalizableComboboxItemSourceDto {
        const json = this.toJSON();
        let result = new LocalizableComboboxItemSourceDto();
        result.init(json);
        return result;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)[key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }

    clone(): FeatureInputTypeDto {
        const json = this.toJSON();
        let result = new FeatureInputTypeDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }

    clone(): FlatFeatureDto {
        const json = this.toJSON();
        let result = new FlatFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetEditionEditOutput {
        const json = this.toJSON();
        let result = new GetEditionEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionListDto implements IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): EditionListDto {
        const json = this.toJSON();
        let result = new EditionListDto();
        result.init(json);
        return result;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfEditionListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfEditionListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }

    clone(): MoveTenantsToAnotherEditionDto {
        const json = this.toJSON();
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(json);
        return result;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

/** 教育背景的列表DTO QYB.QYBProduct.Organization.EducationBackground.EducationBackground */
export class EducationBackgroundEditDto implements IEducationBackgroundEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 入学日志 */
    startDate: moment.Moment | undefined;
    /** 毕业日期 */
    endDate: moment.Moment | undefined;
    /** 学校名称 */
    schoolName: string | undefined;
    /** 专业 */
    professional: string | undefined;
    /** 教育类型 */
    eduTypeCode: string | undefined;
    /** 学历 */
    educationsCode: string | undefined;
    /** 学位 */
    degreesCode: string | undefined;
    /** 学年制 */
    academicYearSystem: string | undefined;
    /** 最高学历 */
    isHighestEducationCode: string | undefined;
    /** 是否第一学历 */
    isFirstEduCode: string | undefined;
    /** 是否211/985 */
    isNProjectCode: string | undefined;

    constructor(data?: IEducationBackgroundEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.schoolName = _data["schoolName"];
            this.professional = _data["professional"];
            this.eduTypeCode = _data["eduTypeCode"];
            this.educationsCode = _data["educationsCode"];
            this.degreesCode = _data["degreesCode"];
            this.academicYearSystem = _data["academicYearSystem"];
            this.isHighestEducationCode = _data["isHighestEducationCode"];
            this.isFirstEduCode = _data["isFirstEduCode"];
            this.isNProjectCode = _data["isNProjectCode"];
        }
    }

    static fromJS(data: any): EducationBackgroundEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationBackgroundEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["schoolName"] = this.schoolName;
        data["professional"] = this.professional;
        data["eduTypeCode"] = this.eduTypeCode;
        data["educationsCode"] = this.educationsCode;
        data["degreesCode"] = this.degreesCode;
        data["academicYearSystem"] = this.academicYearSystem;
        data["isHighestEducationCode"] = this.isHighestEducationCode;
        data["isFirstEduCode"] = this.isFirstEduCode;
        data["isNProjectCode"] = this.isNProjectCode;
        return data;
    }

    clone(): EducationBackgroundEditDto {
        const json = this.toJSON();
        let result = new EducationBackgroundEditDto();
        result.init(json);
        return result;
    }
}

/** 教育背景的列表DTO QYB.QYBProduct.Organization.EducationBackground.EducationBackground */
export interface IEducationBackgroundEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 入学日志 */
    startDate: moment.Moment | undefined;
    /** 毕业日期 */
    endDate: moment.Moment | undefined;
    /** 学校名称 */
    schoolName: string | undefined;
    /** 专业 */
    professional: string | undefined;
    /** 教育类型 */
    eduTypeCode: string | undefined;
    /** 学历 */
    educationsCode: string | undefined;
    /** 学位 */
    degreesCode: string | undefined;
    /** 学年制 */
    academicYearSystem: string | undefined;
    /** 最高学历 */
    isHighestEducationCode: string | undefined;
    /** 是否第一学历 */
    isFirstEduCode: string | undefined;
    /** 是否211/985 */
    isNProjectCode: string | undefined;
}

export class CreateOrUpdateEducationBackgroundInput implements ICreateOrUpdateEducationBackgroundInput {
    educationBackground: EducationBackgroundEditDto;

    constructor(data?: ICreateOrUpdateEducationBackgroundInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.educationBackground = new EducationBackgroundEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationBackground = _data["educationBackground"] ? EducationBackgroundEditDto.fromJS(_data["educationBackground"]) : new EducationBackgroundEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEducationBackgroundInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEducationBackgroundInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationBackground"] = this.educationBackground ? this.educationBackground.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateEducationBackgroundInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateEducationBackgroundInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEducationBackgroundInput {
    educationBackground: EducationBackgroundEditDto;
}

export class OrgPostGrade implements IOrgPostGrade {
    orgPostId: number;
    gradeName: string | undefined;
    basePay: number | undefined;
    managerAdd: number | undefined;
    psotSubsidy: number | undefined;
    skillSubsidy: number | undefined;
    overTimeSubsidy: number | undefined;
    otherSubsidy: number | undefined;
    salaryIncome: number | undefined;
    monthlyBonus: number | undefined;
    synthesisIncome: number | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: IOrgPostGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPostId = _data["orgPostId"];
            this.gradeName = _data["gradeName"];
            this.basePay = _data["basePay"];
            this.managerAdd = _data["managerAdd"];
            this.psotSubsidy = _data["psotSubsidy"];
            this.skillSubsidy = _data["skillSubsidy"];
            this.overTimeSubsidy = _data["overTimeSubsidy"];
            this.otherSubsidy = _data["otherSubsidy"];
            this.salaryIncome = _data["salaryIncome"];
            this.monthlyBonus = _data["monthlyBonus"];
            this.synthesisIncome = _data["synthesisIncome"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrgPostGrade {
        data = typeof data === 'object' ? data : {};
        let result = new OrgPostGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPostId"] = this.orgPostId;
        data["gradeName"] = this.gradeName;
        data["basePay"] = this.basePay;
        data["managerAdd"] = this.managerAdd;
        data["psotSubsidy"] = this.psotSubsidy;
        data["skillSubsidy"] = this.skillSubsidy;
        data["overTimeSubsidy"] = this.overTimeSubsidy;
        data["otherSubsidy"] = this.otherSubsidy;
        data["salaryIncome"] = this.salaryIncome;
        data["monthlyBonus"] = this.monthlyBonus;
        data["synthesisIncome"] = this.synthesisIncome;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): OrgPostGrade {
        const json = this.toJSON();
        let result = new OrgPostGrade();
        result.init(json);
        return result;
    }
}

export interface IOrgPostGrade {
    orgPostId: number;
    gradeName: string | undefined;
    basePay: number | undefined;
    managerAdd: number | undefined;
    psotSubsidy: number | undefined;
    skillSubsidy: number | undefined;
    overTimeSubsidy: number | undefined;
    otherSubsidy: number | undefined;
    salaryIncome: number | undefined;
    monthlyBonus: number | undefined;
    synthesisIncome: number | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class OrgPost implements IOrgPost {
    parentId: number;
    name: string | undefined;
    enCode: string | undefined;
    companyId: number;
    departmentId: number;
    empKindOne: string | undefined;
    empKindTwo: string | undefined;
    empKindThree: string | undefined;
    description: string | undefined;
    sortCode: number | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: IOrgPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.enCode = _data["enCode"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.empKindOne = _data["empKindOne"];
            this.empKindTwo = _data["empKindTwo"];
            this.empKindThree = _data["empKindThree"];
            this.description = _data["description"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrgPost {
        data = typeof data === 'object' ? data : {};
        let result = new OrgPost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["enCode"] = this.enCode;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["empKindOne"] = this.empKindOne;
        data["empKindTwo"] = this.empKindTwo;
        data["empKindThree"] = this.empKindThree;
        data["description"] = this.description;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): OrgPost {
        const json = this.toJSON();
        let result = new OrgPost();
        result.init(json);
        return result;
    }
}

export interface IOrgPost {
    parentId: number;
    name: string | undefined;
    enCode: string | undefined;
    companyId: number;
    departmentId: number;
    empKindOne: string | undefined;
    empKindTwo: string | undefined;
    empKindThree: string | undefined;
    description: string | undefined;
    sortCode: number | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class Employee implements IEmployee {
    userId: number | undefined;
    empTypeCode: string | undefined;
    empStateCode: string | undefined;
    hireDate: moment.Moment | undefined;
    probationMonth: number | undefined;
    regularDate: moment.Moment | undefined;
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    personalServiceCode: string | undefined;
    recruitmentSourceCode: string | undefined;
    companyEmail: string | undefined;
    rfid: string | undefined;
    realName: string | undefined;
    jobNumber: string | undefined;
    companyId: number | undefined;
    company: Company;
    departmentId: number | undefined;
    orgPostId: number | undefined;
    orgPost: OrgPost;
    idPhoto: string | undefined;
    identityCard: string | undefined;
    cardIsLongTerm: boolean | undefined;
    identityValidity: moment.Moment | undefined;
    identityStartDate: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
    nativePlace: string | undefined;
    identityAddress: string | undefined;
    nationCode: string | undefined;
    mobile: string | undefined;
    personalEmail: string | undefined;
    genderCode: string | undefined;
    postalCode: string | undefined;
    educationsCode: string | undefined;
    maritalStatusCode: string | undefined;
    politicsStatusCode: string | undefined;
    residenceTypeCode: string | undefined;
    socialSecurity: string | undefined;
    reservedFunds: string | undefined;
    cardNo: string | undefined;
    bankName: string | undefined;
    firstWorkDate: moment.Moment | undefined;
    presentAddress: string | undefined;
    identityFaceImg: string | undefined;
    identityEmblemImg: string | undefined;
    userPictureType: string | undefined;
    termDate: moment.Moment | undefined;
    termReason: string | undefined;
    recommender: string | undefined;
    insuranceType: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.empTypeCode = _data["empTypeCode"];
            this.empStateCode = _data["empStateCode"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.probationGradeId = _data["probationGradeId"];
            this.probationGrade = _data["probationGrade"] ? OrgPostGrade.fromJS(_data["probationGrade"]) : <any>undefined;
            this.regularGradeId = _data["regularGradeId"];
            this.regularGrade = _data["regularGrade"] ? OrgPostGrade.fromJS(_data["regularGrade"]) : <any>undefined;
            this.personalServiceCode = _data["personalServiceCode"];
            this.recruitmentSourceCode = _data["recruitmentSourceCode"];
            this.companyEmail = _data["companyEmail"];
            this.rfid = _data["rfid"];
            this.realName = _data["realName"];
            this.jobNumber = _data["jobNumber"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.orgPostId = _data["orgPostId"];
            this.orgPost = _data["orgPost"] ? OrgPost.fromJS(_data["orgPost"]) : <any>undefined;
            this.idPhoto = _data["idPhoto"];
            this.identityCard = _data["identityCard"];
            this.cardIsLongTerm = _data["cardIsLongTerm"];
            this.identityValidity = _data["identityValidity"] ? moment(_data["identityValidity"].toString()) : <any>undefined;
            this.identityStartDate = _data["identityStartDate"] ? moment(_data["identityStartDate"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.nativePlace = _data["nativePlace"];
            this.identityAddress = _data["identityAddress"];
            this.nationCode = _data["nationCode"];
            this.mobile = _data["mobile"];
            this.personalEmail = _data["personalEmail"];
            this.genderCode = _data["genderCode"];
            this.postalCode = _data["postalCode"];
            this.educationsCode = _data["educationsCode"];
            this.maritalStatusCode = _data["maritalStatusCode"];
            this.politicsStatusCode = _data["politicsStatusCode"];
            this.residenceTypeCode = _data["residenceTypeCode"];
            this.socialSecurity = _data["socialSecurity"];
            this.reservedFunds = _data["reservedFunds"];
            this.cardNo = _data["cardNo"];
            this.bankName = _data["bankName"];
            this.firstWorkDate = _data["firstWorkDate"] ? moment(_data["firstWorkDate"].toString()) : <any>undefined;
            this.presentAddress = _data["presentAddress"];
            this.identityFaceImg = _data["identityFaceImg"];
            this.identityEmblemImg = _data["identityEmblemImg"];
            this.userPictureType = _data["userPictureType"];
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.termReason = _data["termReason"];
            this.recommender = _data["recommender"];
            this.insuranceType = _data["insuranceType"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["empTypeCode"] = this.empTypeCode;
        data["empStateCode"] = this.empStateCode;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["probationGradeId"] = this.probationGradeId;
        data["probationGrade"] = this.probationGrade ? this.probationGrade.toJSON() : <any>undefined;
        data["regularGradeId"] = this.regularGradeId;
        data["regularGrade"] = this.regularGrade ? this.regularGrade.toJSON() : <any>undefined;
        data["personalServiceCode"] = this.personalServiceCode;
        data["recruitmentSourceCode"] = this.recruitmentSourceCode;
        data["companyEmail"] = this.companyEmail;
        data["rfid"] = this.rfid;
        data["realName"] = this.realName;
        data["jobNumber"] = this.jobNumber;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["orgPostId"] = this.orgPostId;
        data["orgPost"] = this.orgPost ? this.orgPost.toJSON() : <any>undefined;
        data["idPhoto"] = this.idPhoto;
        data["identityCard"] = this.identityCard;
        data["cardIsLongTerm"] = this.cardIsLongTerm;
        data["identityValidity"] = this.identityValidity ? this.identityValidity.toISOString() : <any>undefined;
        data["identityStartDate"] = this.identityStartDate ? this.identityStartDate.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["nativePlace"] = this.nativePlace;
        data["identityAddress"] = this.identityAddress;
        data["nationCode"] = this.nationCode;
        data["mobile"] = this.mobile;
        data["personalEmail"] = this.personalEmail;
        data["genderCode"] = this.genderCode;
        data["postalCode"] = this.postalCode;
        data["educationsCode"] = this.educationsCode;
        data["maritalStatusCode"] = this.maritalStatusCode;
        data["politicsStatusCode"] = this.politicsStatusCode;
        data["residenceTypeCode"] = this.residenceTypeCode;
        data["socialSecurity"] = this.socialSecurity;
        data["reservedFunds"] = this.reservedFunds;
        data["cardNo"] = this.cardNo;
        data["bankName"] = this.bankName;
        data["firstWorkDate"] = this.firstWorkDate ? this.firstWorkDate.toISOString() : <any>undefined;
        data["presentAddress"] = this.presentAddress;
        data["identityFaceImg"] = this.identityFaceImg;
        data["identityEmblemImg"] = this.identityEmblemImg;
        data["userPictureType"] = this.userPictureType;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["termReason"] = this.termReason;
        data["recommender"] = this.recommender;
        data["insuranceType"] = this.insuranceType;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): Employee {
        const json = this.toJSON();
        let result = new Employee();
        result.init(json);
        return result;
    }
}

export interface IEmployee {
    userId: number | undefined;
    empTypeCode: string | undefined;
    empStateCode: string | undefined;
    hireDate: moment.Moment | undefined;
    probationMonth: number | undefined;
    regularDate: moment.Moment | undefined;
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    personalServiceCode: string | undefined;
    recruitmentSourceCode: string | undefined;
    companyEmail: string | undefined;
    rfid: string | undefined;
    realName: string | undefined;
    jobNumber: string | undefined;
    companyId: number | undefined;
    company: Company;
    departmentId: number | undefined;
    orgPostId: number | undefined;
    orgPost: OrgPost;
    idPhoto: string | undefined;
    identityCard: string | undefined;
    cardIsLongTerm: boolean | undefined;
    identityValidity: moment.Moment | undefined;
    identityStartDate: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
    nativePlace: string | undefined;
    identityAddress: string | undefined;
    nationCode: string | undefined;
    mobile: string | undefined;
    personalEmail: string | undefined;
    genderCode: string | undefined;
    postalCode: string | undefined;
    educationsCode: string | undefined;
    maritalStatusCode: string | undefined;
    politicsStatusCode: string | undefined;
    residenceTypeCode: string | undefined;
    socialSecurity: string | undefined;
    reservedFunds: string | undefined;
    cardNo: string | undefined;
    bankName: string | undefined;
    firstWorkDate: moment.Moment | undefined;
    presentAddress: string | undefined;
    identityFaceImg: string | undefined;
    identityEmblemImg: string | undefined;
    userPictureType: string | undefined;
    termDate: moment.Moment | undefined;
    termReason: string | undefined;
    recommender: string | undefined;
    insuranceType: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

/** 教育背景的列表DTO QYB.QYBProduct.Organization.EducationBackground.EducationBackground */
export class EducationBackgroundListDto implements IEducationBackgroundListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 入学日志 */
    startDate: moment.Moment | undefined;
    /** 毕业日期 */
    endDate: moment.Moment | undefined;
    /** 学校名称 */
    schoolName: string | undefined;
    /** 专业 */
    professional: string | undefined;
    /** 教育类型 */
    eduTypeCode: string | undefined;
    eduTypeName: string | undefined;
    /** 学历 */
    educationsCode: string | undefined;
    educationsName: string | undefined;
    /** 学位 */
    degreesCode: string | undefined;
    degreesName: string | undefined;
    /** 学年制 */
    academicYearSystem: string | undefined;
    /** 最高学历 */
    isHighestEducationCode: string | undefined;
    isHighestEducationName: string | undefined;
    /** 是否第一学历 */
    isFirstEduCode: string | undefined;
    isFirstEduName: string | undefined;
    /** 是否211/985 */
    isNProjectCode: string | undefined;
    isNProjectName: string | undefined;
    id: number;

    constructor(data?: IEducationBackgroundListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.emp = _data["emp"] ? Employee.fromJS(_data["emp"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.schoolName = _data["schoolName"];
            this.professional = _data["professional"];
            this.eduTypeCode = _data["eduTypeCode"];
            this.eduTypeName = _data["eduTypeName"];
            this.educationsCode = _data["educationsCode"];
            this.educationsName = _data["educationsName"];
            this.degreesCode = _data["degreesCode"];
            this.degreesName = _data["degreesName"];
            this.academicYearSystem = _data["academicYearSystem"];
            this.isHighestEducationCode = _data["isHighestEducationCode"];
            this.isHighestEducationName = _data["isHighestEducationName"];
            this.isFirstEduCode = _data["isFirstEduCode"];
            this.isFirstEduName = _data["isFirstEduName"];
            this.isNProjectCode = _data["isNProjectCode"];
            this.isNProjectName = _data["isNProjectName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EducationBackgroundListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationBackgroundListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["emp"] = this.emp ? this.emp.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["schoolName"] = this.schoolName;
        data["professional"] = this.professional;
        data["eduTypeCode"] = this.eduTypeCode;
        data["eduTypeName"] = this.eduTypeName;
        data["educationsCode"] = this.educationsCode;
        data["educationsName"] = this.educationsName;
        data["degreesCode"] = this.degreesCode;
        data["degreesName"] = this.degreesName;
        data["academicYearSystem"] = this.academicYearSystem;
        data["isHighestEducationCode"] = this.isHighestEducationCode;
        data["isHighestEducationName"] = this.isHighestEducationName;
        data["isFirstEduCode"] = this.isFirstEduCode;
        data["isFirstEduName"] = this.isFirstEduName;
        data["isNProjectCode"] = this.isNProjectCode;
        data["isNProjectName"] = this.isNProjectName;
        data["id"] = this.id;
        return data;
    }

    clone(): EducationBackgroundListDto {
        const json = this.toJSON();
        let result = new EducationBackgroundListDto();
        result.init(json);
        return result;
    }
}

/** 教育背景的列表DTO QYB.QYBProduct.Organization.EducationBackground.EducationBackground */
export interface IEducationBackgroundListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 入学日志 */
    startDate: moment.Moment | undefined;
    /** 毕业日期 */
    endDate: moment.Moment | undefined;
    /** 学校名称 */
    schoolName: string | undefined;
    /** 专业 */
    professional: string | undefined;
    /** 教育类型 */
    eduTypeCode: string | undefined;
    eduTypeName: string | undefined;
    /** 学历 */
    educationsCode: string | undefined;
    educationsName: string | undefined;
    /** 学位 */
    degreesCode: string | undefined;
    degreesName: string | undefined;
    /** 学年制 */
    academicYearSystem: string | undefined;
    /** 最高学历 */
    isHighestEducationCode: string | undefined;
    isHighestEducationName: string | undefined;
    /** 是否第一学历 */
    isFirstEduCode: string | undefined;
    isFirstEduName: string | undefined;
    /** 是否211/985 */
    isNProjectCode: string | undefined;
    isNProjectName: string | undefined;
    id: number;
}

/** 读取可编辑教育背景的Dto */
export class GetEducationBackgroundForEditOutput implements IGetEducationBackgroundForEditOutput {
    educationBackground: EducationBackgroundEditDto;

    constructor(data?: IGetEducationBackgroundForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationBackground = _data["educationBackground"] ? EducationBackgroundEditDto.fromJS(_data["educationBackground"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEducationBackgroundForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationBackgroundForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationBackground"] = this.educationBackground ? this.educationBackground.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetEducationBackgroundForEditOutput {
        const json = this.toJSON();
        let result = new GetEducationBackgroundForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑教育背景的Dto */
export interface IGetEducationBackgroundForEditOutput {
    educationBackground: EducationBackgroundEditDto;
}

export class PagedResultDtoOfEducationBackgroundListDto implements IPagedResultDtoOfEducationBackgroundListDto {
    totalCount: number;
    items: EducationBackgroundListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEducationBackgroundListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EducationBackgroundListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEducationBackgroundListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEducationBackgroundListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEducationBackgroundListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEducationBackgroundListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEducationBackgroundListDto {
    totalCount: number;
    items: EducationBackgroundListDto[] | undefined;
}

export class EHSUserEditDto implements IEHSUserEditDto {
    /** 租户 */
    tenantId: number;
    /** 私钥 */
    privatekey: string | undefined;
    /** 真实姓名-------------------新增 */
    realName: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 账号 */
    userName: string | undefined;
    /** 手机号 */
    phoneNumber: string | undefined;
    /** 密码 */
    password: string | undefined;
    /** 员工卡ID */
    rfid: string | undefined;
    /** 公司邮箱 */
    emailAddress: string | undefined;
    /** 是否启用邮件通知 */
    enableEmail: boolean;
    /** 是否启用App推送 */
    enableAPPPush: boolean;

    constructor(data?: IEHSUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.privatekey = _data["privatekey"];
            this.realName = _data["realName"];
            this.remarks = _data["remarks"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.rfid = _data["rfid"];
            this.emailAddress = _data["emailAddress"];
            this.enableEmail = _data["enableEmail"];
            this.enableAPPPush = _data["enableAPPPush"];
        }
    }

    static fromJS(data: any): EHSUserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EHSUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["privatekey"] = this.privatekey;
        data["realName"] = this.realName;
        data["remarks"] = this.remarks;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["rfid"] = this.rfid;
        data["emailAddress"] = this.emailAddress;
        data["enableEmail"] = this.enableEmail;
        data["enableAPPPush"] = this.enableAPPPush;
        return data;
    }

    clone(): EHSUserEditDto {
        const json = this.toJSON();
        let result = new EHSUserEditDto();
        result.init(json);
        return result;
    }
}

export interface IEHSUserEditDto {
    /** 租户 */
    tenantId: number;
    /** 私钥 */
    privatekey: string | undefined;
    /** 真实姓名-------------------新增 */
    realName: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 账号 */
    userName: string | undefined;
    /** 手机号 */
    phoneNumber: string | undefined;
    /** 密码 */
    password: string | undefined;
    /** 员工卡ID */
    rfid: string | undefined;
    /** 公司邮箱 */
    emailAddress: string | undefined;
    /** 是否启用邮件通知 */
    enableEmail: boolean;
    /** 是否启用App推送 */
    enableAPPPush: boolean;
}

/** 安全隐患提交问题 */
export class EHSCreateIssueDto implements IEHSCreateIssueDto {
    /** 租户 */
    tenantId: number;
    /** 私钥 */
    privatekey: string | undefined;
    /** MachineOrAuditPoint */
    machineOrAuditPoint: string | undefined;
    /** 问题类型 */
    issueTypeName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;

    constructor(data?: IEHSCreateIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.privatekey = _data["privatekey"];
            this.machineOrAuditPoint = _data["machineOrAuditPoint"];
            this.issueTypeName = _data["issueTypeName"];
            this.description = _data["description"];
            this.issueProgress = _data["issueProgress"];
            this.discovererName = _data["discovererName"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respName = _data["respName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.correctiveNote = _data["correctiveNote"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): EHSCreateIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new EHSCreateIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["privatekey"] = this.privatekey;
        data["machineOrAuditPoint"] = this.machineOrAuditPoint;
        data["issueTypeName"] = this.issueTypeName;
        data["description"] = this.description;
        data["issueProgress"] = this.issueProgress;
        data["discovererName"] = this.discovererName;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respName"] = this.respName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["correctiveNote"] = this.correctiveNote;
        data["remark"] = this.remark;
        return data;
    }

    clone(): EHSCreateIssueDto {
        const json = this.toJSON();
        let result = new EHSCreateIssueDto();
        result.init(json);
        return result;
    }
}

/** 安全隐患提交问题 */
export interface IEHSCreateIssueDto {
    /** 租户 */
    tenantId: number;
    /** 私钥 */
    privatekey: string | undefined;
    /** MachineOrAuditPoint */
    machineOrAuditPoint: string | undefined;
    /** 问题类型 */
    issueTypeName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 私钥Dto */
export class EHSPrivatekeyDto implements IEHSPrivatekeyDto {
    /** 是否启用 */
    ehsPrivatekey: string | undefined;

    constructor(data?: IEHSPrivatekeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehsPrivatekey = _data["ehsPrivatekey"];
        }
    }

    static fromJS(data: any): EHSPrivatekeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new EHSPrivatekeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehsPrivatekey"] = this.ehsPrivatekey;
        return data;
    }

    clone(): EHSPrivatekeyDto {
        const json = this.toJSON();
        let result = new EHSPrivatekeyDto();
        result.init(json);
        return result;
    }
}

/** 私钥Dto */
export interface IEHSPrivatekeyDto {
    /** 是否启用 */
    ehsPrivatekey: string | undefined;
}

export class AnalysisDtos implements IAnalysisDtos {
    /** 开始时间 */
    startTime: moment.Moment | undefined;
    /** 结束时间 */
    endTime: moment.Moment | undefined;
    /** 员工(可多选，多个用，隔开) */
    userIds: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 考勤组 */
    attGroupId: number | undefined;

    constructor(data?: IAnalysisDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.userIds = _data["userIds"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.attGroupId = _data["attGroupId"];
        }
    }

    static fromJS(data: any): AnalysisDtos {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["userIds"] = this.userIds;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["attGroupId"] = this.attGroupId;
        return data;
    }

    clone(): AnalysisDtos {
        const json = this.toJSON();
        let result = new AnalysisDtos();
        result.init(json);
        return result;
    }
}

export interface IAnalysisDtos {
    /** 开始时间 */
    startTime: moment.Moment | undefined;
    /** 结束时间 */
    endTime: moment.Moment | undefined;
    /** 员工(可多选，多个用，隔开) */
    userIds: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 考勤组 */
    attGroupId: number | undefined;
}

export class EmpattdailyEditDto implements IEmpattdailyEditDto {
    id: number;
    /** 员工 */
    empId: number | undefined;
    /** 考勤日期 */
    attendDate: moment.Moment | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工 4：缺卡) */
    abnormalType: string | undefined;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出时数 */
    gcHours: number | undefined;
    /** 工时假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核 2：已审核 3：员工已确认 4:已结账) */
    state: string | undefined;
    /** 审核人 */
    auditUserId: number | undefined;
    auditUserRealName: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;

    constructor(data?: IEmpattdailyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.attendDate = _data["attendDate"] ? moment(_data["attendDate"].toString()) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.dutyFrom = _data["dutyFrom"] ? moment(_data["dutyFrom"].toString()) : <any>undefined;
            this.dutyTo = _data["dutyTo"] ? moment(_data["dutyTo"].toString()) : <any>undefined;
            this.attDays = _data["attDays"];
            this.restDays = _data["restDays"];
            this.standardLobor = _data["standardLobor"];
            this.factLabor = _data["factLabor"];
            this.ot = _data["ot"];
            this.oT1 = _data["oT1"];
            this.oT2 = _data["oT2"];
            this.oT3 = _data["oT3"];
            this.lateMinutes = _data["lateMinutes"];
            this.earlyMinutes = _data["earlyMinutes"];
            this.absentHours = _data["absentHours"];
            this.abnormalType = _data["abnormalType"];
            this.signCardNums = _data["signCardNums"];
            this.brHours = _data["brHours"];
            this.ssHours = _data["ssHours"];
            this.hjHours = _data["hjHours"];
            this.cjHours = _data["cjHours"];
            this.njHours = _data["njHours"];
            this.gcHours = _data["gcHours"];
            this.gsHours = _data["gsHours"];
            this.pcHours = _data["pcHours"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.txHours = _data["txHours"];
            this.cjjHours = _data["cjjHours"];
            this.nightNums = _data["nightNums"];
            this.state = _data["state"];
            this.auditUserId = _data["auditUserId"];
            this.auditUserRealName = _data["auditUserRealName"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.selfCheckTime = _data["selfCheckTime"] ? moment(_data["selfCheckTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmpattdailyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattdailyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["attendDate"] = this.attendDate ? this.attendDate.toISOString() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["dutyFrom"] = this.dutyFrom ? this.dutyFrom.toISOString() : <any>undefined;
        data["dutyTo"] = this.dutyTo ? this.dutyTo.toISOString() : <any>undefined;
        data["attDays"] = this.attDays;
        data["restDays"] = this.restDays;
        data["standardLobor"] = this.standardLobor;
        data["factLabor"] = this.factLabor;
        data["ot"] = this.ot;
        data["oT1"] = this.oT1;
        data["oT2"] = this.oT2;
        data["oT3"] = this.oT3;
        data["lateMinutes"] = this.lateMinutes;
        data["earlyMinutes"] = this.earlyMinutes;
        data["absentHours"] = this.absentHours;
        data["abnormalType"] = this.abnormalType;
        data["signCardNums"] = this.signCardNums;
        data["brHours"] = this.brHours;
        data["ssHours"] = this.ssHours;
        data["hjHours"] = this.hjHours;
        data["cjHours"] = this.cjHours;
        data["njHours"] = this.njHours;
        data["gcHours"] = this.gcHours;
        data["gsHours"] = this.gsHours;
        data["pcHours"] = this.pcHours;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["txHours"] = this.txHours;
        data["cjjHours"] = this.cjjHours;
        data["nightNums"] = this.nightNums;
        data["state"] = this.state;
        data["auditUserId"] = this.auditUserId;
        data["auditUserRealName"] = this.auditUserRealName;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["selfCheckTime"] = this.selfCheckTime ? this.selfCheckTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): EmpattdailyEditDto {
        const json = this.toJSON();
        let result = new EmpattdailyEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmpattdailyEditDto {
    id: number;
    /** 员工 */
    empId: number | undefined;
    /** 考勤日期 */
    attendDate: moment.Moment | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工 4：缺卡) */
    abnormalType: string | undefined;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出时数 */
    gcHours: number | undefined;
    /** 工时假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核 2：已审核 3：员工已确认 4:已结账) */
    state: string | undefined;
    /** 审核人 */
    auditUserId: number | undefined;
    auditUserRealName: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
}

export class AttGroupDto implements IAttGroupDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IAttGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AttGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AttGroupDto {
        const json = this.toJSON();
        let result = new AttGroupDto();
        result.init(json);
        return result;
    }
}

export interface IAttGroupDto {
    id: string | undefined;
    name: string | undefined;
}

/** 考勤异常 */
export class EmpattdailyErrorDto implements IEmpattdailyErrorDto {
    /** 工号 */
    jobNumber: string | undefined;
    userId: number | undefined;
    empId: number | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 异常日期 */
    errorDate: moment.Moment;
    /** 班次 */
    shiftName: string | undefined;
    /** 班次代码 */
    shiftCode: string | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 异常类型 */
    abnormalType: string | undefined;
    /** 异常类型代码(1：迟到 2：早退 3：旷工) */
    abnormalTypeCode: string | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** 设备唯一标识 */
    clientId: string | undefined;
    /** 系统名称(安卓、苹果) */
    systemName: string | undefined;
    /** 部门管理员公司邮箱 */
    depMCompanyEmail: string | undefined;
    /** 部门管理员工号 */
    depJobNumber: string | undefined;
    /** 部门管理员设备唯一标识 */
    depMClientId: string | undefined;
    /** 部门管理员系统名称(安卓、苹果) */
    depMSystemName: string | undefined;
    rowSpan: number;
    /** 是否需要补卡 */
    isSignCard: boolean;
    /** OnWork上班 OffWork下班 */
    signCardType: string | undefined;
    /** 上班时间(时分格式) */
    startTime: string | undefined;
    /** 下班时间(时分格式) */
    endTime: string | undefined;
    /** 旷工开始分钟数(大于迟到设置值) */
    absenteeismMinutes: number | undefined;

    constructor(data?: IEmpattdailyErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.userId = _data["userId"];
            this.empId = _data["empId"];
            this.idPhoto = _data["idPhoto"];
            this.realName = _data["realName"];
            this.errorDate = _data["errorDate"] ? moment(_data["errorDate"].toString()) : <any>undefined;
            this.shiftName = _data["shiftName"];
            this.shiftCode = _data["shiftCode"];
            this.dutyFrom = _data["dutyFrom"] ? moment(_data["dutyFrom"].toString()) : <any>undefined;
            this.dutyTo = _data["dutyTo"] ? moment(_data["dutyTo"].toString()) : <any>undefined;
            this.abnormalType = _data["abnormalType"];
            this.abnormalTypeCode = _data["abnormalTypeCode"];
            this.departmentId = _data["departmentId"];
            this.companyEmail = _data["companyEmail"];
            this.clientId = _data["clientId"];
            this.systemName = _data["systemName"];
            this.depMCompanyEmail = _data["depMCompanyEmail"];
            this.depJobNumber = _data["depJobNumber"];
            this.depMClientId = _data["depMClientId"];
            this.depMSystemName = _data["depMSystemName"];
            this.rowSpan = _data["rowSpan"];
            this.isSignCard = _data["isSignCard"];
            this.signCardType = _data["signCardType"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.absenteeismMinutes = _data["absenteeismMinutes"];
        }
    }

    static fromJS(data: any): EmpattdailyErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattdailyErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["userId"] = this.userId;
        data["empId"] = this.empId;
        data["idPhoto"] = this.idPhoto;
        data["realName"] = this.realName;
        data["errorDate"] = this.errorDate ? this.errorDate.toISOString() : <any>undefined;
        data["shiftName"] = this.shiftName;
        data["shiftCode"] = this.shiftCode;
        data["dutyFrom"] = this.dutyFrom ? this.dutyFrom.toISOString() : <any>undefined;
        data["dutyTo"] = this.dutyTo ? this.dutyTo.toISOString() : <any>undefined;
        data["abnormalType"] = this.abnormalType;
        data["abnormalTypeCode"] = this.abnormalTypeCode;
        data["departmentId"] = this.departmentId;
        data["companyEmail"] = this.companyEmail;
        data["clientId"] = this.clientId;
        data["systemName"] = this.systemName;
        data["depMCompanyEmail"] = this.depMCompanyEmail;
        data["depJobNumber"] = this.depJobNumber;
        data["depMClientId"] = this.depMClientId;
        data["depMSystemName"] = this.depMSystemName;
        data["rowSpan"] = this.rowSpan;
        data["isSignCard"] = this.isSignCard;
        data["signCardType"] = this.signCardType;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["absenteeismMinutes"] = this.absenteeismMinutes;
        return data;
    }

    clone(): EmpattdailyErrorDto {
        const json = this.toJSON();
        let result = new EmpattdailyErrorDto();
        result.init(json);
        return result;
    }
}

/** 考勤异常 */
export interface IEmpattdailyErrorDto {
    /** 工号 */
    jobNumber: string | undefined;
    userId: number | undefined;
    empId: number | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 异常日期 */
    errorDate: moment.Moment;
    /** 班次 */
    shiftName: string | undefined;
    /** 班次代码 */
    shiftCode: string | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 异常类型 */
    abnormalType: string | undefined;
    /** 异常类型代码(1：迟到 2：早退 3：旷工) */
    abnormalTypeCode: string | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** 设备唯一标识 */
    clientId: string | undefined;
    /** 系统名称(安卓、苹果) */
    systemName: string | undefined;
    /** 部门管理员公司邮箱 */
    depMCompanyEmail: string | undefined;
    /** 部门管理员工号 */
    depJobNumber: string | undefined;
    /** 部门管理员设备唯一标识 */
    depMClientId: string | undefined;
    /** 部门管理员系统名称(安卓、苹果) */
    depMSystemName: string | undefined;
    rowSpan: number;
    /** 是否需要补卡 */
    isSignCard: boolean;
    /** OnWork上班 OffWork下班 */
    signCardType: string | undefined;
    /** 上班时间(时分格式) */
    startTime: string | undefined;
    /** 下班时间(时分格式) */
    endTime: string | undefined;
    /** 旷工开始分钟数(大于迟到设置值) */
    absenteeismMinutes: number | undefined;
}

export class EmpattdailyListDto implements IEmpattdailyListDto {
    id: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    empId: number | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 公司 */
    companyName: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentName: string | undefined;
    /** 班次 */
    shiftName: string | undefined;
    /** 班次代码 */
    shiftCode: string | undefined;
    /** 智能识别班次 */
    smartShiftCode: string | undefined;
    smartShiftName: string | undefined;
    /** 考勤日期 */
    attDate: moment.Moment | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 缺勤次数 */
    absenceNums: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工) */
    abnormalType: string | undefined;
    /** 异常类型代码 */
    abnormalTypeCode: string | undefined;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核 2：已审核 3：员工已确认 4:已结账) */
    state: string | undefined;
    /** 状态代码 */
    stateCode: string | undefined;
    /** 审核人 */
    auditUserName: string | undefined;
    auditUserId: number | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 部门管理员Id */
    orgManagerId: number | undefined;
    /** 打卡出勤/时 */
    clockInHours: number | undefined;

    constructor(data?: IEmpattdailyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobNumber = _data["jobNumber"];
            this.empType = _data["empType"];
            this.empId = _data["empId"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.companyId = _data["companyId"];
            this.departmentName = _data["departmentName"];
            this.shiftName = _data["shiftName"];
            this.shiftCode = _data["shiftCode"];
            this.smartShiftCode = _data["smartShiftCode"];
            this.smartShiftName = _data["smartShiftName"];
            this.attDate = _data["attDate"] ? moment(_data["attDate"].toString()) : <any>undefined;
            this.dutyFrom = _data["dutyFrom"] ? moment(_data["dutyFrom"].toString()) : <any>undefined;
            this.dutyTo = _data["dutyTo"] ? moment(_data["dutyTo"].toString()) : <any>undefined;
            this.attDays = _data["attDays"];
            this.absenceNums = _data["absenceNums"];
            this.restDays = _data["restDays"];
            this.standardLobor = _data["standardLobor"];
            this.factLabor = _data["factLabor"];
            this.ot = _data["ot"];
            this.oT1 = _data["oT1"];
            this.oT2 = _data["oT2"];
            this.oT3 = _data["oT3"];
            this.lateMinutes = _data["lateMinutes"];
            this.earlyMinutes = _data["earlyMinutes"];
            this.absentHours = _data["absentHours"];
            this.abnormalType = _data["abnormalType"];
            this.abnormalTypeCode = _data["abnormalTypeCode"];
            this.signCardNums = _data["signCardNums"];
            this.brHours = _data["brHours"];
            this.ssHours = _data["ssHours"];
            this.hjHours = _data["hjHours"];
            this.cjHours = _data["cjHours"];
            this.njHours = _data["njHours"];
            this.gcHours = _data["gcHours"];
            this.gsHours = _data["gsHours"];
            this.pcHours = _data["pcHours"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.txHours = _data["txHours"];
            this.cjjHours = _data["cjjHours"];
            this.nightNums = _data["nightNums"];
            this.state = _data["state"];
            this.stateCode = _data["stateCode"];
            this.auditUserName = _data["auditUserName"];
            this.auditUserId = _data["auditUserId"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.selfCheckTime = _data["selfCheckTime"] ? moment(_data["selfCheckTime"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.orgManagerId = _data["orgManagerId"];
            this.clockInHours = _data["clockInHours"];
        }
    }

    static fromJS(data: any): EmpattdailyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattdailyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["empType"] = this.empType;
        data["empId"] = this.empId;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["companyId"] = this.companyId;
        data["departmentName"] = this.departmentName;
        data["shiftName"] = this.shiftName;
        data["shiftCode"] = this.shiftCode;
        data["smartShiftCode"] = this.smartShiftCode;
        data["smartShiftName"] = this.smartShiftName;
        data["attDate"] = this.attDate ? this.attDate.toISOString() : <any>undefined;
        data["dutyFrom"] = this.dutyFrom ? this.dutyFrom.toISOString() : <any>undefined;
        data["dutyTo"] = this.dutyTo ? this.dutyTo.toISOString() : <any>undefined;
        data["attDays"] = this.attDays;
        data["absenceNums"] = this.absenceNums;
        data["restDays"] = this.restDays;
        data["standardLobor"] = this.standardLobor;
        data["factLabor"] = this.factLabor;
        data["ot"] = this.ot;
        data["oT1"] = this.oT1;
        data["oT2"] = this.oT2;
        data["oT3"] = this.oT3;
        data["lateMinutes"] = this.lateMinutes;
        data["earlyMinutes"] = this.earlyMinutes;
        data["absentHours"] = this.absentHours;
        data["abnormalType"] = this.abnormalType;
        data["abnormalTypeCode"] = this.abnormalTypeCode;
        data["signCardNums"] = this.signCardNums;
        data["brHours"] = this.brHours;
        data["ssHours"] = this.ssHours;
        data["hjHours"] = this.hjHours;
        data["cjHours"] = this.cjHours;
        data["njHours"] = this.njHours;
        data["gcHours"] = this.gcHours;
        data["gsHours"] = this.gsHours;
        data["pcHours"] = this.pcHours;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["txHours"] = this.txHours;
        data["cjjHours"] = this.cjjHours;
        data["nightNums"] = this.nightNums;
        data["state"] = this.state;
        data["stateCode"] = this.stateCode;
        data["auditUserName"] = this.auditUserName;
        data["auditUserId"] = this.auditUserId;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["selfCheckTime"] = this.selfCheckTime ? this.selfCheckTime.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["orgManagerId"] = this.orgManagerId;
        data["clockInHours"] = this.clockInHours;
        return data;
    }

    clone(): EmpattdailyListDto {
        const json = this.toJSON();
        let result = new EmpattdailyListDto();
        result.init(json);
        return result;
    }
}

export interface IEmpattdailyListDto {
    id: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    empId: number | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 公司 */
    companyName: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentName: string | undefined;
    /** 班次 */
    shiftName: string | undefined;
    /** 班次代码 */
    shiftCode: string | undefined;
    /** 智能识别班次 */
    smartShiftCode: string | undefined;
    smartShiftName: string | undefined;
    /** 考勤日期 */
    attDate: moment.Moment | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 缺勤次数 */
    absenceNums: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工) */
    abnormalType: string | undefined;
    /** 异常类型代码 */
    abnormalTypeCode: string | undefined;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核 2：已审核 3：员工已确认 4:已结账) */
    state: string | undefined;
    /** 状态代码 */
    stateCode: string | undefined;
    /** 审核人 */
    auditUserName: string | undefined;
    auditUserId: number | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 部门管理员Id */
    orgManagerId: number | undefined;
    /** 打卡出勤/时 */
    clockInHours: number | undefined;
}

export class PagedResultDtoOfEmpattdailyListDto implements IPagedResultDtoOfEmpattdailyListDto {
    totalCount: number;
    items: EmpattdailyListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmpattdailyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmpattdailyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmpattdailyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmpattdailyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEmpattdailyListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmpattdailyListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmpattdailyListDto {
    totalCount: number;
    items: EmpattdailyListDto[] | undefined;
}

export class UpdateStateDto implements IUpdateStateDto {
    ids: number[] | undefined;
    stateCode: string | undefined;

    constructor(data?: IUpdateStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): UpdateStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): UpdateStateDto {
        const json = this.toJSON();
        let result = new UpdateStateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStateDto {
    ids: number[] | undefined;
    stateCode: string | undefined;
}

export class EmpattmonthlyAnalysisDtos implements IEmpattmonthlyAnalysisDtos {
    /** 员工(可多选，多个用，隔开) */
    userIds: string | undefined;
    /** 公司 */
    companyId: string | undefined;
    /** 部门 */
    departmentId: string | undefined;
    /** 考勤组 */
    attGroupId: string | undefined;
    year: number;
    month: number;

    constructor(data?: IEmpattmonthlyAnalysisDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIds = _data["userIds"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.attGroupId = _data["attGroupId"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): EmpattmonthlyAnalysisDtos {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattmonthlyAnalysisDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIds"] = this.userIds;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["attGroupId"] = this.attGroupId;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }

    clone(): EmpattmonthlyAnalysisDtos {
        const json = this.toJSON();
        let result = new EmpattmonthlyAnalysisDtos();
        result.init(json);
        return result;
    }
}

export interface IEmpattmonthlyAnalysisDtos {
    /** 员工(可多选，多个用，隔开) */
    userIds: string | undefined;
    /** 公司 */
    companyId: string | undefined;
    /** 部门 */
    departmentId: string | undefined;
    /** 考勤组 */
    attGroupId: string | undefined;
    year: number;
    month: number;
}

export class EmpAttWeekListDto implements IEmpAttWeekListDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 名称 */
    empName: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 缺勤天数 */
    absenceDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工分钟数 */
    absentHours: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 哺乳假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出假时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 周末有薪假时数 */
    weekendPaidLeave: number;
    /** 有薪假时数 */
    paidLeaveHours: number;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    state: string | undefined;
    /** 周末应出勤时/时 */
    weekStandardLobor: number | undefined;
    /** 周末实际出勤/时 */
    weekFactLabor: number | undefined;
    /** 周末病假时数 */
    weekBjHours: number;
    /** 周末事假/时 */
    weekSjHours: number;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 三级部门 */
    threeDepartment: string | undefined;
    /** 入职日期 */
    hireDate: string | undefined;
    /** 离职日期 */
    termDate: string | undefined;
    /** 员工Id */
    empId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    department: string | undefined;
    /** 公司ID */
    companyId: number | undefined;
    company: string | undefined;

    constructor(data?: IEmpAttWeekListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.empName = _data["empName"];
            this.empType = _data["empType"];
            this.attDays = _data["attDays"];
            this.absenceDays = _data["absenceDays"];
            this.restDays = _data["restDays"];
            this.standardLobor = _data["standardLobor"];
            this.factLabor = _data["factLabor"];
            this.nightNums = _data["nightNums"];
            this.lateNums = _data["lateNums"];
            this.earlyNums = _data["earlyNums"];
            this.absentNums = _data["absentNums"];
            this.lateMinutes = _data["lateMinutes"];
            this.earlyMinutes = _data["earlyMinutes"];
            this.absentHours = _data["absentHours"];
            this.ot = _data["ot"];
            this.oT1 = _data["oT1"];
            this.oT2 = _data["oT2"];
            this.oT3 = _data["oT3"];
            this.brHours = _data["brHours"];
            this.ssHours = _data["ssHours"];
            this.hjHours = _data["hjHours"];
            this.cjHours = _data["cjHours"];
            this.njHours = _data["njHours"];
            this.gcHours = _data["gcHours"];
            this.gsHours = _data["gsHours"];
            this.pcHours = _data["pcHours"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.txHours = _data["txHours"];
            this.cjjHours = _data["cjjHours"];
            this.weekendPaidLeave = _data["weekendPaidLeave"];
            this.paidLeaveHours = _data["paidLeaveHours"];
            this.signCardNums = _data["signCardNums"];
            this.state = _data["state"];
            this.weekStandardLobor = _data["weekStandardLobor"];
            this.weekFactLabor = _data["weekFactLabor"];
            this.weekBjHours = _data["weekBjHours"];
            this.weekSjHours = _data["weekSjHours"];
            this.twoDepartment = _data["twoDepartment"];
            this.threeDepartment = _data["threeDepartment"];
            this.hireDate = _data["hireDate"];
            this.termDate = _data["termDate"];
            this.empId = _data["empId"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"];
            this.companyId = _data["companyId"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): EmpAttWeekListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpAttWeekListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["empName"] = this.empName;
        data["empType"] = this.empType;
        data["attDays"] = this.attDays;
        data["absenceDays"] = this.absenceDays;
        data["restDays"] = this.restDays;
        data["standardLobor"] = this.standardLobor;
        data["factLabor"] = this.factLabor;
        data["nightNums"] = this.nightNums;
        data["lateNums"] = this.lateNums;
        data["earlyNums"] = this.earlyNums;
        data["absentNums"] = this.absentNums;
        data["lateMinutes"] = this.lateMinutes;
        data["earlyMinutes"] = this.earlyMinutes;
        data["absentHours"] = this.absentHours;
        data["ot"] = this.ot;
        data["oT1"] = this.oT1;
        data["oT2"] = this.oT2;
        data["oT3"] = this.oT3;
        data["brHours"] = this.brHours;
        data["ssHours"] = this.ssHours;
        data["hjHours"] = this.hjHours;
        data["cjHours"] = this.cjHours;
        data["njHours"] = this.njHours;
        data["gcHours"] = this.gcHours;
        data["gsHours"] = this.gsHours;
        data["pcHours"] = this.pcHours;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["txHours"] = this.txHours;
        data["cjjHours"] = this.cjjHours;
        data["weekendPaidLeave"] = this.weekendPaidLeave;
        data["paidLeaveHours"] = this.paidLeaveHours;
        data["signCardNums"] = this.signCardNums;
        data["state"] = this.state;
        data["weekStandardLobor"] = this.weekStandardLobor;
        data["weekFactLabor"] = this.weekFactLabor;
        data["weekBjHours"] = this.weekBjHours;
        data["weekSjHours"] = this.weekSjHours;
        data["twoDepartment"] = this.twoDepartment;
        data["threeDepartment"] = this.threeDepartment;
        data["hireDate"] = this.hireDate;
        data["termDate"] = this.termDate;
        data["empId"] = this.empId;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department;
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        return data;
    }

    clone(): EmpAttWeekListDto {
        const json = this.toJSON();
        let result = new EmpAttWeekListDto();
        result.init(json);
        return result;
    }
}

export interface IEmpAttWeekListDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 名称 */
    empName: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 缺勤天数 */
    absenceDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工分钟数 */
    absentHours: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 哺乳假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出假时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 周末有薪假时数 */
    weekendPaidLeave: number;
    /** 有薪假时数 */
    paidLeaveHours: number;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    state: string | undefined;
    /** 周末应出勤时/时 */
    weekStandardLobor: number | undefined;
    /** 周末实际出勤/时 */
    weekFactLabor: number | undefined;
    /** 周末病假时数 */
    weekBjHours: number;
    /** 周末事假/时 */
    weekSjHours: number;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 三级部门 */
    threeDepartment: string | undefined;
    /** 入职日期 */
    hireDate: string | undefined;
    /** 离职日期 */
    termDate: string | undefined;
    /** 员工Id */
    empId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    department: string | undefined;
    /** 公司ID */
    companyId: number | undefined;
    company: string | undefined;
}

export class PagedResultDtoOfEmpAttWeekListDto implements IPagedResultDtoOfEmpAttWeekListDto {
    totalCount: number;
    items: EmpAttWeekListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmpAttWeekListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmpAttWeekListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmpAttWeekListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmpAttWeekListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEmpAttWeekListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmpAttWeekListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmpAttWeekListDto {
    totalCount: number;
    items: EmpAttWeekListDto[] | undefined;
}

export class EmpAttMonthlyEditDto implements IEmpAttMonthlyEditDto {
    /** 员工 */
    empId: number | undefined;
    /** 考勤年 */
    attYear: number | undefined;
    /** 考勤月 */
    attMonth: number | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 缺勤天数 */
    absenceDays: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出假时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    state: string | undefined;
    /** 审核人 */
    auditUserId: number | undefined;
    auditUserRealName: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 结账人 */
    passUserId: number | undefined;
    passUserRealName: string | undefined;
    /** 结账时间 */
    passTime: moment.Moment | undefined;
    /** 周末应出勤时/时 */
    weekStandardLobor: number | undefined;
    /** 周末实际出勤/时 */
    weekFactLabor: number | undefined;
    /** 周末缺勤 */
    weekAbsence: number | undefined;
    /** 周末事假/时 */
    weekSjHours: number;
    /** 周末病假时数 */
    weekBjHours: number;
    /** 周末有薪假时数 */
    weekendPaidLeave: number;
    /** 国假缺勤(法定假日) */
    holidayAbsence: number | undefined;
    id: number;

    constructor(data?: IEmpAttMonthlyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.attYear = _data["attYear"];
            this.attMonth = _data["attMonth"];
            this.attDays = _data["attDays"];
            this.restDays = _data["restDays"];
            this.standardLobor = _data["standardLobor"];
            this.factLabor = _data["factLabor"];
            this.ot = _data["ot"];
            this.absenceDays = _data["absenceDays"];
            this.oT1 = _data["oT1"];
            this.oT2 = _data["oT2"];
            this.oT3 = _data["oT3"];
            this.lateNums = _data["lateNums"];
            this.earlyNums = _data["earlyNums"];
            this.absentNums = _data["absentNums"];
            this.lateMinutes = _data["lateMinutes"];
            this.earlyMinutes = _data["earlyMinutes"];
            this.absentHours = _data["absentHours"];
            this.cjjHours = _data["cjjHours"];
            this.signCardNums = _data["signCardNums"];
            this.brHours = _data["brHours"];
            this.ssHours = _data["ssHours"];
            this.hjHours = _data["hjHours"];
            this.cjHours = _data["cjHours"];
            this.njHours = _data["njHours"];
            this.gcHours = _data["gcHours"];
            this.gsHours = _data["gsHours"];
            this.pcHours = _data["pcHours"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.txHours = _data["txHours"];
            this.nightNums = _data["nightNums"];
            this.state = _data["state"];
            this.auditUserId = _data["auditUserId"];
            this.auditUserRealName = _data["auditUserRealName"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.selfCheckTime = _data["selfCheckTime"] ? moment(_data["selfCheckTime"].toString()) : <any>undefined;
            this.passUserId = _data["passUserId"];
            this.passUserRealName = _data["passUserRealName"];
            this.passTime = _data["passTime"] ? moment(_data["passTime"].toString()) : <any>undefined;
            this.weekStandardLobor = _data["weekStandardLobor"];
            this.weekFactLabor = _data["weekFactLabor"];
            this.weekAbsence = _data["weekAbsence"];
            this.weekSjHours = _data["weekSjHours"];
            this.weekBjHours = _data["weekBjHours"];
            this.weekendPaidLeave = _data["weekendPaidLeave"];
            this.holidayAbsence = _data["holidayAbsence"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmpAttMonthlyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpAttMonthlyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["attYear"] = this.attYear;
        data["attMonth"] = this.attMonth;
        data["attDays"] = this.attDays;
        data["restDays"] = this.restDays;
        data["standardLobor"] = this.standardLobor;
        data["factLabor"] = this.factLabor;
        data["ot"] = this.ot;
        data["absenceDays"] = this.absenceDays;
        data["oT1"] = this.oT1;
        data["oT2"] = this.oT2;
        data["oT3"] = this.oT3;
        data["lateNums"] = this.lateNums;
        data["earlyNums"] = this.earlyNums;
        data["absentNums"] = this.absentNums;
        data["lateMinutes"] = this.lateMinutes;
        data["earlyMinutes"] = this.earlyMinutes;
        data["absentHours"] = this.absentHours;
        data["cjjHours"] = this.cjjHours;
        data["signCardNums"] = this.signCardNums;
        data["brHours"] = this.brHours;
        data["ssHours"] = this.ssHours;
        data["hjHours"] = this.hjHours;
        data["cjHours"] = this.cjHours;
        data["njHours"] = this.njHours;
        data["gcHours"] = this.gcHours;
        data["gsHours"] = this.gsHours;
        data["pcHours"] = this.pcHours;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["txHours"] = this.txHours;
        data["nightNums"] = this.nightNums;
        data["state"] = this.state;
        data["auditUserId"] = this.auditUserId;
        data["auditUserRealName"] = this.auditUserRealName;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["selfCheckTime"] = this.selfCheckTime ? this.selfCheckTime.toISOString() : <any>undefined;
        data["passUserId"] = this.passUserId;
        data["passUserRealName"] = this.passUserRealName;
        data["passTime"] = this.passTime ? this.passTime.toISOString() : <any>undefined;
        data["weekStandardLobor"] = this.weekStandardLobor;
        data["weekFactLabor"] = this.weekFactLabor;
        data["weekAbsence"] = this.weekAbsence;
        data["weekSjHours"] = this.weekSjHours;
        data["weekBjHours"] = this.weekBjHours;
        data["weekendPaidLeave"] = this.weekendPaidLeave;
        data["holidayAbsence"] = this.holidayAbsence;
        data["id"] = this.id;
        return data;
    }

    clone(): EmpAttMonthlyEditDto {
        const json = this.toJSON();
        let result = new EmpAttMonthlyEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmpAttMonthlyEditDto {
    /** 员工 */
    empId: number | undefined;
    /** 考勤年 */
    attYear: number | undefined;
    /** 考勤月 */
    attMonth: number | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 缺勤天数 */
    absenceDays: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出假时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    state: string | undefined;
    /** 审核人 */
    auditUserId: number | undefined;
    auditUserRealName: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 结账人 */
    passUserId: number | undefined;
    passUserRealName: string | undefined;
    /** 结账时间 */
    passTime: moment.Moment | undefined;
    /** 周末应出勤时/时 */
    weekStandardLobor: number | undefined;
    /** 周末实际出勤/时 */
    weekFactLabor: number | undefined;
    /** 周末缺勤 */
    weekAbsence: number | undefined;
    /** 周末事假/时 */
    weekSjHours: number;
    /** 周末病假时数 */
    weekBjHours: number;
    /** 周末有薪假时数 */
    weekendPaidLeave: number;
    /** 国假缺勤(法定假日) */
    holidayAbsence: number | undefined;
    id: number;
}

/** 月度考勤汇总 */
export class MonthAttAll implements IMonthAttAll {
    id: number;
    /** 考勤年 */
    attYear: number;
    /** 考勤月 */
    attMonth: number;
    /** 出勤天数 */
    attDays: number;
    /** 加班时数 */
    ot: number;
    /** 缺勤天数 */
    offDutyDay: number;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    stateName: string | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    stateCode: string | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;

    constructor(data?: IMonthAttAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attYear = _data["attYear"];
            this.attMonth = _data["attMonth"];
            this.attDays = _data["attDays"];
            this.ot = _data["ot"];
            this.offDutyDay = _data["offDutyDay"];
            this.lateNums = _data["lateNums"];
            this.earlyNums = _data["earlyNums"];
            this.stateName = _data["stateName"];
            this.stateCode = _data["stateCode"];
            this.absentNums = _data["absentNums"];
        }
    }

    static fromJS(data: any): MonthAttAll {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attYear"] = this.attYear;
        data["attMonth"] = this.attMonth;
        data["attDays"] = this.attDays;
        data["ot"] = this.ot;
        data["offDutyDay"] = this.offDutyDay;
        data["lateNums"] = this.lateNums;
        data["earlyNums"] = this.earlyNums;
        data["stateName"] = this.stateName;
        data["stateCode"] = this.stateCode;
        data["absentNums"] = this.absentNums;
        return data;
    }

    clone(): MonthAttAll {
        const json = this.toJSON();
        let result = new MonthAttAll();
        result.init(json);
        return result;
    }
}

/** 月度考勤汇总 */
export interface IMonthAttAll {
    id: number;
    /** 考勤年 */
    attYear: number;
    /** 考勤月 */
    attMonth: number;
    /** 出勤天数 */
    attDays: number;
    /** 加班时数 */
    ot: number;
    /** 缺勤天数 */
    offDutyDay: number;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    stateName: string | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    stateCode: string | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
}

export class MonthAttDetail implements IMonthAttDetail {
    /** 名称 */
    name: string | undefined;
    /** 值 */
    value: string | undefined;

    constructor(data?: IMonthAttDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MonthAttDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): MonthAttDetail {
        const json = this.toJSON();
        let result = new MonthAttDetail();
        result.init(json);
        return result;
    }
}

export interface IMonthAttDetail {
    /** 名称 */
    name: string | undefined;
    /** 值 */
    value: string | undefined;
}

export class CheckInRecord implements ICheckInRecord {
    empId: number;
    checkTime: moment.Moment;
    checkType: string | undefined;
    upDownCheck: string | undefined;
    checkPoint: string | undefined;
    cardNumber: string | undefined;
    checkAddress: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    distance: number | undefined;
    wifiMac: string | undefined;
    signalStrength: string | undefined;
    zkId: number | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: ICheckInRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.checkTime = _data["checkTime"] ? moment(_data["checkTime"].toString()) : <any>undefined;
            this.checkType = _data["checkType"];
            this.upDownCheck = _data["upDownCheck"];
            this.checkPoint = _data["checkPoint"];
            this.cardNumber = _data["cardNumber"];
            this.checkAddress = _data["checkAddress"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.distance = _data["distance"];
            this.wifiMac = _data["wifiMac"];
            this.signalStrength = _data["signalStrength"];
            this.zkId = _data["zkId"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CheckInRecord {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["checkType"] = this.checkType;
        data["upDownCheck"] = this.upDownCheck;
        data["checkPoint"] = this.checkPoint;
        data["cardNumber"] = this.cardNumber;
        data["checkAddress"] = this.checkAddress;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["distance"] = this.distance;
        data["wifiMac"] = this.wifiMac;
        data["signalStrength"] = this.signalStrength;
        data["zkId"] = this.zkId;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): CheckInRecord {
        const json = this.toJSON();
        let result = new CheckInRecord();
        result.init(json);
        return result;
    }
}

export interface ICheckInRecord {
    empId: number;
    checkTime: moment.Moment;
    checkType: string | undefined;
    upDownCheck: string | undefined;
    checkPoint: string | undefined;
    cardNumber: string | undefined;
    checkAddress: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    distance: number | undefined;
    wifiMac: string | undefined;
    signalStrength: string | undefined;
    zkId: number | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class AttendanceGroup implements IAttendanceGroup {
    name: string | undefined;
    attendanceType: string | undefined;
    checkInType: string | undefined;
    shiftCodes: string | undefined;
    cycleDays: number | undefined;
    cycleName: string | undefined;
    ruleShiftCodes: string | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: IAttendanceGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attendanceType = _data["attendanceType"];
            this.checkInType = _data["checkInType"];
            this.shiftCodes = _data["shiftCodes"];
            this.cycleDays = _data["cycleDays"];
            this.cycleName = _data["cycleName"];
            this.ruleShiftCodes = _data["ruleShiftCodes"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attendanceType"] = this.attendanceType;
        data["checkInType"] = this.checkInType;
        data["shiftCodes"] = this.shiftCodes;
        data["cycleDays"] = this.cycleDays;
        data["cycleName"] = this.cycleName;
        data["ruleShiftCodes"] = this.ruleShiftCodes;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): AttendanceGroup {
        const json = this.toJSON();
        let result = new AttendanceGroup();
        result.init(json);
        return result;
    }
}

export interface IAttendanceGroup {
    name: string | undefined;
    attendanceType: string | undefined;
    checkInType: string | undefined;
    shiftCodes: string | undefined;
    cycleDays: number | undefined;
    cycleName: string | undefined;
    ruleShiftCodes: string | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class CheckInAddress implements ICheckInAddress {
    attendanceGroupId: number;
    attendanceGroup: AttendanceGroup;
    name: string | undefined;
    detailedAddress: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    validLimit: number;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: ICheckInAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceGroupId = _data["attendanceGroupId"];
            this.attendanceGroup = _data["attendanceGroup"] ? AttendanceGroup.fromJS(_data["attendanceGroup"]) : <any>undefined;
            this.name = _data["name"];
            this.detailedAddress = _data["detailedAddress"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.validLimit = _data["validLimit"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CheckInAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceGroupId"] = this.attendanceGroupId;
        data["attendanceGroup"] = this.attendanceGroup ? this.attendanceGroup.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["detailedAddress"] = this.detailedAddress;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["validLimit"] = this.validLimit;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): CheckInAddress {
        const json = this.toJSON();
        let result = new CheckInAddress();
        result.init(json);
        return result;
    }
}

export interface ICheckInAddress {
    attendanceGroupId: number;
    attendanceGroup: AttendanceGroup;
    name: string | undefined;
    detailedAddress: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    validLimit: number;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class GetMonthPointDto implements IGetMonthPointDto {
    /** 打卡记录 */
    checkInRecordList: CheckInRecord[] | undefined;
    /** 考勤组打卡地址 */
    checkInAddressList: CheckInAddress[] | undefined;

    constructor(data?: IGetMonthPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checkInRecordList"])) {
                this.checkInRecordList = [] as any;
                for (let item of _data["checkInRecordList"])
                    this.checkInRecordList.push(CheckInRecord.fromJS(item));
            }
            if (Array.isArray(_data["checkInAddressList"])) {
                this.checkInAddressList = [] as any;
                for (let item of _data["checkInAddressList"])
                    this.checkInAddressList.push(CheckInAddress.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMonthPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checkInRecordList)) {
            data["checkInRecordList"] = [];
            for (let item of this.checkInRecordList)
                data["checkInRecordList"].push(item.toJSON());
        }
        if (Array.isArray(this.checkInAddressList)) {
            data["checkInAddressList"] = [];
            for (let item of this.checkInAddressList)
                data["checkInAddressList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetMonthPointDto {
        const json = this.toJSON();
        let result = new GetMonthPointDto();
        result.init(json);
        return result;
    }
}

export interface IGetMonthPointDto {
    /** 打卡记录 */
    checkInRecordList: CheckInRecord[] | undefined;
    /** 考勤组打卡地址 */
    checkInAddressList: CheckInAddress[] | undefined;
}

export class EmpattmonthlyListDto implements IEmpattmonthlyListDto {
    /** 考勤月汇总ID */
    id: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 缺勤天数 */
    absenceDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工分钟数 */
    absentHours: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 哺乳假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出假时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 周末有薪假时数 */
    weekendPaidLeave: number;
    /** 有薪假时数 */
    paidLeaveHours: number;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    state: string | undefined;
    /** 周末应出勤时/时 */
    weekStandardLobor: number | undefined;
    /** 周末实际出勤/时 */
    weekFactLabor: number | undefined;
    /** 周末病假时数 */
    weekBjHours: number;
    /** 周末事假/时 */
    weekSjHours: number;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 三级部门 */
    threeDepartment: string | undefined;
    /** 入职日期 */
    hireDate: string | undefined;
    /** 离职日期 */
    termDate: string | undefined;
    /** 国假缺勤(法定假日) */
    holidayAbsence: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    stateCode: string | undefined;
    /** 审核人Id */
    auditUserId: number | undefined;
    /** 审核人 */
    auditUserName: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 员工自助确认状态 */
    selfCheckState: string | undefined;
    /** 结账人Id */
    passUserId: number | undefined;
    /** 结账人 */
    passUserName: string | undefined;
    /** 结账时间 */
    passTime: moment.Moment | undefined;
    /** 考勤年 */
    attYear: number | undefined;
    /** 考勤月 */
    attMonth: number | undefined;
    /** 员工Id */
    empId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    department: string | undefined;
    /** 部门管理员Id */
    orgManagerId: number | undefined;
    /** 公司ID */
    companyId: number | undefined;
    company: string | undefined;
    /** 周末缺勤 */
    weekAbsence: number | undefined;
    /** 打卡出勤/时 */
    clockInHours: number | undefined;

    constructor(data?: IEmpattmonthlyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.empType = _data["empType"];
            this.attDays = _data["attDays"];
            this.absenceDays = _data["absenceDays"];
            this.restDays = _data["restDays"];
            this.standardLobor = _data["standardLobor"];
            this.factLabor = _data["factLabor"];
            this.nightNums = _data["nightNums"];
            this.lateNums = _data["lateNums"];
            this.earlyNums = _data["earlyNums"];
            this.absentNums = _data["absentNums"];
            this.lateMinutes = _data["lateMinutes"];
            this.earlyMinutes = _data["earlyMinutes"];
            this.absentHours = _data["absentHours"];
            this.ot = _data["ot"];
            this.oT1 = _data["oT1"];
            this.oT2 = _data["oT2"];
            this.oT3 = _data["oT3"];
            this.brHours = _data["brHours"];
            this.ssHours = _data["ssHours"];
            this.hjHours = _data["hjHours"];
            this.cjHours = _data["cjHours"];
            this.njHours = _data["njHours"];
            this.gcHours = _data["gcHours"];
            this.gsHours = _data["gsHours"];
            this.pcHours = _data["pcHours"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.txHours = _data["txHours"];
            this.cjjHours = _data["cjjHours"];
            this.weekendPaidLeave = _data["weekendPaidLeave"];
            this.paidLeaveHours = _data["paidLeaveHours"];
            this.signCardNums = _data["signCardNums"];
            this.state = _data["state"];
            this.weekStandardLobor = _data["weekStandardLobor"];
            this.weekFactLabor = _data["weekFactLabor"];
            this.weekBjHours = _data["weekBjHours"];
            this.weekSjHours = _data["weekSjHours"];
            this.twoDepartment = _data["twoDepartment"];
            this.threeDepartment = _data["threeDepartment"];
            this.hireDate = _data["hireDate"];
            this.termDate = _data["termDate"];
            this.holidayAbsence = _data["holidayAbsence"];
            this.stateCode = _data["stateCode"];
            this.auditUserId = _data["auditUserId"];
            this.auditUserName = _data["auditUserName"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.selfCheckTime = _data["selfCheckTime"] ? moment(_data["selfCheckTime"].toString()) : <any>undefined;
            this.selfCheckState = _data["selfCheckState"];
            this.passUserId = _data["passUserId"];
            this.passUserName = _data["passUserName"];
            this.passTime = _data["passTime"] ? moment(_data["passTime"].toString()) : <any>undefined;
            this.attYear = _data["attYear"];
            this.attMonth = _data["attMonth"];
            this.empId = _data["empId"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"];
            this.orgManagerId = _data["orgManagerId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"];
            this.weekAbsence = _data["weekAbsence"];
            this.clockInHours = _data["clockInHours"];
        }
    }

    static fromJS(data: any): EmpattmonthlyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattmonthlyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["empType"] = this.empType;
        data["attDays"] = this.attDays;
        data["absenceDays"] = this.absenceDays;
        data["restDays"] = this.restDays;
        data["standardLobor"] = this.standardLobor;
        data["factLabor"] = this.factLabor;
        data["nightNums"] = this.nightNums;
        data["lateNums"] = this.lateNums;
        data["earlyNums"] = this.earlyNums;
        data["absentNums"] = this.absentNums;
        data["lateMinutes"] = this.lateMinutes;
        data["earlyMinutes"] = this.earlyMinutes;
        data["absentHours"] = this.absentHours;
        data["ot"] = this.ot;
        data["oT1"] = this.oT1;
        data["oT2"] = this.oT2;
        data["oT3"] = this.oT3;
        data["brHours"] = this.brHours;
        data["ssHours"] = this.ssHours;
        data["hjHours"] = this.hjHours;
        data["cjHours"] = this.cjHours;
        data["njHours"] = this.njHours;
        data["gcHours"] = this.gcHours;
        data["gsHours"] = this.gsHours;
        data["pcHours"] = this.pcHours;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["txHours"] = this.txHours;
        data["cjjHours"] = this.cjjHours;
        data["weekendPaidLeave"] = this.weekendPaidLeave;
        data["paidLeaveHours"] = this.paidLeaveHours;
        data["signCardNums"] = this.signCardNums;
        data["state"] = this.state;
        data["weekStandardLobor"] = this.weekStandardLobor;
        data["weekFactLabor"] = this.weekFactLabor;
        data["weekBjHours"] = this.weekBjHours;
        data["weekSjHours"] = this.weekSjHours;
        data["twoDepartment"] = this.twoDepartment;
        data["threeDepartment"] = this.threeDepartment;
        data["hireDate"] = this.hireDate;
        data["termDate"] = this.termDate;
        data["holidayAbsence"] = this.holidayAbsence;
        data["stateCode"] = this.stateCode;
        data["auditUserId"] = this.auditUserId;
        data["auditUserName"] = this.auditUserName;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["selfCheckTime"] = this.selfCheckTime ? this.selfCheckTime.toISOString() : <any>undefined;
        data["selfCheckState"] = this.selfCheckState;
        data["passUserId"] = this.passUserId;
        data["passUserName"] = this.passUserName;
        data["passTime"] = this.passTime ? this.passTime.toISOString() : <any>undefined;
        data["attYear"] = this.attYear;
        data["attMonth"] = this.attMonth;
        data["empId"] = this.empId;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department;
        data["orgManagerId"] = this.orgManagerId;
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        data["weekAbsence"] = this.weekAbsence;
        data["clockInHours"] = this.clockInHours;
        return data;
    }

    clone(): EmpattmonthlyListDto {
        const json = this.toJSON();
        let result = new EmpattmonthlyListDto();
        result.init(json);
        return result;
    }
}

export interface IEmpattmonthlyListDto {
    /** 考勤月汇总ID */
    id: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 缺勤天数 */
    absenceDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 迟到次数 */
    lateNums: number | undefined;
    /** 早退次数 */
    earlyNums: number | undefined;
    /** 旷工次数 */
    absentNums: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工分钟数 */
    absentHours: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 哺乳假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出假时数 */
    gcHours: number | undefined;
    /** 工伤假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 产检假 */
    cjjHours: number;
    /** 周末有薪假时数 */
    weekendPaidLeave: number;
    /** 有薪假时数 */
    paidLeaveHours: number;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    state: string | undefined;
    /** 周末应出勤时/时 */
    weekStandardLobor: number | undefined;
    /** 周末实际出勤/时 */
    weekFactLabor: number | undefined;
    /** 周末病假时数 */
    weekBjHours: number;
    /** 周末事假/时 */
    weekSjHours: number;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 三级部门 */
    threeDepartment: string | undefined;
    /** 入职日期 */
    hireDate: string | undefined;
    /** 离职日期 */
    termDate: string | undefined;
    /** 国假缺勤(法定假日) */
    holidayAbsence: number | undefined;
    /** 状态(1:待审核、2：已审核、3:员工已确认、4:已结账)--数据字典 */
    stateCode: string | undefined;
    /** 审核人Id */
    auditUserId: number | undefined;
    /** 审核人 */
    auditUserName: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 员工自助确认状态 */
    selfCheckState: string | undefined;
    /** 结账人Id */
    passUserId: number | undefined;
    /** 结账人 */
    passUserName: string | undefined;
    /** 结账时间 */
    passTime: moment.Moment | undefined;
    /** 考勤年 */
    attYear: number | undefined;
    /** 考勤月 */
    attMonth: number | undefined;
    /** 员工Id */
    empId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    department: string | undefined;
    /** 部门管理员Id */
    orgManagerId: number | undefined;
    /** 公司ID */
    companyId: number | undefined;
    company: string | undefined;
    /** 周末缺勤 */
    weekAbsence: number | undefined;
    /** 打卡出勤/时 */
    clockInHours: number | undefined;
}

export class PagedResultDtoOfEmpattmonthlyListDto implements IPagedResultDtoOfEmpattmonthlyListDto {
    totalCount: number;
    items: EmpattmonthlyListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmpattmonthlyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmpattmonthlyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmpattmonthlyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmpattmonthlyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEmpattmonthlyListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmpattmonthlyListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmpattmonthlyListDto {
    totalCount: number;
    items: EmpattmonthlyListDto[] | undefined;
}

export class EmpattmonthlyUpdateStateDto implements IEmpattmonthlyUpdateStateDto {
    ids: number[] | undefined;
    stateCode: string | undefined;

    constructor(data?: IEmpattmonthlyUpdateStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
            this.stateCode = _data["stateCode"];
        }
    }

    static fromJS(data: any): EmpattmonthlyUpdateStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattmonthlyUpdateStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["stateCode"] = this.stateCode;
        return data;
    }

    clone(): EmpattmonthlyUpdateStateDto {
        const json = this.toJSON();
        let result = new EmpattmonthlyUpdateStateDto();
        result.init(json);
        return result;
    }
}

export interface IEmpattmonthlyUpdateStateDto {
    ids: number[] | undefined;
    stateCode: string | undefined;
}

export class WeekAnalysisDtoInput implements IWeekAnalysisDtoInput {
    startTime: moment.Moment;
    endTime: moment.Moment;
    /** 员工(可多选，多个用，隔开) */
    userIds: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 考勤组 */
    attGroupId: number | undefined;

    constructor(data?: IWeekAnalysisDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.userIds = _data["userIds"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.attGroupId = _data["attGroupId"];
        }
    }

    static fromJS(data: any): WeekAnalysisDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new WeekAnalysisDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["userIds"] = this.userIds;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["attGroupId"] = this.attGroupId;
        return data;
    }

    clone(): WeekAnalysisDtoInput {
        const json = this.toJSON();
        let result = new WeekAnalysisDtoInput();
        result.init(json);
        return result;
    }
}

export interface IWeekAnalysisDtoInput {
    startTime: moment.Moment;
    endTime: moment.Moment;
    /** 员工(可多选，多个用，隔开) */
    userIds: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 考勤组 */
    attGroupId: number | undefined;
}

/** 的列表DTO QYB.QYBProduct.Organization.Employee.Employee */
export class EmployeeEditDto implements IEmployeeEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    userId: number | undefined;
    /** RealName */
    realName: string | undefined;
    /** GenderCode */
    genderCode: string | undefined;
    /** Mobile */
    mobile: string | undefined;
    /** CompanyId */
    companyId: number | undefined;
    company: Company;
    /** DepartmentId */
    departmentId: number | undefined;
    /** Birthday */
    birthday: moment.Moment | undefined;
    /** HireDate */
    hireDate: moment.Moment | undefined;
    /** ProbationMonth */
    probationMonth: number | undefined;
    /** RegularDate */
    regularDate: moment.Moment | undefined;
    /** TermDate */
    termDate: moment.Moment | undefined;
    /** EmpStateCode */
    empStateCode: string | undefined;
    /** MaritalStatusCode */
    maritalStatusCode: string | undefined;
    /** EmpTypeCode */
    empTypeCode: string | undefined;
    /** PoliticsStatusCode */
    politicsStatusCode: string | undefined;
    /** JobNumber */
    jobNumber: string | undefined;
    /** UserPictureType */
    userPictureType: string | undefined;
    /** IdentityCard */
    identityCard: string | undefined;
    /** CardIsLongTerm */
    cardIsLongTerm: boolean | undefined;
    /** IdentityValidity */
    identityValidity: moment.Moment | undefined;
    /** IdentityAddress */
    identityAddress: string | undefined;
    /** PresentAddress */
    presentAddress: string | undefined;
    /** NationCode */
    nationCode: string | undefined;
    /** NativePlace */
    nativePlace: string | undefined;
    /** PostalCode */
    postalCode: string | undefined;
    /** PersonalServiceCode */
    personalServiceCode: string | undefined;
    /** ResidenceTypeCode */
    residenceTypeCode: string | undefined;
    /** RecruitmentSourceCode */
    recruitmentSourceCode: string | undefined;
    /** EducationsCode */
    educationsCode: string | undefined;
    /** FirstWorkDate */
    firstWorkDate: moment.Moment | undefined;
    /** OrgPostId */
    orgPostId: number | undefined;
    orgPost: OrgPost;
    /** ProbationGradeId */
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    /** RegularGradeId */
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    /** PersonalEmail */
    personalEmail: string | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** IdentityFaceImg */
    identityFaceImg: string | undefined;
    /** IdentityEmblemImg */
    identityEmblemImg: string | undefined;
    /** IdPhoto */
    idPhoto: string | undefined;
    /** SocialSecurity */
    socialSecurity: string | undefined;
    /** ReservedFunds */
    reservedFunds: string | undefined;
    /** CardNo */
    cardNo: string | undefined;
    /** BankName */
    bankName: string | undefined;
    /** 是否创建用户 */
    isCreateUser: boolean;
    /** 员工卡号 */
    rfid: string | undefined;
    /** 身份证开始日期 */
    identityStartDate: moment.Moment | undefined;
    /** 内部推荐人 */
    recommender: string | undefined;
    /** 保险类型 */
    insuranceType: string | undefined;

    constructor(data?: IEmployeeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.realName = _data["realName"];
            this.genderCode = _data["genderCode"];
            this.mobile = _data["mobile"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.empStateCode = _data["empStateCode"];
            this.maritalStatusCode = _data["maritalStatusCode"];
            this.empTypeCode = _data["empTypeCode"];
            this.politicsStatusCode = _data["politicsStatusCode"];
            this.jobNumber = _data["jobNumber"];
            this.userPictureType = _data["userPictureType"];
            this.identityCard = _data["identityCard"];
            this.cardIsLongTerm = _data["cardIsLongTerm"];
            this.identityValidity = _data["identityValidity"] ? moment(_data["identityValidity"].toString()) : <any>undefined;
            this.identityAddress = _data["identityAddress"];
            this.presentAddress = _data["presentAddress"];
            this.nationCode = _data["nationCode"];
            this.nativePlace = _data["nativePlace"];
            this.postalCode = _data["postalCode"];
            this.personalServiceCode = _data["personalServiceCode"];
            this.residenceTypeCode = _data["residenceTypeCode"];
            this.recruitmentSourceCode = _data["recruitmentSourceCode"];
            this.educationsCode = _data["educationsCode"];
            this.firstWorkDate = _data["firstWorkDate"] ? moment(_data["firstWorkDate"].toString()) : <any>undefined;
            this.orgPostId = _data["orgPostId"];
            this.orgPost = _data["orgPost"] ? OrgPost.fromJS(_data["orgPost"]) : <any>undefined;
            this.probationGradeId = _data["probationGradeId"];
            this.probationGrade = _data["probationGrade"] ? OrgPostGrade.fromJS(_data["probationGrade"]) : <any>undefined;
            this.regularGradeId = _data["regularGradeId"];
            this.regularGrade = _data["regularGrade"] ? OrgPostGrade.fromJS(_data["regularGrade"]) : <any>undefined;
            this.personalEmail = _data["personalEmail"];
            this.companyEmail = _data["companyEmail"];
            this.identityFaceImg = _data["identityFaceImg"];
            this.identityEmblemImg = _data["identityEmblemImg"];
            this.idPhoto = _data["idPhoto"];
            this.socialSecurity = _data["socialSecurity"];
            this.reservedFunds = _data["reservedFunds"];
            this.cardNo = _data["cardNo"];
            this.bankName = _data["bankName"];
            this.isCreateUser = _data["isCreateUser"];
            this.rfid = _data["rfid"];
            this.identityStartDate = _data["identityStartDate"] ? moment(_data["identityStartDate"].toString()) : <any>undefined;
            this.recommender = _data["recommender"];
            this.insuranceType = _data["insuranceType"];
        }
    }

    static fromJS(data: any): EmployeeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["realName"] = this.realName;
        data["genderCode"] = this.genderCode;
        data["mobile"] = this.mobile;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["empStateCode"] = this.empStateCode;
        data["maritalStatusCode"] = this.maritalStatusCode;
        data["empTypeCode"] = this.empTypeCode;
        data["politicsStatusCode"] = this.politicsStatusCode;
        data["jobNumber"] = this.jobNumber;
        data["userPictureType"] = this.userPictureType;
        data["identityCard"] = this.identityCard;
        data["cardIsLongTerm"] = this.cardIsLongTerm;
        data["identityValidity"] = this.identityValidity ? this.identityValidity.toISOString() : <any>undefined;
        data["identityAddress"] = this.identityAddress;
        data["presentAddress"] = this.presentAddress;
        data["nationCode"] = this.nationCode;
        data["nativePlace"] = this.nativePlace;
        data["postalCode"] = this.postalCode;
        data["personalServiceCode"] = this.personalServiceCode;
        data["residenceTypeCode"] = this.residenceTypeCode;
        data["recruitmentSourceCode"] = this.recruitmentSourceCode;
        data["educationsCode"] = this.educationsCode;
        data["firstWorkDate"] = this.firstWorkDate ? this.firstWorkDate.toISOString() : <any>undefined;
        data["orgPostId"] = this.orgPostId;
        data["orgPost"] = this.orgPost ? this.orgPost.toJSON() : <any>undefined;
        data["probationGradeId"] = this.probationGradeId;
        data["probationGrade"] = this.probationGrade ? this.probationGrade.toJSON() : <any>undefined;
        data["regularGradeId"] = this.regularGradeId;
        data["regularGrade"] = this.regularGrade ? this.regularGrade.toJSON() : <any>undefined;
        data["personalEmail"] = this.personalEmail;
        data["companyEmail"] = this.companyEmail;
        data["identityFaceImg"] = this.identityFaceImg;
        data["identityEmblemImg"] = this.identityEmblemImg;
        data["idPhoto"] = this.idPhoto;
        data["socialSecurity"] = this.socialSecurity;
        data["reservedFunds"] = this.reservedFunds;
        data["cardNo"] = this.cardNo;
        data["bankName"] = this.bankName;
        data["isCreateUser"] = this.isCreateUser;
        data["rfid"] = this.rfid;
        data["identityStartDate"] = this.identityStartDate ? this.identityStartDate.toISOString() : <any>undefined;
        data["recommender"] = this.recommender;
        data["insuranceType"] = this.insuranceType;
        return data;
    }

    clone(): EmployeeEditDto {
        const json = this.toJSON();
        let result = new EmployeeEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.Employee.Employee */
export interface IEmployeeEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    userId: number | undefined;
    /** RealName */
    realName: string | undefined;
    /** GenderCode */
    genderCode: string | undefined;
    /** Mobile */
    mobile: string | undefined;
    /** CompanyId */
    companyId: number | undefined;
    company: Company;
    /** DepartmentId */
    departmentId: number | undefined;
    /** Birthday */
    birthday: moment.Moment | undefined;
    /** HireDate */
    hireDate: moment.Moment | undefined;
    /** ProbationMonth */
    probationMonth: number | undefined;
    /** RegularDate */
    regularDate: moment.Moment | undefined;
    /** TermDate */
    termDate: moment.Moment | undefined;
    /** EmpStateCode */
    empStateCode: string | undefined;
    /** MaritalStatusCode */
    maritalStatusCode: string | undefined;
    /** EmpTypeCode */
    empTypeCode: string | undefined;
    /** PoliticsStatusCode */
    politicsStatusCode: string | undefined;
    /** JobNumber */
    jobNumber: string | undefined;
    /** UserPictureType */
    userPictureType: string | undefined;
    /** IdentityCard */
    identityCard: string | undefined;
    /** CardIsLongTerm */
    cardIsLongTerm: boolean | undefined;
    /** IdentityValidity */
    identityValidity: moment.Moment | undefined;
    /** IdentityAddress */
    identityAddress: string | undefined;
    /** PresentAddress */
    presentAddress: string | undefined;
    /** NationCode */
    nationCode: string | undefined;
    /** NativePlace */
    nativePlace: string | undefined;
    /** PostalCode */
    postalCode: string | undefined;
    /** PersonalServiceCode */
    personalServiceCode: string | undefined;
    /** ResidenceTypeCode */
    residenceTypeCode: string | undefined;
    /** RecruitmentSourceCode */
    recruitmentSourceCode: string | undefined;
    /** EducationsCode */
    educationsCode: string | undefined;
    /** FirstWorkDate */
    firstWorkDate: moment.Moment | undefined;
    /** OrgPostId */
    orgPostId: number | undefined;
    orgPost: OrgPost;
    /** ProbationGradeId */
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    /** RegularGradeId */
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    /** PersonalEmail */
    personalEmail: string | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** IdentityFaceImg */
    identityFaceImg: string | undefined;
    /** IdentityEmblemImg */
    identityEmblemImg: string | undefined;
    /** IdPhoto */
    idPhoto: string | undefined;
    /** SocialSecurity */
    socialSecurity: string | undefined;
    /** ReservedFunds */
    reservedFunds: string | undefined;
    /** CardNo */
    cardNo: string | undefined;
    /** BankName */
    bankName: string | undefined;
    /** 是否创建用户 */
    isCreateUser: boolean;
    /** 员工卡号 */
    rfid: string | undefined;
    /** 身份证开始日期 */
    identityStartDate: moment.Moment | undefined;
    /** 内部推荐人 */
    recommender: string | undefined;
    /** 保险类型 */
    insuranceType: string | undefined;
}

/** 用户信息编辑用Dto */
export class UserEditDto implements IUserEditDto {
    /** 员工ID */
    empId: number | undefined;
    /** 根据id是否有值来判断是创建还是添加 */
    id: number | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 真实姓名-------------------新增 */
    realName: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 泛微OA系统用户ID */
    weaverUserId: number | undefined;
    userName: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isLockoutEnabled: boolean;
    /** 需要修改密码 */
    needToChangeThePassword: boolean;
    /** 头像Id */
    profilePictureId: string | undefined;
    isTwoFactorEnabled: boolean;
    isActive: boolean;
    /** 员工卡ID */
    rfid: string | undefined;
    /** 公司邮箱 */
    emailAddress: string | undefined;
    /** 是否启用邮件通知 */
    enableEmail: boolean;
    /** 是否启用App推送 */
    enableAPPPush: boolean;
    /** 是否启用短信 */
    enableTextMessage: boolean;
    /** 是否启用企业微信通知 */
    enableWeComMessage: boolean;
    /** 是否仅限Ldap登录 */
    isOnlyLdapLogin: boolean;
    /** 域账号 */
    domainAccount: string | undefined;
    /** 企业微信UserId */
    weComUserId: string | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.id = _data["id"];
            this.userPictureType = _data["userPictureType"];
            this.realName = _data["realName"];
            this.remarks = _data["remarks"];
            this.weaverUserId = _data["weaverUserId"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.needToChangeThePassword = _data["needToChangeThePassword"];
            this.profilePictureId = _data["profilePictureId"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isActive = _data["isActive"];
            this.rfid = _data["rfid"];
            this.emailAddress = _data["emailAddress"];
            this.enableEmail = _data["enableEmail"];
            this.enableAPPPush = _data["enableAPPPush"];
            this.enableTextMessage = _data["enableTextMessage"];
            this.enableWeComMessage = _data["enableWeComMessage"];
            this.isOnlyLdapLogin = _data["isOnlyLdapLogin"];
            this.domainAccount = _data["domainAccount"];
            this.weComUserId = _data["weComUserId"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["id"] = this.id;
        data["userPictureType"] = this.userPictureType;
        data["realName"] = this.realName;
        data["remarks"] = this.remarks;
        data["weaverUserId"] = this.weaverUserId;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["needToChangeThePassword"] = this.needToChangeThePassword;
        data["profilePictureId"] = this.profilePictureId;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isActive"] = this.isActive;
        data["rfid"] = this.rfid;
        data["emailAddress"] = this.emailAddress;
        data["enableEmail"] = this.enableEmail;
        data["enableAPPPush"] = this.enableAPPPush;
        data["enableTextMessage"] = this.enableTextMessage;
        data["enableWeComMessage"] = this.enableWeComMessage;
        data["isOnlyLdapLogin"] = this.isOnlyLdapLogin;
        data["domainAccount"] = this.domainAccount;
        data["weComUserId"] = this.weComUserId;
        return data;
    }

    clone(): UserEditDto {
        const json = this.toJSON();
        let result = new UserEditDto();
        result.init(json);
        return result;
    }
}

/** 用户信息编辑用Dto */
export interface IUserEditDto {
    /** 员工ID */
    empId: number | undefined;
    /** 根据id是否有值来判断是创建还是添加 */
    id: number | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 真实姓名-------------------新增 */
    realName: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 泛微OA系统用户ID */
    weaverUserId: number | undefined;
    userName: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isLockoutEnabled: boolean;
    /** 需要修改密码 */
    needToChangeThePassword: boolean;
    /** 头像Id */
    profilePictureId: string | undefined;
    isTwoFactorEnabled: boolean;
    isActive: boolean;
    /** 员工卡ID */
    rfid: string | undefined;
    /** 公司邮箱 */
    emailAddress: string | undefined;
    /** 是否启用邮件通知 */
    enableEmail: boolean;
    /** 是否启用App推送 */
    enableAPPPush: boolean;
    /** 是否启用短信 */
    enableTextMessage: boolean;
    /** 是否启用企业微信通知 */
    enableWeComMessage: boolean;
    /** 是否仅限Ldap登录 */
    isOnlyLdapLogin: boolean;
    /** 域账号 */
    domainAccount: string | undefined;
    /** 企业微信UserId */
    weComUserId: string | undefined;
}

export class CreateOrUpdateEmployeeInput implements ICreateOrUpdateEmployeeInput {
    employee: EmployeeEditDto;
    user: UserEditDto;
    /** 授权的角色 */
    assignedRoleNames: string[];
    /** 流水号 */
    serialNumber: string | undefined;

    constructor(data?: ICreateOrUpdateEmployeeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employee = new EmployeeEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeEditDto.fromJS(_data["employee"]) : new EmployeeEditDto();
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): CreateOrUpdateEmployeeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEmployeeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["serialNumber"] = this.serialNumber;
        return data;
    }

    clone(): CreateOrUpdateEmployeeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateEmployeeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEmployeeInput {
    employee: EmployeeEditDto;
    user: UserEditDto;
    /** 授权的角色 */
    assignedRoleNames: string[];
    /** 流水号 */
    serialNumber: string | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }

    clone(): UserListRoleDto {
        const json = this.toJSON();
        let result = new UserListRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

/** 用户信息列表Dto QYB.UserManagerment.Users.User */
export class UserListDto implements IUserListDto {
    userName: string | undefined;
    emailAddress: string | undefined;
    /** 头像Id */
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    isActive: boolean;
    /** 真实姓名-------------------新增 */
    realName: string | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 泛微OA系统用户ID */
    weaverUserId: number | undefined;
    isLockoutEnabled: boolean;
    /** 是否启用邮件通知 */
    enableEmail: boolean;
    /** 是否启用App推送 */
    enableAPPPush: boolean;
    /** 是否启用短信 */
    enableTextMessage: boolean;
    /** 是否启用企业微信通知 */
    enableWeComMessage: boolean;
    /** 企业微信UserId */
    weComUserId: string | undefined;
    /** 是否仅限Ldap登录 */
    isOnlyLdapLogin: boolean;
    /** 域账号 */
    domainAccount: string | undefined;
    id: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.realName = _data["realName"];
            this.userPictureType = _data["userPictureType"];
            this.remarks = _data["remarks"];
            this.weaverUserId = _data["weaverUserId"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.enableEmail = _data["enableEmail"];
            this.enableAPPPush = _data["enableAPPPush"];
            this.enableTextMessage = _data["enableTextMessage"];
            this.enableWeComMessage = _data["enableWeComMessage"];
            this.weComUserId = _data["weComUserId"];
            this.isOnlyLdapLogin = _data["isOnlyLdapLogin"];
            this.domainAccount = _data["domainAccount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["realName"] = this.realName;
        data["userPictureType"] = this.userPictureType;
        data["remarks"] = this.remarks;
        data["weaverUserId"] = this.weaverUserId;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["enableEmail"] = this.enableEmail;
        data["enableAPPPush"] = this.enableAPPPush;
        data["enableTextMessage"] = this.enableTextMessage;
        data["enableWeComMessage"] = this.enableWeComMessage;
        data["weComUserId"] = this.weComUserId;
        data["isOnlyLdapLogin"] = this.isOnlyLdapLogin;
        data["domainAccount"] = this.domainAccount;
        data["id"] = this.id;
        return data;
    }

    clone(): UserListDto {
        const json = this.toJSON();
        let result = new UserListDto();
        result.init(json);
        return result;
    }
}

/** 用户信息列表Dto QYB.UserManagerment.Users.User */
export interface IUserListDto {
    userName: string | undefined;
    emailAddress: string | undefined;
    /** 头像Id */
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    isActive: boolean;
    /** 真实姓名-------------------新增 */
    realName: string | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 备注 */
    remarks: string | undefined;
    /** 泛微OA系统用户ID */
    weaverUserId: number | undefined;
    isLockoutEnabled: boolean;
    /** 是否启用邮件通知 */
    enableEmail: boolean;
    /** 是否启用App推送 */
    enableAPPPush: boolean;
    /** 是否启用短信 */
    enableTextMessage: boolean;
    /** 是否启用企业微信通知 */
    enableWeComMessage: boolean;
    /** 企业微信UserId */
    weComUserId: string | undefined;
    /** 是否仅限Ldap登录 */
    isOnlyLdapLogin: boolean;
    /** 域账号 */
    domainAccount: string | undefined;
    id: number;
}

export class OrganizationUnit implements IOrganizationUnit {
    tenantId: number | undefined;
    parent: OrganizationUnit;
    parentId: number | undefined;
    code: string;
    displayName: string;
    children: OrganizationUnit[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.parent = _data["parent"] ? OrganizationUnit.fromJS(_data["parent"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(OrganizationUnit.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrganizationUnit {
        const json = this.toJSON();
        let result = new OrganizationUnit();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnit {
    tenantId: number | undefined;
    parent: OrganizationUnit;
    parentId: number | undefined;
    code: string;
    displayName: string;
    children: OrganizationUnit[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class AbpOrganizationunitsExtend implements IAbpOrganizationunitsExtend {
    companyId: number;
    company: Company;
    shortName: string | undefined;
    natureCode: string | undefined;
    managerId: number | undefined;
    outerPhone: string | undefined;
    innerPhone: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    sortCode: number | undefined;
    isVirtual: boolean;
    description: string | undefined;
    tenantId: number | undefined;
    parent: OrganizationUnit;
    parentId: number | undefined;
    code: string;
    displayName: string;
    children: OrganizationUnit[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IAbpOrganizationunitsExtend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.shortName = _data["shortName"];
            this.natureCode = _data["natureCode"];
            this.managerId = _data["managerId"];
            this.outerPhone = _data["outerPhone"];
            this.innerPhone = _data["innerPhone"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.sortCode = _data["sortCode"];
            this.isVirtual = _data["isVirtual"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.parent = _data["parent"] ? OrganizationUnit.fromJS(_data["parent"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(OrganizationUnit.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AbpOrganizationunitsExtend {
        data = typeof data === 'object' ? data : {};
        let result = new AbpOrganizationunitsExtend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["shortName"] = this.shortName;
        data["natureCode"] = this.natureCode;
        data["managerId"] = this.managerId;
        data["outerPhone"] = this.outerPhone;
        data["innerPhone"] = this.innerPhone;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["sortCode"] = this.sortCode;
        data["isVirtual"] = this.isVirtual;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AbpOrganizationunitsExtend {
        const json = this.toJSON();
        let result = new AbpOrganizationunitsExtend();
        result.init(json);
        return result;
    }
}

export interface IAbpOrganizationunitsExtend {
    companyId: number;
    company: Company;
    shortName: string | undefined;
    natureCode: string | undefined;
    managerId: number | undefined;
    outerPhone: string | undefined;
    innerPhone: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    sortCode: number | undefined;
    isVirtual: boolean;
    description: string | undefined;
    tenantId: number | undefined;
    parent: OrganizationUnit;
    parentId: number | undefined;
    code: string;
    displayName: string;
    children: OrganizationUnit[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** 的列表DTO QYB.QYBProduct.Organization.Employee.Employee */
export class EmployeeListDto implements IEmployeeListDto {
    companyName: string | undefined;
    departmentName: string | undefined;
    departmentID: number | undefined;
    employeeType: string | undefined;
    creationTime: moment.Moment | undefined;
    /** UserId */
    userId: number | undefined;
    /** 账号 */
    userName: string | undefined;
    /** RealName */
    realName: string | undefined;
    /** GenderCode */
    genderCode: string | undefined;
    gender: DataItemDetail;
    /** Mobile */
    mobile: string | undefined;
    /** CompanyId */
    companyId: number | undefined;
    company: Company;
    /** DepartmentId */
    departmentId: number | undefined;
    department: AbpOrganizationunitsExtend;
    /** Birthday */
    birthday: moment.Moment | undefined;
    /** HireDate */
    hireDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
    /** EmpStateCode */
    empStateCode: string | undefined;
    empState: DataItemDetail;
    /** MaritalStatusCode */
    maritalStatusCode: string | undefined;
    maritalStatus: DataItemDetail;
    /** EmpTypeCode */
    empTypeCode: string | undefined;
    empType: DataItemDetail;
    /** PoliticsStatusCode */
    politicsStatusCode: string | undefined;
    politicsStatus: DataItemDetail;
    /** JobNumber */
    jobNumber: string | undefined;
    /** UserPictureType */
    userPictureType: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** CardIsLongTerm */
    cardIsLongTerm: boolean | undefined;
    /** 身份证有效期 */
    identityValidity: moment.Moment | undefined;
    /** 户籍地址 */
    identityAddress: string | undefined;
    /** PresentAddress */
    presentAddress: string | undefined;
    /** NationCode */
    nationCode: string | undefined;
    nation: DataItemDetail;
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 常用地址邮编 */
    postalCode: string | undefined;
    /** PersonalServiceCode */
    personalServiceCode: string | undefined;
    personalService: DataItemDetail;
    /** ResidenceTypeCode */
    residenceTypeCode: string | undefined;
    residenceType: DataItemDetail;
    /** RecruitmentSourceCode */
    recruitmentSourceCode: string | undefined;
    recruitmentSource: DataItemDetail;
    /** EducationsCode */
    educationsCode: string | undefined;
    educations: DataItemDetail;
    /** 首次工作日期 */
    firstWorkDate: moment.Moment | undefined;
    /** OrgPostId */
    orgPostId: number | undefined;
    orgPost: OrgPost;
    /** ProbationGradeId */
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    /** RegularGradeId */
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    /** PersonalEmail */
    personalEmail: string | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** IdentityFaceImg */
    identityFaceImg: string | undefined;
    /** IdentityEmblemImg */
    identityEmblemImg: string | undefined;
    /** IdPhoto */
    idPhoto: string | undefined;
    /** 个人社保编号 */
    socialSecurity: string | undefined;
    /** 个人公积金编号 */
    reservedFunds: string | undefined;
    /** 银行卡号 */
    cardNo: string | undefined;
    /** 开户银行 */
    bankName: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 岗位名称 */
    orgName: string | undefined;
    /** 试用期岗位等级 */
    probationGradeName: string | undefined;
    /** 转正后岗位等级 */
    regularGradeName: string | undefined;
    /** 性别（中文） */
    genderName: string | undefined;
    /** 民族（中文） */
    nationName: string | undefined;
    /** 户口性质（中文） */
    residenceName: string | undefined;
    /** 员工种类一（中文） */
    empKindOne: string | undefined;
    /** 员工种类二（中文） */
    empKindTwo: string | undefined;
    /** 员工种类三（中文） */
    empKindThree: string | undefined;
    /** 员工类型（中文） */
    empTypeName: string | undefined;
    /** 员工状态（中文） */
    empStateName: string | undefined;
    /** 婚姻状态（中文） */
    maritalStatusName: string | undefined;
    /** 政治面貌（中文） */
    politicsStatusName: string | undefined;
    /** 学历（中文） */
    educationsName: string | undefined;
    /** 招聘来源（中文） */
    recruitmentSourceName: string | undefined;
    /** 劳务公司（中文） */
    personalServiceName: string | undefined;
    /** 年龄 */
    age: number | undefined;
    /** 司龄 */
    companyAge: number | undefined;
    /** 员工卡号 */
    rfid: string | undefined;
    /** 身份证开始日期 */
    identityStartDate: moment.Moment | undefined;
    sortCode: number;
    color: string | undefined;
    id: number;

    constructor(data?: IEmployeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.departmentID = _data["departmentID"];
            this.employeeType = _data["employeeType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.realName = _data["realName"];
            this.genderCode = _data["genderCode"];
            this.gender = _data["gender"] ? DataItemDetail.fromJS(_data["gender"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? AbpOrganizationunitsExtend.fromJS(_data["department"]) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.empStateCode = _data["empStateCode"];
            this.empState = _data["empState"] ? DataItemDetail.fromJS(_data["empState"]) : <any>undefined;
            this.maritalStatusCode = _data["maritalStatusCode"];
            this.maritalStatus = _data["maritalStatus"] ? DataItemDetail.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.empTypeCode = _data["empTypeCode"];
            this.empType = _data["empType"] ? DataItemDetail.fromJS(_data["empType"]) : <any>undefined;
            this.politicsStatusCode = _data["politicsStatusCode"];
            this.politicsStatus = _data["politicsStatus"] ? DataItemDetail.fromJS(_data["politicsStatus"]) : <any>undefined;
            this.jobNumber = _data["jobNumber"];
            this.userPictureType = _data["userPictureType"];
            this.identityCard = _data["identityCard"];
            this.cardIsLongTerm = _data["cardIsLongTerm"];
            this.identityValidity = _data["identityValidity"] ? moment(_data["identityValidity"].toString()) : <any>undefined;
            this.identityAddress = _data["identityAddress"];
            this.presentAddress = _data["presentAddress"];
            this.nationCode = _data["nationCode"];
            this.nation = _data["nation"] ? DataItemDetail.fromJS(_data["nation"]) : <any>undefined;
            this.nativePlace = _data["nativePlace"];
            this.postalCode = _data["postalCode"];
            this.personalServiceCode = _data["personalServiceCode"];
            this.personalService = _data["personalService"] ? DataItemDetail.fromJS(_data["personalService"]) : <any>undefined;
            this.residenceTypeCode = _data["residenceTypeCode"];
            this.residenceType = _data["residenceType"] ? DataItemDetail.fromJS(_data["residenceType"]) : <any>undefined;
            this.recruitmentSourceCode = _data["recruitmentSourceCode"];
            this.recruitmentSource = _data["recruitmentSource"] ? DataItemDetail.fromJS(_data["recruitmentSource"]) : <any>undefined;
            this.educationsCode = _data["educationsCode"];
            this.educations = _data["educations"] ? DataItemDetail.fromJS(_data["educations"]) : <any>undefined;
            this.firstWorkDate = _data["firstWorkDate"] ? moment(_data["firstWorkDate"].toString()) : <any>undefined;
            this.orgPostId = _data["orgPostId"];
            this.orgPost = _data["orgPost"] ? OrgPost.fromJS(_data["orgPost"]) : <any>undefined;
            this.probationGradeId = _data["probationGradeId"];
            this.probationGrade = _data["probationGrade"] ? OrgPostGrade.fromJS(_data["probationGrade"]) : <any>undefined;
            this.regularGradeId = _data["regularGradeId"];
            this.regularGrade = _data["regularGrade"] ? OrgPostGrade.fromJS(_data["regularGrade"]) : <any>undefined;
            this.personalEmail = _data["personalEmail"];
            this.companyEmail = _data["companyEmail"];
            this.identityFaceImg = _data["identityFaceImg"];
            this.identityEmblemImg = _data["identityEmblemImg"];
            this.idPhoto = _data["idPhoto"];
            this.socialSecurity = _data["socialSecurity"];
            this.reservedFunds = _data["reservedFunds"];
            this.cardNo = _data["cardNo"];
            this.bankName = _data["bankName"];
            this.displayName = _data["displayName"];
            this.orgName = _data["orgName"];
            this.probationGradeName = _data["probationGradeName"];
            this.regularGradeName = _data["regularGradeName"];
            this.genderName = _data["genderName"];
            this.nationName = _data["nationName"];
            this.residenceName = _data["residenceName"];
            this.empKindOne = _data["empKindOne"];
            this.empKindTwo = _data["empKindTwo"];
            this.empKindThree = _data["empKindThree"];
            this.empTypeName = _data["empTypeName"];
            this.empStateName = _data["empStateName"];
            this.maritalStatusName = _data["maritalStatusName"];
            this.politicsStatusName = _data["politicsStatusName"];
            this.educationsName = _data["educationsName"];
            this.recruitmentSourceName = _data["recruitmentSourceName"];
            this.personalServiceName = _data["personalServiceName"];
            this.age = _data["age"];
            this.companyAge = _data["companyAge"];
            this.rfid = _data["rfid"];
            this.identityStartDate = _data["identityStartDate"] ? moment(_data["identityStartDate"].toString()) : <any>undefined;
            this.sortCode = _data["sortCode"];
            this.color = _data["color"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["departmentID"] = this.departmentID;
        data["employeeType"] = this.employeeType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["realName"] = this.realName;
        data["genderCode"] = this.genderCode;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["empStateCode"] = this.empStateCode;
        data["empState"] = this.empState ? this.empState.toJSON() : <any>undefined;
        data["maritalStatusCode"] = this.maritalStatusCode;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["empTypeCode"] = this.empTypeCode;
        data["empType"] = this.empType ? this.empType.toJSON() : <any>undefined;
        data["politicsStatusCode"] = this.politicsStatusCode;
        data["politicsStatus"] = this.politicsStatus ? this.politicsStatus.toJSON() : <any>undefined;
        data["jobNumber"] = this.jobNumber;
        data["userPictureType"] = this.userPictureType;
        data["identityCard"] = this.identityCard;
        data["cardIsLongTerm"] = this.cardIsLongTerm;
        data["identityValidity"] = this.identityValidity ? this.identityValidity.toISOString() : <any>undefined;
        data["identityAddress"] = this.identityAddress;
        data["presentAddress"] = this.presentAddress;
        data["nationCode"] = this.nationCode;
        data["nation"] = this.nation ? this.nation.toJSON() : <any>undefined;
        data["nativePlace"] = this.nativePlace;
        data["postalCode"] = this.postalCode;
        data["personalServiceCode"] = this.personalServiceCode;
        data["personalService"] = this.personalService ? this.personalService.toJSON() : <any>undefined;
        data["residenceTypeCode"] = this.residenceTypeCode;
        data["residenceType"] = this.residenceType ? this.residenceType.toJSON() : <any>undefined;
        data["recruitmentSourceCode"] = this.recruitmentSourceCode;
        data["recruitmentSource"] = this.recruitmentSource ? this.recruitmentSource.toJSON() : <any>undefined;
        data["educationsCode"] = this.educationsCode;
        data["educations"] = this.educations ? this.educations.toJSON() : <any>undefined;
        data["firstWorkDate"] = this.firstWorkDate ? this.firstWorkDate.toISOString() : <any>undefined;
        data["orgPostId"] = this.orgPostId;
        data["orgPost"] = this.orgPost ? this.orgPost.toJSON() : <any>undefined;
        data["probationGradeId"] = this.probationGradeId;
        data["probationGrade"] = this.probationGrade ? this.probationGrade.toJSON() : <any>undefined;
        data["regularGradeId"] = this.regularGradeId;
        data["regularGrade"] = this.regularGrade ? this.regularGrade.toJSON() : <any>undefined;
        data["personalEmail"] = this.personalEmail;
        data["companyEmail"] = this.companyEmail;
        data["identityFaceImg"] = this.identityFaceImg;
        data["identityEmblemImg"] = this.identityEmblemImg;
        data["idPhoto"] = this.idPhoto;
        data["socialSecurity"] = this.socialSecurity;
        data["reservedFunds"] = this.reservedFunds;
        data["cardNo"] = this.cardNo;
        data["bankName"] = this.bankName;
        data["displayName"] = this.displayName;
        data["orgName"] = this.orgName;
        data["probationGradeName"] = this.probationGradeName;
        data["regularGradeName"] = this.regularGradeName;
        data["genderName"] = this.genderName;
        data["nationName"] = this.nationName;
        data["residenceName"] = this.residenceName;
        data["empKindOne"] = this.empKindOne;
        data["empKindTwo"] = this.empKindTwo;
        data["empKindThree"] = this.empKindThree;
        data["empTypeName"] = this.empTypeName;
        data["empStateName"] = this.empStateName;
        data["maritalStatusName"] = this.maritalStatusName;
        data["politicsStatusName"] = this.politicsStatusName;
        data["educationsName"] = this.educationsName;
        data["recruitmentSourceName"] = this.recruitmentSourceName;
        data["personalServiceName"] = this.personalServiceName;
        data["age"] = this.age;
        data["companyAge"] = this.companyAge;
        data["rfid"] = this.rfid;
        data["identityStartDate"] = this.identityStartDate ? this.identityStartDate.toISOString() : <any>undefined;
        data["sortCode"] = this.sortCode;
        data["color"] = this.color;
        data["id"] = this.id;
        return data;
    }

    clone(): EmployeeListDto {
        const json = this.toJSON();
        let result = new EmployeeListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.Employee.Employee */
export interface IEmployeeListDto {
    companyName: string | undefined;
    departmentName: string | undefined;
    departmentID: number | undefined;
    employeeType: string | undefined;
    creationTime: moment.Moment | undefined;
    /** UserId */
    userId: number | undefined;
    /** 账号 */
    userName: string | undefined;
    /** RealName */
    realName: string | undefined;
    /** GenderCode */
    genderCode: string | undefined;
    gender: DataItemDetail;
    /** Mobile */
    mobile: string | undefined;
    /** CompanyId */
    companyId: number | undefined;
    company: Company;
    /** DepartmentId */
    departmentId: number | undefined;
    department: AbpOrganizationunitsExtend;
    /** Birthday */
    birthday: moment.Moment | undefined;
    /** HireDate */
    hireDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
    /** EmpStateCode */
    empStateCode: string | undefined;
    empState: DataItemDetail;
    /** MaritalStatusCode */
    maritalStatusCode: string | undefined;
    maritalStatus: DataItemDetail;
    /** EmpTypeCode */
    empTypeCode: string | undefined;
    empType: DataItemDetail;
    /** PoliticsStatusCode */
    politicsStatusCode: string | undefined;
    politicsStatus: DataItemDetail;
    /** JobNumber */
    jobNumber: string | undefined;
    /** UserPictureType */
    userPictureType: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** CardIsLongTerm */
    cardIsLongTerm: boolean | undefined;
    /** 身份证有效期 */
    identityValidity: moment.Moment | undefined;
    /** 户籍地址 */
    identityAddress: string | undefined;
    /** PresentAddress */
    presentAddress: string | undefined;
    /** NationCode */
    nationCode: string | undefined;
    nation: DataItemDetail;
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 常用地址邮编 */
    postalCode: string | undefined;
    /** PersonalServiceCode */
    personalServiceCode: string | undefined;
    personalService: DataItemDetail;
    /** ResidenceTypeCode */
    residenceTypeCode: string | undefined;
    residenceType: DataItemDetail;
    /** RecruitmentSourceCode */
    recruitmentSourceCode: string | undefined;
    recruitmentSource: DataItemDetail;
    /** EducationsCode */
    educationsCode: string | undefined;
    educations: DataItemDetail;
    /** 首次工作日期 */
    firstWorkDate: moment.Moment | undefined;
    /** OrgPostId */
    orgPostId: number | undefined;
    orgPost: OrgPost;
    /** ProbationGradeId */
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    /** RegularGradeId */
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    /** PersonalEmail */
    personalEmail: string | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** IdentityFaceImg */
    identityFaceImg: string | undefined;
    /** IdentityEmblemImg */
    identityEmblemImg: string | undefined;
    /** IdPhoto */
    idPhoto: string | undefined;
    /** 个人社保编号 */
    socialSecurity: string | undefined;
    /** 个人公积金编号 */
    reservedFunds: string | undefined;
    /** 银行卡号 */
    cardNo: string | undefined;
    /** 开户银行 */
    bankName: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 岗位名称 */
    orgName: string | undefined;
    /** 试用期岗位等级 */
    probationGradeName: string | undefined;
    /** 转正后岗位等级 */
    regularGradeName: string | undefined;
    /** 性别（中文） */
    genderName: string | undefined;
    /** 民族（中文） */
    nationName: string | undefined;
    /** 户口性质（中文） */
    residenceName: string | undefined;
    /** 员工种类一（中文） */
    empKindOne: string | undefined;
    /** 员工种类二（中文） */
    empKindTwo: string | undefined;
    /** 员工种类三（中文） */
    empKindThree: string | undefined;
    /** 员工类型（中文） */
    empTypeName: string | undefined;
    /** 员工状态（中文） */
    empStateName: string | undefined;
    /** 婚姻状态（中文） */
    maritalStatusName: string | undefined;
    /** 政治面貌（中文） */
    politicsStatusName: string | undefined;
    /** 学历（中文） */
    educationsName: string | undefined;
    /** 招聘来源（中文） */
    recruitmentSourceName: string | undefined;
    /** 劳务公司（中文） */
    personalServiceName: string | undefined;
    /** 年龄 */
    age: number | undefined;
    /** 司龄 */
    companyAge: number | undefined;
    /** 员工卡号 */
    rfid: string | undefined;
    /** 身份证开始日期 */
    identityStartDate: moment.Moment | undefined;
    sortCode: number;
    color: string | undefined;
    id: number;
}

export class PagedResultDtoOfEmployeeListDto implements IPagedResultDtoOfEmployeeListDto {
    totalCount: number;
    items: EmployeeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmployeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmployeeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmployeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEmployeeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmployeeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmployeeListDto {
    totalCount: number;
    items: EmployeeListDto[] | undefined;
}

/** 生日人员信息 */
export class BirthdayEmpInfo implements IBirthdayEmpInfo {
    /** 姓名 */
    realName: string | undefined;
    /** 性别 */
    gender: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 生日 */
    birthday: moment.Moment | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;

    constructor(data?: IBirthdayEmpInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.realName = _data["realName"];
            this.gender = _data["gender"];
            this.mobile = _data["mobile"];
            this.jobNumber = _data["jobNumber"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.idPhoto = _data["idPhoto"];
        }
    }

    static fromJS(data: any): BirthdayEmpInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayEmpInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["realName"] = this.realName;
        data["gender"] = this.gender;
        data["mobile"] = this.mobile;
        data["jobNumber"] = this.jobNumber;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["idPhoto"] = this.idPhoto;
        return data;
    }

    clone(): BirthdayEmpInfo {
        const json = this.toJSON();
        let result = new BirthdayEmpInfo();
        result.init(json);
        return result;
    }
}

/** 生日人员信息 */
export interface IBirthdayEmpInfo {
    /** 姓名 */
    realName: string | undefined;
    /** 性别 */
    gender: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 生日 */
    birthday: moment.Moment | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
}

/** 生日人员根据部门分组 */
export class BirthdayDepGroup implements IBirthdayDepGroup {
    /** 部门名称 */
    departmentName: string | undefined;
    /** 部门人数统计列表 */
    birthdayEmpList: BirthdayEmpInfo[] | undefined;

    constructor(data?: IBirthdayDepGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            if (Array.isArray(_data["birthdayEmpList"])) {
                this.birthdayEmpList = [] as any;
                for (let item of _data["birthdayEmpList"])
                    this.birthdayEmpList.push(BirthdayEmpInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BirthdayDepGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayDepGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        if (Array.isArray(this.birthdayEmpList)) {
            data["birthdayEmpList"] = [];
            for (let item of this.birthdayEmpList)
                data["birthdayEmpList"].push(item.toJSON());
        }
        return data;
    }

    clone(): BirthdayDepGroup {
        const json = this.toJSON();
        let result = new BirthdayDepGroup();
        result.init(json);
        return result;
    }
}

/** 生日人员根据部门分组 */
export interface IBirthdayDepGroup {
    /** 部门名称 */
    departmentName: string | undefined;
    /** 部门人数统计列表 */
    birthdayEmpList: BirthdayEmpInfo[] | undefined;
}

/** 生日人员根据公司分组 */
export class BirthdayComGroup implements IBirthdayComGroup {
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门人数统计列表 */
    birthdayEmpList: BirthdayDepGroup[] | undefined;

    constructor(data?: IBirthdayComGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            if (Array.isArray(_data["birthdayEmpList"])) {
                this.birthdayEmpList = [] as any;
                for (let item of _data["birthdayEmpList"])
                    this.birthdayEmpList.push(BirthdayDepGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BirthdayComGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayComGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        if (Array.isArray(this.birthdayEmpList)) {
            data["birthdayEmpList"] = [];
            for (let item of this.birthdayEmpList)
                data["birthdayEmpList"].push(item.toJSON());
        }
        return data;
    }

    clone(): BirthdayComGroup {
        const json = this.toJSON();
        let result = new BirthdayComGroup();
        result.init(json);
        return result;
    }
}

/** 生日人员根据公司分组 */
export interface IBirthdayComGroup {
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门人数统计列表 */
    birthdayEmpList: BirthdayDepGroup[] | undefined;
}

export class ContractEmpInfo implements IContractEmpInfo {
    /** 姓名 */
    realName: string | undefined;
    /** 性别 */
    gender: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 生日 */
    birthday: moment.Moment | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 合同的结束日期 */
    endDate: moment.Moment | undefined;

    constructor(data?: IContractEmpInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.realName = _data["realName"];
            this.gender = _data["gender"];
            this.mobile = _data["mobile"];
            this.jobNumber = _data["jobNumber"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.idPhoto = _data["idPhoto"];
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractEmpInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContractEmpInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["realName"] = this.realName;
        data["gender"] = this.gender;
        data["mobile"] = this.mobile;
        data["jobNumber"] = this.jobNumber;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["idPhoto"] = this.idPhoto;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ContractEmpInfo {
        const json = this.toJSON();
        let result = new ContractEmpInfo();
        result.init(json);
        return result;
    }
}

export interface IContractEmpInfo {
    /** 姓名 */
    realName: string | undefined;
    /** 性别 */
    gender: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 生日 */
    birthday: moment.Moment | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 合同的结束日期 */
    endDate: moment.Moment | undefined;
}

/** 各公司人数统计图表 */
export class EmpNumChart implements IEmpNumChart {
    /** 公司名称 */
    companyName: string | undefined;
    /** 公司在职人数 */
    peopleNum: number;

    constructor(data?: IEmpNumChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.peopleNum = _data["peopleNum"];
        }
    }

    static fromJS(data: any): EmpNumChart {
        data = typeof data === 'object' ? data : {};
        let result = new EmpNumChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["peopleNum"] = this.peopleNum;
        return data;
    }

    clone(): EmpNumChart {
        const json = this.toJSON();
        let result = new EmpNumChart();
        result.init(json);
        return result;
    }
}

/** 各公司人数统计图表 */
export interface IEmpNumChart {
    /** 公司名称 */
    companyName: string | undefined;
    /** 公司在职人数 */
    peopleNum: number;
}

/** APP首页员工数据统计实体 */
export class EmpCountInfoDto implements IEmpCountInfoDto {
    /** 在职人数 */
    onJobNum: number;
    /** 当月生日人数 */
    birthdayNum: number;
    /** 合同到期人数 */
    contractNum: number;
    /** 当月生日人员列表 */
    birthdayList: BirthdayEmpInfo[] | undefined;
    /** 各公司人数统计列表 */
    empNumChartList: EmpNumChart[] | undefined;

    constructor(data?: IEmpCountInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onJobNum = _data["onJobNum"];
            this.birthdayNum = _data["birthdayNum"];
            this.contractNum = _data["contractNum"];
            if (Array.isArray(_data["birthdayList"])) {
                this.birthdayList = [] as any;
                for (let item of _data["birthdayList"])
                    this.birthdayList.push(BirthdayEmpInfo.fromJS(item));
            }
            if (Array.isArray(_data["empNumChartList"])) {
                this.empNumChartList = [] as any;
                for (let item of _data["empNumChartList"])
                    this.empNumChartList.push(EmpNumChart.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmpCountInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpCountInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onJobNum"] = this.onJobNum;
        data["birthdayNum"] = this.birthdayNum;
        data["contractNum"] = this.contractNum;
        if (Array.isArray(this.birthdayList)) {
            data["birthdayList"] = [];
            for (let item of this.birthdayList)
                data["birthdayList"].push(item.toJSON());
        }
        if (Array.isArray(this.empNumChartList)) {
            data["empNumChartList"] = [];
            for (let item of this.empNumChartList)
                data["empNumChartList"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmpCountInfoDto {
        const json = this.toJSON();
        let result = new EmpCountInfoDto();
        result.init(json);
        return result;
    }
}

/** APP首页员工数据统计实体 */
export interface IEmpCountInfoDto {
    /** 在职人数 */
    onJobNum: number;
    /** 当月生日人数 */
    birthdayNum: number;
    /** 合同到期人数 */
    contractNum: number;
    /** 当月生日人员列表 */
    birthdayList: BirthdayEmpInfo[] | undefined;
    /** 各公司人数统计列表 */
    empNumChartList: EmpNumChart[] | undefined;
}

export class GetEmpDepManagerDto implements IGetEmpDepManagerDto {
    departmentId: number | undefined;
    departmentName: string | undefined;

    constructor(data?: IGetEmpDepManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): GetEmpDepManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmpDepManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        return data;
    }

    clone(): GetEmpDepManagerDto {
        const json = this.toJSON();
        let result = new GetEmpDepManagerDto();
        result.init(json);
        return result;
    }
}

export interface IGetEmpDepManagerDto {
    departmentId: number | undefined;
    departmentName: string | undefined;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data;
    }

    clone(): UserRoleDto {
        const json = this.toJSON();
        let result = new UserRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
}

/** 读取可编辑的Dto */
export class GetEmployeeForEditOutput implements IGetEmployeeForEditOutput {
    user: UserEditDto;
    employee: EmployeeEditDto;
    roles: UserRoleDto[] | undefined;

    constructor(data?: IGetEmployeeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeEditDto.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetEmployeeForEditOutput {
        const json = this.toJSON();
        let result = new GetEmployeeForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetEmployeeForEditOutput {
    user: UserEditDto;
    employee: EmployeeEditDto;
    roles: UserRoleDto[] | undefined;
}

export class NewUserJobNumberDto implements INewUserJobNumberDto {
    newEmpJobNumber: string | undefined;
    serialNumber: string | undefined;

    constructor(data?: INewUserJobNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmpJobNumber = _data["newEmpJobNumber"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): NewUserJobNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewUserJobNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmpJobNumber"] = this.newEmpJobNumber;
        data["serialNumber"] = this.serialNumber;
        return data;
    }

    clone(): NewUserJobNumberDto {
        const json = this.toJSON();
        let result = new NewUserJobNumberDto();
        result.init(json);
        return result;
    }
}

export interface INewUserJobNumberDto {
    newEmpJobNumber: string | undefined;
    serialNumber: string | undefined;
}

export class RosterListDto implements IRosterListDto {
    companyName: string | undefined;
    departmentName: string | undefined;
    departmentID: number | undefined;
    employeeType: string | undefined;
    creationTime: moment.Moment | undefined;
    /** UserId */
    userId: number | undefined;
    /** 账号 */
    userName: string | undefined;
    /** RealName */
    realName: string | undefined;
    /** GenderCode */
    genderCode: string | undefined;
    gender: DataItemDetail;
    /** Mobile */
    mobile: string | undefined;
    /** CompanyId */
    companyId: number | undefined;
    company: Company;
    /** DepartmentId */
    departmentId: number | undefined;
    department: AbpOrganizationunitsExtend;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 三级部门 */
    threeDepartment: string | undefined;
    /** Birthday */
    birthday: moment.Moment | undefined;
    /** 出生月份 */
    birthdayMonth: number | undefined;
    /** HireDate */
    hireDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
    /** EmpStateCode */
    empStateCode: string | undefined;
    empState: DataItemDetail;
    /** MaritalStatusCode */
    maritalStatusCode: string | undefined;
    maritalStatus: DataItemDetail;
    /** EmpTypeCode */
    empTypeCode: string | undefined;
    empType: DataItemDetail;
    /** PoliticsStatusCode */
    politicsStatusCode: string | undefined;
    politicsStatus: DataItemDetail;
    /** JobNumber */
    jobNumber: string | undefined;
    /** UserPictureType */
    userPictureType: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** CardIsLongTerm */
    cardIsLongTerm: boolean | undefined;
    /** 身份证有效期 */
    identityValidity: moment.Moment | undefined;
    /** 户籍地址 */
    identityAddress: string | undefined;
    /** PresentAddress */
    presentAddress: string | undefined;
    /** NationCode */
    nationCode: string | undefined;
    nation: DataItemDetail;
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 常用地址邮编 */
    postalCode: string | undefined;
    /** PersonalServiceCode */
    personalServiceCode: string | undefined;
    personalService: DataItemDetail;
    /** ResidenceTypeCode */
    residenceTypeCode: string | undefined;
    residenceType: DataItemDetail;
    /** RecruitmentSourceCode */
    recruitmentSourceCode: string | undefined;
    recruitmentSource: DataItemDetail;
    /** EducationsCode */
    educationsCode: string | undefined;
    educations: DataItemDetail;
    /** 首次工作日期 */
    firstWorkDate: moment.Moment | undefined;
    /** OrgPostId */
    orgPostId: number | undefined;
    orgPost: OrgPost;
    /** ProbationGradeId */
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    /** RegularGradeId */
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    /** PersonalEmail */
    personalEmail: string | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** IdentityFaceImg */
    identityFaceImg: string | undefined;
    /** IdentityEmblemImg */
    identityEmblemImg: string | undefined;
    /** IdPhoto */
    idPhoto: string | undefined;
    /** 个人社保编号 */
    socialSecurity: string | undefined;
    /** 个人公积金编号 */
    reservedFunds: string | undefined;
    /** 银行卡号 */
    cardNo: string | undefined;
    /** 开户银行 */
    bankName: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 岗位名称 */
    orgName: string | undefined;
    /** 试用期岗位等级 */
    probationGradeName: string | undefined;
    /** 转正后岗位等级 */
    regularGradeName: string | undefined;
    /** 性别（中文） */
    genderName: string | undefined;
    /** 民族（中文） */
    nationName: string | undefined;
    /** 户口性质（中文） */
    residenceName: string | undefined;
    /** 员工种类一（中文） */
    empKindOne: string | undefined;
    /** 员工种类二（中文） */
    empKindTwo: string | undefined;
    /** 员工种类三（中文） */
    empKindThree: string | undefined;
    /** 员工类型（中文） */
    empTypeName: string | undefined;
    /** 员工状态（中文） */
    empStateName: string | undefined;
    /** 婚姻状态（中文） */
    maritalStatusName: string | undefined;
    /** 政治面貌（中文） */
    politicsStatusName: string | undefined;
    /** 学历（中文） */
    educationsName: string | undefined;
    /** 招聘来源（中文） */
    recruitmentSourceName: string | undefined;
    /** 劳务公司（中文） */
    personalServiceName: string | undefined;
    /** 年龄 */
    age: number | undefined;
    /** 司龄 */
    companyAge: number | undefined;
    /** 员工卡号 */
    rfid: string | undefined;
    /** 身份证开始日期 */
    identityStartDate: moment.Moment | undefined;
    /** 内部推荐人 */
    recommender: string | undefined;
    /** 保险类型 */
    insuranceType: string | undefined;
    /** 毕业日期 */
    schoolEndDate: moment.Moment | undefined;
    /** 学校名称 */
    schoolName: string | undefined;
    /** 专业 */
    professional: string | undefined;
    /** 紧急联系人 */
    contactName: string | undefined;
    /** 紧急联系人 */
    contactPhone: string | undefined;
    /** 合同类型 */
    pcTypeName: string | undefined;
    /** 开始时间 */
    pcStartDate: moment.Moment | undefined;
    /** 结束 */
    pcEndDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermName: string | undefined;
    /** 离职原因 */
    termReason: string | undefined;
    sortCode: number;
    color: string | undefined;
    id: number;

    constructor(data?: IRosterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.departmentID = _data["departmentID"];
            this.employeeType = _data["employeeType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.realName = _data["realName"];
            this.genderCode = _data["genderCode"];
            this.gender = _data["gender"] ? DataItemDetail.fromJS(_data["gender"]) : <any>undefined;
            this.mobile = _data["mobile"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? AbpOrganizationunitsExtend.fromJS(_data["department"]) : <any>undefined;
            this.twoDepartment = _data["twoDepartment"];
            this.threeDepartment = _data["threeDepartment"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.birthdayMonth = _data["birthdayMonth"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.empStateCode = _data["empStateCode"];
            this.empState = _data["empState"] ? DataItemDetail.fromJS(_data["empState"]) : <any>undefined;
            this.maritalStatusCode = _data["maritalStatusCode"];
            this.maritalStatus = _data["maritalStatus"] ? DataItemDetail.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.empTypeCode = _data["empTypeCode"];
            this.empType = _data["empType"] ? DataItemDetail.fromJS(_data["empType"]) : <any>undefined;
            this.politicsStatusCode = _data["politicsStatusCode"];
            this.politicsStatus = _data["politicsStatus"] ? DataItemDetail.fromJS(_data["politicsStatus"]) : <any>undefined;
            this.jobNumber = _data["jobNumber"];
            this.userPictureType = _data["userPictureType"];
            this.identityCard = _data["identityCard"];
            this.cardIsLongTerm = _data["cardIsLongTerm"];
            this.identityValidity = _data["identityValidity"] ? moment(_data["identityValidity"].toString()) : <any>undefined;
            this.identityAddress = _data["identityAddress"];
            this.presentAddress = _data["presentAddress"];
            this.nationCode = _data["nationCode"];
            this.nation = _data["nation"] ? DataItemDetail.fromJS(_data["nation"]) : <any>undefined;
            this.nativePlace = _data["nativePlace"];
            this.postalCode = _data["postalCode"];
            this.personalServiceCode = _data["personalServiceCode"];
            this.personalService = _data["personalService"] ? DataItemDetail.fromJS(_data["personalService"]) : <any>undefined;
            this.residenceTypeCode = _data["residenceTypeCode"];
            this.residenceType = _data["residenceType"] ? DataItemDetail.fromJS(_data["residenceType"]) : <any>undefined;
            this.recruitmentSourceCode = _data["recruitmentSourceCode"];
            this.recruitmentSource = _data["recruitmentSource"] ? DataItemDetail.fromJS(_data["recruitmentSource"]) : <any>undefined;
            this.educationsCode = _data["educationsCode"];
            this.educations = _data["educations"] ? DataItemDetail.fromJS(_data["educations"]) : <any>undefined;
            this.firstWorkDate = _data["firstWorkDate"] ? moment(_data["firstWorkDate"].toString()) : <any>undefined;
            this.orgPostId = _data["orgPostId"];
            this.orgPost = _data["orgPost"] ? OrgPost.fromJS(_data["orgPost"]) : <any>undefined;
            this.probationGradeId = _data["probationGradeId"];
            this.probationGrade = _data["probationGrade"] ? OrgPostGrade.fromJS(_data["probationGrade"]) : <any>undefined;
            this.regularGradeId = _data["regularGradeId"];
            this.regularGrade = _data["regularGrade"] ? OrgPostGrade.fromJS(_data["regularGrade"]) : <any>undefined;
            this.personalEmail = _data["personalEmail"];
            this.companyEmail = _data["companyEmail"];
            this.identityFaceImg = _data["identityFaceImg"];
            this.identityEmblemImg = _data["identityEmblemImg"];
            this.idPhoto = _data["idPhoto"];
            this.socialSecurity = _data["socialSecurity"];
            this.reservedFunds = _data["reservedFunds"];
            this.cardNo = _data["cardNo"];
            this.bankName = _data["bankName"];
            this.displayName = _data["displayName"];
            this.orgName = _data["orgName"];
            this.probationGradeName = _data["probationGradeName"];
            this.regularGradeName = _data["regularGradeName"];
            this.genderName = _data["genderName"];
            this.nationName = _data["nationName"];
            this.residenceName = _data["residenceName"];
            this.empKindOne = _data["empKindOne"];
            this.empKindTwo = _data["empKindTwo"];
            this.empKindThree = _data["empKindThree"];
            this.empTypeName = _data["empTypeName"];
            this.empStateName = _data["empStateName"];
            this.maritalStatusName = _data["maritalStatusName"];
            this.politicsStatusName = _data["politicsStatusName"];
            this.educationsName = _data["educationsName"];
            this.recruitmentSourceName = _data["recruitmentSourceName"];
            this.personalServiceName = _data["personalServiceName"];
            this.age = _data["age"];
            this.companyAge = _data["companyAge"];
            this.rfid = _data["rfid"];
            this.identityStartDate = _data["identityStartDate"] ? moment(_data["identityStartDate"].toString()) : <any>undefined;
            this.recommender = _data["recommender"];
            this.insuranceType = _data["insuranceType"];
            this.schoolEndDate = _data["schoolEndDate"] ? moment(_data["schoolEndDate"].toString()) : <any>undefined;
            this.schoolName = _data["schoolName"];
            this.professional = _data["professional"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.pcTypeName = _data["pcTypeName"];
            this.pcStartDate = _data["pcStartDate"] ? moment(_data["pcStartDate"].toString()) : <any>undefined;
            this.pcEndDate = _data["pcEndDate"] ? moment(_data["pcEndDate"].toString()) : <any>undefined;
            this.dueTerm = _data["dueTerm"];
            this.isNotHaveFixedTermName = _data["isNotHaveFixedTermName"];
            this.termReason = _data["termReason"];
            this.sortCode = _data["sortCode"];
            this.color = _data["color"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RosterListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RosterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["departmentID"] = this.departmentID;
        data["employeeType"] = this.employeeType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["realName"] = this.realName;
        data["genderCode"] = this.genderCode;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["mobile"] = this.mobile;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["twoDepartment"] = this.twoDepartment;
        data["threeDepartment"] = this.threeDepartment;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["birthdayMonth"] = this.birthdayMonth;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["empStateCode"] = this.empStateCode;
        data["empState"] = this.empState ? this.empState.toJSON() : <any>undefined;
        data["maritalStatusCode"] = this.maritalStatusCode;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["empTypeCode"] = this.empTypeCode;
        data["empType"] = this.empType ? this.empType.toJSON() : <any>undefined;
        data["politicsStatusCode"] = this.politicsStatusCode;
        data["politicsStatus"] = this.politicsStatus ? this.politicsStatus.toJSON() : <any>undefined;
        data["jobNumber"] = this.jobNumber;
        data["userPictureType"] = this.userPictureType;
        data["identityCard"] = this.identityCard;
        data["cardIsLongTerm"] = this.cardIsLongTerm;
        data["identityValidity"] = this.identityValidity ? this.identityValidity.toISOString() : <any>undefined;
        data["identityAddress"] = this.identityAddress;
        data["presentAddress"] = this.presentAddress;
        data["nationCode"] = this.nationCode;
        data["nation"] = this.nation ? this.nation.toJSON() : <any>undefined;
        data["nativePlace"] = this.nativePlace;
        data["postalCode"] = this.postalCode;
        data["personalServiceCode"] = this.personalServiceCode;
        data["personalService"] = this.personalService ? this.personalService.toJSON() : <any>undefined;
        data["residenceTypeCode"] = this.residenceTypeCode;
        data["residenceType"] = this.residenceType ? this.residenceType.toJSON() : <any>undefined;
        data["recruitmentSourceCode"] = this.recruitmentSourceCode;
        data["recruitmentSource"] = this.recruitmentSource ? this.recruitmentSource.toJSON() : <any>undefined;
        data["educationsCode"] = this.educationsCode;
        data["educations"] = this.educations ? this.educations.toJSON() : <any>undefined;
        data["firstWorkDate"] = this.firstWorkDate ? this.firstWorkDate.toISOString() : <any>undefined;
        data["orgPostId"] = this.orgPostId;
        data["orgPost"] = this.orgPost ? this.orgPost.toJSON() : <any>undefined;
        data["probationGradeId"] = this.probationGradeId;
        data["probationGrade"] = this.probationGrade ? this.probationGrade.toJSON() : <any>undefined;
        data["regularGradeId"] = this.regularGradeId;
        data["regularGrade"] = this.regularGrade ? this.regularGrade.toJSON() : <any>undefined;
        data["personalEmail"] = this.personalEmail;
        data["companyEmail"] = this.companyEmail;
        data["identityFaceImg"] = this.identityFaceImg;
        data["identityEmblemImg"] = this.identityEmblemImg;
        data["idPhoto"] = this.idPhoto;
        data["socialSecurity"] = this.socialSecurity;
        data["reservedFunds"] = this.reservedFunds;
        data["cardNo"] = this.cardNo;
        data["bankName"] = this.bankName;
        data["displayName"] = this.displayName;
        data["orgName"] = this.orgName;
        data["probationGradeName"] = this.probationGradeName;
        data["regularGradeName"] = this.regularGradeName;
        data["genderName"] = this.genderName;
        data["nationName"] = this.nationName;
        data["residenceName"] = this.residenceName;
        data["empKindOne"] = this.empKindOne;
        data["empKindTwo"] = this.empKindTwo;
        data["empKindThree"] = this.empKindThree;
        data["empTypeName"] = this.empTypeName;
        data["empStateName"] = this.empStateName;
        data["maritalStatusName"] = this.maritalStatusName;
        data["politicsStatusName"] = this.politicsStatusName;
        data["educationsName"] = this.educationsName;
        data["recruitmentSourceName"] = this.recruitmentSourceName;
        data["personalServiceName"] = this.personalServiceName;
        data["age"] = this.age;
        data["companyAge"] = this.companyAge;
        data["rfid"] = this.rfid;
        data["identityStartDate"] = this.identityStartDate ? this.identityStartDate.toISOString() : <any>undefined;
        data["recommender"] = this.recommender;
        data["insuranceType"] = this.insuranceType;
        data["schoolEndDate"] = this.schoolEndDate ? this.schoolEndDate.toISOString() : <any>undefined;
        data["schoolName"] = this.schoolName;
        data["professional"] = this.professional;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["pcTypeName"] = this.pcTypeName;
        data["pcStartDate"] = this.pcStartDate ? this.pcStartDate.toISOString() : <any>undefined;
        data["pcEndDate"] = this.pcEndDate ? this.pcEndDate.toISOString() : <any>undefined;
        data["dueTerm"] = this.dueTerm;
        data["isNotHaveFixedTermName"] = this.isNotHaveFixedTermName;
        data["termReason"] = this.termReason;
        data["sortCode"] = this.sortCode;
        data["color"] = this.color;
        data["id"] = this.id;
        return data;
    }

    clone(): RosterListDto {
        const json = this.toJSON();
        let result = new RosterListDto();
        result.init(json);
        return result;
    }
}

export interface IRosterListDto {
    companyName: string | undefined;
    departmentName: string | undefined;
    departmentID: number | undefined;
    employeeType: string | undefined;
    creationTime: moment.Moment | undefined;
    /** UserId */
    userId: number | undefined;
    /** 账号 */
    userName: string | undefined;
    /** RealName */
    realName: string | undefined;
    /** GenderCode */
    genderCode: string | undefined;
    gender: DataItemDetail;
    /** Mobile */
    mobile: string | undefined;
    /** CompanyId */
    companyId: number | undefined;
    company: Company;
    /** DepartmentId */
    departmentId: number | undefined;
    department: AbpOrganizationunitsExtend;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 三级部门 */
    threeDepartment: string | undefined;
    /** Birthday */
    birthday: moment.Moment | undefined;
    /** 出生月份 */
    birthdayMonth: number | undefined;
    /** HireDate */
    hireDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
    /** EmpStateCode */
    empStateCode: string | undefined;
    empState: DataItemDetail;
    /** MaritalStatusCode */
    maritalStatusCode: string | undefined;
    maritalStatus: DataItemDetail;
    /** EmpTypeCode */
    empTypeCode: string | undefined;
    empType: DataItemDetail;
    /** PoliticsStatusCode */
    politicsStatusCode: string | undefined;
    politicsStatus: DataItemDetail;
    /** JobNumber */
    jobNumber: string | undefined;
    /** UserPictureType */
    userPictureType: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** CardIsLongTerm */
    cardIsLongTerm: boolean | undefined;
    /** 身份证有效期 */
    identityValidity: moment.Moment | undefined;
    /** 户籍地址 */
    identityAddress: string | undefined;
    /** PresentAddress */
    presentAddress: string | undefined;
    /** NationCode */
    nationCode: string | undefined;
    nation: DataItemDetail;
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 常用地址邮编 */
    postalCode: string | undefined;
    /** PersonalServiceCode */
    personalServiceCode: string | undefined;
    personalService: DataItemDetail;
    /** ResidenceTypeCode */
    residenceTypeCode: string | undefined;
    residenceType: DataItemDetail;
    /** RecruitmentSourceCode */
    recruitmentSourceCode: string | undefined;
    recruitmentSource: DataItemDetail;
    /** EducationsCode */
    educationsCode: string | undefined;
    educations: DataItemDetail;
    /** 首次工作日期 */
    firstWorkDate: moment.Moment | undefined;
    /** OrgPostId */
    orgPostId: number | undefined;
    orgPost: OrgPost;
    /** ProbationGradeId */
    probationGradeId: number | undefined;
    probationGrade: OrgPostGrade;
    /** RegularGradeId */
    regularGradeId: number | undefined;
    regularGrade: OrgPostGrade;
    /** PersonalEmail */
    personalEmail: string | undefined;
    /** 公司邮箱 */
    companyEmail: string | undefined;
    /** IdentityFaceImg */
    identityFaceImg: string | undefined;
    /** IdentityEmblemImg */
    identityEmblemImg: string | undefined;
    /** IdPhoto */
    idPhoto: string | undefined;
    /** 个人社保编号 */
    socialSecurity: string | undefined;
    /** 个人公积金编号 */
    reservedFunds: string | undefined;
    /** 银行卡号 */
    cardNo: string | undefined;
    /** 开户银行 */
    bankName: string | undefined;
    /** 部门名称 */
    displayName: string | undefined;
    /** 岗位名称 */
    orgName: string | undefined;
    /** 试用期岗位等级 */
    probationGradeName: string | undefined;
    /** 转正后岗位等级 */
    regularGradeName: string | undefined;
    /** 性别（中文） */
    genderName: string | undefined;
    /** 民族（中文） */
    nationName: string | undefined;
    /** 户口性质（中文） */
    residenceName: string | undefined;
    /** 员工种类一（中文） */
    empKindOne: string | undefined;
    /** 员工种类二（中文） */
    empKindTwo: string | undefined;
    /** 员工种类三（中文） */
    empKindThree: string | undefined;
    /** 员工类型（中文） */
    empTypeName: string | undefined;
    /** 员工状态（中文） */
    empStateName: string | undefined;
    /** 婚姻状态（中文） */
    maritalStatusName: string | undefined;
    /** 政治面貌（中文） */
    politicsStatusName: string | undefined;
    /** 学历（中文） */
    educationsName: string | undefined;
    /** 招聘来源（中文） */
    recruitmentSourceName: string | undefined;
    /** 劳务公司（中文） */
    personalServiceName: string | undefined;
    /** 年龄 */
    age: number | undefined;
    /** 司龄 */
    companyAge: number | undefined;
    /** 员工卡号 */
    rfid: string | undefined;
    /** 身份证开始日期 */
    identityStartDate: moment.Moment | undefined;
    /** 内部推荐人 */
    recommender: string | undefined;
    /** 保险类型 */
    insuranceType: string | undefined;
    /** 毕业日期 */
    schoolEndDate: moment.Moment | undefined;
    /** 学校名称 */
    schoolName: string | undefined;
    /** 专业 */
    professional: string | undefined;
    /** 紧急联系人 */
    contactName: string | undefined;
    /** 紧急联系人 */
    contactPhone: string | undefined;
    /** 合同类型 */
    pcTypeName: string | undefined;
    /** 开始时间 */
    pcStartDate: moment.Moment | undefined;
    /** 结束 */
    pcEndDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermName: string | undefined;
    /** 离职原因 */
    termReason: string | undefined;
    sortCode: number;
    color: string | undefined;
    id: number;
}

export class PagedResultDtoOfRosterListDto implements IPagedResultDtoOfRosterListDto {
    totalCount: number;
    items: RosterListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRosterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RosterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRosterListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRosterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfRosterListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRosterListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRosterListDto {
    totalCount: number;
    items: RosterListDto[] | undefined;
}

export class AttendanceRecordInput implements IAttendanceRecordInput {
    /** 打卡方式（考勤机、定位、WIFI） */
    checkType: string | undefined;
    /** 上下班打卡（0上班打卡、1下班打卡） */
    upDownCheck: string | undefined;
    /** 打卡点位 (考勤机打卡) */
    checkPoint: string | undefined;
    /** 卡号 (考勤机打卡) */
    cardNumber: string | undefined;
    /** 地址(定位) */
    checkAddress: string | undefined;
    /** 维度(定位) */
    lat: string | undefined;
    /** 经度 (定位) */
    lng: string | undefined;
    /** 距离(定位) */
    distance: number | undefined;
    /** WIFIMAC(WIFI) */
    wifiMac: string | undefined;
    /** 信号强度(WIFI) */
    signalStrength: string | undefined;

    constructor(data?: IAttendanceRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkType = _data["checkType"];
            this.upDownCheck = _data["upDownCheck"];
            this.checkPoint = _data["checkPoint"];
            this.cardNumber = _data["cardNumber"];
            this.checkAddress = _data["checkAddress"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.distance = _data["distance"];
            this.wifiMac = _data["wifiMac"];
            this.signalStrength = _data["signalStrength"];
        }
    }

    static fromJS(data: any): AttendanceRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkType"] = this.checkType;
        data["upDownCheck"] = this.upDownCheck;
        data["checkPoint"] = this.checkPoint;
        data["cardNumber"] = this.cardNumber;
        data["checkAddress"] = this.checkAddress;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["distance"] = this.distance;
        data["wifiMac"] = this.wifiMac;
        data["signalStrength"] = this.signalStrength;
        return data;
    }

    clone(): AttendanceRecordInput {
        const json = this.toJSON();
        let result = new AttendanceRecordInput();
        result.init(json);
        return result;
    }
}

export interface IAttendanceRecordInput {
    /** 打卡方式（考勤机、定位、WIFI） */
    checkType: string | undefined;
    /** 上下班打卡（0上班打卡、1下班打卡） */
    upDownCheck: string | undefined;
    /** 打卡点位 (考勤机打卡) */
    checkPoint: string | undefined;
    /** 卡号 (考勤机打卡) */
    cardNumber: string | undefined;
    /** 地址(定位) */
    checkAddress: string | undefined;
    /** 维度(定位) */
    lat: string | undefined;
    /** 经度 (定位) */
    lng: string | undefined;
    /** 距离(定位) */
    distance: number | undefined;
    /** WIFIMAC(WIFI) */
    wifiMac: string | undefined;
    /** 信号强度(WIFI) */
    signalStrength: string | undefined;
}

export class AttendanceRecordDto implements IAttendanceRecordDto {
    /** 当前时间 */
    dateTimeNow: moment.Moment;
    /** 出勤日期 */
    attendDate: moment.Moment | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 班次 */
    shiftName: string | undefined;
    /** 上班时间(时分格式) */
    startTime: string | undefined;
    /** 下班时间(时分格式) */
    endTime: string | undefined;
    /** 是否休息 */
    isRest: boolean;
    /** 打卡地址列表 */
    checkInAddressEditListDto: CheckInAddressEditDto[] | undefined;
    upCardRecord: CheckInRecordListDto;
    downCardRecord: CheckInRecordListDto;
    /** APP缩放等级 */
    appScale: string | undefined;

    constructor(data?: IAttendanceRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTimeNow = _data["dateTimeNow"] ? moment(_data["dateTimeNow"].toString()) : <any>undefined;
            this.attendDate = _data["attendDate"] ? moment(_data["attendDate"].toString()) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.isRest = _data["isRest"];
            if (Array.isArray(_data["checkInAddressEditListDto"])) {
                this.checkInAddressEditListDto = [] as any;
                for (let item of _data["checkInAddressEditListDto"])
                    this.checkInAddressEditListDto.push(CheckInAddressEditDto.fromJS(item));
            }
            this.upCardRecord = _data["upCardRecord"] ? CheckInRecordListDto.fromJS(_data["upCardRecord"]) : <any>undefined;
            this.downCardRecord = _data["downCardRecord"] ? CheckInRecordListDto.fromJS(_data["downCardRecord"]) : <any>undefined;
            this.appScale = _data["appScale"];
        }
    }

    static fromJS(data: any): AttendanceRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTimeNow"] = this.dateTimeNow ? this.dateTimeNow.toISOString() : <any>undefined;
        data["attendDate"] = this.attendDate ? this.attendDate.toISOString() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["isRest"] = this.isRest;
        if (Array.isArray(this.checkInAddressEditListDto)) {
            data["checkInAddressEditListDto"] = [];
            for (let item of this.checkInAddressEditListDto)
                data["checkInAddressEditListDto"].push(item.toJSON());
        }
        data["upCardRecord"] = this.upCardRecord ? this.upCardRecord.toJSON() : <any>undefined;
        data["downCardRecord"] = this.downCardRecord ? this.downCardRecord.toJSON() : <any>undefined;
        data["appScale"] = this.appScale;
        return data;
    }

    clone(): AttendanceRecordDto {
        const json = this.toJSON();
        let result = new AttendanceRecordDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceRecordDto {
    /** 当前时间 */
    dateTimeNow: moment.Moment;
    /** 出勤日期 */
    attendDate: moment.Moment | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 班次 */
    shiftName: string | undefined;
    /** 上班时间(时分格式) */
    startTime: string | undefined;
    /** 下班时间(时分格式) */
    endTime: string | undefined;
    /** 是否休息 */
    isRest: boolean;
    /** 打卡地址列表 */
    checkInAddressEditListDto: CheckInAddressEditDto[] | undefined;
    upCardRecord: CheckInRecordListDto;
    downCardRecord: CheckInRecordListDto;
    /** APP缩放等级 */
    appScale: string | undefined;
}

/** 月打卡记录 */
export class MonthAttendanceRecordDto implements IMonthAttendanceRecordDto {
    /** 天 */
    day: number;
    /** 考勤日期 */
    attendDate: moment.Moment | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工 4：缺卡) */
    abnormalType: string | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 上班时间(时分格式) */
    startTime: string | undefined;
    /** 下班时间(时分格式) */
    endTime: string | undefined;
    /** 上班取卡开始(时分格式) */
    upCardStartTime: string | undefined;
    /** 上班取卡结束(时分格式) */
    upCardEndTime: string | undefined;
    /** 下班取卡开始(时分格式) */
    downCardStartTime: string | undefined;
    /** 下班取卡结束(时分格式) */
    downCardEndTime: string | undefined;
    /** 允许迟到分钟数 */
    lateMinutes: number | undefined;
    /** 允许早退分钟数 */
    leaveEarlyMinutes: number | undefined;
    /** 旷工开始分钟数(大于迟到设置值) */
    absenteeismMinutes: number | undefined;
    /** 是否跳过 */
    isSkip: boolean;
    /** 跳过原因 */
    skipMsg: string | undefined;
    upCardRecord: CheckInRecordListDto;
    downCardRecord: CheckInRecordListDto;
    /** 是否需要补卡 */
    isSignCard: boolean;
    /** OnWork上班 OffWork下班 */
    signCardType: string | undefined;

    constructor(data?: IMonthAttendanceRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.attendDate = _data["attendDate"] ? moment(_data["attendDate"].toString()) : <any>undefined;
            this.abnormalType = _data["abnormalType"];
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.upCardStartTime = _data["upCardStartTime"];
            this.upCardEndTime = _data["upCardEndTime"];
            this.downCardStartTime = _data["downCardStartTime"];
            this.downCardEndTime = _data["downCardEndTime"];
            this.lateMinutes = _data["lateMinutes"];
            this.leaveEarlyMinutes = _data["leaveEarlyMinutes"];
            this.absenteeismMinutes = _data["absenteeismMinutes"];
            this.isSkip = _data["isSkip"];
            this.skipMsg = _data["skipMsg"];
            this.upCardRecord = _data["upCardRecord"] ? CheckInRecordListDto.fromJS(_data["upCardRecord"]) : <any>undefined;
            this.downCardRecord = _data["downCardRecord"] ? CheckInRecordListDto.fromJS(_data["downCardRecord"]) : <any>undefined;
            this.isSignCard = _data["isSignCard"];
            this.signCardType = _data["signCardType"];
        }
    }

    static fromJS(data: any): MonthAttendanceRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttendanceRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["attendDate"] = this.attendDate ? this.attendDate.toISOString() : <any>undefined;
        data["abnormalType"] = this.abnormalType;
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["upCardStartTime"] = this.upCardStartTime;
        data["upCardEndTime"] = this.upCardEndTime;
        data["downCardStartTime"] = this.downCardStartTime;
        data["downCardEndTime"] = this.downCardEndTime;
        data["lateMinutes"] = this.lateMinutes;
        data["leaveEarlyMinutes"] = this.leaveEarlyMinutes;
        data["absenteeismMinutes"] = this.absenteeismMinutes;
        data["isSkip"] = this.isSkip;
        data["skipMsg"] = this.skipMsg;
        data["upCardRecord"] = this.upCardRecord ? this.upCardRecord.toJSON() : <any>undefined;
        data["downCardRecord"] = this.downCardRecord ? this.downCardRecord.toJSON() : <any>undefined;
        data["isSignCard"] = this.isSignCard;
        data["signCardType"] = this.signCardType;
        return data;
    }

    clone(): MonthAttendanceRecordDto {
        const json = this.toJSON();
        let result = new MonthAttendanceRecordDto();
        result.init(json);
        return result;
    }
}

/** 月打卡记录 */
export interface IMonthAttendanceRecordDto {
    /** 天 */
    day: number;
    /** 考勤日期 */
    attendDate: moment.Moment | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工 4：缺卡) */
    abnormalType: string | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 上班时间(时分格式) */
    startTime: string | undefined;
    /** 下班时间(时分格式) */
    endTime: string | undefined;
    /** 上班取卡开始(时分格式) */
    upCardStartTime: string | undefined;
    /** 上班取卡结束(时分格式) */
    upCardEndTime: string | undefined;
    /** 下班取卡开始(时分格式) */
    downCardStartTime: string | undefined;
    /** 下班取卡结束(时分格式) */
    downCardEndTime: string | undefined;
    /** 允许迟到分钟数 */
    lateMinutes: number | undefined;
    /** 允许早退分钟数 */
    leaveEarlyMinutes: number | undefined;
    /** 旷工开始分钟数(大于迟到设置值) */
    absenteeismMinutes: number | undefined;
    /** 是否跳过 */
    isSkip: boolean;
    /** 跳过原因 */
    skipMsg: string | undefined;
    upCardRecord: CheckInRecordListDto;
    downCardRecord: CheckInRecordListDto;
    /** 是否需要补卡 */
    isSignCard: boolean;
    /** OnWork上班 OffWork下班 */
    signCardType: string | undefined;
}

export class EmployeeQuitListDto implements IEmployeeQuitListDto {
    id: number | undefined;
    /** 工号---------------------新增 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    depertment: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 员工类型Code */
    empTypeCode: string | undefined;
    /** 员工状态 */
    empState: string | undefined;
    /** 员工状态code */
    empStateCode: string | undefined;
    /** 入职日期-------------------新增 */
    hireDate: moment.Moment | undefined;
    /** 转正日期-------------------新增 */
    regularDate: moment.Moment | undefined;
    /** 离职日期-------------------新增 */
    termDate: moment.Moment | undefined;
    /** 离职原因 */
    termReason: string | undefined;

    constructor(data?: IEmployeeQuitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.company = _data["company"];
            this.depertment = _data["depertment"];
            this.empType = _data["empType"];
            this.empTypeCode = _data["empTypeCode"];
            this.empState = _data["empState"];
            this.empStateCode = _data["empStateCode"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.termReason = _data["termReason"];
        }
    }

    static fromJS(data: any): EmployeeQuitListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeQuitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["company"] = this.company;
        data["depertment"] = this.depertment;
        data["empType"] = this.empType;
        data["empTypeCode"] = this.empTypeCode;
        data["empState"] = this.empState;
        data["empStateCode"] = this.empStateCode;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["termReason"] = this.termReason;
        return data;
    }

    clone(): EmployeeQuitListDto {
        const json = this.toJSON();
        let result = new EmployeeQuitListDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeQuitListDto {
    id: number | undefined;
    /** 工号---------------------新增 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    depertment: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 员工类型Code */
    empTypeCode: string | undefined;
    /** 员工状态 */
    empState: string | undefined;
    /** 员工状态code */
    empStateCode: string | undefined;
    /** 入职日期-------------------新增 */
    hireDate: moment.Moment | undefined;
    /** 转正日期-------------------新增 */
    regularDate: moment.Moment | undefined;
    /** 离职日期-------------------新增 */
    termDate: moment.Moment | undefined;
    /** 离职原因 */
    termReason: string | undefined;
}

export class PagedResultDtoOfEmployeeQuitListDto implements IPagedResultDtoOfEmployeeQuitListDto {
    totalCount: number;
    items: EmployeeQuitListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmployeeQuitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeQuitListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmployeeQuitListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmployeeQuitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEmployeeQuitListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmployeeQuitListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmployeeQuitListDto {
    totalCount: number;
    items: EmployeeQuitListDto[] | undefined;
}

export class HandleEmployeeQuitDto implements IHandleEmployeeQuitDto {
    /** 员工Id */
    empId: number;
    /** 离职日期-------------------新增 */
    termDate: moment.Moment | undefined;
    /** 离职原因 */
    termReason: string | undefined;

    constructor(data?: IHandleEmployeeQuitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.termReason = _data["termReason"];
        }
    }

    static fromJS(data: any): HandleEmployeeQuitDto {
        data = typeof data === 'object' ? data : {};
        let result = new HandleEmployeeQuitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["termReason"] = this.termReason;
        return data;
    }

    clone(): HandleEmployeeQuitDto {
        const json = this.toJSON();
        let result = new HandleEmployeeQuitDto();
        result.init(json);
        return result;
    }
}

export interface IHandleEmployeeQuitDto {
    /** 员工Id */
    empId: number;
    /** 离职日期-------------------新增 */
    termDate: moment.Moment | undefined;
    /** 离职原因 */
    termReason: string | undefined;
}

/** 企业考勤周期的列表DTO QYB.QYBProduct.Attendance.EnterpriseAttendCycle.EnterpriseAttendCycle */
export class EnterpriseAttendCycleEditDto implements IEnterpriseAttendCycleEditDto {
    /** Id */
    id: number | undefined;
    /** StartDay */
    startDay: number;

    constructor(data?: IEnterpriseAttendCycleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDay = _data["startDay"];
        }
    }

    static fromJS(data: any): EnterpriseAttendCycleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAttendCycleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDay"] = this.startDay;
        return data;
    }

    clone(): EnterpriseAttendCycleEditDto {
        const json = this.toJSON();
        let result = new EnterpriseAttendCycleEditDto();
        result.init(json);
        return result;
    }
}

/** 企业考勤周期的列表DTO QYB.QYBProduct.Attendance.EnterpriseAttendCycle.EnterpriseAttendCycle */
export interface IEnterpriseAttendCycleEditDto {
    /** Id */
    id: number | undefined;
    /** StartDay */
    startDay: number;
}

export class CreateOrUpdateEnterpriseAttendCycleInput implements ICreateOrUpdateEnterpriseAttendCycleInput {
    enterpriseAttendCycle: EnterpriseAttendCycleEditDto;

    constructor(data?: ICreateOrUpdateEnterpriseAttendCycleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.enterpriseAttendCycle = new EnterpriseAttendCycleEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseAttendCycle = _data["enterpriseAttendCycle"] ? EnterpriseAttendCycleEditDto.fromJS(_data["enterpriseAttendCycle"]) : new EnterpriseAttendCycleEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEnterpriseAttendCycleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEnterpriseAttendCycleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseAttendCycle"] = this.enterpriseAttendCycle ? this.enterpriseAttendCycle.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateEnterpriseAttendCycleInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateEnterpriseAttendCycleInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEnterpriseAttendCycleInput {
    enterpriseAttendCycle: EnterpriseAttendCycleEditDto;
}

export class GetCycleDto implements IGetCycleDto {
    startTime: string | undefined;
    endTime: string | undefined;
    /** xxxx-xx */
    yearOrMonth: string | undefined;

    constructor(data?: IGetCycleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.yearOrMonth = _data["yearOrMonth"];
        }
    }

    static fromJS(data: any): GetCycleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCycleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["yearOrMonth"] = this.yearOrMonth;
        return data;
    }

    clone(): GetCycleDto {
        const json = this.toJSON();
        let result = new GetCycleDto();
        result.init(json);
        return result;
    }
}

export interface IGetCycleDto {
    startTime: string | undefined;
    endTime: string | undefined;
    /** xxxx-xx */
    yearOrMonth: string | undefined;
}

/** 读取可编辑企业考勤周期的Dto */
export class GetEnterpriseAttendCycleForEditOutput implements IGetEnterpriseAttendCycleForEditOutput {
    enterpriseAttendCycle: EnterpriseAttendCycleEditDto;

    constructor(data?: IGetEnterpriseAttendCycleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enterpriseAttendCycle = _data["enterpriseAttendCycle"] ? EnterpriseAttendCycleEditDto.fromJS(_data["enterpriseAttendCycle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEnterpriseAttendCycleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnterpriseAttendCycleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enterpriseAttendCycle"] = this.enterpriseAttendCycle ? this.enterpriseAttendCycle.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetEnterpriseAttendCycleForEditOutput {
        const json = this.toJSON();
        let result = new GetEnterpriseAttendCycleForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑企业考勤周期的Dto */
export interface IGetEnterpriseAttendCycleForEditOutput {
    enterpriseAttendCycle: EnterpriseAttendCycleEditDto;
}

/** 企业考勤周期的列表DTO QYB.QYBProduct.Attendance.EnterpriseAttendCycle.EnterpriseAttendCycle */
export class EnterpriseAttendCycleListDto implements IEnterpriseAttendCycleListDto {
    /** StartDay */
    startDay: number;
    id: number;

    constructor(data?: IEnterpriseAttendCycleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDay = _data["startDay"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnterpriseAttendCycleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseAttendCycleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDay"] = this.startDay;
        data["id"] = this.id;
        return data;
    }

    clone(): EnterpriseAttendCycleListDto {
        const json = this.toJSON();
        let result = new EnterpriseAttendCycleListDto();
        result.init(json);
        return result;
    }
}

/** 企业考勤周期的列表DTO QYB.QYBProduct.Attendance.EnterpriseAttendCycle.EnterpriseAttendCycle */
export interface IEnterpriseAttendCycleListDto {
    /** StartDay */
    startDay: number;
    id: number;
}

export class PagedResultDtoOfEnterpriseAttendCycleListDto implements IPagedResultDtoOfEnterpriseAttendCycleListDto {
    totalCount: number;
    items: EnterpriseAttendCycleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEnterpriseAttendCycleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EnterpriseAttendCycleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEnterpriseAttendCycleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEnterpriseAttendCycleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEnterpriseAttendCycleListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEnterpriseAttendCycleListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEnterpriseAttendCycleListDto {
    totalCount: number;
    items: EnterpriseAttendCycleListDto[] | undefined;
}

export class EnterpriseCalendarDtoInput implements IEnterpriseCalendarDtoInput {
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 工作日类型(工作日,周末,法定) */
    workTypeCode: string | undefined;
    /** 描述 */
    description: string | undefined;

    constructor(data?: IEnterpriseCalendarDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.workTypeCode = _data["workTypeCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EnterpriseCalendarDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseCalendarDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["workTypeCode"] = this.workTypeCode;
        data["description"] = this.description;
        return data;
    }

    clone(): EnterpriseCalendarDtoInput {
        const json = this.toJSON();
        let result = new EnterpriseCalendarDtoInput();
        result.init(json);
        return result;
    }
}

export interface IEnterpriseCalendarDtoInput {
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 工作日类型(工作日,周末,法定) */
    workTypeCode: string | undefined;
    /** 描述 */
    description: string | undefined;
}

export class EnterpriseCalendarListDto implements IEnterpriseCalendarListDto {
    /** 日期 */
    calendarDate: moment.Moment | undefined;
    /** 工作日类型(工作日,周末,法定) */
    workTypeCode: string | undefined;
    workType: DataItemDetail;
    /** 描述 */
    description: string | undefined;

    constructor(data?: IEnterpriseCalendarListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarDate = _data["calendarDate"] ? moment(_data["calendarDate"].toString()) : <any>undefined;
            this.workTypeCode = _data["workTypeCode"];
            this.workType = _data["workType"] ? DataItemDetail.fromJS(_data["workType"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EnterpriseCalendarListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseCalendarListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarDate"] = this.calendarDate ? this.calendarDate.toISOString() : <any>undefined;
        data["workTypeCode"] = this.workTypeCode;
        data["workType"] = this.workType ? this.workType.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }

    clone(): EnterpriseCalendarListDto {
        const json = this.toJSON();
        let result = new EnterpriseCalendarListDto();
        result.init(json);
        return result;
    }
}

export interface IEnterpriseCalendarListDto {
    /** 日期 */
    calendarDate: moment.Moment | undefined;
    /** 工作日类型(工作日,周末,法定) */
    workTypeCode: string | undefined;
    workType: DataItemDetail;
    /** 描述 */
    description: string | undefined;
}

export class EnterpriseCalendarEditDto implements IEnterpriseCalendarEditDto {
    id: number | undefined;
    /** 日期 */
    calendarDate: moment.Moment;
    /** 工作日类型(工作日,周末,法定) */
    workTypeCode: string | undefined;
    /** 描述 */
    description: string | undefined;

    constructor(data?: IEnterpriseCalendarEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calendarDate = _data["calendarDate"] ? moment(_data["calendarDate"].toString()) : <any>undefined;
            this.workTypeCode = _data["workTypeCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EnterpriseCalendarEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnterpriseCalendarEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calendarDate"] = this.calendarDate ? this.calendarDate.toISOString() : <any>undefined;
        data["workTypeCode"] = this.workTypeCode;
        data["description"] = this.description;
        return data;
    }

    clone(): EnterpriseCalendarEditDto {
        const json = this.toJSON();
        let result = new EnterpriseCalendarEditDto();
        result.init(json);
        return result;
    }
}

export interface IEnterpriseCalendarEditDto {
    id: number | undefined;
    /** 日期 */
    calendarDate: moment.Moment;
    /** 工作日类型(工作日,周末,法定) */
    workTypeCode: string | undefined;
    /** 描述 */
    description: string | undefined;
}

/** 审核记录导出 */
export class GetAuditTaskDetailExportDto implements IGetAuditTaskDetailExportDto {
    /** 审核人 */
    inspectorName: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 是否跳过审核项 */
    isSkipAuditPointName: string | undefined;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核时间 */
    auditTime: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;

    constructor(data?: IGetAuditTaskDetailExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspectorName = _data["inspectorName"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            this.auditItemName = _data["auditItemName"];
            this.auditTaskStateName = _data["auditTaskStateName"];
            this.isSkipAuditPointName = _data["isSkipAuditPointName"];
            this.result = _data["result"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.auditTime = _data["auditTime"];
            this.note = _data["note"];
            this.data = _data["data"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): GetAuditTaskDetailExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditTaskDetailExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectorName"] = this.inspectorName;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["auditPointName"] = this.auditPointName;
        data["auditItemTypeName"] = this.auditItemTypeName;
        data["auditItemName"] = this.auditItemName;
        data["auditTaskStateName"] = this.auditTaskStateName;
        data["isSkipAuditPointName"] = this.isSkipAuditPointName;
        data["result"] = this.result;
        data["deviationTypeName"] = this.deviationTypeName;
        data["auditTime"] = this.auditTime;
        data["note"] = this.note;
        data["data"] = this.data;
        data["picture"] = this.picture;
        return data;
    }

    clone(): GetAuditTaskDetailExportDto {
        const json = this.toJSON();
        let result = new GetAuditTaskDetailExportDto();
        result.init(json);
        return result;
    }
}

/** 审核记录导出 */
export interface IGetAuditTaskDetailExportDto {
    /** 审核人 */
    inspectorName: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 是否跳过审核项 */
    isSkipAuditPointName: string | undefined;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核时间 */
    auditTime: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
}

export class FeedbackEditDto implements IFeedbackEditDto {
    /** 反馈账号Id */
    userId: number | undefined;
    /** 反馈分类 */
    feedbackType: string | undefined;
    /** 反馈图片 */
    feedbackPicture: string | undefined;
    /** 反馈内容 */
    feedbackContent: string | undefined;
    /** 系统名称(安卓、IOS) */
    systemName: string | undefined;
    /** 设备标识 */
    clientId: string | undefined;
    /** APP版本 */
    appEdition: string | undefined;
    /** 手机品牌 */
    phoneBrand: string | undefined;
    /** 标识（1 网页，2 APP） */
    identification: number;
    /** 父级ID */
    parentId: number;
    /** 状态(01处理中，02已回复，03已关闭) */
    state: string | undefined;
    /** 评价等级 */
    evaluationGrade: string | undefined;
    /** 问题评价 */
    problemEvaluation: string | undefined;
    /** 意见分类 */
    problemType: string | undefined;

    constructor(data?: IFeedbackEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.feedbackType = _data["feedbackType"];
            this.feedbackPicture = _data["feedbackPicture"];
            this.feedbackContent = _data["feedbackContent"];
            this.systemName = _data["systemName"];
            this.clientId = _data["clientId"];
            this.appEdition = _data["appEdition"];
            this.phoneBrand = _data["phoneBrand"];
            this.identification = _data["identification"];
            this.parentId = _data["parentId"];
            this.state = _data["state"];
            this.evaluationGrade = _data["evaluationGrade"];
            this.problemEvaluation = _data["problemEvaluation"];
            this.problemType = _data["problemType"];
        }
    }

    static fromJS(data: any): FeedbackEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["feedbackType"] = this.feedbackType;
        data["feedbackPicture"] = this.feedbackPicture;
        data["feedbackContent"] = this.feedbackContent;
        data["systemName"] = this.systemName;
        data["clientId"] = this.clientId;
        data["appEdition"] = this.appEdition;
        data["phoneBrand"] = this.phoneBrand;
        data["identification"] = this.identification;
        data["parentId"] = this.parentId;
        data["state"] = this.state;
        data["evaluationGrade"] = this.evaluationGrade;
        data["problemEvaluation"] = this.problemEvaluation;
        data["problemType"] = this.problemType;
        return data;
    }

    clone(): FeedbackEditDto {
        const json = this.toJSON();
        let result = new FeedbackEditDto();
        result.init(json);
        return result;
    }
}

export interface IFeedbackEditDto {
    /** 反馈账号Id */
    userId: number | undefined;
    /** 反馈分类 */
    feedbackType: string | undefined;
    /** 反馈图片 */
    feedbackPicture: string | undefined;
    /** 反馈内容 */
    feedbackContent: string | undefined;
    /** 系统名称(安卓、IOS) */
    systemName: string | undefined;
    /** 设备标识 */
    clientId: string | undefined;
    /** APP版本 */
    appEdition: string | undefined;
    /** 手机品牌 */
    phoneBrand: string | undefined;
    /** 标识（1 网页，2 APP） */
    identification: number;
    /** 父级ID */
    parentId: number;
    /** 状态(01处理中，02已回复，03已关闭) */
    state: string | undefined;
    /** 评价等级 */
    evaluationGrade: string | undefined;
    /** 问题评价 */
    problemEvaluation: string | undefined;
    /** 意见分类 */
    problemType: string | undefined;
}

export class FeedbackListDto implements IFeedbackListDto {
    /** 反馈账号Id */
    userId: number | undefined;
    /** 反馈类型 */
    feedbackTypeName: string | undefined;
    /** 反馈类型代码 */
    feedbackTypeCode: string | undefined;
    /** 用户账号 */
    userName: string | undefined;
    /** 真实名称 */
    realName: string | undefined;
    /** 反馈图片 */
    feedbackPicture: string | undefined;
    /** 反馈内容 */
    feedbackContent: string | undefined;
    /** 系统名称(安卓、IOS) */
    systemName: string | undefined;
    /** 设备标识 */
    clientId: string | undefined;
    /** APP版本 */
    appEdition: string | undefined;
    /** 意见分类 */
    problemType: string | undefined;
    problemTypeName: string | undefined;
    /** 手机品牌 */
    phoneBrand: string | undefined;
    department: string | undefined;
    /** 是否为自己的反馈 */
    isSelf: boolean;
    /** 租户ID */
    tenantId: number;
    tenantName: string | undefined;
    /** 父级ID */
    parentId: number;
    /** 状态(01处理中，02已回复，03已关闭) */
    state: string | undefined;
    /** 状态名称 */
    stateName: string | undefined;
    /** 评价等级 */
    evaluationGrade: number;
    /** 问题评价 */
    problemEvaluation: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 最后更新用户ID */
    lastModifierUserId: number | undefined;
    /** 最后更新时间 */
    lastModificationTime: moment.Moment | undefined;
    /** 删除用户ID */
    deleterUserId: number | undefined;
    /** 删除时间 */
    deletionTime: moment.Moment | undefined;
    /** 是否删除 */
    isDeleted: boolean;
    id: number;

    constructor(data?: IFeedbackListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.feedbackTypeName = _data["feedbackTypeName"];
            this.feedbackTypeCode = _data["feedbackTypeCode"];
            this.userName = _data["userName"];
            this.realName = _data["realName"];
            this.feedbackPicture = _data["feedbackPicture"];
            this.feedbackContent = _data["feedbackContent"];
            this.systemName = _data["systemName"];
            this.clientId = _data["clientId"];
            this.appEdition = _data["appEdition"];
            this.problemType = _data["problemType"];
            this.problemTypeName = _data["problemTypeName"];
            this.phoneBrand = _data["phoneBrand"];
            this.department = _data["department"];
            this.isSelf = _data["isSelf"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.parentId = _data["parentId"];
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.evaluationGrade = _data["evaluationGrade"];
            this.problemEvaluation = _data["problemEvaluation"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FeedbackListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["feedbackTypeName"] = this.feedbackTypeName;
        data["feedbackTypeCode"] = this.feedbackTypeCode;
        data["userName"] = this.userName;
        data["realName"] = this.realName;
        data["feedbackPicture"] = this.feedbackPicture;
        data["feedbackContent"] = this.feedbackContent;
        data["systemName"] = this.systemName;
        data["clientId"] = this.clientId;
        data["appEdition"] = this.appEdition;
        data["problemType"] = this.problemType;
        data["problemTypeName"] = this.problemTypeName;
        data["phoneBrand"] = this.phoneBrand;
        data["department"] = this.department;
        data["isSelf"] = this.isSelf;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["parentId"] = this.parentId;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["evaluationGrade"] = this.evaluationGrade;
        data["problemEvaluation"] = this.problemEvaluation;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): FeedbackListDto {
        const json = this.toJSON();
        let result = new FeedbackListDto();
        result.init(json);
        return result;
    }
}

export interface IFeedbackListDto {
    /** 反馈账号Id */
    userId: number | undefined;
    /** 反馈类型 */
    feedbackTypeName: string | undefined;
    /** 反馈类型代码 */
    feedbackTypeCode: string | undefined;
    /** 用户账号 */
    userName: string | undefined;
    /** 真实名称 */
    realName: string | undefined;
    /** 反馈图片 */
    feedbackPicture: string | undefined;
    /** 反馈内容 */
    feedbackContent: string | undefined;
    /** 系统名称(安卓、IOS) */
    systemName: string | undefined;
    /** 设备标识 */
    clientId: string | undefined;
    /** APP版本 */
    appEdition: string | undefined;
    /** 意见分类 */
    problemType: string | undefined;
    problemTypeName: string | undefined;
    /** 手机品牌 */
    phoneBrand: string | undefined;
    department: string | undefined;
    /** 是否为自己的反馈 */
    isSelf: boolean;
    /** 租户ID */
    tenantId: number;
    tenantName: string | undefined;
    /** 父级ID */
    parentId: number;
    /** 状态(01处理中，02已回复，03已关闭) */
    state: string | undefined;
    /** 状态名称 */
    stateName: string | undefined;
    /** 评价等级 */
    evaluationGrade: number;
    /** 问题评价 */
    problemEvaluation: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 最后更新用户ID */
    lastModifierUserId: number | undefined;
    /** 最后更新时间 */
    lastModificationTime: moment.Moment | undefined;
    /** 删除用户ID */
    deleterUserId: number | undefined;
    /** 删除时间 */
    deletionTime: moment.Moment | undefined;
    /** 是否删除 */
    isDeleted: boolean;
    id: number;
}

export class PagedResultDtoOfFeedbackListDto implements IPagedResultDtoOfFeedbackListDto {
    totalCount: number;
    items: FeedbackListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFeedbackListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FeedbackListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFeedbackListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFeedbackListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfFeedbackListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFeedbackListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFeedbackListDto {
    totalCount: number;
    items: FeedbackListDto[] | undefined;
}

export class PieChart implements IPieChart {
    value: number;
    name: string | undefined;

    constructor(data?: IPieChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PieChart {
        data = typeof data === 'object' ? data : {};
        let result = new PieChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }

    clone(): PieChart {
        const json = this.toJSON();
        let result = new PieChart();
        result.init(json);
        return result;
    }
}

export interface IPieChart {
    value: number;
    name: string | undefined;
}

/** 柱状图 */
export class Histogram implements IHistogram {
    /** 提交数据 */
    submitData: number[] | undefined;
    /** 关闭数据 */
    offData: number[] | undefined;

    constructor(data?: IHistogram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["submitData"])) {
                this.submitData = [] as any;
                for (let item of _data["submitData"])
                    this.submitData.push(item);
            }
            if (Array.isArray(_data["offData"])) {
                this.offData = [] as any;
                for (let item of _data["offData"])
                    this.offData.push(item);
            }
        }
    }

    static fromJS(data: any): Histogram {
        data = typeof data === 'object' ? data : {};
        let result = new Histogram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.submitData)) {
            data["submitData"] = [];
            for (let item of this.submitData)
                data["submitData"].push(item);
        }
        if (Array.isArray(this.offData)) {
            data["offData"] = [];
            for (let item of this.offData)
                data["offData"].push(item);
        }
        return data;
    }

    clone(): Histogram {
        const json = this.toJSON();
        let result = new Histogram();
        result.init(json);
        return result;
    }
}

/** 柱状图 */
export interface IHistogram {
    /** 提交数据 */
    submitData: number[] | undefined;
    /** 关闭数据 */
    offData: number[] | undefined;
}

/** 文件上传输出Dto */
export class FileUploadOutputDto implements IFileUploadOutputDto {
    fileName: string;
    fileToken: string;
    fileSize: number;

    constructor(data?: IFileUploadOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileToken = _data["fileToken"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): FileUploadOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileToken"] = this.fileToken;
        data["fileSize"] = this.fileSize;
        return data;
    }

    clone(): FileUploadOutputDto {
        const json = this.toJSON();
        let result = new FileUploadOutputDto();
        result.init(json);
        return result;
    }
}

/** 文件上传输出Dto */
export interface IFileUploadOutputDto {
    fileName: string;
    fileToken: string;
    fileSize: number;
}

/** 文件的编辑DTO QYB.Modules.FileManager.SysFile */
export class SysFileListDto implements ISysFileListDto {
    /** 是否为文件夹 */
    dir: boolean;
    /** 父级 QYB.Modules.FileManager.SysFile Id. 如果是根节点，值为null */
    parentId: string | undefined;
    /** 是否为图片 */
    isImg: boolean;
    /** 文件名 */
    name: string | undefined;
    /** 原文件名 */
    fileName: string | undefined;
    /** 路径 */
    path: string | undefined;
    /** 文件格式 */
    fileExt: string | undefined;
    /** 文件类型 */
    contentType: string | undefined;
    /** 格式化大小 */
    formattedSize: string | undefined;
    /** 大小 */
    size: number;
    /** 宽度 */
    width: number;
    /** 高度 */
    height: number;
    /** 编码 */
    code: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: ISysFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dir = _data["dir"];
            this.parentId = _data["parentId"];
            this.isImg = _data["isImg"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
            this.path = _data["path"];
            this.fileExt = _data["fileExt"];
            this.contentType = _data["contentType"];
            this.formattedSize = _data["formattedSize"];
            this.size = _data["size"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.code = _data["code"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SysFileListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dir"] = this.dir;
        data["parentId"] = this.parentId;
        data["isImg"] = this.isImg;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["path"] = this.path;
        data["fileExt"] = this.fileExt;
        data["contentType"] = this.contentType;
        data["formattedSize"] = this.formattedSize;
        data["size"] = this.size;
        data["width"] = this.width;
        data["height"] = this.height;
        data["code"] = this.code;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): SysFileListDto {
        const json = this.toJSON();
        let result = new SysFileListDto();
        result.init(json);
        return result;
    }
}

/** 文件的编辑DTO QYB.Modules.FileManager.SysFile */
export interface ISysFileListDto {
    /** 是否为文件夹 */
    dir: boolean;
    /** 父级 QYB.Modules.FileManager.SysFile Id. 如果是根节点，值为null */
    parentId: string | undefined;
    /** 是否为图片 */
    isImg: boolean;
    /** 文件名 */
    name: string | undefined;
    /** 原文件名 */
    fileName: string | undefined;
    /** 路径 */
    path: string | undefined;
    /** 文件格式 */
    fileExt: string | undefined;
    /** 文件类型 */
    contentType: string | undefined;
    /** 格式化大小 */
    formattedSize: string | undefined;
    /** 大小 */
    size: number;
    /** 宽度 */
    width: number;
    /** 高度 */
    height: number;
    /** 编码 */
    code: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AcceptFriendshipRequestInput {
        const json = this.toJSON();
        let result = new AcceptFriendshipRequestInput();
        result.init(json);
        return result;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): BlockUserInput {
        const json = this.toJSON();
        let result = new BlockUserInput();
        result.init(json);
        return result;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): CreateFriendshipRequestInput {
        const json = this.toJSON();
        let result = new CreateFriendshipRequestInput();
        result.init(json);
        return result;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }

    clone(): CreateFriendshipRequestByUserNameInput {
        const json = this.toJSON();
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(json);
        return result;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): UnblockUserInput {
        const json = this.toJSON();
        let result = new UnblockUserInput();
        result.init(json);
        return result;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class IssuesClient implements IIssuesClient {

    constructor(data?: IIssuesClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IssuesClient {
        data = typeof data === 'object' ? data : {};
        let result = new IssuesClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IssuesClient {
        const json = this.toJSON();
        let result = new IssuesClient();
        result.init(json);
        return result;
    }
}

export interface IIssuesClient {
}

export class UploadsClient implements IUploadsClient {

    constructor(data?: IUploadsClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UploadsClient {
        data = typeof data === 'object' ? data : {};
        let result = new UploadsClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UploadsClient {
        const json = this.toJSON();
        let result = new UploadsClient();
        result.init(json);
        return result;
    }
}

export interface IUploadsClient {
}

export class MergeRequestsClient implements IMergeRequestsClient {

    constructor(data?: IMergeRequestsClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MergeRequestsClient {
        data = typeof data === 'object' ? data : {};
        let result = new MergeRequestsClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): MergeRequestsClient {
        const json = this.toJSON();
        let result = new MergeRequestsClient();
        result.init(json);
        return result;
    }
}

export interface IMergeRequestsClient {
}

export class ProjectsClient implements IProjectsClient {

    constructor(data?: IProjectsClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ProjectsClient {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectsClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ProjectsClient {
        const json = this.toJSON();
        let result = new ProjectsClient();
        result.init(json);
        return result;
    }
}

export interface IProjectsClient {
}

export class UsersClient implements IUsersClient {

    constructor(data?: IUsersClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UsersClient {
        data = typeof data === 'object' ? data : {};
        let result = new UsersClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UsersClient {
        const json = this.toJSON();
        let result = new UsersClient();
        result.init(json);
        return result;
    }
}

export interface IUsersClient {
}

export class GroupsClient implements IGroupsClient {

    constructor(data?: IGroupsClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GroupsClient {
        data = typeof data === 'object' ? data : {};
        let result = new GroupsClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): GroupsClient {
        const json = this.toJSON();
        let result = new GroupsClient();
        result.init(json);
        return result;
    }
}

export interface IGroupsClient {
}

export class BranchClient implements IBranchClient {

    constructor(data?: IBranchClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BranchClient {
        data = typeof data === 'object' ? data : {};
        let result = new BranchClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): BranchClient {
        const json = this.toJSON();
        let result = new BranchClient();
        result.init(json);
        return result;
    }
}

export interface IBranchClient {
}

export class ReleaseClient implements IReleaseClient {

    constructor(data?: IReleaseClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReleaseClient {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ReleaseClient {
        const json = this.toJSON();
        let result = new ReleaseClient();
        result.init(json);
        return result;
    }
}

export interface IReleaseClient {
}

export class TagClient implements ITagClient {

    constructor(data?: ITagClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TagClient {
        data = typeof data === 'object' ? data : {};
        let result = new TagClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): TagClient {
        const json = this.toJSON();
        let result = new TagClient();
        result.init(json);
        return result;
    }
}

export interface ITagClient {
}

export class WebhookClient implements IWebhookClient {

    constructor(data?: IWebhookClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WebhookClient {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): WebhookClient {
        const json = this.toJSON();
        let result = new WebhookClient();
        result.init(json);
        return result;
    }
}

export interface IWebhookClient {
}

export class CommitsClient implements ICommitsClient {

    constructor(data?: ICommitsClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CommitsClient {
        data = typeof data === 'object' ? data : {};
        let result = new CommitsClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CommitsClient {
        const json = this.toJSON();
        let result = new CommitsClient();
        result.init(json);
        return result;
    }
}

export interface ICommitsClient {
}

export class TreesClient implements ITreesClient {

    constructor(data?: ITreesClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TreesClient {
        data = typeof data === 'object' ? data : {};
        let result = new TreesClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): TreesClient {
        const json = this.toJSON();
        let result = new TreesClient();
        result.init(json);
        return result;
    }
}

export interface ITreesClient {
}

export class FilesClient implements IFilesClient {

    constructor(data?: IFilesClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FilesClient {
        data = typeof data === 'object' ? data : {};
        let result = new FilesClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): FilesClient {
        const json = this.toJSON();
        let result = new FilesClient();
        result.init(json);
        return result;
    }
}

export interface IFilesClient {
}

export class MarkdownClient implements IMarkdownClient {

    constructor(data?: IMarkdownClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarkdownClient {
        data = typeof data === 'object' ? data : {};
        let result = new MarkdownClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): MarkdownClient {
        const json = this.toJSON();
        let result = new MarkdownClient();
        result.init(json);
        return result;
    }
}

export interface IMarkdownClient {
}

export class PipelineClient implements IPipelineClient {

    constructor(data?: IPipelineClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PipelineClient {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): PipelineClient {
        const json = this.toJSON();
        let result = new PipelineClient();
        result.init(json);
        return result;
    }
}

export interface IPipelineClient {
}

export class RunnersClient implements IRunnersClient {

    constructor(data?: IRunnersClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RunnersClient {
        data = typeof data === 'object' ? data : {};
        let result = new RunnersClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): RunnersClient {
        const json = this.toJSON();
        let result = new RunnersClient();
        result.init(json);
        return result;
    }
}

export interface IRunnersClient {
}

export class ToDoListClient implements IToDoListClient {

    constructor(data?: IToDoListClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ToDoListClient {
        data = typeof data === 'object' ? data : {};
        let result = new ToDoListClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ToDoListClient {
        const json = this.toJSON();
        let result = new ToDoListClient();
        result.init(json);
        return result;
    }
}

export interface IToDoListClient {
}

export class GitLabClient implements IGitLabClient {
    issues: IssuesClient;
    uploads: UploadsClient;
    mergeRequests: MergeRequestsClient;
    projects: ProjectsClient;
    users: UsersClient;
    groups: GroupsClient;
    branches: BranchClient;
    releases: ReleaseClient;
    tags: TagClient;
    webhooks: WebhookClient;
    commits: CommitsClient;
    trees: TreesClient;
    files: FilesClient;
    markdown: MarkdownClient;
    pipelines: PipelineClient;
    runners: RunnersClient;
    toDoList: ToDoListClient;
    hostUrl: string | undefined;

    constructor(data?: IGitLabClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issues = _data["issues"] ? IssuesClient.fromJS(_data["issues"]) : <any>undefined;
            this.uploads = _data["uploads"] ? UploadsClient.fromJS(_data["uploads"]) : <any>undefined;
            this.mergeRequests = _data["mergeRequests"] ? MergeRequestsClient.fromJS(_data["mergeRequests"]) : <any>undefined;
            this.projects = _data["projects"] ? ProjectsClient.fromJS(_data["projects"]) : <any>undefined;
            this.users = _data["users"] ? UsersClient.fromJS(_data["users"]) : <any>undefined;
            this.groups = _data["groups"] ? GroupsClient.fromJS(_data["groups"]) : <any>undefined;
            this.branches = _data["branches"] ? BranchClient.fromJS(_data["branches"]) : <any>undefined;
            this.releases = _data["releases"] ? ReleaseClient.fromJS(_data["releases"]) : <any>undefined;
            this.tags = _data["tags"] ? TagClient.fromJS(_data["tags"]) : <any>undefined;
            this.webhooks = _data["webhooks"] ? WebhookClient.fromJS(_data["webhooks"]) : <any>undefined;
            this.commits = _data["commits"] ? CommitsClient.fromJS(_data["commits"]) : <any>undefined;
            this.trees = _data["trees"] ? TreesClient.fromJS(_data["trees"]) : <any>undefined;
            this.files = _data["files"] ? FilesClient.fromJS(_data["files"]) : <any>undefined;
            this.markdown = _data["markdown"] ? MarkdownClient.fromJS(_data["markdown"]) : <any>undefined;
            this.pipelines = _data["pipelines"] ? PipelineClient.fromJS(_data["pipelines"]) : <any>undefined;
            this.runners = _data["runners"] ? RunnersClient.fromJS(_data["runners"]) : <any>undefined;
            this.toDoList = _data["toDoList"] ? ToDoListClient.fromJS(_data["toDoList"]) : <any>undefined;
            this.hostUrl = _data["hostUrl"];
        }
    }

    static fromJS(data: any): GitLabClient {
        data = typeof data === 'object' ? data : {};
        let result = new GitLabClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issues"] = this.issues ? this.issues.toJSON() : <any>undefined;
        data["uploads"] = this.uploads ? this.uploads.toJSON() : <any>undefined;
        data["mergeRequests"] = this.mergeRequests ? this.mergeRequests.toJSON() : <any>undefined;
        data["projects"] = this.projects ? this.projects.toJSON() : <any>undefined;
        data["users"] = this.users ? this.users.toJSON() : <any>undefined;
        data["groups"] = this.groups ? this.groups.toJSON() : <any>undefined;
        data["branches"] = this.branches ? this.branches.toJSON() : <any>undefined;
        data["releases"] = this.releases ? this.releases.toJSON() : <any>undefined;
        data["tags"] = this.tags ? this.tags.toJSON() : <any>undefined;
        data["webhooks"] = this.webhooks ? this.webhooks.toJSON() : <any>undefined;
        data["commits"] = this.commits ? this.commits.toJSON() : <any>undefined;
        data["trees"] = this.trees ? this.trees.toJSON() : <any>undefined;
        data["files"] = this.files ? this.files.toJSON() : <any>undefined;
        data["markdown"] = this.markdown ? this.markdown.toJSON() : <any>undefined;
        data["pipelines"] = this.pipelines ? this.pipelines.toJSON() : <any>undefined;
        data["runners"] = this.runners ? this.runners.toJSON() : <any>undefined;
        data["toDoList"] = this.toDoList ? this.toDoList.toJSON() : <any>undefined;
        data["hostUrl"] = this.hostUrl;
        return data;
    }

    clone(): GitLabClient {
        const json = this.toJSON();
        let result = new GitLabClient();
        result.init(json);
        return result;
    }
}

export interface IGitLabClient {
    issues: IssuesClient;
    uploads: UploadsClient;
    mergeRequests: MergeRequestsClient;
    projects: ProjectsClient;
    users: UsersClient;
    groups: GroupsClient;
    branches: BranchClient;
    releases: ReleaseClient;
    tags: TagClient;
    webhooks: WebhookClient;
    commits: CommitsClient;
    trees: TreesClient;
    files: FilesClient;
    markdown: MarkdownClient;
    pipelines: PipelineClient;
    runners: RunnersClient;
    toDoList: ToDoListClient;
    hostUrl: string | undefined;
}

export class File implements IFile {
    file_name: string | undefined;
    file_path: string | undefined;
    size: number;
    encoding: string | undefined;
    content_sha256: string | undefined;
    ref: string | undefined;
    blob_id: string | undefined;
    commit_id: string | undefined;
    last_commit_id: string | undefined;
    content: string | undefined;
    readonly contentDecoded: string | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file_name = _data["file_name"];
            this.file_path = _data["file_path"];
            this.size = _data["size"];
            this.encoding = _data["encoding"];
            this.content_sha256 = _data["content_sha256"];
            this.ref = _data["ref"];
            this.blob_id = _data["blob_id"];
            this.commit_id = _data["commit_id"];
            this.last_commit_id = _data["last_commit_id"];
            this.content = _data["content"];
            (<any>this).contentDecoded = _data["contentDecoded"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file_name"] = this.file_name;
        data["file_path"] = this.file_path;
        data["size"] = this.size;
        data["encoding"] = this.encoding;
        data["content_sha256"] = this.content_sha256;
        data["ref"] = this.ref;
        data["blob_id"] = this.blob_id;
        data["commit_id"] = this.commit_id;
        data["last_commit_id"] = this.last_commit_id;
        data["content"] = this.content;
        data["contentDecoded"] = this.contentDecoded;
        return data;
    }

    clone(): File {
        const json = this.toJSON();
        let result = new File();
        result.init(json);
        return result;
    }
}

export interface IFile {
    file_name: string | undefined;
    file_path: string | undefined;
    size: number;
    encoding: string | undefined;
    content_sha256: string | undefined;
    ref: string | undefined;
    blob_id: string | undefined;
    commit_id: string | undefined;
    last_commit_id: string | undefined;
    content: string | undefined;
    contentDecoded: string | undefined;
}

export class Links implements ILinks {
    members: string | undefined;
    issues: string | undefined;
    events: string | undefined;
    labels: string | undefined;
    repo_branches: string | undefined;
    merge_requests: string | undefined;
    self: string | undefined;

    constructor(data?: ILinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.members = _data["members"];
            this.issues = _data["issues"];
            this.events = _data["events"];
            this.labels = _data["labels"];
            this.repo_branches = _data["repo_branches"];
            this.merge_requests = _data["merge_requests"];
            this.self = _data["self"];
        }
    }

    static fromJS(data: any): Links {
        data = typeof data === 'object' ? data : {};
        let result = new Links();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["members"] = this.members;
        data["issues"] = this.issues;
        data["events"] = this.events;
        data["labels"] = this.labels;
        data["repo_branches"] = this.repo_branches;
        data["merge_requests"] = this.merge_requests;
        data["self"] = this.self;
        return data;
    }

    clone(): Links {
        const json = this.toJSON();
        let result = new Links();
        result.init(json);
        return result;
    }
}

export interface ILinks {
    members: string | undefined;
    issues: string | undefined;
    events: string | undefined;
    labels: string | undefined;
    repo_branches: string | undefined;
    merge_requests: string | undefined;
    self: string | undefined;
}

export class Owner implements IOwner {
    id: number;
    created_at: moment.Moment;
    name: string | undefined;

    constructor(data?: IOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Owner {
        data = typeof data === 'object' ? data : {};
        let result = new Owner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }

    clone(): Owner {
        const json = this.toJSON();
        let result = new Owner();
        result.init(json);
        return result;
    }
}

export interface IOwner {
    id: number;
    created_at: moment.Moment;
    name: string | undefined;
}

export class Namespace implements INamespace {
    id: number;
    name: string | undefined;
    full_path: string | undefined;
    kind: string | undefined;
    path: string | undefined;

    constructor(data?: INamespace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.full_path = _data["full_path"];
            this.kind = _data["kind"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): Namespace {
        data = typeof data === 'object' ? data : {};
        let result = new Namespace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["full_path"] = this.full_path;
        data["kind"] = this.kind;
        data["path"] = this.path;
        return data;
    }

    clone(): Namespace {
        const json = this.toJSON();
        let result = new Namespace();
        result.init(json);
        return result;
    }
}

export interface INamespace {
    id: number;
    name: string | undefined;
    full_path: string | undefined;
    kind: string | undefined;
    path: string | undefined;
}

export class Access implements IAccess {
    access_level: number;
    notification_level: number;

    constructor(data?: IAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_level = _data["access_level"];
            this.notification_level = _data["notification_level"];
        }
    }

    static fromJS(data: any): Access {
        data = typeof data === 'object' ? data : {};
        let result = new Access();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_level"] = this.access_level;
        data["notification_level"] = this.notification_level;
        return data;
    }

    clone(): Access {
        const json = this.toJSON();
        let result = new Access();
        result.init(json);
        return result;
    }
}

export interface IAccess {
    access_level: number;
    notification_level: number;
}

export class Permissions implements IPermissions {
    group_access: Access;
    project_access: Access;

    constructor(data?: IPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group_access = _data["group_access"] ? Access.fromJS(_data["group_access"]) : <any>undefined;
            this.project_access = _data["project_access"] ? Access.fromJS(_data["project_access"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Permissions {
        data = typeof data === 'object' ? data : {};
        let result = new Permissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group_access"] = this.group_access ? this.group_access.toJSON() : <any>undefined;
        data["project_access"] = this.project_access ? this.project_access.toJSON() : <any>undefined;
        return data;
    }

    clone(): Permissions {
        const json = this.toJSON();
        let result = new Permissions();
        result.init(json);
        return result;
    }
}

export interface IPermissions {
    group_access: Access;
    project_access: Access;
}

export class Statistics implements IStatistics {
    job_artifacts_size: number;
    repository_size: number;
    commit_count: number;
    lfs_objects_size: number;
    storage_size: number;

    constructor(data?: IStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.job_artifacts_size = _data["job_artifacts_size"];
            this.repository_size = _data["repository_size"];
            this.commit_count = _data["commit_count"];
            this.lfs_objects_size = _data["lfs_objects_size"];
            this.storage_size = _data["storage_size"];
        }
    }

    static fromJS(data: any): Statistics {
        data = typeof data === 'object' ? data : {};
        let result = new Statistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job_artifacts_size"] = this.job_artifacts_size;
        data["repository_size"] = this.repository_size;
        data["commit_count"] = this.commit_count;
        data["lfs_objects_size"] = this.lfs_objects_size;
        data["storage_size"] = this.storage_size;
        return data;
    }

    clone(): Statistics {
        const json = this.toJSON();
        let result = new Statistics();
        result.init(json);
        return result;
    }
}

export interface IStatistics {
    job_artifacts_size: number;
    repository_size: number;
    commit_count: number;
    lfs_objects_size: number;
    storage_size: number;
}

export enum ProjectVisibilityLevel {
    Private = <any>"private",
    Internal = <any>"internal",
    Public = <any>"public",
}

export class Project implements IProject {
    last_activity_at: string | undefined;
    description: string | undefined;
    container_registry_enabled: boolean;
    archived: boolean;
    _links: Links;
    avatar_url: string | undefined;
    creator_id: number;
    created_at: string | undefined;
    default_branch: string | undefined;
    import_error: string | undefined;
    http_url_to_repo: string | undefined;
    forks_count: number;
    id: number;
    issues_enabled: boolean;
    import_status: string | undefined;
    jobs_enabled: boolean;
    owner: Owner;
    namespace: Namespace;
    name: string | undefined;
    merge_requests_enabled: boolean;
    name_with_namespace: string | undefined;
    only_allow_merge_if_pipeline_succeeds: boolean | undefined;
    only_allow_merge_if_all_discussions_are_resolved: boolean | undefined;
    open_issues_count: number;
    public_jobs: boolean;
    path_with_namespace: string | undefined;
    path: string | undefined;
    permissions: Permissions;
    runners_token: string | undefined;
    request_access_enabled: boolean;
    shared_runners_enabled: boolean;
    statistics: Statistics;
    ssh_url_to_repo: string | undefined;
    snippets_enabled: boolean;
    star_count: number;
    visibility: ProjectVisibilityLevel;
    readonly tag_list: string[] | undefined;
    web_url: string | undefined;
    wiki_enabled: boolean;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_activity_at = _data["last_activity_at"];
            this.description = _data["description"];
            this.container_registry_enabled = _data["container_registry_enabled"];
            this.archived = _data["archived"];
            this._links = _data["_links"] ? Links.fromJS(_data["_links"]) : <any>undefined;
            this.avatar_url = _data["avatar_url"];
            this.creator_id = _data["creator_id"];
            this.created_at = _data["created_at"];
            this.default_branch = _data["default_branch"];
            this.import_error = _data["import_error"];
            this.http_url_to_repo = _data["http_url_to_repo"];
            this.forks_count = _data["forks_count"];
            this.id = _data["id"];
            this.issues_enabled = _data["issues_enabled"];
            this.import_status = _data["import_status"];
            this.jobs_enabled = _data["jobs_enabled"];
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : <any>undefined;
            this.namespace = _data["namespace"] ? Namespace.fromJS(_data["namespace"]) : <any>undefined;
            this.name = _data["name"];
            this.merge_requests_enabled = _data["merge_requests_enabled"];
            this.name_with_namespace = _data["name_with_namespace"];
            this.only_allow_merge_if_pipeline_succeeds = _data["only_allow_merge_if_pipeline_succeeds"];
            this.only_allow_merge_if_all_discussions_are_resolved = _data["only_allow_merge_if_all_discussions_are_resolved"];
            this.open_issues_count = _data["open_issues_count"];
            this.public_jobs = _data["public_jobs"];
            this.path_with_namespace = _data["path_with_namespace"];
            this.path = _data["path"];
            this.permissions = _data["permissions"] ? Permissions.fromJS(_data["permissions"]) : <any>undefined;
            this.runners_token = _data["runners_token"];
            this.request_access_enabled = _data["request_access_enabled"];
            this.shared_runners_enabled = _data["shared_runners_enabled"];
            this.statistics = _data["statistics"] ? Statistics.fromJS(_data["statistics"]) : <any>undefined;
            this.ssh_url_to_repo = _data["ssh_url_to_repo"];
            this.snippets_enabled = _data["snippets_enabled"];
            this.star_count = _data["star_count"];
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["tag_list"])) {
                (<any>this).tag_list = [] as any;
                for (let item of _data["tag_list"])
                    (<any>this).tag_list.push(item);
            }
            this.web_url = _data["web_url"];
            this.wiki_enabled = _data["wiki_enabled"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_activity_at"] = this.last_activity_at;
        data["description"] = this.description;
        data["container_registry_enabled"] = this.container_registry_enabled;
        data["archived"] = this.archived;
        data["_links"] = this._links ? this._links.toJSON() : <any>undefined;
        data["avatar_url"] = this.avatar_url;
        data["creator_id"] = this.creator_id;
        data["created_at"] = this.created_at;
        data["default_branch"] = this.default_branch;
        data["import_error"] = this.import_error;
        data["http_url_to_repo"] = this.http_url_to_repo;
        data["forks_count"] = this.forks_count;
        data["id"] = this.id;
        data["issues_enabled"] = this.issues_enabled;
        data["import_status"] = this.import_status;
        data["jobs_enabled"] = this.jobs_enabled;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["namespace"] = this.namespace ? this.namespace.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["merge_requests_enabled"] = this.merge_requests_enabled;
        data["name_with_namespace"] = this.name_with_namespace;
        data["only_allow_merge_if_pipeline_succeeds"] = this.only_allow_merge_if_pipeline_succeeds;
        data["only_allow_merge_if_all_discussions_are_resolved"] = this.only_allow_merge_if_all_discussions_are_resolved;
        data["open_issues_count"] = this.open_issues_count;
        data["public_jobs"] = this.public_jobs;
        data["path_with_namespace"] = this.path_with_namespace;
        data["path"] = this.path;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        data["runners_token"] = this.runners_token;
        data["request_access_enabled"] = this.request_access_enabled;
        data["shared_runners_enabled"] = this.shared_runners_enabled;
        data["statistics"] = this.statistics ? this.statistics.toJSON() : <any>undefined;
        data["ssh_url_to_repo"] = this.ssh_url_to_repo;
        data["snippets_enabled"] = this.snippets_enabled;
        data["star_count"] = this.star_count;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.tag_list)) {
            data["tag_list"] = [];
            for (let item of this.tag_list)
                data["tag_list"].push(item);
        }
        data["web_url"] = this.web_url;
        data["wiki_enabled"] = this.wiki_enabled;
        return data;
    }

    clone(): Project {
        const json = this.toJSON();
        let result = new Project();
        result.init(json);
        return result;
    }
}

export interface IProject {
    last_activity_at: string | undefined;
    description: string | undefined;
    container_registry_enabled: boolean;
    archived: boolean;
    _links: Links;
    avatar_url: string | undefined;
    creator_id: number;
    created_at: string | undefined;
    default_branch: string | undefined;
    import_error: string | undefined;
    http_url_to_repo: string | undefined;
    forks_count: number;
    id: number;
    issues_enabled: boolean;
    import_status: string | undefined;
    jobs_enabled: boolean;
    owner: Owner;
    namespace: Namespace;
    name: string | undefined;
    merge_requests_enabled: boolean;
    name_with_namespace: string | undefined;
    only_allow_merge_if_pipeline_succeeds: boolean | undefined;
    only_allow_merge_if_all_discussions_are_resolved: boolean | undefined;
    open_issues_count: number;
    public_jobs: boolean;
    path_with_namespace: string | undefined;
    path: string | undefined;
    permissions: Permissions;
    runners_token: string | undefined;
    request_access_enabled: boolean;
    shared_runners_enabled: boolean;
    statistics: Statistics;
    ssh_url_to_repo: string | undefined;
    snippets_enabled: boolean;
    star_count: number;
    visibility: ProjectVisibilityLevel;
    tag_list: string[] | undefined;
    web_url: string | undefined;
    wiki_enabled: boolean;
}

export class UploadPictureToBed implements IUploadPictureToBed {
    pathWithNamespace: string | undefined;
    file: File;
    directoryPath: string | undefined;

    constructor(data?: IUploadPictureToBed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pathWithNamespace = _data["pathWithNamespace"];
            this.file = _data["file"] ? File.fromJS(_data["file"]) : <any>undefined;
            this.directoryPath = _data["directoryPath"];
        }
    }

    static fromJS(data: any): UploadPictureToBed {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPictureToBed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pathWithNamespace"] = this.pathWithNamespace;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["directoryPath"] = this.directoryPath;
        return data;
    }

    clone(): UploadPictureToBed {
        const json = this.toJSON();
        let result = new UploadPictureToBed();
        result.init(json);
        return result;
    }
}

export interface IUploadPictureToBed {
    pathWithNamespace: string | undefined;
    file: File;
    directoryPath: string | undefined;
}

export class CreateOrEditHandLenntryInput implements ICreateOrEditHandLenntryInput {
    employee: EmployeeEditDto;

    constructor(data?: ICreateOrEditHandLenntryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeEditDto.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditHandLenntryInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHandLenntryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrEditHandLenntryInput {
        const json = this.toJSON();
        let result = new CreateOrEditHandLenntryInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrEditHandLenntryInput {
    employee: EmployeeEditDto;
}

export class EmpattdailyListsDto implements IEmpattdailyListsDto {
    /** 公司 */
    fullName: string | undefined;
    /** 部门 */
    displayName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 员工 */
    userId: number | undefined;
    /** 考勤日期 */
    attDate: moment.Moment | undefined;
    /** 班次code */
    shiftCode: string | undefined;
    /** 应上班时间 */
    shouldStartTime: moment.Moment | undefined;
    /** 应下班时间 */
    shouldEndTime: moment.Moment | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工) */
    abnormalType: string | undefined;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出时数 */
    gcHours: number | undefined;
    /** 工时假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核 2：已审核 3：员工已确认 4:已结账) */
    state: string | undefined;
    /** 审核人 */
    auditUserId: number | undefined;
    auditUser: User;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 异常状态名称 */
    itemDetailName: string | undefined;
    id: number;

    constructor(data?: IEmpattdailyListsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.displayName = _data["displayName"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.shiftName = _data["shiftName"];
            this.userId = _data["userId"];
            this.attDate = _data["attDate"] ? moment(_data["attDate"].toString()) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.shouldStartTime = _data["shouldStartTime"] ? moment(_data["shouldStartTime"].toString()) : <any>undefined;
            this.shouldEndTime = _data["shouldEndTime"] ? moment(_data["shouldEndTime"].toString()) : <any>undefined;
            this.dutyFrom = _data["dutyFrom"] ? moment(_data["dutyFrom"].toString()) : <any>undefined;
            this.dutyTo = _data["dutyTo"] ? moment(_data["dutyTo"].toString()) : <any>undefined;
            this.attDays = _data["attDays"];
            this.restDays = _data["restDays"];
            this.standardLobor = _data["standardLobor"];
            this.factLabor = _data["factLabor"];
            this.ot = _data["ot"];
            this.oT1 = _data["oT1"];
            this.oT2 = _data["oT2"];
            this.oT3 = _data["oT3"];
            this.lateMinutes = _data["lateMinutes"];
            this.earlyMinutes = _data["earlyMinutes"];
            this.absentHours = _data["absentHours"];
            this.abnormalType = _data["abnormalType"];
            this.signCardNums = _data["signCardNums"];
            this.brHours = _data["brHours"];
            this.ssHours = _data["ssHours"];
            this.hjHours = _data["hjHours"];
            this.cjHours = _data["cjHours"];
            this.njHours = _data["njHours"];
            this.gcHours = _data["gcHours"];
            this.gsHours = _data["gsHours"];
            this.pcHours = _data["pcHours"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.txHours = _data["txHours"];
            this.nightNums = _data["nightNums"];
            this.state = _data["state"];
            this.auditUserId = _data["auditUserId"];
            this.auditUser = _data["auditUser"] ? User.fromJS(_data["auditUser"]) : <any>undefined;
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.selfCheckTime = _data["selfCheckTime"] ? moment(_data["selfCheckTime"].toString()) : <any>undefined;
            this.itemDetailName = _data["itemDetailName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmpattdailyListsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmpattdailyListsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["displayName"] = this.displayName;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["shiftName"] = this.shiftName;
        data["userId"] = this.userId;
        data["attDate"] = this.attDate ? this.attDate.toISOString() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["shouldStartTime"] = this.shouldStartTime ? this.shouldStartTime.toISOString() : <any>undefined;
        data["shouldEndTime"] = this.shouldEndTime ? this.shouldEndTime.toISOString() : <any>undefined;
        data["dutyFrom"] = this.dutyFrom ? this.dutyFrom.toISOString() : <any>undefined;
        data["dutyTo"] = this.dutyTo ? this.dutyTo.toISOString() : <any>undefined;
        data["attDays"] = this.attDays;
        data["restDays"] = this.restDays;
        data["standardLobor"] = this.standardLobor;
        data["factLabor"] = this.factLabor;
        data["ot"] = this.ot;
        data["oT1"] = this.oT1;
        data["oT2"] = this.oT2;
        data["oT3"] = this.oT3;
        data["lateMinutes"] = this.lateMinutes;
        data["earlyMinutes"] = this.earlyMinutes;
        data["absentHours"] = this.absentHours;
        data["abnormalType"] = this.abnormalType;
        data["signCardNums"] = this.signCardNums;
        data["brHours"] = this.brHours;
        data["ssHours"] = this.ssHours;
        data["hjHours"] = this.hjHours;
        data["cjHours"] = this.cjHours;
        data["njHours"] = this.njHours;
        data["gcHours"] = this.gcHours;
        data["gsHours"] = this.gsHours;
        data["pcHours"] = this.pcHours;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["txHours"] = this.txHours;
        data["nightNums"] = this.nightNums;
        data["state"] = this.state;
        data["auditUserId"] = this.auditUserId;
        data["auditUser"] = this.auditUser ? this.auditUser.toJSON() : <any>undefined;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["selfCheckTime"] = this.selfCheckTime ? this.selfCheckTime.toISOString() : <any>undefined;
        data["itemDetailName"] = this.itemDetailName;
        data["id"] = this.id;
        return data;
    }

    clone(): EmpattdailyListsDto {
        const json = this.toJSON();
        let result = new EmpattdailyListsDto();
        result.init(json);
        return result;
    }
}

export interface IEmpattdailyListsDto {
    /** 公司 */
    fullName: string | undefined;
    /** 部门 */
    displayName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 名称 */
    realName: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 员工 */
    userId: number | undefined;
    /** 考勤日期 */
    attDate: moment.Moment | undefined;
    /** 班次code */
    shiftCode: string | undefined;
    /** 应上班时间 */
    shouldStartTime: moment.Moment | undefined;
    /** 应下班时间 */
    shouldEndTime: moment.Moment | undefined;
    /** 上班时间 */
    dutyFrom: moment.Moment | undefined;
    /** 下班时间 */
    dutyTo: moment.Moment | undefined;
    /** 出勤天数 */
    attDays: number | undefined;
    /** 休息天数 */
    restDays: number | undefined;
    /** 应出勤工时 */
    standardLobor: number | undefined;
    /** 实出勤工时 */
    factLabor: number | undefined;
    /** 加班时数 */
    ot: number | undefined;
    /** 工作日加班时数 */
    oT1: number | undefined;
    /** 周末加班时数 */
    oT2: number | undefined;
    /** 法定加班时数 */
    oT3: number | undefined;
    /** 迟到分钟数 */
    lateMinutes: number | undefined;
    /** 早退分钟数 */
    earlyMinutes: number | undefined;
    /** 旷工小时数 */
    absentHours: number | undefined;
    /** 异常类型(1：迟到 2：早退 3：旷工) */
    abnormalType: string | undefined;
    /** 因私签卡次数 */
    signCardNums: number | undefined;
    /** 哺乳假假时数 */
    brHours: number | undefined;
    /** 丧假时数 */
    ssHours: number | undefined;
    /** 婚假时数 */
    hjHours: number | undefined;
    /** 产假时数 */
    cjHours: number | undefined;
    /** 年假时数 */
    njHours: number | undefined;
    /** 公出时数 */
    gcHours: number | undefined;
    /** 工时假时数 */
    gsHours: number | undefined;
    /** 陪产假时数 */
    pcHours: number | undefined;
    /** 事假时数 */
    sjHours: number | undefined;
    /** 病假时数 */
    bjHours: number | undefined;
    /** 调休时数 */
    txHours: number | undefined;
    /** 夜班次数 */
    nightNums: number | undefined;
    /** 状态(1:待审核 2：已审核 3：员工已确认 4:已结账) */
    state: string | undefined;
    /** 审核人 */
    auditUserId: number | undefined;
    auditUser: User;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 员工确认时间 */
    selfCheckTime: moment.Moment | undefined;
    /** 异常状态名称 */
    itemDetailName: string | undefined;
    id: number;
}

export class PagedResultDtoOfEmpattdailyListsDto implements IPagedResultDtoOfEmpattdailyListsDto {
    totalCount: number;
    items: EmpattdailyListsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmpattdailyListsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmpattdailyListsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmpattdailyListsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmpattdailyListsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfEmpattdailyListsDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEmpattdailyListsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEmpattdailyListsDto {
    totalCount: number;
    items: EmpattdailyListsDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Attendance.HolidayRule.HolidayRule */
export class HolidayRuleEditDto implements IHolidayRuleEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** UnitType */
    unitType: string | undefined;
    /** MinUnitNum */
    minUnitNum: number | undefined;
    /** IsContainHoilday */
    isContainHoilday: boolean | undefined;
    /** IsQuotaRule */
    isQuotaRule: boolean | undefined;
    /** AssignType */
    assignType: string | undefined;
    /** AssignDateType */
    assignDateType: string | undefined;
    /** AssignDate */
    assignDate: moment.Moment | undefined;
    /** QuotaRuleType */
    quotaRuleType: string | undefined;
    /** QuotaValue */
    quotaValue: number | undefined;
    /** IsConvert */
    isConvert: boolean | undefined;
    /** IsNextAssign */
    isNextAssign: boolean | undefined;
    /** ValidPeriod */
    validPeriod: string | undefined;
    /** IsAllowDelay */
    isAllowDelay: boolean | undefined;
    /** DelayDays */
    delayDays: number | undefined;
    /** 排序 */
    sort: number | undefined;

    constructor(data?: IHolidayRuleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.unitType = _data["unitType"];
            this.minUnitNum = _data["minUnitNum"];
            this.isContainHoilday = _data["isContainHoilday"];
            this.isQuotaRule = _data["isQuotaRule"];
            this.assignType = _data["assignType"];
            this.assignDateType = _data["assignDateType"];
            this.assignDate = _data["assignDate"] ? moment(_data["assignDate"].toString()) : <any>undefined;
            this.quotaRuleType = _data["quotaRuleType"];
            this.quotaValue = _data["quotaValue"];
            this.isConvert = _data["isConvert"];
            this.isNextAssign = _data["isNextAssign"];
            this.validPeriod = _data["validPeriod"];
            this.isAllowDelay = _data["isAllowDelay"];
            this.delayDays = _data["delayDays"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): HolidayRuleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayRuleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["unitType"] = this.unitType;
        data["minUnitNum"] = this.minUnitNum;
        data["isContainHoilday"] = this.isContainHoilday;
        data["isQuotaRule"] = this.isQuotaRule;
        data["assignType"] = this.assignType;
        data["assignDateType"] = this.assignDateType;
        data["assignDate"] = this.assignDate ? this.assignDate.toISOString() : <any>undefined;
        data["quotaRuleType"] = this.quotaRuleType;
        data["quotaValue"] = this.quotaValue;
        data["isConvert"] = this.isConvert;
        data["isNextAssign"] = this.isNextAssign;
        data["validPeriod"] = this.validPeriod;
        data["isAllowDelay"] = this.isAllowDelay;
        data["delayDays"] = this.delayDays;
        data["sort"] = this.sort;
        return data;
    }

    clone(): HolidayRuleEditDto {
        const json = this.toJSON();
        let result = new HolidayRuleEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.HolidayRule.HolidayRule */
export interface IHolidayRuleEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** UnitType */
    unitType: string | undefined;
    /** MinUnitNum */
    minUnitNum: number | undefined;
    /** IsContainHoilday */
    isContainHoilday: boolean | undefined;
    /** IsQuotaRule */
    isQuotaRule: boolean | undefined;
    /** AssignType */
    assignType: string | undefined;
    /** AssignDateType */
    assignDateType: string | undefined;
    /** AssignDate */
    assignDate: moment.Moment | undefined;
    /** QuotaRuleType */
    quotaRuleType: string | undefined;
    /** QuotaValue */
    quotaValue: number | undefined;
    /** IsConvert */
    isConvert: boolean | undefined;
    /** IsNextAssign */
    isNextAssign: boolean | undefined;
    /** ValidPeriod */
    validPeriod: string | undefined;
    /** IsAllowDelay */
    isAllowDelay: boolean | undefined;
    /** DelayDays */
    delayDays: number | undefined;
    /** 排序 */
    sort: number | undefined;
}

/** 的列表DTO QYB.QYBProduct.Attendance.WorkYearsQuota.WorkYearsQuota */
export class WorkYearsQuotaEditDto implements IWorkYearsQuotaEditDto {
    /** Id */
    id: number | undefined;
    /** HolidayRuleId */
    holidayRuleId: number;
    /** WorkYears */
    workYears: number;
    /** QuotaValue */
    quotaValue: number;

    constructor(data?: IWorkYearsQuotaEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.holidayRuleId = _data["holidayRuleId"];
            this.workYears = _data["workYears"];
            this.quotaValue = _data["quotaValue"];
        }
    }

    static fromJS(data: any): WorkYearsQuotaEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkYearsQuotaEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["holidayRuleId"] = this.holidayRuleId;
        data["workYears"] = this.workYears;
        data["quotaValue"] = this.quotaValue;
        return data;
    }

    clone(): WorkYearsQuotaEditDto {
        const json = this.toJSON();
        let result = new WorkYearsQuotaEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.WorkYearsQuota.WorkYearsQuota */
export interface IWorkYearsQuotaEditDto {
    /** Id */
    id: number | undefined;
    /** HolidayRuleId */
    holidayRuleId: number;
    /** WorkYears */
    workYears: number;
    /** QuotaValue */
    quotaValue: number;
}

export class CreateOrUpdateHolidayRuleInput implements ICreateOrUpdateHolidayRuleInput {
    holidayRule: HolidayRuleEditDto;
    workYearsList: WorkYearsQuotaEditDto[];

    constructor(data?: ICreateOrUpdateHolidayRuleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.holidayRule = new HolidayRuleEditDto();
            this.workYearsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayRule = _data["holidayRule"] ? HolidayRuleEditDto.fromJS(_data["holidayRule"]) : new HolidayRuleEditDto();
            if (Array.isArray(_data["workYearsList"])) {
                this.workYearsList = [] as any;
                for (let item of _data["workYearsList"])
                    this.workYearsList.push(WorkYearsQuotaEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateHolidayRuleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateHolidayRuleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayRule"] = this.holidayRule ? this.holidayRule.toJSON() : <any>undefined;
        if (Array.isArray(this.workYearsList)) {
            data["workYearsList"] = [];
            for (let item of this.workYearsList)
                data["workYearsList"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateHolidayRuleInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateHolidayRuleInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateHolidayRuleInput {
    holidayRule: HolidayRuleEditDto;
    workYearsList: WorkYearsQuotaEditDto[];
}

/** 的列表DTO QYB.QYBProduct.Attendance.HolidayRule.HolidayRule */
export class HolidayRuleListDto implements IHolidayRuleListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** UnitType */
    unitType: string | undefined;
    /** MinUnitNum */
    minUnitNum: number | undefined;
    /** IsContainHoilday */
    isContainHoilday: boolean | undefined;
    /** IsQuotaRule */
    isQuotaRule: boolean | undefined;
    /** AssignType */
    assignType: string | undefined;
    /** AssignDateType */
    assignDateType: string | undefined;
    /** AssignDate */
    assignDate: moment.Moment | undefined;
    /** QuotaRuleType */
    quotaRuleType: string | undefined;
    /** QuotaValue */
    quotaValue: number | undefined;
    /** IsConvert */
    isConvert: boolean | undefined;
    /** IsNextAssign */
    isNextAssign: boolean | undefined;
    /** ValidPeriod */
    validPeriod: string | undefined;
    /** IsAllowDelay */
    isAllowDelay: boolean | undefined;
    /** DelayDays */
    delayDays: number | undefined;
    /** 排序 */
    sort: number | undefined;
    id: number;

    constructor(data?: IHolidayRuleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.unitType = _data["unitType"];
            this.minUnitNum = _data["minUnitNum"];
            this.isContainHoilday = _data["isContainHoilday"];
            this.isQuotaRule = _data["isQuotaRule"];
            this.assignType = _data["assignType"];
            this.assignDateType = _data["assignDateType"];
            this.assignDate = _data["assignDate"] ? moment(_data["assignDate"].toString()) : <any>undefined;
            this.quotaRuleType = _data["quotaRuleType"];
            this.quotaValue = _data["quotaValue"];
            this.isConvert = _data["isConvert"];
            this.isNextAssign = _data["isNextAssign"];
            this.validPeriod = _data["validPeriod"];
            this.isAllowDelay = _data["isAllowDelay"];
            this.delayDays = _data["delayDays"];
            this.sort = _data["sort"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HolidayRuleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayRuleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["unitType"] = this.unitType;
        data["minUnitNum"] = this.minUnitNum;
        data["isContainHoilday"] = this.isContainHoilday;
        data["isQuotaRule"] = this.isQuotaRule;
        data["assignType"] = this.assignType;
        data["assignDateType"] = this.assignDateType;
        data["assignDate"] = this.assignDate ? this.assignDate.toISOString() : <any>undefined;
        data["quotaRuleType"] = this.quotaRuleType;
        data["quotaValue"] = this.quotaValue;
        data["isConvert"] = this.isConvert;
        data["isNextAssign"] = this.isNextAssign;
        data["validPeriod"] = this.validPeriod;
        data["isAllowDelay"] = this.isAllowDelay;
        data["delayDays"] = this.delayDays;
        data["sort"] = this.sort;
        data["id"] = this.id;
        return data;
    }

    clone(): HolidayRuleListDto {
        const json = this.toJSON();
        let result = new HolidayRuleListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.HolidayRule.HolidayRule */
export interface IHolidayRuleListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** UnitType */
    unitType: string | undefined;
    /** MinUnitNum */
    minUnitNum: number | undefined;
    /** IsContainHoilday */
    isContainHoilday: boolean | undefined;
    /** IsQuotaRule */
    isQuotaRule: boolean | undefined;
    /** AssignType */
    assignType: string | undefined;
    /** AssignDateType */
    assignDateType: string | undefined;
    /** AssignDate */
    assignDate: moment.Moment | undefined;
    /** QuotaRuleType */
    quotaRuleType: string | undefined;
    /** QuotaValue */
    quotaValue: number | undefined;
    /** IsConvert */
    isConvert: boolean | undefined;
    /** IsNextAssign */
    isNextAssign: boolean | undefined;
    /** ValidPeriod */
    validPeriod: string | undefined;
    /** IsAllowDelay */
    isAllowDelay: boolean | undefined;
    /** DelayDays */
    delayDays: number | undefined;
    /** 排序 */
    sort: number | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetHolidayRuleForEditOutput implements IGetHolidayRuleForEditOutput {
    holidayRule: HolidayRuleEditDto;
    workYearsList: WorkYearsQuotaEditDto[] | undefined;

    constructor(data?: IGetHolidayRuleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayRule = _data["holidayRule"] ? HolidayRuleEditDto.fromJS(_data["holidayRule"]) : <any>undefined;
            if (Array.isArray(_data["workYearsList"])) {
                this.workYearsList = [] as any;
                for (let item of _data["workYearsList"])
                    this.workYearsList.push(WorkYearsQuotaEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetHolidayRuleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidayRuleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayRule"] = this.holidayRule ? this.holidayRule.toJSON() : <any>undefined;
        if (Array.isArray(this.workYearsList)) {
            data["workYearsList"] = [];
            for (let item of this.workYearsList)
                data["workYearsList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetHolidayRuleForEditOutput {
        const json = this.toJSON();
        let result = new GetHolidayRuleForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetHolidayRuleForEditOutput {
    holidayRule: HolidayRuleEditDto;
    workYearsList: WorkYearsQuotaEditDto[] | undefined;
}

export class PagedResultDtoOfHolidayRuleListDto implements IPagedResultDtoOfHolidayRuleListDto {
    totalCount: number;
    items: HolidayRuleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfHolidayRuleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HolidayRuleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHolidayRuleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHolidayRuleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfHolidayRuleListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfHolidayRuleListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfHolidayRuleListDto {
    totalCount: number;
    items: HolidayRuleListDto[] | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDtoOfString {
        const json = this.toJSON();
        let result = new EntityDtoOfString();
        result.init(json);
        return result;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class HostCacheDto implements IHostCacheDto {
    name: string | undefined;

    constructor(data?: IHostCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HostCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): HostCacheDto {
        const json = this.toJSON();
        let result = new HostCacheDto();
        result.init(json);
        return result;
    }
}

export interface IHostCacheDto {
    name: string | undefined;
}

export class ListResultDtoOfHostCacheDto implements IListResultDtoOfHostCacheDto {
    items: HostCacheDto[] | undefined;

    constructor(data?: IListResultDtoOfHostCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HostCacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHostCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfHostCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfHostCacheDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfHostCacheDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfHostCacheDto {
    items: HostCacheDto[] | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    /** 时区 */
    timezone: string | undefined;
    /** 这个字段只用于比较用户的时区与默认时区 */
    timezoneForComparison: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }

    clone(): GeneralSettingsEditDto {
        const json = this.toJSON();
        let result = new GeneralSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralSettingsEditDto {
    /** 时区 */
    timezone: string | undefined;
    /** 这个字段只用于比较用户的时区与默认时区 */
    timezoneForComparison: string | undefined;
}

export enum ValidateCodeType {
    Number = <any>"Number",
    English = <any>"English",
    NumberAndLetter = <any>"NumberAndLetter",
    Hanzi = <any>"Hanzi",
}

/** 网站全局管理设置 */
export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    /** 是否必须验证邮箱才能登陆 */
    isEmailConfirmationRequiredForLogin: boolean;
    /** 是否启用短信验证 */
    smsVerificationEnabled: boolean;
    /** 是否启用Cookie内容 */
    isCookieConsentEnabled: boolean;
    /** 宿主用户登陆使用验证码 */
    useCaptchaOnUserLogin: boolean;
    captchaOnUserLoginType: ValidateCodeType;
    /** 宿主用户登陆验证码长度 */
    captchaOnUserLoginLength: number;
    isQuickThemeSelectEnabled: boolean;
    externalLoginProviders: string[] | undefined;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.useCaptchaOnUserLogin = _data["useCaptchaOnUserLogin"];
            this.captchaOnUserLoginType = _data["captchaOnUserLoginType"];
            this.captchaOnUserLoginLength = _data["captchaOnUserLoginLength"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            if (Array.isArray(_data["externalLoginProviders"])) {
                this.externalLoginProviders = [] as any;
                for (let item of _data["externalLoginProviders"])
                    this.externalLoginProviders.push(item);
            }
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["useCaptchaOnUserLogin"] = this.useCaptchaOnUserLogin;
        data["captchaOnUserLoginType"] = this.captchaOnUserLoginType;
        data["captchaOnUserLoginLength"] = this.captchaOnUserLoginLength;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        if (Array.isArray(this.externalLoginProviders)) {
            data["externalLoginProviders"] = [];
            for (let item of this.externalLoginProviders)
                data["externalLoginProviders"].push(item);
        }
        return data;
    }

    clone(): HostUserManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new HostUserManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

/** 网站全局管理设置 */
export interface IHostUserManagementSettingsEditDto {
    /** 是否必须验证邮箱才能登陆 */
    isEmailConfirmationRequiredForLogin: boolean;
    /** 是否启用短信验证 */
    smsVerificationEnabled: boolean;
    /** 是否启用Cookie内容 */
    isCookieConsentEnabled: boolean;
    /** 宿主用户登陆使用验证码 */
    useCaptchaOnUserLogin: boolean;
    captchaOnUserLoginType: ValidateCodeType;
    /** 宿主用户登陆验证码长度 */
    captchaOnUserLoginLength: number;
    isQuickThemeSelectEnabled: boolean;
    externalLoginProviders: string[] | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    /** 默认发件人邮箱地址 */
    defaultFromAddress: string | undefined;
    /** 邮箱显示名称 */
    defaultFromDisplayName: string | undefined;
    /** 发件人邮箱SMTP服务器Host */
    smtpHost: string | undefined;
    /** 发件人邮箱SMTP服务器端口 */
    smtpPort: number;
    /** 发件人校验名称 */
    smtpUserName: string | undefined;
    /** 发件人校验密码 */
    smtpPassword: string | undefined;
    /** 发件人 */
    smtpDomain: string | undefined;
    /** 使用ssl */
    smtpEnableSsl: boolean;
    /** 使用默认凭据 */
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }

    clone(): EmailSettingsEditDto {
        const json = this.toJSON();
        let result = new EmailSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmailSettingsEditDto {
    /** 默认发件人邮箱地址 */
    defaultFromAddress: string | undefined;
    /** 邮箱显示名称 */
    defaultFromDisplayName: string | undefined;
    /** 发件人邮箱SMTP服务器Host */
    smtpHost: string | undefined;
    /** 发件人邮箱SMTP服务器端口 */
    smtpPort: number;
    /** 发件人校验名称 */
    smtpUserName: string | undefined;
    /** 发件人校验密码 */
    smtpPassword: string | undefined;
    /** 发件人 */
    smtpDomain: string | undefined;
    /** 使用ssl */
    smtpEnableSsl: boolean;
    /** 使用默认凭据 */
    smtpUseDefaultCredentials: boolean;
}

export class TextMessageSettingsEditDto implements ITextMessageSettingsEditDto {
    smS_Addr: string | undefined;
    smS_Account: string | undefined;
    smS_Key: string | undefined;
    smS_IsActivate: boolean;

    constructor(data?: ITextMessageSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smS_Addr = _data["smS_Addr"];
            this.smS_Account = _data["smS_Account"];
            this.smS_Key = _data["smS_Key"];
            this.smS_IsActivate = _data["smS_IsActivate"];
        }
    }

    static fromJS(data: any): TextMessageSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessageSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smS_Addr"] = this.smS_Addr;
        data["smS_Account"] = this.smS_Account;
        data["smS_Key"] = this.smS_Key;
        data["smS_IsActivate"] = this.smS_IsActivate;
        return data;
    }

    clone(): TextMessageSettingsEditDto {
        const json = this.toJSON();
        let result = new TextMessageSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITextMessageSettingsEditDto {
    smS_Addr: string | undefined;
    smS_Account: string | undefined;
    smS_Key: string | undefined;
    smS_IsActivate: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    /** 允许注册 */
    allowSelfRegistration: boolean;
    /** 注册租户默认激活 */
    isNewRegisteredTenantActiveByDefault: boolean;
    /** 宿主租户注册使用验证码 */
    useCaptchaOnTenantRegistration: boolean;
    captchaOnTenantRegistrationType: ValidateCodeType;
    /** 宿主租户注册验证码长度 */
    captchaOnTenantRegistrationLength: number;
    /** 默认版本id */
    defaultEditionId: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnTenantRegistration = _data["useCaptchaOnTenantRegistration"];
            this.captchaOnTenantRegistrationType = _data["captchaOnTenantRegistrationType"];
            this.captchaOnTenantRegistrationLength = _data["captchaOnTenantRegistrationLength"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnTenantRegistration"] = this.useCaptchaOnTenantRegistration;
        data["captchaOnTenantRegistrationType"] = this.captchaOnTenantRegistrationType;
        data["captchaOnTenantRegistrationLength"] = this.captchaOnTenantRegistrationLength;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }

    clone(): TenantManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantManagementSettingsEditDto {
    /** 允许注册 */
    allowSelfRegistration: boolean;
    /** 注册租户默认激活 */
    isNewRegisteredTenantActiveByDefault: boolean;
    /** 宿主租户注册使用验证码 */
    useCaptchaOnTenantRegistration: boolean;
    captchaOnTenantRegistrationType: ValidateCodeType;
    /** 宿主租户注册验证码长度 */
    captchaOnTenantRegistrationLength: number;
    /** 默认版本id */
    defaultEditionId: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }

    clone(): PasswordComplexitySetting {
        const json = this.toJSON();
        let result = new PasswordComplexitySetting();
        result.init(json);
        return result;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    /** 是否启用 */
    isEnabled: boolean;
    /** 登陆校验错误锁定账户最大次数 */
    maxFailedAccessAttemptsBeforeLockout: number;
    /** 默认锁定时间 */
    defaultAccountLockoutSeconds: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }

    clone(): UserLockOutSettingsEditDto {
        const json = this.toJSON();
        let result = new UserLockOutSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IUserLockOutSettingsEditDto {
    /** 是否启用 */
    isEnabled: boolean;
    /** 登陆校验错误锁定账户最大次数 */
    maxFailedAccessAttemptsBeforeLockout: number;
    /** 默认锁定时间 */
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    /** 是否启用 */
    isEnabled: boolean;
    /** 邮箱启用 */
    isEmailProviderEnabled: boolean;
    /** 短信启用 */
    isSmsProviderEnabled: boolean;
    /** 浏览器‘记住我’启用 */
    isRememberBrowserEnabled: boolean;
    /** google校验启用 */
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }

    clone(): TwoFactorLoginSettingsEditDto {
        const json = this.toJSON();
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    /** 是否启用 */
    isEnabled: boolean;
    /** 邮箱启用 */
    isEmailProviderEnabled: boolean;
    /** 短信启用 */
    isSmsProviderEnabled: boolean;
    /** 浏览器‘记住我’启用 */
    isRememberBrowserEnabled: boolean;
    /** google校验启用 */
    isGoogleAuthenticatorEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    /** 使用默认密码校验设置 */
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }

    clone(): SecuritySettingsEditDto {
        const json = this.toJSON();
        let result = new SecuritySettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ISecuritySettingsEditDto {
    /** 使用默认密码校验设置 */
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }

    clone(): HostBillingSettingsEditDto {
        const json = this.toJSON();
        let result = new HostBillingSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

/** 样式 */
export class ThemeEditDto implements IThemeEditDto {
    /** 布局
QYB.Configuration.AppSettings.AppSettingValues.CommonSettings */
    layout: string | undefined;

    constructor(data?: IThemeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layout = _data["layout"];
        }
    }

    static fromJS(data: any): ThemeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout;
        return data;
    }

    clone(): ThemeEditDto {
        const json = this.toJSON();
        let result = new ThemeEditDto();
        result.init(json);
        return result;
    }
}

/** 样式 */
export interface IThemeEditDto {
    /** 布局
QYB.Configuration.AppSettings.AppSettingValues.CommonSettings */
    layout: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    textMessage: TextMessageSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    theme: ThemeEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.textMessage = new TextMessageSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
            this.theme = new ThemeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.textMessage = _data["textMessage"] ? TextMessageSettingsEditDto.fromJS(_data["textMessage"]) : new TextMessageSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.theme = _data["theme"] ? ThemeEditDto.fromJS(_data["theme"]) : new ThemeEditDto();
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["textMessage"] = this.textMessage ? this.textMessage.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostSettingsEditDto {
        const json = this.toJSON();
        let result = new HostSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    textMessage: TextMessageSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    theme: ThemeEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    /** 邮箱地址 */
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): SendTestEmailInput {
        const json = this.toJSON();
        let result = new SendTestEmailInput();
        result.init(json);
        return result;
    }
}

export interface ISendTestEmailInput {
    /** 邮箱地址 */
    emailAddress: string;
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Interface.Interface */
export class InterfaceEditDto implements IInterfaceEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Address */
    address: string | undefined;
    typeCode: string | undefined;

    constructor(data?: IInterfaceEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.typeCode = _data["typeCode"];
        }
    }

    static fromJS(data: any): InterfaceEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["typeCode"] = this.typeCode;
        return data;
    }

    clone(): InterfaceEditDto {
        const json = this.toJSON();
        let result = new InterfaceEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Interface.Interface */
export interface IInterfaceEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Address */
    address: string | undefined;
    typeCode: string | undefined;
}

export class CreateOrUpdateInterfaceInput implements ICreateOrUpdateInterfaceInput {
    interface: InterfaceEditDto;

    constructor(data?: ICreateOrUpdateInterfaceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.interface = new InterfaceEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interface = _data["interface"] ? InterfaceEditDto.fromJS(_data["interface"]) : new InterfaceEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateInterfaceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateInterfaceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interface"] = this.interface ? this.interface.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateInterfaceInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateInterfaceInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateInterfaceInput {
    interface: InterfaceEditDto;
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Interface.Interface */
export class InterfaceListDto implements IInterfaceListDto {
    id: number;
    /** Name */
    name: string | undefined;
    /** Address */
    address: string | undefined;
    /** 类型名称 */
    typeName: string | undefined;

    constructor(data?: IInterfaceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): InterfaceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["typeName"] = this.typeName;
        return data;
    }

    clone(): InterfaceListDto {
        const json = this.toJSON();
        let result = new InterfaceListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Interface.Interface */
export interface IInterfaceListDto {
    id: number;
    /** Name */
    name: string | undefined;
    /** Address */
    address: string | undefined;
    /** 类型名称 */
    typeName: string | undefined;
}

/** 读取可编辑的Dto */
export class GetInterfaceForEditOutput implements IGetInterfaceForEditOutput {
    interface: InterfaceEditDto;

    constructor(data?: IGetInterfaceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interface = _data["interface"] ? InterfaceEditDto.fromJS(_data["interface"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInterfaceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterfaceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interface"] = this.interface ? this.interface.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetInterfaceForEditOutput {
        const json = this.toJSON();
        let result = new GetInterfaceForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetInterfaceForEditOutput {
    interface: InterfaceEditDto;
}

export class InterfaceTreeDto implements IInterfaceTreeDto {
    title: string | undefined;
    key: string | undefined;
    value: string | undefined;
    children: InterfaceTreeDto[] | undefined;

    constructor(data?: IInterfaceTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(InterfaceTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InterfaceTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): InterfaceTreeDto {
        const json = this.toJSON();
        let result = new InterfaceTreeDto();
        result.init(json);
        return result;
    }
}

export interface IInterfaceTreeDto {
    title: string | undefined;
    key: string | undefined;
    value: string | undefined;
    children: InterfaceTreeDto[] | undefined;
}

export class PagedResultDtoOfInterfaceListDto implements IPagedResultDtoOfInterfaceListDto {
    totalCount: number;
    items: InterfaceListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInterfaceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InterfaceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInterfaceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInterfaceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfInterfaceListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfInterfaceListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfInterfaceListDto {
    totalCount: number;
    items: InterfaceListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.SystemModule.InterfaceFieId.InterfaceFieId */
export class InterfaceFieIdEditDto implements IInterfaceFieIdEditDto {
    /** Id */
    id: number | undefined;
    /** InterfaceId */
    interfaceId: number;
    /** Name */
    name: string | undefined;
    /** Describe */
    describe: string | undefined;
    /** Type */
    type: number;

    constructor(data?: IInterfaceFieIdEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interfaceId = _data["interfaceId"];
            this.name = _data["name"];
            this.describe = _data["describe"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InterfaceFieIdEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceFieIdEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interfaceId"] = this.interfaceId;
        data["name"] = this.name;
        data["describe"] = this.describe;
        data["type"] = this.type;
        return data;
    }

    clone(): InterfaceFieIdEditDto {
        const json = this.toJSON();
        let result = new InterfaceFieIdEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.SystemModule.InterfaceFieId.InterfaceFieId */
export interface IInterfaceFieIdEditDto {
    /** Id */
    id: number | undefined;
    /** InterfaceId */
    interfaceId: number;
    /** Name */
    name: string | undefined;
    /** Describe */
    describe: string | undefined;
    /** Type */
    type: number;
}

export class CreateOrUpdateInterfaceFieIdInput implements ICreateOrUpdateInterfaceFieIdInput {
    interfaceFieId: InterfaceFieIdEditDto;

    constructor(data?: ICreateOrUpdateInterfaceFieIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.interfaceFieId = new InterfaceFieIdEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interfaceFieId = _data["interfaceFieId"] ? InterfaceFieIdEditDto.fromJS(_data["interfaceFieId"]) : new InterfaceFieIdEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateInterfaceFieIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateInterfaceFieIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interfaceFieId"] = this.interfaceFieId ? this.interfaceFieId.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateInterfaceFieIdInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateInterfaceFieIdInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateInterfaceFieIdInput {
    interfaceFieId: InterfaceFieIdEditDto;
}

/** 的列表DTO QYB.QYBProduct.SystemModule.InterfaceFieId.InterfaceFieId */
export class InterfaceFieIdListDto implements IInterfaceFieIdListDto {
    id: number;
    /** InterfaceId */
    interfaceId: number;
    /** Name */
    name: string | undefined;
    /** Describe */
    describe: string | undefined;
    /** Type */
    type: number;
    /** 类型名称 */
    typeName: string | undefined;

    constructor(data?: IInterfaceFieIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interfaceId = _data["interfaceId"];
            this.name = _data["name"];
            this.describe = _data["describe"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): InterfaceFieIdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceFieIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interfaceId"] = this.interfaceId;
        data["name"] = this.name;
        data["describe"] = this.describe;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        return data;
    }

    clone(): InterfaceFieIdListDto {
        const json = this.toJSON();
        let result = new InterfaceFieIdListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.SystemModule.InterfaceFieId.InterfaceFieId */
export interface IInterfaceFieIdListDto {
    id: number;
    /** InterfaceId */
    interfaceId: number;
    /** Name */
    name: string | undefined;
    /** Describe */
    describe: string | undefined;
    /** Type */
    type: number;
    /** 类型名称 */
    typeName: string | undefined;
}

/** 读取可编辑的Dto */
export class GetInterfaceFieIdForEditOutput implements IGetInterfaceFieIdForEditOutput {
    interfaceFieId: InterfaceFieIdEditDto;

    constructor(data?: IGetInterfaceFieIdForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interfaceFieId = _data["interfaceFieId"] ? InterfaceFieIdEditDto.fromJS(_data["interfaceFieId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInterfaceFieIdForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterfaceFieIdForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interfaceFieId"] = this.interfaceFieId ? this.interfaceFieId.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetInterfaceFieIdForEditOutput {
        const json = this.toJSON();
        let result = new GetInterfaceFieIdForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetInterfaceFieIdForEditOutput {
    interfaceFieId: InterfaceFieIdEditDto;
}

export class PagedResultDtoOfInterfaceFieIdListDto implements IPagedResultDtoOfInterfaceFieIdListDto {
    totalCount: number;
    items: InterfaceFieIdListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInterfaceFieIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InterfaceFieIdListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInterfaceFieIdListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInterfaceFieIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfInterfaceFieIdListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfInterfaceFieIdListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfInterfaceFieIdListDto {
    totalCount: number;
    items: InterfaceFieIdListDto[] | undefined;
}

export class HandleFormalEditDto implements IHandleFormalEditDto {
    empId: number;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;

    constructor(data?: IHandleFormalEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
        }
    }

    static fromJS(data: any): HandleFormalEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HandleFormalEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        return data;
    }

    clone(): HandleFormalEditDto {
        const json = this.toJSON();
        let result = new HandleFormalEditDto();
        result.init(json);
        return result;
    }
}

export interface IHandleFormalEditDto {
    empId: number;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
}

export class GetInternshipListDto implements IGetInternshipListDto {
    id: number;
    /** 姓名 */
    realName: string | undefined;
    /** 部门 */
    derpanment: string | undefined;
    /** 公司 */
    company: string | undefined;
    /** 岗位 */
    post: string | undefined;
    /** 员工类型Code */
    staffTypeCode: string | undefined;
    /** 员工类型 */
    staffTypeName: string | undefined;
    /** 入职时间 */
    hireDate: moment.Moment | undefined;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;

    constructor(data?: IGetInternshipListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.realName = _data["realName"];
            this.derpanment = _data["derpanment"];
            this.company = _data["company"];
            this.post = _data["post"];
            this.staffTypeCode = _data["staffTypeCode"];
            this.staffTypeName = _data["staffTypeName"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
        }
    }

    static fromJS(data: any): GetInternshipListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInternshipListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["realName"] = this.realName;
        data["derpanment"] = this.derpanment;
        data["company"] = this.company;
        data["post"] = this.post;
        data["staffTypeCode"] = this.staffTypeCode;
        data["staffTypeName"] = this.staffTypeName;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        return data;
    }

    clone(): GetInternshipListDto {
        const json = this.toJSON();
        let result = new GetInternshipListDto();
        result.init(json);
        return result;
    }
}

export interface IGetInternshipListDto {
    id: number;
    /** 姓名 */
    realName: string | undefined;
    /** 部门 */
    derpanment: string | undefined;
    /** 公司 */
    company: string | undefined;
    /** 岗位 */
    post: string | undefined;
    /** 员工类型Code */
    staffTypeCode: string | undefined;
    /** 员工类型 */
    staffTypeName: string | undefined;
    /** 入职时间 */
    hireDate: moment.Moment | undefined;
    /** 转正日期 */
    regularDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
}

export class PagedResultDtoOfGetInternshipListDto implements IPagedResultDtoOfGetInternshipListDto {
    totalCount: number;
    items: GetInternshipListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInternshipListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetInternshipListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInternshipListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetInternshipListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetInternshipListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetInternshipListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetInternshipListDto {
    totalCount: number;
    items: GetInternshipListDto[] | undefined;
}

export class ImportUserDto implements IImportUserDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    /** comma separated list */
    assignedRoleNames: string[] | undefined;
    /** Can be set when reading data from excel or when importing user */
    exception: string | undefined;

    constructor(data?: IImportUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): ImportUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["exception"] = this.exception;
        return data;
    }

    clone(): ImportUserDto {
        const json = this.toJSON();
        let result = new ImportUserDto();
        result.init(json);
        return result;
    }
}

export interface IImportUserDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    /** comma separated list */
    assignedRoleNames: string[] | undefined;
    /** Can be set when reading data from excel or when importing user */
    exception: string | undefined;
}

export class StarDto implements IStarDto {
    issueId: number;

    constructor(data?: IStarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueId = _data["issueId"];
        }
    }

    static fromJS(data: any): StarDto {
        data = typeof data === 'object' ? data : {};
        let result = new StarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueId"] = this.issueId;
        return data;
    }

    clone(): StarDto {
        const json = this.toJSON();
        let result = new StarDto();
        result.init(json);
        return result;
    }
}

export interface IStarDto {
    issueId: number;
}

export class AuditExcludeIssueCategoriesConfigDto implements IAuditExcludeIssueCategoriesConfigDto {
    excludedCategoryIds: string | undefined;

    constructor(data?: IAuditExcludeIssueCategoriesConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.excludedCategoryIds = _data["excludedCategoryIds"];
        }
    }

    static fromJS(data: any): AuditExcludeIssueCategoriesConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditExcludeIssueCategoriesConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["excludedCategoryIds"] = this.excludedCategoryIds;
        return data;
    }

    clone(): AuditExcludeIssueCategoriesConfigDto {
        const json = this.toJSON();
        let result = new AuditExcludeIssueCategoriesConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAuditExcludeIssueCategoriesConfigDto {
    excludedCategoryIds: string | undefined;
}

export class AuditMustFindIssuesConfigDto implements IAuditMustFindIssuesConfigDto {
    minIssuesPerAudit: number;

    constructor(data?: IAuditMustFindIssuesConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minIssuesPerAudit = _data["minIssuesPerAudit"];
        }
    }

    static fromJS(data: any): AuditMustFindIssuesConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditMustFindIssuesConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minIssuesPerAudit"] = this.minIssuesPerAudit;
        return data;
    }

    clone(): AuditMustFindIssuesConfigDto {
        const json = this.toJSON();
        let result = new AuditMustFindIssuesConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAuditMustFindIssuesConfigDto {
    minIssuesPerAudit: number;
}

export class BatchHandleDto implements IBatchHandleDto {
    ids: number[] | undefined;
    issueStatus: string | undefined;

    constructor(data?: IBatchHandleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
            this.issueStatus = _data["issueStatus"];
        }
    }

    static fromJS(data: any): BatchHandleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchHandleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["issueStatus"] = this.issueStatus;
        return data;
    }

    clone(): BatchHandleDto {
        const json = this.toJSON();
        let result = new BatchHandleDto();
        result.init(json);
        return result;
    }
}

export interface IBatchHandleDto {
    ids: number[] | undefined;
    issueStatus: string | undefined;
}

export class CreateIssueDto implements ICreateIssueDto {
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否别的系统提交 */
    isOtherSystemSubmit: boolean;
    /** 视频 */
    video: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;

    constructor(data?: ICreateIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueProgress = _data["issueProgress"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respId = _data["respId"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.issueReason = _data["issueReason"];
            this.remark = _data["remark"];
            this.isOtherSystemSubmit = _data["isOtherSystemSubmit"];
            this.video = _data["video"];
            this.excludeFromStatistics = _data["excludeFromStatistics"];
        }
    }

    static fromJS(data: any): CreateIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueProgress"] = this.issueProgress;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respId"] = this.respId;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["issueReason"] = this.issueReason;
        data["remark"] = this.remark;
        data["isOtherSystemSubmit"] = this.isOtherSystemSubmit;
        data["video"] = this.video;
        data["excludeFromStatistics"] = this.excludeFromStatistics;
        return data;
    }

    clone(): CreateIssueDto {
        const json = this.toJSON();
        let result = new CreateIssueDto();
        result.init(json);
        return result;
    }
}

export interface ICreateIssueDto {
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否别的系统提交 */
    isOtherSystemSubmit: boolean;
    /** 视频 */
    video: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;
}

/** 创建问题入参（用于安全隐患） */
export class CreateIssueBySafetyHazardsDto implements ICreateIssueBySafetyHazardsDto {
    /** 租户Id */
    tenantId: number;
    /** 场景ID */
    scenesId: number;
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门Id */
    submitterDeptId: number | undefined;
    /** 部门 */
    submitterDept: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否别的系统提交 */
    isOtherSystemSubmit: boolean;
    /** 视频 */
    video: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;

    constructor(data?: ICreateIssueBySafetyHazardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.scenesId = _data["scenesId"];
            this.submitterJobID = _data["submitterJobID"];
            this.submitterName = _data["submitterName"];
            this.submitterDeptId = _data["submitterDeptId"];
            this.submitterDept = _data["submitterDept"];
            this.sourceType = _data["sourceType"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueProgress = _data["issueProgress"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respId = _data["respId"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.issueReason = _data["issueReason"];
            this.remark = _data["remark"];
            this.isOtherSystemSubmit = _data["isOtherSystemSubmit"];
            this.video = _data["video"];
            this.excludeFromStatistics = _data["excludeFromStatistics"];
        }
    }

    static fromJS(data: any): CreateIssueBySafetyHazardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIssueBySafetyHazardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["scenesId"] = this.scenesId;
        data["submitterJobID"] = this.submitterJobID;
        data["submitterName"] = this.submitterName;
        data["submitterDeptId"] = this.submitterDeptId;
        data["submitterDept"] = this.submitterDept;
        data["sourceType"] = this.sourceType;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueProgress"] = this.issueProgress;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respId"] = this.respId;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["issueReason"] = this.issueReason;
        data["remark"] = this.remark;
        data["isOtherSystemSubmit"] = this.isOtherSystemSubmit;
        data["video"] = this.video;
        data["excludeFromStatistics"] = this.excludeFromStatistics;
        return data;
    }

    clone(): CreateIssueBySafetyHazardsDto {
        const json = this.toJSON();
        let result = new CreateIssueBySafetyHazardsDto();
        result.init(json);
        return result;
    }
}

/** 创建问题入参（用于安全隐患） */
export interface ICreateIssueBySafetyHazardsDto {
    /** 租户Id */
    tenantId: number;
    /** 场景ID */
    scenesId: number;
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门Id */
    submitterDeptId: number | undefined;
    /** 部门 */
    submitterDept: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否别的系统提交 */
    isOtherSystemSubmit: boolean;
    /** 视频 */
    video: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;
}

/** 创建工作流请求输入参数 */
export class CreateWorkflowRequestInput implements ICreateWorkflowRequestInput {
    /** 当前用户ID */
    userId: number;
    id: number;

    constructor(data?: ICreateWorkflowRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWorkflowRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkflowRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    }

    clone(): CreateWorkflowRequestInput {
        const json = this.toJSON();
        let result = new CreateWorkflowRequestInput();
        result.init(json);
        return result;
    }
}

/** 创建工作流请求输入参数 */
export interface ICreateWorkflowRequestInput {
    /** 当前用户ID */
    userId: number;
    id: number;
}

/** 工作流响应DTO */
export class WorkflowResponseDto implements IWorkflowResponseDto {
    success: boolean;
    requestId: string | undefined;
    errorCode: number;
    errorMessage: string | undefined;

    constructor(data?: IWorkflowResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.requestId = _data["requestId"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): WorkflowResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["requestId"] = this.requestId;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }

    clone(): WorkflowResponseDto {
        const json = this.toJSON();
        let result = new WorkflowResponseDto();
        result.init(json);
        return result;
    }
}

/** 工作流响应DTO */
export interface IWorkflowResponseDto {
    success: boolean;
    requestId: string | undefined;
    errorCode: number;
    errorMessage: string | undefined;
}

export class FillInCorrectiveNoteMustUpdateProgressDto implements IFillInCorrectiveNoteMustUpdateProgressDto {
    enable: boolean;

    constructor(data?: IFillInCorrectiveNoteMustUpdateProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): FillInCorrectiveNoteMustUpdateProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new FillInCorrectiveNoteMustUpdateProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): FillInCorrectiveNoteMustUpdateProgressDto {
        const json = this.toJSON();
        let result = new FillInCorrectiveNoteMustUpdateProgressDto();
        result.init(json);
        return result;
    }
}

export interface IFillInCorrectiveNoteMustUpdateProgressDto {
    enable: boolean;
}

export class IssueListDto implements IIssueListDto {
    id: number | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    sourceName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    discoverer: string | undefined;
    /** 发现人部门 */
    discovererDept: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 责任部门 */
    respDept: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    auditPoint: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    auditItemName: string | undefined;
    /** 审核项详细描述 */
    auditItemDescription: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 审核项序号 */
    auditItemSN: number;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 改正措施录入时间 */
    correctiveNoteTime: moment.Moment | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    foreColor: string | undefined;
    issueSubscribeId: number | undefined;
    /** 24小时 */
    twentyFourHour: string | undefined;
    /** 30天 */
    thirtyDays: string | undefined;
    /** 是否六个月内重复发生 */
    recurrence: string | undefined;
    /** 问题修改记录 */
    history: IssueHistory[] | undefined;
    /** 视频 */
    video: string | undefined;
    /** 问题状态
0、待确认
1、已确认
2、作废 */
    issueStatus: string | undefined;
    /** 作废原因 */
    statusReason: string | undefined;
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门Id */
    submitterDeptId: number | undefined;
    /** 部门 */
    submitterDept: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;

    constructor(data?: IIssueListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceType = _data["sourceType"];
            this.sourceName = _data["sourceName"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueTypeName = _data["issueTypeName"];
            this.issueTypeListName = _data["issueTypeListName"];
            this.issueProgress = _data["issueProgress"];
            this.issueProgressName = _data["issueProgressName"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discoverer = _data["discoverer"];
            this.discovererDept = _data["discovererDept"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.respDept = _data["respDept"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPoint = _data["auditPoint"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.auditItemDescription = _data["auditItemDescription"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.auditItemSN = _data["auditItemSN"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.correctiveNoteTime = _data["correctiveNoteTime"] ? moment(_data["correctiveNoteTime"].toString()) : <any>undefined;
            this.issueReason = _data["issueReason"];
            this.remark = _data["remark"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.foreColor = _data["foreColor"];
            this.issueSubscribeId = _data["issueSubscribeId"];
            this.twentyFourHour = _data["twentyFourHour"];
            this.thirtyDays = _data["thirtyDays"];
            this.recurrence = _data["recurrence"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history.push(IssueHistory.fromJS(item));
            }
            this.video = _data["video"];
            this.issueStatus = _data["issueStatus"];
            this.statusReason = _data["statusReason"];
            this.submitterJobID = _data["submitterJobID"];
            this.submitterName = _data["submitterName"];
            this.submitterDeptId = _data["submitterDeptId"];
            this.submitterDept = _data["submitterDept"];
            this.excludeFromStatistics = _data["excludeFromStatistics"];
        }
    }

    static fromJS(data: any): IssueListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceType"] = this.sourceType;
        data["sourceName"] = this.sourceName;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueTypeName"] = this.issueTypeName;
        data["issueTypeListName"] = this.issueTypeListName;
        data["issueProgress"] = this.issueProgress;
        data["issueProgressName"] = this.issueProgressName;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discoverer"] = this.discoverer;
        data["discovererDept"] = this.discovererDept;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["respDept"] = this.respDept;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPoint"] = this.auditPoint;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["auditItemDescription"] = this.auditItemDescription;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["auditItemSN"] = this.auditItemSN;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["correctiveNoteTime"] = this.correctiveNoteTime ? this.correctiveNoteTime.toISOString() : <any>undefined;
        data["issueReason"] = this.issueReason;
        data["remark"] = this.remark;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["foreColor"] = this.foreColor;
        data["issueSubscribeId"] = this.issueSubscribeId;
        data["twentyFourHour"] = this.twentyFourHour;
        data["thirtyDays"] = this.thirtyDays;
        data["recurrence"] = this.recurrence;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["video"] = this.video;
        data["issueStatus"] = this.issueStatus;
        data["statusReason"] = this.statusReason;
        data["submitterJobID"] = this.submitterJobID;
        data["submitterName"] = this.submitterName;
        data["submitterDeptId"] = this.submitterDeptId;
        data["submitterDept"] = this.submitterDept;
        data["excludeFromStatistics"] = this.excludeFromStatistics;
        return data;
    }

    clone(): IssueListDto {
        const json = this.toJSON();
        let result = new IssueListDto();
        result.init(json);
        return result;
    }
}

export interface IIssueListDto {
    id: number | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    sourceName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    discoverer: string | undefined;
    /** 发现人部门 */
    discovererDept: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 责任部门 */
    respDept: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    auditPoint: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    auditItemName: string | undefined;
    /** 审核项详细描述 */
    auditItemDescription: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 审核项序号 */
    auditItemSN: number;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 改正措施录入时间 */
    correctiveNoteTime: moment.Moment | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    foreColor: string | undefined;
    issueSubscribeId: number | undefined;
    /** 24小时 */
    twentyFourHour: string | undefined;
    /** 30天 */
    thirtyDays: string | undefined;
    /** 是否六个月内重复发生 */
    recurrence: string | undefined;
    /** 问题修改记录 */
    history: IssueHistory[] | undefined;
    /** 视频 */
    video: string | undefined;
    /** 问题状态
0、待确认
1、已确认
2、作废 */
    issueStatus: string | undefined;
    /** 作废原因 */
    statusReason: string | undefined;
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门Id */
    submitterDeptId: number | undefined;
    /** 部门 */
    submitterDept: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;
}

export class AppIssueRequiredAllScenesDto implements IAppIssueRequiredAllScenesDto {
    /** 问题发现时照片是否必须上传 */
    isDiscoveryPhotoRequired: boolean;
    enableSubmitPlanTime: boolean;
    enableUpdatePlanTime: boolean;
    enableClosePlanTime: boolean;
    enableSubmitImprovePicture: boolean;
    enableUpdateImprovePicture: boolean;
    enableCloseImprovePicture: boolean;
    enableSubmitCorrectiveNote: boolean;
    enableUpdateCorrectiveNote: boolean;
    enableCloseCorrectiveNote: boolean;
    enableSubmitAuditPoint: boolean;
    enableUpdateAuditPoint: boolean;
    enableCloseAuditPoint: boolean;
    enableSubmitCategory: boolean;
    enableUpdateCategory: boolean;
    enableCloseCategory: boolean;
    enableSubmitDescription: boolean;
    enableUpdateDescription: boolean;
    enableCloseDescription: boolean;
    enableSubmitPhoto: boolean;
    enableUpdatePhoto: boolean;
    enableClosePhoto: boolean;
    enableSubmitRootCauseAnalysis: boolean;
    enableUpdateRootCauseAnalysis: boolean;
    enableCloseRootCauseAnalysis: boolean;

    constructor(data?: IAppIssueRequiredAllScenesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDiscoveryPhotoRequired = _data["isDiscoveryPhotoRequired"];
            this.enableSubmitPlanTime = _data["enableSubmitPlanTime"];
            this.enableUpdatePlanTime = _data["enableUpdatePlanTime"];
            this.enableClosePlanTime = _data["enableClosePlanTime"];
            this.enableSubmitImprovePicture = _data["enableSubmitImprovePicture"];
            this.enableUpdateImprovePicture = _data["enableUpdateImprovePicture"];
            this.enableCloseImprovePicture = _data["enableCloseImprovePicture"];
            this.enableSubmitCorrectiveNote = _data["enableSubmitCorrectiveNote"];
            this.enableUpdateCorrectiveNote = _data["enableUpdateCorrectiveNote"];
            this.enableCloseCorrectiveNote = _data["enableCloseCorrectiveNote"];
            this.enableSubmitAuditPoint = _data["enableSubmitAuditPoint"];
            this.enableUpdateAuditPoint = _data["enableUpdateAuditPoint"];
            this.enableCloseAuditPoint = _data["enableCloseAuditPoint"];
            this.enableSubmitCategory = _data["enableSubmitCategory"];
            this.enableUpdateCategory = _data["enableUpdateCategory"];
            this.enableCloseCategory = _data["enableCloseCategory"];
            this.enableSubmitDescription = _data["enableSubmitDescription"];
            this.enableUpdateDescription = _data["enableUpdateDescription"];
            this.enableCloseDescription = _data["enableCloseDescription"];
            this.enableSubmitPhoto = _data["enableSubmitPhoto"];
            this.enableUpdatePhoto = _data["enableUpdatePhoto"];
            this.enableClosePhoto = _data["enableClosePhoto"];
            this.enableSubmitRootCauseAnalysis = _data["enableSubmitRootCauseAnalysis"];
            this.enableUpdateRootCauseAnalysis = _data["enableUpdateRootCauseAnalysis"];
            this.enableCloseRootCauseAnalysis = _data["enableCloseRootCauseAnalysis"];
        }
    }

    static fromJS(data: any): AppIssueRequiredAllScenesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppIssueRequiredAllScenesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDiscoveryPhotoRequired"] = this.isDiscoveryPhotoRequired;
        data["enableSubmitPlanTime"] = this.enableSubmitPlanTime;
        data["enableUpdatePlanTime"] = this.enableUpdatePlanTime;
        data["enableClosePlanTime"] = this.enableClosePlanTime;
        data["enableSubmitImprovePicture"] = this.enableSubmitImprovePicture;
        data["enableUpdateImprovePicture"] = this.enableUpdateImprovePicture;
        data["enableCloseImprovePicture"] = this.enableCloseImprovePicture;
        data["enableSubmitCorrectiveNote"] = this.enableSubmitCorrectiveNote;
        data["enableUpdateCorrectiveNote"] = this.enableUpdateCorrectiveNote;
        data["enableCloseCorrectiveNote"] = this.enableCloseCorrectiveNote;
        data["enableSubmitAuditPoint"] = this.enableSubmitAuditPoint;
        data["enableUpdateAuditPoint"] = this.enableUpdateAuditPoint;
        data["enableCloseAuditPoint"] = this.enableCloseAuditPoint;
        data["enableSubmitCategory"] = this.enableSubmitCategory;
        data["enableUpdateCategory"] = this.enableUpdateCategory;
        data["enableCloseCategory"] = this.enableCloseCategory;
        data["enableSubmitDescription"] = this.enableSubmitDescription;
        data["enableUpdateDescription"] = this.enableUpdateDescription;
        data["enableCloseDescription"] = this.enableCloseDescription;
        data["enableSubmitPhoto"] = this.enableSubmitPhoto;
        data["enableUpdatePhoto"] = this.enableUpdatePhoto;
        data["enableClosePhoto"] = this.enableClosePhoto;
        data["enableSubmitRootCauseAnalysis"] = this.enableSubmitRootCauseAnalysis;
        data["enableUpdateRootCauseAnalysis"] = this.enableUpdateRootCauseAnalysis;
        data["enableCloseRootCauseAnalysis"] = this.enableCloseRootCauseAnalysis;
        return data;
    }

    clone(): AppIssueRequiredAllScenesDto {
        const json = this.toJSON();
        let result = new AppIssueRequiredAllScenesDto();
        result.init(json);
        return result;
    }
}

export interface IAppIssueRequiredAllScenesDto {
    /** 问题发现时照片是否必须上传 */
    isDiscoveryPhotoRequired: boolean;
    enableSubmitPlanTime: boolean;
    enableUpdatePlanTime: boolean;
    enableClosePlanTime: boolean;
    enableSubmitImprovePicture: boolean;
    enableUpdateImprovePicture: boolean;
    enableCloseImprovePicture: boolean;
    enableSubmitCorrectiveNote: boolean;
    enableUpdateCorrectiveNote: boolean;
    enableCloseCorrectiveNote: boolean;
    enableSubmitAuditPoint: boolean;
    enableUpdateAuditPoint: boolean;
    enableCloseAuditPoint: boolean;
    enableSubmitCategory: boolean;
    enableUpdateCategory: boolean;
    enableCloseCategory: boolean;
    enableSubmitDescription: boolean;
    enableUpdateDescription: boolean;
    enableCloseDescription: boolean;
    enableSubmitPhoto: boolean;
    enableUpdatePhoto: boolean;
    enableClosePhoto: boolean;
    enableSubmitRootCauseAnalysis: boolean;
    enableUpdateRootCauseAnalysis: boolean;
    enableCloseRootCauseAnalysis: boolean;
}

export class GetPageIssueDto implements IGetPageIssueDto {
    /** 进度百分比 */
    progress: number;
    /** 状态名称 */
    progressName: string | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    count: number;
    issueListDto: IssueListDto[] | undefined;

    constructor(data?: IGetPageIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progress = _data["progress"];
            this.progressName = _data["progressName"];
            this.foreColor = _data["foreColor"];
            this.backColor = _data["backColor"];
            this.count = _data["count"];
            if (Array.isArray(_data["issueListDto"])) {
                this.issueListDto = [] as any;
                for (let item of _data["issueListDto"])
                    this.issueListDto.push(IssueListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPageIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progress"] = this.progress;
        data["progressName"] = this.progressName;
        data["foreColor"] = this.foreColor;
        data["backColor"] = this.backColor;
        data["count"] = this.count;
        if (Array.isArray(this.issueListDto)) {
            data["issueListDto"] = [];
            for (let item of this.issueListDto)
                data["issueListDto"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPageIssueDto {
        const json = this.toJSON();
        let result = new GetPageIssueDto();
        result.init(json);
        return result;
    }
}

export interface IGetPageIssueDto {
    /** 进度百分比 */
    progress: number;
    /** 状态名称 */
    progressName: string | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    count: number;
    issueListDto: IssueListDto[] | undefined;
}

/** 问题管理详情 */
export class GetIssueReportDetailDto implements IGetIssueReportDetailDto {
    /** 周次 */
    week: number | undefined;
    /** 月份 */
    month: number | undefined;
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
    /** 问题关闭数 */
    closeCount: number;
    /** 问题关闭率 */
    closePercent: number;

    constructor(data?: IGetIssueReportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.week = _data["week"];
            this.month = _data["month"];
            this.name = _data["name"];
            this.problemCount = _data["problemCount"];
            this.closeCount = _data["closeCount"];
            this.closePercent = _data["closePercent"];
        }
    }

    static fromJS(data: any): GetIssueReportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueReportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week;
        data["month"] = this.month;
        data["name"] = this.name;
        data["problemCount"] = this.problemCount;
        data["closeCount"] = this.closeCount;
        data["closePercent"] = this.closePercent;
        return data;
    }

    clone(): GetIssueReportDetailDto {
        const json = this.toJSON();
        let result = new GetIssueReportDetailDto();
        result.init(json);
        return result;
    }
}

/** 问题管理详情 */
export interface IGetIssueReportDetailDto {
    /** 周次 */
    week: number | undefined;
    /** 月份 */
    month: number | undefined;
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
    /** 问题关闭数 */
    closeCount: number;
    /** 问题关闭率 */
    closePercent: number;
}

/** 饼图Dto */
export class PieDto implements IPieDto {
    /** 值 */
    value: number;
    /** 名称 */
    id: number;
    /** 名称 */
    name: string | undefined;

    constructor(data?: IPieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PieDto {
        data = typeof data === 'object' ? data : {};
        let result = new PieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PieDto {
        const json = this.toJSON();
        let result = new PieDto();
        result.init(json);
        return result;
    }
}

/** 饼图Dto */
export interface IPieDto {
    /** 值 */
    value: number;
    /** 名称 */
    id: number;
    /** 名称 */
    name: string | undefined;
}

/** 问题报表 */
export class GetIssueReportDto implements IGetIssueReportDto {
    /** 周次 */
    weeks: string[] | undefined;
    /** 详细数据 */
    data: GetIssueReportDetailDto[] | undefined;
    /** 问题分类 */
    probTypeList: string[] | undefined;
    /** 人员列表 */
    userList: string[] | undefined;
    /** 审核项模板 */
    auditItemTemplateList: string[] | undefined;
    /** 审核点模板 */
    auditPointTemplateList: string[] | undefined;
    /** 饼图数据 */
    pieChartData: PieDto[] | undefined;

    constructor(data?: IGetIssueReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [] as any;
                for (let item of _data["weeks"])
                    this.weeks.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(GetIssueReportDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["probTypeList"])) {
                this.probTypeList = [] as any;
                for (let item of _data["probTypeList"])
                    this.probTypeList.push(item);
            }
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList.push(item);
            }
            if (Array.isArray(_data["auditItemTemplateList"])) {
                this.auditItemTemplateList = [] as any;
                for (let item of _data["auditItemTemplateList"])
                    this.auditItemTemplateList.push(item);
            }
            if (Array.isArray(_data["auditPointTemplateList"])) {
                this.auditPointTemplateList = [] as any;
                for (let item of _data["auditPointTemplateList"])
                    this.auditPointTemplateList.push(item);
            }
            if (Array.isArray(_data["pieChartData"])) {
                this.pieChartData = [] as any;
                for (let item of _data["pieChartData"])
                    this.pieChartData.push(PieDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIssueReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (let item of this.weeks)
                data["weeks"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.probTypeList)) {
            data["probTypeList"] = [];
            for (let item of this.probTypeList)
                data["probTypeList"].push(item);
        }
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item);
        }
        if (Array.isArray(this.auditItemTemplateList)) {
            data["auditItemTemplateList"] = [];
            for (let item of this.auditItemTemplateList)
                data["auditItemTemplateList"].push(item);
        }
        if (Array.isArray(this.auditPointTemplateList)) {
            data["auditPointTemplateList"] = [];
            for (let item of this.auditPointTemplateList)
                data["auditPointTemplateList"].push(item);
        }
        if (Array.isArray(this.pieChartData)) {
            data["pieChartData"] = [];
            for (let item of this.pieChartData)
                data["pieChartData"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIssueReportDto {
        const json = this.toJSON();
        let result = new GetIssueReportDto();
        result.init(json);
        return result;
    }
}

/** 问题报表 */
export interface IGetIssueReportDto {
    /** 周次 */
    weeks: string[] | undefined;
    /** 详细数据 */
    data: GetIssueReportDetailDto[] | undefined;
    /** 问题分类 */
    probTypeList: string[] | undefined;
    /** 人员列表 */
    userList: string[] | undefined;
    /** 审核项模板 */
    auditItemTemplateList: string[] | undefined;
    /** 审核点模板 */
    auditPointTemplateList: string[] | undefined;
    /** 饼图数据 */
    pieChartData: PieDto[] | undefined;
}

export class IssueRestrictedFieldsDto implements IIssueRestrictedFieldsDto {
    enableSubmitPlanTime: boolean;
    enableUpdatePlanTime: boolean;
    enableClosePlanTime: boolean;
    enableSubmitImprovePicture: boolean;
    enableUpdateImprovePicture: boolean;
    enableCloseImprovePicture: boolean;
    enableSubmitCorrectiveNote: boolean;
    enableUpdateCorrectiveNote: boolean;
    enableCloseCorrectiveNote: boolean;
    enableSubmitAuditPoint: boolean;
    enableUpdateAuditPoint: boolean;
    enableCloseAuditPoint: boolean;
    enableSubmitCategory: boolean;
    enableUpdateCategory: boolean;
    enableCloseCategory: boolean;
    enableSubmitDescription: boolean;
    enableUpdateDescription: boolean;
    enableCloseDescription: boolean;
    enableSubmitPhoto: boolean;
    enableUpdatePhoto: boolean;
    enableClosePhoto: boolean;
    enableSubmitRootCauseAnalysis: boolean;
    enableUpdateRootCauseAnalysis: boolean;
    enableCloseRootCauseAnalysis: boolean;

    constructor(data?: IIssueRestrictedFieldsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableSubmitPlanTime = _data["enableSubmitPlanTime"];
            this.enableUpdatePlanTime = _data["enableUpdatePlanTime"];
            this.enableClosePlanTime = _data["enableClosePlanTime"];
            this.enableSubmitImprovePicture = _data["enableSubmitImprovePicture"];
            this.enableUpdateImprovePicture = _data["enableUpdateImprovePicture"];
            this.enableCloseImprovePicture = _data["enableCloseImprovePicture"];
            this.enableSubmitCorrectiveNote = _data["enableSubmitCorrectiveNote"];
            this.enableUpdateCorrectiveNote = _data["enableUpdateCorrectiveNote"];
            this.enableCloseCorrectiveNote = _data["enableCloseCorrectiveNote"];
            this.enableSubmitAuditPoint = _data["enableSubmitAuditPoint"];
            this.enableUpdateAuditPoint = _data["enableUpdateAuditPoint"];
            this.enableCloseAuditPoint = _data["enableCloseAuditPoint"];
            this.enableSubmitCategory = _data["enableSubmitCategory"];
            this.enableUpdateCategory = _data["enableUpdateCategory"];
            this.enableCloseCategory = _data["enableCloseCategory"];
            this.enableSubmitDescription = _data["enableSubmitDescription"];
            this.enableUpdateDescription = _data["enableUpdateDescription"];
            this.enableCloseDescription = _data["enableCloseDescription"];
            this.enableSubmitPhoto = _data["enableSubmitPhoto"];
            this.enableUpdatePhoto = _data["enableUpdatePhoto"];
            this.enableClosePhoto = _data["enableClosePhoto"];
            this.enableSubmitRootCauseAnalysis = _data["enableSubmitRootCauseAnalysis"];
            this.enableUpdateRootCauseAnalysis = _data["enableUpdateRootCauseAnalysis"];
            this.enableCloseRootCauseAnalysis = _data["enableCloseRootCauseAnalysis"];
        }
    }

    static fromJS(data: any): IssueRestrictedFieldsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueRestrictedFieldsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableSubmitPlanTime"] = this.enableSubmitPlanTime;
        data["enableUpdatePlanTime"] = this.enableUpdatePlanTime;
        data["enableClosePlanTime"] = this.enableClosePlanTime;
        data["enableSubmitImprovePicture"] = this.enableSubmitImprovePicture;
        data["enableUpdateImprovePicture"] = this.enableUpdateImprovePicture;
        data["enableCloseImprovePicture"] = this.enableCloseImprovePicture;
        data["enableSubmitCorrectiveNote"] = this.enableSubmitCorrectiveNote;
        data["enableUpdateCorrectiveNote"] = this.enableUpdateCorrectiveNote;
        data["enableCloseCorrectiveNote"] = this.enableCloseCorrectiveNote;
        data["enableSubmitAuditPoint"] = this.enableSubmitAuditPoint;
        data["enableUpdateAuditPoint"] = this.enableUpdateAuditPoint;
        data["enableCloseAuditPoint"] = this.enableCloseAuditPoint;
        data["enableSubmitCategory"] = this.enableSubmitCategory;
        data["enableUpdateCategory"] = this.enableUpdateCategory;
        data["enableCloseCategory"] = this.enableCloseCategory;
        data["enableSubmitDescription"] = this.enableSubmitDescription;
        data["enableUpdateDescription"] = this.enableUpdateDescription;
        data["enableCloseDescription"] = this.enableCloseDescription;
        data["enableSubmitPhoto"] = this.enableSubmitPhoto;
        data["enableUpdatePhoto"] = this.enableUpdatePhoto;
        data["enableClosePhoto"] = this.enableClosePhoto;
        data["enableSubmitRootCauseAnalysis"] = this.enableSubmitRootCauseAnalysis;
        data["enableUpdateRootCauseAnalysis"] = this.enableUpdateRootCauseAnalysis;
        data["enableCloseRootCauseAnalysis"] = this.enableCloseRootCauseAnalysis;
        return data;
    }

    clone(): IssueRestrictedFieldsDto {
        const json = this.toJSON();
        let result = new IssueRestrictedFieldsDto();
        result.init(json);
        return result;
    }
}

export interface IIssueRestrictedFieldsDto {
    enableSubmitPlanTime: boolean;
    enableUpdatePlanTime: boolean;
    enableClosePlanTime: boolean;
    enableSubmitImprovePicture: boolean;
    enableUpdateImprovePicture: boolean;
    enableCloseImprovePicture: boolean;
    enableSubmitCorrectiveNote: boolean;
    enableUpdateCorrectiveNote: boolean;
    enableCloseCorrectiveNote: boolean;
    enableSubmitAuditPoint: boolean;
    enableUpdateAuditPoint: boolean;
    enableCloseAuditPoint: boolean;
    enableSubmitCategory: boolean;
    enableUpdateCategory: boolean;
    enableCloseCategory: boolean;
    enableSubmitDescription: boolean;
    enableUpdateDescription: boolean;
    enableCloseDescription: boolean;
    enableSubmitPhoto: boolean;
    enableUpdatePhoto: boolean;
    enableClosePhoto: boolean;
    enableSubmitRootCauseAnalysis: boolean;
    enableUpdateRootCauseAnalysis: boolean;
    enableCloseRootCauseAnalysis: boolean;
}

/** 问题关注ListDto */
export class IssueSubscribeListDto implements IIssueSubscribeListDto {
    /** 点星人 */
    userId: number;
    /** 点星人 */
    userName: string | undefined;
    /** 问题Id */
    issueId: number;
    /** 关注时间 */
    subTime: moment.Moment;

    constructor(data?: IIssueSubscribeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.issueId = _data["issueId"];
            this.subTime = _data["subTime"] ? moment(_data["subTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueSubscribeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueSubscribeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["issueId"] = this.issueId;
        data["subTime"] = this.subTime ? this.subTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): IssueSubscribeListDto {
        const json = this.toJSON();
        let result = new IssueSubscribeListDto();
        result.init(json);
        return result;
    }
}

/** 问题关注ListDto */
export interface IIssueSubscribeListDto {
    /** 点星人 */
    userId: number;
    /** 点星人 */
    userName: string | undefined;
    /** 问题Id */
    issueId: number;
    /** 关注时间 */
    subTime: moment.Moment;
}

export class PagedResultDtoOfIssueListDto implements IPagedResultDtoOfIssueListDto {
    totalCount: number;
    items: IssueListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfIssueListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IssueListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfIssueListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIssueListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfIssueListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfIssueListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfIssueListDto {
    totalCount: number;
    items: IssueListDto[] | undefined;
}

export class GetUserInfoForSafetyHazardsDto implements IGetUserInfoForSafetyHazardsDto {
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门 */
    submitterDept: string | undefined;
    /** 部门 */
    submitterDeptId: number | undefined;

    constructor(data?: IGetUserInfoForSafetyHazardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitterJobID = _data["submitterJobID"];
            this.submitterName = _data["submitterName"];
            this.submitterDept = _data["submitterDept"];
            this.submitterDeptId = _data["submitterDeptId"];
        }
    }

    static fromJS(data: any): GetUserInfoForSafetyHazardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserInfoForSafetyHazardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitterJobID"] = this.submitterJobID;
        data["submitterName"] = this.submitterName;
        data["submitterDept"] = this.submitterDept;
        data["submitterDeptId"] = this.submitterDeptId;
        return data;
    }

    clone(): GetUserInfoForSafetyHazardsDto {
        const json = this.toJSON();
        let result = new GetUserInfoForSafetyHazardsDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserInfoForSafetyHazardsDto {
    /** 工号 */
    submitterJobID: string | undefined;
    /** 姓名 */
    submitterName: string | undefined;
    /** 部门 */
    submitterDept: string | undefined;
    /** 部门 */
    submitterDeptId: number | undefined;
}

export class IssueEditDto implements IIssueEditDto {
    id: number;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 视频 */
    video: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;

    constructor(data?: IIssueEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueProgress = _data["issueProgress"];
            this.description = _data["description"];
            this.respId = _data["respId"];
            this.auditPointId = _data["auditPointId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.issueReason = _data["issueReason"];
            this.remark = _data["remark"];
            this.video = _data["video"];
            this.excludeFromStatistics = _data["excludeFromStatistics"];
        }
    }

    static fromJS(data: any): IssueEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueProgress"] = this.issueProgress;
        data["description"] = this.description;
        data["respId"] = this.respId;
        data["auditPointId"] = this.auditPointId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["issueReason"] = this.issueReason;
        data["remark"] = this.remark;
        data["video"] = this.video;
        data["excludeFromStatistics"] = this.excludeFromStatistics;
        return data;
    }

    clone(): IssueEditDto {
        const json = this.toJSON();
        let result = new IssueEditDto();
        result.init(json);
        return result;
    }
}

export interface IIssueEditDto {
    id: number;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题描述 */
    description: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 视频 */
    video: string | undefined;
    /** 不参与统计 */
    excludeFromStatistics: boolean;
}

/** 修改Dto */
export class UpdataIssueDto implements IUpdataIssueDto {
    issueEditDto: IssueEditDto;

    constructor(data?: IUpdataIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.issueEditDto = new IssueEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueEditDto = _data["issueEditDto"] ? IssueEditDto.fromJS(_data["issueEditDto"]) : new IssueEditDto();
        }
    }

    static fromJS(data: any): UpdataIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdataIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueEditDto"] = this.issueEditDto ? this.issueEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdataIssueDto {
        const json = this.toJSON();
        let result = new UpdataIssueDto();
        result.init(json);
        return result;
    }
}

/** 修改Dto */
export interface IUpdataIssueDto {
    issueEditDto: IssueEditDto;
}

export class IsCloseIssueFillInRemarksDto implements IIsCloseIssueFillInRemarksDto {
    enable: boolean;

    constructor(data?: IIsCloseIssueFillInRemarksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsCloseIssueFillInRemarksDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsCloseIssueFillInRemarksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsCloseIssueFillInRemarksDto {
        const json = this.toJSON();
        let result = new IsCloseIssueFillInRemarksDto();
        result.init(json);
        return result;
    }
}

export interface IIsCloseIssueFillInRemarksDto {
    enable: boolean;
}

export class IsEnabledAssistantConfirmationProcessDto implements IIsEnabledAssistantConfirmationProcessDto {
    enable: boolean;

    constructor(data?: IIsEnabledAssistantConfirmationProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnabledAssistantConfirmationProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnabledAssistantConfirmationProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnabledAssistantConfirmationProcessDto {
        const json = this.toJSON();
        let result = new IsEnabledAssistantConfirmationProcessDto();
        result.init(json);
        return result;
    }
}

export interface IIsEnabledAssistantConfirmationProcessDto {
    enable: boolean;
}

export class IsMustUploadImprovedPictureDto implements IIsMustUploadImprovedPictureDto {
    enable: boolean;

    constructor(data?: IIsMustUploadImprovedPictureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsMustUploadImprovedPictureDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsMustUploadImprovedPictureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsMustUploadImprovedPictureDto {
        const json = this.toJSON();
        let result = new IsMustUploadImprovedPictureDto();
        result.init(json);
        return result;
    }
}

export interface IIsMustUploadImprovedPictureDto {
    enable: boolean;
}

export class IsRequiredIssueRespDto implements IIsRequiredIssueRespDto {
    enable: boolean;

    constructor(data?: IIsRequiredIssueRespDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsRequiredIssueRespDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsRequiredIssueRespDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsRequiredIssueRespDto {
        const json = this.toJSON();
        let result = new IsRequiredIssueRespDto();
        result.init(json);
        return result;
    }
}

export interface IIsRequiredIssueRespDto {
    enable: boolean;
}

export class IsRequiredPhotoIssueRespDto implements IIsRequiredPhotoIssueRespDto {
    enable: boolean;

    constructor(data?: IIsRequiredPhotoIssueRespDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsRequiredPhotoIssueRespDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsRequiredPhotoIssueRespDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsRequiredPhotoIssueRespDto {
        const json = this.toJSON();
        let result = new IsRequiredPhotoIssueRespDto();
        result.init(json);
        return result;
    }
}

export interface IIsRequiredPhotoIssueRespDto {
    enable: boolean;
}

export class IssueConfirmAssistantDto implements IIssueConfirmAssistantDto {
    issueConfirmAssistant: string | undefined;

    constructor(data?: IIssueConfirmAssistantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueConfirmAssistant = _data["issueConfirmAssistant"];
        }
    }

    static fromJS(data: any): IssueConfirmAssistantDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueConfirmAssistantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueConfirmAssistant"] = this.issueConfirmAssistant;
        return data;
    }

    clone(): IssueConfirmAssistantDto {
        const json = this.toJSON();
        let result = new IssueConfirmAssistantDto();
        result.init(json);
        return result;
    }
}

export interface IIssueConfirmAssistantDto {
    issueConfirmAssistant: string | undefined;
}

export class IssueDiscovererIsCanCloseIssueDto implements IIssueDiscovererIsCanCloseIssueDto {
    enable: boolean;

    constructor(data?: IIssueDiscovererIsCanCloseIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IssueDiscovererIsCanCloseIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDiscovererIsCanCloseIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IssueDiscovererIsCanCloseIssueDto {
        const json = this.toJSON();
        let result = new IssueDiscovererIsCanCloseIssueDto();
        result.init(json);
        return result;
    }
}

export interface IIssueDiscovererIsCanCloseIssueDto {
    enable: boolean;
}

export class IssuePlanTimeNotFilledInHourDto implements IIssuePlanTimeNotFilledInHourDto {
    issuePlanTimeNotFilledInHour: number;

    constructor(data?: IIssuePlanTimeNotFilledInHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuePlanTimeNotFilledInHour = _data["issuePlanTimeNotFilledInHour"];
        }
    }

    static fromJS(data: any): IssuePlanTimeNotFilledInHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePlanTimeNotFilledInHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuePlanTimeNotFilledInHour"] = this.issuePlanTimeNotFilledInHour;
        return data;
    }

    clone(): IssuePlanTimeNotFilledInHourDto {
        const json = this.toJSON();
        let result = new IssuePlanTimeNotFilledInHourDto();
        result.init(json);
        return result;
    }
}

export interface IIssuePlanTimeNotFilledInHourDto {
    issuePlanTimeNotFilledInHour: number;
}

export class IssueProgressEditDto implements IIssueProgressEditDto {
    /** Id */
    id: number | undefined;
    /** 进度百分比 */
    progress: number;
    /** 状态名称 */
    name: string | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    /** 是否通知专员 */
    isNoticeAssistant: boolean;
    /** 是否通知责任人 */
    isNoticeResp: boolean;
    /** 是否通知提交人 */
    isNoticeSubmitter: boolean;

    constructor(data?: IIssueProgressEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progress = _data["progress"];
            this.name = _data["name"];
            this.foreColor = _data["foreColor"];
            this.backColor = _data["backColor"];
            this.isNoticeAssistant = _data["isNoticeAssistant"];
            this.isNoticeResp = _data["isNoticeResp"];
            this.isNoticeSubmitter = _data["isNoticeSubmitter"];
        }
    }

    static fromJS(data: any): IssueProgressEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueProgressEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progress"] = this.progress;
        data["name"] = this.name;
        data["foreColor"] = this.foreColor;
        data["backColor"] = this.backColor;
        data["isNoticeAssistant"] = this.isNoticeAssistant;
        data["isNoticeResp"] = this.isNoticeResp;
        data["isNoticeSubmitter"] = this.isNoticeSubmitter;
        return data;
    }

    clone(): IssueProgressEditDto {
        const json = this.toJSON();
        let result = new IssueProgressEditDto();
        result.init(json);
        return result;
    }
}

export interface IIssueProgressEditDto {
    /** Id */
    id: number | undefined;
    /** 进度百分比 */
    progress: number;
    /** 状态名称 */
    name: string | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    /** 是否通知专员 */
    isNoticeAssistant: boolean;
    /** 是否通知责任人 */
    isNoticeResp: boolean;
    /** 是否通知提交人 */
    isNoticeSubmitter: boolean;
}

export class CreateOrUpdateIssueProgressInput implements ICreateOrUpdateIssueProgressInput {
    issueProgress: IssueProgressEditDto;

    constructor(data?: ICreateOrUpdateIssueProgressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.issueProgress = new IssueProgressEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueProgress = _data["issueProgress"] ? IssueProgressEditDto.fromJS(_data["issueProgress"]) : new IssueProgressEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateIssueProgressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateIssueProgressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueProgress"] = this.issueProgress ? this.issueProgress.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateIssueProgressInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateIssueProgressInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateIssueProgressInput {
    issueProgress: IssueProgressEditDto;
}

export class IssueProgressListDto implements IIssueProgressListDto {
    /** Id */
    id: number | undefined;
    /** 进度百分比 */
    progress: number;
    /** 状态名称 */
    name: string | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    /** 是否通知专员 */
    isNoticeAssistant: boolean;
    /** 是否通知责任人 */
    isNoticeResp: boolean;
    /** 是否通知提交人 */
    isNoticeSubmitter: boolean;

    constructor(data?: IIssueProgressListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.progress = _data["progress"];
            this.name = _data["name"];
            this.foreColor = _data["foreColor"];
            this.backColor = _data["backColor"];
            this.isNoticeAssistant = _data["isNoticeAssistant"];
            this.isNoticeResp = _data["isNoticeResp"];
            this.isNoticeSubmitter = _data["isNoticeSubmitter"];
        }
    }

    static fromJS(data: any): IssueProgressListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueProgressListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["progress"] = this.progress;
        data["name"] = this.name;
        data["foreColor"] = this.foreColor;
        data["backColor"] = this.backColor;
        data["isNoticeAssistant"] = this.isNoticeAssistant;
        data["isNoticeResp"] = this.isNoticeResp;
        data["isNoticeSubmitter"] = this.isNoticeSubmitter;
        return data;
    }

    clone(): IssueProgressListDto {
        const json = this.toJSON();
        let result = new IssueProgressListDto();
        result.init(json);
        return result;
    }
}

export interface IIssueProgressListDto {
    /** Id */
    id: number | undefined;
    /** 进度百分比 */
    progress: number;
    /** 状态名称 */
    name: string | undefined;
    /** 字体颜色前景色 Rgb配色 */
    foreColor: string | undefined;
    /** 字体颜色背景色 Rgb配色 */
    backColor: string | undefined;
    /** 是否通知专员 */
    isNoticeAssistant: boolean;
    /** 是否通知责任人 */
    isNoticeResp: boolean;
    /** 是否通知提交人 */
    isNoticeSubmitter: boolean;
}

export class GetIssueProgressForEditOutput implements IGetIssueProgressForEditOutput {
    issueProgress: IssueProgressEditDto;

    constructor(data?: IGetIssueProgressForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.issueProgress = new IssueProgressEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueProgress = _data["issueProgress"] ? IssueProgressEditDto.fromJS(_data["issueProgress"]) : new IssueProgressEditDto();
        }
    }

    static fromJS(data: any): GetIssueProgressForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueProgressForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueProgress"] = this.issueProgress ? this.issueProgress.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetIssueProgressForEditOutput {
        const json = this.toJSON();
        let result = new GetIssueProgressForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetIssueProgressForEditOutput {
    issueProgress: IssueProgressEditDto;
}

export class PagedResultDtoOfIssueProgressListDto implements IPagedResultDtoOfIssueProgressListDto {
    totalCount: number;
    items: IssueProgressListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfIssueProgressListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IssueProgressListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfIssueProgressListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIssueProgressListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfIssueProgressListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfIssueProgressListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfIssueProgressListDto {
    totalCount: number;
    items: IssueProgressListDto[] | undefined;
}

export class IssueTypeEditDto implements IIssueTypeEditDto {
    /** Id */
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 计划完成时间 */
    planFinishTime: number;
    /** 是否可以修改时间 */
    canModifyTime: boolean;

    constructor(data?: IIssueTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            this.planFinishTime = _data["planFinishTime"];
            this.canModifyTime = _data["canModifyTime"];
        }
    }

    static fromJS(data: any): IssueTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        data["planFinishTime"] = this.planFinishTime;
        data["canModifyTime"] = this.canModifyTime;
        return data;
    }

    clone(): IssueTypeEditDto {
        const json = this.toJSON();
        let result = new IssueTypeEditDto();
        result.init(json);
        return result;
    }
}

export interface IIssueTypeEditDto {
    /** Id */
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 计划完成时间 */
    planFinishTime: number;
    /** 是否可以修改时间 */
    canModifyTime: boolean;
}

export class CreateOrUpdateIssueTypeInput implements ICreateOrUpdateIssueTypeInput {
    issueType: IssueTypeEditDto;

    constructor(data?: ICreateOrUpdateIssueTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.issueType = new IssueTypeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueType = _data["issueType"] ? IssueTypeEditDto.fromJS(_data["issueType"]) : new IssueTypeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateIssueTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateIssueTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueType"] = this.issueType ? this.issueType.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateIssueTypeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateIssueTypeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateIssueTypeInput {
    issueType: IssueTypeEditDto;
}

export class GetIssueTypeForEditOutput implements IGetIssueTypeForEditOutput {
    issueType: IssueTypeEditDto;

    constructor(data?: IGetIssueTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.issueType = new IssueTypeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueType = _data["issueType"] ? IssueTypeEditDto.fromJS(_data["issueType"]) : new IssueTypeEditDto();
        }
    }

    static fromJS(data: any): GetIssueTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueType"] = this.issueType ? this.issueType.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetIssueTypeForEditOutput {
        const json = this.toJSON();
        let result = new GetIssueTypeForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetIssueTypeForEditOutput {
    issueType: IssueTypeEditDto;
}

export class IssueTypeTreeSelectDto implements IIssueTypeTreeSelectDto {
    name: string | undefined;
    /** 名称 */
    title: string | undefined;
    id: number;
    code: string | undefined;
    pid: number;
    children: IssueTypeTreeSelectDto[] | undefined;

    constructor(data?: IIssueTypeTreeSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.id = _data["id"];
            this.code = _data["code"];
            this.pid = _data["pid"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(IssueTypeTreeSelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IssueTypeTreeSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTypeTreeSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["id"] = this.id;
        data["code"] = this.code;
        data["pid"] = this.pid;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): IssueTypeTreeSelectDto {
        const json = this.toJSON();
        let result = new IssueTypeTreeSelectDto();
        result.init(json);
        return result;
    }
}

export interface IIssueTypeTreeSelectDto {
    name: string | undefined;
    /** 名称 */
    title: string | undefined;
    id: number;
    code: string | undefined;
    pid: number;
    children: IssueTypeTreeSelectDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpProtocol.JumpProtocol */
export class JumpProtocolEditDto implements IJumpProtocolEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** JumpUrl */
    jumpUrl: string | undefined;

    constructor(data?: IJumpProtocolEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.jumpUrl = _data["jumpUrl"];
        }
    }

    static fromJS(data: any): JumpProtocolEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new JumpProtocolEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["jumpUrl"] = this.jumpUrl;
        return data;
    }

    clone(): JumpProtocolEditDto {
        const json = this.toJSON();
        let result = new JumpProtocolEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpProtocol.JumpProtocol */
export interface IJumpProtocolEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** JumpUrl */
    jumpUrl: string | undefined;
}

export class CreateOrUpdateJumpProtocolInput implements ICreateOrUpdateJumpProtocolInput {
    jumpProtocol: JumpProtocolEditDto;

    constructor(data?: ICreateOrUpdateJumpProtocolInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jumpProtocol = new JumpProtocolEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jumpProtocol = _data["jumpProtocol"] ? JumpProtocolEditDto.fromJS(_data["jumpProtocol"]) : new JumpProtocolEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateJumpProtocolInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateJumpProtocolInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jumpProtocol"] = this.jumpProtocol ? this.jumpProtocol.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateJumpProtocolInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateJumpProtocolInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateJumpProtocolInput {
    jumpProtocol: JumpProtocolEditDto;
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpProtocol.JumpProtocol */
export class JumpProtocolListDto implements IJumpProtocolListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** JumpUrl */
    jumpUrl: string | undefined;
    id: number;

    constructor(data?: IJumpProtocolListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.jumpUrl = _data["jumpUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JumpProtocolListDto {
        data = typeof data === 'object' ? data : {};
        let result = new JumpProtocolListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["jumpUrl"] = this.jumpUrl;
        data["id"] = this.id;
        return data;
    }

    clone(): JumpProtocolListDto {
        const json = this.toJSON();
        let result = new JumpProtocolListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpProtocol.JumpProtocol */
export interface IJumpProtocolListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** JumpUrl */
    jumpUrl: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetJumpProtocolForEditOutput implements IGetJumpProtocolForEditOutput {
    jumpProtocol: JumpProtocolEditDto;

    constructor(data?: IGetJumpProtocolForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jumpProtocol = _data["jumpProtocol"] ? JumpProtocolEditDto.fromJS(_data["jumpProtocol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJumpProtocolForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJumpProtocolForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jumpProtocol"] = this.jumpProtocol ? this.jumpProtocol.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetJumpProtocolForEditOutput {
        const json = this.toJSON();
        let result = new GetJumpProtocolForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetJumpProtocolForEditOutput {
    jumpProtocol: JumpProtocolEditDto;
}

export class PagedResultDtoOfJumpProtocolListDto implements IPagedResultDtoOfJumpProtocolListDto {
    totalCount: number;
    items: JumpProtocolListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfJumpProtocolListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JumpProtocolListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfJumpProtocolListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJumpProtocolListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfJumpProtocolListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfJumpProtocolListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfJumpProtocolListDto {
    totalCount: number;
    items: JumpProtocolListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpValidPath.JumpValidPath */
export class JumpValidPathEditDto implements IJumpValidPathEditDto {
    /** Id */
    id: number | undefined;
    /** JvpId */
    jvpId: number;
    /** SourceType */
    sourceType: string | undefined;
    /** ValidPath */
    validPath: string | undefined;

    constructor(data?: IJumpValidPathEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jvpId = _data["jvpId"];
            this.sourceType = _data["sourceType"];
            this.validPath = _data["validPath"];
        }
    }

    static fromJS(data: any): JumpValidPathEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new JumpValidPathEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jvpId"] = this.jvpId;
        data["sourceType"] = this.sourceType;
        data["validPath"] = this.validPath;
        return data;
    }

    clone(): JumpValidPathEditDto {
        const json = this.toJSON();
        let result = new JumpValidPathEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpValidPath.JumpValidPath */
export interface IJumpValidPathEditDto {
    /** Id */
    id: number | undefined;
    /** JvpId */
    jvpId: number;
    /** SourceType */
    sourceType: string | undefined;
    /** ValidPath */
    validPath: string | undefined;
}

export class CreateOrUpdateJumpValidPathInput implements ICreateOrUpdateJumpValidPathInput {
    jumpValidPath: JumpValidPathEditDto;

    constructor(data?: ICreateOrUpdateJumpValidPathInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.jumpValidPath = new JumpValidPathEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jumpValidPath = _data["jumpValidPath"] ? JumpValidPathEditDto.fromJS(_data["jumpValidPath"]) : new JumpValidPathEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateJumpValidPathInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateJumpValidPathInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jumpValidPath"] = this.jumpValidPath ? this.jumpValidPath.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateJumpValidPathInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateJumpValidPathInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateJumpValidPathInput {
    jumpValidPath: JumpValidPathEditDto;
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpValidPath.JumpValidPath */
export class JumpValidPathListDto implements IJumpValidPathListDto {
    /** JvpId */
    jvpId: number;
    /** SourceType */
    sourceType: string | undefined;
    sourceTypeName: string | undefined;
    /** ValidPath */
    validPath: string | undefined;
    id: number;

    constructor(data?: IJumpValidPathListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jvpId = _data["jvpId"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.validPath = _data["validPath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JumpValidPathListDto {
        data = typeof data === 'object' ? data : {};
        let result = new JumpValidPathListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jvpId"] = this.jvpId;
        data["sourceType"] = this.sourceType;
        data["sourceTypeName"] = this.sourceTypeName;
        data["validPath"] = this.validPath;
        data["id"] = this.id;
        return data;
    }

    clone(): JumpValidPathListDto {
        const json = this.toJSON();
        let result = new JumpValidPathListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.MessageManage.JumpValidPath.JumpValidPath */
export interface IJumpValidPathListDto {
    /** JvpId */
    jvpId: number;
    /** SourceType */
    sourceType: string | undefined;
    sourceTypeName: string | undefined;
    /** ValidPath */
    validPath: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetJumpValidPathForEditOutput implements IGetJumpValidPathForEditOutput {
    jumpValidPath: JumpValidPathEditDto;

    constructor(data?: IGetJumpValidPathForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jumpValidPath = _data["jumpValidPath"] ? JumpValidPathEditDto.fromJS(_data["jumpValidPath"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJumpValidPathForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJumpValidPathForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jumpValidPath"] = this.jumpValidPath ? this.jumpValidPath.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetJumpValidPathForEditOutput {
        const json = this.toJSON();
        let result = new GetJumpValidPathForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetJumpValidPathForEditOutput {
    jumpValidPath: JumpValidPathEditDto;
}

export class PagedResultDtoOfJumpValidPathListDto implements IPagedResultDtoOfJumpValidPathListDto {
    totalCount: number;
    items: JumpValidPathListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfJumpValidPathListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JumpValidPathListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfJumpValidPathListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJumpValidPathListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfJumpValidPathListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfJumpValidPathListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfJumpValidPathListDto {
    totalCount: number;
    items: JumpValidPathListDto[] | undefined;
}

/** 看板模拟数据 */
export class KanbanAnalogDataEditDto implements IKanbanAnalogDataEditDto {
    /** Id */
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 名称 */
    value: string | undefined;
    /** 参数描述 */
    paramDesc: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否对接数据 */
    isDockingData: boolean;

    constructor(data?: IKanbanAnalogDataEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.paramDesc = _data["paramDesc"];
            this.remark = _data["remark"];
            this.isDockingData = _data["isDockingData"];
        }
    }

    static fromJS(data: any): KanbanAnalogDataEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanAnalogDataEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["value"] = this.value;
        data["paramDesc"] = this.paramDesc;
        data["remark"] = this.remark;
        data["isDockingData"] = this.isDockingData;
        return data;
    }

    clone(): KanbanAnalogDataEditDto {
        const json = this.toJSON();
        let result = new KanbanAnalogDataEditDto();
        result.init(json);
        return result;
    }
}

/** 看板模拟数据 */
export interface IKanbanAnalogDataEditDto {
    /** Id */
    id: number | undefined;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 名称 */
    value: string | undefined;
    /** 参数描述 */
    paramDesc: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否对接数据 */
    isDockingData: boolean;
}

/** 看板模拟数据 */
export class KanbanAnalogDataListDto implements IKanbanAnalogDataListDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 名称 */
    value: string | undefined;
    /** 参数描述 */
    paramDesc: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否对接数据 */
    isDockingData: boolean;

    constructor(data?: IKanbanAnalogDataListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.paramDesc = _data["paramDesc"];
            this.remark = _data["remark"];
            this.isDockingData = _data["isDockingData"];
        }
    }

    static fromJS(data: any): KanbanAnalogDataListDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanAnalogDataListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["value"] = this.value;
        data["paramDesc"] = this.paramDesc;
        data["remark"] = this.remark;
        data["isDockingData"] = this.isDockingData;
        return data;
    }

    clone(): KanbanAnalogDataListDto {
        const json = this.toJSON();
        let result = new KanbanAnalogDataListDto();
        result.init(json);
        return result;
    }
}

/** 看板模拟数据 */
export interface IKanbanAnalogDataListDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 名称 */
    value: string | undefined;
    /** 参数描述 */
    paramDesc: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否对接数据 */
    isDockingData: boolean;
}

/** dto */
export class GetAuditPointComplianceRateEntityDto implements IGetAuditPointComplianceRateEntityDto {
    /** 审核点 */
    name: string | undefined;
    /** 1-12月的符合项数量 */
    conform: number[] | undefined;
    /** 1-12月的不符合项数量 */
    nonConformity: number[] | undefined;
    /** 1-12月的符合率 */
    complianceRate: number[] | undefined;

    constructor(data?: IGetAuditPointComplianceRateEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["conform"])) {
                this.conform = [] as any;
                for (let item of _data["conform"])
                    this.conform.push(item);
            }
            if (Array.isArray(_data["nonConformity"])) {
                this.nonConformity = [] as any;
                for (let item of _data["nonConformity"])
                    this.nonConformity.push(item);
            }
            if (Array.isArray(_data["complianceRate"])) {
                this.complianceRate = [] as any;
                for (let item of _data["complianceRate"])
                    this.complianceRate.push(item);
            }
        }
    }

    static fromJS(data: any): GetAuditPointComplianceRateEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditPointComplianceRateEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.conform)) {
            data["conform"] = [];
            for (let item of this.conform)
                data["conform"].push(item);
        }
        if (Array.isArray(this.nonConformity)) {
            data["nonConformity"] = [];
            for (let item of this.nonConformity)
                data["nonConformity"].push(item);
        }
        if (Array.isArray(this.complianceRate)) {
            data["complianceRate"] = [];
            for (let item of this.complianceRate)
                data["complianceRate"].push(item);
        }
        return data;
    }

    clone(): GetAuditPointComplianceRateEntityDto {
        const json = this.toJSON();
        let result = new GetAuditPointComplianceRateEntityDto();
        result.init(json);
        return result;
    }
}

/** dto */
export interface IGetAuditPointComplianceRateEntityDto {
    /** 审核点 */
    name: string | undefined;
    /** 1-12月的符合项数量 */
    conform: number[] | undefined;
    /** 1-12月的不符合项数量 */
    nonConformity: number[] | undefined;
    /** 1-12月的符合率 */
    complianceRate: number[] | undefined;
}

/** 审核点 */
export class GetAuditPointComplianceRateDto implements IGetAuditPointComplianceRateDto {
    /** 月 */
    month: number[] | undefined;
    /** 数据 */
    data: GetAuditPointComplianceRateEntityDto[] | undefined;

    constructor(data?: IGetAuditPointComplianceRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["month"])) {
                this.month = [] as any;
                for (let item of _data["month"])
                    this.month.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(GetAuditPointComplianceRateEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAuditPointComplianceRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditPointComplianceRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.month)) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAuditPointComplianceRateDto {
        const json = this.toJSON();
        let result = new GetAuditPointComplianceRateDto();
        result.init(json);
        return result;
    }
}

/** 审核点 */
export interface IGetAuditPointComplianceRateDto {
    /** 月 */
    month: number[] | undefined;
    /** 数据 */
    data: GetAuditPointComplianceRateEntityDto[] | undefined;
}

/** 审核任务 */
export class GetAuditTaskListDto implements IGetAuditTaskListDto {
    /** Id */
    id: number;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核模板名 */
    auditTemplateName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 实际开始日期 */
    startTime: moment.Moment | undefined;
    /** 实际结束日期 */
    endTime: moment.Moment | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateSN: number;
    /** 备注 */
    remark: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 请假原因 */
    leaveReason: string | undefined;
    /** 请假详细描述 */
    leaveRemark: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
    /** 提前开始 */
    earlyStartTime: string | undefined;
    /** 延后完成 */
    delayedFinishTime: string | undefined;
    /** 是否为审核记录转办任务 */
    isTransfer: boolean;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    isTimeout: boolean;

    constructor(data?: IGetAuditTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditTaskType = _data["auditTaskType"];
            this.auditTaskTypeName = _data["auditTaskTypeName"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.auditTemplateName = _data["auditTemplateName"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"];
            this.auditTaskStateName = _data["auditTaskStateName"];
            this.auditTaskStateSN = _data["auditTaskStateSN"];
            this.remark = _data["remark"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.leaveReason = _data["leaveReason"];
            this.leaveRemark = _data["leaveRemark"];
            this.auditTaskCreateId = _data["auditTaskCreateId"];
            this.auditTaskLabel = _data["auditTaskLabel"];
            this.auditTaskLabelName = _data["auditTaskLabelName"];
            this.earlyStart = _data["earlyStart"];
            this.delayedFinish = _data["delayedFinish"];
            this.earlyStartTime = _data["earlyStartTime"];
            this.delayedFinishTime = _data["delayedFinishTime"];
            this.isTransfer = _data["isTransfer"];
            this.templateBarCode = _data["templateBarCode"];
            this.assitField = _data["assitField"];
            this.isTimeout = _data["isTimeout"];
        }
    }

    static fromJS(data: any): GetAuditTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditTaskType"] = this.auditTaskType;
        data["auditTaskTypeName"] = this.auditTaskTypeName;
        data["auditTemplateId"] = this.auditTemplateId;
        data["auditTemplateName"] = this.auditTemplateName;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState;
        data["auditTaskStateName"] = this.auditTaskStateName;
        data["auditTaskStateSN"] = this.auditTaskStateSN;
        data["remark"] = this.remark;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["leaveReason"] = this.leaveReason;
        data["leaveRemark"] = this.leaveRemark;
        data["auditTaskCreateId"] = this.auditTaskCreateId;
        data["auditTaskLabel"] = this.auditTaskLabel;
        data["auditTaskLabelName"] = this.auditTaskLabelName;
        data["earlyStart"] = this.earlyStart;
        data["delayedFinish"] = this.delayedFinish;
        data["earlyStartTime"] = this.earlyStartTime;
        data["delayedFinishTime"] = this.delayedFinishTime;
        data["isTransfer"] = this.isTransfer;
        data["templateBarCode"] = this.templateBarCode;
        data["assitField"] = this.assitField;
        data["isTimeout"] = this.isTimeout;
        return data;
    }

    clone(): GetAuditTaskListDto {
        const json = this.toJSON();
        let result = new GetAuditTaskListDto();
        result.init(json);
        return result;
    }
}

/** 审核任务 */
export interface IGetAuditTaskListDto {
    /** Id */
    id: number;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
    /** 审核模板 */
    auditTemplateId: number | undefined;
    /** 审核模板名 */
    auditTemplateName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 实际开始日期 */
    startTime: moment.Moment | undefined;
    /** 实际结束日期 */
    endTime: moment.Moment | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateSN: number;
    /** 备注 */
    remark: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 请假原因 */
    leaveReason: string | undefined;
    /** 请假详细描述 */
    leaveRemark: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 审核任务标签 */
    auditTaskLabel: string | undefined;
    /** 审核任务标签 */
    auditTaskLabelName: string | undefined;
    /** 提前开始 */
    earlyStart: number;
    /** 延后完成 */
    delayedFinish: number;
    /** 提前开始 */
    earlyStartTime: string | undefined;
    /** 延后完成 */
    delayedFinishTime: string | undefined;
    /** 是否为审核记录转办任务 */
    isTransfer: boolean;
    /** 条码 */
    templateBarCode: string | undefined;
    /** 辅助字段 */
    assitField: string | undefined;
    isTimeout: boolean;
}

/** 完成率Dto */
export class GetCompletionRateDto implements IGetCompletionRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 计划数量 */
    planList: number[] | undefined;
    /** 完成数量 */
    finshList: number[] | undefined;
    /** 完成率 */
    finshRateList: number[] | undefined;
    /** 未完成数量 */
    noFinshList: number[] | undefined;

    constructor(data?: IGetCompletionRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["monthList"])) {
                this.monthList = [] as any;
                for (let item of _data["monthList"])
                    this.monthList.push(item);
            }
            if (Array.isArray(_data["planList"])) {
                this.planList = [] as any;
                for (let item of _data["planList"])
                    this.planList.push(item);
            }
            if (Array.isArray(_data["finshList"])) {
                this.finshList = [] as any;
                for (let item of _data["finshList"])
                    this.finshList.push(item);
            }
            if (Array.isArray(_data["finshRateList"])) {
                this.finshRateList = [] as any;
                for (let item of _data["finshRateList"])
                    this.finshRateList.push(item);
            }
            if (Array.isArray(_data["noFinshList"])) {
                this.noFinshList = [] as any;
                for (let item of _data["noFinshList"])
                    this.noFinshList.push(item);
            }
        }
    }

    static fromJS(data: any): GetCompletionRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompletionRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.monthList)) {
            data["monthList"] = [];
            for (let item of this.monthList)
                data["monthList"].push(item);
        }
        if (Array.isArray(this.planList)) {
            data["planList"] = [];
            for (let item of this.planList)
                data["planList"].push(item);
        }
        if (Array.isArray(this.finshList)) {
            data["finshList"] = [];
            for (let item of this.finshList)
                data["finshList"].push(item);
        }
        if (Array.isArray(this.finshRateList)) {
            data["finshRateList"] = [];
            for (let item of this.finshRateList)
                data["finshRateList"].push(item);
        }
        if (Array.isArray(this.noFinshList)) {
            data["noFinshList"] = [];
            for (let item of this.noFinshList)
                data["noFinshList"].push(item);
        }
        return data;
    }

    clone(): GetCompletionRateDto {
        const json = this.toJSON();
        let result = new GetCompletionRateDto();
        result.init(json);
        return result;
    }
}

/** 完成率Dto */
export interface IGetCompletionRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 计划数量 */
    planList: number[] | undefined;
    /** 完成数量 */
    finshList: number[] | undefined;
    /** 完成率 */
    finshRateList: number[] | undefined;
    /** 未完成数量 */
    noFinshList: number[] | undefined;
}

/** 符合率 */
export class GetComplianceRateDto implements IGetComplianceRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueList: number[] | undefined;
    /** 审核记录数量 */
    auditItemList: number[] | undefined;
    /** 符合率 */
    complianceRateList: number[] | undefined;

    constructor(data?: IGetComplianceRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["monthList"])) {
                this.monthList = [] as any;
                for (let item of _data["monthList"])
                    this.monthList.push(item);
            }
            if (Array.isArray(_data["issueList"])) {
                this.issueList = [] as any;
                for (let item of _data["issueList"])
                    this.issueList.push(item);
            }
            if (Array.isArray(_data["auditItemList"])) {
                this.auditItemList = [] as any;
                for (let item of _data["auditItemList"])
                    this.auditItemList.push(item);
            }
            if (Array.isArray(_data["complianceRateList"])) {
                this.complianceRateList = [] as any;
                for (let item of _data["complianceRateList"])
                    this.complianceRateList.push(item);
            }
        }
    }

    static fromJS(data: any): GetComplianceRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetComplianceRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.monthList)) {
            data["monthList"] = [];
            for (let item of this.monthList)
                data["monthList"].push(item);
        }
        if (Array.isArray(this.issueList)) {
            data["issueList"] = [];
            for (let item of this.issueList)
                data["issueList"].push(item);
        }
        if (Array.isArray(this.auditItemList)) {
            data["auditItemList"] = [];
            for (let item of this.auditItemList)
                data["auditItemList"].push(item);
        }
        if (Array.isArray(this.complianceRateList)) {
            data["complianceRateList"] = [];
            for (let item of this.complianceRateList)
                data["complianceRateList"].push(item);
        }
        return data;
    }

    clone(): GetComplianceRateDto {
        const json = this.toJSON();
        let result = new GetComplianceRateDto();
        result.init(json);
        return result;
    }
}

/** 符合率 */
export interface IGetComplianceRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueList: number[] | undefined;
    /** 审核记录数量 */
    auditItemList: number[] | undefined;
    /** 符合率 */
    complianceRateList: number[] | undefined;
}

/** 问题关闭率 */
export class GetIssueCloseRateDto implements IGetIssueCloseRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueList: number[] | undefined;
    /** 关闭数量 */
    closeList: number[] | undefined;
    /** 关闭率 */
    closeRateList: number[] | undefined;
    /** 未关闭数量 */
    noCloseList: number[] | undefined;

    constructor(data?: IGetIssueCloseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["monthList"])) {
                this.monthList = [] as any;
                for (let item of _data["monthList"])
                    this.monthList.push(item);
            }
            if (Array.isArray(_data["issueList"])) {
                this.issueList = [] as any;
                for (let item of _data["issueList"])
                    this.issueList.push(item);
            }
            if (Array.isArray(_data["closeList"])) {
                this.closeList = [] as any;
                for (let item of _data["closeList"])
                    this.closeList.push(item);
            }
            if (Array.isArray(_data["closeRateList"])) {
                this.closeRateList = [] as any;
                for (let item of _data["closeRateList"])
                    this.closeRateList.push(item);
            }
            if (Array.isArray(_data["noCloseList"])) {
                this.noCloseList = [] as any;
                for (let item of _data["noCloseList"])
                    this.noCloseList.push(item);
            }
        }
    }

    static fromJS(data: any): GetIssueCloseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueCloseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.monthList)) {
            data["monthList"] = [];
            for (let item of this.monthList)
                data["monthList"].push(item);
        }
        if (Array.isArray(this.issueList)) {
            data["issueList"] = [];
            for (let item of this.issueList)
                data["issueList"].push(item);
        }
        if (Array.isArray(this.closeList)) {
            data["closeList"] = [];
            for (let item of this.closeList)
                data["closeList"].push(item);
        }
        if (Array.isArray(this.closeRateList)) {
            data["closeRateList"] = [];
            for (let item of this.closeRateList)
                data["closeRateList"].push(item);
        }
        if (Array.isArray(this.noCloseList)) {
            data["noCloseList"] = [];
            for (let item of this.noCloseList)
                data["noCloseList"].push(item);
        }
        return data;
    }

    clone(): GetIssueCloseRateDto {
        const json = this.toJSON();
        let result = new GetIssueCloseRateDto();
        result.init(json);
        return result;
    }
}

/** 问题关闭率 */
export interface IGetIssueCloseRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueList: number[] | undefined;
    /** 关闭数量 */
    closeList: number[] | undefined;
    /** 关闭率 */
    closeRateList: number[] | undefined;
    /** 未关闭数量 */
    noCloseList: number[] | undefined;
}

/** 隐患问题部门关闭率数据 */
export class GetIssueCloseRateForSafetyHazardsDto implements IGetIssueCloseRateForSafetyHazardsDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueCountList: number[] | undefined;
    /** 关闭数量 */
    closeCountList: number[] | undefined;
    /** 关闭率 */
    closeRateList: number[] | undefined;
    /** 目标关闭率 */
    targetCloseRateList: number[] | undefined;
    /** 未关闭数量 */
    noCloseCountList: number[] | undefined;

    constructor(data?: IGetIssueCloseRateForSafetyHazardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["monthList"])) {
                this.monthList = [] as any;
                for (let item of _data["monthList"])
                    this.monthList.push(item);
            }
            if (Array.isArray(_data["issueCountList"])) {
                this.issueCountList = [] as any;
                for (let item of _data["issueCountList"])
                    this.issueCountList.push(item);
            }
            if (Array.isArray(_data["closeCountList"])) {
                this.closeCountList = [] as any;
                for (let item of _data["closeCountList"])
                    this.closeCountList.push(item);
            }
            if (Array.isArray(_data["closeRateList"])) {
                this.closeRateList = [] as any;
                for (let item of _data["closeRateList"])
                    this.closeRateList.push(item);
            }
            if (Array.isArray(_data["targetCloseRateList"])) {
                this.targetCloseRateList = [] as any;
                for (let item of _data["targetCloseRateList"])
                    this.targetCloseRateList.push(item);
            }
            if (Array.isArray(_data["noCloseCountList"])) {
                this.noCloseCountList = [] as any;
                for (let item of _data["noCloseCountList"])
                    this.noCloseCountList.push(item);
            }
        }
    }

    static fromJS(data: any): GetIssueCloseRateForSafetyHazardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueCloseRateForSafetyHazardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.monthList)) {
            data["monthList"] = [];
            for (let item of this.monthList)
                data["monthList"].push(item);
        }
        if (Array.isArray(this.issueCountList)) {
            data["issueCountList"] = [];
            for (let item of this.issueCountList)
                data["issueCountList"].push(item);
        }
        if (Array.isArray(this.closeCountList)) {
            data["closeCountList"] = [];
            for (let item of this.closeCountList)
                data["closeCountList"].push(item);
        }
        if (Array.isArray(this.closeRateList)) {
            data["closeRateList"] = [];
            for (let item of this.closeRateList)
                data["closeRateList"].push(item);
        }
        if (Array.isArray(this.targetCloseRateList)) {
            data["targetCloseRateList"] = [];
            for (let item of this.targetCloseRateList)
                data["targetCloseRateList"].push(item);
        }
        if (Array.isArray(this.noCloseCountList)) {
            data["noCloseCountList"] = [];
            for (let item of this.noCloseCountList)
                data["noCloseCountList"].push(item);
        }
        return data;
    }

    clone(): GetIssueCloseRateForSafetyHazardsDto {
        const json = this.toJSON();
        let result = new GetIssueCloseRateForSafetyHazardsDto();
        result.init(json);
        return result;
    }
}

/** 隐患问题部门关闭率数据 */
export interface IGetIssueCloseRateForSafetyHazardsDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueCountList: number[] | undefined;
    /** 关闭数量 */
    closeCountList: number[] | undefined;
    /** 关闭率 */
    closeRateList: number[] | undefined;
    /** 目标关闭率 */
    targetCloseRateList: number[] | undefined;
    /** 未关闭数量 */
    noCloseCountList: number[] | undefined;
}

/** 部门隐患月度发现数量 */
export class GetDeptIssueMonthQtyForSafetyHazardsDto implements IGetDeptIssueMonthQtyForSafetyHazardsDto {
    /** 部门 */
    name: string[] | undefined;
    /** 问题数量 */
    issueCount: number[] | undefined;
    /** 问题数量 */
    targetCount: number[] | undefined;

    constructor(data?: IGetDeptIssueMonthQtyForSafetyHazardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name.push(item);
            }
            if (Array.isArray(_data["issueCount"])) {
                this.issueCount = [] as any;
                for (let item of _data["issueCount"])
                    this.issueCount.push(item);
            }
            if (Array.isArray(_data["targetCount"])) {
                this.targetCount = [] as any;
                for (let item of _data["targetCount"])
                    this.targetCount.push(item);
            }
        }
    }

    static fromJS(data: any): GetDeptIssueMonthQtyForSafetyHazardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeptIssueMonthQtyForSafetyHazardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        if (Array.isArray(this.issueCount)) {
            data["issueCount"] = [];
            for (let item of this.issueCount)
                data["issueCount"].push(item);
        }
        if (Array.isArray(this.targetCount)) {
            data["targetCount"] = [];
            for (let item of this.targetCount)
                data["targetCount"].push(item);
        }
        return data;
    }

    clone(): GetDeptIssueMonthQtyForSafetyHazardsDto {
        const json = this.toJSON();
        let result = new GetDeptIssueMonthQtyForSafetyHazardsDto();
        result.init(json);
        return result;
    }
}

/** 部门隐患月度发现数量 */
export interface IGetDeptIssueMonthQtyForSafetyHazardsDto {
    /** 部门 */
    name: string[] | undefined;
    /** 问题数量 */
    issueCount: number[] | undefined;
    /** 问题数量 */
    targetCount: number[] | undefined;
}

/** dto */
export class GetDeptIssueQtyEntityDto implements IGetDeptIssueQtyEntityDto {
    /** 部门 */
    name: string | undefined;
    /** 1-12月的问题数量 */
    data: number[] | undefined;

    constructor(data?: IGetDeptIssueQtyEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(item);
            }
        }
    }

    static fromJS(data: any): GetDeptIssueQtyEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeptIssueQtyEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }

    clone(): GetDeptIssueQtyEntityDto {
        const json = this.toJSON();
        let result = new GetDeptIssueQtyEntityDto();
        result.init(json);
        return result;
    }
}

/** dto */
export interface IGetDeptIssueQtyEntityDto {
    /** 部门 */
    name: string | undefined;
    /** 1-12月的问题数量 */
    data: number[] | undefined;
}

/** 部门问题数量 */
export class GetDeptIssueQtyDto implements IGetDeptIssueQtyDto {
    /** 月 */
    month: number[] | undefined;
    /** 数据 */
    data: GetDeptIssueQtyEntityDto[] | undefined;

    constructor(data?: IGetDeptIssueQtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["month"])) {
                this.month = [] as any;
                for (let item of _data["month"])
                    this.month.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(GetDeptIssueQtyEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeptIssueQtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeptIssueQtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.month)) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetDeptIssueQtyDto {
        const json = this.toJSON();
        let result = new GetDeptIssueQtyDto();
        result.init(json);
        return result;
    }
}

/** 部门问题数量 */
export interface IGetDeptIssueQtyDto {
    /** 月 */
    month: number[] | undefined;
    /** 数据 */
    data: GetDeptIssueQtyEntityDto[] | undefined;
}

export class GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto implements IGetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto {
    /** 人员 */
    name: string[] | undefined;
    /** 问题数量 */
    issueCount: number[] | undefined;
    /** 问题数量 */
    targetCount: number[] | undefined;

    constructor(data?: IGetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name.push(item);
            }
            if (Array.isArray(_data["issueCount"])) {
                this.issueCount = [] as any;
                for (let item of _data["issueCount"])
                    this.issueCount.push(item);
            }
            if (Array.isArray(_data["targetCount"])) {
                this.targetCount = [] as any;
                for (let item of _data["targetCount"])
                    this.targetCount.push(item);
            }
        }
    }

    static fromJS(data: any): GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        if (Array.isArray(this.issueCount)) {
            data["issueCount"] = [];
            for (let item of this.issueCount)
                data["issueCount"].push(item);
        }
        if (Array.isArray(this.targetCount)) {
            data["targetCount"] = [];
            for (let item of this.targetCount)
                data["targetCount"].push(item);
        }
        return data;
    }

    clone(): GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto {
        const json = this.toJSON();
        let result = new GetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto();
        result.init(json);
        return result;
    }
}

export interface IGetIsKeyPositionsUserMonthIssueQtyForSafetyHazardsDto {
    /** 人员 */
    name: string[] | undefined;
    /** 问题数量 */
    issueCount: number[] | undefined;
    /** 问题数量 */
    targetCount: number[] | undefined;
}

/** 问题清单 */
export class GetKanBanIssueListDto implements IGetKanBanIssueListDto {
    /** Id */
    id: number | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型 */
    sourceName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型 */
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discoverer: string | undefined;
    /** 发现人部门 */
    discovererDept: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 责任部门 */
    respDept: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点 */
    auditPoint: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项 */
    auditItemName: string | undefined;
    /** 审核项序号 */
    auditItemSN: number;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    foreColor: string | undefined;
    issueSubscribeId: number | undefined;
    /** 24小时 */
    twentyFourHour: string | undefined;
    /** 30天 */
    thirtyDays: string | undefined;
    /** 是否六个月内重复发生 */
    recurrence: string | undefined;

    constructor(data?: IGetKanBanIssueListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceType = _data["sourceType"];
            this.sourceName = _data["sourceName"];
            this.issueTypeId = _data["issueTypeId"];
            this.issueTypeName = _data["issueTypeName"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueTypeListName = _data["issueTypeListName"];
            this.issueProgress = _data["issueProgress"];
            this.issueProgressName = _data["issueProgressName"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discoverer = _data["discoverer"];
            this.discovererDept = _data["discovererDept"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.respDept = _data["respDept"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPoint = _data["auditPoint"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.auditItemSN = _data["auditItemSN"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.remark = _data["remark"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.foreColor = _data["foreColor"];
            this.issueSubscribeId = _data["issueSubscribeId"];
            this.twentyFourHour = _data["twentyFourHour"];
            this.thirtyDays = _data["thirtyDays"];
            this.recurrence = _data["recurrence"];
        }
    }

    static fromJS(data: any): GetKanBanIssueListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanBanIssueListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceType"] = this.sourceType;
        data["sourceName"] = this.sourceName;
        data["issueTypeId"] = this.issueTypeId;
        data["issueTypeName"] = this.issueTypeName;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueTypeListName"] = this.issueTypeListName;
        data["issueProgress"] = this.issueProgress;
        data["issueProgressName"] = this.issueProgressName;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discoverer"] = this.discoverer;
        data["discovererDept"] = this.discovererDept;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["respDept"] = this.respDept;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPoint"] = this.auditPoint;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["auditItemSN"] = this.auditItemSN;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["remark"] = this.remark;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["foreColor"] = this.foreColor;
        data["issueSubscribeId"] = this.issueSubscribeId;
        data["twentyFourHour"] = this.twentyFourHour;
        data["thirtyDays"] = this.thirtyDays;
        data["recurrence"] = this.recurrence;
        return data;
    }

    clone(): GetKanBanIssueListDto {
        const json = this.toJSON();
        let result = new GetKanBanIssueListDto();
        result.init(json);
        return result;
    }
}

/** 问题清单 */
export interface IGetKanBanIssueListDto {
    /** Id */
    id: number | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型 */
    sourceName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型 */
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discoverer: string | undefined;
    /** 发现人部门 */
    discovererDept: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 责任部门 */
    respDept: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点 */
    auditPoint: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项 */
    auditItemName: string | undefined;
    /** 审核项序号 */
    auditItemSN: number;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    foreColor: string | undefined;
    issueSubscribeId: number | undefined;
    /** 24小时 */
    twentyFourHour: string | undefined;
    /** 30天 */
    thirtyDays: string | undefined;
    /** 是否六个月内重复发生 */
    recurrence: string | undefined;
}

/** 问题按时关闭率 */
export class GetIssueOnTimeCloseRateDto implements IGetIssueOnTimeCloseRateDto {
    name: string | undefined;
    onTimeCloseRate: number;

    constructor(data?: IGetIssueOnTimeCloseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.onTimeCloseRate = _data["onTimeCloseRate"];
        }
    }

    static fromJS(data: any): GetIssueOnTimeCloseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueOnTimeCloseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["onTimeCloseRate"] = this.onTimeCloseRate;
        return data;
    }

    clone(): GetIssueOnTimeCloseRateDto {
        const json = this.toJSON();
        let result = new GetIssueOnTimeCloseRateDto();
        result.init(json);
        return result;
    }
}

/** 问题按时关闭率 */
export interface IGetIssueOnTimeCloseRateDto {
    name: string | undefined;
    onTimeCloseRate: number;
}

/** 获取问题top3 */
export class GetIssueTopThree implements IGetIssueTopThree {
    /** 值 */
    value: number;
    /** 名称 */
    name: string | undefined;

    constructor(data?: IGetIssueTopThree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetIssueTopThree {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueTopThree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }

    clone(): GetIssueTopThree {
        const json = this.toJSON();
        let result = new GetIssueTopThree();
        result.init(json);
        return result;
    }
}

/** 获取问题top3 */
export interface IGetIssueTopThree {
    /** 值 */
    value: number;
    /** 名称 */
    name: string | undefined;
}

/** 问题数量前十的问题分类 */
export class GetIssueTypeTopTenDto implements IGetIssueTypeTopTenDto {
    /** 问题分类 */
    name: string | undefined;
    /** 1-12月的问题数量 */
    data: number[] | undefined;

    constructor(data?: IGetIssueTypeTopTenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(item);
            }
        }
    }

    static fromJS(data: any): GetIssueTypeTopTenDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueTypeTopTenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }

    clone(): GetIssueTypeTopTenDto {
        const json = this.toJSON();
        let result = new GetIssueTypeTopTenDto();
        result.init(json);
        return result;
    }
}

/** 问题数量前十的问题分类 */
export interface IGetIssueTypeTopTenDto {
    /** 问题分类 */
    name: string | undefined;
    /** 1-12月的问题数量 */
    data: number[] | undefined;
}

/** 看板审核计划轻量项 */
export class KanBanAuditPlanBoardItemDto implements IKanBanAuditPlanBoardItemDto {
    /** Id */
    id: number;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 状态编码 */
    auditTaskState: string | undefined;
    /** 状态名称 */
    auditTaskStateName: string | undefined;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 是否超时预警 */
    isTimeout: boolean;

    constructor(data?: IKanBanAuditPlanBoardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.inspectorName = _data["inspectorName"];
            this.auditTaskState = _data["auditTaskState"];
            this.auditTaskStateName = _data["auditTaskStateName"];
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.isTimeout = _data["isTimeout"];
        }
    }

    static fromJS(data: any): KanBanAuditPlanBoardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanBanAuditPlanBoardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["inspectorName"] = this.inspectorName;
        data["auditTaskState"] = this.auditTaskState;
        data["auditTaskStateName"] = this.auditTaskStateName;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["isTimeout"] = this.isTimeout;
        return data;
    }

    clone(): KanBanAuditPlanBoardItemDto {
        const json = this.toJSON();
        let result = new KanBanAuditPlanBoardItemDto();
        result.init(json);
        return result;
    }
}

/** 看板审核计划轻量项 */
export interface IKanBanAuditPlanBoardItemDto {
    /** Id */
    id: number;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 状态编码 */
    auditTaskState: string | undefined;
    /** 状态名称 */
    auditTaskStateName: string | undefined;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 是否超时预警 */
    isTimeout: boolean;
}

/** 用户层级 */
export class GetUserLevelDto implements IGetUserLevelDto {
    /** 层级名称 */
    levelName: string | undefined;
    /** 任务数量 */
    planCount: number;
    /** 完成率 */
    finshRate: number;

    constructor(data?: IGetUserLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelName = _data["levelName"];
            this.planCount = _data["planCount"];
            this.finshRate = _data["finshRate"];
        }
    }

    static fromJS(data: any): GetUserLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["planCount"] = this.planCount;
        data["finshRate"] = this.finshRate;
        return data;
    }

    clone(): GetUserLevelDto {
        const json = this.toJSON();
        let result = new GetUserLevelDto();
        result.init(json);
        return result;
    }
}

/** 用户层级 */
export interface IGetUserLevelDto {
    /** 层级名称 */
    levelName: string | undefined;
    /** 任务数量 */
    planCount: number;
    /** 完成率 */
    finshRate: number;
}

/** 看板总览快照 */
export class GetKanBanSummarySnapshotDto implements IGetKanBanSummarySnapshotDto {
    deptCompletionRate: GetCompletionRateDto;
    deptIssueCloseRate: GetIssueCloseRateDto;
    deptComplianceRate: GetComplianceRateDto;
    yearCompletionRate: GetCompletionRateDto;
    yearIssueCloseRate: GetIssueCloseRateDto;
    yearComplianceRate: GetComplianceRateDto;
    /** 用户层级 */
    userLevel: GetUserLevelDto[] | undefined;
    /** 问题区域TOP3 */
    issuePointTopThree: GetIssueTopThree[] | undefined;
    /** 问题分类TOP3 */
    issueTypeTopThree: GetIssueTopThree[] | undefined;

    constructor(data?: IGetKanBanSummarySnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deptCompletionRate = _data["deptCompletionRate"] ? GetCompletionRateDto.fromJS(_data["deptCompletionRate"]) : <any>undefined;
            this.deptIssueCloseRate = _data["deptIssueCloseRate"] ? GetIssueCloseRateDto.fromJS(_data["deptIssueCloseRate"]) : <any>undefined;
            this.deptComplianceRate = _data["deptComplianceRate"] ? GetComplianceRateDto.fromJS(_data["deptComplianceRate"]) : <any>undefined;
            this.yearCompletionRate = _data["yearCompletionRate"] ? GetCompletionRateDto.fromJS(_data["yearCompletionRate"]) : <any>undefined;
            this.yearIssueCloseRate = _data["yearIssueCloseRate"] ? GetIssueCloseRateDto.fromJS(_data["yearIssueCloseRate"]) : <any>undefined;
            this.yearComplianceRate = _data["yearComplianceRate"] ? GetComplianceRateDto.fromJS(_data["yearComplianceRate"]) : <any>undefined;
            if (Array.isArray(_data["userLevel"])) {
                this.userLevel = [] as any;
                for (let item of _data["userLevel"])
                    this.userLevel.push(GetUserLevelDto.fromJS(item));
            }
            if (Array.isArray(_data["issuePointTopThree"])) {
                this.issuePointTopThree = [] as any;
                for (let item of _data["issuePointTopThree"])
                    this.issuePointTopThree.push(GetIssueTopThree.fromJS(item));
            }
            if (Array.isArray(_data["issueTypeTopThree"])) {
                this.issueTypeTopThree = [] as any;
                for (let item of _data["issueTypeTopThree"])
                    this.issueTypeTopThree.push(GetIssueTopThree.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKanBanSummarySnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanBanSummarySnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deptCompletionRate"] = this.deptCompletionRate ? this.deptCompletionRate.toJSON() : <any>undefined;
        data["deptIssueCloseRate"] = this.deptIssueCloseRate ? this.deptIssueCloseRate.toJSON() : <any>undefined;
        data["deptComplianceRate"] = this.deptComplianceRate ? this.deptComplianceRate.toJSON() : <any>undefined;
        data["yearCompletionRate"] = this.yearCompletionRate ? this.yearCompletionRate.toJSON() : <any>undefined;
        data["yearIssueCloseRate"] = this.yearIssueCloseRate ? this.yearIssueCloseRate.toJSON() : <any>undefined;
        data["yearComplianceRate"] = this.yearComplianceRate ? this.yearComplianceRate.toJSON() : <any>undefined;
        if (Array.isArray(this.userLevel)) {
            data["userLevel"] = [];
            for (let item of this.userLevel)
                data["userLevel"].push(item.toJSON());
        }
        if (Array.isArray(this.issuePointTopThree)) {
            data["issuePointTopThree"] = [];
            for (let item of this.issuePointTopThree)
                data["issuePointTopThree"].push(item.toJSON());
        }
        if (Array.isArray(this.issueTypeTopThree)) {
            data["issueTypeTopThree"] = [];
            for (let item of this.issueTypeTopThree)
                data["issueTypeTopThree"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetKanBanSummarySnapshotDto {
        const json = this.toJSON();
        let result = new GetKanBanSummarySnapshotDto();
        result.init(json);
        return result;
    }
}

/** 看板总览快照 */
export interface IGetKanBanSummarySnapshotDto {
    deptCompletionRate: GetCompletionRateDto;
    deptIssueCloseRate: GetIssueCloseRateDto;
    deptComplianceRate: GetComplianceRateDto;
    yearCompletionRate: GetCompletionRateDto;
    yearIssueCloseRate: GetIssueCloseRateDto;
    yearComplianceRate: GetComplianceRateDto;
    /** 用户层级 */
    userLevel: GetUserLevelDto[] | undefined;
    /** 问题区域TOP3 */
    issuePointTopThree: GetIssueTopThree[] | undefined;
    /** 问题分类TOP3 */
    issueTypeTopThree: GetIssueTopThree[] | undefined;
}

/** 看板问题清单轻量项 */
export class KanBanIssueBoardItemDto implements IKanBanIssueBoardItemDto {
    /** Id */
    id: number | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 问题描述 */
    description: string | undefined;
    /** 问题分类名称 */
    issueTypeListName: string | undefined;
    /** 审核点 */
    auditPoint: string | undefined;
    auditItemTypeListName: string | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;

    constructor(data?: IKanBanIssueBoardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.issueTypeListName = _data["issueTypeListName"];
            this.auditPoint = _data["auditPoint"];
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.respName = _data["respName"];
            this.issueProgressName = _data["issueProgressName"];
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KanBanIssueBoardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanBanIssueBoardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["issueTypeListName"] = this.issueTypeListName;
        data["auditPoint"] = this.auditPoint;
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["respName"] = this.respName;
        data["issueProgressName"] = this.issueProgressName;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): KanBanIssueBoardItemDto {
        const json = this.toJSON();
        let result = new KanBanIssueBoardItemDto();
        result.init(json);
        return result;
    }
}

/** 看板问题清单轻量项 */
export interface IKanBanIssueBoardItemDto {
    /** Id */
    id: number | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 问题描述 */
    description: string | undefined;
    /** 问题分类名称 */
    issueTypeListName: string | undefined;
    /** 审核点 */
    auditPoint: string | undefined;
    auditItemTypeListName: string | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
}

/** 看板聚合结果 */
export class GetKanBanDashboardBundleDto implements IGetKanBanDashboardBundleDto {
    summary: GetKanBanSummarySnapshotDto;
    /** 审核计划列表 */
    auditPlanList: KanBanAuditPlanBoardItemDto[] | undefined;
    /** 问题列表 */
    issueList: KanBanIssueBoardItemDto[] | undefined;

    constructor(data?: IGetKanBanDashboardBundleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? GetKanBanSummarySnapshotDto.fromJS(_data["summary"]) : <any>undefined;
            if (Array.isArray(_data["auditPlanList"])) {
                this.auditPlanList = [] as any;
                for (let item of _data["auditPlanList"])
                    this.auditPlanList.push(KanBanAuditPlanBoardItemDto.fromJS(item));
            }
            if (Array.isArray(_data["issueList"])) {
                this.issueList = [] as any;
                for (let item of _data["issueList"])
                    this.issueList.push(KanBanIssueBoardItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKanBanDashboardBundleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetKanBanDashboardBundleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        if (Array.isArray(this.auditPlanList)) {
            data["auditPlanList"] = [];
            for (let item of this.auditPlanList)
                data["auditPlanList"].push(item.toJSON());
        }
        if (Array.isArray(this.issueList)) {
            data["issueList"] = [];
            for (let item of this.issueList)
                data["issueList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetKanBanDashboardBundleDto {
        const json = this.toJSON();
        let result = new GetKanBanDashboardBundleDto();
        result.init(json);
        return result;
    }
}

/** 看板聚合结果 */
export interface IGetKanBanDashboardBundleDto {
    summary: GetKanBanSummarySnapshotDto;
    /** 审核计划列表 */
    auditPlanList: KanBanAuditPlanBoardItemDto[] | undefined;
    /** 问题列表 */
    issueList: KanBanIssueBoardItemDto[] | undefined;
}

export class PagedResultDtoOfKanbanAnalogDataListDto implements IPagedResultDtoOfKanbanAnalogDataListDto {
    totalCount: number;
    items: KanbanAnalogDataListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfKanbanAnalogDataListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(KanbanAnalogDataListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfKanbanAnalogDataListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfKanbanAnalogDataListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfKanbanAnalogDataListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfKanbanAnalogDataListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfKanbanAnalogDataListDto {
    totalCount: number;
    items: KanbanAnalogDataListDto[] | undefined;
}

export class GetSixMonthRepeatIssueForEchartsDto implements IGetSixMonthRepeatIssueForEchartsDto {
    month: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 数量 */
    issueCount: number;

    constructor(data?: IGetSixMonthRepeatIssueForEchartsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.issueCount = _data["issueCount"];
        }
    }

    static fromJS(data: any): GetSixMonthRepeatIssueForEchartsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSixMonthRepeatIssueForEchartsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["issueCount"] = this.issueCount;
        return data;
    }

    clone(): GetSixMonthRepeatIssueForEchartsDto {
        const json = this.toJSON();
        let result = new GetSixMonthRepeatIssueForEchartsDto();
        result.init(json);
        return result;
    }
}

export interface IGetSixMonthRepeatIssueForEchartsDto {
    month: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 数量 */
    issueCount: number;
}

export class CreateOrUpdateLaborcostYearPlanInput implements ICreateOrUpdateLaborcostYearPlanInput {
    depId: number;
    year: number;
    month: number;
    name: string | undefined;
    num: number;

    constructor(data?: ICreateOrUpdateLaborcostYearPlanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depId = _data["depId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.name = _data["name"];
            this.num = _data["num"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLaborcostYearPlanInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLaborcostYearPlanInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depId"] = this.depId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["name"] = this.name;
        data["num"] = this.num;
        return data;
    }

    clone(): CreateOrUpdateLaborcostYearPlanInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateLaborcostYearPlanInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateLaborcostYearPlanInput {
    depId: number;
    year: number;
    month: number;
    name: string | undefined;
    num: number;
}

/** 导入 */
export class LCExportTemplateInput implements ILCExportTemplateInput {
    fileName: string | undefined;
    year: number;
    comId: number | undefined;
    depId: number | undefined;

    constructor(data?: ILCExportTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.year = _data["year"];
            this.comId = _data["comId"];
            this.depId = _data["depId"];
        }
    }

    static fromJS(data: any): LCExportTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new LCExportTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["year"] = this.year;
        data["comId"] = this.comId;
        data["depId"] = this.depId;
        return data;
    }

    clone(): LCExportTemplateInput {
        const json = this.toJSON();
        let result = new LCExportTemplateInput();
        result.init(json);
        return result;
    }
}

/** 导入 */
export interface ILCExportTemplateInput {
    fileName: string | undefined;
    year: number;
    comId: number | undefined;
    depId: number | undefined;
}

/** 的列表DTO QYB.QYBProduct.Laborcost.LaborcostYearPlan.LaborcostYearPlan */
export class LaborcostYearPlanListDto implements ILaborcostYearPlanListDto {
    /** 年 */
    year: number;
    /** 月 */
    month: number;
    /** 公司 */
    companyId: number;
    company: string | undefined;
    /** 部门 */
    departmentId: number;
    department: string | undefined;
    /** 人数 */
    peopleNum: number;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 请假时数 */
    leaveNum: number;
    /** 合计出勤 */
    standardLoborSum: number;
    /** 成本 */
    cost: number;
    id: number;

    constructor(data?: ILaborcostYearPlanListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.companyId = _data["companyId"];
            this.company = _data["company"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"];
            this.peopleNum = _data["peopleNum"];
            this.standardLobor = _data["standardLobor"];
            this.qtNum = _data["qtNum"];
            this.leaveNum = _data["leaveNum"];
            this.standardLoborSum = _data["standardLoborSum"];
            this.cost = _data["cost"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaborcostYearPlanListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaborcostYearPlanListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department;
        data["peopleNum"] = this.peopleNum;
        data["standardLobor"] = this.standardLobor;
        data["qtNum"] = this.qtNum;
        data["leaveNum"] = this.leaveNum;
        data["standardLoborSum"] = this.standardLoborSum;
        data["cost"] = this.cost;
        data["id"] = this.id;
        return data;
    }

    clone(): LaborcostYearPlanListDto {
        const json = this.toJSON();
        let result = new LaborcostYearPlanListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Laborcost.LaborcostYearPlan.LaborcostYearPlan */
export interface ILaborcostYearPlanListDto {
    /** 年 */
    year: number;
    /** 月 */
    month: number;
    /** 公司 */
    companyId: number;
    company: string | undefined;
    /** 部门 */
    departmentId: number;
    department: string | undefined;
    /** 人数 */
    peopleNum: number;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 请假时数 */
    leaveNum: number;
    /** 合计出勤 */
    standardLoborSum: number;
    /** 成本 */
    cost: number;
    id: number;
}

/** 的列表DTO QYB.QYBProduct.Laborcost.LaborcostYearPlan.LaborcostYearPlan */
export class LaborcostYearPlanEditDto implements ILaborcostYearPlanEditDto {
    /** Id */
    id: number | undefined;
    /** 年 */
    year: number;
    /** 月 */
    month: number;
    /** 公司 */
    companyId: number;
    /** 部门 */
    departmentId: number;
    /** 人数 */
    peopleNum: number;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 请假时数 */
    leaveNum: number;
    /** 成本 */
    cost: number;

    constructor(data?: ILaborcostYearPlanEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.peopleNum = _data["peopleNum"];
            this.standardLobor = _data["standardLobor"];
            this.qtNum = _data["qtNum"];
            this.leaveNum = _data["leaveNum"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): LaborcostYearPlanEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaborcostYearPlanEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["month"] = this.month;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["peopleNum"] = this.peopleNum;
        data["standardLobor"] = this.standardLobor;
        data["qtNum"] = this.qtNum;
        data["leaveNum"] = this.leaveNum;
        data["cost"] = this.cost;
        return data;
    }

    clone(): LaborcostYearPlanEditDto {
        const json = this.toJSON();
        let result = new LaborcostYearPlanEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Laborcost.LaborcostYearPlan.LaborcostYearPlan */
export interface ILaborcostYearPlanEditDto {
    /** Id */
    id: number | undefined;
    /** 年 */
    year: number;
    /** 月 */
    month: number;
    /** 公司 */
    companyId: number;
    /** 部门 */
    departmentId: number;
    /** 人数 */
    peopleNum: number;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 请假时数 */
    leaveNum: number;
    /** 成本 */
    cost: number;
}

/** 读取可编辑的Dto */
export class GetLaborcostYearPlanForEditOutput implements IGetLaborcostYearPlanForEditOutput {
    laborcostYearPlan: LaborcostYearPlanEditDto;

    constructor(data?: IGetLaborcostYearPlanForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laborcostYearPlan = _data["laborcostYearPlan"] ? LaborcostYearPlanEditDto.fromJS(_data["laborcostYearPlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLaborcostYearPlanForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaborcostYearPlanForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laborcostYearPlan"] = this.laborcostYearPlan ? this.laborcostYearPlan.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetLaborcostYearPlanForEditOutput {
        const json = this.toJSON();
        let result = new GetLaborcostYearPlanForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetLaborcostYearPlanForEditOutput {
    laborcostYearPlan: LaborcostYearPlanEditDto;
}

export class MonthLCRateData implements IMonthLCRateData {
    /** 类型 1：人数2：出勤3：加班4：请假5：成本 */
    type: number;
    /** 实际值 */
    actualNumber: number;
    /** 月度计划数值 */
    monthPlanNumber: number;
    /** 月度差异率 */
    monthRate: number;
    /** 年度计划数值 */
    yearPlanNumber: number;
    /** 年度差异率 */
    yearRate: number;

    constructor(data?: IMonthLCRateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.actualNumber = _data["actualNumber"];
            this.monthPlanNumber = _data["monthPlanNumber"];
            this.monthRate = _data["monthRate"];
            this.yearPlanNumber = _data["yearPlanNumber"];
            this.yearRate = _data["yearRate"];
        }
    }

    static fromJS(data: any): MonthLCRateData {
        data = typeof data === 'object' ? data : {};
        let result = new MonthLCRateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["actualNumber"] = this.actualNumber;
        data["monthPlanNumber"] = this.monthPlanNumber;
        data["monthRate"] = this.monthRate;
        data["yearPlanNumber"] = this.yearPlanNumber;
        data["yearRate"] = this.yearRate;
        return data;
    }

    clone(): MonthLCRateData {
        const json = this.toJSON();
        let result = new MonthLCRateData();
        result.init(json);
        return result;
    }
}

export interface IMonthLCRateData {
    /** 类型 1：人数2：出勤3：加班4：请假5：成本 */
    type: number;
    /** 实际值 */
    actualNumber: number;
    /** 月度计划数值 */
    monthPlanNumber: number;
    /** 月度差异率 */
    monthRate: number;
    /** 年度计划数值 */
    yearPlanNumber: number;
    /** 年度差异率 */
    yearRate: number;
}

export class GetMonthLCRateDto implements IGetMonthLCRateDto {
    /** 月 */
    month: number;
    /** 年月 */
    yearMonth: string | undefined;
    /** 数据 */
    monthLCRateData: MonthLCRateData[] | undefined;

    constructor(data?: IGetMonthLCRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.yearMonth = _data["yearMonth"];
            if (Array.isArray(_data["monthLCRateData"])) {
                this.monthLCRateData = [] as any;
                for (let item of _data["monthLCRateData"])
                    this.monthLCRateData.push(MonthLCRateData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMonthLCRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthLCRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["yearMonth"] = this.yearMonth;
        if (Array.isArray(this.monthLCRateData)) {
            data["monthLCRateData"] = [];
            for (let item of this.monthLCRateData)
                data["monthLCRateData"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetMonthLCRateDto {
        const json = this.toJSON();
        let result = new GetMonthLCRateDto();
        result.init(json);
        return result;
    }
}

export interface IGetMonthLCRateDto {
    /** 月 */
    month: number;
    /** 年月 */
    yearMonth: string | undefined;
    /** 数据 */
    monthLCRateData: MonthLCRateData[] | undefined;
}

export class GetPagedResult implements IGetPagedResult {
    totalCount: number;
    items: any | undefined;

    constructor(data?: IGetPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.items = _data["items"];
        }
    }

    static fromJS(data: any): GetPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["items"] = this.items;
        return data;
    }

    clone(): GetPagedResult {
        const json = this.toJSON();
        let result = new GetPagedResult();
        result.init(json);
        return result;
    }
}

export interface IGetPagedResult {
    totalCount: number;
    items: any | undefined;
}

export class LanguageEditDto implements ILanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;

    constructor(data?: ILanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): LanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): LanguageEditDto {
        const json = this.toJSON();
        let result = new LanguageEditDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: LanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new LanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? LanguageEditDto.fromJS(_data["language"]) : new LanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateLanguageInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateLanguageInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: LanguageEditDto;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }

    clone(): ComboboxItemDto {
        const json = this.toJSON();
        let result = new ComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: LanguageEditDto;
    /** 所有的语言名称 */
    languageNames: ComboboxItemDto[] | undefined;
    /** 所有的国旗 */
    flags: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? LanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLanguageForEditOutput {
        const json = this.toJSON();
        let result = new GetLanguageForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLanguageForEditOutput {
    language: LanguageEditDto;
    /** 所有的语言名称 */
    languageNames: ComboboxItemDto[] | undefined;
    /** 所有的国旗 */
    flags: ComboboxItemDto[] | undefined;
}

export class LanguageListDto implements ILanguageListDto {
    tenantId: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 显示名称 */
    displayName: string | undefined;
    /** 图标 */
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ILanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): LanguageListDto {
        const json = this.toJSON();
        let result = new LanguageListDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageListDto {
    tenantId: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 显示名称 */
    displayName: string | undefined;
    /** 图标 */
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    /** 默认语言名称 */
    defaultLanguageName: string | undefined;
    items: LanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLanguagesOutput {
        const json = this.toJSON();
        let result = new GetLanguagesOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLanguagesOutput {
    /** 默认语言名称 */
    defaultLanguageName: string | undefined;
    items: LanguageListDto[] | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    /** 键 */
    key: string | undefined;
    /** 原始值 */
    baseValue: string | undefined;
    /** 目标值 */
    targetValue: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }

    clone(): LanguageTextListDto {
        const json = this.toJSON();
        let result = new LanguageTextListDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageTextListDto {
    /** 键 */
    key: string | undefined;
    /** 原始值 */
    baseValue: string | undefined;
    /** 目标值 */
    targetValue: string | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLanguageTextListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): SetDefaultLanguageInput {
        const json = this.toJSON();
        let result = new SetDefaultLanguageInput();
        result.init(json);
        return result;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

/** 更新语言输入信息 */
export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    /** 键 */
    key: string;
    /** 值 */
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): UpdateLanguageTextInput {
        const json = this.toJSON();
        let result = new UpdateLanguageTextInput();
        result.init(json);
        return result;
    }
}

/** 更新语言输入信息 */
export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    /** 键 */
    key: string;
    /** 值 */
    value: string;
}

export class LayoutLevelEditDto implements ILayoutLevelEditDto {
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 层级等级（倒序 0：最上层） */
    levelIndex: number;
    /** 消息间隔时间 */
    msgInterval: number;
    /** 备注 */
    remark: string | undefined;
    /** 是否在看板显示 */
    isKanBanShow: boolean;
    /** 超时天数 */
    timeoutDays: number;

    constructor(data?: ILayoutLevelEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.levelIndex = _data["levelIndex"];
            this.msgInterval = _data["msgInterval"];
            this.remark = _data["remark"];
            this.isKanBanShow = _data["isKanBanShow"];
            this.timeoutDays = _data["timeoutDays"];
        }
    }

    static fromJS(data: any): LayoutLevelEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutLevelEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["levelIndex"] = this.levelIndex;
        data["msgInterval"] = this.msgInterval;
        data["remark"] = this.remark;
        data["isKanBanShow"] = this.isKanBanShow;
        data["timeoutDays"] = this.timeoutDays;
        return data;
    }

    clone(): LayoutLevelEditDto {
        const json = this.toJSON();
        let result = new LayoutLevelEditDto();
        result.init(json);
        return result;
    }
}

export interface ILayoutLevelEditDto {
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 层级等级（倒序 0：最上层） */
    levelIndex: number;
    /** 消息间隔时间 */
    msgInterval: number;
    /** 备注 */
    remark: string | undefined;
    /** 是否在看板显示 */
    isKanBanShow: boolean;
    /** 超时天数 */
    timeoutDays: number;
}

export class CreatOrUpdataLayoutLevelInput implements ICreatOrUpdataLayoutLevelInput {
    layoutLevelEditDto: LayoutLevelEditDto;

    constructor(data?: ICreatOrUpdataLayoutLevelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layoutLevelEditDto = new LayoutLevelEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutLevelEditDto = _data["layoutLevelEditDto"] ? LayoutLevelEditDto.fromJS(_data["layoutLevelEditDto"]) : new LayoutLevelEditDto();
        }
    }

    static fromJS(data: any): CreatOrUpdataLayoutLevelInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataLayoutLevelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutLevelEditDto"] = this.layoutLevelEditDto ? this.layoutLevelEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdataLayoutLevelInput {
        const json = this.toJSON();
        let result = new CreatOrUpdataLayoutLevelInput();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdataLayoutLevelInput {
    layoutLevelEditDto: LayoutLevelEditDto;
}

export class LayoutLevel implements ILayoutLevel {
    name: string | undefined;
    levelIndex: number;
    msgInterval: number;
    remark: string | undefined;
    isKanBanShow: boolean;
    timeoutDays: number;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    scenesId: number | undefined;
    id: number;

    constructor(data?: ILayoutLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.levelIndex = _data["levelIndex"];
            this.msgInterval = _data["msgInterval"];
            this.remark = _data["remark"];
            this.isKanBanShow = _data["isKanBanShow"];
            this.timeoutDays = _data["timeoutDays"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.scenesId = _data["scenesId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LayoutLevel {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["levelIndex"] = this.levelIndex;
        data["msgInterval"] = this.msgInterval;
        data["remark"] = this.remark;
        data["isKanBanShow"] = this.isKanBanShow;
        data["timeoutDays"] = this.timeoutDays;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["scenesId"] = this.scenesId;
        data["id"] = this.id;
        return data;
    }

    clone(): LayoutLevel {
        const json = this.toJSON();
        let result = new LayoutLevel();
        result.init(json);
        return result;
    }
}

export interface ILayoutLevel {
    name: string | undefined;
    levelIndex: number;
    msgInterval: number;
    remark: string | undefined;
    isKanBanShow: boolean;
    timeoutDays: number;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    scenesId: number | undefined;
    id: number;
}

export class PagedResultDtoOfLayoutLevel implements IPagedResultDtoOfLayoutLevel {
    totalCount: number;
    items: LayoutLevel[] | undefined;

    constructor(data?: IPagedResultDtoOfLayoutLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LayoutLevel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLayoutLevel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLayoutLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLayoutLevel {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLayoutLevel();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLayoutLevel {
    totalCount: number;
    items: LayoutLevel[] | undefined;
}

export class LayoutOrgEditDto implements ILayoutOrgEditDto {
    id: number | undefined;
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 匿名可见 */
    anonymousVisible: boolean;

    constructor(data?: ILayoutOrgEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pId = _data["pId"];
            this.leveIndex = _data["leveIndex"];
            this.remark = _data["remark"];
            this.statisticsOrg = _data["statisticsOrg"];
            this.anonymousVisible = _data["anonymousVisible"];
        }
    }

    static fromJS(data: any): LayoutOrgEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutOrgEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pId"] = this.pId;
        data["leveIndex"] = this.leveIndex;
        data["remark"] = this.remark;
        data["statisticsOrg"] = this.statisticsOrg;
        data["anonymousVisible"] = this.anonymousVisible;
        return data;
    }

    clone(): LayoutOrgEditDto {
        const json = this.toJSON();
        let result = new LayoutOrgEditDto();
        result.init(json);
        return result;
    }
}

export interface ILayoutOrgEditDto {
    id: number | undefined;
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 匿名可见 */
    anonymousVisible: boolean;
}

/** 创建实体Dto */
export class CreatOrUpdataLayoutOrgInput implements ICreatOrUpdataLayoutOrgInput {
    layoutOrgEditDto: LayoutOrgEditDto;

    constructor(data?: ICreatOrUpdataLayoutOrgInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layoutOrgEditDto = new LayoutOrgEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutOrgEditDto = _data["layoutOrgEditDto"] ? LayoutOrgEditDto.fromJS(_data["layoutOrgEditDto"]) : new LayoutOrgEditDto();
        }
    }

    static fromJS(data: any): CreatOrUpdataLayoutOrgInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataLayoutOrgInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutOrgEditDto"] = this.layoutOrgEditDto ? this.layoutOrgEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdataLayoutOrgInput {
        const json = this.toJSON();
        let result = new CreatOrUpdataLayoutOrgInput();
        result.init(json);
        return result;
    }
}

/** 创建实体Dto */
export interface ICreatOrUpdataLayoutOrgInput {
    layoutOrgEditDto: LayoutOrgEditDto;
}

export class PagedResultDtoOfLayoutOrgListDto implements IPagedResultDtoOfLayoutOrgListDto {
    totalCount: number;
    items: LayoutOrgListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLayoutOrgListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LayoutOrgListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLayoutOrgListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLayoutOrgListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLayoutOrgListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLayoutOrgListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLayoutOrgListDto {
    totalCount: number;
    items: LayoutOrgListDto[] | undefined;
}

export class LayoutUserEditDto implements ILayoutUserEditDto {
    id: number | undefined;
    /** 系统用户 */
    userId: number;
    /** 可为责任人 */
    isResponsible: boolean;
    /** 可为审核人 */
    isAuditor: boolean;
    /** LPA组织架构 */
    orgId: number;
    /** 默认审核方案 */
    auditTemplateId: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 关键岗位 */
    isKeyPositions: boolean;
    /** 月度隐患数量指标 */
    monthlyIssueIndicators: number;

    constructor(data?: ILayoutUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.isResponsible = _data["isResponsible"];
            this.isAuditor = _data["isAuditor"];
            this.orgId = _data["orgId"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.remark = _data["remark"];
            this.statisticsOrg = _data["statisticsOrg"];
            this.isKeyPositions = _data["isKeyPositions"];
            this.monthlyIssueIndicators = _data["monthlyIssueIndicators"];
        }
    }

    static fromJS(data: any): LayoutUserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["isResponsible"] = this.isResponsible;
        data["isAuditor"] = this.isAuditor;
        data["orgId"] = this.orgId;
        data["auditTemplateId"] = this.auditTemplateId;
        data["remark"] = this.remark;
        data["statisticsOrg"] = this.statisticsOrg;
        data["isKeyPositions"] = this.isKeyPositions;
        data["monthlyIssueIndicators"] = this.monthlyIssueIndicators;
        return data;
    }

    clone(): LayoutUserEditDto {
        const json = this.toJSON();
        let result = new LayoutUserEditDto();
        result.init(json);
        return result;
    }
}

export interface ILayoutUserEditDto {
    id: number | undefined;
    /** 系统用户 */
    userId: number;
    /** 可为责任人 */
    isResponsible: boolean;
    /** 可为审核人 */
    isAuditor: boolean;
    /** LPA组织架构 */
    orgId: number;
    /** 默认审核方案 */
    auditTemplateId: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 关键岗位 */
    isKeyPositions: boolean;
    /** 月度隐患数量指标 */
    monthlyIssueIndicators: number;
}

export class CreatOrUpdataLayoutUserInput implements ICreatOrUpdataLayoutUserInput {
    layoutUserEditDto: LayoutUserEditDto;

    constructor(data?: ICreatOrUpdataLayoutUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.layoutUserEditDto = new LayoutUserEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutUserEditDto = _data["layoutUserEditDto"] ? LayoutUserEditDto.fromJS(_data["layoutUserEditDto"]) : new LayoutUserEditDto();
        }
    }

    static fromJS(data: any): CreatOrUpdataLayoutUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdataLayoutUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutUserEditDto"] = this.layoutUserEditDto ? this.layoutUserEditDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreatOrUpdataLayoutUserInput {
        const json = this.toJSON();
        let result = new CreatOrUpdataLayoutUserInput();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdataLayoutUserInput {
    layoutUserEditDto: LayoutUserEditDto;
}

export class PagedResultDtoOfLayoutUserListDto implements IPagedResultDtoOfLayoutUserListDto {
    totalCount: number;
    items: LayoutUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLayoutUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LayoutUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLayoutUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLayoutUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLayoutUserListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLayoutUserListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLayoutUserListDto {
    totalCount: number;
    items: LayoutUserListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Attendance.LeaveRecord.LeaveRecord */
export class LeaveRecordEditDto implements ILeaveRecordEditDto {
    /** Id */
    id: number | undefined;
    empId: number;
    /** FromGuid */
    fromGuid: string | undefined;
    /** LeaveType */
    leaveType: string | undefined;
    /** HolidayDate */
    holidayDate: moment.Moment;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** LeaveNums */
    leaveNums: number;
    /** LeaveUnit */
    leaveUnit: string | undefined;
    /** SubmitDate */
    submitDate: moment.Moment;
    /** Reason */
    reason: string | undefined;

    constructor(data?: ILeaveRecordEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.fromGuid = _data["fromGuid"];
            this.leaveType = _data["leaveType"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.leaveNums = _data["leaveNums"];
            this.leaveUnit = _data["leaveUnit"];
            this.submitDate = _data["submitDate"] ? moment(_data["submitDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): LeaveRecordEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveRecordEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["fromGuid"] = this.fromGuid;
        data["leaveType"] = this.leaveType;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["leaveNums"] = this.leaveNums;
        data["leaveUnit"] = this.leaveUnit;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }

    clone(): LeaveRecordEditDto {
        const json = this.toJSON();
        let result = new LeaveRecordEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.LeaveRecord.LeaveRecord */
export interface ILeaveRecordEditDto {
    /** Id */
    id: number | undefined;
    empId: number;
    /** FromGuid */
    fromGuid: string | undefined;
    /** LeaveType */
    leaveType: string | undefined;
    /** HolidayDate */
    holidayDate: moment.Moment;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** LeaveNums */
    leaveNums: number;
    /** LeaveUnit */
    leaveUnit: string | undefined;
    /** SubmitDate */
    submitDate: moment.Moment;
    /** Reason */
    reason: string | undefined;
}

export class CreateOrUpdateLeaveRecordInput implements ICreateOrUpdateLeaveRecordInput {
    leaveRecord: LeaveRecordEditDto;

    constructor(data?: ICreateOrUpdateLeaveRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.leaveRecord = new LeaveRecordEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRecord = _data["leaveRecord"] ? LeaveRecordEditDto.fromJS(_data["leaveRecord"]) : new LeaveRecordEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLeaveRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLeaveRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRecord"] = this.leaveRecord ? this.leaveRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateLeaveRecordInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateLeaveRecordInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateLeaveRecordInput {
    leaveRecord: LeaveRecordEditDto;
}

/** 的列表DTO QYB.QYBProduct.Attendance.LeaveRecord.LeaveRecord */
export class LeaveRecordListDto implements ILeaveRecordListDto {
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** LeaveType */
    leaveType: string | undefined;
    /** HolidayDate */
    holidayDate: moment.Moment;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** LeaveNums */
    leaveNums: number;
    /** LeaveUnit */
    leaveUnit: string | undefined;
    /** SubmitDate */
    submitDate: moment.Moment;
    /** Reason */
    reason: string | undefined;
    unitType: string | undefined;
    id: number;

    constructor(data?: ILeaveRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.fromGuid = _data["fromGuid"];
            this.leaveType = _data["leaveType"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.leaveNums = _data["leaveNums"];
            this.leaveUnit = _data["leaveUnit"];
            this.submitDate = _data["submitDate"] ? moment(_data["submitDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.unitType = _data["unitType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["fromGuid"] = this.fromGuid;
        data["leaveType"] = this.leaveType;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["leaveNums"] = this.leaveNums;
        data["leaveUnit"] = this.leaveUnit;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["unitType"] = this.unitType;
        data["id"] = this.id;
        return data;
    }

    clone(): LeaveRecordListDto {
        const json = this.toJSON();
        let result = new LeaveRecordListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.LeaveRecord.LeaveRecord */
export interface ILeaveRecordListDto {
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** LeaveType */
    leaveType: string | undefined;
    /** HolidayDate */
    holidayDate: moment.Moment;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** LeaveNums */
    leaveNums: number;
    /** LeaveUnit */
    leaveUnit: string | undefined;
    /** SubmitDate */
    submitDate: moment.Moment;
    /** Reason */
    reason: string | undefined;
    unitType: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetLeaveRecordForEditOutput implements IGetLeaveRecordForEditOutput {
    leaveRecord: LeaveRecordEditDto;

    constructor(data?: IGetLeaveRecordForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRecord = _data["leaveRecord"] ? LeaveRecordEditDto.fromJS(_data["leaveRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLeaveRecordForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRecordForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRecord"] = this.leaveRecord ? this.leaveRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetLeaveRecordForEditOutput {
        const json = this.toJSON();
        let result = new GetLeaveRecordForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetLeaveRecordForEditOutput {
    leaveRecord: LeaveRecordEditDto;
}

export class GetHolidayLimit implements IGetHolidayLimit {
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 单位（小时/天） */
    unitType: string | undefined;
    /** 剩余额度 */
    quotaValue: number;
    /** 剩余额度信息描述 */
    quotaValueDescribe: string | undefined;
    /** 描述 */
    describe: string | undefined;

    constructor(data?: IGetHolidayLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.unitType = _data["unitType"];
            this.quotaValue = _data["quotaValue"];
            this.quotaValueDescribe = _data["quotaValueDescribe"];
            this.describe = _data["describe"];
        }
    }

    static fromJS(data: any): GetHolidayLimit {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidayLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["unitType"] = this.unitType;
        data["quotaValue"] = this.quotaValue;
        data["quotaValueDescribe"] = this.quotaValueDescribe;
        data["describe"] = this.describe;
        return data;
    }

    clone(): GetHolidayLimit {
        const json = this.toJSON();
        let result = new GetHolidayLimit();
        result.init(json);
        return result;
    }
}

export interface IGetHolidayLimit {
    /** 名称 */
    name: string | undefined;
    /** 编码 */
    code: string | undefined;
    /** 单位（小时/天） */
    unitType: string | undefined;
    /** 剩余额度 */
    quotaValue: number;
    /** 剩余额度信息描述 */
    quotaValueDescribe: string | undefined;
    /** 描述 */
    describe: string | undefined;
}

export class HolidayLimitDto implements IHolidayLimitDto {
    /** 用户主键 */
    userId: number;
    /** 标准额度 */
    normalQuota: number | undefined;
    /** 实际额度 */
    realQuota: number | undefined;
    /** 单位 */
    quotaUnit: string | undefined;
    /** 假期类型 */
    holidayType: string | undefined;

    constructor(data?: IHolidayLimitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.normalQuota = _data["normalQuota"];
            this.realQuota = _data["realQuota"];
            this.quotaUnit = _data["quotaUnit"];
            this.holidayType = _data["holidayType"];
        }
    }

    static fromJS(data: any): HolidayLimitDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayLimitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["normalQuota"] = this.normalQuota;
        data["realQuota"] = this.realQuota;
        data["quotaUnit"] = this.quotaUnit;
        data["holidayType"] = this.holidayType;
        return data;
    }

    clone(): HolidayLimitDto {
        const json = this.toJSON();
        let result = new HolidayLimitDto();
        result.init(json);
        return result;
    }
}

export interface IHolidayLimitDto {
    /** 用户主键 */
    userId: number;
    /** 标准额度 */
    normalQuota: number | undefined;
    /** 实际额度 */
    realQuota: number | undefined;
    /** 单位 */
    quotaUnit: string | undefined;
    /** 假期类型 */
    holidayType: string | undefined;
}

export class HolidayLimit implements IHolidayLimit {
    empId: number;
    holidayType: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    delayDate: moment.Moment | undefined;
    quotaUnit: string | undefined;
    normalQuota: number | undefined;
    realQuota: number | undefined;
    manualUpdate: number | undefined;
    lockingQuota: number | undefined;
    usedQuota: number | undefined;
    usedNums: number | undefined;
    enable: boolean | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: IHolidayLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.holidayType = _data["holidayType"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.delayDate = _data["delayDate"] ? moment(_data["delayDate"].toString()) : <any>undefined;
            this.quotaUnit = _data["quotaUnit"];
            this.normalQuota = _data["normalQuota"];
            this.realQuota = _data["realQuota"];
            this.manualUpdate = _data["manualUpdate"];
            this.lockingQuota = _data["lockingQuota"];
            this.usedQuota = _data["usedQuota"];
            this.usedNums = _data["usedNums"];
            this.enable = _data["enable"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HolidayLimit {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["holidayType"] = this.holidayType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["delayDate"] = this.delayDate ? this.delayDate.toISOString() : <any>undefined;
        data["quotaUnit"] = this.quotaUnit;
        data["normalQuota"] = this.normalQuota;
        data["realQuota"] = this.realQuota;
        data["manualUpdate"] = this.manualUpdate;
        data["lockingQuota"] = this.lockingQuota;
        data["usedQuota"] = this.usedQuota;
        data["usedNums"] = this.usedNums;
        data["enable"] = this.enable;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): HolidayLimit {
        const json = this.toJSON();
        let result = new HolidayLimit();
        result.init(json);
        return result;
    }
}

export interface IHolidayLimit {
    empId: number;
    holidayType: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    delayDate: moment.Moment | undefined;
    quotaUnit: string | undefined;
    normalQuota: number | undefined;
    realQuota: number | undefined;
    manualUpdate: number | undefined;
    lockingQuota: number | undefined;
    usedQuota: number | undefined;
    usedNums: number | undefined;
    enable: boolean | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

export class PagedResultDtoOfLeaveRecordListDto implements IPagedResultDtoOfLeaveRecordListDto {
    totalCount: number;
    items: LeaveRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLeaveRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LeaveRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeaveRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeaveRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLeaveRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLeaveRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLeaveRecordListDto {
    totalCount: number;
    items: LeaveRecordListDto[] | undefined;
}

export class MailTemplateEditDto implements IMailTemplateEditDto {
    /** Id */
    id: number | undefined;
    /** 模板编码 */
    code: string | undefined;
    /** 模板名称 */
    name: string | undefined;
    /** 模板内容 */
    content: string | undefined;
    /** 输入表头 */
    inputThead: string | undefined;
    /** 输入表内容 */
    inputTbody: string | undefined;
    /** 格式化之后表头 */
    formatThead: string | undefined;
    /** 格式化之后标内容 */
    formatTbody: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 邮件标题配置 */
    title: string | undefined;

    constructor(data?: IMailTemplateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.inputThead = _data["inputThead"];
            this.inputTbody = _data["inputTbody"];
            this.formatThead = _data["formatThead"];
            this.formatTbody = _data["formatTbody"];
            this.enable = _data["enable"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MailTemplateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["content"] = this.content;
        data["inputThead"] = this.inputThead;
        data["inputTbody"] = this.inputTbody;
        data["formatThead"] = this.formatThead;
        data["formatTbody"] = this.formatTbody;
        data["enable"] = this.enable;
        data["title"] = this.title;
        return data;
    }

    clone(): MailTemplateEditDto {
        const json = this.toJSON();
        let result = new MailTemplateEditDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateEditDto {
    /** Id */
    id: number | undefined;
    /** 模板编码 */
    code: string | undefined;
    /** 模板名称 */
    name: string | undefined;
    /** 模板内容 */
    content: string | undefined;
    /** 输入表头 */
    inputThead: string | undefined;
    /** 输入表内容 */
    inputTbody: string | undefined;
    /** 格式化之后表头 */
    formatThead: string | undefined;
    /** 格式化之后标内容 */
    formatTbody: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 邮件标题配置 */
    title: string | undefined;
}

export class CreateOrUpdateMailTemplateInput implements ICreateOrUpdateMailTemplateInput {
    mailTemplate: MailTemplateEditDto;

    constructor(data?: ICreateOrUpdateMailTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mailTemplate = new MailTemplateEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplate = _data["mailTemplate"] ? MailTemplateEditDto.fromJS(_data["mailTemplate"]) : new MailTemplateEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateMailTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMailTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplate"] = this.mailTemplate ? this.mailTemplate.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateMailTemplateInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateMailTemplateInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateMailTemplateInput {
    mailTemplate: MailTemplateEditDto;
}

export class MailTemplateListDto implements IMailTemplateListDto {
    /** Id */
    id: number;
    /** 模板编码 */
    code: string | undefined;
    /** 模板名称 */
    name: string | undefined;
    /** 模板内容 */
    content: string | undefined;
    /** 输入表头 */
    inputThead: string | undefined;
    /** 输入表内容 */
    inputTbody: string | undefined;
    /** 格式化之后表头 */
    formatThead: string | undefined;
    /** 格式化之后标内容 */
    formatTbody: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 邮件标题配置 */
    title: string | undefined;

    constructor(data?: IMailTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.inputThead = _data["inputThead"];
            this.inputTbody = _data["inputTbody"];
            this.formatThead = _data["formatThead"];
            this.formatTbody = _data["formatTbody"];
            this.enable = _data["enable"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MailTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["content"] = this.content;
        data["inputThead"] = this.inputThead;
        data["inputTbody"] = this.inputTbody;
        data["formatThead"] = this.formatThead;
        data["formatTbody"] = this.formatTbody;
        data["enable"] = this.enable;
        data["title"] = this.title;
        return data;
    }

    clone(): MailTemplateListDto {
        const json = this.toJSON();
        let result = new MailTemplateListDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateListDto {
    /** Id */
    id: number;
    /** 模板编码 */
    code: string | undefined;
    /** 模板名称 */
    name: string | undefined;
    /** 模板内容 */
    content: string | undefined;
    /** 输入表头 */
    inputThead: string | undefined;
    /** 输入表内容 */
    inputTbody: string | undefined;
    /** 格式化之后表头 */
    formatThead: string | undefined;
    /** 格式化之后标内容 */
    formatTbody: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 邮件标题配置 */
    title: string | undefined;
}

export class PagedResultDtoOfMailTemplateListDto implements IPagedResultDtoOfMailTemplateListDto {
    totalCount: number;
    items: MailTemplateListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMailTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MailTemplateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfMailTemplateListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfMailTemplateListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfMailTemplateListDto {
    totalCount: number;
    items: MailTemplateListDto[] | undefined;
}

/** 全局配置Dto */
export class GlobalConfigurationDto implements IGlobalConfigurationDto {
    /** 邮箱str */
    emailStr: string | undefined;

    constructor(data?: IGlobalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailStr = _data["emailStr"];
        }
    }

    static fromJS(data: any): GlobalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailStr"] = this.emailStr;
        return data;
    }

    clone(): GlobalConfigurationDto {
        const json = this.toJSON();
        let result = new GlobalConfigurationDto();
        result.init(json);
        return result;
    }
}

/** 全局配置Dto */
export interface IGlobalConfigurationDto {
    /** 邮箱str */
    emailStr: string | undefined;
}

export class Issue implements IIssue {
    sourceType: string | undefined;
    issueTypeId: number | undefined;
    issueProgress: number;
    description: string | undefined;
    discovererId: number;
    discoveryTime: moment.Moment;
    respId: number | undefined;
    auditTaskId: number | undefined;
    auditPointId: number | undefined;
    auditItemId: number | undefined;
    planStart: moment.Moment | undefined;
    planEnd: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    closeTime: moment.Moment | undefined;
    discoveryPicture: string | undefined;
    improvePicture: string | undefined;
    video: string | undefined;
    improveNote: string | undefined;
    correctiveNote: string | undefined;
    correctiveNoteTime: moment.Moment | undefined;
    issueReason: string | undefined;
    remark: string | undefined;
    isOtherSystemSubmit: boolean;
    issueStatus: string | undefined;
    statusReason: string | undefined;
    submitterJobID: string | undefined;
    submitterName: string | undefined;
    submitterDeptId: number | undefined;
    submitterDept: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    scenesId: number | undefined;
    excludeFromStatistics: boolean;
    id: number;

    constructor(data?: IIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
            this.issueTypeId = _data["issueTypeId"];
            this.issueProgress = _data["issueProgress"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respId = _data["respId"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.video = _data["video"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.correctiveNoteTime = _data["correctiveNoteTime"] ? moment(_data["correctiveNoteTime"].toString()) : <any>undefined;
            this.issueReason = _data["issueReason"];
            this.remark = _data["remark"];
            this.isOtherSystemSubmit = _data["isOtherSystemSubmit"];
            this.issueStatus = _data["issueStatus"];
            this.statusReason = _data["statusReason"];
            this.submitterJobID = _data["submitterJobID"];
            this.submitterName = _data["submitterName"];
            this.submitterDeptId = _data["submitterDeptId"];
            this.submitterDept = _data["submitterDept"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.scenesId = _data["scenesId"];
            this.excludeFromStatistics = _data["excludeFromStatistics"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Issue {
        data = typeof data === 'object' ? data : {};
        let result = new Issue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["issueTypeId"] = this.issueTypeId;
        data["issueProgress"] = this.issueProgress;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respId"] = this.respId;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["video"] = this.video;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["correctiveNoteTime"] = this.correctiveNoteTime ? this.correctiveNoteTime.toISOString() : <any>undefined;
        data["issueReason"] = this.issueReason;
        data["remark"] = this.remark;
        data["isOtherSystemSubmit"] = this.isOtherSystemSubmit;
        data["issueStatus"] = this.issueStatus;
        data["statusReason"] = this.statusReason;
        data["submitterJobID"] = this.submitterJobID;
        data["submitterName"] = this.submitterName;
        data["submitterDeptId"] = this.submitterDeptId;
        data["submitterDept"] = this.submitterDept;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["scenesId"] = this.scenesId;
        data["excludeFromStatistics"] = this.excludeFromStatistics;
        data["id"] = this.id;
        return data;
    }

    clone(): Issue {
        const json = this.toJSON();
        let result = new Issue();
        result.init(json);
        return result;
    }
}

export interface IIssue {
    sourceType: string | undefined;
    issueTypeId: number | undefined;
    issueProgress: number;
    description: string | undefined;
    discovererId: number;
    discoveryTime: moment.Moment;
    respId: number | undefined;
    auditTaskId: number | undefined;
    auditPointId: number | undefined;
    auditItemId: number | undefined;
    planStart: moment.Moment | undefined;
    planEnd: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    closeTime: moment.Moment | undefined;
    discoveryPicture: string | undefined;
    improvePicture: string | undefined;
    video: string | undefined;
    improveNote: string | undefined;
    correctiveNote: string | undefined;
    correctiveNoteTime: moment.Moment | undefined;
    issueReason: string | undefined;
    remark: string | undefined;
    isOtherSystemSubmit: boolean;
    issueStatus: string | undefined;
    statusReason: string | undefined;
    submitterJobID: string | undefined;
    submitterName: string | undefined;
    submitterDeptId: number | undefined;
    submitterDept: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    scenesId: number | undefined;
    excludeFromStatistics: boolean;
    id: number;
}

/** 问题转办 */
export class IssueTurnToListDto implements IIssueTurnToListDto {
    /** Id */
    id: number;
    /** 问题Id */
    issueId: number;
    /** 转办人 */
    fromUserId: number;
    /** 转办人名字 */
    fromUserName: string | undefined;
    /** 代办人 */
    toUserId: number;
    /** 代办人 */
    toUserName: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人名称 */
    respName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceTypeName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称 */
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeListName: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgressName: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项概述 */
    auditItemName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;

    constructor(data?: IIssueTurnToListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueId = _data["issueId"];
            this.fromUserId = _data["fromUserId"];
            this.fromUserName = _data["fromUserName"];
            this.toUserId = _data["toUserId"];
            this.toUserName = _data["toUserName"];
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.description = _data["description"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeName = _data["sourceTypeName"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueTypeName = _data["issueTypeName"];
            if (Array.isArray(_data["issueTypeListName"])) {
                this.issueTypeListName = [] as any;
                for (let item of _data["issueTypeListName"])
                    this.issueTypeListName.push(item);
            }
            this.issueProgress = _data["issueProgress"];
            this.issueProgressName = _data["issueProgressName"];
            this.discovererId = _data["discovererId"];
            this.discovererName = _data["discovererName"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.deviationType = _data["deviationType"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.remark = _data["remark"];
            this.issueReason = _data["issueReason"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
        }
    }

    static fromJS(data: any): IssueTurnToListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTurnToListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueId"] = this.issueId;
        data["fromUserId"] = this.fromUserId;
        data["fromUserName"] = this.fromUserName;
        data["toUserId"] = this.toUserId;
        data["toUserName"] = this.toUserName;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["description"] = this.description;
        data["sourceType"] = this.sourceType;
        data["sourceTypeName"] = this.sourceTypeName;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueTypeName"] = this.issueTypeName;
        if (Array.isArray(this.issueTypeListName)) {
            data["issueTypeListName"] = [];
            for (let item of this.issueTypeListName)
                data["issueTypeListName"].push(item);
        }
        data["issueProgress"] = this.issueProgress;
        data["issueProgressName"] = this.issueProgressName;
        data["discovererId"] = this.discovererId;
        data["discovererName"] = this.discovererName;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["deviationType"] = this.deviationType;
        data["deviationTypeName"] = this.deviationTypeName;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["remark"] = this.remark;
        data["issueReason"] = this.issueReason;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        return data;
    }

    clone(): IssueTurnToListDto {
        const json = this.toJSON();
        let result = new IssueTurnToListDto();
        result.init(json);
        return result;
    }
}

/** 问题转办 */
export interface IIssueTurnToListDto {
    /** Id */
    id: number;
    /** 问题Id */
    issueId: number;
    /** 转办人 */
    fromUserId: number;
    /** 转办人名字 */
    fromUserName: string | undefined;
    /** 代办人 */
    toUserId: number;
    /** 代办人 */
    toUserName: string | undefined;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人名称 */
    respName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceTypeName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    /** 问题类型名称 */
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeListName: number[] | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgressName: string | undefined;
    /** 发现人 */
    discovererId: number;
    /** 发现人 */
    discovererName: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    /** 审核项概述 */
    auditItemName: string | undefined;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 问题原因 */
    issueReason: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 创建用户ID */
    creatorUserId: number | undefined;
    /** 真实路径 */
    realPath: string | undefined;
    /** 临时路径 */
    tempPath: string | undefined;
}

/** 审核记录转办Dto */
export class TaskDetailTurnListDto implements ITaskDetailTurnListDto {
    /** Id */
    id: number;
    /** 转办人 */
    fromUserId: number;
    /** 转办人名字 */
    fromUserName: string | undefined;
    /** 代办人 */
    toUserId: number;
    /** 代办人 */
    toUserName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 概述 */
    itemName: string | undefined;
    /** 详细描述 */
    itemDescription: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 文件夹 */
    dicPath: string | undefined;
    /** 文件真实名字 */
    realPath: string | undefined;
    /** 文件guid路径 */
    guidPath: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;

    constructor(data?: ITaskDetailTurnListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromUserId = _data["fromUserId"];
            this.fromUserName = _data["fromUserName"];
            this.toUserId = _data["toUserId"];
            this.toUserName = _data["toUserName"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemTypeId = _data["auditItemTypeId"];
            this.auditItemTypeName = _data["auditItemTypeName"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.itemName = _data["itemName"];
            this.itemDescription = _data["itemDescription"];
            this.auditNeedInput = _data["auditNeedInput"];
            this.auditNeedPic = _data["auditNeedPic"];
            this.auditNeedDesc = _data["auditNeedDesc"];
            this.issueNeedPic = _data["issueNeedPic"];
            this.auditItemSN = _data["auditItemSN"];
            this.result = _data["result"];
            this.deviationType = _data["deviationType"];
            this.deviationTypeName = _data["deviationTypeName"];
            this.note = _data["note"];
            this.data = _data["data"];
            this.picture = _data["picture"];
            this.remark = _data["remark"];
            this.auditTime = _data["auditTime"] ? moment(_data["auditTime"].toString()) : <any>undefined;
            this.valueActual = _data["valueActual"];
            this.optionType = _data["optionType"];
            this.valueStandard = _data["valueStandard"];
            this.valueUpperLimit = _data["valueUpperLimit"];
            this.valueLowerLimit = _data["valueLowerLimit"];
            this.score = _data["score"];
            this.dicPath = _data["dicPath"];
            this.realPath = _data["realPath"];
            this.guidPath = _data["guidPath"];
            this.isAllowTransfer = _data["isAllowTransfer"];
            this.inspectorId = _data["inspectorId"];
            this.transferRecipient = _data["transferRecipient"];
            this.transferTime = _data["transferTime"] ? moment(_data["transferTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskDetailTurnListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailTurnListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromUserId"] = this.fromUserId;
        data["fromUserName"] = this.fromUserName;
        data["toUserId"] = this.toUserId;
        data["toUserName"] = this.toUserName;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditItemId"] = this.auditItemId;
        data["auditItemTypeId"] = this.auditItemTypeId;
        data["auditItemTypeName"] = this.auditItemTypeName;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["itemName"] = this.itemName;
        data["itemDescription"] = this.itemDescription;
        data["auditNeedInput"] = this.auditNeedInput;
        data["auditNeedPic"] = this.auditNeedPic;
        data["auditNeedDesc"] = this.auditNeedDesc;
        data["issueNeedPic"] = this.issueNeedPic;
        data["auditItemSN"] = this.auditItemSN;
        data["result"] = this.result;
        data["deviationType"] = this.deviationType;
        data["deviationTypeName"] = this.deviationTypeName;
        data["note"] = this.note;
        data["data"] = this.data;
        data["picture"] = this.picture;
        data["remark"] = this.remark;
        data["auditTime"] = this.auditTime ? this.auditTime.toISOString() : <any>undefined;
        data["valueActual"] = this.valueActual;
        data["optionType"] = this.optionType;
        data["valueStandard"] = this.valueStandard;
        data["valueUpperLimit"] = this.valueUpperLimit;
        data["valueLowerLimit"] = this.valueLowerLimit;
        data["score"] = this.score;
        data["dicPath"] = this.dicPath;
        data["realPath"] = this.realPath;
        data["guidPath"] = this.guidPath;
        data["isAllowTransfer"] = this.isAllowTransfer;
        data["inspectorId"] = this.inspectorId;
        data["transferRecipient"] = this.transferRecipient;
        data["transferTime"] = this.transferTime ? this.transferTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TaskDetailTurnListDto {
        const json = this.toJSON();
        let result = new TaskDetailTurnListDto();
        result.init(json);
        return result;
    }
}

/** 审核记录转办Dto */
export interface ITaskDetailTurnListDto {
    /** Id */
    id: number;
    /** 转办人 */
    fromUserId: number;
    /** 转办人名字 */
    fromUserName: string | undefined;
    /** 代办人 */
    toUserId: number;
    /** 代办人 */
    toUserName: string | undefined;
    /** 审核任务Id */
    auditTaskId: number;
    /** 审核点Id */
    auditPointId: number;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项类型 */
    auditItemTypeId: number;
    /** 审核项类型名称 */
    auditItemTypeName: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 概述 */
    itemName: string | undefined;
    /** 详细描述 */
    itemDescription: string | undefined;
    /** 需要输入数值 */
    auditNeedInput: boolean;
    /** 需要审核时拍照 */
    auditNeedPic: boolean;
    /** 需要审核时输入描述信息 */
    auditNeedDesc: boolean;
    /** 需要发现问题时拍照 */
    issueNeedPic: boolean;
    /** 排序 */
    auditItemSN: number;
    /** 审核结果  Y/N/NA/NC */
    result: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationType: string | undefined;
    /** 不符合项分类  1.严重不符合 2.一般不符合 3.观察项 */
    deviationTypeName: string | undefined;
    /** 审核描述 */
    note: string | undefined;
    /** 录入数据 */
    data: string | undefined;
    /** 审核时照片 */
    picture: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 审核时间 */
    auditTime: moment.Moment | undefined;
    /** 实际值 */
    valueActual: string | undefined;
    /** 选项类型
1.布尔值
2.文本值
3.区间值
4.标准差
5.最大值
6.最小值
7.列表 */
    optionType: string | undefined;
    /** 标准值 */
    valueStandard: string | undefined;
    /** 上限 */
    valueUpperLimit: number | undefined;
    /** 下限 */
    valueLowerLimit: number | undefined;
    /** 分值 */
    score: number;
    /** 文件夹 */
    dicPath: string | undefined;
    /** 文件真实名字 */
    realPath: string | undefined;
    /** 文件guid路径 */
    guidPath: string | undefined;
    /** 是否允许转办 */
    isAllowTransfer: boolean;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 转办接收人 */
    transferRecipient: number | undefined;
    /** 转办时间 */
    transferTime: moment.Moment | undefined;
}

/** 计划转办Dto */
export class TaskTurnListDto implements ITaskTurnListDto {
    /** 审核任务Id */
    auditTaskId: number;
    /** 转办人 */
    fromUserId: number;
    /** 转办人名字 */
    fromUserName: string | undefined;
    /** 代办人 */
    toUserId: number;
    /** 代办人 */
    toUserName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;

    constructor(data?: ITaskTurnListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditTaskId = _data["auditTaskId"];
            this.fromUserId = _data["fromUserId"];
            this.fromUserName = _data["fromUserName"];
            this.toUserId = _data["toUserId"];
            this.toUserName = _data["toUserName"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"];
            this.auditTaskStateName = _data["auditTaskStateName"];
            this.fomartDateTime = _data["fomartDateTime"];
            this.name = _data["name"];
            this.auditTaskCreateId = _data["auditTaskCreateId"];
            this.auditTaskType = _data["auditTaskType"];
            this.auditTaskTypeName = _data["auditTaskTypeName"];
        }
    }

    static fromJS(data: any): TaskTurnListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTurnListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditTaskId"] = this.auditTaskId;
        data["fromUserId"] = this.fromUserId;
        data["fromUserName"] = this.fromUserName;
        data["toUserId"] = this.toUserId;
        data["toUserName"] = this.toUserName;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState;
        data["auditTaskStateName"] = this.auditTaskStateName;
        data["fomartDateTime"] = this.fomartDateTime;
        data["name"] = this.name;
        data["auditTaskCreateId"] = this.auditTaskCreateId;
        data["auditTaskType"] = this.auditTaskType;
        data["auditTaskTypeName"] = this.auditTaskTypeName;
        return data;
    }

    clone(): TaskTurnListDto {
        const json = this.toJSON();
        let result = new TaskTurnListDto();
        result.init(json);
        return result;
    }
}

/** 计划转办Dto */
export interface ITaskTurnListDto {
    /** 审核任务Id */
    auditTaskId: number;
    /** 转办人 */
    fromUserId: number;
    /** 转办人名字 */
    fromUserName: string | undefined;
    /** 代办人 */
    toUserId: number;
    /** 代办人 */
    toUserName: string | undefined;
    /** 审核人 */
    inspectorId: number | undefined;
    /** 审核人 */
    inspectorName: string | undefined;
    /** 计划开始日期 */
    planStart: moment.Moment;
    /** 计划结束日期 */
    planEnd: moment.Moment;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskState: string | undefined;
    /** 状态(字典)1.有计划 2.执行中 3.已完成 4.未完成 */
    auditTaskStateName: string | undefined;
    /** 格式化之后的日期 */
    fomartDateTime: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 审核任务创建记录 */
    auditTaskCreateId: number;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskType: string | undefined;
    /** 任务类型（字典）1.plan 2.walk */
    auditTaskTypeName: string | undefined;
}

export class MemberEditDto implements IMemberEditDto {
    /** Id */
    id: number | undefined;
    /** 地址 */
    address: string | undefined;
    /** 关于我 */
    aboutMe: string | undefined;
    /** 电话号码 */
    phoneNumber: string | undefined;
    /** 微信号码 */
    wechat: string | undefined;
    /** QQ号码 */
    qq: string | undefined;
    /** GitHub地址 */
    gitHub: string | undefined;
    /** 码云地址 */
    gitee: string | undefined;
    /** 关联的用户Id */
    userId: number | undefined;

    constructor(data?: IMemberEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.aboutMe = _data["aboutMe"];
            this.phoneNumber = _data["phoneNumber"];
            this.wechat = _data["wechat"];
            this.qq = _data["qq"];
            this.gitHub = _data["gitHub"];
            this.gitee = _data["gitee"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MemberEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["aboutMe"] = this.aboutMe;
        data["phoneNumber"] = this.phoneNumber;
        data["wechat"] = this.wechat;
        data["qq"] = this.qq;
        data["gitHub"] = this.gitHub;
        data["gitee"] = this.gitee;
        data["userId"] = this.userId;
        return data;
    }

    clone(): MemberEditDto {
        const json = this.toJSON();
        let result = new MemberEditDto();
        result.init(json);
        return result;
    }
}

export interface IMemberEditDto {
    /** Id */
    id: number | undefined;
    /** 地址 */
    address: string | undefined;
    /** 关于我 */
    aboutMe: string | undefined;
    /** 电话号码 */
    phoneNumber: string | undefined;
    /** 微信号码 */
    wechat: string | undefined;
    /** QQ号码 */
    qq: string | undefined;
    /** GitHub地址 */
    gitHub: string | undefined;
    /** 码云地址 */
    gitee: string | undefined;
    /** 关联的用户Id */
    userId: number | undefined;
}

export class CreateOrUpdateMemberInput implements ICreateOrUpdateMemberInput {
    member: MemberEditDto;

    constructor(data?: ICreateOrUpdateMemberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.member = new MemberEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.member = _data["member"] ? MemberEditDto.fromJS(_data["member"]) : new MemberEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateMemberInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMemberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateMemberInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateMemberInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateMemberInput {
    member: MemberEditDto;
}

export class MemberListDto implements IMemberListDto {
    /** 地址 */
    address: string | undefined;
    /** 关于我 */
    aboutMe: string | undefined;
    /** 电话号码 */
    phoneNumber: string | undefined;
    /** 微信号码 */
    wechat: string | undefined;
    /** QQ号码 */
    qq: string | undefined;
    /** GitHub地址 */
    gitHub: string | undefined;
    /** 码云地址 */
    gitee: string | undefined;
    id: number;

    constructor(data?: IMemberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.aboutMe = _data["aboutMe"];
            this.phoneNumber = _data["phoneNumber"];
            this.wechat = _data["wechat"];
            this.qq = _data["qq"];
            this.gitHub = _data["gitHub"];
            this.gitee = _data["gitee"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MemberListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["aboutMe"] = this.aboutMe;
        data["phoneNumber"] = this.phoneNumber;
        data["wechat"] = this.wechat;
        data["qq"] = this.qq;
        data["gitHub"] = this.gitHub;
        data["gitee"] = this.gitee;
        data["id"] = this.id;
        return data;
    }

    clone(): MemberListDto {
        const json = this.toJSON();
        let result = new MemberListDto();
        result.init(json);
        return result;
    }
}

export interface IMemberListDto {
    /** 地址 */
    address: string | undefined;
    /** 关于我 */
    aboutMe: string | undefined;
    /** 电话号码 */
    phoneNumber: string | undefined;
    /** 微信号码 */
    wechat: string | undefined;
    /** QQ号码 */
    qq: string | undefined;
    /** GitHub地址 */
    gitHub: string | undefined;
    /** 码云地址 */
    gitee: string | undefined;
    id: number;
}

export class GetMemberForEditOutput implements IGetMemberForEditOutput {
    member: MemberEditDto;

    constructor(data?: IGetMemberForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.member = _data["member"] ? MemberEditDto.fromJS(_data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMemberForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetMemberForEditOutput {
        const json = this.toJSON();
        let result = new GetMemberForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetMemberForEditOutput {
    member: MemberEditDto;
}

export class PagedResultDtoOfMemberListDto implements IPagedResultDtoOfMemberListDto {
    totalCount: number;
    items: MemberListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMemberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MemberListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMemberListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMemberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfMemberListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfMemberListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfMemberListDto {
    totalCount: number;
    items: MemberListDto[] | undefined;
}

export class AddSystemMessageInput implements IAddSystemMessageInput {
    sysClassifyCode: string | undefined;
    recvUserId: number;
    content: string | undefined;
    mesUrl: string | undefined;
    mesTitle: string | undefined;
    tenantId: number | undefined;
    msgProtocol: string | undefined;
    isPush: boolean;

    constructor(data?: IAddSystemMessageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysClassifyCode = _data["sysClassifyCode"];
            this.recvUserId = _data["recvUserId"];
            this.content = _data["content"];
            this.mesUrl = _data["mesUrl"];
            this.mesTitle = _data["mesTitle"];
            this.tenantId = _data["tenantId"];
            this.msgProtocol = _data["msgProtocol"];
            this.isPush = _data["isPush"];
        }
    }

    static fromJS(data: any): AddSystemMessageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddSystemMessageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysClassifyCode"] = this.sysClassifyCode;
        data["recvUserId"] = this.recvUserId;
        data["content"] = this.content;
        data["mesUrl"] = this.mesUrl;
        data["mesTitle"] = this.mesTitle;
        data["tenantId"] = this.tenantId;
        data["msgProtocol"] = this.msgProtocol;
        data["isPush"] = this.isPush;
        return data;
    }

    clone(): AddSystemMessageInput {
        const json = this.toJSON();
        let result = new AddSystemMessageInput();
        result.init(json);
        return result;
    }
}

export interface IAddSystemMessageInput {
    sysClassifyCode: string | undefined;
    recvUserId: number;
    content: string | undefined;
    mesUrl: string | undefined;
    mesTitle: string | undefined;
    tenantId: number | undefined;
    msgProtocol: string | undefined;
    isPush: boolean;
}

/** 根据对方ID获取历史消息 */
export class HistoryByOtherUserIdDto implements IHistoryByOtherUserIdDto {
    id: number;
    /** 发送者Id */
    sendId: number;
    /** 发送者名称 */
    sendName: string | undefined;
    /** 发送者编号 */
    sendCode: string | undefined;
    /** 发送者图片 */
    sendIcon: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 是否是系统消息0：不是，1：是 */
    isSystemMes: boolean;
    /** 详情跳转原URL */
    mesPrimaryUrl: string | undefined;
    /** 详情跳转URL */
    mesUrl: string | undefined;
    /** 跳转页面标题 */
    mesTitle: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;

    constructor(data?: IHistoryByOtherUserIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sendId = _data["sendId"];
            this.sendName = _data["sendName"];
            this.sendCode = _data["sendCode"];
            this.sendIcon = _data["sendIcon"];
            this.content = _data["content"];
            this.isSystemMes = _data["isSystemMes"];
            this.mesPrimaryUrl = _data["mesPrimaryUrl"];
            this.mesUrl = _data["mesUrl"];
            this.mesTitle = _data["mesTitle"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryByOtherUserIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryByOtherUserIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sendId"] = this.sendId;
        data["sendName"] = this.sendName;
        data["sendCode"] = this.sendCode;
        data["sendIcon"] = this.sendIcon;
        data["content"] = this.content;
        data["isSystemMes"] = this.isSystemMes;
        data["mesPrimaryUrl"] = this.mesPrimaryUrl;
        data["mesUrl"] = this.mesUrl;
        data["mesTitle"] = this.mesTitle;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): HistoryByOtherUserIdDto {
        const json = this.toJSON();
        let result = new HistoryByOtherUserIdDto();
        result.init(json);
        return result;
    }
}

/** 根据对方ID获取历史消息 */
export interface IHistoryByOtherUserIdDto {
    id: number;
    /** 发送者Id */
    sendId: number;
    /** 发送者名称 */
    sendName: string | undefined;
    /** 发送者编号 */
    sendCode: string | undefined;
    /** 发送者图片 */
    sendIcon: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 是否是系统消息0：不是，1：是 */
    isSystemMes: boolean;
    /** 详情跳转原URL */
    mesPrimaryUrl: string | undefined;
    /** 详情跳转URL */
    mesUrl: string | undefined;
    /** 跳转页面标题 */
    mesTitle: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
}

export class PagedResultDtoOfHistoryByOtherUserIdDto implements IPagedResultDtoOfHistoryByOtherUserIdDto {
    totalCount: number;
    items: HistoryByOtherUserIdDto[] | undefined;

    constructor(data?: IPagedResultDtoOfHistoryByOtherUserIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HistoryByOtherUserIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHistoryByOtherUserIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfHistoryByOtherUserIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfHistoryByOtherUserIdDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfHistoryByOtherUserIdDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfHistoryByOtherUserIdDto {
    totalCount: number;
    items: HistoryByOtherUserIdDto[] | undefined;
}

export class MessagePushEditDto implements IMessagePushEditDto {
    id: number | undefined;
    /** 个推类型 */
    type: string | undefined;
    /** 跳转url */
    jumpUrl: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IMessagePushEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.jumpUrl = _data["jumpUrl"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): MessagePushEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessagePushEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["jumpUrl"] = this.jumpUrl;
        data["title"] = this.title;
        data["description"] = this.description;
        data["enable"] = this.enable;
        return data;
    }

    clone(): MessagePushEditDto {
        const json = this.toJSON();
        let result = new MessagePushEditDto();
        result.init(json);
        return result;
    }
}

export interface IMessagePushEditDto {
    id: number | undefined;
    /** 个推类型 */
    type: string | undefined;
    /** 跳转url */
    jumpUrl: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;
}

export class DailyMessageDto implements IDailyMessageDto {
    /** 今日计划 */
    todayPlan: AuditTaskListDto[] | undefined;
    /** 任务即将超期 */
    planWillOutTime: AuditTaskListDto[] | undefined;
    /** 任务已超期 */
    outTimePlan: AuditTaskListDto[] | undefined;
    /** 问题即将超期 */
    probWillOutTime: APPIssueListDto[] | undefined;
    /** 问题已超期 */
    outTimeProb: APPIssueListDto[] | undefined;

    constructor(data?: IDailyMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["todayPlan"])) {
                this.todayPlan = [] as any;
                for (let item of _data["todayPlan"])
                    this.todayPlan.push(AuditTaskListDto.fromJS(item));
            }
            if (Array.isArray(_data["planWillOutTime"])) {
                this.planWillOutTime = [] as any;
                for (let item of _data["planWillOutTime"])
                    this.planWillOutTime.push(AuditTaskListDto.fromJS(item));
            }
            if (Array.isArray(_data["outTimePlan"])) {
                this.outTimePlan = [] as any;
                for (let item of _data["outTimePlan"])
                    this.outTimePlan.push(AuditTaskListDto.fromJS(item));
            }
            if (Array.isArray(_data["probWillOutTime"])) {
                this.probWillOutTime = [] as any;
                for (let item of _data["probWillOutTime"])
                    this.probWillOutTime.push(APPIssueListDto.fromJS(item));
            }
            if (Array.isArray(_data["outTimeProb"])) {
                this.outTimeProb = [] as any;
                for (let item of _data["outTimeProb"])
                    this.outTimeProb.push(APPIssueListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.todayPlan)) {
            data["todayPlan"] = [];
            for (let item of this.todayPlan)
                data["todayPlan"].push(item.toJSON());
        }
        if (Array.isArray(this.planWillOutTime)) {
            data["planWillOutTime"] = [];
            for (let item of this.planWillOutTime)
                data["planWillOutTime"].push(item.toJSON());
        }
        if (Array.isArray(this.outTimePlan)) {
            data["outTimePlan"] = [];
            for (let item of this.outTimePlan)
                data["outTimePlan"].push(item.toJSON());
        }
        if (Array.isArray(this.probWillOutTime)) {
            data["probWillOutTime"] = [];
            for (let item of this.probWillOutTime)
                data["probWillOutTime"].push(item.toJSON());
        }
        if (Array.isArray(this.outTimeProb)) {
            data["outTimeProb"] = [];
            for (let item of this.outTimeProb)
                data["outTimeProb"].push(item.toJSON());
        }
        return data;
    }

    clone(): DailyMessageDto {
        const json = this.toJSON();
        let result = new DailyMessageDto();
        result.init(json);
        return result;
    }
}

export interface IDailyMessageDto {
    /** 今日计划 */
    todayPlan: AuditTaskListDto[] | undefined;
    /** 任务即将超期 */
    planWillOutTime: AuditTaskListDto[] | undefined;
    /** 任务已超期 */
    outTimePlan: AuditTaskListDto[] | undefined;
    /** 问题即将超期 */
    probWillOutTime: APPIssueListDto[] | undefined;
    /** 问题已超期 */
    outTimeProb: APPIssueListDto[] | undefined;
}

/** LPA消息推送模型 */
export class MessagePushListDto implements IMessagePushListDto {
    /** Id */
    id: number;
    /** 个推类型 */
    type: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IMessagePushListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): MessagePushListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessagePushListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["enable"] = this.enable;
        return data;
    }

    clone(): MessagePushListDto {
        const json = this.toJSON();
        let result = new MessagePushListDto();
        result.init(json);
        return result;
    }
}

/** LPA消息推送模型 */
export interface IMessagePushListDto {
    /** Id */
    id: number;
    /** 个推类型 */
    type: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;
}

export class PagedResultDtoOfMessagePushListDto implements IPagedResultDtoOfMessagePushListDto {
    totalCount: number;
    items: MessagePushListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMessagePushListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MessagePushListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMessagePushListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMessagePushListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfMessagePushListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfMessagePushListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfMessagePushListDto {
    totalCount: number;
    items: MessagePushListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Module.Module */
export class ModuleEditDto implements IModuleEditDto {
    /** Id */
    id: number | undefined;
    /** ParentId */
    parentId: number;
    /** EnCode */
    enCode: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** UrlAddress */
    urlAddress: string | undefined;
    /** Target */
    target: string | undefined;
    /** AllowExpand */
    allowExpand: number | undefined;
    /** IsMenu */
    isMenu: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** Description */
    description: string | undefined;
    isApp: boolean;

    constructor(data?: IModuleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.icon = _data["icon"];
            this.urlAddress = _data["urlAddress"];
            this.target = _data["target"];
            this.allowExpand = _data["allowExpand"];
            this.isMenu = _data["isMenu"];
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.description = _data["description"];
            this.isApp = _data["isApp"];
        }
    }

    static fromJS(data: any): ModuleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["icon"] = this.icon;
        data["urlAddress"] = this.urlAddress;
        data["target"] = this.target;
        data["allowExpand"] = this.allowExpand;
        data["isMenu"] = this.isMenu;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["description"] = this.description;
        data["isApp"] = this.isApp;
        return data;
    }

    clone(): ModuleEditDto {
        const json = this.toJSON();
        let result = new ModuleEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Module.Module */
export interface IModuleEditDto {
    /** Id */
    id: number | undefined;
    /** ParentId */
    parentId: number;
    /** EnCode */
    enCode: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** UrlAddress */
    urlAddress: string | undefined;
    /** Target */
    target: string | undefined;
    /** AllowExpand */
    allowExpand: number | undefined;
    /** IsMenu */
    isMenu: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** Description */
    description: string | undefined;
    isApp: boolean;
}

export class ModuleButtonEditDto implements IModuleButtonEditDto {
    /** 菜单主键 */
    moduleId: number;
    /** 父级主键 */
    parentId: number;
    /** 图标 */
    icon: string | undefined;
    /** 编码 */
    enCode: string | undefined;
    /** 名称 */
    fullName: string | undefined;
    /** 排序码 */
    sortCode: number | undefined;

    constructor(data?: IModuleButtonEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.parentId = _data["parentId"];
            this.icon = _data["icon"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): ModuleButtonEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleButtonEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["parentId"] = this.parentId;
        data["icon"] = this.icon;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["sortCode"] = this.sortCode;
        return data;
    }

    clone(): ModuleButtonEditDto {
        const json = this.toJSON();
        let result = new ModuleButtonEditDto();
        result.init(json);
        return result;
    }
}

export interface IModuleButtonEditDto {
    /** 菜单主键 */
    moduleId: number;
    /** 父级主键 */
    parentId: number;
    /** 图标 */
    icon: string | undefined;
    /** 编码 */
    enCode: string | undefined;
    /** 名称 */
    fullName: string | undefined;
    /** 排序码 */
    sortCode: number | undefined;
}

export class ModuleColumnEditDto implements IModuleColumnEditDto {
    /** 菜单Id */
    moduleId: number;
    /** 表格名称 */
    gridName: string | undefined;
    /** 编号 */
    enCode: string | undefined;
    /** 名称 */
    fullName: string | undefined;
    /** 排序号 */
    sortCode: string | undefined;

    constructor(data?: IModuleColumnEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.gridName = _data["gridName"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): ModuleColumnEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleColumnEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["gridName"] = this.gridName;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["sortCode"] = this.sortCode;
        return data;
    }

    clone(): ModuleColumnEditDto {
        const json = this.toJSON();
        let result = new ModuleColumnEditDto();
        result.init(json);
        return result;
    }
}

export interface IModuleColumnEditDto {
    /** 菜单Id */
    moduleId: number;
    /** 表格名称 */
    gridName: string | undefined;
    /** 编号 */
    enCode: string | undefined;
    /** 名称 */
    fullName: string | undefined;
    /** 排序号 */
    sortCode: string | undefined;
}

export class CreateOrUpdateModuleInput implements ICreateOrUpdateModuleInput {
    module: ModuleEditDto;
    moduleButton: ModuleButtonEditDto[] | undefined;
    moduleColumn: ModuleColumnEditDto[] | undefined;

    constructor(data?: ICreateOrUpdateModuleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? ModuleEditDto.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["moduleButton"])) {
                this.moduleButton = [] as any;
                for (let item of _data["moduleButton"])
                    this.moduleButton.push(ModuleButtonEditDto.fromJS(item));
            }
            if (Array.isArray(_data["moduleColumn"])) {
                this.moduleColumn = [] as any;
                for (let item of _data["moduleColumn"])
                    this.moduleColumn.push(ModuleColumnEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateModuleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateModuleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.moduleButton)) {
            data["moduleButton"] = [];
            for (let item of this.moduleButton)
                data["moduleButton"].push(item.toJSON());
        }
        if (Array.isArray(this.moduleColumn)) {
            data["moduleColumn"] = [];
            for (let item of this.moduleColumn)
                data["moduleColumn"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateModuleInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateModuleInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateModuleInput {
    module: ModuleEditDto;
    moduleButton: ModuleButtonEditDto[] | undefined;
    moduleColumn: ModuleColumnEditDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Module.Module */
export class ModuleListDto implements IModuleListDto {
    /** ParentId */
    parentId: number;
    /** EnCode */
    enCode: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** UrlAddress */
    urlAddress: string | undefined;
    /** Target */
    target: string | undefined;
    /** AllowExpand */
    allowExpand: number | undefined;
    /** IsMenu */
    isMenu: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** Description */
    description: string | undefined;
    id: number;

    constructor(data?: IModuleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.icon = _data["icon"];
            this.urlAddress = _data["urlAddress"];
            this.target = _data["target"];
            this.allowExpand = _data["allowExpand"];
            this.isMenu = _data["isMenu"];
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModuleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["icon"] = this.icon;
        data["urlAddress"] = this.urlAddress;
        data["target"] = this.target;
        data["allowExpand"] = this.allowExpand;
        data["isMenu"] = this.isMenu;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): ModuleListDto {
        const json = this.toJSON();
        let result = new ModuleListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.SystemModule.Module.Module */
export interface IModuleListDto {
    /** ParentId */
    parentId: number;
    /** EnCode */
    enCode: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** UrlAddress */
    urlAddress: string | undefined;
    /** Target */
    target: string | undefined;
    /** AllowExpand */
    allowExpand: number | undefined;
    /** IsMenu */
    isMenu: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** Description */
    description: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetModuleForEditOutput implements IGetModuleForEditOutput {
    module: ModuleEditDto;
    moduleButton: ModuleButtonEditDto[] | undefined;
    moduleColumn: ModuleColumnEditDto[] | undefined;

    constructor(data?: IGetModuleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? ModuleEditDto.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["moduleButton"])) {
                this.moduleButton = [] as any;
                for (let item of _data["moduleButton"])
                    this.moduleButton.push(ModuleButtonEditDto.fromJS(item));
            }
            if (Array.isArray(_data["moduleColumn"])) {
                this.moduleColumn = [] as any;
                for (let item of _data["moduleColumn"])
                    this.moduleColumn.push(ModuleColumnEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetModuleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetModuleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.moduleButton)) {
            data["moduleButton"] = [];
            for (let item of this.moduleButton)
                data["moduleButton"].push(item.toJSON());
        }
        if (Array.isArray(this.moduleColumn)) {
            data["moduleColumn"] = [];
            for (let item of this.moduleColumn)
                data["moduleColumn"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetModuleForEditOutput {
        const json = this.toJSON();
        let result = new GetModuleForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetModuleForEditOutput {
    module: ModuleEditDto;
    moduleButton: ModuleButtonEditDto[] | undefined;
    moduleColumn: ModuleColumnEditDto[] | undefined;
}

export class PagedResultDtoOfModuleListDto implements IPagedResultDtoOfModuleListDto {
    totalCount: number;
    items: ModuleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfModuleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ModuleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfModuleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfModuleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfModuleListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfModuleListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfModuleListDto {
    totalCount: number;
    items: ModuleListDto[] | undefined;
}

export class ModuleLanguageListDto implements IModuleLanguageListDto {
    /** 目标语言 */
    targetText: string | undefined;
    /** ParentId */
    parentId: number;
    /** EnCode */
    enCode: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** UrlAddress */
    urlAddress: string | undefined;
    /** Target */
    target: string | undefined;
    /** AllowExpand */
    allowExpand: number | undefined;
    /** IsMenu */
    isMenu: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** Description */
    description: string | undefined;
    id: number;

    constructor(data?: IModuleLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetText = _data["targetText"];
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.icon = _data["icon"];
            this.urlAddress = _data["urlAddress"];
            this.target = _data["target"];
            this.allowExpand = _data["allowExpand"];
            this.isMenu = _data["isMenu"];
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModuleLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetText"] = this.targetText;
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["icon"] = this.icon;
        data["urlAddress"] = this.urlAddress;
        data["target"] = this.target;
        data["allowExpand"] = this.allowExpand;
        data["isMenu"] = this.isMenu;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): ModuleLanguageListDto {
        const json = this.toJSON();
        let result = new ModuleLanguageListDto();
        result.init(json);
        return result;
    }
}

export interface IModuleLanguageListDto {
    /** 目标语言 */
    targetText: string | undefined;
    /** ParentId */
    parentId: number;
    /** EnCode */
    enCode: string | undefined;
    /** FullName */
    fullName: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** UrlAddress */
    urlAddress: string | undefined;
    /** Target */
    target: string | undefined;
    /** AllowExpand */
    allowExpand: number | undefined;
    /** IsMenu */
    isMenu: number | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** Description */
    description: string | undefined;
    id: number;
}

export class PagedResultDtoOfModuleLanguageListDto implements IPagedResultDtoOfModuleLanguageListDto {
    totalCount: number;
    items: ModuleLanguageListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfModuleLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ModuleLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfModuleLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfModuleLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfModuleLanguageListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfModuleLanguageListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfModuleLanguageListDto {
    totalCount: number;
    items: ModuleLanguageListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Laborcost.MonthAttendancePlan.MonthAttendancePlan */
export class MonthAttendancePlanEditDto implements IMonthAttendancePlanEditDto {
    /** Id */
    id: number | undefined;
    /** 员工 */
    empId: number;
    /** 出勤日期 */
    attendDate: moment.Moment;
    /** 出勤班次 */
    attendShiftCode: string | undefined;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 加班备注 */
    qtRemark: string | undefined;
    /** 请假时数 */
    leaveNum: number;
    /** 请假类型 */
    leaveType: string | undefined;
    /** 请假备注 */
    leaveRemark: string | undefined;

    constructor(data?: IMonthAttendancePlanEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.attendDate = _data["attendDate"] ? moment(_data["attendDate"].toString()) : <any>undefined;
            this.attendShiftCode = _data["attendShiftCode"];
            this.standardLobor = _data["standardLobor"];
            this.qtNum = _data["qtNum"];
            this.qtRemark = _data["qtRemark"];
            this.leaveNum = _data["leaveNum"];
            this.leaveType = _data["leaveType"];
            this.leaveRemark = _data["leaveRemark"];
        }
    }

    static fromJS(data: any): MonthAttendancePlanEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttendancePlanEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["attendDate"] = this.attendDate ? this.attendDate.toISOString() : <any>undefined;
        data["attendShiftCode"] = this.attendShiftCode;
        data["standardLobor"] = this.standardLobor;
        data["qtNum"] = this.qtNum;
        data["qtRemark"] = this.qtRemark;
        data["leaveNum"] = this.leaveNum;
        data["leaveType"] = this.leaveType;
        data["leaveRemark"] = this.leaveRemark;
        return data;
    }

    clone(): MonthAttendancePlanEditDto {
        const json = this.toJSON();
        let result = new MonthAttendancePlanEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Laborcost.MonthAttendancePlan.MonthAttendancePlan */
export interface IMonthAttendancePlanEditDto {
    /** Id */
    id: number | undefined;
    /** 员工 */
    empId: number;
    /** 出勤日期 */
    attendDate: moment.Moment;
    /** 出勤班次 */
    attendShiftCode: string | undefined;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 加班备注 */
    qtRemark: string | undefined;
    /** 请假时数 */
    leaveNum: number;
    /** 请假类型 */
    leaveType: string | undefined;
    /** 请假备注 */
    leaveRemark: string | undefined;
}

export class CreateOrUpdateMonthAttendancePlanInput implements ICreateOrUpdateMonthAttendancePlanInput {
    monthAttendancePlan: MonthAttendancePlanEditDto;

    constructor(data?: ICreateOrUpdateMonthAttendancePlanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.monthAttendancePlan = new MonthAttendancePlanEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthAttendancePlan = _data["monthAttendancePlan"] ? MonthAttendancePlanEditDto.fromJS(_data["monthAttendancePlan"]) : new MonthAttendancePlanEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateMonthAttendancePlanInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMonthAttendancePlanInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthAttendancePlan"] = this.monthAttendancePlan ? this.monthAttendancePlan.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateMonthAttendancePlanInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateMonthAttendancePlanInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateMonthAttendancePlanInput {
    monthAttendancePlan: MonthAttendancePlanEditDto;
}

export class MonthAttPlanEditDto implements IMonthAttPlanEditDto {
    /** 类型，1：班次，2：日总出勤时数，3：加班时数，4：请假 */
    type: number;
    id: number | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 其它数值 */
    number: number;
    leaveType: string | undefined;
    /** 出勤日期 */
    attendDate: moment.Moment;

    constructor(data?: IMonthAttPlanEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.shiftCode = _data["shiftCode"];
            this.number = _data["number"];
            this.leaveType = _data["leaveType"];
            this.attendDate = _data["attendDate"] ? moment(_data["attendDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthAttPlanEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttPlanEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["shiftCode"] = this.shiftCode;
        data["number"] = this.number;
        data["leaveType"] = this.leaveType;
        data["attendDate"] = this.attendDate ? this.attendDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): MonthAttPlanEditDto {
        const json = this.toJSON();
        let result = new MonthAttPlanEditDto();
        result.init(json);
        return result;
    }
}

export interface IMonthAttPlanEditDto {
    /** 类型，1：班次，2：日总出勤时数，3：加班时数，4：请假 */
    type: number;
    id: number | undefined;
    /** 班次 */
    shiftCode: string | undefined;
    /** 其它数值 */
    number: number;
    leaveType: string | undefined;
    /** 出勤日期 */
    attendDate: moment.Moment;
}

export class MonthAttPlanDto implements IMonthAttPlanDto {
    /** 员工 */
    empId: number;
    /** 姓名 */
    realName: string | undefined;
    /** 员工工号 */
    jobNumber: string | undefined;
    /** 部门 */
    department: string | undefined;
    /** 岗位 */
    post: string | undefined;
    /** 考情组Id */
    attGroupId: number | undefined;
    /** 出勤日期 */
    attendDate: moment.Moment;
    /** 出勤班次 */
    attendShiftCode: string | undefined;
    /** 班次 */
    attendShift: string | undefined;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 加班备注 */
    qtRemark: string | undefined;
    /** 请假时数 */
    leaveNum: number;
    /** 请假类型 */
    leaveType: string | undefined;
    /** 请假类型 */
    leaveTypeCode: string | undefined;
    /** 请假备注 */
    leaveRemark: string | undefined;
    /** 部门ID */
    departmentId: number;
    /** 班次类型 */
    workTypeCode: string | undefined;
    /** 是否夜班 */
    isNightShift: boolean | undefined;
    /** 离职日期-------------------新增 */
    termDate: moment.Moment | undefined;
    /** 入职日期-------------------新增 */
    hireDate: moment.Moment | undefined;
    id: number;

    constructor(data?: IMonthAttPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.realName = _data["realName"];
            this.jobNumber = _data["jobNumber"];
            this.department = _data["department"];
            this.post = _data["post"];
            this.attGroupId = _data["attGroupId"];
            this.attendDate = _data["attendDate"] ? moment(_data["attendDate"].toString()) : <any>undefined;
            this.attendShiftCode = _data["attendShiftCode"];
            this.attendShift = _data["attendShift"];
            this.standardLobor = _data["standardLobor"];
            this.qtNum = _data["qtNum"];
            this.qtRemark = _data["qtRemark"];
            this.leaveNum = _data["leaveNum"];
            this.leaveType = _data["leaveType"];
            this.leaveTypeCode = _data["leaveTypeCode"];
            this.leaveRemark = _data["leaveRemark"];
            this.departmentId = _data["departmentId"];
            this.workTypeCode = _data["workTypeCode"];
            this.isNightShift = _data["isNightShift"];
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MonthAttPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["realName"] = this.realName;
        data["jobNumber"] = this.jobNumber;
        data["department"] = this.department;
        data["post"] = this.post;
        data["attGroupId"] = this.attGroupId;
        data["attendDate"] = this.attendDate ? this.attendDate.toISOString() : <any>undefined;
        data["attendShiftCode"] = this.attendShiftCode;
        data["attendShift"] = this.attendShift;
        data["standardLobor"] = this.standardLobor;
        data["qtNum"] = this.qtNum;
        data["qtRemark"] = this.qtRemark;
        data["leaveNum"] = this.leaveNum;
        data["leaveType"] = this.leaveType;
        data["leaveTypeCode"] = this.leaveTypeCode;
        data["leaveRemark"] = this.leaveRemark;
        data["departmentId"] = this.departmentId;
        data["workTypeCode"] = this.workTypeCode;
        data["isNightShift"] = this.isNightShift;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): MonthAttPlanDto {
        const json = this.toJSON();
        let result = new MonthAttPlanDto();
        result.init(json);
        return result;
    }
}

export interface IMonthAttPlanDto {
    /** 员工 */
    empId: number;
    /** 姓名 */
    realName: string | undefined;
    /** 员工工号 */
    jobNumber: string | undefined;
    /** 部门 */
    department: string | undefined;
    /** 岗位 */
    post: string | undefined;
    /** 考情组Id */
    attGroupId: number | undefined;
    /** 出勤日期 */
    attendDate: moment.Moment;
    /** 出勤班次 */
    attendShiftCode: string | undefined;
    /** 班次 */
    attendShift: string | undefined;
    /** 出勤时数 */
    standardLobor: number;
    /** 加班时数 */
    qtNum: number;
    /** 加班备注 */
    qtRemark: string | undefined;
    /** 请假时数 */
    leaveNum: number;
    /** 请假类型 */
    leaveType: string | undefined;
    /** 请假类型 */
    leaveTypeCode: string | undefined;
    /** 请假备注 */
    leaveRemark: string | undefined;
    /** 部门ID */
    departmentId: number;
    /** 班次类型 */
    workTypeCode: string | undefined;
    /** 是否夜班 */
    isNightShift: boolean | undefined;
    /** 离职日期-------------------新增 */
    termDate: moment.Moment | undefined;
    /** 入职日期-------------------新增 */
    hireDate: moment.Moment | undefined;
    id: number;
}

export class MonthAttSumDto implements IMonthAttSumDto {
    empId: number;
    /** 正常出勤时数 */
    attNumber: number;
    /** 工作日加班时数 */
    workQTNumber: number;
    /** 周末加班时数 */
    weekQTNumber: number;
    /** 夜班天数 */
    nightDays: number;
    /** 病假 */
    sjHours: number;
    bjHours: number;
    /** 有薪假时数 */
    salaryHours: number;
    /** 缺勤时数 */
    absenceHours: number;

    constructor(data?: IMonthAttSumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.attNumber = _data["attNumber"];
            this.workQTNumber = _data["workQTNumber"];
            this.weekQTNumber = _data["weekQTNumber"];
            this.nightDays = _data["nightDays"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.salaryHours = _data["salaryHours"];
            this.absenceHours = _data["absenceHours"];
        }
    }

    static fromJS(data: any): MonthAttSumDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttSumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["attNumber"] = this.attNumber;
        data["workQTNumber"] = this.workQTNumber;
        data["weekQTNumber"] = this.weekQTNumber;
        data["nightDays"] = this.nightDays;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["salaryHours"] = this.salaryHours;
        data["absenceHours"] = this.absenceHours;
        return data;
    }

    clone(): MonthAttSumDto {
        const json = this.toJSON();
        let result = new MonthAttSumDto();
        result.init(json);
        return result;
    }
}

export interface IMonthAttSumDto {
    empId: number;
    /** 正常出勤时数 */
    attNumber: number;
    /** 工作日加班时数 */
    workQTNumber: number;
    /** 周末加班时数 */
    weekQTNumber: number;
    /** 夜班天数 */
    nightDays: number;
    /** 病假 */
    sjHours: number;
    bjHours: number;
    /** 有薪假时数 */
    salaryHours: number;
    /** 缺勤时数 */
    absenceHours: number;
}

/** 的列表DTO QYB.QYBProduct.Laborcost.MonthAttendancePlan.MonthAttendancePlan */
export class MonthAttendancePlanListDto implements IMonthAttendancePlanListDto {
    monthAttPlan: MonthAttPlanDto[] | undefined;
    empList: number[] | undefined;
    monthAttSumList: MonthAttSumDto[] | undefined;

    constructor(data?: IMonthAttendancePlanListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["monthAttPlan"])) {
                this.monthAttPlan = [] as any;
                for (let item of _data["monthAttPlan"])
                    this.monthAttPlan.push(MonthAttPlanDto.fromJS(item));
            }
            if (Array.isArray(_data["empList"])) {
                this.empList = [] as any;
                for (let item of _data["empList"])
                    this.empList.push(item);
            }
            if (Array.isArray(_data["monthAttSumList"])) {
                this.monthAttSumList = [] as any;
                for (let item of _data["monthAttSumList"])
                    this.monthAttSumList.push(MonthAttSumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthAttendancePlanListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttendancePlanListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.monthAttPlan)) {
            data["monthAttPlan"] = [];
            for (let item of this.monthAttPlan)
                data["monthAttPlan"].push(item.toJSON());
        }
        if (Array.isArray(this.empList)) {
            data["empList"] = [];
            for (let item of this.empList)
                data["empList"].push(item);
        }
        if (Array.isArray(this.monthAttSumList)) {
            data["monthAttSumList"] = [];
            for (let item of this.monthAttSumList)
                data["monthAttSumList"].push(item.toJSON());
        }
        return data;
    }

    clone(): MonthAttendancePlanListDto {
        const json = this.toJSON();
        let result = new MonthAttendancePlanListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Laborcost.MonthAttendancePlan.MonthAttendancePlan */
export interface IMonthAttendancePlanListDto {
    monthAttPlan: MonthAttPlanDto[] | undefined;
    empList: number[] | undefined;
    monthAttSumList: MonthAttSumDto[] | undefined;
}

/** 读取可编辑的Dto */
export class GetMonthAttendancePlanForEditOutput implements IGetMonthAttendancePlanForEditOutput {
    monthAttendancePlan: MonthAttendancePlanEditDto;

    constructor(data?: IGetMonthAttendancePlanForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthAttendancePlan = _data["monthAttendancePlan"] ? MonthAttendancePlanEditDto.fromJS(_data["monthAttendancePlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMonthAttendancePlanForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthAttendancePlanForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthAttendancePlan"] = this.monthAttendancePlan ? this.monthAttendancePlan.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetMonthAttendancePlanForEditOutput {
        const json = this.toJSON();
        let result = new GetMonthAttendancePlanForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetMonthAttendancePlanForEditOutput {
    monthAttendancePlan: MonthAttendancePlanEditDto;
}

export class HolidayRuleList implements IHolidayRuleList {
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IHolidayRuleList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): HolidayRuleList {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayRuleList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): HolidayRuleList {
        const json = this.toJSON();
        let result = new HolidayRuleList();
        result.init(json);
        return result;
    }
}

export interface IHolidayRuleList {
    name: string | undefined;
    code: string | undefined;
}

export class MonthAttendancePlanImportInput implements IMonthAttendancePlanImportInput {
    fileName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;

    constructor(data?: IMonthAttendancePlanImportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthAttendancePlanImportInput {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttendancePlanImportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MonthAttendancePlanImportInput {
        const json = this.toJSON();
        let result = new MonthAttendancePlanImportInput();
        result.init(json);
        return result;
    }
}

export interface IMonthAttendancePlanImportInput {
    fileName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class PlanData implements IPlanData {
    /** 出勤日期 */
    attendDate: string | undefined;
    /** 出勤班次 */
    attendShiftCode: string | undefined;
    /** 出勤时数 */
    standardLobor: string | undefined;
    /** 加班时数 */
    qtNum: string | undefined;
    /** 请假类型 */
    leaveType: string | undefined;

    constructor(data?: IPlanData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendDate = _data["attendDate"];
            this.attendShiftCode = _data["attendShiftCode"];
            this.standardLobor = _data["standardLobor"];
            this.qtNum = _data["qtNum"];
            this.leaveType = _data["leaveType"];
        }
    }

    static fromJS(data: any): PlanData {
        data = typeof data === 'object' ? data : {};
        let result = new PlanData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendDate"] = this.attendDate;
        data["attendShiftCode"] = this.attendShiftCode;
        data["standardLobor"] = this.standardLobor;
        data["qtNum"] = this.qtNum;
        data["leaveType"] = this.leaveType;
        return data;
    }

    clone(): PlanData {
        const json = this.toJSON();
        let result = new PlanData();
        result.init(json);
        return result;
    }
}

export interface IPlanData {
    /** 出勤日期 */
    attendDate: string | undefined;
    /** 出勤班次 */
    attendShiftCode: string | undefined;
    /** 出勤时数 */
    standardLobor: string | undefined;
    /** 加班时数 */
    qtNum: string | undefined;
    /** 请假类型 */
    leaveType: string | undefined;
}

export class EmpPlan implements IEmpPlan {
    /** 姓名 */
    empName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 部门 */
    department: string | undefined;
    /** 岗位 */
    post: string | undefined;
    /** 计划 */
    planData: PlanData[] | undefined;
    /** 正常出勤时数 */
    attNumber: number;
    /** 工作日加班时数 */
    workQTNumber: number;
    /** 周末加班时数 */
    weekQTNumber: number;
    /** 夜班天数 */
    nightDays: number;
    /** 事假 */
    sjHours: number;
    /** 病假 */
    bjHours: number;
    /** 有薪假时数 */
    salaryHours: number;
    /** 缺勤时数 */
    absenceHours: number;
    /** 错误说明 */
    errorDes: string | undefined;

    constructor(data?: IEmpPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empName = _data["empName"];
            this.jobNumber = _data["jobNumber"];
            this.department = _data["department"];
            this.post = _data["post"];
            if (Array.isArray(_data["planData"])) {
                this.planData = [] as any;
                for (let item of _data["planData"])
                    this.planData.push(PlanData.fromJS(item));
            }
            this.attNumber = _data["attNumber"];
            this.workQTNumber = _data["workQTNumber"];
            this.weekQTNumber = _data["weekQTNumber"];
            this.nightDays = _data["nightDays"];
            this.sjHours = _data["sjHours"];
            this.bjHours = _data["bjHours"];
            this.salaryHours = _data["salaryHours"];
            this.absenceHours = _data["absenceHours"];
            this.errorDes = _data["errorDes"];
        }
    }

    static fromJS(data: any): EmpPlan {
        data = typeof data === 'object' ? data : {};
        let result = new EmpPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empName"] = this.empName;
        data["jobNumber"] = this.jobNumber;
        data["department"] = this.department;
        data["post"] = this.post;
        if (Array.isArray(this.planData)) {
            data["planData"] = [];
            for (let item of this.planData)
                data["planData"].push(item.toJSON());
        }
        data["attNumber"] = this.attNumber;
        data["workQTNumber"] = this.workQTNumber;
        data["weekQTNumber"] = this.weekQTNumber;
        data["nightDays"] = this.nightDays;
        data["sjHours"] = this.sjHours;
        data["bjHours"] = this.bjHours;
        data["salaryHours"] = this.salaryHours;
        data["absenceHours"] = this.absenceHours;
        data["errorDes"] = this.errorDes;
        return data;
    }

    clone(): EmpPlan {
        const json = this.toJSON();
        let result = new EmpPlan();
        result.init(json);
        return result;
    }
}

export interface IEmpPlan {
    /** 姓名 */
    empName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 部门 */
    department: string | undefined;
    /** 岗位 */
    post: string | undefined;
    /** 计划 */
    planData: PlanData[] | undefined;
    /** 正常出勤时数 */
    attNumber: number;
    /** 工作日加班时数 */
    workQTNumber: number;
    /** 周末加班时数 */
    weekQTNumber: number;
    /** 夜班天数 */
    nightDays: number;
    /** 事假 */
    sjHours: number;
    /** 病假 */
    bjHours: number;
    /** 有薪假时数 */
    salaryHours: number;
    /** 缺勤时数 */
    absenceHours: number;
    /** 错误说明 */
    errorDes: string | undefined;
}

export class MonthAttendancePlanImportDto implements IMonthAttendancePlanImportDto {
    /** 表头 */
    tableHeader: string[] | undefined;
    /** 员工考勤计划集合 */
    empPlanList: EmpPlan[] | undefined;

    constructor(data?: IMonthAttendancePlanImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableHeader"])) {
                this.tableHeader = [] as any;
                for (let item of _data["tableHeader"])
                    this.tableHeader.push(item);
            }
            if (Array.isArray(_data["empPlanList"])) {
                this.empPlanList = [] as any;
                for (let item of _data["empPlanList"])
                    this.empPlanList.push(EmpPlan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthAttendancePlanImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthAttendancePlanImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableHeader)) {
            data["tableHeader"] = [];
            for (let item of this.tableHeader)
                data["tableHeader"].push(item);
        }
        if (Array.isArray(this.empPlanList)) {
            data["empPlanList"] = [];
            for (let item of this.empPlanList)
                data["empPlanList"].push(item.toJSON());
        }
        return data;
    }

    clone(): MonthAttendancePlanImportDto {
        const json = this.toJSON();
        let result = new MonthAttendancePlanImportDto();
        result.init(json);
        return result;
    }
}

export interface IMonthAttendancePlanImportDto {
    /** 表头 */
    tableHeader: string[] | undefined;
    /** 员工考勤计划集合 */
    empPlanList: EmpPlan[] | undefined;
}

export class NeteaseOrderInfoEditDto implements INeteaseOrderInfoEditDto {
    /** Id */
    id: number | undefined;
    /** 订单编号 */
    orderNo: string | undefined;
    /** 创建时间 */
    orderDate: moment.Moment | undefined;
    /** 商品类型 */
    productType: string | undefined;
    /** 商品名称 */
    productName: string | undefined;
    /** 商品详细 */
    productDes: string | undefined;
    /** 原价 */
    originalPrice: number;
    /** 现价 */
    transactionAmount: number;
    /** 买家 */
    buyerName: string | undefined;
    /** 推广来源 */
    generalizeSource: string | undefined;
    /** 推广者 */
    generalizeName: string | undefined;
    /** 学习卡 */
    cardAmount: number;
    /** 平台红包 */
    platformHB: number;
    /** 实际付款 */
    practicalAmount: number;
    /** 支付方式 */
    payType: string | undefined;
    /** 第三方支付费用 */
    thirdPartyPayServiceCharge: number;
    /** 推广费用 */
    generalizeServiceCharge: number;
    /** 平台服务费 */
    platformServiceCharge: number;
    /** 实际收入 */
    realityAmount: number;
    /** 交易状态 */
    transactionStatus: string | undefined;
    /** 交易成功时间 */
    transactionSuccessDate: moment.Moment | undefined;
    /** 结算状态 */
    settleAccounts: string | undefined;
    /** 结算时间 */
    settleAccountsDate: moment.Moment | undefined;
    /** QQ已审核 */
    isChecked: boolean;
    /** 码云已审核 */
    isGiteeChecked: boolean;
    /** 平台 */
    platform: string | undefined;

    constructor(data?: INeteaseOrderInfoEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNo = _data["orderNo"];
            this.orderDate = _data["orderDate"] ? moment(_data["orderDate"].toString()) : <any>undefined;
            this.productType = _data["productType"];
            this.productName = _data["productName"];
            this.productDes = _data["productDes"];
            this.originalPrice = _data["originalPrice"];
            this.transactionAmount = _data["transactionAmount"];
            this.buyerName = _data["buyerName"];
            this.generalizeSource = _data["generalizeSource"];
            this.generalizeName = _data["generalizeName"];
            this.cardAmount = _data["cardAmount"];
            this.platformHB = _data["platformHB"];
            this.practicalAmount = _data["practicalAmount"];
            this.payType = _data["payType"];
            this.thirdPartyPayServiceCharge = _data["thirdPartyPayServiceCharge"];
            this.generalizeServiceCharge = _data["generalizeServiceCharge"];
            this.platformServiceCharge = _data["platformServiceCharge"];
            this.realityAmount = _data["realityAmount"];
            this.transactionStatus = _data["transactionStatus"];
            this.transactionSuccessDate = _data["transactionSuccessDate"] ? moment(_data["transactionSuccessDate"].toString()) : <any>undefined;
            this.settleAccounts = _data["settleAccounts"];
            this.settleAccountsDate = _data["settleAccountsDate"] ? moment(_data["settleAccountsDate"].toString()) : <any>undefined;
            this.isChecked = _data["isChecked"];
            this.isGiteeChecked = _data["isGiteeChecked"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): NeteaseOrderInfoEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeteaseOrderInfoEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNo"] = this.orderNo;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["productType"] = this.productType;
        data["productName"] = this.productName;
        data["productDes"] = this.productDes;
        data["originalPrice"] = this.originalPrice;
        data["transactionAmount"] = this.transactionAmount;
        data["buyerName"] = this.buyerName;
        data["generalizeSource"] = this.generalizeSource;
        data["generalizeName"] = this.generalizeName;
        data["cardAmount"] = this.cardAmount;
        data["platformHB"] = this.platformHB;
        data["practicalAmount"] = this.practicalAmount;
        data["payType"] = this.payType;
        data["thirdPartyPayServiceCharge"] = this.thirdPartyPayServiceCharge;
        data["generalizeServiceCharge"] = this.generalizeServiceCharge;
        data["platformServiceCharge"] = this.platformServiceCharge;
        data["realityAmount"] = this.realityAmount;
        data["transactionStatus"] = this.transactionStatus;
        data["transactionSuccessDate"] = this.transactionSuccessDate ? this.transactionSuccessDate.toISOString() : <any>undefined;
        data["settleAccounts"] = this.settleAccounts;
        data["settleAccountsDate"] = this.settleAccountsDate ? this.settleAccountsDate.toISOString() : <any>undefined;
        data["isChecked"] = this.isChecked;
        data["isGiteeChecked"] = this.isGiteeChecked;
        data["platform"] = this.platform;
        return data;
    }

    clone(): NeteaseOrderInfoEditDto {
        const json = this.toJSON();
        let result = new NeteaseOrderInfoEditDto();
        result.init(json);
        return result;
    }
}

export interface INeteaseOrderInfoEditDto {
    /** Id */
    id: number | undefined;
    /** 订单编号 */
    orderNo: string | undefined;
    /** 创建时间 */
    orderDate: moment.Moment | undefined;
    /** 商品类型 */
    productType: string | undefined;
    /** 商品名称 */
    productName: string | undefined;
    /** 商品详细 */
    productDes: string | undefined;
    /** 原价 */
    originalPrice: number;
    /** 现价 */
    transactionAmount: number;
    /** 买家 */
    buyerName: string | undefined;
    /** 推广来源 */
    generalizeSource: string | undefined;
    /** 推广者 */
    generalizeName: string | undefined;
    /** 学习卡 */
    cardAmount: number;
    /** 平台红包 */
    platformHB: number;
    /** 实际付款 */
    practicalAmount: number;
    /** 支付方式 */
    payType: string | undefined;
    /** 第三方支付费用 */
    thirdPartyPayServiceCharge: number;
    /** 推广费用 */
    generalizeServiceCharge: number;
    /** 平台服务费 */
    platformServiceCharge: number;
    /** 实际收入 */
    realityAmount: number;
    /** 交易状态 */
    transactionStatus: string | undefined;
    /** 交易成功时间 */
    transactionSuccessDate: moment.Moment | undefined;
    /** 结算状态 */
    settleAccounts: string | undefined;
    /** 结算时间 */
    settleAccountsDate: moment.Moment | undefined;
    /** QQ已审核 */
    isChecked: boolean;
    /** 码云已审核 */
    isGiteeChecked: boolean;
    /** 平台 */
    platform: string | undefined;
}

export class NeteaseOrderInfoListDto implements INeteaseOrderInfoListDto {
    /** 订单编号 */
    orderNo: string | undefined;
    /** 创建时间 */
    orderDate: moment.Moment | undefined;
    /** 商品名称 */
    productName: string | undefined;
    /** 原价 */
    originalPrice: number;
    /** 现价 */
    transactionAmount: number;
    /** 买家 */
    buyerName: string | undefined;
    /** 支付方式 */
    payType: string | undefined;
    /** 实际收入 */
    realityAmount: number;
    /** 交易状态 */
    transactionStatus: string | undefined;
    /** QQ已审核 */
    isChecked: boolean;
    /** 码云已审核 */
    isGiteeChecked: boolean;
    /** 平台 */
    platform: string | undefined;
    id: number;

    constructor(data?: INeteaseOrderInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNo = _data["orderNo"];
            this.orderDate = _data["orderDate"] ? moment(_data["orderDate"].toString()) : <any>undefined;
            this.productName = _data["productName"];
            this.originalPrice = _data["originalPrice"];
            this.transactionAmount = _data["transactionAmount"];
            this.buyerName = _data["buyerName"];
            this.payType = _data["payType"];
            this.realityAmount = _data["realityAmount"];
            this.transactionStatus = _data["transactionStatus"];
            this.isChecked = _data["isChecked"];
            this.isGiteeChecked = _data["isGiteeChecked"];
            this.platform = _data["platform"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NeteaseOrderInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeteaseOrderInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["productName"] = this.productName;
        data["originalPrice"] = this.originalPrice;
        data["transactionAmount"] = this.transactionAmount;
        data["buyerName"] = this.buyerName;
        data["payType"] = this.payType;
        data["realityAmount"] = this.realityAmount;
        data["transactionStatus"] = this.transactionStatus;
        data["isChecked"] = this.isChecked;
        data["isGiteeChecked"] = this.isGiteeChecked;
        data["platform"] = this.platform;
        data["id"] = this.id;
        return data;
    }

    clone(): NeteaseOrderInfoListDto {
        const json = this.toJSON();
        let result = new NeteaseOrderInfoListDto();
        result.init(json);
        return result;
    }
}

export interface INeteaseOrderInfoListDto {
    /** 订单编号 */
    orderNo: string | undefined;
    /** 创建时间 */
    orderDate: moment.Moment | undefined;
    /** 商品名称 */
    productName: string | undefined;
    /** 原价 */
    originalPrice: number;
    /** 现价 */
    transactionAmount: number;
    /** 买家 */
    buyerName: string | undefined;
    /** 支付方式 */
    payType: string | undefined;
    /** 实际收入 */
    realityAmount: number;
    /** 交易状态 */
    transactionStatus: string | undefined;
    /** QQ已审核 */
    isChecked: boolean;
    /** 码云已审核 */
    isGiteeChecked: boolean;
    /** 平台 */
    platform: string | undefined;
    id: number;
}

export class PagedResultDtoOfNeteaseOrderInfoListDto implements IPagedResultDtoOfNeteaseOrderInfoListDto {
    totalCount: number;
    items: NeteaseOrderInfoListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNeteaseOrderInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NeteaseOrderInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNeteaseOrderInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNeteaseOrderInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfNeteaseOrderInfoListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNeteaseOrderInfoListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNeteaseOrderInfoListDto {
    totalCount: number;
    items: NeteaseOrderInfoListDto[] | undefined;
}

export class NeteaseOrderInfoStatisticsDto implements INeteaseOrderInfoStatisticsDto {
    /** 课程名称 */
    key: string | undefined;
    /** 实际收入 */
    value: number;
    /** 销售总额 */
    sum: number;
    /** 购买数量 */
    buyCount: number;
    /** 服务费(手续费) */
    readonly serviceCharge: number;

    constructor(data?: INeteaseOrderInfoStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.sum = _data["sum"];
            this.buyCount = _data["buyCount"];
            (<any>this).serviceCharge = _data["serviceCharge"];
        }
    }

    static fromJS(data: any): NeteaseOrderInfoStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeteaseOrderInfoStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["sum"] = this.sum;
        data["buyCount"] = this.buyCount;
        data["serviceCharge"] = this.serviceCharge;
        return data;
    }

    clone(): NeteaseOrderInfoStatisticsDto {
        const json = this.toJSON();
        let result = new NeteaseOrderInfoStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface INeteaseOrderInfoStatisticsDto {
    /** 课程名称 */
    key: string | undefined;
    /** 实际收入 */
    value: number;
    /** 销售总额 */
    sum: number;
    /** 购买数量 */
    buyCount: number;
    /** 服务费(手续费) */
    serviceCharge: number;
}

export class ListResultDtoOfNeteaseOrderInfoStatisticsDto implements IListResultDtoOfNeteaseOrderInfoStatisticsDto {
    items: NeteaseOrderInfoStatisticsDto[] | undefined;

    constructor(data?: IListResultDtoOfNeteaseOrderInfoStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NeteaseOrderInfoStatisticsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNeteaseOrderInfoStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNeteaseOrderInfoStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfNeteaseOrderInfoStatisticsDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfNeteaseOrderInfoStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfNeteaseOrderInfoStatisticsDto {
    items: NeteaseOrderInfoStatisticsDto[] | undefined;
}

/** 新闻中心的列表DTO QYB.QYBProduct.OA.News.News */
export class NewsEditDto implements INewsEditDto {
    id: number | undefined;
    /** 类型 (1:新闻 2:公告) */
    typeCode: string | undefined;
    /** 所属类别 */
    categoryCode: string | undefined;
    /** 完整标题 */
    fullHead: string | undefined;
    /** 副标题 */
    subtitle: string | undefined;
    /** 作者 */
    authorName: string | undefined;
    /** 编辑 */
    compileName: string | undefined;
    /** tag词 */
    tagWord: string | undefined;
    /** 关键字 */
    keyWord: string | undefined;
    /** 来源 */
    sourceName: string | undefined;
    /** 来源地址 */
    sourceAddress: string | undefined;
    /** 新闻内容 */
    newsContent: string | undefined;
    /** 浏览量 */
    pv: number | undefined;
    /** 发布时间 */
    releaseTime: moment.Moment | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 有效标志 */
    enabledMark: number | undefined;
    /** 通知公告类型(1：通知 2：公告) */
    noticeTypeCode: string | undefined;
    /** 推送部门 */
    sendDeptIds: string | undefined;
    /** 推送人员 */
    sendUserIds: string | undefined;
    /** 备注 */
    description: string | undefined;

    constructor(data?: INewsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeCode = _data["typeCode"];
            this.categoryCode = _data["categoryCode"];
            this.fullHead = _data["fullHead"];
            this.subtitle = _data["subtitle"];
            this.authorName = _data["authorName"];
            this.compileName = _data["compileName"];
            this.tagWord = _data["tagWord"];
            this.keyWord = _data["keyWord"];
            this.sourceName = _data["sourceName"];
            this.sourceAddress = _data["sourceAddress"];
            this.newsContent = _data["newsContent"];
            this.pv = _data["pv"];
            this.releaseTime = _data["releaseTime"] ? moment(_data["releaseTime"].toString()) : <any>undefined;
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.noticeTypeCode = _data["noticeTypeCode"];
            this.sendDeptIds = _data["sendDeptIds"];
            this.sendUserIds = _data["sendUserIds"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NewsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeCode"] = this.typeCode;
        data["categoryCode"] = this.categoryCode;
        data["fullHead"] = this.fullHead;
        data["subtitle"] = this.subtitle;
        data["authorName"] = this.authorName;
        data["compileName"] = this.compileName;
        data["tagWord"] = this.tagWord;
        data["keyWord"] = this.keyWord;
        data["sourceName"] = this.sourceName;
        data["sourceAddress"] = this.sourceAddress;
        data["newsContent"] = this.newsContent;
        data["pv"] = this.pv;
        data["releaseTime"] = this.releaseTime ? this.releaseTime.toISOString() : <any>undefined;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["noticeTypeCode"] = this.noticeTypeCode;
        data["sendDeptIds"] = this.sendDeptIds;
        data["sendUserIds"] = this.sendUserIds;
        data["description"] = this.description;
        return data;
    }

    clone(): NewsEditDto {
        const json = this.toJSON();
        let result = new NewsEditDto();
        result.init(json);
        return result;
    }
}

/** 新闻中心的列表DTO QYB.QYBProduct.OA.News.News */
export interface INewsEditDto {
    id: number | undefined;
    /** 类型 (1:新闻 2:公告) */
    typeCode: string | undefined;
    /** 所属类别 */
    categoryCode: string | undefined;
    /** 完整标题 */
    fullHead: string | undefined;
    /** 副标题 */
    subtitle: string | undefined;
    /** 作者 */
    authorName: string | undefined;
    /** 编辑 */
    compileName: string | undefined;
    /** tag词 */
    tagWord: string | undefined;
    /** 关键字 */
    keyWord: string | undefined;
    /** 来源 */
    sourceName: string | undefined;
    /** 来源地址 */
    sourceAddress: string | undefined;
    /** 新闻内容 */
    newsContent: string | undefined;
    /** 浏览量 */
    pv: number | undefined;
    /** 发布时间 */
    releaseTime: moment.Moment | undefined;
    /** 排序 */
    sortCode: number | undefined;
    /** 有效标志 */
    enabledMark: number | undefined;
    /** 通知公告类型(1：通知 2：公告) */
    noticeTypeCode: string | undefined;
    /** 推送部门 */
    sendDeptIds: string | undefined;
    /** 推送人员 */
    sendUserIds: string | undefined;
    /** 备注 */
    description: string | undefined;
}

export class CreateOrUpdateNewsInput implements ICreateOrUpdateNewsInput {
    news: NewsEditDto;
    departmentIds: string | undefined;

    constructor(data?: ICreateOrUpdateNewsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.news = new NewsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"] ? NewsEditDto.fromJS(_data["news"]) : new NewsEditDto();
            this.departmentIds = _data["departmentIds"];
        }
    }

    static fromJS(data: any): CreateOrUpdateNewsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNewsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        data["departmentIds"] = this.departmentIds;
        return data;
    }

    clone(): CreateOrUpdateNewsInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateNewsInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateNewsInput {
    news: NewsEditDto;
    departmentIds: string | undefined;
}

/** 新闻中心的列表DTO QYB.QYBProduct.OA.News.News */
export class NewsListDto implements INewsListDto {
    /** TypeId */
    typeCode: string | undefined;
    type: DataItemDetail;
    /** CategoryId */
    categoryCode: string | undefined;
    category: DataItemDetail;
    /** FullHead */
    fullHead: string | undefined;
    /** 副标题 */
    subtitle: string | undefined;
    /** AuthorName */
    authorName: string | undefined;
    /** CompileName */
    compileName: string | undefined;
    /** TagWord */
    tagWord: string | undefined;
    /** KeyWord */
    keyWord: string | undefined;
    /** SourceName */
    sourceName: string | undefined;
    /** SourceAddress */
    sourceAddress: string | undefined;
    /** NewsContent */
    newsContent: string | undefined;
    /** PV */
    pv: number | undefined;
    /** ReleaseTime */
    releaseTime: moment.Moment | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** NoticeTypeId */
    noticeTypeCode: string | undefined;
    noticeType: DataItemDetail;
    /** SendDeptIds */
    sendDeptIds: string | undefined;
    /** sendUserIds */
    sendUserIds: string | undefined;
    /** Description */
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number;

    constructor(data?: INewsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCode = _data["typeCode"];
            this.type = _data["type"] ? DataItemDetail.fromJS(_data["type"]) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.category = _data["category"] ? DataItemDetail.fromJS(_data["category"]) : <any>undefined;
            this.fullHead = _data["fullHead"];
            this.subtitle = _data["subtitle"];
            this.authorName = _data["authorName"];
            this.compileName = _data["compileName"];
            this.tagWord = _data["tagWord"];
            this.keyWord = _data["keyWord"];
            this.sourceName = _data["sourceName"];
            this.sourceAddress = _data["sourceAddress"];
            this.newsContent = _data["newsContent"];
            this.pv = _data["pv"];
            this.releaseTime = _data["releaseTime"] ? moment(_data["releaseTime"].toString()) : <any>undefined;
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.noticeTypeCode = _data["noticeTypeCode"];
            this.noticeType = _data["noticeType"] ? DataItemDetail.fromJS(_data["noticeType"]) : <any>undefined;
            this.sendDeptIds = _data["sendDeptIds"];
            this.sendUserIds = _data["sendUserIds"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NewsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCode"] = this.typeCode;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["fullHead"] = this.fullHead;
        data["subtitle"] = this.subtitle;
        data["authorName"] = this.authorName;
        data["compileName"] = this.compileName;
        data["tagWord"] = this.tagWord;
        data["keyWord"] = this.keyWord;
        data["sourceName"] = this.sourceName;
        data["sourceAddress"] = this.sourceAddress;
        data["newsContent"] = this.newsContent;
        data["pv"] = this.pv;
        data["releaseTime"] = this.releaseTime ? this.releaseTime.toISOString() : <any>undefined;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["noticeTypeCode"] = this.noticeTypeCode;
        data["noticeType"] = this.noticeType ? this.noticeType.toJSON() : <any>undefined;
        data["sendDeptIds"] = this.sendDeptIds;
        data["sendUserIds"] = this.sendUserIds;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): NewsListDto {
        const json = this.toJSON();
        let result = new NewsListDto();
        result.init(json);
        return result;
    }
}

/** 新闻中心的列表DTO QYB.QYBProduct.OA.News.News */
export interface INewsListDto {
    /** TypeId */
    typeCode: string | undefined;
    type: DataItemDetail;
    /** CategoryId */
    categoryCode: string | undefined;
    category: DataItemDetail;
    /** FullHead */
    fullHead: string | undefined;
    /** 副标题 */
    subtitle: string | undefined;
    /** AuthorName */
    authorName: string | undefined;
    /** CompileName */
    compileName: string | undefined;
    /** TagWord */
    tagWord: string | undefined;
    /** KeyWord */
    keyWord: string | undefined;
    /** SourceName */
    sourceName: string | undefined;
    /** SourceAddress */
    sourceAddress: string | undefined;
    /** NewsContent */
    newsContent: string | undefined;
    /** PV */
    pv: number | undefined;
    /** ReleaseTime */
    releaseTime: moment.Moment | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** NoticeTypeId */
    noticeTypeCode: string | undefined;
    noticeType: DataItemDetail;
    /** SendDeptIds */
    sendDeptIds: string | undefined;
    /** sendUserIds */
    sendUserIds: string | undefined;
    /** Description */
    description: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number;
}

/** 读取可编辑新闻中心的Dto */
export class GetNewsForEditOutput implements IGetNewsForEditOutput {
    news: NewsEditDto;
    /** 推送部门名称(通知公告) */
    depList: AbpOrganizationunitsExtendListDto[] | undefined;
    /** 推送人员名称(通知公告) */
    userNames: string | undefined;
    userIds: EmployeeListDto[] | undefined;
    /** 已读人员 */
    readUserList: string[] | undefined;
    /** 未读人员 */
    noReadUserList: string[] | undefined;

    constructor(data?: IGetNewsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"] ? NewsEditDto.fromJS(_data["news"]) : <any>undefined;
            if (Array.isArray(_data["depList"])) {
                this.depList = [] as any;
                for (let item of _data["depList"])
                    this.depList.push(AbpOrganizationunitsExtendListDto.fromJS(item));
            }
            this.userNames = _data["userNames"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(EmployeeListDto.fromJS(item));
            }
            if (Array.isArray(_data["readUserList"])) {
                this.readUserList = [] as any;
                for (let item of _data["readUserList"])
                    this.readUserList.push(item);
            }
            if (Array.isArray(_data["noReadUserList"])) {
                this.noReadUserList = [] as any;
                for (let item of _data["noReadUserList"])
                    this.noReadUserList.push(item);
            }
        }
    }

    static fromJS(data: any): GetNewsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        if (Array.isArray(this.depList)) {
            data["depList"] = [];
            for (let item of this.depList)
                data["depList"].push(item.toJSON());
        }
        data["userNames"] = this.userNames;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item.toJSON());
        }
        if (Array.isArray(this.readUserList)) {
            data["readUserList"] = [];
            for (let item of this.readUserList)
                data["readUserList"].push(item);
        }
        if (Array.isArray(this.noReadUserList)) {
            data["noReadUserList"] = [];
            for (let item of this.noReadUserList)
                data["noReadUserList"].push(item);
        }
        return data;
    }

    clone(): GetNewsForEditOutput {
        const json = this.toJSON();
        let result = new GetNewsForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑新闻中心的Dto */
export interface IGetNewsForEditOutput {
    news: NewsEditDto;
    /** 推送部门名称(通知公告) */
    depList: AbpOrganizationunitsExtendListDto[] | undefined;
    /** 推送人员名称(通知公告) */
    userNames: string | undefined;
    userIds: EmployeeListDto[] | undefined;
    /** 已读人员 */
    readUserList: string[] | undefined;
    /** 未读人员 */
    noReadUserList: string[] | undefined;
}

export class GetNewListDto implements IGetNewListDto {
    id: number | undefined;
    /** TypeId */
    typeCode: string | undefined;
    /** Type */
    typeName: string | undefined;
    /** CategoryId */
    categoryCode: string | undefined;
    /** Category */
    categoryName: string | undefined;
    /** FullHead */
    fullHead: string | undefined;
    /** 副标题 */
    subtitle: string | undefined;
    /** AuthorName */
    authorName: string | undefined;
    /** CompileName */
    compileName: string | undefined;
    /** TagWord */
    tagWord: string | undefined;
    /** KeyWord */
    keyWord: string | undefined;
    /** SourceName */
    sourceName: string | undefined;
    /** SourceAddress */
    sourceAddress: string | undefined;
    /** PV */
    pv: number | undefined;
    /** ReleaseTime */
    releaseTime: moment.Moment | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** NoticeTypeId */
    noticeTypeCode: string | undefined;
    /** NoticeType */
    noticeTypeName: string | undefined;
    /** SendDeptIds */
    sendDeptIds: string | undefined;
    /** sendUserIds */
    sendUserIds: string | undefined;
    /** Description */
    description: string | undefined;
    creationTime: moment.Moment | undefined;

    constructor(data?: IGetNewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeCode = _data["typeCode"];
            this.typeName = _data["typeName"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.fullHead = _data["fullHead"];
            this.subtitle = _data["subtitle"];
            this.authorName = _data["authorName"];
            this.compileName = _data["compileName"];
            this.tagWord = _data["tagWord"];
            this.keyWord = _data["keyWord"];
            this.sourceName = _data["sourceName"];
            this.sourceAddress = _data["sourceAddress"];
            this.pv = _data["pv"];
            this.releaseTime = _data["releaseTime"] ? moment(_data["releaseTime"].toString()) : <any>undefined;
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.noticeTypeCode = _data["noticeTypeCode"];
            this.noticeTypeName = _data["noticeTypeName"];
            this.sendDeptIds = _data["sendDeptIds"];
            this.sendUserIds = _data["sendUserIds"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeCode"] = this.typeCode;
        data["typeName"] = this.typeName;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["fullHead"] = this.fullHead;
        data["subtitle"] = this.subtitle;
        data["authorName"] = this.authorName;
        data["compileName"] = this.compileName;
        data["tagWord"] = this.tagWord;
        data["keyWord"] = this.keyWord;
        data["sourceName"] = this.sourceName;
        data["sourceAddress"] = this.sourceAddress;
        data["pv"] = this.pv;
        data["releaseTime"] = this.releaseTime ? this.releaseTime.toISOString() : <any>undefined;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["noticeTypeCode"] = this.noticeTypeCode;
        data["noticeTypeName"] = this.noticeTypeName;
        data["sendDeptIds"] = this.sendDeptIds;
        data["sendUserIds"] = this.sendUserIds;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetNewListDto {
        const json = this.toJSON();
        let result = new GetNewListDto();
        result.init(json);
        return result;
    }
}

export interface IGetNewListDto {
    id: number | undefined;
    /** TypeId */
    typeCode: string | undefined;
    /** Type */
    typeName: string | undefined;
    /** CategoryId */
    categoryCode: string | undefined;
    /** Category */
    categoryName: string | undefined;
    /** FullHead */
    fullHead: string | undefined;
    /** 副标题 */
    subtitle: string | undefined;
    /** AuthorName */
    authorName: string | undefined;
    /** CompileName */
    compileName: string | undefined;
    /** TagWord */
    tagWord: string | undefined;
    /** KeyWord */
    keyWord: string | undefined;
    /** SourceName */
    sourceName: string | undefined;
    /** SourceAddress */
    sourceAddress: string | undefined;
    /** PV */
    pv: number | undefined;
    /** ReleaseTime */
    releaseTime: moment.Moment | undefined;
    /** SortCode */
    sortCode: number | undefined;
    /** EnabledMark */
    enabledMark: number | undefined;
    /** NoticeTypeId */
    noticeTypeCode: string | undefined;
    /** NoticeType */
    noticeTypeName: string | undefined;
    /** SendDeptIds */
    sendDeptIds: string | undefined;
    /** sendUserIds */
    sendUserIds: string | undefined;
    /** Description */
    description: string | undefined;
    creationTime: moment.Moment | undefined;
}

export class PagedResultDtoOfGetNewListDto implements IPagedResultDtoOfGetNewListDto {
    totalCount: number;
    items: GetNewListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetNewListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetNewListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetNewListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetNewListDto {
    totalCount: number;
    items: GetNewListDto[] | undefined;
}

export class PagedResultDtoOfNewsListDto implements IPagedResultDtoOfNewsListDto {
    totalCount: number;
    items: NewsListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNewsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NewsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNewsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNewsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfNewsListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNewsListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNewsListDto {
    totalCount: number;
    items: NewsListDto[] | undefined;
}

export class News implements INews {
    typeCode: string | undefined;
    categoryCode: string | undefined;
    fullHead: string | undefined;
    subtitle: string | undefined;
    authorName: string | undefined;
    compileName: string | undefined;
    tagWord: string | undefined;
    keyWord: string | undefined;
    sourceName: string | undefined;
    sourceAddress: string | undefined;
    newsContent: string | undefined;
    pv: number | undefined;
    releaseTime: moment.Moment | undefined;
    sortCode: number | undefined;
    enabledMark: number | undefined;
    noticeTypeCode: string | undefined;
    sendDeptIds: string | undefined;
    sendUserIds: string | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeCode = _data["typeCode"];
            this.categoryCode = _data["categoryCode"];
            this.fullHead = _data["fullHead"];
            this.subtitle = _data["subtitle"];
            this.authorName = _data["authorName"];
            this.compileName = _data["compileName"];
            this.tagWord = _data["tagWord"];
            this.keyWord = _data["keyWord"];
            this.sourceName = _data["sourceName"];
            this.sourceAddress = _data["sourceAddress"];
            this.newsContent = _data["newsContent"];
            this.pv = _data["pv"];
            this.releaseTime = _data["releaseTime"] ? moment(_data["releaseTime"].toString()) : <any>undefined;
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.noticeTypeCode = _data["noticeTypeCode"];
            this.sendDeptIds = _data["sendDeptIds"];
            this.sendUserIds = _data["sendUserIds"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCode"] = this.typeCode;
        data["categoryCode"] = this.categoryCode;
        data["fullHead"] = this.fullHead;
        data["subtitle"] = this.subtitle;
        data["authorName"] = this.authorName;
        data["compileName"] = this.compileName;
        data["tagWord"] = this.tagWord;
        data["keyWord"] = this.keyWord;
        data["sourceName"] = this.sourceName;
        data["sourceAddress"] = this.sourceAddress;
        data["newsContent"] = this.newsContent;
        data["pv"] = this.pv;
        data["releaseTime"] = this.releaseTime ? this.releaseTime.toISOString() : <any>undefined;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["noticeTypeCode"] = this.noticeTypeCode;
        data["sendDeptIds"] = this.sendDeptIds;
        data["sendUserIds"] = this.sendUserIds;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): News {
        const json = this.toJSON();
        let result = new News();
        result.init(json);
        return result;
    }
}

export interface INews {
    typeCode: string | undefined;
    categoryCode: string | undefined;
    fullHead: string | undefined;
    subtitle: string | undefined;
    authorName: string | undefined;
    compileName: string | undefined;
    tagWord: string | undefined;
    keyWord: string | undefined;
    sourceName: string | undefined;
    sourceAddress: string | undefined;
    newsContent: string | undefined;
    pv: number | undefined;
    releaseTime: moment.Moment | undefined;
    sortCode: number | undefined;
    enabledMark: number | undefined;
    noticeTypeCode: string | undefined;
    sendDeptIds: string | undefined;
    sendUserIds: string | undefined;
    description: string | undefined;
    tenantId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    id: number;
}

/** 消息通知记录的列表DTO QYB.QYBProduct.OA.NoticSendRecord.NoticSendRecord */
export class NoticSendRecordListDto implements INoticSendRecordListDto {
    /** NewsId */
    newsId: number | undefined;
    news: News;
    /** ReceiveId */
    receiveId: number | undefined;
    receive: User;
    /** IsRead */
    isRead: boolean | undefined;
    /** ReadTime */
    readTime: moment.Moment | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;

    constructor(data?: INoticSendRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsId = _data["newsId"];
            this.news = _data["news"] ? News.fromJS(_data["news"]) : <any>undefined;
            this.receiveId = _data["receiveId"];
            this.receive = _data["receive"] ? User.fromJS(_data["receive"]) : <any>undefined;
            this.isRead = _data["isRead"];
            this.readTime = _data["readTime"] ? moment(_data["readTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NoticSendRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticSendRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsId"] = this.newsId;
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        data["receiveId"] = this.receiveId;
        data["receive"] = this.receive ? this.receive.toJSON() : <any>undefined;
        data["isRead"] = this.isRead;
        data["readTime"] = this.readTime ? this.readTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): NoticSendRecordListDto {
        const json = this.toJSON();
        let result = new NoticSendRecordListDto();
        result.init(json);
        return result;
    }
}

/** 消息通知记录的列表DTO QYB.QYBProduct.OA.NoticSendRecord.NoticSendRecord */
export interface INoticSendRecordListDto {
    /** NewsId */
    newsId: number | undefined;
    news: News;
    /** ReceiveId */
    receiveId: number | undefined;
    receive: User;
    /** IsRead */
    isRead: boolean | undefined;
    /** ReadTime */
    readTime: moment.Moment | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;
}

export class NoticInfoDto implements INoticInfoDto {
    news: NewsListDto;
    /** 已读清单 */
    readList: NoticSendRecordListDto[] | undefined;
    /** 未读清单 */
    notReadList: NoticSendRecordListDto[] | undefined;

    constructor(data?: INoticInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"] ? NewsListDto.fromJS(_data["news"]) : <any>undefined;
            if (Array.isArray(_data["readList"])) {
                this.readList = [] as any;
                for (let item of _data["readList"])
                    this.readList.push(NoticSendRecordListDto.fromJS(item));
            }
            if (Array.isArray(_data["notReadList"])) {
                this.notReadList = [] as any;
                for (let item of _data["notReadList"])
                    this.notReadList.push(NoticSendRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NoticInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        if (Array.isArray(this.readList)) {
            data["readList"] = [];
            for (let item of this.readList)
                data["readList"].push(item.toJSON());
        }
        if (Array.isArray(this.notReadList)) {
            data["notReadList"] = [];
            for (let item of this.notReadList)
                data["notReadList"].push(item.toJSON());
        }
        return data;
    }

    clone(): NoticInfoDto {
        const json = this.toJSON();
        let result = new NoticInfoDto();
        result.init(json);
        return result;
    }
}

export interface INoticInfoDto {
    news: NewsListDto;
    /** 已读清单 */
    readList: NoticSendRecordListDto[] | undefined;
    /** 未读清单 */
    notReadList: NoticSendRecordListDto[] | undefined;
}

/** 消息通知记录的列表DTO QYB.QYBProduct.OA.NoticSendRecord.NoticSendRecord */
export class NoticSendRecordEditDto implements INoticSendRecordEditDto {
    /** Id */
    id: number | undefined;
    /** NewsId */
    newsId: number | undefined;
    /** ReceiveId */
    receiveId: number | undefined;
    /** IsRead */
    isRead: boolean | undefined;
    /** ReadTime */
    readTime: moment.Moment | undefined;

    constructor(data?: INoticSendRecordEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newsId = _data["newsId"];
            this.receiveId = _data["receiveId"];
            this.isRead = _data["isRead"];
            this.readTime = _data["readTime"] ? moment(_data["readTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NoticSendRecordEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticSendRecordEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newsId"] = this.newsId;
        data["receiveId"] = this.receiveId;
        data["isRead"] = this.isRead;
        data["readTime"] = this.readTime ? this.readTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): NoticSendRecordEditDto {
        const json = this.toJSON();
        let result = new NoticSendRecordEditDto();
        result.init(json);
        return result;
    }
}

/** 消息通知记录的列表DTO QYB.QYBProduct.OA.NoticSendRecord.NoticSendRecord */
export interface INoticSendRecordEditDto {
    /** Id */
    id: number | undefined;
    /** NewsId */
    newsId: number | undefined;
    /** ReceiveId */
    receiveId: number | undefined;
    /** IsRead */
    isRead: boolean | undefined;
    /** ReadTime */
    readTime: moment.Moment | undefined;
}

export class CreateOrUpdateNoticSendRecordInput implements ICreateOrUpdateNoticSendRecordInput {
    noticSendRecord: NoticSendRecordEditDto;

    constructor(data?: ICreateOrUpdateNoticSendRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.noticSendRecord = new NoticSendRecordEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticSendRecord = _data["noticSendRecord"] ? NoticSendRecordEditDto.fromJS(_data["noticSendRecord"]) : new NoticSendRecordEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateNoticSendRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNoticSendRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticSendRecord"] = this.noticSendRecord ? this.noticSendRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateNoticSendRecordInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateNoticSendRecordInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateNoticSendRecordInput {
    noticSendRecord: NoticSendRecordEditDto;
}

/** 读取可编辑消息通知记录的Dto */
export class GetNoticSendRecordForEditOutput implements IGetNoticSendRecordForEditOutput {
    noticSendRecord: NoticSendRecordEditDto;

    constructor(data?: IGetNoticSendRecordForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticSendRecord = _data["noticSendRecord"] ? NoticSendRecordEditDto.fromJS(_data["noticSendRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNoticSendRecordForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNoticSendRecordForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticSendRecord"] = this.noticSendRecord ? this.noticSendRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetNoticSendRecordForEditOutput {
        const json = this.toJSON();
        let result = new GetNoticSendRecordForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑消息通知记录的Dto */
export interface IGetNoticSendRecordForEditOutput {
    noticSendRecord: NoticSendRecordEditDto;
}

export class PagedResultDtoOfNoticSendRecordListDto implements IPagedResultDtoOfNoticSendRecordListDto {
    totalCount: number;
    items: NoticSendRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNoticSendRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NoticSendRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNoticSendRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNoticSendRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfNoticSendRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNoticSendRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNoticSendRecordListDto {
    totalCount: number;
    items: NoticSendRecordListDto[] | undefined;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }

    clone(): NotificationSubscriptionWithDisplayNameDto {
        const json = this.toJSON();
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetNotificationSettingsOutput {
        const json = this.toJSON();
        let result = new GetNotificationSettingsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export enum UserNotificationState {
    Unread = <any>"Unread",
    Read = <any>"Read",
}

export class NotificationData implements INotificationData {
    readonly type: string | undefined;
    properties: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)[key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }

    clone(): NotificationData {
        const json = this.toJSON();
        let result = new NotificationData();
        result.init(json);
        return result;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = <any>"Info",
    Success = <any>"Success",
    Warn = <any>"Warn",
    Error = <any>"Error",
    Fatal = <any>"Fatal",
}

export class TenantNotification implements ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantNotification {
        const json = this.toJSON();
        let result = new TenantNotification();
        result.init(json);
        return result;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UserNotification {
        const json = this.toJSON();
        let result = new UserNotification();
        result.init(json);
        return result;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    /** 未阅读消息数量 */
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetNotificationsOutput {
        const json = this.toJSON();
        let result = new GetNotificationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetNotificationsOutput {
    /** 未阅读消息数量 */
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDtoOfGuid {
        const json = this.toJSON();
        let result = new EntityDtoOfGuid();
        result.init(json);
        return result;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }

    clone(): NotificationSubscriptionDto {
        const json = this.toJSON();
        let result = new NotificationSubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateNotificationSettingsInput {
        const json = this.toJSON();
        let result = new UpdateNotificationSettingsInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

/** 选项类型实体 */
export class OptionListEditDto implements IOptionListEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 展示形式 1.下拉 2.平铺 */
    displayForm: string | undefined;
    /** 是否快速点检 */
    isQuickCheck: boolean;

    constructor(data?: IOptionListEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayForm = _data["displayForm"];
            this.isQuickCheck = _data["isQuickCheck"];
        }
    }

    static fromJS(data: any): OptionListEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionListEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayForm"] = this.displayForm;
        data["isQuickCheck"] = this.isQuickCheck;
        return data;
    }

    clone(): OptionListEditDto {
        const json = this.toJSON();
        let result = new OptionListEditDto();
        result.init(json);
        return result;
    }
}

/** 选项类型实体 */
export interface IOptionListEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 展示形式 1.下拉 2.平铺 */
    displayForm: string | undefined;
    /** 是否快速点检 */
    isQuickCheck: boolean;
}

/** 选项类型详情实体 */
export class OptionListDetailEditDto implements IOptionListDetailEditDto {
    /** Id */
    id: number | undefined;
    /** 列表Id */
    optionListId: number;
    /** 名称 */
    name: string | undefined;
    /** 是否合格 */
    isQualified: boolean;
    /** 分值 */
    score: number;
    /** 背景色 Rgb配色 */
    backColor: string | undefined;
    /** 前景色 Rgb配色 */
    foreColor: string | undefined;

    constructor(data?: IOptionListDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.optionListId = _data["optionListId"];
            this.name = _data["name"];
            this.isQualified = _data["isQualified"];
            this.score = _data["score"];
            this.backColor = _data["backColor"];
            this.foreColor = _data["foreColor"];
        }
    }

    static fromJS(data: any): OptionListDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionListDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["optionListId"] = this.optionListId;
        data["name"] = this.name;
        data["isQualified"] = this.isQualified;
        data["score"] = this.score;
        data["backColor"] = this.backColor;
        data["foreColor"] = this.foreColor;
        return data;
    }

    clone(): OptionListDetailEditDto {
        const json = this.toJSON();
        let result = new OptionListDetailEditDto();
        result.init(json);
        return result;
    }
}

/** 选项类型详情实体 */
export interface IOptionListDetailEditDto {
    /** Id */
    id: number | undefined;
    /** 列表Id */
    optionListId: number;
    /** 名称 */
    name: string | undefined;
    /** 是否合格 */
    isQualified: boolean;
    /** 分值 */
    score: number;
    /** 背景色 Rgb配色 */
    backColor: string | undefined;
    /** 前景色 Rgb配色 */
    foreColor: string | undefined;
}

/** 选项类型列表实体 */
export class OptionListListDto implements IOptionListListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 展示形式 1.下拉 2.平铺 */
    displayForm: string | undefined;
    /** 是否快速点检 */
    isQuickCheck: boolean;

    constructor(data?: IOptionListListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayForm = _data["displayForm"];
            this.isQuickCheck = _data["isQuickCheck"];
        }
    }

    static fromJS(data: any): OptionListListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionListListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayForm"] = this.displayForm;
        data["isQuickCheck"] = this.isQuickCheck;
        return data;
    }

    clone(): OptionListListDto {
        const json = this.toJSON();
        let result = new OptionListListDto();
        result.init(json);
        return result;
    }
}

/** 选项类型列表实体 */
export interface IOptionListListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 展示形式 1.下拉 2.平铺 */
    displayForm: string | undefined;
    /** 是否快速点检 */
    isQuickCheck: boolean;
}

export class PagedResultDtoOfOptionListListDto implements IPagedResultDtoOfOptionListListDto {
    totalCount: number;
    items: OptionListListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOptionListListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OptionListListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOptionListListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOptionListListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOptionListListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOptionListListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOptionListListDto {
    totalCount: number;
    items: OptionListListDto[] | undefined;
}

export class PagedResultDtoOfOptionListDetailListDto implements IPagedResultDtoOfOptionListDetailListDto {
    totalCount: number;
    items: OptionListDetailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOptionListDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OptionListDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOptionListDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOptionListDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOptionListDetailListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOptionListDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOptionListDetailListDto {
    totalCount: number;
    items: OptionListDetailListDto[] | undefined;
}

export enum OrderStatusEnum {
    WaitForPayment = <any>"WaitForPayment",
    WaitForDelivery = <any>"WaitForDelivery",
    ChangeHands = <any>"ChangeHands",
    TradingClosed = <any>"TradingClosed",
}

export enum OrderSourceType {
    Product = <any>"Product",
    Course = <any>"Course",
}

export class OrderListDto implements IOrderListDto {
    /** 订单编码 */
    orderCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品助记码 */
    productCode: string | undefined;
    /** 价格 */
    price: number;
    /** 优惠 */
    discounts: number;
    /** 实付款 */
    actualPayment: number;
    status: OrderStatusEnum;
    /** 订单状态字符串 */
    statusStr: string | undefined;
    /** 产品的项目创建数量 */
    productCreateProjectCount: number;
    /** 产品的有效期 单位(天) */
    productIndate: number;
    /** 订单关联的UserName */
    userName: string | undefined;
    orderSourceType: OrderSourceType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IOrderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["orderCode"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.price = _data["price"];
            this.discounts = _data["discounts"];
            this.actualPayment = _data["actualPayment"];
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.productCreateProjectCount = _data["productCreateProjectCount"];
            this.productIndate = _data["productIndate"];
            this.userName = _data["userName"];
            this.orderSourceType = _data["orderSourceType"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["price"] = this.price;
        data["discounts"] = this.discounts;
        data["actualPayment"] = this.actualPayment;
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["productCreateProjectCount"] = this.productCreateProjectCount;
        data["productIndate"] = this.productIndate;
        data["userName"] = this.userName;
        data["orderSourceType"] = this.orderSourceType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderListDto {
        const json = this.toJSON();
        let result = new OrderListDto();
        result.init(json);
        return result;
    }
}

export interface IOrderListDto {
    /** 订单编码 */
    orderCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 产品助记码 */
    productCode: string | undefined;
    /** 价格 */
    price: number;
    /** 优惠 */
    discounts: number;
    /** 实付款 */
    actualPayment: number;
    status: OrderStatusEnum;
    /** 订单状态字符串 */
    statusStr: string | undefined;
    /** 产品的项目创建数量 */
    productCreateProjectCount: number;
    /** 产品的有效期 单位(天) */
    productIndate: number;
    /** 订单关联的UserName */
    userName: string | undefined;
    orderSourceType: OrderSourceType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PagedResultDtoOfOrderListDto implements IPagedResultDtoOfOrderListDto {
    totalCount: number;
    items: OrderListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrderListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderListDto {
    totalCount: number;
    items: OrderListDto[] | undefined;
}

/** 订单统计信息 */
export class OrderStatisticsDto implements IOrderStatisticsDto {
    /** 产品名称 */
    productName: string | undefined;
    /** 实际收入 */
    actualPayment: number;
    /** 按月统计 */
    yearMonth: string | undefined;
    /** 购买数量 */
    buyCount: number;
    orderSourceType: OrderSourceType;

    constructor(data?: IOrderStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.actualPayment = _data["actualPayment"];
            this.yearMonth = _data["yearMonth"];
            this.buyCount = _data["buyCount"];
            this.orderSourceType = _data["orderSourceType"];
        }
    }

    static fromJS(data: any): OrderStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["actualPayment"] = this.actualPayment;
        data["yearMonth"] = this.yearMonth;
        data["buyCount"] = this.buyCount;
        data["orderSourceType"] = this.orderSourceType;
        return data;
    }

    clone(): OrderStatisticsDto {
        const json = this.toJSON();
        let result = new OrderStatisticsDto();
        result.init(json);
        return result;
    }
}

/** 订单统计信息 */
export interface IOrderStatisticsDto {
    /** 产品名称 */
    productName: string | undefined;
    /** 实际收入 */
    actualPayment: number;
    /** 按月统计 */
    yearMonth: string | undefined;
    /** 购买数量 */
    buyCount: number;
    orderSourceType: OrderSourceType;
}

export class ListResultDtoOfOrderStatisticsDto implements IListResultDtoOfOrderStatisticsDto {
    items: OrderStatisticsDto[] | undefined;

    constructor(data?: IListResultDtoOfOrderStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderStatisticsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrderStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrderStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfOrderStatisticsDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfOrderStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfOrderStatisticsDto {
    items: OrderStatisticsDto[] | undefined;
}

export class UserCenterOrderListDto implements IUserCenterOrderListDto {
    /** 订单编码 */
    orderCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 价格 */
    price: number;
    /** 优惠 */
    discounts: number;
    /** 实付款 */
    actualPayment: number;
    status: OrderStatusEnum;
    /** 订单状态字符串 */
    statusStr: string | undefined;
    /** 产品的项目创建数量 */
    productCreateProjectCount: number;
    /** 产品的有效期 单位(天) */
    productIndate: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IUserCenterOrderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["orderCode"];
            this.productName = _data["productName"];
            this.price = _data["price"];
            this.discounts = _data["discounts"];
            this.actualPayment = _data["actualPayment"];
            this.status = _data["status"];
            this.statusStr = _data["statusStr"];
            this.productCreateProjectCount = _data["productCreateProjectCount"];
            this.productIndate = _data["productIndate"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCenterOrderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCenterOrderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["productName"] = this.productName;
        data["price"] = this.price;
        data["discounts"] = this.discounts;
        data["actualPayment"] = this.actualPayment;
        data["status"] = this.status;
        data["statusStr"] = this.statusStr;
        data["productCreateProjectCount"] = this.productCreateProjectCount;
        data["productIndate"] = this.productIndate;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserCenterOrderListDto {
        const json = this.toJSON();
        let result = new UserCenterOrderListDto();
        result.init(json);
        return result;
    }
}

export interface IUserCenterOrderListDto {
    /** 订单编码 */
    orderCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 价格 */
    price: number;
    /** 优惠 */
    discounts: number;
    /** 实付款 */
    actualPayment: number;
    status: OrderStatusEnum;
    /** 订单状态字符串 */
    statusStr: string | undefined;
    /** 产品的项目创建数量 */
    productCreateProjectCount: number;
    /** 产品的有效期 单位(天) */
    productIndate: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PagedResultDtoOfUserCenterOrderListDto implements IPagedResultDtoOfUserCenterOrderListDto {
    totalCount: number;
    items: UserCenterOrderListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCenterOrderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCenterOrderListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCenterOrderListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCenterOrderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserCenterOrderListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCenterOrderListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCenterOrderListDto {
    totalCount: number;
    items: UserCenterOrderListDto[] | undefined;
}

export class OrderEditPriceDto implements IOrderEditPriceDto {
    /** 实付金额 */
    actualPayment: number;
    id: string;

    constructor(data?: IOrderEditPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualPayment = _data["actualPayment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderEditPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEditPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualPayment"] = this.actualPayment;
        data["id"] = this.id;
        return data;
    }

    clone(): OrderEditPriceDto {
        const json = this.toJSON();
        let result = new OrderEditPriceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderEditPriceDto {
    /** 实付金额 */
    actualPayment: number;
    id: string;
}

export class OrderEditDto implements IOrderEditDto {
    /** Id */
    id: string;
    status: OrderStatusEnum;
    /** 产品的项目创建数量 */
    productCreateProjectCount: number;
    /** 产品的有效期 单位(天) */
    productIndate: number;
    orderSourceType: OrderSourceType;

    constructor(data?: IOrderEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.productCreateProjectCount = _data["productCreateProjectCount"];
            this.productIndate = _data["productIndate"];
            this.orderSourceType = _data["orderSourceType"];
        }
    }

    static fromJS(data: any): OrderEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["productCreateProjectCount"] = this.productCreateProjectCount;
        data["productIndate"] = this.productIndate;
        data["orderSourceType"] = this.orderSourceType;
        return data;
    }

    clone(): OrderEditDto {
        const json = this.toJSON();
        let result = new OrderEditDto();
        result.init(json);
        return result;
    }
}

export interface IOrderEditDto {
    /** Id */
    id: string;
    status: OrderStatusEnum;
    /** 产品的项目创建数量 */
    productCreateProjectCount: number;
    /** 产品的有效期 单位(天) */
    productIndate: number;
    orderSourceType: OrderSourceType;
}

export class OrgChartDto implements IOrgChartDto {
    /** 父级Id */
    pid: string | undefined;
    /** Id */
    id: string | undefined;
    /** 部门 */
    orgName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 性别 */
    sex: string | undefined;
    /** 图片 */
    image: string | undefined;
    /** 人数 */
    num: string | undefined;
    /** 人数总和 */
    numCount: number;
    /** 姓名 */
    name: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 用户Id */
    userId: number | undefined;

    constructor(data?: IOrgChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pid = _data["pid"];
            this.id = _data["id"];
            this.orgName = _data["orgName"];
            this.postName = _data["postName"];
            this.sex = _data["sex"];
            this.image = _data["image"];
            this.num = _data["num"];
            this.numCount = _data["numCount"];
            this.name = _data["name"];
            this.jobNumber = _data["jobNumber"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): OrgChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pid"] = this.pid;
        data["id"] = this.id;
        data["orgName"] = this.orgName;
        data["postName"] = this.postName;
        data["sex"] = this.sex;
        data["image"] = this.image;
        data["num"] = this.num;
        data["numCount"] = this.numCount;
        data["name"] = this.name;
        data["jobNumber"] = this.jobNumber;
        data["userId"] = this.userId;
        return data;
    }

    clone(): OrgChartDto {
        const json = this.toJSON();
        let result = new OrgChartDto();
        result.init(json);
        return result;
    }
}

export interface IOrgChartDto {
    /** 父级Id */
    pid: string | undefined;
    /** Id */
    id: string | undefined;
    /** 部门 */
    orgName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 性别 */
    sex: string | undefined;
    /** 图片 */
    image: string | undefined;
    /** 人数 */
    num: string | undefined;
    /** 人数总和 */
    numCount: number;
    /** 姓名 */
    name: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 用户Id */
    userId: number | undefined;
}

export class EmployeeQuitReportDto implements IEmployeeQuitReportDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    companyName: string | undefined;
    /** 一级部门 */
    oneDepartment: string | undefined;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 岗位 */
    orgPost: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
    /** 司龄 */
    workAge: number | undefined;
    /** 手机号 */
    mobile: string | undefined;

    constructor(data?: IEmployeeQuitReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.oneDepartment = _data["oneDepartment"];
            this.twoDepartment = _data["twoDepartment"];
            this.empType = _data["empType"];
            this.orgPost = _data["orgPost"];
            this.identityCard = _data["identityCard"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
            this.workAge = _data["workAge"];
            this.mobile = _data["mobile"];
        }
    }

    static fromJS(data: any): EmployeeQuitReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeQuitReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["oneDepartment"] = this.oneDepartment;
        data["twoDepartment"] = this.twoDepartment;
        data["empType"] = this.empType;
        data["orgPost"] = this.orgPost;
        data["identityCard"] = this.identityCard;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        data["workAge"] = this.workAge;
        data["mobile"] = this.mobile;
        return data;
    }

    clone(): EmployeeQuitReportDto {
        const json = this.toJSON();
        let result = new EmployeeQuitReportDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeQuitReportDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    companyName: string | undefined;
    /** 一级部门 */
    oneDepartment: string | undefined;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 岗位 */
    orgPost: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
    /** 司龄 */
    workAge: number | undefined;
    /** 手机号 */
    mobile: string | undefined;
}

export class NewEmployeeReportDto implements INewEmployeeReportDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    companyName: string | undefined;
    /** 一级部门 */
    oneDepartment: string | undefined;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 岗位 */
    orgPost: string | undefined;
    /** 招聘来源 */
    recruitmentSource: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** 性别 字典 Gender */
    gender: string | undefined;
    /** 生日-------------------新增 */
    birthday: moment.Moment | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
    /** 试用期结束日 */
    regularDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermCode: string | undefined;

    constructor(data?: INewEmployeeReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.oneDepartment = _data["oneDepartment"];
            this.twoDepartment = _data["twoDepartment"];
            this.empType = _data["empType"];
            this.orgPost = _data["orgPost"];
            this.recruitmentSource = _data["recruitmentSource"];
            this.identityCard = _data["identityCard"];
            this.gender = _data["gender"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.mobile = _data["mobile"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.probationMonth = _data["probationMonth"];
            this.regularDate = _data["regularDate"] ? moment(_data["regularDate"].toString()) : <any>undefined;
            this.dueTerm = _data["dueTerm"];
            this.isNotHaveFixedTermCode = _data["isNotHaveFixedTermCode"];
        }
    }

    static fromJS(data: any): NewEmployeeReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewEmployeeReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["oneDepartment"] = this.oneDepartment;
        data["twoDepartment"] = this.twoDepartment;
        data["empType"] = this.empType;
        data["orgPost"] = this.orgPost;
        data["recruitmentSource"] = this.recruitmentSource;
        data["identityCard"] = this.identityCard;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["mobile"] = this.mobile;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["probationMonth"] = this.probationMonth;
        data["regularDate"] = this.regularDate ? this.regularDate.toISOString() : <any>undefined;
        data["dueTerm"] = this.dueTerm;
        data["isNotHaveFixedTermCode"] = this.isNotHaveFixedTermCode;
        return data;
    }

    clone(): NewEmployeeReportDto {
        const json = this.toJSON();
        let result = new NewEmployeeReportDto();
        result.init(json);
        return result;
    }
}

export interface INewEmployeeReportDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司 */
    companyName: string | undefined;
    /** 一级部门 */
    oneDepartment: string | undefined;
    /** 二级部门 */
    twoDepartment: string | undefined;
    /** 员工类型 */
    empType: string | undefined;
    /** 岗位 */
    orgPost: string | undefined;
    /** 招聘来源 */
    recruitmentSource: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** 性别 字典 Gender */
    gender: string | undefined;
    /** 生日-------------------新增 */
    birthday: moment.Moment | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 试用期 */
    probationMonth: number | undefined;
    /** 试用期结束日 */
    regularDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermCode: string | undefined;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }

    clone(): RolesToOrganizationUnitInput {
        const json = this.toJSON();
        let result = new RolesToOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }

    clone(): UsersToOrganizationUnitInput {
        const json = this.toJSON();
        let result = new UsersToOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): CreateOrganizationUnitInput {
        const json = this.toJSON();
        let result = new CreateOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

/** 组织机构列表Dto */
export class OrganizationUnitListDto implements IOrganizationUnitListDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    sortCode: number | undefined;
    key: string | undefined;
    /** 父级Id */
    pId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 真实ID */
    realId: string[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IOrganizationUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.isVirtual = _data["isVirtual"];
            this.sortCode = _data["sortCode"];
            this.key = _data["key"];
            this.pId = _data["pId"];
            this.name = _data["name"];
            if (Array.isArray(_data["realId"])) {
                this.realId = [] as any;
                for (let item of _data["realId"])
                    this.realId.push(item);
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["isVirtual"] = this.isVirtual;
        data["sortCode"] = this.sortCode;
        data["key"] = this.key;
        data["pId"] = this.pId;
        data["name"] = this.name;
        if (Array.isArray(this.realId)) {
            data["realId"] = [];
            for (let item of this.realId)
                data["realId"].push(item);
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): OrganizationUnitListDto {
        const json = this.toJSON();
        let result = new OrganizationUnitListDto();
        result.init(json);
        return result;
    }
}

/** 组织机构列表Dto */
export interface IOrganizationUnitListDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    sortCode: number | undefined;
    key: string | undefined;
    /** 父级Id */
    pId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 真实ID */
    realId: string[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class FindUsersInput implements IFindUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filterText: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filterText = _data["filterText"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filterText"] = this.filterText;
        return data;
    }

    clone(): FindUsersInput {
        const json = this.toJSON();
        let result = new FindUsersInput();
        result.init(json);
        return result;
    }
}

export interface IFindUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filterText: string | undefined;
}

export class ListResultDtoOfOrganizationUnitListDto implements IListResultDtoOfOrganizationUnitListDto {
    items: OrganizationUnitListDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrganizationUnitListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfOrganizationUnitListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfOrganizationUnitListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfOrganizationUnitListDto {
    items: OrganizationUnitListDto[] | undefined;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? moment(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): OrganizationUnitRoleListDto {
        const json = this.toJSON();
        let result = new OrganizationUnitRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrganizationUnitRoleListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    realName: string | undefined;
    jobNumber: string | undefined;
    emailAddress: string | undefined;
    mobile: string | undefined;
    id: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.realName = _data["realName"];
            this.jobNumber = _data["jobNumber"];
            this.emailAddress = _data["emailAddress"];
            this.mobile = _data["mobile"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["realName"] = this.realName;
        data["jobNumber"] = this.jobNumber;
        data["emailAddress"] = this.emailAddress;
        data["mobile"] = this.mobile;
        data["id"] = this.id;
        return data;
    }

    clone(): OrganizationUnitUserListDto {
        const json = this.toJSON();
        let result = new OrganizationUnitUserListDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitUserListDto {
    realName: string | undefined;
    jobNumber: string | undefined;
    emailAddress: string | undefined;
    mobile: string | undefined;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrganizationUnitUserListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class UserToOrganizationUnitInput implements IUserToOrganizationUnitInput {
    userId: number;
    organizationUnitId: number;

    constructor(data?: IUserToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UserToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }

    clone(): UserToOrganizationUnitInput {
        const json = this.toJSON();
        let result = new UserToOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IUserToOrganizationUnitInput {
    userId: number;
    organizationUnitId: number;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }

    clone(): MoveOrganizationUnitInput {
        const json = this.toJSON();
        let result = new MoveOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class RoleToOrganizationUnitInput implements IRoleToOrganizationUnitInput {
    roleId: number;
    organizationUnitId: number;

    constructor(data?: IRoleToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RoleToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RoleToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }

    clone(): RoleToOrganizationUnitInput {
        const json = this.toJSON();
        let result = new RoleToOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IRoleToOrganizationUnitInput {
    roleId: number;
    organizationUnitId: number;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): UpdateOrganizationUnitInput {
        const json = this.toJSON();
        let result = new UpdateOrganizationUnitInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

/** 岗位的列表DTO QYB.QYBProduct.Organization.OrgPost.OrgPost */
export class OrgPostEditDto implements IOrgPostEditDto {
    /** Id */
    id: number | undefined;
    /** 上级主键 */
    parentId: number;
    /** 名称 */
    name: string | undefined;
    /** 编号 */
    enCode: string | undefined;
    /** 公司主键 */
    companyId: number;
    /** 部门主键 */
    departmentId: number;
    /** 员工种类一 */
    empKindOne: string | undefined;
    /** 员工种类二 */
    empKindTwo: string | undefined;
    /** 员工种类三 */
    empKindThree: string | undefined;
    /** 备注 */
    description: string | undefined;
    /** 排序码 */
    sortCode: number | undefined;

    constructor(data?: IOrgPostEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.enCode = _data["enCode"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.empKindOne = _data["empKindOne"];
            this.empKindTwo = _data["empKindTwo"];
            this.empKindThree = _data["empKindThree"];
            this.description = _data["description"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): OrgPostEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgPostEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["enCode"] = this.enCode;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["empKindOne"] = this.empKindOne;
        data["empKindTwo"] = this.empKindTwo;
        data["empKindThree"] = this.empKindThree;
        data["description"] = this.description;
        data["sortCode"] = this.sortCode;
        return data;
    }

    clone(): OrgPostEditDto {
        const json = this.toJSON();
        let result = new OrgPostEditDto();
        result.init(json);
        return result;
    }
}

/** 岗位的列表DTO QYB.QYBProduct.Organization.OrgPost.OrgPost */
export interface IOrgPostEditDto {
    /** Id */
    id: number | undefined;
    /** 上级主键 */
    parentId: number;
    /** 名称 */
    name: string | undefined;
    /** 编号 */
    enCode: string | undefined;
    /** 公司主键 */
    companyId: number;
    /** 部门主键 */
    departmentId: number;
    /** 员工种类一 */
    empKindOne: string | undefined;
    /** 员工种类二 */
    empKindTwo: string | undefined;
    /** 员工种类三 */
    empKindThree: string | undefined;
    /** 备注 */
    description: string | undefined;
    /** 排序码 */
    sortCode: number | undefined;
}

export class CreateOrUpdateOrgPostInput implements ICreateOrUpdateOrgPostInput {
    orgPost: OrgPostEditDto;

    constructor(data?: ICreateOrUpdateOrgPostInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orgPost = new OrgPostEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPost = _data["orgPost"] ? OrgPostEditDto.fromJS(_data["orgPost"]) : new OrgPostEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateOrgPostInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateOrgPostInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPost"] = this.orgPost ? this.orgPost.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateOrgPostInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateOrgPostInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateOrgPostInput {
    orgPost: OrgPostEditDto;
}

/** 岗位的列表DTO QYB.QYBProduct.Organization.OrgPost.OrgPost */
export class OrgPostListDto implements IOrgPostListDto {
    /** 上级主键 */
    parentId: number;
    /** 名称 */
    name: string | undefined;
    /** 编号 */
    enCode: string | undefined;
    /** 公司主键 */
    companyId: number;
    /** 部门主键 */
    departmentId: number;
    /** 员工种类一 */
    empKindOne: string | undefined;
    /** 员工种类二 */
    empKindTwo: string | undefined;
    /** 员工种类三 */
    empKindThree: string | undefined;
    /** 备注 */
    description: string | undefined;
    /** 排序码 */
    sortCode: number | undefined;
    id: number;

    constructor(data?: IOrgPostListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.enCode = _data["enCode"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.empKindOne = _data["empKindOne"];
            this.empKindTwo = _data["empKindTwo"];
            this.empKindThree = _data["empKindThree"];
            this.description = _data["description"];
            this.sortCode = _data["sortCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrgPostListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgPostListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["enCode"] = this.enCode;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["empKindOne"] = this.empKindOne;
        data["empKindTwo"] = this.empKindTwo;
        data["empKindThree"] = this.empKindThree;
        data["description"] = this.description;
        data["sortCode"] = this.sortCode;
        data["id"] = this.id;
        return data;
    }

    clone(): OrgPostListDto {
        const json = this.toJSON();
        let result = new OrgPostListDto();
        result.init(json);
        return result;
    }
}

/** 岗位的列表DTO QYB.QYBProduct.Organization.OrgPost.OrgPost */
export interface IOrgPostListDto {
    /** 上级主键 */
    parentId: number;
    /** 名称 */
    name: string | undefined;
    /** 编号 */
    enCode: string | undefined;
    /** 公司主键 */
    companyId: number;
    /** 部门主键 */
    departmentId: number;
    /** 员工种类一 */
    empKindOne: string | undefined;
    /** 员工种类二 */
    empKindTwo: string | undefined;
    /** 员工种类三 */
    empKindThree: string | undefined;
    /** 备注 */
    description: string | undefined;
    /** 排序码 */
    sortCode: number | undefined;
    id: number;
}

/** 读取可编辑岗位的Dto */
export class GetOrgPostForEditOutput implements IGetOrgPostForEditOutput {
    orgPost: OrgPostEditDto;

    constructor(data?: IGetOrgPostForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPost = _data["orgPost"] ? OrgPostEditDto.fromJS(_data["orgPost"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrgPostForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrgPostForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPost"] = this.orgPost ? this.orgPost.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetOrgPostForEditOutput {
        const json = this.toJSON();
        let result = new GetOrgPostForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑岗位的Dto */
export interface IGetOrgPostForEditOutput {
    orgPost: OrgPostEditDto;
}

export class PagedResultDtoOfOrgPostListDto implements IPagedResultDtoOfOrgPostListDto {
    totalCount: number;
    items: OrgPostListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrgPostListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrgPostListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrgPostListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrgPostListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrgPostListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrgPostListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrgPostListDto {
    totalCount: number;
    items: OrgPostListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Organization.PostGrade.OrgPostGrade */
export class OrgPostGradeEditDto implements IOrgPostGradeEditDto {
    /** Id */
    id: number | undefined;
    /** 岗位主键 */
    orgPostId: number;
    /** 等级名称 */
    gradeName: string | undefined;
    /** 底薪 */
    basePay: number | undefined;
    /** 主管加给 */
    managerAdd: number | undefined;
    /** 岗位津贴 */
    psotSubsidy: number | undefined;
    /** 技术津贴 */
    skillSubsidy: number | undefined;
    /** 加班工资 */
    overTimeSubsidy: number | undefined;
    /** 其他津贴 */
    otherSubsidy: number | undefined;
    /** 工资收入 */
    salaryIncome: number | undefined;
    /** 月度奖金 */
    monthlyBonus: number | undefined;
    /** 综合收入 */
    synthesisIncome: number | undefined;
    /** Description */
    description: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;

    constructor(data?: IOrgPostGradeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orgPostId = _data["orgPostId"];
            this.gradeName = _data["gradeName"];
            this.basePay = _data["basePay"];
            this.managerAdd = _data["managerAdd"];
            this.psotSubsidy = _data["psotSubsidy"];
            this.skillSubsidy = _data["skillSubsidy"];
            this.overTimeSubsidy = _data["overTimeSubsidy"];
            this.otherSubsidy = _data["otherSubsidy"];
            this.salaryIncome = _data["salaryIncome"];
            this.monthlyBonus = _data["monthlyBonus"];
            this.synthesisIncome = _data["synthesisIncome"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OrgPostGradeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgPostGradeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orgPostId"] = this.orgPostId;
        data["gradeName"] = this.gradeName;
        data["basePay"] = this.basePay;
        data["managerAdd"] = this.managerAdd;
        data["psotSubsidy"] = this.psotSubsidy;
        data["skillSubsidy"] = this.skillSubsidy;
        data["overTimeSubsidy"] = this.overTimeSubsidy;
        data["otherSubsidy"] = this.otherSubsidy;
        data["salaryIncome"] = this.salaryIncome;
        data["monthlyBonus"] = this.monthlyBonus;
        data["synthesisIncome"] = this.synthesisIncome;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): OrgPostGradeEditDto {
        const json = this.toJSON();
        let result = new OrgPostGradeEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.PostGrade.OrgPostGrade */
export interface IOrgPostGradeEditDto {
    /** Id */
    id: number | undefined;
    /** 岗位主键 */
    orgPostId: number;
    /** 等级名称 */
    gradeName: string | undefined;
    /** 底薪 */
    basePay: number | undefined;
    /** 主管加给 */
    managerAdd: number | undefined;
    /** 岗位津贴 */
    psotSubsidy: number | undefined;
    /** 技术津贴 */
    skillSubsidy: number | undefined;
    /** 加班工资 */
    overTimeSubsidy: number | undefined;
    /** 其他津贴 */
    otherSubsidy: number | undefined;
    /** 工资收入 */
    salaryIncome: number | undefined;
    /** 月度奖金 */
    monthlyBonus: number | undefined;
    /** 综合收入 */
    synthesisIncome: number | undefined;
    /** Description */
    description: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
}

export class CreateOrUpdateOrgPostGradeInput implements ICreateOrUpdateOrgPostGradeInput {
    orgPostGrade: OrgPostGradeEditDto;

    constructor(data?: ICreateOrUpdateOrgPostGradeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orgPostGrade = new OrgPostGradeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPostGrade = _data["orgPostGrade"] ? OrgPostGradeEditDto.fromJS(_data["orgPostGrade"]) : new OrgPostGradeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateOrgPostGradeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateOrgPostGradeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPostGrade"] = this.orgPostGrade ? this.orgPostGrade.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateOrgPostGradeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateOrgPostGradeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateOrgPostGradeInput {
    orgPostGrade: OrgPostGradeEditDto;
}

/** 的列表DTO QYB.QYBProduct.Organization.PostGrade.OrgPostGrade */
export class OrgPostGradeListDto implements IOrgPostGradeListDto {
    /** 岗位主键 */
    orgPostId: number;
    /** 等级名称 */
    gradeName: string | undefined;
    /** 底薪 */
    basePay: number | undefined;
    /** 主管加给 */
    managerAdd: number | undefined;
    /** 岗位津贴 */
    psotSubsidy: number | undefined;
    /** 技术津贴 */
    skillSubsidy: number | undefined;
    /** 加班工资 */
    overTimeSubsidy: number | undefined;
    /** 其他津贴 */
    otherSubsidy: number | undefined;
    /** 工资收入 */
    salaryIncome: number | undefined;
    /** 月度奖金 */
    monthlyBonus: number | undefined;
    /** 综合收入 */
    synthesisIncome: number | undefined;
    /** Description */
    description: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;

    constructor(data?: IOrgPostGradeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPostId = _data["orgPostId"];
            this.gradeName = _data["gradeName"];
            this.basePay = _data["basePay"];
            this.managerAdd = _data["managerAdd"];
            this.psotSubsidy = _data["psotSubsidy"];
            this.skillSubsidy = _data["skillSubsidy"];
            this.overTimeSubsidy = _data["overTimeSubsidy"];
            this.otherSubsidy = _data["otherSubsidy"];
            this.salaryIncome = _data["salaryIncome"];
            this.monthlyBonus = _data["monthlyBonus"];
            this.synthesisIncome = _data["synthesisIncome"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrgPostGradeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgPostGradeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPostId"] = this.orgPostId;
        data["gradeName"] = this.gradeName;
        data["basePay"] = this.basePay;
        data["managerAdd"] = this.managerAdd;
        data["psotSubsidy"] = this.psotSubsidy;
        data["skillSubsidy"] = this.skillSubsidy;
        data["overTimeSubsidy"] = this.overTimeSubsidy;
        data["otherSubsidy"] = this.otherSubsidy;
        data["salaryIncome"] = this.salaryIncome;
        data["monthlyBonus"] = this.monthlyBonus;
        data["synthesisIncome"] = this.synthesisIncome;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): OrgPostGradeListDto {
        const json = this.toJSON();
        let result = new OrgPostGradeListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.PostGrade.OrgPostGrade */
export interface IOrgPostGradeListDto {
    /** 岗位主键 */
    orgPostId: number;
    /** 等级名称 */
    gradeName: string | undefined;
    /** 底薪 */
    basePay: number | undefined;
    /** 主管加给 */
    managerAdd: number | undefined;
    /** 岗位津贴 */
    psotSubsidy: number | undefined;
    /** 技术津贴 */
    skillSubsidy: number | undefined;
    /** 加班工资 */
    overTimeSubsidy: number | undefined;
    /** 其他津贴 */
    otherSubsidy: number | undefined;
    /** 工资收入 */
    salaryIncome: number | undefined;
    /** 月度奖金 */
    monthlyBonus: number | undefined;
    /** 综合收入 */
    synthesisIncome: number | undefined;
    /** Description */
    description: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;
}

/** 读取可编辑的Dto */
export class GetOrgPostGradeForEditOutput implements IGetOrgPostGradeForEditOutput {
    orgPostGrade: OrgPostGradeEditDto;

    constructor(data?: IGetOrgPostGradeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPostGrade = _data["orgPostGrade"] ? OrgPostGradeEditDto.fromJS(_data["orgPostGrade"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrgPostGradeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrgPostGradeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPostGrade"] = this.orgPostGrade ? this.orgPostGrade.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetOrgPostGradeForEditOutput {
        const json = this.toJSON();
        let result = new GetOrgPostGradeForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetOrgPostGradeForEditOutput {
    orgPostGrade: OrgPostGradeEditDto;
}

export class PagedResultDtoOfOrgPostGradeListDto implements IPagedResultDtoOfOrgPostGradeListDto {
    totalCount: number;
    items: OrgPostGradeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrgPostGradeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrgPostGradeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrgPostGradeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrgPostGradeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOrgPostGradeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrgPostGradeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrgPostGradeListDto {
    totalCount: number;
    items: OrgPostGradeListDto[] | undefined;
}

export class CheckSecuritySettingDto implements ICheckSecuritySettingDto {
    isCheckError: boolean;
    lastUpdatePassDate: moment.Moment | undefined;

    constructor(data?: ICheckSecuritySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCheckError = _data["isCheckError"];
            this.lastUpdatePassDate = _data["lastUpdatePassDate"] ? moment(_data["lastUpdatePassDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckSecuritySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSecuritySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCheckError"] = this.isCheckError;
        data["lastUpdatePassDate"] = this.lastUpdatePassDate ? this.lastUpdatePassDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CheckSecuritySettingDto {
        const json = this.toJSON();
        let result = new CheckSecuritySettingDto();
        result.init(json);
        return result;
    }
}

export interface ICheckSecuritySettingDto {
    isCheckError: boolean;
    lastUpdatePassDate: moment.Moment | undefined;
}

export class DicItemDto implements IDicItemDto {
    parentId: number;
    /** 文本 */
    text: string | undefined;
    /** 值 */
    value: string | undefined;

    constructor(data?: IDicItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DicItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DicItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): DicItemDto {
        const json = this.toJSON();
        let result = new DicItemDto();
        result.init(json);
        return result;
    }
}

export interface IDicItemDto {
    parentId: number;
    /** 文本 */
    text: string | undefined;
    /** 值 */
    value: string | undefined;
}

export class GetCompanyListDto implements IGetCompanyListDto {
    name: string | undefined;
    parentId: string | undefined;

    constructor(data?: IGetCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): GetCompanyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): GetCompanyListDto {
        const json = this.toJSON();
        let result = new GetCompanyListDto();
        result.init(json);
        return result;
    }
}

export interface IGetCompanyListDto {
    name: string | undefined;
    parentId: string | undefined;
}

export class GetDepartmentListDto implements IGetDepartmentListDto {
    id: string | undefined;
    companyId: string | undefined;
    name: string | undefined;
    parentId: string | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 排序码 */
    sortCode: number | undefined;

    constructor(data?: IGetDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.isVirtual = _data["isVirtual"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): GetDepartmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["isVirtual"] = this.isVirtual;
        data["sortCode"] = this.sortCode;
        return data;
    }

    clone(): GetDepartmentListDto {
        const json = this.toJSON();
        let result = new GetDepartmentListDto();
        result.init(json);
        return result;
    }
}

export interface IGetDepartmentListDto {
    id: string | undefined;
    companyId: string | undefined;
    name: string | undefined;
    parentId: string | undefined;
    /** 是否为虚拟部门 */
    isVirtual: boolean;
    /** 排序码 */
    sortCode: number | undefined;
}

export class DicDtoOfGetDepartmentListDto implements IDicDtoOfGetDepartmentListDto {
    data: GetDepartmentListDto[] | undefined;
    dic: { [key: string]: GetDepartmentListDto; } | undefined;

    constructor(data?: IDicDtoOfGetDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(GetDepartmentListDto.fromJS(item));
            }
            if (_data["dic"]) {
                this.dic = {} as any;
                for (let key in _data["dic"]) {
                    if (_data["dic"].hasOwnProperty(key))
                        (<any>this.dic)[key] = _data["dic"][key] ? GetDepartmentListDto.fromJS(_data["dic"][key]) : new GetDepartmentListDto();
                }
            }
        }
    }

    static fromJS(data: any): DicDtoOfGetDepartmentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DicDtoOfGetDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.dic) {
            data["dic"] = {};
            for (let key in this.dic) {
                if (this.dic.hasOwnProperty(key))
                    (<any>data["dic"])[key] = this.dic[key] ? this.dic[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): DicDtoOfGetDepartmentListDto {
        const json = this.toJSON();
        let result = new DicDtoOfGetDepartmentListDto();
        result.init(json);
        return result;
    }
}

export interface IDicDtoOfGetDepartmentListDto {
    data: GetDepartmentListDto[] | undefined;
    dic: { [key: string]: GetDepartmentListDto; } | undefined;
}

export class GetUserListDto implements IGetUserListDto {
    /** 账号 */
    account: string | undefined;
    /** 账号Id */
    userId: number | undefined;
    /** 公司Id */
    companyId: string | undefined;
    /** 部门Id */
    departmentId: string | undefined;
    /** 图片 */
    img: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 头像类型 */
    imgType: string | undefined;
    /** 工号 */
    staffCode: string | undefined;
    /** 员工Id */
    empId: number | undefined;
    /** 性别 字典 Gender */
    genderCode: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;

    constructor(data?: IGetUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.account = _data["account"];
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.img = _data["img"];
            this.name = _data["name"];
            this.postId = _data["postId"];
            this.postName = _data["postName"];
            this.imgType = _data["imgType"];
            this.staffCode = _data["staffCode"];
            this.empId = _data["empId"];
            this.genderCode = _data["genderCode"];
            this.mobile = _data["mobile"];
            this.jobNumber = _data["jobNumber"];
        }
    }

    static fromJS(data: any): GetUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["img"] = this.img;
        data["name"] = this.name;
        data["postId"] = this.postId;
        data["postName"] = this.postName;
        data["imgType"] = this.imgType;
        data["staffCode"] = this.staffCode;
        data["empId"] = this.empId;
        data["genderCode"] = this.genderCode;
        data["mobile"] = this.mobile;
        data["jobNumber"] = this.jobNumber;
        return data;
    }

    clone(): GetUserListDto {
        const json = this.toJSON();
        let result = new GetUserListDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserListDto {
    /** 账号 */
    account: string | undefined;
    /** 账号Id */
    userId: number | undefined;
    /** 公司Id */
    companyId: string | undefined;
    /** 部门Id */
    departmentId: string | undefined;
    /** 图片 */
    img: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 头像类型 */
    imgType: string | undefined;
    /** 工号 */
    staffCode: string | undefined;
    /** 员工Id */
    empId: number | undefined;
    /** 性别 字典 Gender */
    genderCode: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
}

export class DicDtoOfGetUserListDto implements IDicDtoOfGetUserListDto {
    data: GetUserListDto[] | undefined;
    dic: { [key: string]: GetUserListDto; } | undefined;

    constructor(data?: IDicDtoOfGetUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(GetUserListDto.fromJS(item));
            }
            if (_data["dic"]) {
                this.dic = {} as any;
                for (let key in _data["dic"]) {
                    if (_data["dic"].hasOwnProperty(key))
                        (<any>this.dic)[key] = _data["dic"][key] ? GetUserListDto.fromJS(_data["dic"][key]) : new GetUserListDto();
                }
            }
        }
    }

    static fromJS(data: any): DicDtoOfGetUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DicDtoOfGetUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.dic) {
            data["dic"] = {};
            for (let key in this.dic) {
                if (this.dic.hasOwnProperty(key))
                    (<any>data["dic"])[key] = this.dic[key] ? this.dic[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): DicDtoOfGetUserListDto {
        const json = this.toJSON();
        let result = new DicDtoOfGetUserListDto();
        result.init(json);
        return result;
    }
}

export interface IDicDtoOfGetUserListDto {
    data: GetUserListDto[] | undefined;
    dic: { [key: string]: GetUserListDto; } | undefined;
}

export class GetPostListDto implements IGetPostListDto {
    id: string | undefined;
    name: string | undefined;
    companyId: string | undefined;
    departmentId: string | undefined;

    constructor(data?: IGetPostListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): GetPostListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        return data;
    }

    clone(): GetPostListDto {
        const json = this.toJSON();
        let result = new GetPostListDto();
        result.init(json);
        return result;
    }
}

export interface IGetPostListDto {
    id: string | undefined;
    name: string | undefined;
    companyId: string | undefined;
    departmentId: string | undefined;
}

export class OrgAllDto implements IOrgAllDto {
    /** 是否展开，默认展开 */
    show: boolean;
    /** 是否打开，默认不打开 */
    open: boolean;
    /** 是否虚拟 */
    isVirtual: boolean;
    /** ID */
    id: string | undefined;
    /** 父级Id */
    pId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 类型 */
    type: string | undefined;
    /** 排序 */
    sort: number;
    /** 真实Id */
    realId: string[] | undefined;
    /** 子 */
    children: OrgAllDto[] | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 账号ID */
    userId: string | undefined;
    /** 账号 */
    userName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 性别 字典 Gender */
    genderCode: string | undefined;
    /** 公司Id */
    companyId: string | undefined;
    /** 部门Id */
    departmentId: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
    /** 头像 */
    img: string | undefined;
    /** 关键字 */
    key: number;

    constructor(data?: IOrgAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.show = _data["show"];
            this.open = _data["open"];
            this.isVirtual = _data["isVirtual"];
            this.id = _data["id"];
            this.pId = _data["pId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.sort = _data["sort"];
            if (Array.isArray(_data["realId"])) {
                this.realId = [] as any;
                for (let item of _data["realId"])
                    this.realId.push(item);
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(OrgAllDto.fromJS(item));
            }
            this.postName = _data["postName"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.jobNumber = _data["jobNumber"];
            this.mobile = _data["mobile"];
            this.realName = _data["realName"];
            this.genderCode = _data["genderCode"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.postId = _data["postId"];
            this.img = _data["img"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): OrgAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrgAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["show"] = this.show;
        data["open"] = this.open;
        data["isVirtual"] = this.isVirtual;
        data["id"] = this.id;
        data["pId"] = this.pId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["sort"] = this.sort;
        if (Array.isArray(this.realId)) {
            data["realId"] = [];
            for (let item of this.realId)
                data["realId"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["postName"] = this.postName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["jobNumber"] = this.jobNumber;
        data["mobile"] = this.mobile;
        data["realName"] = this.realName;
        data["genderCode"] = this.genderCode;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["postId"] = this.postId;
        data["img"] = this.img;
        data["key"] = this.key;
        return data;
    }

    clone(): OrgAllDto {
        const json = this.toJSON();
        let result = new OrgAllDto();
        result.init(json);
        return result;
    }
}

export interface IOrgAllDto {
    /** 是否展开，默认展开 */
    show: boolean;
    /** 是否打开，默认不打开 */
    open: boolean;
    /** 是否虚拟 */
    isVirtual: boolean;
    /** ID */
    id: string | undefined;
    /** 父级Id */
    pId: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 类型 */
    type: string | undefined;
    /** 排序 */
    sort: number;
    /** 真实Id */
    realId: string[] | undefined;
    /** 子 */
    children: OrgAllDto[] | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 账号ID */
    userId: string | undefined;
    /** 账号 */
    userName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 性别 字典 Gender */
    genderCode: string | undefined;
    /** 公司Id */
    companyId: string | undefined;
    /** 部门Id */
    departmentId: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
    /** 头像 */
    img: string | undefined;
    /** 关键字 */
    key: number;
}

/** 的列表DTO QYB.QYBProduct.Attendance.OverTimeRecord.OverTimeRecord */
export class OverTimeRecordEditDto implements IOverTimeRecordEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    empId: number;
    /** FromGuid */
    fromGuid: string | undefined;
    /** OverTimeType */
    overTimeType: string | undefined;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** OverTimeHours */
    overTimeHours: number | undefined;
    /** DeclareWay */
    declareWay: string | undefined;
    /** ShiftCode */
    shiftCode: string | undefined;
    /** 加班班次日期 */
    shiftDate: moment.Moment | undefined;
    /** Reason */
    reason: string | undefined;

    constructor(data?: IOverTimeRecordEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.fromGuid = _data["fromGuid"];
            this.overTimeType = _data["overTimeType"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.overTimeHours = _data["overTimeHours"];
            this.declareWay = _data["declareWay"];
            this.shiftCode = _data["shiftCode"];
            this.shiftDate = _data["shiftDate"] ? moment(_data["shiftDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): OverTimeRecordEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverTimeRecordEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["fromGuid"] = this.fromGuid;
        data["overTimeType"] = this.overTimeType;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["overTimeHours"] = this.overTimeHours;
        data["declareWay"] = this.declareWay;
        data["shiftCode"] = this.shiftCode;
        data["shiftDate"] = this.shiftDate ? this.shiftDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }

    clone(): OverTimeRecordEditDto {
        const json = this.toJSON();
        let result = new OverTimeRecordEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.OverTimeRecord.OverTimeRecord */
export interface IOverTimeRecordEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    empId: number;
    /** FromGuid */
    fromGuid: string | undefined;
    /** OverTimeType */
    overTimeType: string | undefined;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** OverTimeHours */
    overTimeHours: number | undefined;
    /** DeclareWay */
    declareWay: string | undefined;
    /** ShiftCode */
    shiftCode: string | undefined;
    /** 加班班次日期 */
    shiftDate: moment.Moment | undefined;
    /** Reason */
    reason: string | undefined;
}

export class CreateOrUpdateOverTimeRecordInput implements ICreateOrUpdateOverTimeRecordInput {
    overTimeRecord: OverTimeRecordEditDto;

    constructor(data?: ICreateOrUpdateOverTimeRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.overTimeRecord = new OverTimeRecordEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overTimeRecord = _data["overTimeRecord"] ? OverTimeRecordEditDto.fromJS(_data["overTimeRecord"]) : new OverTimeRecordEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateOverTimeRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateOverTimeRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overTimeRecord"] = this.overTimeRecord ? this.overTimeRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateOverTimeRecordInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateOverTimeRecordInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateOverTimeRecordInput {
    overTimeRecord: OverTimeRecordEditDto;
}

/** 的列表DTO QYB.QYBProduct.Attendance.OverTimeRecord.OverTimeRecord */
export class OverTimeRecordListDto implements IOverTimeRecordListDto {
    /** UserId */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** OverTimeType */
    overTimeType: string | undefined;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** OverTimeHours */
    overTimeHours: number | undefined;
    /** DeclareWay */
    declareWay: string | undefined;
    /** ShiftCode */
    shiftCode: string | undefined;
    /** 加班班次日期 */
    shiftDate: moment.Moment | undefined;
    /** Reason */
    reason: string | undefined;
    id: number;

    constructor(data?: IOverTimeRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.fromGuid = _data["fromGuid"];
            this.overTimeType = _data["overTimeType"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.overTimeHours = _data["overTimeHours"];
            this.declareWay = _data["declareWay"];
            this.shiftCode = _data["shiftCode"];
            this.shiftDate = _data["shiftDate"] ? moment(_data["shiftDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OverTimeRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverTimeRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["fromGuid"] = this.fromGuid;
        data["overTimeType"] = this.overTimeType;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["overTimeHours"] = this.overTimeHours;
        data["declareWay"] = this.declareWay;
        data["shiftCode"] = this.shiftCode;
        data["shiftDate"] = this.shiftDate ? this.shiftDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["id"] = this.id;
        return data;
    }

    clone(): OverTimeRecordListDto {
        const json = this.toJSON();
        let result = new OverTimeRecordListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.OverTimeRecord.OverTimeRecord */
export interface IOverTimeRecordListDto {
    /** UserId */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** OverTimeType */
    overTimeType: string | undefined;
    /** StartTime */
    startTime: moment.Moment;
    /** EndTime */
    endTime: moment.Moment;
    /** OverTimeHours */
    overTimeHours: number | undefined;
    /** DeclareWay */
    declareWay: string | undefined;
    /** ShiftCode */
    shiftCode: string | undefined;
    /** 加班班次日期 */
    shiftDate: moment.Moment | undefined;
    /** Reason */
    reason: string | undefined;
    id: number;
}

/** 超过最大加班时数Dto */
export class ExceedMaxOverTimeNumberListDto implements IExceedMaxOverTimeNumberListDto {
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** 加班合计/时 */
    overTimeCount: number;

    constructor(data?: IExceedMaxOverTimeNumberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.overTimeCount = _data["overTimeCount"];
        }
    }

    static fromJS(data: any): ExceedMaxOverTimeNumberListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExceedMaxOverTimeNumberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["overTimeCount"] = this.overTimeCount;
        return data;
    }

    clone(): ExceedMaxOverTimeNumberListDto {
        const json = this.toJSON();
        let result = new ExceedMaxOverTimeNumberListDto();
        result.init(json);
        return result;
    }
}

/** 超过最大加班时数Dto */
export interface IExceedMaxOverTimeNumberListDto {
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** 加班合计/时 */
    overTimeCount: number;
}

export class PagedResultDtoOfExceedMaxOverTimeNumberListDto implements IPagedResultDtoOfExceedMaxOverTimeNumberListDto {
    totalCount: number;
    items: ExceedMaxOverTimeNumberListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfExceedMaxOverTimeNumberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ExceedMaxOverTimeNumberListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfExceedMaxOverTimeNumberListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfExceedMaxOverTimeNumberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfExceedMaxOverTimeNumberListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfExceedMaxOverTimeNumberListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfExceedMaxOverTimeNumberListDto {
    totalCount: number;
    items: ExceedMaxOverTimeNumberListDto[] | undefined;
}

/** 读取可编辑的Dto */
export class GetOverTimeRecordForEditOutput implements IGetOverTimeRecordForEditOutput {
    overTimeRecord: OverTimeRecordEditDto;

    constructor(data?: IGetOverTimeRecordForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overTimeRecord = _data["overTimeRecord"] ? OverTimeRecordEditDto.fromJS(_data["overTimeRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOverTimeRecordForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOverTimeRecordForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overTimeRecord"] = this.overTimeRecord ? this.overTimeRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetOverTimeRecordForEditOutput {
        const json = this.toJSON();
        let result = new GetOverTimeRecordForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetOverTimeRecordForEditOutput {
    overTimeRecord: OverTimeRecordEditDto;
}

export class PagedResultDtoOfOverTimeRecordListDto implements IPagedResultDtoOfOverTimeRecordListDto {
    totalCount: number;
    items: OverTimeRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOverTimeRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OverTimeRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOverTimeRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOverTimeRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfOverTimeRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOverTimeRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOverTimeRecordListDto {
    totalCount: number;
    items: OverTimeRecordListDto[] | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }

    clone(): FlatPermissionWithLevelDto {
        const json = this.toJSON();
        let result = new FlatPermissionWithLevelDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfFlatPermissionWithLevelDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class TreePermissionDto implements ITreePermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    children: TreePermissionDto[] | undefined;
    checked: boolean;

    constructor(data?: ITreePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(TreePermissionDto.fromJS(item));
            }
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): TreePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["checked"] = this.checked;
        return data;
    }

    clone(): TreePermissionDto {
        const json = this.toJSON();
        let result = new TreePermissionDto();
        result.init(json);
        return result;
    }
}

export interface ITreePermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    children: TreePermissionDto[] | undefined;
    checked: boolean;
}

export class ListResultDtoOfTreePermissionDto implements IListResultDtoOfTreePermissionDto {
    items: TreePermissionDto[] | undefined;

    constructor(data?: IListResultDtoOfTreePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TreePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTreePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfTreePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfTreePermissionDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfTreePermissionDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfTreePermissionDto {
    items: TreePermissionDto[] | undefined;
}

/** 合同信息的列表DTO QYB.QYBProduct.Organization.PersonnelContracts.PersonnelContracts */
export class PersonnelContractsEditDto implements IPersonnelContractsEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 合同编号 */
    pcNumber: string | undefined;
    /** 合同类型 */
    pcTypeCode: string | undefined;
    /** 开始时间 */
    startDate: moment.Moment | undefined;
    /** 结束 */
    endDate: moment.Moment | undefined;
    /** 试用期开始时间 */
    probationStartDate: moment.Moment | undefined;
    /** 试用期结束时间 */
    probationEndDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermCode: string | undefined;
    /** 是否完成 */
    isCompleteCode: string | undefined;
    /** 档案所在地 */
    filesAddress: string | undefined;
    /** 签订方式 */
    signedModeCode: string | undefined;
    /** 备注 */
    description: string | undefined;

    constructor(data?: IPersonnelContractsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.pcNumber = _data["pcNumber"];
            this.pcTypeCode = _data["pcTypeCode"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.probationStartDate = _data["probationStartDate"] ? moment(_data["probationStartDate"].toString()) : <any>undefined;
            this.probationEndDate = _data["probationEndDate"] ? moment(_data["probationEndDate"].toString()) : <any>undefined;
            this.dueTerm = _data["dueTerm"];
            this.isNotHaveFixedTermCode = _data["isNotHaveFixedTermCode"];
            this.isCompleteCode = _data["isCompleteCode"];
            this.filesAddress = _data["filesAddress"];
            this.signedModeCode = _data["signedModeCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PersonnelContractsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonnelContractsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["pcNumber"] = this.pcNumber;
        data["pcTypeCode"] = this.pcTypeCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["probationStartDate"] = this.probationStartDate ? this.probationStartDate.toISOString() : <any>undefined;
        data["probationEndDate"] = this.probationEndDate ? this.probationEndDate.toISOString() : <any>undefined;
        data["dueTerm"] = this.dueTerm;
        data["isNotHaveFixedTermCode"] = this.isNotHaveFixedTermCode;
        data["isCompleteCode"] = this.isCompleteCode;
        data["filesAddress"] = this.filesAddress;
        data["signedModeCode"] = this.signedModeCode;
        data["description"] = this.description;
        return data;
    }

    clone(): PersonnelContractsEditDto {
        const json = this.toJSON();
        let result = new PersonnelContractsEditDto();
        result.init(json);
        return result;
    }
}

/** 合同信息的列表DTO QYB.QYBProduct.Organization.PersonnelContracts.PersonnelContracts */
export interface IPersonnelContractsEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 合同编号 */
    pcNumber: string | undefined;
    /** 合同类型 */
    pcTypeCode: string | undefined;
    /** 开始时间 */
    startDate: moment.Moment | undefined;
    /** 结束 */
    endDate: moment.Moment | undefined;
    /** 试用期开始时间 */
    probationStartDate: moment.Moment | undefined;
    /** 试用期结束时间 */
    probationEndDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermCode: string | undefined;
    /** 是否完成 */
    isCompleteCode: string | undefined;
    /** 档案所在地 */
    filesAddress: string | undefined;
    /** 签订方式 */
    signedModeCode: string | undefined;
    /** 备注 */
    description: string | undefined;
}

export class CreateOrUpdatePersonnelContractsInput implements ICreateOrUpdatePersonnelContractsInput {
    personnelContracts: PersonnelContractsEditDto;

    constructor(data?: ICreateOrUpdatePersonnelContractsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personnelContracts = new PersonnelContractsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personnelContracts = _data["personnelContracts"] ? PersonnelContractsEditDto.fromJS(_data["personnelContracts"]) : new PersonnelContractsEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePersonnelContractsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePersonnelContractsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personnelContracts"] = this.personnelContracts ? this.personnelContracts.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePersonnelContractsInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePersonnelContractsInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePersonnelContractsInput {
    personnelContracts: PersonnelContractsEditDto;
}

/** 合同信息的列表DTO QYB.QYBProduct.Organization.PersonnelContracts.PersonnelContracts */
export class PersonnelContractsListDto implements IPersonnelContractsListDto {
    /** 用户 */
    empId: number | undefined;
    /** 合同编号 */
    pcNumber: string | undefined;
    /** 合同类型 */
    pcTypeCode: string | undefined;
    pcTypeName: string | undefined;
    /** 开始时间 */
    startDate: moment.Moment | undefined;
    /** 结束 */
    endDate: moment.Moment | undefined;
    /** 试用期开始时间 */
    probationStartDate: moment.Moment | undefined;
    /** 试用期结束时间 */
    probationEndDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermCode: string | undefined;
    isNotHaveFixedTermName: string | undefined;
    /** 是否完成 */
    isCompleteCode: string | undefined;
    isCompleteName: string | undefined;
    /** 档案所在地 */
    filesAddress: string | undefined;
    /** 签订方式 */
    signedModeCode: string | undefined;
    signedModeName: string | undefined;
    /** 备注 */
    description: string | undefined;
    id: number;

    constructor(data?: IPersonnelContractsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.pcNumber = _data["pcNumber"];
            this.pcTypeCode = _data["pcTypeCode"];
            this.pcTypeName = _data["pcTypeName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.probationStartDate = _data["probationStartDate"] ? moment(_data["probationStartDate"].toString()) : <any>undefined;
            this.probationEndDate = _data["probationEndDate"] ? moment(_data["probationEndDate"].toString()) : <any>undefined;
            this.dueTerm = _data["dueTerm"];
            this.isNotHaveFixedTermCode = _data["isNotHaveFixedTermCode"];
            this.isNotHaveFixedTermName = _data["isNotHaveFixedTermName"];
            this.isCompleteCode = _data["isCompleteCode"];
            this.isCompleteName = _data["isCompleteName"];
            this.filesAddress = _data["filesAddress"];
            this.signedModeCode = _data["signedModeCode"];
            this.signedModeName = _data["signedModeName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonnelContractsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonnelContractsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["pcNumber"] = this.pcNumber;
        data["pcTypeCode"] = this.pcTypeCode;
        data["pcTypeName"] = this.pcTypeName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["probationStartDate"] = this.probationStartDate ? this.probationStartDate.toISOString() : <any>undefined;
        data["probationEndDate"] = this.probationEndDate ? this.probationEndDate.toISOString() : <any>undefined;
        data["dueTerm"] = this.dueTerm;
        data["isNotHaveFixedTermCode"] = this.isNotHaveFixedTermCode;
        data["isNotHaveFixedTermName"] = this.isNotHaveFixedTermName;
        data["isCompleteCode"] = this.isCompleteCode;
        data["isCompleteName"] = this.isCompleteName;
        data["filesAddress"] = this.filesAddress;
        data["signedModeCode"] = this.signedModeCode;
        data["signedModeName"] = this.signedModeName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PersonnelContractsListDto {
        const json = this.toJSON();
        let result = new PersonnelContractsListDto();
        result.init(json);
        return result;
    }
}

/** 合同信息的列表DTO QYB.QYBProduct.Organization.PersonnelContracts.PersonnelContracts */
export interface IPersonnelContractsListDto {
    /** 用户 */
    empId: number | undefined;
    /** 合同编号 */
    pcNumber: string | undefined;
    /** 合同类型 */
    pcTypeCode: string | undefined;
    pcTypeName: string | undefined;
    /** 开始时间 */
    startDate: moment.Moment | undefined;
    /** 结束 */
    endDate: moment.Moment | undefined;
    /** 试用期开始时间 */
    probationStartDate: moment.Moment | undefined;
    /** 试用期结束时间 */
    probationEndDate: moment.Moment | undefined;
    /** 合同期限 */
    dueTerm: number | undefined;
    /** 是否固定期 */
    isNotHaveFixedTermCode: string | undefined;
    isNotHaveFixedTermName: string | undefined;
    /** 是否完成 */
    isCompleteCode: string | undefined;
    isCompleteName: string | undefined;
    /** 档案所在地 */
    filesAddress: string | undefined;
    /** 签订方式 */
    signedModeCode: string | undefined;
    signedModeName: string | undefined;
    /** 备注 */
    description: string | undefined;
    id: number;
}

/** 读取可编辑合同信息的Dto */
export class GetPersonnelContractsForEditOutput implements IGetPersonnelContractsForEditOutput {
    personnelContracts: PersonnelContractsEditDto;

    constructor(data?: IGetPersonnelContractsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personnelContracts = _data["personnelContracts"] ? PersonnelContractsEditDto.fromJS(_data["personnelContracts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPersonnelContractsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonnelContractsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personnelContracts"] = this.personnelContracts ? this.personnelContracts.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetPersonnelContractsForEditOutput {
        const json = this.toJSON();
        let result = new GetPersonnelContractsForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑合同信息的Dto */
export interface IGetPersonnelContractsForEditOutput {
    personnelContracts: PersonnelContractsEditDto;
}

export class PagedResultDtoOfPersonnelContractsListDto implements IPagedResultDtoOfPersonnelContractsListDto {
    totalCount: number;
    items: PersonnelContractsListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPersonnelContractsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PersonnelContractsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPersonnelContractsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPersonnelContractsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfPersonnelContractsListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPersonnelContractsListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPersonnelContractsListDto {
    totalCount: number;
    items: PersonnelContractsListDto[] | undefined;
}

export class GetMonthViewDetailsInput implements IGetMonthViewDetailsInput {
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点 */
    selectTime: moment.Moment;
    /** 审核点 */
    hourOrDay: number;
    filterText: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IGetMonthViewDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditPointId = _data["auditPointId"];
            this.selectTime = _data["selectTime"] ? moment(_data["selectTime"].toString()) : <any>undefined;
            this.hourOrDay = _data["hourOrDay"];
            this.filterText = _data["filterText"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetMonthViewDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthViewDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditPointId"] = this.auditPointId;
        data["selectTime"] = this.selectTime ? this.selectTime.toISOString() : <any>undefined;
        data["hourOrDay"] = this.hourOrDay;
        data["filterText"] = this.filterText;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }

    clone(): GetMonthViewDetailsInput {
        const json = this.toJSON();
        let result = new GetMonthViewDetailsInput();
        result.init(json);
        return result;
    }
}

export interface IGetMonthViewDetailsInput {
    /** 审核点 */
    auditPointId: number | undefined;
    /** 审核点 */
    selectTime: moment.Moment;
    /** 审核点 */
    hourOrDay: number;
    filterText: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

/** 查询参数 */
export class GetPointCheckMonthViewInput implements IGetPointCheckMonthViewInput {
    /** 选择的是小时还是天  1.小时  2.天 */
    hourOrDay: number;
    /** 选择的天 */
    selectDayTime: moment.Moment;
    /** 选择的月 */
    selectMonthTime: moment.Moment;
    /** 小时开始时间 */
    timeRangeStartTime: moment.Moment | undefined;
    /** 小时结束时间 */
    timeRangeEndTime: moment.Moment | undefined;

    constructor(data?: IGetPointCheckMonthViewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourOrDay = _data["hourOrDay"];
            this.selectDayTime = _data["selectDayTime"] ? moment(_data["selectDayTime"].toString()) : <any>undefined;
            this.selectMonthTime = _data["selectMonthTime"] ? moment(_data["selectMonthTime"].toString()) : <any>undefined;
            this.timeRangeStartTime = _data["timeRangeStartTime"] ? moment(_data["timeRangeStartTime"].toString()) : <any>undefined;
            this.timeRangeEndTime = _data["timeRangeEndTime"] ? moment(_data["timeRangeEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPointCheckMonthViewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointCheckMonthViewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourOrDay"] = this.hourOrDay;
        data["selectDayTime"] = this.selectDayTime ? this.selectDayTime.toISOString() : <any>undefined;
        data["selectMonthTime"] = this.selectMonthTime ? this.selectMonthTime.toISOString() : <any>undefined;
        data["timeRangeStartTime"] = this.timeRangeStartTime ? this.timeRangeStartTime.toISOString() : <any>undefined;
        data["timeRangeEndTime"] = this.timeRangeEndTime ? this.timeRangeEndTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetPointCheckMonthViewInput {
        const json = this.toJSON();
        let result = new GetPointCheckMonthViewInput();
        result.init(json);
        return result;
    }
}

/** 查询参数 */
export interface IGetPointCheckMonthViewInput {
    /** 选择的是小时还是天  1.小时  2.天 */
    hourOrDay: number;
    /** 选择的天 */
    selectDayTime: moment.Moment;
    /** 选择的月 */
    selectMonthTime: moment.Moment;
    /** 小时开始时间 */
    timeRangeStartTime: moment.Moment | undefined;
    /** 小时结束时间 */
    timeRangeEndTime: moment.Moment | undefined;
}

export class ChirdPointCheckMonthViewListDto implements IChirdPointCheckMonthViewListDto {
    /** 时间 */
    time: moment.Moment;
    /** 打卡次数 */
    count: number;
    /** 点位 */
    auditPointId: number;
    /** 点位 */
    auditPointName: string | undefined;

    constructor(data?: IChirdPointCheckMonthViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
            this.count = _data["count"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
        }
    }

    static fromJS(data: any): ChirdPointCheckMonthViewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChirdPointCheckMonthViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["count"] = this.count;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        return data;
    }

    clone(): ChirdPointCheckMonthViewListDto {
        const json = this.toJSON();
        let result = new ChirdPointCheckMonthViewListDto();
        result.init(json);
        return result;
    }
}

export interface IChirdPointCheckMonthViewListDto {
    /** 时间 */
    time: moment.Moment;
    /** 打卡次数 */
    count: number;
    /** 点位 */
    auditPointId: number;
    /** 点位 */
    auditPointName: string | undefined;
}

/** 点位打卡月视图dto */
export class PointCheckMonthViewListDto implements IPointCheckMonthViewListDto {
    /** 时间 */
    time: moment.Moment;
    /** 打卡次数 */
    count: number;
    /** 点位 */
    auditPointId: number;
    /** 点位 */
    auditPointName: string | undefined;
    chirdPointCheckMonthViewDto: ChirdPointCheckMonthViewListDto;

    constructor(data?: IPointCheckMonthViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
            this.count = _data["count"];
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.chirdPointCheckMonthViewDto = _data["chirdPointCheckMonthViewDto"] ? ChirdPointCheckMonthViewListDto.fromJS(_data["chirdPointCheckMonthViewDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PointCheckMonthViewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointCheckMonthViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["count"] = this.count;
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["chirdPointCheckMonthViewDto"] = this.chirdPointCheckMonthViewDto ? this.chirdPointCheckMonthViewDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): PointCheckMonthViewListDto {
        const json = this.toJSON();
        let result = new PointCheckMonthViewListDto();
        result.init(json);
        return result;
    }
}

/** 点位打卡月视图dto */
export interface IPointCheckMonthViewListDto {
    /** 时间 */
    time: moment.Moment;
    /** 打卡次数 */
    count: number;
    /** 点位 */
    auditPointId: number;
    /** 点位 */
    auditPointName: string | undefined;
    chirdPointCheckMonthViewDto: ChirdPointCheckMonthViewListDto;
}

/** 包一层 */
export class ParPointCheckMonthViewListDto implements IParPointCheckMonthViewListDto {
    /** 点位 */
    auditPointId: number;
    /** 打卡记录 */
    pointCheckMonthView: PointCheckMonthViewListDto[] | undefined;

    constructor(data?: IParPointCheckMonthViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditPointId = _data["auditPointId"];
            if (Array.isArray(_data["pointCheckMonthView"])) {
                this.pointCheckMonthView = [] as any;
                for (let item of _data["pointCheckMonthView"])
                    this.pointCheckMonthView.push(PointCheckMonthViewListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParPointCheckMonthViewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParPointCheckMonthViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditPointId"] = this.auditPointId;
        if (Array.isArray(this.pointCheckMonthView)) {
            data["pointCheckMonthView"] = [];
            for (let item of this.pointCheckMonthView)
                data["pointCheckMonthView"].push(item.toJSON());
        }
        return data;
    }

    clone(): ParPointCheckMonthViewListDto {
        const json = this.toJSON();
        let result = new ParPointCheckMonthViewListDto();
        result.init(json);
        return result;
    }
}

/** 包一层 */
export interface IParPointCheckMonthViewListDto {
    /** 点位 */
    auditPointId: number;
    /** 打卡记录 */
    pointCheckMonthView: PointCheckMonthViewListDto[] | undefined;
}

export class GitlabPostsNavInput implements IGitlabPostsNavInput {
    pathWithNamespace: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    readonly fullPath: string | undefined;
    sercertCode: string | undefined;
    gitlabApiUrl: string | undefined;
    gitlabAccessToken: string | undefined;

    constructor(data?: IGitlabPostsNavInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pathWithNamespace = _data["pathWithNamespace"];
            this.filePath = _data["filePath"];
            this.fileName = _data["fileName"];
            (<any>this).fullPath = _data["fullPath"];
            this.sercertCode = _data["sercertCode"];
            this.gitlabApiUrl = _data["gitlabApiUrl"];
            this.gitlabAccessToken = _data["gitlabAccessToken"];
        }
    }

    static fromJS(data: any): GitlabPostsNavInput {
        data = typeof data === 'object' ? data : {};
        let result = new GitlabPostsNavInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pathWithNamespace"] = this.pathWithNamespace;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fullPath"] = this.fullPath;
        data["sercertCode"] = this.sercertCode;
        data["gitlabApiUrl"] = this.gitlabApiUrl;
        data["gitlabAccessToken"] = this.gitlabAccessToken;
        return data;
    }

    clone(): GitlabPostsNavInput {
        const json = this.toJSON();
        let result = new GitlabPostsNavInput();
        result.init(json);
        return result;
    }
}

export interface IGitlabPostsNavInput {
    pathWithNamespace: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    fullPath: string | undefined;
    sercertCode: string | undefined;
    gitlabApiUrl: string | undefined;
    gitlabAccessToken: string | undefined;
}

export class IHtmlContent implements IIHtmlContent {

    constructor(data?: IIHtmlContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IHtmlContent {
        data = typeof data === 'object' ? data : {};
        let result = new IHtmlContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IHtmlContent {
        const json = this.toJSON();
        let result = new IHtmlContent();
        result.init(json);
        return result;
    }
}

export interface IIHtmlContent {
}

export class ProductListDto implements IProductListDto {
    /** 产品名称 */
    name: string | undefined;
    /** 价格 */
    price: number;
    /** 产品类型 */
    type: string | undefined;
    /** 创建项目次数 */
    createProjectCount: number;
    /** 推荐 */
    recommended: boolean;
    /** 有效天数 */
    indate: number;
    /** 产品助记码 */
    code: string | undefined;
    /** 是否已发布(已发布的禁止修改) */
    published: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.createProjectCount = _data["createProjectCount"];
            this.recommended = _data["recommended"];
            this.indate = _data["indate"];
            this.code = _data["code"];
            this.published = _data["published"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["createProjectCount"] = this.createProjectCount;
        data["recommended"] = this.recommended;
        data["indate"] = this.indate;
        data["code"] = this.code;
        data["published"] = this.published;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductListDto {
        const json = this.toJSON();
        let result = new ProductListDto();
        result.init(json);
        return result;
    }
}

export interface IProductListDto {
    /** 产品名称 */
    name: string | undefined;
    /** 价格 */
    price: number;
    /** 产品类型 */
    type: string | undefined;
    /** 创建项目次数 */
    createProjectCount: number;
    /** 推荐 */
    recommended: boolean;
    /** 有效天数 */
    indate: number;
    /** 产品助记码 */
    code: string | undefined;
    /** 是否已发布(已发布的禁止修改) */
    published: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export enum PostType {
    Original = <any>"Original",
    Transshipment = <any>"Transshipment",
    Translate = <any>"Translate",
}

/** 文章的列表DTO QYB.Modules.Blogging.Posts.Post */
export class PostEditDto implements IPostEditDto {
    /** Id */
    id: string | undefined;
    /** 博客Id */
    blogId: string;
    /** 历史内容 */
    historyContent: string | undefined;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    postType: PostType;
    /** 标签 */
    tagIds: string[] | undefined;

    constructor(data?: IPostEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blogId = _data["blogId"];
            this.historyContent = _data["historyContent"];
            this.url = _data["url"];
            this.coverImage = _data["coverImage"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.postType = _data["postType"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds.push(item);
            }
        }
    }

    static fromJS(data: any): PostEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blogId"] = this.blogId;
        data["historyContent"] = this.historyContent;
        data["url"] = this.url;
        data["coverImage"] = this.coverImage;
        data["title"] = this.title;
        data["content"] = this.content;
        data["postType"] = this.postType;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }

    clone(): PostEditDto {
        const json = this.toJSON();
        let result = new PostEditDto();
        result.init(json);
        return result;
    }
}

/** 文章的列表DTO QYB.Modules.Blogging.Posts.Post */
export interface IPostEditDto {
    /** Id */
    id: string | undefined;
    /** 博客Id */
    blogId: string;
    /** 历史内容 */
    historyContent: string | undefined;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    postType: PostType;
    /** 标签 */
    tagIds: string[] | undefined;
}

export class CreateOrUpdatePostInput implements ICreateOrUpdatePostInput {
    post: PostEditDto;

    constructor(data?: ICreateOrUpdatePostInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.post = new PostEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.post = _data["post"] ? PostEditDto.fromJS(_data["post"]) : new PostEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePostInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePostInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["post"] = this.post ? this.post.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdatePostInput {
        const json = this.toJSON();
        let result = new CreateOrUpdatePostInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePostInput {
    post: PostEditDto;
}

export class CreatePostDto implements ICreatePostDto {
    /** 文章的列表DTO
QYB.Modules.Blogging.Posts.Post */
    id: string | undefined;
    /** 博客Id */
    blogId: string;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 历史内容 */
    historyContent: string | undefined;
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    postType: PostType;
    /** 文章标签 */
    newTags: string[] | undefined;

    constructor(data?: ICreatePostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blogId = _data["blogId"];
            this.url = _data["url"];
            this.coverImage = _data["coverImage"];
            this.historyContent = _data["historyContent"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.postType = _data["postType"];
            if (Array.isArray(_data["newTags"])) {
                this.newTags = [] as any;
                for (let item of _data["newTags"])
                    this.newTags.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePostDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blogId"] = this.blogId;
        data["url"] = this.url;
        data["coverImage"] = this.coverImage;
        data["historyContent"] = this.historyContent;
        data["title"] = this.title;
        data["content"] = this.content;
        data["postType"] = this.postType;
        if (Array.isArray(this.newTags)) {
            data["newTags"] = [];
            for (let item of this.newTags)
                data["newTags"].push(item);
        }
        return data;
    }

    clone(): CreatePostDto {
        const json = this.toJSON();
        let result = new CreatePostDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePostDto {
    /** 文章的列表DTO
QYB.Modules.Blogging.Posts.Post */
    id: string | undefined;
    /** 博客Id */
    blogId: string;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 历史内容 */
    historyContent: string | undefined;
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    postType: PostType;
    /** 文章标签 */
    newTags: string[] | undefined;
}

/** 文章的编辑DTO QYB.Modules.Blogging.Posts.Post */
export class PostListDto implements IPostListDto {
    /** 博客Id */
    blogId: string;
    /** 标题 */
    title: string | undefined;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 阅读数 */
    readCount: number;
    postType: PostType;
    /** 文章类型描述 */
    readonly postTypeDescirption: string | undefined;
    /** 文章标签 */
    tags: string | undefined;
    /** 博客名称 */
    blogName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPostListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogId = _data["blogId"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.coverImage = _data["coverImage"];
            this.content = _data["content"];
            this.readCount = _data["readCount"];
            this.postType = _data["postType"];
            (<any>this).postTypeDescirption = _data["postTypeDescirption"];
            this.tags = _data["tags"];
            this.blogName = _data["blogName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PostListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogId"] = this.blogId;
        data["title"] = this.title;
        data["url"] = this.url;
        data["coverImage"] = this.coverImage;
        data["content"] = this.content;
        data["readCount"] = this.readCount;
        data["postType"] = this.postType;
        data["postTypeDescirption"] = this.postTypeDescirption;
        data["tags"] = this.tags;
        data["blogName"] = this.blogName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PostListDto {
        const json = this.toJSON();
        let result = new PostListDto();
        result.init(json);
        return result;
    }
}

/** 文章的编辑DTO QYB.Modules.Blogging.Posts.Post */
export interface IPostListDto {
    /** 博客Id */
    blogId: string;
    /** 标题 */
    title: string | undefined;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 阅读数 */
    readCount: number;
    postType: PostType;
    /** 文章类型描述 */
    postTypeDescirption: string | undefined;
    /** 文章标签 */
    tags: string | undefined;
    /** 博客名称 */
    blogName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

/** 读取可编辑文章的Dto */
export class GetPostForEditOutput implements IGetPostForEditOutput {
    post: PostEditDto;
    postTypeTypeEnum: KeyValuePairOfStringString[] | undefined;

    constructor(data?: IGetPostForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.post = _data["post"] ? PostEditDto.fromJS(_data["post"]) : <any>undefined;
            if (Array.isArray(_data["postTypeTypeEnum"])) {
                this.postTypeTypeEnum = [] as any;
                for (let item of _data["postTypeTypeEnum"])
                    this.postTypeTypeEnum.push(KeyValuePairOfStringString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPostForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["post"] = this.post ? this.post.toJSON() : <any>undefined;
        if (Array.isArray(this.postTypeTypeEnum)) {
            data["postTypeTypeEnum"] = [];
            for (let item of this.postTypeTypeEnum)
                data["postTypeTypeEnum"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetPostForEditOutput {
        const json = this.toJSON();
        let result = new GetPostForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑文章的Dto */
export interface IGetPostForEditOutput {
    post: PostEditDto;
    postTypeTypeEnum: KeyValuePairOfStringString[] | undefined;
}

/** 文章详情的DTO QYB.Modules.Blogging.Posts.Post */
export class PostDetailsDto implements IPostDetailsDto {
    /** 博客Id */
    blogId: string;
    /** 标题 */
    title: string | undefined;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 阅读数 */
    readCount: number;
    postType: PostType;
    /** 评论总数 */
    commentCount: number;
    /** 文章标签 */
    tags: TagListDto[] | undefined;
    writer: UserListDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPostDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogId = _data["blogId"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.coverImage = _data["coverImage"];
            this.content = _data["content"];
            this.readCount = _data["readCount"];
            this.postType = _data["postType"];
            this.commentCount = _data["commentCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags.push(TagListDto.fromJS(item));
            }
            this.writer = _data["writer"] ? UserListDto.fromJS(_data["writer"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PostDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogId"] = this.blogId;
        data["title"] = this.title;
        data["url"] = this.url;
        data["coverImage"] = this.coverImage;
        data["content"] = this.content;
        data["readCount"] = this.readCount;
        data["postType"] = this.postType;
        data["commentCount"] = this.commentCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["writer"] = this.writer ? this.writer.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PostDetailsDto {
        const json = this.toJSON();
        let result = new PostDetailsDto();
        result.init(json);
        return result;
    }
}

/** 文章详情的DTO QYB.Modules.Blogging.Posts.Post */
export interface IPostDetailsDto {
    /** 博客Id */
    blogId: string;
    /** 标题 */
    title: string | undefined;
    /** 地址 */
    url: string | undefined;
    /** 封面 */
    coverImage: string | undefined;
    /** 内容 */
    content: string | undefined;
    /** 阅读数 */
    readCount: number;
    postType: PostType;
    /** 评论总数 */
    commentCount: number;
    /** 文章标签 */
    tags: TagListDto[] | undefined;
    writer: UserListDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ListResultDtoOfPostDetailsDto implements IListResultDtoOfPostDetailsDto {
    items: PostDetailsDto[] | undefined;

    constructor(data?: IListResultDtoOfPostDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PostDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPostDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPostDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfPostDetailsDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPostDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPostDetailsDto {
    items: PostDetailsDto[] | undefined;
}

export class PagedResultDtoOfPostListDto implements IPagedResultDtoOfPostListDto {
    totalCount: number;
    items: PostListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPostListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PostListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPostListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPostListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfPostListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPostListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPostListDto {
    totalCount: number;
    items: PostListDto[] | undefined;
}

export class PurchasePayInput implements IPurchasePayInput {
    /** 产品代码 */
    productCode: string | undefined;
    /** 是否移动端 */
    isMobile: boolean;
    /** 订单编码 */
    orderCode: string | undefined;
    orderSourceType: OrderSourceType;

    constructor(data?: IPurchasePayInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.isMobile = _data["isMobile"];
            this.orderCode = _data["orderCode"];
            this.orderSourceType = _data["orderSourceType"];
        }
    }

    static fromJS(data: any): PurchasePayInput {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasePayInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["isMobile"] = this.isMobile;
        data["orderCode"] = this.orderCode;
        data["orderSourceType"] = this.orderSourceType;
        return data;
    }

    clone(): PurchasePayInput {
        const json = this.toJSON();
        let result = new PurchasePayInput();
        result.init(json);
        return result;
    }
}

export interface IPurchasePayInput {
    /** 产品代码 */
    productCode: string | undefined;
    /** 是否移动端 */
    isMobile: boolean;
    /** 订单编码 */
    orderCode: string | undefined;
    orderSourceType: OrderSourceType;
}

export class Order implements IOrder {
    orderCode: string | undefined;
    productName: string | undefined;
    productId: string | undefined;
    courseId: number | undefined;
    productCode: string | undefined;
    price: number;
    discounts: number;
    actualPayment: number;
    status: OrderStatusEnum;
    productCreateProjectCount: number;
    productIndate: number;
    userId: number | undefined;
    userName: string | undefined;
    orderSourceType: OrderSourceType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCode = _data["orderCode"];
            this.productName = _data["productName"];
            this.productId = _data["productId"];
            this.courseId = _data["courseId"];
            this.productCode = _data["productCode"];
            this.price = _data["price"];
            this.discounts = _data["discounts"];
            this.actualPayment = _data["actualPayment"];
            this.status = _data["status"];
            this.productCreateProjectCount = _data["productCreateProjectCount"];
            this.productIndate = _data["productIndate"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.orderSourceType = _data["orderSourceType"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["productName"] = this.productName;
        data["productId"] = this.productId;
        data["courseId"] = this.courseId;
        data["productCode"] = this.productCode;
        data["price"] = this.price;
        data["discounts"] = this.discounts;
        data["actualPayment"] = this.actualPayment;
        data["status"] = this.status;
        data["productCreateProjectCount"] = this.productCreateProjectCount;
        data["productIndate"] = this.productIndate;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["orderSourceType"] = this.orderSourceType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    orderCode: string | undefined;
    productName: string | undefined;
    productId: string | undefined;
    courseId: number | undefined;
    productCode: string | undefined;
    price: number;
    discounts: number;
    actualPayment: number;
    status: OrderStatusEnum;
    productCreateProjectCount: number;
    productIndate: number;
    userId: number | undefined;
    userName: string | undefined;
    orderSourceType: OrderSourceType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class ProductEditDto implements IProductEditDto {
    /** Id */
    id: string | undefined;
    /** 产品名称 */
    name: string;
    /** 价格 */
    price: number;
    /** 产品类型 */
    type: string;
    /** 创建项目次数 */
    createProjectCount: number;
    /** 推荐 */
    recommended: boolean;
    /** 有效天数 */
    indate: number | undefined;
    /** 产品助记码,只用来展示,系统自动生成,不可直接编辑 */
    code: string | undefined;
    /** 是否已发布(已发布的禁止修改) */
    published: boolean;

    constructor(data?: IProductEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.createProjectCount = _data["createProjectCount"];
            this.recommended = _data["recommended"];
            this.indate = _data["indate"];
            this.code = _data["code"];
            this.published = _data["published"];
        }
    }

    static fromJS(data: any): ProductEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["createProjectCount"] = this.createProjectCount;
        data["recommended"] = this.recommended;
        data["indate"] = this.indate;
        data["code"] = this.code;
        data["published"] = this.published;
        return data;
    }

    clone(): ProductEditDto {
        const json = this.toJSON();
        let result = new ProductEditDto();
        result.init(json);
        return result;
    }
}

export interface IProductEditDto {
    /** Id */
    id: string | undefined;
    /** 产品名称 */
    name: string;
    /** 价格 */
    price: number;
    /** 产品类型 */
    type: string;
    /** 创建项目次数 */
    createProjectCount: number;
    /** 推荐 */
    recommended: boolean;
    /** 有效天数 */
    indate: number | undefined;
    /** 产品助记码,只用来展示,系统自动生成,不可直接编辑 */
    code: string | undefined;
    /** 是否已发布(已发布的禁止修改) */
    published: boolean;
}

export class CreateOrUpdateProductInput implements ICreateOrUpdateProductInput {
    product: ProductEditDto;

    constructor(data?: ICreateOrUpdateProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.product = new ProductEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductEditDto.fromJS(_data["product"]) : new ProductEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProductInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProductInput {
    product: ProductEditDto;
}

export class GetProductForEditOutput implements IGetProductForEditOutput {
    product: ProductEditDto;
    types: KeyValuePairOfStringString[] | undefined;

    constructor(data?: IGetProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductEditDto.fromJS(_data["product"]) : <any>undefined;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types.push(KeyValuePairOfStringString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProductForEditOutput {
        const json = this.toJSON();
        let result = new GetProductForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProductForEditOutput {
    product: ProductEditDto;
    types: KeyValuePairOfStringString[] | undefined;
}

export class PagedResultDtoOfProductListDto implements IPagedResultDtoOfProductListDto {
    totalCount: number;
    items: ProductListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfProductListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductListDto {
    totalCount: number;
    items: ProductListDto[] | undefined;
}

export class NullableIdDtoOfGuid implements INullableIdDtoOfGuid {
    id: string | undefined;

    constructor(data?: INullableIdDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NullableIdDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new NullableIdDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): NullableIdDtoOfGuid {
        const json = this.toJSON();
        let result = new NullableIdDtoOfGuid();
        result.init(json);
        return result;
    }
}

export interface INullableIdDtoOfGuid {
    id: string | undefined;
}

export class BatchCreateProductSecretKeyInput implements IBatchCreateProductSecretKeyInput {
    /** 数量 */
    quantity: number;
    /** 产品编码(助记码) */
    productCode: string;

    constructor(data?: IBatchCreateProductSecretKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): BatchCreateProductSecretKeyInput {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCreateProductSecretKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["productCode"] = this.productCode;
        return data;
    }

    clone(): BatchCreateProductSecretKeyInput {
        const json = this.toJSON();
        let result = new BatchCreateProductSecretKeyInput();
        result.init(json);
        return result;
    }
}

export interface IBatchCreateProductSecretKeyInput {
    /** 数量 */
    quantity: number;
    /** 产品编码(助记码) */
    productCode: string;
}

export class ProductSecretKeyBindToUserInput implements IProductSecretKeyBindToUserInput {
    /** 卡密 */
    secretKey: string;
    /** 用户名 */
    userName: string;
    /** 价格 */
    money: number;

    constructor(data?: IProductSecretKeyBindToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretKey = _data["secretKey"];
            this.userName = _data["userName"];
            this.money = _data["money"];
        }
    }

    static fromJS(data: any): ProductSecretKeyBindToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSecretKeyBindToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretKey"] = this.secretKey;
        data["userName"] = this.userName;
        data["money"] = this.money;
        return data;
    }

    clone(): ProductSecretKeyBindToUserInput {
        const json = this.toJSON();
        let result = new ProductSecretKeyBindToUserInput();
        result.init(json);
        return result;
    }
}

export interface IProductSecretKeyBindToUserInput {
    /** 卡密 */
    secretKey: string;
    /** 用户名 */
    userName: string;
    /** 价格 */
    money: number;
}

export class ProductSecretKeyListDto implements IProductSecretKeyListDto {
    /** 卡密 */
    secretKey: string | undefined;
    /** 产品助记码 */
    productCode: string | undefined;
    /** 已使用 */
    used: boolean;
    /** 用户Id */
    userId: number | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 在销售状态(销售状态下禁止删除和手动使用) */
    inSale: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IProductSecretKeyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretKey = _data["secretKey"];
            this.productCode = _data["productCode"];
            this.used = _data["used"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.orderCode = _data["orderCode"];
            this.inSale = _data["inSale"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductSecretKeyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSecretKeyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretKey"] = this.secretKey;
        data["productCode"] = this.productCode;
        data["used"] = this.used;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["orderCode"] = this.orderCode;
        data["inSale"] = this.inSale;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ProductSecretKeyListDto {
        const json = this.toJSON();
        let result = new ProductSecretKeyListDto();
        result.init(json);
        return result;
    }
}

export interface IProductSecretKeyListDto {
    /** 卡密 */
    secretKey: string | undefined;
    /** 产品助记码 */
    productCode: string | undefined;
    /** 已使用 */
    used: boolean;
    /** 用户Id */
    userId: number | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 订单编码 */
    orderCode: string | undefined;
    /** 在销售状态(销售状态下禁止删除和手动使用) */
    inSale: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class PagedResultDtoOfProductSecretKeyListDto implements IPagedResultDtoOfProductSecretKeyListDto {
    totalCount: number;
    items: ProductSecretKeyListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductSecretKeyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductSecretKeyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductSecretKeyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductSecretKeyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfProductSecretKeyListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductSecretKeyListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductSecretKeyListDto {
    totalCount: number;
    items: ProductSecretKeyListDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordInput {
        const json = this.toJSON();
        let result = new ChangePasswordInput();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangePasswordByTenantInput implements IChangePasswordByTenantInput {
    /** 租户 */
    tenantId: number;
    /** 账号 */
    userId: number;
    /** 原密码 */
    currentPassword: string;
    /** 新密码 */
    newPassword: string;

    constructor(data?: IChangePasswordByTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordByTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordByTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordByTenantInput {
        const json = this.toJSON();
        let result = new ChangePasswordByTenantInput();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordByTenantInput {
    /** 租户 */
    tenantId: number;
    /** 账号 */
    userId: number;
    /** 原密码 */
    currentPassword: string;
    /** 新密码 */
    newPassword: string;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    userName: string;
    fullName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    /** 时区 */
    timezone: string | undefined;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        return data;
    }

    clone(): CurrentUserProfileEditDto {
        const json = this.toJSON();
        let result = new CurrentUserProfileEditDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentUserProfileEditDto {
    userName: string;
    fullName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    /** 时区 */
    timezone: string | undefined;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }

    clone(): GetProfilePictureOutput {
        const json = this.toJSON();
        let result = new GetProfilePictureOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

/** 用户头像输出 */
export class GetProfilePictureOutputDto implements IGetProfilePictureOutputDto {
    profilePicture: string | undefined;

    constructor(data?: IGetProfilePictureOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }

    clone(): GetProfilePictureOutputDto {
        const json = this.toJSON();
        let result = new GetProfilePictureOutputDto();
        result.init(json);
        return result;
    }
}

/** 用户头像输出 */
export interface IGetProfilePictureOutputDto {
    profilePicture: string | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken: string;
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }

    clone(): UpdateProfilePictureInput {
        const json = this.toJSON();
        let result = new UpdateProfilePictureInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class ProjectEditDto implements IProjectEditDto {
    /** Id */
    id: string | undefined;
    imgUrl: string | undefined;
    /** 显示名称 */
    name: string | undefined;
    /** 短名称 */
    shortName: string | undefined;
    /** 最后的版本分支信息 */
    latestVersionBranchName: string | undefined;
    /** 最小版本号 */
    minimumVersion: string | undefined;
    /** 格式化方式 */
    format: string | undefined;
    /** 默认文档名称 */
    defaultDocumentName: string | undefined;
    /** 导航文件名称 */
    navigationDocumentName: string | undefined;
    /** 文档仓储类型 */
    documentStoreType: string | undefined;
    /** 扩展属性 */
    extraProperties: string | undefined;
    /** 主站点地址 */
    mainWebsiteUrl: string | undefined;
    enabled: boolean;
    /** 前台展示优先级，值越大优先级越高 */
    sort: number;

    constructor(data?: IProjectEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imgUrl = _data["imgUrl"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.latestVersionBranchName = _data["latestVersionBranchName"];
            this.minimumVersion = _data["minimumVersion"];
            this.format = _data["format"];
            this.defaultDocumentName = _data["defaultDocumentName"];
            this.navigationDocumentName = _data["navigationDocumentName"];
            this.documentStoreType = _data["documentStoreType"];
            this.extraProperties = _data["extraProperties"];
            this.mainWebsiteUrl = _data["mainWebsiteUrl"];
            this.enabled = _data["enabled"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): ProjectEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imgUrl"] = this.imgUrl;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["latestVersionBranchName"] = this.latestVersionBranchName;
        data["minimumVersion"] = this.minimumVersion;
        data["format"] = this.format;
        data["defaultDocumentName"] = this.defaultDocumentName;
        data["navigationDocumentName"] = this.navigationDocumentName;
        data["documentStoreType"] = this.documentStoreType;
        data["extraProperties"] = this.extraProperties;
        data["mainWebsiteUrl"] = this.mainWebsiteUrl;
        data["enabled"] = this.enabled;
        data["sort"] = this.sort;
        return data;
    }

    clone(): ProjectEditDto {
        const json = this.toJSON();
        let result = new ProjectEditDto();
        result.init(json);
        return result;
    }
}

export interface IProjectEditDto {
    /** Id */
    id: string | undefined;
    imgUrl: string | undefined;
    /** 显示名称 */
    name: string | undefined;
    /** 短名称 */
    shortName: string | undefined;
    /** 最后的版本分支信息 */
    latestVersionBranchName: string | undefined;
    /** 最小版本号 */
    minimumVersion: string | undefined;
    /** 格式化方式 */
    format: string | undefined;
    /** 默认文档名称 */
    defaultDocumentName: string | undefined;
    /** 导航文件名称 */
    navigationDocumentName: string | undefined;
    /** 文档仓储类型 */
    documentStoreType: string | undefined;
    /** 扩展属性 */
    extraProperties: string | undefined;
    /** 主站点地址 */
    mainWebsiteUrl: string | undefined;
    enabled: boolean;
    /** 前台展示优先级，值越大优先级越高 */
    sort: number;
}

export class CreateOrUpdateProjectInput implements ICreateOrUpdateProjectInput {
    project: ProjectEditDto;

    constructor(data?: ICreateOrUpdateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.project = new ProjectEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectEditDto.fromJS(_data["project"]) : new ProjectEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateProjectInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProjectInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProjectInput {
    project: ProjectEditDto;
}

export class ProjectDto implements IProjectDto {
    imgUrl: string | undefined;
    name: string | undefined;
    shortName: string | undefined;
    defaultDocumentName: string | undefined;
    navigationDocumentName: string | undefined;
    /** 最小版本号，用于过滤 */
    minimumVersion: string | undefined;
    latestVersionBranchName: string | undefined;
    documentStoreType: string | undefined;
    extraProperties: string | undefined;
    mainWebsiteUrl: string | undefined;
    format: string | undefined;
    id: string;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgUrl = _data["imgUrl"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.defaultDocumentName = _data["defaultDocumentName"];
            this.navigationDocumentName = _data["navigationDocumentName"];
            this.minimumVersion = _data["minimumVersion"];
            this.latestVersionBranchName = _data["latestVersionBranchName"];
            this.documentStoreType = _data["documentStoreType"];
            this.extraProperties = _data["extraProperties"];
            this.mainWebsiteUrl = _data["mainWebsiteUrl"];
            this.format = _data["format"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imgUrl"] = this.imgUrl;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["defaultDocumentName"] = this.defaultDocumentName;
        data["navigationDocumentName"] = this.navigationDocumentName;
        data["minimumVersion"] = this.minimumVersion;
        data["latestVersionBranchName"] = this.latestVersionBranchName;
        data["documentStoreType"] = this.documentStoreType;
        data["extraProperties"] = this.extraProperties;
        data["mainWebsiteUrl"] = this.mainWebsiteUrl;
        data["format"] = this.format;
        data["id"] = this.id;
        return data;
    }

    clone(): ProjectDto {
        const json = this.toJSON();
        let result = new ProjectDto();
        result.init(json);
        return result;
    }
}

export interface IProjectDto {
    imgUrl: string | undefined;
    name: string | undefined;
    shortName: string | undefined;
    defaultDocumentName: string | undefined;
    navigationDocumentName: string | undefined;
    /** 最小版本号，用于过滤 */
    minimumVersion: string | undefined;
    latestVersionBranchName: string | undefined;
    documentStoreType: string | undefined;
    extraProperties: string | undefined;
    mainWebsiteUrl: string | undefined;
    format: string | undefined;
    id: string;
}

export class ProjectListDto implements IProjectListDto {
    /** 封面 */
    imgUrl: string | undefined;
    /** 显示名称 */
    name: string | undefined;
    /** 短名称 */
    shortName: string | undefined;
    /** 格式化方式 */
    format: string | undefined;
    /** 默认文档名称 */
    defaultDocumentName: string | undefined;
    /** 导航文件名称 */
    navigationDocumentName: string | undefined;
    /** 文档仓储类型 */
    documentStoreType: string | undefined;
    /** 主站点地址 */
    mainWebsiteUrl: string | undefined;
    enabled: boolean;
    /** 优先级，值越大优先级越高 */
    sort: number;
    /** 最后的版本分支信息 */
    latestVersionBranchName: string | undefined;
    /** 最小版本号 */
    minimumVersion: string | undefined;
    id: string;

    constructor(data?: IProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgUrl = _data["imgUrl"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.format = _data["format"];
            this.defaultDocumentName = _data["defaultDocumentName"];
            this.navigationDocumentName = _data["navigationDocumentName"];
            this.documentStoreType = _data["documentStoreType"];
            this.mainWebsiteUrl = _data["mainWebsiteUrl"];
            this.enabled = _data["enabled"];
            this.sort = _data["sort"];
            this.latestVersionBranchName = _data["latestVersionBranchName"];
            this.minimumVersion = _data["minimumVersion"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProjectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imgUrl"] = this.imgUrl;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["format"] = this.format;
        data["defaultDocumentName"] = this.defaultDocumentName;
        data["navigationDocumentName"] = this.navigationDocumentName;
        data["documentStoreType"] = this.documentStoreType;
        data["mainWebsiteUrl"] = this.mainWebsiteUrl;
        data["enabled"] = this.enabled;
        data["sort"] = this.sort;
        data["latestVersionBranchName"] = this.latestVersionBranchName;
        data["minimumVersion"] = this.minimumVersion;
        data["id"] = this.id;
        return data;
    }

    clone(): ProjectListDto {
        const json = this.toJSON();
        let result = new ProjectListDto();
        result.init(json);
        return result;
    }
}

export interface IProjectListDto {
    /** 封面 */
    imgUrl: string | undefined;
    /** 显示名称 */
    name: string | undefined;
    /** 短名称 */
    shortName: string | undefined;
    /** 格式化方式 */
    format: string | undefined;
    /** 默认文档名称 */
    defaultDocumentName: string | undefined;
    /** 导航文件名称 */
    navigationDocumentName: string | undefined;
    /** 文档仓储类型 */
    documentStoreType: string | undefined;
    /** 主站点地址 */
    mainWebsiteUrl: string | undefined;
    enabled: boolean;
    /** 优先级，值越大优先级越高 */
    sort: number;
    /** 最后的版本分支信息 */
    latestVersionBranchName: string | undefined;
    /** 最小版本号 */
    minimumVersion: string | undefined;
    id: string;
}

export class GetProjectForEditOutput implements IGetProjectForEditOutput {
    project: ProjectEditDto;

    constructor(data?: IGetProjectForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectEditDto.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetProjectForEditOutput {
        const json = this.toJSON();
        let result = new GetProjectForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProjectForEditOutput {
    project: ProjectEditDto;
}

export class ListResultDtoOfProjectDto implements IListResultDtoOfProjectDto {
    items: ProjectDto[] | undefined;

    constructor(data?: IListResultDtoOfProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfProjectDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfProjectDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfProjectDto {
    items: ProjectDto[] | undefined;
}

export class PagedResultDtoOfProjectListDto implements IPagedResultDtoOfProjectListDto {
    totalCount: number;
    items: ProjectListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProjectListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProjectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfProjectListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProjectListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProjectListDto {
    totalCount: number;
    items: ProjectListDto[] | undefined;
}

/** 版本Dto */
export class VersionInfoDto implements IVersionInfoDto {
    /** 对应的是TagName */
    tagName: string | undefined;
    /** 对应的是 ReleaseName */
    name: string | undefined;

    constructor(data?: IVersionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagName = _data["tagName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VersionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VersionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagName"] = this.tagName;
        data["name"] = this.name;
        return data;
    }

    clone(): VersionInfoDto {
        const json = this.toJSON();
        let result = new VersionInfoDto();
        result.init(json);
        return result;
    }
}

/** 版本Dto */
export interface IVersionInfoDto {
    /** 对应的是TagName */
    tagName: string | undefined;
    /** 对应的是 ReleaseName */
    name: string | undefined;
}

export class ListResultDtoOfVersionInfoDto implements IListResultDtoOfVersionInfoDto {
    items: VersionInfoDto[] | undefined;

    constructor(data?: IListResultDtoOfVersionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VersionInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVersionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfVersionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfVersionInfoDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfVersionInfoDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfVersionInfoDto {
    items: VersionInfoDto[] | undefined;
}

export class DefaultData implements IDefaultData {
    content: string | undefined;
    userImg: string | undefined;
    userName: string | undefined;
    post: string | undefined;
    gender: string | undefined;

    constructor(data?: IDefaultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.userImg = _data["userImg"];
            this.userName = _data["userName"];
            this.post = _data["post"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): DefaultData {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["userImg"] = this.userImg;
        data["userName"] = this.userName;
        data["post"] = this.post;
        data["gender"] = this.gender;
        return data;
    }

    clone(): DefaultData {
        const json = this.toJSON();
        let result = new DefaultData();
        result.init(json);
        return result;
    }
}

export interface IDefaultData {
    content: string | undefined;
    userImg: string | undefined;
    userName: string | undefined;
    post: string | undefined;
    gender: string | undefined;
}

export class MessagePayloadOfDefaultData implements IMessagePayloadOfDefaultData {
    type: string | undefined;
    jumpUrl: string | undefined;
    title: string | undefined;
    description: string | undefined;
    data: DefaultData;

    constructor(data?: IMessagePayloadOfDefaultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.jumpUrl = _data["jumpUrl"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.data = _data["data"] ? DefaultData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MessagePayloadOfDefaultData {
        data = typeof data === 'object' ? data : {};
        let result = new MessagePayloadOfDefaultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["jumpUrl"] = this.jumpUrl;
        data["title"] = this.title;
        data["description"] = this.description;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }

    clone(): MessagePayloadOfDefaultData {
        const json = this.toJSON();
        let result = new MessagePayloadOfDefaultData();
        result.init(json);
        return result;
    }
}

export interface IMessagePayloadOfDefaultData {
    type: string | undefined;
    jumpUrl: string | undefined;
    title: string | undefined;
    description: string | undefined;
    data: DefaultData;
}

export class QuotaUpdateRecordEditDto implements IQuotaUpdateRecordEditDto {
    limitId: number;
    userId: number;
    /** 修改值 */
    modifyValue: number;
    /** 修改原因 */
    reason: string | undefined;

    constructor(data?: IQuotaUpdateRecordEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limitId = _data["limitId"];
            this.userId = _data["userId"];
            this.modifyValue = _data["modifyValue"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): QuotaUpdateRecordEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotaUpdateRecordEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limitId"] = this.limitId;
        data["userId"] = this.userId;
        data["modifyValue"] = this.modifyValue;
        data["reason"] = this.reason;
        return data;
    }

    clone(): QuotaUpdateRecordEditDto {
        const json = this.toJSON();
        let result = new QuotaUpdateRecordEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuotaUpdateRecordEditDto {
    limitId: number;
    userId: number;
    /** 修改值 */
    modifyValue: number;
    /** 修改原因 */
    reason: string | undefined;
}

export class QuotaUpdateRecordDto implements IQuotaUpdateRecordDto {
    id: number;
    /** 用户主键 */
    userId: number;
    /** 员工假期额度ID */
    limitId: number;
    /** 修改值 */
    modifyValue: number;
    /** 修改原因 */
    reason: string | undefined;
    /** 最后修改人 */
    lastUpdateUserName: string | undefined;
    /** 修改时间 */
    updateTime: moment.Moment | undefined;

    constructor(data?: IQuotaUpdateRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.limitId = _data["limitId"];
            this.modifyValue = _data["modifyValue"];
            this.reason = _data["reason"];
            this.lastUpdateUserName = _data["lastUpdateUserName"];
            this.updateTime = _data["updateTime"] ? moment(_data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuotaUpdateRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotaUpdateRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["limitId"] = this.limitId;
        data["modifyValue"] = this.modifyValue;
        data["reason"] = this.reason;
        data["lastUpdateUserName"] = this.lastUpdateUserName;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): QuotaUpdateRecordDto {
        const json = this.toJSON();
        let result = new QuotaUpdateRecordDto();
        result.init(json);
        return result;
    }
}

export interface IQuotaUpdateRecordDto {
    id: number;
    /** 用户主键 */
    userId: number;
    /** 员工假期额度ID */
    limitId: number;
    /** 修改值 */
    modifyValue: number;
    /** 修改原因 */
    reason: string | undefined;
    /** 最后修改人 */
    lastUpdateUserName: string | undefined;
    /** 修改时间 */
    updateTime: moment.Moment | undefined;
}

export class PagedResultDtoOfQuotaUpdateRecordDto implements IPagedResultDtoOfQuotaUpdateRecordDto {
    totalCount: number;
    items: QuotaUpdateRecordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQuotaUpdateRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QuotaUpdateRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQuotaUpdateRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfQuotaUpdateRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfQuotaUpdateRecordDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfQuotaUpdateRecordDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfQuotaUpdateRecordDto {
    totalCount: number;
    items: QuotaUpdateRecordDto[] | undefined;
}

export class QuotaRecordDto implements IQuotaRecordDto {
    id: number | undefined;
    /** 假期主键 */
    limitId: number;
    /** 用户主键 */
    userId: number;
    /** 假期类型 */
    holidayType: string | undefined;
    /** 开始日期 */
    startDate: moment.Moment;
    /** 结束日期 */
    endDate: moment.Moment;
    /** 延期日期 */
    delayDate: moment.Moment | undefined;
    /** 额度单位 */
    quotaUnit: string | undefined;
    /** 标准额度 */
    normalQuota: number | undefined;
    /** 实际额度 */
    realQuota: number | undefined;
    /** 手工调整 */
    manualUpdate: number | undefined;
    /** 锁定额度 */
    lockingQuota: number | undefined;
    /** 已用额度 */
    usedQuota: number | undefined;
    /** 可用额度 */
    usableQuota: number | undefined;
    /** 单位 */
    holidayUnit: string | undefined;
    /** 是否可用 */
    enable: boolean | undefined;

    constructor(data?: IQuotaRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.limitId = _data["limitId"];
            this.userId = _data["userId"];
            this.holidayType = _data["holidayType"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.delayDate = _data["delayDate"] ? moment(_data["delayDate"].toString()) : <any>undefined;
            this.quotaUnit = _data["quotaUnit"];
            this.normalQuota = _data["normalQuota"];
            this.realQuota = _data["realQuota"];
            this.manualUpdate = _data["manualUpdate"];
            this.lockingQuota = _data["lockingQuota"];
            this.usedQuota = _data["usedQuota"];
            this.usableQuota = _data["usableQuota"];
            this.holidayUnit = _data["holidayUnit"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): QuotaRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotaRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["limitId"] = this.limitId;
        data["userId"] = this.userId;
        data["holidayType"] = this.holidayType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["delayDate"] = this.delayDate ? this.delayDate.toISOString() : <any>undefined;
        data["quotaUnit"] = this.quotaUnit;
        data["normalQuota"] = this.normalQuota;
        data["realQuota"] = this.realQuota;
        data["manualUpdate"] = this.manualUpdate;
        data["lockingQuota"] = this.lockingQuota;
        data["usedQuota"] = this.usedQuota;
        data["usableQuota"] = this.usableQuota;
        data["holidayUnit"] = this.holidayUnit;
        data["enable"] = this.enable;
        return data;
    }

    clone(): QuotaRecordDto {
        const json = this.toJSON();
        let result = new QuotaRecordDto();
        result.init(json);
        return result;
    }
}

export interface IQuotaRecordDto {
    id: number | undefined;
    /** 假期主键 */
    limitId: number;
    /** 用户主键 */
    userId: number;
    /** 假期类型 */
    holidayType: string | undefined;
    /** 开始日期 */
    startDate: moment.Moment;
    /** 结束日期 */
    endDate: moment.Moment;
    /** 延期日期 */
    delayDate: moment.Moment | undefined;
    /** 额度单位 */
    quotaUnit: string | undefined;
    /** 标准额度 */
    normalQuota: number | undefined;
    /** 实际额度 */
    realQuota: number | undefined;
    /** 手工调整 */
    manualUpdate: number | undefined;
    /** 锁定额度 */
    lockingQuota: number | undefined;
    /** 已用额度 */
    usedQuota: number | undefined;
    /** 可用额度 */
    usableQuota: number | undefined;
    /** 单位 */
    holidayUnit: string | undefined;
    /** 是否可用 */
    enable: boolean | undefined;
}

export class PagedResultDtoOfQuotaRecordDto implements IPagedResultDtoOfQuotaRecordDto {
    totalCount: number;
    items: QuotaRecordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQuotaRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(QuotaRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQuotaRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfQuotaRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfQuotaRecordDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfQuotaRecordDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfQuotaRecordDto {
    totalCount: number;
    items: QuotaRecordDto[] | undefined;
}

export class TabsDataDto implements ITabsDataDto {
    /** 假期类型 */
    holidayType: string | undefined;
    /** 假期名称 */
    holidayName: string | undefined;
    /** 是否拥有 */
    isHave: boolean;

    constructor(data?: ITabsDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayType = _data["holidayType"];
            this.holidayName = _data["holidayName"];
            this.isHave = _data["isHave"];
        }
    }

    static fromJS(data: any): TabsDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TabsDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayType"] = this.holidayType;
        data["holidayName"] = this.holidayName;
        data["isHave"] = this.isHave;
        return data;
    }

    clone(): TabsDataDto {
        const json = this.toJSON();
        let result = new TabsDataDto();
        result.init(json);
        return result;
    }
}

export interface ITabsDataDto {
    /** 假期类型 */
    holidayType: string | undefined;
    /** 假期名称 */
    holidayName: string | undefined;
    /** 是否拥有 */
    isHave: boolean;
}

export class QYBLanguageTexts implements IQYBLanguageTexts {
    languagesId: number;
    languageName: string;
    source: string;
    key: string;
    value: string;
    tenantId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQYBLanguageTexts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languagesId = _data["languagesId"];
            this.languageName = _data["languageName"];
            this.source = _data["source"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QYBLanguageTexts {
        data = typeof data === 'object' ? data : {};
        let result = new QYBLanguageTexts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languagesId"] = this.languagesId;
        data["languageName"] = this.languageName;
        data["source"] = this.source;
        data["key"] = this.key;
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): QYBLanguageTexts {
        const json = this.toJSON();
        let result = new QYBLanguageTexts();
        result.init(json);
        return result;
    }
}

export interface IQYBLanguageTexts {
    languagesId: number;
    languageName: string;
    source: string;
    key: string;
    value: string;
    tenantId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QYBLanguages implements IQYBLanguages {
    name: string;
    displayName: string;
    isDisabled: boolean;
    isDefault: boolean | undefined;
    languageTexts: QYBLanguageTexts[] | undefined;
    tenantId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQYBLanguages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDisabled = _data["isDisabled"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["languageTexts"])) {
                this.languageTexts = [] as any;
                for (let item of _data["languageTexts"])
                    this.languageTexts.push(QYBLanguageTexts.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QYBLanguages {
        data = typeof data === 'object' ? data : {};
        let result = new QYBLanguages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDisabled"] = this.isDisabled;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.languageTexts)) {
            data["languageTexts"] = [];
            for (let item of this.languageTexts)
                data["languageTexts"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): QYBLanguages {
        const json = this.toJSON();
        let result = new QYBLanguages();
        result.init(json);
        return result;
    }
}

export interface IQYBLanguages {
    name: string;
    displayName: string;
    isDisabled: boolean;
    isDefault: boolean | undefined;
    languageTexts: QYBLanguageTexts[] | undefined;
    tenantId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EditLanguage implements IEditLanguage {
    languageId: number;
    displayName: string | undefined;

    constructor(data?: IEditLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EditLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new EditLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): EditLanguage {
        const json = this.toJSON();
        let result = new EditLanguage();
        result.init(json);
        return result;
    }
}

export interface IEditLanguage {
    languageId: number;
    displayName: string | undefined;
}

export class CreateLanguageReq implements ICreateLanguageReq {
    name: string;
    displayName: string;
    isDefault: boolean | undefined;

    constructor(data?: ICreateLanguageReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CreateLanguageReq {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLanguageReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): CreateLanguageReq {
        const json = this.toJSON();
        let result = new CreateLanguageReq();
        result.init(json);
        return result;
    }
}

export interface ICreateLanguageReq {
    name: string;
    displayName: string;
    isDefault: boolean | undefined;
}

export class CreatOrUpdateLangualeText implements ICreatOrUpdateLangualeText {
    languageId: number;
    languageName: string | undefined;
    /** 翻译的键 */
    key: string | undefined;
    /** 翻译的值 */
    value: string | undefined;
    targetValue: string | undefined;

    constructor(data?: ICreatOrUpdateLangualeText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.languageName = _data["languageName"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): CreatOrUpdateLangualeText {
        data = typeof data === 'object' ? data : {};
        let result = new CreatOrUpdateLangualeText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["languageName"] = this.languageName;
        data["key"] = this.key;
        data["value"] = this.value;
        data["targetValue"] = this.targetValue;
        return data;
    }

    clone(): CreatOrUpdateLangualeText {
        const json = this.toJSON();
        let result = new CreatOrUpdateLangualeText();
        result.init(json);
        return result;
    }
}

export interface ICreatOrUpdateLangualeText {
    languageId: number;
    languageName: string | undefined;
    /** 翻译的键 */
    key: string | undefined;
    /** 翻译的值 */
    value: string | undefined;
    targetValue: string | undefined;
}

export class QueryLanguageReq implements IQueryLanguageReq {
    id: number;

    constructor(data?: IQueryLanguageReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QueryLanguageReq {
        data = typeof data === 'object' ? data : {};
        let result = new QueryLanguageReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): QueryLanguageReq {
        const json = this.toJSON();
        let result = new QueryLanguageReq();
        result.init(json);
        return result;
    }
}

export interface IQueryLanguageReq {
    id: number;
}

export class ChangeLanguageStatusReq implements IChangeLanguageStatusReq {
    language: number;
    isDisabled: boolean;

    constructor(data?: IChangeLanguageStatusReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): ChangeLanguageStatusReq {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLanguageStatusReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): ChangeLanguageStatusReq {
        const json = this.toJSON();
        let result = new ChangeLanguageStatusReq();
        result.init(json);
        return result;
    }
}

export interface IChangeLanguageStatusReq {
    language: number;
    isDisabled: boolean;
}

export class CultureInfoDto implements ICultureInfoDto {
    /** 名称 例如 zh-Hants */
    name: string | undefined;
    displayName: string | undefined;

    constructor(data?: ICultureInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CultureInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CultureInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): CultureInfoDto {
        const json = this.toJSON();
        let result = new CultureInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICultureInfoDto {
    /** 名称 例如 zh-Hants */
    name: string | undefined;
    displayName: string | undefined;
}

export class KeyValue implements IKeyValue {
    /** 翻译的键 */
    key: string | undefined;
    /** 翻译的值 */
    value: string | undefined;

    constructor(data?: IKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): KeyValue {
        const json = this.toJSON();
        let result = new KeyValue();
        result.init(json);
        return result;
    }
}

export interface IKeyValue {
    /** 翻译的键 */
    key: string | undefined;
    /** 翻译的值 */
    value: string | undefined;
}

export class LanguageResp implements ILanguageResp {
    /** 语言名称 */
    name: string | undefined;
    /** 展示名称 */
    displayName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 是否被禁用 */
    isDisabled: boolean;
    /** 是否可以作为源 */
    source: boolean;
    /** 是否默认语言 */
    isDefault: boolean | undefined;
    /** 是否为租户语言 */
    isTenantLanguage: boolean;
    id: number;

    constructor(data?: ILanguageResp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isDisabled = _data["isDisabled"];
            this.source = _data["source"];
            this.isDefault = _data["isDefault"];
            this.isTenantLanguage = _data["isTenantLanguage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LanguageResp {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isDisabled"] = this.isDisabled;
        data["source"] = this.source;
        data["isDefault"] = this.isDefault;
        data["isTenantLanguage"] = this.isTenantLanguage;
        data["id"] = this.id;
        return data;
    }

    clone(): LanguageResp {
        const json = this.toJSON();
        let result = new LanguageResp();
        result.init(json);
        return result;
    }
}

export interface ILanguageResp {
    /** 语言名称 */
    name: string | undefined;
    /** 展示名称 */
    displayName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 是否被禁用 */
    isDisabled: boolean;
    /** 是否可以作为源 */
    source: boolean;
    /** 是否默认语言 */
    isDefault: boolean | undefined;
    /** 是否为租户语言 */
    isTenantLanguage: boolean;
    id: number;
}

export class EditTranslateLanguageReq implements IEditTranslateLanguageReq {
    sourceLanguageId: number;
    targetLanguageId: number;

    constructor(data?: IEditTranslateLanguageReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceLanguageId = _data["sourceLanguageId"];
            this.targetLanguageId = _data["targetLanguageId"];
        }
    }

    static fromJS(data: any): EditTranslateLanguageReq {
        data = typeof data === 'object' ? data : {};
        let result = new EditTranslateLanguageReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceLanguageId"] = this.sourceLanguageId;
        data["targetLanguageId"] = this.targetLanguageId;
        return data;
    }

    clone(): EditTranslateLanguageReq {
        const json = this.toJSON();
        let result = new EditTranslateLanguageReq();
        result.init(json);
        return result;
    }
}

export interface IEditTranslateLanguageReq {
    sourceLanguageId: number;
    targetLanguageId: number;
}

export class LanguageTextResp implements ILanguageTextResp {
    id: number;
    /** 翻译的键 */
    key: string | undefined;
    /** 翻译的值 */
    value: string | undefined;
    targetValue: string | undefined;

    constructor(data?: ILanguageTextResp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextResp {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextResp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        data["targetValue"] = this.targetValue;
        return data;
    }

    clone(): LanguageTextResp {
        const json = this.toJSON();
        let result = new LanguageTextResp();
        result.init(json);
        return result;
    }
}

export interface ILanguageTextResp {
    id: number;
    /** 翻译的键 */
    key: string | undefined;
    /** 翻译的值 */
    value: string | undefined;
    targetValue: string | undefined;
}

/** 返回对照语言的的键值列表 */
export class TranslateTextDto implements ITranslateTextDto {
    /** 语言编号 */
    languageId: number;
    /** 语言名称 */
    languageName: string | undefined;
    /** 语言显示名称 */
    languageDisplayName: string | undefined;
    languageTexts: LanguageTextResp[] | undefined;
    targetLanguageId: number;
    targetLanguageName: string | undefined;
    targetLanguageDisplayName: string | undefined;

    constructor(data?: ITranslateTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.languageName = _data["languageName"];
            this.languageDisplayName = _data["languageDisplayName"];
            if (Array.isArray(_data["languageTexts"])) {
                this.languageTexts = [] as any;
                for (let item of _data["languageTexts"])
                    this.languageTexts.push(LanguageTextResp.fromJS(item));
            }
            this.targetLanguageId = _data["targetLanguageId"];
            this.targetLanguageName = _data["targetLanguageName"];
            this.targetLanguageDisplayName = _data["targetLanguageDisplayName"];
        }
    }

    static fromJS(data: any): TranslateTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["languageName"] = this.languageName;
        data["languageDisplayName"] = this.languageDisplayName;
        if (Array.isArray(this.languageTexts)) {
            data["languageTexts"] = [];
            for (let item of this.languageTexts)
                data["languageTexts"].push(item.toJSON());
        }
        data["targetLanguageId"] = this.targetLanguageId;
        data["targetLanguageName"] = this.targetLanguageName;
        data["targetLanguageDisplayName"] = this.targetLanguageDisplayName;
        return data;
    }

    clone(): TranslateTextDto {
        const json = this.toJSON();
        let result = new TranslateTextDto();
        result.init(json);
        return result;
    }
}

/** 返回对照语言的的键值列表 */
export interface ITranslateTextDto {
    /** 语言编号 */
    languageId: number;
    /** 语言名称 */
    languageName: string | undefined;
    /** 语言显示名称 */
    languageDisplayName: string | undefined;
    languageTexts: LanguageTextResp[] | undefined;
    targetLanguageId: number;
    targetLanguageName: string | undefined;
    targetLanguageDisplayName: string | undefined;
}

export class SaveLanguageTextReq implements ISaveLanguageTextReq {
    /** 保存的Language */
    languageId: number;
    /** 键值对 */
    languageTexts: LanguageTextResp[] | undefined;

    constructor(data?: ISaveLanguageTextReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            if (Array.isArray(_data["languageTexts"])) {
                this.languageTexts = [] as any;
                for (let item of _data["languageTexts"])
                    this.languageTexts.push(LanguageTextResp.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveLanguageTextReq {
        data = typeof data === 'object' ? data : {};
        let result = new SaveLanguageTextReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        if (Array.isArray(this.languageTexts)) {
            data["languageTexts"] = [];
            for (let item of this.languageTexts)
                data["languageTexts"].push(item.toJSON());
        }
        return data;
    }

    clone(): SaveLanguageTextReq {
        const json = this.toJSON();
        let result = new SaveLanguageTextReq();
        result.init(json);
        return result;
    }
}

export interface ISaveLanguageTextReq {
    /** 保存的Language */
    languageId: number;
    /** 键值对 */
    languageTexts: LanguageTextResp[] | undefined;
}

/** 按审核项类型分组的符合率数据 */
export class GetAnditItemTypeGroupComplianceRateDto implements IGetAnditItemTypeGroupComplianceRateDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集 */
    children: GetAnditItemTypeGroupComplianceRateDto[] | undefined;
    /** 审核记录合格数量 */
    finishAuditItemCount: number;
    /** 审核记录数量 */
    auditItemCount: number;
    /** 符合率 */
    complianceRate: number;

    constructor(data?: IGetAnditItemTypeGroupComplianceRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GetAnditItemTypeGroupComplianceRateDto.fromJS(item));
            }
            this.finishAuditItemCount = _data["finishAuditItemCount"];
            this.auditItemCount = _data["auditItemCount"];
            this.complianceRate = _data["complianceRate"];
        }
    }

    static fromJS(data: any): GetAnditItemTypeGroupComplianceRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnditItemTypeGroupComplianceRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["finishAuditItemCount"] = this.finishAuditItemCount;
        data["auditItemCount"] = this.auditItemCount;
        data["complianceRate"] = this.complianceRate;
        return data;
    }

    clone(): GetAnditItemTypeGroupComplianceRateDto {
        const json = this.toJSON();
        let result = new GetAnditItemTypeGroupComplianceRateDto();
        result.init(json);
        return result;
    }
}

/** 按审核项类型分组的符合率数据 */
export interface IGetAnditItemTypeGroupComplianceRateDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 子集 */
    children: GetAnditItemTypeGroupComplianceRateDto[] | undefined;
    /** 审核记录合格数量 */
    finishAuditItemCount: number;
    /** 审核记录数量 */
    auditItemCount: number;
    /** 符合率 */
    complianceRate: number;
}

/** 审核员不符合项 */
export class GetAuditInspComplianceRateDto implements IGetAuditInspComplianceRateDto {
    /** 人员Id */
    inspId: number;
    /** 人员名称 */
    inspName: string | undefined;
    /** 审核记录不合格数量 */
    notFinishCount: number;

    constructor(data?: IGetAuditInspComplianceRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspId = _data["inspId"];
            this.inspName = _data["inspName"];
            this.notFinishCount = _data["notFinishCount"];
        }
    }

    static fromJS(data: any): GetAuditInspComplianceRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditInspComplianceRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspId"] = this.inspId;
        data["inspName"] = this.inspName;
        data["notFinishCount"] = this.notFinishCount;
        return data;
    }

    clone(): GetAuditInspComplianceRateDto {
        const json = this.toJSON();
        let result = new GetAuditInspComplianceRateDto();
        result.init(json);
        return result;
    }
}

/** 审核员不符合项 */
export interface IGetAuditInspComplianceRateDto {
    /** 人员Id */
    inspId: number;
    /** 人员名称 */
    inspName: string | undefined;
    /** 审核记录不合格数量 */
    notFinishCount: number;
}

/** 审核项问题统计Dto */
export class GetAuditItemIssueStatisticsDto implements IGetAuditItemIssueStatisticsDto {
    /** 审核项 */
    auditItemName: string | undefined;
    /** 数量 */
    count: number;

    constructor(data?: IGetAuditItemIssueStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemName = _data["auditItemName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAuditItemIssueStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditItemIssueStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemName"] = this.auditItemName;
        data["count"] = this.count;
        return data;
    }

    clone(): GetAuditItemIssueStatisticsDto {
        const json = this.toJSON();
        let result = new GetAuditItemIssueStatisticsDto();
        result.init(json);
        return result;
    }
}

/** 审核项问题统计Dto */
export interface IGetAuditItemIssueStatisticsDto {
    /** 审核项 */
    auditItemName: string | undefined;
    /** 数量 */
    count: number;
}

export class PagedResultDtoOfGetAuditItemIssueStatisticsDto implements IPagedResultDtoOfGetAuditItemIssueStatisticsDto {
    totalCount: number;
    items: GetAuditItemIssueStatisticsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAuditItemIssueStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetAuditItemIssueStatisticsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAuditItemIssueStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAuditItemIssueStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetAuditItemIssueStatisticsDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAuditItemIssueStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAuditItemIssueStatisticsDto {
    totalCount: number;
    items: GetAuditItemIssueStatisticsDto[] | undefined;
}

/** 审核项问题统计报表数据源 */
export class GetAuditItemIssueStatisticsForEchartsDto implements IGetAuditItemIssueStatisticsForEchartsDto {
    /** 审核项 */
    auditItemName: string | undefined;
    /** 序号 */
    sn: number;
    /** 编号 */
    code: string | undefined;
    /** 数量 */
    count: number;

    constructor(data?: IGetAuditItemIssueStatisticsForEchartsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditItemName = _data["auditItemName"];
            this.sn = _data["sn"];
            this.code = _data["code"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetAuditItemIssueStatisticsForEchartsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditItemIssueStatisticsForEchartsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditItemName"] = this.auditItemName;
        data["sn"] = this.sn;
        data["code"] = this.code;
        data["count"] = this.count;
        return data;
    }

    clone(): GetAuditItemIssueStatisticsForEchartsDto {
        const json = this.toJSON();
        let result = new GetAuditItemIssueStatisticsForEchartsDto();
        result.init(json);
        return result;
    }
}

/** 审核项问题统计报表数据源 */
export interface IGetAuditItemIssueStatisticsForEchartsDto {
    /** 审核项 */
    auditItemName: string | undefined;
    /** 序号 */
    sn: number;
    /** 编号 */
    code: string | undefined;
    /** 数量 */
    count: number;
}

/** 区域审核记录统计 */
export class AuditPointRecordDto implements IAuditPointRecordDto {
    /** 审核点Id */
    id: number;
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 责任人 */
    respId: number;
    /** 责任人名称 */
    respName: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 排序 */
    sn: number;
    /** 子集 */
    children: AuditPointRecordDto[] | undefined;
    /** title */
    title: string | undefined;
    /** key */
    key: number;
    /** 计划审核次数 */
    planAuditCount: number;
    /** 实际审核次数 */
    aclAuditCount: number;
    /** 完成率 */
    completionRate: number;
    /** 问题数量 */
    issueCount: number;

    constructor(data?: IAuditPointRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.mustQRCode = _data["mustQRCode"];
            this.mustNFC = _data["mustNFC"];
            this.qrCode = _data["qrCode"];
            this.nfcNo = _data["nfcNo"];
            this.nfcid = _data["nfcid"];
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.enable = _data["enable"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            this.sn = _data["sn"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AuditPointRecordDto.fromJS(item));
            }
            this.title = _data["title"];
            this.key = _data["key"];
            this.planAuditCount = _data["planAuditCount"];
            this.aclAuditCount = _data["aclAuditCount"];
            this.completionRate = _data["completionRate"];
            this.issueCount = _data["issueCount"];
        }
    }

    static fromJS(data: any): AuditPointRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditPointRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["mustQRCode"] = this.mustQRCode;
        data["mustNFC"] = this.mustNFC;
        data["qrCode"] = this.qrCode;
        data["nfcNo"] = this.nfcNo;
        data["nfcid"] = this.nfcid;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["enable"] = this.enable;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        data["sn"] = this.sn;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["key"] = this.key;
        data["planAuditCount"] = this.planAuditCount;
        data["aclAuditCount"] = this.aclAuditCount;
        data["completionRate"] = this.completionRate;
        data["issueCount"] = this.issueCount;
        return data;
    }

    clone(): AuditPointRecordDto {
        const json = this.toJSON();
        let result = new AuditPointRecordDto();
        result.init(json);
        return result;
    }
}

/** 区域审核记录统计 */
export interface IAuditPointRecordDto {
    /** 审核点Id */
    id: number;
    /** 审核点代码 */
    code: string | undefined;
    /** 审核点名称 */
    name: string | undefined;
    /** 是否必须二维码 */
    mustQRCode: boolean;
    /** 是否必须电子标签 */
    mustNFC: boolean;
    /** 二维码guid */
    qrCode: string | undefined;
    /** 电子标签序号 */
    nfcNo: string | undefined;
    /** 电子标签标志 */
    nfcid: string | undefined;
    /** 责任人 */
    respId: number;
    /** 责任人名称 */
    respName: string | undefined;
    /** 是否启用 */
    enable: boolean;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 排序 */
    sn: number;
    /** 子集 */
    children: AuditPointRecordDto[] | undefined;
    /** title */
    title: string | undefined;
    /** key */
    key: number;
    /** 计划审核次数 */
    planAuditCount: number;
    /** 实际审核次数 */
    aclAuditCount: number;
    /** 完成率 */
    completionRate: number;
    /** 问题数量 */
    issueCount: number;
}

export class PagedResultDtoOfAuditPointRecordDto implements IPagedResultDtoOfAuditPointRecordDto {
    totalCount: number;
    items: AuditPointRecordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditPointRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditPointRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditPointRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditPointRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfAuditPointRecordDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuditPointRecordDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuditPointRecordDto {
    totalCount: number;
    items: AuditPointRecordDto[] | undefined;
}

/** 审核任务柱状图Dto */
export class AuditTaskHistogramDto implements IAuditTaskHistogramDto {
    /** 月份 */
    month: string | undefined;
    /** 任务总数 */
    auditTaskPlanCount: number;
    /** 任务完成数 */
    auditTaskCompleteCount: number;
    /** 任务完成率 */
    completePercent: number;

    constructor(data?: IAuditTaskHistogramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.auditTaskPlanCount = _data["auditTaskPlanCount"];
            this.auditTaskCompleteCount = _data["auditTaskCompleteCount"];
            this.completePercent = _data["completePercent"];
        }
    }

    static fromJS(data: any): AuditTaskHistogramDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskHistogramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["auditTaskPlanCount"] = this.auditTaskPlanCount;
        data["auditTaskCompleteCount"] = this.auditTaskCompleteCount;
        data["completePercent"] = this.completePercent;
        return data;
    }

    clone(): AuditTaskHistogramDto {
        const json = this.toJSON();
        let result = new AuditTaskHistogramDto();
        result.init(json);
        return result;
    }
}

/** 审核任务柱状图Dto */
export interface IAuditTaskHistogramDto {
    /** 月份 */
    month: string | undefined;
    /** 任务总数 */
    auditTaskPlanCount: number;
    /** 任务完成数 */
    auditTaskCompleteCount: number;
    /** 任务完成率 */
    completePercent: number;
}

/** 获取层级报表 */
export class GetAuditTaskLevelReportEntityDto implements IGetAuditTaskLevelReportEntityDto {
    levelName: string | undefined;
    planCount: number;
    aclCount: number;
    completionRate: number;

    constructor(data?: IGetAuditTaskLevelReportEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelName = _data["levelName"];
            this.planCount = _data["planCount"];
            this.aclCount = _data["aclCount"];
            this.completionRate = _data["completionRate"];
        }
    }

    static fromJS(data: any): GetAuditTaskLevelReportEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditTaskLevelReportEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["planCount"] = this.planCount;
        data["aclCount"] = this.aclCount;
        data["completionRate"] = this.completionRate;
        return data;
    }

    clone(): GetAuditTaskLevelReportEntityDto {
        const json = this.toJSON();
        let result = new GetAuditTaskLevelReportEntityDto();
        result.init(json);
        return result;
    }
}

/** 获取层级报表 */
export interface IGetAuditTaskLevelReportEntityDto {
    levelName: string | undefined;
    planCount: number;
    aclCount: number;
    completionRate: number;
}

/** 获取层级报表 */
export class GetAuditTaskLevelReportDto implements IGetAuditTaskLevelReportDto {
    month: number;
    level: GetAuditTaskLevelReportEntityDto[] | undefined;

    constructor(data?: IGetAuditTaskLevelReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            if (Array.isArray(_data["level"])) {
                this.level = [] as any;
                for (let item of _data["level"])
                    this.level.push(GetAuditTaskLevelReportEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAuditTaskLevelReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuditTaskLevelReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        if (Array.isArray(this.level)) {
            data["level"] = [];
            for (let item of this.level)
                data["level"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAuditTaskLevelReportDto {
        const json = this.toJSON();
        let result = new GetAuditTaskLevelReportDto();
        result.init(json);
        return result;
    }
}

/** 获取层级报表 */
export interface IGetAuditTaskLevelReportDto {
    month: number;
    level: GetAuditTaskLevelReportEntityDto[] | undefined;
}

export class GetDeptAuditTaskCompletionRateDto implements IGetDeptAuditTaskCompletionRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 计划数量 */
    planList: number[] | undefined;
    /** 完成数量 */
    finshList: number[] | undefined;
    /** 完成率 */
    finshRateList: number[] | undefined;
    /** 未完成数量 */
    noFinshList: number[] | undefined;

    constructor(data?: IGetDeptAuditTaskCompletionRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["planList"])) {
                this.planList = [] as any;
                for (let item of _data["planList"])
                    this.planList.push(item);
            }
            if (Array.isArray(_data["finshList"])) {
                this.finshList = [] as any;
                for (let item of _data["finshList"])
                    this.finshList.push(item);
            }
            if (Array.isArray(_data["finshRateList"])) {
                this.finshRateList = [] as any;
                for (let item of _data["finshRateList"])
                    this.finshRateList.push(item);
            }
            if (Array.isArray(_data["noFinshList"])) {
                this.noFinshList = [] as any;
                for (let item of _data["noFinshList"])
                    this.noFinshList.push(item);
            }
        }
    }

    static fromJS(data: any): GetDeptAuditTaskCompletionRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeptAuditTaskCompletionRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.planList)) {
            data["planList"] = [];
            for (let item of this.planList)
                data["planList"].push(item);
        }
        if (Array.isArray(this.finshList)) {
            data["finshList"] = [];
            for (let item of this.finshList)
                data["finshList"].push(item);
        }
        if (Array.isArray(this.finshRateList)) {
            data["finshRateList"] = [];
            for (let item of this.finshRateList)
                data["finshRateList"].push(item);
        }
        if (Array.isArray(this.noFinshList)) {
            data["noFinshList"] = [];
            for (let item of this.noFinshList)
                data["noFinshList"].push(item);
        }
        return data;
    }

    clone(): GetDeptAuditTaskCompletionRateDto {
        const json = this.toJSON();
        let result = new GetDeptAuditTaskCompletionRateDto();
        result.init(json);
        return result;
    }
}

export interface IGetDeptAuditTaskCompletionRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 计划数量 */
    planList: number[] | undefined;
    /** 完成数量 */
    finshList: number[] | undefined;
    /** 完成率 */
    finshRateList: number[] | undefined;
    /** 未完成数量 */
    noFinshList: number[] | undefined;
}

/** 获取单个部门每个月的问题数量 */
export class GetEveryMonthIssueCountForDeptEntityDto implements IGetEveryMonthIssueCountForDeptEntityDto {
    month: number;
    count: number;

    constructor(data?: IGetEveryMonthIssueCountForDeptEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetEveryMonthIssueCountForDeptEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEveryMonthIssueCountForDeptEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["count"] = this.count;
        return data;
    }

    clone(): GetEveryMonthIssueCountForDeptEntityDto {
        const json = this.toJSON();
        let result = new GetEveryMonthIssueCountForDeptEntityDto();
        result.init(json);
        return result;
    }
}

/** 获取单个部门每个月的问题数量 */
export interface IGetEveryMonthIssueCountForDeptEntityDto {
    month: number;
    count: number;
}

/** 获取部门每个月的问题数量 */
export class GetEveryMonthIssueCountForDeptDto implements IGetEveryMonthIssueCountForDeptDto {
    id: number;
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 层级名称 */
    levelName: string | undefined;
    levelNameAndName: string | undefined;
    children: GetEveryMonthIssueCountForDeptDto[] | undefined;
    monthCount: GetEveryMonthIssueCountForDeptEntityDto[] | undefined;

    constructor(data?: IGetEveryMonthIssueCountForDeptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pId = _data["pId"];
            this.leveIndex = _data["leveIndex"];
            this.remark = _data["remark"];
            this.levelName = _data["levelName"];
            this.levelNameAndName = _data["levelNameAndName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GetEveryMonthIssueCountForDeptDto.fromJS(item));
            }
            if (Array.isArray(_data["monthCount"])) {
                this.monthCount = [] as any;
                for (let item of _data["monthCount"])
                    this.monthCount.push(GetEveryMonthIssueCountForDeptEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEveryMonthIssueCountForDeptDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEveryMonthIssueCountForDeptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pId"] = this.pId;
        data["leveIndex"] = this.leveIndex;
        data["remark"] = this.remark;
        data["levelName"] = this.levelName;
        data["levelNameAndName"] = this.levelNameAndName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.monthCount)) {
            data["monthCount"] = [];
            for (let item of this.monthCount)
                data["monthCount"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetEveryMonthIssueCountForDeptDto {
        const json = this.toJSON();
        let result = new GetEveryMonthIssueCountForDeptDto();
        result.init(json);
        return result;
    }
}

/** 获取部门每个月的问题数量 */
export interface IGetEveryMonthIssueCountForDeptDto {
    id: number;
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 层级名称 */
    levelName: string | undefined;
    levelNameAndName: string | undefined;
    children: GetEveryMonthIssueCountForDeptDto[] | undefined;
    monthCount: GetEveryMonthIssueCountForDeptEntityDto[] | undefined;
}

/** 人员未完成数量 */
export class GetInCompleteAuditInspTopTenDto implements IGetInCompleteAuditInspTopTenDto {
    /** 人员Id */
    inspId: number;
    /** 人员名称 */
    inspName: string | undefined;
    /** 人员未完成数量 */
    inspInCompleteCount: number;

    constructor(data?: IGetInCompleteAuditInspTopTenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspId = _data["inspId"];
            this.inspName = _data["inspName"];
            this.inspInCompleteCount = _data["inspInCompleteCount"];
        }
    }

    static fromJS(data: any): GetInCompleteAuditInspTopTenDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInCompleteAuditInspTopTenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspId"] = this.inspId;
        data["inspName"] = this.inspName;
        data["inspInCompleteCount"] = this.inspInCompleteCount;
        return data;
    }

    clone(): GetInCompleteAuditInspTopTenDto {
        const json = this.toJSON();
        let result = new GetInCompleteAuditInspTopTenDto();
        result.init(json);
        return result;
    }
}

/** 人员未完成数量 */
export interface IGetInCompleteAuditInspTopTenDto {
    /** 人员Id */
    inspId: number;
    /** 人员名称 */
    inspName: string | undefined;
    /** 人员未完成数量 */
    inspInCompleteCount: number;
}

/** 获取责任部门问题关闭率数据Dto */
export class GetInspDeptIssueCloseRateDto implements IGetInspDeptIssueCloseRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueList: number[] | undefined;
    /** 关闭数量 */
    closeList: number[] | undefined;
    /** 关闭率 */
    closeRateList: number[] | undefined;
    /** 未关闭数量 */
    noCloseList: number[] | undefined;

    constructor(data?: IGetInspDeptIssueCloseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["monthList"])) {
                this.monthList = [] as any;
                for (let item of _data["monthList"])
                    this.monthList.push(item);
            }
            if (Array.isArray(_data["issueList"])) {
                this.issueList = [] as any;
                for (let item of _data["issueList"])
                    this.issueList.push(item);
            }
            if (Array.isArray(_data["closeList"])) {
                this.closeList = [] as any;
                for (let item of _data["closeList"])
                    this.closeList.push(item);
            }
            if (Array.isArray(_data["closeRateList"])) {
                this.closeRateList = [] as any;
                for (let item of _data["closeRateList"])
                    this.closeRateList.push(item);
            }
            if (Array.isArray(_data["noCloseList"])) {
                this.noCloseList = [] as any;
                for (let item of _data["noCloseList"])
                    this.noCloseList.push(item);
            }
        }
    }

    static fromJS(data: any): GetInspDeptIssueCloseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInspDeptIssueCloseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.monthList)) {
            data["monthList"] = [];
            for (let item of this.monthList)
                data["monthList"].push(item);
        }
        if (Array.isArray(this.issueList)) {
            data["issueList"] = [];
            for (let item of this.issueList)
                data["issueList"].push(item);
        }
        if (Array.isArray(this.closeList)) {
            data["closeList"] = [];
            for (let item of this.closeList)
                data["closeList"].push(item);
        }
        if (Array.isArray(this.closeRateList)) {
            data["closeRateList"] = [];
            for (let item of this.closeRateList)
                data["closeRateList"].push(item);
        }
        if (Array.isArray(this.noCloseList)) {
            data["noCloseList"] = [];
            for (let item of this.noCloseList)
                data["noCloseList"].push(item);
        }
        return data;
    }

    clone(): GetInspDeptIssueCloseRateDto {
        const json = this.toJSON();
        let result = new GetInspDeptIssueCloseRateDto();
        result.init(json);
        return result;
    }
}

/** 获取责任部门问题关闭率数据Dto */
export interface IGetInspDeptIssueCloseRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 问题数量 */
    issueList: number[] | undefined;
    /** 关闭数量 */
    closeList: number[] | undefined;
    /** 关闭率 */
    closeRateList: number[] | undefined;
    /** 未关闭数量 */
    noCloseList: number[] | undefined;
}

export class GetIssueThirtyDayNoCloseForDeptDto implements IGetIssueThirtyDayNoCloseForDeptDto {
    id: number;
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 层级名称 */
    levelName: string | undefined;
    levelNameAndName: string | undefined;
    /** 问题数量 */
    issueCount: number;
    /** 关闭数量 */
    closeCount: number;
    /** 未关闭数量 */
    noCloseCount: number;
    children: GetIssueThirtyDayNoCloseForDeptDto[] | undefined;

    constructor(data?: IGetIssueThirtyDayNoCloseForDeptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pId = _data["pId"];
            this.leveIndex = _data["leveIndex"];
            this.remark = _data["remark"];
            this.statisticsOrg = _data["statisticsOrg"];
            this.levelName = _data["levelName"];
            this.levelNameAndName = _data["levelNameAndName"];
            this.issueCount = _data["issueCount"];
            this.closeCount = _data["closeCount"];
            this.noCloseCount = _data["noCloseCount"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GetIssueThirtyDayNoCloseForDeptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIssueThirtyDayNoCloseForDeptDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueThirtyDayNoCloseForDeptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pId"] = this.pId;
        data["leveIndex"] = this.leveIndex;
        data["remark"] = this.remark;
        data["statisticsOrg"] = this.statisticsOrg;
        data["levelName"] = this.levelName;
        data["levelNameAndName"] = this.levelNameAndName;
        data["issueCount"] = this.issueCount;
        data["closeCount"] = this.closeCount;
        data["noCloseCount"] = this.noCloseCount;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIssueThirtyDayNoCloseForDeptDto {
        const json = this.toJSON();
        let result = new GetIssueThirtyDayNoCloseForDeptDto();
        result.init(json);
        return result;
    }
}

export interface IGetIssueThirtyDayNoCloseForDeptDto {
    id: number;
    /** 架构名称 */
    name: string | undefined;
    /** 父级ID */
    pId: number;
    /** 层级等级（倒序 0：最上层） */
    leveIndex: number;
    /** 备注 */
    remark: string | undefined;
    /** 部门归属 */
    statisticsOrg: string | undefined;
    /** 层级名称 */
    levelName: string | undefined;
    levelNameAndName: string | undefined;
    /** 问题数量 */
    issueCount: number;
    /** 关闭数量 */
    closeCount: number;
    /** 未关闭数量 */
    noCloseCount: number;
    children: GetIssueThirtyDayNoCloseForDeptDto[] | undefined;
}

export class GetIssueThirtyDayNoCloseForInspDto implements IGetIssueThirtyDayNoCloseForInspDto {
    /** 人员Id */
    inspId: number;
    /** 人员名称 */
    inspName: string | undefined;
    /** 人员未完成数量 */
    issueCount: number;

    constructor(data?: IGetIssueThirtyDayNoCloseForInspDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inspId = _data["inspId"];
            this.inspName = _data["inspName"];
            this.issueCount = _data["issueCount"];
        }
    }

    static fromJS(data: any): GetIssueThirtyDayNoCloseForInspDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueThirtyDayNoCloseForInspDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspId"] = this.inspId;
        data["inspName"] = this.inspName;
        data["issueCount"] = this.issueCount;
        return data;
    }

    clone(): GetIssueThirtyDayNoCloseForInspDto {
        const json = this.toJSON();
        let result = new GetIssueThirtyDayNoCloseForInspDto();
        result.init(json);
        return result;
    }
}

export interface IGetIssueThirtyDayNoCloseForInspDto {
    /** 人员Id */
    inspId: number;
    /** 人员名称 */
    inspName: string | undefined;
    /** 人员未完成数量 */
    issueCount: number;
}

export class GetIssueThirtyDayNoCloseForListDto implements IGetIssueThirtyDayNoCloseForListDto {
    id: number | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    sourceName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    discoverer: string | undefined;
    /** 发现人部门 */
    discovererDept: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 责任部门 */
    respDept: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    auditPoint: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    auditItemName: string | undefined;
    /** 审核项详细描述 */
    auditItemDescription: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 审核项序号 */
    auditItemSN: number;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    foreColor: string | undefined;
    issueSubscribeId: number | undefined;
    /** 24小时 */
    twentyFourHour: string | undefined;
    /** 30天 */
    thirtyDays: string | undefined;
    /** 是否六个月内重复发生 */
    recurrence: string | undefined;
    /** 问题修改记录 */
    history: IssueHistory[] | undefined;

    constructor(data?: IGetIssueThirtyDayNoCloseForListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceType = _data["sourceType"];
            this.sourceName = _data["sourceName"];
            this.issueTypeId = _data["issueTypeId"];
            if (Array.isArray(_data["issueTypeIdList"])) {
                this.issueTypeIdList = [] as any;
                for (let item of _data["issueTypeIdList"])
                    this.issueTypeIdList.push(item);
            }
            this.issueTypeName = _data["issueTypeName"];
            this.issueTypeListName = _data["issueTypeListName"];
            this.issueProgress = _data["issueProgress"];
            this.issueProgressName = _data["issueProgressName"];
            this.description = _data["description"];
            this.discovererId = _data["discovererId"];
            this.discoverer = _data["discoverer"];
            this.discovererDept = _data["discovererDept"];
            this.discoveryTime = _data["discoveryTime"] ? moment(_data["discoveryTime"].toString()) : <any>undefined;
            this.respId = _data["respId"];
            this.respName = _data["respName"];
            this.respDept = _data["respDept"];
            this.auditTaskId = _data["auditTaskId"];
            this.auditPointId = _data["auditPointId"];
            this.auditPoint = _data["auditPoint"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.auditItemDescription = _data["auditItemDescription"];
            if (Array.isArray(_data["auditItemTypeIdList"])) {
                this.auditItemTypeIdList = [] as any;
                for (let item of _data["auditItemTypeIdList"])
                    this.auditItemTypeIdList.push(item);
            }
            this.auditItemTypeListName = _data["auditItemTypeListName"];
            this.auditItemSN = _data["auditItemSN"];
            this.planStart = _data["planStart"] ? moment(_data["planStart"].toString()) : <any>undefined;
            this.planEnd = _data["planEnd"] ? moment(_data["planEnd"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.discoveryPicture = _data["discoveryPicture"];
            this.improvePicture = _data["improvePicture"];
            this.improveNote = _data["improveNote"];
            this.correctiveNote = _data["correctiveNote"];
            this.remark = _data["remark"];
            this.realPath = _data["realPath"];
            this.tempPath = _data["tempPath"];
            this.foreColor = _data["foreColor"];
            this.issueSubscribeId = _data["issueSubscribeId"];
            this.twentyFourHour = _data["twentyFourHour"];
            this.thirtyDays = _data["thirtyDays"];
            this.recurrence = _data["recurrence"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history.push(IssueHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIssueThirtyDayNoCloseForListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueThirtyDayNoCloseForListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceType"] = this.sourceType;
        data["sourceName"] = this.sourceName;
        data["issueTypeId"] = this.issueTypeId;
        if (Array.isArray(this.issueTypeIdList)) {
            data["issueTypeIdList"] = [];
            for (let item of this.issueTypeIdList)
                data["issueTypeIdList"].push(item);
        }
        data["issueTypeName"] = this.issueTypeName;
        data["issueTypeListName"] = this.issueTypeListName;
        data["issueProgress"] = this.issueProgress;
        data["issueProgressName"] = this.issueProgressName;
        data["description"] = this.description;
        data["discovererId"] = this.discovererId;
        data["discoverer"] = this.discoverer;
        data["discovererDept"] = this.discovererDept;
        data["discoveryTime"] = this.discoveryTime ? this.discoveryTime.toISOString() : <any>undefined;
        data["respId"] = this.respId;
        data["respName"] = this.respName;
        data["respDept"] = this.respDept;
        data["auditTaskId"] = this.auditTaskId;
        data["auditPointId"] = this.auditPointId;
        data["auditPoint"] = this.auditPoint;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["auditItemDescription"] = this.auditItemDescription;
        if (Array.isArray(this.auditItemTypeIdList)) {
            data["auditItemTypeIdList"] = [];
            for (let item of this.auditItemTypeIdList)
                data["auditItemTypeIdList"].push(item);
        }
        data["auditItemTypeListName"] = this.auditItemTypeListName;
        data["auditItemSN"] = this.auditItemSN;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["planEnd"] = this.planEnd ? this.planEnd.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["discoveryPicture"] = this.discoveryPicture;
        data["improvePicture"] = this.improvePicture;
        data["improveNote"] = this.improveNote;
        data["correctiveNote"] = this.correctiveNote;
        data["remark"] = this.remark;
        data["realPath"] = this.realPath;
        data["tempPath"] = this.tempPath;
        data["foreColor"] = this.foreColor;
        data["issueSubscribeId"] = this.issueSubscribeId;
        data["twentyFourHour"] = this.twentyFourHour;
        data["thirtyDays"] = this.thirtyDays;
        data["recurrence"] = this.recurrence;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetIssueThirtyDayNoCloseForListDto {
        const json = this.toJSON();
        let result = new GetIssueThirtyDayNoCloseForListDto();
        result.init(json);
        return result;
    }
}

export interface IGetIssueThirtyDayNoCloseForListDto {
    id: number | undefined;
    /** 问题来源类型（字典）1.审核时发现 2.即时问题 */
    sourceType: string | undefined;
    sourceName: string | undefined;
    /** 问题类型 */
    issueTypeId: number | undefined;
    /** 问题类型(多选) */
    issueTypeIdList: number[] | undefined;
    issueTypeName: string | undefined;
    /** 问题类型(多选) */
    issueTypeListName: string | undefined;
    /** 问题进度（存问题进度的值，不是id） */
    issueProgress: number;
    /** 问题状态名称 */
    issueProgressName: string | undefined;
    /** 问题描述 */
    description: string | undefined;
    /** 发现人 */
    discovererId: number;
    discoverer: string | undefined;
    /** 发现人部门 */
    discovererDept: string | undefined;
    /** 发现时间 */
    discoveryTime: moment.Moment;
    /** 责任人 */
    respId: number | undefined;
    /** 责任人 */
    respName: string | undefined;
    /** 责任部门 */
    respDept: string | undefined;
    /** 审核任务Id */
    auditTaskId: number | undefined;
    /** 审核点 */
    auditPointId: number | undefined;
    auditPoint: string | undefined;
    /** 审核项 */
    auditItemId: number | undefined;
    auditItemName: string | undefined;
    /** 审核项详细描述 */
    auditItemDescription: string | undefined;
    /** 审核项类型（多选） */
    auditItemTypeIdList: number[] | undefined;
    /** 审核项类型名称（多选） */
    auditItemTypeListName: string | undefined;
    /** 审核项序号 */
    auditItemSN: number;
    /** 计划开始处理日期 */
    planStart: moment.Moment | undefined;
    /** 计划完成日期 */
    planEnd: moment.Moment | undefined;
    /** 实际开始时间 */
    startTime: moment.Moment | undefined;
    /** 实际完成时间 */
    closeTime: moment.Moment | undefined;
    /** 发现时照片 */
    discoveryPicture: string | undefined;
    /** 改善照片 */
    improvePicture: string | undefined;
    /** 改善建议 */
    improveNote: string | undefined;
    /** 改正措施 */
    correctiveNote: string | undefined;
    /** 备注 */
    remark: string | undefined;
    realPath: string | undefined;
    tempPath: string | undefined;
    foreColor: string | undefined;
    issueSubscribeId: number | undefined;
    /** 24小时 */
    twentyFourHour: string | undefined;
    /** 30天 */
    thirtyDays: string | undefined;
    /** 是否六个月内重复发生 */
    recurrence: string | undefined;
    /** 问题修改记录 */
    history: IssueHistory[] | undefined;
}

export class PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto implements IPagedResultDtoOfGetIssueThirtyDayNoCloseForListDto {
    totalCount: number;
    items: GetIssueThirtyDayNoCloseForListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIssueThirtyDayNoCloseForListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetIssueThirtyDayNoCloseForListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetIssueThirtyDayNoCloseForListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetIssueThirtyDayNoCloseForListDto {
    totalCount: number;
    items: GetIssueThirtyDayNoCloseForListDto[] | undefined;
}

/** 获取按问题分类分组的关闭率数据 */
export class GetIssueTypeGroupCloseRateDto implements IGetIssueTypeGroupCloseRateDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 计划完成时间 */
    planFinishTime: number;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 上级编码 */
    pCode: number;
    /** 子编码 */
    children: GetIssueTypeGroupCloseRateDto[] | undefined;
    /** 问题数量 */
    issueCount: number;
    /** 关闭数量 */
    closeCount: number;
    /** 关闭率 */
    closeRate: number;
    /** 未关闭数量 */
    noCloseCount: number;

    constructor(data?: IGetIssueTypeGroupCloseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.planFinishTime = _data["planFinishTime"];
            this.remark = _data["remark"];
            this.pId = _data["pId"];
            this.pCode = _data["pCode"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(GetIssueTypeGroupCloseRateDto.fromJS(item));
            }
            this.issueCount = _data["issueCount"];
            this.closeCount = _data["closeCount"];
            this.closeRate = _data["closeRate"];
            this.noCloseCount = _data["noCloseCount"];
        }
    }

    static fromJS(data: any): GetIssueTypeGroupCloseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIssueTypeGroupCloseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["planFinishTime"] = this.planFinishTime;
        data["remark"] = this.remark;
        data["pId"] = this.pId;
        data["pCode"] = this.pCode;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["issueCount"] = this.issueCount;
        data["closeCount"] = this.closeCount;
        data["closeRate"] = this.closeRate;
        data["noCloseCount"] = this.noCloseCount;
        return data;
    }

    clone(): GetIssueTypeGroupCloseRateDto {
        const json = this.toJSON();
        let result = new GetIssueTypeGroupCloseRateDto();
        result.init(json);
        return result;
    }
}

/** 获取按问题分类分组的关闭率数据 */
export interface IGetIssueTypeGroupCloseRateDto {
    /** Id */
    id: number;
    /** 编码 */
    code: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** 计划完成时间 */
    planFinishTime: number;
    /** 备注 */
    remark: string | undefined;
    /** 上级Id */
    pId: number;
    /** 上级编码 */
    pCode: number;
    /** 子编码 */
    children: GetIssueTypeGroupCloseRateDto[] | undefined;
    /** 问题数量 */
    issueCount: number;
    /** 关闭数量 */
    closeCount: number;
    /** 关闭率 */
    closeRate: number;
    /** 未关闭数量 */
    noCloseCount: number;
}

/** 问题关闭率 月 */
export class GetMonthClosePercentDto implements IGetMonthClosePercentDto {
    /** 月份 */
    month: string | undefined;
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
    /** 问题关闭数 */
    closeCount: number;
    /** 问题关闭率 */
    closePercent: number;

    constructor(data?: IGetMonthClosePercentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.name = _data["name"];
            this.problemCount = _data["problemCount"];
            this.closeCount = _data["closeCount"];
            this.closePercent = _data["closePercent"];
        }
    }

    static fromJS(data: any): GetMonthClosePercentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthClosePercentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["name"] = this.name;
        data["problemCount"] = this.problemCount;
        data["closeCount"] = this.closeCount;
        data["closePercent"] = this.closePercent;
        return data;
    }

    clone(): GetMonthClosePercentDto {
        const json = this.toJSON();
        let result = new GetMonthClosePercentDto();
        result.init(json);
        return result;
    }
}

/** 问题关闭率 月 */
export interface IGetMonthClosePercentDto {
    /** 月份 */
    month: string | undefined;
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
    /** 问题关闭数 */
    closeCount: number;
    /** 问题关闭率 */
    closePercent: number;
}

/** 总体符合率Dto */
export class GetOverAllComplianceRateDto implements IGetOverAllComplianceRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 审核记录合格数量 */
    finishAuditItemList: number[] | undefined;
    /** 审核记录数量 */
    auditItemList: number[] | undefined;
    /** 符合率 */
    complianceRateList: number[] | undefined;

    constructor(data?: IGetOverAllComplianceRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deptList"])) {
                this.deptList = [] as any;
                for (let item of _data["deptList"])
                    this.deptList.push(LayoutOrgListDto.fromJS(item));
            }
            if (Array.isArray(_data["monthList"])) {
                this.monthList = [] as any;
                for (let item of _data["monthList"])
                    this.monthList.push(item);
            }
            if (Array.isArray(_data["finishAuditItemList"])) {
                this.finishAuditItemList = [] as any;
                for (let item of _data["finishAuditItemList"])
                    this.finishAuditItemList.push(item);
            }
            if (Array.isArray(_data["auditItemList"])) {
                this.auditItemList = [] as any;
                for (let item of _data["auditItemList"])
                    this.auditItemList.push(item);
            }
            if (Array.isArray(_data["complianceRateList"])) {
                this.complianceRateList = [] as any;
                for (let item of _data["complianceRateList"])
                    this.complianceRateList.push(item);
            }
        }
    }

    static fromJS(data: any): GetOverAllComplianceRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOverAllComplianceRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deptList)) {
            data["deptList"] = [];
            for (let item of this.deptList)
                data["deptList"].push(item.toJSON());
        }
        if (Array.isArray(this.monthList)) {
            data["monthList"] = [];
            for (let item of this.monthList)
                data["monthList"].push(item);
        }
        if (Array.isArray(this.finishAuditItemList)) {
            data["finishAuditItemList"] = [];
            for (let item of this.finishAuditItemList)
                data["finishAuditItemList"].push(item);
        }
        if (Array.isArray(this.auditItemList)) {
            data["auditItemList"] = [];
            for (let item of this.auditItemList)
                data["auditItemList"].push(item);
        }
        if (Array.isArray(this.complianceRateList)) {
            data["complianceRateList"] = [];
            for (let item of this.complianceRateList)
                data["complianceRateList"].push(item);
        }
        return data;
    }

    clone(): GetOverAllComplianceRateDto {
        const json = this.toJSON();
        let result = new GetOverAllComplianceRateDto();
        result.init(json);
        return result;
    }
}

/** 总体符合率Dto */
export interface IGetOverAllComplianceRateDto {
    /** 部门（用于本月统计） */
    deptList: LayoutOrgListDto[] | undefined;
    /** 月份（用于年度统计） */
    monthList: string[] | undefined;
    /** 审核记录合格数量 */
    finishAuditItemList: number[] | undefined;
    /** 审核记录数量 */
    auditItemList: number[] | undefined;
    /** 符合率 */
    complianceRateList: number[] | undefined;
}

/** 问题报表详情 */
export class GetRespIssueStatisticsDetailDto implements IGetRespIssueStatisticsDetailDto {
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;

    constructor(data?: IGetRespIssueStatisticsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.problemCount = _data["problemCount"];
        }
    }

    static fromJS(data: any): GetRespIssueStatisticsDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRespIssueStatisticsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["problemCount"] = this.problemCount;
        return data;
    }

    clone(): GetRespIssueStatisticsDetailDto {
        const json = this.toJSON();
        let result = new GetRespIssueStatisticsDetailDto();
        result.init(json);
        return result;
    }
}

/** 问题报表详情 */
export interface IGetRespIssueStatisticsDetailDto {
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
}

/** 问题报表 */
export class GetRespIssueStatisticsDto implements IGetRespIssueStatisticsDto {
    /** 详细数据 */
    data: GetRespIssueStatisticsDetailDto[] | undefined;
    /** 问题分类 */
    progressNameList: string[] | undefined;
    /** 人员 */
    respList: string[] | undefined;

    constructor(data?: IGetRespIssueStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(GetRespIssueStatisticsDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["progressNameList"])) {
                this.progressNameList = [] as any;
                for (let item of _data["progressNameList"])
                    this.progressNameList.push(item);
            }
            if (Array.isArray(_data["respList"])) {
                this.respList = [] as any;
                for (let item of _data["respList"])
                    this.respList.push(item);
            }
        }
    }

    static fromJS(data: any): GetRespIssueStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRespIssueStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.progressNameList)) {
            data["progressNameList"] = [];
            for (let item of this.progressNameList)
                data["progressNameList"].push(item);
        }
        if (Array.isArray(this.respList)) {
            data["respList"] = [];
            for (let item of this.respList)
                data["respList"].push(item);
        }
        return data;
    }

    clone(): GetRespIssueStatisticsDto {
        const json = this.toJSON();
        let result = new GetRespIssueStatisticsDto();
        result.init(json);
        return result;
    }
}

/** 问题报表 */
export interface IGetRespIssueStatisticsDto {
    /** 详细数据 */
    data: GetRespIssueStatisticsDetailDto[] | undefined;
    /** 问题分类 */
    progressNameList: string[] | undefined;
    /** 人员 */
    respList: string[] | undefined;
}

/** 获取六个月内重复问题 */
export class GetSixMonthRepeatIssueDto implements IGetSixMonthRepeatIssueDto {
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 数量 */
    issueCount: number;
    /** 数量 */
    issueIdList: number[] | undefined;

    constructor(data?: IGetSixMonthRepeatIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditPointId = _data["auditPointId"];
            this.auditPointName = _data["auditPointName"];
            this.auditItemId = _data["auditItemId"];
            this.auditItemName = _data["auditItemName"];
            this.issueCount = _data["issueCount"];
            if (Array.isArray(_data["issueIdList"])) {
                this.issueIdList = [] as any;
                for (let item of _data["issueIdList"])
                    this.issueIdList.push(item);
            }
        }
    }

    static fromJS(data: any): GetSixMonthRepeatIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSixMonthRepeatIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditPointId"] = this.auditPointId;
        data["auditPointName"] = this.auditPointName;
        data["auditItemId"] = this.auditItemId;
        data["auditItemName"] = this.auditItemName;
        data["issueCount"] = this.issueCount;
        if (Array.isArray(this.issueIdList)) {
            data["issueIdList"] = [];
            for (let item of this.issueIdList)
                data["issueIdList"].push(item);
        }
        return data;
    }

    clone(): GetSixMonthRepeatIssueDto {
        const json = this.toJSON();
        let result = new GetSixMonthRepeatIssueDto();
        result.init(json);
        return result;
    }
}

/** 获取六个月内重复问题 */
export interface IGetSixMonthRepeatIssueDto {
    /** 审核点Id */
    auditPointId: number;
    /** 审核点名称 */
    auditPointName: string | undefined;
    /** 审核项Id */
    auditItemId: number;
    /** 审核项名称 */
    auditItemName: string | undefined;
    /** 数量 */
    issueCount: number;
    /** 数量 */
    issueIdList: number[] | undefined;
}

/** 获取24小时内问题关闭率 */
export class GetTwentyFourInnerIssueCloseRateDto implements IGetTwentyFourInnerIssueCloseRateDto {
    /** 月份 */
    month: string | undefined;
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
    /** 问题关闭数 */
    closeCount: number;
    /** 问题未关闭数 */
    notCloseCount: number;
    /** 问题关闭率 */
    closePercent: number;

    constructor(data?: IGetTwentyFourInnerIssueCloseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.name = _data["name"];
            this.problemCount = _data["problemCount"];
            this.closeCount = _data["closeCount"];
            this.notCloseCount = _data["notCloseCount"];
            this.closePercent = _data["closePercent"];
        }
    }

    static fromJS(data: any): GetTwentyFourInnerIssueCloseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTwentyFourInnerIssueCloseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["name"] = this.name;
        data["problemCount"] = this.problemCount;
        data["closeCount"] = this.closeCount;
        data["notCloseCount"] = this.notCloseCount;
        data["closePercent"] = this.closePercent;
        return data;
    }

    clone(): GetTwentyFourInnerIssueCloseRateDto {
        const json = this.toJSON();
        let result = new GetTwentyFourInnerIssueCloseRateDto();
        result.init(json);
        return result;
    }
}

/** 获取24小时内问题关闭率 */
export interface IGetTwentyFourInnerIssueCloseRateDto {
    /** 月份 */
    month: string | undefined;
    /** 问题分类名称或者人员名称 */
    name: string | undefined;
    /** 问题总数 */
    problemCount: number;
    /** 问题关闭数 */
    closeCount: number;
    /** 问题未关闭数 */
    notCloseCount: number;
    /** 问题关闭率 */
    closePercent: number;
}

export class UserAuditRecordDto implements IUserAuditRecordDto {
    /** Id */
    id: number;
    /** 系统用户 */
    userId: number;
    /** 可为责任人 */
    isResponsible: boolean;
    /** 可为审核人 */
    isAuditor: boolean;
    /** LPA组织架构 */
    orgId: number;
    orgPId: number;
    /** 默认审核方案 */
    auditTemplateId: number | undefined;
    /** 用户姓名 */
    realName: string | undefined;
    /** 组织架构名 */
    orgName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 计划审核次数 */
    planAuditCount: number;
    /** 实际审核次数 */
    aclAuditCount: number;
    /** 完成率 */
    completionRate: number;
    /** 审核数量 */
    auditItemCount: number;
    /** 实际审核数量 */
    aclAuditItemCount: number;
    /** 符合数量 */
    complianceCount: number;
    /** 不符合数量 */
    notComplianceCount: number;
    /** 符合率 */
    complianceRate: number;
    /** 关键岗位 */
    isKeyPositions: boolean;
    /** 月度隐患数量指标 */
    monthlyIssueIndicators: number;

    constructor(data?: IUserAuditRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.isResponsible = _data["isResponsible"];
            this.isAuditor = _data["isAuditor"];
            this.orgId = _data["orgId"];
            this.orgPId = _data["orgPId"];
            this.auditTemplateId = _data["auditTemplateId"];
            this.realName = _data["realName"];
            this.orgName = _data["orgName"];
            this.remark = _data["remark"];
            this.planAuditCount = _data["planAuditCount"];
            this.aclAuditCount = _data["aclAuditCount"];
            this.completionRate = _data["completionRate"];
            this.auditItemCount = _data["auditItemCount"];
            this.aclAuditItemCount = _data["aclAuditItemCount"];
            this.complianceCount = _data["complianceCount"];
            this.notComplianceCount = _data["notComplianceCount"];
            this.complianceRate = _data["complianceRate"];
            this.isKeyPositions = _data["isKeyPositions"];
            this.monthlyIssueIndicators = _data["monthlyIssueIndicators"];
        }
    }

    static fromJS(data: any): UserAuditRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuditRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["isResponsible"] = this.isResponsible;
        data["isAuditor"] = this.isAuditor;
        data["orgId"] = this.orgId;
        data["orgPId"] = this.orgPId;
        data["auditTemplateId"] = this.auditTemplateId;
        data["realName"] = this.realName;
        data["orgName"] = this.orgName;
        data["remark"] = this.remark;
        data["planAuditCount"] = this.planAuditCount;
        data["aclAuditCount"] = this.aclAuditCount;
        data["completionRate"] = this.completionRate;
        data["auditItemCount"] = this.auditItemCount;
        data["aclAuditItemCount"] = this.aclAuditItemCount;
        data["complianceCount"] = this.complianceCount;
        data["notComplianceCount"] = this.notComplianceCount;
        data["complianceRate"] = this.complianceRate;
        data["isKeyPositions"] = this.isKeyPositions;
        data["monthlyIssueIndicators"] = this.monthlyIssueIndicators;
        return data;
    }

    clone(): UserAuditRecordDto {
        const json = this.toJSON();
        let result = new UserAuditRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUserAuditRecordDto {
    /** Id */
    id: number;
    /** 系统用户 */
    userId: number;
    /** 可为责任人 */
    isResponsible: boolean;
    /** 可为审核人 */
    isAuditor: boolean;
    /** LPA组织架构 */
    orgId: number;
    orgPId: number;
    /** 默认审核方案 */
    auditTemplateId: number | undefined;
    /** 用户姓名 */
    realName: string | undefined;
    /** 组织架构名 */
    orgName: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 计划审核次数 */
    planAuditCount: number;
    /** 实际审核次数 */
    aclAuditCount: number;
    /** 完成率 */
    completionRate: number;
    /** 审核数量 */
    auditItemCount: number;
    /** 实际审核数量 */
    aclAuditItemCount: number;
    /** 符合数量 */
    complianceCount: number;
    /** 不符合数量 */
    notComplianceCount: number;
    /** 符合率 */
    complianceRate: number;
    /** 关键岗位 */
    isKeyPositions: boolean;
    /** 月度隐患数量指标 */
    monthlyIssueIndicators: number;
}

export class PagedResultDtoOfUserAuditRecordDto implements IPagedResultDtoOfUserAuditRecordDto {
    totalCount: number;
    items: UserAuditRecordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserAuditRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserAuditRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserAuditRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserAuditRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserAuditRecordDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserAuditRecordDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserAuditRecordDto {
    totalCount: number;
    items: UserAuditRecordDto[] | undefined;
}

export class UserRoleList implements IUserRoleList {
    userId: number;
    /** 兼职部门ID */
    pDepartmentId: number | undefined;

    constructor(data?: IUserRoleList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.pDepartmentId = _data["pDepartmentId"];
        }
    }

    static fromJS(data: any): UserRoleList {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["pDepartmentId"] = this.pDepartmentId;
        return data;
    }

    clone(): UserRoleList {
        const json = this.toJSON();
        let result = new UserRoleList();
        result.init(json);
        return result;
    }
}

export interface IUserRoleList {
    userId: number;
    /** 兼职部门ID */
    pDepartmentId: number | undefined;
}

export class UserRoleInput implements IUserRoleInput {
    roleId: number;
    userIds: number[] | undefined;
    userList: UserRoleList[] | undefined;

    constructor(data?: IUserRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList.push(UserRoleList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserRoleInput {
        const json = this.toJSON();
        let result = new UserRoleInput();
        result.init(json);
        return result;
    }
}

export interface IUserRoleInput {
    roleId: number;
    userIds: number[] | undefined;
    userList: UserRoleList[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): CreateOrUpdateRoleInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateRoleInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    createUserName: string | undefined;
    updateUserName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.createUserName = _data["createUserName"];
            this.updateUserName = _data["updateUserName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["createUserName"] = this.createUserName;
        data["updateUserName"] = this.updateUserName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    createUserName: string | undefined;
    updateUserName: string | undefined;
    description: string | undefined;
    id: number;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfRoleListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class PagedResultDtoOfRoleListDto implements IPagedResultDtoOfRoleListDto {
    totalCount: number;
    items: RoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfRoleListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleListDto {
    totalCount: number;
    items: RoleListDto[] | undefined;
}

export class RoleUserDto implements IRoleUserDto {
    id: number | undefined;
    /** 账号Id */
    userId: number | undefined;
    /** 员工ID */
    empId: number | undefined;
    /** 公司Id */
    companyId: number | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 部门 */
    department: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 账号 */
    userName: string | undefined;

    constructor(data?: IRoleUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.empId = _data["empId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"];
            this.jobNumber = _data["jobNumber"];
            this.idPhoto = _data["idPhoto"];
            this.realName = _data["realName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): RoleUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["empId"] = this.empId;
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department;
        data["jobNumber"] = this.jobNumber;
        data["idPhoto"] = this.idPhoto;
        data["realName"] = this.realName;
        data["userName"] = this.userName;
        return data;
    }

    clone(): RoleUserDto {
        const json = this.toJSON();
        let result = new RoleUserDto();
        result.init(json);
        return result;
    }
}

export interface IRoleUserDto {
    id: number | undefined;
    /** 账号Id */
    userId: number | undefined;
    /** 员工ID */
    empId: number | undefined;
    /** 公司Id */
    companyId: number | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 部门 */
    department: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 账号 */
    userName: string | undefined;
}

export class PagedResultDtoOfRoleUserDto implements IPagedResultDtoOfRoleUserDto {
    totalCount: number;
    items: RoleUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfRoleUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleUserDto {
    totalCount: number;
    items: RoleUserDto[] | undefined;
}

export class UpdateRolePermissionsInput implements IUpdateRolePermissionsInput {
    roleId: number;
    grantedPermissionNames: string[];

    constructor(data?: IUpdateRolePermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRolePermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRolePermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): UpdateRolePermissionsInput {
        const json = this.toJSON();
        let result = new UpdateRolePermissionsInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateRolePermissionsInput {
    roleId: number;
    grantedPermissionNames: string[];
}

/** 选项类型实体 */
export class SceneEditDto implements ISceneEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 菜单Id */
    moudleId: number;
    /** app菜单Id */
    appMoudleId: number;

    constructor(data?: ISceneEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.moudleId = _data["moudleId"];
            this.appMoudleId = _data["appMoudleId"];
        }
    }

    static fromJS(data: any): SceneEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SceneEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["moudleId"] = this.moudleId;
        data["appMoudleId"] = this.appMoudleId;
        return data;
    }

    clone(): SceneEditDto {
        const json = this.toJSON();
        let result = new SceneEditDto();
        result.init(json);
        return result;
    }
}

/** 选项类型实体 */
export interface ISceneEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 菜单Id */
    moudleId: number;
    /** app菜单Id */
    appMoudleId: number;
}

/** 选项类型列表实体 */
export class SceneListDto implements ISceneListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;

    constructor(data?: ISceneListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SceneListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SceneListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SceneListDto {
        const json = this.toJSON();
        let result = new SceneListDto();
        result.init(json);
        return result;
    }
}

/** 选项类型列表实体 */
export interface ISceneListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
}

export class PagedResultDtoOfSceneListDto implements IPagedResultDtoOfSceneListDto {
    totalCount: number;
    items: SceneListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSceneListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SceneListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSceneListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSceneListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfSceneListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSceneListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSceneListDto {
    totalCount: number;
    items: SceneListDto[] | undefined;
}

export class ModuleColumn implements IModuleColumn {
    moduleId: number;
    gridName: string | undefined;
    enCode: string | undefined;
    fullName: string | undefined;
    sortCode: string | undefined;
    tenantId: number;
    templateId: number;
    id: number;

    constructor(data?: IModuleColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.gridName = _data["gridName"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.sortCode = _data["sortCode"];
            this.tenantId = _data["tenantId"];
            this.templateId = _data["templateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModuleColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["gridName"] = this.gridName;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["sortCode"] = this.sortCode;
        data["tenantId"] = this.tenantId;
        data["templateId"] = this.templateId;
        data["id"] = this.id;
        return data;
    }

    clone(): ModuleColumn {
        const json = this.toJSON();
        let result = new ModuleColumn();
        result.init(json);
        return result;
    }
}

export interface IModuleColumn {
    moduleId: number;
    gridName: string | undefined;
    enCode: string | undefined;
    fullName: string | undefined;
    sortCode: string | undefined;
    tenantId: number;
    templateId: number;
    id: number;
}

export class SystemUserAuthConfigDto implements ISystemUserAuthConfigDto {
    /** 菜单列表 */
    moduleListDtoList: ModuleTreeDto[] | undefined;
    /** 按钮权限 */
    moduleButtonDic: { [key: string]: string[]; } | undefined;
    /** 列权限 */
    moduleColumnDic: { [key: string]: ModuleColumn[]; } | undefined;

    constructor(data?: ISystemUserAuthConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["moduleListDtoList"])) {
                this.moduleListDtoList = [] as any;
                for (let item of _data["moduleListDtoList"])
                    this.moduleListDtoList.push(ModuleTreeDto.fromJS(item));
            }
            if (_data["moduleButtonDic"]) {
                this.moduleButtonDic = {} as any;
                for (let key in _data["moduleButtonDic"]) {
                    if (_data["moduleButtonDic"].hasOwnProperty(key))
                        (<any>this.moduleButtonDic)[key] = _data["moduleButtonDic"][key] !== undefined ? _data["moduleButtonDic"][key] : [];
                }
            }
            if (_data["moduleColumnDic"]) {
                this.moduleColumnDic = {} as any;
                for (let key in _data["moduleColumnDic"]) {
                    if (_data["moduleColumnDic"].hasOwnProperty(key))
                        (<any>this.moduleColumnDic)[key] = _data["moduleColumnDic"][key] ? _data["moduleColumnDic"][key].map((i: any) => ModuleColumn.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): SystemUserAuthConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserAuthConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleListDtoList)) {
            data["moduleListDtoList"] = [];
            for (let item of this.moduleListDtoList)
                data["moduleListDtoList"].push(item.toJSON());
        }
        if (this.moduleButtonDic) {
            data["moduleButtonDic"] = {};
            for (let key in this.moduleButtonDic) {
                if (this.moduleButtonDic.hasOwnProperty(key))
                    (<any>data["moduleButtonDic"])[key] = (<any>this.moduleButtonDic)[key];
            }
        }
        if (this.moduleColumnDic) {
            data["moduleColumnDic"] = {};
            for (let key in this.moduleColumnDic) {
                if (this.moduleColumnDic.hasOwnProperty(key))
                    (<any>data["moduleColumnDic"])[key] = (<any>this.moduleColumnDic)[key];
            }
        }
        return data;
    }

    clone(): SystemUserAuthConfigDto {
        const json = this.toJSON();
        let result = new SystemUserAuthConfigDto();
        result.init(json);
        return result;
    }
}

export interface ISystemUserAuthConfigDto {
    /** 菜单列表 */
    moduleListDtoList: ModuleTreeDto[] | undefined;
    /** 按钮权限 */
    moduleButtonDic: { [key: string]: string[]; } | undefined;
    /** 列权限 */
    moduleColumnDic: { [key: string]: ModuleColumn[]; } | undefined;
}

export class UserInfoDto implements IUserInfoDto {
    userName: string | undefined;
    isTenantAdmin: number | undefined;
    userId: number;
    tenantId: number | undefined;
    tenantName: string | undefined;
    tenantCode: string | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 单点登录ID */
    ssoGuid: string | undefined;
    /** 个人头像Id */
    profilePictureId: string | undefined;
    /** 显示名称-------------------新增 */
    realName: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    department: number | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 手机 */
    mobile: string | undefined;
    /** 性别 */
    genderCode: string | undefined;
    /** 部门ID */
    departmentId: number | undefined;
    /** 岗位ID */
    postId: number | undefined;
    /** 员工ID */
    empId: number | undefined;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.isTenantAdmin = _data["isTenantAdmin"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.tenantCode = _data["tenantCode"];
            this.userPictureType = _data["userPictureType"];
            this.ssoGuid = _data["ssoGuid"];
            this.profilePictureId = _data["profilePictureId"];
            this.realName = _data["realName"];
            this.companyId = _data["companyId"];
            this.department = _data["department"];
            this.jobNumber = _data["jobNumber"];
            this.mobile = _data["mobile"];
            this.genderCode = _data["genderCode"];
            this.departmentId = _data["departmentId"];
            this.postId = _data["postId"];
            this.empId = _data["empId"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["isTenantAdmin"] = this.isTenantAdmin;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["tenantCode"] = this.tenantCode;
        data["userPictureType"] = this.userPictureType;
        data["ssoGuid"] = this.ssoGuid;
        data["profilePictureId"] = this.profilePictureId;
        data["realName"] = this.realName;
        data["companyId"] = this.companyId;
        data["department"] = this.department;
        data["jobNumber"] = this.jobNumber;
        data["mobile"] = this.mobile;
        data["genderCode"] = this.genderCode;
        data["departmentId"] = this.departmentId;
        data["postId"] = this.postId;
        data["empId"] = this.empId;
        return data;
    }

    clone(): UserInfoDto {
        const json = this.toJSON();
        let result = new UserInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserInfoDto {
    userName: string | undefined;
    isTenantAdmin: number | undefined;
    userId: number;
    tenantId: number | undefined;
    tenantName: string | undefined;
    tenantCode: string | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 单点登录ID */
    ssoGuid: string | undefined;
    /** 个人头像Id */
    profilePictureId: string | undefined;
    /** 显示名称-------------------新增 */
    realName: string | undefined;
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    department: number | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 手机 */
    mobile: string | undefined;
    /** 性别 */
    genderCode: string | undefined;
    /** 部门ID */
    departmentId: number | undefined;
    /** 岗位ID */
    postId: number | undefined;
    /** 员工ID */
    empId: number | undefined;
}

export class AbpUserCurrentCultureConfigDto implements IAbpUserCurrentCultureConfigDto {
    name: string | undefined;
    displayName: string | undefined;

    constructor(data?: IAbpUserCurrentCultureConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AbpUserCurrentCultureConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserCurrentCultureConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): AbpUserCurrentCultureConfigDto {
        const json = this.toJSON();
        let result = new AbpUserCurrentCultureConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserCurrentCultureConfigDto {
    name: string | undefined;
    displayName: string | undefined;
}

export class LanguageInfo implements ILanguageInfo {
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDefault: boolean;
    isDisabled: boolean;
    readonly isRightToLeft: boolean;

    constructor(data?: ILanguageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDefault = _data["isDefault"];
            this.isDisabled = _data["isDisabled"];
            (<any>this).isRightToLeft = _data["isRightToLeft"];
        }
    }

    static fromJS(data: any): LanguageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDefault"] = this.isDefault;
        data["isDisabled"] = this.isDisabled;
        data["isRightToLeft"] = this.isRightToLeft;
        return data;
    }

    clone(): LanguageInfo {
        const json = this.toJSON();
        let result = new LanguageInfo();
        result.init(json);
        return result;
    }
}

export interface ILanguageInfo {
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDefault: boolean;
    isDisabled: boolean;
    isRightToLeft: boolean;
}

export class AbpLocalizationSourceDto implements IAbpLocalizationSourceDto {
    name: string | undefined;
    type: string | undefined;

    constructor(data?: IAbpLocalizationSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AbpLocalizationSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpLocalizationSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }

    clone(): AbpLocalizationSourceDto {
        const json = this.toJSON();
        let result = new AbpLocalizationSourceDto();
        result.init(json);
        return result;
    }
}

export interface IAbpLocalizationSourceDto {
    name: string | undefined;
    type: string | undefined;
}

export class AbpUserLocalizationConfigDto implements IAbpUserLocalizationConfigDto {
    currentCulture: AbpUserCurrentCultureConfigDto;
    languages: LanguageInfo[] | undefined;
    currentLanguage: LanguageInfo;
    sources: AbpLocalizationSourceDto[] | undefined;
    values: { [key: string]: { [key: string]: string; }; } | undefined;

    constructor(data?: IAbpUserLocalizationConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentCulture = _data["currentCulture"] ? AbpUserCurrentCultureConfigDto.fromJS(_data["currentCulture"]) : <any>undefined;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages.push(LanguageInfo.fromJS(item));
            }
            this.currentLanguage = _data["currentLanguage"] ? LanguageInfo.fromJS(_data["currentLanguage"]) : <any>undefined;
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources.push(AbpLocalizationSourceDto.fromJS(item));
            }
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)[key] = _data["values"][key] !== undefined ? _data["values"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): AbpUserLocalizationConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserLocalizationConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentCulture"] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["currentLanguage"] = this.currentLanguage ? this.currentLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }

    clone(): AbpUserLocalizationConfigDto {
        const json = this.toJSON();
        let result = new AbpUserLocalizationConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserLocalizationConfigDto {
    currentCulture: AbpUserCurrentCultureConfigDto;
    languages: LanguageInfo[] | undefined;
    currentLanguage: LanguageInfo;
    sources: AbpLocalizationSourceDto[] | undefined;
    values: { [key: string]: { [key: string]: string; }; } | undefined;
}

export class AppSystemUserConfigurationDto implements IAppSystemUserConfigurationDto {
    auth: SystemUserAuthConfigDto;
    /** 是否拥有打卡权限 */
    isClock: boolean;
    /** 是否拥有查看所有问题反馈 */
    isFeedback: boolean;
    /** 是否拥有沃德特有功能权限 */
    isWDSF: boolean;
    userInfo: UserInfoDto;
    localization: AbpUserLocalizationConfigDto;
    /** 获取默认场景Id */
    scenesId: number;

    constructor(data?: IAppSystemUserConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auth = _data["auth"] ? SystemUserAuthConfigDto.fromJS(_data["auth"]) : <any>undefined;
            this.isClock = _data["isClock"];
            this.isFeedback = _data["isFeedback"];
            this.isWDSF = _data["isWDSF"];
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : <any>undefined;
            this.localization = _data["localization"] ? AbpUserLocalizationConfigDto.fromJS(_data["localization"]) : <any>undefined;
            this.scenesId = _data["scenesId"];
        }
    }

    static fromJS(data: any): AppSystemUserConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSystemUserConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auth"] = this.auth ? this.auth.toJSON() : <any>undefined;
        data["isClock"] = this.isClock;
        data["isFeedback"] = this.isFeedback;
        data["isWDSF"] = this.isWDSF;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["scenesId"] = this.scenesId;
        return data;
    }

    clone(): AppSystemUserConfigurationDto {
        const json = this.toJSON();
        let result = new AppSystemUserConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAppSystemUserConfigurationDto {
    auth: SystemUserAuthConfigDto;
    /** 是否拥有打卡权限 */
    isClock: boolean;
    /** 是否拥有查看所有问题反馈 */
    isFeedback: boolean;
    /** 是否拥有沃德特有功能权限 */
    isWDSF: boolean;
    userInfo: UserInfoDto;
    localization: AbpUserLocalizationConfigDto;
    /** 获取默认场景Id */
    scenesId: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }

    clone(): EditionInfoDto {
        const json = this.toJSON();
        let result = new EditionInfoDto();
        result.init(json);
        return result;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
}

export enum MultiTenancySides {
    Tenant = <any>"Tenant",
    Host = <any>"Host",
}

export class AbpMultiTenancySidesConfigDto implements IAbpMultiTenancySidesConfigDto {
    host: MultiTenancySides;
    tenant: MultiTenancySides;

    constructor(data?: IAbpMultiTenancySidesConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.host = _data["host"];
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): AbpMultiTenancySidesConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpMultiTenancySidesConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["host"] = this.host;
        data["tenant"] = this.tenant;
        return data;
    }

    clone(): AbpMultiTenancySidesConfigDto {
        const json = this.toJSON();
        let result = new AbpMultiTenancySidesConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpMultiTenancySidesConfigDto {
    host: MultiTenancySides;
    tenant: MultiTenancySides;
}

export class AbpMultiTenancyConfigDto implements IAbpMultiTenancyConfigDto {
    isEnabled: boolean;
    ignoreFeatureCheckForHostUsers: boolean;
    sides: AbpMultiTenancySidesConfigDto;

    constructor(data?: IAbpMultiTenancyConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.ignoreFeatureCheckForHostUsers = _data["ignoreFeatureCheckForHostUsers"];
            this.sides = _data["sides"] ? AbpMultiTenancySidesConfigDto.fromJS(_data["sides"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpMultiTenancyConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpMultiTenancyConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["ignoreFeatureCheckForHostUsers"] = this.ignoreFeatureCheckForHostUsers;
        data["sides"] = this.sides ? this.sides.toJSON() : <any>undefined;
        return data;
    }

    clone(): AbpMultiTenancyConfigDto {
        const json = this.toJSON();
        let result = new AbpMultiTenancyConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpMultiTenancyConfigDto {
    isEnabled: boolean;
    ignoreFeatureCheckForHostUsers: boolean;
    sides: AbpMultiTenancySidesConfigDto;
}

export class AbpUserSessionConfigDto implements IAbpUserSessionConfigDto {
    userId: number | undefined;
    tenantId: number | undefined;
    impersonatorUserId: number | undefined;
    impersonatorTenantId: number | undefined;
    multiTenancySide: MultiTenancySides;

    constructor(data?: IAbpUserSessionConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.multiTenancySide = _data["multiTenancySide"];
        }
    }

    static fromJS(data: any): AbpUserSessionConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserSessionConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["multiTenancySide"] = this.multiTenancySide;
        return data;
    }

    clone(): AbpUserSessionConfigDto {
        const json = this.toJSON();
        let result = new AbpUserSessionConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserSessionConfigDto {
    userId: number | undefined;
    tenantId: number | undefined;
    impersonatorUserId: number | undefined;
    impersonatorTenantId: number | undefined;
    multiTenancySide: MultiTenancySides;
}

export class AbpStringValueDto implements IAbpStringValueDto {
    value: string | undefined;

    constructor(data?: IAbpStringValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AbpStringValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpStringValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }

    clone(): AbpStringValueDto {
        const json = this.toJSON();
        let result = new AbpStringValueDto();
        result.init(json);
        return result;
    }
}

export interface IAbpStringValueDto {
    value: string | undefined;
}

export class AbpUserFeatureConfigDto implements IAbpUserFeatureConfigDto {
    allFeatures: { [key: string]: AbpStringValueDto; } | undefined;

    constructor(data?: IAbpUserFeatureConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["allFeatures"]) {
                this.allFeatures = {} as any;
                for (let key in _data["allFeatures"]) {
                    if (_data["allFeatures"].hasOwnProperty(key))
                        (<any>this.allFeatures)[key] = _data["allFeatures"][key] ? AbpStringValueDto.fromJS(_data["allFeatures"][key]) : new AbpStringValueDto();
                }
            }
        }
    }

    static fromJS(data: any): AbpUserFeatureConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserFeatureConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures) {
            data["allFeatures"] = {};
            for (let key in this.allFeatures) {
                if (this.allFeatures.hasOwnProperty(key))
                    (<any>data["allFeatures"])[key] = this.allFeatures[key] ? this.allFeatures[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): AbpUserFeatureConfigDto {
        const json = this.toJSON();
        let result = new AbpUserFeatureConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserFeatureConfigDto {
    allFeatures: { [key: string]: AbpStringValueDto; } | undefined;
}

export class UserMenuItem implements IUserMenuItem {
    name: string | undefined;
    icon: string | undefined;
    displayName: string | undefined;
    order: number;
    url: string | undefined;
    customData: any | undefined;
    target: string | undefined;
    isEnabled: boolean;
    isVisible: boolean;
    items: UserMenuItem[] | undefined;

    constructor(data?: IUserMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.displayName = _data["displayName"];
            this.order = _data["order"];
            this.url = _data["url"];
            this.customData = _data["customData"];
            this.target = _data["target"];
            this.isEnabled = _data["isEnabled"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["displayName"] = this.displayName;
        data["order"] = this.order;
        data["url"] = this.url;
        data["customData"] = this.customData;
        data["target"] = this.target;
        data["isEnabled"] = this.isEnabled;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserMenuItem {
        const json = this.toJSON();
        let result = new UserMenuItem();
        result.init(json);
        return result;
    }
}

export interface IUserMenuItem {
    name: string | undefined;
    icon: string | undefined;
    displayName: string | undefined;
    order: number;
    url: string | undefined;
    customData: any | undefined;
    target: string | undefined;
    isEnabled: boolean;
    isVisible: boolean;
    items: UserMenuItem[] | undefined;
}

export class UserMenu implements IUserMenu {
    name: string | undefined;
    displayName: string | undefined;
    customData: any | undefined;
    items: UserMenuItem[] | undefined;

    constructor(data?: IUserMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.customData = _data["customData"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMenu {
        data = typeof data === 'object' ? data : {};
        let result = new UserMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["customData"] = this.customData;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserMenu {
        const json = this.toJSON();
        let result = new UserMenu();
        result.init(json);
        return result;
    }
}

export interface IUserMenu {
    name: string | undefined;
    displayName: string | undefined;
    customData: any | undefined;
    items: UserMenuItem[] | undefined;
}

export class AbpUserNavConfigDto implements IAbpUserNavConfigDto {
    menus: { [key: string]: UserMenu; } | undefined;

    constructor(data?: IAbpUserNavConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["menus"]) {
                this.menus = {} as any;
                for (let key in _data["menus"]) {
                    if (_data["menus"].hasOwnProperty(key))
                        (<any>this.menus)[key] = _data["menus"][key] ? UserMenu.fromJS(_data["menus"][key]) : new UserMenu();
                }
            }
        }
    }

    static fromJS(data: any): AbpUserNavConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserNavConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.menus) {
            data["menus"] = {};
            for (let key in this.menus) {
                if (this.menus.hasOwnProperty(key))
                    (<any>data["menus"])[key] = this.menus[key] ? this.menus[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): AbpUserNavConfigDto {
        const json = this.toJSON();
        let result = new AbpUserNavConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserNavConfigDto {
    menus: { [key: string]: UserMenu; } | undefined;
}

export class AbpUserSettingConfigDto implements IAbpUserSettingConfigDto {
    values: { [key: string]: string; } | undefined;

    constructor(data?: IAbpUserSettingConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)[key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): AbpUserSettingConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserSettingConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }

    clone(): AbpUserSettingConfigDto {
        const json = this.toJSON();
        let result = new AbpUserSettingConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserSettingConfigDto {
    values: { [key: string]: string; } | undefined;
}

export class AbpUserClockConfigDto implements IAbpUserClockConfigDto {
    provider: string | undefined;

    constructor(data?: IAbpUserClockConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): AbpUserClockConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserClockConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        return data;
    }

    clone(): AbpUserClockConfigDto {
        const json = this.toJSON();
        let result = new AbpUserClockConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserClockConfigDto {
    provider: string | undefined;
}

export class AbpUserWindowsTimeZoneConfigDto implements IAbpUserWindowsTimeZoneConfigDto {
    timeZoneId: string | undefined;
    baseUtcOffsetInMilliseconds: number;
    currentUtcOffsetInMilliseconds: number;
    isDaylightSavingTimeNow: boolean;

    constructor(data?: IAbpUserWindowsTimeZoneConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
            this.baseUtcOffsetInMilliseconds = _data["baseUtcOffsetInMilliseconds"];
            this.currentUtcOffsetInMilliseconds = _data["currentUtcOffsetInMilliseconds"];
            this.isDaylightSavingTimeNow = _data["isDaylightSavingTimeNow"];
        }
    }

    static fromJS(data: any): AbpUserWindowsTimeZoneConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserWindowsTimeZoneConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        data["baseUtcOffsetInMilliseconds"] = this.baseUtcOffsetInMilliseconds;
        data["currentUtcOffsetInMilliseconds"] = this.currentUtcOffsetInMilliseconds;
        data["isDaylightSavingTimeNow"] = this.isDaylightSavingTimeNow;
        return data;
    }

    clone(): AbpUserWindowsTimeZoneConfigDto {
        const json = this.toJSON();
        let result = new AbpUserWindowsTimeZoneConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserWindowsTimeZoneConfigDto {
    timeZoneId: string | undefined;
    baseUtcOffsetInMilliseconds: number;
    currentUtcOffsetInMilliseconds: number;
    isDaylightSavingTimeNow: boolean;
}

export class AbpUserIanaTimeZoneConfigDto implements IAbpUserIanaTimeZoneConfigDto {
    timeZoneId: string | undefined;

    constructor(data?: IAbpUserIanaTimeZoneConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): AbpUserIanaTimeZoneConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserIanaTimeZoneConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }

    clone(): AbpUserIanaTimeZoneConfigDto {
        const json = this.toJSON();
        let result = new AbpUserIanaTimeZoneConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserIanaTimeZoneConfigDto {
    timeZoneId: string | undefined;
}

export class AbpUserTimeZoneConfigDto implements IAbpUserTimeZoneConfigDto {
    windows: AbpUserWindowsTimeZoneConfigDto;
    iana: AbpUserIanaTimeZoneConfigDto;

    constructor(data?: IAbpUserTimeZoneConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.windows = _data["windows"] ? AbpUserWindowsTimeZoneConfigDto.fromJS(_data["windows"]) : <any>undefined;
            this.iana = _data["iana"] ? AbpUserIanaTimeZoneConfigDto.fromJS(_data["iana"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserTimeZoneConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserTimeZoneConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windows"] = this.windows ? this.windows.toJSON() : <any>undefined;
        data["iana"] = this.iana ? this.iana.toJSON() : <any>undefined;
        return data;
    }

    clone(): AbpUserTimeZoneConfigDto {
        const json = this.toJSON();
        let result = new AbpUserTimeZoneConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserTimeZoneConfigDto {
    windows: AbpUserWindowsTimeZoneConfigDto;
    iana: AbpUserIanaTimeZoneConfigDto;
}

export class AbpUserTimingConfigDto implements IAbpUserTimingConfigDto {
    timeZoneInfo: AbpUserTimeZoneConfigDto;

    constructor(data?: IAbpUserTimingConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneInfo = _data["timeZoneInfo"] ? AbpUserTimeZoneConfigDto.fromJS(_data["timeZoneInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserTimingConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserTimingConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneInfo"] = this.timeZoneInfo ? this.timeZoneInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): AbpUserTimingConfigDto {
        const json = this.toJSON();
        let result = new AbpUserTimingConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserTimingConfigDto {
    timeZoneInfo: AbpUserTimeZoneConfigDto;
}

export class AbpUserAntiForgeryConfigDto implements IAbpUserAntiForgeryConfigDto {
    tokenCookieName: string | undefined;
    tokenHeaderName: string | undefined;

    constructor(data?: IAbpUserAntiForgeryConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenCookieName = _data["tokenCookieName"];
            this.tokenHeaderName = _data["tokenHeaderName"];
        }
    }

    static fromJS(data: any): AbpUserAntiForgeryConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserAntiForgeryConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenCookieName"] = this.tokenCookieName;
        data["tokenHeaderName"] = this.tokenHeaderName;
        return data;
    }

    clone(): AbpUserAntiForgeryConfigDto {
        const json = this.toJSON();
        let result = new AbpUserAntiForgeryConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserAntiForgeryConfigDto {
    tokenCookieName: string | undefined;
    tokenHeaderName: string | undefined;
}

export class AbpUserSecurityConfigDto implements IAbpUserSecurityConfigDto {
    antiForgery: AbpUserAntiForgeryConfigDto;

    constructor(data?: IAbpUserSecurityConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.antiForgery = _data["antiForgery"] ? AbpUserAntiForgeryConfigDto.fromJS(_data["antiForgery"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AbpUserSecurityConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserSecurityConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["antiForgery"] = this.antiForgery ? this.antiForgery.toJSON() : <any>undefined;
        return data;
    }

    clone(): AbpUserSecurityConfigDto {
        const json = this.toJSON();
        let result = new AbpUserSecurityConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserSecurityConfigDto {
    antiForgery: AbpUserAntiForgeryConfigDto;
}

export class SystemUserConfigurationDto implements ISystemUserConfigurationDto {
    multiTenancy: AbpMultiTenancyConfigDto;
    session: AbpUserSessionConfigDto;
    localization: AbpUserLocalizationConfigDto;
    features: AbpUserFeatureConfigDto;
    auth: SystemUserAuthConfigDto;
    nav: AbpUserNavConfigDto;
    setting: AbpUserSettingConfigDto;
    clock: AbpUserClockConfigDto;
    timing: AbpUserTimingConfigDto;
    security: AbpUserSecurityConfigDto;
    custom: { [key: string]: any; } | undefined;
    userInfo: UserInfoDto;
    /** 获取默认场景Id */
    scenesId: number;

    constructor(data?: ISystemUserConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiTenancy = _data["multiTenancy"] ? AbpMultiTenancyConfigDto.fromJS(_data["multiTenancy"]) : <any>undefined;
            this.session = _data["session"] ? AbpUserSessionConfigDto.fromJS(_data["session"]) : <any>undefined;
            this.localization = _data["localization"] ? AbpUserLocalizationConfigDto.fromJS(_data["localization"]) : <any>undefined;
            this.features = _data["features"] ? AbpUserFeatureConfigDto.fromJS(_data["features"]) : <any>undefined;
            this.auth = _data["auth"] ? SystemUserAuthConfigDto.fromJS(_data["auth"]) : <any>undefined;
            this.nav = _data["nav"] ? AbpUserNavConfigDto.fromJS(_data["nav"]) : <any>undefined;
            this.setting = _data["setting"] ? AbpUserSettingConfigDto.fromJS(_data["setting"]) : <any>undefined;
            this.clock = _data["clock"] ? AbpUserClockConfigDto.fromJS(_data["clock"]) : <any>undefined;
            this.timing = _data["timing"] ? AbpUserTimingConfigDto.fromJS(_data["timing"]) : <any>undefined;
            this.security = _data["security"] ? AbpUserSecurityConfigDto.fromJS(_data["security"]) : <any>undefined;
            if (_data["custom"]) {
                this.custom = {} as any;
                for (let key in _data["custom"]) {
                    if (_data["custom"].hasOwnProperty(key))
                        (<any>this.custom)[key] = _data["custom"][key];
                }
            }
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : <any>undefined;
            this.scenesId = _data["scenesId"];
        }
    }

    static fromJS(data: any): SystemUserConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiTenancy"] = this.multiTenancy ? this.multiTenancy.toJSON() : <any>undefined;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["auth"] = this.auth ? this.auth.toJSON() : <any>undefined;
        data["nav"] = this.nav ? this.nav.toJSON() : <any>undefined;
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        data["clock"] = this.clock ? this.clock.toJSON() : <any>undefined;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        if (this.custom) {
            data["custom"] = {};
            for (let key in this.custom) {
                if (this.custom.hasOwnProperty(key))
                    (<any>data["custom"])[key] = (<any>this.custom)[key];
            }
        }
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        data["scenesId"] = this.scenesId;
        return data;
    }

    clone(): SystemUserConfigurationDto {
        const json = this.toJSON();
        let result = new SystemUserConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface ISystemUserConfigurationDto {
    multiTenancy: AbpMultiTenancyConfigDto;
    session: AbpUserSessionConfigDto;
    localization: AbpUserLocalizationConfigDto;
    features: AbpUserFeatureConfigDto;
    auth: SystemUserAuthConfigDto;
    nav: AbpUserNavConfigDto;
    setting: AbpUserSettingConfigDto;
    clock: AbpUserClockConfigDto;
    timing: AbpUserTimingConfigDto;
    security: AbpUserSecurityConfigDto;
    custom: { [key: string]: any; } | undefined;
    userInfo: UserInfoDto;
    /** 获取默认场景Id */
    scenesId: number;
}

export class AbpUserAuthConfigDto implements IAbpUserAuthConfigDto {
    allPermissions: { [key: string]: string; } | undefined;
    grantedPermissions: { [key: string]: string; } | undefined;

    constructor(data?: IAbpUserAuthConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["allPermissions"]) {
                this.allPermissions = {} as any;
                for (let key in _data["allPermissions"]) {
                    if (_data["allPermissions"].hasOwnProperty(key))
                        (<any>this.allPermissions)[key] = _data["allPermissions"][key];
                }
            }
            if (_data["grantedPermissions"]) {
                this.grantedPermissions = {} as any;
                for (let key in _data["grantedPermissions"]) {
                    if (_data["grantedPermissions"].hasOwnProperty(key))
                        (<any>this.grantedPermissions)[key] = _data["grantedPermissions"][key];
                }
            }
        }
    }

    static fromJS(data: any): AbpUserAuthConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserAuthConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allPermissions) {
            data["allPermissions"] = {};
            for (let key in this.allPermissions) {
                if (this.allPermissions.hasOwnProperty(key))
                    (<any>data["allPermissions"])[key] = (<any>this.allPermissions)[key];
            }
        }
        if (this.grantedPermissions) {
            data["grantedPermissions"] = {};
            for (let key in this.grantedPermissions) {
                if (this.grantedPermissions.hasOwnProperty(key))
                    (<any>data["grantedPermissions"])[key] = (<any>this.grantedPermissions)[key];
            }
        }
        return data;
    }

    clone(): AbpUserAuthConfigDto {
        const json = this.toJSON();
        let result = new AbpUserAuthConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserAuthConfigDto {
    allPermissions: { [key: string]: string; } | undefined;
    grantedPermissions: { [key: string]: string; } | undefined;
}

export class AbpUserConfigurationDto implements IAbpUserConfigurationDto {
    multiTenancy: AbpMultiTenancyConfigDto;
    session: AbpUserSessionConfigDto;
    localization: AbpUserLocalizationConfigDto;
    features: AbpUserFeatureConfigDto;
    auth: AbpUserAuthConfigDto;
    nav: AbpUserNavConfigDto;
    setting: AbpUserSettingConfigDto;
    clock: AbpUserClockConfigDto;
    timing: AbpUserTimingConfigDto;
    security: AbpUserSecurityConfigDto;
    custom: { [key: string]: any; } | undefined;

    constructor(data?: IAbpUserConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiTenancy = _data["multiTenancy"] ? AbpMultiTenancyConfigDto.fromJS(_data["multiTenancy"]) : <any>undefined;
            this.session = _data["session"] ? AbpUserSessionConfigDto.fromJS(_data["session"]) : <any>undefined;
            this.localization = _data["localization"] ? AbpUserLocalizationConfigDto.fromJS(_data["localization"]) : <any>undefined;
            this.features = _data["features"] ? AbpUserFeatureConfigDto.fromJS(_data["features"]) : <any>undefined;
            this.auth = _data["auth"] ? AbpUserAuthConfigDto.fromJS(_data["auth"]) : <any>undefined;
            this.nav = _data["nav"] ? AbpUserNavConfigDto.fromJS(_data["nav"]) : <any>undefined;
            this.setting = _data["setting"] ? AbpUserSettingConfigDto.fromJS(_data["setting"]) : <any>undefined;
            this.clock = _data["clock"] ? AbpUserClockConfigDto.fromJS(_data["clock"]) : <any>undefined;
            this.timing = _data["timing"] ? AbpUserTimingConfigDto.fromJS(_data["timing"]) : <any>undefined;
            this.security = _data["security"] ? AbpUserSecurityConfigDto.fromJS(_data["security"]) : <any>undefined;
            if (_data["custom"]) {
                this.custom = {} as any;
                for (let key in _data["custom"]) {
                    if (_data["custom"].hasOwnProperty(key))
                        (<any>this.custom)[key] = _data["custom"][key];
                }
            }
        }
    }

    static fromJS(data: any): AbpUserConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AbpUserConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["multiTenancy"] = this.multiTenancy ? this.multiTenancy.toJSON() : <any>undefined;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["auth"] = this.auth ? this.auth.toJSON() : <any>undefined;
        data["nav"] = this.nav ? this.nav.toJSON() : <any>undefined;
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        data["clock"] = this.clock ? this.clock.toJSON() : <any>undefined;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        if (this.custom) {
            data["custom"] = {};
            for (let key in this.custom) {
                if (this.custom.hasOwnProperty(key))
                    (<any>data["custom"])[key] = (<any>this.custom)[key];
            }
        }
        return data;
    }

    clone(): AbpUserConfigurationDto {
        const json = this.toJSON();
        let result = new AbpUserConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAbpUserConfigurationDto {
    multiTenancy: AbpMultiTenancyConfigDto;
    session: AbpUserSessionConfigDto;
    localization: AbpUserLocalizationConfigDto;
    features: AbpUserFeatureConfigDto;
    auth: AbpUserAuthConfigDto;
    nav: AbpUserNavConfigDto;
    setting: AbpUserSettingConfigDto;
    clock: AbpUserClockConfigDto;
    timing: AbpUserTimingConfigDto;
    security: AbpUserSecurityConfigDto;
    custom: { [key: string]: any; } | undefined;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }

    clone(): UpdateUserSignInTokenOutput {
        const json = this.toJSON();
        let result = new UpdateUserSignInTokenOutput();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

/** 班次的列表DTO QYB.QYBProduct.Attendance.ShiftInfo.ShiftInfo */
export class ShiftInfoEditDto implements IShiftInfoEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** WorkTypeCode */
    workTypeCode: string | undefined;
    /** StartTime */
    startTime: string | undefined;
    /** EndTime */
    endTime: string | undefined;
    /** UpCardStartTime */
    upCardStartTime: string | undefined;
    /** UpCardEndTime */
    upCardEndTime: string | undefined;
    /** DownCardStartTime */
    downCardStartTime: string | undefined;
    /** DownCardEndTime */
    downCardEndTime: string | undefined;
    /** RestStartTime */
    restStartTime: string | undefined;
    /** RestEndTime */
    restEndTime: string | undefined;
    /** RestMinutes */
    restMinutes: number | undefined;
    /** WorkHours */
    workHours: number | undefined;
    /** WorkDays */
    workDays: number | undefined;
    /** IsNightShift */
    isNightShift: boolean | undefined;
    /** Allowance */
    allowance: number | undefined;
    lateMinutes: number | undefined;
    /** LeaveEarlyMinutes */
    leaveEarlyMinutes: number | undefined;
    /** AbsenteeismMinutes */
    absenteeismMinutes: number | undefined;
    /** AfterWorkOTStart */
    afterWorkOTStart: string | undefined;

    constructor(data?: IShiftInfoEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.workTypeCode = _data["workTypeCode"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.upCardStartTime = _data["upCardStartTime"];
            this.upCardEndTime = _data["upCardEndTime"];
            this.downCardStartTime = _data["downCardStartTime"];
            this.downCardEndTime = _data["downCardEndTime"];
            this.restStartTime = _data["restStartTime"];
            this.restEndTime = _data["restEndTime"];
            this.restMinutes = _data["restMinutes"];
            this.workHours = _data["workHours"];
            this.workDays = _data["workDays"];
            this.isNightShift = _data["isNightShift"];
            this.allowance = _data["allowance"];
            this.lateMinutes = _data["lateMinutes"];
            this.leaveEarlyMinutes = _data["leaveEarlyMinutes"];
            this.absenteeismMinutes = _data["absenteeismMinutes"];
            this.afterWorkOTStart = _data["afterWorkOTStart"];
        }
    }

    static fromJS(data: any): ShiftInfoEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftInfoEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["workTypeCode"] = this.workTypeCode;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["upCardStartTime"] = this.upCardStartTime;
        data["upCardEndTime"] = this.upCardEndTime;
        data["downCardStartTime"] = this.downCardStartTime;
        data["downCardEndTime"] = this.downCardEndTime;
        data["restStartTime"] = this.restStartTime;
        data["restEndTime"] = this.restEndTime;
        data["restMinutes"] = this.restMinutes;
        data["workHours"] = this.workHours;
        data["workDays"] = this.workDays;
        data["isNightShift"] = this.isNightShift;
        data["allowance"] = this.allowance;
        data["lateMinutes"] = this.lateMinutes;
        data["leaveEarlyMinutes"] = this.leaveEarlyMinutes;
        data["absenteeismMinutes"] = this.absenteeismMinutes;
        data["afterWorkOTStart"] = this.afterWorkOTStart;
        return data;
    }

    clone(): ShiftInfoEditDto {
        const json = this.toJSON();
        let result = new ShiftInfoEditDto();
        result.init(json);
        return result;
    }
}

/** 班次的列表DTO QYB.QYBProduct.Attendance.ShiftInfo.ShiftInfo */
export interface IShiftInfoEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** WorkTypeCode */
    workTypeCode: string | undefined;
    /** StartTime */
    startTime: string | undefined;
    /** EndTime */
    endTime: string | undefined;
    /** UpCardStartTime */
    upCardStartTime: string | undefined;
    /** UpCardEndTime */
    upCardEndTime: string | undefined;
    /** DownCardStartTime */
    downCardStartTime: string | undefined;
    /** DownCardEndTime */
    downCardEndTime: string | undefined;
    /** RestStartTime */
    restStartTime: string | undefined;
    /** RestEndTime */
    restEndTime: string | undefined;
    /** RestMinutes */
    restMinutes: number | undefined;
    /** WorkHours */
    workHours: number | undefined;
    /** WorkDays */
    workDays: number | undefined;
    /** IsNightShift */
    isNightShift: boolean | undefined;
    /** Allowance */
    allowance: number | undefined;
    lateMinutes: number | undefined;
    /** LeaveEarlyMinutes */
    leaveEarlyMinutes: number | undefined;
    /** AbsenteeismMinutes */
    absenteeismMinutes: number | undefined;
    /** AfterWorkOTStart */
    afterWorkOTStart: string | undefined;
}

export class CreateOrUpdateShiftInfoInput implements ICreateOrUpdateShiftInfoInput {
    shiftInfo: ShiftInfoEditDto;

    constructor(data?: ICreateOrUpdateShiftInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.shiftInfo = new ShiftInfoEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftInfo = _data["shiftInfo"] ? ShiftInfoEditDto.fromJS(_data["shiftInfo"]) : new ShiftInfoEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateShiftInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateShiftInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftInfo"] = this.shiftInfo ? this.shiftInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateShiftInfoInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateShiftInfoInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateShiftInfoInput {
    shiftInfo: ShiftInfoEditDto;
}

/** 读取可编辑班次的Dto */
export class GetShiftInfoForEditOutput implements IGetShiftInfoForEditOutput {
    shiftInfo: ShiftInfoEditDto;

    constructor(data?: IGetShiftInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftInfo = _data["shiftInfo"] ? ShiftInfoEditDto.fromJS(_data["shiftInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShiftInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftInfo"] = this.shiftInfo ? this.shiftInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetShiftInfoForEditOutput {
        const json = this.toJSON();
        let result = new GetShiftInfoForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑班次的Dto */
export interface IGetShiftInfoForEditOutput {
    shiftInfo: ShiftInfoEditDto;
}

export class PagedResultDtoOfShiftInfoListDto implements IPagedResultDtoOfShiftInfoListDto {
    totalCount: number;
    items: ShiftInfoListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfShiftInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShiftInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfShiftInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfShiftInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfShiftInfoListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfShiftInfoListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfShiftInfoListDto {
    totalCount: number;
    items: ShiftInfoListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Attendance.SignCardRecord.SignCardRecord */
export class SignCardRecordEditDto implements ISignCardRecordEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    empId: number;
    /** FromGuid */
    fromGuid: string | undefined;
    /** AttDate */
    attDate: moment.Moment;
    /** CheckTime */
    checkTime: moment.Moment;
    /** SignCardType */
    signCardType: string | undefined;
    /** ReasonType */
    reasonType: string | undefined;
    /** Reason */
    reason: string | undefined;

    constructor(data?: ISignCardRecordEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.fromGuid = _data["fromGuid"];
            this.attDate = _data["attDate"] ? moment(_data["attDate"].toString()) : <any>undefined;
            this.checkTime = _data["checkTime"] ? moment(_data["checkTime"].toString()) : <any>undefined;
            this.signCardType = _data["signCardType"];
            this.reasonType = _data["reasonType"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): SignCardRecordEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignCardRecordEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["fromGuid"] = this.fromGuid;
        data["attDate"] = this.attDate ? this.attDate.toISOString() : <any>undefined;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["signCardType"] = this.signCardType;
        data["reasonType"] = this.reasonType;
        data["reason"] = this.reason;
        return data;
    }

    clone(): SignCardRecordEditDto {
        const json = this.toJSON();
        let result = new SignCardRecordEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.SignCardRecord.SignCardRecord */
export interface ISignCardRecordEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    empId: number;
    /** FromGuid */
    fromGuid: string | undefined;
    /** AttDate */
    attDate: moment.Moment;
    /** CheckTime */
    checkTime: moment.Moment;
    /** SignCardType */
    signCardType: string | undefined;
    /** ReasonType */
    reasonType: string | undefined;
    /** Reason */
    reason: string | undefined;
}

export class CreateOrUpdateSignCardRecordInput implements ICreateOrUpdateSignCardRecordInput {
    signCardRecord: SignCardRecordEditDto;

    constructor(data?: ICreateOrUpdateSignCardRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.signCardRecord = new SignCardRecordEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signCardRecord = _data["signCardRecord"] ? SignCardRecordEditDto.fromJS(_data["signCardRecord"]) : new SignCardRecordEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateSignCardRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSignCardRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signCardRecord"] = this.signCardRecord ? this.signCardRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateSignCardRecordInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateSignCardRecordInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateSignCardRecordInput {
    signCardRecord: SignCardRecordEditDto;
}

/** 的列表DTO QYB.QYBProduct.Attendance.SignCardRecord.SignCardRecord */
export class SignCardRecordListDto implements ISignCardRecordListDto {
    /** UserId */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** AttDate */
    attDate: moment.Moment;
    /** CheckTime */
    checkTime: moment.Moment;
    /** SignCardType */
    signCardType: string | undefined;
    /** ReasonType */
    reasonType: string | undefined;
    /** Reason */
    reason: string | undefined;
    id: number;

    constructor(data?: ISignCardRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.departmentName = _data["departmentName"];
            this.fromGuid = _data["fromGuid"];
            this.attDate = _data["attDate"] ? moment(_data["attDate"].toString()) : <any>undefined;
            this.checkTime = _data["checkTime"] ? moment(_data["checkTime"].toString()) : <any>undefined;
            this.signCardType = _data["signCardType"];
            this.reasonType = _data["reasonType"];
            this.reason = _data["reason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SignCardRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignCardRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["departmentName"] = this.departmentName;
        data["fromGuid"] = this.fromGuid;
        data["attDate"] = this.attDate ? this.attDate.toISOString() : <any>undefined;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["signCardType"] = this.signCardType;
        data["reasonType"] = this.reasonType;
        data["reason"] = this.reason;
        data["id"] = this.id;
        return data;
    }

    clone(): SignCardRecordListDto {
        const json = this.toJSON();
        let result = new SignCardRecordListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.SignCardRecord.SignCardRecord */
export interface ISignCardRecordListDto {
    /** UserId */
    empId: number;
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** FromGuid */
    fromGuid: string | undefined;
    /** AttDate */
    attDate: moment.Moment;
    /** CheckTime */
    checkTime: moment.Moment;
    /** SignCardType */
    signCardType: string | undefined;
    /** ReasonType */
    reasonType: string | undefined;
    /** Reason */
    reason: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetSignCardRecordForEditOutput implements IGetSignCardRecordForEditOutput {
    signCardRecord: SignCardRecordEditDto;

    constructor(data?: IGetSignCardRecordForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signCardRecord = _data["signCardRecord"] ? SignCardRecordEditDto.fromJS(_data["signCardRecord"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSignCardRecordForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignCardRecordForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signCardRecord"] = this.signCardRecord ? this.signCardRecord.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetSignCardRecordForEditOutput {
        const json = this.toJSON();
        let result = new GetSignCardRecordForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetSignCardRecordForEditOutput {
    signCardRecord: SignCardRecordEditDto;
}

export class PagedResultDtoOfSignCardRecordListDto implements IPagedResultDtoOfSignCardRecordListDto {
    totalCount: number;
    items: SignCardRecordListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSignCardRecordListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SignCardRecordListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSignCardRecordListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSignCardRecordListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfSignCardRecordListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSignCardRecordListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSignCardRecordListDto {
    totalCount: number;
    items: SignCardRecordListDto[] | undefined;
}

/** 证书表的列表DTO QYB.QYBProduct.Organization.SkillInfo.SkillInfo */
export class SkillInfoEditDto implements ISkillInfoEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 证书名称 */
    name: string | undefined;
    /** 证书类别 */
    skillTypeCode: string | undefined;
    /** 证书级别 */
    skillLevelCode: string | undefined;
    /** 证书编号 */
    certificateNumber: string | undefined;
    /** 专利号 */
    patentNumber: string | undefined;
    /** 附加文件 */
    annexesFileId: string | undefined;
    /** 授权日期 */
    expiryDate: moment.Moment | undefined;
    /** 有效日期 */
    effectiveDate: moment.Moment | undefined;
    /** 备注 */
    description: string | undefined;

    constructor(data?: ISkillInfoEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.name = _data["name"];
            this.skillTypeCode = _data["skillTypeCode"];
            this.skillLevelCode = _data["skillLevelCode"];
            this.certificateNumber = _data["certificateNumber"];
            this.patentNumber = _data["patentNumber"];
            this.annexesFileId = _data["annexesFileId"];
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SkillInfoEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillInfoEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["name"] = this.name;
        data["skillTypeCode"] = this.skillTypeCode;
        data["skillLevelCode"] = this.skillLevelCode;
        data["certificateNumber"] = this.certificateNumber;
        data["patentNumber"] = this.patentNumber;
        data["annexesFileId"] = this.annexesFileId;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }

    clone(): SkillInfoEditDto {
        const json = this.toJSON();
        let result = new SkillInfoEditDto();
        result.init(json);
        return result;
    }
}

/** 证书表的列表DTO QYB.QYBProduct.Organization.SkillInfo.SkillInfo */
export interface ISkillInfoEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 证书名称 */
    name: string | undefined;
    /** 证书类别 */
    skillTypeCode: string | undefined;
    /** 证书级别 */
    skillLevelCode: string | undefined;
    /** 证书编号 */
    certificateNumber: string | undefined;
    /** 专利号 */
    patentNumber: string | undefined;
    /** 附加文件 */
    annexesFileId: string | undefined;
    /** 授权日期 */
    expiryDate: moment.Moment | undefined;
    /** 有效日期 */
    effectiveDate: moment.Moment | undefined;
    /** 备注 */
    description: string | undefined;
}

export class CreateOrUpdateSkillInfoInput implements ICreateOrUpdateSkillInfoInput {
    skillInfo: SkillInfoEditDto;
    /** 附件集合 */
    annexesFile: AnnexesFileEditDto[];

    constructor(data?: ICreateOrUpdateSkillInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.skillInfo = new SkillInfoEditDto();
            this.annexesFile = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillInfo = _data["skillInfo"] ? SkillInfoEditDto.fromJS(_data["skillInfo"]) : new SkillInfoEditDto();
            if (Array.isArray(_data["annexesFile"])) {
                this.annexesFile = [] as any;
                for (let item of _data["annexesFile"])
                    this.annexesFile.push(AnnexesFileEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSkillInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSkillInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillInfo"] = this.skillInfo ? this.skillInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.annexesFile)) {
            data["annexesFile"] = [];
            for (let item of this.annexesFile)
                data["annexesFile"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateSkillInfoInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateSkillInfoInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateSkillInfoInput {
    skillInfo: SkillInfoEditDto;
    /** 附件集合 */
    annexesFile: AnnexesFileEditDto[];
}

/** 证书表的列表DTO QYB.QYBProduct.Organization.SkillInfo.SkillInfo */
export class SkillInfoListDto implements ISkillInfoListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 证书名称 */
    name: string | undefined;
    /** 证书类别 */
    skillTypeCode: string | undefined;
    skIllTypeName: string | undefined;
    /** 证书级别 */
    skillLevelCode: string | undefined;
    skillLecelName: string | undefined;
    /** 证书编号 */
    certificateNumber: string | undefined;
    /** 专利号 */
    patentNumber: string | undefined;
    /** 附加文件 */
    annexesFileId: string | undefined;
    /** 授权日期 */
    expiryDate: moment.Moment | undefined;
    /** 有效日期 */
    effectiveDate: moment.Moment | undefined;
    /** 备注 */
    description: string | undefined;
    id: number;

    constructor(data?: ISkillInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.emp = _data["emp"] ? Employee.fromJS(_data["emp"]) : <any>undefined;
            this.name = _data["name"];
            this.skillTypeCode = _data["skillTypeCode"];
            this.skIllTypeName = _data["skIllTypeName"];
            this.skillLevelCode = _data["skillLevelCode"];
            this.skillLecelName = _data["skillLecelName"];
            this.certificateNumber = _data["certificateNumber"];
            this.patentNumber = _data["patentNumber"];
            this.annexesFileId = _data["annexesFileId"];
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SkillInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["emp"] = this.emp ? this.emp.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["skillTypeCode"] = this.skillTypeCode;
        data["skIllTypeName"] = this.skIllTypeName;
        data["skillLevelCode"] = this.skillLevelCode;
        data["skillLecelName"] = this.skillLecelName;
        data["certificateNumber"] = this.certificateNumber;
        data["patentNumber"] = this.patentNumber;
        data["annexesFileId"] = this.annexesFileId;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): SkillInfoListDto {
        const json = this.toJSON();
        let result = new SkillInfoListDto();
        result.init(json);
        return result;
    }
}

/** 证书表的列表DTO QYB.QYBProduct.Organization.SkillInfo.SkillInfo */
export interface ISkillInfoListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 证书名称 */
    name: string | undefined;
    /** 证书类别 */
    skillTypeCode: string | undefined;
    skIllTypeName: string | undefined;
    /** 证书级别 */
    skillLevelCode: string | undefined;
    skillLecelName: string | undefined;
    /** 证书编号 */
    certificateNumber: string | undefined;
    /** 专利号 */
    patentNumber: string | undefined;
    /** 附加文件 */
    annexesFileId: string | undefined;
    /** 授权日期 */
    expiryDate: moment.Moment | undefined;
    /** 有效日期 */
    effectiveDate: moment.Moment | undefined;
    /** 备注 */
    description: string | undefined;
    id: number;
}

/** 读取可编辑证书表的Dto */
export class GetSkillInfoForEditOutput implements IGetSkillInfoForEditOutput {
    skillInfo: SkillInfoEditDto;
    annexesFile: AnnexesFileEditDto[] | undefined;

    constructor(data?: IGetSkillInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillInfo = _data["skillInfo"] ? SkillInfoEditDto.fromJS(_data["skillInfo"]) : <any>undefined;
            if (Array.isArray(_data["annexesFile"])) {
                this.annexesFile = [] as any;
                for (let item of _data["annexesFile"])
                    this.annexesFile.push(AnnexesFileEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSkillInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkillInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillInfo"] = this.skillInfo ? this.skillInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.annexesFile)) {
            data["annexesFile"] = [];
            for (let item of this.annexesFile)
                data["annexesFile"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetSkillInfoForEditOutput {
        const json = this.toJSON();
        let result = new GetSkillInfoForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑证书表的Dto */
export interface IGetSkillInfoForEditOutput {
    skillInfo: SkillInfoEditDto;
    annexesFile: AnnexesFileEditDto[] | undefined;
}

export class PagedResultDtoOfSkillInfoListDto implements IPagedResultDtoOfSkillInfoListDto {
    totalCount: number;
    items: SkillInfoListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSkillInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SkillInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSkillInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSkillInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfSkillInfoListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSkillInfoListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSkillInfoListDto {
    totalCount: number;
    items: SkillInfoListDto[] | undefined;
}

/** 社会关系表的列表DTO QYB.QYBProduct.Organization.SocialRelation.SocialRelation */
export class SocialRelationEditDto implements ISocialRelationEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 姓名 */
    name: string | undefined;
    /** 关系 */
    relation: string | undefined;
    /** 联系电话 */
    phone: string | undefined;
    /** 是否紧急联系人 */
    isUrgentEmplCode: string | undefined;
    /** 联系地址 */
    relatioAddress: string | undefined;
    /** 备注 */
    description: string | undefined;

    constructor(data?: ISocialRelationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.name = _data["name"];
            this.relation = _data["relation"];
            this.phone = _data["phone"];
            this.isUrgentEmplCode = _data["isUrgentEmplCode"];
            this.relatioAddress = _data["relatioAddress"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SocialRelationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialRelationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["name"] = this.name;
        data["relation"] = this.relation;
        data["phone"] = this.phone;
        data["isUrgentEmplCode"] = this.isUrgentEmplCode;
        data["relatioAddress"] = this.relatioAddress;
        data["description"] = this.description;
        return data;
    }

    clone(): SocialRelationEditDto {
        const json = this.toJSON();
        let result = new SocialRelationEditDto();
        result.init(json);
        return result;
    }
}

/** 社会关系表的列表DTO QYB.QYBProduct.Organization.SocialRelation.SocialRelation */
export interface ISocialRelationEditDto {
    /** Id */
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 姓名 */
    name: string | undefined;
    /** 关系 */
    relation: string | undefined;
    /** 联系电话 */
    phone: string | undefined;
    /** 是否紧急联系人 */
    isUrgentEmplCode: string | undefined;
    /** 联系地址 */
    relatioAddress: string | undefined;
    /** 备注 */
    description: string | undefined;
}

export class CreateOrUpdateSocialRelationInput implements ICreateOrUpdateSocialRelationInput {
    socialRelation: SocialRelationEditDto;

    constructor(data?: ICreateOrUpdateSocialRelationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.socialRelation = new SocialRelationEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialRelation = _data["socialRelation"] ? SocialRelationEditDto.fromJS(_data["socialRelation"]) : new SocialRelationEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateSocialRelationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSocialRelationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialRelation"] = this.socialRelation ? this.socialRelation.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateSocialRelationInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateSocialRelationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateSocialRelationInput {
    socialRelation: SocialRelationEditDto;
}

/** 社会关系表的列表DTO QYB.QYBProduct.Organization.SocialRelation.SocialRelation */
export class SocialRelationListDto implements ISocialRelationListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 姓名 */
    name: string | undefined;
    /** 关系 */
    relation: string | undefined;
    /** 联系电话 */
    phone: string | undefined;
    /** 是否紧急联系人 */
    isUrgentEmplCode: string | undefined;
    isUrgentEmpName: string | undefined;
    /** 联系地址 */
    relatioAddress: string | undefined;
    /** 备注 */
    description: string | undefined;
    id: number;

    constructor(data?: ISocialRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.emp = _data["emp"] ? Employee.fromJS(_data["emp"]) : <any>undefined;
            this.name = _data["name"];
            this.relation = _data["relation"];
            this.phone = _data["phone"];
            this.isUrgentEmplCode = _data["isUrgentEmplCode"];
            this.isUrgentEmpName = _data["isUrgentEmpName"];
            this.relatioAddress = _data["relatioAddress"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SocialRelationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["emp"] = this.emp ? this.emp.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["relation"] = this.relation;
        data["phone"] = this.phone;
        data["isUrgentEmplCode"] = this.isUrgentEmplCode;
        data["isUrgentEmpName"] = this.isUrgentEmpName;
        data["relatioAddress"] = this.relatioAddress;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): SocialRelationListDto {
        const json = this.toJSON();
        let result = new SocialRelationListDto();
        result.init(json);
        return result;
    }
}

/** 社会关系表的列表DTO QYB.QYBProduct.Organization.SocialRelation.SocialRelation */
export interface ISocialRelationListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 姓名 */
    name: string | undefined;
    /** 关系 */
    relation: string | undefined;
    /** 联系电话 */
    phone: string | undefined;
    /** 是否紧急联系人 */
    isUrgentEmplCode: string | undefined;
    isUrgentEmpName: string | undefined;
    /** 联系地址 */
    relatioAddress: string | undefined;
    /** 备注 */
    description: string | undefined;
    id: number;
}

/** 读取可编辑社会关系表的Dto */
export class GetSocialRelationForEditOutput implements IGetSocialRelationForEditOutput {
    socialRelation: SocialRelationEditDto;

    constructor(data?: IGetSocialRelationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialRelation = _data["socialRelation"] ? SocialRelationEditDto.fromJS(_data["socialRelation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialRelationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialRelationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialRelation"] = this.socialRelation ? this.socialRelation.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetSocialRelationForEditOutput {
        const json = this.toJSON();
        let result = new GetSocialRelationForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑社会关系表的Dto */
export interface IGetSocialRelationForEditOutput {
    socialRelation: SocialRelationEditDto;
}

export class PagedResultDtoOfSocialRelationListDto implements IPagedResultDtoOfSocialRelationListDto {
    totalCount: number;
    items: SocialRelationListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSocialRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SocialRelationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSocialRelationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSocialRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfSocialRelationListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSocialRelationListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSocialRelationListDto {
    totalCount: number;
    items: SocialRelationListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.MessageManage.SysClassify.SysClassify */
export class SysClassifyEditDto implements ISysClassifyEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** Icon */
    icon: string | undefined;
    /** Description */
    description: string | undefined;
    /** CreationTime */
    creationTime: moment.Moment;

    constructor(data?: ISysClassifyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.size = _data["size"];
            this.icon = _data["icon"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SysClassifyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysClassifyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["size"] = this.size;
        data["icon"] = this.icon;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): SysClassifyEditDto {
        const json = this.toJSON();
        let result = new SysClassifyEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.MessageManage.SysClassify.SysClassify */
export interface ISysClassifyEditDto {
    /** Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** Icon */
    icon: string | undefined;
    /** Description */
    description: string | undefined;
    /** CreationTime */
    creationTime: moment.Moment;
}

export class CreateOrUpdateSysClassifyInput implements ICreateOrUpdateSysClassifyInput {
    sysClassify: SysClassifyEditDto;

    constructor(data?: ICreateOrUpdateSysClassifyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sysClassify = new SysClassifyEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysClassify = _data["sysClassify"] ? SysClassifyEditDto.fromJS(_data["sysClassify"]) : new SysClassifyEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateSysClassifyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSysClassifyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysClassify"] = this.sysClassify ? this.sysClassify.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateSysClassifyInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateSysClassifyInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateSysClassifyInput {
    sysClassify: SysClassifyEditDto;
}

/** 的列表DTO QYB.QYBProduct.MessageManage.SysClassify.SysClassify */
export class SysClassifyListDto implements ISysClassifyListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** Description */
    description: string | undefined;
    /** CreationTime */
    creationTime: moment.Moment;
    id: number;

    constructor(data?: ISysClassifyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.icon = _data["icon"];
            this.size = _data["size"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SysClassifyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysClassifyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["icon"] = this.icon;
        data["size"] = this.size;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): SysClassifyListDto {
        const json = this.toJSON();
        let result = new SysClassifyListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.MessageManage.SysClassify.SysClassify */
export interface ISysClassifyListDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Icon */
    icon: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** Description */
    description: string | undefined;
    /** CreationTime */
    creationTime: moment.Moment;
    id: number;
}

/** 读取可编辑的Dto */
export class GetSysClassifyForEditOutput implements IGetSysClassifyForEditOutput {
    sysClassify: SysClassifyEditDto;

    constructor(data?: IGetSysClassifyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysClassify = _data["sysClassify"] ? SysClassifyEditDto.fromJS(_data["sysClassify"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSysClassifyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSysClassifyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysClassify"] = this.sysClassify ? this.sysClassify.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetSysClassifyForEditOutput {
        const json = this.toJSON();
        let result = new GetSysClassifyForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetSysClassifyForEditOutput {
    sysClassify: SysClassifyEditDto;
}

export class PagedResultDtoOfSysClassifyListDto implements IPagedResultDtoOfSysClassifyListDto {
    totalCount: number;
    items: SysClassifyListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSysClassifyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SysClassifyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSysClassifyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSysClassifyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfSysClassifyListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSysClassifyListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSysClassifyListDto {
    totalCount: number;
    items: SysClassifyListDto[] | undefined;
}

/** 文件的列表DTO QYB.Modules.FileManager.SysFile */
export class SysFileEditDto implements ISysFileEditDto {
    /** Id */
    id: string | undefined;
    /** 父级Id */
    parentId: string | undefined;
    /** 是否为文件夹 */
    dir: boolean;
    /** 文件名 */
    name: string | undefined;
    /** 原文件名 */
    fileName: string | undefined;

    constructor(data?: ISysFileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.dir = _data["dir"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SysFileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SysFileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["dir"] = this.dir;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): SysFileEditDto {
        const json = this.toJSON();
        let result = new SysFileEditDto();
        result.init(json);
        return result;
    }
}

/** 文件的列表DTO QYB.Modules.FileManager.SysFile */
export interface ISysFileEditDto {
    /** Id */
    id: string | undefined;
    /** 父级Id */
    parentId: string | undefined;
    /** 是否为文件夹 */
    dir: boolean;
    /** 文件名 */
    name: string | undefined;
    /** 原文件名 */
    fileName: string | undefined;
}

/** 读取可编辑文件的Dto */
export class GetSysFileForEditOutput implements IGetSysFileForEditOutput {
    sysFile: SysFileEditDto;

    constructor(data?: IGetSysFileForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sysFile = _data["sysFile"] ? SysFileEditDto.fromJS(_data["sysFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSysFileForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSysFileForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sysFile"] = this.sysFile ? this.sysFile.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetSysFileForEditOutput {
        const json = this.toJSON();
        let result = new GetSysFileForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑文件的Dto */
export interface IGetSysFileForEditOutput {
    sysFile: SysFileEditDto;
}

export class PagedResultDtoOfSysFileListDto implements IPagedResultDtoOfSysFileListDto {
    totalCount: number;
    items: SysFileListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSysFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SysFileListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSysFileListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSysFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfSysFileListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSysFileListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSysFileListDto {
    totalCount: number;
    items: SysFileListDto[] | undefined;
}

export class MoveSysFilesInput implements IMoveSysFilesInput {
    id: string;
    newParentId: string | undefined;

    constructor(data?: IMoveSysFilesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveSysFilesInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveSysFilesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }

    clone(): MoveSysFilesInput {
        const json = this.toJSON();
        let result = new MoveSysFilesInput();
        result.init(json);
        return result;
    }
}

export interface IMoveSysFilesInput {
    id: string;
    newParentId: string | undefined;
}

export class FiledExtSettingsEditDto implements IFiledExtSettingsEditDto {
    /** 条码 */
    templateBarCode: boolean;
    /** 辅助字段 */
    assitField: boolean;
    /** 扩展字段1 */
    filedExt1: boolean;
    /** 扩展字段2 */
    filedExt2: boolean;
    /** 扩展字段3 */
    filedExt3: boolean;

    constructor(data?: IFiledExtSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateBarCode = _data["templateBarCode"];
            this.assitField = _data["assitField"];
            this.filedExt1 = _data["filedExt1"];
            this.filedExt2 = _data["filedExt2"];
            this.filedExt3 = _data["filedExt3"];
        }
    }

    static fromJS(data: any): FiledExtSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiledExtSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateBarCode"] = this.templateBarCode;
        data["assitField"] = this.assitField;
        data["filedExt1"] = this.filedExt1;
        data["filedExt2"] = this.filedExt2;
        data["filedExt3"] = this.filedExt3;
        return data;
    }

    clone(): FiledExtSettingsEditDto {
        const json = this.toJSON();
        let result = new FiledExtSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IFiledExtSettingsEditDto {
    /** 条码 */
    templateBarCode: boolean;
    /** 辅助字段 */
    assitField: boolean;
    /** 扩展字段1 */
    filedExt1: boolean;
    /** 扩展字段2 */
    filedExt2: boolean;
    /** 扩展字段3 */
    filedExt3: boolean;
}

export class LdapSettingDto implements ILdapSettingDto {
    /** 是否启用ldap */
    ldapIsActivate: boolean;
    /** ldap DomainName */
    ldapDomainName: string | undefined;
    /** ldap Container */
    ldapContainer: string | undefined;
    /** Ldap 账号 */
    ldapUserName: string | undefined;
    /** Ldap 密码 */
    ldapPassword: string | undefined;

    constructor(data?: ILdapSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ldapIsActivate = _data["ldapIsActivate"];
            this.ldapDomainName = _data["ldapDomainName"];
            this.ldapContainer = _data["ldapContainer"];
            this.ldapUserName = _data["ldapUserName"];
            this.ldapPassword = _data["ldapPassword"];
        }
    }

    static fromJS(data: any): LdapSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ldapIsActivate"] = this.ldapIsActivate;
        data["ldapDomainName"] = this.ldapDomainName;
        data["ldapContainer"] = this.ldapContainer;
        data["ldapUserName"] = this.ldapUserName;
        data["ldapPassword"] = this.ldapPassword;
        return data;
    }

    clone(): LdapSettingDto {
        const json = this.toJSON();
        let result = new LdapSettingDto();
        result.init(json);
        return result;
    }
}

export interface ILdapSettingDto {
    /** 是否启用ldap */
    ldapIsActivate: boolean;
    /** ldap DomainName */
    ldapDomainName: string | undefined;
    /** ldap Container */
    ldapContainer: string | undefined;
    /** Ldap 账号 */
    ldapUserName: string | undefined;
    /** Ldap 密码 */
    ldapPassword: string | undefined;
}

export class ValidateLogonDto implements IValidateLogonDto {
    /** web验证方式 */
    webVerificationMethod: string | undefined;
    /** app验证方式 */
    appVerificationMethod: string | undefined;

    constructor(data?: IValidateLogonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webVerificationMethod = _data["webVerificationMethod"];
            this.appVerificationMethod = _data["appVerificationMethod"];
        }
    }

    static fromJS(data: any): ValidateLogonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateLogonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webVerificationMethod"] = this.webVerificationMethod;
        data["appVerificationMethod"] = this.appVerificationMethod;
        return data;
    }

    clone(): ValidateLogonDto {
        const json = this.toJSON();
        let result = new ValidateLogonDto();
        result.init(json);
        return result;
    }
}

export interface IValidateLogonDto {
    /** web验证方式 */
    webVerificationMethod: string | undefined;
    /** app验证方式 */
    appVerificationMethod: string | undefined;
}

/** 是否启用审核点问题反馈 */
export class IsEnableAuditPointFeedbackDto implements IIsEnableAuditPointFeedbackDto {
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IIsEnableAuditPointFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableAuditPointFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableAuditPointFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableAuditPointFeedbackDto {
        const json = this.toJSON();
        let result = new IsEnableAuditPointFeedbackDto();
        result.init(json);
        return result;
    }
}

/** 是否启用审核点问题反馈 */
export interface IIsEnableAuditPointFeedbackDto {
    /** 是否启用 */
    enable: boolean;
}

/** 是否启用审核记录不符合项分类 */
export class IsEnableAuditTaskDetailDeviationTypeDto implements IIsEnableAuditTaskDetailDeviationTypeDto {
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IIsEnableAuditTaskDetailDeviationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableAuditTaskDetailDeviationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableAuditTaskDetailDeviationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableAuditTaskDetailDeviationTypeDto {
        const json = this.toJSON();
        let result = new IsEnableAuditTaskDetailDeviationTypeDto();
        result.init(json);
        return result;
    }
}

/** 是否启用审核记录不符合项分类 */
export interface IIsEnableAuditTaskDetailDeviationTypeDto {
    /** 是否启用 */
    enable: boolean;
}

/** 是否启用打开手机相册 */
export class IsEnableOpenPhoneAlbumDto implements IIsEnableOpenPhoneAlbumDto {
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IIsEnableOpenPhoneAlbumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableOpenPhoneAlbumDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableOpenPhoneAlbumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableOpenPhoneAlbumDto {
        const json = this.toJSON();
        let result = new IsEnableOpenPhoneAlbumDto();
        result.init(json);
        return result;
    }
}

/** 是否启用打开手机相册 */
export interface IIsEnableOpenPhoneAlbumDto {
    /** 是否启用 */
    enable: boolean;
}

/** 是否启用部门归属 */
export class IsEnableStatisticsOrgDto implements IIsEnableStatisticsOrgDto {
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IIsEnableStatisticsOrgDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableStatisticsOrgDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableStatisticsOrgDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableStatisticsOrgDto {
        const json = this.toJSON();
        let result = new IsEnableStatisticsOrgDto();
        result.init(json);
        return result;
    }
}

/** 是否启用部门归属 */
export interface IIsEnableStatisticsOrgDto {
    /** 是否启用 */
    enable: boolean;
}

/** 禁用上传图片 */
export class IsEnableUploadPictureDto implements IIsEnableUploadPictureDto {
    /** 禁用 */
    enable: boolean;

    constructor(data?: IIsEnableUploadPictureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableUploadPictureDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableUploadPictureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableUploadPictureDto {
        const json = this.toJSON();
        let result = new IsEnableUploadPictureDto();
        result.init(json);
        return result;
    }
}

/** 禁用上传图片 */
export interface IIsEnableUploadPictureDto {
    /** 禁用 */
    enable: boolean;
}

/** 禁用 */
export class IsEnableUploadPictureForPhoneDto implements IIsEnableUploadPictureForPhoneDto {
    /** 禁用 */
    enable: boolean;

    constructor(data?: IIsEnableUploadPictureForPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableUploadPictureForPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableUploadPictureForPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableUploadPictureForPhoneDto {
        const json = this.toJSON();
        let result = new IsEnableUploadPictureForPhoneDto();
        result.init(json);
        return result;
    }
}

/** 禁用 */
export interface IIsEnableUploadPictureForPhoneDto {
    /** 禁用 */
    enable: boolean;
}

/** 是否启用上传视频 */
export class IsEnableUploadVideoDto implements IIsEnableUploadVideoDto {
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IIsEnableUploadVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): IsEnableUploadVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsEnableUploadVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): IsEnableUploadVideoDto {
        const json = this.toJSON();
        let result = new IsEnableUploadVideoDto();
        result.init(json);
        return result;
    }
}

/** 是否启用上传视频 */
export interface IIsEnableUploadVideoDto {
    /** 是否启用 */
    enable: boolean;
}

/** 图片质量配置Dto */
export class PictureQualityDto implements IPictureQualityDto {
    /** 属性 1.小尺寸 Less size 2.清晰 HD 3.高清 FHD */
    pictureQuality: string | undefined;

    constructor(data?: IPictureQualityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pictureQuality = _data["pictureQuality"];
        }
    }

    static fromJS(data: any): PictureQualityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PictureQualityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureQuality"] = this.pictureQuality;
        return data;
    }

    clone(): PictureQualityDto {
        const json = this.toJSON();
        let result = new PictureQualityDto();
        result.init(json);
        return result;
    }
}

/** 图片质量配置Dto */
export interface IPictureQualityDto {
    /** 属性 1.小尺寸 Less size 2.清晰 HD 3.高清 FHD */
    pictureQuality: string | undefined;
}

/** 责任人是否可以关闭问题 */
export class RespIsCloseIssueDto implements IRespIsCloseIssueDto {
    /** 是否启用 */
    enable: boolean;

    constructor(data?: IRespIsCloseIssueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): RespIsCloseIssueDto {
        data = typeof data === 'object' ? data : {};
        let result = new RespIsCloseIssueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enable"] = this.enable;
        return data;
    }

    clone(): RespIsCloseIssueDto {
        const json = this.toJSON();
        let result = new RespIsCloseIssueDto();
        result.init(json);
        return result;
    }
}

/** 责任人是否可以关闭问题 */
export interface IRespIsCloseIssueDto {
    /** 是否启用 */
    enable: boolean;
}

/** 部门归属配置 */
export class StatisticsOrgConfigDto implements IStatisticsOrgConfigDto {
    /** 部门归属配置 */
    statisticsOrgConfig: string | undefined;

    constructor(data?: IStatisticsOrgConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statisticsOrgConfig = _data["statisticsOrgConfig"];
        }
    }

    static fromJS(data: any): StatisticsOrgConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatisticsOrgConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticsOrgConfig"] = this.statisticsOrgConfig;
        return data;
    }

    clone(): StatisticsOrgConfigDto {
        const json = this.toJSON();
        let result = new StatisticsOrgConfigDto();
        result.init(json);
        return result;
    }
}

/** 部门归属配置 */
export interface IStatisticsOrgConfigDto {
    /** 部门归属配置 */
    statisticsOrgConfig: string | undefined;
}

/** 待关闭问题提醒进度 */
export class ToBeClosedIssueNoticeProgressDto implements IToBeClosedIssueNoticeProgressDto {
    /** 问题进度 */
    progress: number;

    constructor(data?: IToBeClosedIssueNoticeProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): ToBeClosedIssueNoticeProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToBeClosedIssueNoticeProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progress"] = this.progress;
        return data;
    }

    clone(): ToBeClosedIssueNoticeProgressDto {
        const json = this.toJSON();
        let result = new ToBeClosedIssueNoticeProgressDto();
        result.init(json);
        return result;
    }
}

/** 待关闭问题提醒进度 */
export interface IToBeClosedIssueNoticeProgressDto {
    /** 问题进度 */
    progress: number;
}

/** 视频时长 */
export class VideoDurationDto implements IVideoDurationDto {
    /** 视频时长 */
    videoDuration: number;

    constructor(data?: IVideoDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoDuration = _data["videoDuration"];
        }
    }

    static fromJS(data: any): VideoDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoDuration"] = this.videoDuration;
        return data;
    }

    clone(): VideoDurationDto {
        const json = this.toJSON();
        let result = new VideoDurationDto();
        result.init(json);
        return result;
    }
}

/** 视频时长 */
export interface IVideoDurationDto {
    /** 视频时长 */
    videoDuration: number;
}

/** 视频分辨率 */
export class VideoResolutionDto implements IVideoResolutionDto {
    /** 视频分辨率 */
    videoResolution: string | undefined;

    constructor(data?: IVideoResolutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoResolution = _data["videoResolution"];
        }
    }

    static fromJS(data: any): VideoResolutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoResolutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoResolution"] = this.videoResolution;
        return data;
    }

    clone(): VideoResolutionDto {
        const json = this.toJSON();
        let result = new VideoResolutionDto();
        result.init(json);
        return result;
    }
}

/** 视频分辨率 */
export interface IVideoResolutionDto {
    /** 视频分辨率 */
    videoResolution: string | undefined;
}

/** 标签的列表DTO QYB.Modules.Blogging.Tagging.Tag */
export class TagEditDto implements ITagEditDto {
    /** 博客Id */
    blogId: string | undefined;
    /** 文章Id */
    postId: string | undefined;
    /** Id */
    id: string | undefined;
    /** 标签名称 */
    name: string;
    /** 标签描述 */
    description: string | undefined;

    constructor(data?: ITagEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blogId = _data["blogId"];
            this.postId = _data["postId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TagEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blogId"] = this.blogId;
        data["postId"] = this.postId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): TagEditDto {
        const json = this.toJSON();
        let result = new TagEditDto();
        result.init(json);
        return result;
    }
}

/** 标签的列表DTO QYB.Modules.Blogging.Tagging.Tag */
export interface ITagEditDto {
    /** 博客Id */
    blogId: string | undefined;
    /** 文章Id */
    postId: string | undefined;
    /** Id */
    id: string | undefined;
    /** 标签名称 */
    name: string;
    /** 标签描述 */
    description: string | undefined;
}

export class CreateOrUpdateTagInput implements ICreateOrUpdateTagInput {
    tag: TagEditDto;

    constructor(data?: ICreateOrUpdateTagInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tag = new TagEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] ? TagEditDto.fromJS(_data["tag"]) : new TagEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTagInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTagInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTagInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTagInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTagInput {
    tag: TagEditDto;
}

/** 读取可编辑标签的Dto */
export class GetTagForEditOutput implements IGetTagForEditOutput {
    tag: TagEditDto;

    constructor(data?: IGetTagForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] ? TagEditDto.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTagForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetTagForEditOutput {
        const json = this.toJSON();
        let result = new GetTagForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑标签的Dto */
export interface IGetTagForEditOutput {
    tag: TagEditDto;
}

export class PagedResultDtoOfTagListDto implements IPagedResultDtoOfTagListDto {
    totalCount: number;
    items: TagListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTagListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTagListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTagListDto {
    totalCount: number;
    items: TagListDto[] | undefined;
}

/** 抄送人列表 */
export class CarbonCopyList implements ICarbonCopyList {
    empId: number;
    name: string | undefined;

    constructor(data?: ICarbonCopyList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CarbonCopyList {
        data = typeof data === 'object' ? data : {};
        let result = new CarbonCopyList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["name"] = this.name;
        return data;
    }

    clone(): CarbonCopyList {
        const json = this.toJSON();
        let result = new CarbonCopyList();
        result.init(json);
        return result;
    }
}

/** 抄送人列表 */
export interface ICarbonCopyList {
    empId: number;
    name: string | undefined;
}

export class CreateTaskInput implements ICreateTaskInput {
    /** Id */
    id: number | undefined;
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** 创建方式 */
    creatWayName: string | undefined;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 抄送人 */
    carbonCopy: string | undefined;
    /** 抄送人列表 */
    carbonCopyList: CarbonCopyList[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 任务状态 */
    stateName: string | undefined;
    /** 发起人图片 */
    initiateImg: string | undefined;
    /** 发起人附件 */
    initiateIFile: string | undefined;
    /** 执行图片 */
    principalImg: string | undefined;
    /** 执行附件 */
    principalFile: string | undefined;
    /** 发起人名称 */
    creatorUserName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;

    constructor(data?: ICreateTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.item = _data["item"];
            this.description = _data["description"];
            this.classify = _data["classify"];
            this.classifyName = _data["classifyName"];
            this.creatWayName = _data["creatWayName"];
            this.principal = _data["principal"];
            this.principalName = _data["principalName"];
            this.carbonCopy = _data["carbonCopy"];
            if (Array.isArray(_data["carbonCopyList"])) {
                this.carbonCopyList = [] as any;
                for (let item of _data["carbonCopyList"])
                    this.carbonCopyList.push(CarbonCopyList.fromJS(item));
            }
            this.cutoffDate = _data["cutoffDate"] ? moment(_data["cutoffDate"].toString()) : <any>undefined;
            this.stateName = _data["stateName"];
            this.initiateImg = _data["initiateImg"];
            this.initiateIFile = _data["initiateIFile"];
            this.principalImg = _data["principalImg"];
            this.principalFile = _data["principalFile"];
            this.creatorUserName = _data["creatorUserName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CreateTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["item"] = this.item;
        data["description"] = this.description;
        data["classify"] = this.classify;
        data["classifyName"] = this.classifyName;
        data["creatWayName"] = this.creatWayName;
        data["principal"] = this.principal;
        data["principalName"] = this.principalName;
        data["carbonCopy"] = this.carbonCopy;
        if (Array.isArray(this.carbonCopyList)) {
            data["carbonCopyList"] = [];
            for (let item of this.carbonCopyList)
                data["carbonCopyList"].push(item.toJSON());
        }
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["stateName"] = this.stateName;
        data["initiateImg"] = this.initiateImg;
        data["initiateIFile"] = this.initiateIFile;
        data["principalImg"] = this.principalImg;
        data["principalFile"] = this.principalFile;
        data["creatorUserName"] = this.creatorUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }

    clone(): CreateTaskInput {
        const json = this.toJSON();
        let result = new CreateTaskInput();
        result.init(json);
        return result;
    }
}

export interface ICreateTaskInput {
    /** Id */
    id: number | undefined;
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** 创建方式 */
    creatWayName: string | undefined;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 抄送人 */
    carbonCopy: string | undefined;
    /** 抄送人列表 */
    carbonCopyList: CarbonCopyList[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 任务状态 */
    stateName: string | undefined;
    /** 发起人图片 */
    initiateImg: string | undefined;
    /** 发起人附件 */
    initiateIFile: string | undefined;
    /** 执行图片 */
    principalImg: string | undefined;
    /** 执行附件 */
    principalFile: string | undefined;
    /** 发起人名称 */
    creatorUserName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
}

export class CreateOrUpdateTaskBaseInfoInput implements ICreateOrUpdateTaskBaseInfoInput {
    taskBaseInfo: CreateTaskInput;
    /** 状态 1提交 2保存 3作废 4拒绝 5完成 6关闭 */
    state: string | undefined;

    constructor(data?: ICreateOrUpdateTaskBaseInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskBaseInfo = new CreateTaskInput();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskBaseInfo = _data["taskBaseInfo"] ? CreateTaskInput.fromJS(_data["taskBaseInfo"]) : new CreateTaskInput();
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CreateOrUpdateTaskBaseInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTaskBaseInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskBaseInfo"] = this.taskBaseInfo ? this.taskBaseInfo.toJSON() : <any>undefined;
        data["state"] = this.state;
        return data;
    }

    clone(): CreateOrUpdateTaskBaseInfoInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTaskBaseInfoInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTaskBaseInfoInput {
    taskBaseInfo: CreateTaskInput;
    /** 状态 1提交 2保存 3作废 4拒绝 5完成 6关闭 */
    state: string | undefined;
}

export class AppTaskAnalysisData implements IAppTaskAnalysisData {
    /** 完成数量 */
    finisTaskNum: number;
    /** 总数 */
    count: number;
    /** 完成率 */
    finisRate: number;

    constructor(data?: IAppTaskAnalysisData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finisTaskNum = _data["finisTaskNum"];
            this.count = _data["count"];
            this.finisRate = _data["finisRate"];
        }
    }

    static fromJS(data: any): AppTaskAnalysisData {
        data = typeof data === 'object' ? data : {};
        let result = new AppTaskAnalysisData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finisTaskNum"] = this.finisTaskNum;
        data["count"] = this.count;
        data["finisRate"] = this.finisRate;
        return data;
    }

    clone(): AppTaskAnalysisData {
        const json = this.toJSON();
        let result = new AppTaskAnalysisData();
        result.init(json);
        return result;
    }
}

export interface IAppTaskAnalysisData {
    /** 完成数量 */
    finisTaskNum: number;
    /** 总数 */
    count: number;
    /** 完成率 */
    finisRate: number;
}

export class GetAppTaskAnalysisDto implements IGetAppTaskAnalysisDto {
    mySend: AppTaskAnalysisData;
    myReceive: AppTaskAnalysisData;
    depReceive: AppTaskAnalysisData;
    comReceive: AppTaskAnalysisData;
    comSend: AppTaskAnalysisData;
    depSend: AppTaskAnalysisData;
    workFlow: AppTaskAnalysisData;
    personnel: AppTaskAnalysisData;
    technology: AppTaskAnalysisData;
    quality: AppTaskAnalysisData;
    customer: AppTaskAnalysisData;
    profit: AppTaskAnalysisData;

    constructor(data?: IGetAppTaskAnalysisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mySend = _data["mySend"] ? AppTaskAnalysisData.fromJS(_data["mySend"]) : <any>undefined;
            this.myReceive = _data["myReceive"] ? AppTaskAnalysisData.fromJS(_data["myReceive"]) : <any>undefined;
            this.depReceive = _data["depReceive"] ? AppTaskAnalysisData.fromJS(_data["depReceive"]) : <any>undefined;
            this.comReceive = _data["comReceive"] ? AppTaskAnalysisData.fromJS(_data["comReceive"]) : <any>undefined;
            this.comSend = _data["comSend"] ? AppTaskAnalysisData.fromJS(_data["comSend"]) : <any>undefined;
            this.depSend = _data["depSend"] ? AppTaskAnalysisData.fromJS(_data["depSend"]) : <any>undefined;
            this.workFlow = _data["workFlow"] ? AppTaskAnalysisData.fromJS(_data["workFlow"]) : <any>undefined;
            this.personnel = _data["personnel"] ? AppTaskAnalysisData.fromJS(_data["personnel"]) : <any>undefined;
            this.technology = _data["technology"] ? AppTaskAnalysisData.fromJS(_data["technology"]) : <any>undefined;
            this.quality = _data["quality"] ? AppTaskAnalysisData.fromJS(_data["quality"]) : <any>undefined;
            this.customer = _data["customer"] ? AppTaskAnalysisData.fromJS(_data["customer"]) : <any>undefined;
            this.profit = _data["profit"] ? AppTaskAnalysisData.fromJS(_data["profit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppTaskAnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppTaskAnalysisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mySend"] = this.mySend ? this.mySend.toJSON() : <any>undefined;
        data["myReceive"] = this.myReceive ? this.myReceive.toJSON() : <any>undefined;
        data["depReceive"] = this.depReceive ? this.depReceive.toJSON() : <any>undefined;
        data["comReceive"] = this.comReceive ? this.comReceive.toJSON() : <any>undefined;
        data["comSend"] = this.comSend ? this.comSend.toJSON() : <any>undefined;
        data["depSend"] = this.depSend ? this.depSend.toJSON() : <any>undefined;
        data["workFlow"] = this.workFlow ? this.workFlow.toJSON() : <any>undefined;
        data["personnel"] = this.personnel ? this.personnel.toJSON() : <any>undefined;
        data["technology"] = this.technology ? this.technology.toJSON() : <any>undefined;
        data["quality"] = this.quality ? this.quality.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["profit"] = this.profit ? this.profit.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetAppTaskAnalysisDto {
        const json = this.toJSON();
        let result = new GetAppTaskAnalysisDto();
        result.init(json);
        return result;
    }
}

export interface IGetAppTaskAnalysisDto {
    mySend: AppTaskAnalysisData;
    myReceive: AppTaskAnalysisData;
    depReceive: AppTaskAnalysisData;
    comReceive: AppTaskAnalysisData;
    comSend: AppTaskAnalysisData;
    depSend: AppTaskAnalysisData;
    workFlow: AppTaskAnalysisData;
    personnel: AppTaskAnalysisData;
    technology: AppTaskAnalysisData;
    quality: AppTaskAnalysisData;
    customer: AppTaskAnalysisData;
    profit: AppTaskAnalysisData;
}

/** App任务清单实体 */
export class GetAppTaskListDto implements IGetAppTaskListDto {
    /** Id */
    id: number | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** UserId */
    userId: number | undefined;
    /** EmpId */
    empId: number;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
    /** 任务状态 */
    stateName: string | undefined;
    /** 状态颜色 */
    stateColor: string | undefined;
    /** 任务项 */
    item: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 来源 */
    source: string | undefined;
    /** 跳转页面 */
    url: string | undefined;
    /** 是否是抄送任务 */
    isCarbonCopy: boolean;
    createUserId: number;

    constructor(data?: IGetAppTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.classify = _data["classify"];
            this.classifyName = _data["classifyName"];
            this.userId = _data["userId"];
            this.empId = _data["empId"];
            this.principal = _data["principal"];
            this.principalName = _data["principalName"];
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.stateColor = _data["stateColor"];
            this.item = _data["item"];
            this.idPhoto = _data["idPhoto"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.source = _data["source"];
            this.url = _data["url"];
            this.isCarbonCopy = _data["isCarbonCopy"];
            this.createUserId = _data["createUserId"];
        }
    }

    static fromJS(data: any): GetAppTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["classify"] = this.classify;
        data["classifyName"] = this.classifyName;
        data["userId"] = this.userId;
        data["empId"] = this.empId;
        data["principal"] = this.principal;
        data["principalName"] = this.principalName;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["stateColor"] = this.stateColor;
        data["item"] = this.item;
        data["idPhoto"] = this.idPhoto;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["url"] = this.url;
        data["isCarbonCopy"] = this.isCarbonCopy;
        data["createUserId"] = this.createUserId;
        return data;
    }

    clone(): GetAppTaskListDto {
        const json = this.toJSON();
        let result = new GetAppTaskListDto();
        result.init(json);
        return result;
    }
}

/** App任务清单实体 */
export interface IGetAppTaskListDto {
    /** Id */
    id: number | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** UserId */
    userId: number | undefined;
    /** EmpId */
    empId: number;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
    /** 任务状态 */
    stateName: string | undefined;
    /** 状态颜色 */
    stateColor: string | undefined;
    /** 任务项 */
    item: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 来源 */
    source: string | undefined;
    /** 跳转页面 */
    url: string | undefined;
    /** 是否是抄送任务 */
    isCarbonCopy: boolean;
    createUserId: number;
}

export class PagedResultDtoOfGetAppTaskListDto implements IPagedResultDtoOfGetAppTaskListDto {
    totalCount: number;
    items: GetAppTaskListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAppTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetAppTaskListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAppTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAppTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetAppTaskListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAppTaskListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAppTaskListDto {
    totalCount: number;
    items: GetAppTaskListDto[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.TaskSystem.TaskBaseInfo.TaskBaseInfo */
export class TaskBaseInfoListDto implements ITaskBaseInfoListDto {
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** 创建方式(数据字典 QYB_TaskCreatWay) */
    creatWay: string | undefined;
    /** 创建方式 */
    creatWayName: string | undefined;
    /** 来源 */
    source: string | undefined;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 负责人部门 */
    principalDep: number;
    /** 负责人公司 */
    principalCom: number;
    /** 抄送人 */
    carbonCopy: string | undefined;
    /** 抄送人列表 */
    carbonCopyList: CarbonCopyList[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 接收时间 */
    receiveTime: moment.Moment | undefined;
    /** 完成时间 */
    completeTime: moment.Moment | undefined;
    /** 关闭时间 */
    closeTime: moment.Moment | undefined;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
    /** 任务状态 */
    stateName: string | undefined;
    /** 发起人图片 */
    initiateImg: string | undefined;
    /** 发起人附件 */
    initiateIFile: string | undefined;
    /** 执行图片 */
    principalImg: string | undefined;
    /** 执行附件 */
    principalFile: string | undefined;
    /** 完成人 */
    finisher: number | undefined;
    /** 完成人名称 */
    finisherName: string | undefined;
    /** 关闭人 */
    closeMan: number | undefined;
    /** 关闭人名称 */
    closeManName: string | undefined;
    /** 发起人 */
    creatorUserId: number | undefined;
    /** 发起人名称 */
    creatorUserName: string | undefined;
    /** 发起人部门 */
    creatorUserDep: number;
    /** 发起人公司 */
    creatorUseCom: number;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 跳转 */
    url: string | undefined;
    id: number;

    constructor(data?: ITaskBaseInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            this.description = _data["description"];
            this.classify = _data["classify"];
            this.classifyName = _data["classifyName"];
            this.creatWay = _data["creatWay"];
            this.creatWayName = _data["creatWayName"];
            this.source = _data["source"];
            this.principal = _data["principal"];
            this.principalName = _data["principalName"];
            this.principalDep = _data["principalDep"];
            this.principalCom = _data["principalCom"];
            this.carbonCopy = _data["carbonCopy"];
            if (Array.isArray(_data["carbonCopyList"])) {
                this.carbonCopyList = [] as any;
                for (let item of _data["carbonCopyList"])
                    this.carbonCopyList.push(CarbonCopyList.fromJS(item));
            }
            this.cutoffDate = _data["cutoffDate"] ? moment(_data["cutoffDate"].toString()) : <any>undefined;
            this.receiveTime = _data["receiveTime"] ? moment(_data["receiveTime"].toString()) : <any>undefined;
            this.completeTime = _data["completeTime"] ? moment(_data["completeTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.initiateImg = _data["initiateImg"];
            this.initiateIFile = _data["initiateIFile"];
            this.principalImg = _data["principalImg"];
            this.principalFile = _data["principalFile"];
            this.finisher = _data["finisher"];
            this.finisherName = _data["finisherName"];
            this.closeMan = _data["closeMan"];
            this.closeManName = _data["closeManName"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.creatorUserDep = _data["creatorUserDep"];
            this.creatorUseCom = _data["creatorUseCom"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.url = _data["url"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskBaseInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskBaseInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        data["description"] = this.description;
        data["classify"] = this.classify;
        data["classifyName"] = this.classifyName;
        data["creatWay"] = this.creatWay;
        data["creatWayName"] = this.creatWayName;
        data["source"] = this.source;
        data["principal"] = this.principal;
        data["principalName"] = this.principalName;
        data["principalDep"] = this.principalDep;
        data["principalCom"] = this.principalCom;
        data["carbonCopy"] = this.carbonCopy;
        if (Array.isArray(this.carbonCopyList)) {
            data["carbonCopyList"] = [];
            for (let item of this.carbonCopyList)
                data["carbonCopyList"].push(item.toJSON());
        }
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["receiveTime"] = this.receiveTime ? this.receiveTime.toISOString() : <any>undefined;
        data["completeTime"] = this.completeTime ? this.completeTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["initiateImg"] = this.initiateImg;
        data["initiateIFile"] = this.initiateIFile;
        data["principalImg"] = this.principalImg;
        data["principalFile"] = this.principalFile;
        data["finisher"] = this.finisher;
        data["finisherName"] = this.finisherName;
        data["closeMan"] = this.closeMan;
        data["closeManName"] = this.closeManName;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["creatorUserDep"] = this.creatorUserDep;
        data["creatorUseCom"] = this.creatorUseCom;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    }

    clone(): TaskBaseInfoListDto {
        const json = this.toJSON();
        let result = new TaskBaseInfoListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.TaskSystem.TaskBaseInfo.TaskBaseInfo */
export interface ITaskBaseInfoListDto {
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** 创建方式(数据字典 QYB_TaskCreatWay) */
    creatWay: string | undefined;
    /** 创建方式 */
    creatWayName: string | undefined;
    /** 来源 */
    source: string | undefined;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 负责人部门 */
    principalDep: number;
    /** 负责人公司 */
    principalCom: number;
    /** 抄送人 */
    carbonCopy: string | undefined;
    /** 抄送人列表 */
    carbonCopyList: CarbonCopyList[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 接收时间 */
    receiveTime: moment.Moment | undefined;
    /** 完成时间 */
    completeTime: moment.Moment | undefined;
    /** 关闭时间 */
    closeTime: moment.Moment | undefined;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
    /** 任务状态 */
    stateName: string | undefined;
    /** 发起人图片 */
    initiateImg: string | undefined;
    /** 发起人附件 */
    initiateIFile: string | undefined;
    /** 执行图片 */
    principalImg: string | undefined;
    /** 执行附件 */
    principalFile: string | undefined;
    /** 完成人 */
    finisher: number | undefined;
    /** 完成人名称 */
    finisherName: string | undefined;
    /** 关闭人 */
    closeMan: number | undefined;
    /** 关闭人名称 */
    closeManName: string | undefined;
    /** 发起人 */
    creatorUserId: number | undefined;
    /** 发起人名称 */
    creatorUserName: string | undefined;
    /** 发起人部门 */
    creatorUserDep: number;
    /** 发起人公司 */
    creatorUseCom: number;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 跳转 */
    url: string | undefined;
    id: number;
}

/** 的列表DTO QYB.QYBProduct.TaskSystem.TaskBaseInfo.TaskBaseInfo */
export class TaskBaseInfoEditDto implements ITaskBaseInfoEditDto {
    /** Id */
    id: number | undefined;
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** 创建方式(数据字典 QYB_TaskCreatWay) */
    creatWay: string | undefined;
    /** 创建方式 */
    creatWayName: string | undefined;
    /** 来源 */
    source: string | undefined;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 抄送人 */
    carbonCopy: string | undefined;
    /** 抄送人列表 */
    carbonCopyList: CarbonCopyList[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 接收时间 */
    receiveTime: moment.Moment | undefined;
    /** 完成时间 */
    completeTime: moment.Moment | undefined;
    /** 关闭时间 */
    closeTime: moment.Moment | undefined;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
    /** 任务状态 */
    stateName: string | undefined;
    /** 发起人图片 */
    initiateImg: string | undefined;
    /** 发起人附件 */
    initiateIFile: string | undefined;
    /** 执行图片 */
    principalImg: string | undefined;
    /** 执行附件 */
    principalFile: string | undefined;
    /** 完成人 */
    finisher: number | undefined;
    /** 完成人名称 */
    finisherName: string | undefined;
    /** 关闭人 */
    closeMan: number | undefined;
    /** 关闭人名称 */
    closeManName: string | undefined;
    /** 发起人 */
    creatorUserId: number | undefined;
    /** 发起人名称 */
    creatorUserName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 跳转地址 */
    url: string | undefined;
    /** 是否是工作流 */
    isWrokflow: boolean;

    constructor(data?: ITaskBaseInfoEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.item = _data["item"];
            this.description = _data["description"];
            this.classify = _data["classify"];
            this.classifyName = _data["classifyName"];
            this.creatWay = _data["creatWay"];
            this.creatWayName = _data["creatWayName"];
            this.source = _data["source"];
            this.principal = _data["principal"];
            this.principalName = _data["principalName"];
            this.carbonCopy = _data["carbonCopy"];
            if (Array.isArray(_data["carbonCopyList"])) {
                this.carbonCopyList = [] as any;
                for (let item of _data["carbonCopyList"])
                    this.carbonCopyList.push(CarbonCopyList.fromJS(item));
            }
            this.cutoffDate = _data["cutoffDate"] ? moment(_data["cutoffDate"].toString()) : <any>undefined;
            this.receiveTime = _data["receiveTime"] ? moment(_data["receiveTime"].toString()) : <any>undefined;
            this.completeTime = _data["completeTime"] ? moment(_data["completeTime"].toString()) : <any>undefined;
            this.closeTime = _data["closeTime"] ? moment(_data["closeTime"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.stateName = _data["stateName"];
            this.initiateImg = _data["initiateImg"];
            this.initiateIFile = _data["initiateIFile"];
            this.principalImg = _data["principalImg"];
            this.principalFile = _data["principalFile"];
            this.finisher = _data["finisher"];
            this.finisherName = _data["finisherName"];
            this.closeMan = _data["closeMan"];
            this.closeManName = _data["closeManName"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.url = _data["url"];
            this.isWrokflow = _data["isWrokflow"];
        }
    }

    static fromJS(data: any): TaskBaseInfoEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskBaseInfoEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["item"] = this.item;
        data["description"] = this.description;
        data["classify"] = this.classify;
        data["classifyName"] = this.classifyName;
        data["creatWay"] = this.creatWay;
        data["creatWayName"] = this.creatWayName;
        data["source"] = this.source;
        data["principal"] = this.principal;
        data["principalName"] = this.principalName;
        data["carbonCopy"] = this.carbonCopy;
        if (Array.isArray(this.carbonCopyList)) {
            data["carbonCopyList"] = [];
            for (let item of this.carbonCopyList)
                data["carbonCopyList"].push(item.toJSON());
        }
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["receiveTime"] = this.receiveTime ? this.receiveTime.toISOString() : <any>undefined;
        data["completeTime"] = this.completeTime ? this.completeTime.toISOString() : <any>undefined;
        data["closeTime"] = this.closeTime ? this.closeTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["stateName"] = this.stateName;
        data["initiateImg"] = this.initiateImg;
        data["initiateIFile"] = this.initiateIFile;
        data["principalImg"] = this.principalImg;
        data["principalFile"] = this.principalFile;
        data["finisher"] = this.finisher;
        data["finisherName"] = this.finisherName;
        data["closeMan"] = this.closeMan;
        data["closeManName"] = this.closeManName;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["url"] = this.url;
        data["isWrokflow"] = this.isWrokflow;
        return data;
    }

    clone(): TaskBaseInfoEditDto {
        const json = this.toJSON();
        let result = new TaskBaseInfoEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.TaskSystem.TaskBaseInfo.TaskBaseInfo */
export interface ITaskBaseInfoEditDto {
    /** Id */
    id: number | undefined;
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 分类(数据字典 QYB_TaskClassify) */
    classify: string | undefined;
    /** 分类 */
    classifyName: string | undefined;
    /** 创建方式(数据字典 QYB_TaskCreatWay) */
    creatWay: string | undefined;
    /** 创建方式 */
    creatWayName: string | undefined;
    /** 来源 */
    source: string | undefined;
    /** 负责人 */
    principal: number;
    /** 负责人名称 */
    principalName: string | undefined;
    /** 抄送人 */
    carbonCopy: string | undefined;
    /** 抄送人列表 */
    carbonCopyList: CarbonCopyList[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 接收时间 */
    receiveTime: moment.Moment | undefined;
    /** 完成时间 */
    completeTime: moment.Moment | undefined;
    /** 关闭时间 */
    closeTime: moment.Moment | undefined;
    /** 任务状态(数据字典 QYB_TaskState) */
    state: string | undefined;
    /** 任务状态 */
    stateName: string | undefined;
    /** 发起人图片 */
    initiateImg: string | undefined;
    /** 发起人附件 */
    initiateIFile: string | undefined;
    /** 执行图片 */
    principalImg: string | undefined;
    /** 执行附件 */
    principalFile: string | undefined;
    /** 完成人 */
    finisher: number | undefined;
    /** 完成人名称 */
    finisherName: string | undefined;
    /** 关闭人 */
    closeMan: number | undefined;
    /** 关闭人名称 */
    closeManName: string | undefined;
    /** 发起人 */
    creatorUserId: number | undefined;
    /** 发起人名称 */
    creatorUserName: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
    /** 跳转地址 */
    url: string | undefined;
    /** 是否是工作流 */
    isWrokflow: boolean;
}

export class TaskLogDto implements ITaskLogDto {
    /** 任务主键 */
    taskId: number;
    /** 人员 */
    userName: string | undefined;
    /** 描述 */
    desciption: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;

    constructor(data?: ITaskLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.userName = _data["userName"];
            this.desciption = _data["desciption"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["userName"] = this.userName;
        data["desciption"] = this.desciption;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TaskLogDto {
        const json = this.toJSON();
        let result = new TaskLogDto();
        result.init(json);
        return result;
    }
}

export interface ITaskLogDto {
    /** 任务主键 */
    taskId: number;
    /** 人员 */
    userName: string | undefined;
    /** 描述 */
    desciption: string | undefined;
    /** 创建时间 */
    creationTime: moment.Moment;
}

/** 读取可编辑的Dto */
export class GetTaskBaseInfoForEditOutput implements IGetTaskBaseInfoForEditOutput {
    taskBaseInfo: TaskBaseInfoEditDto;
    /** Log */
    taskLogDtoList: TaskLogDto[] | undefined;

    constructor(data?: IGetTaskBaseInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskBaseInfo = _data["taskBaseInfo"] ? TaskBaseInfoEditDto.fromJS(_data["taskBaseInfo"]) : <any>undefined;
            if (Array.isArray(_data["taskLogDtoList"])) {
                this.taskLogDtoList = [] as any;
                for (let item of _data["taskLogDtoList"])
                    this.taskLogDtoList.push(TaskLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaskBaseInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskBaseInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskBaseInfo"] = this.taskBaseInfo ? this.taskBaseInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.taskLogDtoList)) {
            data["taskLogDtoList"] = [];
            for (let item of this.taskLogDtoList)
                data["taskLogDtoList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetTaskBaseInfoForEditOutput {
        const json = this.toJSON();
        let result = new GetTaskBaseInfoForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetTaskBaseInfoForEditOutput {
    taskBaseInfo: TaskBaseInfoEditDto;
    /** Log */
    taskLogDtoList: TaskLogDto[] | undefined;
}

export class PagedResultDtoOfTaskBaseInfoListDto implements IPagedResultDtoOfTaskBaseInfoListDto {
    totalCount: number;
    items: TaskBaseInfoListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTaskBaseInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TaskBaseInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTaskBaseInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTaskBaseInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTaskBaseInfoListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTaskBaseInfoListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTaskBaseInfoListDto {
    totalCount: number;
    items: TaskBaseInfoListDto[] | undefined;
}

export class ChartData implements IChartData {
    value: number;
    name: string | undefined;

    constructor(data?: IChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChartData {
        data = typeof data === 'object' ? data : {};
        let result = new ChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }

    clone(): ChartData {
        const json = this.toJSON();
        let result = new ChartData();
        result.init(json);
        return result;
    }
}

export interface IChartData {
    value: number;
    name: string | undefined;
}

export class TaskTypeData implements ITaskTypeData {
    type: string | undefined;
    data: ChartData[] | undefined;

    constructor(data?: ITaskTypeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(ChartData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskTypeData {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTypeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): TaskTypeData {
        const json = this.toJSON();
        let result = new TaskTypeData();
        result.init(json);
        return result;
    }
}

export interface ITaskTypeData {
    type: string | undefined;
    data: ChartData[] | undefined;
}

export class TaskAnalysisDto implements ITaskAnalysisDto {
    /** 个人发出任务完成率 */
    userCompleteData: ChartData[] | undefined;
    /** 部门发出任务完成率 */
    depCompleteData: ChartData[] | undefined;
    /** 公司发出任务完成率 */
    comCompleteData: ChartData[] | undefined;
    /** 个人执行任务完成率 */
    userExecuteData: ChartData[] | undefined;
    /** 部门执行任务完成率 */
    depExecuteData: ChartData[] | undefined;
    /** 公司执行任务完成率 */
    comExecuteData: ChartData[] | undefined;
    /** 主题完成率 */
    taskTypeData: TaskTypeData[] | undefined;

    constructor(data?: ITaskAnalysisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userCompleteData"])) {
                this.userCompleteData = [] as any;
                for (let item of _data["userCompleteData"])
                    this.userCompleteData.push(ChartData.fromJS(item));
            }
            if (Array.isArray(_data["depCompleteData"])) {
                this.depCompleteData = [] as any;
                for (let item of _data["depCompleteData"])
                    this.depCompleteData.push(ChartData.fromJS(item));
            }
            if (Array.isArray(_data["comCompleteData"])) {
                this.comCompleteData = [] as any;
                for (let item of _data["comCompleteData"])
                    this.comCompleteData.push(ChartData.fromJS(item));
            }
            if (Array.isArray(_data["userExecuteData"])) {
                this.userExecuteData = [] as any;
                for (let item of _data["userExecuteData"])
                    this.userExecuteData.push(ChartData.fromJS(item));
            }
            if (Array.isArray(_data["depExecuteData"])) {
                this.depExecuteData = [] as any;
                for (let item of _data["depExecuteData"])
                    this.depExecuteData.push(ChartData.fromJS(item));
            }
            if (Array.isArray(_data["comExecuteData"])) {
                this.comExecuteData = [] as any;
                for (let item of _data["comExecuteData"])
                    this.comExecuteData.push(ChartData.fromJS(item));
            }
            if (Array.isArray(_data["taskTypeData"])) {
                this.taskTypeData = [] as any;
                for (let item of _data["taskTypeData"])
                    this.taskTypeData.push(TaskTypeData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskAnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnalysisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userCompleteData)) {
            data["userCompleteData"] = [];
            for (let item of this.userCompleteData)
                data["userCompleteData"].push(item.toJSON());
        }
        if (Array.isArray(this.depCompleteData)) {
            data["depCompleteData"] = [];
            for (let item of this.depCompleteData)
                data["depCompleteData"].push(item.toJSON());
        }
        if (Array.isArray(this.comCompleteData)) {
            data["comCompleteData"] = [];
            for (let item of this.comCompleteData)
                data["comCompleteData"].push(item.toJSON());
        }
        if (Array.isArray(this.userExecuteData)) {
            data["userExecuteData"] = [];
            for (let item of this.userExecuteData)
                data["userExecuteData"].push(item.toJSON());
        }
        if (Array.isArray(this.depExecuteData)) {
            data["depExecuteData"] = [];
            for (let item of this.depExecuteData)
                data["depExecuteData"].push(item.toJSON());
        }
        if (Array.isArray(this.comExecuteData)) {
            data["comExecuteData"] = [];
            for (let item of this.comExecuteData)
                data["comExecuteData"].push(item.toJSON());
        }
        if (Array.isArray(this.taskTypeData)) {
            data["taskTypeData"] = [];
            for (let item of this.taskTypeData)
                data["taskTypeData"].push(item.toJSON());
        }
        return data;
    }

    clone(): TaskAnalysisDto {
        const json = this.toJSON();
        let result = new TaskAnalysisDto();
        result.init(json);
        return result;
    }
}

export interface ITaskAnalysisDto {
    /** 个人发出任务完成率 */
    userCompleteData: ChartData[] | undefined;
    /** 部门发出任务完成率 */
    depCompleteData: ChartData[] | undefined;
    /** 公司发出任务完成率 */
    comCompleteData: ChartData[] | undefined;
    /** 个人执行任务完成率 */
    userExecuteData: ChartData[] | undefined;
    /** 部门执行任务完成率 */
    depExecuteData: ChartData[] | undefined;
    /** 公司执行任务完成率 */
    comExecuteData: ChartData[] | undefined;
    /** 主题完成率 */
    taskTypeData: TaskTypeData[] | undefined;
}

/** 任务完成率接口 */
export class GetTaskCompletionRateDto implements IGetTaskCompletionRateDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 发出完成数量 */
    issueCompletionNum: number;
    /** 发出总数量 */
    issueTotalNum: number;
    /** 发出完成率 */
    issueCompletionRate: string | undefined;
    /** 执行完成数量 */
    executeCompletionNum: number;
    /** 执行总数量 */
    executeTotalNum: number;
    /** 执行完成率 */
    executeCompletionRate: string | undefined;

    constructor(data?: IGetTaskCompletionRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.issueCompletionNum = _data["issueCompletionNum"];
            this.issueTotalNum = _data["issueTotalNum"];
            this.issueCompletionRate = _data["issueCompletionRate"];
            this.executeCompletionNum = _data["executeCompletionNum"];
            this.executeTotalNum = _data["executeTotalNum"];
            this.executeCompletionRate = _data["executeCompletionRate"];
        }
    }

    static fromJS(data: any): GetTaskCompletionRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskCompletionRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["issueCompletionNum"] = this.issueCompletionNum;
        data["issueTotalNum"] = this.issueTotalNum;
        data["issueCompletionRate"] = this.issueCompletionRate;
        data["executeCompletionNum"] = this.executeCompletionNum;
        data["executeTotalNum"] = this.executeTotalNum;
        data["executeCompletionRate"] = this.executeCompletionRate;
        return data;
    }

    clone(): GetTaskCompletionRateDto {
        const json = this.toJSON();
        let result = new GetTaskCompletionRateDto();
        result.init(json);
        return result;
    }
}

/** 任务完成率接口 */
export interface IGetTaskCompletionRateDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 发出完成数量 */
    issueCompletionNum: number;
    /** 发出总数量 */
    issueTotalNum: number;
    /** 发出完成率 */
    issueCompletionRate: string | undefined;
    /** 执行完成数量 */
    executeCompletionNum: number;
    /** 执行总数量 */
    executeTotalNum: number;
    /** 执行完成率 */
    executeCompletionRate: string | undefined;
}

export class PagedResultDtoOfGetTaskCompletionRateDto implements IPagedResultDtoOfGetTaskCompletionRateDto {
    totalCount: number;
    items: GetTaskCompletionRateDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskCompletionRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetTaskCompletionRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskCompletionRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskCompletionRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetTaskCompletionRateDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetTaskCompletionRateDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetTaskCompletionRateDto {
    totalCount: number;
    items: GetTaskCompletionRateDto[] | undefined;
}

/** 任务拒绝率 */
export class GetTaskRefuseRateDto implements IGetTaskRefuseRateDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 发出拒绝数量 */
    issueRefuseNum: number;
    /** 发出总数量 */
    issueTotalNum: number;
    /** 发出拒绝率 */
    issueRefuseRate: string | undefined;
    /** 执行拒绝数量 */
    executeRefuseNum: number;
    /** 执行总数量 */
    executeTotalNum: number;
    /** 执行拒绝率 */
    executeRefuseRate: string | undefined;

    constructor(data?: IGetTaskRefuseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.issueRefuseNum = _data["issueRefuseNum"];
            this.issueTotalNum = _data["issueTotalNum"];
            this.issueRefuseRate = _data["issueRefuseRate"];
            this.executeRefuseNum = _data["executeRefuseNum"];
            this.executeTotalNum = _data["executeTotalNum"];
            this.executeRefuseRate = _data["executeRefuseRate"];
        }
    }

    static fromJS(data: any): GetTaskRefuseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskRefuseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["issueRefuseNum"] = this.issueRefuseNum;
        data["issueTotalNum"] = this.issueTotalNum;
        data["issueRefuseRate"] = this.issueRefuseRate;
        data["executeRefuseNum"] = this.executeRefuseNum;
        data["executeTotalNum"] = this.executeTotalNum;
        data["executeRefuseRate"] = this.executeRefuseRate;
        return data;
    }

    clone(): GetTaskRefuseRateDto {
        const json = this.toJSON();
        let result = new GetTaskRefuseRateDto();
        result.init(json);
        return result;
    }
}

/** 任务拒绝率 */
export interface IGetTaskRefuseRateDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 发出拒绝数量 */
    issueRefuseNum: number;
    /** 发出总数量 */
    issueTotalNum: number;
    /** 发出拒绝率 */
    issueRefuseRate: string | undefined;
    /** 执行拒绝数量 */
    executeRefuseNum: number;
    /** 执行总数量 */
    executeTotalNum: number;
    /** 执行拒绝率 */
    executeRefuseRate: string | undefined;
}

export class PagedResultDtoOfGetTaskRefuseRateDto implements IPagedResultDtoOfGetTaskRefuseRateDto {
    totalCount: number;
    items: GetTaskRefuseRateDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskRefuseRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GetTaskRefuseRateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskRefuseRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskRefuseRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfGetTaskRefuseRateDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetTaskRefuseRateDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetTaskRefuseRateDto {
    totalCount: number;
    items: GetTaskRefuseRateDto[] | undefined;
}

export class TaskTypeDataItemList implements ITaskTypeDataItemList {
    value: string | undefined;
    /** 字典明细名称 */
    label: string | undefined;

    constructor(data?: ITaskTypeDataItemList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): TaskTypeDataItemList {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTypeDataItemList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }

    clone(): TaskTypeDataItemList {
        const json = this.toJSON();
        let result = new TaskTypeDataItemList();
        result.init(json);
        return result;
    }
}

export interface ITaskTypeDataItemList {
    value: string | undefined;
    /** 字典明细名称 */
    label: string | undefined;
}

/** 第三方创建任务 */
export class OtherCreateTaskDto implements IOtherCreateTaskDto {
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 负责人 */
    principalNo: string | undefined;
    /** 抄送人NoArr */
    carbonCopyNoArr: string[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 来源 */
    source: string | undefined;
    /** 创建人编码 */
    createUserNo: string | undefined;
    /** 租户ID */
    tenantId: number;

    constructor(data?: IOtherCreateTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            this.description = _data["description"];
            this.principalNo = _data["principalNo"];
            if (Array.isArray(_data["carbonCopyNoArr"])) {
                this.carbonCopyNoArr = [] as any;
                for (let item of _data["carbonCopyNoArr"])
                    this.carbonCopyNoArr.push(item);
            }
            this.cutoffDate = _data["cutoffDate"] ? moment(_data["cutoffDate"].toString()) : <any>undefined;
            this.source = _data["source"];
            this.createUserNo = _data["createUserNo"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): OtherCreateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherCreateTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        data["description"] = this.description;
        data["principalNo"] = this.principalNo;
        if (Array.isArray(this.carbonCopyNoArr)) {
            data["carbonCopyNoArr"] = [];
            for (let item of this.carbonCopyNoArr)
                data["carbonCopyNoArr"].push(item);
        }
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["createUserNo"] = this.createUserNo;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): OtherCreateTaskDto {
        const json = this.toJSON();
        let result = new OtherCreateTaskDto();
        result.init(json);
        return result;
    }
}

/** 第三方创建任务 */
export interface IOtherCreateTaskDto {
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 负责人 */
    principalNo: string | undefined;
    /** 抄送人NoArr */
    carbonCopyNoArr: string[] | undefined;
    /** 截止完成时间 */
    cutoffDate: moment.Moment;
    /** 来源 */
    source: string | undefined;
    /** 创建人编码 */
    createUserNo: string | undefined;
    /** 租户ID */
    tenantId: number;
}

export class OtherDeleteTaskBySoureInput implements IOtherDeleteTaskBySoureInput {
    /** 来源 */
    source: string | undefined;
    /** 租户ID */
    tenantId: number;
    /** 删除人编码 */
    deleteUserNo: string | undefined;

    constructor(data?: IOtherDeleteTaskBySoureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.tenantId = _data["tenantId"];
            this.deleteUserNo = _data["deleteUserNo"];
        }
    }

    static fromJS(data: any): OtherDeleteTaskBySoureInput {
        data = typeof data === 'object' ? data : {};
        let result = new OtherDeleteTaskBySoureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["tenantId"] = this.tenantId;
        data["deleteUserNo"] = this.deleteUserNo;
        return data;
    }

    clone(): OtherDeleteTaskBySoureInput {
        const json = this.toJSON();
        let result = new OtherDeleteTaskBySoureInput();
        result.init(json);
        return result;
    }
}

export interface IOtherDeleteTaskBySoureInput {
    /** 来源 */
    source: string | undefined;
    /** 租户ID */
    tenantId: number;
    /** 删除人编码 */
    deleteUserNo: string | undefined;
}

export class OtherUpdateTaskDto implements IOtherUpdateTaskDto {
    id: number;
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 来源 */
    source: string | undefined;
    /** 创建人编码 */
    createUserNo: string | undefined;
    /** 租户ID */
    tenantId: number;

    constructor(data?: IOtherUpdateTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.item = _data["item"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.createUserNo = _data["createUserNo"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): OtherUpdateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherUpdateTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["item"] = this.item;
        data["description"] = this.description;
        data["source"] = this.source;
        data["createUserNo"] = this.createUserNo;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): OtherUpdateTaskDto {
        const json = this.toJSON();
        let result = new OtherUpdateTaskDto();
        result.init(json);
        return result;
    }
}

export interface IOtherUpdateTaskDto {
    id: number;
    /** 任务项 */
    item: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 来源 */
    source: string | undefined;
    /** 创建人编码 */
    createUserNo: string | undefined;
    /** 租户ID */
    tenantId: number;
}

export class OtherUpdateTaskStateByIdInput implements IOtherUpdateTaskStateByIdInput {
    /** 任务ID */
    id: number;
    /** 状态3作废 4拒绝 5完成 6关闭 */
    state: string | undefined;
    /** 租户ID */
    tenantId: number;
    /** 创建人编码 */
    createUserNo: string | undefined;

    constructor(data?: IOtherUpdateTaskStateByIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.createUserNo = _data["createUserNo"];
        }
    }

    static fromJS(data: any): OtherUpdateTaskStateByIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new OtherUpdateTaskStateByIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["createUserNo"] = this.createUserNo;
        return data;
    }

    clone(): OtherUpdateTaskStateByIdInput {
        const json = this.toJSON();
        let result = new OtherUpdateTaskStateByIdInput();
        result.init(json);
        return result;
    }
}

export interface IOtherUpdateTaskStateByIdInput {
    /** 任务ID */
    id: number;
    /** 状态3作废 4拒绝 5完成 6关闭 */
    state: string | undefined;
    /** 租户ID */
    tenantId: number;
    /** 创建人编码 */
    createUserNo: string | undefined;
}

export class OtherUpdateTaskStateBySoureInput implements IOtherUpdateTaskStateBySoureInput {
    /** 来源 */
    source: string | undefined;
    /** 状态3作废 4拒绝 5完成 6关闭 */
    state: string | undefined;
    /** 租户ID */
    tenantId: number;
    /** 创建人编码 */
    createUserNo: string | undefined;

    constructor(data?: IOtherUpdateTaskStateBySoureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.createUserNo = _data["createUserNo"];
        }
    }

    static fromJS(data: any): OtherUpdateTaskStateBySoureInput {
        data = typeof data === 'object' ? data : {};
        let result = new OtherUpdateTaskStateBySoureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["createUserNo"] = this.createUserNo;
        return data;
    }

    clone(): OtherUpdateTaskStateBySoureInput {
        const json = this.toJSON();
        let result = new OtherUpdateTaskStateBySoureInput();
        result.init(json);
        return result;
    }
}

export interface IOtherUpdateTaskStateBySoureInput {
    /** 来源 */
    source: string | undefined;
    /** 状态3作废 4拒绝 5完成 6关闭 */
    state: string | undefined;
    /** 租户ID */
    tenantId: number;
    /** 创建人编码 */
    createUserNo: string | undefined;
}

/** 添加修改Dto */
export class TemplateBarCodeEditDto implements ITemplateBarCodeEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 条码 */
    code: string | undefined;
    /** 截取起始 */
    subStart: number;
    /** 截取长度 */
    subLength: number;
    /** 辅助信息截取规则起始 */
    assitFieldSubStart: number;
    /** 辅助信息截取规则长度 */
    assitFieldSubLength: number;
    /** 备注 */
    remark: string | undefined;

    constructor(data?: ITemplateBarCodeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subStart = _data["subStart"];
            this.subLength = _data["subLength"];
            this.assitFieldSubStart = _data["assitFieldSubStart"];
            this.assitFieldSubLength = _data["assitFieldSubLength"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): TemplateBarCodeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBarCodeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subStart"] = this.subStart;
        data["subLength"] = this.subLength;
        data["assitFieldSubStart"] = this.assitFieldSubStart;
        data["assitFieldSubLength"] = this.assitFieldSubLength;
        data["remark"] = this.remark;
        return data;
    }

    clone(): TemplateBarCodeEditDto {
        const json = this.toJSON();
        let result = new TemplateBarCodeEditDto();
        result.init(json);
        return result;
    }
}

/** 添加修改Dto */
export interface ITemplateBarCodeEditDto {
    /** Id */
    id: number | undefined;
    /** 名称 */
    name: string | undefined;
    /** 条码 */
    code: string | undefined;
    /** 截取起始 */
    subStart: number;
    /** 截取长度 */
    subLength: number;
    /** 辅助信息截取规则起始 */
    assitFieldSubStart: number;
    /** 辅助信息截取规则长度 */
    assitFieldSubLength: number;
    /** 备注 */
    remark: string | undefined;
}

/** 新增修改 */
export class CreateOrUpdateTemplateBarCodeInput implements ICreateOrUpdateTemplateBarCodeInput {
    templateBarCode: TemplateBarCodeEditDto;

    constructor(data?: ICreateOrUpdateTemplateBarCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.templateBarCode = new TemplateBarCodeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateBarCode = _data["templateBarCode"] ? TemplateBarCodeEditDto.fromJS(_data["templateBarCode"]) : new TemplateBarCodeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTemplateBarCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTemplateBarCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateBarCode"] = this.templateBarCode ? this.templateBarCode.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTemplateBarCodeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTemplateBarCodeInput();
        result.init(json);
        return result;
    }
}

/** 新增修改 */
export interface ICreateOrUpdateTemplateBarCodeInput {
    templateBarCode: TemplateBarCodeEditDto;
}

/** 列表Dto */
export class TemplateBarCodeListDto implements ITemplateBarCodeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 条码 */
    code: string | undefined;
    /** 截取起始 */
    subStart: number;
    /** 截取长度 */
    subLength: number;
    /** 辅助信息截取规则起始 */
    assitFieldSubStart: number;
    /** 辅助信息截取规则长度 */
    assitFieldSubLength: number;
    /** 备注 */
    remark: string | undefined;

    constructor(data?: ITemplateBarCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.subStart = _data["subStart"];
            this.subLength = _data["subLength"];
            this.assitFieldSubStart = _data["assitFieldSubStart"];
            this.assitFieldSubLength = _data["assitFieldSubLength"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): TemplateBarCodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBarCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["subStart"] = this.subStart;
        data["subLength"] = this.subLength;
        data["assitFieldSubStart"] = this.assitFieldSubStart;
        data["assitFieldSubLength"] = this.assitFieldSubLength;
        data["remark"] = this.remark;
        return data;
    }

    clone(): TemplateBarCodeListDto {
        const json = this.toJSON();
        let result = new TemplateBarCodeListDto();
        result.init(json);
        return result;
    }
}

/** 列表Dto */
export interface ITemplateBarCodeListDto {
    /** Id */
    id: number;
    /** 名称 */
    name: string | undefined;
    /** 条码 */
    code: string | undefined;
    /** 截取起始 */
    subStart: number;
    /** 截取长度 */
    subLength: number;
    /** 辅助信息截取规则起始 */
    assitFieldSubStart: number;
    /** 辅助信息截取规则长度 */
    assitFieldSubLength: number;
    /** 备注 */
    remark: string | undefined;
}

export class PagedResultDtoOfTemplateBarCodeListDto implements IPagedResultDtoOfTemplateBarCodeListDto {
    totalCount: number;
    items: TemplateBarCodeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTemplateBarCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TemplateBarCodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTemplateBarCodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTemplateBarCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTemplateBarCodeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTemplateBarCodeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTemplateBarCodeListDto {
    totalCount: number;
    items: TemplateBarCodeListDto[] | undefined;
}

export class EntityDto implements IEntityDto {
    id: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDto {
    id: number;
}

export class SynsTenantMenuDto implements ISynsTenantMenuDto {
    /** tenantId */
    tenantlId: number;
    /** 选中的菜单 */
    moudleId: string | undefined;
    /** 是否全部 */
    copyAllMenu: boolean;
    /** 父菜单ID */
    parentModuleId: number;

    constructor(data?: ISynsTenantMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantlId = _data["tenantlId"];
            this.moudleId = _data["moudleId"];
            this.copyAllMenu = _data["copyAllMenu"];
            this.parentModuleId = _data["parentModuleId"];
        }
    }

    static fromJS(data: any): SynsTenantMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new SynsTenantMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantlId"] = this.tenantlId;
        data["moudleId"] = this.moudleId;
        data["copyAllMenu"] = this.copyAllMenu;
        data["parentModuleId"] = this.parentModuleId;
        return data;
    }

    clone(): SynsTenantMenuDto {
        const json = this.toJSON();
        let result = new SynsTenantMenuDto();
        result.init(json);
        return result;
    }
}

export interface ISynsTenantMenuDto {
    /** tenantId */
    tenantlId: number;
    /** 选中的菜单 */
    moudleId: string | undefined;
    /** 是否全部 */
    copyAllMenu: boolean;
    /** 父菜单ID */
    parentModuleId: number;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    /** 是否默认 */
    isDefault: boolean;
    /** LPA服务地址 */
    lpaServicePath: string | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndUtc = _data["subscriptionEndUtc"] ? moment(_data["subscriptionEndUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.isDefault = _data["isDefault"];
            this.lpaServicePath = _data["lpaServicePath"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndUtc"] = this.subscriptionEndUtc ? this.subscriptionEndUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["isDefault"] = this.isDefault;
        data["lpaServicePath"] = this.lpaServicePath;
        return data;
    }

    clone(): CreateTenantInput {
        const json = this.toJSON();
        let result = new CreateTenantInput();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    /** 是否默认 */
    isDefault: boolean;
    /** LPA服务地址 */
    lpaServicePath: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    /** 是否默认 */
    isDefault: boolean;
    /** LPA服务地址 */
    lpaServicePath: string | undefined;
    id: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndUtc = _data["subscriptionEndUtc"] ? moment(_data["subscriptionEndUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.isDefault = _data["isDefault"];
            this.lpaServicePath = _data["lpaServicePath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndUtc"] = this.subscriptionEndUtc ? this.subscriptionEndUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["isDefault"] = this.isDefault;
        data["lpaServicePath"] = this.lpaServicePath;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantEditDto {
        const json = this.toJSON();
        let result = new TenantEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    /** 是否默认 */
    isDefault: boolean;
    /** LPA服务地址 */
    lpaServicePath: string | undefined;
    id: number;
}

export class TenantListDto implements ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndUtc: moment.Moment | undefined;
    editionId: number | undefined;
    /** 是否默认 */
    isDefault: boolean;
    id: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndUtc = _data["subscriptionEndUtc"] ? moment(_data["subscriptionEndUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndUtc"] = this.subscriptionEndUtc ? this.subscriptionEndUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantListDto {
        const json = this.toJSON();
        let result = new TenantListDto();
        result.init(json);
        return result;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndUtc: moment.Moment | undefined;
    editionId: number | undefined;
    /** 是否默认 */
    isDefault: boolean;
    id: number;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTenantListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTenantListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class Module implements IModule {
    parentId: number;
    enCode: string | undefined;
    fullName: string | undefined;
    icon: string | undefined;
    urlAddress: string | undefined;
    target: string | undefined;
    allowExpand: number | undefined;
    isMenu: number | undefined;
    sortCode: number | undefined;
    enabledMark: number | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    tenantId: number;
    templateId: number | undefined;
    isApp: boolean;
    scenesId: number;
    id: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.enCode = _data["enCode"];
            this.fullName = _data["fullName"];
            this.icon = _data["icon"];
            this.urlAddress = _data["urlAddress"];
            this.target = _data["target"];
            this.allowExpand = _data["allowExpand"];
            this.isMenu = _data["isMenu"];
            this.sortCode = _data["sortCode"];
            this.enabledMark = _data["enabledMark"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.templateId = _data["templateId"];
            this.isApp = _data["isApp"];
            this.scenesId = _data["scenesId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["enCode"] = this.enCode;
        data["fullName"] = this.fullName;
        data["icon"] = this.icon;
        data["urlAddress"] = this.urlAddress;
        data["target"] = this.target;
        data["allowExpand"] = this.allowExpand;
        data["isMenu"] = this.isMenu;
        data["sortCode"] = this.sortCode;
        data["enabledMark"] = this.enabledMark;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["templateId"] = this.templateId;
        data["isApp"] = this.isApp;
        data["scenesId"] = this.scenesId;
        data["id"] = this.id;
        return data;
    }

    clone(): Module {
        const json = this.toJSON();
        let result = new Module();
        result.init(json);
        return result;
    }
}

export interface IModule {
    parentId: number;
    enCode: string | undefined;
    fullName: string | undefined;
    icon: string | undefined;
    urlAddress: string | undefined;
    target: string | undefined;
    allowExpand: number | undefined;
    isMenu: number | undefined;
    sortCode: number | undefined;
    enabledMark: number | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    tenantId: number;
    templateId: number | undefined;
    isApp: boolean;
    scenesId: number;
    id: number;
}

export class ValueTupleOfInt32Module implements IValueTupleOfInt32Module {
    item1: number;
    item2: Module;

    constructor(data?: IValueTupleOfInt32Module) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"] ? Module.fromJS(_data["item2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValueTupleOfInt32Module {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfInt32Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }

    clone(): ValueTupleOfInt32Module {
        const json = this.toJSON();
        let result = new ValueTupleOfInt32Module();
        result.init(json);
        return result;
    }
}

export interface IValueTupleOfInt32Module {
    item1: number;
    item2: Module;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetTenantFeaturesEditOutput {
        const json = this.toJSON();
        let result = new GetTenantFeaturesEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class TenantServiceDto implements ITenantServiceDto {
    /** 编码 */
    tenancyName: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** LPA服务地址 */
    lpaServicePath: string | undefined;

    constructor(data?: ITenantServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.lpaServicePath = _data["lpaServicePath"];
        }
    }

    static fromJS(data: any): TenantServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["lpaServicePath"] = this.lpaServicePath;
        return data;
    }

    clone(): TenantServiceDto {
        const json = this.toJSON();
        let result = new TenantServiceDto();
        result.init(json);
        return result;
    }
}

export interface ITenantServiceDto {
    /** 编码 */
    tenancyName: string | undefined;
    /** 名称 */
    name: string | undefined;
    /** LPA服务地址 */
    lpaServicePath: string | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateTenantFeaturesInput {
        const json = this.toJSON();
        let result = new UpdateTenantFeaturesInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

/** 创建租户的DTO信息 */
export class CreateTenantDto implements ICreateTenantDto {
    /** 全局唯一的租户Id */
    tenancyName: string;
    /** 租户名称 */
    name: string;
    userName: string | undefined;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
    /** 验证码 */
    verificationCode: string | undefined;
    /** 租户管理员密码 */
    tenantAdminPassword: string | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.verificationCode = _data["verificationCode"];
            this.tenantAdminPassword = _data["tenantAdminPassword"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["verificationCode"] = this.verificationCode;
        data["tenantAdminPassword"] = this.tenantAdminPassword;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

/** 创建租户的DTO信息 */
export interface ICreateTenantDto {
    /** 全局唯一的租户Id */
    tenancyName: string;
    /** 租户名称 */
    name: string;
    userName: string | undefined;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
    /** 验证码 */
    verificationCode: string | undefined;
    /** 租户管理员密码 */
    tenantAdminPassword: string | undefined;
}

export class RegisterTenantResultDto implements IRegisterTenantResultDto {
    /** 租户Id */
    tenantId: number;
    /** 租户是否激活 */
    isActive: boolean;
    /** 租户启用了用户登陆验证码 */
    useCaptchaOnUserLogin: boolean;

    constructor(data?: IRegisterTenantResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.isActive = _data["isActive"];
            this.useCaptchaOnUserLogin = _data["useCaptchaOnUserLogin"];
        }
    }

    static fromJS(data: any): RegisterTenantResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["useCaptchaOnUserLogin"] = this.useCaptchaOnUserLogin;
        return data;
    }

    clone(): RegisterTenantResultDto {
        const json = this.toJSON();
        let result = new RegisterTenantResultDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterTenantResultDto {
    /** 租户Id */
    tenantId: number;
    /** 租户是否激活 */
    isActive: boolean;
    /** 租户启用了用户登陆验证码 */
    useCaptchaOnUserLogin: boolean;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    /** 是否启用注册 */
    allowSelfRegistration: boolean;
    /** 是否新注册用户默认激活 */
    isNewRegisteredUserActiveByDefault: boolean;
    /** 是否必须校验邮箱才能登陆 */
    isEmailConfirmationRequiredForLogin: boolean;
    /** 是否注册使用验证码 */
    useCaptchaOnUserRegistration: boolean;
    captchaOnUserRegistrationType: ValidateCodeType;
    /** 注册验证码长度 */
    captchaOnUserRegistrationLength: number;
    /** 是否登陆使用验证码 */
    useCaptchaOnUserLogin: boolean;
    captchaOnUserLoginType: ValidateCodeType;
    /** 登陆验证码长度 */
    captchaOnUserLoginLength: number;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnUserRegistration = _data["useCaptchaOnUserRegistration"];
            this.captchaOnUserRegistrationType = _data["captchaOnUserRegistrationType"];
            this.captchaOnUserRegistrationLength = _data["captchaOnUserRegistrationLength"];
            this.useCaptchaOnUserLogin = _data["useCaptchaOnUserLogin"];
            this.captchaOnUserLoginType = _data["captchaOnUserLoginType"];
            this.captchaOnUserLoginLength = _data["captchaOnUserLoginLength"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnUserRegistration"] = this.useCaptchaOnUserRegistration;
        data["captchaOnUserRegistrationType"] = this.captchaOnUserRegistrationType;
        data["captchaOnUserRegistrationLength"] = this.captchaOnUserRegistrationLength;
        data["useCaptchaOnUserLogin"] = this.useCaptchaOnUserLogin;
        data["captchaOnUserLoginType"] = this.captchaOnUserLoginType;
        data["captchaOnUserLoginLength"] = this.captchaOnUserLoginLength;
        return data;
    }

    clone(): TenantUserManagementSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantUserManagementSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    /** 是否启用注册 */
    allowSelfRegistration: boolean;
    /** 是否新注册用户默认激活 */
    isNewRegisteredUserActiveByDefault: boolean;
    /** 是否必须校验邮箱才能登陆 */
    isEmailConfirmationRequiredForLogin: boolean;
    /** 是否注册使用验证码 */
    useCaptchaOnUserRegistration: boolean;
    captchaOnUserRegistrationType: ValidateCodeType;
    /** 注册验证码长度 */
    captchaOnUserRegistrationLength: number;
    /** 是否登陆使用验证码 */
    useCaptchaOnUserLogin: boolean;
    captchaOnUserLoginType: ValidateCodeType;
    /** 登陆验证码长度 */
    captchaOnUserLoginLength: number;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    /** 模块启用 */
    isModuleEnabled: boolean;
    /** 启用 */
    isEnabled: boolean;
    domain: string | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 密码 */
    password: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }

    clone(): LdapSettingsEditDto {
        const json = this.toJSON();
        let result = new LdapSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ILdapSettingsEditDto {
    /** 模块启用 */
    isModuleEnabled: boolean;
    /** 启用 */
    isEnabled: boolean;
    domain: string | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 密码 */
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }

    clone(): TenantBillingSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantBillingSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class SecuritySettingsDto implements ISecuritySettingsDto {
    /** 是否启用首次登录需要修改密码 */
    isFirstUpdatePass: boolean;
    /** 不能与当前密码和默认密码一样 */
    isAllowRepeat: boolean;
    /** 是否启用周期强制变更密码 */
    isCycleUpdatePass: boolean;
    /** 周期天数 */
    cycleUpdatePassDays: number;
    /** 必须有字母(不区分大小写) */
    requireLetter: boolean;
    /** 默认密码配置 */
    defaultPwd: string | undefined;

    constructor(data?: ISecuritySettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFirstUpdatePass = _data["isFirstUpdatePass"];
            this.isAllowRepeat = _data["isAllowRepeat"];
            this.isCycleUpdatePass = _data["isCycleUpdatePass"];
            this.cycleUpdatePassDays = _data["cycleUpdatePassDays"];
            this.requireLetter = _data["requireLetter"];
            this.defaultPwd = _data["defaultPwd"];
        }
    }

    static fromJS(data: any): SecuritySettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFirstUpdatePass"] = this.isFirstUpdatePass;
        data["isAllowRepeat"] = this.isAllowRepeat;
        data["isCycleUpdatePass"] = this.isCycleUpdatePass;
        data["cycleUpdatePassDays"] = this.cycleUpdatePassDays;
        data["requireLetter"] = this.requireLetter;
        data["defaultPwd"] = this.defaultPwd;
        return data;
    }

    clone(): SecuritySettingsDto {
        const json = this.toJSON();
        let result = new SecuritySettingsDto();
        result.init(json);
        return result;
    }
}

export interface ISecuritySettingsDto {
    /** 是否启用首次登录需要修改密码 */
    isFirstUpdatePass: boolean;
    /** 不能与当前密码和默认密码一样 */
    isAllowRepeat: boolean;
    /** 是否启用周期强制变更密码 */
    isCycleUpdatePass: boolean;
    /** 周期天数 */
    cycleUpdatePassDays: number;
    /** 必须有字母(不区分大小写) */
    requireLetter: boolean;
    /** 默认密码配置 */
    defaultPwd: string | undefined;
}

export class SettingWhiteUserListDto implements ISettingWhiteUserListDto {
    empId: number;
    realName: string | undefined;

    constructor(data?: ISettingWhiteUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.realName = _data["realName"];
        }
    }

    static fromJS(data: any): SettingWhiteUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingWhiteUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["realName"] = this.realName;
        return data;
    }

    clone(): SettingWhiteUserListDto {
        const json = this.toJSON();
        let result = new SettingWhiteUserListDto();
        result.init(json);
        return result;
    }
}

export interface ISettingWhiteUserListDto {
    empId: number;
    realName: string | undefined;
}

export class RemoveCompanyEditDto implements IRemoveCompanyEditDto {
    /** 类型 1：正方形LOGO 2：长方形LOG 3：企业文化 */
    type: number;
    fileName: string | undefined;

    constructor(data?: IRemoveCompanyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): RemoveCompanyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCompanyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): RemoveCompanyEditDto {
        const json = this.toJSON();
        let result = new RemoveCompanyEditDto();
        result.init(json);
        return result;
    }
}

export interface IRemoveCompanyEditDto {
    /** 类型 1：正方形LOGO 2：长方形LOG 3：企业文化 */
    type: number;
    fileName: string | undefined;
}

export class ZkDataDockingMangementSettingEditDto implements IZkDataDockingMangementSettingEditDto {
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IZkDataDockingMangementSettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): ZkDataDockingMangementSettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZkDataDockingMangementSettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): ZkDataDockingMangementSettingEditDto {
        const json = this.toJSON();
        let result = new ZkDataDockingMangementSettingEditDto();
        result.init(json);
        return result;
    }
}

export interface IZkDataDockingMangementSettingEditDto {
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class ClockInReminderMangementSettingEditDto implements IClockInReminderMangementSettingEditDto {
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IClockInReminderMangementSettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): ClockInReminderMangementSettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockInReminderMangementSettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): ClockInReminderMangementSettingEditDto {
        const json = this.toJSON();
        let result = new ClockInReminderMangementSettingEditDto();
        result.init(json);
        return result;
    }
}

export interface IClockInReminderMangementSettingEditDto {
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class OmitCheckInRemindSettingEditDto implements IOmitCheckInRemindSettingEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IOmitCheckInRemindSettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour1 = _data["hour1"];
            this.minute1 = _data["minute1"];
            this.hour2 = _data["hour2"];
            this.minute2 = _data["minute2"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): OmitCheckInRemindSettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OmitCheckInRemindSettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour1"] = this.hour1;
        data["minute1"] = this.minute1;
        data["hour2"] = this.hour2;
        data["minute2"] = this.minute2;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): OmitCheckInRemindSettingEditDto {
        const json = this.toJSON();
        let result = new OmitCheckInRemindSettingEditDto();
        result.init(json);
        return result;
    }
}

export interface IOmitCheckInRemindSettingEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

/** 审核超时提醒 */
export class VerifyOverTimeRemindEditDto implements IVerifyOverTimeRemindEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IVerifyOverTimeRemindEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour1 = _data["hour1"];
            this.minute1 = _data["minute1"];
            this.hour2 = _data["hour2"];
            this.minute2 = _data["minute2"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): VerifyOverTimeRemindEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyOverTimeRemindEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour1"] = this.hour1;
        data["minute1"] = this.minute1;
        data["hour2"] = this.hour2;
        data["minute2"] = this.minute2;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): VerifyOverTimeRemindEditDto {
        const json = this.toJSON();
        let result = new VerifyOverTimeRemindEditDto();
        result.init(json);
        return result;
    }
}

/** 审核超时提醒 */
export interface IVerifyOverTimeRemindEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class ContractDueRemindSettingEdit implements IContractDueRemindSettingEdit {
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IContractDueRemindSettingEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): ContractDueRemindSettingEdit {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDueRemindSettingEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): ContractDueRemindSettingEdit {
        const json = this.toJSON();
        let result = new ContractDueRemindSettingEdit();
        result.init(json);
        return result;
    }
}

export interface IContractDueRemindSettingEdit {
    /** 是否启用 */
    isActivate: boolean;
}

export class AttDayAnalysisEditDto implements IAttDayAnalysisEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IAttDayAnalysisEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour1 = _data["hour1"];
            this.minute1 = _data["minute1"];
            this.hour2 = _data["hour2"];
            this.minute2 = _data["minute2"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): AttDayAnalysisEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttDayAnalysisEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour1"] = this.hour1;
        data["minute1"] = this.minute1;
        data["hour2"] = this.hour2;
        data["minute2"] = this.minute2;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): AttDayAnalysisEditDto {
        const json = this.toJSON();
        let result = new AttDayAnalysisEditDto();
        result.init(json);
        return result;
    }
}

export interface IAttDayAnalysisEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class EmployeeTurnoverEditDto implements IEmployeeTurnoverEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IEmployeeTurnoverEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): EmployeeTurnoverEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTurnoverEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): EmployeeTurnoverEditDto {
        const json = this.toJSON();
        let result = new EmployeeTurnoverEditDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeTurnoverEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class AnnualLeaveCalculationEditDto implements IAnnualLeaveCalculationEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IAnnualLeaveCalculationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): AnnualLeaveCalculationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualLeaveCalculationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): AnnualLeaveCalculationEditDto {
        const json = this.toJSON();
        let result = new AnnualLeaveCalculationEditDto();
        result.init(json);
        return result;
    }
}

export interface IAnnualLeaveCalculationEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class SalaryChangeEditDto implements ISalaryChangeEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: ISalaryChangeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): SalaryChangeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryChangeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): SalaryChangeEditDto {
        const json = this.toJSON();
        let result = new SalaryChangeEditDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryChangeEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

/** 考勤月分析 */
export class AttMonthAnalysisEditDto implements IAttMonthAnalysisEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IAttMonthAnalysisEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour1 = _data["hour1"];
            this.minute1 = _data["minute1"];
            this.hour2 = _data["hour2"];
            this.minute2 = _data["minute2"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): AttMonthAnalysisEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttMonthAnalysisEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour1"] = this.hour1;
        data["minute1"] = this.minute1;
        data["hour2"] = this.hour2;
        data["minute2"] = this.minute2;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): AttMonthAnalysisEditDto {
        const json = this.toJSON();
        let result = new AttMonthAnalysisEditDto();
        result.init(json);
        return result;
    }
}

/** 考勤月分析 */
export interface IAttMonthAnalysisEditDto {
    /** 小时1 */
    hour1: number | undefined;
    /** 分钟1 */
    minute1: number | undefined;
    /** 小时2 */
    hour2: number | undefined;
    /** 分钟2 */
    minute2: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

/** 考勤异常定时任务 */
export class AttErrorReportDto implements IAttErrorReportDto {
    /** 开始日期 */
    startTime: moment.Moment | undefined;
    /** 开始时 */
    startHour: moment.Moment | undefined;
    /** 循环天 */
    day: number | undefined;
    /** 是否启用 */
    isActivate: boolean | undefined;
    isUpdate: boolean;

    constructor(data?: IAttErrorReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.startHour = _data["startHour"] ? moment(_data["startHour"].toString()) : <any>undefined;
            this.day = _data["day"];
            this.isActivate = _data["isActivate"];
            this.isUpdate = _data["isUpdate"];
        }
    }

    static fromJS(data: any): AttErrorReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttErrorReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["startHour"] = this.startHour ? this.startHour.toISOString() : <any>undefined;
        data["day"] = this.day;
        data["isActivate"] = this.isActivate;
        data["isUpdate"] = this.isUpdate;
        return data;
    }

    clone(): AttErrorReportDto {
        const json = this.toJSON();
        let result = new AttErrorReportDto();
        result.init(json);
        return result;
    }
}

/** 考勤异常定时任务 */
export interface IAttErrorReportDto {
    /** 开始日期 */
    startTime: moment.Moment | undefined;
    /** 开始时 */
    startHour: moment.Moment | undefined;
    /** 循环天 */
    day: number | undefined;
    /** 是否启用 */
    isActivate: boolean | undefined;
    isUpdate: boolean;
}

export class IDExpireEditDto implements IIDExpireEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IIDExpireEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): IDExpireEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new IDExpireEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): IDExpireEditDto {
        const json = this.toJSON();
        let result = new IDExpireEditDto();
        result.init(json);
        return result;
    }
}

export interface IIDExpireEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class ProbationExpireEditDto implements IProbationExpireEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IProbationExpireEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): ProbationExpireEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProbationExpireEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): ProbationExpireEditDto {
        const json = this.toJSON();
        let result = new ProbationExpireEditDto();
        result.init(json);
        return result;
    }
}

export interface IProbationExpireEditDto {
    /** 小时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class WFOverTimePersonalEditDto implements IWFOverTimePersonalEditDto {
    /** 时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IWFOverTimePersonalEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): WFOverTimePersonalEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WFOverTimePersonalEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): WFOverTimePersonalEditDto {
        const json = this.toJSON();
        let result = new WFOverTimePersonalEditDto();
        result.init(json);
        return result;
    }
}

export interface IWFOverTimePersonalEditDto {
    /** 时 */
    hour: number | undefined;
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class WFOverTimeDepEditDto implements IWFOverTimeDepEditDto {
    /** 周 */
    week: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IWFOverTimeDepEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.week = _data["week"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): WFOverTimeDepEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WFOverTimeDepEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): WFOverTimeDepEditDto {
        const json = this.toJSON();
        let result = new WFOverTimeDepEditDto();
        result.init(json);
        return result;
    }
}

export interface IWFOverTimeDepEditDto {
    /** 周 */
    week: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

/** 员工自助确认超时定时任务 */
export class StaffSelfConfirmationSeetingDto implements IStaffSelfConfirmationSeetingDto {
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;

    constructor(data?: IStaffSelfConfirmationSeetingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minute = _data["minute"];
            this.isActivate = _data["isActivate"];
        }
    }

    static fromJS(data: any): StaffSelfConfirmationSeetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffSelfConfirmationSeetingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minute"] = this.minute;
        data["isActivate"] = this.isActivate;
        return data;
    }

    clone(): StaffSelfConfirmationSeetingDto {
        const json = this.toJSON();
        let result = new StaffSelfConfirmationSeetingDto();
        result.init(json);
        return result;
    }
}

/** 员工自助确认超时定时任务 */
export interface IStaffSelfConfirmationSeetingDto {
    /** 分钟 */
    minute: number | undefined;
    /** 是否启用 */
    isActivate: boolean;
}

export class AuditTaskStateEditDto implements IAuditTaskStateEditDto {
    /** 任务名 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否启用 */
    isActivate: boolean;
    /** 时间表达式 */
    timeExpression: string | undefined;

    constructor(data?: IAuditTaskStateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.isActivate = _data["isActivate"];
            this.timeExpression = _data["timeExpression"];
        }
    }

    static fromJS(data: any): AuditTaskStateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTaskStateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["isActivate"] = this.isActivate;
        data["timeExpression"] = this.timeExpression;
        return data;
    }

    clone(): AuditTaskStateEditDto {
        const json = this.toJSON();
        let result = new AuditTaskStateEditDto();
        result.init(json);
        return result;
    }
}

export interface IAuditTaskStateEditDto {
    /** 任务名 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否启用 */
    isActivate: boolean;
    /** 时间表达式 */
    timeExpression: string | undefined;
}

export class DailyMessageEditDto implements IDailyMessageEditDto {
    /** 任务名 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否启用 */
    isActivate: boolean;
    /** 时间表达式 */
    timeExpression: string | undefined;

    constructor(data?: IDailyMessageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.remark = _data["remark"];
            this.isActivate = _data["isActivate"];
            this.timeExpression = _data["timeExpression"];
        }
    }

    static fromJS(data: any): DailyMessageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyMessageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["isActivate"] = this.isActivate;
        data["timeExpression"] = this.timeExpression;
        return data;
    }

    clone(): DailyMessageEditDto {
        const json = this.toJSON();
        let result = new DailyMessageEditDto();
        result.init(json);
        return result;
    }
}

export interface IDailyMessageEditDto {
    /** 任务名 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 是否启用 */
    isActivate: boolean;
    /** 时间表达式 */
    timeExpression: string | undefined;
}

export class WeComSettingsEditDto implements IWeComSettingsEditDto {
    enabled: boolean;
    corpId: string | undefined;
    agentId: string | undefined;
    secret: string | undefined;
    baseUrl: string | undefined;

    constructor(data?: IWeComSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.corpId = _data["corpId"];
            this.agentId = _data["agentId"];
            this.secret = _data["secret"];
            this.baseUrl = _data["baseUrl"];
        }
    }

    static fromJS(data: any): WeComSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeComSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["corpId"] = this.corpId;
        data["agentId"] = this.agentId;
        data["secret"] = this.secret;
        data["baseUrl"] = this.baseUrl;
        return data;
    }

    clone(): WeComSettingsEditDto {
        const json = this.toJSON();
        let result = new WeComSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface IWeComSettingsEditDto {
    enabled: boolean;
    corpId: string | undefined;
    agentId: string | undefined;
    secret: string | undefined;
    baseUrl: string | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    theme: ThemeEditDto;
    userSecuritySettings: SecuritySettingsDto;
    /** 安全策略白名单 */
    settingWhiteUserList: SettingWhiteUserListDto[] | undefined;
    companyImages: CompanyImagesEditDto;
    /** 移除的图片集合 */
    removeCompanyImageList: RemoveCompanyEditDto[] | undefined;
    anniversaryManagement: AnniversaryManagementSettingsEditDto;
    birthdayWishManagement: BirthdayWishManagementSettingEditDto;
    zkDataDockingManagement: ZkDataDockingMangementSettingEditDto;
    clockInReminderMangement: ClockInReminderMangementSettingEditDto;
    omitCheckInRemindMangement: OmitCheckInRemindSettingEditDto;
    verifyOverTimeRemindMangement: VerifyOverTimeRemindEditDto;
    /** 工号规则 */
    jobNumberRule: string | undefined;
    contractDueRemind: ContractDueRemindSettingEdit;
    attDayAnalysis: AttDayAnalysisEditDto;
    employeeTurnover: EmployeeTurnoverEditDto;
    annualLeaveCalculation: AnnualLeaveCalculationEditDto;
    salaryChange: SalaryChangeEditDto;
    attMonthAnalysis: AttMonthAnalysisEditDto;
    attErrorReport: AttErrorReportDto;
    idExpire: IDExpireEditDto;
    probationExpire: ProbationExpireEditDto;
    wfOverTimePersonal: WFOverTimePersonalEditDto;
    wfOverTimeDep: WFOverTimeDepEditDto;
    staffSelfConfirmationManagement: StaffSelfConfirmationSeetingDto;
    auditTaskState: AuditTaskStateEditDto;
    dailyMessage: DailyMessageEditDto;
    textMessage: TextMessageSettingsEditDto;
    weCom: WeComSettingsEditDto;
    filedExt: FiledExtSettingsEditDto;
    validateLogon: ValidateLogonDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : <any>undefined;
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : <any>undefined;
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.theme = _data["theme"] ? ThemeEditDto.fromJS(_data["theme"]) : <any>undefined;
            this.userSecuritySettings = _data["userSecuritySettings"] ? SecuritySettingsDto.fromJS(_data["userSecuritySettings"]) : <any>undefined;
            if (Array.isArray(_data["settingWhiteUserList"])) {
                this.settingWhiteUserList = [] as any;
                for (let item of _data["settingWhiteUserList"])
                    this.settingWhiteUserList.push(SettingWhiteUserListDto.fromJS(item));
            }
            this.companyImages = _data["companyImages"] ? CompanyImagesEditDto.fromJS(_data["companyImages"]) : <any>undefined;
            if (Array.isArray(_data["removeCompanyImageList"])) {
                this.removeCompanyImageList = [] as any;
                for (let item of _data["removeCompanyImageList"])
                    this.removeCompanyImageList.push(RemoveCompanyEditDto.fromJS(item));
            }
            this.anniversaryManagement = _data["anniversaryManagement"] ? AnniversaryManagementSettingsEditDto.fromJS(_data["anniversaryManagement"]) : <any>undefined;
            this.birthdayWishManagement = _data["birthdayWishManagement"] ? BirthdayWishManagementSettingEditDto.fromJS(_data["birthdayWishManagement"]) : <any>undefined;
            this.zkDataDockingManagement = _data["zkDataDockingManagement"] ? ZkDataDockingMangementSettingEditDto.fromJS(_data["zkDataDockingManagement"]) : <any>undefined;
            this.clockInReminderMangement = _data["clockInReminderMangement"] ? ClockInReminderMangementSettingEditDto.fromJS(_data["clockInReminderMangement"]) : <any>undefined;
            this.omitCheckInRemindMangement = _data["omitCheckInRemindMangement"] ? OmitCheckInRemindSettingEditDto.fromJS(_data["omitCheckInRemindMangement"]) : <any>undefined;
            this.verifyOverTimeRemindMangement = _data["verifyOverTimeRemindMangement"] ? VerifyOverTimeRemindEditDto.fromJS(_data["verifyOverTimeRemindMangement"]) : <any>undefined;
            this.jobNumberRule = _data["jobNumberRule"];
            this.contractDueRemind = _data["contractDueRemind"] ? ContractDueRemindSettingEdit.fromJS(_data["contractDueRemind"]) : <any>undefined;
            this.attDayAnalysis = _data["attDayAnalysis"] ? AttDayAnalysisEditDto.fromJS(_data["attDayAnalysis"]) : <any>undefined;
            this.employeeTurnover = _data["employeeTurnover"] ? EmployeeTurnoverEditDto.fromJS(_data["employeeTurnover"]) : <any>undefined;
            this.annualLeaveCalculation = _data["annualLeaveCalculation"] ? AnnualLeaveCalculationEditDto.fromJS(_data["annualLeaveCalculation"]) : <any>undefined;
            this.salaryChange = _data["salaryChange"] ? SalaryChangeEditDto.fromJS(_data["salaryChange"]) : <any>undefined;
            this.attMonthAnalysis = _data["attMonthAnalysis"] ? AttMonthAnalysisEditDto.fromJS(_data["attMonthAnalysis"]) : <any>undefined;
            this.attErrorReport = _data["attErrorReport"] ? AttErrorReportDto.fromJS(_data["attErrorReport"]) : <any>undefined;
            this.idExpire = _data["idExpire"] ? IDExpireEditDto.fromJS(_data["idExpire"]) : <any>undefined;
            this.probationExpire = _data["probationExpire"] ? ProbationExpireEditDto.fromJS(_data["probationExpire"]) : <any>undefined;
            this.wfOverTimePersonal = _data["wfOverTimePersonal"] ? WFOverTimePersonalEditDto.fromJS(_data["wfOverTimePersonal"]) : <any>undefined;
            this.wfOverTimeDep = _data["wfOverTimeDep"] ? WFOverTimeDepEditDto.fromJS(_data["wfOverTimeDep"]) : <any>undefined;
            this.staffSelfConfirmationManagement = _data["staffSelfConfirmationManagement"] ? StaffSelfConfirmationSeetingDto.fromJS(_data["staffSelfConfirmationManagement"]) : <any>undefined;
            this.auditTaskState = _data["auditTaskState"] ? AuditTaskStateEditDto.fromJS(_data["auditTaskState"]) : <any>undefined;
            this.dailyMessage = _data["dailyMessage"] ? DailyMessageEditDto.fromJS(_data["dailyMessage"]) : <any>undefined;
            this.textMessage = _data["textMessage"] ? TextMessageSettingsEditDto.fromJS(_data["textMessage"]) : <any>undefined;
            this.weCom = _data["weCom"] ? WeComSettingsEditDto.fromJS(_data["weCom"]) : <any>undefined;
            this.filedExt = _data["filedExt"] ? FiledExtSettingsEditDto.fromJS(_data["filedExt"]) : <any>undefined;
            this.validateLogon = _data["validateLogon"] ? ValidateLogonDto.fromJS(_data["validateLogon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        data["userSecuritySettings"] = this.userSecuritySettings ? this.userSecuritySettings.toJSON() : <any>undefined;
        if (Array.isArray(this.settingWhiteUserList)) {
            data["settingWhiteUserList"] = [];
            for (let item of this.settingWhiteUserList)
                data["settingWhiteUserList"].push(item.toJSON());
        }
        data["companyImages"] = this.companyImages ? this.companyImages.toJSON() : <any>undefined;
        if (Array.isArray(this.removeCompanyImageList)) {
            data["removeCompanyImageList"] = [];
            for (let item of this.removeCompanyImageList)
                data["removeCompanyImageList"].push(item.toJSON());
        }
        data["anniversaryManagement"] = this.anniversaryManagement ? this.anniversaryManagement.toJSON() : <any>undefined;
        data["birthdayWishManagement"] = this.birthdayWishManagement ? this.birthdayWishManagement.toJSON() : <any>undefined;
        data["zkDataDockingManagement"] = this.zkDataDockingManagement ? this.zkDataDockingManagement.toJSON() : <any>undefined;
        data["clockInReminderMangement"] = this.clockInReminderMangement ? this.clockInReminderMangement.toJSON() : <any>undefined;
        data["omitCheckInRemindMangement"] = this.omitCheckInRemindMangement ? this.omitCheckInRemindMangement.toJSON() : <any>undefined;
        data["verifyOverTimeRemindMangement"] = this.verifyOverTimeRemindMangement ? this.verifyOverTimeRemindMangement.toJSON() : <any>undefined;
        data["jobNumberRule"] = this.jobNumberRule;
        data["contractDueRemind"] = this.contractDueRemind ? this.contractDueRemind.toJSON() : <any>undefined;
        data["attDayAnalysis"] = this.attDayAnalysis ? this.attDayAnalysis.toJSON() : <any>undefined;
        data["employeeTurnover"] = this.employeeTurnover ? this.employeeTurnover.toJSON() : <any>undefined;
        data["annualLeaveCalculation"] = this.annualLeaveCalculation ? this.annualLeaveCalculation.toJSON() : <any>undefined;
        data["salaryChange"] = this.salaryChange ? this.salaryChange.toJSON() : <any>undefined;
        data["attMonthAnalysis"] = this.attMonthAnalysis ? this.attMonthAnalysis.toJSON() : <any>undefined;
        data["attErrorReport"] = this.attErrorReport ? this.attErrorReport.toJSON() : <any>undefined;
        data["idExpire"] = this.idExpire ? this.idExpire.toJSON() : <any>undefined;
        data["probationExpire"] = this.probationExpire ? this.probationExpire.toJSON() : <any>undefined;
        data["wfOverTimePersonal"] = this.wfOverTimePersonal ? this.wfOverTimePersonal.toJSON() : <any>undefined;
        data["wfOverTimeDep"] = this.wfOverTimeDep ? this.wfOverTimeDep.toJSON() : <any>undefined;
        data["staffSelfConfirmationManagement"] = this.staffSelfConfirmationManagement ? this.staffSelfConfirmationManagement.toJSON() : <any>undefined;
        data["auditTaskState"] = this.auditTaskState ? this.auditTaskState.toJSON() : <any>undefined;
        data["dailyMessage"] = this.dailyMessage ? this.dailyMessage.toJSON() : <any>undefined;
        data["textMessage"] = this.textMessage ? this.textMessage.toJSON() : <any>undefined;
        data["weCom"] = this.weCom ? this.weCom.toJSON() : <any>undefined;
        data["filedExt"] = this.filedExt ? this.filedExt.toJSON() : <any>undefined;
        data["validateLogon"] = this.validateLogon ? this.validateLogon.toJSON() : <any>undefined;
        return data;
    }

    clone(): TenantSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantSettingsEditDto();
        result.init(json);
        return result;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    theme: ThemeEditDto;
    userSecuritySettings: SecuritySettingsDto;
    /** 安全策略白名单 */
    settingWhiteUserList: SettingWhiteUserListDto[] | undefined;
    companyImages: CompanyImagesEditDto;
    /** 移除的图片集合 */
    removeCompanyImageList: RemoveCompanyEditDto[] | undefined;
    anniversaryManagement: AnniversaryManagementSettingsEditDto;
    birthdayWishManagement: BirthdayWishManagementSettingEditDto;
    zkDataDockingManagement: ZkDataDockingMangementSettingEditDto;
    clockInReminderMangement: ClockInReminderMangementSettingEditDto;
    omitCheckInRemindMangement: OmitCheckInRemindSettingEditDto;
    verifyOverTimeRemindMangement: VerifyOverTimeRemindEditDto;
    /** 工号规则 */
    jobNumberRule: string | undefined;
    contractDueRemind: ContractDueRemindSettingEdit;
    attDayAnalysis: AttDayAnalysisEditDto;
    employeeTurnover: EmployeeTurnoverEditDto;
    annualLeaveCalculation: AnnualLeaveCalculationEditDto;
    salaryChange: SalaryChangeEditDto;
    attMonthAnalysis: AttMonthAnalysisEditDto;
    attErrorReport: AttErrorReportDto;
    idExpire: IDExpireEditDto;
    probationExpire: ProbationExpireEditDto;
    wfOverTimePersonal: WFOverTimePersonalEditDto;
    wfOverTimeDep: WFOverTimeDepEditDto;
    staffSelfConfirmationManagement: StaffSelfConfirmationSeetingDto;
    auditTaskState: AuditTaskStateEditDto;
    dailyMessage: DailyMessageEditDto;
    textMessage: TextMessageSettingsEditDto;
    weCom: WeComSettingsEditDto;
    filedExt: FiledExtSettingsEditDto;
    validateLogon: ValidateLogonDto;
}

export class AsycMonthAttendancePlanEditDto implements IAsycMonthAttendancePlanEditDto {
    /** 是否启用 */
    isActivate: boolean;
    /** 天 */
    day: number | undefined;

    constructor(data?: IAsycMonthAttendancePlanEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActivate = _data["isActivate"];
            this.day = _data["day"];
        }
    }

    static fromJS(data: any): AsycMonthAttendancePlanEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AsycMonthAttendancePlanEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActivate"] = this.isActivate;
        data["day"] = this.day;
        return data;
    }

    clone(): AsycMonthAttendancePlanEditDto {
        const json = this.toJSON();
        let result = new AsycMonthAttendancePlanEditDto();
        result.init(json);
        return result;
    }
}

export interface IAsycMonthAttendancePlanEditDto {
    /** 是否启用 */
    isActivate: boolean;
    /** 天 */
    day: number | undefined;
}

export class MaxOverTimeDto implements IMaxOverTimeDto {
    /** 最大加班起始值 */
    maxNumber: number;
    /** 提醒起始值 */
    startNum: number;

    constructor(data?: IMaxOverTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxNumber = _data["maxNumber"];
            this.startNum = _data["startNum"];
        }
    }

    static fromJS(data: any): MaxOverTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaxOverTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxNumber"] = this.maxNumber;
        data["startNum"] = this.startNum;
        return data;
    }

    clone(): MaxOverTimeDto {
        const json = this.toJSON();
        let result = new MaxOverTimeDto();
        result.init(json);
        return result;
    }
}

export interface IMaxOverTimeDto {
    /** 最大加班起始值 */
    maxNumber: number;
    /** 提醒起始值 */
    startNum: number;
}

export class SalaryCycleSettingEditDto implements ISalaryCycleSettingEditDto {
    year: number | undefined;
    month: number | undefined;

    constructor(data?: ISalaryCycleSettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): SalaryCycleSettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryCycleSettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }

    clone(): SalaryCycleSettingEditDto {
        const json = this.toJSON();
        let result = new SalaryCycleSettingEditDto();
        result.init(json);
        return result;
    }
}

export interface ISalaryCycleSettingEditDto {
    year: number | undefined;
    month: number | undefined;
}

export class SalarySettingEditDto implements ISalarySettingEditDto {
    /** 夜班津贴 */
    subsidy: number;
    /** 保底工资 */
    salary: number;
    /** 薪资周期年 */
    year: number | undefined;
    /** 薪资周期月 */
    month: number | undefined;

    constructor(data?: ISalarySettingEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subsidy = _data["subsidy"];
            this.salary = _data["salary"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): SalarySettingEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalarySettingEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subsidy"] = this.subsidy;
        data["salary"] = this.salary;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }

    clone(): SalarySettingEditDto {
        const json = this.toJSON();
        let result = new SalarySettingEditDto();
        result.init(json);
        return result;
    }
}

export interface ISalarySettingEditDto {
    /** 夜班津贴 */
    subsidy: number;
    /** 保底工资 */
    salary: number;
    /** 薪资周期年 */
    year: number | undefined;
    /** 薪资周期月 */
    month: number | undefined;
}

/** 员工自助确认设置 */
export class StaffSelfConfirmationDto implements IStaffSelfConfirmationDto {
    /** 是否启用自助确认 */
    isEnable: boolean;
    /** 超时确认提示文案 */
    overTimePromptCopy: string | undefined;
    /** 确认超时天数 */
    sureOverTimeDays: number;

    constructor(data?: IStaffSelfConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnable = _data["isEnable"];
            this.overTimePromptCopy = _data["overTimePromptCopy"];
            this.sureOverTimeDays = _data["sureOverTimeDays"];
        }
    }

    static fromJS(data: any): StaffSelfConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaffSelfConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnable"] = this.isEnable;
        data["overTimePromptCopy"] = this.overTimePromptCopy;
        data["sureOverTimeDays"] = this.sureOverTimeDays;
        return data;
    }

    clone(): StaffSelfConfirmationDto {
        const json = this.toJSON();
        let result = new StaffSelfConfirmationDto();
        result.init(json);
        return result;
    }
}

/** 员工自助确认设置 */
export interface IStaffSelfConfirmationDto {
    /** 是否启用自助确认 */
    isEnable: boolean;
    /** 超时确认提示文案 */
    overTimePromptCopy: string | undefined;
    /** 确认超时天数 */
    sureOverTimeDays: number;
}

export class ReRegisterHangfireJobsInput implements IReRegisterHangfireJobsInput {
    tenantIds: number[] | undefined;
    reRegisterAuditTaskState: boolean;
    reRegisterDailyMessage: boolean;
    onlyEnabled: boolean;

    constructor(data?: IReRegisterHangfireJobsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds.push(item);
            }
            this.reRegisterAuditTaskState = _data["reRegisterAuditTaskState"];
            this.reRegisterDailyMessage = _data["reRegisterDailyMessage"];
            this.onlyEnabled = _data["onlyEnabled"];
        }
    }

    static fromJS(data: any): ReRegisterHangfireJobsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReRegisterHangfireJobsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["reRegisterAuditTaskState"] = this.reRegisterAuditTaskState;
        data["reRegisterDailyMessage"] = this.reRegisterDailyMessage;
        data["onlyEnabled"] = this.onlyEnabled;
        return data;
    }

    clone(): ReRegisterHangfireJobsInput {
        const json = this.toJSON();
        let result = new ReRegisterHangfireJobsInput();
        result.init(json);
        return result;
    }
}

export interface IReRegisterHangfireJobsInput {
    tenantIds: number[] | undefined;
    reRegisterAuditTaskState: boolean;
    reRegisterDailyMessage: boolean;
    onlyEnabled: boolean;
}

export class ReRegisterHangfireJobResultDto implements IReRegisterHangfireJobResultDto {
    tenantId: number;
    auditTaskStateProcessed: boolean;
    auditTaskStateMessage: string | undefined;
    dailyMessageProcessed: boolean;
    dailyMessageMessage: string | undefined;

    constructor(data?: IReRegisterHangfireJobResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.auditTaskStateProcessed = _data["auditTaskStateProcessed"];
            this.auditTaskStateMessage = _data["auditTaskStateMessage"];
            this.dailyMessageProcessed = _data["dailyMessageProcessed"];
            this.dailyMessageMessage = _data["dailyMessageMessage"];
        }
    }

    static fromJS(data: any): ReRegisterHangfireJobResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReRegisterHangfireJobResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["auditTaskStateProcessed"] = this.auditTaskStateProcessed;
        data["auditTaskStateMessage"] = this.auditTaskStateMessage;
        data["dailyMessageProcessed"] = this.dailyMessageProcessed;
        data["dailyMessageMessage"] = this.dailyMessageMessage;
        return data;
    }

    clone(): ReRegisterHangfireJobResultDto {
        const json = this.toJSON();
        let result = new ReRegisterHangfireJobResultDto();
        result.init(json);
        return result;
    }
}

export interface IReRegisterHangfireJobResultDto {
    tenantId: number;
    auditTaskStateProcessed: boolean;
    auditTaskStateMessage: string | undefined;
    dailyMessageProcessed: boolean;
    dailyMessageMessage: string | undefined;
}

export class TencentOrderInfoEditDto implements ITencentOrderInfoEditDto {
    id: number | undefined;
    /** 机构id */
    organizationId: number;
    /** 订单号 */
    orderNumber: number;
    /** 课程名称 */
    courseTitle: string | undefined;
    /** 课程类型 */
    courseType: string | undefined;
    /** 创建时间 */
    creationTime: string | undefined;
    /** 支付时间 */
    purchaseTime: string | undefined;
    /** 购买Uin码 */
    uIn: string | undefined;
    /** 用户昵称 */
    nickName: string | undefined;
    /** 交易状态 */
    tradingStatus: string | undefined;
    /** 联系人电话 */
    mobileNumber: string | undefined;
    /** 收件人电话 */
    recipientPhone: string | undefined;
    /** 收件人姓名 */
    recipientName: string | undefined;
    /** 收件人地址 */
    recipientAddress: string | undefined;
    /** 交易类型 */
    tradeType: string | undefined;
    /** 用户支付 */
    usersPay: number;
    /** 平台补贴 */
    platformSubsidies: number;
    /** 退款金额 */
    refundAmount: number;
    /** 实算金额 */
    amountPaid: number;
    /** 结算金额 */
    settlementAmount: number;
    /** 结算比例 */
    settlementRatio: number;
    /** 渠道费用 */
    channelFee: number;
    /** 流量转化服务费 */
    trafficConversionFee: number;
    /** 苹果分成 */
    appleShares: number;
    /** 分销商分成 */
    distributorShare: number;
    /** 结算状态 */
    settlementStatus: string | undefined;
    /** 是否IOS订单 */
    isIosOrder: boolean;
    /** 是否分销订单 */
    isDistributorOrder: boolean;
    /** 订单类型 */
    orderType: string | undefined;
    /** 备注1 */
    remarkOne: string | undefined;
    /** 备注2 */
    remarkTwo: string | undefined;
    /** 备注3 */
    remarkThree: string | undefined;
    /** 是否加入qq群 */
    isQqGroupChecked: boolean;
    /** 码云是否通过 */
    isGiteeChecked: boolean;
    /** 是否同步52abp */
    is52AbpChecked: boolean;
    /** 平台 */
    platform: string | undefined;

    constructor(data?: ITencentOrderInfoEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.orderNumber = _data["orderNumber"];
            this.courseTitle = _data["courseTitle"];
            this.courseType = _data["courseType"];
            this.creationTime = _data["creationTime"];
            this.purchaseTime = _data["purchaseTime"];
            this.uIn = _data["uIn"];
            this.nickName = _data["nickName"];
            this.tradingStatus = _data["tradingStatus"];
            this.mobileNumber = _data["mobileNumber"];
            this.recipientPhone = _data["recipientPhone"];
            this.recipientName = _data["recipientName"];
            this.recipientAddress = _data["recipientAddress"];
            this.tradeType = _data["tradeType"];
            this.usersPay = _data["usersPay"];
            this.platformSubsidies = _data["platformSubsidies"];
            this.refundAmount = _data["refundAmount"];
            this.amountPaid = _data["amountPaid"];
            this.settlementAmount = _data["settlementAmount"];
            this.settlementRatio = _data["settlementRatio"];
            this.channelFee = _data["channelFee"];
            this.trafficConversionFee = _data["trafficConversionFee"];
            this.appleShares = _data["appleShares"];
            this.distributorShare = _data["distributorShare"];
            this.settlementStatus = _data["settlementStatus"];
            this.isIosOrder = _data["isIosOrder"];
            this.isDistributorOrder = _data["isDistributorOrder"];
            this.orderType = _data["orderType"];
            this.remarkOne = _data["remarkOne"];
            this.remarkTwo = _data["remarkTwo"];
            this.remarkThree = _data["remarkThree"];
            this.isQqGroupChecked = _data["isQqGroupChecked"];
            this.isGiteeChecked = _data["isGiteeChecked"];
            this.is52AbpChecked = _data["is52AbpChecked"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): TencentOrderInfoEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TencentOrderInfoEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["orderNumber"] = this.orderNumber;
        data["courseTitle"] = this.courseTitle;
        data["courseType"] = this.courseType;
        data["creationTime"] = this.creationTime;
        data["purchaseTime"] = this.purchaseTime;
        data["uIn"] = this.uIn;
        data["nickName"] = this.nickName;
        data["tradingStatus"] = this.tradingStatus;
        data["mobileNumber"] = this.mobileNumber;
        data["recipientPhone"] = this.recipientPhone;
        data["recipientName"] = this.recipientName;
        data["recipientAddress"] = this.recipientAddress;
        data["tradeType"] = this.tradeType;
        data["usersPay"] = this.usersPay;
        data["platformSubsidies"] = this.platformSubsidies;
        data["refundAmount"] = this.refundAmount;
        data["amountPaid"] = this.amountPaid;
        data["settlementAmount"] = this.settlementAmount;
        data["settlementRatio"] = this.settlementRatio;
        data["channelFee"] = this.channelFee;
        data["trafficConversionFee"] = this.trafficConversionFee;
        data["appleShares"] = this.appleShares;
        data["distributorShare"] = this.distributorShare;
        data["settlementStatus"] = this.settlementStatus;
        data["isIosOrder"] = this.isIosOrder;
        data["isDistributorOrder"] = this.isDistributorOrder;
        data["orderType"] = this.orderType;
        data["remarkOne"] = this.remarkOne;
        data["remarkTwo"] = this.remarkTwo;
        data["remarkThree"] = this.remarkThree;
        data["isQqGroupChecked"] = this.isQqGroupChecked;
        data["isGiteeChecked"] = this.isGiteeChecked;
        data["is52AbpChecked"] = this.is52AbpChecked;
        data["platform"] = this.platform;
        return data;
    }

    clone(): TencentOrderInfoEditDto {
        const json = this.toJSON();
        let result = new TencentOrderInfoEditDto();
        result.init(json);
        return result;
    }
}

export interface ITencentOrderInfoEditDto {
    id: number | undefined;
    /** 机构id */
    organizationId: number;
    /** 订单号 */
    orderNumber: number;
    /** 课程名称 */
    courseTitle: string | undefined;
    /** 课程类型 */
    courseType: string | undefined;
    /** 创建时间 */
    creationTime: string | undefined;
    /** 支付时间 */
    purchaseTime: string | undefined;
    /** 购买Uin码 */
    uIn: string | undefined;
    /** 用户昵称 */
    nickName: string | undefined;
    /** 交易状态 */
    tradingStatus: string | undefined;
    /** 联系人电话 */
    mobileNumber: string | undefined;
    /** 收件人电话 */
    recipientPhone: string | undefined;
    /** 收件人姓名 */
    recipientName: string | undefined;
    /** 收件人地址 */
    recipientAddress: string | undefined;
    /** 交易类型 */
    tradeType: string | undefined;
    /** 用户支付 */
    usersPay: number;
    /** 平台补贴 */
    platformSubsidies: number;
    /** 退款金额 */
    refundAmount: number;
    /** 实算金额 */
    amountPaid: number;
    /** 结算金额 */
    settlementAmount: number;
    /** 结算比例 */
    settlementRatio: number;
    /** 渠道费用 */
    channelFee: number;
    /** 流量转化服务费 */
    trafficConversionFee: number;
    /** 苹果分成 */
    appleShares: number;
    /** 分销商分成 */
    distributorShare: number;
    /** 结算状态 */
    settlementStatus: string | undefined;
    /** 是否IOS订单 */
    isIosOrder: boolean;
    /** 是否分销订单 */
    isDistributorOrder: boolean;
    /** 订单类型 */
    orderType: string | undefined;
    /** 备注1 */
    remarkOne: string | undefined;
    /** 备注2 */
    remarkTwo: string | undefined;
    /** 备注3 */
    remarkThree: string | undefined;
    /** 是否加入qq群 */
    isQqGroupChecked: boolean;
    /** 码云是否通过 */
    isGiteeChecked: boolean;
    /** 是否同步52abp */
    is52AbpChecked: boolean;
    /** 平台 */
    platform: string | undefined;
}

export class CreateOrUpdateTencentOrderInfoInput implements ICreateOrUpdateTencentOrderInfoInput {
    tencentOrderInfo: TencentOrderInfoEditDto;

    constructor(data?: ICreateOrUpdateTencentOrderInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tencentOrderInfo = new TencentOrderInfoEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tencentOrderInfo = _data["tencentOrderInfo"] ? TencentOrderInfoEditDto.fromJS(_data["tencentOrderInfo"]) : new TencentOrderInfoEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTencentOrderInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTencentOrderInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tencentOrderInfo"] = this.tencentOrderInfo ? this.tencentOrderInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTencentOrderInfoInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTencentOrderInfoInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTencentOrderInfoInput {
    tencentOrderInfo: TencentOrderInfoEditDto;
}

export class TencentOrderInfoListDto implements ITencentOrderInfoListDto {
    /** 机构id */
    organizationId: number;
    /** 订单号 */
    orderNumber: number;
    /** 课程名称 */
    courseTitle: string | undefined;
    /** 课程类型 */
    courseType: string | undefined;
    /** 创建时间 */
    creationTime: string | undefined;
    /** 支付时间 */
    purchaseTime: string | undefined;
    /** 购买Uin码 */
    uIn: string | undefined;
    /** 用户昵称 */
    nickName: string | undefined;
    /** 交易状态 */
    tradingStatus: string | undefined;
    /** 联系人电话 */
    mobileNumber: string | undefined;
    /** 收件人电话 */
    recipientPhone: string | undefined;
    /** 收件人姓名 */
    recipientName: string | undefined;
    /** 收件人地址 */
    recipientAddress: string | undefined;
    /** 交易类型 */
    tradeType: string | undefined;
    /** 用户支付 */
    usersPay: number;
    /** 平台补贴 */
    platformSubsidies: number;
    /** 退款金额 */
    refundAmount: number;
    /** 实算金额 */
    amountPaid: number;
    /** 结算金额 */
    settlementAmount: number;
    /** 结算比例 */
    settlementRatio: number;
    /** 渠道费用 */
    channelFee: number;
    /** 流量转化服务费 */
    trafficConversionFee: number;
    /** 苹果分成 */
    appleShares: number;
    /** 分销商分成 */
    distributorShare: number;
    /** 结算状态 */
    settlementStatus: string | undefined;
    /** 是否IOS订单 */
    isIosOrder: boolean;
    /** 是否分销订单 */
    isDistributorOrder: boolean;
    /** 订单类型 */
    orderType: string | undefined;
    /** 备注1 */
    remarkOne: string | undefined;
    /** 备注2 */
    remarkTwo: string | undefined;
    /** 备注3 */
    remarkThree: string | undefined;
    /** 是否加入qq群 */
    isQqGroupChecked: boolean;
    /** 码云是否通过 */
    isGiteeChecked: boolean;
    /** 是否同步52abp */
    is52AbpChecked: boolean;
    /** 平台 */
    platform: string | undefined;
    id: number;

    constructor(data?: ITencentOrderInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.orderNumber = _data["orderNumber"];
            this.courseTitle = _data["courseTitle"];
            this.courseType = _data["courseType"];
            this.creationTime = _data["creationTime"];
            this.purchaseTime = _data["purchaseTime"];
            this.uIn = _data["uIn"];
            this.nickName = _data["nickName"];
            this.tradingStatus = _data["tradingStatus"];
            this.mobileNumber = _data["mobileNumber"];
            this.recipientPhone = _data["recipientPhone"];
            this.recipientName = _data["recipientName"];
            this.recipientAddress = _data["recipientAddress"];
            this.tradeType = _data["tradeType"];
            this.usersPay = _data["usersPay"];
            this.platformSubsidies = _data["platformSubsidies"];
            this.refundAmount = _data["refundAmount"];
            this.amountPaid = _data["amountPaid"];
            this.settlementAmount = _data["settlementAmount"];
            this.settlementRatio = _data["settlementRatio"];
            this.channelFee = _data["channelFee"];
            this.trafficConversionFee = _data["trafficConversionFee"];
            this.appleShares = _data["appleShares"];
            this.distributorShare = _data["distributorShare"];
            this.settlementStatus = _data["settlementStatus"];
            this.isIosOrder = _data["isIosOrder"];
            this.isDistributorOrder = _data["isDistributorOrder"];
            this.orderType = _data["orderType"];
            this.remarkOne = _data["remarkOne"];
            this.remarkTwo = _data["remarkTwo"];
            this.remarkThree = _data["remarkThree"];
            this.isQqGroupChecked = _data["isQqGroupChecked"];
            this.isGiteeChecked = _data["isGiteeChecked"];
            this.is52AbpChecked = _data["is52AbpChecked"];
            this.platform = _data["platform"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TencentOrderInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TencentOrderInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["orderNumber"] = this.orderNumber;
        data["courseTitle"] = this.courseTitle;
        data["courseType"] = this.courseType;
        data["creationTime"] = this.creationTime;
        data["purchaseTime"] = this.purchaseTime;
        data["uIn"] = this.uIn;
        data["nickName"] = this.nickName;
        data["tradingStatus"] = this.tradingStatus;
        data["mobileNumber"] = this.mobileNumber;
        data["recipientPhone"] = this.recipientPhone;
        data["recipientName"] = this.recipientName;
        data["recipientAddress"] = this.recipientAddress;
        data["tradeType"] = this.tradeType;
        data["usersPay"] = this.usersPay;
        data["platformSubsidies"] = this.platformSubsidies;
        data["refundAmount"] = this.refundAmount;
        data["amountPaid"] = this.amountPaid;
        data["settlementAmount"] = this.settlementAmount;
        data["settlementRatio"] = this.settlementRatio;
        data["channelFee"] = this.channelFee;
        data["trafficConversionFee"] = this.trafficConversionFee;
        data["appleShares"] = this.appleShares;
        data["distributorShare"] = this.distributorShare;
        data["settlementStatus"] = this.settlementStatus;
        data["isIosOrder"] = this.isIosOrder;
        data["isDistributorOrder"] = this.isDistributorOrder;
        data["orderType"] = this.orderType;
        data["remarkOne"] = this.remarkOne;
        data["remarkTwo"] = this.remarkTwo;
        data["remarkThree"] = this.remarkThree;
        data["isQqGroupChecked"] = this.isQqGroupChecked;
        data["isGiteeChecked"] = this.isGiteeChecked;
        data["is52AbpChecked"] = this.is52AbpChecked;
        data["platform"] = this.platform;
        data["id"] = this.id;
        return data;
    }

    clone(): TencentOrderInfoListDto {
        const json = this.toJSON();
        let result = new TencentOrderInfoListDto();
        result.init(json);
        return result;
    }
}

export interface ITencentOrderInfoListDto {
    /** 机构id */
    organizationId: number;
    /** 订单号 */
    orderNumber: number;
    /** 课程名称 */
    courseTitle: string | undefined;
    /** 课程类型 */
    courseType: string | undefined;
    /** 创建时间 */
    creationTime: string | undefined;
    /** 支付时间 */
    purchaseTime: string | undefined;
    /** 购买Uin码 */
    uIn: string | undefined;
    /** 用户昵称 */
    nickName: string | undefined;
    /** 交易状态 */
    tradingStatus: string | undefined;
    /** 联系人电话 */
    mobileNumber: string | undefined;
    /** 收件人电话 */
    recipientPhone: string | undefined;
    /** 收件人姓名 */
    recipientName: string | undefined;
    /** 收件人地址 */
    recipientAddress: string | undefined;
    /** 交易类型 */
    tradeType: string | undefined;
    /** 用户支付 */
    usersPay: number;
    /** 平台补贴 */
    platformSubsidies: number;
    /** 退款金额 */
    refundAmount: number;
    /** 实算金额 */
    amountPaid: number;
    /** 结算金额 */
    settlementAmount: number;
    /** 结算比例 */
    settlementRatio: number;
    /** 渠道费用 */
    channelFee: number;
    /** 流量转化服务费 */
    trafficConversionFee: number;
    /** 苹果分成 */
    appleShares: number;
    /** 分销商分成 */
    distributorShare: number;
    /** 结算状态 */
    settlementStatus: string | undefined;
    /** 是否IOS订单 */
    isIosOrder: boolean;
    /** 是否分销订单 */
    isDistributorOrder: boolean;
    /** 订单类型 */
    orderType: string | undefined;
    /** 备注1 */
    remarkOne: string | undefined;
    /** 备注2 */
    remarkTwo: string | undefined;
    /** 备注3 */
    remarkThree: string | undefined;
    /** 是否加入qq群 */
    isQqGroupChecked: boolean;
    /** 码云是否通过 */
    isGiteeChecked: boolean;
    /** 是否同步52abp */
    is52AbpChecked: boolean;
    /** 平台 */
    platform: string | undefined;
    id: number;
}

export class GetTencentOrderInfoForEditOutput implements IGetTencentOrderInfoForEditOutput {
    tencentOrderInfo: TencentOrderInfoEditDto;

    constructor(data?: IGetTencentOrderInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tencentOrderInfo = _data["tencentOrderInfo"] ? TencentOrderInfoEditDto.fromJS(_data["tencentOrderInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTencentOrderInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTencentOrderInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tencentOrderInfo"] = this.tencentOrderInfo ? this.tencentOrderInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetTencentOrderInfoForEditOutput {
        const json = this.toJSON();
        let result = new GetTencentOrderInfoForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetTencentOrderInfoForEditOutput {
    tencentOrderInfo: TencentOrderInfoEditDto;
}

export class PagedResultDtoOfTencentOrderInfoListDto implements IPagedResultDtoOfTencentOrderInfoListDto {
    totalCount: number;
    items: TencentOrderInfoListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTencentOrderInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TencentOrderInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTencentOrderInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTencentOrderInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTencentOrderInfoListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTencentOrderInfoListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTencentOrderInfoListDto {
    totalCount: number;
    items: TencentOrderInfoListDto[] | undefined;
}

export class TextMessageEditDto implements ITextMessageEditDto {
    id: number | undefined;
    /** 个推类型 */
    type: string | undefined;
    /** 跳转url */
    jumpUrl: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;

    constructor(data?: ITextMessageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.jumpUrl = _data["jumpUrl"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): TextMessageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["jumpUrl"] = this.jumpUrl;
        data["title"] = this.title;
        data["description"] = this.description;
        data["enable"] = this.enable;
        return data;
    }

    clone(): TextMessageEditDto {
        const json = this.toJSON();
        let result = new TextMessageEditDto();
        result.init(json);
        return result;
    }
}

export interface ITextMessageEditDto {
    id: number | undefined;
    /** 个推类型 */
    type: string | undefined;
    /** 跳转url */
    jumpUrl: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;
}

/** LPA消息推送模型 */
export class TextMessageListDto implements ITextMessageListDto {
    /** Id */
    id: number;
    /** 个推类型 */
    type: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;

    constructor(data?: ITextMessageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.enable = _data["enable"];
        }
    }

    static fromJS(data: any): TextMessageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["enable"] = this.enable;
        return data;
    }

    clone(): TextMessageListDto {
        const json = this.toJSON();
        let result = new TextMessageListDto();
        result.init(json);
        return result;
    }
}

/** LPA消息推送模型 */
export interface ITextMessageListDto {
    /** Id */
    id: number;
    /** 个推类型 */
    type: string | undefined;
    /** 通知栏标题 */
    title: string | undefined;
    /** 通知栏内容 */
    description: string | undefined;
    /** 是否启用 */
    enable: boolean;
}

export class PagedResultDtoOfTextMessageListDto implements IPagedResultDtoOfTextMessageListDto {
    totalCount: number;
    items: TextMessageListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTextMessageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TextMessageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTextMessageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTextMessageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfTextMessageListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTextMessageListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTextMessageListDto {
    totalCount: number;
    items: TextMessageListDto[] | undefined;
}

export enum SettingScopes {
    Application = <any>"Application",
    Tenant = <any>"Tenant",
    User = <any>"User",
    All = <any>"All",
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfNameValueDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfNameValueDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

/** Dto */
export class UpLoadFileDto implements IUpLoadFileDto {
    /** 上传后服务端的uuid名字 */
    uuidName: string | undefined;
    /** 文件的真实名字 */
    fileName: string | undefined;
    /** 文件路径 */
    fileUrl: string | undefined;

    constructor(data?: IUpLoadFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuidName = _data["uuidName"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): UpLoadFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpLoadFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuidName"] = this.uuidName;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        return data;
    }

    clone(): UpLoadFileDto {
        const json = this.toJSON();
        let result = new UpLoadFileDto();
        result.init(json);
        return result;
    }
}

/** Dto */
export interface IUpLoadFileDto {
    /** 上传后服务端的uuid名字 */
    uuidName: string | undefined;
    /** 文件的真实名字 */
    fileName: string | undefined;
    /** 文件路径 */
    fileUrl: string | undefined;
}

/** dto */
export class ReturnListDto implements IReturnListDto {
    /** 文件的Guid */
    fileGuid: string | undefined;
    /** 文件路径 */
    fileUrl: string | undefined;

    constructor(data?: IReturnListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileGuid = _data["fileGuid"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): ReturnListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileGuid"] = this.fileGuid;
        data["fileUrl"] = this.fileUrl;
        return data;
    }

    clone(): ReturnListDto {
        const json = this.toJSON();
        let result = new ReturnListDto();
        result.init(json);
        return result;
    }
}

/** dto */
export interface IReturnListDto {
    /** 文件的Guid */
    fileGuid: string | undefined;
    /** 文件路径 */
    fileUrl: string | undefined;
}

/** 用户信息新增和编辑时用Dto */
export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto;
    /** 授权的角色 */
    assignedRoleNames: string[];

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        return data;
    }

    clone(): CreateOrUpdateUserInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateUserInput();
        result.init(json);
        return result;
    }
}

/** 用户信息新增和编辑时用Dto */
export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    /** 授权的角色 */
    assignedRoleNames: string[];
}

export class BirthdayWishToUserListDto implements IBirthdayWishToUserListDto {
    id: number;
    /** 姓名 */
    realName: string | undefined;
    /** 部门 */
    depantment: string | undefined;
    /** 职位 */
    post: string | undefined;
    /** 员工类型 */
    staffTypeCode: string | undefined;
    staffTypeName: string | undefined;
    /** 生日 */
    birthday: moment.Moment | undefined;
    /** 入职时间 */
    hireDate: moment.Moment | undefined;

    constructor(data?: IBirthdayWishToUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.realName = _data["realName"];
            this.depantment = _data["depantment"];
            this.post = _data["post"];
            this.staffTypeCode = _data["staffTypeCode"];
            this.staffTypeName = _data["staffTypeName"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BirthdayWishToUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayWishToUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["realName"] = this.realName;
        data["depantment"] = this.depantment;
        data["post"] = this.post;
        data["staffTypeCode"] = this.staffTypeCode;
        data["staffTypeName"] = this.staffTypeName;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): BirthdayWishToUserListDto {
        const json = this.toJSON();
        let result = new BirthdayWishToUserListDto();
        result.init(json);
        return result;
    }
}

export interface IBirthdayWishToUserListDto {
    id: number;
    /** 姓名 */
    realName: string | undefined;
    /** 部门 */
    depantment: string | undefined;
    /** 职位 */
    post: string | undefined;
    /** 员工类型 */
    staffTypeCode: string | undefined;
    staffTypeName: string | undefined;
    /** 生日 */
    birthday: moment.Moment | undefined;
    /** 入职时间 */
    hireDate: moment.Moment | undefined;
}

export class PagedResultDtoOfBirthdayWishToUserListDto implements IPagedResultDtoOfBirthdayWishToUserListDto {
    totalCount: number;
    items: BirthdayWishToUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBirthdayWishToUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BirthdayWishToUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBirthdayWishToUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBirthdayWishToUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfBirthdayWishToUserListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBirthdayWishToUserListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBirthdayWishToUserListDto {
    totalCount: number;
    items: BirthdayWishToUserListDto[] | undefined;
}

export class GetUserForEditTreeOutput implements IGetUserForEditTreeOutput {
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;

    constructor(data?: IGetUserForEditTreeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForEditTreeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditTreeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUserForEditTreeOutput {
        const json = this.toJSON();
        let result = new GetUserForEditTreeOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserForEditTreeOutput {
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class GetUserPermissionsTreeForEditOutput implements IGetUserPermissionsTreeForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetUserPermissionsTreeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsTreeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsTreeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetUserPermissionsTreeForEditOutput {
        const json = this.toJSON();
        let result = new GetUserPermissionsTreeForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserPermissionsTreeForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class ArchiverDto implements IArchiverDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 岗位等级 */
    orgPostGrade: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 劳务公司 */
    personalService: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** 身份证有效期 */
    identityValidity: moment.Moment | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 性别 */
    gender: string | undefined;
    /** 民族 */
    nation: string | undefined;
    /** 点至邮箱 */
    eamil: string | undefined;
    /** 婚姻状况 */
    maritalStatus: string | undefined;
    /** 常用地址邮编 */
    postalCode: string | undefined;
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 常住地址 */
    presentAddress: string | undefined;
    /** 最早入职时间 */
    firstHireDate: moment.Moment | undefined;
    /** 政治面貌 */
    politicsStatus: string | undefined;
    /** 招聘来源 */
    recruitmentSource: string | undefined;
    /** 户口性质 */
    residenceType: string | undefined;
    /** 户籍地址 */
    identityAddress: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 生日-------------------新增 */
    birthday: string | undefined;

    constructor(data?: IArchiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.companyName = _data["companyName"];
            this.postName = _data["postName"];
            this.orgPostGrade = _data["orgPostGrade"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.personalService = _data["personalService"];
            this.identityCard = _data["identityCard"];
            this.identityValidity = _data["identityValidity"] ? moment(_data["identityValidity"].toString()) : <any>undefined;
            this.mobile = _data["mobile"];
            this.gender = _data["gender"];
            this.nation = _data["nation"];
            this.eamil = _data["eamil"];
            this.maritalStatus = _data["maritalStatus"];
            this.postalCode = _data["postalCode"];
            this.nativePlace = _data["nativePlace"];
            this.presentAddress = _data["presentAddress"];
            this.firstHireDate = _data["firstHireDate"] ? moment(_data["firstHireDate"].toString()) : <any>undefined;
            this.politicsStatus = _data["politicsStatus"];
            this.recruitmentSource = _data["recruitmentSource"];
            this.residenceType = _data["residenceType"];
            this.identityAddress = _data["identityAddress"];
            this.idPhoto = _data["idPhoto"];
            this.userPictureType = _data["userPictureType"];
            this.birthday = _data["birthday"];
        }
    }

    static fromJS(data: any): ArchiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["companyName"] = this.companyName;
        data["postName"] = this.postName;
        data["orgPostGrade"] = this.orgPostGrade;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["personalService"] = this.personalService;
        data["identityCard"] = this.identityCard;
        data["identityValidity"] = this.identityValidity ? this.identityValidity.toISOString() : <any>undefined;
        data["mobile"] = this.mobile;
        data["gender"] = this.gender;
        data["nation"] = this.nation;
        data["eamil"] = this.eamil;
        data["maritalStatus"] = this.maritalStatus;
        data["postalCode"] = this.postalCode;
        data["nativePlace"] = this.nativePlace;
        data["presentAddress"] = this.presentAddress;
        data["firstHireDate"] = this.firstHireDate ? this.firstHireDate.toISOString() : <any>undefined;
        data["politicsStatus"] = this.politicsStatus;
        data["recruitmentSource"] = this.recruitmentSource;
        data["residenceType"] = this.residenceType;
        data["identityAddress"] = this.identityAddress;
        data["idPhoto"] = this.idPhoto;
        data["userPictureType"] = this.userPictureType;
        data["birthday"] = this.birthday;
        return data;
    }

    clone(): ArchiverDto {
        const json = this.toJSON();
        let result = new ArchiverDto();
        result.init(json);
        return result;
    }
}

export interface IArchiverDto {
    /** 工号 */
    jobNumber: string | undefined;
    /** 姓名 */
    realName: string | undefined;
    /** 公司名称 */
    companyName: string | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** 岗位等级 */
    orgPostGrade: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 劳务公司 */
    personalService: string | undefined;
    /** 身份证号 */
    identityCard: string | undefined;
    /** 身份证有效期 */
    identityValidity: moment.Moment | undefined;
    /** 手机号 */
    mobile: string | undefined;
    /** 性别 */
    gender: string | undefined;
    /** 民族 */
    nation: string | undefined;
    /** 点至邮箱 */
    eamil: string | undefined;
    /** 婚姻状况 */
    maritalStatus: string | undefined;
    /** 常用地址邮编 */
    postalCode: string | undefined;
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 常住地址 */
    presentAddress: string | undefined;
    /** 最早入职时间 */
    firstHireDate: moment.Moment | undefined;
    /** 政治面貌 */
    politicsStatus: string | undefined;
    /** 招聘来源 */
    recruitmentSource: string | undefined;
    /** 户口性质 */
    residenceType: string | undefined;
    /** 户籍地址 */
    identityAddress: string | undefined;
    /** 证件照 */
    idPhoto: string | undefined;
    /** 头像类型------------------新增 */
    userPictureType: string | undefined;
    /** 生日-------------------新增 */
    birthday: string | undefined;
}

/** 工作经验的列表DTO QYB.QYBProduct.Organization.WorkExperience.WorkExperience */
export class WorkExperienceListDto implements IWorkExperienceListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 所在公司 */
    companyName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 开始日期 */
    startDate: moment.Moment | undefined;
    /** 结束日期 */
    endDate: moment.Moment | undefined;
    /** 薪资 */
    salary: number | undefined;
    /** 证明人 */
    certificateEmpl: string | undefined;
    /** 证明人电话 */
    certificateEmplTel: string | undefined;
    /** 离职原因 */
    leaveJobReason: string | undefined;
    /** 工作内容 */
    workDesc: string | undefined;
    id: number;

    constructor(data?: IWorkExperienceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.emp = _data["emp"] ? Employee.fromJS(_data["emp"]) : <any>undefined;
            this.companyName = _data["companyName"];
            this.postName = _data["postName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.salary = _data["salary"];
            this.certificateEmpl = _data["certificateEmpl"];
            this.certificateEmplTel = _data["certificateEmplTel"];
            this.leaveJobReason = _data["leaveJobReason"];
            this.workDesc = _data["workDesc"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkExperienceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkExperienceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["emp"] = this.emp ? this.emp.toJSON() : <any>undefined;
        data["companyName"] = this.companyName;
        data["postName"] = this.postName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["salary"] = this.salary;
        data["certificateEmpl"] = this.certificateEmpl;
        data["certificateEmplTel"] = this.certificateEmplTel;
        data["leaveJobReason"] = this.leaveJobReason;
        data["workDesc"] = this.workDesc;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkExperienceListDto {
        const json = this.toJSON();
        let result = new WorkExperienceListDto();
        result.init(json);
        return result;
    }
}

/** 工作经验的列表DTO QYB.QYBProduct.Organization.WorkExperience.WorkExperience */
export interface IWorkExperienceListDto {
    /** 用户 */
    empId: number | undefined;
    emp: Employee;
    /** 所在公司 */
    companyName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 开始日期 */
    startDate: moment.Moment | undefined;
    /** 结束日期 */
    endDate: moment.Moment | undefined;
    /** 薪资 */
    salary: number | undefined;
    /** 证明人 */
    certificateEmpl: string | undefined;
    /** 证明人电话 */
    certificateEmplTel: string | undefined;
    /** 离职原因 */
    leaveJobReason: string | undefined;
    /** 工作内容 */
    workDesc: string | undefined;
    id: number;
}

/** 用户档案实体 */
export class UserArchiverDto implements IUserArchiverDto {
    user: ArchiverDto;
    /** 合同信息列表 */
    personnelContracts: PersonnelContractsListDto[] | undefined;
    /** 社会关系列表 */
    socialRelation: SocialRelationListDto[] | undefined;
    /** 工作经验列表 */
    workExperience: WorkExperienceListDto[] | undefined;
    /** 教育背景列表 */
    educationBackground: EducationBackgroundListDto[] | undefined;
    /** 证书信息列表 */
    skillInfo: SkillInfoListDto[] | undefined;

    constructor(data?: IUserArchiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? ArchiverDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["personnelContracts"])) {
                this.personnelContracts = [] as any;
                for (let item of _data["personnelContracts"])
                    this.personnelContracts.push(PersonnelContractsListDto.fromJS(item));
            }
            if (Array.isArray(_data["socialRelation"])) {
                this.socialRelation = [] as any;
                for (let item of _data["socialRelation"])
                    this.socialRelation.push(SocialRelationListDto.fromJS(item));
            }
            if (Array.isArray(_data["workExperience"])) {
                this.workExperience = [] as any;
                for (let item of _data["workExperience"])
                    this.workExperience.push(WorkExperienceListDto.fromJS(item));
            }
            if (Array.isArray(_data["educationBackground"])) {
                this.educationBackground = [] as any;
                for (let item of _data["educationBackground"])
                    this.educationBackground.push(EducationBackgroundListDto.fromJS(item));
            }
            if (Array.isArray(_data["skillInfo"])) {
                this.skillInfo = [] as any;
                for (let item of _data["skillInfo"])
                    this.skillInfo.push(SkillInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserArchiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserArchiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.personnelContracts)) {
            data["personnelContracts"] = [];
            for (let item of this.personnelContracts)
                data["personnelContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.socialRelation)) {
            data["socialRelation"] = [];
            for (let item of this.socialRelation)
                data["socialRelation"].push(item.toJSON());
        }
        if (Array.isArray(this.workExperience)) {
            data["workExperience"] = [];
            for (let item of this.workExperience)
                data["workExperience"].push(item.toJSON());
        }
        if (Array.isArray(this.educationBackground)) {
            data["educationBackground"] = [];
            for (let item of this.educationBackground)
                data["educationBackground"].push(item.toJSON());
        }
        if (Array.isArray(this.skillInfo)) {
            data["skillInfo"] = [];
            for (let item of this.skillInfo)
                data["skillInfo"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserArchiverDto {
        const json = this.toJSON();
        let result = new UserArchiverDto();
        result.init(json);
        return result;
    }
}

/** 用户档案实体 */
export interface IUserArchiverDto {
    user: ArchiverDto;
    /** 合同信息列表 */
    personnelContracts: PersonnelContractsListDto[] | undefined;
    /** 社会关系列表 */
    socialRelation: SocialRelationListDto[] | undefined;
    /** 工作经验列表 */
    workExperience: WorkExperienceListDto[] | undefined;
    /** 教育背景列表 */
    educationBackground: EducationBackgroundListDto[] | undefined;
    /** 证书信息列表 */
    skillInfo: SkillInfoListDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUserForEditOutput {
        const json = this.toJSON();
        let result = new GetUserForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    /** 所有的权限 */
    permissions: FlatPermissionDto[] | undefined;
    /** 已有权限 */
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetUserPermissionsForEditOutput {
        const json = this.toJSON();
        let result = new GetUserPermissionsForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserPermissionsForEditOutput {
    /** 所有的权限 */
    permissions: FlatPermissionDto[] | undefined;
    /** 已有权限 */
    grantedPermissionNames: string[] | undefined;
}

export class SendWeComNotificationInput implements ISendWeComNotificationInput {
    userIds: number[] | undefined;
    content: string | undefined;

    constructor(data?: ISendWeComNotificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SendWeComNotificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendWeComNotificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["content"] = this.content;
        return data;
    }

    clone(): SendWeComNotificationInput {
        const json = this.toJSON();
        let result = new SendWeComNotificationInput();
        result.init(json);
        return result;
    }
}

export interface ISendWeComNotificationInput {
    userIds: number[] | undefined;
    content: string | undefined;
}

export class SendWeComNotificationResultItem implements ISendWeComNotificationResultItem {
    userId: number;
    userName: string | undefined;
    realName: string | undefined;
    weComUserId: string | undefined;
    success: boolean;
    errorMessage: string | undefined;

    constructor(data?: ISendWeComNotificationResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.realName = _data["realName"];
            this.weComUserId = _data["weComUserId"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SendWeComNotificationResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new SendWeComNotificationResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["realName"] = this.realName;
        data["weComUserId"] = this.weComUserId;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }

    clone(): SendWeComNotificationResultItem {
        const json = this.toJSON();
        let result = new SendWeComNotificationResultItem();
        result.init(json);
        return result;
    }
}

export interface ISendWeComNotificationResultItem {
    userId: number;
    userName: string | undefined;
    realName: string | undefined;
    weComUserId: string | undefined;
    success: boolean;
    errorMessage: string | undefined;
}

export class SendWeComNotificationOutput implements ISendWeComNotificationOutput {
    totalUsers: number;
    successCount: number;
    failedCount: number;
    details: SendWeComNotificationResultItem[] | undefined;

    constructor(data?: ISendWeComNotificationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUsers = _data["totalUsers"];
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details.push(SendWeComNotificationResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendWeComNotificationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SendWeComNotificationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUsers"] = this.totalUsers;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }

    clone(): SendWeComNotificationOutput {
        const json = this.toJSON();
        let result = new SendWeComNotificationOutput();
        result.init(json);
        return result;
    }
}

export interface ISendWeComNotificationOutput {
    totalUsers: number;
    successCount: number;
    failedCount: number;
    details: SendWeComNotificationResultItem[] | undefined;
}

export class SyncWeComUsersOutput implements ISyncWeComUsersOutput {
    totalWeComUsers: number;
    matchedUsers: number;
    updatedUsers: number;
    createdUsers: number;
    skippedAlreadyBound: number;
    skippedNoMatch: number;
    skippedAmbiguous: number;

    constructor(data?: ISyncWeComUsersOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWeComUsers = _data["totalWeComUsers"];
            this.matchedUsers = _data["matchedUsers"];
            this.updatedUsers = _data["updatedUsers"];
            this.createdUsers = _data["createdUsers"];
            this.skippedAlreadyBound = _data["skippedAlreadyBound"];
            this.skippedNoMatch = _data["skippedNoMatch"];
            this.skippedAmbiguous = _data["skippedAmbiguous"];
        }
    }

    static fromJS(data: any): SyncWeComUsersOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SyncWeComUsersOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWeComUsers"] = this.totalWeComUsers;
        data["matchedUsers"] = this.matchedUsers;
        data["updatedUsers"] = this.updatedUsers;
        data["createdUsers"] = this.createdUsers;
        data["skippedAlreadyBound"] = this.skippedAlreadyBound;
        data["skippedNoMatch"] = this.skippedNoMatch;
        data["skippedAmbiguous"] = this.skippedAmbiguous;
        return data;
    }

    clone(): SyncWeComUsersOutput {
        const json = this.toJSON();
        let result = new SyncWeComUsersOutput();
        result.init(json);
        return result;
    }
}

export interface ISyncWeComUsersOutput {
    totalWeComUsers: number;
    matchedUsers: number;
    updatedUsers: number;
    createdUsers: number;
    skippedAlreadyBound: number;
    skippedNoMatch: number;
    skippedAmbiguous: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): UpdateUserPermissionsInput {
        const json = this.toJSON();
        let result = new UpdateUserPermissionsInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

/** 的列表DTO QYB.QYBProduct.HR.UserChangeLog.UserChangeLog */
export class UserChangeLogEditDto implements IUserChangeLogEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    empId: number;
    /** Type */
    type: number;
    /** Description */
    description: string | undefined;
    /** EntryDate */
    entryDate: moment.Moment | undefined;
    /** DepartmentId */
    departmentId: number | undefined;
    /** PostId */
    postId: number | undefined;
    /** UserType */
    userType: string | undefined;
    /** UserStatus */
    userStatus: string | undefined;
    /** PostGradeId */
    postGradeId: number | undefined;
    /** CorrectionDate */
    correctionDate: moment.Moment | undefined;
    /** CorrectionDepId */
    correctionDepId: number | undefined;
    /** CorrectionPostId */
    correctionPostId: number | undefined;
    /** CorrectionGradeId */
    correctionGradeId: number | undefined;
    /** TransferDate */
    transferDate: moment.Moment | undefined;
    /** OldDepId */
    oldDepId: number | undefined;
    /** OldPostId */
    oldPostId: number | undefined;
    /** NewDepId */
    newDepId: number | undefined;
    /** NewPostId */
    newPostId: number | undefined;
    /** ResignDate */
    resignDate: moment.Moment | undefined;
    /** ResignDEpId */
    resignDEpId: number | undefined;
    /** ResignPostId */
    resignPostId: number | undefined;
    /** ResignReason */
    resignReason: number | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;

    constructor(data?: IUserChangeLogEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.postId = _data["postId"];
            this.userType = _data["userType"];
            this.userStatus = _data["userStatus"];
            this.postGradeId = _data["postGradeId"];
            this.correctionDate = _data["correctionDate"] ? moment(_data["correctionDate"].toString()) : <any>undefined;
            this.correctionDepId = _data["correctionDepId"];
            this.correctionPostId = _data["correctionPostId"];
            this.correctionGradeId = _data["correctionGradeId"];
            this.transferDate = _data["transferDate"] ? moment(_data["transferDate"].toString()) : <any>undefined;
            this.oldDepId = _data["oldDepId"];
            this.oldPostId = _data["oldPostId"];
            this.newDepId = _data["newDepId"];
            this.newPostId = _data["newPostId"];
            this.resignDate = _data["resignDate"] ? moment(_data["resignDate"].toString()) : <any>undefined;
            this.resignDEpId = _data["resignDEpId"];
            this.resignPostId = _data["resignPostId"];
            this.resignReason = _data["resignReason"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserChangeLogEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserChangeLogEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["type"] = this.type;
        data["description"] = this.description;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["postId"] = this.postId;
        data["userType"] = this.userType;
        data["userStatus"] = this.userStatus;
        data["postGradeId"] = this.postGradeId;
        data["correctionDate"] = this.correctionDate ? this.correctionDate.toISOString() : <any>undefined;
        data["correctionDepId"] = this.correctionDepId;
        data["correctionPostId"] = this.correctionPostId;
        data["correctionGradeId"] = this.correctionGradeId;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["oldDepId"] = this.oldDepId;
        data["oldPostId"] = this.oldPostId;
        data["newDepId"] = this.newDepId;
        data["newPostId"] = this.newPostId;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["resignDEpId"] = this.resignDEpId;
        data["resignPostId"] = this.resignPostId;
        data["resignReason"] = this.resignReason;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): UserChangeLogEditDto {
        const json = this.toJSON();
        let result = new UserChangeLogEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.HR.UserChangeLog.UserChangeLog */
export interface IUserChangeLogEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    empId: number;
    /** Type */
    type: number;
    /** Description */
    description: string | undefined;
    /** EntryDate */
    entryDate: moment.Moment | undefined;
    /** DepartmentId */
    departmentId: number | undefined;
    /** PostId */
    postId: number | undefined;
    /** UserType */
    userType: string | undefined;
    /** UserStatus */
    userStatus: string | undefined;
    /** PostGradeId */
    postGradeId: number | undefined;
    /** CorrectionDate */
    correctionDate: moment.Moment | undefined;
    /** CorrectionDepId */
    correctionDepId: number | undefined;
    /** CorrectionPostId */
    correctionPostId: number | undefined;
    /** CorrectionGradeId */
    correctionGradeId: number | undefined;
    /** TransferDate */
    transferDate: moment.Moment | undefined;
    /** OldDepId */
    oldDepId: number | undefined;
    /** OldPostId */
    oldPostId: number | undefined;
    /** NewDepId */
    newDepId: number | undefined;
    /** NewPostId */
    newPostId: number | undefined;
    /** ResignDate */
    resignDate: moment.Moment | undefined;
    /** ResignDEpId */
    resignDEpId: number | undefined;
    /** ResignPostId */
    resignPostId: number | undefined;
    /** ResignReason */
    resignReason: number | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
}

export class CreateOrUpdateUserChangeLogInput implements ICreateOrUpdateUserChangeLogInput {
    userChangeLog: UserChangeLogEditDto;

    constructor(data?: ICreateOrUpdateUserChangeLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userChangeLog = new UserChangeLogEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userChangeLog = _data["userChangeLog"] ? UserChangeLogEditDto.fromJS(_data["userChangeLog"]) : new UserChangeLogEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateUserChangeLogInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserChangeLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userChangeLog"] = this.userChangeLog ? this.userChangeLog.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateUserChangeLogInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateUserChangeLogInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateUserChangeLogInput {
    userChangeLog: UserChangeLogEditDto;
}

/** 的列表DTO QYB.QYBProduct.HR.UserChangeLog.UserChangeLog */
export class UserChangeLogListDto implements IUserChangeLogListDto {
    /** UserId */
    empId: number;
    /** 用户名称 */
    userName: string | undefined;
    /** Type */
    type: number;
    /** 图片 */
    image: string | undefined;
    /** Description */
    description: string | undefined;
    /** EntryDate */
    entryDate: moment.Moment | undefined;
    /** DepartmentId */
    departmentId: number | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** PostId */
    postId: number | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** UserType */
    userType: string | undefined;
    /** 员工类型名称 */
    userTypeName: string | undefined;
    /** UserStatus */
    userStatus: string | undefined;
    /** 员工状态名称 */
    userStatusName: string | undefined;
    /** PostGradeId */
    postGradeId: number | undefined;
    /** 岗位等级名称 */
    postGradeName: string | undefined;
    /** CorrectionDate */
    correctionDate: moment.Moment | undefined;
    /** CorrectionDepId */
    correctionDepId: number | undefined;
    /** 转正时部门 */
    correctionDepName: string | undefined;
    /** CorrectionPostId */
    correctionPostId: number | undefined;
    /** 转正时岗位 */
    correctionPostName: string | undefined;
    /** CorrectionGradeId */
    correctionGradeId: number | undefined;
    /** 转正时职等 */
    correctionGradeName: string | undefined;
    /** TransferDate */
    transferDate: moment.Moment | undefined;
    /** OldDepId */
    oldDepId: number | undefined;
    /** 调岗前部门 */
    oldDepName: string | undefined;
    /** OldPostId */
    oldPostId: number | undefined;
    /** 调岗前岗位 */
    oldPostName: string | undefined;
    /** NewDepId */
    newDepId: number | undefined;
    /** 调岗后部门 */
    newDepName: string | undefined;
    /** NewPostId */
    newPostId: number | undefined;
    /** 调岗后岗位 */
    newPostName: string | undefined;
    /** ResignDate */
    resignDate: moment.Moment | undefined;
    /** ResignDEpId */
    resignDEpId: number | undefined;
    /** 离职时部门 */
    resignDEpName: string | undefined;
    /** ResignPostId */
    resignPostId: number | undefined;
    /** 离职时岗位 */
    resignPostName: string | undefined;
    /** ResignReason */
    resignReason: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** 图片类型 */
    userPictureType: string | undefined;
    id: number;

    constructor(data?: IUserChangeLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.userName = _data["userName"];
            this.type = _data["type"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.postId = _data["postId"];
            this.postName = _data["postName"];
            this.userType = _data["userType"];
            this.userTypeName = _data["userTypeName"];
            this.userStatus = _data["userStatus"];
            this.userStatusName = _data["userStatusName"];
            this.postGradeId = _data["postGradeId"];
            this.postGradeName = _data["postGradeName"];
            this.correctionDate = _data["correctionDate"] ? moment(_data["correctionDate"].toString()) : <any>undefined;
            this.correctionDepId = _data["correctionDepId"];
            this.correctionDepName = _data["correctionDepName"];
            this.correctionPostId = _data["correctionPostId"];
            this.correctionPostName = _data["correctionPostName"];
            this.correctionGradeId = _data["correctionGradeId"];
            this.correctionGradeName = _data["correctionGradeName"];
            this.transferDate = _data["transferDate"] ? moment(_data["transferDate"].toString()) : <any>undefined;
            this.oldDepId = _data["oldDepId"];
            this.oldDepName = _data["oldDepName"];
            this.oldPostId = _data["oldPostId"];
            this.oldPostName = _data["oldPostName"];
            this.newDepId = _data["newDepId"];
            this.newDepName = _data["newDepName"];
            this.newPostId = _data["newPostId"];
            this.newPostName = _data["newPostName"];
            this.resignDate = _data["resignDate"] ? moment(_data["resignDate"].toString()) : <any>undefined;
            this.resignDEpId = _data["resignDEpId"];
            this.resignDEpName = _data["resignDEpName"];
            this.resignPostId = _data["resignPostId"];
            this.resignPostName = _data["resignPostName"];
            this.resignReason = _data["resignReason"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.userPictureType = _data["userPictureType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserChangeLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserChangeLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["userName"] = this.userName;
        data["type"] = this.type;
        data["image"] = this.image;
        data["description"] = this.description;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["postId"] = this.postId;
        data["postName"] = this.postName;
        data["userType"] = this.userType;
        data["userTypeName"] = this.userTypeName;
        data["userStatus"] = this.userStatus;
        data["userStatusName"] = this.userStatusName;
        data["postGradeId"] = this.postGradeId;
        data["postGradeName"] = this.postGradeName;
        data["correctionDate"] = this.correctionDate ? this.correctionDate.toISOString() : <any>undefined;
        data["correctionDepId"] = this.correctionDepId;
        data["correctionDepName"] = this.correctionDepName;
        data["correctionPostId"] = this.correctionPostId;
        data["correctionPostName"] = this.correctionPostName;
        data["correctionGradeId"] = this.correctionGradeId;
        data["correctionGradeName"] = this.correctionGradeName;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["oldDepId"] = this.oldDepId;
        data["oldDepName"] = this.oldDepName;
        data["oldPostId"] = this.oldPostId;
        data["oldPostName"] = this.oldPostName;
        data["newDepId"] = this.newDepId;
        data["newDepName"] = this.newDepName;
        data["newPostId"] = this.newPostId;
        data["newPostName"] = this.newPostName;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["resignDEpId"] = this.resignDEpId;
        data["resignDEpName"] = this.resignDEpName;
        data["resignPostId"] = this.resignPostId;
        data["resignPostName"] = this.resignPostName;
        data["resignReason"] = this.resignReason;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userPictureType"] = this.userPictureType;
        data["id"] = this.id;
        return data;
    }

    clone(): UserChangeLogListDto {
        const json = this.toJSON();
        let result = new UserChangeLogListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.HR.UserChangeLog.UserChangeLog */
export interface IUserChangeLogListDto {
    /** UserId */
    empId: number;
    /** 用户名称 */
    userName: string | undefined;
    /** Type */
    type: number;
    /** 图片 */
    image: string | undefined;
    /** Description */
    description: string | undefined;
    /** EntryDate */
    entryDate: moment.Moment | undefined;
    /** DepartmentId */
    departmentId: number | undefined;
    /** 部门名称 */
    departmentName: string | undefined;
    /** PostId */
    postId: number | undefined;
    /** 岗位名称 */
    postName: string | undefined;
    /** UserType */
    userType: string | undefined;
    /** 员工类型名称 */
    userTypeName: string | undefined;
    /** UserStatus */
    userStatus: string | undefined;
    /** 员工状态名称 */
    userStatusName: string | undefined;
    /** PostGradeId */
    postGradeId: number | undefined;
    /** 岗位等级名称 */
    postGradeName: string | undefined;
    /** CorrectionDate */
    correctionDate: moment.Moment | undefined;
    /** CorrectionDepId */
    correctionDepId: number | undefined;
    /** 转正时部门 */
    correctionDepName: string | undefined;
    /** CorrectionPostId */
    correctionPostId: number | undefined;
    /** 转正时岗位 */
    correctionPostName: string | undefined;
    /** CorrectionGradeId */
    correctionGradeId: number | undefined;
    /** 转正时职等 */
    correctionGradeName: string | undefined;
    /** TransferDate */
    transferDate: moment.Moment | undefined;
    /** OldDepId */
    oldDepId: number | undefined;
    /** 调岗前部门 */
    oldDepName: string | undefined;
    /** OldPostId */
    oldPostId: number | undefined;
    /** 调岗前岗位 */
    oldPostName: string | undefined;
    /** NewDepId */
    newDepId: number | undefined;
    /** 调岗后部门 */
    newDepName: string | undefined;
    /** NewPostId */
    newPostId: number | undefined;
    /** 调岗后岗位 */
    newPostName: string | undefined;
    /** ResignDate */
    resignDate: moment.Moment | undefined;
    /** ResignDEpId */
    resignDEpId: number | undefined;
    /** 离职时部门 */
    resignDEpName: string | undefined;
    /** ResignPostId */
    resignPostId: number | undefined;
    /** 离职时岗位 */
    resignPostName: string | undefined;
    /** ResignReason */
    resignReason: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    /** 图片类型 */
    userPictureType: string | undefined;
    id: number;
}

export class PagedResultDtoOfUserChangeLogListDto implements IPagedResultDtoOfUserChangeLogListDto {
    totalCount: number;
    items: UserChangeLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserChangeLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserChangeLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserChangeLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserChangeLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserChangeLogListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserChangeLogListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserChangeLogListDto {
    totalCount: number;
    items: UserChangeLogListDto[] | undefined;
}

/** 读取可编辑的Dto */
export class GetUserChangeLogForEditOutput implements IGetUserChangeLogForEditOutput {
    userChangeLog: UserChangeLogEditDto;

    constructor(data?: IGetUserChangeLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userChangeLog = _data["userChangeLog"] ? UserChangeLogEditDto.fromJS(_data["userChangeLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserChangeLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChangeLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userChangeLog"] = this.userChangeLog ? this.userChangeLog.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUserChangeLogForEditOutput {
        const json = this.toJSON();
        let result = new GetUserChangeLogForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetUserChangeLogForEditOutput {
    userChangeLog: UserChangeLogEditDto;
}

export class AddUserDepInput implements IAddUserDepInput {
    userIds: number[] | undefined;
    departmentId: number;

    constructor(data?: IAddUserDepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds.push(item);
            }
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): AddUserDepInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserDepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["departmentId"] = this.departmentId;
        return data;
    }

    clone(): AddUserDepInput {
        const json = this.toJSON();
        let result = new AddUserDepInput();
        result.init(json);
        return result;
    }
}

export interface IAddUserDepInput {
    userIds: number[] | undefined;
    departmentId: number;
}

export class AddDepUsersDto implements IAddDepUsersDto {
    /** 部门Id */
    departmentId: number | undefined;
    /** 用户id */
    depUserIds: number[] | undefined;

    constructor(data?: IAddDepUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            if (Array.isArray(_data["depUserIds"])) {
                this.depUserIds = [] as any;
                for (let item of _data["depUserIds"])
                    this.depUserIds.push(item);
            }
        }
    }

    static fromJS(data: any): AddDepUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddDepUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        if (Array.isArray(this.depUserIds)) {
            data["depUserIds"] = [];
            for (let item of this.depUserIds)
                data["depUserIds"].push(item);
        }
        return data;
    }

    clone(): AddDepUsersDto {
        const json = this.toJSON();
        let result = new AddDepUsersDto();
        result.init(json);
        return result;
    }
}

export interface IAddDepUsersDto {
    /** 部门Id */
    departmentId: number | undefined;
    /** 用户id */
    depUserIds: number[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Organization.UserDepPluralism.UserDepPluralism */
export class UserDepPluralismEditDto implements IUserDepPluralismEditDto {
    /** Id */
    id: number | undefined;
    /** 用户ID */
    userId: number;
    /** 部门ID */
    departmentId: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    userName: string | undefined;

    constructor(data?: IUserDepPluralismEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.departmentId = _data["departmentId"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UserDepPluralismEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDepPluralismEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["departmentId"] = this.departmentId;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userName"] = this.userName;
        return data;
    }

    clone(): UserDepPluralismEditDto {
        const json = this.toJSON();
        let result = new UserDepPluralismEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.UserDepPluralism.UserDepPluralism */
export interface IUserDepPluralismEditDto {
    /** Id */
    id: number | undefined;
    /** 用户ID */
    userId: number;
    /** 部门ID */
    departmentId: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    userName: string | undefined;
}

export class CreateOrUpdateUserDepPluralismInput implements ICreateOrUpdateUserDepPluralismInput {
    userDepPluralism: UserDepPluralismEditDto;

    constructor(data?: ICreateOrUpdateUserDepPluralismInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userDepPluralism = new UserDepPluralismEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDepPluralism = _data["userDepPluralism"] ? UserDepPluralismEditDto.fromJS(_data["userDepPluralism"]) : new UserDepPluralismEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateUserDepPluralismInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserDepPluralismInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDepPluralism"] = this.userDepPluralism ? this.userDepPluralism.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateUserDepPluralismInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateUserDepPluralismInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateUserDepPluralismInput {
    userDepPluralism: UserDepPluralismEditDto;
}

/** 的列表DTO QYB.QYBProduct.Organization.UserDepPluralism.UserDepPluralism */
export class UserDepPluralismListDto implements IUserDepPluralismListDto {
    /** 用户ID */
    userId: number;
    /** 部门ID */
    departmentId: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    userName: string | undefined;
    id: number;

    constructor(data?: IUserDepPluralismListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.departmentId = _data["departmentId"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.userName = _data["userName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDepPluralismListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDepPluralismListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["departmentId"] = this.departmentId;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data;
    }

    clone(): UserDepPluralismListDto {
        const json = this.toJSON();
        let result = new UserDepPluralismListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.UserDepPluralism.UserDepPluralism */
export interface IUserDepPluralismListDto {
    /** 用户ID */
    userId: number;
    /** 部门ID */
    departmentId: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    userName: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetUserDepPluralismForEditOutput implements IGetUserDepPluralismForEditOutput {
    userDepPluralism: UserDepPluralismEditDto;

    constructor(data?: IGetUserDepPluralismForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDepPluralism = _data["userDepPluralism"] ? UserDepPluralismEditDto.fromJS(_data["userDepPluralism"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserDepPluralismForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDepPluralismForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDepPluralism"] = this.userDepPluralism ? this.userDepPluralism.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUserDepPluralismForEditOutput {
        const json = this.toJSON();
        let result = new GetUserDepPluralismForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetUserDepPluralismForEditOutput {
    userDepPluralism: UserDepPluralismEditDto;
}

export class PagedResultDtoOfUserDepPluralismListDto implements IPagedResultDtoOfUserDepPluralismListDto {
    totalCount: number;
    items: UserDepPluralismListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDepPluralismListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDepPluralismListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDepPluralismListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDepPluralismListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserDepPluralismListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDepPluralismListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDepPluralismListDto {
    totalCount: number;
    items: UserDepPluralismListDto[] | undefined;
}

export class UserDepListDto implements IUserDepListDto {
    userName: string | undefined;
    creationTime: moment.Moment;
    id: number;
    jobNumber: string | undefined;
    mobile: string | undefined;
    email: string | undefined;
    depId: number | undefined;
    comId: number | undefined;
    departmentName: string | undefined;

    constructor(data?: IUserDepListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.jobNumber = _data["jobNumber"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.depId = _data["depId"];
            this.comId = _data["comId"];
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): UserDepListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDepListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["jobNumber"] = this.jobNumber;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["depId"] = this.depId;
        data["comId"] = this.comId;
        data["departmentName"] = this.departmentName;
        return data;
    }

    clone(): UserDepListDto {
        const json = this.toJSON();
        let result = new UserDepListDto();
        result.init(json);
        return result;
    }
}

export interface IUserDepListDto {
    userName: string | undefined;
    creationTime: moment.Moment;
    id: number;
    jobNumber: string | undefined;
    mobile: string | undefined;
    email: string | undefined;
    depId: number | undefined;
    comId: number | undefined;
    departmentName: string | undefined;
}

export class PagedResultDtoOfUserDepListDto implements IPagedResultDtoOfUserDepListDto {
    totalCount: number;
    items: UserDepListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDepListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDepListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDepListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDepListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserDepListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDepListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDepListDto {
    totalCount: number;
    items: UserDepListDto[] | undefined;
}

export class RoleUserDepListDto implements IRoleUserDepListDto {
    composeId: string | undefined;
    id: number;
    userId: number | undefined;
    mobile: string | undefined;
    jobNumber: string | undefined;
    realName: string | undefined;
    /** 是否兼职部门 */
    isPluralismsDep: boolean;
    /** 公司Id */
    companyId: number | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 部门 */
    department: string | undefined;

    constructor(data?: IRoleUserDepListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.composeId = _data["composeId"];
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.mobile = _data["mobile"];
            this.jobNumber = _data["jobNumber"];
            this.realName = _data["realName"];
            this.isPluralismsDep = _data["isPluralismsDep"];
            this.companyId = _data["companyId"];
            this.company = _data["company"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): RoleUserDepListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUserDepListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["composeId"] = this.composeId;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["mobile"] = this.mobile;
        data["jobNumber"] = this.jobNumber;
        data["realName"] = this.realName;
        data["isPluralismsDep"] = this.isPluralismsDep;
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department;
        return data;
    }

    clone(): RoleUserDepListDto {
        const json = this.toJSON();
        let result = new RoleUserDepListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleUserDepListDto {
    composeId: string | undefined;
    id: number;
    userId: number | undefined;
    mobile: string | undefined;
    jobNumber: string | undefined;
    realName: string | undefined;
    /** 是否兼职部门 */
    isPluralismsDep: boolean;
    /** 公司Id */
    companyId: number | undefined;
    /** 公司 */
    company: string | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 部门 */
    department: string | undefined;
}

export class PagedResultDtoOfRoleUserDepListDto implements IPagedResultDtoOfRoleUserDepListDto {
    totalCount: number;
    items: RoleUserDepListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleUserDepListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleUserDepListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleUserDepListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleUserDepListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfRoleUserDepListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleUserDepListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleUserDepListDto {
    totalCount: number;
    items: RoleUserDepListDto[] | undefined;
}

export class UserDownloadConfigEditDto implements IUserDownloadConfigEditDto {
    /** Id */
    id: number | undefined;
    /** 下载类型 */
    downloadType: string | undefined;
    /** 产品助记码 */
    productCode: string;
    /** 下载次数 */
    residueDegree: number;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 有效天数 */
    indate: number;
    userName: string;

    constructor(data?: IUserDownloadConfigEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.downloadType = _data["downloadType"];
            this.productCode = _data["productCode"];
            this.residueDegree = _data["residueDegree"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.indate = _data["indate"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): UserDownloadConfigEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDownloadConfigEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["downloadType"] = this.downloadType;
        data["productCode"] = this.productCode;
        data["residueDegree"] = this.residueDegree;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["indate"] = this.indate;
        data["userName"] = this.userName;
        return data;
    }

    clone(): UserDownloadConfigEditDto {
        const json = this.toJSON();
        let result = new UserDownloadConfigEditDto();
        result.init(json);
        return result;
    }
}

export interface IUserDownloadConfigEditDto {
    /** Id */
    id: number | undefined;
    /** 下载类型 */
    downloadType: string | undefined;
    /** 产品助记码 */
    productCode: string;
    /** 下载次数 */
    residueDegree: number;
    /** 开始时间 */
    startTime: moment.Moment;
    /** 有效天数 */
    indate: number;
    userName: string;
}

export class CreateOrUpdateUserDownloadConfigInput implements ICreateOrUpdateUserDownloadConfigInput {
    userDownloadConfig: UserDownloadConfigEditDto;

    constructor(data?: ICreateOrUpdateUserDownloadConfigInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userDownloadConfig = new UserDownloadConfigEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDownloadConfig = _data["userDownloadConfig"] ? UserDownloadConfigEditDto.fromJS(_data["userDownloadConfig"]) : new UserDownloadConfigEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateUserDownloadConfigInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserDownloadConfigInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDownloadConfig"] = this.userDownloadConfig ? this.userDownloadConfig.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateUserDownloadConfigInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateUserDownloadConfigInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateUserDownloadConfigInput {
    userDownloadConfig: UserDownloadConfigEditDto;
}

export class UserDownloadConfigListDto implements IUserDownloadConfigListDto {
    /** 产品助记码 */
    productCode: string | undefined;
    /** 下载类型 */
    downloadType: string | undefined;
    /** 下载次数 */
    residueDegree: number;
    /** 开始时间 */
    startTime: moment.Moment | undefined;
    /** 有效天数 */
    indate: number;
    userName: string | undefined;
    id: number;

    constructor(data?: IUserDownloadConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.downloadType = _data["downloadType"];
            this.residueDegree = _data["residueDegree"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.indate = _data["indate"];
            this.userName = _data["userName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDownloadConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDownloadConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["downloadType"] = this.downloadType;
        data["residueDegree"] = this.residueDegree;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["indate"] = this.indate;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data;
    }

    clone(): UserDownloadConfigListDto {
        const json = this.toJSON();
        let result = new UserDownloadConfigListDto();
        result.init(json);
        return result;
    }
}

export interface IUserDownloadConfigListDto {
    /** 产品助记码 */
    productCode: string | undefined;
    /** 下载类型 */
    downloadType: string | undefined;
    /** 下载次数 */
    residueDegree: number;
    /** 开始时间 */
    startTime: moment.Moment | undefined;
    /** 有效天数 */
    indate: number;
    userName: string | undefined;
    id: number;
}

export class GetUserDownloadConfigForEditOutput implements IGetUserDownloadConfigForEditOutput {
    userDownloadConfig: UserDownloadConfigEditDto;

    constructor(data?: IGetUserDownloadConfigForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDownloadConfig = _data["userDownloadConfig"] ? UserDownloadConfigEditDto.fromJS(_data["userDownloadConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserDownloadConfigForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDownloadConfigForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDownloadConfig"] = this.userDownloadConfig ? this.userDownloadConfig.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUserDownloadConfigForEditOutput {
        const json = this.toJSON();
        let result = new GetUserDownloadConfigForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserDownloadConfigForEditOutput {
    userDownloadConfig: UserDownloadConfigEditDto;
}

export class PagedResultDtoOfUserDownloadConfigListDto implements IPagedResultDtoOfUserDownloadConfigListDto {
    totalCount: number;
    items: UserDownloadConfigListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDownloadConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDownloadConfigListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDownloadConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDownloadConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserDownloadConfigListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDownloadConfigListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDownloadConfigListDto {
    totalCount: number;
    items: UserDownloadConfigListDto[] | undefined;
}

export class SendPasswordResetLinkDto implements ISendPasswordResetLinkDto {
    tenantId: number | undefined;
    userName: string | undefined;
    passwordResetCode: string | undefined;
    emailAddress: string | undefined;

    constructor(data?: ISendPasswordResetLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["passwordResetCode"] = this.passwordResetCode;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): SendPasswordResetLinkDto {
        const json = this.toJSON();
        let result = new SendPasswordResetLinkDto();
        result.init(json);
        return result;
    }
}

export interface ISendPasswordResetLinkDto {
    tenantId: number | undefined;
    userName: string | undefined;
    passwordResetCode: string | undefined;
    emailAddress: string | undefined;
}

export class IdentityCardValidatedDto implements IIdentityCardValidatedDto {
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 生日 */
    birthday: string | undefined;
    /** 生日 */
    sex: string | undefined;

    constructor(data?: IIdentityCardValidatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nativePlace = _data["nativePlace"];
            this.birthday = _data["birthday"];
            this.sex = _data["sex"];
        }
    }

    static fromJS(data: any): IdentityCardValidatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityCardValidatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nativePlace"] = this.nativePlace;
        data["birthday"] = this.birthday;
        data["sex"] = this.sex;
        return data;
    }

    clone(): IdentityCardValidatedDto {
        const json = this.toJSON();
        let result = new IdentityCardValidatedDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityCardValidatedDto {
    /** 籍贯 */
    nativePlace: string | undefined;
    /** 生日 */
    birthday: string | undefined;
    /** 生日 */
    sex: string | undefined;
}

export class SkillInfo implements ISkillInfo {
    empId: number | undefined;
    emp: Employee;
    name: string | undefined;
    skillTypeCode: string | undefined;
    skillLevelCode: string | undefined;
    certificateNumber: string | undefined;
    patentNumber: string | undefined;
    annexesFileId: string | undefined;
    expiryDate: moment.Moment | undefined;
    effectiveDate: moment.Moment | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    tenantId: number;
    id: number;

    constructor(data?: ISkillInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.emp = _data["emp"] ? Employee.fromJS(_data["emp"]) : <any>undefined;
            this.name = _data["name"];
            this.skillTypeCode = _data["skillTypeCode"];
            this.skillLevelCode = _data["skillLevelCode"];
            this.certificateNumber = _data["certificateNumber"];
            this.patentNumber = _data["patentNumber"];
            this.annexesFileId = _data["annexesFileId"];
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SkillInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SkillInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["emp"] = this.emp ? this.emp.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["skillTypeCode"] = this.skillTypeCode;
        data["skillLevelCode"] = this.skillLevelCode;
        data["certificateNumber"] = this.certificateNumber;
        data["patentNumber"] = this.patentNumber;
        data["annexesFileId"] = this.annexesFileId;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }

    clone(): SkillInfo {
        const json = this.toJSON();
        let result = new SkillInfo();
        result.init(json);
        return result;
    }
}

export interface ISkillInfo {
    empId: number | undefined;
    emp: Employee;
    name: string | undefined;
    skillTypeCode: string | undefined;
    skillLevelCode: string | undefined;
    certificateNumber: string | undefined;
    patentNumber: string | undefined;
    annexesFileId: string | undefined;
    expiryDate: moment.Moment | undefined;
    effectiveDate: moment.Moment | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    tenantId: number;
    id: number;
}

export class AnnexesFile implements IAnnexesFile {
    folderId: string | undefined;
    locName: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    tenantId: number;
    id: number;

    constructor(data?: IAnnexesFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderId = _data["folderId"];
            this.locName = _data["locName"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AnnexesFile {
        data = typeof data === 'object' ? data : {};
        let result = new AnnexesFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderId"] = this.folderId;
        data["locName"] = this.locName;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }

    clone(): AnnexesFile {
        const json = this.toJSON();
        let result = new AnnexesFile();
        result.init(json);
        return result;
    }
}

export interface IAnnexesFile {
    folderId: string | undefined;
    locName: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    isDeleted: boolean;
    tenantId: number;
    id: number;
}

export class EntrySkillInfo implements IEntrySkillInfo {
    skillInfo: SkillInfo;
    annexesFile: AnnexesFile[] | undefined;

    constructor(data?: IEntrySkillInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillInfo = _data["skillInfo"] ? SkillInfo.fromJS(_data["skillInfo"]) : <any>undefined;
            if (Array.isArray(_data["annexesFile"])) {
                this.annexesFile = [] as any;
                for (let item of _data["annexesFile"])
                    this.annexesFile.push(AnnexesFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntrySkillInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EntrySkillInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillInfo"] = this.skillInfo ? this.skillInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.annexesFile)) {
            data["annexesFile"] = [];
            for (let item of this.annexesFile)
                data["annexesFile"].push(item.toJSON());
        }
        return data;
    }

    clone(): EntrySkillInfo {
        const json = this.toJSON();
        let result = new EntrySkillInfo();
        result.init(json);
        return result;
    }
}

export interface IEntrySkillInfo {
    skillInfo: SkillInfo;
    annexesFile: AnnexesFile[] | undefined;
}

/** 工作经验的列表DTO QYB.QYBProduct.Organization.WorkExperience.WorkExperience */
export class WorkExperienceEditDto implements IWorkExperienceEditDto {
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 所在公司 */
    companyName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 开始日期 */
    startDate: moment.Moment | undefined;
    /** 结束日期 */
    endDate: moment.Moment | undefined;
    /** 薪资 */
    salary: number | undefined;
    /** 证明人 */
    certificateEmpl: string | undefined;
    /** 证明人电话 */
    certificateEmplTel: string | undefined;
    /** 离职原因 */
    leaveJobReason: string | undefined;
    /** 工作内容 */
    workDesc: string | undefined;

    constructor(data?: IWorkExperienceEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empId = _data["empId"];
            this.companyName = _data["companyName"];
            this.postName = _data["postName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.salary = _data["salary"];
            this.certificateEmpl = _data["certificateEmpl"];
            this.certificateEmplTel = _data["certificateEmplTel"];
            this.leaveJobReason = _data["leaveJobReason"];
            this.workDesc = _data["workDesc"];
        }
    }

    static fromJS(data: any): WorkExperienceEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkExperienceEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empId"] = this.empId;
        data["companyName"] = this.companyName;
        data["postName"] = this.postName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["salary"] = this.salary;
        data["certificateEmpl"] = this.certificateEmpl;
        data["certificateEmplTel"] = this.certificateEmplTel;
        data["leaveJobReason"] = this.leaveJobReason;
        data["workDesc"] = this.workDesc;
        return data;
    }

    clone(): WorkExperienceEditDto {
        const json = this.toJSON();
        let result = new WorkExperienceEditDto();
        result.init(json);
        return result;
    }
}

/** 工作经验的列表DTO QYB.QYBProduct.Organization.WorkExperience.WorkExperience */
export interface IWorkExperienceEditDto {
    id: number | undefined;
    /** 用户 */
    empId: number | undefined;
    /** 所在公司 */
    companyName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 开始日期 */
    startDate: moment.Moment | undefined;
    /** 结束日期 */
    endDate: moment.Moment | undefined;
    /** 薪资 */
    salary: number | undefined;
    /** 证明人 */
    certificateEmpl: string | undefined;
    /** 证明人电话 */
    certificateEmplTel: string | undefined;
    /** 离职原因 */
    leaveJobReason: string | undefined;
    /** 工作内容 */
    workDesc: string | undefined;
}

export class UserEntryEditModel implements IUserEntryEditModel {
    tenantId: number | undefined;
    empInfo: EmployeeEditDto;
    /** 教育背景 */
    educationList: EducationBackgroundEditDto[] | undefined;
    /** 证书信息 */
    skillList: EntrySkillInfo[] | undefined;
    /** 家庭成员 */
    familyList: SocialRelationEditDto[] | undefined;
    /** 工作经验 */
    workList: WorkExperienceEditDto[] | undefined;

    constructor(data?: IUserEntryEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.empInfo = _data["empInfo"] ? EmployeeEditDto.fromJS(_data["empInfo"]) : <any>undefined;
            if (Array.isArray(_data["educationList"])) {
                this.educationList = [] as any;
                for (let item of _data["educationList"])
                    this.educationList.push(EducationBackgroundEditDto.fromJS(item));
            }
            if (Array.isArray(_data["skillList"])) {
                this.skillList = [] as any;
                for (let item of _data["skillList"])
                    this.skillList.push(EntrySkillInfo.fromJS(item));
            }
            if (Array.isArray(_data["familyList"])) {
                this.familyList = [] as any;
                for (let item of _data["familyList"])
                    this.familyList.push(SocialRelationEditDto.fromJS(item));
            }
            if (Array.isArray(_data["workList"])) {
                this.workList = [] as any;
                for (let item of _data["workList"])
                    this.workList.push(WorkExperienceEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserEntryEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntryEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["empInfo"] = this.empInfo ? this.empInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.educationList)) {
            data["educationList"] = [];
            for (let item of this.educationList)
                data["educationList"].push(item.toJSON());
        }
        if (Array.isArray(this.skillList)) {
            data["skillList"] = [];
            for (let item of this.skillList)
                data["skillList"].push(item.toJSON());
        }
        if (Array.isArray(this.familyList)) {
            data["familyList"] = [];
            for (let item of this.familyList)
                data["familyList"].push(item.toJSON());
        }
        if (Array.isArray(this.workList)) {
            data["workList"] = [];
            for (let item of this.workList)
                data["workList"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserEntryEditModel {
        const json = this.toJSON();
        let result = new UserEntryEditModel();
        result.init(json);
        return result;
    }
}

export interface IUserEntryEditModel {
    tenantId: number | undefined;
    empInfo: EmployeeEditDto;
    /** 教育背景 */
    educationList: EducationBackgroundEditDto[] | undefined;
    /** 证书信息 */
    skillList: EntrySkillInfo[] | undefined;
    /** 家庭成员 */
    familyList: SocialRelationEditDto[] | undefined;
    /** 工作经验 */
    workList: WorkExperienceEditDto[] | undefined;
}

export class ResultInfo implements IResultInfo {
    result: number;
    resultMes: string | undefined;

    constructor(data?: IResultInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.resultMes = _data["resultMes"];
        }
    }

    static fromJS(data: any): ResultInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ResultInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultMes"] = this.resultMes;
        return data;
    }

    clone(): ResultInfo {
        const json = this.toJSON();
        let result = new ResultInfo();
        result.init(json);
        return result;
    }
}

export interface IResultInfo {
    result: number;
    resultMes: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }

    clone(): LinkedUserDto {
        const json = this.toJSON();
        let result = new LinkedUserDto();
        result.init(json);
        return result;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfLinkedUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfLinkedUserDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }

    clone(): LinkToUserInput {
        const json = this.toJSON();
        let result = new LinkToUserInput();
        result.init(json);
        return result;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UnlinkUserInput {
        const json = this.toJSON();
        let result = new UnlinkUserInput();
        result.init(json);
        return result;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmailAddress: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserLoginAttemptDto {
        const json = this.toJSON();
        let result = new UserLoginAttemptDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmailAddress: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfUserLoginAttemptDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class ExportDes implements IExportDes {
    title: string | undefined;
    des: string | undefined;

    constructor(data?: IExportDes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.des = _data["des"];
        }
    }

    static fromJS(data: any): ExportDes {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["des"] = this.des;
        return data;
    }

    clone(): ExportDes {
        const json = this.toJSON();
        let result = new ExportDes();
        result.init(json);
        return result;
    }
}

export interface IExportDes {
    title: string | undefined;
    des: string | undefined;
}

export class ExportShiftInfo implements IExportShiftInfo {
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IExportShiftInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ExportShiftInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExportShiftInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }

    clone(): ExportShiftInfo {
        const json = this.toJSON();
        let result = new ExportShiftInfo();
        result.init(json);
        return result;
    }
}

export interface IExportShiftInfo {
    name: string | undefined;
    code: string | undefined;
}

export class UserPlanExportingDto implements IUserPlanExportingDto {
    userPlanHeader: string[] | undefined;
    exportDes: ExportDes[] | undefined;
    shiftInfoHeader: string[] | undefined;
    shiftInfoList: ExportShiftInfo[] | undefined;

    constructor(data?: IUserPlanExportingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userPlanHeader"])) {
                this.userPlanHeader = [] as any;
                for (let item of _data["userPlanHeader"])
                    this.userPlanHeader.push(item);
            }
            if (Array.isArray(_data["exportDes"])) {
                this.exportDes = [] as any;
                for (let item of _data["exportDes"])
                    this.exportDes.push(ExportDes.fromJS(item));
            }
            if (Array.isArray(_data["shiftInfoHeader"])) {
                this.shiftInfoHeader = [] as any;
                for (let item of _data["shiftInfoHeader"])
                    this.shiftInfoHeader.push(item);
            }
            if (Array.isArray(_data["shiftInfoList"])) {
                this.shiftInfoList = [] as any;
                for (let item of _data["shiftInfoList"])
                    this.shiftInfoList.push(ExportShiftInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPlanExportingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPlanExportingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userPlanHeader)) {
            data["userPlanHeader"] = [];
            for (let item of this.userPlanHeader)
                data["userPlanHeader"].push(item);
        }
        if (Array.isArray(this.exportDes)) {
            data["exportDes"] = [];
            for (let item of this.exportDes)
                data["exportDes"].push(item.toJSON());
        }
        if (Array.isArray(this.shiftInfoHeader)) {
            data["shiftInfoHeader"] = [];
            for (let item of this.shiftInfoHeader)
                data["shiftInfoHeader"].push(item);
        }
        if (Array.isArray(this.shiftInfoList)) {
            data["shiftInfoList"] = [];
            for (let item of this.shiftInfoList)
                data["shiftInfoList"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserPlanExportingDto {
        const json = this.toJSON();
        let result = new UserPlanExportingDto();
        result.init(json);
        return result;
    }
}

export interface IUserPlanExportingDto {
    userPlanHeader: string[] | undefined;
    exportDes: ExportDes[] | undefined;
    shiftInfoHeader: string[] | undefined;
    shiftInfoList: ExportShiftInfo[] | undefined;
}

export class AttData implements IAttData {
    /** 日期 */
    date: string | undefined;
    /** 班次 */
    code: string | undefined;

    constructor(data?: IAttData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): AttData {
        data = typeof data === 'object' ? data : {};
        let result = new AttData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["code"] = this.code;
        return data;
    }

    clone(): AttData {
        const json = this.toJSON();
        let result = new AttData();
        result.init(json);
        return result;
    }
}

export interface IAttData {
    /** 日期 */
    date: string | undefined;
    /** 班次 */
    code: string | undefined;
}

export class UserPlan implements IUserPlan {
    /** 姓名 */
    empName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 班次集合 */
    shfitCodeList: AttData[] | undefined;
    /** 错误说明 */
    errorDes: string | undefined;

    constructor(data?: IUserPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empName = _data["empName"];
            this.jobNumber = _data["jobNumber"];
            if (Array.isArray(_data["shfitCodeList"])) {
                this.shfitCodeList = [] as any;
                for (let item of _data["shfitCodeList"])
                    this.shfitCodeList.push(AttData.fromJS(item));
            }
            this.errorDes = _data["errorDes"];
        }
    }

    static fromJS(data: any): UserPlan {
        data = typeof data === 'object' ? data : {};
        let result = new UserPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empName"] = this.empName;
        data["jobNumber"] = this.jobNumber;
        if (Array.isArray(this.shfitCodeList)) {
            data["shfitCodeList"] = [];
            for (let item of this.shfitCodeList)
                data["shfitCodeList"].push(item.toJSON());
        }
        data["errorDes"] = this.errorDes;
        return data;
    }

    clone(): UserPlan {
        const json = this.toJSON();
        let result = new UserPlan();
        result.init(json);
        return result;
    }
}

export interface IUserPlan {
    /** 姓名 */
    empName: string | undefined;
    /** 工号 */
    jobNumber: string | undefined;
    /** 班次集合 */
    shfitCodeList: AttData[] | undefined;
    /** 错误说明 */
    errorDes: string | undefined;
}

export class UserShiftPlanImportDto implements IUserShiftPlanImportDto {
    /** 表头 */
    tableHeader: string[] | undefined;
    /** 排班集合 */
    userPlanList: UserPlan[] | undefined;

    constructor(data?: IUserShiftPlanImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tableHeader"])) {
                this.tableHeader = [] as any;
                for (let item of _data["tableHeader"])
                    this.tableHeader.push(item);
            }
            if (Array.isArray(_data["userPlanList"])) {
                this.userPlanList = [] as any;
                for (let item of _data["userPlanList"])
                    this.userPlanList.push(UserPlan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserShiftPlanImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserShiftPlanImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tableHeader)) {
            data["tableHeader"] = [];
            for (let item of this.tableHeader)
                data["tableHeader"].push(item);
        }
        if (Array.isArray(this.userPlanList)) {
            data["userPlanList"] = [];
            for (let item of this.userPlanList)
                data["userPlanList"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserShiftPlanImportDto {
        const json = this.toJSON();
        let result = new UserShiftPlanImportDto();
        result.init(json);
        return result;
    }
}

export interface IUserShiftPlanImportDto {
    /** 表头 */
    tableHeader: string[] | undefined;
    /** 排班集合 */
    userPlanList: UserPlan[] | undefined;
}

export class AddPostUsersDot implements IAddPostUsersDot {
    /** 岗位Id */
    orgPostId: number | undefined;
    /** 用户id */
    depUserIds: number[] | undefined;

    constructor(data?: IAddPostUsersDot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgPostId = _data["orgPostId"];
            if (Array.isArray(_data["depUserIds"])) {
                this.depUserIds = [] as any;
                for (let item of _data["depUserIds"])
                    this.depUserIds.push(item);
            }
        }
    }

    static fromJS(data: any): AddPostUsersDot {
        data = typeof data === 'object' ? data : {};
        let result = new AddPostUsersDot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgPostId"] = this.orgPostId;
        if (Array.isArray(this.depUserIds)) {
            data["depUserIds"] = [];
            for (let item of this.depUserIds)
                data["depUserIds"].push(item);
        }
        return data;
    }

    clone(): AddPostUsersDot {
        const json = this.toJSON();
        let result = new AddPostUsersDot();
        result.init(json);
        return result;
    }
}

export interface IAddPostUsersDot {
    /** 岗位Id */
    orgPostId: number | undefined;
    /** 用户id */
    depUserIds: number[] | undefined;
}

/** 的列表DTO QYB.QYBProduct.Organization.UserRelation.UserRelation */
export class UserRelationEditDto implements IUserRelationEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    userId: string | undefined;
    /** Category */
    category: number | undefined;
    /** ObjectId */
    objectId: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;

    constructor(data?: IUserRelationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.category = _data["category"];
            this.objectId = _data["objectId"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserRelationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRelationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["category"] = this.category;
        data["objectId"] = this.objectId;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): UserRelationEditDto {
        const json = this.toJSON();
        let result = new UserRelationEditDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.UserRelation.UserRelation */
export interface IUserRelationEditDto {
    /** Id */
    id: number | undefined;
    /** UserId */
    userId: string | undefined;
    /** Category */
    category: number | undefined;
    /** ObjectId */
    objectId: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
}

export class CreateOrUpdateUserRelationInput implements ICreateOrUpdateUserRelationInput {
    userRelation: UserRelationEditDto;

    constructor(data?: ICreateOrUpdateUserRelationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userRelation = new UserRelationEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRelation = _data["userRelation"] ? UserRelationEditDto.fromJS(_data["userRelation"]) : new UserRelationEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateUserRelationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserRelationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRelation"] = this.userRelation ? this.userRelation.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateUserRelationInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateUserRelationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateUserRelationInput {
    userRelation: UserRelationEditDto;
}

/** 的列表DTO QYB.QYBProduct.Organization.UserRelation.UserRelation */
export class UserRelationListDto implements IUserRelationListDto {
    /** UserId */
    userId: string | undefined;
    /** Category */
    category: number | undefined;
    /** ObjectId */
    objectId: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    realName: string | undefined;
    jobNumber: string | undefined;
    emailAddress: string | undefined;
    mobile: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: IUserRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.category = _data["category"];
            this.objectId = _data["objectId"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.realName = _data["realName"];
            this.jobNumber = _data["jobNumber"];
            this.emailAddress = _data["emailAddress"];
            this.mobile = _data["mobile"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRelationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["category"] = this.category;
        data["objectId"] = this.objectId;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["realName"] = this.realName;
        data["jobNumber"] = this.jobNumber;
        data["emailAddress"] = this.emailAddress;
        data["mobile"] = this.mobile;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): UserRelationListDto {
        const json = this.toJSON();
        let result = new UserRelationListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Organization.UserRelation.UserRelation */
export interface IUserRelationListDto {
    /** UserId */
    userId: string | undefined;
    /** Category */
    category: number | undefined;
    /** ObjectId */
    objectId: string | undefined;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    realName: string | undefined;
    jobNumber: string | undefined;
    emailAddress: string | undefined;
    mobile: string | undefined;
    name: string | undefined;
    id: number;
}

/** 读取可编辑的Dto */
export class GetUserRelationForEditOutput implements IGetUserRelationForEditOutput {
    userRelation: UserRelationEditDto;

    constructor(data?: IGetUserRelationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRelation = _data["userRelation"] ? UserRelationEditDto.fromJS(_data["userRelation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserRelationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRelationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRelation"] = this.userRelation ? this.userRelation.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetUserRelationForEditOutput {
        const json = this.toJSON();
        let result = new GetUserRelationForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetUserRelationForEditOutput {
    userRelation: UserRelationEditDto;
}

export class PagedResultDtoOfUserRelationListDto implements IPagedResultDtoOfUserRelationListDto {
    totalCount: number;
    items: UserRelationListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserRelationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserRelationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfUserRelationListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserRelationListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserRelationListDto {
    totalCount: number;
    items: UserRelationListDto[] | undefined;
}

export class UserShiftPlanChangeInput implements IUserShiftPlanChangeInput {
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 考勤组 */
    attGroupId: number | undefined;
    /** 人员 */
    empIds: number[] | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;

    constructor(data?: IUserShiftPlanChangeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.attGroupId = _data["attGroupId"];
            if (Array.isArray(_data["empIds"])) {
                this.empIds = [] as any;
                for (let item of _data["empIds"])
                    this.empIds.push(item);
            }
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserShiftPlanChangeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserShiftPlanChangeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["attGroupId"] = this.attGroupId;
        if (Array.isArray(this.empIds)) {
            data["empIds"] = [];
            for (let item of this.empIds)
                data["empIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserShiftPlanChangeInput {
        const json = this.toJSON();
        let result = new UserShiftPlanChangeInput();
        result.init(json);
        return result;
    }
}

export interface IUserShiftPlanChangeInput {
    /** 公司 */
    companyId: number | undefined;
    /** 部门 */
    departmentId: number | undefined;
    /** 考勤组 */
    attGroupId: number | undefined;
    /** 人员 */
    empIds: number[] | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class UserShiftPlanByCodeInput implements IUserShiftPlanByCodeInput {
    date: moment.Moment | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    shiftCode: string | undefined;
    userId: number;
    /** 类型，1：基础信息点击，2：单个日期框点击 */
    type: number;

    constructor(data?: IUserShiftPlanByCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.userId = _data["userId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UserShiftPlanByCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserShiftPlanByCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["userId"] = this.userId;
        data["type"] = this.type;
        return data;
    }

    clone(): UserShiftPlanByCodeInput {
        const json = this.toJSON();
        let result = new UserShiftPlanByCodeInput();
        result.init(json);
        return result;
    }
}

export interface IUserShiftPlanByCodeInput {
    date: moment.Moment | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    shiftCode: string | undefined;
    userId: number;
    /** 类型，1：基础信息点击，2：单个日期框点击 */
    type: number;
}

export class ExportTemplateInput implements IExportTemplateInput {
    startTime: moment.Moment;
    endTime: moment.Moment;

    constructor(data?: IExportTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExportTemplateInput {
        const json = this.toJSON();
        let result = new ExportTemplateInput();
        result.init(json);
        return result;
    }
}

export interface IExportTemplateInput {
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class GetUserShiftPlanListDto implements IGetUserShiftPlanListDto {
    /** 员工Id */
    empId: number;
    /** 公司Id */
    compId: number;
    /** 部门Id */
    deptId: number | undefined;
    /** 部门Id */
    depId: number | undefined;
    /** 部门名称 */
    deptName: string | undefined;
    /** 员工工号 */
    jobNumber: string | undefined;
    /** 员工名称 */
    empName: string | undefined;
    /** 考情组Id */
    attGroupId: number | undefined;
    /** 考勤组名称 */
    attGroupName: string | undefined;
    /** 时间 */
    date: moment.Moment;
    /** 班次代码 */
    shiftCode: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;

    constructor(data?: IGetUserShiftPlanListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.compId = _data["compId"];
            this.deptId = _data["deptId"];
            this.depId = _data["depId"];
            this.deptName = _data["deptName"];
            this.jobNumber = _data["jobNumber"];
            this.empName = _data["empName"];
            this.attGroupId = _data["attGroupId"];
            this.attGroupName = _data["attGroupName"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.hireDate = _data["hireDate"] ? moment(_data["hireDate"].toString()) : <any>undefined;
            this.termDate = _data["termDate"] ? moment(_data["termDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserShiftPlanListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserShiftPlanListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["compId"] = this.compId;
        data["deptId"] = this.deptId;
        data["depId"] = this.depId;
        data["deptName"] = this.deptName;
        data["jobNumber"] = this.jobNumber;
        data["empName"] = this.empName;
        data["attGroupId"] = this.attGroupId;
        data["attGroupName"] = this.attGroupName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetUserShiftPlanListDto {
        const json = this.toJSON();
        let result = new GetUserShiftPlanListDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserShiftPlanListDto {
    /** 员工Id */
    empId: number;
    /** 公司Id */
    compId: number;
    /** 部门Id */
    deptId: number | undefined;
    /** 部门Id */
    depId: number | undefined;
    /** 部门名称 */
    deptName: string | undefined;
    /** 员工工号 */
    jobNumber: string | undefined;
    /** 员工名称 */
    empName: string | undefined;
    /** 考情组Id */
    attGroupId: number | undefined;
    /** 考勤组名称 */
    attGroupName: string | undefined;
    /** 时间 */
    date: moment.Moment;
    /** 班次代码 */
    shiftCode: string | undefined;
    /** 班次名称 */
    shiftName: string | undefined;
    /** 入职日期 */
    hireDate: moment.Moment | undefined;
    /** 离职日期 */
    termDate: moment.Moment | undefined;
}

export class GetUserShiftPlanDto implements IGetUserShiftPlanDto {
    getUserShiftPlanList: GetUserShiftPlanListDto[] | undefined;
    userList: number[] | undefined;

    constructor(data?: IGetUserShiftPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["getUserShiftPlanList"])) {
                this.getUserShiftPlanList = [] as any;
                for (let item of _data["getUserShiftPlanList"])
                    this.getUserShiftPlanList.push(GetUserShiftPlanListDto.fromJS(item));
            }
            if (Array.isArray(_data["userList"])) {
                this.userList = [] as any;
                for (let item of _data["userList"])
                    this.userList.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserShiftPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserShiftPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.getUserShiftPlanList)) {
            data["getUserShiftPlanList"] = [];
            for (let item of this.getUserShiftPlanList)
                data["getUserShiftPlanList"].push(item.toJSON());
        }
        if (Array.isArray(this.userList)) {
            data["userList"] = [];
            for (let item of this.userList)
                data["userList"].push(item);
        }
        return data;
    }

    clone(): GetUserShiftPlanDto {
        const json = this.toJSON();
        let result = new GetUserShiftPlanDto();
        result.init(json);
        return result;
    }
}

export interface IGetUserShiftPlanDto {
    getUserShiftPlanList: GetUserShiftPlanListDto[] | undefined;
    userList: number[] | undefined;
}

export class UserPlanImportInput implements IUserPlanImportInput {
    fileName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;

    constructor(data?: IUserPlanImportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserPlanImportInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserPlanImportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserPlanImportInput {
        const json = this.toJSON();
        let result = new UserPlanImportInput();
        result.init(json);
        return result;
    }
}

export interface IUserPlanImportInput {
    fileName: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class UserShiftPlanByCycleInput implements IUserShiftPlanByCycleInput {
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 用户 */
    userId: number;
    /** 考勤组 */
    attGroupId: number | undefined;
    /** 当前开始的索引 */
    shiftCodeIndex: number;
    /** 节假日规则1：跳过，2：顺延，3：覆盖 */
    ruleCode: number;

    constructor(data?: IUserShiftPlanByCycleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.attGroupId = _data["attGroupId"];
            this.shiftCodeIndex = _data["shiftCodeIndex"];
            this.ruleCode = _data["ruleCode"];
        }
    }

    static fromJS(data: any): UserShiftPlanByCycleInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserShiftPlanByCycleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["attGroupId"] = this.attGroupId;
        data["shiftCodeIndex"] = this.shiftCodeIndex;
        data["ruleCode"] = this.ruleCode;
        return data;
    }

    clone(): UserShiftPlanByCycleInput {
        const json = this.toJSON();
        let result = new UserShiftPlanByCycleInput();
        result.init(json);
        return result;
    }
}

export interface IUserShiftPlanByCycleInput {
    /** 开始时间 */
    startTime: moment.Moment;
    /** 结束时间 */
    endTime: moment.Moment;
    /** 用户 */
    userId: number;
    /** 考勤组 */
    attGroupId: number | undefined;
    /** 当前开始的索引 */
    shiftCodeIndex: number;
    /** 节假日规则1：跳过，2：顺延，3：覆盖 */
    ruleCode: number;
}

export class VideoResourceEditDto implements IVideoResourceEditDto {
    id: number | undefined;
    /** 视频名称 */
    title: string | undefined;
    videoId: string | undefined;
    tags: string | undefined;
    status: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** 时长 */
    duration: number | undefined;
    /** 描述 */
    description: string | undefined;
    modificationTime: string | undefined;
    /** 对应阿里云的CreationTime */
    syncCreationTime: string | undefined;
    /** 封面图片 */
    coverURL: string | undefined;
    cateId: number | undefined;
    /** 分类名称 */
    cateName: string | undefined;
    downloadSwitch: string | undefined;
    templateGroupId: string | undefined;
    preprocessStatus: string | undefined;
    storageLocation: string | undefined;
    regionId: string | undefined;
    customMediaInfo: string | undefined;
    appId: string | undefined;
    /** 课程与视频关联表 */
    creatorUser: number;

    constructor(data?: IVideoResourceEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.videoId = _data["videoId"];
            this.tags = _data["tags"];
            this.status = _data["status"];
            this.size = _data["size"];
            this.duration = _data["duration"];
            this.description = _data["description"];
            this.modificationTime = _data["modificationTime"];
            this.syncCreationTime = _data["syncCreationTime"];
            this.coverURL = _data["coverURL"];
            this.cateId = _data["cateId"];
            this.cateName = _data["cateName"];
            this.downloadSwitch = _data["downloadSwitch"];
            this.templateGroupId = _data["templateGroupId"];
            this.preprocessStatus = _data["preprocessStatus"];
            this.storageLocation = _data["storageLocation"];
            this.regionId = _data["regionId"];
            this.customMediaInfo = _data["customMediaInfo"];
            this.appId = _data["appId"];
            this.creatorUser = _data["creatorUser"];
        }
    }

    static fromJS(data: any): VideoResourceEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoResourceEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["videoId"] = this.videoId;
        data["tags"] = this.tags;
        data["status"] = this.status;
        data["size"] = this.size;
        data["duration"] = this.duration;
        data["description"] = this.description;
        data["modificationTime"] = this.modificationTime;
        data["syncCreationTime"] = this.syncCreationTime;
        data["coverURL"] = this.coverURL;
        data["cateId"] = this.cateId;
        data["cateName"] = this.cateName;
        data["downloadSwitch"] = this.downloadSwitch;
        data["templateGroupId"] = this.templateGroupId;
        data["preprocessStatus"] = this.preprocessStatus;
        data["storageLocation"] = this.storageLocation;
        data["regionId"] = this.regionId;
        data["customMediaInfo"] = this.customMediaInfo;
        data["appId"] = this.appId;
        data["creatorUser"] = this.creatorUser;
        return data;
    }

    clone(): VideoResourceEditDto {
        const json = this.toJSON();
        let result = new VideoResourceEditDto();
        result.init(json);
        return result;
    }
}

export interface IVideoResourceEditDto {
    id: number | undefined;
    /** 视频名称 */
    title: string | undefined;
    videoId: string | undefined;
    tags: string | undefined;
    status: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** 时长 */
    duration: number | undefined;
    /** 描述 */
    description: string | undefined;
    modificationTime: string | undefined;
    /** 对应阿里云的CreationTime */
    syncCreationTime: string | undefined;
    /** 封面图片 */
    coverURL: string | undefined;
    cateId: number | undefined;
    /** 分类名称 */
    cateName: string | undefined;
    downloadSwitch: string | undefined;
    templateGroupId: string | undefined;
    preprocessStatus: string | undefined;
    storageLocation: string | undefined;
    regionId: string | undefined;
    customMediaInfo: string | undefined;
    appId: string | undefined;
    /** 课程与视频关联表 */
    creatorUser: number;
}

export class CreateOrUpdateVideoResourceInput implements ICreateOrUpdateVideoResourceInput {
    videoResource: VideoResourceEditDto;

    constructor(data?: ICreateOrUpdateVideoResourceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.videoResource = new VideoResourceEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoResource = _data["videoResource"] ? VideoResourceEditDto.fromJS(_data["videoResource"]) : new VideoResourceEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateVideoResourceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateVideoResourceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoResource"] = this.videoResource ? this.videoResource.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateVideoResourceInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateVideoResourceInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateVideoResourceInput {
    videoResource: VideoResourceEditDto;
}

/** QYB.Modules.Mooc.VideoResources.VideoResource */
export class VideoResourceListDto implements IVideoResourceListDto {
    /** 视频名称 */
    title: string | undefined;
    videoId: string | undefined;
    tags: string | undefined;
    status: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** 时长 */
    duration: number | undefined;
    /** 描述 */
    description: string | undefined;
    modificationTime: string | undefined;
    /** 对应阿里云的CreationTime */
    syncCreationTime: string | undefined;
    /** 封面图片 */
    coverURL: string | undefined;
    cateId: number | undefined;
    /** 分类名称 */
    cateName: string | undefined;
    downloadSwitch: string | undefined;
    templateGroupId: string | undefined;
    preprocessStatus: string | undefined;
    storageLocation: string | undefined;
    regionId: string | undefined;
    customMediaInfo: string | undefined;
    appId: string | undefined;
    /** 课程与视频关联表 */
    creatorUser: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IVideoResourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.videoId = _data["videoId"];
            this.tags = _data["tags"];
            this.status = _data["status"];
            this.size = _data["size"];
            this.duration = _data["duration"];
            this.description = _data["description"];
            this.modificationTime = _data["modificationTime"];
            this.syncCreationTime = _data["syncCreationTime"];
            this.coverURL = _data["coverURL"];
            this.cateId = _data["cateId"];
            this.cateName = _data["cateName"];
            this.downloadSwitch = _data["downloadSwitch"];
            this.templateGroupId = _data["templateGroupId"];
            this.preprocessStatus = _data["preprocessStatus"];
            this.storageLocation = _data["storageLocation"];
            this.regionId = _data["regionId"];
            this.customMediaInfo = _data["customMediaInfo"];
            this.appId = _data["appId"];
            this.creatorUser = _data["creatorUser"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VideoResourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoResourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["videoId"] = this.videoId;
        data["tags"] = this.tags;
        data["status"] = this.status;
        data["size"] = this.size;
        data["duration"] = this.duration;
        data["description"] = this.description;
        data["modificationTime"] = this.modificationTime;
        data["syncCreationTime"] = this.syncCreationTime;
        data["coverURL"] = this.coverURL;
        data["cateId"] = this.cateId;
        data["cateName"] = this.cateName;
        data["downloadSwitch"] = this.downloadSwitch;
        data["templateGroupId"] = this.templateGroupId;
        data["preprocessStatus"] = this.preprocessStatus;
        data["storageLocation"] = this.storageLocation;
        data["regionId"] = this.regionId;
        data["customMediaInfo"] = this.customMediaInfo;
        data["appId"] = this.appId;
        data["creatorUser"] = this.creatorUser;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): VideoResourceListDto {
        const json = this.toJSON();
        let result = new VideoResourceListDto();
        result.init(json);
        return result;
    }
}

/** QYB.Modules.Mooc.VideoResources.VideoResource */
export interface IVideoResourceListDto {
    /** 视频名称 */
    title: string | undefined;
    videoId: string | undefined;
    tags: string | undefined;
    status: string | undefined;
    /** 大小 */
    size: number | undefined;
    /** 时长 */
    duration: number | undefined;
    /** 描述 */
    description: string | undefined;
    modificationTime: string | undefined;
    /** 对应阿里云的CreationTime */
    syncCreationTime: string | undefined;
    /** 封面图片 */
    coverURL: string | undefined;
    cateId: number | undefined;
    /** 分类名称 */
    cateName: string | undefined;
    downloadSwitch: string | undefined;
    templateGroupId: string | undefined;
    preprocessStatus: string | undefined;
    storageLocation: string | undefined;
    regionId: string | undefined;
    customMediaInfo: string | undefined;
    appId: string | undefined;
    /** 课程与视频关联表 */
    creatorUser: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetVideoResourceForEditOutput implements IGetVideoResourceForEditOutput {
    videoResource: VideoResourceEditDto;

    constructor(data?: IGetVideoResourceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoResource = _data["videoResource"] ? VideoResourceEditDto.fromJS(_data["videoResource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVideoResourceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVideoResourceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoResource"] = this.videoResource ? this.videoResource.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetVideoResourceForEditOutput {
        const json = this.toJSON();
        let result = new GetVideoResourceForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetVideoResourceForEditOutput {
    videoResource: VideoResourceEditDto;
}

export class PagedResultDtoOfVideoResourceListDto implements IPagedResultDtoOfVideoResourceListDto {
    totalCount: number;
    items: VideoResourceListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVideoResourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VideoResourceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVideoResourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVideoResourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfVideoResourceListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfVideoResourceListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfVideoResourceListDto {
    totalCount: number;
    items: VideoResourceListDto[] | undefined;
}

export class VideoPlayAuthDto implements IVideoPlayAuthDto {
    /** 视频Id */
    videoId: string | undefined;
    playAuth: string | undefined;
    coverURL: string | undefined;

    constructor(data?: IVideoPlayAuthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoId = _data["videoId"];
            this.playAuth = _data["playAuth"];
            this.coverURL = _data["coverURL"];
        }
    }

    static fromJS(data: any): VideoPlayAuthDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoPlayAuthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoId"] = this.videoId;
        data["playAuth"] = this.playAuth;
        data["coverURL"] = this.coverURL;
        return data;
    }

    clone(): VideoPlayAuthDto {
        const json = this.toJSON();
        let result = new VideoPlayAuthDto();
        result.init(json);
        return result;
    }
}

export interface IVideoPlayAuthDto {
    /** 视频Id */
    videoId: string | undefined;
    playAuth: string | undefined;
    coverURL: string | undefined;
}

/** 搜索视频资源输入 */
export class SearchVideoResourceInput implements ISearchVideoResourceInput {
    /** 视频分类id */
    videoCategoryId: number;
    /** 筛选名称 */
    filter: string | undefined;

    constructor(data?: ISearchVideoResourceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.videoCategoryId = _data["videoCategoryId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): SearchVideoResourceInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchVideoResourceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoCategoryId"] = this.videoCategoryId;
        data["filter"] = this.filter;
        return data;
    }

    clone(): SearchVideoResourceInput {
        const json = this.toJSON();
        let result = new SearchVideoResourceInput();
        result.init(json);
        return result;
    }
}

/** 搜索视频资源输入 */
export interface ISearchVideoResourceInput {
    /** 视频分类id */
    videoCategoryId: number;
    /** 筛选名称 */
    filter: string | undefined;
}

export class ListResultDtoOfVideoResourceListDto implements IListResultDtoOfVideoResourceListDto {
    items: VideoResourceListDto[] | undefined;

    constructor(data?: IListResultDtoOfVideoResourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VideoResourceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVideoResourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfVideoResourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfVideoResourceListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfVideoResourceListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfVideoResourceListDto {
    items: VideoResourceListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }

    clone(): GetLatestWebLogsOutput {
        const json = this.toJSON();
        let result = new GetLatestWebLogsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

/** 网站公告的列表DTO QYB.Modules.WebSiteSetting.Notices.WebSiteNotice */
export class WebSiteNoticeEditDto implements IWebSiteNoticeEditDto {
    /** Id */
    id: number | undefined;
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    /** ViewCount */
    viewCount: number;

    constructor(data?: IWebSiteNoticeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.viewCount = _data["viewCount"];
        }
    }

    static fromJS(data: any): WebSiteNoticeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebSiteNoticeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["viewCount"] = this.viewCount;
        return data;
    }

    clone(): WebSiteNoticeEditDto {
        const json = this.toJSON();
        let result = new WebSiteNoticeEditDto();
        result.init(json);
        return result;
    }
}

/** 网站公告的列表DTO QYB.Modules.WebSiteSetting.Notices.WebSiteNotice */
export interface IWebSiteNoticeEditDto {
    /** Id */
    id: number | undefined;
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    /** ViewCount */
    viewCount: number;
}

export class CreateOrUpdateWebSiteNoticeInput implements ICreateOrUpdateWebSiteNoticeInput {
    webSiteNotice: WebSiteNoticeEditDto;

    constructor(data?: ICreateOrUpdateWebSiteNoticeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.webSiteNotice = new WebSiteNoticeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteNotice = _data["webSiteNotice"] ? WebSiteNoticeEditDto.fromJS(_data["webSiteNotice"]) : new WebSiteNoticeEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateWebSiteNoticeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateWebSiteNoticeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteNotice"] = this.webSiteNotice ? this.webSiteNotice.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateWebSiteNoticeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateWebSiteNoticeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateWebSiteNoticeInput {
    webSiteNotice: WebSiteNoticeEditDto;
}

/** 网站公告的编辑DTO QYB.Modules.WebSiteSetting.Notices.WebSiteNotice */
export class WebSiteNoticeListDto implements IWebSiteNoticeListDto {
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    /** ViewCount */
    viewCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWebSiteNoticeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.viewCount = _data["viewCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebSiteNoticeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebSiteNoticeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["viewCount"] = this.viewCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WebSiteNoticeListDto {
        const json = this.toJSON();
        let result = new WebSiteNoticeListDto();
        result.init(json);
        return result;
    }
}

/** 网站公告的编辑DTO QYB.Modules.WebSiteSetting.Notices.WebSiteNotice */
export interface IWebSiteNoticeListDto {
    /** 标题 */
    title: string;
    /** 内容 */
    content: string;
    /** ViewCount */
    viewCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

/** 读取可编辑网站公告的Dto */
export class GetWebSiteNoticeForEditOutput implements IGetWebSiteNoticeForEditOutput {
    webSiteNotice: WebSiteNoticeEditDto;

    constructor(data?: IGetWebSiteNoticeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteNotice = _data["webSiteNotice"] ? WebSiteNoticeEditDto.fromJS(_data["webSiteNotice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWebSiteNoticeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWebSiteNoticeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteNotice"] = this.webSiteNotice ? this.webSiteNotice.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetWebSiteNoticeForEditOutput {
        const json = this.toJSON();
        let result = new GetWebSiteNoticeForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑网站公告的Dto */
export interface IGetWebSiteNoticeForEditOutput {
    webSiteNotice: WebSiteNoticeEditDto;
}

export class PagedResultDtoOfWebSiteNoticeListDto implements IPagedResultDtoOfWebSiteNoticeListDto {
    totalCount: number;
    items: WebSiteNoticeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWebSiteNoticeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WebSiteNoticeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWebSiteNoticeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWebSiteNoticeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfWebSiteNoticeListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWebSiteNoticeListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWebSiteNoticeListDto {
    totalCount: number;
    items: WebSiteNoticeListDto[] | undefined;
}

export enum WechatAppTypeEnum {
    订阅号 = <any>"订阅号",
    认证订阅号 = <any>"认证订阅号",
    服务号 = <any>"服务号",
    认证服务号 = <any>"认证服务号",
}

export class WechatAppConfigEditDto implements IWechatAppConfigEditDto {
    /** Id */
    id: number | undefined;
    /** AppId */
    appId: string;
    /** AppSecret */
    appSecret: string;
    /** Token */
    token: string;
    /** EncodingAESKey */
    encodingAESKey: string | undefined;
    /** 公众号名称 */
    name: string;
    /** 公众号原始ID */
    appOrgId: string | undefined;
    appType: WechatAppTypeEnum;
    /** QRCodeUrl */
    qrCodeUrl: string | undefined;

    constructor(data?: IWechatAppConfigEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
            this.token = _data["token"];
            this.encodingAESKey = _data["encodingAESKey"];
            this.name = _data["name"];
            this.appOrgId = _data["appOrgId"];
            this.appType = _data["appType"];
            this.qrCodeUrl = _data["qrCodeUrl"];
        }
    }

    static fromJS(data: any): WechatAppConfigEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new WechatAppConfigEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        data["token"] = this.token;
        data["encodingAESKey"] = this.encodingAESKey;
        data["name"] = this.name;
        data["appOrgId"] = this.appOrgId;
        data["appType"] = this.appType;
        data["qrCodeUrl"] = this.qrCodeUrl;
        return data;
    }

    clone(): WechatAppConfigEditDto {
        const json = this.toJSON();
        let result = new WechatAppConfigEditDto();
        result.init(json);
        return result;
    }
}

export interface IWechatAppConfigEditDto {
    /** Id */
    id: number | undefined;
    /** AppId */
    appId: string;
    /** AppSecret */
    appSecret: string;
    /** Token */
    token: string;
    /** EncodingAESKey */
    encodingAESKey: string | undefined;
    /** 公众号名称 */
    name: string;
    /** 公众号原始ID */
    appOrgId: string | undefined;
    appType: WechatAppTypeEnum;
    /** QRCodeUrl */
    qrCodeUrl: string | undefined;
}

export class CreateOrUpdateWechatAppConfigInput implements ICreateOrUpdateWechatAppConfigInput {
    wechatAppConfig: WechatAppConfigEditDto;

    constructor(data?: ICreateOrUpdateWechatAppConfigInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wechatAppConfig = new WechatAppConfigEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wechatAppConfig = _data["wechatAppConfig"] ? WechatAppConfigEditDto.fromJS(_data["wechatAppConfig"]) : new WechatAppConfigEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateWechatAppConfigInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateWechatAppConfigInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wechatAppConfig"] = this.wechatAppConfig ? this.wechatAppConfig.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateWechatAppConfigInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateWechatAppConfigInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateWechatAppConfigInput {
    wechatAppConfig: WechatAppConfigEditDto;
}

export class WechatAppConfigListDto implements IWechatAppConfigListDto {
    /** AppId */
    appId: string;
    /** 公众号名称 */
    name: string;
    appType: WechatAppTypeEnum;
    /** 公众号类型中文名称 */
    appTypeStr: string | undefined;
    /** QRCodeUrl */
    qrCodeUrl: string | undefined;
    /** 已注册到应用冲 */
    registered: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IWechatAppConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.name = _data["name"];
            this.appType = _data["appType"];
            this.appTypeStr = _data["appTypeStr"];
            this.qrCodeUrl = _data["qrCodeUrl"];
            this.registered = _data["registered"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WechatAppConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WechatAppConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["name"] = this.name;
        data["appType"] = this.appType;
        data["appTypeStr"] = this.appTypeStr;
        data["qrCodeUrl"] = this.qrCodeUrl;
        data["registered"] = this.registered;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): WechatAppConfigListDto {
        const json = this.toJSON();
        let result = new WechatAppConfigListDto();
        result.init(json);
        return result;
    }
}

export interface IWechatAppConfigListDto {
    /** AppId */
    appId: string;
    /** 公众号名称 */
    name: string;
    appType: WechatAppTypeEnum;
    /** 公众号类型中文名称 */
    appTypeStr: string | undefined;
    /** QRCodeUrl */
    qrCodeUrl: string | undefined;
    /** 已注册到应用冲 */
    registered: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class KeyValuePairOfStringInt32 implements IKeyValuePairOfStringInt32 {
    key: string | undefined;
    value: number;

    constructor(data?: IKeyValuePairOfStringInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): KeyValuePairOfStringInt32 {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringInt32();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringInt32 {
    key: string | undefined;
    value: number;
}

export class GetWechatAppConfigForEditOutput implements IGetWechatAppConfigForEditOutput {
    wechatAppConfig: WechatAppConfigEditDto;
    wechatAppTypeList: KeyValuePairOfStringInt32[] | undefined;

    constructor(data?: IGetWechatAppConfigForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wechatAppConfig = _data["wechatAppConfig"] ? WechatAppConfigEditDto.fromJS(_data["wechatAppConfig"]) : <any>undefined;
            if (Array.isArray(_data["wechatAppTypeList"])) {
                this.wechatAppTypeList = [] as any;
                for (let item of _data["wechatAppTypeList"])
                    this.wechatAppTypeList.push(KeyValuePairOfStringInt32.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWechatAppConfigForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWechatAppConfigForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wechatAppConfig"] = this.wechatAppConfig ? this.wechatAppConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.wechatAppTypeList)) {
            data["wechatAppTypeList"] = [];
            for (let item of this.wechatAppTypeList)
                data["wechatAppTypeList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetWechatAppConfigForEditOutput {
        const json = this.toJSON();
        let result = new GetWechatAppConfigForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetWechatAppConfigForEditOutput {
    wechatAppConfig: WechatAppConfigEditDto;
    wechatAppTypeList: KeyValuePairOfStringInt32[] | undefined;
}

export class PagedResultDtoOfWechatAppConfigListDto implements IPagedResultDtoOfWechatAppConfigListDto {
    totalCount: number;
    items: WechatAppConfigListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWechatAppConfigListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WechatAppConfigListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWechatAppConfigListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWechatAppConfigListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfWechatAppConfigListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWechatAppConfigListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWechatAppConfigListDto {
    totalCount: number;
    items: WechatAppConfigListDto[] | undefined;
}

export class GetImageTextMaterialsInput implements IGetImageTextMaterialsInput {
    appId: string;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IGetImageTextMaterialsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetImageTextMaterialsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageTextMaterialsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }

    clone(): GetImageTextMaterialsInput {
        const json = this.toJSON();
        let result = new GetImageTextMaterialsInput();
        result.init(json);
        return result;
    }
}

export interface IGetImageTextMaterialsInput {
    appId: string;
    maxResultCount: number;
    skipCount: number;
}

export class Media_News_Content_Item implements IMedia_News_Content_Item {
    url: string | undefined;
    thumb_url: string | undefined;
    thumb_media_id: string | undefined;
    author: string | undefined;
    title: string | undefined;
    content_source_url: string | undefined;
    content: string | undefined;
    digest: string | undefined;
    show_cover_pic: string | undefined;
    need_open_comment: number;
    only_fans_can_comment: number;

    constructor(data?: IMedia_News_Content_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.thumb_url = _data["thumb_url"];
            this.thumb_media_id = _data["thumb_media_id"];
            this.author = _data["author"];
            this.title = _data["title"];
            this.content_source_url = _data["content_source_url"];
            this.content = _data["content"];
            this.digest = _data["digest"];
            this.show_cover_pic = _data["show_cover_pic"];
            this.need_open_comment = _data["need_open_comment"];
            this.only_fans_can_comment = _data["only_fans_can_comment"];
        }
    }

    static fromJS(data: any): Media_News_Content_Item {
        data = typeof data === 'object' ? data : {};
        let result = new Media_News_Content_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["thumb_url"] = this.thumb_url;
        data["thumb_media_id"] = this.thumb_media_id;
        data["author"] = this.author;
        data["title"] = this.title;
        data["content_source_url"] = this.content_source_url;
        data["content"] = this.content;
        data["digest"] = this.digest;
        data["show_cover_pic"] = this.show_cover_pic;
        data["need_open_comment"] = this.need_open_comment;
        data["only_fans_can_comment"] = this.only_fans_can_comment;
        return data;
    }

    clone(): Media_News_Content_Item {
        const json = this.toJSON();
        let result = new Media_News_Content_Item();
        result.init(json);
        return result;
    }
}

export interface IMedia_News_Content_Item {
    url: string | undefined;
    thumb_url: string | undefined;
    thumb_media_id: string | undefined;
    author: string | undefined;
    title: string | undefined;
    content_source_url: string | undefined;
    content: string | undefined;
    digest: string | undefined;
    show_cover_pic: string | undefined;
    need_open_comment: number;
    only_fans_can_comment: number;
}

export class Media_News_Content implements IMedia_News_Content {
    news_item: Media_News_Content_Item[] | undefined;

    constructor(data?: IMedia_News_Content) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["news_item"])) {
                this.news_item = [] as any;
                for (let item of _data["news_item"])
                    this.news_item.push(Media_News_Content_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Media_News_Content {
        data = typeof data === 'object' ? data : {};
        let result = new Media_News_Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.news_item)) {
            data["news_item"] = [];
            for (let item of this.news_item)
                data["news_item"].push(item.toJSON());
        }
        return data;
    }

    clone(): Media_News_Content {
        const json = this.toJSON();
        let result = new Media_News_Content();
        result.init(json);
        return result;
    }
}

export interface IMedia_News_Content {
    news_item: Media_News_Content_Item[] | undefined;
}

export class MediaList_News_Item implements IMediaList_News_Item {
    media_id: string | undefined;
    content: Media_News_Content;
    update_time: number;

    constructor(data?: IMediaList_News_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.media_id = _data["media_id"];
            this.content = _data["content"] ? Media_News_Content.fromJS(_data["content"]) : <any>undefined;
            this.update_time = _data["update_time"];
        }
    }

    static fromJS(data: any): MediaList_News_Item {
        data = typeof data === 'object' ? data : {};
        let result = new MediaList_News_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["media_id"] = this.media_id;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["update_time"] = this.update_time;
        return data;
    }

    clone(): MediaList_News_Item {
        const json = this.toJSON();
        let result = new MediaList_News_Item();
        result.init(json);
        return result;
    }
}

export interface IMediaList_News_Item {
    media_id: string | undefined;
    content: Media_News_Content;
    update_time: number;
}

export class PagedResultDtoOfMediaList_News_Item implements IPagedResultDtoOfMediaList_News_Item {
    totalCount: number;
    items: MediaList_News_Item[] | undefined;

    constructor(data?: IPagedResultDtoOfMediaList_News_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MediaList_News_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMediaList_News_Item {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMediaList_News_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfMediaList_News_Item {
        const json = this.toJSON();
        let result = new PagedResultDtoOfMediaList_News_Item();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfMediaList_News_Item {
    totalCount: number;
    items: MediaList_News_Item[] | undefined;
}

export enum UploadMediaFileType {
    Image = <any>"image",
    Voice = <any>"voice",
    Video = <any>"video",
    Thumb = <any>"thumb",
    News = <any>"news",
}

export class GetOtherMaterialsInput implements IGetOtherMaterialsInput {
    appId: string;
    materialType: UploadMediaFileType;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IGetOtherMaterialsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.materialType = _data["materialType"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetOtherMaterialsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOtherMaterialsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["materialType"] = this.materialType;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }

    clone(): GetOtherMaterialsInput {
        const json = this.toJSON();
        let result = new GetOtherMaterialsInput();
        result.init(json);
        return result;
    }
}

export interface IGetOtherMaterialsInput {
    appId: string;
    materialType: UploadMediaFileType;
    maxResultCount: number;
    skipCount: number;
}

export class MediaList_Others_Item implements IMediaList_Others_Item {
    media_id: string | undefined;
    name: string | undefined;
    update_time: number;
    url: string | undefined;

    constructor(data?: IMediaList_Others_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.media_id = _data["media_id"];
            this.name = _data["name"];
            this.update_time = _data["update_time"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MediaList_Others_Item {
        data = typeof data === 'object' ? data : {};
        let result = new MediaList_Others_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["media_id"] = this.media_id;
        data["name"] = this.name;
        data["update_time"] = this.update_time;
        data["url"] = this.url;
        return data;
    }

    clone(): MediaList_Others_Item {
        const json = this.toJSON();
        let result = new MediaList_Others_Item();
        result.init(json);
        return result;
    }
}

export interface IMediaList_Others_Item {
    media_id: string | undefined;
    name: string | undefined;
    update_time: number;
    url: string | undefined;
}

export class PagedResultDtoOfMediaList_Others_Item implements IPagedResultDtoOfMediaList_Others_Item {
    totalCount: number;
    items: MediaList_Others_Item[] | undefined;

    constructor(data?: IPagedResultDtoOfMediaList_Others_Item) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MediaList_Others_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMediaList_Others_Item {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMediaList_Others_Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfMediaList_Others_Item {
        const json = this.toJSON();
        let result = new PagedResultDtoOfMediaList_Others_Item();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfMediaList_Others_Item {
    totalCount: number;
    items: MediaList_Others_Item[] | undefined;
}

export class NewsInfoItem implements INewsInfoItem {
    title: string | undefined;
    author: string | undefined;
    digest: string | undefined;
    show_cover: number;
    cover_url: string | undefined;
    content_url: string | undefined;
    source_url: string | undefined;

    constructor(data?: INewsInfoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.author = _data["author"];
            this.digest = _data["digest"];
            this.show_cover = _data["show_cover"];
            this.cover_url = _data["cover_url"];
            this.content_url = _data["content_url"];
            this.source_url = _data["source_url"];
        }
    }

    static fromJS(data: any): NewsInfoItem {
        data = typeof data === 'object' ? data : {};
        let result = new NewsInfoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["author"] = this.author;
        data["digest"] = this.digest;
        data["show_cover"] = this.show_cover;
        data["cover_url"] = this.cover_url;
        data["content_url"] = this.content_url;
        data["source_url"] = this.source_url;
        return data;
    }

    clone(): NewsInfoItem {
        const json = this.toJSON();
        let result = new NewsInfoItem();
        result.init(json);
        return result;
    }
}

export interface INewsInfoItem {
    title: string | undefined;
    author: string | undefined;
    digest: string | undefined;
    show_cover: number;
    cover_url: string | undefined;
    content_url: string | undefined;
    source_url: string | undefined;
}

export class NewsInfo implements INewsInfo {
    list: NewsInfoItem[] | undefined;

    constructor(data?: INewsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list.push(NewsInfoItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NewsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }

    clone(): NewsInfo {
        const json = this.toJSON();
        let result = new NewsInfo();
        result.init(json);
        return result;
    }
}

export interface INewsInfo {
    list: NewsInfoItem[] | undefined;
}

export class MenuFull_RootButton implements IMenuFull_RootButton {
    type: string | undefined;
    key: string | undefined;
    name: string | undefined;
    url: string | undefined;
    news_info: NewsInfo;
    appid: string | undefined;
    pagepath: string | undefined;
    media_id: string | undefined;
    sub_button: MenuFull_RootButton[] | undefined;

    constructor(data?: IMenuFull_RootButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.news_info = _data["news_info"] ? NewsInfo.fromJS(_data["news_info"]) : <any>undefined;
            this.appid = _data["appid"];
            this.pagepath = _data["pagepath"];
            this.media_id = _data["media_id"];
            if (Array.isArray(_data["sub_button"])) {
                this.sub_button = [] as any;
                for (let item of _data["sub_button"])
                    this.sub_button.push(MenuFull_RootButton.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuFull_RootButton {
        data = typeof data === 'object' ? data : {};
        let result = new MenuFull_RootButton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["key"] = this.key;
        data["name"] = this.name;
        data["url"] = this.url;
        data["news_info"] = this.news_info ? this.news_info.toJSON() : <any>undefined;
        data["appid"] = this.appid;
        data["pagepath"] = this.pagepath;
        data["media_id"] = this.media_id;
        if (Array.isArray(this.sub_button)) {
            data["sub_button"] = [];
            for (let item of this.sub_button)
                data["sub_button"].push(item.toJSON());
        }
        return data;
    }

    clone(): MenuFull_RootButton {
        const json = this.toJSON();
        let result = new MenuFull_RootButton();
        result.init(json);
        return result;
    }
}

export interface IMenuFull_RootButton {
    type: string | undefined;
    key: string | undefined;
    name: string | undefined;
    url: string | undefined;
    news_info: NewsInfo;
    appid: string | undefined;
    pagepath: string | undefined;
    media_id: string | undefined;
    sub_button: MenuFull_RootButton[] | undefined;
}

export class MenuMatchRule implements IMenuMatchRule {
    tag_id: string | undefined;
    group_id: string | undefined;
    sex: string | undefined;
    country: string | undefined;
    province: string | undefined;
    city: string | undefined;
    client_platform_type: string | undefined;
    language: string | undefined;

    constructor(data?: IMenuMatchRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag_id = _data["tag_id"];
            this.group_id = _data["group_id"];
            this.sex = _data["sex"];
            this.country = _data["country"];
            this.province = _data["province"];
            this.city = _data["city"];
            this.client_platform_type = _data["client_platform_type"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MenuMatchRule {
        data = typeof data === 'object' ? data : {};
        let result = new MenuMatchRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag_id"] = this.tag_id;
        data["group_id"] = this.group_id;
        data["sex"] = this.sex;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["client_platform_type"] = this.client_platform_type;
        data["language"] = this.language;
        return data;
    }

    clone(): MenuMatchRule {
        const json = this.toJSON();
        let result = new MenuMatchRule();
        result.init(json);
        return result;
    }
}

export interface IMenuMatchRule {
    tag_id: string | undefined;
    group_id: string | undefined;
    sex: string | undefined;
    country: string | undefined;
    province: string | undefined;
    city: string | undefined;
    client_platform_type: string | undefined;
    language: string | undefined;
}

/** 创建或编辑菜单 */
export class CreateOrEditWechatMenuInput implements ICreateOrEditWechatMenuInput {
    /** 应用key */
    appId: string | undefined;
    /** 菜单数据结构 */
    menu: MenuFull_RootButton[] | undefined;
    matchRule: MenuMatchRule;

    constructor(data?: ICreateOrEditWechatMenuInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            if (Array.isArray(_data["menu"])) {
                this.menu = [] as any;
                for (let item of _data["menu"])
                    this.menu.push(MenuFull_RootButton.fromJS(item));
            }
            this.matchRule = _data["matchRule"] ? MenuMatchRule.fromJS(_data["matchRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditWechatMenuInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditWechatMenuInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        if (Array.isArray(this.menu)) {
            data["menu"] = [];
            for (let item of this.menu)
                data["menu"].push(item.toJSON());
        }
        data["matchRule"] = this.matchRule ? this.matchRule.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrEditWechatMenuInput {
        const json = this.toJSON();
        let result = new CreateOrEditWechatMenuInput();
        result.init(json);
        return result;
    }
}

/** 创建或编辑菜单 */
export interface ICreateOrEditWechatMenuInput {
    /** 应用key */
    appId: string | undefined;
    /** 菜单数据结构 */
    menu: MenuFull_RootButton[] | undefined;
    matchRule: MenuMatchRule;
}

export class GetWechatMenuForEditOutput implements IGetWechatMenuForEditOutput {
    /** 默认菜单
(单独对象,数据结构参照 MenuFull_ButtonGroup) */
    menu: any | undefined;
    /** 有个性化菜单时显示。最新的在最前。
(集合 数据结构参照 MenuFull_ConditionalButtonGroup) */
    conditionalmenu: any | undefined;
    /** 菜单类型 */
    menuTypeList: KeyValuePairOfStringString[] | undefined;

    constructor(data?: IGetWechatMenuForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menu = _data["menu"];
            this.conditionalmenu = _data["conditionalmenu"];
            if (Array.isArray(_data["menuTypeList"])) {
                this.menuTypeList = [] as any;
                for (let item of _data["menuTypeList"])
                    this.menuTypeList.push(KeyValuePairOfStringString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWechatMenuForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWechatMenuForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menu"] = this.menu;
        data["conditionalmenu"] = this.conditionalmenu;
        if (Array.isArray(this.menuTypeList)) {
            data["menuTypeList"] = [];
            for (let item of this.menuTypeList)
                data["menuTypeList"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetWechatMenuForEditOutput {
        const json = this.toJSON();
        let result = new GetWechatMenuForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetWechatMenuForEditOutput {
    /** 默认菜单
(单独对象,数据结构参照 MenuFull_ButtonGroup) */
    menu: any | undefined;
    /** 有个性化菜单时显示。最新的在最前。
(集合 数据结构参照 MenuFull_ConditionalButtonGroup) */
    conditionalmenu: any | undefined;
    /** 菜单类型 */
    menuTypeList: KeyValuePairOfStringString[] | undefined;
}

export class CreateOrUpdateWorkExperienceInput implements ICreateOrUpdateWorkExperienceInput {
    workExperience: WorkExperienceEditDto;

    constructor(data?: ICreateOrUpdateWorkExperienceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workExperience = new WorkExperienceEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workExperience = _data["workExperience"] ? WorkExperienceEditDto.fromJS(_data["workExperience"]) : new WorkExperienceEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateWorkExperienceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateWorkExperienceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workExperience"] = this.workExperience ? this.workExperience.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateWorkExperienceInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateWorkExperienceInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateWorkExperienceInput {
    workExperience: WorkExperienceEditDto;
}

/** 读取可编辑工作经验的Dto */
export class GetWorkExperienceForEditOutput implements IGetWorkExperienceForEditOutput {
    workExperience: WorkExperienceEditDto;

    constructor(data?: IGetWorkExperienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workExperience = _data["workExperience"] ? WorkExperienceEditDto.fromJS(_data["workExperience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWorkExperienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkExperienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workExperience"] = this.workExperience ? this.workExperience.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetWorkExperienceForEditOutput {
        const json = this.toJSON();
        let result = new GetWorkExperienceForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑工作经验的Dto */
export interface IGetWorkExperienceForEditOutput {
    workExperience: WorkExperienceEditDto;
}

export class PagedResultDtoOfWorkExperienceListDto implements IPagedResultDtoOfWorkExperienceListDto {
    totalCount: number;
    items: WorkExperienceListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWorkExperienceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WorkExperienceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWorkExperienceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWorkExperienceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfWorkExperienceListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWorkExperienceListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWorkExperienceListDto {
    totalCount: number;
    items: WorkExperienceListDto[] | undefined;
}

export class CreateOrUpdateWorkYearsQuotaInput implements ICreateOrUpdateWorkYearsQuotaInput {
    workYearsQuota: WorkYearsQuotaEditDto;

    constructor(data?: ICreateOrUpdateWorkYearsQuotaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.workYearsQuota = new WorkYearsQuotaEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workYearsQuota = _data["workYearsQuota"] ? WorkYearsQuotaEditDto.fromJS(_data["workYearsQuota"]) : new WorkYearsQuotaEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateWorkYearsQuotaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateWorkYearsQuotaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workYearsQuota"] = this.workYearsQuota ? this.workYearsQuota.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateWorkYearsQuotaInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateWorkYearsQuotaInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateWorkYearsQuotaInput {
    workYearsQuota: WorkYearsQuotaEditDto;
}

/** 的列表DTO QYB.QYBProduct.Attendance.WorkYearsQuota.WorkYearsQuota */
export class WorkYearsQuotaListDto implements IWorkYearsQuotaListDto {
    /** HolidayRuleId */
    holidayRuleId: number;
    /** WorkYears */
    workYears: number;
    /** QuotaValue */
    quotaValue: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;

    constructor(data?: IWorkYearsQuotaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayRuleId = _data["holidayRuleId"];
            this.workYears = _data["workYears"];
            this.quotaValue = _data["quotaValue"];
            this.tenantId = _data["tenantId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkYearsQuotaListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkYearsQuotaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayRuleId"] = this.holidayRuleId;
        data["workYears"] = this.workYears;
        data["quotaValue"] = this.quotaValue;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }

    clone(): WorkYearsQuotaListDto {
        const json = this.toJSON();
        let result = new WorkYearsQuotaListDto();
        result.init(json);
        return result;
    }
}

/** 的列表DTO QYB.QYBProduct.Attendance.WorkYearsQuota.WorkYearsQuota */
export interface IWorkYearsQuotaListDto {
    /** HolidayRuleId */
    holidayRuleId: number;
    /** WorkYears */
    workYears: number;
    /** QuotaValue */
    quotaValue: number;
    /** TenantId */
    tenantId: number;
    /** CreationTime */
    creationTime: moment.Moment;
    /** CreatorUserId */
    creatorUserId: number | undefined;
    /** LastModifierUserId */
    lastModifierUserId: number | undefined;
    /** LastModificationTime */
    lastModificationTime: moment.Moment | undefined;
    /** DeleterUserId */
    deleterUserId: number | undefined;
    /** DeletionTime */
    deletionTime: moment.Moment | undefined;
    /** IsDeleted */
    isDeleted: boolean;
    id: number;
}

/** 读取可编辑的Dto */
export class GetWorkYearsQuotaForEditOutput implements IGetWorkYearsQuotaForEditOutput {
    workYearsQuota: WorkYearsQuotaEditDto;

    constructor(data?: IGetWorkYearsQuotaForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workYearsQuota = _data["workYearsQuota"] ? WorkYearsQuotaEditDto.fromJS(_data["workYearsQuota"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWorkYearsQuotaForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkYearsQuotaForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workYearsQuota"] = this.workYearsQuota ? this.workYearsQuota.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetWorkYearsQuotaForEditOutput {
        const json = this.toJSON();
        let result = new GetWorkYearsQuotaForEditOutput();
        result.init(json);
        return result;
    }
}

/** 读取可编辑的Dto */
export interface IGetWorkYearsQuotaForEditOutput {
    workYearsQuota: WorkYearsQuotaEditDto;
}

export class PagedResultDtoOfWorkYearsQuotaListDto implements IPagedResultDtoOfWorkYearsQuotaListDto {
    totalCount: number;
    items: WorkYearsQuotaListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWorkYearsQuotaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WorkYearsQuotaListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWorkYearsQuotaListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWorkYearsQuotaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultDtoOfWorkYearsQuotaListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWorkYearsQuotaListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWorkYearsQuotaListDto {
    totalCount: number;
    items: WorkYearsQuotaListDto[] | undefined;
}

export class ZkCheckInRecord implements IZkCheckInRecord {
    /** 人员姓名 */
    ename: string | undefined;
    /** 打卡时间 */
    checktime: moment.Moment;
    /** 人员编号 */
    pin: string | undefined;
    /** 验证方式 */
    verify: number;
    /** 部门编号 */
    deptnumber: string | undefined;
    /** 照片信息数据为BASE64格式 */
    photograph: string | undefined;
    /** 设备名称 */
    alias: string | undefined;
    /** 考勤状态说明 */
    state: string | undefined;
    /** 设备序列号 */
    sn: string | undefined;
    /** 考勤状态 */
    stateno: string | undefined;
    /** 部门名称 */
    deptname: string | undefined;
    /** 流水号 */
    id: number;

    constructor(data?: IZkCheckInRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ename = _data["ename"];
            this.checktime = _data["checktime"] ? moment(_data["checktime"].toString()) : <any>undefined;
            this.pin = _data["pin"];
            this.verify = _data["verify"];
            this.deptnumber = _data["deptnumber"];
            this.photograph = _data["photograph"];
            this.alias = _data["alias"];
            this.state = _data["state"];
            this.sn = _data["sn"];
            this.stateno = _data["stateno"];
            this.deptname = _data["deptname"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZkCheckInRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ZkCheckInRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ename"] = this.ename;
        data["checktime"] = this.checktime ? this.checktime.toISOString() : <any>undefined;
        data["pin"] = this.pin;
        data["verify"] = this.verify;
        data["deptnumber"] = this.deptnumber;
        data["photograph"] = this.photograph;
        data["alias"] = this.alias;
        data["state"] = this.state;
        data["sn"] = this.sn;
        data["stateno"] = this.stateno;
        data["deptname"] = this.deptname;
        data["id"] = this.id;
        return data;
    }

    clone(): ZkCheckInRecord {
        const json = this.toJSON();
        let result = new ZkCheckInRecord();
        result.init(json);
        return result;
    }
}

export interface IZkCheckInRecord {
    /** 人员姓名 */
    ename: string | undefined;
    /** 打卡时间 */
    checktime: moment.Moment;
    /** 人员编号 */
    pin: string | undefined;
    /** 验证方式 */
    verify: number;
    /** 部门编号 */
    deptnumber: string | undefined;
    /** 照片信息数据为BASE64格式 */
    photograph: string | undefined;
    /** 设备名称 */
    alias: string | undefined;
    /** 考勤状态说明 */
    state: string | undefined;
    /** 设备序列号 */
    sn: string | undefined;
    /** 考勤状态 */
    stateno: string | undefined;
    /** 部门名称 */
    deptname: string | undefined;
    /** 流水号 */
    id: number;
}

export class ZkCheckInInfo implements IZkCheckInInfo {
    count: number;
    items: ZkCheckInRecord[] | undefined;

    constructor(data?: IZkCheckInInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ZkCheckInRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZkCheckInInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ZkCheckInInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ZkCheckInInfo {
        const json = this.toJSON();
        let result = new ZkCheckInInfo();
        result.init(json);
        return result;
    }
}

export interface IZkCheckInInfo {
    count: number;
    items: ZkCheckInRecord[] | undefined;
}

/** 服务返回结果包装类 */
export class SrvResult implements ISrvResult {
    /** 消息 */
    msg: string | undefined;
    data: ZkCheckInInfo;
    /** 消息 */
    ret: number;

    constructor(data?: ISrvResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msg = _data["msg"];
            this.data = _data["data"] ? ZkCheckInInfo.fromJS(_data["data"]) : <any>undefined;
            this.ret = _data["ret"];
        }
    }

    static fromJS(data: any): SrvResult {
        data = typeof data === 'object' ? data : {};
        let result = new SrvResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msg"] = this.msg;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["ret"] = this.ret;
        return data;
    }

    clone(): SrvResult {
        const json = this.toJSON();
        let result = new SrvResult();
        result.init(json);
        return result;
    }
}

/** 服务返回结果包装类 */
export interface ISrvResult {
    /** 消息 */
    msg: string | undefined;
    data: ZkCheckInInfo;
    /** 消息 */
    ret: number;
}

export class ZkEmpLeave implements IZkEmpLeave {
    /** 人员编号 */
    pin: string | undefined;
    /** 离职时间 %Y-%m-%d %H:%M */
    leavedate: string | undefined;
    /** 离职类型 0 自离 1 辞退 2 辞职 3 调离 4 停薪留职 */
    leavetype: number;
    /** 离职原因 */
    reason: string | undefined;

    constructor(data?: IZkEmpLeave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
            this.leavedate = _data["leavedate"];
            this.leavetype = _data["leavetype"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ZkEmpLeave {
        data = typeof data === 'object' ? data : {};
        let result = new ZkEmpLeave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        data["leavedate"] = this.leavedate;
        data["leavetype"] = this.leavetype;
        data["reason"] = this.reason;
        return data;
    }

    clone(): ZkEmpLeave {
        const json = this.toJSON();
        let result = new ZkEmpLeave();
        result.init(json);
        return result;
    }
}

export interface IZkEmpLeave {
    /** 人员编号 */
    pin: string | undefined;
    /** 离职时间 %Y-%m-%d %H:%M */
    leavedate: string | undefined;
    /** 离职类型 0 自离 1 辞退 2 辞职 3 调离 4 停薪留职 */
    leavetype: number;
    /** 离职原因 */
    reason: string | undefined;
}

/** 部门对接 - 更新部门 */
export class ZkDepartment implements IZkDepartment {
    /** 部门编号。长度表示为1~40个字符（只能包含字母和数字） */
    deptnumber: string | undefined;
    /** 名称。长度表示为1~40个字符(更新可以不填，新增必填) */
    deptname: string | undefined;
    /** 父部门编号。长度表示为1~40个字符(更新可以不填，新增必填) */
    parentnumber: string | undefined;
    /** 部门地址 */
    deptaddr: string | undefined;
    /** 联系人 */
    deptperson: string | undefined;
    /** 联系电话 */
    deptphone: string | undefined;

    constructor(data?: IZkDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deptnumber = _data["deptnumber"];
            this.deptname = _data["deptname"];
            this.parentnumber = _data["parentnumber"];
            this.deptaddr = _data["deptaddr"];
            this.deptperson = _data["deptperson"];
            this.deptphone = _data["deptphone"];
        }
    }

    static fromJS(data: any): ZkDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new ZkDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deptnumber"] = this.deptnumber;
        data["deptname"] = this.deptname;
        data["parentnumber"] = this.parentnumber;
        data["deptaddr"] = this.deptaddr;
        data["deptperson"] = this.deptperson;
        data["deptphone"] = this.deptphone;
        return data;
    }

    clone(): ZkDepartment {
        const json = this.toJSON();
        let result = new ZkDepartment();
        result.init(json);
        return result;
    }
}

/** 部门对接 - 更新部门 */
export interface IZkDepartment {
    /** 部门编号。长度表示为1~40个字符（只能包含字母和数字） */
    deptnumber: string | undefined;
    /** 名称。长度表示为1~40个字符(更新可以不填，新增必填) */
    deptname: string | undefined;
    /** 父部门编号。长度表示为1~40个字符(更新可以不填，新增必填) */
    parentnumber: string | undefined;
    /** 部门地址 */
    deptaddr: string | undefined;
    /** 联系人 */
    deptperson: string | undefined;
    /** 联系电话 */
    deptphone: string | undefined;
}

/** 人员对接 - 更新人员 */
export class ZkEmployee implements IZkEmployee {
    /** 人员编号(工号) */
    pin: string | undefined;
    /** 人员名称 */
    name: string | undefined;
    /** 员工卡号 */
    cardno: string | undefined;
    /** 人员所属部门编号(更新可以不填，新增必填) */
    deptnumber: string | undefined;
    /** 人员是否考勤 */
    att: number;
    /** 验证方式 */
    comverifys: number;

    constructor(data?: IZkEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
            this.name = _data["name"];
            this.cardno = _data["cardno"];
            this.deptnumber = _data["deptnumber"];
            this.att = _data["att"];
            this.comverifys = _data["comverifys"];
        }
    }

    static fromJS(data: any): ZkEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new ZkEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        data["name"] = this.name;
        data["cardno"] = this.cardno;
        data["deptnumber"] = this.deptnumber;
        data["att"] = this.att;
        data["comverifys"] = this.comverifys;
        return data;
    }

    clone(): ZkEmployee {
        const json = this.toJSON();
        let result = new ZkEmployee();
        result.init(json);
        return result;
    }
}

/** 人员对接 - 更新人员 */
export interface IZkEmployee {
    /** 人员编号(工号) */
    pin: string | undefined;
    /** 人员名称 */
    name: string | undefined;
    /** 员工卡号 */
    cardno: string | undefined;
    /** 人员所属部门编号(更新可以不填，新增必填) */
    deptnumber: string | undefined;
    /** 人员是否考勤 */
    att: number;
    /** 验证方式 */
    comverifys: number;
}

export enum ActivateType {
    NewAccount = <any>"NewAccount",
    BindExistAccount = <any>"BindExistAccount",
}

export class ActivateAccountModel implements IActivateAccountModel {
    emailAddress: string;
    password: string;
    userId: string | undefined;
    verificationCode: string | undefined;
    activateType: ActivateType;

    constructor(data?: IActivateAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.userId = _data["userId"];
            this.verificationCode = _data["verificationCode"];
            this.activateType = _data["activateType"];
        }
    }

    static fromJS(data: any): ActivateAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["userId"] = this.userId;
        data["verificationCode"] = this.verificationCode;
        data["activateType"] = this.activateType;
        return data;
    }

    clone(): ActivateAccountModel {
        const json = this.toJSON();
        let result = new ActivateAccountModel();
        result.init(json);
        return result;
    }
}

export interface IActivateAccountModel {
    emailAddress: string;
    password: string;
    userId: string | undefined;
    verificationCode: string | undefined;
    activateType: ActivateType;
}

export class ActivateAccountResultModel implements IActivateAccountResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IActivateAccountResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ActivateAccountResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateAccountResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): ActivateAccountResultModel {
        const json = this.toJSON();
        let result = new ActivateAccountResultModel();
        result.init(json);
        return result;
    }
}

export interface IActivateAccountResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;
    clientType: number;
    scenesId: number;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.clientId = _data["clientId"];
            this.systemName = _data["systemName"];
            this.appVersion = _data["appVersion"];
            this.phoneBrand = _data["phoneBrand"];
            this.verificationCode = _data["verificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.returnUrl = _data["returnUrl"];
            this.clientType = _data["clientType"];
            this.scenesId = _data["scenesId"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["clientId"] = this.clientId;
        data["systemName"] = this.systemName;
        data["appVersion"] = this.appVersion;
        data["phoneBrand"] = this.phoneBrand;
        data["verificationCode"] = this.verificationCode;
        data["rememberClient"] = this.rememberClient;
        data["returnUrl"] = this.returnUrl;
        data["clientType"] = this.clientType;
        data["scenesId"] = this.scenesId;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;
    clientType: number;
    scenesId: number;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    passwordResetType: number;
    lastUpdatePassDate: moment.Moment | undefined;
    returnUrl: string | undefined;
    empId: number | undefined;
    waitingForActivation: boolean;
    ssoGuid: string | undefined;
    realName: string | undefined;
    userName: string | undefined;
    companyId: number | undefined;
    departmentId: number | undefined;
    postId: number | undefined;
    jobNumber: string | undefined;
    mobile: string | undefined;
    genderCode: string | undefined;
    forceUpdate: boolean;
    tenantId: number | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.passwordResetType = _data["passwordResetType"];
            this.lastUpdatePassDate = _data["lastUpdatePassDate"] ? moment(_data["lastUpdatePassDate"].toString()) : <any>undefined;
            this.returnUrl = _data["returnUrl"];
            this.empId = _data["empId"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.ssoGuid = _data["ssoGuid"];
            this.realName = _data["realName"];
            this.userName = _data["userName"];
            this.companyId = _data["companyId"];
            this.departmentId = _data["departmentId"];
            this.postId = _data["postId"];
            this.jobNumber = _data["jobNumber"];
            this.mobile = _data["mobile"];
            this.genderCode = _data["genderCode"];
            this.forceUpdate = _data["forceUpdate"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["passwordResetType"] = this.passwordResetType;
        data["lastUpdatePassDate"] = this.lastUpdatePassDate ? this.lastUpdatePassDate.toISOString() : <any>undefined;
        data["returnUrl"] = this.returnUrl;
        data["empId"] = this.empId;
        data["waitingForActivation"] = this.waitingForActivation;
        data["ssoGuid"] = this.ssoGuid;
        data["realName"] = this.realName;
        data["userName"] = this.userName;
        data["companyId"] = this.companyId;
        data["departmentId"] = this.departmentId;
        data["postId"] = this.postId;
        data["jobNumber"] = this.jobNumber;
        data["mobile"] = this.mobile;
        data["genderCode"] = this.genderCode;
        data["forceUpdate"] = this.forceUpdate;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    passwordResetType: number;
    lastUpdatePassDate: moment.Moment | undefined;
    returnUrl: string | undefined;
    empId: number | undefined;
    waitingForActivation: boolean;
    ssoGuid: string | undefined;
    realName: string | undefined;
    userName: string | undefined;
    companyId: number | undefined;
    departmentId: number | undefined;
    postId: number | undefined;
    jobNumber: string | undefined;
    mobile: string | undefined;
    genderCode: string | undefined;
    forceUpdate: boolean;
    tenantId: number | undefined;
}

export class AuthenticateToAccountAndNFCModel implements IAuthenticateToAccountAndNFCModel {
    userNameOrEmailAddress: string;
    password: string;
    nfcNo: string | undefined;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;
    clientType: number;
    scenesId: number;

    constructor(data?: IAuthenticateToAccountAndNFCModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.nfcNo = _data["nfcNo"];
            this.clientId = _data["clientId"];
            this.systemName = _data["systemName"];
            this.appVersion = _data["appVersion"];
            this.phoneBrand = _data["phoneBrand"];
            this.verificationCode = _data["verificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.returnUrl = _data["returnUrl"];
            this.clientType = _data["clientType"];
            this.scenesId = _data["scenesId"];
        }
    }

    static fromJS(data: any): AuthenticateToAccountAndNFCModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateToAccountAndNFCModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["nfcNo"] = this.nfcNo;
        data["clientId"] = this.clientId;
        data["systemName"] = this.systemName;
        data["appVersion"] = this.appVersion;
        data["phoneBrand"] = this.phoneBrand;
        data["verificationCode"] = this.verificationCode;
        data["rememberClient"] = this.rememberClient;
        data["returnUrl"] = this.returnUrl;
        data["clientType"] = this.clientType;
        data["scenesId"] = this.scenesId;
        return data;
    }

    clone(): AuthenticateToAccountAndNFCModel {
        const json = this.toJSON();
        let result = new AuthenticateToAccountAndNFCModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateToAccountAndNFCModel {
    userNameOrEmailAddress: string;
    password: string;
    nfcNo: string | undefined;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;
    clientType: number;
    scenesId: number;
}

export class AuthenticateNfcModel implements IAuthenticateNfcModel {
    nfcNo: string | undefined;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;

    constructor(data?: IAuthenticateNfcModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nfcNo = _data["nfcNo"];
            this.clientId = _data["clientId"];
            this.systemName = _data["systemName"];
            this.appVersion = _data["appVersion"];
            this.phoneBrand = _data["phoneBrand"];
            this.verificationCode = _data["verificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateNfcModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateNfcModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nfcNo"] = this.nfcNo;
        data["clientId"] = this.clientId;
        data["systemName"] = this.systemName;
        data["appVersion"] = this.appVersion;
        data["phoneBrand"] = this.phoneBrand;
        data["verificationCode"] = this.verificationCode;
        data["rememberClient"] = this.rememberClient;
        data["returnUrl"] = this.returnUrl;
        return data;
    }

    clone(): AuthenticateNfcModel {
        const json = this.toJSON();
        let result = new AuthenticateNfcModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateNfcModel {
    nfcNo: string | undefined;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;
}

export class AutoLoginRequest implements IAutoLoginRequest {
    domainUser: string | undefined;
    tenantId: number;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;

    constructor(data?: IAutoLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainUser = _data["domainUser"];
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.systemName = _data["systemName"];
            this.appVersion = _data["appVersion"];
            this.phoneBrand = _data["phoneBrand"];
            this.verificationCode = _data["verificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): AutoLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutoLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainUser"] = this.domainUser;
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["systemName"] = this.systemName;
        data["appVersion"] = this.appVersion;
        data["phoneBrand"] = this.phoneBrand;
        data["verificationCode"] = this.verificationCode;
        data["rememberClient"] = this.rememberClient;
        data["returnUrl"] = this.returnUrl;
        return data;
    }

    clone(): AutoLoginRequest {
        const json = this.toJSON();
        let result = new AutoLoginRequest();
        result.init(json);
        return result;
    }
}

export interface IAutoLoginRequest {
    domainUser: string | undefined;
    tenantId: number;
    clientId: string | undefined;
    systemName: string | undefined;
    appVersion: string | undefined;
    phoneBrand: string | undefined;
    verificationCode: string | undefined;
    rememberClient: boolean;
    returnUrl: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    userId: number;
    providerKey: string | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.userId = _data["userId"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["userId"] = this.userId;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    userId: number;
    providerKey: string | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)[key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class Icon implements IIcon {
    icon_id: string | undefined;
    name: string | undefined;
    font_class: string | undefined;
    unicode: string | undefined;
    unicode_decimal: number;

    constructor(data?: IIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon_id = _data["icon_id"];
            this.name = _data["name"];
            this.font_class = _data["font_class"];
            this.unicode = _data["unicode"];
            this.unicode_decimal = _data["unicode_decimal"];
        }
    }

    static fromJS(data: any): Icon {
        data = typeof data === 'object' ? data : {};
        let result = new Icon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon_id"] = this.icon_id;
        data["name"] = this.name;
        data["font_class"] = this.font_class;
        data["unicode"] = this.unicode;
        data["unicode_decimal"] = this.unicode_decimal;
        return data;
    }

    clone(): Icon {
        const json = this.toJSON();
        let result = new Icon();
        result.init(json);
        return result;
    }
}

export interface IIcon {
    icon_id: string | undefined;
    name: string | undefined;
    font_class: string | undefined;
    unicode: string | undefined;
    unicode_decimal: number;
}

export class IconFontDto implements IIconFontDto {
    id: string | undefined;
    name: string | undefined;
    font_family: string | undefined;
    css_prefix_text: string | undefined;
    description: string | undefined;
    glyphs: Icon[] | undefined;

    constructor(data?: IIconFontDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.font_family = _data["font_family"];
            this.css_prefix_text = _data["css_prefix_text"];
            this.description = _data["description"];
            if (Array.isArray(_data["glyphs"])) {
                this.glyphs = [] as any;
                for (let item of _data["glyphs"])
                    this.glyphs.push(Icon.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IconFontDto {
        data = typeof data === 'object' ? data : {};
        let result = new IconFontDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["font_family"] = this.font_family;
        data["css_prefix_text"] = this.css_prefix_text;
        data["description"] = this.description;
        if (Array.isArray(this.glyphs)) {
            data["glyphs"] = [];
            for (let item of this.glyphs)
                data["glyphs"].push(item.toJSON());
        }
        return data;
    }

    clone(): IconFontDto {
        const json = this.toJSON();
        let result = new IconFontDto();
        result.init(json);
        return result;
    }
}

export interface IIconFontDto {
    id: string | undefined;
    name: string | undefined;
    font_family: string | undefined;
    css_prefix_text: string | undefined;
    description: string | undefined;
    glyphs: Icon[] | undefined;
}

export class SSODto implements ISSODto {
    guid: string | undefined;
    tenantId: number | undefined;

    constructor(data?: ISSODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): SSODto {
        data = typeof data === 'object' ? data : {};
        let result = new SSODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): SSODto {
        const json = this.toJSON();
        let result = new SSODto();
        result.init(json);
        return result;
    }
}

export interface ISSODto {
    guid: string | undefined;
    tenantId: number | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }

    clone(): ImpersonatedAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }

    clone(): SwitchedAccountAuthenticateResultModel {
        const json = this.toJSON();
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
export interface WeeklyPlanAssignment {
    userId: number;
    userName: string | undefined;
    templateId: number;
    templateName: string | undefined;
    isRepeat: boolean;
}

export interface WeeklyPlanPreviewDto {
    taskCount: number;
    memberCount: number;
    repeatCount: number;
    duplicateWeek: boolean;
    assignments: WeeklyPlanAssignment[] | undefined;
}

export interface CreateWeeklyPlanInput {
    name: string | undefined;
    auditTeamId: number;
    templateIds: number[] | undefined;
    weekStart: Date;
    earlyStart: number;
    delayedFinish: number;
    remark: string | undefined;
    auditTaskLabel: string[] | undefined;
    ignoreDuplicateWarning: boolean;
}

export interface CreateWeeklyPlanResultDto {
    auditTaskCreateId: number;
    taskCount: number;
    memberCount: number;
    repeatCount: number;
}

export class WeeklyPlanServiceProxy {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * 预览按周随机分配结果（不落库）
     * @param body (optional)
     * @return Success
     */
    previewWeeklyPlan(body: { auditTeamId: number; templateIds: number[]; weekStart: Date } | undefined, cancelToken?: CancelToken | undefined): Promise<WeeklyPlanPreviewDto> {
        let url_ = this.baseUrl + "/api/services/app/WeeklyPlan/PreviewWeeklyPlan";
        let content_ = JSON.stringify(body);
        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewWeeklyPlan(_response);
        });
    }

    protected processPreviewWeeklyPlan(response: AxiosResponse): Promise<WeeklyPlanPreviewDto> {
        const status = response.status;
        if (status === 200) {
            const _result = response.data as WeeklyPlanPreviewDto;
            return Promise.resolve(_result);
        } else if (status !== 200 && status !== 204) {
            return throwException("An unexpected server error occurred.", status, response.data, response.headers);
        }
        return Promise.resolve<WeeklyPlanPreviewDto>(null as any);
    }

    /**
     * 创建下周随机排班计划并生成任务实例
     * @param body (optional)
     * @return Success
     */
    createWeeklyPlan(body: CreateWeeklyPlanInput | undefined, cancelToken?: CancelToken | undefined): Promise<CreateWeeklyPlanResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WeeklyPlan/CreateWeeklyPlan";
        let content_ = JSON.stringify(body);
        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateWeeklyPlan(_response);
        });
    }

    protected processCreateWeeklyPlan(response: AxiosResponse): Promise<CreateWeeklyPlanResultDto> {
        const status = response.status;
        if (status === 200) {
            const _result = response.data as CreateWeeklyPlanResultDto;
            return Promise.resolve(_result);
        } else if (status !== 200 && status !== 204) {
            return throwException("An unexpected server error occurred.", status, response.data, response.headers);
        }
        return Promise.resolve<CreateWeeklyPlanResultDto>(null as any);
    }
}
